// ============================================================
//  unclaimedData.js — The Sahyadri Sahakari Bank Ltd.
//  Auto-generated from: Deaf_List_For_Website__1_.xlsx
//  Total Records: 45354
//
//  TO UPDATE DATA:
//  1. Export your new Excel as CSV
//  2. Visit https://csvjson.com/csv2json
//  3. Replace the array below with new JSON
//  4. Make sure each record has: branch, type, accountNo, name
// ============================================================

const UNCLAIMED_DATA = [
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2522",
    "name": "A N Bros."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2782",
    "name": "Aarveetech"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2239",
    "name": "Advanced Cargo Carriers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2479",
    "name": "Agarwal Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1076",
    "name": "All India Trading Co."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "240",
    "name": "Amar Tailor"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3431",
    "name": "Ambajee  Corporation."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3347",
    "name": "Ambica Jewellers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2141",
    "name": "Ambika Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1709",
    "name": "Anand Textiles Agency"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3486",
    "name": "Anil Prints"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15198",
    "name": "Badekar Indubai Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4171",
    "name": "Anupam Silk S"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1075",
    "name": "Ashok Kumar & Co."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12157",
    "name": "Indulkar Smita Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1814",
    "name": "B A Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "559",
    "name": "B Nanchand Javeri"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13014",
    "name": "Kadav Anand Vasantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17092",
    "name": "Kinlekar Sanjiv Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13550",
    "name": "Lanjekar Ajit Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11509",
    "name": "Parab Umesh Balakrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16620",
    "name": "Pisal Dnyaneshwar Pralhad"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "521",
    "name": "Bee Jay Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7159",
    "name": "Shah Chandravati Kumudchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14064",
    "name": "Valanje Santosh Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "564",
    "name": "Bharat Kumar & Co."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "988",
    "name": "Bharatkumar Kirankumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1525",
    "name": "Bharuka Synthetics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3071",
    "name": "Bhavana Traders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2676",
    "name": "Bhawesh Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18672",
    "name": "Hanik Mohmad  Ksshm Mohmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19470",
    "name": "Imtiyaz  Mohd Siddhique Shaikh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18684",
    "name": "Joshi   Jayant Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18387",
    "name": "Kambale  Anita Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19050",
    "name": "Kaushalya Karanchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18897",
    "name": "Shikh Abdul Hamid  Kasm"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18874",
    "name": "Abdul Hamid Abdul Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19427",
    "name": "Abdul Salim Shaikh Ahmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19646",
    "name": "Adagale Shubhash Dattatary"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19366",
    "name": "Agrawal Jugalkishore Shiv Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19797",
    "name": "Aher  Mahesh  Kedarnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18748",
    "name": "Aji Hasan Mohmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19004",
    "name": "Ajij Mohmad Husain Abdul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18737",
    "name": "Akhtar Hussain Karbari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19408",
    "name": "Akil Ahmad Abdul Kadar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19699",
    "name": "Alfred Georg Jemes Willum."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18442",
    "name": "Alim Kashinath Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19647",
    "name": "Altaf Shaikh M Shaikh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19695",
    "name": "Amba Vane   Rajesh  Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15767",
    "name": "Amberkar Nisha Nitin."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19839",
    "name": "Angane Pratap Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19300",
    "name": "Ansari Abdulvahid Abdul Aziz"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18871",
    "name": "Ansari Lal Mohamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18473",
    "name": "Ansari Qamrulhaqu Qurbanali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19068",
    "name": "Anwar Ali Akbar Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18680",
    "name": "Anwar Hussein Hassan Shaikh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18902",
    "name": "Arifkhan Gani Khan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15592",
    "name": "Arolakar Vasant Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19581",
    "name": "Arondekar Rajendra Madan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19654",
    "name": "Aryamane Surendra Kishor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18876",
    "name": "Awari Balasaheb Khaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16698",
    "name": "Ayare Dattaram Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18742",
    "name": "Badre Vasant Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18673",
    "name": "Badshaha Baba Sinkandar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19499",
    "name": "Bag Mirjaali Askander"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19372",
    "name": "Bagade Rojahmad Makbul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17597",
    "name": "Bagakar Sandesh Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14744",
    "name": "Balip Ankush Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18804",
    "name": "Banasode Dnyaneshwar Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19008",
    "name": "Bankar Dagadu Bhima"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19118",
    "name": "Bankar Dattaram Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17658",
    "name": "Bansode  Hanumant Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18507",
    "name": "Bansode Anand Bibhishan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18724",
    "name": "Bansode Gautam Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19398",
    "name": "Bansode Vilas Gulab"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16357",
    "name": "Baraskar Priyanka Surendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18356",
    "name": "Bari Arju Kalu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18910",
    "name": "Barkatali  Mohmad Samin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19752",
    "name": "Barve Sudhakar Balwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19329",
    "name": "Beg Mirja Sufiyan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17050",
    "name": "Bendkhale Kamlaksha Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19709",
    "name": "Bhagat Ganpat Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14487",
    "name": "Bhagwat Rashmi Shashikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18720",
    "name": "Bhagwat Umesh Laxaman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19506",
    "name": "Bhalerao Sudam Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19821",
    "name": "Bhandare Laxman Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18593",
    "name": "Bhanu Prabhu Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19751",
    "name": "Bhata Bharatbhushan Gangaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19487",
    "name": "Bhatt Deepakumar Bankey"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18561",
    "name": "Bhatt Rajendra Gunwantray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19772",
    "name": "Bhavar Balu Nathu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19650",
    "name": "Bhilare Dashrath Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16787",
    "name": "Bhoite Baban Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19426",
    "name": "Bhor Ravindra Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18560",
    "name": "Bhosale Babasaheb Havasrav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17566",
    "name": "Bhosale Harish Madhukar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13862",
    "name": "Bhosale Madhukar Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15155",
    "name": "Bhosale Sunil Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14334",
    "name": "Bhosale Sushila Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19277",
    "name": "Bind Sitaram Chawatiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19107",
    "name": "Birodkar Krishna Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18949",
    "name": "Bodake Bharat Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17558",
    "name": "Borade Sheshrao Totaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19199",
    "name": "Borde Nirmala Vidyadhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17354",
    "name": "Borkar Chandrakant Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19825",
    "name": "Borse Santosh Omkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19418",
    "name": "Chaudhary Ajaykumar Surendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18732",
    "name": "Chaugule Tanveer Yusuf"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19378",
    "name": "Chauhan Achhelal Mataprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19365",
    "name": "Chauhan Amala Banvari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18325",
    "name": "Chauhan Gajanan Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18651",
    "name": "Chaurasiya Shivlal Ramkisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10284",
    "name": "Chavan Bhanudas Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19805",
    "name": "Chavan Jagadish Jaiprakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18686",
    "name": "Chavan Jaywant Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19302",
    "name": "Chavan Kishor Movji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18622",
    "name": "Chavan Krishna Bable 7/220"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19542",
    "name": "Chavan Kundalik Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19738",
    "name": "Chavan Parsuram Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13197",
    "name": "Chavan Prakash Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16227",
    "name": "Chavan Rajashree Dattatrya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19639",
    "name": "Chavan Ramesh Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18351",
    "name": "Chavan Sainath Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1329",
    "name": "Chavan Sampat Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10933",
    "name": "Chavan Sudhakar  Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18363",
    "name": "Chavan Vikas Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19556",
    "name": "Chavan Vinod Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18491",
    "name": "Chavre Ankush Jaganath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18439",
    "name": "Chavre Vimal Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18384",
    "name": "Chawan  Mangesh  Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19395",
    "name": "Chikane Narayan Khandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19791",
    "name": "Chikne Anil Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19528",
    "name": "Chilvante Bhimrav Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16106",
    "name": "Chinchwalkar  Ramesh Bhaga."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19357",
    "name": "Chindarkar Ramchandra Bharat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18924",
    "name": "Chokshi Raju Pitambardas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11706",
    "name": "Chorage Bharati Baba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18683",
    "name": "Choudary  Vijay Devaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18430",
    "name": "Choudhary Vakhil Ahmed Jagnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19655",
    "name": "Choudhary Vithal Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19447",
    "name": "Chougule Dayanand Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18638",
    "name": "Chouhan Raisaheb Samarjeet"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18907",
    "name": "Chourasia Harishchandra Radheshyam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19524",
    "name": "Chuhan Laxaman Jaynandan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19267",
    "name": "Dabhade Sunil Motiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19304",
    "name": "Dagadu Babasaheb Rohimal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19589",
    "name": "Dait Baliram Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16541",
    "name": "Dalvi Kirti Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18449",
    "name": "Dalvi Rajiv Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19620",
    "name": "Danavale Vishnu Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18376",
    "name": "Dangale Haribhau Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19354",
    "name": "Dange Sanjay Khusba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18934",
    "name": "Darwatkar Bharat Shripat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19694",
    "name": "Das Geeta Purushotam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19564",
    "name": "Dere Dilip Balasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14206",
    "name": "Desai Amar Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19801",
    "name": "Desai Milind Vishvanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19274",
    "name": "Desai Shashikamt Harishchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19342",
    "name": "Desai Vishwanath Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19166",
    "name": "Deshmukh Narmada Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19604",
    "name": "Deshmukh Vijay Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19546",
    "name": "Devar Murgan Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19656",
    "name": "Devare Pandit Bhaurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19779",
    "name": "Devendra Kumbaiya Subhaya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19038",
    "name": "Dhamapurkar Dhanjaya Madhav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19419",
    "name": "Dhanwade Santosh Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19756",
    "name": "Dhawale  Sanjay Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19359",
    "name": "Dhaygave Dinkar Nivrati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18745",
    "name": "Dhende Prlhad Jayyappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17559",
    "name": "Dhodiya Palji Dosa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15627",
    "name": "Dhokare Manda Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14396",
    "name": "Dhumal Uttamrao Kalyanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18633",
    "name": "Dhuri Jai Prakash R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18708",
    "name": "Dodke Sharad Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19096",
    "name": "Dongare Vasant Appa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18916",
    "name": "Dongre Raju Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19497",
    "name": "Dongre Tanaji Bhamaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19178",
    "name": "Dubay Deviprasad Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19362",
    "name": "Dube Avdeshkumar Durvanaryan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19425",
    "name": "Dube Dinanath Hiralal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19299",
    "name": "Dube Jayprakash Kasipprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19451",
    "name": "Dube Radhakrishna Sheetlaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18627",
    "name": "Dube Rajmani Jaydar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18350",
    "name": "Dubey Adityaprakash Surajbhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19194",
    "name": "Dubey Arunkumar Babulnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19193",
    "name": "Dubey Jayshankar Bholenath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18953",
    "name": "Dubey Krishnakumar Devnaryan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19381",
    "name": "Dubey Ramji Rampal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18567",
    "name": "Dubey Sushilkumar Hansnarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18565",
    "name": "Dubey Tribhuvan Yadunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19844",
    "name": "Dukare Arjun  Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19174",
    "name": "Edris Mohmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19030",
    "name": "Emauddin Mohmad Khaja"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19519",
    "name": "Farnadies Albert John"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19006",
    "name": "Fernandes Sylvester Anthony"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19138",
    "name": "Fhale Vijay Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19567",
    "name": "Firoz Khan Rasid Khan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18324",
    "name": "Firoz Suleman Khan Shiddan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19258",
    "name": "Gadakh Kusum Kasinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19530",
    "name": "Gadakh Ramakant Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18909",
    "name": "Gadekar Jalindhar Natha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16969",
    "name": "Gaikawad Jitesh Ravindra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14560",
    "name": "Gaikawad Laxman Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19786",
    "name": "Gaikawad Sukhadeo Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18923",
    "name": "Gaikawad Sunil  Sudam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19414",
    "name": "Gaikwad Sanjay Ganapat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16480",
    "name": "Gaikwad Satywan Soma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18360",
    "name": "Gajakosh Chandrakant Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19016",
    "name": "Gajare Shankar Bhagawan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19224",
    "name": "Gamre Alka Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19743",
    "name": "Gangawane Sahebrao Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16486",
    "name": "Garasiya Thakora Gulab."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17063",
    "name": "Gare Chandrakant Gunaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19675",
    "name": "Gaud Omprakash Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19054",
    "name": "Gaud Pradeepkumar Ramede"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19424",
    "name": "Gaud Vijay Ramsumer"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19613",
    "name": "Gawada Rama  Uchaiya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19531",
    "name": "Gawade Dhondi Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18983",
    "name": "Gawali  Sandip Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19049",
    "name": "Gawandanant Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19301",
    "name": "Ghadge Dinkar Daulat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18617",
    "name": "Ghag Sandeep Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18465",
    "name": "Ghanawate Ananda Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19009",
    "name": "Ghanekar Ravindra Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19607",
    "name": "Ghatvisave Shravan Rohidas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19641",
    "name": "Ghodekar Subhash Ukhada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19179",
    "name": "Ghodke  Vijaykumar V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19311",
    "name": "Gholap Kisan Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18663",
    "name": "Ghude Santtosh Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17375",
    "name": "Gill Khazan Singh Bahdur Singh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19749",
    "name": "Giri Lalita Ghyanshyam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19649",
    "name": "Giri Vijay Vishwanth"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12724",
    "name": "Goankar Chandrakant Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18659",
    "name": "Goankar Chandrakant Sajnoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18444",
    "name": "Gore Uttam     Dada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18669",
    "name": "Gosavi Anant Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18591",
    "name": "Gosavi Bhagawan Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18611",
    "name": "Gound Omprakash Shreeram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18543",
    "name": "Gowda Shanker Borid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15758",
    "name": "Gujar Rajendra Damodar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17137",
    "name": "Gujaria Jitendra Ramesh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19758",
    "name": "Gulambe Suryakant Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18551",
    "name": "Gulle Thimmesh Veeranna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18392",
    "name": "Gundal Shankar Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19764",
    "name": "Gupata Gulabchandra Santlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19606",
    "name": "Gupata Herilal Pancham"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19742",
    "name": "Gupata Lalbihari Swaminath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19088",
    "name": "Gupata Suresh Keshavprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19111",
    "name": "Gupta    Manoj    T"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19807",
    "name": "Gupta Acchelal Shriram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18693",
    "name": "Gupta Bechulal Zhinku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18497",
    "name": "Gupta Chandrabhan Doma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19265",
    "name": "Gupta Chedilal Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19211",
    "name": "Gupta Dineshchandra Bedilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19391",
    "name": "Gupta Ganesh Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14136",
    "name": "Gupta Harichandra Guruprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19005",
    "name": "Gupta Harishankar Sarju"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18647",
    "name": "Gupta Lallan Prasad Acchelal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19380",
    "name": "Gupta Premchand Bhailal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18636",
    "name": "Gupta Ramesh Chotelal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19242",
    "name": "Gupta Ramesh Gulab"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19086",
    "name": "Gupta Ramji Balram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19508",
    "name": "Gupta Ravi Ramasare"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19255",
    "name": "Gupta Shivkumar  Ccandvali."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19686",
    "name": "Gupta Shivshankar Punvasi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18566",
    "name": "Gupta Shreeniwas Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18432",
    "name": "Gupta Shyamdhar Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19115",
    "name": "Gupta Sitaram Ramnarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19124",
    "name": "Gupta Surendrkumar M."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19189",
    "name": "Gupta Vinodkumar Brijbihari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19332",
    "name": "Gupte Rajendra Pannalal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18985",
    "name": "Haji Mohmad Pokar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19706",
    "name": "Haji Mohmad Y Usuf Usman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18326",
    "name": "Harwani Shekhar Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18694",
    "name": "Havaldar Dilip Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19479",
    "name": "Havaldar Umesh Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19574",
    "name": "Havldar Umesh Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19399",
    "name": "Hegade Sadashiv  Surenna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19177",
    "name": "Honmane Vilas S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19800",
    "name": "Howal Appasaheb Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19511",
    "name": "Hulwan Ravindra Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19307",
    "name": "Inamdar Hobib Kadar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19790",
    "name": "Indulkar Santosh Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19060",
    "name": "Ingavale Udhav Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19591",
    "name": "Ingh Kamleshkumar Satynaryan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19125",
    "name": "Ismail Riyaz Ahamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19469",
    "name": "Iyaz Abdul Reheman Quresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19600",
    "name": "Jadhav Anil Vasudev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19203",
    "name": "Jadhav Chandrakant Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18422",
    "name": "Jadhav Chandramani Changu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19602",
    "name": "Jadhav Digambar Bajirav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18380",
    "name": "Jadhav Dilip Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19172",
    "name": "Jadhav Dilip Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18709",
    "name": "Jadhav Ganehsh Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19229",
    "name": "Jadhav Ganesh Jaysing"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2157",
    "name": "Bhushan Transport"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17889",
    "name": "Jadhav Mahadeo Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18385",
    "name": "Jadhav Mohan Bhupal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17803",
    "name": "Jadhav Rajendra Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18403",
    "name": "Jadhav Rakesh Ahok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15830",
    "name": "Jadhav Ramesh Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18943",
    "name": "Jadhav Ravindra Sampatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18381",
    "name": "Jadhav Sahadeo Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18177",
    "name": "Jadhav Santosh Tulshiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19473",
    "name": "Jadhav Suresh Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19705",
    "name": "Jadhav Sushil Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18382",
    "name": "Jadhav Uyaraj    Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19261",
    "name": "Jaggannath Pujari Giryana Pujari"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2386",
    "name": "Birla Textiles Agency"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13409",
    "name": "Jagtap Chandrasen Vaman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14210",
    "name": "Jagtap Chandu Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19625",
    "name": "Jagtap Dhondiram Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19504",
    "name": "Jagtap Vikas Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16342",
    "name": "Jain Dinesh Mangilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19129",
    "name": "Jain Janaklal Devichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19175",
    "name": "Jaiswal Nandlal Hiralal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19453",
    "name": "Jaiswal Pamodkumr Alguram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19665",
    "name": "Jaiswal Rajendra Anadgopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18303",
    "name": "Jaiswal Rajkumar Vishram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19170",
    "name": "Jaiswal Ramlotan Gopihiraman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19036",
    "name": "Jaiswal Rmojagar  K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16627",
    "name": "Jaitapkar Deepak Prabahkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19085",
    "name": "Jalmi Shobha  Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "412",
    "name": "Jambukar Namdeo Sahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19171",
    "name": "Jamil Anwarbadshah Mohmmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19254",
    "name": "Javkar Rajendra Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18489",
    "name": "Jogiya Usman Ismail"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19614",
    "name": "Joshi Bhagwan Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18510",
    "name": "Joshi Manoj Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18538",
    "name": "Joshi Umesh Vithaldas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18071",
    "name": "Kadam Arpana Digambar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19394",
    "name": "Kadam Kishore Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19308",
    "name": "Kadam Naryan Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18470",
    "name": "Kadam Ravindra Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17915",
    "name": "Kadam Sachin Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19343",
    "name": "Kadam Shankar Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15647",
    "name": "Kadam Shivaji Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18421",
    "name": "Kadam Sugandha  Ravindra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18993",
    "name": "Kadam Sushil Savalaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19039",
    "name": "Kadam Vilas Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18053",
    "name": "Kadav Dinesh Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18511",
    "name": "Kagda Devasingh  Sukhiyaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18702",
    "name": "Kakade Mangesh Lalasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19040",
    "name": "Kale Mahendra Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17876",
    "name": "Kalyankar Narayan Sambaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19712",
    "name": "Kambale  Raju Annappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18434",
    "name": "Kambale Gautam Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18913",
    "name": "Kambale Pandurang Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17645",
    "name": "Kambale Ravindra Kisan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18652",
    "name": "Kambale Suresh Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19079",
    "name": "Kamble Mahadev Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19611",
    "name": "Kambli Dilip Digambar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17908",
    "name": "Kanade Vinayak Ramling"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19817",
    "name": "Kanble Manik Devidas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18493",
    "name": "Kandekar Yuvraj Santu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17178",
    "name": "Kannadkar Santosh Ganesh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18423",
    "name": "Kanojia  Umesh Chandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12358",
    "name": "Karale Ramesh Harishchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19382",
    "name": "Kasbe Ranjeet Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18706",
    "name": "Kasenevaru Ashok Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19552",
    "name": "Kashidali Mohmad Hanif"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19411",
    "name": "Kashyap Prakash Gurunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19323",
    "name": "Kashyap Sumitra Babulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18624",
    "name": "Kasyab Surykumar Banarashi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19202",
    "name": "Kasyap Udayraj Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17564",
    "name": "Katakdhond Raosaheb Sainaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13370",
    "name": "Kate Dasharath Sopan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19173",
    "name": "Katkar Nilkant Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19688",
    "name": "Katkar Pamod Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16799",
    "name": "Katkar Rajendra Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19041",
    "name": "Kedare Raju  Kashinath."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19396",
    "name": "Kedare Suresh Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19484",
    "name": "Keluskar Bharat Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4373",
    "name": "Kerkar Bhikaji Nilkanth"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14632",
    "name": "Kesarkar Ramdas Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19493",
    "name": "Khadatare Satish Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19200",
    "name": "Khade Bhagwan Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18984",
    "name": "Khalid Sayad Abdul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19285",
    "name": "Khamgal Sukhdeo Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14493",
    "name": "Khamkar Deepali Dinanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19120",
    "name": "Khan Abdul Mehboob"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19240",
    "name": "Khan Amir Hussain Momin Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19144",
    "name": "Khan Isthiyak Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19455",
    "name": "Khan Mansul Alam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19691",
    "name": "Khan Mohmad Rafi Aksha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18695",
    "name": "Khan Mohmad Salim Munna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19369",
    "name": "Khan Mphd.Umar Kayum"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19237",
    "name": "Khan Mukhtar Samad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18698",
    "name": "Khan Mukis Hafiz"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19251",
    "name": "Khan Nasir Mehmmd"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19374",
    "name": "Khan Salim Mustkim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18714",
    "name": "Khan Samashu Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18868",
    "name": "Khan Sarfuddin Azhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18655",
    "name": "Khan Sayad S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18873",
    "name": "Khan Shabir Sher"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19529",
    "name": "Khan Sitarannisa Taufiq"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19592",
    "name": "Khan Tahussain Gulamhussain"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19130",
    "name": "Khan Vakil Ahmed Abdul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18614",
    "name": "Khandagale  Haridas Ganapat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18186",
    "name": "Khandagale Annasaheb Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19157",
    "name": "Khandagale Laxman Damu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19313",
    "name": "Khandekar Gulab Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19297",
    "name": "Kharatmal Suresh Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19571",
    "name": "Kharwar Sanjay Prasad S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19268",
    "name": "Khatke Mahananda Ramdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18925",
    "name": "Khatri Gopal Krishna Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19583",
    "name": "Khatu Santosh Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4046",
    "name": "C.M. Cargo Movers"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18616",
    "name": "Khatwad  Shantaram Ganapat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19312",
    "name": "Khobarekar Chibildas Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2042",
    "name": "Cash Deal Corporation"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19163",
    "name": "Kokate Balram D Ashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17450",
    "name": "Koltharkar Leena Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19488",
    "name": "Kori Krishnakumar Ansari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18995",
    "name": "Kotkar Nandkumar K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19186",
    "name": "Krumi Jawaharlal Shivprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18015",
    "name": "Kumbhar Chandrakant Vishnu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18132",
    "name": "Kumkar  Pandarinath Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "837",
    "name": "Kunkule Vasant Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19102",
    "name": "Kurkute Sakharam Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19565",
    "name": "Kuslenkar Naga Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19291",
    "name": "L. Palani Laxminarayan Swami"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16206",
    "name": "Labade Sangeeta Jivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14860",
    "name": "Lad Anuradha Omprakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19400",
    "name": "Lad Motiram Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19823",
    "name": "Lawand Vinod Sopan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18637",
    "name": "Ligade Bharat Machindar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18615",
    "name": "Ligade Haridas Machindra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19576",
    "name": "Lokhande Ashok Laximan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19481",
    "name": "Lokhande Ashok Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19627",
    "name": "Londhe Rajendra Pilaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17560",
    "name": "Londhe Uttam Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19609",
    "name": "Magade Bhimrao Motiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8883",
    "name": "Mahadik Dhondu Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19548",
    "name": "Mahadik Dnyaneswar Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19657",
    "name": "Mahadik Gopal Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17927",
    "name": "Mahadik Vidula Vishavnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19763",
    "name": "Mahadik Virendra Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18988",
    "name": "Mahale Prashant Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19526",
    "name": "Mahanti Santosh Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19510",
    "name": "Mahaske Uttam Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19692",
    "name": "Mahulkar Milind Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18715",
    "name": "Mairale Mukund Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "574",
    "name": "Chandulal D Mehta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17556",
    "name": "Makawana Jayram Ganga"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19140",
    "name": "Mali Vinod Janu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18699",
    "name": "Mallah Shyamlal Murli"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19058",
    "name": "Malusare Yeshwant Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19262",
    "name": "Maluskar Vilas Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19457",
    "name": "Mandamiya Yusuf Daoud"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3339",
    "name": "Charbhuja Silk Mills"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18599",
    "name": "Mande Anil Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "711",
    "name": "Mande Popat Janku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14537",
    "name": "Mandhare Balasaheb Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18447",
    "name": "Mandlik Manohar Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18013",
    "name": "Mandve Sachin Nathu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16163",
    "name": "Mandvekar Mariti Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19739",
    "name": "Mane Ashok Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19555",
    "name": "Mane Pundlik Dattu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19136",
    "name": "Mane Vijay Balawant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11881",
    "name": "Mane Vithoba Bhiva"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19402",
    "name": "Mani Ganpathi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17786",
    "name": "Manjarekar Dikshita Dipak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19741",
    "name": "Manjarekar Mahaesh Raghuvir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18585",
    "name": "Manjarekar Vijay Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19798",
    "name": "Manral  Khimsingh  Bhagsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19053",
    "name": "Maskar Santosh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18469",
    "name": "Maske Dilip Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19303",
    "name": "Masurkar Ganesh Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16064",
    "name": "Masurkar Pradeep Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11529",
    "name": "Mathews Shiji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19167",
    "name": "Maurya Rajeshkumar Bholenath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19352",
    "name": "Medekar Prakash Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19353",
    "name": "Mehraj Ali Yawar Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19121",
    "name": "Mehta Ashok Ranchoddas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18604",
    "name": "Mendes Don Girician"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13682",
    "name": "Mhaskar Chandrakant Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19409",
    "name": "Mhatre Jaywant Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19563",
    "name": "Mhatre Kamlakar Motiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19471",
    "name": "Mhatre Vikas Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19238",
    "name": "Mishra  Ramsagar Shivmurat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19057",
    "name": "Mishra Bans Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19286",
    "name": "Mishra Bhanupratap Gomtiprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19618",
    "name": "Mishra Devkant Vikramditya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18654",
    "name": "Mishra Dinesh Kumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19441",
    "name": "Mishra Jaichand Ramnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18605",
    "name": "Mishra Jawahar Rameshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19243",
    "name": "Mishra Jilajeet Girijashankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19355",
    "name": "Mishra Rajendra Prasad Syabarali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19450",
    "name": "Mishra Rajendrakumar Mataprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19047",
    "name": "Mishra Ramakant  Shirprasadi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18917",
    "name": "Mishra Shivkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19566",
    "name": "Mishra Shivpujan Shamshankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18353",
    "name": "Mishra Shivshanker Dudnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19002",
    "name": "Mishra Subhashchandra Shrinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19345",
    "name": "Mishra Triyogi Deepanarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19405",
    "name": "Mishra Vinodkumar Bhagwati Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19377",
    "name": "Misra Udaykant Shripal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19420",
    "name": "Mistry Kalpana Ravindra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19159",
    "name": "Mohamad Ekbal Mohamad Hussen"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18946",
    "name": "Mohamad Jahir Mohamad Hamid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18877",
    "name": "Mohammad Faizal Mohammd Sahid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18437",
    "name": "Mohammad Jainuddin Isak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19101",
    "name": "Mohd  Ikram Mohd Yasim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18662",
    "name": "Mohd Anwar Mohd"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19406",
    "name": "Mohite Nanda  Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19143",
    "name": "Mohmad Aslam  Mohm Naim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19622",
    "name": "Mohmad Harun Mohmad Arif"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19624",
    "name": "Mohmad Parvaj Abu Bakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19475",
    "name": "Mohmmad Abid Mohd. Muslim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19269",
    "name": "Mohmmad Kasam Bane Miya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19465",
    "name": "Mohmmad Shakil Mohmmad Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19502",
    "name": "Mohmmad Yasin Mohmmad Munirshaikh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19334",
    "name": "Mohmmd Rafiq Gani Shaikh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19219",
    "name": "Mohmmed  Sazid Shaikh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18397",
    "name": "Mokashi Mohd Aslam Gatal Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18590",
    "name": "More Bapu Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18903",
    "name": "More Deepak Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19603",
    "name": "More Deepak Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19099",
    "name": "More Devram Arjune"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19160",
    "name": "More Dilip Uttam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17762",
    "name": "More Hitendra  Atamaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17596",
    "name": "More Kishor Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18540",
    "name": "More Mahesh Anna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19205",
    "name": "More Prakash Rajuji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19270",
    "name": "More Ramesh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17853",
    "name": "More Ravindra Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17280",
    "name": "More Sharad Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18393",
    "name": "More Sujata Bhagwan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18592",
    "name": "Morya Dinanth Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19429",
    "name": "Mote Siddharth Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19760",
    "name": "Mote Sukhdeo Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19586",
    "name": "Mote Sukhdev Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19156",
    "name": "Mourya Nandlal Lawdhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19155",
    "name": "Mourya Ramjanak Malaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18569",
    "name": "Mugase Balkrishna Gangadhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18800",
    "name": "Mugase Ramesh Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17093",
    "name": "Mujawar Faruq Shaukat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18932",
    "name": "Mukadam Tauficmohamad Husen"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15118",
    "name": "Mulik Nandkumar Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19217",
    "name": "Mulla Mohabat Nasruddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19580",
    "name": "Murande Dnyashwar Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19273",
    "name": "Murudkar Nandkishor Dhulaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19363",
    "name": "Mustak Shaikh Ali Bahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19367",
    "name": "Nagatilak Sudhakar  Babrvan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19554",
    "name": "Nagothnekar Bharat Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19340",
    "name": "Nagpal Daulat Arjandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19560",
    "name": "Naik Meghshyam Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19081",
    "name": "Naik Rajendra Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18348",
    "name": "Naik Ramesh Sura"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14827",
    "name": "Naik Vishal Sharad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19294",
    "name": "Nalawade Nilesh Subhash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16337",
    "name": "Nalawade Vijay Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18581",
    "name": "Nambiar Dinesh Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19629",
    "name": "Namdhare Ramesh Tamani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19572",
    "name": "Nandkishor K. Bhoir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15858",
    "name": "Nangre Nivendra Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19333",
    "name": "Narappa Ashappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18409",
    "name": "Narwade Kisan  Sudam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19748",
    "name": "Naryankar Rajendra Anappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19087",
    "name": "Nasir Ahmed Allauddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5900",
    "name": "Navadkar Hanmant Narsing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18898",
    "name": "Navgare Pandurang Sheku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19444",
    "name": "Nawani Suresh Laxmichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19690",
    "name": "Naze Rahil Abdul Mazid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18499",
    "name": "Negi Jaykrit Kundansingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16533",
    "name": "Nerurkar Vivek Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18687",
    "name": "Nevrekar Rajendra Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19139",
    "name": "Nikam Dilip Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11751",
    "name": "Nikam Krishna Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19188",
    "name": "Nikam Sanjay Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19713",
    "name": "Nikam Vishwas Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19538",
    "name": "Nimbalkar Prakash Dnyanoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18791",
    "name": "Nimble Sudesh Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19633",
    "name": "Nirmal Mannulal Mahavir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18597",
    "name": "Noor Mohamomd Hasan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14973",
    "name": "Paaste Shivram Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18872",
    "name": "Padule Surykant Ramchndra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17808",
    "name": "Padyar Ravindra Dhaku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19338",
    "name": "Pagare Balu Dharma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19223",
    "name": "Pal Chotelal Budhiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19309",
    "name": "Pal Javaharilal Jayram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19045",
    "name": "Pal Kalichran Khedanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18875",
    "name": "Pal Omprakash Hubraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18676",
    "name": "Pal Rajkumar Shivmurat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19456",
    "name": "Pal Ramnarayn Ramlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19089",
    "name": "Pal Rampyare Ramnihor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19185",
    "name": "Pal Shitalprasad Chabburam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19640",
    "name": "Palave Surendra Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18696",
    "name": "Panda Santosh Kumari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18558",
    "name": "Panday Harishankar Chhotkan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19061",
    "name": "Pande Premprakash Ghotelal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19075",
    "name": "Pande Shyamcharan Dayaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19623",
    "name": "Pande Vijaybahadur Shivnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18705",
    "name": "Pandey Jitendrakumar Hanuman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18349",
    "name": "Pandey Rajaram Satyanarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19673",
    "name": "Pandey Rajeshkumar Raghuraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19486",
    "name": "Pandey Rajmani Ramnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19523",
    "name": "Pandey Surendrakumar Shardaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18500",
    "name": "Pangula P.L. Ramalu  Lingya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19252",
    "name": "Panjabi Prakash Parmanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18541",
    "name": "Pansare Bhimrao  Bapurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17542",
    "name": "Parab Arvind Madhukar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19241",
    "name": "Parab Indumati Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17888",
    "name": "Parab Jayshree Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15950",
    "name": "Parab Mayuresh Sadanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19561",
    "name": "Parab Prashant Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17401",
    "name": "Parab Ujwala Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8094",
    "name": "Parab Uttam Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15761",
    "name": "Parave Arati Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "820",
    "name": "Parkar Radhakrishna Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16914",
    "name": "Parte Janardhan Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19723",
    "name": "Pasi Musafir Ramraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7832",
    "name": "Patane Sopan Abaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19145",
    "name": "Patel Chabildas Lalbhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18948",
    "name": "Patel Dishad Kayyum"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19490",
    "name": "Patel Lallanprasad Amritlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19403",
    "name": "Patel Mahendra Babhubhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18474",
    "name": "Patel Mahesh Dayaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18578",
    "name": "Patel Mukhatar Alli"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19645",
    "name": "Patel Mustak Hussein"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18671",
    "name": "Patel Ramesh Chandra Ram Lal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18634",
    "name": "Patel Vinod Ranchood"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19339",
    "name": "Pathak Radheshyam Maniram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18583",
    "name": "Pathak Rameshchandra Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19500",
    "name": "Pathan Yakub Mohmmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18730",
    "name": "Pathare Ramesh Trimbak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18537",
    "name": "Pathare Suresh Trimbak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18283",
    "name": "Pathare Swapnil Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18746",
    "name": "Patil Anandrao Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12357",
    "name": "Patil Anil Rama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18688",
    "name": "Patil Bharat Kanjibhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16992",
    "name": "Patil Bhupesh Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19636",
    "name": "Patil Daulat Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19137",
    "name": "Patil Dnyandeo Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13720",
    "name": "Patil Geeta Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19213",
    "name": "Patil Haresh Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15457",
    "name": "Patil Krishna Aaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18950",
    "name": "Patil Krishna Damodhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19253",
    "name": "Patil Manik Jaggannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18914",
    "name": "Patil Manohar Santaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19799",
    "name": "Patil Rohidas Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19549",
    "name": "Patil Samadhan Shyamrav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18488",
    "name": "Patil Sanjay Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19314",
    "name": "Patil Santosh Gambhir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19214",
    "name": "Patil Santosh Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12356",
    "name": "Patil Sunil Rama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19505",
    "name": "Patil Vilas Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19306",
    "name": "Patva Prabunath Vaijnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19802",
    "name": "Pawar Chandrakant Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19221",
    "name": "Pawar Manoj Murlidhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18866",
    "name": "Pawar Namdeo Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19503",
    "name": "Pawar Prakash Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19319",
    "name": "Pawar Rajendra Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18723",
    "name": "Pawar Rajesh Vishvnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18411",
    "name": "Pawar Sachin Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18629",
    "name": "Pawar Sadanand Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19421",
    "name": "Pawar Santosh Hanumant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12424",
    "name": "Pawar Subhash Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18712",
    "name": "Pawase  Vittahal Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18559",
    "name": "Pawaskar Shrikrishna Vishram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18408",
    "name": "Pawaskar Vilas Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19350",
    "name": "Pethasange Parmeshwar Satppa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19547",
    "name": "Phapale Rajaram Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19044",
    "name": "Pinjari Rasool Haidersab"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19070",
    "name": "Podndekar Yeshwant Nanya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19482",
    "name": "Poojari Rekha Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13136",
    "name": "Pophale Shashikant Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19634",
    "name": "Prajapati Banwarilal Nawaki"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19736",
    "name": "Prajapati Dayaram Tilhuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19187",
    "name": "Pramar Kishor Rawaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18911",
    "name": "Prasad Ramfher Indrajit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18653",
    "name": "Prashade Mahesh Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18556",
    "name": "Qureshi Abdul Vahid Abdul Hamid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19103",
    "name": "Qureshi Mohd Salim Shabbir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19127",
    "name": "Rai  Raghwendra  Umashankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18679",
    "name": "Raikar Sudhir Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19141",
    "name": "Rajbar Shivnarayan Rajdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19197",
    "name": "Rajbhar  Lalji  Pakharan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18881",
    "name": "Rajbhar Udaypratap Sharda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14559",
    "name": "Rajeshirke Shriram Gopalji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19768",
    "name": "Rajiwade Ramdas Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18639",
    "name": "Ranbhadur Baban Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13468",
    "name": "Rane Ashok Vaman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19605",
    "name": "Rane Chandrakant Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19733",
    "name": "Rane Gopinath Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18880",
    "name": "Rane Nilkant Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19788",
    "name": "Ranjan Jaki Sudhir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17819",
    "name": "Rasal Manohar Parshuram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17686",
    "name": "Rasal Shilpa Shashikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19390",
    "name": "Rashid Khan Hidaytulla Khan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18878",
    "name": "Rathod Davanand Soma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18539",
    "name": "Ravandale Sheshrao Satvaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19771",
    "name": "Ravidhone Bhagvan Jyotiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19557",
    "name": "Rawat Rajeshram Fulchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18375",
    "name": "Rawool Vitthal Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18886",
    "name": "Razak Abdul Gani Mohameed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18726",
    "name": "Rebello Constancio Sapru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18552",
    "name": "Reddy Venkat Ram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14092",
    "name": "Redekar Amrtuta Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15442",
    "name": "Redkar Vasant Radhakrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19162",
    "name": "Rege Millind G"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19707",
    "name": "Rehman  Mohmad Sherif Abdul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19315",
    "name": "Rhate Bhaguji Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19663",
    "name": "Rokade Nandkumar Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19750",
    "name": "Rupnar Dadasaheb Rawaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19512",
    "name": "Rupnar Shivaji Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19480",
    "name": "Sah Pramodkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19527",
    "name": "Said Pasu Nandumiya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18509",
    "name": "Sakpal Rohidas Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15620",
    "name": "Sakpal Vanita Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19573",
    "name": "Saksena Naresh Bhushan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19227",
    "name": "Salekar Rajendra Atmarama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19513",
    "name": "Salian Shankar Appu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19296",
    "name": "Salunkhe Krishna Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19784",
    "name": "Salve Santosh Naryan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19348",
    "name": "Sanas Kisan Bhagoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18744",
    "name": "Sanas Madhukar Shripat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19356",
    "name": "Sandbhor Sanjay Malhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19532",
    "name": "Sandbhor Sanjay Malhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17992",
    "name": "Sangale Mahesh Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14674",
    "name": "Sangaonkar Bandu Ravji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19215",
    "name": "Sankapal Bhagawan Baraku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19501",
    "name": "Sarada Abdulrazaq Mohmmadsiraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19320",
    "name": "Sarmalkar Shankar Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19375",
    "name": "Sasane Dilip Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19787",
    "name": "Sasulade Mandodary Gokuldas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19728",
    "name": "Sathe Dhondiram Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19067",
    "name": "Sathe Kashinath Baburav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18487",
    "name": "Satle Sunil Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19042",
    "name": "Satpute Avinash Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19263",
    "name": "Savale Gurappa Murappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12929",
    "name": "Sawant Anjali Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19346",
    "name": "Sawant Chandrakant Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19483",
    "name": "Sawant Deepak Achut"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19642",
    "name": "Sawant Prdeep Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17823",
    "name": "Sawant Sandesh Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19803",
    "name": "Sawant Santosh Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19757",
    "name": "Sawant Shrirang Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16861",
    "name": "Sawant Sunanda Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18133",
    "name": "Sawant Suryakant Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12694",
    "name": "Sawant Swati Suryakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19491",
    "name": "Sawat Ayub Nanubhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19492",
    "name": "Saxena Naresh Bhushan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18674",
    "name": "Sayyad Mohamad Husain Kadar Miyya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19093",
    "name": "Sayyad Rehaman Isak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19204",
    "name": "Sayyad Saffi Hasan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19220",
    "name": "Sejal Keshav  Ramu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18547",
    "name": "Shah Chandrakant Prabudas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18668",
    "name": "Shah Paresh Ramanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16890",
    "name": "Shah Samsher Minbahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19388",
    "name": "Shaha Gopal Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19123",
    "name": "Shaikh  Mohamod Muslim Mad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18912",
    "name": "Shaikh  Shahajan Kasim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19007",
    "name": "Shaikh Abdual Rehaman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19371",
    "name": "Shaikh Abdul Aziz Abdul Malik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19384",
    "name": "Shaikh Abdul Jabbar Husein"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19056",
    "name": "Shaikh Abdul Jalila"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19806",
    "name": "Shaikh Abdul Mohd  Mustakim Mohd"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18598",
    "name": "Shaikh Ahmad Jikiya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18572",
    "name": "Shaikh Alram Bahadar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19693",
    "name": "Shaikh Asghar Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18596",
    "name": "Shaikh Ashik Noormohmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19116",
    "name": "Shaikh Babu Shaikh Ajij"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19628",
    "name": "Shaikh Bhola Mohmad Husen"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19410",
    "name": "Shaikh Fida  Husain"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19570",
    "name": "Shaikh Firoz Ahmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19582",
    "name": "Shaikh Gulam Hussain Abdul Karim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18940",
    "name": "Shaikh Hasina Rais"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19413",
    "name": "Shaikh Hisamuddin Abdul Karim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19389",
    "name": "Shaikh Imran Shaikh Yunus"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19011",
    "name": "Shaikh Kulsum B Abdul Ajij"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18563",
    "name": "Shaikh Mansur Ali Jawad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19181",
    "name": "Shaikh Mehaboob Inamdar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19216",
    "name": "Shaikh Mo Asalam Abdul Latif"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18675",
    "name": "Shaikh Modh Salim  Abadul Gani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18395",
    "name": "Shaikh Mohammed Mobin Firozali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19762",
    "name": "Shaikh Mohd Sadik Mohd Yusuf"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18564",
    "name": "Shaikh Mohd.Hanif Yusuf"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19122",
    "name": "Shaikh Mohmad Islam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18729",
    "name": "Shaikh Momd. Ghouse Momd.Hamid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19293",
    "name": "Shaikh Noormohammad Mohd.Umar+"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19608",
    "name": "Shaikh Parvej Abdul Jallar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18377",
    "name": "Shaikh Rafique Ismail"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18736",
    "name": "Shaikh Rahimulla Hamid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18475",
    "name": "Shaikh Rasool Chand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18707",
    "name": "Shaikh Rayees Ahmed Niyag Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18942",
    "name": "Shaikh Riyaz Abdul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19664",
    "name": "Shaikh Sagir Ahmed Munir Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19449",
    "name": "Shaikh Samshuddin Noormohmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19721",
    "name": "Shaikh Shabir Ali Kamruddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18888",
    "name": "Shaikh Shah Mohameed Salar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18792",
    "name": "Shaikh Shaukat Abdulkarim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19804",
    "name": "Shaikh Zahir Babajan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19774",
    "name": "Sharma Arvindkumar Omprakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18580",
    "name": "Sharma Raghuveerprasad Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19003",
    "name": "Sharma Rajaram Balbal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19489",
    "name": "Sharma Rajnath Jagadambaprsad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19507",
    "name": "Sharma Ramasare Jaganath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18327",
    "name": "Sharma Sampat Mahatam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19337",
    "name": "Sharma Shrikant Marwoo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18433",
    "name": "Sharma Vinodkumar Chandrabhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19317",
    "name": "Sheikh Hasinabegam Noormohamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19316",
    "name": "Shekh Vahabuddin Shabuddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18717",
    "name": "Shelar Bhausaheb Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17530",
    "name": "Shende Hari Baburao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18685",
    "name": "Shenlakar Baban Rawaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19146",
    "name": "Shere Ashok Tulsiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16828",
    "name": "Shere Sandeep Arun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19463",
    "name": "Shete Sunil Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19104",
    "name": "Shetty Karunakar Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19275",
    "name": "Shimpi Gulab Babulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18891",
    "name": "Shinde Deepak Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18697",
    "name": "Shinde Ganpat Nanabhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15916",
    "name": "Shinde Krishnat Tukaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17865",
    "name": "Shinde Nilesh Suresh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19612",
    "name": "Shinde Pandharinath Uttamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18867",
    "name": "Shinde Ramesh Sitram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1291",
    "name": "Chetan Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2500",
    "name": "Chhajed Corporation"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19445",
    "name": "Shinde Shrikant Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8781",
    "name": "Shinde Sopan Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19228",
    "name": "Shinde Suresh Khandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19472",
    "name": "Shingade Popat Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19029",
    "name": "Shirkar Deepak Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18743",
    "name": "Shirke Anant Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9345",
    "name": "Shirke Santosh Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19147",
    "name": "Shirkhande Abadas Ramdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18657",
    "name": "Shirodkar Arun Nilkanth"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11858",
    "name": "Shitole Tejkumar Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19543",
    "name": "Shivgan Sakharam Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19190",
    "name": "Shivnarayan  Sing Rampal Sing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18933",
    "name": "Shrivardhan Jayanti  Janardhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18926",
    "name": "Shukala Ashokkumar Mangal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19597",
    "name": "Shukala Surymani R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19700",
    "name": "Shukla Dyashankar Satyanarayan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19416",
    "name": "Shukla Gajanan Sanktaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18557",
    "name": "Shukla Harishankar Ramdular"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18643",
    "name": "Shukla Ramakant Ramprakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19831",
    "name": "Shukla Ramkishor Shivsharan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19468",
    "name": "Shukla Surendraprasad Girjashankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18352",
    "name": "Shukla Umakant H"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19257",
    "name": "Siddik Sanaullaa Movakil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18606",
    "name": "Siddque Tifiq Alam Shah Mohd"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18610",
    "name": "Sing Avdushkumar Pheku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18938",
    "name": "Sing Kanchan Yadunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19436",
    "name": "Singh  Gyan  Kushalpal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19264",
    "name": "Singh  Rajendrabahadur Mataprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18435",
    "name": "Singh  Sanjay Ramharakh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19168",
    "name": "Singh  Shivkumar V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19034",
    "name": "Singh Amarsing K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18894",
    "name": "Singh Anant Rangeet"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18284",
    "name": "Singh Chatendrnath Jaggnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19520",
    "name": "Singh Dalsingh Gurubahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19196",
    "name": "Singh Dharamvir Kamla"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19113",
    "name": "Singh Dhruvraj Rajbali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19364",
    "name": "Singh Jaswant Prasadsingh Bhawanisingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19635",
    "name": "Singh Lalji Parasnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19439",
    "name": "Singh Man Singh Tirthraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19142",
    "name": "Singh Manoj Kumar  Brijbihari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19373",
    "name": "Singh Manojkumar Chotelal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3397",
    "name": "Chirabazar Jewellers Council"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17376",
    "name": "Singh Naresh Kumar Muniram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19722",
    "name": "Singh Omkarnath Satyanarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18944",
    "name": "Singh Rajeshpratap Baburam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19208",
    "name": "Singh Rajeshwar Randheer"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19689",
    "name": "Singh Ramvijay Raghupati"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1173",
    "name": "Chitlangi & Associates"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19485",
    "name": "Singh Ravindra J."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19066",
    "name": "Singh Ravindra Kedar"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "614",
    "name": "Chitra -Darshan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17770",
    "name": "Singh Ravindra S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19417",
    "name": "Singh Santosh Rajmani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18589",
    "name": "Singh Santoshkumar Laln"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19744",
    "name": "Singh Satyanaryan Bechan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18939",
    "name": "Singh Shivlal Jadunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19746",
    "name": "Singh Surendra Bahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19404",
    "name": "Singh Surendrakumar Tilakwadi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19824",
    "name": "Singh Suryapratap Bahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19212",
    "name": "Singh Umashankar Ramavtar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19176",
    "name": "Singh Urmila Feku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19341",
    "name": "Singh Vijaypal Rambharose"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2318",
    "name": "Chokshi & Sons"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19550",
    "name": "Sinh Lallan Manik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18010",
    "name": "Siroya Mansi Kamlesh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18443",
    "name": "Solanki Jasabhai Dayabhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19278",
    "name": "Sonar Harishankar Tileshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18134",
    "name": "Sonavane Ananda Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19017",
    "name": "Sonavane Madhukar Chandraji A"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19256",
    "name": "Sonawane  Dhondiram Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19584",
    "name": "Sonawane Pravin  Shrihari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19077",
    "name": "Sonawane Ramesh Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18383",
    "name": "Sonawane Ramesh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19466",
    "name": "Sonkar Surendrakumar Mithailal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19412",
    "name": "Subramin  Chinna Kuladi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17644",
    "name": "Sunjay Vitthal Rananaware"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19534",
    "name": "Sureshsingh Magarsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13738",
    "name": "Surve Ashok Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18571",
    "name": "Surve Sanjay Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19331",
    "name": "Suryawanshi Ashoka Dnyana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19149",
    "name": "Suryawanshi Chagan Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19018",
    "name": "Suryrao Santosh Hanumant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17073",
    "name": "Sutar Arjun Ramu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5432",
    "name": "Sutar Vasant Piloba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18931",
    "name": "Suvarna Naryan Sundar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18635",
    "name": "Tahir Ali Anwar Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18328",
    "name": "Talahari Raju Posaiha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19437",
    "name": "Talekar Vijay Shantram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18703",
    "name": "Tambe Anant Janu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19218",
    "name": "Tambe Rajesh Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18448",
    "name": "Tamboli Gulab Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18595",
    "name": "Tandel Dhiraj Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18550",
    "name": "Tandel Jagannath Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18870",
    "name": "Tanpure Rohidas Ekanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19232",
    "name": "Tedore Mohan Bangera"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15086",
    "name": "Tele Subhash Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19658",
    "name": "Thakkar Deepak Jagjivan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19585",
    "name": "Thakur Dilip Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17374",
    "name": "Thakur Karanbahadur Birbahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18678",
    "name": "Thakur Shailendra Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19833",
    "name": "Thite Bajirao Babasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19677",
    "name": "Thorat Naresh Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19773",
    "name": "Thorat Prashant Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19206",
    "name": "Tikekar Kisan Girju"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19119",
    "name": "Tiwari Amarprakash Dhaniram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18008",
    "name": "Tiwari Anil Amarnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19062",
    "name": "Tiwari Jagdish Chintamani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19464",
    "name": "Tiwari Jatashankar Matukdhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19537",
    "name": "Tiwari Karuna Shankar Shardaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19226",
    "name": "Tiwari Premshankar Ramshankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19336",
    "name": "Tiwari Rajivkumar Lalji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19596",
    "name": "Tiwari Ramakant Shivpraad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19065",
    "name": "Tiwari Subhashchandra Ramdar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19674",
    "name": "Tiwari Surendraprasad Ramapati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19370",
    "name": "Tiwari Vijayshankar Rajnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19001",
    "name": "Tiwari Vishwambarnath Rajdhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14145",
    "name": "Toraskar Subhash Jaydeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19292",
    "name": "Tripathi Anilkumar Radheshyam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19164",
    "name": "Tripathi Dilip Kumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19644",
    "name": "Tripathi Lalaji Mukanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19235",
    "name": "Tripathi Rameshkumar Jagdamba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19476",
    "name": "Trivedi Jayprakash  Parmatma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19259",
    "name": "Tupe Sudhakar Nandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19230",
    "name": "Upadhay Dasharath Ramkhilavan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19467",
    "name": "Upadhay Jatashankar Chandramani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18801",
    "name": "Upadhyaramachal  Ramkishor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19747",
    "name": "Uppadhyya Rameshchandra Dinanth"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18710",
    "name": "Vagare Bapu Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19083",
    "name": "Vare Dinkar Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17804",
    "name": "Varhadi Shilpa  Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6045",
    "name": "Varhadi Vimal Chandrkant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19462",
    "name": "Varma Baburam Bekaru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19064",
    "name": "Varma Chhotelal Vishwnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18879",
    "name": "Varma Lalmani  Shivmurthi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18945",
    "name": "Varma Rajkumar Jayram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18961",
    "name": "Varma Ramkewal Rambharose"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19710",
    "name": "Varma Ramvachan Bhagawati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19165",
    "name": "Varma Sabhajit  Ramkishan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19289",
    "name": "Vazir Sayyad Tarmahamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18594",
    "name": "Vedarkar Prakash Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19666",
    "name": "Vedpathak Dilip Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12940",
    "name": "Velonde Prakash Rambhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18471",
    "name": "Vetal Shantaram Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6867",
    "name": "Vidhate Shantaram Dhanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19734",
    "name": "Vidyakant Rampare"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18396",
    "name": "Vishawkarma Hiralal Budhiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19028",
    "name": "Vishvkarma Amarnath V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19832",
    "name": "Vishwakarma Ashok Ramkripal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19415",
    "name": "Vishwakarma Chandrbali Pancham"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17607",
    "name": "Wadkar Laxmi Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19231",
    "name": "Wadke  Ravindra Bairam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19043",
    "name": "Wagh Sunil Kacharu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14401",
    "name": "Waghela Dhanji Raja"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19840",
    "name": "Waghila Sharad Maganlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19290",
    "name": "Waje Raju Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18994",
    "name": "Wakale Khandu Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18952",
    "name": "Warkhade Dilip Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18915",
    "name": "Warwatkar Kashinath Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19662",
    "name": "Wayal Gopinath Devram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19276",
    "name": "Yadav  Rajnarayan Rajpal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19559",
    "name": "Yadav  Sureshkumar Chaturi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18623",
    "name": "Yadav Abasaheb Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19310",
    "name": "Yadav Amarnath Nageshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19072",
    "name": "Yadav Bechanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19621",
    "name": "Yadav Chhotelal Sakku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19379",
    "name": "Yadav Dayashankar Ramnaresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19601",
    "name": "Yadav Deepak Kadadin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19234",
    "name": "Yadav Dinanath Ramkaran"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18472",
    "name": "Yadav Ekanath Bodake"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19525",
    "name": "Yadav Girijashankar Ramsurat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19430",
    "name": "Yadav Gopaldas Ramraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19598",
    "name": "Yadav Hanscry Ramraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19452",
    "name": "Yadav Hublal Ramdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19841",
    "name": "Yadav Jawarlal Deviprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19148",
    "name": "Yadav Jilajeet Bholanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18490",
    "name": "Yadav Jiledar Ramdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19260",
    "name": "Yadav Kailasnath Ramdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19272",
    "name": "Yadav Kamataprasad Indrajit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18285",
    "name": "Yadav Kamlesh  Laloo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18568",
    "name": "Yadav Lalchand Nanku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19327",
    "name": "Yadav Lallan Kedarnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19180",
    "name": "Yadav Mahendra Basant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19648",
    "name": "Yadav Maruthi Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1781",
    "name": "Citizen Salses Corporation"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19358",
    "name": "Yadav Maruti Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "405",
    "name": "Com Tek"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19266",
    "name": "Yadav Muniraj Ayodyaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19076",
    "name": "Yadav Panchbahadur C."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19368",
    "name": "Yadav Pandharilal Ramjiyavan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19133",
    "name": "Yadav Parmesh Shivdhani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17988",
    "name": "Yadav Pradnya Datta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19108",
    "name": "Yadav Rajendra Ramnihar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19322",
    "name": "Yadav Rajendrakumar Matacharan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19423",
    "name": "Yadav Rajesh  Brijlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19074",
    "name": "Yadav Rajnath Rajkiran"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19233",
    "name": "Yadav Ramakant Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19767",
    "name": "Yadav Ramashankar Mataprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19361",
    "name": "Yadav Rameshchandra Lalji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19150",
    "name": "Yadav Ramjas Lalmat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19128",
    "name": "Yadav Ramkhelawan  Sachai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19671",
    "name": "Yadav Ramlakhan Makdam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19073",
    "name": "Yadav Ramlal Rajman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19732",
    "name": "Yadav Ramniharprasad Vishwnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18810",
    "name": "Yadav Ramsurat Shreenath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18410",
    "name": "Yadav Ramyash Mahesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17518",
    "name": "Yadav Randhawa Ramprit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19440",
    "name": "Yadav Ranjeet Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17906",
    "name": "Yadav Reshma Dattu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14819",
    "name": "Yadav Sadhana Mansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19434",
    "name": "Yadav Satyaram  Rambhajan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19063",
    "name": "Yadav Sevalal Dukhram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19432",
    "name": "Yadav Shivpalat Shyamlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18890",
    "name": "Yadav Shobhnath Lalgi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18895",
    "name": "Yadav Shubhash Chandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18486",
    "name": "Yadav Sohansingh Siddawar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18275",
    "name": "Yadav Subhash Pralhad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19360",
    "name": "Yadav Subhashchandra  Jainarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19553",
    "name": "Yadav Sudhakar Chaturi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18887",
    "name": "Yadav Sunil Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18670",
    "name": "Yadav Surendra Gaurishankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19458",
    "name": "Yadav Surendrakumar Jokhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19558",
    "name": "Yadav Tejbahadur Ramdular"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14871",
    "name": "Yadav Umesh Mansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19676",
    "name": "Yadav Vijaykumar Phiraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19239",
    "name": "Yadav Vijaykumar Rajkiran"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19287",
    "name": "Yadav Vishram Chunilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19158",
    "name": "Yadhav Shobhanath K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19454",
    "name": "Yewalekar Jaiprakash Padmakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17588",
    "name": "Zagade Chandrakant Rambhau."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18584",
    "name": "Zende Jaisingh Sadhu"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "107",
    "name": "Dalichand Chhogmal & Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "653",
    "name": "Damodar & Co."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19778",
    "name": "Jagadia Deepak Dana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17189",
    "name": "Aditya Seva Mandal ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15607",
    "name": "Adivarekar Ganesh Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18299",
    "name": "Adsule Ramesh Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2010",
    "name": "Deepak Arts"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13246",
    "name": "Ardekar Eknath Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16714",
    "name": "Bagal  Amol Rivaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19653",
    "name": "Bangale Sharda Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14770",
    "name": "Bendre Kashiram Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12489",
    "name": "Bhilare Pravin Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16004",
    "name": "Bhosale Rameshrao Govind."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17793",
    "name": "Bhosale Shobha Hindurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17384",
    "name": "Bobade Baban Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1760",
    "name": "Dalvi Anant Krishnajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16165",
    "name": "Dange Bajirao Suryakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "839",
    "name": "Designz`N` Art"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14205",
    "name": "Desai Amit Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19094",
    "name": "Dhone Suman Sanjay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18021",
    "name": "Dhuri Anagha Nandakishor"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "478",
    "name": "Devayani Furnishing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17231",
    "name": "Gade Mahesh Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "231",
    "name": "Ghadi Manohar Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13750",
    "name": "Ghadi Sanjay Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13874",
    "name": "Ghadigaonkar Mangesh Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16373",
    "name": "Ghadigoankar Shrikant Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18354",
    "name": "Goankar Sanjay Sahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13978",
    "name": "Golatakar Arun Vishvnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18058",
    "name": "Gunda Rajeshwari Wilson"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15152",
    "name": "Gurav Ganesh Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8794",
    "name": "Hule Vijay Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13994",
    "name": "Jadhav Jagannath Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18928",
    "name": "Jadhav Pranita Vishwas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16195",
    "name": "Jadhav Sopan Sawalaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16877",
    "name": "Jaiswal Brijalal Surtiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18477",
    "name": "Jambhale Bhalerao Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18293",
    "name": "Janeshwar Munshi Sharma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15312",
    "name": "Kadam Urmila Uttamrao & Rajkumar U Kadam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14214",
    "name": "Kakade Mohan Badamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18234",
    "name": "Kamble  Nirmala Sunil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1017",
    "name": "Khamkar Dinanath Krishnaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13931",
    "name": "Kindre Ramchandra Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15482",
    "name": "Lembe Ramchandra Dadaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7550",
    "name": "Majgaokar Prbhakar Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18139",
    "name": "Makwana Shamji Danji"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "688",
    "name": "Dhumal Hanmant Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3993",
    "name": "Manjgaonkar Pratibha Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17931",
    "name": "Matekar Avinash Balasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7325",
    "name": "Mathews Sheela"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16012",
    "name": "Matpati Manali Sanjay."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18085",
    "name": "Mayekar Arpana Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17611",
    "name": "More Abhinandan Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10354",
    "name": "Motele Mohan Datttray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19198",
    "name": "Naik Mohan Harishchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11354",
    "name": "Nare Vijay Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1560",
    "name": "Nikam Balasaheb Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11372",
    "name": "Nikam Bhikaji Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19849",
    "name": "Nikam Subhassh  Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17422",
    "name": "Pankar Shraddesh Chandrashekar."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1886",
    "name": "Diamond Printers"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15327",
    "name": "Parab Suman Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10139",
    "name": "Parte Sampat Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18660",
    "name": "Pashilkar Vithal Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "894",
    "name": "Dilip Lalchand Porval"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "442",
    "name": "Dinbandhu Dairy Farm"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11261",
    "name": "Patkar Lalita Arvind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17800",
    "name": "Pawar Maruti Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18296",
    "name": "Pawar Rajesh Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13666",
    "name": "Pawar Sudhakar Savalaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16556",
    "name": "Pawar Sunil Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14290",
    "name": "Pingale Nayana Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14051",
    "name": "Poyarekar Smita Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16285",
    "name": "Rane  Gurunath Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19701",
    "name": "Rathod Ramji Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13365",
    "name": "Raut Narayan Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15306",
    "name": "Raut Vikaram Namadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16975",
    "name": "Rimal Vimalprasad Narsuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5897",
    "name": "Sabale Nandraj Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5034",
    "name": "Salwi Suvarna Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11047",
    "name": "Shai Surendra A"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6954",
    "name": "Shelar Dattaram Balaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18628",
    "name": "Shinde Manoj Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "762",
    "name": "Esense Infosys"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2307",
    "name": "Electronic Linkers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2937",
    "name": "Emvee Foams And Mattresses"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2926",
    "name": "Eternity Computers"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15439",
    "name": "Shirke Vasant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1752",
    "name": "Fab Tex"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19593",
    "name": "Sonar Kalusing Jyotising"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19515",
    "name": "Sugarkar Ashok Shekhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17547",
    "name": "Surve Baliram Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6255",
    "name": "Surve Sujata Jayawant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18758",
    "name": "Suryavanshi Tanaji Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18087",
    "name": "Tansale Rahul Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18504",
    "name": "Thakur Asha Bhavansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18842",
    "name": "Tiwari Chotelal Devnaryan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16609",
    "name": "Tupe Indumati Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "781",
    "name": "Focus Computer"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12528",
    "name": "Verma Sunita Adesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "807",
    "name": "G D Sambhare & Co."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17921",
    "name": "Waikul Prakash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17099",
    "name": "Waje Tushar Suryakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19183",
    "name": "Yadav Amol Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15602",
    "name": "Yadav Govind Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15390",
    "name": "Yadav Sandip Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18935",
    "name": "Yadav Shivlal Radheshyam"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "77",
    "name": "Ganesh Lime & Hardware Stores"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12890",
    "name": "Nalawade Kishanrao Shrirangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7626",
    "name": "Chavan Venubai Khandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17785",
    "name": "Ahere Shridhar Dharmdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13362",
    "name": "Beldar Ramkesh Rasaran"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15641",
    "name": "Bhandare Pallavi Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17451",
    "name": "Bobade Ashok Sadashiv."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2632",
    "name": "Gayatri Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17824",
    "name": "Dalvi Sunjay Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11842",
    "name": "Desai Pratibha Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17515",
    "name": "Desai Rupali Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12370",
    "name": "Dhavan Dinanath Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17784",
    "name": "Gaikwad Vasant Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15235",
    "name": "Ghadigaonkar Aatmaram  Dhondu & Manoj A."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11870",
    "name": "Ghodekar Shaila Sopan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16150",
    "name": "Jadhav Akaram Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8819",
    "name": "Jadhav Sharad Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10555",
    "name": "Joshi Avinash Dattatrya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17583",
    "name": "Kadam Balkrishna Laxman."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17475",
    "name": "Kadam Laxmibai Anant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18110",
    "name": "Kadu  Shobha  Santosh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15956",
    "name": "Kerkar Mangala Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17555",
    "name": "Lalge Ravindra Ganapat."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1569",
    "name": "Ghanshyam Syntex"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16008",
    "name": "Mahadik Arvind Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14536",
    "name": "Mahadik Sahebrao Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14563",
    "name": "Mahajan Avinash Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14651",
    "name": "Mujawar Nasir Kadar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16615",
    "name": "Nandoskar Manisha Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13003",
    "name": "Pangharkar Shrikant Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "971",
    "name": "Girija Men S Fashions"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17733",
    "name": "S.Ramamurtty"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17861",
    "name": "Shaikh Mohmad Hanif"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17379",
    "name": "Shekh Khammas Ahamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17629",
    "name": "Smita P Dhuri"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16038",
    "name": "Sukale Ashwini Sunil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17896",
    "name": "Suryawanshi Bhimrav Baburav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14943",
    "name": "Tamatta Dinesh Sher Singh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15819",
    "name": "Varkhade Pandurang Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12642",
    "name": "Wadke Jayshree Jaykumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17954",
    "name": "Yadav Prakash Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2873",
    "name": "Gracious Rentals"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12143",
    "name": "Aangane Amruta Ajit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5186",
    "name": "Advilkar Arvind Moreshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17346",
    "name": "Aulto  Peeris."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16240",
    "name": "Bhosale Abhilash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10343",
    "name": "Dhamankar Dagadu Sadhu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15832",
    "name": "Gavkar Kartika Vishvanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3005",
    "name": "Gurukrupa Flowerist"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2584",
    "name": "H P Peticoat"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "777",
    "name": "H.Irani & Co."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14488",
    "name": "Lokhande Namdeo Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15083",
    "name": "Mahangare Machindra Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2292",
    "name": "Hari Janak Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1905",
    "name": "Hariom Packing Works"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2454",
    "name": "Hariom Parcel Service"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2634",
    "name": "Harish Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2539",
    "name": "Harsha Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14393",
    "name": "Nivadekar Vaishali Vijaykumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "569",
    "name": "Hi Tech Communication"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2154",
    "name": "Himansu Medicals"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1674",
    "name": "Hiralal Anilkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15515",
    "name": "Pawar Mohan Shivaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2512",
    "name": "Hope Graphics"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "918",
    "name": "Hotel Blue Moon"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "972",
    "name": "J & P Engineering Works"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3280",
    "name": "J .R.Fabrics"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17277",
    "name": "Tarade Abasaheb Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6856",
    "name": "Chawan Tanaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2749",
    "name": "Jagdamba Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2625",
    "name": "Sawat Varsha Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9271",
    "name": "Shetti B Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16447",
    "name": "Bhoite Mahadeo Dattatreya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15781",
    "name": "Dawada Devraj Chandrashekhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16444",
    "name": "Ghare Sanjay Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4861",
    "name": "Salunkhe Vishwas Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3341",
    "name": "Jams Enerprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2762",
    "name": "Janak Textile"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2942",
    "name": "K S Enteriors"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "67",
    "name": "Bhosale Broathers"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20551",
    "name": "Mulik Nandkumar Shrirang ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8073",
    "name": "Parvati Hanmant Male"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7562",
    "name": "More Rajendra Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9378",
    "name": "Nalawde Prakash Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17424",
    "name": "Ethape Sharad Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3645",
    "name": "Sawant Vanita Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3486",
    "name": "Phalake Tanubai Krushanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4894",
    "name": "Pawar Pandurang Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "688",
    "name": "Kadam Dhondiram Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1388",
    "name": "Salunkhe Kisan Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1321",
    "name": "Shirtode Gajaba Bali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13765",
    "name": "Mangrule Rajendra Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1387",
    "name": "Kadam Sampat Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2214",
    "name": "Mane Shantabai Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6959",
    "name": "Shide Aapaso Raut"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1861",
    "name": "Chatur Malan Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13000",
    "name": "Shukla Ramesh Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14741",
    "name": "Atugade Vishwas Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "270",
    "name": "Kakade Digambar Bhauso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15840",
    "name": "Mulik Nandkumar Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2293",
    "name": "Machhar Beena  Jayesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19703",
    "name": "Parmar Heeralal Jodhramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18067",
    "name": "Sanghvi Shwetal Parag"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16829",
    "name": "Gorkha Padmabahadur K"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2405",
    "name": "Kamal Maheshwari & Others"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3437",
    "name": "Kamasa Trading Corporation"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17778",
    "name": "Yelwe Laxman Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19454",
    "name": "Shinde Avinash Harichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13020",
    "name": "Soni Mahendrakumar H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13621",
    "name": "Sapkal Jaysing Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14123",
    "name": "Kenjale Sanjay Subhedar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19638",
    "name": "Barreto High  School -Secondary Section"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3654",
    "name": "Kanodia Trading Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10646",
    "name": "Dhore Sitaram Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18205",
    "name": "Bhamare Sanjay Damodar"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3370",
    "name": "Karni Packagings"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19146",
    "name": "Chavan Parinita Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17663",
    "name": "Dhumal Dharmraj Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20813",
    "name": "Guthale   Santosh  Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "718",
    "name": "Shah Auto Stores"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8398",
    "name": "Bhoite Dattatrey Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20415",
    "name": "Bhilare Bhavna Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5159",
    "name": "Lotlikar Santosh Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18351",
    "name": "Navsare Vijay Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17107",
    "name": "Mulik Kishor Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2269",
    "name": "Khushabu Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18667",
    "name": "Aarate Baban Santu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "990",
    "name": "Kiran Silk Industries"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18498",
    "name": "Jadhav Prakash  S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16952",
    "name": "Dhumal Dilip Balasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17794",
    "name": "Kolekar Vikas Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10742",
    "name": "Lotlikar Manohar Raghuvir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10974",
    "name": "Shah Kamlesh J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17010",
    "name": "Waghmare Arjun Yadavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11041",
    "name": "Gaikar Manohar Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10632",
    "name": "Chalke Dilip Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6578",
    "name": "Barve Narayan Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14183",
    "name": "Bhor Jitendra Savleram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18265",
    "name": "Bhore Sunil Nagesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18229",
    "name": "Devgude Yuvraj Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18297",
    "name": "Devkar Prakash Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16548",
    "name": "Jagnod Sulochana Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16039",
    "name": "Jagtap Meena Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18266",
    "name": "Kadam Sambhaji Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18558",
    "name": "Nabhole Ankush Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8442",
    "name": "Nikam Deepak M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14423",
    "name": "Pawar Tukaram Savlaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19975",
    "name": "Sawant Sanyog Avinash."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18295",
    "name": "Shaikh Munna Isaq"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18309",
    "name": "Sharma Lina Suman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20096",
    "name": "Shejwal Sulochana Pandhrinath."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18287",
    "name": "Tarde Krishnat Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18242",
    "name": "Thorat Yashwant Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18296",
    "name": "Wagh Shivaji Dagdoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10548",
    "name": "Dhumal Vijaykumar Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10527",
    "name": "Shivankar Bajirao Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10942",
    "name": "Sawant Hanmant Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6004",
    "name": "Yewale Namdeo Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10745",
    "name": "Chowhan Jitendra Visram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14935",
    "name": "Sawant Shashikant Harichandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10701",
    "name": "Pawar Mohan Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5473",
    "name": "Bhapkar Yeshwant Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13647",
    "name": "Bhagwat Sopan Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18469",
    "name": "Gaikwad Raosaheb Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16118",
    "name": "Kadam Dhondiba Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16453",
    "name": "Madhare Kailash Malhari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20783",
    "name": "Mestry  Vaishali  Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14070",
    "name": "Patil Bharat Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13562",
    "name": "Suryawanshi Laxman Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18224",
    "name": "Thombare Santosh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16106",
    "name": "Patil Bhaskar Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5227",
    "name": "Joshi Ramanlal D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18033",
    "name": "Shaikh Iqbal Musa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11311",
    "name": "Matre Dattu Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12349",
    "name": "Mangrule Rajendra Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3430",
    "name": "Laxmi Arts"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1671",
    "name": "Leena Construtions & Developers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "738",
    "name": "Leo Supply Service"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1321",
    "name": "Link Printers"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "722",
    "name": "Lobo Motors"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8246",
    "name": "Rach Suresh H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17616",
    "name": "Mane Sunil Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "507",
    "name": "Lucky Stores"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1595",
    "name": "M Amitkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2793",
    "name": "M P Traders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1351",
    "name": "M R Chemicales."
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2079",
    "name": "Chavan Sitaram Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13600",
    "name": "Khopade Subhash Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2081",
    "name": "Kuveskar Sanjay Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2080",
    "name": "Thorat Mahadev Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3029",
    "name": "Madhukar Entrprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17468",
    "name": "Shinde Sharad Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17302",
    "name": "Hindocha Bharat G"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1150",
    "name": "Mahalaxmi Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2419",
    "name": "Mahalaxmi Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "745",
    "name": "Maharashtra Rajya Nivadnook Karmachari S"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2398",
    "name": "Mahendra Furniture Works"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17100",
    "name": "Dhumal Hindurao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1647",
    "name": "Mahesh Synthetics"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16955",
    "name": "Pawar Atmaram Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18801",
    "name": "Wagh Mansing A"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3009",
    "name": "Mandar Investments"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13708",
    "name": "Khopade Vinod Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9315",
    "name": "Tambde Ashok Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12283",
    "name": "Phadtare Tukaram Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13189",
    "name": "Mhatale Dipeeka Dinesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3626",
    "name": "Gaikwad Dattatray Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5163",
    "name": "Lotlikar Ambika Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5014",
    "name": "Dheb R B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13669",
    "name": "Rimal Gourilal Shivlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8268",
    "name": "Bhoite Shamrao Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10956",
    "name": "Lotlikar Rajashree Raya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4165",
    "name": "Gawas S V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14695",
    "name": "Bobade Vikas Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1858",
    "name": "Maneklal Bhikamchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1223",
    "name": "Manhar Express Service"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "467",
    "name": "Manisha Embroidery Works"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1870",
    "name": "Manoj Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "835",
    "name": "Mansi Arts"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15947",
    "name": "Gupalji Awadhkishore M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6828",
    "name": "Pawar Gulabrao Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15910",
    "name": "Kurade Dattatray Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17301",
    "name": "Mahakude Gangaram Sopanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17171",
    "name": "More Lalita Nandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17332",
    "name": "Pawar Vitthal Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13808",
    "name": "Patil Ramchandra Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1592",
    "name": "Umbarkar S V"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2831",
    "name": "Meenaxi Silk Mills"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11735",
    "name": "Bohra Ramesh B"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "357",
    "name": "Mehta Industrial Corp."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13532",
    "name": "Pisal Dilip Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2464",
    "name": "Microtech Systems & Software"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5753",
    "name": "Lavand Gulab Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3563",
    "name": "Mithali Tours & Travels"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1079",
    "name": "Phanse Sampat Balwantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7775",
    "name": "Mulik."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11958",
    "name": "Yadav Devaji Tulshiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2514",
    "name": "Moon Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "1941",
    "name": "Indhav Dilip Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "61",
    "name": "Mukesh Enterprise."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17062",
    "name": "Salunkhe Tukaram Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5283",
    "name": "Jagtap Bhiku Vithalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8869",
    "name": "Keni Shailaja Suryakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16480",
    "name": "Jaiswal Ramgbalore Mehilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20374",
    "name": "Gan Milind Sharadrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "359",
    "name": "Khambe Shankar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5913",
    "name": "Hagawane Madan Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3232",
    "name": "Chawan Ashok Bandoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7881",
    "name": "Shaikh Jamalu Ahemmod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "496",
    "name": "Wagh Baburao Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12870",
    "name": "Jugder Shankar Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1177",
    "name": "Raichura Kirti Mohanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1413",
    "name": "Nandan Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "570",
    "name": "Natwarlal Gangadas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2428",
    "name": "Navkar Aradhana Cheritable Trust."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "438",
    "name": "Nirlav Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1345",
    "name": "Nisha Packing Works"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1901",
    "name": "Nitin Shantilal Shah"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3134",
    "name": "Omkaar  Lime Depot."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "677",
    "name": "Omkar Arts"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2809",
    "name": "Omkar Computer Classes"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2855",
    "name": "Omkar Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2079",
    "name": "Omkar Print Art"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2321",
    "name": "Padmini Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9373",
    "name": "Kadam Shivaji Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9432",
    "name": "Ware Tukaram Sawala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13936",
    "name": "Rajbhar Kaniayalal Chaturi"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3590",
    "name": "Panchariya Print N Plast."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16494",
    "name": "Mane Nirmala Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16098",
    "name": "Phadatare Prashant Hanumant"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1515",
    "name": "Panim Construction Pvt Ltd."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18124",
    "name": "Taldeokar Naresh Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13353",
    "name": "Lalji Singh Gaya Singh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18405",
    "name": "Jagtap Sweta Naresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16324",
    "name": "Sonawane Shivaji Yashwant."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1074",
    "name": "Paresh Sales Corporation"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14008",
    "name": "Liman Anant Sidu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17881",
    "name": "Chavan Dhananjay  Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10440",
    "name": "Jadhav Hanumant Khandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3730",
    "name": "Parth Computer"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2894",
    "name": "Parvati Packing"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1661",
    "name": "Pash Agencies"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10901",
    "name": "Chaudhari Ramlal Magaramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2864",
    "name": "Patel & Co."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "459",
    "name": "Patel Atul Kumar Kalidas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14997",
    "name": "Jagdale Santosh Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17632",
    "name": "Pokharkar Sheetal Sudam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6293",
    "name": "Sawant Gajanan Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17674",
    "name": "Nimkar Gajannan Bhargav."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15341",
    "name": "Mayekar Urmila Tukaram & Shri Hari W. Mu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8736",
    "name": "Bhosale Narsinha Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15913",
    "name": "Dhumal Dattatray Kalyanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6966",
    "name": "Shinde Shankar Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16651",
    "name": "Mishra Anil Jagatnarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16818",
    "name": "Rane Vinayak Sitaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7892",
    "name": "Wagh Arjun Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16449",
    "name": "Panday Rampher Ayodhyaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13652",
    "name": "Temkar Pradeep Naryan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10954",
    "name": "Mistry Nitin S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10891",
    "name": "Bhogaonkar Uma Chandrashekar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6257",
    "name": "Chavan Vilasrao Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3650",
    "name": "Sawant Ratnaprabha Sahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13983",
    "name": "Dhumal Tanaji Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15726",
    "name": "Jadhav Shrikant Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15474",
    "name": "Posture Shantaram Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15151",
    "name": "Salunkhe Dilip Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3797",
    "name": "D Souza Peter"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11609",
    "name": "Sawant Vijay Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8417",
    "name": "Chavan Shahajirao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7794",
    "name": "Jadhav Sunil B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "350",
    "name": "Pawar Sudam Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2460",
    "name": "Jain Baijnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18744",
    "name": "Sonawane Abaibai Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10994",
    "name": "Bilaye Usha S."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4505",
    "name": "Sha Achalaji Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16473",
    "name": "Atugade Akaram Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14153",
    "name": "Chorage Bhagwan Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14160",
    "name": "Modak Tukaram Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15601",
    "name": "Pathak Gangadhar Ramnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15498",
    "name": "Sayyad Mohammad Kasim Bahadurali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "222",
    "name": "Shinde Pandurang Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10684",
    "name": "Trivedi Ashok Nanalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7993",
    "name": "Sawant Balwant Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "65",
    "name": "More Sarjerao Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6457",
    "name": "Anapat Shivaji Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15606",
    "name": "Jadhav Dilip Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15023",
    "name": "Joshi Sharatraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18482",
    "name": "Kakade Pravin Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9664",
    "name": "Kolekar Gulabrao Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19666",
    "name": "Pawar Santosh Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2534",
    "name": "Sakpal Vilas Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2545",
    "name": "Chavan Laxman Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10709",
    "name": "Jain Dariyaubai Rasiklal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1073",
    "name": "Barve Tukaram Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10616",
    "name": "Salunkhe Arjun Subhedar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9786",
    "name": "Borkar Shridhar Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3036",
    "name": "Tanavade Sitaram Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17767",
    "name": "Leitao Sebastian"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17885",
    "name": "Mardhekar Bhiku Janu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13443",
    "name": "Chavan Pradip Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1530",
    "name": "Nikam Gorak Shahu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5195",
    "name": "Thakur Murlidhar Genuji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1484",
    "name": "Sakunde Gulab D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18929",
    "name": "Kadam Anand Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11443",
    "name": "Shinde Kisan Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10463",
    "name": "Bhiku Nihare"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13090",
    "name": "Sadh Ramnarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13821",
    "name": "Bhosale Maruti Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12317",
    "name": "Mardhekar Raghunath Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5630",
    "name": "Sarkale Yeshwant R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3498",
    "name": "Pisal Jayantrao Janardan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4644",
    "name": "Misquitha Cashmere"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12339",
    "name": "Deshmukh Vasant Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14957",
    "name": "Ethape Sadashiv Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9213",
    "name": "Matre Tanaji Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12660",
    "name": "Surve Shailesh Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11539",
    "name": "Jain Popatlal F"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7248",
    "name": "Chaudhari Kanaiyalal Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13464",
    "name": "Bhilare Mansing N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6220",
    "name": "Navtarun Vikas Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11897",
    "name": "Agarwal Paankumar Inder"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11898",
    "name": "Agarwal Brizmohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10340",
    "name": "Jain Arvind Shantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10379",
    "name": "Mehta Devjani Sharadkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10422",
    "name": "Vyas Laxmi Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5943",
    "name": "Pawar Balkrishna Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8342",
    "name": "Bohra Dinesh Murlidhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14232",
    "name": "Desai Sagar Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9136",
    "name": "Jadhav Kisan Shripatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10359",
    "name": "Jain Surendrakumar Saraogi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10248",
    "name": "Parmar Saveetaben P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9030",
    "name": "Jare Ashok Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10352",
    "name": "Rathi Madanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10330",
    "name": "Sutradhar Tabun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3267",
    "name": "Shah Raksha Shashikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5144",
    "name": "Budiya Lalitkumar J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15583",
    "name": "Agarwal Poonamchand Brijmohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10341",
    "name": "Jain Surendra Tilokchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3314",
    "name": "Acharya Mahendraprasad Revashankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11218",
    "name": "Purohit Purchraj R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12075",
    "name": "Chawan Tanajirao Narayanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19782",
    "name": "Maskar Balu Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14534",
    "name": "Patil Pragati Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "80",
    "name": "More Kisan Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13091",
    "name": "Suthar Surajmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5884",
    "name": "Ithape Ganpat Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13293",
    "name": "Agarbattiwala Ishwarlal Maganlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6125",
    "name": "Nalawade Ramesh Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10047",
    "name": "Sawant Sharad Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3286",
    "name": "Dhamal Dattatray Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13288",
    "name": "Sutar Shivlal P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16689",
    "name": "Wani Balkisan Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9445",
    "name": "Desai Sameera T"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17713",
    "name": "Choudhary Manoj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14644",
    "name": "Chougule Bharat R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6386",
    "name": "Kudale Appaji Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9732",
    "name": "Pankibai Rajmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2003",
    "name": "Kadam Vinayak Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9870",
    "name": "Patil Gopal Sidappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10155",
    "name": "Jain Teena D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11018",
    "name": "Gije Nanda Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2829",
    "name": "Lembhe Pralhad Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9662",
    "name": "Jain Kantilal K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17911",
    "name": "Ashar Sanjay K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16439",
    "name": "Korda Jagram Gopi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14456",
    "name": "Patel Parul Kunvarji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10144",
    "name": "Shah Mahendra L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10145",
    "name": "Shah Nayna R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9952",
    "name": "Sapre Subhash Udhav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10584",
    "name": "Yewale Namdeo Vyankatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10010",
    "name": "Sankpal Mansing Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "112",
    "name": "Jagtap Mugatrao Appaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2947",
    "name": "Kadam Kishore Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11546",
    "name": "Shindevasudeo Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9655",
    "name": "Shah Mohanlal Hajarimal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16823",
    "name": "Bait Sarswati Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15164",
    "name": "Bhoite Vikas Hanumantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17662",
    "name": "Fernandes Monica"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17677",
    "name": "Nikam Amit Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14594",
    "name": "Sohara Himmatlal Vagaramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15348",
    "name": "Thakkar Ramaben Laxmidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17625",
    "name": "Waghela Mukesh V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3348",
    "name": "Bobade Bhanudas Krishnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6438",
    "name": "Pawar Dattatrey Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9469",
    "name": "Punmia Shantilal S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11742",
    "name": "Singh Sanjay Surendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6463",
    "name": "Tambe Hari Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17330",
    "name": "Londhe Laxman Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15729",
    "name": "Wod Kalusingh Baluram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9861",
    "name": "Mulik Prashant Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10705",
    "name": "Parave Anant Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10555",
    "name": "Bhosale Namdeo Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4993",
    "name": "Kapadia Niranjan P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13436",
    "name": "Pawar Shivaji Parbati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15906",
    "name": "Bhosale Kashinath Jagdeorao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9186",
    "name": "Jain Prakash G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11950",
    "name": "Bhosale Poonam Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10143",
    "name": "Shah Ashakumari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19678",
    "name": "Kadam Neha Vijaykumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17038",
    "name": "Kamble Jayesh Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7482",
    "name": "Khade Pandurang Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5119",
    "name": "Mastud Kashinath Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16866",
    "name": "Kolte Savita Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9783",
    "name": "Panchal Ramesh Chandulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9784",
    "name": "Valsangkar Sharad Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9813",
    "name": "Desai Navnitrai Ishwarlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4411",
    "name": "Jadhav Prakash Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3053",
    "name": "Shaha Pannachand Devraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8680",
    "name": "Zore Dattaram Dhakla"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17391",
    "name": "Kalebere Sagar Rajendra."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9459",
    "name": "Porwal Leena Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15555",
    "name": "Joshi Vishal Bhupendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11548",
    "name": "Pawar Manu Somnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17478",
    "name": "Jadhav Vikas Balku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17519",
    "name": "Kadam Sunil Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "841",
    "name": "Bhosale Sarjerao Keshavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "689",
    "name": "Patil Laxman Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6504",
    "name": "Bhosle Hindurao Sonba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10862",
    "name": "Shukla Kusumbala K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13215",
    "name": "Solanki Hitesh Mansukhlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4981",
    "name": "Malkan Praful D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3399",
    "name": "Chikne Atmaram Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10428",
    "name": "Khingre T K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12110",
    "name": "Doshi Jayant Kishorchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11668",
    "name": "Karnani Rajesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3407",
    "name": "Chawan Sampatrao Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8301",
    "name": "Pawar Shivaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4130",
    "name": "Bhise Gurunath Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2297",
    "name": "Modi Chandrakant C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3971",
    "name": "Jadhav Vilas Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13925",
    "name": "Navadkar Sulochana Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9481",
    "name": "Rajge Ramchandra Tatoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4834",
    "name": "Shinde Banutai Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13450",
    "name": "Vaishnav  Manojkumar H"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14898",
    "name": "Patil Khashaba Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9399",
    "name": "Shinde Hiralal Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7605",
    "name": "Shirodkar Vinayak Anand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5439",
    "name": "Sharma Kamladevi Deviram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1645",
    "name": "Mohite Y S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4952",
    "name": "Shelar Rajaram Krishnaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8904",
    "name": "Mandhare Krishna Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3776",
    "name": "Tambe Shantaram Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1738",
    "name": "Matekar Ananda Tatoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13130",
    "name": "Mahernwari Shiv Shriram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17144",
    "name": "Ingulkar Namdeo Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14519",
    "name": "Rajpurohit Tikamsingh K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17388",
    "name": "Shakoor Shaikh Ismail Mohammed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9323",
    "name": "Jain Ottarmal Hajarimal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13662",
    "name": "Shaikh Imran G Mohd"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15411",
    "name": "Vengurlekar Shrikant Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13712",
    "name": "Shinde Vivek Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1948",
    "name": "Kadam Kisanrao Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4610",
    "name": "Shelar Dilip Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5063",
    "name": "Badgujar Shobhana Devidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14227",
    "name": "Jadhav Shamrao Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16707",
    "name": "Modi Vikas Sureshchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15194",
    "name": "More Dnyanoba Dharmu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15045",
    "name": "Palande Deepali Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18739",
    "name": "Shiralkar Kashinath Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "119",
    "name": "Jadhav Gulabarao Appa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9460",
    "name": "Patel Maheshkumar Natwarlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6249",
    "name": "Shinde Ramdas Vyankatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11368",
    "name": "Dalal Sunil Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14301",
    "name": "Bharugade Dnyandeo Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9192",
    "name": "Bhodi Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4498",
    "name": "Shinde Shivaji Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17008",
    "name": "Shelke Rahul Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11993",
    "name": "Yelonde Namdeo Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8571",
    "name": "Shinde Nandkumar Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1818",
    "name": "Kothekar D L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11773",
    "name": "Gurav Ananda Jotiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10096",
    "name": "Pawale Namdeo Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11794",
    "name": "Salve Baburao R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14510",
    "name": "Gujar Anandibai Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20988",
    "name": "Namole Prakash M."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16814",
    "name": "Pawar Santaji Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18532",
    "name": "Dutta Ramsingnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16272",
    "name": "Parab Smita Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11417",
    "name": "Mehta Ichhalal Laljibhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8248",
    "name": "Adsul Anandrao Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "160",
    "name": "Khopade Yashwant Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13243",
    "name": "Salunkhe Shakuntala Popat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5185",
    "name": "Mohite Kamal Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "608",
    "name": "Chawan Mukadam Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7849",
    "name": "Veer Suryakant Keru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7825",
    "name": "Salian Baby Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4243",
    "name": "Tentnas Association"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1454",
    "name": "Salunkhe Ramchandra Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14279",
    "name": "Haazare Shivaji Homaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13577",
    "name": "Pol Vijay Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9254",
    "name": "Patil A B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15847",
    "name": "Mistry Sanjay Bhagwandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11644",
    "name": "Kadam Bhagwan Gangaram/Shedge S D /Shind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3772",
    "name": "Nalawade Jaganath Rattoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1298",
    "name": "Bhor Dagadu Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1617",
    "name": "Raugraj Arun Harmohandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17415",
    "name": "Bhoite Yashwant Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17312",
    "name": "D Silva Xavier"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16404",
    "name": "Gound Santoshkumar Jagatpal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4289",
    "name": "Mane Balkrishna Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13115",
    "name": "Soni Gordhanlal U"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9982",
    "name": "K Manjnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10630",
    "name": "Dodia Hasmukh Ratilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1329",
    "name": "Helekar H H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11784",
    "name": "Mohammad Iqbal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3935",
    "name": "Babar Shamrao Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16730",
    "name": "Ahirekar Ajitkumar Hindurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17787",
    "name": "Chaudhari Dilip Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14518",
    "name": "Jagtap Pradesh Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15664",
    "name": "Pujari Kamlakar Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "199",
    "name": "Kadam Gajanan Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8895",
    "name": "Jain Rajmal Chunilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15257",
    "name": "Chavan Neha Nandkishor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15743",
    "name": "Sawant Sonali Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13474",
    "name": "Barge Shivaji Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8978",
    "name": "Chavan Mohan Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3510",
    "name": "Bhoite Madhukar Vinayakrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15702",
    "name": "Chorge Rangrao Gunj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12581",
    "name": "Master Mukesh Haribhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1294",
    "name": "Rajeshirke Ashok Gopalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16134",
    "name": "Deshmukh Ramchandra Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12956",
    "name": "Meghani Haresh K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11556",
    "name": "Mehta Fency R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11686",
    "name": "Raje Daulat Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1358",
    "name": "Bhosale Bajrang Sawalaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14544",
    "name": "Jadhav Kamlakar Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3961",
    "name": "Kale Mahadeo Tulshiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16462",
    "name": "Kanase Sadashiv Subhedar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15203",
    "name": "Parasmal Champalalji D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16328",
    "name": "Udaya Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14844",
    "name": "Umbare Ashok Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8551",
    "name": "Sankpal Chappanrao Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8386",
    "name": "Tankaria Sunil G"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17947",
    "name": "Bhosale Pratap Dhanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12598",
    "name": "Agarwal Paresh M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7441",
    "name": "Gadhave Dagadu Piraji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14014",
    "name": "Dhawade Keshav Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17273",
    "name": "Malai Keshvan Yelu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12539",
    "name": "Mestry Ramesh Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10915",
    "name": "Raval Kantilal K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1030",
    "name": "Chikate Ramchandra Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13232",
    "name": "Jadhav Shankarrao Nathuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17819",
    "name": "Pawar Anandrao Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11269",
    "name": "Parab Vinod Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9828",
    "name": "Sarkar Madhu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2447",
    "name": "Parte Shripat Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "419",
    "name": "Mahangade Anandrao Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10936",
    "name": "Devkar Namdeo Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13978",
    "name": "Bhilare Arjun Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "622",
    "name": "Payal Collection"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4611",
    "name": "Sarkale Tukaram Dadasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17151",
    "name": "Ghanwat Rohidas Patilbuva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15825",
    "name": "Ghorpade Chandrakant Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13824",
    "name": "Patil Dipak Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18003",
    "name": "Patil Yashwant Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15448",
    "name": "Shinde Suresh Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18450",
    "name": "Singh Shambahadur R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4136",
    "name": "Yadav Suryakant Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6625",
    "name": "Javel Sakharam Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9775",
    "name": "Patel Swatiben Kishorebhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13966",
    "name": "Phalke Sugandha Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4154",
    "name": "Chawan Pandurang Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7573",
    "name": "Ajgaonkar Madhukar Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9761",
    "name": "More Shyamrao Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3264",
    "name": "Shinde Shankar Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13741",
    "name": "Mandhare Santosh Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5299",
    "name": "Waychal Ramchandra Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1330",
    "name": "Chorge Krishna Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20358",
    "name": "Agre Haresh Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18329",
    "name": "Nakti Mahesh Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17410",
    "name": "Nikam Dnyandeo Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13150",
    "name": "Rajput Nisha T"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20365",
    "name": "Nigade Balaso Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16695",
    "name": "Patil Vikas Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9587",
    "name": "Bombale Jaysing Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17523",
    "name": "Mali Ganesh Sadwanji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20274",
    "name": "Martins Iris"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4804",
    "name": "Hate Rajendra Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3946",
    "name": "Kelkar Anant Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5575",
    "name": "Jadhav Ramesh Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8577",
    "name": "Adate Baburao Bhimrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9668",
    "name": "Jagadale Sambhaji Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12637",
    "name": "Damgude Sadashiv Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15558",
    "name": "Shaikh Mohammad Mahiboob"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4398",
    "name": "Lokhandi Jattha Maratha Kamgar Sang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15014",
    "name": "Chavan Sujata Sahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19605",
    "name": "Kanbar Jaya Kirit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5566",
    "name": "Banka Komal Sajan Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5009",
    "name": "Navadkar Ankush Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14252",
    "name": "Valanje Pradeep Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5919",
    "name": "Salian Babu Kukra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6587",
    "name": "Jain Premchand Jasraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18748",
    "name": "Jagtap Balkrishna Rangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16523",
    "name": "Paradkar Devdas Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16524",
    "name": "Paradkar Santosh Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17531",
    "name": "Pawar Deepak Sumanya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4892",
    "name": "D Souza Francis P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15586",
    "name": "Pawar Vikas Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11288",
    "name": "Rawat Sumersing Sainsinha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5686",
    "name": "Pophale Shamrao Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7762",
    "name": "Shah Jashvantlal Fatechand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "220",
    "name": "Babar Namdeo Parbati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7197",
    "name": "Khalde Rajendra Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8500",
    "name": "Botre Ashok Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2123",
    "name": "Liman Shantabai Sidhu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1139",
    "name": "Deshmukh Balasaheb Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6734",
    "name": "Makda Naziq Hajiali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4884",
    "name": "Borave Chandrakant Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16476",
    "name": "Dere Uttam Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13952",
    "name": "Khandvilkar Siddesh Shashikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13947",
    "name": "Parvadi Eknath Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6145",
    "name": "Mulik Kisan Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1028",
    "name": "Khot Atmaram Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13467",
    "name": "Bhosale Machindranath Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17854",
    "name": "Kadam Hanmant Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17973",
    "name": "Karde Prakash Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15433",
    "name": "Kodhalkar Tanaji Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17237",
    "name": "Salunkhe Rajendra Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15359",
    "name": "Shinde Rajan Dwarkanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13017",
    "name": "Singh Dwarika"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "192",
    "name": "Shinde Bharat Jaysingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12309",
    "name": "Sakunde Eknath Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14430",
    "name": "Ghule Sangeeta Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17265",
    "name": "Jadhav Hanmant Abaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17398",
    "name": "Nate Swapnil Surendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14930",
    "name": "Shaikh Irfan Mehmood"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12340",
    "name": "Pisal Malan Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10519",
    "name": "Bhosale Anand Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4041",
    "name": "Nimbalkar Abasaheb Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10249",
    "name": "Pawar Baban Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11474",
    "name": "Chilekar Vinod Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "880",
    "name": "Anuradha Construction Co."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18313",
    "name": "Bhalerao Nivrutti Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15125",
    "name": "Fernandis  Maxi  Kaitan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20766",
    "name": "Kushwaha Dilipprasad Rohanprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13724",
    "name": "Rane Shradhdha Sanjay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15115",
    "name": "Tukrul Santosh Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13383",
    "name": "Shinde Malan Chintopant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "125",
    "name": "Shivde Vishnu Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8210",
    "name": "Pisal Babu Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2977",
    "name": "Jagtap Shankar Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "710",
    "name": "Pabale Tukaram Perbati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5516",
    "name": "Sakpal Shankar Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14333",
    "name": "Deora Narpat Singh G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8285",
    "name": "Patel Rajendra Vasudeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9928",
    "name": "Gund Vanarasabai Deoram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9199",
    "name": "Swaly Dilip Khimji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8361",
    "name": "Bhosle Gautam Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11640",
    "name": "Tawade Uttara Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11772",
    "name": "Dhumal Tulsiram B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2165",
    "name": "Kadam Appaji Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17405",
    "name": "Jagtap Sharad Jitas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16320",
    "name": "Vajpeyee Ganeshprasad Dayashankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15630",
    "name": "Veer Jayashree Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10256",
    "name": "Angre Vishram Devji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4015",
    "name": "Chandan Wadi Mahila Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4857",
    "name": "Pawar Maruti Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7571",
    "name": "Patkar Suhasini Ankush"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15760",
    "name": "Fernandes Santano Martin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11649",
    "name": "Gaikwad Dayanand S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12271",
    "name": "Yadav Dilip Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11072",
    "name": "Soni Rajendra Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16498",
    "name": "Bhosale Santosh Shivram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16979",
    "name": "Chowhan Manharlal Kasturlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7808",
    "name": "Bhuthawala Tarunaben Gunvantbhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2784",
    "name": "Shaikh H.M."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7988",
    "name": "Pachupate Shrirang Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9079",
    "name": "More Maruti Raghu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9779",
    "name": "Jain Sumitra Bhawarlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10976",
    "name": "Popat Dilipkumar O"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7991",
    "name": "Narvekar Krishna Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14970",
    "name": "Jaiswar Kariyaram Sopi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19965",
    "name": "Marate Sunanda Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15420",
    "name": "Bhoite Lalaso Govindrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18170",
    "name": "Kirtane Nilkantha Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19491",
    "name": "Luis Amanda Atgkato"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17573",
    "name": "Mandhare Chandrakant Vitthalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15243",
    "name": "Singh Sandeepkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6446",
    "name": "Pawar Mahadeo Yadavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4020",
    "name": "Sawant Ashok Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5183",
    "name": "Yadav Ramchandra Dadaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15263",
    "name": "Chorge Suresh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16135",
    "name": "Fernandes Alex Zeffina"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16204",
    "name": "Mandhare Rajendra Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5076",
    "name": "Chavan Raghunath Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16521",
    "name": "Chavan Ashok S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7883",
    "name": "Sulke Santoshkumar Wamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2882",
    "name": "Jadhav Achuyt Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8297",
    "name": "Bhosle Mohan Prataprao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10688",
    "name": "Shelar Genu Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6927",
    "name": "Kadam Prakash Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6518",
    "name": "Nirmal Gajanan Ramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7899",
    "name": "Morya Chintalal Ramnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1878",
    "name": "Poster Point"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9325",
    "name": "Ashok Nagar Navrartri Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15759",
    "name": "Kale Sanjay Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15225",
    "name": "Shinde Ankush Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9058",
    "name": "Jhunjhunwala Bimal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12505",
    "name": "Rathod Sajjansingh Jaysing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9082",
    "name": "Mehta Pushpa Harshad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3506",
    "name": "Mulik Bhiku Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12599",
    "name": "Pereira Micheal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8635",
    "name": "Shingate Mohan Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9176",
    "name": "D Souza Joseph Vincent"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12386",
    "name": "Gamavat Kala Jayantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1721",
    "name": "Jagtap Yashwant Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16384",
    "name": "Kumbhar Vanita Suresh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7195",
    "name": "Bhagwat Sandhya Jayram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2262",
    "name": "Dhide Ramchandra D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14824",
    "name": "Bhandari Virendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12198",
    "name": "Kadam Vijay Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2712",
    "name": "8 Tadwadi Tenents Association"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15083",
    "name": "Patilsangeeta Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9659",
    "name": "Jain Narendrakumar Deepchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4081",
    "name": "Dhumal Gangaram Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4429",
    "name": "Jadhav Rajaram Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15369",
    "name": "Bhosale Pradeep Sampatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "351",
    "name": "Prakash Trading Co."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2492",
    "name": "Prakashchandra Kantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "428",
    "name": "Pratee - Isha Road Carriers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2444",
    "name": "Pratik Traders"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "882",
    "name": "Print Avenue."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10423",
    "name": "Beekay Graphics Staff Welfare"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13056",
    "name": "Agarwal Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12002",
    "name": "Sawale Arun G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "855",
    "name": "Chikane Dhondiram Bala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3438",
    "name": "Bhosale Raghunath Gujaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13060",
    "name": "Sharma Ravindra M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4272",
    "name": "More Mahendra Premlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13131",
    "name": "Gaikwad Narayan Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14196",
    "name": "More Chandrakant Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15864",
    "name": "Rannaware Vinayak Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "960",
    "name": "Katekar Shivaji Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13105",
    "name": "Waghe Kashinath Sonu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13461",
    "name": "Jagtap V S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11884",
    "name": "Jadhav Pradip Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10195",
    "name": "Tyagraj Javregaunda Najgaunda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1401",
    "name": "More Hanmant Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16134",
    "name": "Datkhile Ganesh Bhagwan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14930",
    "name": "Mohada Rameshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8242",
    "name": "Shah Mohanlal Joharmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5668",
    "name": "Bhagwat Shashikant Jayshing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12781",
    "name": "Nanawae Gulabbai Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10788",
    "name": "Bhojane Laxmi Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16166",
    "name": "Chilekar Vinita Vinod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8934",
    "name": "Sabale Dnyandeo Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17726",
    "name": "Anande Sachin  Rajkumar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "406",
    "name": "Bhosale Mahadeo Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1327",
    "name": "R C Agencies"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1966",
    "name": "R Chunilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17999",
    "name": "(Rathi) Sarvaiya Sunita Rajesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14133",
    "name": "Shah Popatlal Kantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2013",
    "name": "More Shankar Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13235",
    "name": "Chhapwala Rekha Rajesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "591",
    "name": "Radio Centre"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1916",
    "name": "Rado Furnishing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16548",
    "name": "Wahlekar  Yashwant Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10883",
    "name": "Pol Sanjeev B"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2447",
    "name": "Rahul Silk Mills"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18759",
    "name": "Solanki Anil Dalpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11528",
    "name": "Bhoite Pandurang Krishnarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11014",
    "name": "Sawant Suvarna Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14291",
    "name": "Pingale Anuj Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "768",
    "name": "Raj Marble"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14068",
    "name": "Jadhav Prakash Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2625",
    "name": "Rajas Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "706",
    "name": "Rajashree Carpet Industry"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10672",
    "name": "Chirabazar Bhadekari Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12803",
    "name": "Shigwan Uday Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9395",
    "name": "Musale Anil Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1578",
    "name": "Tetame Rajaram Chandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10469",
    "name": "Sable Anandrao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7616",
    "name": "Barge Ramesh Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16275",
    "name": "Chugule Dattaram K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "167",
    "name": "Anpat Mahadeo P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9634",
    "name": "Bhapkar Yeshwant Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2413",
    "name": "Salunkhe Bandu Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7410",
    "name": "More Hanmant Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1785",
    "name": "Mane Tukaram Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15602",
    "name": "Jadhav Bandu Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16592",
    "name": "Jain Kamleshkumar Bhurmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10995",
    "name": "Dhanawade Bapu Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5579",
    "name": "Salunkhe Narhari Nilkantha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5708",
    "name": "Jadhav Vithal Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8033",
    "name": "Waghmare Subhana Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1317",
    "name": "Rajesh Enterprise"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1518",
    "name": "Rajesh Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4511",
    "name": "Kewat Rajakumar Kallu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14857",
    "name": "Lama Seema Jeetbahadur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17287",
    "name": "Pujari Anand Ramaiyaraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16008",
    "name": "Yadav Shankar Surendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "221",
    "name": "Babar Mansing Parbati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14330",
    "name": "More Subhash Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6304",
    "name": "Patil Mahadeo Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12634",
    "name": "Patkar Bhagwan Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11562",
    "name": "Jaiswal Ramlote"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2650",
    "name": "Rama Silk Mill"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4063",
    "name": "Ramapeer Textiles Mills"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18958",
    "name": "Doke Sagar Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5816",
    "name": "Pawar Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12878",
    "name": "Karle Snehal Suhas"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2865",
    "name": "Ramdas Tempo Service"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5839",
    "name": "Shetty Krishna J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6190",
    "name": "Rodrigues Sammy"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8109",
    "name": "Patil Sadashiv Parashram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1849",
    "name": "Rameshkumar Chhogalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7604",
    "name": "Naik Deepa Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9818",
    "name": "Salunkhe Haribhau Gopala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3086",
    "name": "Jadhav Madhukar Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "506",
    "name": "Ramji Jesa And Co."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16252",
    "name": "Malap Shailesh Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14649",
    "name": "Shinde Bharat Mukundrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10788",
    "name": "Bergal Tukaram Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7118",
    "name": "Sharma Geetaram Pannalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5637",
    "name": "Gore Bhagatsing Parbatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "38",
    "name": "Pawar Shankarrao Wamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3250",
    "name": "Madhav Vasakh Singh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2765",
    "name": "Dhanawade Jagannath Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "118",
    "name": "Saleskar Nivrutti Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4615",
    "name": "Nikam Laxman Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11155",
    "name": "Faria Goma Tiben Manashi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13311",
    "name": "Tambade Sakharam Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6367",
    "name": "Sodiye Anant Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13241",
    "name": "Rathod Nagji Bhepa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8552",
    "name": "Shinde Ramesh Mahipati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10159",
    "name": "Gala Mansukhlal Shamji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15020",
    "name": "Ahirekar Asha Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13334",
    "name": "Nalage Sarjerao Vyankat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19221",
    "name": "Rai Nandkishor Fanindranath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6407",
    "name": "Chaudhari Arvind Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "874",
    "name": "Shinde Hanmant Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5565",
    "name": "Banka Seema Sajankumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "1567",
    "name": "Karangutkar Ashok Kamlakar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20008",
    "name": "Mishra Rajkumar Ramdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15757",
    "name": "Thombare Shantaram Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "918",
    "name": "Kadam Ramchandra Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2863",
    "name": "Ranu Silk Mills"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1621",
    "name": "Ranuja Synthetics"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13532",
    "name": "Thombre Laxman Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8714",
    "name": "Shinde Ratan Sampatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8666",
    "name": "Bhagwat Parshuram Genba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6151",
    "name": "Mhatre Govind Dhakatu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15135",
    "name": "Prajapat Ganeshmal Kasturji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13034",
    "name": "Tawde Santosh Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5728",
    "name": "Chavan Tukaram Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12389",
    "name": "Parkar Shubhada Dayanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16682",
    "name": "Shinde Suresh Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7626",
    "name": "Mistry Indira Nagindas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11324",
    "name": "Rawat Jayendrasinh G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6827",
    "name": "Haldankar Nandkumar Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15366",
    "name": "Borge Rabhaji Sarja"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15050",
    "name": "Pedamkar Suryakant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5435",
    "name": "Shetye Dattatray Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "394",
    "name": "Pawar Mahadeo Martand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17726",
    "name": "Teli Chandrakant Gaudappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "299",
    "name": "Rathod Bros."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2356",
    "name": "More Ananda Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11055",
    "name": "Jagtap Abasaheb Subhedar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16578",
    "name": "Nandekar Vishwanath Kekaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15070",
    "name": "Raheja Pahlaj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15206",
    "name": "Shah Kusumben Jethalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10178",
    "name": "Shinde Vasant Appasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "790",
    "name": "Rathor Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "508",
    "name": "Ratnagar Marines"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11429",
    "name": "Pawar Bhanudas Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17491",
    "name": "Bhosale Vijay Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3006",
    "name": "Shirodkar Kalpana Damodar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13397",
    "name": "Khopade Tanaji Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8422",
    "name": "Panchal Gautam N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14643",
    "name": "Shah Hitesh Gordhandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12561",
    "name": "Jawal Ramchandra Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18152",
    "name": "Goil Pushpa Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16420",
    "name": "Khadaka Khemraj Udaysinh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14778",
    "name": "Shedge Ganesh Babaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9257",
    "name": "Nagarkar Ashok R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9037",
    "name": "Saibaba Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6692",
    "name": "Parekh Pankaj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3920",
    "name": "Babar Hanmant Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9056",
    "name": "Mehta Nilesh Prataprai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12878",
    "name": "Gorule Tukaram Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12780",
    "name": "Satve Govind Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7615",
    "name": "Mandhare Shankar Gopala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15527",
    "name": "Jadhav Lavh Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14603",
    "name": "Shah Jaichand Punamchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9356",
    "name": "Mestry Tukaram Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19986",
    "name": "Gawda Vasu Manjiappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2552",
    "name": "Rekha Art Printers"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "692",
    "name": "Aaderki & Mandali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18161",
    "name": "Wagh Amol Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7194",
    "name": "Kadam Suman Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14168",
    "name": "Jain Chanda P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18012",
    "name": "Phapale Mayur Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1384",
    "name": "Rooshabh Synthetics"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18011",
    "name": "Waghe Sanjay Bhagwat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18320",
    "name": "Kamble Namdeo Kerappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10538",
    "name": "Gaikwad Ankush Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10619",
    "name": "Gupta Karamchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11028",
    "name": "Shetye Vinayak K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13655",
    "name": "Khade Surekha Sadanad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14608",
    "name": "Nikam Mohan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1404",
    "name": "S A Synthetics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2733",
    "name": "S D Brothers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2881",
    "name": "S G P Works"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2340",
    "name": "S J Plastics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "689",
    "name": "S K Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "920",
    "name": "S Lalji & Sons"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3482",
    "name": "S.K. Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19937",
    "name": "Mangale Sunil Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15206",
    "name": "Yadav Jitendra Dnyaneshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11860",
    "name": "Kulkarni Yeshwant Pandharinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15279",
    "name": "Wagh Kusum Subhash & Dr.Suhash R Wagh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4999",
    "name": "Budhia Karunashankar P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14819",
    "name": "Chorage Suresh Gunda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15212",
    "name": "Jadhav Mahesh Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3041",
    "name": "Shelar Balu Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15100",
    "name": "Gaikwad Jaywant V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5661",
    "name": "Gaikwad Laxmi Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15300",
    "name": "Chawan Lata Sharad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6816",
    "name": "Chawan Vijay Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1996",
    "name": "Gaikwad Khashaba Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13290",
    "name": "Mohd Nafeesa Gulam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6657",
    "name": "Desai Namta S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5031",
    "name": "Nalawade Shivaji Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5876",
    "name": "Waghe Vishnu Malu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9577",
    "name": "Pawar Anurath Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10696",
    "name": "Dalvi Anil Atmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6331",
    "name": "Pawar Khashaba Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17932",
    "name": "Pawar Anil Vittahal"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "610",
    "name": "Sai Decorators"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "638",
    "name": "Saikrupa Constructions"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "684",
    "name": "Saisiddhi Travales"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17742",
    "name": "Trivedi Asha A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9316",
    "name": "Musale Vijay Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1750",
    "name": "Shri Hanuman Karyakari Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5348",
    "name": "Deshmukh Subhash Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16600",
    "name": "Bait Gopal Bhiva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1432",
    "name": "Padwalkar Sitaram Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7898",
    "name": "Banka Sajan Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1508",
    "name": "Ahirekar Rajaram Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18987",
    "name": "Malwade Radhika Kiran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14065",
    "name": "Ghadge Sanjay Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17138",
    "name": "Lawand Maruti Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12891",
    "name": "Painter Sudhir Sitanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7686",
    "name": "Patel Jamanaben B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6356",
    "name": "Sawant Adika Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2577",
    "name": "Bandre Ramchandra Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8555",
    "name": "Gusai Tulshipani Bhurpani"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15390",
    "name": "Kadam Prakash Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20422",
    "name": "Kanchawade  Anil Balkrushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17325",
    "name": "Pathare Madhavi Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17879",
    "name": "Yadav Dashrath Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9006",
    "name": "Pillay Kannickhary Francis"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19033",
    "name": "Chalake Ashok Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17254",
    "name": "Subramanian Rosita"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18216",
    "name": "Shinde Sachin Narhari."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1239",
    "name": "Bhagwat Dharmaji Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4235",
    "name": "Dawale Balu Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13939",
    "name": "Jain Mangilal S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13036",
    "name": "Das Pushpa Putulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14921",
    "name": "Nangare Chandrakant Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17796",
    "name": "Kadam Chabutai Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17576",
    "name": "Sathe Latabai Bhagwan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4137",
    "name": "Yadav Chandrakant Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "682",
    "name": "Shinde Appaso Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10332",
    "name": "Shaikh Mohammad Ali Mendihasan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2186",
    "name": "Kadam Vasant Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10502",
    "name": "Budhia Punit Dayalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14949",
    "name": "Jagdale Santosh Srirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14187",
    "name": "Karne Sopan Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12798",
    "name": "Chheda Manjula L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9660",
    "name": "Jain Chandrakant D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9915",
    "name": "Kadam Madhukar Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11199",
    "name": "Redkar Mohan Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1876",
    "name": "Shinde Ramchandra Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16133",
    "name": "Dinde Jaysing Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14274",
    "name": "Pawar Pandurang Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5664",
    "name": "Shirke Bhanudas Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6529",
    "name": "Shinde Sharad Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3102",
    "name": "Mahagade Babasaheb Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9709",
    "name": "Phadtare Mansing Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18572",
    "name": "Kanekar Chhaya S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8256",
    "name": "Bhawale Vithal Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8388",
    "name": "More Balaram Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10724",
    "name": "Lembhe Kisan Aabaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6527",
    "name": "Shingan Rajaram Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11108",
    "name": "Kadam Dilip Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12678",
    "name": "Bhosale Laxman Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14995",
    "name": "Shinde Rajkumar Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12808",
    "name": "Shinde Narayan Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6903",
    "name": "Ghadge Laxman Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "1647",
    "name": "Shirsat Rajan Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6223",
    "name": "Rayate Gopal Dada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4130",
    "name": "Padawal Subhadrabai Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12108",
    "name": "Punamiya Aruna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6428",
    "name": "Pawar Jotiram Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4361",
    "name": "Bhoite Laxman Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15404",
    "name": "Mehta Manoj Hirachand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5961",
    "name": "Gaikwad Krishnabai Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11307",
    "name": "Salunkhe Mahadeo Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14965",
    "name": "Bhekare Dharesh P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13974",
    "name": "Gafar Abdul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5222",
    "name": "Kadam Sulochana Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17379",
    "name": "Chawan Umeshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18720",
    "name": "Kolekar Shankar Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10223",
    "name": "Kansara Shantilal Mangaldas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10119",
    "name": "Jain Jamnadas Lalchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12818",
    "name": "Upadhyay Ratilal Satyanarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2949",
    "name": "Pisal Vinayak Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8933",
    "name": "Bhonsale Kisan Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13850",
    "name": "Monde Shashikala Lahuraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16559",
    "name": "Jadhav Kashinath Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15862",
    "name": "Pawar Laxmibai Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9794",
    "name": "Edirardo Victor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10153",
    "name": "Patil Baburao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6657",
    "name": "Shende Bhagwan Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2756",
    "name": "Shirsat Vasant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9291",
    "name": "Kansara Umesh Ishwarlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16124",
    "name": "Jain Mithalal Pukhraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16454",
    "name": "Navghane Subash Darmaji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14005",
    "name": "Sawant Laxmibai S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11149",
    "name": "Tiwari Indradeo Pruthvipal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8730",
    "name": "Gawhane Jagannath Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9876",
    "name": "Khadka Loka Bahadur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11304",
    "name": "Sayed Noormohmed Ahmed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9658",
    "name": "Shah Jayantilal Premji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7043",
    "name": "Aytoda Kiran Shantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12825",
    "name": "Patil Bhausaheb Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17190",
    "name": "Dhide Jitesh Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18318",
    "name": "Sharif Liyakt Ali Mohmmad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2813",
    "name": "Ghorpade Vishnu Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5133",
    "name": "Sabale Pandurang Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13370",
    "name": "Harijan Chandrashekhar Ramnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13495",
    "name": "Jadhav Balkrishna Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10274",
    "name": "Bhosale Laxman Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12845",
    "name": "Chavan Trimbak Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13762",
    "name": "Mulik Dipak Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "242",
    "name": "Chaudhari Mangaru Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16042",
    "name": "Desasi Dinkar Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13138",
    "name": "Shinde Pravin Sadashivrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8055",
    "name": "Shivthare Dilip Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4938",
    "name": "Shinde Mahadeo Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8538",
    "name": "Jadhav Lahoo Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10483",
    "name": "Khadka Prakash Bahadur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16324",
    "name": "Matre Sunil Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9864",
    "name": "Thorave Suman Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9370",
    "name": "Trivedi Arjunlal Madanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5223",
    "name": "Chawan Ramesh Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6193",
    "name": "Modak Balkrushna Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11599",
    "name": "Bhosale Anil Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11475",
    "name": "Rodrigues Mathew"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7915",
    "name": "Bombale Chandrabhaga Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7958",
    "name": "Dalvi Dattatray Natha"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "544",
    "name": "Samadhan Art Printers"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4599",
    "name": "Shinde Subhedar Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3733",
    "name": "Pandwalkar Baban Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11985",
    "name": "Babar Ramesh Janardhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17412",
    "name": "Fanse Cricket Club."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2213",
    "name": "Samrudha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10483",
    "name": "Prajapati Kauleshwar Malu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12652",
    "name": "Yadav Mehilal Shivdevlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13741",
    "name": "Dakave Banutai Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13026",
    "name": "Chawan Harishchandra Appaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3502",
    "name": "Gujar Laxman Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6656",
    "name": "Patel Ajay B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15988",
    "name": "Chawan Chandrashekhar Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16050",
    "name": "Gaunda Nagesh Sidappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11855",
    "name": "Yadav Ramkhilawan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11451",
    "name": "Gandhi Sujata Kashiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2787",
    "name": "Jagtap Ganpat Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18985",
    "name": "Malwade Bhushan Kiran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8266",
    "name": "Salunkhe Govindrao Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2086",
    "name": "Sandhya Enterprises"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1815",
    "name": "Jagtap Arun Chintamani"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11135",
    "name": "Patil Pandurang Krishana"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1567",
    "name": "Sanjay Silk Mills"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "581",
    "name": "Sanjay Transport"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10188",
    "name": "Chawan Anandrao K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12039",
    "name": "Kandatgaonkar Subhash Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16481",
    "name": "Narkar Dipak Tukaram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18730",
    "name": "Yadav Indra Shrijanaki"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5596",
    "name": "Nalawade Haibatrao Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4709",
    "name": "Salunke Vamanrao D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1354",
    "name": "Sakunde Dyandev Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4219",
    "name": "Jain Subhash Mangalchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12253",
    "name": "Patel Narendra Purshottam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4448",
    "name": "Kamat Attorney Service"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10792",
    "name": "Marathe Rajendra Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5741",
    "name": "Shingan Jalinder Aatmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2048",
    "name": "Salunkhe Laxman Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3232",
    "name": "Pawar Mahadev Sadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1661",
    "name": "Phalke Ashok Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15704",
    "name": "Bhilare Sharad Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8276",
    "name": "More Shamrao Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17707",
    "name": "Dhumal Hausabai Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12861",
    "name": "Pisal Lahudas Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16016",
    "name": "Shinde Laxman Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10979",
    "name": "Panvelkar Rajaram Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7909",
    "name": "Prabhu Prabhakar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9796",
    "name": "Chalke Sunil Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10888",
    "name": "Kothale Trambak Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6632",
    "name": "Sulake Suresh Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12251",
    "name": "Sethia Ratnidevi M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4978",
    "name": "Shah Dipak Chimanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9651",
    "name": "Patel Achularam Ladhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4174",
    "name": "Nazareth Sabastian E"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17389",
    "name": "Jadhav Nivrutti Savlaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1777",
    "name": "Jagdale Baban Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18866",
    "name": "Bhowmik Nabakumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5385",
    "name": "Khande Prakash Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12772",
    "name": "Dhumal Satish Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11434",
    "name": "Katkar Gopinath Aabaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7983",
    "name": "Pisal Madhukar Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17355",
    "name": "Shinde Hanmant Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "230",
    "name": "Warnekar Gulabrao Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2022",
    "name": "Sarajiarao Sahebrao & Co."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4998",
    "name": "Suvarna Balkrishna B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8378",
    "name": "Malpote Gablu Damodar / Nalawade Sd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14663",
    "name": "Chawan Vijay Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8708",
    "name": "Shinde Mahadeo Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11904",
    "name": "Chawan Dinkar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9592",
    "name": "Kherajani Ghanshyam Mohandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15255",
    "name": "Shah Pankaj Kantilal &Rastrika P Shah"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1121",
    "name": "Wagh Dharma Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9534",
    "name": "Jain Ranjeetkumar Danmalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1164",
    "name": "Rajak Abdul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5199",
    "name": "Shinde Dadaso Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11110",
    "name": "Nikam Madhukar Jijaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16062",
    "name": "Kaldevkar Dattaram Sunder"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5846",
    "name": "Mistry Pravin Nagindas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "383",
    "name": "Kadam Uttam Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8309",
    "name": "Pradhan Shirish Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17391",
    "name": "Rodrigues Astin Edwin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10452",
    "name": "Shilimkar Shivaji Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11667",
    "name": "Tamse Anil Govindrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9712",
    "name": "Yadav Kisanlal Bhavnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9120",
    "name": "Chorge Suresh G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17091",
    "name": "Pawar Sanjay Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8371",
    "name": "Rathor Rameshkumar S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17459",
    "name": "Ghadigaonkar Prajakta Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4714",
    "name": "Shinde Balu Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16422",
    "name": "Manjrekar Rajesh Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14290",
    "name": "Chawan Vijaybhan Ghirau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10647",
    "name": "Mishra Harikrishna Muknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4498",
    "name": "Yadav Usha Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11207",
    "name": "Salunkhe Sanjay Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8812",
    "name": "Jadhav Mangaru Chotu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4671",
    "name": "Shinde Parshuram Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8058",
    "name": "Pawar Mahadeo Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15610",
    "name": "Bhagat Nidhi Satish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10598",
    "name": "Bhosale Shankar Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8997",
    "name": "Jadhav Balasaheb Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "51",
    "name": "Savla Shopping Centre"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1280",
    "name": "Chavan Maruti Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16217",
    "name": "Ghadage Usha Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17864",
    "name": "Phatak Rupa Suhas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2263",
    "name": "Bodake Laxman Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10463",
    "name": "Patil Shivaji Baku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16894",
    "name": "Chavan Malati Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5896",
    "name": "Purohit Bhanwar Sing Bhopalsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4412",
    "name": "Jadhav Kisanrao Nanasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10774",
    "name": "Karale Tanaji Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15431",
    "name": "Chavan Ram Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5632",
    "name": "Phadtare Tukaram Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9940",
    "name": "Shah Ramesh B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8087",
    "name": "Pawar Ramchandra Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "374",
    "name": "Shivthare Sadashiv Jagdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10629",
    "name": "Yadav Jagatnarayan Ramavatar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17406",
    "name": "Jagtap Balu Jitas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14119",
    "name": "Mehta Suresh R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6936",
    "name": "Jagtap Ramdas Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1060",
    "name": "Ramayya Manjula K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8656",
    "name": "Ghadiali Manjula Krishnakumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4771",
    "name": "Bandal Tukaram Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16776",
    "name": "Jain Chhaganlal S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12013",
    "name": "Kadam Vishnu Tayappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12428",
    "name": "Mangaladevi Marg Rahiwashi Sahakary"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9997",
    "name": "Kocharekar Pramod Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4161",
    "name": "Waghchaure Sakhu Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12701",
    "name": "Kansara Chandrakant Chunilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6092",
    "name": "Deora Tejsingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5926",
    "name": "Patel Nandaben V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7055",
    "name": "Shidruk Mahadeo Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11730",
    "name": "Kadam Tanaji Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "697",
    "name": "Pawar Gulabrao Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9289",
    "name": "Dhumal Jagannath Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9964",
    "name": "Nalage Dilipkumar Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1318",
    "name": "Nalage Namdev Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9150",
    "name": "Gohil Bhavana Vinod"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5371",
    "name": "Shinde Popat Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5139",
    "name": "Bhatt Rajendra S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4649",
    "name": "Jagdale Ramdas Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3781",
    "name": "Shivankar Narayan Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14002",
    "name": "Dere Mansing A"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16001",
    "name": "Hawal Sunita Mangesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9879",
    "name": "Patel Pratip Vasudeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10828",
    "name": "Bhoite Vithal Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12255",
    "name": "Yadav Ramprasad Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11606",
    "name": "Mandhare Namdeo Sopanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14316",
    "name": "Chowhan Ghirau Bhuje"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15450",
    "name": "Sapugade Anandrao Nathaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15220",
    "name": "Adsul Dattatray Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17789",
    "name": "Dalvi Amol Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14233",
    "name": "Gowda Narayan Nanjuda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14969",
    "name": "Pawar Suryakant Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17776",
    "name": "Patel Hetal C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15855",
    "name": "Patil Prakash Ramchandra."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3080",
    "name": "Chawan Kundalik Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11890",
    "name": "Chavan Shivaji Vinayakrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "614",
    "name": "Nalage Aabaji Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1758",
    "name": "Lahigude Sahebrao Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17631",
    "name": "Rathour Phulchand L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14889",
    "name": "Shukla Bhagawatiprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12307",
    "name": "Phadtare Navnath Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12882",
    "name": "Shinde R.B."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5720",
    "name": "Chikne Ramchandra Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8462",
    "name": "Gandhi Parag Rasiklal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6302",
    "name": "Salunkhe Sambhaji Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5272",
    "name": "Jain Budhamal Hukmichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11330",
    "name": "Chawan Arun Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3124",
    "name": "Pawar Shivaji Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15739",
    "name": "Dhumal Suresh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11668",
    "name": "Gade Uttam Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15031",
    "name": "Mhatre Moreshwar Jaywant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9687",
    "name": "Ray Jiten"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1287",
    "name": "Kenjale Vishnu Savlaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8549",
    "name": "Jain Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13702",
    "name": "Joyis Prakash R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17483",
    "name": "Kansara Rameshchandra Bhagwandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10864",
    "name": "Shah Bhavesh J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3447",
    "name": "Mutke Jijaba Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9689",
    "name": "Kapadi Shripat Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11244",
    "name": "Disale Kisabai Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15409",
    "name": "Jadhav Jitendra Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8425",
    "name": "K Sadashiv Shetty"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3604",
    "name": "Nawadkar Sopan Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13428",
    "name": "Ghag Ganesh Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6285",
    "name": "Tanpure Shankaranand Marutirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12706",
    "name": "Pariwal Gaurishankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5692",
    "name": "Jagdale Ramdas Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11355",
    "name": "Kadav Prakash Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15357",
    "name": "Rebello Flossy"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11191",
    "name": "Sherekar Sadashiv Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2897",
    "name": "Pachupate Nanasaheb Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7662",
    "name": "Dalvi Annapurna Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13578",
    "name": "Pereira John Michael"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16586",
    "name": "Sankpal Rekha A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2958",
    "name": "Salunkhe Pralhad Joji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4189",
    "name": "Yadav Anita Mugatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17707",
    "name": "Thukarul Trupti Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7160",
    "name": "Shaikh Abdul Rehaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6018",
    "name": "Aavachar Sudam Jagdevrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18307",
    "name": "Agarwal Shyam Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11350",
    "name": "Chawan Balu Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9097",
    "name": "Dalvi Godawari Digamber"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9797",
    "name": "Shedage Suresh Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6767",
    "name": "Shelar Shantaram Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9217",
    "name": "Shah Arvind Champaklal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12111",
    "name": "Mahadik Arun Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10844",
    "name": "Dubey Ramashankar Ramdin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15071",
    "name": "Mahadik Chandrakant Atmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15598",
    "name": "Poojary Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2181",
    "name": "Jadhav Shivaji Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1289",
    "name": "Chawan Sampatrao Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7378",
    "name": "Pawar Ganpat Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5591",
    "name": "Matre Kisan Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2745",
    "name": "Bobade Jagannath Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2993",
    "name": "Sawant Khashaba Mahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9676",
    "name": "Chawan Ananda Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21502",
    "name": "Keluskar Sandeep  Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21486",
    "name": "Poojari  Santosh  Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7603",
    "name": "Vyas Maganlal Hariwansh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21429",
    "name": "Akash Gosai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21427",
    "name": "Gandhi Ketan Rajnikant ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21443",
    "name": "Gupta Sharad Jagdish."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21444",
    "name": "Gupta Vishal Jagdish."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21431",
    "name": "Narendra Singh ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21420",
    "name": "Sawant Sunil Sharad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21430",
    "name": "Viplav Singh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8955",
    "name": "Dhaniya Mehandi Allahadar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4000",
    "name": "Pisal Ramrao Gyanba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6930",
    "name": "Lobo Janwario Manoel"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2389",
    "name": "Sakunde Shrimant Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21361",
    "name": "Chinangath Prasad Gangadharam."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14832",
    "name": "Jain Atul Hastimal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21363",
    "name": "Kandle Mahesh  Ramlu."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17847",
    "name": "Nikam Popat Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10324",
    "name": "Sharma Rajesh S"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "883",
    "name": "Shah Keshavlal Narbheram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14462",
    "name": "Pawar Ganesh Bhimrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "342",
    "name": "Gole Vishnu Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6080",
    "name": "More Chandrakant Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4974",
    "name": "Jadhav Bhaskar Sawalaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14109",
    "name": "Chavan Dayanand Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3691",
    "name": "Pawar Ramdas Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21233",
    "name": "Amin Harish Virappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21232",
    "name": "Amin Malati Harish."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21230",
    "name": "Bangera Ganesh Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21231",
    "name": "Bangera Smita Ganesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21249",
    "name": "Bobhate  Prashant  Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17658",
    "name": "Chavan Bhagoji Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16201",
    "name": "Thakur Sachin Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12947",
    "name": "Thakker Mala Mahesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3845",
    "name": "Parasnath Mannubai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4827",
    "name": "Bhosale Sadashiv Jagdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4258",
    "name": "Gaikwad Ashok Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2437",
    "name": "Bhoite Atmaram Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21180",
    "name": "Bhagade Prabhakar Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21181",
    "name": "Bhaip Ashok Mukund"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19090",
    "name": "Borade Sachin Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21209",
    "name": "Fernandes  Juliet  R."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21182",
    "name": "Haryan Mangesh Appa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14494",
    "name": "Jadhav Leena Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21211",
    "name": "Raykar Prabhavti  Jaydev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4245",
    "name": "Gram Vikas Seva Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2393",
    "name": "Jadhav Maruti Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4025",
    "name": "Zanzane Namdeo Waghu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3520",
    "name": "Shinde Mahipatrao Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18016",
    "name": "Wadia Babubhai Nagardas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10358",
    "name": "Deshmukh Sudhir Sarjerao& Pisal Tai Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17559",
    "name": "Pandye Santoshkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "511",
    "name": "Shah Vasraj Jawanmal & Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21130",
    "name": "Bavale  Nivrutti  Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21129",
    "name": "Kothari  Shilpa  N."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8526",
    "name": "Pawar Vishwanath Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9648",
    "name": "Pawar Uddhav Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12588",
    "name": "Mehta Punamchand K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18776",
    "name": "Desai Rajesh Lumaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16261",
    "name": "Kadam Seema Sanjay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21098",
    "name": "Sawant Vasudeo Shridhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4609",
    "name": "Shinde Shankar Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1499",
    "name": "Bhoite Eknath Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6343",
    "name": "Tailor Laxman Kanhaiyalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12465",
    "name": "Mandhare Nanasaheb Jayshing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9368",
    "name": "Patel Rajanikant Ishwardas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8354",
    "name": "More Baburao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10891",
    "name": "Gholap Hindurao Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19793",
    "name": "Shinde Pravin Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1038",
    "name": "P Jaysukhlal Anandlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3622",
    "name": "Aadhav Kisan Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21075",
    "name": "Bandre Sharad Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5794",
    "name": "Chavan Manik Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4665",
    "name": "B Wadi Vikas Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13563",
    "name": "Mardhekar Nikita Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9368",
    "name": "Pisal Prakash Parbatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6575",
    "name": "Malu Anand Motilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4911",
    "name": "Sahyadri Sahakari B.Ltd Staff Sport"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6178",
    "name": "Jain Pushpadevi C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13592",
    "name": "Shilimkar Reshma Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8126",
    "name": "Taware Kubir Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2104",
    "name": "Bhosale Shankar Kikola"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9234",
    "name": "Yadav Sitaram Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15025",
    "name": "Patil Sudhakar Vasudeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11471",
    "name": "Jain Sheetal A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1818",
    "name": "Chavan Shamrao Jyoti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7379",
    "name": "Veer Dattatray Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1636",
    "name": "Lembhe Narshing Baji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5767",
    "name": "Bambarad Ankush Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3089",
    "name": "Barve Sambhaji Mahadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18389",
    "name": "Abraham Chacko  P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18368",
    "name": "Gharat Parag Ramakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1144",
    "name": "Dhumal Nivruti Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14825",
    "name": "Anpat Raghunath Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11857",
    "name": "Kadam Baliram Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11940",
    "name": "Gupta Bhagwandin Chotelal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2663",
    "name": "Gavali Premnath Dhansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "867",
    "name": "Shailesh Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2480",
    "name": "Shalan Arts"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1085",
    "name": "Shankar Steels"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20876",
    "name": "Misal Babasaheb  Baliba"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3418",
    "name": "Sharad Publication"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20705",
    "name": "Khonde Jitendra Sonu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10338",
    "name": "Dakave Krishna Rakhamu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11958",
    "name": "Gowda Raghu Rangappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17139",
    "name": "Shelake  Hirabai  Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7912",
    "name": "Yewale Shashikant Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5844",
    "name": "Jadhav Balaram B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21125",
    "name": "Bhosale Vijay Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18257",
    "name": "Khandagale Shantaram  Sudam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1960",
    "name": "Shinde Vithal Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10684",
    "name": "Shinde Shankar Dadaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15510",
    "name": "Akerkar Gurunath Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18191",
    "name": "Jadhav Budhadas Yeswant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18190",
    "name": "Jadhav Prakash Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18189",
    "name": "Kadam Mahendra Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9811",
    "name": "Shinde Hanmant Atmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9707",
    "name": "Gunjawate Uttam Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7801",
    "name": "Jasani Suresh Harakhp"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18136",
    "name": "Kadam Mahesh Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10783",
    "name": "Bhoite Tukaram Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11963",
    "name": "Chorage Rajaram Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11428",
    "name": "Rathor Rahulkumar Rameshkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14466",
    "name": "Satardekar Nitin Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10201",
    "name": "Sawant Ramchandra Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9777",
    "name": "Udatar Gramastha Vikas Mandal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18066",
    "name": "Nalavade Mala Santosh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1684",
    "name": "Bhoite Kamal Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2397",
    "name": "Sheetal Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16982",
    "name": "Mahade Sandeep Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13425",
    "name": "Padawal Minanath Sawaleram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "196",
    "name": "Gholap Prakash Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18887",
    "name": "Kadam  Hemant Sudhakar/ Neetu H Kadam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14134",
    "name": "Salekar Vinesh Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5771",
    "name": "Shah Budhamal H."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4046",
    "name": "Chaphekar Suchita J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18264",
    "name": "Joshi Durgadevi Harilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "186",
    "name": "Kadam Mangal Vyankatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12286",
    "name": "Lakhwani Premchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1210",
    "name": "Waghmare Parshuram Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15008",
    "name": "Rane Anil Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2296",
    "name": "Chawan Subhash Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8117",
    "name": "Pawar Sadashiv Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13281",
    "name": "Mohite Arun Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9775",
    "name": "Yadav Thakurprasad Dukhprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8290",
    "name": "Yadav Rammurat Ramlakhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15813",
    "name": "Gala Heena Kishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9502",
    "name": "Jain Ramesh Kumar Himatmalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12418",
    "name": "Shah Manjula Babulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10997",
    "name": "Jain Modilal Ganeshlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8877",
    "name": "Jadhav Ramchandra R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1240",
    "name": "Pujari Laxman Dajee"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17953",
    "name": "Pednekar Suhas Liladhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10160",
    "name": "Yadav Shivaji Govindrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17919",
    "name": "Chavan Mahesh Bhaskar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3945",
    "name": "Dasuri Jairam Vasudeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17166",
    "name": "Shilimakar  Malan  Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "863",
    "name": "Raut Ramchandra Bhivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7942",
    "name": "Chandiwade Hariba Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20350",
    "name": "Chaughule Aziza Mahemud"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20347",
    "name": "Mehata Pinky Mitesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4045",
    "name": "Chaphekar Satyabhamabai Y"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17795",
    "name": "Chavan Rohini Ramakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20492",
    "name": "Kapadia Atul Pratapsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15360",
    "name": "Kudale Sambhaji Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16663",
    "name": "Pawar Jitendra Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7483",
    "name": "Chawan Raghunath Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1075",
    "name": "Kadav Dinkar Rao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6320",
    "name": "Jain Anandkumar T"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10339",
    "name": "Yadav Abaso Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16074",
    "name": "D Sa Charles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7126",
    "name": "Pawar Bhanundas Kerba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10787",
    "name": "Raman Ayambara K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5068",
    "name": "Maharugade Rajaram Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1047",
    "name": "Babar Ranjana Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17771",
    "name": "Kale Shashi Vijaykumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11107",
    "name": "Sinnanan Ramu Tevan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7136",
    "name": "Chawan Gulab Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17708",
    "name": "Gosavi Vishwnath Gangaram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10761",
    "name": "Jethwani Kaushalya Dewandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15727",
    "name": "Nalawade Dinkar Karbhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7445",
    "name": "Desai Prakash Govindrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4772",
    "name": "Sanghvi Panna H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2267",
    "name": "Bhoite Shankar Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5927",
    "name": "Kumpawat Parmanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8488",
    "name": "Salvi Ramchandra Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16804",
    "name": "Chavan Santosh Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13479",
    "name": "Dhumal Vitthal Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2925",
    "name": "Sakpal Pandurang Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17327",
    "name": "Modak Bhanudas Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11391",
    "name": "Gaikwad Sahaji Damrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14853",
    "name": "Baduri Lakshmikanta Dinbandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18159",
    "name": "Chawan Sachindra Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13710",
    "name": "Sakpal Ashok Vishram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3695",
    "name": "Chaskar Mahadu Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13286",
    "name": "Bhoite Sunil Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4363",
    "name": "More Mahadeo Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9641",
    "name": "Jadeja Meraman Kandha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16136",
    "name": "Chawan Sharad Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8035",
    "name": "Parmanand Parvatibai M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7950",
    "name": "Maniar Bhadra J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13298",
    "name": "Ambanave Sushila Balaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18839",
    "name": "Dalvi Shrikant Digamber"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5710",
    "name": "Veigas Hazel"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6591",
    "name": "Shinde Tukaram Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2979",
    "name": "Agency Sarvodaya Transport"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15213",
    "name": "Agrawal Maheshkumar P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10048",
    "name": "Shelar Vithal Ravaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13125",
    "name": "Gurasale Savita Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "584",
    "name": "Mohite Ramrao Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14512",
    "name": "Anande Rajkumar Keshavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20728",
    "name": "Lotalokar Suresh Narsiha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14491",
    "name": "Ludabe Sunil Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8299",
    "name": "Mohite Mahadeo Kalu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20087",
    "name": "Kakade Suresh Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20082",
    "name": "Ovalekar Deepa Mahendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19015",
    "name": "Talvekar Mangesh Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6672",
    "name": "Pol Shahaji Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9427",
    "name": "Chawan Dharmaraj Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "802",
    "name": "Taware Aatmaram Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13716",
    "name": "Dalvi Rohini Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5610",
    "name": "Chaudhari Lata Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16337",
    "name": "Cabral Mary"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15318",
    "name": "Kadam Prakash Arun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10660",
    "name": "Jain Nemichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6849",
    "name": "Patil Maruti Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5564",
    "name": "Banka Jagdishprasad Sajankumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20044",
    "name": "Gamare Rajesh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20026",
    "name": "Ravi Sawarmal Singhania"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12341",
    "name": "Sapkal Ashok D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2277",
    "name": "Shinde Sambhaji Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14199",
    "name": "Saroj Ghanshyam Ramraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13194",
    "name": "Panchal Mehul Pravin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13502",
    "name": "Chavan N D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18060",
    "name": "Gauda Kumar Rajiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8147",
    "name": "Gaikwad Pralhad Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4143",
    "name": "Mokal Laxman Sahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18932",
    "name": "Barge Neeta  Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1056",
    "name": "Remje Vasant Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11062",
    "name": "Marimutha M K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16700",
    "name": "Mayekar Sweeta Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17972",
    "name": "Potdar Harshala Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12517",
    "name": "Jaigadi Maniram Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1870",
    "name": "Chavan Narayanrao Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7675",
    "name": "Chawan Chandru Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "603",
    "name": "Thakur Dawood Hassan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8941",
    "name": "Mane Balaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5189",
    "name": "Shirgaonkar Rajashree Jagdish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3832",
    "name": "Vora Babulal Karsanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7503",
    "name": "Udeshi Kakubhai Jamnadas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16333",
    "name": "Dinde Narayan Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12583",
    "name": "Lembhe Bajirao Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12204",
    "name": "More Parvati Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12355",
    "name": "Dhumal Sanjay Raosaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15143",
    "name": "Baheti Kailashchand G"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15993",
    "name": "Shirke Umesh Trimbak."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2178",
    "name": "Tosalkar Dwarkanath Keshavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10348",
    "name": "Bagal Shankar Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15210",
    "name": "Salunke Chandrakant Namedo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9986",
    "name": "Pancholi House Bhadotri Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15822",
    "name": "Aait Shekhar Vishram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19198",
    "name": "Gole Pushpa Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13655",
    "name": "Doiphode Bayabai Thaku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9860",
    "name": "Bhosale Kirti Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15860",
    "name": "Molake Chandrakant Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8634",
    "name": "Jagdale Narayan Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5152",
    "name": "Kadam Ramchandra Ravji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3253",
    "name": "Pawar Tukaram Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15156",
    "name": "Agarwal Meena Rajkapoor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11548",
    "name": "S Binakumari G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19534",
    "name": "Dcosta  Joel  Peter"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3445",
    "name": "Jain Babulal Chunilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9297",
    "name": "Matre Bandu Raju"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7486",
    "name": "Pawar Shankar Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12635",
    "name": "Dubal Narendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14796",
    "name": "Gorivale Pandurang Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15208",
    "name": "Patil Pandurang Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2448",
    "name": "Deshmukh Dattu Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13288",
    "name": "Deshmukh Vijay Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "280",
    "name": "Indulkar Suresh Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5154",
    "name": "Rode Vatsala Kisanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6995",
    "name": "Bansal Chamelidevi Pralhadrai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11188",
    "name": "Kuchekar Balu Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2619",
    "name": "Dumbre Sitaram Mohanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14059",
    "name": "Chalke Manorama Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9374",
    "name": "Rathod Sweta Jayantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4371",
    "name": "Bhosale Vitthalrao Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18753",
    "name": "Rambhiya Maitri Manish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2977",
    "name": "Hinugale Ganpat Raghu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5530",
    "name": "Pawar Vishnu Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7732",
    "name": "Trivedi Shilpa Girishchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19149",
    "name": "Varma Kailash Bhagatsinh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12665",
    "name": "Shah Hasmukhlal Nanalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2563",
    "name": "Shiv Om Syntex"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2377",
    "name": "Shivam Syntex"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17224",
    "name": "Jadhav Devendra Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10320",
    "name": "Bhavade Pandurang Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15568",
    "name": "Patel Kantilal Purashotam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17313",
    "name": "Pawar Tukaram Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18729",
    "name": "Salunkhe Supriya Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5011",
    "name": "Mane Pratibha Sharad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10547",
    "name": "Chalke Vithoba Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "807",
    "name": "Shree Kapad Bazar Maratha Kamgar Ma"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10602",
    "name": "Prakaji Viraram (Huf)"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3899",
    "name": "Pisal Vilas Vithalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20668",
    "name": "Maji  Narayn   Anukul"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "689",
    "name": "Shraddha Medicaments Pvt.Ltd."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "332",
    "name": "Shree Ahireshwar Transport Service"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2537",
    "name": "Shree Ganesh Construction"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2282",
    "name": "Shree Ganesh Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1",
    "name": "Shree Kapad Bazar Maratha Kamgar Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1381",
    "name": "Shree Krishna Trading Co."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3688",
    "name": "Shree Mahalaxmi Transport Service"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2940",
    "name": "Shree Satyam Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2483",
    "name": "Shreeji Sarees"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "582",
    "name": "Shreeji Traders"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "736",
    "name": "Shreeji Trading."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2485",
    "name": "Shri Ganpati Yarn Syndicate"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3057",
    "name": "Shri Mallikarjun Trading"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13850",
    "name": "Mavani Nirmala Jaswant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16816",
    "name": "More Balkrishna Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1288",
    "name": "Shriram Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1037",
    "name": "Pawar Kisan Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15043",
    "name": "Farnandis Kaytan Manvel"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9269",
    "name": "Sakunde Satish Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19068",
    "name": "Gurav Abhijit D."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2371",
    "name": "Shubh Enterprise"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10354",
    "name": "Chandi Ramdeo Vasudeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6252",
    "name": "Kamble Babu Aasruba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11502",
    "name": "Rajput Kuvarsing D."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9284",
    "name": "Jagtap Mahadeo Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19173",
    "name": "Namdas Panchfula Dnyaneshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12666",
    "name": "Shah Hitiksha Hasmukhlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "606",
    "name": "Siddhivinayak Bottle Suppliers"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "687",
    "name": "Sidhanath Transport Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19199",
    "name": "Gole Sunil Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19053",
    "name": "Malawade Devata Ratan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19056",
    "name": "Malawade Vishakha Ratan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19061",
    "name": "Malwade Kamini Ratan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19052",
    "name": "Malwade Rilesh Ratan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9498",
    "name": "Dhanawade Laxman Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8723",
    "name": "Shirsat Vasant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15472",
    "name": "Desai Pravin Hemraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7051",
    "name": "Shinde Hambirrao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11673",
    "name": "Mane Ravindra Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4669",
    "name": "More Mohan Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6706",
    "name": "Kolpekar Mohan Aasaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12499",
    "name": "Sabale Kanta Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6327",
    "name": "Nagaram Premaji Chaudhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16608",
    "name": "Bhuwad Atmaram Ratnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12725",
    "name": "Gaikwad Ravindra Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18044",
    "name": "Mayekar Ashok Sudam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1963",
    "name": "Katkar Babanrao Abbaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14823",
    "name": "Vyas Sunil Badridas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9744",
    "name": "Savla Shamji Shivji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3996",
    "name": "Kadam Dnyandeo Appaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9108",
    "name": "Chalake Sampat Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5542",
    "name": "Jagtap Kisan Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12708",
    "name": "Shah Sangita Ratanchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8610",
    "name": "Borkar Rajashree Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17481",
    "name": "Nanani Rupin M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20454",
    "name": "Remje Amit Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6977",
    "name": "Pisal Genaba Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2137",
    "name": "Bhoite Shivaji Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7982",
    "name": "Thombare Santosh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7351",
    "name": "Budhia Dipu Dayalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "257",
    "name": "Smitkamal Products"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11459",
    "name": "Chonkar Chandrakant Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9407",
    "name": "Joshi Hina Rashmikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12080",
    "name": "Gaikwad Surendra Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "475",
    "name": "Jagtap Vishnu Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14572",
    "name": "Thakur Hamendra Pratapsinh"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "348",
    "name": "Sogmal Bhutaji And Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1819",
    "name": "Tayshete R P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10015",
    "name": "Thorat Jayashree Nanaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12074",
    "name": "Gaikwad Laxmibai Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11206",
    "name": "Fernandes Nelson F"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12478",
    "name": "Usgaonkar Dhondiba Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17510",
    "name": "Martin Ranjini Moses."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13222",
    "name": "Mistry Umedmal Chelaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "613",
    "name": "Solar Illumination"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3099",
    "name": "Umbarkar Shrirang Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3633",
    "name": "Aanute Sakharam Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20220",
    "name": "Angre Arvind Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15268",
    "name": "Bhagwat Indubai Narayan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12762",
    "name": "Bohra Purna Amritlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8466",
    "name": "Gujar Vijay Sopan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16547",
    "name": "Chalke Amol Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10762",
    "name": "Jethwani Lata Mulchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2938",
    "name": "Somnath Sai Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15312",
    "name": "Shinde Narayan Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13749",
    "name": "Kambli Parinita Shridhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17472",
    "name": "Patil Namdev Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8107",
    "name": "Shelar Vasant Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4571",
    "name": "Mulik Atmaram Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "245",
    "name": "Sonawane Jaysingh Ravba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15529",
    "name": "Naik Subhash Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4613",
    "name": "Pawar Balkrishna Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14949",
    "name": "Shidruk Hanmant Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10424",
    "name": "Ashwini-Employees Benefit Scheme"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8542",
    "name": "Fernandes Conception Sebastion"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15069",
    "name": "Panchal Kishor Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14556",
    "name": "Shah Sundarben Rameshchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4882",
    "name": "Ghadage Babnrao Bhugangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19197",
    "name": "Gawda  Mahesh  Nanjay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6683",
    "name": "Jagtap Balu Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4215",
    "name": "Mane Arvind Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8786",
    "name": "Wayal Shivaji Dattatraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9739",
    "name": "Jain Gheesulal P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15495",
    "name": "Karekar Shital Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5396",
    "name": "Shinde Shivaji Jagdevrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10607",
    "name": "Risbud Prakash Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1790",
    "name": "Palav Shobhana Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9135",
    "name": "Phalle Dattatray Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8289",
    "name": "Agrawal Raghuveer Prasad Bansilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20525",
    "name": "Rambhiya Riya Sandeep"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18539",
    "name": "Shah Jay Kirtikumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17127",
    "name": "Shaik Mohd  Ismail"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4108",
    "name": "Star Packaging"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7162",
    "name": "More Jagdish Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6990",
    "name": "Pushpa Devi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3274",
    "name": "Doshi Jayesh Hiralal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9563",
    "name": "Salvi Madhusudan Gopaldas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16930",
    "name": "Chawan Uttam Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14500",
    "name": "Pawar Popat Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2648",
    "name": "Sun Silk Synthetics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2887",
    "name": "Sun Wire Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16262",
    "name": "More Santosh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2978",
    "name": "Sunil Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9149",
    "name": "Ghadge Yashoda Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17717",
    "name": "Jain Mahendra K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16715",
    "name": "L R & Other Bldg Tenent Association"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16281",
    "name": "Rajasthan Jain Parishad"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2834",
    "name": "Suraj Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12496",
    "name": "Iyer Raman D"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2858",
    "name": "Suresh Syntex"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15060",
    "name": "Chaudhari Kailash Mupaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "558",
    "name": "Sureshchandra & Co."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16561",
    "name": "Pawar Rupali Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16714",
    "name": "Shadi Bhakat Bahadur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6153",
    "name": "Rathor Bhavarlal Sermalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4104",
    "name": "Barge Tukaram Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5088",
    "name": "Dalvi Yeshwant Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7910",
    "name": "Aatugade Vishnu Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1274",
    "name": "Pawar Mahadu Sadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4049",
    "name": "More Shivram Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14761",
    "name": "Dhumal Suresh Vishwasrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1040",
    "name": "Deshmukh Maruti Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2475",
    "name": "Pabale Tukaram Parbati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7511",
    "name": "Shilimkar Chandrakant Jaising"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16540",
    "name": "Sawant Laxman Jayram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11865",
    "name": "Jadhav Anna Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1839",
    "name": "Gramastha Mandal Mauje Kalangwadi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16411",
    "name": "Jogatar Babulal Shivlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4459",
    "name": "More Rajaram Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5035",
    "name": "Bhilare Dagadu Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1024",
    "name": "Remje Attmaram Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4322",
    "name": "Mumbai Kagad Bazar Kamgar Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1128",
    "name": "Mane Haibati Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18516",
    "name": "Milwani Devraj Shamlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18515",
    "name": "Milwani Vijaya Devraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7304",
    "name": "Dhinde Sitabai Ramachandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11692",
    "name": "Padwal Vasudha Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14042",
    "name": "Chavan Annasaheb Appaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17590",
    "name": "Kadam Malan Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11836",
    "name": "Sharma Ravindrakumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1839",
    "name": "Suyash Saree Centre"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1714",
    "name": "Suyog Sarees"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2506",
    "name": "Suyog Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10121",
    "name": "Mistry Manoj Nagindas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16798",
    "name": "Bhapkar Jalindar Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14084",
    "name": "Jaiswal Deviprasad Baisek"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "359",
    "name": "T Rodrigues Garage"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "753",
    "name": "T.K. Sharma"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10345",
    "name": "Kadam Shankar Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2203",
    "name": "Yadav Rao Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8172",
    "name": "Bisure Ganpat Shivappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6895",
    "name": "Kadam Mahadeo Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9376",
    "name": "Jadhav Balkrishna Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11828",
    "name": "Kambale Ramesh Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1990",
    "name": "Gorat Dnyanu Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16530",
    "name": "Shinde Nandkumar Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14846",
    "name": "Bhosale Vijay Shidraram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2170",
    "name": "Kumkule Hanmant Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7512",
    "name": "Shinde Hanmant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "534",
    "name": "Sakpal Sampat Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4820",
    "name": "Chalke Shivaji Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10972",
    "name": "Makwana Bhavesh Jayantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11245",
    "name": "More Hanmant Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9541",
    "name": "Raut Govind Atmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19062",
    "name": "Kubade Rameswari Ravindra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19063",
    "name": "Kubade Shalaka Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2863",
    "name": "Nalawade Anandrao Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19643",
    "name": "Belwalkar Amit Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "805",
    "name": "Shri Kapad Bazar Maratha Kamgar Mandal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8273",
    "name": "Porwal Kantilal Chunilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20099",
    "name": "Mane  Balu Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10207",
    "name": "Shinde Krishna Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11235",
    "name": "Jain Bherulal Ghisulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15080",
    "name": "Chalke Dashrath Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6644",
    "name": "Kadam Ishwar Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "890",
    "name": "Mandria Jamnadas Makhanji"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "10002",
    "name": "Mankat B.P. & Urankar P.R."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6801",
    "name": "Jain Pukhraj Shetmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2420",
    "name": "Dutal Kisan Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2129",
    "name": "Mungase Jagannath Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10318",
    "name": "Shah Hasmukhlal N"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12555",
    "name": "More Gautam Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20748",
    "name": "Dinda Bhimnath Premlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17958",
    "name": "Juvekar Sunita Surendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10069",
    "name": "Sonwale Ashok Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "672",
    "name": "Sarafdar Ganpat Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14575",
    "name": "Luniya Audram Ramdin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13067",
    "name": "Baheti Rukmanidevi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2147",
    "name": "Wagh Dattatray Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11325",
    "name": "Vithalwadi Sarv Ganeshotsav/Shivjay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18972",
    "name": "Jagadale Govind Kahanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1549",
    "name": "Techni Craft"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3664",
    "name": "Techno Computers."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15452",
    "name": "Taigade Suresh Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15215",
    "name": "Lotlikar Kundalik Gokuldas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14528",
    "name": "Jaiswal Asharam Kanahiyalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11492",
    "name": "Shah Tarulata Hasmukh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15658",
    "name": "Mistry Munnalal Bodhuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9396",
    "name": "Jain Pawan Hastimal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1462",
    "name": "Deshmukh Shankar Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1489",
    "name": "Salate Ananda Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2412",
    "name": "Khan Sukarulla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9490",
    "name": "Pukhrajji Sukanraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3007",
    "name": "Loke Shridhar Gunaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18240",
    "name": "Gole Tukaram Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5258",
    "name": "Yadav Shyambihari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5920",
    "name": "Pisal Parasram Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2004",
    "name": "Kadam Baburao Aaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7915",
    "name": "Ahmed Bashirkhan Najir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16504",
    "name": "Wadekar Sharmila Rajendranath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7585",
    "name": "Patil Shrikant Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18378",
    "name": "Estibeiro Roque"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18208",
    "name": "Shah Kajal P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4762",
    "name": "Bobade Vilas Gangaram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12819",
    "name": "Sewarsa Krishanpal Juharsingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17446",
    "name": "Jain Rajeshkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1688",
    "name": "Satra Padmini Rameshchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11639",
    "name": "Waghe Pandurang Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14048",
    "name": "Verma Shreeniwas M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5355",
    "name": "Chhangani Ramchandra Murlidhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9382",
    "name": "Pal Nabhopal Gopalchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8471",
    "name": "Kaji Baban Magbul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17550",
    "name": "Kapadia Bakul Kakubhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11093",
    "name": "Shah Deepak Himatlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2336",
    "name": "Chawan Sharda Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2133",
    "name": "Danawale Dharmu Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5247",
    "name": "Sawant Nana Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2190",
    "name": "Jaikar Maruti Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "235",
    "name": "Pujari Shankar B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14712",
    "name": "Munde Raghunath Hadaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10907",
    "name": "Prajapati Daularam Vajaramji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13592",
    "name": "Yezarkar Pornima Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6988",
    "name": "Mulik Sampat Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5373",
    "name": "Bandre Anant Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16485",
    "name": "Garasiya Vanita Thakora"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12378",
    "name": "Shinde Dattatray Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8685",
    "name": "Jadhav Sanjay Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17966",
    "name": "Thakur Ranjit Singh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "798",
    "name": "Thorat Sampatrao Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3967",
    "name": "Pokle Minal C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11778",
    "name": "Yadav Kisanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3193",
    "name": "Tikamchand & Co."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2286",
    "name": "Tirupati Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5066",
    "name": "Yadav Shankar Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11034",
    "name": "Maharashtra Gumasta Labour Union"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14658",
    "name": "Bhandari Daljeetsingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14654",
    "name": "Shah Bipinkumar Rameshchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19794",
    "name": "Purohit Punamchand Bhairaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9657",
    "name": "Solanki Tarabai B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11363",
    "name": "Limaye Mohan Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3401",
    "name": "Tiwari Parcel Service"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7966",
    "name": "Jain Bimladevi Basantkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "425",
    "name": "Nikam Namdev Santu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19971",
    "name": "Gala Kuntal Manilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7637",
    "name": "Bhati Ramlal Jethaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4329",
    "name": "Chavan Kisan Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11572",
    "name": "Jamsandekar Alka A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13948",
    "name": "Dhumal Ramesh Vinayakrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19859",
    "name": "Chikane Anand Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15996",
    "name": "Pawar Sitaram Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17388",
    "name": "Bhogle Sarvottam Atmaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "457",
    "name": "Trinity Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17406",
    "name": "Bandiwadekar Ramnath Vasant."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18086",
    "name": "Bhosale Popat Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19460",
    "name": "Yedage Shivram Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "238",
    "name": "Patil Narayan Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10426",
    "name": "Laud Mangesh K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12587",
    "name": "Jain Vishalkumar Sureshchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18619",
    "name": "Patil Sangeeta Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17129",
    "name": "Pawar Bhagwan Tatya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "373",
    "name": "Ghare Ramchandra Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13219",
    "name": "Dave Jayamati Dinkarrai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8816",
    "name": "Shinde Avinash Harishchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14391",
    "name": "Mohite Madhuri Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15918",
    "name": "Shree Hanuman Mandir Mandap Samiti"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2432",
    "name": "Uday Textiles Packing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3100",
    "name": "Noormohamad Hakim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19069",
    "name": "Chavan Vaibhav Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14596",
    "name": "Jain Niranjan B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5993",
    "name": "Mulik Vishwas Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16339",
    "name": "Ghare Ishwar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6812",
    "name": "Jadhav Shrirang Mugatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "579",
    "name": "Umarkar Traders"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10346",
    "name": "Salvi Unmay Madhusudan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2538",
    "name": "Teli Niwas Ali Sahadutt"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3867",
    "name": "Muchalla Lalita Chandulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1293",
    "name": "Chikate Ramchandra Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13564",
    "name": "Khandbhour Sanjay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17641",
    "name": "Fernandes Xavier F"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11962",
    "name": "Nikam Bhanudas Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3087",
    "name": "V 7 Overseas"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1460",
    "name": "V J Porwal"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "790",
    "name": "V.V.Marbles."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7619",
    "name": "Sawant Ramesh Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10030",
    "name": "Bhosale Vishwanath Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1085",
    "name": "Jagtap Shamrao Balram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1894",
    "name": "Shinde Nanaso Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5987",
    "name": "Sawant Dadu Jyoti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18057",
    "name": "Salvi Gauri Suhodh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8880",
    "name": "Jasani Mahesh Tarachand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11609",
    "name": "Sarkale Dharmaji Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8380",
    "name": "Sabale Ananda Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12913",
    "name": "Kidre Gulab Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "285",
    "name": "Tarade Mukundrao Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12706",
    "name": "Jain Sajjan Futarmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15830",
    "name": "Waghamare Laxman Gynaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4764",
    "name": "Shinde Yeshwant Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13773",
    "name": "Arekar Abhinay M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1686",
    "name": "Dabade Maruti Ranaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8003",
    "name": "Gholap Ravaji Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14584",
    "name": "More Subhash Balaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6217",
    "name": "Agarwal Vimladevi Kesharimal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13298",
    "name": "Kolpek Baburao Atmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9375",
    "name": "Rathod Renuka J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6397",
    "name": "Modi Dinesh Nagardas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18732",
    "name": "Mishra Indrabhan Chhotelal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15160",
    "name": "Mane Vaishali Prasanna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9933",
    "name": "Sabale Subhash Harishchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12982",
    "name": "Lokhande Sadashiv Keru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12216",
    "name": "Patil Appaji Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6124",
    "name": "Kolekar Ramchandra Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8750",
    "name": "Sharma Meghraj Udaybhanji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15362",
    "name": "Patil Ananda Shannkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8843",
    "name": "Jadhav Dattatray Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16608",
    "name": "Barge Daulat Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15643",
    "name": "Nimbalkar Shankar Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15772",
    "name": "380 B Chawl Committee"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16416",
    "name": "Rambhiya Charmi Manish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17144",
    "name": "Shafique Ahmad Khan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12724",
    "name": "Gupta Mahesh Kumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17706",
    "name": "Thukarul  Bhakti Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9665",
    "name": "Gramastha Mandal Waghjaiwadi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4356",
    "name": "Patil Ramchandra Tatoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8868",
    "name": "Kate Waman Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5449",
    "name": "Mandhare B S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15749",
    "name": "Agarwal Hanuman Prasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13552",
    "name": "Unkule Anil C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6892",
    "name": "Pawar Ganpat Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4862",
    "name": "Shri Dattaguru Seva Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5021",
    "name": "Mehta Virendra Chhotalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8298",
    "name": "Jagtap Suman Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9382",
    "name": "Jain Mahendra Gyanchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7131",
    "name": "Narvekar Siddhi Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17141",
    "name": "Ahirekar Satish Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17746",
    "name": "Bhosale Avinash Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16456",
    "name": "Nerurkar Vishwanath Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15484",
    "name": "Chakankar Atul Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8382",
    "name": "Keshri Biharilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2630",
    "name": "Bhoite Vithalrao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7507",
    "name": "Patil Tukaram Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3705",
    "name": "Aadarsh Tarun Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16594",
    "name": "Khan Sajjak Ahamad."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10225",
    "name": "Shirke Tukaram Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5488",
    "name": "Mohar Rau Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4533",
    "name": "Gardi Rangrao Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6792",
    "name": "Mutal Dnyandeo Rau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6905",
    "name": "Salvi Shubhangi Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1609",
    "name": "Vichitra Arts"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5476",
    "name": "Metal Bazar Kamgar Sangha"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2509",
    "name": "Vijay Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7945",
    "name": "Pednekar Nalini Nandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9219",
    "name": "Shah Kaushika Sureshchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "793",
    "name": "Bahichand Sharadkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21048",
    "name": "Chandan Vishwanath Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15477",
    "name": "Sottany Julie Nilesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1302",
    "name": "Vinaka Fabrics Pvt Ltd"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "769",
    "name": "Vipra Investment Consultants"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3400",
    "name": "Vir Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3249",
    "name": "Vishal Textile Packing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12434",
    "name": "D Souza Darryl Anthony"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18097",
    "name": "Upadhyay Dilipkumar A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6842",
    "name": "Devlekar Shankar Pilaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6537",
    "name": "Shetye Nitin Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4257",
    "name": "Shinde Dharmaraj Shivaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8503",
    "name": "Gosavi Vishvinath Dayagiri"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14711",
    "name": "Pal Zagruprasad Juganu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1487",
    "name": "Vrinda Fab"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "935",
    "name": "Vyankatesh Car Service Guarrage"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8823",
    "name": "Oswal Rameshchand Amarchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9381",
    "name": "Jain Gyanchand Mahendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12536",
    "name": "Sandeepkumar Ashokkumar Jain"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10592",
    "name": "Kadam Tanaji Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14401",
    "name": "Lunia Sangeeta Bharat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8927",
    "name": "Jaju Kamal Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13756",
    "name": "Machhar Jayesh H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12502",
    "name": "Bajria D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5349",
    "name": "Katkar Shamrao Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3809",
    "name": "Khambe Govind Pama"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12936",
    "name": "Jambur Gramastha Mandal (Mumbai)"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12652",
    "name": "Rajpurohit Revashankar L"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4893",
    "name": "Rajpure Mahadeo Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15268",
    "name": "Jain Rajendra Parasmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8975",
    "name": "Jadhav Dhondiram Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9803",
    "name": "Jadhav Shivaji Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10522",
    "name": "Domimie Farnadise"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1673",
    "name": "Nikam Shankar Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16220",
    "name": "Rathor Ramesh S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7731",
    "name": "Trivedi Priti Girishchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5346",
    "name": "Katekar Subhash Devaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10283",
    "name": "Daga Pankaj B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10281",
    "name": "Daga Paresh B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13121",
    "name": "Dalvi Sharada Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14587",
    "name": "Raut Kisan Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7350",
    "name": "Budhia Nilam Dayalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17693",
    "name": "Bhosale Dinkar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14452",
    "name": "Soni Reena Juharmalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4958",
    "name": "Shinde Vishnu Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10825",
    "name": "Pednekar Anant Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15280",
    "name": "Gadage Gangadhar Dattatrya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1999",
    "name": "Arolkar Keshav Narhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10475",
    "name": "Chavan Anil Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2467",
    "name": "Shivthare Anandrao Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6704",
    "name": "Sanghvi Ramaben Pravinchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18758",
    "name": "Dhumal Mangesh Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8664",
    "name": "Purohit Mangalchand Parkaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17421",
    "name": "Dalvi Samir Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13792",
    "name": "Varpe Gaurav Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8513",
    "name": "Jain Mukesh Kumar Tarachand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8070",
    "name": "Rawal Bhawarlal Maganlalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11039",
    "name": "Ranawat Ashakunwar Mulsiha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7984",
    "name": "Chawan Ghanshyam Gauri"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7947",
    "name": "Sakpal Balkrishna Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8400",
    "name": "Shah Varunkumr Rameshkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14683",
    "name": "Lal Bahadur Lais Mohamad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16087",
    "name": "Bhosale Usha Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3515",
    "name": "Gaikwad Jaishing Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13170",
    "name": "Dhage Nilesh Bhimrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15862",
    "name": "Lad Prakash Dhondu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7751",
    "name": "Ambavale Laxman Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13983",
    "name": "Pendhare Maruti Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "685",
    "name": "Nawadkar Jaysingh Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12662",
    "name": "Pal Sanatkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2727",
    "name": "Fernandes Natalino"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5324",
    "name": "Modi Jyotsna Nagardas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7771",
    "name": "Gade Shankarrao Daulatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18986",
    "name": "Malwade Sohan Kiran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14521",
    "name": "Khan Shahaban Abdulkhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16787",
    "name": "Vichare Vinayak R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2624",
    "name": "Desai Anusaya Ramniklal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4486",
    "name": "Jain Bibankumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16079",
    "name": "Vast Vijay Dattaram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12902",
    "name": "Gokharu Pukhraj Mangilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9152",
    "name": "Kothari Prafulla Mangilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9475",
    "name": "Mali Devaram Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3948",
    "name": "Kanagale Pandurang Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8734",
    "name": "Jadhav Maruti Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8645",
    "name": "Bhosale Janardan Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4327",
    "name": "Veswikar Vidya Nandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7607",
    "name": "Joshi Laxmandas  N."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14549",
    "name": "Shah Rameshchandra Jaichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15679",
    "name": "Mohd Sayed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9621",
    "name": "Patil Dilip Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8489",
    "name": "Sawant Narayan Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7846",
    "name": "Khot Suman Sujan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12901",
    "name": "Joshi Ramlal Devilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13401",
    "name": "Yadav Subhash Bajaee"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "513",
    "name": "Pawar Vithal Sudamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16645",
    "name": "Rathor Nikhil R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10924",
    "name": "Mulchandani Paribai C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "923",
    "name": "Jadhav Tukaram Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16614",
    "name": "Patil Ambaji Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5808",
    "name": "Jambukar Rabaji Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15166",
    "name": "Shah Dhiraj Kalyankumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12667",
    "name": "Pahadia Hiralal Samuaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "928",
    "name": "Navadkar Sadashiv Dagdoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11291",
    "name": "Pisal Tanaji Ramchandra /Dhanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1578",
    "name": "Taware Popat Shivdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "300",
    "name": "Musale Pandurang Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17190",
    "name": "Khanse  Gorakh  Vitthal  ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12936",
    "name": "Sawant Abhay Daulat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "993",
    "name": "Nalage Dinkar Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1570",
    "name": "Dhumal Vithalrao Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2557",
    "name": "Kadam Khanderao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12531",
    "name": "Jai Maharashtra Gumasta Kamgar Unio"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16927",
    "name": "Wayngankar Jayashri Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14685",
    "name": "Teli Mohamed Ismail K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13805",
    "name": "Bhosale Dnyandeo Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16672",
    "name": "Jadhav Vaijanta Tanaji."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14794",
    "name": "Jain Alok Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9540",
    "name": "Bhosale Krishnarao Sarjeta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9472",
    "name": "Shelar Prabhakar Thakuji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11812",
    "name": "Bhoite Fatesingh S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13582",
    "name": "Mali Mohanlal M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "296",
    "name": "Jadhav Vyankat Mugarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2502",
    "name": "Yogesh Corporation"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13345",
    "name": "Sawant Kisan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9546",
    "name": "Pathan Alimkhan Jalilkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11091",
    "name": "Jaiswal Munnalal Ramkrupal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13680",
    "name": "Harijan Krupashankar Rammilan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17513",
    "name": "Shetty Rati Raju"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1113",
    "name": "Mehata Jayshankar Kesavji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11268",
    "name": "Jain Aman Girish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8507",
    "name": "Jain Parasmal Devichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6375",
    "name": "Sanas Tukaram Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13057",
    "name": "Jaiswal Ramrup Jokhudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13454",
    "name": "Telitera Jilibai Chandmalji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11201",
    "name": "Morgaonkar Anant Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12656",
    "name": "Sutar Jayantilal Pukhrajji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2346",
    "name": "Solaskar Lalaji Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16281",
    "name": "Jain Sangeeta B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16381",
    "name": "Pareira Richard C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11632",
    "name": "Pisal Maruti Jijyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "358",
    "name": "Jadhav Prabhakar Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13927",
    "name": "Mane  Krishnabai  Balaso ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3360",
    "name": "More Gadagu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12107",
    "name": "Bhati Madanlal Mansharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5270",
    "name": "Jagtap Bhimrao Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7872",
    "name": "Dhopat Laxmibai Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17480",
    "name": "Thorat Asha Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9821",
    "name": "Jain Neera Jayantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1213",
    "name": "Pawar Laxman Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17744",
    "name": "Kesarkar Vinita Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17522",
    "name": "Ghadigaonkar Shital Ramesh."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5348",
    "name": "Shinde Narsingrao Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1934",
    "name": "More Ramchandra Aba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11084",
    "name": "Manakchand And Sons Huf"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5469",
    "name": "Shigavan Vithoba Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15283",
    "name": "Dagale Kashinath Dyandeo."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11010",
    "name": "Shivankar Vyankatrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7522",
    "name": "Matre Baburao Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11037",
    "name": "Jadhav Rajan Kusaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16467",
    "name": "Parmar Rajbahaddursingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1124",
    "name": "Veer Sopan Parabat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8585",
    "name": "Jadhav Suresh Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11819",
    "name": "Gram Vikas Samity Guda Endla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1089",
    "name": "Gujar Shamrao Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1994",
    "name": "Bhoite Sahebrao Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9956",
    "name": "Choudhari Laxman Babraji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8421",
    "name": "Purohit Manoharsingh Laxmansingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9659",
    "name": "Jain Sagarmal Chunnilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14069",
    "name": "Shaikh Insafali M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11025",
    "name": "Kothari Dhanraj Ratanprakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11200",
    "name": "Bhosale Narayan Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4797",
    "name": "Nalawade Bhikoba Dnyanoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11026",
    "name": "Kothari Dhanraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11023",
    "name": "Kothari Dineshkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11024",
    "name": "Kothari Pistadevi Dhanraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11021",
    "name": "Ratanprakash Dineshkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2581",
    "name": "Jagdale Janabai Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11710",
    "name": "Jain Shakuntala R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6702",
    "name": "Wagh Prakash Sidaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3607",
    "name": "Shinde Namdeo Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13184",
    "name": "Dubey Shailesh Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11595",
    "name": "Tondwalkar Jitendra Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "6",
    "name": "Variar Krishna Kunjan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11865",
    "name": "Mishra Bhagwatprasad M"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "2",
    "name": "Shyam Sripat Shinde"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17364",
    "name": "Deshmukh Sitaram Narayan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3072",
    "name": "Ethape Ramchandra Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11895",
    "name": "Pisal Bhagwan Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9968",
    "name": "Varadkar Aarati Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5042",
    "name": "Teja Kisan Raika"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4703",
    "name": "Shinde Balaso Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5042",
    "name": "Ghag Balkrishna Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8735",
    "name": "Aagarwal Rajkumar R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11166",
    "name": "Shah Pravinkumar Lalchandji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16273",
    "name": "Shinde Sunil Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4497",
    "name": "Bhosale Raghunath Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "988",
    "name": "Chaturvedi Ramnarayan P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1226",
    "name": "Hande Santosh Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1261",
    "name": "Gawade Dharmaji Baba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11366",
    "name": "Ram Nuneshwar Chintaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10476",
    "name": "Agarwal Sureshkumar P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11644",
    "name": "Punamiya Naveen M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13722",
    "name": "Pal Ramaasare Tulsiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12057",
    "name": "Chawan Shankar Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8758",
    "name": "Bhoite Mukund Marutirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9443",
    "name": "Arora Milan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5023",
    "name": "Hinukale Bandu Ranu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16732",
    "name": "Kadge Meena Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4793",
    "name": "Shinde Madhav Devaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13299",
    "name": "Suryawanshi Aashru Mujabhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17409",
    "name": "Sutar Jogaram Keshaji  Huf"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12668",
    "name": "Daniya Praveenkumar Premsingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11027",
    "name": "Kothari Nirmaladevi Ratanprakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "788",
    "name": "Jadhav Nivrutti Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4955",
    "name": "Shirke Popat Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4188",
    "name": "Achrekar Balkrishna Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "33",
    "name": "Shibe Sakharam Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17283",
    "name": "Ramprakash Sampati Pal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11054",
    "name": "Sharma Shantibai Meghraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17288",
    "name": "Satam Krishnakant Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15900",
    "name": "Gundge Dyndeo Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8785",
    "name": "Wayal Haribhau Murlidhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8738",
    "name": "Sharma Shankarlal Shubhkaranji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13487",
    "name": "Harijan Dnyandas Rampati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8777",
    "name": "Shirobiya Rajendra Hunnilalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7306",
    "name": "Khanekar Bhagwan Limbaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8613",
    "name": "Dhobale Babaji Thakaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16813",
    "name": "Dhoot Manish Ramkishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16812",
    "name": "Ladhar Rakesh Bhawarlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9403",
    "name": "Jain Anjana Chandulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14003",
    "name": "Parab Aashish Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12919",
    "name": "Harijan Matidevi Keshavram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9793",
    "name": "Kanse Dilip Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4714",
    "name": "Salunkhe Sarjerao Khenu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18407",
    "name": "Chaurasiya Sureshkumar Teju"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3923",
    "name": "Ghorpade Laxman Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9642",
    "name": "Sonpal Vijay Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11538",
    "name": "Dak Suresh M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3706",
    "name": "Bhoite Ramchandra Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17317",
    "name": "Lobo Neillson Silvester"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15457",
    "name": "Raval Lalita Shivram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6567",
    "name": "Hait Robin Aswini"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10130",
    "name": "Jain Lalita Naresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9524",
    "name": "Jain Anraj L"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3390",
    "name": "Gramastha Mandal Wakhamwadi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9001",
    "name": "Bali Sunil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14189",
    "name": "Barai Mukhalal Saitu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4950",
    "name": "Deshamukh Shankar Dattatraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16568",
    "name": "Joshi Ashok Shankarlal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11097",
    "name": "Pagade Tukaram Ragho"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "1022",
    "name": "Gade Rajaram Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14235",
    "name": "Kumbhar Pancham Ramdulare"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "429",
    "name": "Salunkhe Kashinath Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "129",
    "name": "Nikam Shamrao Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4306",
    "name": "Chawan Dnyanu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "106",
    "name": "Mane Vilas Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17951",
    "name": "Verma Lalu Bhagant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13530",
    "name": "Kakade Rahul Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14267",
    "name": "Sawant Vijay Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14070",
    "name": "Naik Brenda Nitin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14667",
    "name": "Shibe Sakharam Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10858",
    "name": "Deshmukh Chandrakant Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2561",
    "name": "Landage Vishnu Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "638",
    "name": "Shingan Shankar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13177",
    "name": "More Suresh Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14709",
    "name": "Prajapati Ramesh Kumar Hemaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9861",
    "name": "Jina Bhoga Wadi Vyapar Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3681",
    "name": "Jadhav Namdeo Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13080",
    "name": "Zagade Sunil Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3773",
    "name": "Disale Vitthal Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11454",
    "name": "Jain Sureshkumar C"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15657",
    "name": "Mane Balasaheb Ganpati."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "131",
    "name": "Malusare Baban Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11362",
    "name": "Hegde Shekhar Shivappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5608",
    "name": "Ranka Shantilal V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12602",
    "name": "Salunkhe Manda Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1911",
    "name": "Maharashtra Rajya Kagad & General K U"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14374",
    "name": "Jaiswal Hrudayram Ramlaut"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4543",
    "name": "Godambe Somaji Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "125",
    "name": "Purandare Digambar Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13607",
    "name": "Gupta Dnyaneshwar Ramlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5914",
    "name": "Purohit Kantilal Kesharamji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12058",
    "name": "Kakad Market Sarvajanik Ganeshotsav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3006",
    "name": "Bandal Uttam Nanasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "208",
    "name": "Sayyed Hussain Sultan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7715",
    "name": "Pal Rajnarayan Rambodh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12728",
    "name": "Jain Sangeeta Mishrimal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "899",
    "name": "Shingan Ganpat Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14553",
    "name": "Aamberkar Tushar Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4844",
    "name": "Shingan Mahadeo Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1553",
    "name": "Kamble Sujata Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9076",
    "name": "Lavare Shakuntala Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10154",
    "name": "Jain Vimalkumar Sohanrajji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1371",
    "name": "Bobade Baban Gulab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10251",
    "name": "Chalke Kashinath Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13041",
    "name": "Indulkar Prakash Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14402",
    "name": "Shiv Chhatrapati Krida Kala Kendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6005",
    "name": "Yadav Ashok Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8531",
    "name": "Kothari Ratanbai Motilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17353",
    "name": "Jain Yash Shantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10422",
    "name": "Chavan Sandesh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14076",
    "name": "Jain Rinal Mukeshkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12410",
    "name": "Ughade Sandesh Gorakhnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17436",
    "name": "Jadhav Baban Eknath."
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "5",
    "name": "Kundhe Ramnath Sukhdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11298",
    "name": "Falore Ridhkaran Pokarmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8719",
    "name": "Agarwal Chandrika Harish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6548",
    "name": "Sarafdar Baburao Baji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9244",
    "name": "Tikudave Narayan Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14758",
    "name": "Rathod Jitendra Kapoorchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15732",
    "name": "Gariya Nandidevi Darbansingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11701",
    "name": "Jain Sishila Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11277",
    "name": "More Shankar Raghu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14900",
    "name": "Shah Anil Namchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5545",
    "name": "Jain Jayantilal F"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10656",
    "name": "Khande Narayan Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10775",
    "name": "Sakpal Nathu Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4103",
    "name": "Zagde Chandrakant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9965",
    "name": "Chandra Shantidevi Jasaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4873",
    "name": "Ranka Shantilal Walchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6321",
    "name": "Chawan Shankar Krushnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "7",
    "name": "Samuel Jayakumar Ebenever"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8999",
    "name": "Jain Lalita Hirachand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10774",
    "name": "Shetye Umesh Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1684",
    "name": "Pawar Laxman Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5774",
    "name": "Nalawade Sushila Gunwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14458",
    "name": "Sonawane Nandram Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12836",
    "name": "Sawant Vijayashri Shrikant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14556",
    "name": "Gujar Dayaram Jageshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "621",
    "name": "Hawale Baburao Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7217",
    "name": "Disale Dnyandeo Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14463",
    "name": "Mehta Vandana Bhojraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6366",
    "name": "Wagh Tanaji Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5519",
    "name": "Mojar Krushna Ravaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3452",
    "name": "Jagtap Vitthal Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12984",
    "name": "Baghit Jagatsing Dansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4269",
    "name": "Shinde Ramdas Vyankatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8224",
    "name": "Jagtap Dilip Dajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13133",
    "name": "Chawan Laxmibai Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14127",
    "name": "Akerkar Shubhangi Zilu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6561",
    "name": "Shelar Pandurang Dagadoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3737",
    "name": "Matkar Hindurao Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11404",
    "name": "Rohidas Bhagwandas Guman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6080",
    "name": "Gaikwad Ganpat Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9774",
    "name": "Jain Ashok Kumar M."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7588",
    "name": "Nikam Bhagwat Galagu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16898",
    "name": "Todkar  Ranjana  Ashok ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3903",
    "name": "Bhagwat Narayan Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2998",
    "name": "Chawan Tukaram Narayan Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8177",
    "name": "Agrawal Sitaram Jagdishprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8874",
    "name": "Bhoite Udhavrao Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8105",
    "name": "Kudale Bajrang Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3516",
    "name": "Gaikwad Suresh Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17705",
    "name": "Pansare Vandana Devdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4214",
    "name": "Gaikawad Pandurang Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "330",
    "name": "Suryawanshi Subhash Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6935",
    "name": "Jain Bhavri Ambalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9362",
    "name": "Jain Prakash Kumar Chunilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6085",
    "name": "Ranka Vimalchand Mohanraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15017",
    "name": "Kayandekar Sunil Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6356",
    "name": "Jain Indraben Shantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6594",
    "name": "Behal Shivkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1344",
    "name": "Dhumal Ramchandra Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16716",
    "name": "Shinde Anusaya Sarjerao."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13801",
    "name": "Gawade Subhash Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15528",
    "name": "Shivle Rohinee Devram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17153",
    "name": "Jaiswal Vrajlal Chanku."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5905",
    "name": "Raika Kisan Kesaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11561",
    "name": "Jain B P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9069",
    "name": "Gaikwad Gulab Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6260",
    "name": "Shedge Dagadu Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11398",
    "name": "Yadav Kesharinandan Ramkaran"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13810",
    "name": "Gavkar Kantikumar Raoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15398",
    "name": "Jain Seema Upendra."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10539",
    "name": "Jain Mohanlal S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12733",
    "name": "Jain Urmila Bhawarlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4845",
    "name": "Chawan Tukaram Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "10046",
    "name": "Mohite Raghunath Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5063",
    "name": "Disale Ramchandra Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11291",
    "name": "Agrawal Nikita D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5022",
    "name": "Ghadage Pratap Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6457",
    "name": "Jadhav Laxman Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10131",
    "name": "Jain Naresh Sagarmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "30",
    "name": "Kalantre Jagnnatah Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12382",
    "name": "Yadav Motilal Sarju"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "1",
    "name": "Purchase&Supply Officersilvassa A/C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11456",
    "name": "Jain Chandulal C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "702",
    "name": "Chavan Pandurang Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "10058",
    "name": "Rajbhar Shardaprasad Shivnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14293",
    "name": "Jadhav Baban Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17230",
    "name": "Balaji Group."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5353",
    "name": "Mandhare Narayan Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6571",
    "name": "Jain Manikchand Babulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1853",
    "name": "Dere Bhagatsing Parbatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7658",
    "name": "Chandak Vidya Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14754",
    "name": "Malkan Jagdish D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "886",
    "name": "Pande Vinayak Bholanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9325",
    "name": "Ghorapade Arvind Amruta"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13695",
    "name": "Sawant Rajendra Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12527",
    "name": "Shramik Niwas Uttsav Mandal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16251",
    "name": "Maharashtra Yuva Pratisthan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "522",
    "name": "Khandekar Kondiba Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6887",
    "name": "Purohit Vijay Raj Bhalagi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6055",
    "name": "Temkar Shankar Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16670",
    "name": "Mohite Deepak Vishnu."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8046",
    "name": "Dhumal Sadashiv Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11515",
    "name": "Bafna Mahavir J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13918",
    "name": "Jathar Pratibha Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15047",
    "name": "Sacheti Nidhi Seemant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14458",
    "name": "Kumbhar Shriram Prabhu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8011",
    "name": "Zanwar Vidya Ghanshyamdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5250",
    "name": "Jain Shakuntala Kumari A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8739",
    "name": "Chindak Shobhadevi Satyanarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4616",
    "name": "Ghodekar Sadashiv Balaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15461",
    "name": "Jagadale Bhiku Janu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16043",
    "name": "Shirke Supriya Sanjay."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18978",
    "name": "Chinchkar Pradip Murlidhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "3169",
    "name": "Lohana Kantilal Ambalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17162",
    "name": "Naik Sundar Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16355",
    "name": "Lalitkumar Roopchandji Ranka H.U.F."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5760",
    "name": "Jagani Dayalal Khusalkhand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16780",
    "name": "Parkale Dilip Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1948",
    "name": "Bhoite Jaywant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13861",
    "name": "Yadav Phoolcharan Keshari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5626",
    "name": "Waghmale Pandurang Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16890",
    "name": "More Balu Narayan    393/72"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12636",
    "name": "Gaikwad Santosh Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10597",
    "name": "Bhati Bhavesh B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10596",
    "name": "Bhati Naresh B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7792",
    "name": "Mehta Sheetal B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4330",
    "name": "Phalake Anil Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3039",
    "name": "Someshwar Navtarun Mandal Mumbai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15398",
    "name": "Yadav Waman Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12566",
    "name": "Jain Vilash Rajesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "579",
    "name": "Bhosale Mansingh Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10578",
    "name": "Kadam Laxman Devji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3674",
    "name": "Gori Kalu Abdula"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2018",
    "name": "Thorat Maruti Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3",
    "name": "Bandal Shilpa Digambar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15187",
    "name": "Jain Savita Jaichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "869",
    "name": "Shri Jain Veer Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8065",
    "name": "Hanuman Mandir Jirnodaar Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3307",
    "name": "Nanaware Amruta Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9747",
    "name": "Sidhwani Mamta Anilkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8291",
    "name": "Jogani Lilaben Tokarbhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1129",
    "name": "Vakate Raghunath Chimaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6998",
    "name": "Maharugade Bajirao Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "483",
    "name": "Kalokhe Shankar Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2758",
    "name": "Ghorpade Namdeo Dadasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "265",
    "name": "Rajbhar Ramasharay Lalli"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11455",
    "name": "Jain Fulchand C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10657",
    "name": "Nawal Rameshchand O"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "477",
    "name": "Dharmal Bandu Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10227",
    "name": "Gundage Vijay Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "668",
    "name": "Harijan Bindeshwariprasad Jogiprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10663",
    "name": "Chavan Sunita Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3459",
    "name": "Pokale Sunita Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12724",
    "name": "Shinde Suresh Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "9",
    "name": "Monde Lahuraj Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11029",
    "name": "Rathod Sangeeta Kapoorchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11721",
    "name": "Sinh Radheshyam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13840",
    "name": "Jagtap Sahadeo Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9718",
    "name": "Shah Mita Hitendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3723",
    "name": "More Parasram Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4587",
    "name": "Patil Ramchandra Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11579",
    "name": "Jogater Nishaben Shaileshkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "4477",
    "name": "Jaiswal Chotalal Gadur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4570",
    "name": "Salwi Ramchandra Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5226",
    "name": "Dhavle Ratnabai Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "4086",
    "name": "Ombale Sham Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "3955",
    "name": "Waghmare Sampat Dyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18722",
    "name": "Padval Nalini Madhusudan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12072",
    "name": "Sharma Agarchand Udaychandji"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "207",
    "name": "Urankar Prabhakar R./& Mohan B. Dhekhne"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9703",
    "name": "Dhanresha Anita Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8303",
    "name": "Salunkhe Sahebrao Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8050",
    "name": "Ahire Suman Nanasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15939",
    "name": "Printer Tehmasp Nariman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11063",
    "name": "Misra Poonam Premnarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5350",
    "name": "Ghorpade Krushna Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12479",
    "name": "Jagtap Hanmant Vasantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11560",
    "name": "Jain V P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "2563",
    "name": "Mahadik Baou Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16942",
    "name": "Surve  Sachin  Dadaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7330",
    "name": "Bhosale Shankar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16110",
    "name": "Yadav Ramsaran Motilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1988",
    "name": "Pathan Mohamad Idris"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12660",
    "name": "Dangra Kalawati K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10537",
    "name": "Patil Jalindar Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1468",
    "name": "Sankpal Jagannath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2928",
    "name": "Nikam Subhedar Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "471",
    "name": "Mahadik Bapu Balvant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4919",
    "name": "Jadhav Shripati Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9421",
    "name": "Dhruv Dilip Krishnalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13164",
    "name": "Khanvilkar Anita Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8675",
    "name": "Somnath Dilip Babubhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "541",
    "name": "Dhanavade Genba Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12160",
    "name": "Dhamal Anandrao Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13196",
    "name": "Khanvilkar Lata Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "409",
    "name": "Raje Dattoba Ranoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9241",
    "name": "Pawar Chandrakant N"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "607",
    "name": "Gharpe Ashok Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "4576",
    "name": "Mane Dattatray Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "4533",
    "name": "Karpe Krushna Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8996",
    "name": "Jain Dinesh Kumar Devraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "4380",
    "name": "Kadam Arun Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7089",
    "name": "Padawal Ananta Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "4224",
    "name": "Kadam Laxman Devji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "4200",
    "name": "Kende Kailash Dyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "4167",
    "name": "Gaikwad Ramchandra Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "4039",
    "name": "More Vijay Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11564",
    "name": "Jain Pinky P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10391",
    "name": "Kalantre Mahipati Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16011",
    "name": "Shiwaldas & Others Building Repair Fund"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10146",
    "name": "Pisal Hanmant Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "3858",
    "name": "Agrawal Sonu H."
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "3856",
    "name": "Agrawal Swati H."
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "3857",
    "name": "Agrawal Sweta H."
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "3859",
    "name": "Agrawal Vijay H."
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "3855",
    "name": "Dharmesh Agrawal Piyush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5771",
    "name": "Bodake Bapurao Malhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "3503",
    "name": "Sawant Manik Kondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12723",
    "name": "Chaudhari Ramkishan Magare"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6943",
    "name": "Mohite Balwant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11022",
    "name": "Kothari Ratanprakash Dhanraj"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "10020",
    "name": "Jivdani Krupa General Stores"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14051",
    "name": "Harijan Dhanraj Biraja"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "3337",
    "name": "Bastikar Supriya Shrilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7145",
    "name": "Khopade Balu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "2814",
    "name": "Kadam Shivaji Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "2793",
    "name": "Lawale Jalindar Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3124",
    "name": "Jain Arvindkumar M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7983",
    "name": "More Ramchandra Bapuso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18259",
    "name": "Phanse Chainoba Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "273",
    "name": "Salate Dattu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10864",
    "name": "Jain Ramesh Devichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1467",
    "name": "Gade Hanmant Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "1",
    "name": "Karegaon Taluka Samaj Seva Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5433",
    "name": "Phalke Gulabrao Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1761",
    "name": "Shevale Mohan Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "957",
    "name": "Supe Shankar Kondaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11799",
    "name": "Singapuri Bldg.Bhadut Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4468",
    "name": "Barge Dattajirao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8301",
    "name": "Tiwari Mayashankar Jainath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2857",
    "name": "Bhosale Sadashiv Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1818",
    "name": "Chavan Vithal Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13818",
    "name": "Kadam Geetabai Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16891",
    "name": "Pawar Sudhakar Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17120",
    "name": "Nate Anand Madhavrao."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15895",
    "name": "Thik Shalabai Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9567",
    "name": "Pawar Sharad Shivajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "3568",
    "name": "Kondvilkar Samita Sandesh."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16168",
    "name": "Yadav Gyanpatta Baliram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10108",
    "name": "Solanki Hastimal S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11338",
    "name": "Shri Kapad Bazar Maratha Kamgar Mandal U"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12758",
    "name": "Parab Siddhesh Santosh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7213",
    "name": "Chikane Ganesh Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13197",
    "name": "Harijan Shivharsh Ramcharan"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "1645",
    "name": "Shinde Sanjay Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10061",
    "name": "Shaikh Mohammad Amjad"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "1457",
    "name": "Gaikwad Uddhav Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13372",
    "name": "Harijan Jagdishprasad Ramnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10066",
    "name": "Chawan Shankar Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4178",
    "name": "Martand Malari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9458",
    "name": "Mulchandani Ishwar H"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7507",
    "name": "Narvekar Sumitra Sadanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "10007",
    "name": "Urankar S.N. Dhekne M. B. Urankar P.R."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10721",
    "name": "Yadav Aatmaram Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13368",
    "name": "Jain Panibai V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8039",
    "name": "Gandhi Mansi Pradeep Kumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10567",
    "name": "Yadav Harilal Sarju"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14610",
    "name": "Shah Deepti Atul"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "1051",
    "name": "Nibad Savitri S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7610",
    "name": "Salunkhe Gajanan Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8675",
    "name": "Ghag Aasha Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5776",
    "name": "Jain Prakash S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12300",
    "name": "Chheda Bipin Damji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11056",
    "name": "Sharma Meghraj Udaybhanji"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "10177",
    "name": "Murkute Ramesh Yashwantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15702",
    "name": "Jain Kapoorchand Hastimal[Huf]"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5652",
    "name": "Holkar Balasaheb Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6859",
    "name": "Jain Chandanbala Sakalchand"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "3570",
    "name": "Kondawilkar Harshala Sandesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14840",
    "name": "Sutbazar Nakhodastreet Tempo Malak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5564",
    "name": "Pujari Nivrutti Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9696",
    "name": "Shah Pinkesh Kumar R."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11249",
    "name": "Malpote Shankar Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12738",
    "name": "Jain Shital Shantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5836",
    "name": "Jain Suresh Kumar Sagarmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "2",
    "name": "Karle Chandrabhaga Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16248",
    "name": "Poojary Bhaskar  Suba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5865",
    "name": "Salvi Pranay Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15005",
    "name": "Patade Nilesh Sadanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3724",
    "name": "76 Telgally Bhadut Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10625",
    "name": "Jain Asmukhlal Babulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10697",
    "name": "Chandak Gopal S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14689",
    "name": "Bafna Jayantilal G"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10857",
    "name": "Changoiwala Mahesh Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13183",
    "name": "Jaiswal Thakurprasad Zangar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10108",
    "name": "Mahadik Tulsiram Amrut"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2",
    "name": "Satara Dist Pragati Mahamandal Bombay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5055",
    "name": "Shinde Vasant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9457",
    "name": "Mulchandani Ashok Kumar H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8718",
    "name": "Agarwal Kiran Dharmesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11050",
    "name": "Singhvi Sandeep N"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "10007",
    "name": "Bubere Ridhavan Anavar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16535",
    "name": "Bhor Jayashree Krushnakumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15465",
    "name": "Shelar B.K. & Kadam B G. & Shelar V. S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15353",
    "name": "Parab Shridhar Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10571",
    "name": "Jai Bharat Rashtriya Shramik Sangh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15502",
    "name": "Pawar Yadavrao C.& Sunita Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "979",
    "name": "A K Synthetics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2463",
    "name": "A R V I N D   E N T E R P R I S E S ."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "319",
    "name": "A. S. Construction"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1695",
    "name": "A.K. Trading Corporation"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "64",
    "name": "A.R.Traders ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18918",
    "name": "Pachupate Atmaram Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8490",
    "name": "Dhumal Dharmraj Sarjerao"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "71",
    "name": "Aastha Home"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2268",
    "name": "Aayushi Textiles (Packing)"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1397",
    "name": "Abhishek Enerprises."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1205",
    "name": "Adinath Computers"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "20",
    "name": "Adinath Kirana General Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1796",
    "name": "Adreshwar Transport Service"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "244",
    "name": "Agrawal Stores"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3769",
    "name": "Ajamera  Chandrakant  J"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3523",
    "name": "Ajay Associates"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3289",
    "name": "Ajay Kailaschandra Kanodi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "140",
    "name": "Ajay Sales"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "224",
    "name": "Ajinkya Milk Can"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "408",
    "name": "Ajit Travels"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4412",
    "name": "Alvi Enterprises"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2218",
    "name": "Amar Deep Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "283",
    "name": "Amar Rubber Works"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "160",
    "name": "Amar Shrirang Jadhav"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3118",
    "name": "Amarlal & Sons"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1402",
    "name": "Ambika Polyblend"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2560",
    "name": "Ambika Trading Co"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "80",
    "name": "Amey Estate Consultant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2167",
    "name": "Anand Daily Service"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "163",
    "name": "Anand Industries"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3243",
    "name": "Anant Dhondu Shinde"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "877",
    "name": "Anant Printing Press"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2370",
    "name": "Aniket Enterprises."
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "223",
    "name": "Ankul Netwark"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "38",
    "name": "Anmol Collection"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "103",
    "name": "Anuradha Enterprises"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "115",
    "name": "Arbuda Logistics"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "523",
    "name": "Arman Traders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "925",
    "name": "Arun Decorators"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1759",
    "name": "Asf Automobile."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "221",
    "name": "Ashar Assocites ."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "817",
    "name": "Ashish Enterprises"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "68",
    "name": "Ashtavinayak Transport"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4514",
    "name": "Ashtivinayak Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1317",
    "name": "Ashwini Transport Service"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1868",
    "name": "Asmita Prints"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "962",
    "name": "Associated Civil Engineers"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "95",
    "name": "Atul Traders"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1938",
    "name": "Aum Construction Co."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1785",
    "name": "Avenue Corporation."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1381",
    "name": "B S Enterprise"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "124",
    "name": "B S International"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3164",
    "name": "B.K.Distributers"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "803",
    "name": "B.K.Sawant"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "215",
    "name": "B.N.&Bros"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3373",
    "name": "Bafna Ramesh Phaoolal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2209",
    "name": "Baheti Tex"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1220",
    "name": "Balaji Decorators"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1922",
    "name": "Balaji Developers"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "221",
    "name": "Balaji Scrap Traders"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "213",
    "name": "Balaji Trading Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4226",
    "name": "Banjara Vikas Samiti"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1225",
    "name": "Best Marketing&Advertising Agency"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "156",
    "name": "Bhairav Textiles"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "168",
    "name": "Bhairavnath Kirana Stores"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4343",
    "name": "Bhakti  Enterprise"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3591",
    "name": "Bhaktwarmal Roopchand Bapna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20919",
    "name": "Ahire Vilas Runjaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20397",
    "name": "Akare Ganesh Harishchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21295",
    "name": "Ambekar Pankaj Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21151",
    "name": "Anthoni Joseph Channappaa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20911",
    "name": "Atpadkar Hindurao Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21029",
    "name": "Attar Mohammad Rafik Yusuf"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21027",
    "name": "Avate Dattatray Mahatarba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21352",
    "name": "Babar Sambhaji Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21243",
    "name": "Babar Sanjay Balkrushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21101",
    "name": "Badekar Tanaji Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20915",
    "name": "Bansode Sharad Saybu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21495",
    "name": "Belose Ravindra Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20908",
    "name": "Bhagyawant Ganesh Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14634",
    "name": "Bhalghare Sureka Balvant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15793",
    "name": "Bhilare Manisha Pravin."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21091",
    "name": "Bhise Deepak Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21039",
    "name": "Bhise Shrirang Aaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21347",
    "name": "Bhogale Ganesh Vasudev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20335",
    "name": "Bhoir Basant Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21034",
    "name": "Bhosale Shrikrushna Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20399",
    "name": "Bhosale Vasant Vishnu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14243",
    "name": "Bhuwad Sudhakar Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21083",
    "name": "Borade  Ashok Babanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21212",
    "name": "Borade Ram Kundlik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21156",
    "name": "Botalaje Anil Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20916",
    "name": "Chandenshive Mukind Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21491",
    "name": "Chaturvedi Suryakant Sambhajit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20918",
    "name": "Chaube Jitendranath Divakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20369",
    "name": "Chavan Amir Harichandra."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21055",
    "name": "Chavan Satish Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22120",
    "name": "Chavan Shradha Balasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20126",
    "name": "Chavan Sunil Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20906",
    "name": "Chawan Rajesh Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21062",
    "name": "Choudhari  Satyey   Jayavant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20963",
    "name": "Darvesh Kamrudin Ismil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12490",
    "name": "Deorukhakar Sunil Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21350",
    "name": "Desai Sudhir Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21089",
    "name": "Deshmukh Mangesh Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11886",
    "name": "Deshmukh Sunil Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20875",
    "name": "Dhiver Devdas Manik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19351",
    "name": "Dhumal Chhagan Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14682",
    "name": "Dhumal Usha Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "359",
    "name": "Dhuri Laxman Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20921",
    "name": "Dube Deviprasad Hariharnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20604",
    "name": "Dubey Shivba Li Thakurprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21496",
    "name": "Dudhwadkar Vishvnath Janardhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20937",
    "name": "Dukare Pandurang Natha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20923",
    "name": "Gaikwad  Dattaram Dagdu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21493",
    "name": "Gaikwad Chandrakant Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20925",
    "name": "Gaikwad Suryakant Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20332",
    "name": "Gaikwad Vasant Atamaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21119",
    "name": "Gaikwad Vasant Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2117",
    "name": "Bharat Apparels"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1171",
    "name": "Bharat Chemical"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "306",
    "name": "Bharat Deep Industries ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1999",
    "name": "Bharat Emporium"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20873",
    "name": "Gamare  Baban Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1910",
    "name": "Bharat Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20996",
    "name": "Gamare  Digvijay Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20998",
    "name": "Gamre Ashok Bhiva"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19443",
    "name": "Gamre Jayant Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21210",
    "name": "Gamre Madhukar Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16585",
    "name": "Gawade Vijaya Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21076",
    "name": "Gazar Mahesh Visanji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21351",
    "name": "Ghadge Ramrao Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21060",
    "name": "Ghag  Vinayak   Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21084",
    "name": "Ghagare Dasharath Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21147",
    "name": "Gherade Sauba Dyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21335",
    "name": "Ghode Baban Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20956",
    "name": "Ghone Dilip Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16071",
    "name": "Goyal Savita Damu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21227",
    "name": "Gujeriya Shamaji Mashree"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16922",
    "name": "Gurav Narendra Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21509",
    "name": "Hule Diwakar Sahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21247",
    "name": "Husen Mehtab Shahjad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21077",
    "name": "Jadhav Mahendra Yaswant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20962",
    "name": "Jadhav Mukund Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21042",
    "name": "Jadhav Nivruti Shakarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21209",
    "name": "Jadhav Prakash Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3394",
    "name": "Bharti Packing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21131",
    "name": "Jadhav Sanjay Shridhar ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21002",
    "name": "Jadhav Siddharth Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6072",
    "name": "Jadhav Vijaya Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20931",
    "name": "Jagdale Gajanan Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21208",
    "name": "Jagtap Anand Pandhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21211",
    "name": "Jagtap Kachru Nagesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21040",
    "name": "Jagtap Satishkumar Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4244",
    "name": "Jain Chogibai Fulchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13689",
    "name": "Jambukar Bharat Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19638",
    "name": "Jambulkar Mukund Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19376",
    "name": "Joeph Britto Panniyal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21418",
    "name": "Jogdiya Babu Danaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20277",
    "name": "John  D`Costa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18656",
    "name": "John  Yashudas Yammal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21063",
    "name": "Kadam  Santosh  Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12455",
    "name": "Kadam Ankush Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21159",
    "name": "Kadam Ashok Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20994",
    "name": "Kadam Attamaram Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21348",
    "name": "Kadam Kishor Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20934",
    "name": "Kadam Ravindra Kamlakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21155",
    "name": "Kadam Ravindra Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20455",
    "name": "Kale Namrata Rakesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21269",
    "name": "Kambale Adesh T Olya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21158",
    "name": "Kambale Ananda Gundu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21257",
    "name": "Kambale Chandrakant Bhimrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21268",
    "name": "Kambale Ekanath Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21078",
    "name": "Kamble Arvind Raosaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21025",
    "name": "Kamble Jayvant Vishram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20924",
    "name": "Kamble Prabhakar Malahari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21118",
    "name": "Kamble Prakash Ramu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21100",
    "name": "Kamble Shashikant Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21036",
    "name": "Kamble Sumesh Jagnnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21092",
    "name": "Kamble Sunil Vishram ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21057",
    "name": "Kamble Suresh Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21166",
    "name": "Kanijiya Mukesh Mevalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17362",
    "name": "Karagutkar Jaymala Kamalakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6617",
    "name": "Katakar Sharad Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20989",
    "name": "Khadwal Balachand Laxuman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20936",
    "name": "Khaire Vilas Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20961",
    "name": "Kharare Pandurang Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21154",
    "name": "Kharat Dattaram Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20997",
    "name": "Kharat Dayanand Lala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21026",
    "name": "Khedekar Sainath Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21290",
    "name": "Kokate Ajit Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20905",
    "name": "Kubal Jayant Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19882",
    "name": "Kumbhar Vinyak Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13443",
    "name": "Kuveskar Sudesh Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21132",
    "name": "Lad Suryakant Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17339",
    "name": "Lad Vaishali Kamalakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21258",
    "name": "Lallan Gulab Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20926",
    "name": "Langi Subash Posha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20990",
    "name": "Madavi Rajesh Harkishan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21058",
    "name": "Madne Aappa Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14802",
    "name": "Mahadeshwar Vijay Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21071",
    "name": "Mahadik Dilip Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21003",
    "name": "Mahadik Sudhakar Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20330",
    "name": "Mahajan Subhash Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21149",
    "name": "Mahamuni Ravindra Mohanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16092",
    "name": "Mahindrakar Nishant Laxman."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21035",
    "name": "Majrekar Vivek Vidhyadhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21224",
    "name": "Makawana Hiralal Jethalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21087",
    "name": "Makwan Suresh Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20603",
    "name": "Mali  Rajkumar Shyamkishor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20398",
    "name": "Mandhavi Kirit Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16753",
    "name": "Mane Ananda Tayappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21134",
    "name": "Mane Shankar Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15564",
    "name": "Mane Swati Viveknand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20995",
    "name": "Mankar Samir Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20907",
    "name": "Mestry Santosh Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21108",
    "name": "Mhatre Motiram Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21157",
    "name": "Mishra Tarakeshwar Ramyadnya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20848",
    "name": "Mohite  Ashok   Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21120",
    "name": "Mohite Gauttam Yaswant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17097",
    "name": "Mohite Nanda Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21271",
    "name": "Mohite Prakash Yashvant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20933",
    "name": "Mohite Pravin Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20876",
    "name": "Mohite Sangam Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21074",
    "name": "Mohite Sanjay Bhudhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21164",
    "name": "Mohite Sanjay Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20909",
    "name": "More Arun Krushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21239",
    "name": "More Paresh Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21075",
    "name": "More Subhash Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20932",
    "name": "Mudle Bhimrao Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20914",
    "name": "Nagarkar Prabhakar Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21037",
    "name": "Naik Rajaram Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21031",
    "name": "Nikam Arjun Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21336",
    "name": "Ohavhal Sanjay Sudam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21245",
    "name": "Padale Gautam Chhagan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21094",
    "name": "Padave Balkrishnan Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20322",
    "name": "Pai Shankar Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20910",
    "name": "Palande Eaknath Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21237",
    "name": "Panchamsingh Rajendraprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20920",
    "name": "Parab Balkrushna Appa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21270",
    "name": "Parab Prakash Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21056",
    "name": "Parab Ravindra Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12676",
    "name": "Parab Rupali Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21165",
    "name": "Paradhan Vaibhav Nandkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20960",
    "name": "Parve Ramesh Jagnnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4262",
    "name": "Bhavesh Prakash Pabari"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1797",
    "name": "Bhavna Interiors"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17413",
    "name": "Patel Dinesh Venibhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21242",
    "name": "Patil Dattatray Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20935",
    "name": "Patro Pramod Gourang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20955",
    "name": "Pawar Madhukar Jaywant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18125",
    "name": "Pawar Narendra Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15189",
    "name": "Pawar Ramakant Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21291",
    "name": "Pawar Ramesh Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20957",
    "name": "Pawar Shamrao Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21038",
    "name": "Pawar Subash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21238",
    "name": "Pawar Subhash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21168",
    "name": "Pawar Uttam Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4158",
    "name": "Pednekar Raghunath Shau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20120",
    "name": "Phalke Radhabai Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21073",
    "name": "Pilankar Laxman Purshottam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21494",
    "name": "Pille Shivraman T Natrajan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21033",
    "name": "Pol Ganpat Bansi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15106",
    "name": "Pol Sampat Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20912",
    "name": "Puradkar Vijay Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21514",
    "name": "Rajbhar Geetadevi Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19711",
    "name": "Rakte Raju Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20993",
    "name": "Ramane Suresh Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9705",
    "name": "Rane Ratnadeep Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20992",
    "name": "Rasal Manohar Balkrushna ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21072",
    "name": "Rasal Prakash Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20991",
    "name": "Rasam Vijay Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20363",
    "name": "Rathod Chandram Somlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17129",
    "name": "Rode Rajendra Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20756",
    "name": "Rokade Shashikant Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20345",
    "name": "Roy Rajesh Gorakhnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21102",
    "name": "Sable Siddharth Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21059",
    "name": "Sakapal  Santosh   Sonu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21259",
    "name": "Sakpal Ashok Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18026",
    "name": "Sakpal Vijay D"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20325",
    "name": "Salunkhe Bhagwan. Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21054",
    "name": "Salve  Ramesh Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21041",
    "name": "Samudra Anna Dipaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21490",
    "name": "Sanavale Bharat Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21169",
    "name": "Sargar Kerappa Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21128",
    "name": "Sargar Laxman Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21167",
    "name": "Sargar Laxman Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20958",
    "name": "Sathe Subhash Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20361",
    "name": "Sawant  Nandkumartukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21061",
    "name": "Sawant  Vikas   Zipru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16796",
    "name": "Sawant Anil Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21148",
    "name": "Sawant Anil Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12627",
    "name": "Sawant Hanumant Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21349",
    "name": "Sawant Mangesh Jagnnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20727",
    "name": "Sawant Prashant Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21001",
    "name": "Sawant Ramchandra Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18731",
    "name": "Shaikh Momd.Ghouse Momd.Hamid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21043",
    "name": "Shaikh Nisahahmad Ismail"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21150",
    "name": "Sheikh Mohammad Aslam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21133",
    "name": "Sheikh Mohmad Ali Jinu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21030",
    "name": "Shekh Mohammd Ghasi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20927",
    "name": "Shinde Ankush Raghu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21241",
    "name": "Shinde Arjun Bhiva"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20999",
    "name": "Shinde Sanjay Shashikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15499",
    "name": "Shirke Neelam Keshar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21225",
    "name": "Shirsat Rajaram Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9670",
    "name": "Shirshat Hanumant Ganesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21226",
    "name": "Shriram Ravi Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20121",
    "name": "Shukala Rajkumar Ramakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21246",
    "name": "Singh Pavankumar Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20917",
    "name": "Singh Shyamsundar Umashankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21236",
    "name": "Singh Suryaprakash Devendrapratap"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21088",
    "name": "Solanki Dalpat Shiva"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21248",
    "name": "Sonavane Deepak Dagdu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18741",
    "name": "Sonawane Anand Subrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21129",
    "name": "Sonawane Pravin Sawlaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9941",
    "name": "Sudam Bhuvan Utsav Mandal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21240",
    "name": "Surve Milind Rama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21207",
    "name": "Surve Yashwant Bhambu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21085",
    "name": "Suryawanshi Nana Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21292",
    "name": "Syed Iqbal Mohmood"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21064",
    "name": "Tambe  Ramdas   Janardhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18065",
    "name": "Tambe Deepak Tulsiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20913",
    "name": "Tarse Shivaji Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20331",
    "name": "Thakre Shreenath Motiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21213",
    "name": "Thange Ramesh Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2",
    "name": "Tidake  Narendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19782",
    "name": "Tippe Maruti Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21338",
    "name": "Torat Mahadev Bhimrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21053",
    "name": "Ubare Narayan Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17643",
    "name": "Vardekar Ravindra Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10634",
    "name": "Vare Hanumant Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21337",
    "name": "Vartak Pankaj Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20362",
    "name": "Wankhede Babulal Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19545",
    "name": "Yadav Babulnath Kalekhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18951",
    "name": "Yadav Chandrabhan Shriramjeet"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21512",
    "name": "Yadav Dilip Harilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20244",
    "name": "Yadav Kamalashankar Prabhunath."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20959",
    "name": "Yadav Rajbhadur Chandrawali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20323",
    "name": "Yadav Rajkumar Rambahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21028",
    "name": "Yadav Ram Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21272",
    "name": "Yadav Vikash Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21130",
    "name": "Zanje Prkash Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "226",
    "name": "Bhosale Vijay Govindrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4197",
    "name": "Bizworld International."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1066",
    "name": "Brahma Developer Pvt.Ltd"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3477",
    "name": "Bubna Jagdishprasad Saharmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3217",
    "name": "Bubna Pawankumar Jagdishprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4543",
    "name": "Busybee Developers Pvt. Ltd"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2724",
    "name": "C Hiteshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3027",
    "name": "Casino Wines"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2034",
    "name": "Central Mould Make"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4562",
    "name": "Chaitnya Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2281",
    "name": "Chandra Paints"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1523",
    "name": "Chandrakala Agarwal"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "583",
    "name": "Chandrakant Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4253",
    "name": "Chandrama Trader"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3054",
    "name": "Chate Coaching Classes"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1658",
    "name": "Chavan Shrikant Mohan."
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "156",
    "name": "Chavan Transport"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "217",
    "name": "Chetan Farm"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "109",
    "name": "Chetana Transport"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3916",
    "name": "Chodankar Manoj Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3767",
    "name": "Chorge Vijay Ramchandra."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3679",
    "name": "Choudhary  Tarvn"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "40",
    "name": "Crown Telecom"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "293",
    "name": "D.M. Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "741",
    "name": "Daga Textiles Agency"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20762",
    "name": "Aarya Dhirajbhai C."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15839",
    "name": "Advilkar Surendra Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12831",
    "name": "Ambre Sushma Ganesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20887",
    "name": "Bandhaware Vasant Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15454",
    "name": "Belvalkar Rajesh Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "279",
    "name": "Bhagwat Baburao Pandharinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21416",
    "name": "Bhandari Puran Devanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18024",
    "name": "Bhandigare Yogita Shyamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20845",
    "name": "Bhaya Narendra Manilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15975",
    "name": "Bhoite Vandana Ashok."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15873",
    "name": "Bhor Mahendra Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3487",
    "name": "Bhosale Laxman Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20102",
    "name": "Bhosale Mandar Virendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19816",
    "name": "Bhosale Satish Bapusaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18239",
    "name": "Bhosale Tatyaba Jijaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15876",
    "name": "Bhutal Suvarna Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20743",
    "name": "Chavan Nana Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17883",
    "name": "Chavan Ravindra Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16965",
    "name": "Chawan Shivaji Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16581",
    "name": "Chibade Dipali Rambhau."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16338",
    "name": "Chikhale Santosh Vishwanath."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17965",
    "name": "Chindarkar  Rohan Shashikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20005",
    "name": "Dalvi Vilas Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "681",
    "name": "Desai Padmawati Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15987",
    "name": "Desai Sakharam Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19843",
    "name": "Deshmukh Santosh Hanumant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20190",
    "name": "Devalekar Kavita Abhijit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15294",
    "name": "Dhamane Vijay Harichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20329",
    "name": "Dhaske Sindhu Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12258",
    "name": "Dhavan Anant Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20886",
    "name": "Dheb Dhanaji Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1520",
    "name": "Dhule Sharmila Shshikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18222",
    "name": "Dhuri Mahesh Dinanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19536",
    "name": "Dodke Hemant Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18501",
    "name": "Dubey Rameshkumar Bansnarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19518",
    "name": "Dubey Trimbaknath Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16923",
    "name": "Farade Vinod Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16601",
    "name": "Farnandis Rocky Maxi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20191",
    "name": "Gaikawad Sachin Ashoka"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20744",
    "name": "Gaikwad Vithal Kakaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20752",
    "name": "Gajarmal Mangesh Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12104",
    "name": "Gaonkar Chandrakant Ravji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20748",
    "name": "Gavli Sandeep Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17296",
    "name": "Gawade Minesh Krishna."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11581",
    "name": "Ghadage Ravikant Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13378",
    "name": "Ghangale Mahendra Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14705",
    "name": "Ghatkar Sunita Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13731",
    "name": "Ghosalkar Rekha Yashwamt"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20882",
    "name": "Gole Shivaji Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20817",
    "name": "Gore  Vijay   Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15711",
    "name": "Gorivale Mahesh Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18401",
    "name": "Gosavi Vaishali Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19048",
    "name": "Goswami Sabhajit Shivnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11489",
    "name": "Gujar Nivruti Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15584",
    "name": "Gupta Chandni Ratan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18728",
    "name": "Gupta Kailashchandra Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7325",
    "name": "Gurav Ram Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19875",
    "name": "Hule Prakash Venunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17182",
    "name": "Ingulkar Bhiku Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17565",
    "name": "Jadhav Arvind Anita"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13989",
    "name": "Jadhav Ashok Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18323",
    "name": "Jadhav Chandrakant Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6758",
    "name": "Jadhav Mahadev Pujaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15424",
    "name": "Jadhav Nirmala Keru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18060",
    "name": "Jadhav Shashikant Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20883",
    "name": "Jadhav Suresh Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17464",
    "name": "Jadhav Vilasrao Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7314",
    "name": "Jagdale Jagannath Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6079",
    "name": "Jagtap Sanjay Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14946",
    "name": "Jain Seema Nathmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20851",
    "name": "Jaiswal  Shriram  Bansraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19318",
    "name": "Jaiswal Arvind Laltaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19347",
    "name": "Jha Parshuram Upendra  Mh-02-Sa.7876"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12190",
    "name": "Joshi Chandrashekar Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15979",
    "name": "Kadam Genu Ranu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15822",
    "name": "Kadam Hanmant Dnanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19610",
    "name": "Kadam Mohan Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20747",
    "name": "Kadam Santosh Bhagoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8463",
    "name": "Kakade Gulab Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15514",
    "name": "Kale Pramod Bapurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20849",
    "name": "Kamble  Madhukar   Amruta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8245",
    "name": "Kamble Sanju Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16490",
    "name": "Kambli Abhijit Vinayak."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16029",
    "name": "Kashid Arun Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18235",
    "name": "Khalde Yogesh Dnyaneshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20804",
    "name": "Khan Ashapak Ahamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16887",
    "name": "Khare Dilip Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14587",
    "name": "Khedekar Sonali Sunil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20794",
    "name": "Khond  Abhijeet  Sadanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14759",
    "name": "Kirve Bharati Satish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16463",
    "name": "Kokate Sharad Bhimaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20813",
    "name": "Kulal Balwant Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4919",
    "name": "Kumawat  Bhagwansahai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3859",
    "name": "Kumbhar Gopal Sing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7288",
    "name": "Kusum"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17813",
    "name": "Lipare Sanjit Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19035",
    "name": "Mahajan Kalyan Ganapat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14645",
    "name": "Mahindrakar Laxman Vasudev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20745",
    "name": "Malkar Rajaram Nilu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13624",
    "name": "Malkar Vijay Jiji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2376",
    "name": "Malpote Gabaku Damodar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21700",
    "name": "Malvankar Santosh Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21699",
    "name": "Malvankar Sayali Santosh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17089",
    "name": "Mandavkar Vasant Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19578",
    "name": "Mane Ganesh Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20823",
    "name": "Mane Vijay Tatoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20814",
    "name": "Manjrekar Ranjit T."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17183",
    "name": "Maskar Rakesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7059",
    "name": "Mhatre Lata Chintaman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12961",
    "name": "Mishra Pankaj Pyarelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5006",
    "name": "Mishra Rajkumar Kailashnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20847",
    "name": "Mohite  Goutam   Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20810",
    "name": "Mohite Gautam Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3611",
    "name": "More Narayan Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "680",
    "name": "More Shivaji Aba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18579",
    "name": "Morya Rameshchandra Samaylal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20828",
    "name": "Mutaya  Mutana   Pasula"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16736",
    "name": "Nagavekar Susen Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20755",
    "name": "Nikam Vasant Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6485",
    "name": "Nipane Tanaji Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18161",
    "name": "Padwal Karuna Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19195",
    "name": "Pal Lataprasad Ramlakhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19579",
    "name": "Pal Maujilal Ramlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18973",
    "name": "Palange Asha Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16468",
    "name": "Palange Sushma Anand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18394",
    "name": "Palav Savlaram Jairam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20825",
    "name": "Panchal  Ramchandra   Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9034",
    "name": "Pande Surendra Kumar Ramdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12890",
    "name": "Pandya Dilip Purushottam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18412",
    "name": "Pange Apurva Jagdish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2174",
    "name": "Parab Prabhakar Ramchandra ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17941",
    "name": "Parab Rashmi Gunaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16983",
    "name": "Parab Vijaykumar Ladoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18061",
    "name": "Patel Visarjan Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7679",
    "name": "Patil Gopinath Ramchandra."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18165",
    "name": "Patil Laxman Narayan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16446",
    "name": "Patil Shahaji Ganpati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3693",
    "name": "Patkar Saroj Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20869",
    "name": "Pawar  Rajesh Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17221",
    "name": "Pawar Amit Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16507",
    "name": "Pawar Amit Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15923",
    "name": "Pawar Dadaso Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17321",
    "name": "Pawar Kamal Ramakant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14177",
    "name": "Pawar Nana Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16280",
    "name": "Pawar Santosh Hiraji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20884",
    "name": "Pawar Shashikant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6863",
    "name": "Pedamkar Dhanaji Sudkoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17351",
    "name": "Pingulkar Jyoti Arjun."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17455",
    "name": "Pisal Mahesh Uttam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11626",
    "name": "Porwal Navinkumar D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6536",
    "name": "Posanna  Narasanna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5953",
    "name": "Punde Nanadkumar Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20141",
    "name": "Puralkar Dattaram Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19448",
    "name": "Ram Ravindra Hardeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18006",
    "name": "Rane Puroshattam Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18138",
    "name": "Rane Vaibhavi Upendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17090",
    "name": "Raul Swati Nitin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17238",
    "name": "Raut Amir Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15955",
    "name": "Raut Manoj Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16842",
    "name": "Raut Vilas Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17122",
    "name": "Rauthan Chandrashekhar Vikramsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19972",
    "name": "Rawale Sanjay Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12684",
    "name": "Rawool Shivaram Saba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20588",
    "name": "Sadanand Niwas Chawl Commitee"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17096",
    "name": "Safariya Jivibai Palaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13245",
    "name": "Sakpal Pramila Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20757",
    "name": "Sakpal Vijay Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16511",
    "name": "Salkar Milind Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6656",
    "name": "Salunke Vimal Maruti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1904",
    "name": "Sankpal Atmaram Anna."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17728",
    "name": "Satam Jyoti Ganesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4972",
    "name": "Sawal Medha Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19541",
    "name": "Sawant Jaising Bapurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20808",
    "name": "Sawant Rajkumar Ziphra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13124",
    "name": "Sawant Vasu Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20820",
    "name": "Sawant Vijay Vishvanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19970",
    "name": "Shah Anil Kumar Bharat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13730",
    "name": "Shah Bhavin S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20827",
    "name": "Shaikh  Riyajuddin   Salauddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20754",
    "name": "Shaikh Ayaz Vazir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20885",
    "name": "Shaikh Mohmmad Nabi Hakimmulla"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19055",
    "name": "Sharma Sarjusaran Gayaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3255",
    "name": "Shelar Laxman Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11064",
    "name": "Shelar Mangesh Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6743",
    "name": "Shelar Shyam Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13790",
    "name": "Shelar Vithal Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6974",
    "name": "Shete Govind Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6009",
    "name": "Shikh Mohama Ali Nurmahamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1109",
    "name": "Darade Rajabhau Karbhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18896",
    "name": "Shinde Gangadhar Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2468",
    "name": "Shinde Popat Sadashiv."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13756",
    "name": "Shinde Radhika Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14486",
    "name": "Shinde Ramchandra Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17315",
    "name": "Shirgavkar Sanjay Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15831",
    "name": "Shirodkar Mahesh Dashrat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18727",
    "name": "Shirvadekar Vithal Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6706",
    "name": "Shukhala  Vishal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20759",
    "name": "Sing Ashokkumar Aditya Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14148",
    "name": "Solanki Naresh Pusushottam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20821",
    "name": "Sonawane Dipak Dagdu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17426",
    "name": "Tapase Suresh Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17936",
    "name": "Tawade Sneha Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20826",
    "name": "Thoravade  Dhiraj   Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20805",
    "name": "Thorwade Sanjay Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16431",
    "name": "Thukarul Shashank Anant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20811",
    "name": "Umar Abu Talib Mohamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19956",
    "name": "Utekar Dattaram Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20850",
    "name": "Vankhede  Krishna  Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17821",
    "name": "Varhadi Prashant Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "780",
    "name": "Darshan Clinical Laboratories"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "382",
    "name": "Darshan Engineering"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "71",
    "name": "Darshan Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19201",
    "name": "Wagh Balu Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19161",
    "name": "Waghmare Dilip Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14914",
    "name": "Walve Dattaram Babaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9874",
    "name": "Waradkar Anant Babali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13192",
    "name": "Warang Jitendra Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20819",
    "name": "Wavahal Kamal Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17378",
    "name": "Yadav Mahesh Mansing."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16063",
    "name": "Zagade Santosh Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "313",
    "name": "Das Powers"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10152",
    "name": "Jadhav Vijay Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1975",
    "name": "Choudhari Madhukar Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "483",
    "name": "Vimal Hindurao Tarde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2981",
    "name": "Sahi Lokendra K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1010",
    "name": "Annamma  Varghese."
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "312",
    "name": "Das Traders"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4162",
    "name": "Maru Khimaji Keshavji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "614",
    "name": "S. Velvswami Cipoya Murgan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8916",
    "name": "Lalit  Sing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3493",
    "name": "Yadav Shambhunath Nayak."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1348",
    "name": "Kambale Subhash Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3057",
    "name": "Landge Laxman Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3056",
    "name": "Landge Ramchandra Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2872",
    "name": "Kadam Dnyandeo Marutrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2068",
    "name": "Sanjay Vasant Patil."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2558",
    "name": "Akberalii Amajad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4362",
    "name": "Kalawadia Nazima Mushtaque."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "743",
    "name": "Namdev Mallappa Balli ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "453",
    "name": "Omprakash R. Gogia."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2496",
    "name": "Sanakar Dattaram Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1624",
    "name": "Shendekar Mahadeo Janu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2774",
    "name": "Chavan Ashok Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "719",
    "name": "Anil Vinod Nerurkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3927",
    "name": "Choudhari  Upendra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1053",
    "name": "Ratanlal  Gupta."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1137",
    "name": "Bhima  Vasta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5909",
    "name": "Gaikwad Ramkrishna Shivappa."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "327",
    "name": "Gurav Ramesh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "692",
    "name": "Datta Transport Service"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3447",
    "name": "Nachare Krishna Laxman."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5919",
    "name": "Zanzane Mahadev Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2394",
    "name": "Savale Yashwant Dattu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2924",
    "name": "Kadlag Namdev Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5176",
    "name": "Pawar Ankush Rajaram/Shashikala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "655",
    "name": "Rajan Ramakant Walanju."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2352",
    "name": "Shekha Suryawanshi Mahadeo."
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "164",
    "name": "Dattatray Marutrao Jadhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6274",
    "name": "Singh  Brijesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4470",
    "name": "Sutar  S.Usha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "66",
    "name": "Shankar Nana Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "824",
    "name": "Pradesh Mugatrao Jagtap."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2280",
    "name": "Tiksera Filip Nikals"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14953",
    "name": "Gawade Narhari Dashrath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3135",
    "name": "Daftary Hemu Bhailalbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2030",
    "name": "Sonavane Shataram Savlaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "458",
    "name": "Subhash Jaising Salunkhe."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3157",
    "name": "Patil Gangubai Chandrashekhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "610",
    "name": "Gokulabai Popat Jagtap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10557",
    "name": "Kenjale Piloba Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "503",
    "name": "Mayekar Deepak Barakya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4118",
    "name": "Suryavanshi Madan Bhivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3050",
    "name": "Shaik Gulzar Fakir Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2252",
    "name": "Bhise Vijaykumar B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1960",
    "name": "Bhitade Ulhas Kisanraeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "206",
    "name": "K Somdevan Nagraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "700",
    "name": "Shital Vishram Baikar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "351",
    "name": "Vidya Yashvant Kadam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "116",
    "name": "Sampatrao Nathuram Mulik."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "129",
    "name": "Anusaya Dayaram Bhosale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3413",
    "name": "Bagat Poone Kully Poone."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "484",
    "name": "Mahadeo Bhikaji Chorge."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3889",
    "name": "Patil Madhukar Vishnu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2055",
    "name": "Satpure Baburao Ganpatrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2505",
    "name": "Bhagat Ramdas Baban."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5935",
    "name": "Jagtap Kashinath Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1272",
    "name": "Pathak Praful S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4110",
    "name": "Shaikh Mohamad Rafiq Nazir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "733",
    "name": "Pandurang Bhikaji Pikhare ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1410",
    "name": "Anthony T. Mariya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "383",
    "name": "Prabhakar Ramchandra Pawar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "392",
    "name": "Prabhu Kondiba Gaikwad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2860",
    "name": "Rasal Pushpa Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "55",
    "name": "Yogesh Vinod Ghuge."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "180",
    "name": "Maruti Ramrao Chavan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4120",
    "name": "Rasal Suresh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1807",
    "name": "Saxena  Pushkar."
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "78",
    "name": "Deep Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4198",
    "name": "Deepak Fabrics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1548",
    "name": "Deepesh Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1498",
    "name": "Deepshika Gas Equipment."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2154",
    "name": "Delwara Silk Mills"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1060",
    "name": "Dena Enterprise"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3952",
    "name": "Desai Madhura Mahesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3944",
    "name": "Desai Madhuri Umesh"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2073",
    "name": "Design Mantra"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "42",
    "name": "Dev  Labour Services"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "872",
    "name": "Dhanshri R. Maynak."
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "218",
    "name": "Diamond Electric Works"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "182",
    "name": "Diamond Hightech Products"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2",
    "name": "Dilip Electric Sales& Service"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1705",
    "name": "Dinesh Cotton Mills"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1253",
    "name": "Dinesh Industries"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "299",
    "name": "Dinesh Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "899",
    "name": "Dipak Enterprises."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1651",
    "name": "Drishti Prakashan"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1085",
    "name": "Dupoint Systems"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1062",
    "name": "Durga Construction Co"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1007",
    "name": "Durva Motors"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1607",
    "name": "Ecom Solutions  Services"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "464",
    "name": "Eharma Industries"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1542",
    "name": "Ekta Genaral Stores"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4188",
    "name": "Elton Industries"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "759",
    "name": "Emageware Technologies Pvt Ltd"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1879",
    "name": "Emkay Enterprise"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "92",
    "name": "Excel Batteries"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1822",
    "name": "Expo Footwear Moulds"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "281",
    "name": "Farhan Enterprises"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2182",
    "name": "Flori Furnishing"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1330",
    "name": "For Shubham Trading Corporation."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1357",
    "name": "Four Plus Marketing Services."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4087",
    "name": "G M Synthetics"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2731",
    "name": "A Devid Anbu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8169",
    "name": "Aagunde Prakash Sayadi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5765",
    "name": "Aajgaonkar Nikhil Shrikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14173",
    "name": "Aarote Bagubhai Sudam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3263",
    "name": "Acharya  Sanjeeva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2732",
    "name": "Adhatrao Umesh Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17902",
    "name": "Adkar Sneha Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "750",
    "name": "Agnes Caesar D Souza."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20159",
    "name": "Ahire Ananda Baburav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19225",
    "name": "Ahire Bhima Bhagawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7560",
    "name": "Ajij Shaikh Shahanoorbegam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18223",
    "name": "Amar Suresh Tawade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3064",
    "name": "Amberakar Shankar Sonu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20258",
    "name": "Anpat Mahendra Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21427",
    "name": "Ansari Fahim Abdulgafar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21186",
    "name": "Ansari Mehboob Abdulsamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21357",
    "name": "Ansari Mohabid Abdul Latif"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21356",
    "name": "Ansari Mohvakil Mohhanif"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21423",
    "name": "Ansari Safikahmad Abdulvahid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4772",
    "name": "Ansary Mohmed Usuf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6850",
    "name": "Apasarikhatun Mumtaz Ahmed Khan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20618",
    "name": "Arav Ashali Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19934",
    "name": "Armogham  Karunanidhi Armughan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2475",
    "name": "Arokeswami Joseph Jesuraj."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6925",
    "name": "Ashrafi Naved A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3159",
    "name": "Auadhesh  Prasad."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21404",
    "name": "Bad Machindra Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2106",
    "name": "Bamagude Arun Damodar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20110",
    "name": "Bandewar Santosh Rajabhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2738",
    "name": "Bari Shantaram Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13275",
    "name": "Bariya Mohan Ratanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6139",
    "name": "Barui T. K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2901",
    "name": "Bata Dhaku Savalaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17414",
    "name": "Bhadekar Bhikaji Purushotam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2812",
    "name": "Bhalerao Nivrutti Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5069",
    "name": "Bhoir Ranjana Shrikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16048",
    "name": "Bhokare Yeshwant Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1337",
    "name": "Bhorade Tukaram Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21443",
    "name": "Bhosale Ravi Ramdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21187",
    "name": "Bhujbal Kishan Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "754",
    "name": "Bishwakarma Hiralal B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10712",
    "name": "Bobade Subhash Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7293",
    "name": "Bubere  Mehrunnisa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21445",
    "name": "Butekar Vikram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2911",
    "name": "Chandrarana Bharati Kishore"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4832",
    "name": "Chapke Naandkishor Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6640",
    "name": "Charkop Congress Committee[I"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "734",
    "name": "Chaskar Sopan Kisan ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4869",
    "name": "Chauhan  Sukminath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21438",
    "name": "Chauvhan Ajay Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20488",
    "name": "Chavan Ajit Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13933",
    "name": "Chavan Anita Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16635",
    "name": "Chavan Ashok Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3450",
    "name": "Chavan Baburao Shamrao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19134",
    "name": "Chavan Dattatray Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1751",
    "name": "Chavan Deepak Balkrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2581",
    "name": "Chavan Eknath Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19955",
    "name": "Chavan Madhavi Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2867",
    "name": "Chavan Madhukar Chandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2735",
    "name": "Chavan Mahadev Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7722",
    "name": "Chavan Prakash Sarjerao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6973",
    "name": "Chavan Rajendra Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16164",
    "name": "Chavan Rajesh Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8349",
    "name": "Chavan Raju Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "333",
    "name": "Chavan Ramchandra Bayaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19881",
    "name": "Chavan Roopa Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7537",
    "name": "Chavan Sangita Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21406",
    "name": "Chavan Subhash Balaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5178",
    "name": "Chavan Suman Arjunrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4098",
    "name": "Chawan Jayant Tulsiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20676",
    "name": "Chawan Sujata Shiwaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3422",
    "name": "Chohan Tribhuvan Shivanand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6085",
    "name": "Chormale Jaysing C"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20129",
    "name": "Choudhary Ankush Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20128",
    "name": "Dabhekar Ashok Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6831",
    "name": "Dabholkar Shrikant Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "209",
    "name": "Dattatrya Jotiram Mulik."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3039",
    "name": "D'Cruz Joseph Martin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5441",
    "name": "Desai Ajay Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18570",
    "name": "Desai Vishawnath Sudhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3148",
    "name": "Deshmukh Deepak Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3776",
    "name": "Deshmukh Ramesh Govind."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2482",
    "name": "Desul Gajanan D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7347",
    "name": "Devale Chandrashekhar Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6460",
    "name": "Devalia Ramaben Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11087",
    "name": "Dhanak Kajol Girish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6884",
    "name": "Dhaya Sanjay Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8518",
    "name": "Dhepale Mangal Gautam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21475",
    "name": "Dhopat Ravindra Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5950",
    "name": "Dhruv Bakul D."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15059",
    "name": "Dhumak Vinayak Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3252",
    "name": "Dhumal Dinesh Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5568",
    "name": "Dhumal Rajendra Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20077",
    "name": "Dondkar Sanjay Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19765",
    "name": "Doyale Reshma Manoj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20109",
    "name": "Dube Omprakash Nagarinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20118",
    "name": "Dubey Akhileshkumar Swaminath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19046",
    "name": "Dubey Dhiredrakumar D"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21373",
    "name": "Dubey Pramodkumar Baijnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3262",
    "name": "Dude Mohan Sitaram ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17236",
    "name": "Dudwadkar Amit Anant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13899",
    "name": "Etam Hariba Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1295",
    "name": "Gade Dhananjay Shivaji."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11907",
    "name": "Gadekar Kanhaiya Jagdish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6911",
    "name": "Gadgil Arun Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20124",
    "name": "Gaikawad Naryan Rama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19954",
    "name": "Gaikwad  Vilas   Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9185",
    "name": "Gaikwad Ajit Daji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3672",
    "name": "Gaikwad Balasaheb Sopan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21198",
    "name": "Gaikwad Mahendra Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10618",
    "name": "Gaikwad Rajaram Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5989",
    "name": "Gaikwad Raju Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5173",
    "name": "Gaikwad Sanjay Digambar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20040",
    "name": "Gaikwad Sujata Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6548",
    "name": "Gaikwad Uttam Jyotiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20570",
    "name": "Gaikwad Vilas Malhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9743",
    "name": "Gamare Sarla Changdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8469",
    "name": "Gandnile Anand H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6628",
    "name": "Gawade Devendra Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6629",
    "name": "Gawade Rajendra Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6221",
    "name": "Gawde Vijay Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9199",
    "name": "Ghadashi Sudhakar Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2440",
    "name": "Ghadge Jagannath Balu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21444",
    "name": "Ghag Ajit Nilesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19617",
    "name": "Ghag Pranay Krushnanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3021",
    "name": "Ghante Arjun Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7564",
    "name": "Gharat Viswas Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10216",
    "name": "Ghoadigaonkar Vishwanath Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7162",
    "name": "Ghorge Dilip Gundu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20723",
    "name": "Gohil Prakash Bijal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8150",
    "name": "Golathade Shashikant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6566",
    "name": "Gondane  Ravikumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2334",
    "name": "Goregavkar Nanda Kishor ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4956",
    "name": "Gound Bhramdeo S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20142",
    "name": "Gujar Ashok Maruthi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18091",
    "name": "Gujar Pramod Nathuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21403",
    "name": "Gupta Gangaprasad Jankiprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20224",
    "name": "Gupta Gopalprasad Ramdhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21364",
    "name": "Gupta Indradev Matafer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6134",
    "name": "Gupta Radheshyam Arjunprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21384",
    "name": "Gupta Ramesh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21185",
    "name": "Gupta Ravishankar Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20283",
    "name": "Gupta Sanjaykumar Rajendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12016",
    "name": "Gupta/Halwai Viddyatma Rutan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16658",
    "name": "Gurav Uma Shivaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19516",
    "name": "Haji Nasim Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1568",
    "name": "Hake Anil Nivrutti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6405",
    "name": "Halye Haresh Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2828",
    "name": "Hande Jijabhau Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3092",
    "name": "Hasan Sarpuddin Sayyad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4260",
    "name": "Hule Atmaram Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6165",
    "name": "Indore Ramdas D."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20513",
    "name": "Ingale  Wilson  Lucas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6486",
    "name": "Ingavale Vijay Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7849",
    "name": "Intenni Hanmanta Sanjappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7880",
    "name": "Iyegar Pradeep Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4064",
    "name": "Jadhav Atmaram Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7662",
    "name": "Jadhav Deepak Ramaji/Dipali."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "720",
    "name": "Jadhav Laxman Manaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6150",
    "name": "Jadhav Mohan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2819",
    "name": "Jadhav Prakash Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20068",
    "name": "Jadhav Satish Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15340",
    "name": "Jadhav Shrirang Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19971",
    "name": "Jadhav Vikas Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21499",
    "name": "Jadhav Yogesh Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7014",
    "name": "Jagatap Harichandra Nanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6064",
    "name": "Jaghid  Masum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2484",
    "name": "Jagtap Dilip Sadashiv."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15747",
    "name": "Jain Deviben Champalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12226",
    "name": "Jain Hasmukh Devichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15478",
    "name": "Jain Jayantilal J /Manojkumar J Jain"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20388",
    "name": "Jain Kishorkumar Sagarmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15740",
    "name": "Jain Mahendra Babulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18919",
    "name": "Jain Sukhibai Chunilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20389",
    "name": "Jain Vinodkumar Sagarmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10697",
    "name": "Jaiswar Poojari Sahkaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3279",
    "name": "James  C.L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7640",
    "name": "Jethani Vrajlal Nagendra."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20518",
    "name": "Kadam Ashok Parashuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17119",
    "name": "Kadam Bharati Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17765",
    "name": "Kadam Dhanraj Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2087",
    "name": "Kadam Ganpat Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3216",
    "name": "Kadam Meena Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4520",
    "name": "Kadam P. Sharad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3112",
    "name": "Kadam Rajani Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4575",
    "name": "Kadam T Sushakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11483",
    "name": "Kadam Vitthal Mansingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10500",
    "name": "Kadav Dashrath Parashram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3151",
    "name": "Kakkad  Fatima"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20254",
    "name": "Kale Janabai Savalaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21436",
    "name": "Kale Kiran Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4894",
    "name": "Kale Murlidhar Sukhadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1426",
    "name": "Kambale Prakash Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3003",
    "name": "Kamble Mahadev Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7213",
    "name": "Kamble Raghunath Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20495",
    "name": "Kamble Virat Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3040",
    "name": "Kambli Shritant Sayaru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19987",
    "name": "Kanekar Ashok Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2890",
    "name": "Kapadia Bhadrakant Ishwarlil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17626",
    "name": "Kargutkar Sweta Vijay."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3082",
    "name": "Karvola Hilda Michel"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20605",
    "name": "Katkar Anita Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6749",
    "name": "Keni Chandrakant Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8319",
    "name": "Keni Vidya Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6905",
    "name": "Kenjale Machindra Rangrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21192",
    "name": "Keskar Gangaram Digamber"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14947",
    "name": "Khade Sadanand Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21453",
    "name": "Khan Ashraf Mohammad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21429",
    "name": "Khan Firoz Habibahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21358",
    "name": "Khan Gufran Kamruddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21179",
    "name": "Khan Gulamnabi Mohd.Iqubal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21426",
    "name": "Khan Mohd Niyas Mohd Nigam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2684",
    "name": "Khan Samashir Khan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8321",
    "name": "Kharat Vishnu Umaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5797",
    "name": "Khot Sadanand Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21175",
    "name": "Kilje Sandesh Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18005",
    "name": "Kocharekar Dinesh Nakul."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19551",
    "name": "Kolekar Sidhary Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14958",
    "name": "Kondulkar Phulabai Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "692",
    "name": "Krishna Vishnu Desai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9225",
    "name": "Kshirsagar Kiran Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18391",
    "name": "Kubal Ganesh Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9547",
    "name": "Kulaso M. K/T R Gorivale"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19966",
    "name": "Kumbhar Archana Vinyak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7360",
    "name": "Kurade Shankar Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20834",
    "name": "Lad Eknath Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8292",
    "name": "Lad Sitaram Dnyandev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17741",
    "name": "Lanjval Ratan Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6446",
    "name": "Lata  Koushik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15415",
    "name": "Lombar Vinayak Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20080",
    "name": "Louis  Cardiro"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4381",
    "name": "Madkaikar Namita Ravindra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2425",
    "name": "Magdoom Dilawar Abbas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6492",
    "name": "Mahadik Shashikant Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15512",
    "name": "Mahadik Shobha Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14564",
    "name": "Mahajan Snehal Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6227",
    "name": "Mahakal Gajanan A."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21473",
    "name": "Mahamuni Balu Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20725",
    "name": "Mahankal Nandan Govardhan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15326",
    "name": "Maharashtra Rajya Nivadnuk Karmchari San"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20643",
    "name": "Mahind  Prakash  Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3236",
    "name": "Makale Raju Hanmanta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7973",
    "name": "Makashi Kumud Vasudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2734",
    "name": "Makrani Shah Mohammed Karim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2752",
    "name": "Malavankar Vilas Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21422",
    "name": "Mali Manojkumar Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20535",
    "name": "Malondkar Ravindra Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7814",
    "name": "Malwekar Krishanath Race"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19984",
    "name": "Mandhare Dnyandev Sopanrav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19517",
    "name": "Mane Gorakh Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9674",
    "name": "Mane Namdeo Tatyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18126",
    "name": "Manjrekar Santosh Dayal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21378",
    "name": "Mansuri Mehboob Gafurbhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21202",
    "name": "Maqnoujia Mohd Umaryakub Umaryakub"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20111",
    "name": "Marathe Manohar Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4982",
    "name": "Marediya Jahir Noorshi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13842",
    "name": "Margaj Harischandra Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2977",
    "name": "Martin  D Souza."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3933",
    "name": "Masurkar Gunaji Zilu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5338",
    "name": "Mathaja Satyawan Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6238",
    "name": "Matris Toni Josef"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19879",
    "name": "Mayekar Ravindra Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2433",
    "name": "Mehata Rajdeo Prasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8326",
    "name": "Mendis Jonny Anthony"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20125",
    "name": "Mishra Anilkumar Vijayprakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21407",
    "name": "Mishra Laxminarayan Balianath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21375",
    "name": "Mishra Sandeep Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21365",
    "name": "Mishra Satish Harinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21367",
    "name": "Mishra Shivkumar Devman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2850",
    "name": "Mogare Sidharth Bhaga"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20410",
    "name": "Mohammed Anwar Mohammed Habib"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4612",
    "name": "Moraye Reshma Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7436",
    "name": "More Hari Manik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1612",
    "name": "More Mohan Dyandeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2509",
    "name": "More Pradip Ramkrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11215",
    "name": "Moses Sandra Godfrey"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2434",
    "name": "Mourya Sherbahadur Ramlal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5859",
    "name": "Mukharji Papia Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18481",
    "name": "Mulaye Shubhangi Satyvijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3058",
    "name": "Mulsheri Anand Umed."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3239",
    "name": "Mustafa  M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2974",
    "name": "Nadar Samuel G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3338",
    "name": "Nadgiri Shakuntala Parmeshwar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21381",
    "name": "Nagre Mahendra Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7306",
    "name": "Naik Shehnaj B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6034",
    "name": "Naik Shivanad Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21437",
    "name": "Naik Suresh Bhiwa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4070",
    "name": "Nair Radhakrishn Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21044",
    "name": "Nalavade  Siddhesh Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6187",
    "name": "Nalawade Bharati L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2282",
    "name": "Nalla  Mullaswami"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21425",
    "name": "Nanavare Pravin Chintaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8257",
    "name": "Narale Laxman Hanumant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20018",
    "name": "Narkar Manisha Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7914",
    "name": "Narkar Nanda Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13608",
    "name": "Narkar Sarojini Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "47",
    "name": "Nawadkar Prahlad Dashrath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6535",
    "name": "Nirmal Ramnaresh Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "461",
    "name": "Nivrutti Yadavrao Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2283",
    "name": "Omprakash  Mahashingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3213",
    "name": "Padawal Balkrishna Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17844",
    "name": "Padelkar Ramesh Ratnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7099",
    "name": "Pal  Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20140",
    "name": "Pal Ramsajivan Ramsamuj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20119",
    "name": "Palasmkar Deepak Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11821",
    "name": "Panchal Ravindra Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3487",
    "name": "Pandere Shantaram Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10308",
    "name": "Pandey Chaya Kamlesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20083",
    "name": "Pandey Devendrakumar Sambhunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20108",
    "name": "Pandit Dinesh Rameshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8247",
    "name": "Pandit Prabhakar Sahbaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4710",
    "name": "Pandiy Prabhkar Kundalik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16167",
    "name": "Pansare Tejas Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17714",
    "name": "Parab Rajesh Eknath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2474",
    "name": "Parera James Sabistan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17983",
    "name": "Parmar Suresh Jethalal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10008",
    "name": "Parte Smita Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "714",
    "name": "Parvti Dadu Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6988",
    "name": "Patekar Vinod Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3193",
    "name": "Patel Bharat Manubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3232",
    "name": "Patel Kashmira P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3227",
    "name": "Patel Navanitbhai F"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3226",
    "name": "Patel Navanitbhai F"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3225",
    "name": "Patel Navanitbhai F"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3233",
    "name": "Patel Navanitbhai F"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21188",
    "name": "Pathan Ibrahim Khalil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3273",
    "name": "Patil Anandrao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2701",
    "name": "Patil Dadu Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2676",
    "name": "Patil Dilip Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2947",
    "name": "Patil Liladhar Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3685",
    "name": "Patil Rangrao Vitthal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3996",
    "name": "Patil Shankar Dhondi ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20771",
    "name": "Patil Shivaji Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15126",
    "name": "Patil Sudhir Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16308",
    "name": "Patil Sunita Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3089",
    "name": "Patole Anant Sitaram ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "886",
    "name": "Paul Vasant Dhamangi."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15338",
    "name": "Pawar Pramod Jagganath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18096",
    "name": "Pawar Pramod Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2857",
    "name": "Pawar Sambhaji Darmaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18040",
    "name": "Pawar Shantaram Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21139",
    "name": "Pawar Subhash Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4514",
    "name": "Pawar Vilas G."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12310",
    "name": "Pednekar Subhash Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20268",
    "name": "Phalke Gopal Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7092",
    "name": "Phanse Umesh Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7456",
    "name": "Pillai Jayraj D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5912",
    "name": "Pingulkar  Shalini."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6109",
    "name": "Pise Pramod D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6512",
    "name": "Pokharkar Gulab Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19906",
    "name": "Poojari Santosh Raghu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3532",
    "name": "Pratap  Meeta."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21380",
    "name": "Qureshi Mohjaved Mehandi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20112",
    "name": "Rai Ramakant Matashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3286",
    "name": "Raj Joice C."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21199",
    "name": "Rajbhar Dilip Shukuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "468",
    "name": "Rajendra Janardan Vaidya."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21402",
    "name": "Rajput Pravin Jivraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8104",
    "name": "Ramble Rajesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2784",
    "name": "Ramnathan A"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18094",
    "name": "Rane  Veena Vishnu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17190",
    "name": "Rane Shankar Atmaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21203",
    "name": "Ranpise Ravindra Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20130",
    "name": "Rathod  Roopsingh Damu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5720",
    "name": "Rathod Sitaram Ravji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2486",
    "name": "Raut Karunakar Anant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6637",
    "name": "Raval Jekurbahen Kunverji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8306",
    "name": "Ravivansh Dayanand Bansilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18837",
    "name": "Rawalekartiki  Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5910",
    "name": "Rawasa Jitendra Shantilal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19958",
    "name": "Reddy Cheka Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3730",
    "name": "Ruchh Jaysukh Tribhovanduj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9570",
    "name": "Rupwale Raju Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2351",
    "name": "Sabale Raghunath Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21359",
    "name": "Sable Raju Dewoo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3903",
    "name": "Saira Banu Shahjahan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2416",
    "name": "Sakunde Jagannath Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3301",
    "name": "Salavi Ashok Budhilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4764",
    "name": "Salavi Dattaram Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20414",
    "name": "Salavi Sunita Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9001",
    "name": "Salian Devidas S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9000",
    "name": "Saliyan Laxman S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3164",
    "name": "Salunkhe Jaysing Mansing."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13458",
    "name": "Salvi Baliram Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19912",
    "name": "Salvi Nitin Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7858",
    "name": "Sans Ankush Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1638",
    "name": "Sarode Asaram Ranganath."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21366",
    "name": "Satam Mohan Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9801",
    "name": "Sawant  Anant Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17012",
    "name": "Sawant Dattatrey Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19886",
    "name": "Sawant Mahesh Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17253",
    "name": "Sawant Millind Hanuman."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21368",
    "name": "Sawant Nagesh Vishwanth"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20008",
    "name": "Sawant Poonam Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2746",
    "name": "Sawant Sampat Mugajee"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15944",
    "name": "Sawant Shailesh Manohar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14922",
    "name": "Sawant Subhash Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20835",
    "name": "Sawant Sunil Pundlikrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21181",
    "name": "Sayed Yasin Sayed Badsha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2847",
    "name": "Shah Bharati Kiran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "322",
    "name": "Shah Kavrav Krishnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3062",
    "name": "Shaik Mahomed Hanif Fakir M."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21379",
    "name": "Shaikh Ajaaz Anis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8357",
    "name": "Shaikh Asalam Shaukatali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21180",
    "name": "Shaikh Dastagir Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21178",
    "name": "Shaikh Husain Mehboob"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21377",
    "name": "Shaikh Irfan Nazir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21177",
    "name": "Shaikh Mehboob Imam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5973",
    "name": "Shaikh Mohamad Abdul Salam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7914",
    "name": "Shaikh Mohmed Habib Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21189",
    "name": "Shaikh Mustakim Buddu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21454",
    "name": "Shaikh Nisarahmad Abdulrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4512",
    "name": "Shaikh R Gafur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18788",
    "name": "Shaikh Riyaj Ahamad Sajjad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21424",
    "name": "Shaikh Rizwan Gulam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17502",
    "name": "Shaikh Sultan Abdulrajak."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3195",
    "name": "Shaji  Pushkaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3920",
    "name": "Shejwal Nahipati Shripati."
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "289",
    "name": "Gajanan Trading Compnay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20947",
    "name": "Shelke Uday Kashitam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6869",
    "name": "Shenoy Sudhakar Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3667",
    "name": "Shette Sambhaji Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7702",
    "name": "Shetty Navmani Jemini."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3335",
    "name": "Shetty Sanath Sadanand."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20082",
    "name": "Shety Narendra Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7905",
    "name": "Shevale Mathurabai Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21474",
    "name": "Shewale Bhargav Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9300",
    "name": "Shinde Anand Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2568",
    "name": "Shinde Arjun Bhairu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5977",
    "name": "Shinde Arjun Gynba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5739",
    "name": "Shinde Ashok Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "949",
    "name": "Shinde Chhapanrao Yadevrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1178",
    "name": "Shinde Prakash Narayan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20550",
    "name": "Shinde Ramakant Dattaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6530",
    "name": "Shinde Ravindra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "604",
    "name": "Shinde Suresh Appa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20715",
    "name": "Shinde Vijay Ganapat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15196",
    "name": "Shingh Haribahadur Dilbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5866",
    "name": "Shirke Ashwini C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3774",
    "name": "Shirke Jayprakash Deu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8000",
    "name": "Shirke Pratima Pradeep"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20321",
    "name": "Shirodkar Gajanan Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3270",
    "name": "Shivalkar Ashok Krishnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2907",
    "name": "Shivalkar Ashok Krishnaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21176",
    "name": "Siddiqui Md.Ishaque Maqbool"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20979",
    "name": "Singh Bhanu Pratap"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21405",
    "name": "Singh Jai Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6116",
    "name": "Singh Kalwatidevi D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6996",
    "name": "Singh Madan Murari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20070",
    "name": "Singh Mahesh Sarju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20045",
    "name": "Singh Parmendar P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10512",
    "name": "Singh Ramesh Pratap Mannulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20138",
    "name": "Singh Ratansingh Ringa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10996",
    "name": "Singh Surendra Jitanprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20157",
    "name": "Sitap Vilas Daji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2590",
    "name": "Sneha Arora"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2740",
    "name": "Sneha Arora"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10998",
    "name": "Solanki Naran Bhikha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17831",
    "name": "Solanki Naresh Fula"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6342",
    "name": "Soloman Lata Kanaka"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21201",
    "name": "Somad Ashraf Rafibuddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21196",
    "name": "Somaiya Himanshu Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20977",
    "name": "Sonar Ashishkumar S ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20158",
    "name": "Sonawane Sharad Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17933",
    "name": "Soni Vimlaben L. Soni Kantilal C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "815",
    "name": "Subhash R. Bagave."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21376",
    "name": "Sundaram Arunraj M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "777",
    "name": "Suresh Kumar Ram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14216",
    "name": "Surve Anant Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7140",
    "name": "Surve Nivedita Nandkishore"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13700",
    "name": "Surve Rajaram Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5938",
    "name": "Suryawanshi Neela Chandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2948",
    "name": "Suvarna Bhojraj R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3124",
    "name": "Tandel Kishor Appaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20161",
    "name": "Tari Tanaji Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18519",
    "name": "Tayade Vishwas Kadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3007",
    "name": "Thakur  Dhanichand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8367",
    "name": "Thapa Ram Bahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21360",
    "name": "Tiwari Ashok Kripashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19083",
    "name": "Tiwari Manoj Sabajit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21363",
    "name": "Tiwari Surendra Hariram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4324",
    "name": "Tudape Shivaji Subhashrao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15075",
    "name": "Tupe Shivaji Narayan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15838",
    "name": "Udamle Ramesh Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20282",
    "name": "Upadhaya Indrasen Loknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13632",
    "name": "Utekar Anant Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18000",
    "name": "Uttamshaha Indrasing Thakur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7021",
    "name": "Vaishnav Gopinath Shankardas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17580",
    "name": "Valantra Bharat Khushal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3466",
    "name": "Vanjaria Ashwin Sonubhai."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18947",
    "name": "Varadi Ratankar Kushba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11689",
    "name": "Varhadi Chandrakant Sabaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2770",
    "name": "Vashist Bhagawati Swarup ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20172",
    "name": "Vatkar Gangadhar Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20529",
    "name": "Vende Suhas Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20517",
    "name": "Verma Jayesh Kailashchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13647",
    "name": "Verma Omprakash Jagatdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3061",
    "name": "Vessoakar  Peter"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16181",
    "name": "Vichare Archana Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9089",
    "name": "Vidhate Arjun Rakhmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2579",
    "name": "Visapadia Hiraben"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21428",
    "name": "Vishwakarna Subedar Bholanath"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "83",
    "name": "Ganesh Electrical & Hardware Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2688",
    "name": "Vishwkarma  Kamaljeet"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "229",
    "name": "Ganesh Jwelors"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "178",
    "name": "Ganesh Krishi Bhandar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1036",
    "name": "Ganesh Provision Stores"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8937",
    "name": "Vora Jaysukh Dharamshi"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "821",
    "name": "Ganesh Soceity Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "865",
    "name": "Ganesh Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4542",
    "name": "Wagh Chitra D."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "654",
    "name": "Ganga Furniture"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6777",
    "name": "Waghe Pradeep Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20114",
    "name": "Waghmare Umesh Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20145",
    "name": "Wakale Sangita Khandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2910",
    "name": "William  P."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20117",
    "name": "Yadav Bhonu Tunki"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21374",
    "name": "Yadav Bijendra Hardev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20173",
    "name": "Yadav Chandramani Rajpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2510",
    "name": "Yadav Gaya Prasad."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19983",
    "name": "Yadav Kiran Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2488",
    "name": "Yadav Mahadeo Vinayak."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13039",
    "name": "Yadav Nathu Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20155",
    "name": "Yadav Rajkiran Jagdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20069",
    "name": "Yadav Rajkishor Jagnnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20178",
    "name": "Yadav Sarjeet Budhiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21383",
    "name": "Yadav Sureshkumar Chabinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20079",
    "name": "Yadav Suryabali Mahabalram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21382",
    "name": "Yadav Vijaykumar Mangru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21421",
    "name": "Yadav Vinod Panchuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "753",
    "name": "Yadaw Ganesh Khelu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6179",
    "name": "Yakub Shaked Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20131",
    "name": "Yemgar Arvind Sonappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20098",
    "name": "Zagade Sameer Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8895",
    "name": "Zavare Jaganath Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1799",
    "name": "Mane Ashok Gangaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1748",
    "name": "Rane Chandrakant Govind."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4548",
    "name": "Chachad  N.V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8221",
    "name": "Salkar Sarang Ratnakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9974",
    "name": "Sawant Tanaji Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9216",
    "name": "Parkar Prashant Pramod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1711",
    "name": "Bhosale Narayan Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3419",
    "name": "Kadam Kalidas Appaso."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3767",
    "name": "Solaskar  Maya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "664",
    "name": "Bansi S. Sapkale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1393",
    "name": "Gohil Nagindas Varjivandas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1977",
    "name": "Rade Vasant Janardan ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "665",
    "name": "Ramesh B. Shah."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "839",
    "name": "Hirenkumar  Sonavaria"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1505",
    "name": "Warnekar Rajendra Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1593",
    "name": "Dixit Vijaykumar Bhalchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3241",
    "name": "Gupta Javaharlal Ramshnkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10638",
    "name": "Mhatre Tukaram Baluappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5243",
    "name": "Pandya Pragna Hemant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3034",
    "name": "Sakariya  Syman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1080",
    "name": "Gopal Bhagoji Fefade."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2150",
    "name": "Zore Gangaram Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3399",
    "name": "Jadhav Sudam Subhedar ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2962",
    "name": "Mistry Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2999",
    "name": "Patel Sharad Hirjibhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2826",
    "name": "Sangale Balkrishna Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2236",
    "name": "Kesarkar Uttam Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2992",
    "name": "Kadam Sharad Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "420",
    "name": "Ashok Rajaram Hindlekar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2118",
    "name": "Chavan Baban Tatoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2670",
    "name": "Sharma Kamala Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3806",
    "name": "Dhaigude Dyaneshwar Krishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2010",
    "name": "Gois  Marcelino."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2556",
    "name": "Shaikh Kayum Ramjanee"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1772",
    "name": "Kadam Krishna Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "887",
    "name": "Ramanna  Hanumanta."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6261",
    "name": "Pujari Bhagirti Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3284",
    "name": "Mohammed Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11721",
    "name": "Salunkhe Saita Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3955",
    "name": "Kavar Chandrakant Balu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3470",
    "name": "Hiwale Shamrao Punaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5014",
    "name": "Charoiya Rashid Jalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3640",
    "name": "Mohmand Umar Mohmand Farid."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10459",
    "name": "Momin Jabbar Musa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5302",
    "name": "Pandy Ramnivas S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4943",
    "name": "Rajani Allauddin Namji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4849",
    "name": "Sakhani Phiroj Nooralli"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "742",
    "name": "Shalan Shamrao Nanaware."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1174",
    "name": "Gathuya Pailteer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4796",
    "name": "Sippy Sunil Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4831",
    "name": "Surve Chandrakant Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4942",
    "name": "Yadav Angnu Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9047",
    "name": "Chatur Khandu Dharma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3322",
    "name": "Deshmukh Ramrao Wamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1252",
    "name": "Anant Laxman Mhapalkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1893",
    "name": "Angre Shantaram Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2162",
    "name": "Gaud Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1689",
    "name": "Gaikwad Baburao Savala."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1052",
    "name": "Rajanna  Kunnanna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2741",
    "name": "Reedy  Esther"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3467",
    "name": "Pawar Prejan Sitaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "403",
    "name": "Abdul Samad Khan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1914",
    "name": "Patel Kanaram Khetaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3709",
    "name": "Pawar Anandrao Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2671",
    "name": "Kalmankar Prkash Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "454",
    "name": "Bhimrao Bandu Dubal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "162",
    "name": "Kisan Rambhau Nalawade."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6076",
    "name": "Kothvadekar Mangesh Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2183",
    "name": "Bulunge Bharat Popatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1844",
    "name": "Pujari Jagdeo Shantappa."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3978",
    "name": "Patel Santaben Jayantbhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5689",
    "name": "Jadhav Harichandra Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11256",
    "name": "Malwankar Revati Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4446",
    "name": "Shah Kishore Bhagwanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1784",
    "name": "Singh  Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1669",
    "name": "Vyas Umesh Tuljaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4369",
    "name": "Ajgaonkar Mangal Shrikant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1949",
    "name": "Damonia Shonalal N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "880",
    "name": "Kadakia Divyesh Shashiknat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1825",
    "name": "Lembhe Dashrath Narsing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "780",
    "name": "Meena Anthony Vaity."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "242",
    "name": "Gautam Plumber"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1967",
    "name": "Kubhare Ram Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2912",
    "name": "Habib Shaikh Mahamad Maksood"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "491",
    "name": "Kisanrao Gulabrao Deshmukh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3173",
    "name": "Kamble Ramesh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2250",
    "name": "Mane Padmadevi Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11548",
    "name": "Shaikh Mohd Rafi Gulam Rasul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2696",
    "name": "Chavan Baban Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1887",
    "name": "Desai Sumitra Laxman /Laxman  Desai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2645",
    "name": "Jain Uttamchand Jugaraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "185",
    "name": "Kaji Khadim Ali."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2723",
    "name": "Kandalgaovkar Suvarna Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2658",
    "name": "Sawant Haribhaue Bhimajee"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1510",
    "name": "Subramani M P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3568",
    "name": "Valanju Rajan Ramakant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2085",
    "name": "Arya Khadkram Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3783",
    "name": "D Souza Maggi Matesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2114",
    "name": "Kadam Ramadas Jaywantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3647",
    "name": "Rasidkhan  Indrishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "752",
    "name": "Kadakia Rasiklal Keshavlal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "91",
    "name": "Gayathri Ceramics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4178",
    "name": "Geeta  Auto  Dealer"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1106",
    "name": "Geeta Steel Works"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "151",
    "name": "Geeta Tyeres"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1135",
    "name": "Ghadge Tours & Travels"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3651",
    "name": "Ghanshyamdas Maliram"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "129",
    "name": "Ghar Sansar Kirana & General Stores."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2582",
    "name": "Global  Impex."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1360",
    "name": "Global Services."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1873",
    "name": "Glory Enterprise"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1909",
    "name": "Goenka Synthetics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3796",
    "name": "Gogawale Prakash Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1139",
    "name": "Golden Estate Agency"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3423",
    "name": "Golden Express Service"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3550",
    "name": "Dhumal Dhamandre H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2035",
    "name": "Jagdale Dattatrya Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1649",
    "name": "Kadam Anjali Kamlesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1659",
    "name": "Kamble Bhagwan Saluji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1219",
    "name": "Gaikwad Mangal Ramesh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12757",
    "name": "Ambre Seema Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10089",
    "name": "Andhale Laxman Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6103",
    "name": "Ansari Kharulla Rafiulla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2152",
    "name": "Ashok Dnyanadeo Kadam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6704",
    "name": "Baing Hanmant Jyotiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14302",
    "name": "Bane Sudhir Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15942",
    "name": "Barmukh  Pravin Ramachandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16638",
    "name": "Bhagat Snehlata Madhukar/Mr.Madhukar.Mew"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5403",
    "name": "Bhosale Dattatray Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15671",
    "name": "Bhosale Shramita Dinanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11951",
    "name": "Bhovad Manohar Shripat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21371",
    "name": "Billai Neelkant Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5159",
    "name": "Bopale Ravi Rambhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15319",
    "name": "Chawan Swati Surendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20838",
    "name": "Chilap  Anil  Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5881",
    "name": "D Souza  Cyril Francis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "168",
    "name": "Dadaso Sayaji Jagtap."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15455",
    "name": "Dangat Gulab Popat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17331",
    "name": "Desai Babaji Lumaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2171",
    "name": "Dethe Pradeep K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4264",
    "name": "Dhanawade Govind Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7573",
    "name": "Dhaneswar Saroj Ramrup"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17739",
    "name": "Dongare Abhishek Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22200",
    "name": "Dubale Sujaya Nilesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3439",
    "name": "Gaikwad Dagadu Mayappa."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6456",
    "name": "Gardi Laxman Buvasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15121",
    "name": "Gavali Nitin Madannath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15376",
    "name": "Ghadge Shakuntala Viswasrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18315",
    "name": "Ghadigaonkar C. D.& Nilima Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17468",
    "name": "Godambe Mahesh Naresh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5115",
    "name": "Gonabare Suresh Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7115",
    "name": "Goud Anilkumar Pyarelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5755",
    "name": "Gupta Ashokkumar Pannalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13548",
    "name": "Haldankar Pravin Raghunath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5321",
    "name": "Herekar Naresh Ragunath/Pradip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3230",
    "name": "Hule Bharat Attamaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10191",
    "name": "Imran Ahmad Abdul Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "174",
    "name": "Indubai Ganpat Bhosale."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21781",
    "name": "Jadhav Roshani Rahul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21412",
    "name": "Jadhav Seema Sahaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17982",
    "name": "Jadhav Shantaram Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17251",
    "name": "Jagtap Bapurao Krishna ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7301",
    "name": "Jain Abulal Motilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11478",
    "name": "Jain Sangita Ketan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12391",
    "name": "Jain Shanti S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2230",
    "name": "Jambale Vithal Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17509",
    "name": "Jarodarwala  Sahanawaz"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20865",
    "name": "Jhadav  Ajit  Dattatray A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12477",
    "name": "Jogdand Chandrakant Nanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10945",
    "name": "Joshi Bipin Chandrashekhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13418",
    "name": "Kadam Dattaram Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18828",
    "name": "Kadam Pravin Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16727",
    "name": "Kadam Sanjay Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5700",
    "name": "Kadam Sunita Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12907",
    "name": "Kadlak Ganesh Rangnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17018",
    "name": "Kadri Sayyad Mahammad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5479",
    "name": "Kale Sonba Dhamaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21557",
    "name": "Kalokhe Manini Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19542",
    "name": "Kambale Nanda Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4398",
    "name": "Kamble Deepak Ramchandra."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14142",
    "name": "Kandalkar Ajit Pandurangj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15281",
    "name": "Karad Anna Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14385",
    "name": "Keni Ramesh Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7237",
    "name": "Khale Ratnamala Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4438",
    "name": "Khandre G. Dhanshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8908",
    "name": "Khatao Shaliendra Ghanshyam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14750",
    "name": "Kindre Sonaba Kushaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5088",
    "name": "Kokane Vivek Sawantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17069",
    "name": "Kolhe Sanjay Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21434",
    "name": "Kondaskar Ramesh Daji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8863",
    "name": "Kumbhar Baburao Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4508",
    "name": "Lad Subhash Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5416",
    "name": "Lahane Ratan Aasaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6232",
    "name": "Lobo  Denis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7416",
    "name": "Magdum Pandurang Maruti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5660",
    "name": "Makwana Sayarabanu S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22012",
    "name": "Mandhare Sachin Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6300",
    "name": "Maru Pritesh J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "175",
    "name": "Maruti Hari Nawadkar."
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "300",
    "name": "Gudhka Fabrics"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2197",
    "name": "Mayekar Rajeev Pandurang."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20303",
    "name": "Mestry Sachin Purushottam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18069",
    "name": "Mishra Rajendra Shrinath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2180",
    "name": "Mishra Saroj Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8949",
    "name": "Moraye Reshma Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "82",
    "name": "More Ankush Mahadev."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16969",
    "name": "More Sunita Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6287",
    "name": "Morye Gajanan Mukund"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1543",
    "name": "Motwani Rajesh R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11175",
    "name": "Mugwankar Yogesh Digambar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2184",
    "name": "Mumbre Gajanan Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4484",
    "name": "Musale M. D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5727",
    "name": "Naik Eknath Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5719",
    "name": "Naruka  Madhavsing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21802",
    "name": "Narvekar Sandeep Sursh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9513",
    "name": "Narvekar Tukaram Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9514",
    "name": "Nawadkar Chabutai Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13945",
    "name": "Pabalkar Nilambari Sachin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17210",
    "name": "Padave Suhas Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "652",
    "name": "Pandharinath Ramchandra Pingale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1179",
    "name": "Panikar Soman Gopalan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5729",
    "name": "Parab Snehlata Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5377",
    "name": "Paradhi Arun Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3206",
    "name": "Patel Ismile Usman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5838",
    "name": "Patel Kishor K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12597",
    "name": "Patel Ramshre Somnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6461",
    "name": "Patel Shahajanbi Zairuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6509",
    "name": "Patil Anil Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8661",
    "name": "Patil Balasaheb Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6865",
    "name": "Patil Ratnaprabha Ramakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17943",
    "name": "Pawar Anita Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5600",
    "name": "Petkar Santosh Digambar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18169",
    "name": "Phatak Dinesh Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2148",
    "name": "Prabhu Dinesh V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5536",
    "name": "Prajapati Ravindra Jagjivan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1538",
    "name": "Pujari Sanjay Panditrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6406",
    "name": "Rajan  Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19734",
    "name": "Rajbhar Faujdar Ramdhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4855",
    "name": "Rajbhar Satiram Savaru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3205",
    "name": "Rajendra Janardan Vaidya."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21433",
    "name": "Rambade Suhas Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8812",
    "name": "Ramdulari  Shayamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5587",
    "name": "Rana Mahindrasingh Gopalsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1891",
    "name": "Randive Uttam Bhagaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2727",
    "name": "Rane Krishanajee Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15678",
    "name": "Rane Sanjyot Sandip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "946",
    "name": "Rane Vishwanath Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10248",
    "name": "Ranshinge Ashok Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9003",
    "name": "Rathod Haridas Soma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8992",
    "name": "Raut Trimbak Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1575",
    "name": "Rokade Anil Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5514",
    "name": "Roy Ajitkumar K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4730",
    "name": "Sabale Rukmini Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21396",
    "name": "Sabale Sushant Ashokrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21747",
    "name": "Sadavarte Sagar Sharad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22186",
    "name": "Saha Rajkumar Lalsing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20549",
    "name": "Sakharkar Narayan Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21794",
    "name": "Sakpal Sanket Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6351",
    "name": "Sakpal Vithal Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9365",
    "name": "Salve Sangita Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4075",
    "name": "Salvi Anant Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6222",
    "name": "Sangale Eknath Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8688",
    "name": "Sarade Anil Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20144",
    "name": "Sasane Vilas Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11760",
    "name": "Satpute Shankar Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8965",
    "name": "Sawant Alka Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21746",
    "name": "Sawant Amar Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20137",
    "name": "Sawant Anant Chintu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8767",
    "name": "Sawant Eknath V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "33",
    "name": "Sawant Rajendra Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20795",
    "name": "Shah  Shamsher  Bahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21559",
    "name": "Shah Ramesh Vershi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6820",
    "name": "Shaikh B Noorbadsha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1951",
    "name": "Shaikh Ibrahim Kasim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9285",
    "name": "Shaikh Sharfuddin Allauddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7457",
    "name": "Sharma  Mahantkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1320",
    "name": "Sharma Shobhnath Vikrajit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15623",
    "name": "Shinde Achut Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5677",
    "name": "Shinde Arti Pradip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21765",
    "name": "Shinde Nilesh Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12979",
    "name": "Shinde Sunil Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6975",
    "name": "Shinde Tatoba Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9110",
    "name": "Shinde Vithoba Appa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16108",
    "name": "Shrungare Shraddha Sudhir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2155",
    "name": "Solanki Kantilal Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "178",
    "name": "Gulshan Supari Stores"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16111",
    "name": "Sonawane Bhawanji Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1808",
    "name": "Sonawane Sanjivani Achaldas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8317",
    "name": "Surve Kashiram Ratnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4954",
    "name": "Suryawanshi Prakash Gyanoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7926",
    "name": "Suryvanshi Himmat Nanabhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6005",
    "name": "Tamboli Shantaram Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17846",
    "name": "Tangappo Aslai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10983",
    "name": "Tavade Navin Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6464",
    "name": "Taware Samadhan Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21917",
    "name": "Tawde Sunil Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5253",
    "name": "Tembhe Shankar R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5491",
    "name": "Thakar Leeladevi Bhopsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2188",
    "name": "Thapa Meher Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1042",
    "name": "Thorat Dinkar Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2187",
    "name": "Tillaram  Mahonram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6685",
    "name": "Tiwari Badrinarayan Shashidhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12962",
    "name": "Tiwari Rajmani Ramraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1838",
    "name": "Vargheese  Mary."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8293",
    "name": "Vichare Ramchandra Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "159",
    "name": "Vinod Uttamrao Nawadkar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21704",
    "name": "Waghmare Vijay Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2181",
    "name": "Yadav Beni Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2182",
    "name": "Yadav Gama Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2193",
    "name": "Yadav Udayraj Kulafath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8692",
    "name": "Zagade Snehal Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10202",
    "name": "Zore Chandrakant Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2542",
    "name": "Desai Vishwas Shamrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "355",
    "name": "Minakshi Malappa Naikodi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1398",
    "name": "Momin Abbas Mohmad ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3712",
    "name": "Yadav Premkumar Munnilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3045",
    "name": "Gupta Deelip Kumar ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2083",
    "name": "Indap Baban Sabajai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6295",
    "name": "Jahari  Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4086",
    "name": "Katbamna Rachana Bhagirath ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2755",
    "name": "Kadam Rajendra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2504",
    "name": "Vaity Meena Antony."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3809",
    "name": "Todkar Shankar Bayaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7737",
    "name": "Shinde Ashok Prabhakar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3123",
    "name": "Jambhale Kashinath M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "717",
    "name": "Shivaji Narayan Chavan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2605",
    "name": "Rambhai Deepak M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2502",
    "name": "Daine Hemantkumar Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4111",
    "name": "Shinde Ashalata Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "177",
    "name": "Mohan Ramchandra Mulik."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "526",
    "name": "Shalan Shridhar Jadhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2963",
    "name": "Padawal Hanumant Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2169",
    "name": "Kundapur Manohar Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "825",
    "name": "Lahu Ramchandra Pilane."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "870",
    "name": "Shamrao Namdev Wangde ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1287",
    "name": "Mistri Antayys Chinayys"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "218",
    "name": "Karbhari Mahdu Pathade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8971",
    "name": "Kirdak Ashok Sukhdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6356",
    "name": "Shinde Pratibha Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "999",
    "name": "Threscanna  T.M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4015",
    "name": "Gudavlekar Appa Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1943",
    "name": "Jadhav Narayan R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2490",
    "name": "Nayagam J. Soosai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1673",
    "name": "Pawar Vandana Chandrakant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4602",
    "name": "Badhe Vijay Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5215",
    "name": "Brid Ashok Sitaramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4924",
    "name": "Iqbal Ibrahim Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4583",
    "name": "Jangam Narayan Rana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "492",
    "name": "Mohan Laxman Tambitkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "945",
    "name": "Rokade Vilas Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3063",
    "name": "Patil Narayan Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1406",
    "name": "Khatre Surekha A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1285",
    "name": "Jadhav Hanumant Keshav."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1588",
    "name": "Barve Vishnu Sadashiv."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3849",
    "name": "Maharana Vinod Khetravasi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6978",
    "name": "Beluse Dnyaneshwar/Balkrishna Chondankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2229",
    "name": "Jarande Pawar  Dadasaheb Namde"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2017",
    "name": "Dhumal Sunil Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2725",
    "name": "Raheman Muhammad Majibur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3272",
    "name": "Randhave Laxman Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6246",
    "name": "Wagh Digambar Panjasi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1424",
    "name": "Bagave Bhikaji Maruti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1281",
    "name": "Hari Gajananrao Bhoite."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3044",
    "name": "Hatagale Krishna Arjun ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3400",
    "name": "Kamble Dilip Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4108",
    "name": "Karachiwala Mehboob Auddusaddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5741",
    "name": "Turk Irshad Hassan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5531",
    "name": "Upadhyay Trilikinath Ramshakal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1408",
    "name": "Dmello Oscar Joseph ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9198",
    "name": "Kadam Shanti Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "35",
    "name": "Joshi Motiram N."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3038",
    "name": "Chavan Dilip Y."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "220",
    "name": "Yeshwant Barku Pimpalkar"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "202",
    "name": "Guruddatta Udyog"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1677",
    "name": "Gurukripa Traders"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1926",
    "name": "Gurukrupa Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3127",
    "name": "H.Patel & Co"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "661",
    "name": "H.R. Construction"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2588",
    "name": "Haresh Traders"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2216",
    "name": "Hari Om Packing Works"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "10",
    "name": "Hari Om Super Market"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1841",
    "name": "Hari Priya Engineering"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4091",
    "name": "Hariom  Textile"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1601",
    "name": "Harshadrai & Co."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "969",
    "name": "Hem Fabrics"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1729",
    "name": "Hi Tek Mixing Systems"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "356",
    "name": "Hips Printers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1215",
    "name": "Hitesh K Mehta And Co."
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "54",
    "name": "Home Builders"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1161",
    "name": "Honest Automobiles"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "239",
    "name": "Hotel Khushbu"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "777",
    "name": "Hotel Sandhya  Restaurant & Bar"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "1",
    "name": "Hotel Vishnukripa"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1794",
    "name": "Hrishikesh Tempo Service"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "108",
    "name": "Iccha Logistics"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2064",
    "name": "Image Technology"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3701",
    "name": "Imtiaz Sukltan Malik."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1981",
    "name": "International Paint"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "98",
    "name": "Irfan Air Cool"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "873",
    "name": "Ishan Communications."
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "155",
    "name": "J.K.Service Centre"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1587",
    "name": "Patel Laxman Bhana."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1518",
    "name": "Varghave A. Arakkel"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "370",
    "name": "Shantaram Janu Karjavkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "249",
    "name": "Shantaram Dattatrya Bhalerao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10376",
    "name": "A  Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6786",
    "name": "Adenwalla  Anwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10635",
    "name": "Bagate Bhaskar Kacharu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7030",
    "name": "Baina Devaram Umaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5199",
    "name": "Bajrur Shobha V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16718",
    "name": "Bandal Laxman Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5417",
    "name": "Bhandari Karsing Pramalsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5806",
    "name": "Bhatade Ravindra Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16236",
    "name": "Bhosale Manohar Raghoba."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20234",
    "name": "Bohra Khem Bhadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5349",
    "name": "Chandrabhaga Ganpat Lembhe"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5005",
    "name": "Chavan Gorakh Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8969",
    "name": "Chavan Rajaram Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9010",
    "name": "Chopdekar Umesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5045",
    "name": "Choudhari Sunil Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17549",
    "name": "Dhuri Dilip Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20682",
    "name": "Divakar Ashok Ramprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7615",
    "name": "Dorkar Jayshri Sakharam."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20030",
    "name": "Gauda Jkumar Javane"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5291",
    "name": "Gavkar Sumati Savalaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4946",
    "name": "Ghadi Arvind Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10616",
    "name": "Ghosh Vijaykumar Rubendranath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18893",
    "name": "Gole Sanjay Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5285",
    "name": "Gupta S K."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5271",
    "name": "Gurav Sudhakar Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8022",
    "name": "Jadhav Hemlata Prakadh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7024",
    "name": "Jadhav Vasant Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10515",
    "name": "Jagtap Raju Raghmaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20029",
    "name": "Joshi Premds Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17745",
    "name": "Kadam Maruti Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5921",
    "name": "Kadam Pandurang Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5692",
    "name": "Kambale Suman Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8335",
    "name": "Kambale Vitthal Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18156",
    "name": "Kamble Nalini Suryakant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "749",
    "name": "Kangralkar Gajanan Payappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17972",
    "name": "Khamkar Atmaram Raghunath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4781",
    "name": "Kolte Suryakant Madhukar/Dattaram Y.Sawa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7513",
    "name": "Konkar Purshottam Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7561",
    "name": "Lingam  Salvi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20628",
    "name": "Loke Amar Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20132",
    "name": "Madhavi  Vinayak Jetha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7652",
    "name": "Mahadik Manisha Mahadeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5691",
    "name": "Mahalungekar Anand Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "289",
    "name": "Mandhare Mahadeo Rangrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13781",
    "name": "Mandhare Tukaram Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4589",
    "name": "Mane Shakuntala Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5343",
    "name": "Masawkar Madhusudan Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4794",
    "name": "Mate Gangaram Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4095",
    "name": "Mayekar Narendra Yashbant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13773",
    "name": "Mishra Premnarayan R./Poonam P Mishra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21191",
    "name": "Mungekar Arti Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5431",
    "name": "Nag Ramnarayan Hansraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6044",
    "name": "Naik Umesh Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14361",
    "name": "Nalawade Abhay Dayanand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8656",
    "name": "Nalla Sneha Gangadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6990",
    "name": "Pala Prafulchandra Pitamberdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4885",
    "name": "Palpuza  Mohmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16329",
    "name": "Pangare Eknath Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14452",
    "name": "Parab Kashiram Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6719",
    "name": "Parab Manohar Vaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4871",
    "name": "Parekh Narendra Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6730",
    "name": "Parmar Mahendrakumar Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7481",
    "name": "Patel Josep P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4640",
    "name": "Pathak Suhas Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10646",
    "name": "Patil Gorakhnath Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19903",
    "name": "Patode Anjani Laxaman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14081",
    "name": "Pednekar Saroj Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4917",
    "name": "Pile Joshna Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7998",
    "name": "Pujari Jagannath D ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17747",
    "name": "R.David  John"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10866",
    "name": "Rajbhar Satiram Savaru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5281",
    "name": "Rane Shraddha Ratnakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11071",
    "name": "Rao P. Someswara/Garumella Padma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6396",
    "name": "Rashid  Mohammad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7556",
    "name": "Sadke Govind Srirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17171",
    "name": "Sagavekar Vaishali Vishnu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10636",
    "name": "Sakat Bhausaheb Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11770",
    "name": "Sakte Rekha Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6369",
    "name": "Saldanha Prakash M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8841",
    "name": "Sathe Shalik Harshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11759",
    "name": "Satpute Pandurang Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13786",
    "name": "Saving Difference A/C (Internal Use)"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3265",
    "name": "Sawant Dattatray Appa ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8735",
    "name": "Shah Savitaben Gokuldas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5365",
    "name": "Shaikh Jayarabai Abbas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17719",
    "name": "Shaikh Moosa Usman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20078",
    "name": "Shaikh Moula Shaikh Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5283",
    "name": "Sheth Prakash Harjivandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6431",
    "name": "Sheth Prakash Harjivandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11758",
    "name": "Shette Bajirao Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11757",
    "name": "Shette Bhagwan Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7643",
    "name": "Shinde Chandrakant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5979",
    "name": "Shinde Narendra Marutirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4629",
    "name": "Shinde Shivaji Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18691",
    "name": "Shitole Omkar Arun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15242",
    "name": "Shrungare  Sudhir  Vishram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1837",
    "name": "Shukla Rameshkumar Radheshyam."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20028",
    "name": "Singh Darmendar Uditnarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19789",
    "name": "Solanki Jitesh Kishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6438",
    "name": "Suryavanshi Shivaji Rajinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12159",
    "name": "Suvarna K Pushpa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7732",
    "name": "Tamhankar Ravindra Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8716",
    "name": "Tapkire Smita Suhas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8003",
    "name": "Thakur Prakash Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7519",
    "name": "Todkar Manohar Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6461",
    "name": "Tripathi N K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10196",
    "name": "Unavane Masu Bhimaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7131",
    "name": "Waghmare Gangaram Malhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4644",
    "name": "Wakkar Arun Dayal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13723",
    "name": "Yadav Sukhdeo Lodhi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1092",
    "name": "Lingaya Guruya Naglu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2141",
    "name": "Sharma Ramesh R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "501",
    "name": "Chavan Mahadeo Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3137",
    "name": "Borhade Anilkumar Savleram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2648",
    "name": "Bensekar Mohamaed Rafik Jainnuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2536",
    "name": "Kumbhar Shivaji Krishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1293",
    "name": "Galve Vishnu Dnyanu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "237",
    "name": "Srikant Dhondiram Musale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1065",
    "name": "Dadahari Vinayak Gite."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1383",
    "name": "Jaiprakash Daladin Pandye."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3013",
    "name": "Mohmed Mumtajbegam Vali."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2706",
    "name": "Ghode Bhanudas Bhago"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "539",
    "name": "Dnyandev Ganpati Jadhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2421",
    "name": "Dandekar Vilas Murlidhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3025",
    "name": "Bhandari Ramesh Jairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10600",
    "name": "Hanspal  Anil/Manjeet"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2423",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "396",
    "name": "Laxman Durganna Adluru."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2189",
    "name": "Yadav Motaprasad M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2001",
    "name": "Kadam Vasant Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "398",
    "name": "Sanjay Laxman Pujari."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1061",
    "name": "Harischandra  Chauhan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2084",
    "name": "Tamita Mahanram Jagram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2239",
    "name": "Gawade Narayan A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3589",
    "name": "Singh  Brijesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "612",
    "name": "Balasaheb Marutrao Mane"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1176",
    "name": "Darekar Tatyaba Sitaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "931",
    "name": "Kumbhar Suresh Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "623",
    "name": "Mahadev Balu Khade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "260",
    "name": "Salunkhe Damodar Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1070",
    "name": "Bal Sakharam Sakpal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2027",
    "name": "Govekar Vivek Saanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "247",
    "name": "Anjana Prahlad Ghadge."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2694",
    "name": "Choure Haribhaue Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "314",
    "name": "Bhagawan Shankar Dhumal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4488",
    "name": "Dhami Sangeeta U."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3237",
    "name": "Parab Sudhakar Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3245",
    "name": "Dixit Bhaskar Y."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2563",
    "name": "Rambhiya Nitesh Khimagee"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "809",
    "name": "Avate Vasudeo Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2477",
    "name": "Kakkad Kamal Vinod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2041",
    "name": "Sunanda A Pawar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3024",
    "name": "Kanavaje Vijay Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3775",
    "name": "Jaiswal Udaychand Shripat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2392",
    "name": "Mastan Latif Hussain."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "769",
    "name": "Bunty Manohar Java . Manohar M.Java"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3634",
    "name": "Ghaswalw Hasan Ebrahim ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2769",
    "name": "Kanthariya Dineshkumar Manchubhai ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4455",
    "name": "Mestry Waman K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1934",
    "name": "Modak Shankar Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2108",
    "name": "Nair Gopi Dashan ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5155",
    "name": "Patil Jagannath Shriram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4185",
    "name": "Suryawanshi Pandurang R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1894",
    "name": "Agre Mahadeo Barku."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1230",
    "name": "Telge Manohar Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5437",
    "name": "Rawle Sangeeta Sandeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2142",
    "name": "Shetty Bhaskar D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "330",
    "name": "Mulik Vishvas Sarjerao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2201",
    "name": "Nigade Balram Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "793",
    "name": "Vithal Jayaram Kudtarkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2538",
    "name": "Joshi Parshuram Khadakram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4255",
    "name": "Damaniya Jayshree Jeetendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9084",
    "name": "Mahadik Ramchandra Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1278",
    "name": "Vinayak Sarjerao Chavan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15436",
    "name": "Asha  Elizabeth"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11664",
    "name": "Aynodkar Vibha Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15090",
    "name": "Bhoite Devidas Dasharath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5379",
    "name": "Jadhav Gorakhnath Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17448",
    "name": "Kadam Bhausaheb Ramchandra& Kadam N .U."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18041",
    "name": "Mascarenhas Rocky Ivan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7353",
    "name": "Patel Shilpa Bipin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15674",
    "name": "Pendurkar Pramila Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17382",
    "name": "Sanzgiri Manoj Anandrao/Mrs.Ma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19447",
    "name": "Solanki  Narayan Hanuman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12063",
    "name": "Phalke Ashok Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "546",
    "name": "Kisan  Rangarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8786",
    "name": "Ajmeri M Liyakat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5373",
    "name": "Bambardekar Girish Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10283",
    "name": "Bane Shankar Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6409",
    "name": "Bansod Sanjay Kisanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6783",
    "name": "Bhatt Pramod I"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10727",
    "name": "Bhogale Vilas Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8016",
    "name": "Bhosale Gulabrao E/Chotelal Jagdev K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6258",
    "name": "Bhosale Umesh B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7387",
    "name": "Bhuwad Sahadeo Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5474",
    "name": "Boeinvada Sananda Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7818",
    "name": "Chavan Ramprit S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10871",
    "name": "Chawada Humansing Ratansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10737",
    "name": "Chougule Dashrath Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14279",
    "name": "Dasurkar Sanjay Balkrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8879",
    "name": "Desai Vinod Arjun."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8549",
    "name": "Dhuri Sunil Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5310",
    "name": "Gaglani Asha Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6021",
    "name": "Gaikawad Raju Bhikoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6985",
    "name": "Gaikwad Rajendra Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6740",
    "name": "Gaikwad Vinayak Nanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5758",
    "name": "Gamre Pallavi Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18368",
    "name": "Gandhi Asha Hemant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10720",
    "name": "Gaonkar Vasant Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6624",
    "name": "Garde Arun Vishram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5679",
    "name": "Gharat Santosh Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6168",
    "name": "Girase Laxmansing C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6004",
    "name": "Gosawi Jaganath Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6600",
    "name": "Gunjal Suresh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5468",
    "name": "Gupta Ashok Shitalprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5955",
    "name": "Hade Sakharam Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19918",
    "name": "Hule  Deepak  Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5249",
    "name": "Jadhav Nitin Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4880",
    "name": "Jalgaonkar Dattaram Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6432",
    "name": "Jha Subodhakumar/Shivraj/Abdul Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7365",
    "name": "Kadam Dinesh S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13790",
    "name": "Kadam Sindhu Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5235",
    "name": "Kale Kalpana Bhalchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5795",
    "name": "Kamat Subhash Vasudeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17115",
    "name": "Kambale Lata Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7828",
    "name": "Kambale Sugriv Satwaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11312",
    "name": "Kamble Naresh Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6498",
    "name": "Kanu T Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4760",
    "name": "Karani Hansa Harkchand/Mr.Hiten Harkchan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7255",
    "name": "Karluke Vijay Punaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8538",
    "name": "Keni Kusum Praphula"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11026",
    "name": "Kurne Lalita Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4931",
    "name": "Lad Vanita Deelip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2437",
    "name": "Lokare Waman Vitthalrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5422",
    "name": "Loke Aruna Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6160",
    "name": "Malik Atmaram Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10602",
    "name": "Mandhare Vijay Jagdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9903",
    "name": "Manorwala Nasim Bacchumiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10330",
    "name": "Marwadi Shakuntala Ramanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8677",
    "name": "Maynakhawa Mahendra Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5972",
    "name": "Mirge Shrikrishna Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7048",
    "name": "Moglade Anil Shripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5821",
    "name": "More Dadarao Gopalrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9338",
    "name": "Motewad Uttam Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6098",
    "name": "Naik Raju Ganpatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8167",
    "name": "Narijan Ramdas Ashrafi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8444",
    "name": "Palande Bhaskar Babajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9369",
    "name": "Parab Raju Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2932",
    "name": "Patil Subhash H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10860",
    "name": "Patkar Ragho Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6476",
    "name": "Pawar Mohan Sripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6099",
    "name": "Pawar Sagar V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3287",
    "name": "Pereira Hilda Aurelius"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8857",
    "name": "Prajapati Bechan Sahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6683",
    "name": "Rane Madhukar Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13573",
    "name": "Rawal Vinod Ravishankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5832",
    "name": "Sahu  Kumuda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7054",
    "name": "Salunkhe Ashok Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11551",
    "name": "Sankpal Surekha Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10056",
    "name": "Sarate Rajay Subrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6505",
    "name": "Shah Ramesh D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10818",
    "name": "Shaikh Salim Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6801",
    "name": "Shaikh Zerani Isak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8497",
    "name": "Shendkar Babu Khandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5445",
    "name": "Shinde Sandhya Nathuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10691",
    "name": "Shinde Santosh Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6769",
    "name": "Shinde Shantaram Sudam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5446",
    "name": "Shinde Vidhya Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10338",
    "name": "Shukla Vinod Shambunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10595",
    "name": "Singh Ramesh Chhattar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5050",
    "name": "Solani Ashwin C/Rekha A Solani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7090",
    "name": "Swami Gloria George"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6487",
    "name": "Tambe Ganpat Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6428",
    "name": "Thomas  Danial"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13273",
    "name": "Trinathsarkar Tapankumar S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10576",
    "name": "Vaity Raju Niklav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9208",
    "name": "Vajar Nagesh Nagendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7609",
    "name": "Vartak  Kiran."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6158",
    "name": "Vasant Mohan Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7448",
    "name": "Vichare Kisan Bajrang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10827",
    "name": "Wayat Shivaji Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18733",
    "name": "Yadav Rakesh Rampratap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "687",
    "name": "Balabhau Baburao Narawade."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1122",
    "name": "Mohammed Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2525",
    "name": "Pawar Sampatrao Bandu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2653",
    "name": "Liya Hemendra Narottamdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "332",
    "name": "Shah Bharatkumar Chhotalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1030",
    "name": "Ramnaresh  Jayswal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2081",
    "name": "Nainar K S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "235",
    "name": "Tukaram Shankar Hule."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17736",
    "name": "Vora Rajen Vipinchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4377",
    "name": "Thorve Shridhar Bapu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "386",
    "name": "Anandrao Daulatrao Deshmukh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3521",
    "name": "Patel Abdurab Alamgir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7119",
    "name": "Shetty Shivanand Ram/Umabai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7949",
    "name": "Shikare Sunil Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2564",
    "name": "Vazir Usmman Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3332",
    "name": "Nashibdar Riyaj Khan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4316",
    "name": "Appa  Shagufta."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4007",
    "name": "Devan  Babul."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2557",
    "name": "Ingale Suresh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5244",
    "name": "Jaiswal Ramchandra Fulchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2076",
    "name": "Kadam Mangal Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5030",
    "name": "Kasar Pramod Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5165",
    "name": "Muleri Prabhakarrao Chailayashetty"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5140",
    "name": "Rajpal Ghanshyam Saduram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5141",
    "name": "Singh Vinodkumar Chotelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2071",
    "name": "Dharmraj  Nadar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "735",
    "name": "Sawant Prakash Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "83",
    "name": "Vasant Appa Gurav."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1395",
    "name": "Shinde Dagadu Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5293",
    "name": "Bhandari Harishchandra Hareshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2790",
    "name": "Botre Sunita Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3333",
    "name": "Mestri Vijay Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3383",
    "name": "Murarka Rajendra Prasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2481",
    "name": "Vaity Robert Elis."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "557",
    "name": "Chavan Khanderao Yadavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2780",
    "name": "Chalvadi Laxappa Gangappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4147",
    "name": "Matre Khashaba Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1925",
    "name": "Mendes Gilbert Thomas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "681",
    "name": "Balasaheb Nivruti Jaikar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2739",
    "name": "Dusange Dwarkabai Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3306",
    "name": "Kini Jaywant Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "876",
    "name": "Bhandari Hemant Damodar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16056",
    "name": "Rane Dashrath Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4648",
    "name": "Warik Arti Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2090",
    "name": "Shetty Jayakar Menka ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4283",
    "name": "Britto Julie David"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10492",
    "name": "Konde Somnath Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4109",
    "name": "Shinde Bhagawan Limbaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6957",
    "name": "Birajdar Nisha Harichandra/Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2122",
    "name": "Devar Shanmukhm Subramnyam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3693",
    "name": "Pawar Sambhaji Manikrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2763",
    "name": "Bani Arshi Kanbhai ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2376",
    "name": "Tambat Sanjay Dattatrya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2388",
    "name": "Ahamed  Nisar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2341",
    "name": "Hatkar Anita Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2337",
    "name": "P.K.  Muraleedharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2342",
    "name": "Shirodkaar Supriya Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "514",
    "name": "Devendra N Solanki"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "583",
    "name": "Ramnarayan Damodar Dave"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1776",
    "name": "Anpat Malan Vitthal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3833",
    "name": "Matkar Ranjana Vasant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "834",
    "name": "Deelip Vittal Kambale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1953",
    "name": "Punjabi Herdevi K ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3659",
    "name": "Thakkar Pratap Keshav."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3510",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1334",
    "name": "Dsouza  Sabina Pascol"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1929",
    "name": "Hindlekar Ashok Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3756",
    "name": "Acharya Hansa Ajit."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4307",
    "name": "Tarayya Sangeeta Jagdish."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2237",
    "name": "Thakur Shantaram Pitkur."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7976",
    "name": "Bhalerao Shashikant Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1279",
    "name": "Dnyaneshwar Anant Chavan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1251",
    "name": "Deshmukh Sharada Ankushrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3326",
    "name": "Tambe Ravindra Babu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3628",
    "name": "Pandit  Shivalal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4970",
    "name": "Kawar  Balkrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3392",
    "name": "Pathak Surendra Rampal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2092",
    "name": "Shetty  Sudhama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1892",
    "name": "Shinde Ramchandra Sakharam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3365",
    "name": "Kadam Rajendra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1054",
    "name": "Sambhaji Shankar Patil."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3654",
    "name": "Suryvanshi Babu Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3087",
    "name": "Kadam Janardhan Jaiwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "946",
    "name": "Salunkhe Krushnabai Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "157",
    "name": "Nivrutti Kondiram Bhosale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2336",
    "name": "Alfon  Furtado"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "390",
    "name": "Arumugam Suppayya Shetti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2512",
    "name": "Shingre Gulab Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "344",
    "name": "Baban Narayan Kirdat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3162",
    "name": "Satam Hanumant Bandeappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2861",
    "name": "10Dhav Vilasrao Vittal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8009",
    "name": "Adivarekar Ravikant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1494",
    "name": "Agarwal Kanhyalal G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9200",
    "name": "Amberkar Ashwini Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "917",
    "name": "Ambica Hotel."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1264",
    "name": "Ambre Vilas Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "519",
    "name": "Amita Ashok Nagvekar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "898",
    "name": "Ananda Parshuram Mane"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "639",
    "name": "Anil Govind Shigwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2632",
    "name": "Anpat Vitthal Appa."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "431",
    "name": "Ashok Arjun Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1047",
    "name": "Avatar Sing Kaunsal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1083",
    "name": "Avinash S. Hatiskar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "430",
    "name": "Baburao Laxman Thorat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7695",
    "name": "Bakshi Balkrishna Anantram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6873",
    "name": "Bano  Afrose"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "989",
    "name": "Barge Shakuntala Shivji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1983",
    "name": "Bayema B.Abdul Rashid Faras."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2372",
    "name": "Bhagat Prabhakar Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1087",
    "name": "Bhalchandra Gopal Raout."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1416",
    "name": "Bhosale Mahadev Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2054",
    "name": "Bhosale Prakash B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8978",
    "name": "Borole Yadav T."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8679",
    "name": "Chache Arvind Sonu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8583",
    "name": "Chavan Dattatry Baburav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13251",
    "name": "Chavan Mohan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2756",
    "name": "Chavan Rajendara Bhikoba ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9967",
    "name": "Chavan Ruchira Raghuvir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2338",
    "name": "Chavan Shivaji Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1404",
    "name": "Chavan Tukaram Bapuji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5216",
    "name": "Chavan Vanita Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "667",
    "name": "Chedhilal Bhagwandas Yadav."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2355",
    "name": "Chhatbar Ramniklal Vallabhdas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2139",
    "name": "Chhatkar Sharadkumar Vallabhdas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10186",
    "name": "D Souza Doris Francis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8885",
    "name": "Dabholkar Shrikant Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1082",
    "name": "Darade Jagannath Kashinath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7027",
    "name": "Das Prema Robin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "509",
    "name": "Dasan S Ayer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "596",
    "name": "Daulatrao Metih Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "362",
    "name": "Davadratam  Muthu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1864",
    "name": "Desai Mangesh Krishnarao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "553",
    "name": "Desul Jagannath Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1072",
    "name": "Dhanavade Sakharam Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4266",
    "name": "Dhanawade Sushama Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "571",
    "name": "Dhane Kondiram Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2228",
    "name": "Dhatavakar Atmaram Bapu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8447",
    "name": "Dhotrre Naina Dilip."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "987",
    "name": "Dhumate Ananda Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8339",
    "name": "Dhuri Nandadeepak Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8205",
    "name": "Doke Kamlakar Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "661",
    "name": "Druganatha Sundarrao Vaidya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1553",
    "name": "Dukhande Sandeep Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "797",
    "name": "G.M.  Vakataya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5592",
    "name": "Gadekar Subhash Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10175",
    "name": "Gadge Shailesh Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "895",
    "name": "Gandhi Padmini Damodardas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1012",
    "name": "Gangedhare Kondilan S/O Ramah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9917",
    "name": "Gannawala Kranti G"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8647",
    "name": "Gawali Harish Shrikrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2292",
    "name": "Gawand Vithoba Sauba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2613",
    "name": "Ghadage Sambhaji Bandu ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5900",
    "name": "Ghadge Anil Dnyneba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2687",
    "name": "Ghadge Bhagwan Dagdu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2420",
    "name": "Ghandi Baugue Ahmed."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2422",
    "name": "Gopinathan  C.M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1041",
    "name": "Gorishankar Sitaraam Sabbat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8251",
    "name": "Gujar Basantlal Savarmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1690",
    "name": "Gujar Chandrakant Raghunath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1886",
    "name": "Gujar Rishikumar Sunder."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6924",
    "name": "Gupta Chandrashekhar T"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9129",
    "name": "Haldankar Vijay Jagdish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8295",
    "name": "Happan Sambhaji Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4998",
    "name": "Hole Sanjay Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10185",
    "name": "Indrajit  Kaur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9348",
    "name": "Indulkar Krishna Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5022",
    "name": "Ingale Sitaram Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "983",
    "name": "Jadhav Asmita Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2217",
    "name": "Jadhav Bharat Shankarrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1545",
    "name": "Jadhav Kisan Kundlika"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8419",
    "name": "Jadhav Shakuntala Vasant/Vasant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1401",
    "name": "Jagtap Sayajirao Shripatrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1848",
    "name": "Jagushte Vandana Vijay."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6225",
    "name": "Jaipurkar Pandurang Vyankatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1508",
    "name": "Jengid Looram B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4872",
    "name": "Jha Naresh/Ramanand Chaudhari/Ghanshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "628",
    "name": "Joseph M. D Souza"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1665",
    "name": "Joshi Bhavanishankar V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "324",
    "name": "Junnare Radhabai Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2370",
    "name": "Kadam Amol Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2491",
    "name": "Kadam Eknath Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1959",
    "name": "Kadam Vijaya Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2837",
    "name": "Kale  Sangam Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8727",
    "name": "Kambale Subhash Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "476",
    "name": "Kamlakar Shankar Jadhav."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2633",
    "name": "Kanse Vilas Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1608",
    "name": "Kapasi Nafisa Y."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1609",
    "name": "Kapasi Zoher A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6361",
    "name": "Karmare Suresh Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9848",
    "name": "Kaushik Avdhesh Mahesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4012",
    "name": "Khalate Rajendra Bapurao ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8311",
    "name": "Khan Ayub Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1991",
    "name": "Khandagale Hanumant Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10872",
    "name": "Khote Subhash Sitanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "901",
    "name": "Kisan Narayan Mahale"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1578",
    "name": "Koli Shashikant Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1533",
    "name": "Kukani Ajit Mulchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9322",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2575",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7245",
    "name": "Latake Ganesh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "511",
    "name": "Laxman Hiru Fhulare"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9525",
    "name": "Lonbal Jahir Ahmad Amin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8418",
    "name": "M  Dhinakaran."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9445",
    "name": "Madankar Suresh Nagappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "620",
    "name": "Madhukar Barku Gaikwad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "629",
    "name": "Madhukar Jagannath Jamasandekar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7122",
    "name": "Malap Surekha Suryakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1215",
    "name": "Malwande Nagesh Shrirang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1459",
    "name": "Mane Kisan Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1116",
    "name": "Mardekar Bhimrao Maruti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1193",
    "name": "Mhatre Dananjay Manohar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3318",
    "name": "Mhtre Vinayak Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "516",
    "name": "Minakshi Mahadev Raual"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5414",
    "name": "Modhave Shantan Gopichand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2070",
    "name": "Mohamd Salim Mohamed Sahjan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1458",
    "name": "More Parasram Bandu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2954",
    "name": "More Rangarao Vittoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1744",
    "name": "More Shivaji Jayram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5286",
    "name": "More Suman Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5179",
    "name": "More Suneeta Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1845",
    "name": "More Suresh Sakharam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4735",
    "name": "More Vikas Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1471",
    "name": "Mulik Prakash Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7618",
    "name": "Musale Rajesh Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "580",
    "name": "Nair  Rajan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "58",
    "name": "Narayan Hari Mane."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "518",
    "name": "Narendra Ramchandra Bhoir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5015",
    "name": "Nikam Laxman Dynanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "953",
    "name": "Nimbalkar Dilip Dharma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1479",
    "name": "Nimbalkar Subhash Sahebrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "634",
    "name": "Nivruti Maruti Taware"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "624",
    "name": "P. R. Lonappan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9777",
    "name": "Palande Suvarna Bhaskarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4882",
    "name": "Panchal Vithoba Gopinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2464",
    "name": "Parab Dyaneshwar Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "111",
    "name": "Paresh Ramchandra Nawale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1539",
    "name": "Patel Natvarlal P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7992",
    "name": "Patil Alka Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10093",
    "name": "Patil Ashok Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3085",
    "name": "Patil Chandrashekhar Saranappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3801",
    "name": "Patil Prakash Mahadu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3941",
    "name": "Patil Pramod Balaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5213",
    "name": "Patil Ramchandra Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1569",
    "name": "Pawar Pandurang Yashwant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5364",
    "name": "Pawar Shekhar Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1516",
    "name": "Pawar Vitthal Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7670",
    "name": "Phalke Bharat Gulab."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3812",
    "name": "Pingale Vitthal Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10414",
    "name": "Pinto  Rahul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1125",
    "name": "Pise Atmaram Gajanan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7352",
    "name": "Popale Uttam Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "443",
    "name": "Popat Shankar Kadam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6368",
    "name": "Prabha Bhavani Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "523",
    "name": "Prabhakar Trimbhak Gawad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2069",
    "name": "Prakash Sitaram Patil."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "520",
    "name": "Pramila Kamalakar Gawad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "683",
    "name": "Pushpa Dhonduram Devrukhakar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2453",
    "name": "Rai  Shambhu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8377",
    "name": "Rajappan Ramesh P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5061",
    "name": "Rajbhar Rajendra R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1109",
    "name": "Ramesh Harishchandra Sakhare."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "647",
    "name": "Ramesh Motiram Bhandari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "682",
    "name": "Ramesh Narayan Kondalkar ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "360",
    "name": "Ramhajare Bhajwati Yadav."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1738",
    "name": "Rangnekar Balkrishna G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8770",
    "name": "Raul Avinash Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2811",
    "name": "Ravic Kalyanji Valji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7759",
    "name": "Ray Virendkumar Gokula"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14561",
    "name": "Rimal Gangaprasad Jaiprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6936",
    "name": "Rokade Sudam Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "967",
    "name": "Rokade Tukaram Baburao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2454",
    "name": "Roy  Deepa."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2476",
    "name": "Sable Vasant Motiram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7101",
    "name": "Sahani Heema Jaiprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6760",
    "name": "Sakpal Sunita Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2374",
    "name": "Salate Balu Govind."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2522",
    "name": "Saldhanha  Jerry."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9797",
    "name": "Salian M Chandrashekhar N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1427",
    "name": "Salunkhe Chandrakant Gajanan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4732",
    "name": "Salunkhe Hanamant Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5925",
    "name": "Salunkhr Raosaheb Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5892",
    "name": "Sapkal Vijay Laxman/Vinaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2379",
    "name": "Sarfare Avinash Bhaskar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1027",
    "name": "Satish Balkrishana Nimbalkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10078",
    "name": "Satpalkar Mukesh Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10079",
    "name": "Satpulkar Swati Mukesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8305",
    "name": "Save Sandeep Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2722",
    "name": "Selin Kulan Thaisang Chelfiar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7462",
    "name": "Shah Anil M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2758",
    "name": "Shah Jitendra Jivanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5020",
    "name": "Shah Kesh Gagan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6741",
    "name": "Shah Krishnadas Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "554",
    "name": "Shaikh Abdul Majid Munne"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2191",
    "name": "Shaikh Mohmad Miraj Ebrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "723",
    "name": "Shankarrao Genaba Musale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7710",
    "name": "Sharma Lavkush Harimohan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8395",
    "name": "Sharma Ramchandr Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "395",
    "name": "Shashikant Sambhaji Sawant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "813",
    "name": "Shavlal Ramswami Jayram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2407",
    "name": "Shigvan Anand Kashiram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2136",
    "name": "Shinde Chandrakant Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1704",
    "name": "Shinde Sarjerao Baburao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2414",
    "name": "Shinde Shamrao Wamanrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1674",
    "name": "Shinde Shridhar Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4553",
    "name": "Sinari Udaya Radhekrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2163",
    "name": "Sing Balvirkur Jogindar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "984",
    "name": "Singh  Ranjeet."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1455",
    "name": "Sodi Sanjogata S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8876",
    "name": "Solanki Harjiwan J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1912",
    "name": "Sonavane Dadabhau Manaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6429",
    "name": "Sukla Atmaram Ramsumer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2346",
    "name": "Sunil Laxman Deshmukh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "594",
    "name": "Sunita Vasant Kulkarni"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "621",
    "name": "Surendra Baliram Gawande"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2304",
    "name": "Sylvelet  Lyrk Serro ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2333",
    "name": "T .Arul Das."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1049",
    "name": "Tatya Pundlik Vanjari."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7671",
    "name": "Thakur Usha Sitaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16960",
    "name": "Toliya Manoj Mohanbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "485",
    "name": "Tukaram Murlidhar Sabale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5597",
    "name": "Ubale Dinkar Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7929",
    "name": "Umale Santosh Nilkanth"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14415",
    "name": "Varadkar Sarita Dashrath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1190",
    "name": "Vasant Chandrakant P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "595",
    "name": "Vasant Purushottam Kulkarni"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6324",
    "name": "Vastu  Siddhi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2473",
    "name": "Vengurlekar Shashikala Vasant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "226",
    "name": "Vijay Shivram Chavan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "622",
    "name": "Vishwanath Kashinath Chakranarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1750",
    "name": "Vyas Jugalkishor H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1467",
    "name": "Wagh Laxman Krishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1244",
    "name": "Wagh Shubhasha Bhikoba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11272",
    "name": "Yadav Hansadevi Rajbali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2074",
    "name": "Yadav Suresh Kundlika"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1177",
    "name": "Yevale Lalsing Mansing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1557",
    "name": "Zade Sharad Bhaurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4092",
    "name": "Raut Surekha Parashram ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "739",
    "name": "Bebi Vilas Patil."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2979",
    "name": "Ganatra Harish C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "951",
    "name": "Yadav Mukundchand R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1136",
    "name": "Dapase Bandya Babalya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1537",
    "name": "Adam Soma Pundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4464",
    "name": "Sing  Arbindkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1730",
    "name": "Mayavanshi Manilal Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "522",
    "name": "Vincent  Ferreira"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4076",
    "name": "Pawar Prakash Rama ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2531",
    "name": "Bhavana  G.P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "36",
    "name": "Bhosale Hanmantrao Baburao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2877",
    "name": "Jain Nathulal Gulabchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2119",
    "name": "Nikalje Kaduba Kisan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12704",
    "name": "Bajaj Rupesh Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "631",
    "name": "Dhanaji Poonaji Dhangat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3291",
    "name": "Rajbhar Lalita Prasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "411",
    "name": "Dattarya Sakharam Bhalerao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13971",
    "name": "Joshi Sanjay Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2654",
    "name": "Prabhu  Jaylaxmi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3675",
    "name": "Chavan Tulasidas Eknath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "970",
    "name": "Kadam Madhukar Tukaram ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4327",
    "name": "Raut Priya Vijay."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3373",
    "name": "Sakhala Shriram Bhehraramji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5328",
    "name": "Shikhare Madhukar Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "794",
    "name": "Anant Govind Choulkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1639",
    "name": "Wani Rajendra Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2489",
    "name": "Pednekar Anil Shantaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3441",
    "name": "Faruki Mohamad Najibamirsaheb."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7262",
    "name": "Gupta  Shivprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5810",
    "name": "Prajapati  Rajkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4037",
    "name": "Ray Jitendra Udaybhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1354",
    "name": "Gadve Narayan Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "57",
    "name": "Chandrabhaga Shivram Ugale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "155",
    "name": "Baburao Jyoti Jadhav."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4179",
    "name": "Mithbawakar Suverna Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4204",
    "name": "Sheth Prakash Harjivandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4044",
    "name": "Jangapalli Sunil Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1916",
    "name": "Tamata Maheshlal Bahaduram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1298",
    "name": "Gaikwad Rajani Chandrashekhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13679",
    "name": "Mhatre Pravin Nandan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4121",
    "name": "Bhudha Darbar Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2221",
    "name": "Patil Suresh Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7811",
    "name": "Sharma Atul Omprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1234",
    "name": "Yadgiri Kuttapalli Chandriya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "607",
    "name": "Nawadkar Baburao Abuji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1043",
    "name": "Pawar Pushapa Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4701",
    "name": "Bhandari Arun Dwarkanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5145",
    "name": "Chavda Magan Bachubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3981",
    "name": "Desai Iliyas Suleman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5629",
    "name": "Gupta Nachhatradhari S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2296",
    "name": "Devani Vinodkumar Mohanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3518",
    "name": "Bagewade Veerabhadra Madukappu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2983",
    "name": "Borade Lahu Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12491",
    "name": "Lewis Reynold Joseph Lawrence"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4524",
    "name": "Phatraphod Minaxi M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "807",
    "name": "Gaikwad Suresh Keru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "798",
    "name": "Pratap Ramchndra Warang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "955",
    "name": "Shigwan Vajantabai Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1121",
    "name": "Gupta Rajendra Prasad Satyanarayan"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "103",
    "name": "Jai Bhavani Enterprises"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "262",
    "name": "Jai Mata Di Elect"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1653",
    "name": "Jadhav Ravindra Charan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1476",
    "name": "Kadam Ramesh G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1926",
    "name": "Thakur Ashok Kumar Ganesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8072",
    "name": "Adhav Kamal Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2348",
    "name": "Aravind Sakharam More."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "499",
    "name": "Ashok Vishnupant Katke."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4437",
    "name": "Bansode Mahendra M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7283",
    "name": "Bhalerao Haribhau Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4689",
    "name": "Bhosale Baban Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2301",
    "name": "Chandrakant Chintaman Gavad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9721",
    "name": "Chavan Santosh Shripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13112",
    "name": "Choudhary Mahamad Rafik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11882",
    "name": "Dalavi Kalyani Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8711",
    "name": "Damale Prabhakar Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9481",
    "name": "Dandpal  Bijaykumar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "392",
    "name": "Deshmukh Vidya Gorakhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9717",
    "name": "Dhillon  Raveesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "71",
    "name": "Dilip Shankarrao Chavan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2767",
    "name": "Dixit Bhalchandra B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10171",
    "name": "Gaikwad Aruna Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "230",
    "name": "Govindrao Shankarrao Salunkhe"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "462",
    "name": "Gulambi Ghaffur Shaikh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1585",
    "name": "Gunjawate Sarjerao Akaray."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8740",
    "name": "Gupte Sagar Shantikumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7956",
    "name": "Had Smeeta Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4768",
    "name": "Ikbal Parvin H A Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7843",
    "name": "Jadhav Rajendra Vishawanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5393",
    "name": "Jagade Ravindra Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6722",
    "name": "Jain Premlata Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9206",
    "name": "Jaiswal  Rakesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "792",
    "name": "Jetendra M Doshi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "28",
    "name": "Kadam Dinkar Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1562",
    "name": "Kadam Dinkar Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17722",
    "name": "Kamble Vinayak Yashawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9918",
    "name": "Kaushik Lalit Shivdutt"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10408",
    "name": "Kedar Raghunath Rau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12987",
    "name": "Khan Abdul Vahi A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10371",
    "name": "Kharat Ganesh Piraji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10277",
    "name": "Khopade Dhanagi A."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4807",
    "name": "Kshirsagar Dashrath Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6245",
    "name": "Lad Vinayak Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17710",
    "name": "Londhe Prashant Pandhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9601",
    "name": "Lourdmary George Peter"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5644",
    "name": "Mandhare Madhukar Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8342",
    "name": "Manvatkar Haribhau Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5114",
    "name": "Matkar Jayshree Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5685",
    "name": "Menezes  Gracy"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "679",
    "name": "Mohite Haribhau Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16282",
    "name": "Mohite Vasant Aaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1346",
    "name": "Mohmed Yunus G"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8168",
    "name": "More Dilip Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4458",
    "name": "More Laxmibai Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11077",
    "name": "More Yuvraj Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7741",
    "name": "Mourya Ajaykumar Jagnnath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8166",
    "name": "Mourya Vinod Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6531",
    "name": "Nalawade Mahendra Kailash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8345",
    "name": "Nalawade Uttam Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1256",
    "name": "Nanu Narendra Mehta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1488",
    "name": "Nikam Uddhav Keshavrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2766",
    "name": "Pandit Madhukar B ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9305",
    "name": "Pangerkar Jyoti Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8126",
    "name": "Parab Vishwanath Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9296",
    "name": "Parmar Kanti Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8051",
    "name": "Pathe Sapana Sopanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4940",
    "name": "Pawar Nathuram Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "277",
    "name": "Pisal Sopan Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17156",
    "name": "Pujari Jagannath Pirappa /Mrs.Gita Jagan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11465",
    "name": "Pujari Vinoda Sinkran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "50",
    "name": "Ramdas Eknath Hule."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5010",
    "name": "Reddy Raju Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1340",
    "name": "Sabale Laxman Dasharath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1400",
    "name": "Sabnis Shyam Mangesh ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9260",
    "name": "Sagar Ravi Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "656",
    "name": "Sahadeo Laxman Patil."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6573",
    "name": "Saiyad Sardar Kadar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8050",
    "name": "Sarkare Padmavati Yashawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10147",
    "name": "Sathe Jayant Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "92",
    "name": "Sawant Babanrao Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10112",
    "name": "Sawant Sudhir Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7305",
    "name": "Sellappa S Kumari Velimmmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "962",
    "name": "Shah Chandrakant C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10145",
    "name": "Shaikh Rokhia Yusuf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2329",
    "name": "Shamalkumar  Sharma."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9990",
    "name": "Sheth Hemaben Satish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2782",
    "name": "Shinde Jotiram Dhondiba ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9107",
    "name": "Siddhesh Anil Balvant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "971",
    "name": "Sigh Mathroo Gurmiwder."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4572",
    "name": "Solanki Jayanti Damajee ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6121",
    "name": "Sukate Shevantrao Rangarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "138",
    "name": "Suresh Sopanrao Jadhav."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15630",
    "name": "Thakur Manoj Hirachand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7920",
    "name": "Tidu  Filomina"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4359",
    "name": "Vajirkar Suhasini Sushant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9681",
    "name": "Veera Pravin Jayantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9680",
    "name": "Veera Ranjana Pravin"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "849",
    "name": "Jain Jewellers"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10599",
    "name": "Wagh Kachru Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4143",
    "name": "Patil Mohan Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2369",
    "name": "Dap Shushanta Kumar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1850",
    "name": "Lingampilli  Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "364",
    "name": "Laxman Purshottam Pilankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1658",
    "name": "Sharma Padmaraj G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1396",
    "name": "Pawar Shobha Ramdas ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "894",
    "name": "Sheth Navin Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "427",
    "name": "Mallama Poshanna Dadu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1757",
    "name": "Bhosale Shivaji Gopal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3650",
    "name": "Musale Ravindra Namdeo ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8449",
    "name": "Gondal Santosh Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "686",
    "name": "Manohar Mulchan Java."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1928",
    "name": "Shivsena Ambulance Shakha No 117"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "787",
    "name": "P. B. Lahothakashan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "728",
    "name": "Gupta Rajaram Kokil."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4340",
    "name": "Brid Pravin Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4303",
    "name": "Jose  M.L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3116",
    "name": "Rauat Bharat Adnyan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4291",
    "name": "Suryavanshi Dhanaji Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4287",
    "name": "Tondon Mita Bharatkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "131",
    "name": "Suraj Shivaji Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "844",
    "name": "Bhagwan Bajirao Kasurde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "188",
    "name": "Vilas Mugutrao Chavan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2480",
    "name": "Adak Dyneshwar Harichandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1997",
    "name": "Ramjadhe Narayan Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2583",
    "name": "Singh Rajesh Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1945",
    "name": "Tendulkar Bhalchandra Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1546",
    "name": "Koli Fulumina Duming"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3554",
    "name": "Nunia Dwarkaprasad Shamlal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3403",
    "name": "Gori Anis Fakir Mo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1729",
    "name": "Kumbhar Dyandeo Namdeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1531",
    "name": "Rajbhar Suresh Lali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3676",
    "name": "Kale Prakawsh Hariba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5481",
    "name": "Nair  Sureshkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4077",
    "name": "Nai Deepchand Purnamal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4230",
    "name": "Puniya  Mahendrakumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2357",
    "name": "Shinde Mandakini Prakash."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11937",
    "name": "Shinde Vishwas P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1147",
    "name": "Thomas  Joseph."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2610",
    "name": "Kharade Pandurang Antu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4749",
    "name": "Dhampurkar Prathnesh Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "992",
    "name": "Pawar Anandrao Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4412",
    "name": "Joshi Swapna Dhananjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1409",
    "name": "Rangnath Bhola Khandekar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8495",
    "name": "Bhandare Surendra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2288",
    "name": "Kadam Rajendra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1474",
    "name": "Ravat Ravindra Sinh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1202",
    "name": "Sukumaran  T.N."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7489",
    "name": "Cheda Arvind Ratilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7490",
    "name": "Cheda Chandu Ratilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "994",
    "name": "Mahale  Bhalchandra Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2042",
    "name": "Souapanna  Mariappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4481",
    "name": "Ahmadkhan  A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4797",
    "name": "Chaudhary Sachindra Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4393",
    "name": "Mohamed Sharif Mohamed Salim."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5029",
    "name": "Poojari Chanddya Kadiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4477",
    "name": "Poonita  Antony"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4276",
    "name": "Rinayat Suraj Chandulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4338",
    "name": "Shinde Hemantkumr Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2897",
    "name": "Gulwadi Nitish Naganand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1391",
    "name": "Dsouza  Clive Ignatius"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3561",
    "name": "Pallai Ramchandra Bhaskar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "261",
    "name": "Hule Pakash Venunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4530",
    "name": "Jain Pramod Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2604",
    "name": "Havlader Mohd Rafik Abdul Mannan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "438",
    "name": "Dwarka Arvind Kadam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "533",
    "name": "Suresh Shridhar Sawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3935",
    "name": "Bhosale Pushpa Bhagwan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2125",
    "name": "Ambare Jaysing Mansing ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3127",
    "name": "Parmar Girish L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9624",
    "name": "Aagam Dinkar Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8322",
    "name": "Abdul Gaful Kadar Sharif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18470",
    "name": "Acharekar Chetana Chintaman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3911",
    "name": "Agarawal  Satyanarayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9663",
    "name": "Ahire Raju Natha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8041",
    "name": "Ahirekar Maruti Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6824",
    "name": "Ahmed Sakeel Ahmed Kamal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8536",
    "name": "Ali Sayyad Manjoor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10030",
    "name": "Alwe Pramod Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3122",
    "name": "Ambre Suresh Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8181",
    "name": "Amin Surendra G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1286",
    "name": "Anjayya  Mistry."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2659",
    "name": "Anpat Rupchand Nivrutti ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9406",
    "name": "Ansari Mohd Harun Fale"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8660",
    "name": "Apraj Sumati Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4674",
    "name": "Asaram Mahadeo Jagdand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9399",
    "name": "Azaz Ahemad Mohmed Hanif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7724",
    "name": "Balze India Pharmaceticals."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4822",
    "name": "Barvakar Bapu Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3913",
    "name": "Behra Bhikari Anot."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10262",
    "name": "Bhambe Rajiv Navneet."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1695",
    "name": "Bhandari Suresh Mangal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7070",
    "name": "Bhandari Vithabai Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5418",
    "name": "Bhise Chandrakant Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9875",
    "name": "Bhoir Madhukar Nago"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3067",
    "name": "Bhosale Madhukar Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9392",
    "name": "Chaubel Rajpati Ramsatyaki"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2642",
    "name": "Chavan Nandkumar Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2713",
    "name": "Chavan Ranjana Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4279",
    "name": "Chavan Shahuraj D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3608",
    "name": "Chavan Subhash Kahnu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5230",
    "name": "Chouhan  Rajeshkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6823",
    "name": "Chouhan Rajesh Ramadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3596",
    "name": "D Souza John B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8644",
    "name": "D Souza Mary G/Rosalind F"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2714",
    "name": "Damale Prabhakar Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9497",
    "name": "Daundkar Shivaji D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2439",
    "name": "David  K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4891",
    "name": "Deshmukh Ankush Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9471",
    "name": "Deshmukh Nagesh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6525",
    "name": "Deshpande Mahesh Shrikrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11299",
    "name": "Devaiya Bhagwati Natulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11262",
    "name": "Dhabse Ganga Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3666",
    "name": "Dhane Ramesh Dadasaheb."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4930",
    "name": "Dharaskar Geeta Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10149",
    "name": "Dhekale Gautam Popat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3534",
    "name": "Dhumal Vinayk Nivrutti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9506",
    "name": "Dilsne Ramesh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8113",
    "name": "Disoza Vidya S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9182",
    "name": "Dongre Mangal Pradeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4043",
    "name": "Gaikar Kashinath Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10378",
    "name": "Gaji Sikander Zainal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1606",
    "name": "Ganesh Electronocs"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3182",
    "name": "Garalkar Sunita Baburao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10740",
    "name": "Gawade Sunil Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3244",
    "name": "Gawande Mahadev Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6036",
    "name": "Gawde Mahesh Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3795",
    "name": "Gawhale Ambadas Ramji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4933",
    "name": "Ghadge Dattaram Raghu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9573",
    "name": "Ghadi Vasudev Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2814",
    "name": "Ghanekar Sunita Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8323",
    "name": "Gulam Subhani Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7698",
    "name": "Gulhane Bhaskar Narhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8138",
    "name": "Gulmohanmmad  Hamidali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9648",
    "name": "Gupta Rajkumar Ramlakhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11399",
    "name": "Gurakha Birka Jaising"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9387",
    "name": "Hafijur Rehman Mohd Iliyas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4858",
    "name": "Hande Ambarnath Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9779",
    "name": "Hanif Mohamad Kasam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8141",
    "name": "Hasan Mohammad Alifhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7032",
    "name": "Indalkar Navnath Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9749",
    "name": "Iqbal Ahmed Rais Khan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8103",
    "name": "Jadhav Bhimsen Kanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3305",
    "name": "Jadhav Suman Hindurao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7773",
    "name": "Jagtap Dilip Dajiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "541",
    "name": "John  Johnson"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9748",
    "name": "Jon Albert Brito"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3068",
    "name": "Kadam Gopinath Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4531",
    "name": "Jain Vipul Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7368",
    "name": "Kadam Habirrao Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9467",
    "name": "Kadam Vijaya Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3649",
    "name": "Kakapoil Sundar Velayudhan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7351",
    "name": "Kalai Nagendra Ramappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4177",
    "name": "Jainam Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10913",
    "name": "Kamath Swetha V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4152",
    "name": "Kambale Sharda Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9527",
    "name": "Kamble Baswant Santram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3885",
    "name": "Kamble Gautam Hariba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4453",
    "name": "Kamble P. R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6183",
    "name": "Karekar Narhari M/Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10536",
    "name": "Kedar Sunanda Khadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1610",
    "name": "Keni Jagdish Dadodar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3962",
    "name": "Kenjale Parvatibai Piloba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1641",
    "name": "Kenjale Sunil Khashaba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9795",
    "name": "Khan Salim Mukbil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5826",
    "name": "Khan Shabana Shahabuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2783",
    "name": "Khan Shahaja Basid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3882",
    "name": "Khandare Rajaram Rangrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2737",
    "name": "Khanna Kanchan Davinder"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4999",
    "name": "Kharat Sambhaji Yashwantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8789",
    "name": "Khatara  Devilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6825",
    "name": "Kulkarni N P/Aruna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2546",
    "name": "Kumbhar Nanda Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "496",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3254",
    "name": "Landge Geeta Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6714",
    "name": "Lokhande Shankar Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7667",
    "name": "Mahamad  Noor."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9523",
    "name": "Mali Chandrabali Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3324",
    "name": "Mani  Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7756",
    "name": "Marchant Arif Ebrahim."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17269",
    "name": "Mate Makrand Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4210",
    "name": "Menan Jan Mohmed Karim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9728",
    "name": "Mishra Jamnaprasad Rambachan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9593",
    "name": "Mishra Markande Yugal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8748",
    "name": "Mishra Prasanta Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3566",
    "name": "Mohamad Yusuf Mehaboob."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9397",
    "name": "Mohd Masood Jumman Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7857",
    "name": "Mohite Jyoti Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7686",
    "name": "More Santosh Harichandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3488",
    "name": "More Shantaram Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7965",
    "name": "Morya Ramesh Kumar Jeevan Andan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4584",
    "name": "Motewad Laxman K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2925",
    "name": "Mulani Nanik Hariram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8140",
    "name": "Mulya Anand Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10183",
    "name": "Mundokar Prabhakar Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7619",
    "name": "Musale Anil N."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8194",
    "name": "Nadar Thilakraj Rajapudi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "921",
    "name": "Nagavankar Ramesh Govind."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8024",
    "name": "Nagvekar Gangaram A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2818",
    "name": "Narayan Namdeo Pawar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7595",
    "name": "Natrajan  V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18436",
    "name": "Nimavat Vina Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6713",
    "name": "Panchal Ashok Chhagan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11157",
    "name": "Panchal Janardhan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10358",
    "name": "Panchal Manohar Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9649",
    "name": "Pande Prakash Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6465",
    "name": "Parkar Prasad Shrikrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10218",
    "name": "Parmar Umesh Kanti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3183",
    "name": "Patel Manubhai B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4677",
    "name": "Patil Anant Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8215",
    "name": "Patil Bharat Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4450",
    "name": "Patil Gulab Shaligram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2669",
    "name": "Patil Maruti Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2224",
    "name": "Patil Mohan Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4480",
    "name": "Patil T. B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6696",
    "name": "Patkar Sarita Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2361",
    "name": "Pawar Balu Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4554",
    "name": "Pawar Laxman Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5353",
    "name": "Pawar Mahesh Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3947",
    "name": "Pawar Raju Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4097",
    "name": "Pawar Sitaram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7028",
    "name": "Pawar Subhash Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2625",
    "name": "Pawar Sumant Sitaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5699",
    "name": "Pendhari Vaishali Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9524",
    "name": "Pereira Alphonsus Antony"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8439",
    "name": "Poojari Asha Vijay."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8528",
    "name": "Poojari Narayan Baccha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5320",
    "name": "Prasad Munnar K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6860",
    "name": "Pujari Sunil Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6110",
    "name": "Raithathe Meena Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6421",
    "name": "Rajani Salim Meherali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8192",
    "name": "Rajput Vinodkumar Tilak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5702",
    "name": "Rane Deepa Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10180",
    "name": "Ranshinge Rekha Sidharth"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3893",
    "name": "Rasal Suresh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4294",
    "name": "Reddy Shantaram Baba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9752",
    "name": "Sakhade Shailesh Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3211",
    "name": "Salukhe Laxman Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7454",
    "name": "Salunke Vials Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5570",
    "name": "Salunkhe Pralhad Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9856",
    "name": "Sankhe Anil Gangadhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2576",
    "name": "Sarkar  Madhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8055",
    "name": "Sawant  Aparna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10104",
    "name": "Sawant Milind Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9521",
    "name": "Shaekh Hussain Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1145",
    "name": "Shah Bharatkumar Chhotalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8440",
    "name": "Shah Rajkumar R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2446",
    "name": "Shah Vasantiben K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3580",
    "name": "Shaikh Harun Ysuf ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3894",
    "name": "Shaikh Mohammed Papa."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9405",
    "name": "Sheshadri  Vittal  L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5359",
    "name": "Shigwan Ramchandra Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5501",
    "name": "Shinde Balkrushna Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8500",
    "name": "Shinde Chandrasen Arjunrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5337",
    "name": "Shinde Namdeo Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "725",
    "name": "Jaiswal Sareen Art"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3043",
    "name": "Shinde Prakash Bhanudas ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4961",
    "name": "Shinde Prakash Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9708",
    "name": "Shinde Rajaram Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2349",
    "name": "Shirvalkar Suresh Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9726",
    "name": "Shivbahadur Kadedin Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7113",
    "name": "Shrivastava Sangita Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "325",
    "name": "Shriyan Bhaskar J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9652",
    "name": "Siddique Mohd Salim Mohiddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9787",
    "name": "Singh Lalan Ramnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6972",
    "name": "Singh Vidhyadevi R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7233",
    "name": "Sonawane Lilabai Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "243",
    "name": "Sopan Krishna Sontakke."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7361",
    "name": "Surve Pandurang Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6710",
    "name": "Suryavanshi Suryakant Nanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2626",
    "name": "Suryawanshi Sulabai Sitaram ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5464",
    "name": "Tamse Digambar Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5081",
    "name": "Tiwari Surendraprasad R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4486",
    "name": "Tripathi  M.D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2445",
    "name": "Trivedi Umesh Gourishankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4876",
    "name": "Utekar Varsha Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4454",
    "name": "Vaishav  B.L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8364",
    "name": "Waghmare Balu Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8033",
    "name": "Walkar Prakash Ravji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8361",
    "name": "Watkar Asha Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7961",
    "name": "Yadav Jiledar Bechy"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9924",
    "name": "Yadav Pannalal Ramdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6794",
    "name": "Yakub Mohammad Afazal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "600",
    "name": "Prabhakar Tukaram Wagh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2517",
    "name": "Prajapati Shailesh Gangarambhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2657",
    "name": "Salunkhe Bhanudas Hanmant ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4421",
    "name": "Memon Ebrahim N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1819",
    "name": "Shinde Madhukar Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4197",
    "name": "Deshmukh Dilip Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3018",
    "name": "Yadav Avadhnarayan S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1847",
    "name": "Nair Mohan M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4537",
    "name": "Barwarkar  C.D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5242",
    "name": "Chawan Sarjerao Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3822",
    "name": "Jengid Motilal Balaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4380",
    "name": "Sharma Sushilkumar Ramswaroop."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2997",
    "name": "Udaywar Prabhakar P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4062",
    "name": "Sawant Ananda Bapu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4695",
    "name": "Momin Khalik Shikandar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8100",
    "name": "Pednekar Rajesh V/Anita"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2358",
    "name": "Jain Bhagvatilal Arjunlal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4057",
    "name": "Gadkari Rohini Parshuram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2000",
    "name": "Kubde Vijaya Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1982",
    "name": "Arjun Nathu Kelgane."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "799",
    "name": "Shirke Balkrishna Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2406",
    "name": "Gholap Namdeo Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3896",
    "name": "Singh Arvind Bhupendranath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2366",
    "name": "Gaikar Vandana Ravaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6279",
    "name": "Malandkar Khrushna Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6017",
    "name": "Pavaskar Parshram B."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1045",
    "name": "Jalaram Wood Decor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "53",
    "name": "Rajashri Vinod Ghuge."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5150",
    "name": "Sawant Eknath Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4679",
    "name": "Tupkar Ramchandra Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2899",
    "name": "Utekar Parshuram Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3961",
    "name": "Savratkar Krishna Abaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1315",
    "name": "Sirsat Subhash Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1865",
    "name": "Dhadve Tanaji Namdeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3479",
    "name": "Gaikwad Anant Krishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4261",
    "name": "Thorve Vandana Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4555",
    "name": "Tembe Sharde S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1833",
    "name": "Joshi Bharat Ratilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1968",
    "name": "Naik Ram Murti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5773",
    "name": "Patil Vishnu Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4317",
    "name": "Survade Shravan Kacharu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3902",
    "name": "Pradhan Kundalik Khandoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3867",
    "name": "Sakunde Atmaram Namdeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5290",
    "name": "Chavan Dilip Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3559",
    "name": "Khare Hanmant Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1570",
    "name": "Patil Mangala Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2066",
    "name": "Sujata Satish Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "760",
    "name": "Poojari Shekhar Budha"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1288",
    "name": "Janata Trading Co."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3946",
    "name": "Pradhan Pooja Vijay."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "72",
    "name": "Devram Sakharam Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "236",
    "name": "Jalindar Shankar Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "811",
    "name": "Kishor Daulat Mane."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3778",
    "name": "Sawant Ganpat Atmaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3190",
    "name": "Verma Premadevi Shivbodhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11134",
    "name": "Adhikari Sanjay Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2160",
    "name": "Anardy Sudhakar Dattaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2161",
    "name": "Anardy Sushila Sudhakar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "127",
    "name": "Baban Rambhan Khomne."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6612",
    "name": "Bagwe Vandana D"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "110",
    "name": "Jannat Beer Shop"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2094",
    "name": "Bahaddur Hira ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5860",
    "name": "Balade Dnyanoba Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2144",
    "name": "Barot Dayabhai Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16064",
    "name": "Bhabarekarnagar Rahiwashi Sangh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1432",
    "name": "Bhoite Ashok Raosaheb."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13114",
    "name": "Chaudhary Satish Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15924",
    "name": "Chavan Popat Jaganath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2681",
    "name": "Cheda Amrut Nawjee"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7876",
    "name": "Dhangat Dhondiba Genubhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2096",
    "name": "Doss Maria"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3535",
    "name": "D'Sylva  Robert."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4410",
    "name": "Dudhwadkar Achala Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "913",
    "name": "Frances  Pereira"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5609",
    "name": "Gad Mahadeo Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13438",
    "name": "Gadhe Hanumant Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1399",
    "name": "Gaikwad Ajay Subhash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "297",
    "name": "Jat Textile Machinary Maintenance Service"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5667",
    "name": "Gawakar Devanand Narahari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14287",
    "name": "Ghadi Ranjeeta Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9183",
    "name": "Gimbal Vasanti S/Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7630",
    "name": "Gupta Rambruj Dukhiprasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7774",
    "name": "Hatagale Damu C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1978",
    "name": "Jacob Abraham"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6006",
    "name": "Jeewa Asif Umar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1941",
    "name": "Kambale Padminee Manohar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9823",
    "name": "Kamble Bhimrao Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1540",
    "name": "Kambli Pradeep Digambar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5583",
    "name": "Kawar  Balkrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1919",
    "name": "Kayat Mohanlal Bhaurilal ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7582",
    "name": "Keni Arvind Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5333",
    "name": "Khatib Sohel Najir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7758",
    "name": "Khoja Sultan Ebrahim."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5601",
    "name": "Lavangare Vitthal Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6135",
    "name": "Lawade Shaligram Kudsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9354",
    "name": "Lobo George Allasis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2154",
    "name": "Mahadik Ram Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4373",
    "name": "Mardhekar Sarjerao Dadu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2145",
    "name": "Mistry Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9273",
    "name": "Narvankar Prakash Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8490",
    "name": "Navalu Varsha Chandrkant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1853",
    "name": "Pal Ramgopal M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2742",
    "name": "Palpandi  P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17653",
    "name": "Panchal Jaswant Popatlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6247",
    "name": "Parab Vilas Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15920",
    "name": "Patel Ritaben Chturbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5673",
    "name": "Pathare Chandrakant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "43",
    "name": "Pawar Bhanudas Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2413",
    "name": "Pawar Dattaram Dagadu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12688",
    "name": "Pisal Shashikala Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8744",
    "name": "Pujari Prakash Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7764",
    "name": "Rahate Prakash Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1642",
    "name": "Ramchandani Hemant Dipchand."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4258",
    "name": "Jay Jinendra Co  Op Cedit Society Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "315",
    "name": "Jay Krishna Traders"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2073",
    "name": "Ramesh Prangivan Parmar.0"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3136",
    "name": "Rana Padan Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7870",
    "name": "Rashidharan Omkar Ponnayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5768",
    "name": "Rodrigues Jerald Lawrence"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11245",
    "name": "Roy Sanjivkumar R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7291",
    "name": "Ruchh Jaysukh Tribhovanduj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2101",
    "name": "Salgoankar Namdev Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13627",
    "name": "Samuel Glenn Mathews."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5743",
    "name": "Sarif Salim Mohmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5304",
    "name": "Sawant Ram Ratnoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7939",
    "name": "Selwan A Kalai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2062",
    "name": "Sethey Suryakant Mkoe."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6197",
    "name": "Shaikh Mahabusaheb Husainsaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2712",
    "name": "Sheth Naresh Chandulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1517",
    "name": "Shinde Mahendra Attmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7653",
    "name": "Singh  Sureshlal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7728",
    "name": "Singh Naresh Sukar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18029",
    "name": "Singh Rsamakant Tejbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4973",
    "name": "Solani Ashwin C"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2164",
    "name": "Somsekharan  C.P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6918",
    "name": "Sultan Md Arif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1592",
    "name": "Surve Anant Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7073",
    "name": "Surve Vinayak Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7053",
    "name": "Taithatha Urmi Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5537",
    "name": "Thevare Nanda Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "863",
    "name": "Udayan  Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8848",
    "name": "Vishwakarma Palak Dhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11514",
    "name": "Waghamare Jyoti Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7638",
    "name": "Ware Narayan Sadashiv."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5064",
    "name": "Yadav Minaxi Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5027",
    "name": "Yadav Suresh Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1814",
    "name": "Rajput Kuwarsing Dhansing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7117",
    "name": "Vaze  Mahesh/Manjiri"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "691",
    "name": "Mohan Appaji Dalavi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4160",
    "name": "Shinde Vitthal Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2859",
    "name": "Nawadkar Vittal Bhikoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1722",
    "name": "Mahangade Sanjay Nanaso."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6652",
    "name": "Gainak Suresh Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "782",
    "name": "Jaiswal Amarnath Radheshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4987",
    "name": "Parikh Rama Navnitlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2535",
    "name": "Nigade Subhash Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4032",
    "name": "Padamsingh  Lokbahadur."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4219",
    "name": "Pagare Ramchandra Barku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4218",
    "name": "Poonam Ashok Dodlani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "849",
    "name": "Shakuntala Shrirang Mahangade."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2664",
    "name": "Shirke Gopichand Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4693",
    "name": "Gaikwad Mahadeo Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7451",
    "name": "Valunj Pandurang Rakhamaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2088",
    "name": "Joshi Parshottam Kalidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "399",
    "name": "Satyawan Mahadeo Kawade."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11063",
    "name": "Naik Megha Ramnath/Rupeshri Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1785",
    "name": "Kamble Shankar Sambhaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2485",
    "name": "Kambli Suresh Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3507",
    "name": "Bangera Ishwar Ghuma."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7001",
    "name": "Dhamapurkar Vijaya Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3506",
    "name": "Dubey Gajanand Badriprasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3356",
    "name": "Mandal  Alauddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2896",
    "name": "More Sadhashiv Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "762",
    "name": "Ziguriprasad  Kanojia."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1283",
    "name": "Gajare Ghanshyam Shivram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2297",
    "name": "Saini  Rajendraprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1628",
    "name": "Jineswar Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "118",
    "name": "Ramesh Namdev Gaikwad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "542",
    "name": "Ramabhilas  Yadav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "472",
    "name": "Prakash Tukaram Deshmukh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "379",
    "name": "Hanumant Baburao Nawadkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1187",
    "name": "Palekar Sumati Parshuram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12000",
    "name": "Khalate Rajendra Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "674",
    "name": "Jivan  Collection"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3556",
    "name": "Khan Jarzana Vali."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5575",
    "name": "Dube Janardhan Parasnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3207",
    "name": "Ghevande Bhanudas Shripati."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "394",
    "name": "Namdev Kerappa Kamble."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4496",
    "name": "Rokade  D.S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4034",
    "name": "Aliyas Wilson Machyado."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2806",
    "name": "Dhumal Indubai Shivajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3601",
    "name": "Modak Prakash Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3881",
    "name": "Dhekane Nilam Nandakumar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6214",
    "name": "Aabhale Arjun Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11443",
    "name": "Amre Jayashree Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5092",
    "name": "Arolkar Leena Lavu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8058",
    "name": "Bhan  Pranay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5100",
    "name": "Chavan Lalita Ladu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13172",
    "name": "Chheda Chandrakant Thokarsi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5406",
    "name": "Chourasia  Umesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6951",
    "name": "Chourasiya Laxminarayan Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11001",
    "name": "Desai Sunil Vasant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6853",
    "name": "Devid Jems Maikal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4878",
    "name": "Dhawale Bhagwan Janu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7284",
    "name": "Gotmukale Shivaji Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6410",
    "name": "Gupta Ginnilal Pitambar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4426",
    "name": "Jadhav Sunil Sudam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5732",
    "name": "Jadhav Vijaya Suhas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4838",
    "name": "Jagtap Sanjay Yadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17766",
    "name": "Jain Kamala Prakash/Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6755",
    "name": "Joshi  Sahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10320",
    "name": "Kadam Manisha Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8476",
    "name": "Kadam Namdeo Nilkanth"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9491",
    "name": "Kadam Sangeeta Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8212",
    "name": "Kamble Dhananjay Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4741",
    "name": "Kansara Nayna Jayant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1267",
    "name": "Karanjekar Dinesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "502",
    "name": "Kavar Maruti Dnayu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7152",
    "name": "Kawar  Balkrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1770",
    "name": "Kenjale Mohan Sarjerao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5997",
    "name": "Khan Arif Isuf/Amrin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5098",
    "name": "Khan Mohmed Ehasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5307",
    "name": "Khan Rehman Khan Sanapmstan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4978",
    "name": "Kirve Vishnu Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4767",
    "name": "Korde Yogesh Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5696",
    "name": "Latke Neeta Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8340",
    "name": "Madhale Shravan Bharmu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6333",
    "name": "Malekar Prabhakar Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8762",
    "name": "Mandhare Mandakini Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12481",
    "name": "Mandhare Subhash Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14786",
    "name": "Mishra Rakesh Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5112",
    "name": "Mourya Ram Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7180",
    "name": "Nale Anil Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12474",
    "name": "Nikam Dilip Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7299",
    "name": "Panchal Rajesh Hasmukhlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14952",
    "name": "Panigrahi Santoshkumar Jagannath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6888",
    "name": "Pathan Kisanlal Chhunnidas Kurli"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3008",
    "name": "Pawar Krishanath Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7345",
    "name": "Pillai Pradeesh Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6284",
    "name": "Prajapati Jalapadevi Budharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1643",
    "name": "Pujari Kamal Dashrath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2805",
    "name": "Pujari Vijay Laxmanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6669",
    "name": "Puralkar Mohan Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4802",
    "name": "Rasal Prakash Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4128",
    "name": "Renuka Mahadeo Pendarkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6843",
    "name": "Salunkhe Dipak Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5130",
    "name": "Salunkhe Prabhavati Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6275",
    "name": "Salunkhe Shobha Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12431",
    "name": "Sankpal Sambhaji Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7403",
    "name": "Saroj Omkar Shivcharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8347",
    "name": "Sawant Ramsing Birbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5953",
    "name": "Shaikh Mansoor Ahmed Juman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2130",
    "name": "Shete Vinayak Shankar ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5055",
    "name": "Shetty S Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17999",
    "name": "Shirke Bharti Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16124",
    "name": "Sinha Mithilesh Son Of Gopalsharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6999",
    "name": "Sukum Ankush Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6576",
    "name": "Sumra Kasam Mohmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7688",
    "name": "Sutramaniyan  T."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4067",
    "name": "Tawade Chandrakant Vasudev."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12589",
    "name": "Thane Shashikant Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5113",
    "name": "Toraskar Balvant Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6008",
    "name": "Vairal Ravindra Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1152",
    "name": "Vashishta Anilkumar Biharilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7076",
    "name": "Vijaykumar K C"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4789",
    "name": "Yadav Shashikant Dada"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3732",
    "name": "L Shalikram Lalit."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3854",
    "name": "Rajbhar Balgovind Madho."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3813",
    "name": "Saidane Bhaidas Gambhir."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3718",
    "name": "Sawant Atmaram Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2031",
    "name": "Singh Mahipal Singh Kamal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3839",
    "name": "Savratkar Krishna Abaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4660",
    "name": "Wadekar Sopan Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2995",
    "name": "Kadam Meena Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3728",
    "name": "Sanghavi Ushaben Pravinchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "469",
    "name": "Atmaram Pandurang Thorat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "833",
    "name": "Prakash Raghunath Katre."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4101",
    "name": "Chavan Aashabai Shankersingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11051",
    "name": "Nare Shramika Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3035",
    "name": "Birbahadur  Budhbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4656",
    "name": "James Chacko/Mr Vijay Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3625",
    "name": "Sami Rajreddy Patel."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2404",
    "name": "Shah Rajnikant ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3919",
    "name": "Pol Ankush Mahadeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "828",
    "name": "Ramcharan Ghasitelal Chaurasiya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "308",
    "name": "Shinde Manohar Pandurag"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "349",
    "name": "Joshna Welfare Associates"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4428",
    "name": "Virani V D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2240",
    "name": "Kale Tukaram J."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1074",
    "name": "Jp Gec & Agro Hindustan Pvt Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1994",
    "name": "Shah Nemaji Ravaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7016",
    "name": "Irani P.R/Mr P R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "223",
    "name": "Eknath Balkrishna Patil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "990",
    "name": "Kenjale Alka Bhimrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3484",
    "name": "Rajpure Bajirao Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "280",
    "name": "Dadasaheb Piloba Kenjale"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3626",
    "name": "Jadhav Rajendra Maruti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "259",
    "name": "Pawar Sunita Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4325",
    "name": "Chavan Sushila Shrirang."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "908",
    "name": "Jupitor Investment"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "613",
    "name": "Khimjibhai K. Makawana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14284",
    "name": "Landage Baban Chokhaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4244",
    "name": "Singh  Inderpal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "818",
    "name": "Marian P. Colaco."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2888",
    "name": "More Tukaram Bhagwat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1846",
    "name": "Nawadkar Pravin Bhanudas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3250",
    "name": "Shinde Ramesh Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "288",
    "name": "Muktabai Shamrao Bhosale"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2374",
    "name": "K Pukhraj Impex"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3591",
    "name": "Desai Ramdas Chandrakant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6364",
    "name": "Kadam Indubai Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1227",
    "name": "Shingan Sarjerao Dattu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4157",
    "name": "Chande Kumud K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1775",
    "name": "Gurung Gamarsing A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2615",
    "name": "Kahar Shivkaran Ramprasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1143",
    "name": "Kadam Dyandeo Maruti."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1456",
    "name": "K.A.A.Enterprises."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1727",
    "name": "K.Die Works."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "217",
    "name": "Ganesh Anant Naik"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2079",
    "name": "K.P.Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3081",
    "name": "K.Worldcom"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2382",
    "name": "Kadam Nirmala Ramesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7338",
    "name": "Bhandari Kalpana Moreshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7335",
    "name": "Bhandari Kishore Moreshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7339",
    "name": "Bhandari Sangeeta Moreshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7336",
    "name": "Bhandrai Rajendra Moreshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5774",
    "name": "D Souza Selvahan Devraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3377",
    "name": "Doke Mohan Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "353",
    "name": "Jagannath Ananadrao Bandal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6107",
    "name": "Parmar Mangelal V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4052",
    "name": "Jadhav Sudhakar Govinda."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3943",
    "name": "Alinakki  Ajimulla."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2608",
    "name": "Chavan  Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3915",
    "name": "Shinde Vijay Abaso."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4225",
    "name": "Nepali Dhansing Virsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1096",
    "name": "Vedvyas Mukund Kamath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3330",
    "name": "Durgawale Parshuram Ramchndra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "439",
    "name": "Mangal Kalyan Bansode."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8974",
    "name": "Dhandore Shaila Sampatti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16940",
    "name": "Prajapati Suresh Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7120",
    "name": "Sawant Sneha Sachin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11463",
    "name": "Shukla Ashokkumar Shardaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3113",
    "name": "Rimal Ganga Prasad J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11403",
    "name": "Shinde Ravindra Ramarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8786",
    "name": "Chavan Yashoda Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9957",
    "name": "Chouhan Virendra Dhis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16928",
    "name": "Dange Krupali Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12231",
    "name": "Dhobi Geeta Shankarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12270",
    "name": "Gavai Ramu Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11783",
    "name": "Kshirsagar Manik Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11790",
    "name": "Laxman Malaya Vimla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12819",
    "name": "Mahabri Lajam Nijam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11820",
    "name": "Mate Vaijayanti Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14395",
    "name": "Samel Sheetal Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11847",
    "name": "Shaikh Ramesha Banu Hanif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12781",
    "name": "Tavare Rajaram Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11911",
    "name": "Wagh Santosh Kacharu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11360",
    "name": "Avhad Vishal Ramesh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22785",
    "name": "Pingle Mayur Jayendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12002",
    "name": "Nikam Bhikaji Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10629",
    "name": "Gaikwad Harshalata Anil"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "621",
    "name": "Gopi Alath Unnikrishnan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19180",
    "name": "Gurav Akanshkaa Narendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5566",
    "name": "Maskar Janardan Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18280",
    "name": "Patil Gulab Shaligram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "121",
    "name": "Shrirang Shankar Shingate."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10535",
    "name": "Shukla Naresh Jawaharlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12499",
    "name": "Benere Dasharath Shivram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1290",
    "name": "Gopal  Chaturvedi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20456",
    "name": "Kadam Ankush Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17160",
    "name": "Parekh Sanddep Devendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4268",
    "name": "Soni Bhavna Vrajlal/ Vrajlal  R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "982",
    "name": "Keni Kavita Krishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1851",
    "name": "Matekar Tukaram Dyanu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3661",
    "name": "Patil Ashok Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10220",
    "name": "Dabholkar Arun Krishnarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19925",
    "name": "Ghone Vijay Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12845",
    "name": "Rasal Bapu Aappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13177",
    "name": "Shinde Swapnil Ranjitrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13183",
    "name": "Kadam Popatrao Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1541",
    "name": "Pandit Deepak Vasudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9143",
    "name": "Sain  Sumit"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9710",
    "name": "Disale Shakuntala Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16935",
    "name": "Ghosh Hemant Ravindranath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19498",
    "name": "Pawar Kalpana Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20173",
    "name": "Rao Suresh Vijayraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9604",
    "name": "Shivekar Balasaheb Chandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15864",
    "name": "Pawar Maruti Chandru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13950",
    "name": "Desai Bhavana Suresh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15233",
    "name": "Gupta Himmatlal Ramlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6521",
    "name": "Patel Abdurab Alamgir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14260",
    "name": "Rai Rampiyare Kamala."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15903",
    "name": "Rane Amit Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10267",
    "name": "Shaikh Aliya Mustaque Ali"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "135",
    "name": "Jambulkar Swati Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12992",
    "name": "Bagwe Prabhakar Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6964",
    "name": "Crasto  Edna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16104",
    "name": "Mhatre Malati Madhav /Keni Krishna Govin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17734",
    "name": "Rimal Gourilal Shivlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8123",
    "name": "Sharma Shamlal J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12628",
    "name": "Soman Daksha Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1779",
    "name": "Subhedar Pradip Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5162",
    "name": "Pisal Tulshidas Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1",
    "name": "Patil Vasantdada Banduji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6018",
    "name": "Sankhe Avinash Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13891",
    "name": "Kapadia Mulji Vasanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16886",
    "name": "Kelembekar Jayshree Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6167",
    "name": "Patel  Gafoor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15423",
    "name": "Shinde Sandeep Kishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14428",
    "name": "Chakrawarthi Bablu Vijay."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18305",
    "name": "Khandare Sandip Prabhu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9534",
    "name": "Khot Jafir Mallik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7958",
    "name": "Tawade Rohinee Gopinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4202",
    "name": "Vaity Mojesh Anthony"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2561",
    "name": "Abdil Mohamad Joinel."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "991",
    "name": "Adhav Maruti Sakharam."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11486",
    "name": "Disale Kantabai Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10006",
    "name": "Jadhav Narendra Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17566",
    "name": "Kochare Bhaskar Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10596",
    "name": "Kumbhar Hari Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4107",
    "name": "Soni Hitesh Jamnadas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8061",
    "name": "Chitia Ramanilal Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14339",
    "name": "Shinde Nilesh Suresh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14002",
    "name": "Vaddapalli Shriniwas Yadaiah."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8821",
    "name": "Bhosale Prataprao Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8828",
    "name": "Chavan Dattatray Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8801",
    "name": "Jagtap Ramchandra Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15152",
    "name": "Jayesh Ka Dattani"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8820",
    "name": "Kadam Mahadeo Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8845",
    "name": "Yadav Sahebrao Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15690",
    "name": "Patil Jotiba Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9463",
    "name": "Shinde Laxman Rau 6338"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "585",
    "name": "Singh Manojkumar Vidyachal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15716",
    "name": "Kanade Eknath Dhondiba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "178",
    "name": "Karne Uttam Raghunath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "152",
    "name": "Sonawane Mithun Vishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3552",
    "name": "Mandhare Popat Jaysing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "81",
    "name": "Mohan Ankush More."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20461",
    "name": "Adhav Vishal Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12762",
    "name": "Jadhav Usha Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18094",
    "name": "Jagtap Rekha Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10316",
    "name": "Kamble Vaibhav Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11588",
    "name": "Kulkarni Vivek Vidyadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18772",
    "name": "Pandey Chandramani J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9911",
    "name": "Shetty Kalavidhi S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7321",
    "name": "Shrivardhankar Ashok Dharma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6834",
    "name": "Kadam Kalpana Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6524",
    "name": "Baluwala Samina Akbar ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19502",
    "name": "Bhatkar Rajesh Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13307",
    "name": "Matre Atmaram Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6141",
    "name": "Vishwakarma  Urmila"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15937",
    "name": "Jagatap Chandakant Kshinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12548",
    "name": "Mandhare Ravindra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1305",
    "name": "Salunkhe Ashok Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13511",
    "name": "Chavan Baban Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17292",
    "name": "Gathia Jayash Kantilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8804",
    "name": "Kadam Rukhmini Vitthal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1585",
    "name": "Lonbal Farhan Malik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18256",
    "name": "Ramraje Agashti Pandarinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17296",
    "name": "Shah Pushpaben Chandulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22500",
    "name": "Shinde Navnath Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1628",
    "name": "Bhogal Dattaram Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "826",
    "name": "Gauda Satish Donda"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "17",
    "name": "Gavli Meena Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "26",
    "name": "Kokane Dilip Bhaguji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "921",
    "name": "Mane Prakash Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1138",
    "name": "Shah Kiranbhai K."
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "102",
    "name": "Shaikh Fatma Ramjan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1816",
    "name": "Chandravathy  P.A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3658",
    "name": "Shaikh Riyaz Mehbub"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9508",
    "name": "Dsouza Rony S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6345",
    "name": "Khan Rahma B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11631",
    "name": "Sharma Kamal Krishnanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10108",
    "name": "Khan Mohd Salim Mrs. Rashida Salim Khan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21469",
    "name": "Kanodia  Naval  B."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "474",
    "name": "Mandge Manohar Mahadev"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "78",
    "name": "Murugan Arthy Sunder Raju Nagappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18860",
    "name": "Patil Rajendra Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4490",
    "name": "Pisal Sachin Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17649",
    "name": "Dhalpe Surekha Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12361",
    "name": "Fernandes Merry Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16453",
    "name": "Vichare Prashant Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5683",
    "name": "Nagvekar Suhasini Laxman/Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9974",
    "name": "Jadhav Kamlakar Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14359",
    "name": "Shinde Mahandra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1369",
    "name": "Shah Bharat Kheraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12970",
    "name": "Chawan Sharda Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6508",
    "name": "Patel Shailesh Amrutlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20457",
    "name": "Pisal Dnyaneshwar Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14340",
    "name": "Rao B Madhusudan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16295",
    "name": "Smita Sudhir Ambulkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17873",
    "name": "Misal Mahemdra Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10688",
    "name": "Mishra Asha Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8621",
    "name": "Shah Ranjankumar Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17694",
    "name": "Trivedi Manoj Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6259",
    "name": "Jayswal Lutavan Ramnewar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2691",
    "name": "Shinde Sonubai Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18078",
    "name": "Dhumal Rupesh Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15790",
    "name": "Pawar Shobha Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9684",
    "name": "Sai Sukhdev Manger"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18339",
    "name": "Salian Sudhir Sunder"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13316",
    "name": "Shaikh Ansar Ismaile"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1077",
    "name": "Sharada Prasad Sivanath Rajbhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1217",
    "name": "Vaje Narayan Tukaram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11881",
    "name": "Chavan Bhanudas Appaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12570",
    "name": "Agrawal Rajveer Jainarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1753",
    "name": "Shahapurkar Nayan Chandrakant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6784",
    "name": "Karode Ambadas Kanheyalal/Ahilyabai Amba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13343",
    "name": "Patil Tarubai Jalindar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18651",
    "name": "Bhalekar Suresh Dnyandev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14122",
    "name": "Dhiwar Subhash Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14199",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16505",
    "name": "Mahadik Sandeep Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15780",
    "name": "Mondal Mohmad Alluddin."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13023",
    "name": "Talekar Surekha Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4278",
    "name": "Laxman Daji Pujari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15011",
    "name": "Belekar Vidya Sagundas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5578",
    "name": "Goriwale Alpesh Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6835",
    "name": "Bhosale Vijay Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12528",
    "name": "Shah Devendra Dhirajlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9017",
    "name": "Andhale Dattu Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16237",
    "name": "Gandhi Indravadan Jagjivan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4411",
    "name": "Jadhav Manoj Manilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "244",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17610",
    "name": "Bhogale Arun Bhanji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10584",
    "name": "Jadhav Vikas Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13655",
    "name": "Kadam Chandra Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6921",
    "name": "More Uttam Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15379",
    "name": "Chavan Uttam Tukaram/Mrs.Sunanda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17030",
    "name": "Jadhav Sanjivani Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11170",
    "name": "Pawar Rakmini Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17106",
    "name": "Pednekar Sandeep Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10721",
    "name": "Wayale Gajanan Mangal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1679",
    "name": "Nalawade Kamal Ramesh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21482",
    "name": "Kanodia Dinesh B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21404",
    "name": "Sankpal Chintan Prakash."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9272",
    "name": "Sabale Hanamnt Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20961",
    "name": "Abdul  Yanus Ansari."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16213",
    "name": "Agarwal Pawan P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20867",
    "name": "Ali Arshad Iqbal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20851",
    "name": "Altaf Abdul Kadar Inamdar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20850",
    "name": "Altaf Abdul Kadar Inamdar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20908",
    "name": "Ansari Umar Farooq"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20977",
    "name": "Arumugan Ammasi Devendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14333",
    "name": "Babar Arunkumar Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20833",
    "name": "Bandal Balkrishna Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20931",
    "name": "Bhalekar Lavoo Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20896",
    "name": "Chalke Suryakant Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21019",
    "name": "Chiragali Firozali Farook"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20921",
    "name": "Choudhary Abbasali Ajijali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20849",
    "name": "Daisa Vencu Misquita"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20866",
    "name": "Dalvi Pratibha Vasant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21014",
    "name": "Dasari Shridhar Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20994",
    "name": "Dawood Khan Akbar Khan Pathan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20926",
    "name": "Dsouza Martin Appolin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20937",
    "name": "Dubey Bhupendranath Laxminarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20942",
    "name": "Gaikwad Dilip Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20897",
    "name": "Gangavane Bhagawan Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20891",
    "name": "Garud Vijay Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21026",
    "name": "Gauda Puttaswami Chandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21013",
    "name": "Gawade Mani Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21022",
    "name": "Gondawana Laxman Hariya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21016",
    "name": "Gupta Biharilal Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20848",
    "name": "Gupta Kedarnath Ramlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20950",
    "name": "Gupta Surendranath Hariprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20873",
    "name": "Hasan Miya Fakir Moh  Shaikh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21015",
    "name": "Jadhav Harish Shetty"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20855",
    "name": "Jadhav Manoj Manilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20990",
    "name": "Jaiswal Birbal Baldev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20943",
    "name": "Jaiswar Udaychand Jayshankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20959",
    "name": "Jethwa  Yusuf  Ibrahim."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9572",
    "name": "Kadam Pushpa Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21018",
    "name": "Kambale Yellubai Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20930",
    "name": "Kerkar Sanjay Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20979",
    "name": "Khan Akbar Subrati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20924",
    "name": "Khan Mohd Manam Halim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20958",
    "name": "Kunte Yashwant Madhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6688",
    "name": "Limkar Shashikant Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20936",
    "name": "Lonkar Jayesh Tejrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20857",
    "name": "Mane Ashok Vikas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20895",
    "name": "Mishra  Devendra Omprakash."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20868",
    "name": "Mohdeluas Aziz Miya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21029",
    "name": "More Anusaya Mahadeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20918",
    "name": "Murdeshwar Tansen Nagappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20871",
    "name": "Naik  Sunder Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20832",
    "name": "Naik Ulhas Nagesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16893",
    "name": "Navratne Anand Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20879",
    "name": "Nirmal Rajpati Gayadin."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20907",
    "name": "Nizamuddin Aslam Mohd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20920",
    "name": "Pal Shankar Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20984",
    "name": "Panday Avinash Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21028",
    "name": "Panday Santosh Mahendra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21000",
    "name": "Parekh Shishir Mohanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21002",
    "name": "Pashte Ramesh Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20906",
    "name": "Patekar Tukaram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20910",
    "name": "Patel Alam Makboom"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20949",
    "name": "Patel Prakash Dnizabhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20882",
    "name": "Patel Vijay Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21027",
    "name": "Pawar Kamal Shridhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20954",
    "name": "Prajapati  Arvindkumar  Rambachan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18054",
    "name": "Rabdiya Mahesh Kanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20853",
    "name": "Rahim Noor Khan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20905",
    "name": "Rajhans Murlidhar Shyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20859",
    "name": "Sadruddin Hasan Nanji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20955",
    "name": "Sahu  Arjunkumar  Satyanarayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20890",
    "name": "Sakpal Santosh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21017",
    "name": "Satpate Popat Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20838",
    "name": "Sayad Gulam Murtaja"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21021",
    "name": "Sayyed Rafik Kadarbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20960",
    "name": "Shaikh  Aslam Mohd Lalu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20893",
    "name": "Shaikh Ahmed Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20932",
    "name": "Shaikh Aqeel Haroon"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20915",
    "name": "Shaikh Ibrahim Mohiddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21006",
    "name": "Shaikh Iqbal Abdu Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20852",
    "name": "Shaikh Mohd. Rafique Abdul Karim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19387",
    "name": "Shaikh Mohd.Rafiq Abdullah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20878",
    "name": "Shaikh Rajsaheb Nabisab."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20946",
    "name": "Shaikh Turuk Mohd Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21003",
    "name": "Sharma Rajkumar Baghmadatt"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20947",
    "name": "Sharma Santoshkumar P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21024",
    "name": "Shinde Sachin Madhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20881",
    "name": "Singh  Pradeep S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20919",
    "name": "Singh Jitendra Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21023",
    "name": "Singh Shankar Bhagril Sawant Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20909",
    "name": "Swami Nagappa Subeya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20889",
    "name": "Tambe Vilas Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20883",
    "name": "Thani Yunus Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20989",
    "name": "Tiwari Rajesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20985",
    "name": "Tripathi Radhyashyam Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21030",
    "name": "Usare  Ankush  Ram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20922",
    "name": "Varma Mandapal Parasnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20935",
    "name": "Vishwakarma Shripal Lalmani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20957",
    "name": "Yadav  Nanku Kuber."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20951",
    "name": "Yadav Ashadevi R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20983",
    "name": "Yadav Dharmraj Ramraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20956",
    "name": "Yadav Dilip Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19361",
    "name": "Yadav Jagjivan Khandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20978",
    "name": "Yadav Kanhaiyalal Subedar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20892",
    "name": "Yadav Ramlal Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20974",
    "name": "Yadav Shyamlal Laxminarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20948",
    "name": "Yadav Surendra Salikram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21005",
    "name": "Yete Anwar Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20872",
    "name": "Zuber Mohmmad Razzak Shaikh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12724",
    "name": "Kambale Vaishali S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16418",
    "name": "Mashru  Bhavin Sudhirbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21057",
    "name": "Abhyankar Satish Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18155",
    "name": "Adhav Sachin Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20809",
    "name": "Ansari Mohammad Quasim  Jaisuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20830",
    "name": "Bote Vasant Dashrath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19277",
    "name": "Chikne  Dinkar Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20803",
    "name": "Gupta Ashokkumar Katwaroo Mh-02 Ra-924"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20806",
    "name": "Gupta Babulal Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20818",
    "name": "Gupta Harichandra Motilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20816",
    "name": "Hullur Nazirahmad Fakruddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20828",
    "name": "Joshi Joshnath Kanayalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20784",
    "name": "Kambale Vishwas Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19263",
    "name": "Mansoori Mohd.Hussain Saukatali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20804",
    "name": "Mukadam Prashant Manikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20798",
    "name": "Panday Laxmishankar Shardaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20786",
    "name": "Pathan Iqbal Rahimuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20817",
    "name": "Shaikh Mohd Idris"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20812",
    "name": "Shetty Arogyaswami Chinappan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11122",
    "name": "Wagh Dhanraj Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20797",
    "name": "Yadav Dimleshkumar Shivcharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20829",
    "name": "Yunus Mohd. Ayub Mohd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1898",
    "name": "Punjabi Deepak K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5067",
    "name": "Khavale Prakash Thaksen"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8822",
    "name": "Bhoite Ramesh Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17584",
    "name": "Kumbhar Nitin Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1682",
    "name": "Anpat Shivaji Nivrutti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4223",
    "name": "Dhansingh  Chandarsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18021",
    "name": "Shah Prachi Kaumin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20736",
    "name": "Baig Aiyaz Chand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9464",
    "name": "Divkar Ismil Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20730",
    "name": "Gandalwala Yusuf Abdulla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20729",
    "name": "Gupta Banwarilal Ramshukh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20703",
    "name": "Gupta Bharat Umashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20741",
    "name": "Gupta Premchand Gopinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20701",
    "name": "Gupta Sarojkumar Chotelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20746",
    "name": "Khan Mohammad Hanif Naseem"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20748",
    "name": "Khan Zakeer Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20689",
    "name": "Mandavkar Atmaram Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20742",
    "name": "Pai Ramesh Dattaray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9707",
    "name": "Patil Tulashiram Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20747",
    "name": "Rai Udaypratap Banarasi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15757",
    "name": "Sakunde Sagar Trimbak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20735",
    "name": "Sawant Pramod Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20737",
    "name": "Subramani Laxman Devendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20691",
    "name": "Vaswani Suresh Bulchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6376",
    "name": "Wadekar Girish Bhagwnji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20690",
    "name": "Warti Vishwas Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20702",
    "name": "Yadav Rakesh Lallu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20740",
    "name": "Yadav Sohan Siddwar Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7703",
    "name": "Shetty Mukaiyi K.Tangrat/Tangarat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3248",
    "name": "Kasat Mangal Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8893",
    "name": "Bhure Noeen Zaki"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6692",
    "name": "Borage Atmaram  Baloso  Hariba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13875",
    "name": "Dasai Chhaya Jignesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20574",
    "name": "Dulpin  Dsouza"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20567",
    "name": "Jaiswal Rajendraprasad Lalata Gupta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20573",
    "name": "Kadam Satyavan Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20566",
    "name": "Mishra Premnath Rambaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20594",
    "name": "Mohd Hanif Ahmad Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20618",
    "name": "Nile Sudesh Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20586",
    "name": "Noorali  Bakarali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20577",
    "name": "Paw F. Pinto"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20619",
    "name": "Sayad Anwar Sharif."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20575",
    "name": "Shaikh Asgarali Akbarali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20576",
    "name": "Shaikh Monudin Guddu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20596",
    "name": "Sunsaya Zabir Yusuf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18230",
    "name": "Tripathi Satish Satyanarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10548",
    "name": "Verma Gopaljee Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20608",
    "name": "Vetal Adhikari Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20564",
    "name": "Yadav Birendrakumar Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20585",
    "name": "Yadav Jainbahadur Hargain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20584",
    "name": "Yadav Lalchand Bihari"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "726",
    "name": "Malik Javed Musa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18219",
    "name": "Khan Sameer Moin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14610",
    "name": "Rane Sachin Anil."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20488",
    "name": "Amboskar Chandrakant Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20489",
    "name": "Bhagat Hareshwar Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20531",
    "name": "Desai Satish Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20504",
    "name": "Gadkar Manohar Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20536",
    "name": "Ghag Chandrakant Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20475",
    "name": "Godhan Brijlal Yadav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20497",
    "name": "Gupta Chandrabhan Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20506",
    "name": "Gupta Ravindrakumar Shitalaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20473",
    "name": "Gupta Sohanlal Bandhulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13965",
    "name": "Jadhav Suresh Rambhavu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20535",
    "name": "Jaiswal Vijayshankar Chhabilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20490",
    "name": "Modi Jayesh Jeevan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20476",
    "name": "Mohmad Siddique Mohmad Kadari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20480",
    "name": "Panchal Kiran Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12371",
    "name": "Pawar Dinesh Dnyandev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20477",
    "name": "Prajapati Amraram Pramramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20511",
    "name": "Sayyed Niyaz Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20481",
    "name": "Shafi Kondaji Sajan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20501",
    "name": "Shaikh Mohamed Rafiq Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20485",
    "name": "Shaikh Mohd. Sayyad Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20487",
    "name": "Shaikh Naimuddin Wahiduddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20526",
    "name": "Shinde Mohan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17628",
    "name": "Surve Keshav Dnyanoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20532",
    "name": "Suryvanshi Sukhdeo Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20510",
    "name": "Upadhyay Achedhan Ramdhani"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "390",
    "name": "Kadav Copy Arts"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20491",
    "name": "Yadav Surjan Mangru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5975",
    "name": "Bhatt Joshna B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20460",
    "name": "Choursia Ramgopal Kanhyalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18151",
    "name": "Kamate Vitthal Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20451",
    "name": "Mallah Jangbahadur Ramudhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20429",
    "name": "Mishra Bhanuprakash Jawaharlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20452",
    "name": "Panday Nagendra Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7553",
    "name": "Parekh Dharmishtha A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20464",
    "name": "Sakoor  Govindraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2409",
    "name": "Shah Harshad Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20465",
    "name": "Sherigar Sanjiv Shena"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6872",
    "name": "Thakur Jyoti Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20466",
    "name": "Ujgaonkar Maruti Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17826",
    "name": "Mascarenhas John Sylvester"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18881",
    "name": "Gupta Murahuprasad Shambhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18865",
    "name": "Huk  Azijul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5894",
    "name": "Ranware Eknath Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8261",
    "name": "Sachidanand Tejpratap Singh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1167",
    "name": "Phalke Shankar Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6973",
    "name": "Bhosale Shankar Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20364",
    "name": "D`Suza James Adward"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18700",
    "name": "Gite Vishal Nandkishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19413",
    "name": "Mulik Shivaji Dajiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11405",
    "name": "Parab Namita Nandkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17763",
    "name": "Mansukh Bharat Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10816",
    "name": "Chaugule Subhash Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5840",
    "name": "Murarka Manujudevi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20209",
    "name": "Asif Taj Mohmmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17936",
    "name": "Bhanushali Yogita Ratanshi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16063",
    "name": "Shirke Sunil Bhargavram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6366",
    "name": "Senwal Shivdayal I."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21066",
    "name": "Abdul Rasid Sayyed Hussain"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "550",
    "name": "Bahujan Vidhyarthi Seva Bhavi Santha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21065",
    "name": "Chauhan Jaya Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21064",
    "name": "D Souza Petar Joseph"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21069",
    "name": "Gupta  Ramprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20999",
    "name": "Gupta Dhanpat Devi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21063",
    "name": "Gupta Radheshyam Arjunprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21043",
    "name": "Jamal Samsuddin Jainuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21050",
    "name": "Khan Amina Rahimuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21052",
    "name": "Khan Shakila Abdullah  Ansari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15844",
    "name": "Lokhande Avinash Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21040",
    "name": "Mohd Jakir Noor Mohd Parve"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21058",
    "name": "Mohd Tujeel Javed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21060",
    "name": "Pandey Ashokkumar Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21051",
    "name": "Pathak Pradeepkumar Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21045",
    "name": "Sakinabanu Ayub Mohd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7107",
    "name": "Sardar Singh Bishan Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21054",
    "name": "Shaikh Mohd Suleman Tahir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21053",
    "name": "Sharma Vimleshkumar Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21056",
    "name": "Yadav Laldevi Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21055",
    "name": "Yadav Ramkishori Somnath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "294",
    "name": "Chaudhari Sandip Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20118",
    "name": "Harijan Annamalai Chopiyan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14424",
    "name": "Kshirsagar Chagan Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15781",
    "name": "Mishra Santoshkumar Hiraram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16322",
    "name": "Mote Laxman Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13108",
    "name": "Sakunde Sangeeta Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14596",
    "name": "Sharma Ramswarup Shivdayal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15752",
    "name": "Solanki Bhupendra P"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5588",
    "name": "Mulik Shriram Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11544",
    "name": "Jadhav Dyandeo Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9331",
    "name": "Kadam Narayan Aba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12285",
    "name": "Mane Vijaya Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13713",
    "name": "Patil Vishnu Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8871",
    "name": "Sinha  Brijesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11195",
    "name": "Phalke Ashok/Chandrakant Shinde/Raghunat"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "765",
    "name": "Kalawati Casting Works"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8934",
    "name": "Shinde Sunita R./Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2294",
    "name": "Shinde Vijaykumar Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11331",
    "name": "Salvi Santosh Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16715",
    "name": "More Ashok Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18404",
    "name": "Parkar Nitesh Dinanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3023",
    "name": "Khopade Sachin Yeshwant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7401",
    "name": "Mehta  Mahaveer"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "809",
    "name": "Pisal Madhukar Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "204",
    "name": "Vithal Krishna Shinde."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6223",
    "name": "Phalke Nandkumar Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15741",
    "name": "Shah Vikrantkumar R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9694",
    "name": "Shaikh Abdul Munaf Abdulla Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17593",
    "name": "Shugufta Jaroderwala Hajiabdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4607",
    "name": "Soni Bipinbhai Potlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9135",
    "name": "Virle Bhalchandra Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "375",
    "name": "Vithal Tukaram Panaskar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8925",
    "name": "Bhosale Prataprao Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12404",
    "name": "Bhatt S Ananta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12344",
    "name": "Gaikwad Uddhav Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15408",
    "name": "Laxkar Shyam Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15019",
    "name": "Madkaikar  S.Mohandas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19172",
    "name": "Parab Satyavijay Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16422",
    "name": "Shah Gangadhar Ganeshprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9621",
    "name": "Singh Jayprakash Markande"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7540",
    "name": "Kamble Vijay Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8815",
    "name": "Sabale Lahu Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10975",
    "name": "Kadam Bandu Ravji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11569",
    "name": "Barge Hanamant Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11981",
    "name": "Kochrekar Sameer Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16949",
    "name": "Raja Rajul Jitendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13585",
    "name": "Fanibanda Pesi Dinshaw"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13885",
    "name": "Smita R.Dhadve."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6610",
    "name": "Pisal Sunita Tulashidas & Pisal Tulashidas Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7137",
    "name": "Trivedi Tarun S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9539",
    "name": "Bandal Dada Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14437",
    "name": "Chaturvedi Anurag Jitendra Dutt."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17215",
    "name": "Jadhav Bhanudas Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11453",
    "name": "Mulik Ashok Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1802",
    "name": "Jadhav Anusaya Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2364",
    "name": "Kamal Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2326",
    "name": "Kamal Trading Co."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1591",
    "name": "Shinde Balu Sadashiv."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10775",
    "name": "Bhandari Ravindra Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15154",
    "name": "Borase Kiran Himmatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14931",
    "name": "Maddheshia Jatashankar Vishwanath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "515",
    "name": "Patel Pradeepkumar Ramapati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11399",
    "name": "Waghe Deepak Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20768",
    "name": "More Mahadev Krishnat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2505",
    "name": "Shinde Babasaheb Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7728",
    "name": "Suryavanshi Nathoba Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21385",
    "name": "Ahmad Abdul Hamid Basir."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19082",
    "name": "Chorge Kisan Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18578",
    "name": "Divekar Ganesh Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21223",
    "name": "Jaid Satish Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22047",
    "name": "More Rutuja Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13791",
    "name": "Sharma  Sneha."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1306",
    "name": "Surakha Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20223",
    "name": "Trivedi Atul Arvind   Mrs  Bharati A Tri"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8584",
    "name": "Phalke Suresh Shreepati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8888",
    "name": "Khopade Mahadeo Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16627",
    "name": "Rambhiya Reena Sandeep"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15167",
    "name": "Chavan Mahendra Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15003",
    "name": "Khambal Sunil Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16210",
    "name": "Khandare Sandeep Prabhu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15046",
    "name": "Nalawade Ashok Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17707",
    "name": "Rajput Chainsingh Udaysingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "192",
    "name": "Sharma Anilkumar Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9641",
    "name": "Thakur Ajitkumar U ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22804",
    "name": "Wagh Prafulla Hanmantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7948",
    "name": "Phalke Ankush Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7632",
    "name": "Shelake Shalan Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18751",
    "name": "Dalvi Babaram Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14238",
    "name": "Fernandies Bela Rudalf."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6083",
    "name": "Patel  Paliram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3142",
    "name": "Pawar Uttam Begatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9963",
    "name": "Kureshi Rehmantulla Munna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "604",
    "name": "Bobade Bhauso Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "77",
    "name": "Chimane Pandit Changdeo"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "329",
    "name": "Gupta Harindar Hirasa"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "87",
    "name": "Lokhande Shobha Vasant"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "265",
    "name": "Pal Ramesh Motilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1651",
    "name": "Parmar Phoolchand Himatram"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "100",
    "name": "Pawar Adhik Bharat"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "74",
    "name": "Sanas Parvati Dinkar"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "164",
    "name": "Sharma Rajkumar Ramsabad"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "270",
    "name": "Soni Pappukumar Sudhiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "195",
    "name": "Varanjani Umesh M"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "105",
    "name": "Vedpathak Rushikesh Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "927",
    "name": "Yerunkar Vasudev Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11017",
    "name": "Kadam Sharad Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9734",
    "name": "Sawant Kalabai Rama"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6665",
    "name": "Bhoite Ranjana Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1218",
    "name": "Bhoite Govindrao Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1541",
    "name": "Gaikwad Raghunath Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14737",
    "name": "Suryawanshi Pratap Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "625",
    "name": "Tanaji Abaji Shinde"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18593",
    "name": "Gaikwad Sachin Babasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6817",
    "name": "Pujari Chadrashekhar Ningappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "654",
    "name": "Chavan Sampat Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1991",
    "name": "Dorke Yeshwant Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17579",
    "name": "Feroj Abdul Hammed Munashi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12850",
    "name": "Kamble Bhimarao Santaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11448",
    "name": "Menghani Kishor Damandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12924",
    "name": "Sawant Arun Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15954",
    "name": "Varma Koyikal Rajan/ Mrs. Rajan K Varma"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "407",
    "name": "Jadhav Hanmant Dada"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6484",
    "name": "More Arun Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2063",
    "name": "Chavan Ramchandra Raghu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2652",
    "name": "Ghadge Ashok Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4347",
    "name": "Sapkal Hanmant Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14143",
    "name": "Bhavsar Surendrakumar Mithalal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3268",
    "name": "Gadhave Somanath Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6083",
    "name": "Kambale Nandkumar Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8442",
    "name": "Chinchkar Arun Ramcahandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2892",
    "name": "Kadam Ankush Kondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16799",
    "name": "Kantharia Kiran Sureshchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13759",
    "name": "Mhagade Dashrath Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3466",
    "name": "Shinde Dyanu Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4602",
    "name": "Chavan Anjani Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3384",
    "name": "Mulani Shokat Bappu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1684",
    "name": "Kirdat Kusum Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4294",
    "name": "Bhosale Shrirang Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5255",
    "name": "Suryvanshi Chandrakant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5097",
    "name": "Pawar Suresh Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8170",
    "name": "Dhanavade Prakash Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1373",
    "name": "Phalke Vilas Yadavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1440",
    "name": "Sable Savitrabai Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12407",
    "name": "Nagvekar Shrimati M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7355",
    "name": "Barge Santosh Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4914",
    "name": "Inamdar Bismillha Buran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2760",
    "name": "Nikam Tatyaba Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16962",
    "name": "Chavan  Vikram Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8103",
    "name": "Nikam Dasharath Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1696",
    "name": "Roman Jalindra Kundlika"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "927",
    "name": "Dhande Sharad Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3480",
    "name": "Kadam Sambhaji Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1217",
    "name": "Kamdar Machine Tools"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "947",
    "name": "Kamdar Tools Agency"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1190",
    "name": "Parte Rajaram Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7929",
    "name": "Gadhave Jagannath Jahangir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4682",
    "name": "Hiremath Chanbasayya Muransayya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2378",
    "name": "Jadhav Pandurang Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7187",
    "name": "Kadam Indumati Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10111",
    "name": "Padalkar Manda Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2441",
    "name": "Bhosale Sudam Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9199",
    "name": "Dhumal Vaibhav Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11096",
    "name": "Mule Madhav Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3576",
    "name": "Barge Baburav Bahiru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4755",
    "name": "Jadhav Savita Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5411",
    "name": "Bhosale Bharat Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6891",
    "name": "Pawar Suryakant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4861",
    "name": "Raut Pushpa Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16425",
    "name": "Gotise Ramesh Mahadev."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5145",
    "name": "Waghamale Balaso Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1758",
    "name": "Mane Subhadra Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5123",
    "name": "Gadre Parasharam Vishavnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6932",
    "name": "Bobade Gulabrao Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7333",
    "name": "Nanawre Pandurang Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1113",
    "name": "Kadav Baban Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10019",
    "name": "Aware Tatyaba Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18056",
    "name": "Lotlikar Bina Sushant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19586",
    "name": "Waghela Rajesh Jethalal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6084",
    "name": "Taralekar Sampat Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11908",
    "name": "Gurkha Amruta Dhanbahaddur"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2436",
    "name": "Bhosale Damu Manu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3291",
    "name": "Kanodia Kailashchandra Maliram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3965",
    "name": "Kanodia Ritu Ajay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6215",
    "name": "Sawant Manohar Yashawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5281",
    "name": "Shine Alka Genuba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5453",
    "name": "Kadam Vyankatrao Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5050",
    "name": "Shinde Tanaji Kundalikrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5548",
    "name": "Matkar Dilip Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17643",
    "name": "Brahma Hemraj Patel"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11332",
    "name": "Dhole Arvind Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7754",
    "name": "Jadhav Shamrao Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10788",
    "name": "Kadam Balaso Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10197",
    "name": "Ranbhare Sweta Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6336",
    "name": "Kadam Prakash Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7575",
    "name": "Kadam Nanda Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7038",
    "name": "Chavan Hindurao Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "234",
    "name": "Roman Tukaram Bhuiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8360",
    "name": "Sabale Hemant Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6302",
    "name": "Chavan Sadashiv Genaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5061",
    "name": "Dixit Anant Moreshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4285",
    "name": "Dhawan Ramchandra Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10539",
    "name": "Aware Tukaram Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10675",
    "name": "Inamdar Allauddhin Raheman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10708",
    "name": "Kadam Sampat Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15204",
    "name": "Sonawale Madhukar Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7045",
    "name": "Kadam Chandrakant Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1856",
    "name": "Phalke Anandrao Shankrarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6288",
    "name": "Phalke Mansing Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5527",
    "name": "Shekh Asafali Shamsudin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "519",
    "name": "Bhosale Raghunath Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8529",
    "name": "Kadam Popat Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8152",
    "name": "Jadhav Vasant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10322",
    "name": "Pisal Vithoba Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11249",
    "name": "Walekar Kausalya Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8941",
    "name": "Mane Somanath Suryakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5726",
    "name": "Mane Shalini Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8456",
    "name": "Badekar Sunil Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2070",
    "name": "Jadhav Dattatrya Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3588",
    "name": "Jadhav Vilasrao Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7736",
    "name": "Nalawade Shashikant Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11616",
    "name": "Karalkar Anila Pundalik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7876",
    "name": "Chavan Deepak Bajarang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21474",
    "name": "Lokhande Sunil Pandit."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1568",
    "name": "More Ankush Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10066",
    "name": "Pisal Ramrao Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10173",
    "name": "Sakunde Shyam Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13925",
    "name": "Waghela Rajubhai Chaganbhai."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4475",
    "name": "Bhosale Sushila Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3696",
    "name": "Kudve Baburao Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2147",
    "name": "Jadhav Madhavrao Namdeorao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7133",
    "name": "Nikam Shankar Appa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20384",
    "name": "Dhavale Dhondiram Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14071",
    "name": "Sheikh Abdul Gani"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2585",
    "name": "Karma Air Cargo."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4202",
    "name": "Kartickey   Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4545",
    "name": "Karwar Hotels Pvt. Ltd."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5926",
    "name": "Giri Vijay Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6446",
    "name": "Jadhav Muktabai Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1881",
    "name": "Durgule Govind Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8836",
    "name": "Phalke Rajendra Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7915",
    "name": "Sakunde Shivaji Pandharinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2493",
    "name": "Kumbhar Vishnu Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9971",
    "name": "Chavan Janardan Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11879",
    "name": "Kamble Sushma Malu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1609",
    "name": "Phalke Vilas Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4935",
    "name": "Chavan Hari Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4088",
    "name": "Chatur Jagannath Gulab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8025",
    "name": "Pawar Mahendra Arvind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8023",
    "name": "Sabale Vishwas Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1462",
    "name": "Sayyad Aziz Miya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "873",
    "name": "Jadhav Parashram Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2397",
    "name": "Yewale Ananda Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6943",
    "name": "Bongane Bhagwan Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8571",
    "name": "Sabale Lilavati Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6864",
    "name": "Chavan Rajendra Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17049",
    "name": "Dhumal Shaila Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8381",
    "name": "Bhagwat Madhukar Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3092",
    "name": "Chavan Hanamant Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11668",
    "name": "Ghodke Madhuri Chandrashekhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10102",
    "name": "Jadhav Anjana Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3494",
    "name": "Jadhav Balwant Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6280",
    "name": "Kadam Gajanan Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9853",
    "name": "Kadam Shankar Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11505",
    "name": "Kambale Bhagoji Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20914",
    "name": "Porwal Amritlal Dhanraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6901",
    "name": "Shinde Kalyan Kisanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4183",
    "name": "Nawadkar Sampat Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7831",
    "name": "Aware Janabai Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8928",
    "name": "Kashid Uttam Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7371",
    "name": "Korde Arvind Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5154",
    "name": "Chawan Gorakhnath Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5659",
    "name": "Phalke Vasant Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11946",
    "name": "Chavan Arun Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9240",
    "name": "Ghadge Subhash Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4984",
    "name": "Jagdale Subhedar Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6961",
    "name": "Phalake Rajaram Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5365",
    "name": "Sawant Tribak Madhavrav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20456",
    "name": "Jagtap Balasaheb Jagnnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7721",
    "name": "Kadam Navnath Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18958",
    "name": "Mahadik Vikas Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7573",
    "name": "Pawar Mohan Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9803",
    "name": "Yadao Vaishali Sapan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9842",
    "name": "Kadam Gorakhanath Shankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "204",
    "name": "Kaushik Manjeet Sukhbir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9838",
    "name": "Phalake Vilas Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3589",
    "name": "Sakunde Hindurao Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1308",
    "name": "Sabale Anant Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3141",
    "name": "Dhane Tanaji Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1392",
    "name": "Jadhav Kisan Parbati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19022",
    "name": "Kholmbe Chandrakant Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7564",
    "name": "Nikam Sampat Gajaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8268",
    "name": "Sabale Bhanudas Jayshing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21745",
    "name": "Chavan Praladh Appasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9628",
    "name": "Kadav Ashok Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9394",
    "name": "Kakade Maruti Genba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7237",
    "name": "Pawar Narsing Bajirao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "586",
    "name": "Pawar Santosh Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12545",
    "name": "Chhajer  Pukhraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "243",
    "name": "Phalke Patangrao Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9542",
    "name": "Gaikawad Nana Dhananjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9440",
    "name": "Nimbalkar Chaya Krushnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9416",
    "name": "Pawar Dilip Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9474",
    "name": "Phadtare Ramrao Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9473",
    "name": "Phadtare Sarswati Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12786",
    "name": "Phalake Asha Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4712",
    "name": "Phalke Sadashiv Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9461",
    "name": "Pisal Pralhad Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1159",
    "name": "Salunkhe Ananda Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "201",
    "name": "Kamble Maruti Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4580",
    "name": "Gaikawad Dnyaneshwar Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "691",
    "name": "Bhosale Sarjerao Genu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3212",
    "name": "Chavan Ajitsingh Suryasingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1327",
    "name": "Pujari Manoj Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9341",
    "name": "Anpat Sajabai Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8245",
    "name": "Bhoite Ravindra Vasantarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9279",
    "name": "Bhoite Sonubai Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9310",
    "name": "Bhosale Nanaso Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9308",
    "name": "Bhosale Nandkumar Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4146",
    "name": "Dafedar Shahbuddin Mehboob"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12200",
    "name": "Dhalait Mumtaj Gani"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9276",
    "name": "Gadhave Mohan Shivling"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9156",
    "name": "Ghadge Bhiku Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9260",
    "name": "Jadhav Rajendrakumar Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9177",
    "name": "Kadam Dhansing Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9234",
    "name": "Kadam Tanaji Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9339",
    "name": "Kadam Vithal Gopala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9246",
    "name": "Mahindre Bhikoba Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9286",
    "name": "Matkar Anusaya Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9281",
    "name": "Pawar Bhausaheb Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9222",
    "name": "Phalke Balasaheb Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9201",
    "name": "Pisal Hanmant Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9264",
    "name": "Shinde Gorakh Kakaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7274",
    "name": "Jadhav Sanjay Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2048",
    "name": "Phalke Ramchandra Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9203",
    "name": "Kadam Bhikoba Parshram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "582",
    "name": "Sapkal Baburao Jagdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11230",
    "name": "Gaikwad Rohini Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8075",
    "name": "Giri Prema Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9191",
    "name": "Jadhav Bhanudas Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5573",
    "name": "Jadhav Dada Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3039",
    "name": "Kadam Kisan Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7034",
    "name": "Nikam Arjun Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9573",
    "name": "Phalke Pradeep Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8293",
    "name": "Shinde Hanmant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7859",
    "name": "Umbardand Jagannath Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "752",
    "name": "Kumthekar Geeta Nilesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21948",
    "name": "Bagve  Umesh Madukar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "966",
    "name": "Godbole Eknath Bhujang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16561",
    "name": "Kolge Namdeo Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "535",
    "name": "Patil Mayur Prakash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "381",
    "name": "Vemula Naresh Mallesham"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "841",
    "name": "Jadhav Ganpat Mahadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8969",
    "name": "Momin Aslam Yusuf"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8829",
    "name": "Jadhav Nivrutti Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4720",
    "name": "Jadhav Govind Vipul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8972",
    "name": "Disale Suresh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9039",
    "name": "Durgule Vishvanath Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4579",
    "name": "Jadhav Sopan Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4855",
    "name": "Jadhav Waman Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6675",
    "name": "Kadam Ganapat Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7320",
    "name": "Salunkhe Shivaji Salunkhe"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21422",
    "name": "Sawant Sarjerao Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9224",
    "name": "Shinde Shalini Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6144",
    "name": "Kadam Kisan Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7459",
    "name": "Kharat Pandurang Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5458",
    "name": "Pawar Sarjerao Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9054",
    "name": "Phalke Suhas Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8124",
    "name": "Salunkhe Parshuram Dagdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7453",
    "name": "Zanzurne Vijay Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6421",
    "name": "Bhoite Amrutrao Balaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13874",
    "name": "Desai Anna Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10908",
    "name": "Sawant Supriya Sunil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2797",
    "name": "Roman Ramrao Parasharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7833",
    "name": "Pisal Pooja Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4942",
    "name": "Bhoite Dattatray Lalasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8304",
    "name": "Chavan Tanaji Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8466",
    "name": "Dhane Venkat Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8659",
    "name": "Gaikawad Satish Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7755",
    "name": "Kadam Vilas Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8376",
    "name": "Mane Laxman Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5758",
    "name": "Nanaware Baliram Bhiwa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7777",
    "name": "Nikam Laxman Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9821",
    "name": "Pisal Sampat Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8864",
    "name": "Sakunde Ashok Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5974",
    "name": "Sakunde Ramkrishna Madhav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5624",
    "name": "Shirke Anandrao Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7509",
    "name": "Shirtode Eknath Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4775",
    "name": "Bhosale Prakash Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7496",
    "name": "Pacharane Raghunath Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7470",
    "name": "Pisal Jaywantibai Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7375",
    "name": "Sabale Trimbak Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8499",
    "name": "Shinde Manohar Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17140",
    "name": "Gavali Haresh Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15642",
    "name": "Nimbalkar Sudhakar Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4003",
    "name": "Barge Sushila Natha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7339",
    "name": "Phalke Ashok Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7481",
    "name": "Desai Sunil Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5920",
    "name": "Adhav Ganapat Balkrishan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8798",
    "name": "Bhosale Mayura Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2996",
    "name": "Durgule Baban Bandu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1196",
    "name": "Gardi Ganesh Mininath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7944",
    "name": "Kadam Satish Balkrish"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12073",
    "name": "Kadam Sudhakar Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18155",
    "name": "Kadav Vasantrao Rau"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "512",
    "name": "Nishad Umesh Laltaprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17668",
    "name": "Patil Maruti Dadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6221",
    "name": "Phalke Vasant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7227",
    "name": "Sawant Pandharinath Bhujaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10214",
    "name": "Sutar Prakash Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4319",
    "name": "Waghamle Dnyandeo Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3272",
    "name": "Keshrimal  Vijayraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7321",
    "name": "Bobade Sayaji Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4171",
    "name": "Palampalli Bhagirthi Lingappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7959",
    "name": "Jagdale Vijay Jagdale"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8627",
    "name": "Khamkar Godabai Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5372",
    "name": "Waghamale Gulab Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9469",
    "name": "Pisal Baban Gyanba 949/7"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "570",
    "name": "Bhosale Arjun Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8777",
    "name": "Gaikawad Sushila Shreerang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7580",
    "name": "Choure Dattatray Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9646",
    "name": "Gupta Panary Prasad Kallyprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4396",
    "name": "Chatur Bhujang Gopala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8753",
    "name": "Kadam Maruti Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4464",
    "name": "Sakunde Prakash Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8694",
    "name": "Pawar Bajirao Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8711",
    "name": "Phalke Dnyandeo Appa"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "256",
    "name": "Nanche Nirmala Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "283",
    "name": "Taware Sampatrao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9812",
    "name": "Bakshi  Vivekkumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3283",
    "name": "Gaikawad Vishwas Babasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8392",
    "name": "Babar Deodas Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7841",
    "name": "Bodake Baban Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7852",
    "name": "Kadam Kashinath Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5960",
    "name": "Matkar Arun Bhauso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8369",
    "name": "Navadkar Madhavrao Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8142",
    "name": "Pawar Shatrughna Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4292",
    "name": "Sabale Vishnu Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6040",
    "name": "Shirke Hanmant Gulab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6555",
    "name": "Kadam Ramesh Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1962",
    "name": "Jadhav Narayan Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8995",
    "name": "Bhosale Abhimanyu Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8478",
    "name": "Bhosale Pradeep Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9023",
    "name": "Chavan Ankush Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4847",
    "name": "Kamable Vinayak Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9056",
    "name": "Raje Sadashiv Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6764",
    "name": "Sakunde Anjana Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9060",
    "name": "Salunkhe Sandeep Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6610",
    "name": "Chavan Baban Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4951",
    "name": "Shikalgar Dilawar Babu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7443",
    "name": "Chavan Ratnabai Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8910",
    "name": "Bhosale Ashok Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8856",
    "name": "Pisal Shankar Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1576",
    "name": "Kshirsagar Shripati Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4890",
    "name": "Shinde Ratnamala Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2439",
    "name": "Chavan Babu Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1766",
    "name": "Kadam Shankar Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7730",
    "name": "Chavan Khanderao Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3483",
    "name": "Kadam Girjabai Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1183",
    "name": "Sapkal Pralhad Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4770",
    "name": "Durgule Arun Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8285",
    "name": "Sakunde Ganpat Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7803",
    "name": "Sakunde Madhav Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8284",
    "name": "Sakunde Tukaram Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8292",
    "name": "Shinde Narayan Raghoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9395",
    "name": "Vagh Shrirang Tanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3011",
    "name": "Phalake Gulabrao Jaganath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9137",
    "name": "Barge Pramila Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "355",
    "name": "Khan Abdul Vahi A"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9148",
    "name": "Shelar Jalindar Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7519",
    "name": "Jadhav Shivaji Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6993",
    "name": "Kadam Aanandarao Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8024",
    "name": "Phalke Anil Dnaydeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9095",
    "name": "Chavan Sanjay Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9113",
    "name": "Gurav Nanda Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9112",
    "name": "Gurav Yeshodabai Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9103",
    "name": "Maskar Bharat Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6506",
    "name": "Mulik Sitaram Nathuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9099",
    "name": "Nawadkar Vasant Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9121",
    "name": "Salunkhe Popat Jaising"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7900",
    "name": "Pawar Anandrao Dadaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7838",
    "name": "Phalke Mahadeo Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7751",
    "name": "Phalke Vijay Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8790",
    "name": "Sapkal Tanaji Aabaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6272",
    "name": "Salunkhe Arun Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1672",
    "name": "Sawant Prakash Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8893",
    "name": "Jadhav Deepak Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6154",
    "name": "Gangavane Mlaruti Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8855",
    "name": "Sankpal Rohidas Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20760",
    "name": "Chavan Ankush Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20844",
    "name": "Chawda Bhikhabhai Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20822",
    "name": "Deshpande.Abhay.  Madhusudan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20881",
    "name": "Dethe Parakash Genu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20807",
    "name": "Gade Gautam Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20750",
    "name": "Gholap Saya Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20877",
    "name": "Jadhav Ashok Sudkoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20880",
    "name": "Jadhav Vijay Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20846",
    "name": "Kadam  Chandrakant   Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20763",
    "name": "Kambale Mahendra Wamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21734",
    "name": "Karande Nitin Chandrakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "474",
    "name": "Karne Vijaykumar Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20765",
    "name": "Kori Jitlal Bhagwandin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20824",
    "name": "Mirukhe  Swaraj  Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20830",
    "name": "Montero Mimin Shimao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20874",
    "name": "More  Shivaji  Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20816",
    "name": "More Paratap Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "153",
    "name": "Nakate Nandu Chhagan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20742",
    "name": "Panchmukh Kishor Gahnaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20870",
    "name": "Pawar  Shidharth   Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20872",
    "name": "Pawar  Yashvant  Dhaktu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8812",
    "name": "Phalke Pravin Shtrughna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20746",
    "name": "Qureshi  Mohmmadanwar  Mo Rashid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20818",
    "name": "Rahate Ravindra Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20806",
    "name": "Rajput  Ashish  Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20764",
    "name": "Sakharkar Salam Hasan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20879",
    "name": "Sankpal Prakash Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20812",
    "name": "Sawant  Chandrakant  Zipru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20868",
    "name": "Shinde  Mahendra   Vishanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20751",
    "name": "Shinde Rajesh Gulab"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20749",
    "name": "Shinde Sunil Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18701",
    "name": "Shirke Ajit Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20843",
    "name": "Shrimal Babulal Gangaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "154",
    "name": "Sonawale Vishwas Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20753",
    "name": "Surve Ashok Babaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20809",
    "name": "Suryawanshi Ashok Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20815",
    "name": "Thakre Baliram Damu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20758",
    "name": "Tirilotkar Prakash Shankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "151",
    "name": "Tode Jagdish Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20761",
    "name": "Varma Ganesh Praladh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20878",
    "name": "Vazir Abid Husen Shekh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3576",
    "name": "Zanzane Balu Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6220",
    "name": "Jagdale Kalavati Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8788",
    "name": "Khopade Shashikala Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7171",
    "name": "Khopade Santosh Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9067",
    "name": "Jadhav Raju Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7582",
    "name": "Phalke Uday Patangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "931",
    "name": "Kadam Sopan Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3034",
    "name": "Jagatap Kalavati Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1664",
    "name": "Bhosale Ramdas Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6305",
    "name": "Avghade Kantabai Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9001",
    "name": "Aware Jagnnath Kesu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9006",
    "name": "Kirtikudav Sunil Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8946",
    "name": "Yadav Suryakant Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4518",
    "name": "Jadhav Balaso Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4364",
    "name": "Sawant Gokula Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10324",
    "name": "Sutar Veerbhadra Gundappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21768",
    "name": "Pawar Rahul Laxman."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "595",
    "name": "Dhembre Sharad Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1086",
    "name": "Sayyad Yusuf Kamrulla"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10763",
    "name": "Shinde Shivaji Wamanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9182",
    "name": "Jadhav Sanjay Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "63",
    "name": "Arava Manish Sujatsing"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "50",
    "name": "Bhange Vijay Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1160",
    "name": "Ganesh Balaram Uttekar"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "56",
    "name": "More Nilesh Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "977",
    "name": "Yadav Pandurang Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "227",
    "name": "Sutar Shahabuddin Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3276",
    "name": "Chavan Shalan Balu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1006",
    "name": "Bhole Shashikant Laxman"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1068",
    "name": "Chaudhari Surekha Godhaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1106",
    "name": "Chavan Ranjana Arjun"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1016",
    "name": "Deshpande Renuka Girish"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1168",
    "name": "Dhale Atul Devidasrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1280",
    "name": "Gangurde Ashwini Mukund"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1019",
    "name": "Gharat Sandeep Mahadev"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1012",
    "name": "Gogate Uttara Dhananjay"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1018",
    "name": "Gorbal Mangalagauri Rameshchandra"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1008",
    "name": "Hardas Minal Sudarshan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1070",
    "name": "Jadhav Dinkar Sadashiv"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1024",
    "name": "Jondhale Baburao Haribhau"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1082",
    "name": "Kambire Subhash Bhanudas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1040",
    "name": "Kesari Amit Ramesh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1014",
    "name": "Khatavkar Archana Suresh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "668",
    "name": "Koli Chandrakant Arjun"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1080",
    "name": "Kondalkar Prathamesh Vithal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1081",
    "name": "Kondalkar Pratibha Vithal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1171",
    "name": "Lahare Santosh Nuvrutti"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1011",
    "name": "Lonkar Smita Avinash"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1005",
    "name": "M Veera Bhadrarao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1013",
    "name": "Narwelkar Meenakshi Pradeep"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1072",
    "name": "Patekar Vandana Pradeep"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1009",
    "name": "Pathade Sunita Kishor"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1069",
    "name": "Patil Deepali Parag"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1201",
    "name": "Patil Nitin Tukaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1300",
    "name": "Patil Yogita Jitendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9731",
    "name": "Pawar Baban Anna"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1438",
    "name": "Pawar Mohan Marutrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1115",
    "name": "Pawar Sujata Pramod"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "149",
    "name": "Khan Sales"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1029",
    "name": "Phahpale Dattatry Bhausaheb"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1084",
    "name": "Purohit Vijaykumar Vithalrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1023",
    "name": "Rodge Pramod Ramdas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1203",
    "name": "Satao Nitin Tulidas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1015",
    "name": "Shaikh Amjadali Shahratali"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1074",
    "name": "Sharma Anil Deepchand"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1020",
    "name": "Shelke Monali Ramesh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1017",
    "name": "Shelke Sangita Dileep"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1190",
    "name": "Shinde Bhausaheb Savaleram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1021",
    "name": "Sonawane Pratiksha Nanadkishor"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1063",
    "name": "Suryavanshi Shantabai Dadarao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1010",
    "name": "Thakur Bhavna Dhananjay"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1022",
    "name": "Vadak Revannath Ranganath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1073",
    "name": "Vishwanath Saroja T"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1391",
    "name": "Waghoskar Naina Naresh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1095",
    "name": "Yadav Dayanand Bhanudas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1041",
    "name": "Yadav Krishnakumar Jadunandan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1212",
    "name": "Yewale Sapna Sachin"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1181",
    "name": "Zanzane Deepali Ramdas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1183",
    "name": "Zanzane Kunal Ramdas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1182",
    "name": "Zanzane Laxmibai Sarjerao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1180",
    "name": "Zanzane Ramdas Sarjerao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1184",
    "name": "Zanzane Siddhi Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2170",
    "name": "Phalke Radhabai Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8538",
    "name": "Sapkal Rajendra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7131",
    "name": "Gade Asha Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7024",
    "name": "Pawar Sanjay Janrdan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1574",
    "name": "Kashid Pandharinath Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4503",
    "name": "More Hanmant Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9101",
    "name": "Sathe Mangal Gubal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6556",
    "name": "Pawar Ashok Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6672",
    "name": "Salunke Banubai Kasharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2965",
    "name": "Deshmukh Shankar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6155",
    "name": "Phalke Sumam Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2970",
    "name": "Jagdale Shivaji Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6570",
    "name": "Jadhav Wishvambar Ravba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "479",
    "name": "Shinde Balkrishna Jigoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7522",
    "name": "Sonmale Balkrushna Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1723",
    "name": "Kadam Shaila Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8046",
    "name": "Chavan Vikas Nanaso"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "727",
    "name": "Goswami Dineshgiri Mohangiri"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17316",
    "name": "Lotliker Sachin Suresh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1132",
    "name": "Mohite Vijay Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10793",
    "name": "Sakunde Balkrishna Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9631",
    "name": "Shinde Shivaji Wamanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8498",
    "name": "Agavane Ranjana Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2734",
    "name": "Shinde Ashok Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13602",
    "name": "Thakur Charan Singh."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4776",
    "name": "Pawar Vilas Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5022",
    "name": "Bhosale Mathura Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6876",
    "name": "Babar Lata Balkisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8477",
    "name": "Burle Prakash Chanmallapa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8955",
    "name": "Kadam Nanda Ankush"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8649",
    "name": "Mahadik Ankush Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22391",
    "name": "Chavan Jayant Shivaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22473",
    "name": "Chivilkar Narendra Shripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22405",
    "name": "Gupta Balgovind Babai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22390",
    "name": "Hanjankar Dinesh Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23158",
    "name": "Hodar Vivek Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22472",
    "name": "Hussain Abdul Jabbar Sayyed Khaja"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22364",
    "name": "Iqbal Noor Mohd.Sumra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22394",
    "name": "Kadir Mehboob Khan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22512",
    "name": "Kokate Santosh Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22476",
    "name": "Lokhande Santosh Shivdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22513",
    "name": "Maurya Lalji Baburam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22495",
    "name": "More Pandurang Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22466",
    "name": "Narje Upendranath S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22456",
    "name": "Patel Jamil Gulan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22365",
    "name": "Penekar Milind Dattatrey"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22362",
    "name": "Sawant Prakash Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22435",
    "name": "Sharma Rajnarayan Ramlagan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12417",
    "name": "Sutar Laxmi Annappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22353",
    "name": "Vhanmane Uttam Krishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22407",
    "name": "Vishwakarma Krishna Kumar  B"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2607",
    "name": "Bhosale Manohar Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1452",
    "name": "Phalke Hanmant Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9029",
    "name": "Durgule Shalan Vishvanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22146",
    "name": "Bidgar Namdeo Bhikoo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22013",
    "name": "Gongde Suresh Yashwant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22134",
    "name": "Khan Bismillah Husain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22032",
    "name": "Korba Bauddin Sofilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22171",
    "name": "Mishra Krishna Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22058",
    "name": "Mohd Salim Abdul Razzak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22012",
    "name": "Nimbre Madhukar Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22269",
    "name": "Pathak Vishnu Atmaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22185",
    "name": "Patkar Sabaji Gundu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22011",
    "name": "Pawar Vithal Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22061",
    "name": "Prajapati Lakhu Jamuna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22010",
    "name": "Salunke Deepak Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22140",
    "name": "Sayyed Faiyaz Zaiuuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22006",
    "name": "Shaikh  Chand Umrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22197",
    "name": "Shaikh Mohd.Yusuf Ayub"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22062",
    "name": "Shaikh Rabul Hussain Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22014",
    "name": "Shaikh Rehana Najarahmad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22179",
    "name": "Shaikh Salim Mohammed."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22057",
    "name": "Sonawane Chandrakant Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22116",
    "name": "Sonkamble Chandrakant Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22246",
    "name": "Tamboli Gulab Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22188",
    "name": "Waghchore Kiran Rangnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22239",
    "name": "Yadav Baijnath Bholaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22071",
    "name": "Yadav Ramjit Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22271",
    "name": "Yewale Sanjay Vishnupant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10340",
    "name": "Ahirekar Maruti Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21932",
    "name": "Chetty Mohan Ramaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21816",
    "name": "Dube Omprakash Radeshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21869",
    "name": "Gupta Harikesh Shivnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21852",
    "name": "Jadhav Jayram Dharamsingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18530",
    "name": "Jadhav Rajendra Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21941",
    "name": "Kalamkar Satish Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21885",
    "name": "Kavatkar Devdas Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21883",
    "name": "Mali Shuklal Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21908",
    "name": "Mane Ashok Vishnu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21892",
    "name": "Mhaskar Maruti Budha."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21933",
    "name": "Mourya Harishchandra Ramsurat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10902",
    "name": "Mulik Jyotiram Nathuram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "319",
    "name": "Nikam Sandip Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21965",
    "name": "Pareet Sanjeevkumar Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23208",
    "name": "Pujari Sagar Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21987",
    "name": "Shaikh Mohd Rafiq Yusuf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21944",
    "name": "Shelar Umaji Ganu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21842",
    "name": "Singh Madansen Ramnagina"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21814",
    "name": "Yadav Hansraj Phoolchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21881",
    "name": "Yadav Parashanth Lauhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "530",
    "name": "Jagtap Shivaji Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21652",
    "name": "Chouhan Shyamnarayan Durjan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21671",
    "name": "Dange Istiaque Ahmed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21675",
    "name": "Desai Shivaji Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20301",
    "name": "Gharat  Santosh   Madhukar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21671",
    "name": "Goswami Umeshkumar Ramchander"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9764",
    "name": "Jadhao Jayashri Nandkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21734",
    "name": "Kahar Kailashnath Hiralal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21698",
    "name": "Kambli Jagannath Arjun"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "626",
    "name": "Magar Rahul Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21796",
    "name": "Mishra Chandramani Balgovind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21658",
    "name": "Pathak Shubhashchandra Ramabhilash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21760",
    "name": "Prajapati Baichu Bidhram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21660",
    "name": "Sayyed Mohmed Babamiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21783",
    "name": "Sharma Abhiraj Banarsi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21703",
    "name": "Yadav Abhimannyu Shobhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21749",
    "name": "Yadav Dayashankar Rajnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21699",
    "name": "Yadav Harinath Ramsundar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21682",
    "name": "Yadav Sureshpratap Ramjarshram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4760",
    "name": "Phalke Shantabai Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8176",
    "name": "Shekh Abira Amir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1598",
    "name": "Kadam Ramchandra Sadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8721",
    "name": "Jagtap Vasant Gyanba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5563",
    "name": "Jagtap Damu Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8230",
    "name": "Roman Baburao Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11975",
    "name": "Bista Gurkha Bhimbahadur Katakbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21438",
    "name": "Dandade Anuradha Ashok"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1449",
    "name": "Detke Mahesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15616",
    "name": "Karale Rajendra Ragunath."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2152",
    "name": "Sayyad Ayesha Abdul Khalil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19871",
    "name": "Shah Badsha Ismail"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10071",
    "name": "Shirke Vishwas Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3973",
    "name": "Jagdale Jotiram Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5566",
    "name": "Sabale Dattatray Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5226",
    "name": "Bande Vitthal Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4081",
    "name": "Shekh Mhairun Gulab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8273",
    "name": "Sakunde Raju Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21335",
    "name": "Ambre Narayan Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21159",
    "name": "Ansari Amanat Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21196",
    "name": "Ansari Imtiyaz Sumer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21163",
    "name": "Ansari Mohammad Idrish Ahmed Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21304",
    "name": "Ansari Mohd. Arman Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21724",
    "name": "Bangar Vaijnath Anantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21166",
    "name": "Bapat Bhujanga Raghvendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21126",
    "name": "Belose Deepak Jayaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17551",
    "name": "Bhosale Jayawant Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21328",
    "name": "Bopate Shashikant Raghu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21177",
    "name": "Chauhan Jaisingh Shriram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21118",
    "name": "Dhage Ramesh Barmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21174",
    "name": "Dhodhiya Sunil Magan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21214",
    "name": "Dhotre Laxman Yellappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21187",
    "name": "Farid Abdul Ahmed Makhajla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21185",
    "name": "Gade Arvind Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21199",
    "name": "Gaikwad Prakash Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21293",
    "name": "Ghugare Sadashiv Jyotiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21331",
    "name": "Gore Krishna Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21152",
    "name": "Goswami Dhanraj Kedarnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21239",
    "name": "Gupta Chhotelal Shivlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21151",
    "name": "Gupta Deepchand Shitalaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21160",
    "name": "Gupta Gulabchand Achhelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21203",
    "name": "Gupta Rajnarayan Bharavnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21240",
    "name": "Gupta Ramesh Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21117",
    "name": "Gupta Sarita Laxmiprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21336",
    "name": "Gupta Shivkumar Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21253",
    "name": "Jadhav Vinayak Keshwa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21301",
    "name": "Jaiswal Ashok Ratan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9382",
    "name": "Kadam Ujwala Wishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21134",
    "name": "Kadar Abdul Rashid Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21149",
    "name": "Kanojiya Hariram Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21291",
    "name": "Kargutkar Kishor Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21162",
    "name": "Khan Khalifa Ahmed Khoja Haroon"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21247",
    "name": "Khan Mohammed Shamim Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21128",
    "name": "Kharat Dnyandev Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21256",
    "name": "Krishna Mari Mathu Javer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21289",
    "name": "Mahske Suresh Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21112",
    "name": "Milling Gurao Ramling"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21150",
    "name": "Mishra Raja Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21138",
    "name": "Mistry Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21229",
    "name": "Mistry Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21119",
    "name": "Mistry Abhay Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21251",
    "name": "Mohd. Irfan Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21219",
    "name": "Nair Prakash Chanshekhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21193",
    "name": "Nazmin Ayub Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21200",
    "name": "Negi Darshan Vinod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21183",
    "name": "Panday Gayadin Vaidyanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21266",
    "name": "Panday Lalchand Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21334",
    "name": "Pandey Chitrasen Dharmatma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21323",
    "name": "Pandey Pralhad Kundan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21294",
    "name": "Patel Paresh Rameshbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21325",
    "name": "Patel Ramesh Harkha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21171",
    "name": "Patel Ranchodbai Ravji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21202",
    "name": "Pathak Dinanath Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21147",
    "name": "Pathak Hemantkumar Upendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21302",
    "name": "Pathan Abdul Karim Abdul Majid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21315",
    "name": "Pyarelal Bhagelu Sahu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21218",
    "name": "Rashid  Mohammad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21175",
    "name": "Rehman Aslam Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21145",
    "name": "Riyaj Ahmed Mohd Adil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21201",
    "name": "Saffan Ismail Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21217",
    "name": "Saval Ravikant Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21303",
    "name": "Sawant Ajit Vithalrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21300",
    "name": "Sayad Farooq Ahmed Sabir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21241",
    "name": "Sayed Karamatali Ashrafali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19776",
    "name": "Sayyad Iqubal Aziz Sayyad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21326",
    "name": "Shaikh Inayat Khurshid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21221",
    "name": "Shaikh Jaan Mohammad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21176",
    "name": "Shaikh Jibrail Safiullah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21329",
    "name": "Shaikh Mansur Algu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21220",
    "name": "Shaikh Mohammad Ikbal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21181",
    "name": "Shaikh Mohammed Tahir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21144",
    "name": "Shaikh Mohd Samir Abdul Haroon"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21267",
    "name": "Shaikh Mohmad Miraj Ebrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21295",
    "name": "Shaikh Ruksana Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21288",
    "name": "Shaikh Sohel Mohd.Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21194",
    "name": "Sharma Birendranath Jankiprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21184",
    "name": "Sharma Dilip Gurucharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21333",
    "name": "Sharma Vijay Ramprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21299",
    "name": "Shrivatsav Shyamdhar Shehnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21213",
    "name": "Shukla  Santoshkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21204",
    "name": "Singh Chandresh Swamisant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21338",
    "name": "Singh Ratanlal Bhairav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21170",
    "name": "Singh Surypal Rajmani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21143",
    "name": "Tambe Malin Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21136",
    "name": "Tiwari Indradhar Ramswarup"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21324",
    "name": "Upadhayay Babuna Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21161",
    "name": "Upadhayay Triloknath Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21314",
    "name": "Vaidya Suman Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21339",
    "name": "Vora Shaukat Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17797",
    "name": "Wagh Keshav Tatyaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21337",
    "name": "Waghmare Jagalu Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21243",
    "name": "Wahida Salim Mohd Noor Mohd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21178",
    "name": "Waz  Jenniter"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21265",
    "name": "Yadav Arvindkumar Mesal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21173",
    "name": "Yadav Dhirajlal Mangal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21252",
    "name": "Yadav Gopalchand Kantaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19807",
    "name": "Yadav Hiralal Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21238",
    "name": "Yadav Kamlawatidevi Akhilesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21158",
    "name": "Yadav Loknath Rajnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21216",
    "name": "Yadav Mahadeo R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21186",
    "name": "Yadav Prakash Dharmadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21148",
    "name": "Yadav Ramasare Sobhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21137",
    "name": "Yadav Rambachan Rajdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21182",
    "name": "Yadav Satyapal Ramdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6057",
    "name": "Shaikh Rashid Jafar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7647",
    "name": "Sayyad Hatimabi Akbar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5059",
    "name": "Lohar Namdeo Rangnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6287",
    "name": "Shinde Niwas Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5799",
    "name": "Pisal Prashant Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1247",
    "name": "Hamdare Esa Ujali."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21499",
    "name": "Ghorpade Rajendra Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16467",
    "name": "Shroff  Jayesh."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13227",
    "name": "Suryavanshi Sarika Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4699",
    "name": "Jadhav Dinkar Buaa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "166",
    "name": "Bharat Engineering Works"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2370",
    "name": "Kharat Ramchandra Jagnnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20403",
    "name": "Bhalerao Sahebrao Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13364",
    "name": "Chavan Dinkarrao Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13363",
    "name": "Chavan Manisha Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20402",
    "name": "Dongre Machindra Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20404",
    "name": "Kashyap Ashish Kumar Mulchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20405",
    "name": "Kudtarkar Laxman Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20431",
    "name": "Mahadik Ajit Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20433",
    "name": "Mohmad Shabir Mohmad Ishak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15514",
    "name": "More Babutai Yeswant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20407",
    "name": "Naka Arjun Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20428",
    "name": "Swamy Nagraj Punna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20383",
    "name": "Bhor Suresh Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20398",
    "name": "Chougale Vazirahmed Umar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20393",
    "name": "Dhanraj  Ratan Charan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9881",
    "name": "Gaikwad Ninna Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20392",
    "name": "Gupta Shatrughna S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20348",
    "name": "Khan Imtiyaz Abbas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20369",
    "name": "Khan Rafiq Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20365",
    "name": "Majeed Noor Mohmmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14632",
    "name": "Matulkar Sunil Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20396",
    "name": "Mishra Krishna Ram Milan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13279",
    "name": "Mlandhare Satish Mahadeo"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "181",
    "name": "Patel Murji Punj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20358",
    "name": "Prajapati Jiten Katwara"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20346",
    "name": "Qureshi  Mohd.Salaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "545",
    "name": "Sarafe Nagesh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20368",
    "name": "Shabir Nazir Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20370",
    "name": "Vane Sanjay Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20352",
    "name": "Varma  Ram Brij"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20394",
    "name": "Veluswami  Mutteya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20384",
    "name": "Yevle Subhash Devram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2254",
    "name": "Khushi Rayon Silk Mills"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3521",
    "name": "Khushi Silk Mills"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18571",
    "name": "Thorat Bapu Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3746",
    "name": "Sawant Shankar Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2007",
    "name": "Chatur Shilabai Tanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8896",
    "name": "More Pravin Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9135",
    "name": "Nikam Sagar Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1598",
    "name": "Chikne Nivrutti Nanu."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2621",
    "name": "More Jairam Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20200",
    "name": "Bhandari Pinki Ramkrisna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20191",
    "name": "Gaikar Sunita Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20230",
    "name": "Gupta Kamlesh Heralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20207",
    "name": "Inamdar Mauzam Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20210",
    "name": "Karande Anand Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16710",
    "name": "Khatri Vishal Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20185",
    "name": "Kolambkar Uday Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20229",
    "name": "Mishra Kalika Prasad O"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20186",
    "name": "Mohd Aslam Mohd Hussien.."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20176",
    "name": "Mohit Akhlakh Ahmed Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20182",
    "name": "More Ramakant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20183",
    "name": "N. Vellu Nadol Salyan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20227",
    "name": "Patil Ramesh Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10190",
    "name": "Pawar Chandrakant Raghunathl"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20175",
    "name": "Puhi Harbhajansingh Nanaksingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20192",
    "name": "Satoskar Avinash Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20226",
    "name": "Shinde Salil Dattratray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20223",
    "name": "Siddhique Shaikh Tahir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20184",
    "name": "Sodaye Vijay Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20215",
    "name": "Tawradare Bauraj Gurling"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20228",
    "name": "Vora Hitesh Nevsi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20193",
    "name": "Yadav Madan Kanhyalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20181",
    "name": "Yadav Ramesh Meeta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20239",
    "name": "Yerunkar Ramakant Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2161",
    "name": "Kiran Labour Service"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "14",
    "name": "Kiran Tours & Travel"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20237",
    "name": "Yusuf Hanif Khan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6429",
    "name": "Waghmale Janardhan Dhondi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7790",
    "name": "Musale Soupan Vaman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8505",
    "name": "Bandal Dattu Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8518",
    "name": "Toraskar Ramesh Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8272",
    "name": "Salunkhe Bhagwat Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13267",
    "name": "Jadhav Laxmi Sunil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12861",
    "name": "Kadam Hanmant Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15515",
    "name": "Sankpal Savita Rajendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12441",
    "name": "Sapkal Sampat Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1338",
    "name": "Raut Vithal Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9452",
    "name": "Shivekar Shivaji Mahadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1317",
    "name": "Chatur Baban Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "522",
    "name": "Ansari Mohd Haiderali Ishratali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12989",
    "name": "Aohale Sunil Namdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12807",
    "name": "Ayyed Asif Amir"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1234",
    "name": "Bajage Sanket Sawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19976",
    "name": "Gawda Jagdish Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12997",
    "name": "Ghorpade Dnahyandev Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13044",
    "name": "Kumbhar Gokula Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20094",
    "name": "Mishra Laldhar Shyamsundar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19416",
    "name": "Mohd. Sadiqulla Fakruddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13064",
    "name": "More Dnyanu Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12827",
    "name": "Nashikar Ayesha Ramjan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20119",
    "name": "Pandey  Sanjaykumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20092",
    "name": "Patel Ayub Chand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13052",
    "name": "Phalke Kalpana Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12982",
    "name": "Salunke Hanmant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16549",
    "name": "Salunkhe Govida Pandurang."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13055",
    "name": "Sangale Dilip Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13069",
    "name": "Sapkal Vitthal Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12993",
    "name": "Sayyed Ahamed Imran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20107",
    "name": "Shaikh Babu Abdul Hasan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13051",
    "name": "Shelke Baba Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19443",
    "name": "Tanalkar Sadanand Shanalkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20120",
    "name": "Thakur Lajpat Shivcharansingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21491",
    "name": "Nalawade Prakash Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8374",
    "name": "Bichukale Vilas Rav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19927",
    "name": "Ansari Khurshid A Amir Husain"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12909",
    "name": "Bhatia Usha Omprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16353",
    "name": "Bhavsar Paresh Purshotam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12882",
    "name": "Chavan Aamba Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19955",
    "name": "D`Souza Pius Lieo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19969",
    "name": "Doshi Bhagwan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19920",
    "name": "Dsouza Santan Kazmin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12873",
    "name": "Ghodake Varsha Nilesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12903",
    "name": "Gulwe Sanjay Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19901",
    "name": "Gupta Ashok Kumar Sona"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17221",
    "name": "Hule Sachin Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4224",
    "name": "Jadhav Anant Kashiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12871",
    "name": "Jadhav Sampat Baba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12878",
    "name": "Kadam Baliram Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12946",
    "name": "Kadam Nilesh Dattatraya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12848",
    "name": "Kamble Sudhir Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19903",
    "name": "Khan Shabana Shahabuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12953",
    "name": "Madhav Pralhad Samachar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19936",
    "name": "Mohd Hajnen Sharif Alam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19909",
    "name": "Panchal Vijay Natwarlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9934",
    "name": "Pawar Tukaram Kesu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12838",
    "name": "Sakunde Laxman Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19937",
    "name": "Shaikh Azaz Ahmad Bashir Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19954",
    "name": "Shaikh Chandbadshah Abdulrehman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19945",
    "name": "Shaikh Gafoor Badshah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19922",
    "name": "Shaikh Jafar Latif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19921",
    "name": "Shaikh Mohd Eraf Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19951",
    "name": "Shaikh Sartaj Shouket Hussain"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12842",
    "name": "Shidture Sandeep Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19926",
    "name": "Shikh Sherali Isaq"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12949",
    "name": "Sutar Dhanwant Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18782",
    "name": "Tirthe Ramesh Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19956",
    "name": "Velachi Kashinath Savanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19968",
    "name": "Vishwakarma  Ramnath Bindeshwarprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19911",
    "name": "Yadav Brijlal Prasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12933",
    "name": "Yadav Tajesh Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5500",
    "name": "Phalke Balaso Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4965",
    "name": "Bodake Sakharam Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2398",
    "name": "Sanas Kashinath Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3537",
    "name": "Ganesh Sharad Gopalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2534",
    "name": "Phadatare Sampat Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6098",
    "name": "Phalke Sanjay Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8973",
    "name": "Kulkarni Devidas Padmakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2352",
    "name": "Kadam Yashwant Parsharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5724",
    "name": "Awade Aba Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8279",
    "name": "Mahangade Pralhad Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18698",
    "name": "Bhatkar Suryakant Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19394",
    "name": "Jaiswal Chunne Hiralal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11927",
    "name": "Katkar Ramdas Abaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15997",
    "name": "Panjawani Vanisha Dilip / Panjawani Hite"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6955",
    "name": "Shinde Sarjerao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18719",
    "name": "Solaskar Sudhakar Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2555",
    "name": "Mulla Sayyad Mohomad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10352",
    "name": "Jadhav Ananda Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9072",
    "name": "Mulik Pandurang Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "388",
    "name": "Dalvi Balkrishna Narhari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2631",
    "name": "Pisal Nana Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "432",
    "name": "Jagatap Babu Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9005",
    "name": "Mhetras Deepak Arvind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2412",
    "name": "Shinde Vishwash Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1723",
    "name": "Momin Rashida Hasan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8988",
    "name": "Sakunde Madhukar Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8234",
    "name": "Phalke Sushila Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8805",
    "name": "Satpute Sharad Dnyaneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2345",
    "name": "Mali Vithoba Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11461",
    "name": "Jagadale Sandeep Gulabraao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3970",
    "name": "Sabale Mahindra Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19893",
    "name": "Akram Yusuf Kazi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19838",
    "name": "Anwar Alga Ansari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10542",
    "name": "Bhosale Ankush Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11055",
    "name": "Chavan Dilip Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19839",
    "name": "Dukka Salim Rahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19842",
    "name": "Gupta Mohanlal R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19864",
    "name": "Gupta Nokhelal Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19885",
    "name": "Halwai Rajesh Salikram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12209",
    "name": "Inamdar Minaz Munir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6881",
    "name": "Jadhao Bhimarao Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19828",
    "name": "Jadhav Satish Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12725",
    "name": "Jadhav Satish Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10168",
    "name": "Jagdale Jagannath Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12746",
    "name": "Jagdale Kishori Suyog"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8838",
    "name": "Jagtap Suresh Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19891",
    "name": "Joseph Ibrahim Mendosa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10085",
    "name": "More Hanumat Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19887",
    "name": "Palav Anirudha Achyut"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12728",
    "name": "Panvelkar Shanakar Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19888",
    "name": "Parmar Mahendra Sumanbhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12764",
    "name": "Patole Maruti Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19824",
    "name": "Pawaskar Madhukar Bala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19886",
    "name": "Perumal Karipan Devendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19816",
    "name": "Pujari Ramanand Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19874",
    "name": "Qreshi Mohd Farooq Yakub"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9368",
    "name": "Rajbhar Gajraj Sudharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19848",
    "name": "Sakpal Jotiba Ramchandra +"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19872",
    "name": "Shaikh Abdul Gafur Nazir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19825",
    "name": "Shaikh Amir Basumiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19847",
    "name": "Shaikh Mehboob Ali Mohd.Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19843",
    "name": "Shaikh Mohd. Haroon Badshah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19841",
    "name": "Shaikh Shakur B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19829",
    "name": "Sharma Brijbhan Parswan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19830",
    "name": "Singh Omprakash Chauharaja"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19854",
    "name": "Surve Vijay Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19354",
    "name": "Tupe Sachin Bajrang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12742",
    "name": "Yadav Chandrabhaga Rajnikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19840",
    "name": "Yadav Ramjivan R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19817",
    "name": "Yadav Shriram Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19853",
    "name": "Yadav Sochan Rajbali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11826",
    "name": "Gavali Ajay Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8017",
    "name": "Lembe Arun Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5156",
    "name": "Jadhav Vilas Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2221",
    "name": "Jagdale Jagannath Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8006",
    "name": "Baraskar Shabbir H"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7713",
    "name": "Phalke Ramdas Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8521",
    "name": "Chavan Girish Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3447",
    "name": "Kadam Popatrao Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19797",
    "name": "D D\"Souza Paul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9231",
    "name": "Ghadge Jagannath Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19748",
    "name": "Godawariya Ramesh Karsan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19784",
    "name": "Gupta Sunilkumar Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19799",
    "name": "Hadwale Anant Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19766",
    "name": "Irshad Ahmed Sardar Ahmed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13103",
    "name": "Jadhav Bhanudas Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12693",
    "name": "Kadam Maruti Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5882",
    "name": "Kirdat Laxman Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19775",
    "name": "Mohamad Hanif Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19789",
    "name": "Mohd. Rafiq Mohd. Shafi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12718",
    "name": "More Chandrakant Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19787",
    "name": "Panchal Anil Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12696",
    "name": "Patel Shakira Ayub"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19764",
    "name": "Patil Sudhakar Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12708",
    "name": "Pawar Gulabrao Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19780",
    "name": "Rane Prashant Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19809",
    "name": "Sabuddin Ali Bhimani Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19802",
    "name": "Shaikh Habibullah Samsuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19796",
    "name": "Shaikh Mehboob Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19808",
    "name": "Shikh Bademiya T."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12713",
    "name": "Shinde Sanjay Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19790",
    "name": "Upadhyay Dinesh Chandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19805",
    "name": "Yadav Chahiraj Paravat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15481",
    "name": "Yadav Vishnu Krishna [ Pan Aanpy 0776E ]"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2708",
    "name": "Kadam Parasharam Genba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5235",
    "name": "Shedge Vasant Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5564",
    "name": "Beg Rajjak Yakub"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8361",
    "name": "Chavan Narayan Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9133",
    "name": "Pawar Parshuram Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4728",
    "name": "Pawar Baban Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6585",
    "name": "Pisal Parvati Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9052",
    "name": "Momin Salim Sattar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3",
    "name": "Pisal Ramrao Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3708",
    "name": "Kadam Avinash Dharmaji."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4038",
    "name": "Kulkarni Ramesh Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4130",
    "name": "Pathare Ramesh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3900",
    "name": "Kothare Anita Sunil Rane"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2407",
    "name": "Kadam Hindurao Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4663",
    "name": "Mujawar Mubarak Shegaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1563",
    "name": "Bhosale Ranjana Fattehsinh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22573",
    "name": "Bhosale Vinod Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12477",
    "name": "Gujar Ramesh Guruprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12665",
    "name": "Jadhav Sahebrao Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19166",
    "name": "Mohd Sahid Ali Lal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12475",
    "name": "Nalawade Maruti Shyamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9603",
    "name": "Phalke Pradeep Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12472",
    "name": "Shaikh Yusuf Shamshuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7430",
    "name": "Shitaphe Shakuntala Yashawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12655",
    "name": "Yewale Premila Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4290",
    "name": "Tambe Laxman Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5540",
    "name": "Deshmukh Arvind V"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "188",
    "name": "Sabale Balkrishna Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8620",
    "name": "Sapkal Bajrang Santu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2531",
    "name": "Kothari Offset Printers"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1468",
    "name": "Shirtode Narayan Bhiva"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6249",
    "name": "Bhise Laxman Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8526",
    "name": "Shelar Sunil Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8987",
    "name": "Chavan Savitrabai Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9050",
    "name": "Chavan Umesh Hanmantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7774",
    "name": "Wagh Eknath Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7865",
    "name": "Mane Sanjay Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4994",
    "name": "Jadhav Sampat Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "31",
    "name": "Jagdale Balkrishna Dada"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5052",
    "name": "Wagh Subhash Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12628",
    "name": "Agawane Dayanand Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17206",
    "name": "Babar  Jaysingh Balu."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "380",
    "name": "Bhoir Sandip Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19695",
    "name": "Chavan Sitaram Daulati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18333",
    "name": "Devrukhakar Kavita Sakharam."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12612",
    "name": "Gaikwad Deepak Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19690",
    "name": "Gupta Surendraprasad Jawlaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19707",
    "name": "Jadhav Sunil Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19726",
    "name": "Kurade Mohan Shetti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19706",
    "name": "Mapari Sultan Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19708",
    "name": "Naik Dattatray Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19720",
    "name": "Narvekar Jitendra Raman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19699",
    "name": "Parab Vijay Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19721",
    "name": "Patel Bipin Vallabhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12586",
    "name": "Pawar Rajendra Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2626",
    "name": "Krush Chem"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19733",
    "name": "Shabbir Sayed Hussain"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12596",
    "name": "Shinde Namdeo Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18232",
    "name": "Shinde Sunil Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17855",
    "name": "Shirke Chandrakant Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18540",
    "name": "Singh Harpreet Balraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12582",
    "name": "Waghmale Sandeep Parashuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19735",
    "name": "Yadav Ramashankar Bhullan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8883",
    "name": "Bansode Sanjay Bhagawan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7553",
    "name": "Jadhav Dattu Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2311",
    "name": "Sabale Suvarna Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7674",
    "name": "Kshirsagar Sarjerao Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4064",
    "name": "Gaikwad Suresh Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3944",
    "name": "Nikam Shivaji Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7606",
    "name": "Gaikwad Indu Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "781",
    "name": "Shinde Vilas Govindrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3881",
    "name": "Phalke Balkrishna Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7031",
    "name": "Gaikawad Janardan Pandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19669",
    "name": "Abdul Rehaman Abbas Shaikh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12545",
    "name": "Bhosale Murlidhar Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12533",
    "name": "Chavan Pramod Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12555",
    "name": "Chavan Ravindra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19643",
    "name": "Choudhary Mohd. Arif Yakub"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19617",
    "name": "Ghadi Umesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19621",
    "name": "Gupta Sunita Ramprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2715",
    "name": "Kuber Enpterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19610",
    "name": "Jabde Girish Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12513",
    "name": "Jadhav Maruti Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19662",
    "name": "Jha Shraankumar Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19611",
    "name": "Kambale Sharda Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19651",
    "name": "Khan Kalim Ishaq"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19666",
    "name": "Khan Mohd. Hanif Ayal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4551",
    "name": "Kurup Vijaya Shridhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12527",
    "name": "Londhe Shrikant Yashawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12507",
    "name": "Mane Mangal Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19607",
    "name": "Mapari Shaukat Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17191",
    "name": "Marathe Vijay Kundlik."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15987",
    "name": "Mulik Prashant Sampat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19629",
    "name": "Nepali Amarsingh Dhansingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12530",
    "name": "Nikam Shankarrao Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19636",
    "name": "Patel Maxie Jacob"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17322",
    "name": "Patil Ashok Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12546",
    "name": "Patil Uday Jayshingrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18608",
    "name": "Punjabi Kishor Munshiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12567",
    "name": "Rajpure Sunil Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12563",
    "name": "Sakunde Baliram Tulshidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19644",
    "name": "Shaikh Abdul Rehman Abdul Majid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19618",
    "name": "Shaikh Mohamed Rafiq Nabirajul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19628",
    "name": "Sharma Sharadkumar Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12526",
    "name": "Shekh Shahin Ibrahim"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12521",
    "name": "Shinde Dilip Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19679",
    "name": "Shrivastav Gorakh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18136",
    "name": "Solanki Sangeeta P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16690",
    "name": "Thakur Santoshkumar Raneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12525",
    "name": "Wagh Dasharath Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19616",
    "name": "Yadav Shardaprasad Vikram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "41",
    "name": "Chavan Parvatibai Shankarrao."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2125",
    "name": "Jagtap Maruti Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3795",
    "name": "Kambale Ladabai Sonu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8880",
    "name": "Chalke Rahul Dagdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5501",
    "name": "Dhumal Shaila Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "899",
    "name": "Raut Jyoti Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8736",
    "name": "Kamble Dhakuram Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7904",
    "name": "Vichare Bajarang Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7743",
    "name": "Shinde Nagnath Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12333",
    "name": "Bhuvad Sudhakar Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7199",
    "name": "Aware Ramchandra Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17813",
    "name": "Jadhav Anant Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17706",
    "name": "Kawar  Balkrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17740",
    "name": "Labde Vilas Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17676",
    "name": "Manjrekar Jeetendra Sahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17674",
    "name": "Manjrekar Navnath Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17675",
    "name": "Manjrekar Pravin Narendea"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17776",
    "name": "Naidu Prabha Haridas/Samir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17841",
    "name": "Rao Luckydevi Nageshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17716",
    "name": "Salunkhe Anita Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18275",
    "name": "Samudra Nalini Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12955",
    "name": "Sapkal Neeta Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17702",
    "name": "Sawant Kalpana Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18746",
    "name": "Shaikh Gulam Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5011",
    "name": "Shaikh Mainuddin Rehaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17809",
    "name": "Talekar Asman Bhaurao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "470",
    "name": "Bendakoli Dattatray Tulshiram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "799",
    "name": "Kumaun Security Services"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3239",
    "name": "Sabale Sadashio Kundlic"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6906",
    "name": "Kadam Purashotam Vishvanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7529",
    "name": "Gaikwad Namdeo Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7623",
    "name": "Phalke Ramesh Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3396",
    "name": "Jadhao Janardhan Jaganath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7285",
    "name": "Shaikh Jaibun Jafar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4735",
    "name": "Bhosale Gajanan Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5947",
    "name": "Pawar Rama Ramchadra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3399",
    "name": "Mane Sampat Ganapat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3102",
    "name": "Disale Vimal Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7558",
    "name": "Gaikwad Lilawati Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12830",
    "name": "Gore Sandeep Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1119",
    "name": "Jadhav Shivram Chandru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1124",
    "name": "Sabale Jaisingh Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19588",
    "name": "Chavan Arun Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17530",
    "name": "Chavan Popat Jaganath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12648",
    "name": "Chavan Tarabai Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9298",
    "name": "Chavan Trimbak Bhikoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15010",
    "name": "Choudhary Satyasheela Goroba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19604",
    "name": "Daw Suresh Wilyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12426",
    "name": "Gothankar Subhash Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12427",
    "name": "Jadhav Dattatray Bhikoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19544",
    "name": "Kadam Dattaram Anant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8235",
    "name": "Kakade Dipak Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19545",
    "name": "Kambale Prakash Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17559",
    "name": "Keni Ratna Prabhakar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19592",
    "name": "Keni Sunil Sadanand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12437",
    "name": "Landge Shatrughna Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12463",
    "name": "Mane Ashok Wishvanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17488",
    "name": "Marwadi Soni Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17696",
    "name": "Mohite Sachin Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17587",
    "name": "More Nayna Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9507",
    "name": "Nachan Digambar Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19590",
    "name": "Nachanekar Mohan Anant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11144",
    "name": "Nandgaonkar Makrand Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16165",
    "name": "Noor Mohama Peer Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19589",
    "name": "Pal Girijashankar Sarju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19601",
    "name": "Pal Kansaraj Shobhanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19602",
    "name": "Pandagale Rohidas Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19577",
    "name": "Pawar Shashikant Khandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12529",
    "name": "Phalke Hanmant Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11464",
    "name": "Pisal Gandhari Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12429",
    "name": "Pol Ravindra Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17580",
    "name": "Raghav Eknath Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19528",
    "name": "Rane Gurunath Sahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19593",
    "name": "Rathod Ravindra Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12444",
    "name": "Salunhe Sandeep Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17613",
    "name": "Salunkhe Ajit Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12466",
    "name": "Salunkhe Kisan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17538",
    "name": "Salunkhe Prashant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19573",
    "name": "Sawant Jagannath Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12443",
    "name": "Sawant Sampat Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17519",
    "name": "Sawant Sanjay Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19564",
    "name": "Sawaya Raman Chinappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17599",
    "name": "Shah Rushikumar R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19554",
    "name": "Shaikh Abdul Gafur Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6949",
    "name": "Shaikh Moiuddin Aliuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17575",
    "name": "Sharma Avdeshkumar Vishvakarma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17573",
    "name": "Sharma Jitendra Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19603",
    "name": "Shetty Narayan Jarappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17157",
    "name": "Shinde Pallavi Himatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17564",
    "name": "Ubale Deepak Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19543",
    "name": "Yadav Rajnath Kalluram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7745",
    "name": "Agam Satish Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4401",
    "name": "Gaikawad Mangal Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5993",
    "name": "Shinde Ramchandra Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6061",
    "name": "Bhosale Parshuram Manu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6184",
    "name": "Ghorpade Shivaji Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11512",
    "name": "Nachnekar Rajani Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8294",
    "name": "Kadam Krushnat Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10529",
    "name": "Pisal Malan Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10182",
    "name": "Shinde Suresh Appa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1741",
    "name": "Mulla Sharifa Mohmed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4079",
    "name": "Jadhav Anandraaaao Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3738",
    "name": "Mane Ravindra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4541",
    "name": "Jagtap Vilas Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6992",
    "name": "Ithape Chatura Bhairavnath"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "621",
    "name": "Kumkum Printers"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3338",
    "name": "Kadam Dnyandeo Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1968",
    "name": "Gadhave Ramchandra Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19477",
    "name": "Acharya Mahendra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12000",
    "name": "Birwale Aavba Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19417",
    "name": "Bote Krishna Dashrath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12425",
    "name": "Chavan Vijaykumar Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12406",
    "name": "Chikate Dattatray Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19420",
    "name": "Danawale Dnyanoba. Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12859",
    "name": "Dandekar Shekhar Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19458",
    "name": "Dawood Salim Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19486",
    "name": "Gangurde Rajaram Bhagwat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19423",
    "name": "Gupta Raghunath Parasnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19435",
    "name": "Gurav Suryakant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19461",
    "name": "Hussain  Muktar Bashir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17433",
    "name": "Jagtap Ganpat Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19475",
    "name": "Kadam Chandrakant Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17373",
    "name": "Kadam Manisha Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2273",
    "name": "Kadam Tukaram Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12395",
    "name": "Kadam Vijaya Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19511",
    "name": "Kaliyankar Usman Abdullah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17343",
    "name": "Kamath Swetha V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17394",
    "name": "Kap Arti Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19492",
    "name": "Kaskar  Sukur Sanfrancis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19485",
    "name": "Khan Abdul Yashim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19490",
    "name": "Khan Amirali Nazirali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19415",
    "name": "Khude Maruti Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19421",
    "name": "Mane Uttam Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17440",
    "name": "More Manik Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19515",
    "name": "Mourya Shivkumar Bhim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19510",
    "name": "Namdev Abhivant Sajanrav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19453",
    "name": "Pal Lalmani Shriram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19504",
    "name": "Pathan Hayat Mehboob Khan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17407",
    "name": "Pawar  Pradeep Ganga"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17383",
    "name": "Pawar Hanumant Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12394",
    "name": "Pawar Subhash Anna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19438",
    "name": "Pawar Vilas Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19505",
    "name": "Pednekar Maruti Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12408",
    "name": "Pisal Hindurao Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19422",
    "name": "Qureshi Mohamad Aslam Chandmiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19476",
    "name": "Saraya Dinesh Randhodji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19454",
    "name": "Sayad Sirajuddin Sharifuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19518",
    "name": "Shaikh Rafiq Tajmohamed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17574",
    "name": "Sharma Suraj Ramnaresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1627",
    "name": "Kushal Road Lines"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19437",
    "name": "Shenvi Shashikant Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17428",
    "name": "Shinde Manubai Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17349",
    "name": "Takke Vishvanath Namdev /"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19463",
    "name": "Yadav Jitendra Kantaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19442",
    "name": "Yadav Muleharidevi Ramkher"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2006",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19516",
    "name": "Yadav Nandlal Hawaldar Sukhaya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "293",
    "name": "Pisal Sadhu Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7357",
    "name": "Ahirekar Pandit Subhedar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7359",
    "name": "Bhosale Gorakh Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2385",
    "name": "Jadhav Harischandra Dagdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12816",
    "name": "Jadhav Sujay Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8282",
    "name": "Pawar Raosaheb Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9598",
    "name": "Shinde Jannath Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3961",
    "name": "Shivankar Malhari Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7657",
    "name": "Pawar Sampat Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8640",
    "name": "Pisal Chandrabhaga Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7330",
    "name": "Jadhav Bhiku Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "645",
    "name": "Mane Vithal Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4197",
    "name": "Nikam Dhansing Dattu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7248",
    "name": "Shinde Babanrao Mugutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2163",
    "name": "Chatur Nana Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2693",
    "name": "Kusum Textiels"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8265",
    "name": "Bhosale Shashikant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5653",
    "name": "Jadhav Anil Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5230",
    "name": "Pawar Asha Sahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1555",
    "name": "Rajmane Mohan Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8262",
    "name": "Babar Shushhama Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12371",
    "name": "Bhoite Shivaji Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12340",
    "name": "Dhane Santosh Tanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12330",
    "name": "Jadhav Chandrashekhar Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15923",
    "name": "Jadhav Sunil Gangadhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3752",
    "name": "Kadam Dinkar Bala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12356",
    "name": "Kadam Dinkar Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15764",
    "name": "Kamble Rajkumar Sundarlal Mrs.Meena Rajk"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6921",
    "name": "Kokate Vasudha Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12351",
    "name": "Pawar Puja Ambaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18164",
    "name": "Pawar Rajesh Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12352",
    "name": "Pawar Rani Ankush"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1956",
    "name": "Pawar Uttam Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9935",
    "name": "Phalake Kiran Balawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12324",
    "name": "Phalke Madhukar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13093",
    "name": "Phalke Nitin Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12299",
    "name": "Sabale Amar Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12360",
    "name": "Sabale Pralhad Bali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12327",
    "name": "Sakunde Ramchandra Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12624",
    "name": "Sapkal Jagnnath Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12339",
    "name": "Sarkle Vithal Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12306",
    "name": "Shinde Suresh Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1831",
    "name": "Sawant Sahebrao Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7987",
    "name": "Jadhav Shamrao Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10357",
    "name": "Bhosale  Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4992",
    "name": "Sable Maruti Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5854",
    "name": "Bhagvat Balkrishna Chaintu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2680",
    "name": "P Ramanuzam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12405",
    "name": "Jadhav Nitin Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5944",
    "name": "Chavan Archana Krishana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8293",
    "name": "Chawan Shamrao Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5288",
    "name": "Barge Ramesh Natha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7452",
    "name": "Lohar Suresh Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11100",
    "name": "Sawant Versha Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2795",
    "name": "Avade Sulabai Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "846",
    "name": "Gyandev Krishna Manjrekar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4414",
    "name": "Bhosale Sopan Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4767",
    "name": "Jadhav Sulabha Dnyaneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4643",
    "name": "Sable Mahadeo Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6908",
    "name": "Jadhao Mathura Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19407",
    "name": "Baig Mehmood Mohd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17891",
    "name": "Bhatt Bipinchandra Amrutlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12282",
    "name": "Bhosale Jalindar Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19337",
    "name": "Dasin D. Roache"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9251",
    "name": "Garash Nanda Gajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19367",
    "name": "Gupta Munshi Mewalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19317",
    "name": "Gupta Ramnath Deepchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19316",
    "name": "Husain Mohd Hanif Mohd"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12286",
    "name": "Jadhav Govind Appasheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12274",
    "name": "Jadhav Sunil Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19309",
    "name": "Kadam  Tukaram Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17052",
    "name": "Kambale Avinash Atamaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19376",
    "name": "Khot Annasaheb Yallappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19395",
    "name": "Koli Malikaarjun Bhimanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16938",
    "name": "Kori Ashokkumar Dayaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12283",
    "name": "Mahadik Sahebrao Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17067",
    "name": "Mhadik Subhadra Ramchandgra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19329",
    "name": "Nadar Murugeshan Devraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19360",
    "name": "Naidu Meena Ganesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12253",
    "name": "Nimbalkar Vijay Yadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12262",
    "name": "Panbude Harishchandra Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16956",
    "name": "Pardeshi Narendrasing Naryansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19341",
    "name": "Pawar Suresh Yashawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19312",
    "name": "Rane Santosh Shashikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12250",
    "name": "Sabale Shrimant Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19357",
    "name": "Salagare Vijaya Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22625",
    "name": "Salunkhe Sujit Uddhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19396",
    "name": "Sangle Baby Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19409",
    "name": "Satardekar Santosh Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19402",
    "name": "Sayad Iqbal Sayadmastan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10028",
    "name": "Shahane Madhav Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19330",
    "name": "Shaikh Azim Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19342",
    "name": "Shaikh Liyakat Najir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19311",
    "name": "Shaikh Sufia Shafique"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19313",
    "name": "Shende Ashok Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19377",
    "name": "Singh Jawhar Sudarshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19363",
    "name": "Solanki Suresh Nathalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19328",
    "name": "Yadav Lalchand Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19318",
    "name": "Yadav Shyamlal Boodan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19345",
    "name": "Yadav Vinodkumar Feku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19336",
    "name": "Zari Nisar Abdul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5725",
    "name": "Sapakal Manukabai Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13796",
    "name": "Sarafdar Anusaya Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7796",
    "name": "Sheersagar Suraka Mughatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8871",
    "name": "Kadam Rajendra Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3621",
    "name": "Lembhe Sushila Amrutrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11459",
    "name": "Parathe Balu Dagadu."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2455",
    "name": "Sakunde Balkrishna Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2862",
    "name": "Sakunde Ankush Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3960",
    "name": "Bamane Shankar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8261",
    "name": "More Dagadu Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1774",
    "name": "Netke Sahebrao Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3909",
    "name": "Birges J.Louis S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19299",
    "name": "Abbas Ali Mohd.Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19290",
    "name": "Ansari Taslim Ahmad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12207",
    "name": "Bhosale Navnath Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19267",
    "name": "Borge Madhukar Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7527",
    "name": "Chalke Parasharam Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19257",
    "name": "Devendra Velayayadam Kundaswami"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9232",
    "name": "Dhumal Chandrakant Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16912",
    "name": "Ghag Rekha Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16729",
    "name": "Gurav Surendra Shivram/Uma Gurav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19298",
    "name": "Habib Iabal Habib Noor Mohd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19266",
    "name": "Khadse Gopal Pandit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19289",
    "name": "Khan Salim Mohamed"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3288",
    "name": "Lalit Kumar Milapchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19301",
    "name": "Lokare Sambhaji Anna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19280",
    "name": "Maredi Hemant Keru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17237",
    "name": "Mishra Akhileskumar Krishnakumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19256",
    "name": "More Surendra Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8249",
    "name": "Nimbalkar Satish Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19125",
    "name": "Parekh Premal Arvindlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19283",
    "name": "Patel Harishankar Harsan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19265",
    "name": "Pille Iskisaamm Kahan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17015",
    "name": "Pradhan Karbhari Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12193",
    "name": "Sakunde Uddhav Madhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16739",
    "name": "Salve Priti Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12921",
    "name": "Sayyed Yasmin Chintan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19285",
    "name": "Shaikh Abdul Razak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19302",
    "name": "Shaikh Imamuddin Nijamuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15115",
    "name": "Shashikant Janardhan Bhandari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8826",
    "name": "Shewale Asha Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11310",
    "name": "Shinde Vilas Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19258",
    "name": "Singh Mohan Rajnath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19260",
    "name": "Surve Kishor Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12809",
    "name": "Sutar Sonal Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19295",
    "name": "Yadav Lalsaheb Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5299",
    "name": "Durgule Jijabai Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5967",
    "name": "Gurav Vinayak Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9495",
    "name": "Palaskar Rajaram Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "867",
    "name": "Phalke Rangrao Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8311",
    "name": "Pawar Yashawant Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "862",
    "name": "Phalke Narayan Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8789",
    "name": "Khopade Vinod Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7048",
    "name": "Gaikawad Manohar Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4112",
    "name": "Chavan Gulab Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4402",
    "name": "Wagh Popat Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1377",
    "name": "Thakur Indrasing Gagansingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5120",
    "name": "Daude Suryakant Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4672",
    "name": "Pisal Vinayak Yashawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1860",
    "name": "Bhosale Bajirao Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18185",
    "name": "Patil Ekta Jaywant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "760",
    "name": "Sakhare Sudhakar Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1647",
    "name": "Salunkhe Babaji Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6997",
    "name": "Pisal Shahaji Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12112",
    "name": "Awade Gauri Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16625",
    "name": "Bheda  Dipesh Pradeep"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11951",
    "name": "Bhosale Pralhad Anandrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1005",
    "name": "Biswal Surjaymani Jadomani"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12139",
    "name": "Bongane Satyawan Bhgawan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11361",
    "name": "Chavan Malhari Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19241",
    "name": "Choubey Shreerama Girija"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19231",
    "name": "Ghone Pradeep Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9237",
    "name": "Jadhav Ramrao Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12038",
    "name": "Jadhav Rupchand Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12144",
    "name": "Jadhav Shankar Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12130",
    "name": "Jadhav Vinayak Hariba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12198",
    "name": "Jagdale Ashok Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12133",
    "name": "Kadam Arun Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19249",
    "name": "Kadam Sandeep Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16683",
    "name": "Kadam Suhas Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19235",
    "name": "Khan Yukub Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13808",
    "name": "Kothari Pranay Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19237",
    "name": "More Shashikant Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19232",
    "name": "Naik Galib Mohd"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12092",
    "name": "Navadkar Anilkumar Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17243",
    "name": "Palekar Suvasini Vishvanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12148",
    "name": "Pawar Shivaji Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12099",
    "name": "Phalke Vishal Hanamnat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19240",
    "name": "Raheja Rajendra Hariram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18277",
    "name": "Rajanikant Chunilal Shah"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12109",
    "name": "Sabale Mohan Savalaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19242",
    "name": "Shaikh Yunus Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19228",
    "name": "Shukla Rameshkumar Ramsajivan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12153",
    "name": "Sutar Kusum Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2345",
    "name": "Laxmi Corporation"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1425",
    "name": "Laxmi Enterprises Co"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2073",
    "name": "Laxmi Venkatesh Textiles."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12107",
    "name": "Yadav Sunil Ekanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5596",
    "name": "Pandit Ramchandra Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7126",
    "name": "Bagwan Muktarmohammad Yunus"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7468",
    "name": "Jadhav Sunil Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3981",
    "name": "Lembhe  Dasharath   Narsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5106",
    "name": "Pawar Gopal Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9866",
    "name": "Chavan Sanjay Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4980",
    "name": "Phalke Akkatai Shivajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6941",
    "name": "Pawar Prabhavati Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3506",
    "name": "Jagtap Pradip Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12821",
    "name": "Sabale Sachin Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7221",
    "name": "Bista Hikmat Nayanbaddur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17804",
    "name": "Kanade Eknath D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9160",
    "name": "Badve Vijay Sudhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4389",
    "name": "Bhosale Urmila Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5997",
    "name": "Jangam Kumar Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19198",
    "name": "Adkamkar Arvind Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19111",
    "name": "Aktar Najma Shamim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19199",
    "name": "Ansari Abrar Mohd. Jafrul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19185",
    "name": "Ansari Mohd. Arif Sharif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19165",
    "name": "Belwalkar Shirish Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14207",
    "name": "Bhatte Amruta Praful"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14034",
    "name": "Bhoite Santosh Vasantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12400",
    "name": "Bhoite Shivaji Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11522",
    "name": "Bhosale Jaganath Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16406",
    "name": "Bobade Arjun Nagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19213",
    "name": "Buchkule Sachin Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19094",
    "name": "Chachale Vilas Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19164",
    "name": "Chari Subhash Sawala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19042",
    "name": "Chavan Prabhakar Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19171",
    "name": "Chavan Rajaram Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11518",
    "name": "Chavan Sanjay Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19210",
    "name": "Dhotre Lalu Tamma"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9777",
    "name": "Dhotre Sajana Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9628",
    "name": "Dhumal Narayan Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12040",
    "name": "Dhumal Rupesh Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19074",
    "name": "Dsouza Jaoauin Anthony"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19109",
    "name": "Dubey Ramashray Sabapati"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3983",
    "name": "Lembhe Sangeeta Sudhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16486",
    "name": "Goyal Harish Premkishan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9190",
    "name": "Gujar Hanmant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19168",
    "name": "Gupta Motichnad Ramavtar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19203",
    "name": "Gupta Prabhu Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19103",
    "name": "Gurav Randhir Kamlakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19104",
    "name": "Gurmi Mithailu Muddai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10026",
    "name": "Jadhav Manisha Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19088",
    "name": "Jadhav Ramdas Dinanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8114",
    "name": "Jadhav Sulabai Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19143",
    "name": "Joshi Hemant Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19110",
    "name": "Julfikar Husen Gulabnabi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12086",
    "name": "Kadam Arvind Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12069",
    "name": "Kadam Bajirao Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12056",
    "name": "Kadam Satish Hanamnat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19051",
    "name": "Khan Yusuf Rehman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16393",
    "name": "Kolte Daynesh Suryakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17007",
    "name": "Kudre Ambubai Shripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17879",
    "name": "Kumbhar Sadashiv Ramchandra"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "125",
    "name": "Life Educational Social Trust"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4018",
    "name": "Lifeasia Reprographics"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19068",
    "name": "Mali Mahendra Shobhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16611",
    "name": "Mehata Prakash Karsandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19144",
    "name": "Mishra Preamchandra Amarnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19219",
    "name": "Mustafa Sayed Manzoor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19112",
    "name": "Nagori Ayub Ishaq"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19212",
    "name": "Naik Yashawant Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19187",
    "name": "Nevrekar Mahadeo Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19169",
    "name": "Pal Shivsagar Sukharn"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19149",
    "name": "Pandey Surendrakumar Shyamkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19133",
    "name": "Parmar Govind Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17064",
    "name": "Parmar Paresh Jugjivan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19059",
    "name": "Patel Krishnakant Madhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19069",
    "name": "Pathak Surendra Hariharnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19107",
    "name": "Pathak Vijay Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19132",
    "name": "Patil Suryakant Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16412",
    "name": "Pawar Pravin Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19053",
    "name": "Poojari Ashok Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12054",
    "name": "Pote Megha Niteen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19197",
    "name": "Quraba Mehaboob Babodin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19209",
    "name": "Rajbhor Ajaykumar Achaibar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19099",
    "name": "Rajput Prakash Kishorsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12059",
    "name": "Sabale Chandrakant Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12072",
    "name": "Sabale Ravindra Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19204",
    "name": "Sawant Gundu Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19222",
    "name": "Sawant Suryakant Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19052",
    "name": "Sayed Wajid Ali Afzal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1797",
    "name": "Lisa Prints"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19096",
    "name": "Sayeed Khursheed Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19119",
    "name": "Sayyad Amin Abdul Razzak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2262",
    "name": "Lkb Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19134",
    "name": "Sayyed Anwar Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19138",
    "name": "Shah Pravin Manilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19070",
    "name": "Shaikh  Mohd.Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19179",
    "name": "Shaikh Kamruddin Badruddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19156",
    "name": "Shaikh Mohd.Salim Karimuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19148",
    "name": "Shaikh Rukumuddin Shokotali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19167",
    "name": "Sharma Rajnarayan Ramlakhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19159",
    "name": "Sharma Vishwanath Chorthmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19043",
    "name": "Shetty  Jagganath Kariya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19040",
    "name": "Shinde Dipika Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19184",
    "name": "Shinde Prabhakar Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19091",
    "name": "Shirke Laxman Dharma"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1135",
    "name": "Shrivastava Neeta Ravi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19080",
    "name": "Singh Angad Ramsumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19075",
    "name": "Singh Ramsingh Bhola"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19076",
    "name": "Singh Tribhuvan Ramkaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19048",
    "name": "Sony Shankar Algu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19086",
    "name": "Tambe Vilas Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19095",
    "name": "Thakur Dinesh Mansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19186",
    "name": "Thombre Ankush Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19058",
    "name": "Tiwari Sabhapati Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19062",
    "name": "Vedak Shashikant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18156",
    "name": "Vyas Pious Manubhai & Mrs Nayna Manubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17077",
    "name": "Wadekar Seema Yashwant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19189",
    "name": "Wadmare Sanjay Chandru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19221",
    "name": "Yadav Indrajeet Saligram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19139",
    "name": "Yadav Lalitaprasad Ramkhilavon"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12663",
    "name": "Yadav Ramdas Ramdulari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6705",
    "name": "Pawar Mohanrao Marutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3479",
    "name": "Ithape Sitaram Bapuso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6132",
    "name": "Barge Balaso Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8054",
    "name": "Chavan Yashodha Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4839",
    "name": "Jadhav Vimal Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1173",
    "name": "Roman Janardhan Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7875",
    "name": "Khopade Vikas Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15972",
    "name": "Khandekar Rushika Anil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10266",
    "name": "Sawant Sahebrao Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9007",
    "name": "Phalke Gorakh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6055",
    "name": "Thorat Ranjana Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17605",
    "name": "Chaturvedi Sapana Sukhraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1965",
    "name": "Phalke Bhagirthi Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8718",
    "name": "Chavan Mahadeo Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1955",
    "name": "Rawat  Dhansiha"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "422",
    "name": "Chaudhary Maulana Abdul Mannan Haidarali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16323",
    "name": "Chehulkar Dharmenda Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9405",
    "name": "Dhumal Vithal Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16334",
    "name": "Gherwada Muktaben Arvindbhai/D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9384",
    "name": "Jagdale Sachin Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12014",
    "name": "Kadam Sudarshan Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16324",
    "name": "Keni Omkesh Anil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11997",
    "name": "Mane Prashant Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16327",
    "name": "Mhatare Vlshnu Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9229",
    "name": "Pisal Ashok Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12016",
    "name": "Sabale Anil Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11563",
    "name": "Sabale Sambhaji Ganesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10978",
    "name": "Sapkal Anandrao Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16335",
    "name": "Sarode Laxman Asaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "636",
    "name": "Sarvde Anil Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12206",
    "name": "Shinde Kalyan Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16332",
    "name": "Shinde Sharda Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11854",
    "name": "Vedpathak Vyjayanti Sunil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12008",
    "name": "Warpe Rajendra Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7437",
    "name": "Kadam Shivaji Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6805",
    "name": "Solskar Hanmantarao Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6690",
    "name": "Ghadage Dadasaheb Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6454",
    "name": "Chavan Shivaji Yadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4455",
    "name": "Fadtare Lata Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8728",
    "name": "Dhamal Baban Appaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3870",
    "name": "Phalke Ankush Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17272",
    "name": "Sharma Madan Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3758",
    "name": "Kadam Bipin Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "667",
    "name": "Ranaware Rajaram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16199",
    "name": "Archana Shivaji Yadav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10488",
    "name": "Awale Hindubai Vittal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10632",
    "name": "Babar Pushpa Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18983",
    "name": "Baikar Ravindra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19028",
    "name": "Barad Ramesh Lakhabhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11964",
    "name": "Bhagwat Umesh Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18972",
    "name": "Chavan Ajay Shyamsunder"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19022",
    "name": "Chavan Madanlal Ramkajuri"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16191",
    "name": "Chawan Yashvant V"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11944",
    "name": "Chirgute Kisanrao Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19013",
    "name": "Gavade Savita Mahesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19000",
    "name": "Gavade Savita Mahesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19016",
    "name": "Gavade Savita Mahesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11936",
    "name": "Ghadge Meena Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18987",
    "name": "Gupta  Vijaykumar Probhudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18999",
    "name": "Hulwale Harish Babu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9906",
    "name": "Jadhao Savitra Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16176",
    "name": "Joshi Falguni Bhyppndra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15420",
    "name": "Kalekar Arvind Nandan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16160",
    "name": "Kambale Raju Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16032",
    "name": "Khandekar Nandkishor Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11904",
    "name": "Lohar Ashok Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11669",
    "name": "Lokhande Dattatray Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19017",
    "name": "Malekar Balu Hira"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12767",
    "name": "Mali Ramchandra Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11947",
    "name": "Mane Uttam Yashwantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19036",
    "name": "Mishra Lalji Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10096",
    "name": "Naik Jaywant Saiyaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11624",
    "name": "Nikam Lahuraj Hinduraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11878",
    "name": "Nikam Narayan Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16069",
    "name": "Panchal Shilpa Dharmendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10498",
    "name": "Pande Keshavprasad Ayodya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11976",
    "name": "Pawar Dhanaji Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17877",
    "name": "Pawar Santosh Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19033",
    "name": "Pednekar Gurudatt Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11973",
    "name": "Phalke Dnyandeo Gulab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11924",
    "name": "Phalke Sambhaji Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16702",
    "name": "Pujari Pravin Bhoja"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18996",
    "name": "Rane Pramod Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16045",
    "name": "Reddy Tikkanna Ranganna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11451",
    "name": "Sabale Vishanu Nivarutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11912",
    "name": "Salunkhe Sachin Gorakhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16157",
    "name": "Sandeep Bhaskar Sawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19012",
    "name": "Shaikh Abdul Gaffar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18988",
    "name": "Sharifa Begam Mohd Zahir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11942",
    "name": "Shidne Dhansing Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6977",
    "name": "Shinde Ranjana Shriram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19034",
    "name": "Surti Morarbhai Devajibhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19001",
    "name": "Swami Bharti Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20026",
    "name": "Tambe Sachin V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20527",
    "name": "Tambvekar Kiran D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19005",
    "name": "Yadav Sochan Rajbali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2227",
    "name": "More Anandrao Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5149",
    "name": "Babar Shankar Yashwant"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "132",
    "name": "Acharya Ajay Patmanabhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1605",
    "name": "Gupta Rajan Matacharan"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "144",
    "name": "Gupta Sanjay Shrigunasa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1306",
    "name": "Joshi Ratanlal Giridharlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1512",
    "name": "Mahato Ravi Vakil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "751",
    "name": "Masurkar Anand Shridhar"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "82",
    "name": "Mhatre Dattaguru Shama"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "41",
    "name": "Rajput Mahesh B"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "55",
    "name": "Sutar Sunil Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10854",
    "name": "Nikam Dayanand Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "280",
    "name": "Phalke Shankar Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9038",
    "name": "Nalwade Shivajirao Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5190",
    "name": "Bhagwat Anant Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3865",
    "name": "Shinde Tanaji Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3946",
    "name": "Shinde Hambirrao Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3945",
    "name": "Damame Vilasrao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15096",
    "name": "Jadhav Sonal Shridhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "637",
    "name": "Rupanwar Tukaram Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2943",
    "name": "Lade Dnyandev Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5872",
    "name": "Anuwadia Dhaval Mansukhlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12127",
    "name": "Bhosale Godawari Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16811",
    "name": "Chaturvedi Manjula Anurag"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12234",
    "name": "Chavan Keshav Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "577",
    "name": "M  Bharatkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16398",
    "name": "Chavan Shailesh Vasantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11883",
    "name": "Dhumal Yashwant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18967",
    "name": "Dukhande Tushar Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2220",
    "name": "M Dilipkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1937",
    "name": "M Dipesh Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1909",
    "name": "M M Plast"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3536",
    "name": "Gaikawad Hanmant Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1314",
    "name": "Jadhav Anandrao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17915",
    "name": "Kadam Madhuri Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4573",
    "name": "Kadam Namdeo Ramchandra"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "131",
    "name": "M.A.Patil & Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1280",
    "name": "M.D. Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1494",
    "name": "M.K. Textiles."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2193",
    "name": "M.K.Fabrics"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1256",
    "name": "M.M.Electricals."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1691",
    "name": "M.S.Associates"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "111",
    "name": "Maahi Trading Corporation"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18935",
    "name": "Khan Mohmmad Yasir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12445",
    "name": "Mane Indubai Uttam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7866",
    "name": "Nikam Reshma Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18431",
    "name": "Panchal Kunal Jaswant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14522",
    "name": "Parab Shailesh Bhalchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9026",
    "name": "Sabale Jaywant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13287",
    "name": "Sable Madhukar Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12591",
    "name": "Salunkhe Ramchandra Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18921",
    "name": "Saw Sahdeo Tulsi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14112",
    "name": "Sawant Darshana Dasharath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8663",
    "name": "Shinde Maruti Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18952",
    "name": "Yadav Rajmoh Terashnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11359",
    "name": "Yadav Tanaji Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6039",
    "name": "Kharat Sudam Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6380",
    "name": "Patel Ramshre Somnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6441",
    "name": "Kirdat Chandrakant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2630",
    "name": "Madanlalal Ramprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8082",
    "name": "Gaikwad Vishnu Martand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3357",
    "name": "Borate Vishavanath Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1623",
    "name": "Sabale Suresh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10938",
    "name": "Yadav Baban Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4609",
    "name": "Jadhav Dnyaneshwar Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6632",
    "name": "Phalake Prabhakar Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8058",
    "name": "Mane Lata Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8944",
    "name": "Phalke Bhagirthibai Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11817",
    "name": "Barkade Laxman Lahuba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11816",
    "name": "Dadas Bapurao Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12929",
    "name": "Indalkar Shukantala Prakesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10654",
    "name": "Jadhav Bharati Pramod"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11783",
    "name": "Kadam Rajshri Balaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11799",
    "name": "Madhukar Neembak Kavlage"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "295",
    "name": "Madhuban Roadways"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12158",
    "name": "Mandhare Dattatrya Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11840",
    "name": "Mane Dadasaheb Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11858",
    "name": "Mulik Dilipkumar Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14458",
    "name": "Parab Mahadeo Punaji."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1676",
    "name": "Madhusudan Cloth Agency"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9675",
    "name": "Parte Taramati Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9939",
    "name": "Patil Shubhangi Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11857",
    "name": "Pawar Umesh Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12494",
    "name": "Phalke Vitthal Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4758",
    "name": "Prajapati  Paradeshi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11835",
    "name": "Sable Kisan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11844",
    "name": "Sangle Mahendra Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11820",
    "name": "Sawant Shankar Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7717",
    "name": "Shinde Narayan Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1908",
    "name": "Suryavanshi Ashok Sonappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11822",
    "name": "Udapi Narayan Nagesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6168",
    "name": "Jagdale Janabai Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16986",
    "name": "Khandekar  Balkrishna  Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7848",
    "name": "Gadhile Ravindra H"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4661",
    "name": "Jadhav Chaturabai Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8473",
    "name": "Sabale Prahalad Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6510",
    "name": "Dhanawade Marutrao Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6509",
    "name": "Jadhav Chandrakant Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "105",
    "name": "Jadhav Parbati Bhairu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9447",
    "name": "Bhise Nanaso Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3633",
    "name": "Shinde Bajirao Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7238",
    "name": "Jadhav Anusaya Savlaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8807",
    "name": "Salunkhe Balutai Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4985",
    "name": "Vichare Rajaram Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10388",
    "name": "Mane Mohan Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3940",
    "name": "Jadhav Dasharath Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4555",
    "name": "Magic System"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "566",
    "name": "Mahabali Construction"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2246",
    "name": "Nimbalkar Sundeep Ratnakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6279",
    "name": "Maner Alamshah Rajimiya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8439",
    "name": "Jadhav Dnyanu Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4322",
    "name": "Wagh Rukmini Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4972",
    "name": "Phalke Yamuna Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "852",
    "name": "Balu Dattoba Daundkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15931",
    "name": "Belose Ajinkya Prabhakar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17581",
    "name": "Bhandari Kiran Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16012",
    "name": "Burji Subhadra Hardeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18867",
    "name": "Gupta Jivanlal Sukharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15927",
    "name": "Kadam Lilanand Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17523",
    "name": "Pawar Bharati Sadashive"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14389",
    "name": "Sakpal Mangala Kashiram."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1837",
    "name": "Mahadev Jewellers"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16010",
    "name": "Sawant Ravindra Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18836",
    "name": "Shaikh Sairaj Ahmed Mohd. Sahid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16471",
    "name": "Sushila Tukaram Janjale"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6211",
    "name": "Bhoir Babu Joma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19288",
    "name": "Mehta Hasmukh Nathalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13353",
    "name": "Patil Rajani Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18829",
    "name": "Abdul Sakur Latifsndiwala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15758",
    "name": "Amalani Ketaki Rasiklal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11767",
    "name": "Anpat Ravindra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18828",
    "name": "Bendhasi .Gulabchandra . Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9253",
    "name": "Bhagwat Vimal Chintu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11774",
    "name": "Bhoite Sanjay Hindurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11769",
    "name": "Bhosale Bhausaheb Jagnnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12276",
    "name": "Chavan Shivaji Bajirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15709",
    "name": "Gaikwad Sunanda Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7043",
    "name": "Gole Shivaji Bhiwa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10177",
    "name": "Jadhav Sudamrao Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6901",
    "name": "Jaiswal Jagdish S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15717",
    "name": "Kadam Devanand Jijaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15723",
    "name": "Kadam Shailendra Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15787",
    "name": "Kadav Rao Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17692",
    "name": "Kale Tushar Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15830",
    "name": "Karuvankandi  Sureshkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15805",
    "name": "Khuspe Ganpat Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10955",
    "name": "Lohar Sulochana Dashrath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11733",
    "name": "Navadkar Maruti Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15725",
    "name": "Patel Ekabal Babu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "447",
    "name": "Pisal Hausabai Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15853",
    "name": "Shelake Sanjay Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15778",
    "name": "Shradha Shantaram Ayare"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8827",
    "name": "Pawar Machindranath Shreerang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8122",
    "name": "Jadhav Dropada Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2711",
    "name": "Phalke Ashok Sambahji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8188",
    "name": "Phalke Bharat Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6352",
    "name": "Barge Rangubai Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2269",
    "name": "Mane Sopan Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6156",
    "name": "Salunkhe Shankar Sagu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "290",
    "name": "Phalke Tukaram Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2937",
    "name": "Rais Shahanawaz Yusuf"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3077",
    "name": "Chavan Shradha Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3865",
    "name": "Mistry Abdul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3851",
    "name": "Bhosale Mohan Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7032",
    "name": "Nalawade Parbati Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6360",
    "name": "Kadale Mohan Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11969",
    "name": "Bhosale Tanaji Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11726",
    "name": "Dhumal Nandkumar Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11692",
    "name": "Gade Laxman Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11631",
    "name": "Gardi Malan Jyotiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11621",
    "name": "Ghadge Sanjay Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11671",
    "name": "Ghorpade Amol Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11623",
    "name": "Ghorpade Gajanan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19097",
    "name": "Gupta Dayashankar Kalikaprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11701",
    "name": "Jadhav Laxman Yadavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3095",
    "name": "Jadhav Vinayak Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16198",
    "name": "Kudalkar Reema Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11676",
    "name": "Mandave Pratap Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15802",
    "name": "More Ashvini Krisna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11604",
    "name": "Mulik Laxman Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10311",
    "name": "Nalawade Mohan Jijaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18021",
    "name": "Patil Sanjay Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10429",
    "name": "Phalke Rahul Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12503",
    "name": "Pujari Baburao Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9922",
    "name": "Sabale Sanjay Dyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11685",
    "name": "Sabale Vijay Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11643",
    "name": "Shelar Bajirao Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11641",
    "name": "Shelar Balasaheb Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11686",
    "name": "Shinde Madhukar Dhanasingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "974",
    "name": "Survanse Parasram Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10895",
    "name": "Zanzurne Ramchandra Hariba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2165",
    "name": "Manere Sudhakar Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5915",
    "name": "Sakunde Vithal Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12658",
    "name": "Ahirekar Chandrakant Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6939",
    "name": "Phalake Rajendra Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3869",
    "name": "Anpat Shiwaji Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5585",
    "name": "Bhosale Godawari Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2098",
    "name": "Inamdar Azad Dulemiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15100",
    "name": "Adhikari Dipendra Rishikesh."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5078",
    "name": "Dhavan Pralhad Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7532",
    "name": "Shinde Pramila Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7550",
    "name": "Chatur Pallavi Dashrath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4967",
    "name": "Mulani Sharfoddin Abdul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6338",
    "name": "Risakdar Salim Abdul Rehman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15676",
    "name": "Damle Seema Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11573",
    "name": "Dhumal Jitin Shiwaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11595",
    "name": "Gurao Dattatray Udhav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11442",
    "name": "Jadhav Kamal Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10909",
    "name": "Jadhav Tanaji Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11579",
    "name": "Kadam Bhimarao Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10221",
    "name": "Kadam Sampat Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11574",
    "name": "Kadam Suresh Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11594",
    "name": "Khamkar Balasaheb Jayasingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11571",
    "name": "Nikam Mohan Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1784",
    "name": "Mahalakshmi Engineering Works"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "250",
    "name": "Mahalaxmi Construction"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1424",
    "name": "Mahalaxmi Sales Corpn."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15996",
    "name": "Panjawani Dilip Ramchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15644",
    "name": "Pawar  Pradeep Ganga"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18055",
    "name": "Raut Chandrahas Balvant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15342",
    "name": "Sathe Jijabai Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15635",
    "name": "Shivaji Namdeo Ahirakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15571",
    "name": "Shukla Renuka Rammuryi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10583",
    "name": "Sutar Yuvraj Haridas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15543",
    "name": "Yadav Shriprasad Ramdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8013",
    "name": "Shende Uttam Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "948",
    "name": "Chavan Laxman Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11156",
    "name": "Bhope Nanibai Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3646",
    "name": "Kadam Lilavati Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1907",
    "name": "Patange Narayan Dattatrya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5250",
    "name": "Mane Atmaram Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10712",
    "name": "Chavan Bhikoba Dadaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6300",
    "name": "Jadhav Hanmant Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3522",
    "name": "Bhandalkar Dinakar Keru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8900",
    "name": "Kate Chandrakant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6720",
    "name": "Babar Gajarabai Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15283",
    "name": "Bhalerao Sudhakar Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16855",
    "name": "D Penad Raj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15406",
    "name": "Dhumal Shubhangi Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12733",
    "name": "Kadam Sharad Madhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7201",
    "name": "Kadam Shilpa Sanjay /Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15354",
    "name": "Kambale Neeta Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15341",
    "name": "Madhwani Tejas Rasklal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15977",
    "name": "Malusare Dattaram Raghoba."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11782",
    "name": "Nikam Anusaya Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18739",
    "name": "Paste Gopal Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12145",
    "name": "Phalke Lahuraj Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13144",
    "name": "Sangoil Bharat Ratilal &Mrs Sunita"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11642",
    "name": "Shelar Hanamant Babaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7461",
    "name": "Tadke Sunita Popatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5910",
    "name": "Disale Namdeo Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15297",
    "name": "Varadkar Santosh Dasarath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7007",
    "name": "Chavan Rajaram Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8434",
    "name": "Shinde Pravin Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1276",
    "name": "Maharashtra Decorators"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5627",
    "name": "Bhandari Ashok Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5867",
    "name": "Mulik Ravaindra Jagdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "842",
    "name": "Jadhav Gopal Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2776",
    "name": "Anpat Baburao Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1783",
    "name": "Maharashtra Textiles Mills"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "388",
    "name": "Dashrath Dagdoba Nawadkar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11444",
    "name": "Chatur Machindra Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13070",
    "name": "Dholkiya Ramaji Nadda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11426",
    "name": "Gade Pankaja Uttam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "514",
    "name": "Gaikwad Ankush Rama"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12009",
    "name": "Ithape Umesh Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10623",
    "name": "Jadhav Sharda Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11513",
    "name": "Jagadale Anusaya Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13319",
    "name": "Jagatap Arvind Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11440",
    "name": "Jagtap Suresh Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11467",
    "name": "Kadam Ramesh Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15582",
    "name": "Kamble Smita Hiraman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11474",
    "name": "Kharat Bhiku Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11558",
    "name": "Pawar Narayan Savitra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11456",
    "name": "Phalake Manisha Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2192",
    "name": "Mahavir Sales"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16620",
    "name": "Puralkar Shrikant Achyut"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "19",
    "name": "Mahavir Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14638",
    "name": "Renose Ravindra Sakharam."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11549",
    "name": "Sabale Ashok Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11493",
    "name": "Sabale Mahapat Ganapat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16122",
    "name": "Wadekar Santosh Kishor"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8410",
    "name": "Dandekar Shrikant Yashawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12249",
    "name": "Mane Jyoti Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5424",
    "name": "Matkar Shivaji Antu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5697",
    "name": "Madane Hanamant Sonaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12509",
    "name": "Qureshi Mahamad Iqbal Nanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2213",
    "name": "Chavan Vithal Kundlika"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5790",
    "name": "Mulik Sampatrao Nathuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7862",
    "name": "Nikam Tara Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11788",
    "name": "Sapaliga Amisha R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "221",
    "name": "Yevale Shankar Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10419",
    "name": "Phalke Satyawan Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13041",
    "name": "Rakshe Mandeo Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16127",
    "name": "Ambaji Manoj Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10631",
    "name": "Babar Vilas Ekanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12380",
    "name": "Bhilare Hanmant Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16707",
    "name": "Budha Premsingh Palsingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10699",
    "name": "Chavan Niteen Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4119",
    "name": "Gaikawad Dinkar Dharmu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16002",
    "name": "Gawade Rambai Bhimrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15204",
    "name": "Ithape Chandrakant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16347",
    "name": "Jadhav Rohini Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10465",
    "name": "Kadam Shankar Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4578",
    "name": "Kudalkar Antu Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15146",
    "name": "Lambate Asha Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20913",
    "name": "Lele  Shrinath  Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15246",
    "name": "Mahadik Tukaram Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4375",
    "name": "Nawadkar Raghunath Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12397",
    "name": "Nikam Vishnu Appaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18295",
    "name": "Pandey Shivkumar Vijaykumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15763",
    "name": "Paramar Sachin Nandakishore"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11400",
    "name": "Phalke Sadashiv Bhujaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18832",
    "name": "Sarode Sharad Asharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11492",
    "name": "Shekh Mahamad Isak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14602",
    "name": "Shetty Minal Madhav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12374",
    "name": "Shirke Yuvraj Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15208",
    "name": "Somiyal Rozy Francis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1827",
    "name": "Kulkarni Bandu Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1050",
    "name": "Harshna Harishchindra Pawar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3513",
    "name": "Pisal Vijaysingh Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2794",
    "name": "More Dnaneshwar Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8847",
    "name": "Vedpathak Surekha Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8323",
    "name": "Phalke Madhukar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "722",
    "name": "Mahadik Vithal Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11798",
    "name": "Bhosale Sanjay Visnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10327",
    "name": "Chavan Ashok Raghu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11450",
    "name": "Chavan Bajirao Baba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15080",
    "name": "Chudji Yojana Sadnand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7497",
    "name": "Ghag Mahendra Dhondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10588",
    "name": "Jadhav Vijay Krishnaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11270",
    "name": "Kadam Prakash Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6338",
    "name": "Mishra  Umendrakumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11414",
    "name": "Nawadakar Dyandeo Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15135",
    "name": "Pagare Arati Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11412",
    "name": "Pawar Balkrushan Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17686",
    "name": "Pragati Vidyalaya  Primary Sect.Mar.Medi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15059",
    "name": "Rupali Ashok Parab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15009",
    "name": "Satpute Vijay Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15494",
    "name": "Shukala Harishankar Manbodh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11084",
    "name": "Sonawane Dilip Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17565",
    "name": "Yadav Shambhulal Pyarelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9507",
    "name": "Yadav Shivnarayan R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6072",
    "name": "More Karuna Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8367",
    "name": "Ithape Sharad Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "1145",
    "name": "Kumthekar Prabhakar Ganesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8198",
    "name": "Kadam Namdeo Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11386",
    "name": "Jadhav Manisha Satyawan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8657",
    "name": "Wagh Bhimrao Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7165",
    "name": "Salunkhe Laxmi Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7457",
    "name": "Jadhav Sopan Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2277",
    "name": "Mulik Uttam Ramchndra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6919",
    "name": "Ambawale Satwashila Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9208",
    "name": "Pisal Sayaji Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5441",
    "name": "Salunkhe Ravaji Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9077",
    "name": "Sutar Muktabai Dasharath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9725",
    "name": "Abdul Rahim Abdul Samad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14948",
    "name": "Bharamal Balu Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11364",
    "name": "Bhoite Tulshidas Kundalikrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11284",
    "name": "Bhosale Satish Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11311",
    "name": "Chavan Bapurao Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10785",
    "name": "Chavan Shankararo Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14959",
    "name": "Dalavi Deepak Raghunath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14960",
    "name": "Dike Sunita Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11267",
    "name": "Gaikwad Mansing Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1542",
    "name": "Gaikwad Raghunath Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "515",
    "name": "Malesh Tempo Service."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11323",
    "name": "Jadhav Anil Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1451",
    "name": "Malhar Prakashan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13026",
    "name": "Jadhav Jayshri Kamlakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11396",
    "name": "Jadhav Shankar Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9391",
    "name": "Joran Nikolus Ruzaria"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16138",
    "name": "Kadam Lata Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15224",
    "name": "Kahale Subhash Raybhan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16876",
    "name": "Khandekar Alka Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8267",
    "name": "Mardhekar Pandurang Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10869",
    "name": "More Sayaji Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16717",
    "name": "Mungurwade Manohar Parasu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14859",
    "name": "Parsekar Vivekanand Dattram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11382",
    "name": "Pawar Murlidhar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11317",
    "name": "Pawar Suvarana Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14932",
    "name": "Rais  Kalu Kureshi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14876",
    "name": "Rajendra Janardhan Unde"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11662",
    "name": "Sabale Kisan Bhiva"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11346",
    "name": "Sabale Suresh Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18065",
    "name": "Salunkhe Ashok Murlidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15615",
    "name": "Santosh Vasant Dasgaonkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14944",
    "name": "Shah Ajay Chunilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9669",
    "name": "Shaikh Nazir Husain Abdul Sattar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17850",
    "name": "Shelar Laxman Savalaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11261",
    "name": "Shiakh Mukhtar Gulabhusen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6289",
    "name": "Tarde Dilip Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4921",
    "name": "Tunki Mallesh Sonayya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11398",
    "name": "Waghmale Vikram Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14877",
    "name": "Zanazane Pramod Kundalik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6766",
    "name": "Jadhao Balasaheb Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8624",
    "name": "Bhope Pratap Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8394",
    "name": "Gadhave Ashish Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4109",
    "name": "Gaikawad Rajendra Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11536",
    "name": "Mali Sachin Ragunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2030",
    "name": "Sabale Vijay Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9258",
    "name": "Sabale Pralhad Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4969",
    "name": "Sankurde Ashok Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6935",
    "name": "Ingale Sunita Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12059",
    "name": "Waghamare Vanita Pradip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4129",
    "name": "Jadhav Baburao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14699",
    "name": "B. Venkataramlu Keshanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15281",
    "name": "Baikar Akash Dipak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17680",
    "name": "Bhosale Ujwala Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16430",
    "name": "Chauhan Jayshree S/Neelesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12057",
    "name": "Disale Kusum Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5073",
    "name": "Herekar Sulochana Raghunath/Pradip R Her"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11808",
    "name": "Jadhav Nakusabi Tulsaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13177",
    "name": "K Somdevan Nagraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16664",
    "name": "Kadam Avinash Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14778",
    "name": "Karande Bharat Krushna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1817",
    "name": "Mandhre Subhahsh Namdeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18080",
    "name": "Mhamunkar Bal Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19821",
    "name": "Parekh Trushakant Arvindlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11746",
    "name": "Pathan Jalalkhan Nazirkhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14821",
    "name": "Rekha Manish Mate"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14648",
    "name": "Sadhavani Murlidhar Premchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14694",
    "name": "Sharma Ashokkumar Shivkrshna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "917",
    "name": "Sawant Khandu Bhujaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7222",
    "name": "Ghadge Chandrakant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6301",
    "name": "Pisal Shashikala Raosaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13782",
    "name": "Palekar Ramchandra Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7943",
    "name": "Nawadkar Dasharat Dagadoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "79",
    "name": "Jadhav Roopchand Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3841",
    "name": "Phalke Khashaba Rangu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6539",
    "name": "Kharat Laxmibai Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12001",
    "name": "Ithape Sharad Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2461",
    "name": "Gaikwad Sunubai Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10721",
    "name": "Bhosale Vikas Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11246",
    "name": "Chavan Vishwas Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15926",
    "name": "Choudhari Gourshankar Radhakant/Sudha G."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11240",
    "name": "Dere Subhedar Parabati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11384",
    "name": "Dhuaml Dattatray Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14641",
    "name": "Farnadish Pedru John"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9591",
    "name": "Gupta Gourishankar B."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8985",
    "name": "Jadhav Shantabai Subhedar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11302",
    "name": "Kudale Subhash Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "859",
    "name": "Morya Bhavesh Lalaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23916",
    "name": "Pardeshi Ashutosh Pratapsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14601",
    "name": "Pawar Devidas Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14885",
    "name": "Pawar Krisna Jagajivan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10134",
    "name": "Phalke Dipika Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10280",
    "name": "Pisal Chatura Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7901",
    "name": "Salate Ananda Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14565",
    "name": "Salunkhe Madhukar Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14824",
    "name": "Sawant Sandeep Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11247",
    "name": "Shaikh Aziz Ahmed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11548",
    "name": "Shinde Shankar Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11447",
    "name": "Yadav Sharma Prasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16763",
    "name": "Bhoite Subhash Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6427",
    "name": "Londhe Madhukar Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "313",
    "name": "Mamta Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16154",
    "name": "Bhagwat Dhanaji Kisan /Londhe/"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11186",
    "name": "Chavan Pandurang Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8375",
    "name": "Churihar Abdulla Safi Mohamed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15889",
    "name": "Dalvi Yogesh Jairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10572",
    "name": "Dingankar Vidya Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9682",
    "name": "Dodia Bharat Kanajibhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11200",
    "name": "Ghadge Amol Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13767",
    "name": "Jadhav Sunita Sudam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19722",
    "name": "Jagatap Mahesh Dhananjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14165",
    "name": "Katalkar Sachin Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11213",
    "name": "Khan Gamakhan Nasir Mohd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6037",
    "name": "Khande Dilip Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14518",
    "name": "Lalge Sadanand Vishnu."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11365",
    "name": "Machale Somnath Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14450",
    "name": "Patil Tanagi Kundalik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14884",
    "name": "Patric Pascal Rodricks"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11554",
    "name": "Phalke Dilip Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1847",
    "name": "Mandar Travellers"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17139",
    "name": "Pisal Laxman Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14519",
    "name": "Pise Arvind Bhagvant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11193",
    "name": "Sable Sunil Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11235",
    "name": "Sawant Vasantrao Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9385",
    "name": "Shinde Ankush Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11093",
    "name": "Shinde Nilesh Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14464",
    "name": "Tambe  Asha Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10190",
    "name": "Yadav Rakesh Ramdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14488",
    "name": "Yewale Subhash Jayshing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11147",
    "name": "Jadhav Swati Kiran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10993",
    "name": "Sable Kisan Bhiwa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11104",
    "name": "Aawade Rajendra Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11128",
    "name": "Anpat Shivaji Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8561",
    "name": "Bande Kumar Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11167",
    "name": "Bulunge Pradeep Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11135",
    "name": "Chavan Baburao Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12496",
    "name": "Dhumal Nalita Pradip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11153",
    "name": "Kare Dada Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11103",
    "name": "Kshirsagar Raghu Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9481",
    "name": "Pawar Namdeo Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11169",
    "name": "Phalke Anandrao Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12063",
    "name": "Phalke Ujwala Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23484",
    "name": "Rana Jayashree Karsandas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11174",
    "name": "Raut Kiran Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11114",
    "name": "Sable Sunil Hiroji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3470",
    "name": "Pawar Vijaya Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5939",
    "name": "Kadam Prakash Jaganath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6753",
    "name": "Phalake Jayasingh Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3140",
    "name": "Sadi Zakir Husen Abdul Raheman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2864",
    "name": "Jayswal Devsharan Ramkisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3346",
    "name": "Ghadage Dhanaji Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6505",
    "name": "Deshmukh Ranjana Rupchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8216",
    "name": "Tirlotkar Suryaji Deu/Sumila"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14240",
    "name": "Amin Ajit Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14337",
    "name": "Desai Laxman Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7758",
    "name": "Durgule Arjun Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10909",
    "name": "Gaikwad Vilas Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4431",
    "name": "Inamdar Shabbir Abdul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11077",
    "name": "Jagtap Dattatray Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11974",
    "name": "Kumbhar Sanjay Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19056",
    "name": "Nadgeri Dinesh Parmeshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10328",
    "name": "Naik Raju Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14312",
    "name": "Pandit Suresh Bapurao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17354",
    "name": "Pejale Rajendra Gunaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11074",
    "name": "Phalke Pramod Abaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11839",
    "name": "Shejwal Santosh Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7878",
    "name": "Shinde Hanamant Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11219",
    "name": "Shinde Pandurang Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7927",
    "name": "Suryawanshi Bhiku Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14583",
    "name": "Todkar Yogesh Bhalchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11089",
    "name": "Wagh Baban Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2707",
    "name": "Babar Vitthal Bapuji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8949",
    "name": "Dhavan Sanjay Wamanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6598",
    "name": "Phalke Rajendrakumar Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2982",
    "name": "Wagh Mahadeo Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10750",
    "name": "Kurade Rajaram Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12936",
    "name": "Mane Pandurang Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5835",
    "name": "Kusum"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5811",
    "name": "Ghadge Laxman Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "262",
    "name": "Chalake Shrirang Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16271",
    "name": "Anuvadia Nishaben Mansukhlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2146",
    "name": "Ayodhya  Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14120",
    "name": "Bavishi Ashvin Hemchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10661",
    "name": "Jagatap Deepak Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14782",
    "name": "Mandhare Dattatray Bhikoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14131",
    "name": "Modak Shashikant Sadashiv."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6395",
    "name": "Pande Shyam Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9314",
    "name": "Pandey Pannalal Hridayshankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17663",
    "name": "Parekh Kamini Surendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14215",
    "name": "Pisal Shivaji Govindrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16472",
    "name": "Sawant Rajesh Digambar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10520",
    "name": "Shukla Rajkapur Udayraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14328",
    "name": "Suryavanshi Tanaji Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3320",
    "name": "Patil Deelip Mukund"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7870",
    "name": "Jadhav Hanumant Knahdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3671",
    "name": "Pawar Rajaram Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14628",
    "name": "Chalake Atmaram Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10451",
    "name": "Chavan Ramesh Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11056",
    "name": "Chavan Vijay Nilkanthrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11042",
    "name": "Darekar Vinayak Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11068",
    "name": "Deshmukh Sudam Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10328",
    "name": "Gujar Vishal Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11067",
    "name": "Jagtap Nivrutti Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11016",
    "name": "Kadam Baliram Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23066",
    "name": "More Ankush Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11071",
    "name": "Nalawade Savitra Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11013",
    "name": "Phalke Ganpat Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11043",
    "name": "Pisal Sangeeta Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11780",
    "name": "Pisal Vanchalabai Dattu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9519",
    "name": "Pol Ratnadeep Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4631",
    "name": "Sakunde Baliram Yadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19555",
    "name": "Salunkhe Sunanda Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12702",
    "name": "Sapkal Sakhubai Hanamnt"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11058",
    "name": "Shaikh Naseem Salim"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11066",
    "name": "Shinde Manjula Dashrath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12634",
    "name": "Vichare Dilip Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11049",
    "name": "Yadav Solaskar Manikrao Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8725",
    "name": "Kharade Lata Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7691",
    "name": "Chavan Dagadu Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10208",
    "name": "Nikam Hausabai Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3568",
    "name": "Gadhave Sadashiv Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "696",
    "name": "Jadhav Shamrao Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6277",
    "name": "Nalge Keru Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5116",
    "name": "Dhumal Sarjerao Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1709",
    "name": "More Chandrakant Bhikoba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16470",
    "name": "Anand Sarjerao Yadav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10961",
    "name": "Bhagwat Vilas Savlaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13964",
    "name": "Cardoza Shirin Francis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11055",
    "name": "Chand Mohan B."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10812",
    "name": "Dhumal Shahaji Subhanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10969",
    "name": "Gadhave Usha Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16184",
    "name": "Ghag Pravin Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11001",
    "name": "Jadhav Dharmaraj Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10972",
    "name": "Jadhav Tulsaram Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13949",
    "name": "Jagtap Nandkumar Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10977",
    "name": "Jambhale Vijaya Gulab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10957",
    "name": "Kadam Pratap Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9270",
    "name": "Khandare Padmini Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14024",
    "name": "Khuchekar Jagadish Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11011",
    "name": "Kumbhar Krishnabai Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7331",
    "name": "Latke Baliram Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15117",
    "name": "Mulik Ajit Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14030",
    "name": "Nagada Anil Gangajar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14057",
    "name": "Naik Anand Fakaroji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10454",
    "name": "Pendurkar Kishor Dhondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11528",
    "name": "Phadatare Dilip Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10993",
    "name": "Pujari Ajit Kundlik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10992",
    "name": "Pujari Pravin Kundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14035",
    "name": "Rodriques Leena Alwin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10996",
    "name": "Sapkal Pralhad Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9944",
    "name": "Sarjine Sanjay Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14040",
    "name": "Shivde Priti Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6793",
    "name": "Siddiqui Ishratali Warish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7924",
    "name": "Vijaykumar  Padma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17155",
    "name": "Vishwakarma Praladh Hariram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5777",
    "name": "Bhoite Sushila Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9064",
    "name": "Phalke Narmadabai Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "460",
    "name": "Ghadge Laxman Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6734",
    "name": "Kambale Rajaram Bhiwa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11265",
    "name": "Chavan Ranarao Wamanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1910",
    "name": "Bhosale Hanmant Pandharinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5452",
    "name": "Jadhav Kisan Sarjerav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13935",
    "name": "Dalvi Pratibha Vasant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13789",
    "name": "Devendra Salama Kharpana."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13793",
    "name": "Dhasale Pravin Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9935",
    "name": "Kalekhan Mohd Kayum Mohd Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13072",
    "name": "Mane Kailas Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10070",
    "name": "Maniyar Jubedar Islam Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13926",
    "name": "More Shivaji Dehurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16538",
    "name": "Prasad Laxman Phulana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11988",
    "name": "Said Narayan Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1",
    "name": "Mali Krishnaji Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6970",
    "name": "Sawant Sanjay Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10927",
    "name": "Babr Hanmant Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11248",
    "name": "Barge Sanjay Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10931",
    "name": "Jagtap Dadaso Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10930",
    "name": "Jagtap Dagdu Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10934",
    "name": "Jagtap Sunil Dagdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9632",
    "name": "Kadam Bhagirathi Madhao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1062",
    "name": "Kamble Santosh Ram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10995",
    "name": "Sabale Anil Kundlik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11120",
    "name": "Shaikh Pakiza Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10935",
    "name": "Shinde Kusum Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11134",
    "name": "Sutar Anita Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11900",
    "name": "Tamboli Nilesh Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10164",
    "name": "Waghamale Satish Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3897",
    "name": "Kharat Chandrabhaga Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5810",
    "name": "Satpute Sunil Dnyaneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7037",
    "name": "Phalke Sarubai Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "926",
    "name": "Bhosale Maruti Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7594",
    "name": "Kadam Arjun Vinak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7367",
    "name": "Nalge Vijaya Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23598",
    "name": "Agsar Ramesh Malakali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18308",
    "name": "Barge Abhijit Naryan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16054",
    "name": "Dhodmise Mangal Gangadhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9617",
    "name": "Dumbare Sonaba Rangnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14110",
    "name": "Jadhav Kisan Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20323",
    "name": "Kandapur Banty M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7003",
    "name": "Khapare Dattaram Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10095",
    "name": "Mane Madhu Shripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4543",
    "name": "More Shantaram J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9983",
    "name": "Patel Hasmukh Maganlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11502",
    "name": "Patil Sushila Mango"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14254",
    "name": "Pujari Satish Manja."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16482",
    "name": "Sanjay Kumar Pujari Jha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10026",
    "name": "Shaikh Nijamuddin Chingud"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9888",
    "name": "Soni Kantaben Momaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9408",
    "name": "Yadav Ramkisan Shripal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10029",
    "name": "Yadav Vikramjeet Ramlakhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14564",
    "name": "Satpute Sunil Bhimrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4267",
    "name": "Bhise Suresh Jaysingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1039",
    "name": "Vijaypal Singh Chawhan."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3687",
    "name": "Ghadage Namdeo Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4420",
    "name": "Chavan Shriral M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1148",
    "name": "Nanware Nirmala Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3403",
    "name": "Shinde Gajanan Kisanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5417",
    "name": "Barge Bhagawan Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6507",
    "name": "Bhosale Shyanrao Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8965",
    "name": "Bhosale Vasant Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6750",
    "name": "Chavan Nalini Madan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12121",
    "name": "Desai Nanda Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16585",
    "name": "Dethe Vitthal Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6101",
    "name": "Devahar Yogendra V."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7800",
    "name": "Falake Bajirao Ramchnadra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1927",
    "name": "Friends Electrical Works."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10042",
    "name": "Godavarikar Rishi Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13534",
    "name": "Guge Suman Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9788",
    "name": "Jagtap Raju Bansi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10310",
    "name": "K Somdevan Nagraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12690",
    "name": "Kadam Anant Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6662",
    "name": "Kadam Ramchandra Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10891",
    "name": "Kadam Shivaji Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13555",
    "name": "Kamble Vijay Mohan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5133",
    "name": "Kataria Satish Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7997",
    "name": "Khopkar Gangaram N"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10951",
    "name": "Lalbegi Manoj Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10592",
    "name": "Mane Shankar Anadrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12938",
    "name": "Mhaskar Kanta Vittal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15902",
    "name": "More Satish Motiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10900",
    "name": "Mulik Arvind Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9596",
    "name": "Naik Rajani Suryakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10976",
    "name": "Nalawade Dattatray Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17400",
    "name": "Nimbalkar Narayan Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9899",
    "name": "Pal Shivshankar Devnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13530",
    "name": "Patel Ramesh Haribhai."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11968",
    "name": "Phalke Janardan Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6670",
    "name": "Quazy Shabana Nikhal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21646",
    "name": "Rane Vishnu Suryakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10094",
    "name": "Rathod Rama G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7083",
    "name": "Saliyan Shridhar B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13599",
    "name": "Sawant Sunita Digamber."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15624",
    "name": "Shah Shrikant Permeshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9683",
    "name": "Shaikh Gaffar Shaikh Satar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11377",
    "name": "Shinde Kusum Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13612",
    "name": "Surve Navnath Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6142",
    "name": "Yadav Lalchand Murwal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2519",
    "name": "Pawar Laxman Manikrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6814",
    "name": "Bhatwadekar Mangal Bhalchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4690",
    "name": "Sakunde Kusum Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1158",
    "name": "Kole Rajaram Ashayaa."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1482",
    "name": "Mohite Shrirang Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4536",
    "name": "Jadhav  Bhaskar Gangadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15631",
    "name": "Date Amol Pradip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3271",
    "name": "Yadav Pandurang Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3362",
    "name": "Kadam Sampat Appaji ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6972",
    "name": "Phalake Gajanan Madhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23549",
    "name": "Mehra Raama Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14088",
    "name": "Chavan Mahadeo Dadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8228",
    "name": "Chavan Haribhau Dhansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7286",
    "name": "Chavan Suresh Baburao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "203",
    "name": "Raman Aparkapparam Sasi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "93",
    "name": "Yadav Indrajeet Ramraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5673",
    "name": "Momin Afajal Abdul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3648",
    "name": "Ghadage Rajaram Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20286",
    "name": "Ahire Vijay V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13462",
    "name": "Bobade Sanjay Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13496",
    "name": "Chandraya Vimala Bharati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13066",
    "name": "Chavan Mohan Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13846",
    "name": "Chavan Namdev Dnyanoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13472",
    "name": "Dange Laxmi Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17782",
    "name": "Ghuge Shakuntala Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10819",
    "name": "Jedhe Bhimrao Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9857",
    "name": "Kadam Balkrishna Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5539",
    "name": "Kadam Sanjay Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5586",
    "name": "Kalsekar Rupali Satyawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12919",
    "name": "Kamat Parak Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10820",
    "name": "Kashid Dnyandeo Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12590",
    "name": "Lad Santosh Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10873",
    "name": "Mane Tanajirao Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1036",
    "name": "Manish Corporation"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "284",
    "name": "Maruti Ganapat Bhosale ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10849",
    "name": "More Janardhan Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4000",
    "name": "Mulik Nandkumar Shrirang ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13514",
    "name": "Mulla Huseuddin Hajrat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13515",
    "name": "Mulla Unthiyabegum Husedin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10867",
    "name": "Nalawade Abasaheb Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10874",
    "name": "Navghane Vithal Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17585",
    "name": "Palekar Vishvanath Ramkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17075",
    "name": "Patil Sadashiv Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10127",
    "name": "Patil Vijay Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8674",
    "name": "Phalke Tanaji Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7103",
    "name": "Ramayya  M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13492",
    "name": "Shaikh Ahimat Kasam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11608",
    "name": "Shelke Rajendra Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13482",
    "name": "Shinde Madhukar Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9892",
    "name": "Singh Anilprasad Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8002",
    "name": "Sonawane Bhimrao Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13523",
    "name": "Vishwakarma Bhavansingh Premsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11048",
    "name": "Yadhav Dudhnath Navnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6846",
    "name": "Gujar Sanjay Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1453",
    "name": "Kamath Usha S."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8460",
    "name": "Barge Anil Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6666",
    "name": "Gaikwad Pandurang Sakaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5661",
    "name": "Lagwankar Lata Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2752",
    "name": "Shaikh Banu Rajjak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4605",
    "name": "Pacharne Ravindra Laxman/Vijaya R Pachar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1254",
    "name": "Shantaram Pandurang Shinde."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7074",
    "name": "Wagh Sampat Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3922",
    "name": "Ayare Vilas Gangaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3189",
    "name": "Kadam Surayakant Balaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7181",
    "name": "Rajmane Krishna Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9466",
    "name": "Rahate Sunil Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3726",
    "name": "Shaikh Ibrahim Kasim"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3311",
    "name": "Pawar Yashoda Aabaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1208",
    "name": "Shinde Vithal Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3412",
    "name": "Jagatap Shantabai Kundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3019",
    "name": "Pawar Pramod Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2255",
    "name": "Mahadik Suresh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1149",
    "name": "More Ananda Kesu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10594",
    "name": "Awad Nilesh Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10802",
    "name": "Chavan Maganrao Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12473",
    "name": "Gaikwad Asha Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7434",
    "name": "Ganage Ramesh Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6705",
    "name": "Gite Sopan Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4828",
    "name": "Jadhav Kamlakar Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10629",
    "name": "Jadhav Ramchandra Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11269",
    "name": "Kumbhar Mangesh Khashaba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "818",
    "name": "Magar Chandrashekhar Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10973",
    "name": "More Sharmila Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8794",
    "name": "Pawar Rajaram Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10327",
    "name": "Phalke Pratap Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16041",
    "name": "Rane Hetendra Devendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20316",
    "name": "Saindane Bhiku Himmatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11143",
    "name": "Sawant Umesh Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7466",
    "name": "Sonawane Achaldas Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "318",
    "name": "Sore Sanjay Mahadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3520",
    "name": "Jadhao Dharmraj Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2288",
    "name": "Bhoite Pramila Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1299",
    "name": "Vasudeo Kashinath Patil."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5775",
    "name": "Gaikwad Bhagwan Appaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8688",
    "name": "Jadhav Anil Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3768",
    "name": "Jadhav Dattatrya Bhikoba."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5020",
    "name": "Ghanekar Sarswati Ganesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8709",
    "name": "More Chandrakant Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "934",
    "name": "Jadhav Baji Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19239",
    "name": "Bhuwad Sujay Sudhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10804",
    "name": "Khatal Balu Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19849",
    "name": "Kolkar Chandra Kant Sonu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17977",
    "name": "Manjrekar Prathamesh Suhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8412",
    "name": "Mujavar Dadamiya Abdul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10796",
    "name": "Pisal Dagdu Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12451",
    "name": "Pisal Ganpat Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7511",
    "name": "Salunkhe Shivaji Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1635",
    "name": "Saroj Ramratan Ransvarup"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8355",
    "name": "Shinde Bhagwan Nanaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5984",
    "name": "Shinde Sakhubai Manaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "705",
    "name": "More Maruti Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1330",
    "name": "Sakunde Parashram Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8489",
    "name": "Shinde Sudhir Hunderao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3938",
    "name": "Bhosale Nanaso Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7543",
    "name": "Pisal Subhash Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7507",
    "name": "Jadhav Mahadeo Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4429",
    "name": "Gadhve Ganpat Shivling"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3137",
    "name": "Shinde Prataparao Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8982",
    "name": "Gurakha Katakbahadur Tikaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6412",
    "name": "Bhosale Sunil Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13537",
    "name": "Agonde Shubhangini Tulsiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10290",
    "name": "Chavan Hanmant Dadaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10710",
    "name": "Chavan Sangeeta Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5084",
    "name": "Gawade Madhavi Vishanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13382",
    "name": "Isak  Jaylata"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10685",
    "name": "Jadhav Sunanda Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14918",
    "name": "Jawale Meena Pandurang."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10757",
    "name": "Kadam Ramesh Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13377",
    "name": "Kalmaste Sunil Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10916",
    "name": "Kambale Subhash Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10233",
    "name": "Karande Anusaya Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14315",
    "name": "Kshirsagar Sushila Chagan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14869",
    "name": "Kumbhar Suresh Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11990",
    "name": "Lawand Kanta Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13379",
    "name": "Mahadik Tukaram Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15264",
    "name": "Meckley Pralhad Jivdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9896",
    "name": "Miya Mohmed Rajak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4531",
    "name": "Mohite Ganpat Dada."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13410",
    "name": "Panchal Vijay Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15731",
    "name": "Parihar Manisha M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10747",
    "name": "Pisal Shivaji Govindrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15974",
    "name": "Poojary Ranjit Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14619",
    "name": "Rao Bamidipati Jayalaxmi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13374",
    "name": "Rawal Bhartiben Ishwarlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10739",
    "name": "Salunkhe Vinayak Abaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17282",
    "name": "Savratkar Suvrna Bhimrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11596",
    "name": "Shingate Lalaso Yashawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5398",
    "name": "Vishwakarma Jaharsingh Gopalsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10718",
    "name": "Wagh Vishwas Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "380",
    "name": "Marine Tronics"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6818",
    "name": "Momin Isak Rashid"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3921",
    "name": "Vaidh Ravindra Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3456",
    "name": "Naik Rahamat Ahamad."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1603",
    "name": "Jadhav Baburao Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1764",
    "name": "Rawal Halnath Magunda."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3315",
    "name": "Borale Deelip Ukha."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "572",
    "name": "Phalke Uttam Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2317",
    "name": "Gaikwad Khashaba Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2253",
    "name": "Salunkhe Shakuntala Mahadev."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4898",
    "name": "Chavan Khashaba Bali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3789",
    "name": "Kadry Mohammed Salim."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2824",
    "name": "Khopade Ankush Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "418",
    "name": "Marwah Engineering Industries."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1171",
    "name": "Maheliya Malik Arjun Basappa."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1127",
    "name": "Mulani Rashid Chand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11913",
    "name": "Babul Ravindra Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4974",
    "name": "Barad Shamrao Bhairu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13333",
    "name": "Bhavsar Nanda Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10686",
    "name": "Bhoite Asha Suhas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10687",
    "name": "Bhoite Suhas Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13266",
    "name": "Chavan Hanmant Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13324",
    "name": "Chavan Vilas Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13268",
    "name": "Chenna Suvarna Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14410",
    "name": "Chougule  Dhonduram Pandurang."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10646",
    "name": "Dixit Suhas Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9706",
    "name": "Dubey Vinodkumar Fatehbahadur"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10669",
    "name": "Gade Hanmant Savala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10662",
    "name": "Gaikwad Vitthal Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7239",
    "name": "Gurav Vilas Shankar ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10634",
    "name": "Inamdar Abdul Ibrahim"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10580",
    "name": "Jadhav Chandrakant Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10569",
    "name": "Jadhav Uma Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10691",
    "name": "Jadhav Vasant Appasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15538",
    "name": "Kachare Vinayak Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10672",
    "name": "Kadam Nandkumar Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10673",
    "name": "Kadam Rajendra Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10694",
    "name": "Kadam Sharad Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16359",
    "name": "Kamble Sunita Hanumant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10612",
    "name": "Karne Shripati Raoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10661",
    "name": "Karne Sudhakar Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13339",
    "name": "Misra Chanda Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14288",
    "name": "More Vikas Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13323",
    "name": "Nadar P. Kalaselvi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17235",
    "name": "Nalwade Manda Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12215",
    "name": "Nikam Chandrakant Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12953",
    "name": "Parkar Vinod Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12932",
    "name": "Pawar Kalidas Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9593",
    "name": "Phalke Gulab Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13267",
    "name": "Rekhi Preeti Kaur"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10644",
    "name": "Sabale Kalidas Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13227",
    "name": "Sable Vijay Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9557",
    "name": "Sakunde Balkrishna Venkat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12239",
    "name": "Salunkhe Baban Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10600",
    "name": "Salunkhe Maruti Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13349",
    "name": "Sankhe Madhuri Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13249",
    "name": "Sawant Sunil Jaisingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10664",
    "name": "Shinde Kantabai Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10627",
    "name": "Shinde Santosh Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10657",
    "name": "Shinde Shivsji Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11499",
    "name": "Sonkar Indresh/Ramchandra Sonker"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7933",
    "name": "Surve Ramchandra Sahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13334",
    "name": "Surywanshi Mandakini Vishnupant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13000",
    "name": "Thakur Manhesh Shrilakhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15239",
    "name": "Thombare Sanjay Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16218",
    "name": "Ubale Dipak Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10774",
    "name": "Ugale Deepak Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13327",
    "name": "Varma Sunil Raju"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10905",
    "name": "Yewale Rahul Sudam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5491",
    "name": "Rakshe Sarjerao Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1302",
    "name": "Sau.Shalini Pandurang Wagh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13234",
    "name": "Kamble Sachin Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1347",
    "name": "Ghag  Pandurang Umaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5877",
    "name": "Jadhav Dnyandeo Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1352",
    "name": "Patil Malatibai Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5945",
    "name": "Matkar Dnyandeo Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7197",
    "name": "Bhande Baburao Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2048",
    "name": "Bhalerao Sunanda Shataram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4140",
    "name": "Kudo Unu Usman Shekh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "569",
    "name": "Roman Kashinath Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16344",
    "name": "Bhoyar Madan Rajeramji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19100",
    "name": "Giri Sureshchandra Shambhunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21278",
    "name": "Kale Pravin Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14533",
    "name": "Nimbalkar Arun Vamanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10560",
    "name": "Pawar Sanjay Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12053",
    "name": "Phalke Sujata Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10556",
    "name": "Pisal Vishnuraj Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11925",
    "name": "Shinde Pandurang Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11503",
    "name": "Sutar Santosh Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16215",
    "name": "Matakar Prakash Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "500",
    "name": "Nanubai Keshav Patil."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6173",
    "name": "Phalke Kamal Dattu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7019",
    "name": "Dixit Pratibha Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15383",
    "name": "Nikam Vilas Jaganath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5556",
    "name": "Pawar Laxman Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2624",
    "name": "Mateshree Textiles Agency"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12173",
    "name": "Patil Vasant Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2523",
    "name": "Thapa  Tejbahadur."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18992",
    "name": "Varpe Ujwala Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6057",
    "name": "Anpat Mangal Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17346",
    "name": "Ansari Mubarak Husain Saheb Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13169",
    "name": "Ayare Bhaskar Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10061",
    "name": "Barai Gangaprasad Raghav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13000",
    "name": "Borate Swati Madhuri Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14993",
    "name": "Buthella Sofiya Jeri"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14047",
    "name": "Chutwy Basattappa Basuvaraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12291",
    "name": "Gaikawad Sadhana Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7932",
    "name": "Himbhare Manda Dattatrya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10554",
    "name": "Jagdale Ananda Nathu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13182",
    "name": "Kalwar Maruti Santlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13181",
    "name": "Kalwar Santlal Jan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7967",
    "name": "Machale Ravindrakumar Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9407",
    "name": "Makwana Pravin Babubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13320",
    "name": "Panchal Deepak Jaichand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11305",
    "name": "Parmar Arvindkumar Prabhudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10801",
    "name": "Pawar Balkrishna Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13203",
    "name": "Pawar Madan Dagadu."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10490",
    "name": "Pawar Suvarana Anil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11072",
    "name": "Phalke Anil Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10499",
    "name": "Phalke Gulabrao Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17508",
    "name": "Rahate Yamuna Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15448",
    "name": "Saha Dibyendu Ajay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7516",
    "name": "Saroj Janku Bhulan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6077",
    "name": "Sawant Manisha Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12049",
    "name": "Shahane Lata Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15590",
    "name": "Sharma Jaiprakash Ratanlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10566",
    "name": "Shinde Chandrakant Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22777",
    "name": "Singh Puran Rambhadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13189",
    "name": "Suryawanshi Rajendrakumar Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9980",
    "name": "Yadav Shivpujan Meghnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3930",
    "name": "Jadhav Mahadeo Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7787",
    "name": "Falake Vimal Balawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4542",
    "name": "Bhagat Gunabai Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1237",
    "name": "Vishnoi Arjunram Hariram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4231",
    "name": "Kusum"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8169",
    "name": "Chavan Pradip Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5329",
    "name": "Patel  Kantilal Dahyabhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "919",
    "name": "Sharma Ramprasad Nandlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1469",
    "name": "Sonavane Rajendra Amrutrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9509",
    "name": "Baig Akhatar Kasam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "107",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9511",
    "name": "Pandey Sarajuprasad R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6334",
    "name": "Achrekar Lata Suhas/Suhas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8047",
    "name": "Anpat Namdeo Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6076",
    "name": "Mane Popat Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9714",
    "name": "Pisal Namdeo Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1226",
    "name": "Patil Dattatry Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13076",
    "name": "Bhagat Chandrahas Maniklal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15660",
    "name": "Chndrakant Hari Sagvekar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10405",
    "name": "Jadhav Krishna Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13104",
    "name": "Jodhale Prakash Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12506",
    "name": "Kambale Jagannath Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13308",
    "name": "Khadaka Jaibhadur N."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8983",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5965",
    "name": "Malvi  Chandadevi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13419",
    "name": "Matre Pilaji Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13117",
    "name": "Mayekar Gurunath Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7909",
    "name": "Mulik Aruna Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6080",
    "name": "Parab Ujwala Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1851",
    "name": "Pathan Madar Husen"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1644",
    "name": "Mauli Electrical Service"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "157",
    "name": "Mauli Enterpises"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10489",
    "name": "Pawar Anil Krisnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10365",
    "name": "Phalke Subhash Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18401",
    "name": "Renuka R.Salunkhe."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10493",
    "name": "Sabale Shivaji Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10404",
    "name": "Sakpal Kisan Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10481",
    "name": "Sambale Rajendra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7994",
    "name": "Sawant Manisha Vasudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10995",
    "name": "Shaikh Shakil Faqruddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16735",
    "name": "Shinde Eknath Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9179",
    "name": "Sonawane Achaldas Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9905",
    "name": "Varai Raghupati Chamaru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7665",
    "name": "Varma Vedprakash R."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3632",
    "name": "Gaikwad Narmada Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1833",
    "name": "Jadhav Ramchandra Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5808",
    "name": "Chatur Prakash Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2455",
    "name": "Thakur Sukhlal Heeralal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14943",
    "name": "Yendhe Maruti Shankar."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2758",
    "name": "Maxwell Enpterprises"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "35",
    "name": "Maxx Motors"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "300",
    "name": "Vasanti Krishna Chavan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11063",
    "name": "Thombare Subodh Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "104",
    "name": "Jadhav Shankar Bhairu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3030",
    "name": "Yadav Udayraj Kulafath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1094",
    "name": "Bhalchandra Madan Mhatre."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5646",
    "name": "Bhoite Arvind Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2602",
    "name": "Ranaware Pradip Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8440",
    "name": "More Milind Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "143",
    "name": "Shrirang Bhauso Mahangade."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22054",
    "name": "Hashmi Aamir Sabirali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7825",
    "name": "Kumbhar Bharat Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2562",
    "name": "Madhare Rajendr Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6222",
    "name": "Ghadge Sanjay Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "933",
    "name": "Chatur Hanmant Sidram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2464",
    "name": "Mayur  Painting  Works."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2559",
    "name": "Mayur Enterprises"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "54",
    "name": "Mayur Graphics"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1270",
    "name": "Mayur Transport."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1010",
    "name": "Jadhav Arjun Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11916",
    "name": "Nidan Nandkumar Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8135",
    "name": "Ahire Nivrutti Parsharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9386",
    "name": "Ashphak Hussain Eqlaque Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11082",
    "name": "Awadh Shankarrao Govindrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10703",
    "name": "Bansode Ashok Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13416",
    "name": "Bhosale Nitin Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7652",
    "name": "Bhosale Pralhad Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10413",
    "name": "Chavan Dattatray Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10154",
    "name": "Chavan Shivaji Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9236",
    "name": "Dalavi Yashwant Antu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2646",
    "name": "Meenaxi Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14679",
    "name": "Dhrua Hitesh Dhirajlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10462",
    "name": "Dubal Baburao Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8064",
    "name": "Gadge Vishwasrao Sarjayrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10157",
    "name": "Gaikwad Shankar Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9613",
    "name": "Ibrahim Khan Hussain Khan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10414",
    "name": "Jadhav Krishna Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10444",
    "name": "Jagtap Nandkumar Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8137",
    "name": "Kadam Waman Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13051",
    "name": "Mandhare Yogesh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15852",
    "name": "Meena Jitendra Maniyar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9843",
    "name": "Mehtar Usman Suleman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10476",
    "name": "Nalwade Shahaji Namdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10463",
    "name": "Navsare Rajendra Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9410",
    "name": "Ongya Tashi Pasang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13660",
    "name": "Patel Amba Arjunsing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8664",
    "name": "Patil Faram D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10536",
    "name": "Pawar Kisan Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15339",
    "name": "Pawar Suresh Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7676",
    "name": "Sable Ramesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13201",
    "name": "Said Shankar Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10464",
    "name": "Vaydande Ashok Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10409",
    "name": "Wagh Dattatray Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9855",
    "name": "Yadav Indrajit Dhaneswar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2822",
    "name": "Palaskar Kedar Shyamsundar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5395",
    "name": "Singh  Satyanarayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11455",
    "name": "Nikam Latika Dilip"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "110",
    "name": "Mehta Brothers Freight Forwarders Pvt Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12844",
    "name": "Chhatry Indrasingh Ratansingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12389",
    "name": "Jadhav Shewantabai Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2830",
    "name": "Umap  Asharam"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "69",
    "name": "Pawanekar Chandrakant Pundlik"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "185",
    "name": "Sampat Hansa Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10558",
    "name": "Sayyad Begum Allabaksha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12831",
    "name": "Shinde Sandip Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11345",
    "name": "Kadam Godavari Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1607",
    "name": "Vishwakarma Damarsing Budhsing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "868",
    "name": "Manohar Narhari Sawant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6807",
    "name": "Bhandari Gulab Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10368",
    "name": "Chavan Bhanudas Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8290",
    "name": "Ghadge Maruti Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15822",
    "name": "Ghadi Prakash Govind."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10482",
    "name": "Godugade Sunita Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12901",
    "name": "Howal Dilip Shivdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10385",
    "name": "Kadam Subhash Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10601",
    "name": "Katelkar Ravindra Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7710",
    "name": "Katte Sudhakar Veerbhadra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1331",
    "name": "Kishor  Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9433",
    "name": "Kokate Shantaram Ramaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10382",
    "name": "Kshirsagar Suresh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5429",
    "name": "Lahane Yashwant Trimbak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10390",
    "name": "Lembhe Namdeo Buvaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12839",
    "name": "More Dilip Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12237",
    "name": "Muliya Raju Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10611",
    "name": "Nikam Namdeo Kundlik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10377",
    "name": "Padale Prakash Jijaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17209",
    "name": "Paste Rajesh Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10344",
    "name": "Patil Manisha Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13025",
    "name": "Patil Ravindra Bhimsing"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "114",
    "name": "Patil Vishal Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8089",
    "name": "Pawar Atmaram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14252",
    "name": "Pawar Rajaram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5983",
    "name": "Pitale Surykant Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14380",
    "name": "Ratan Surandhar Jugalirai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6858",
    "name": "Rimal Manojkumar G"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5083",
    "name": "Sadavarte Damodar Rambhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10223",
    "name": "Sakunde Satish Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12863",
    "name": "Shaikh Mohamad Yusuf Mehaboob"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12738",
    "name": "Shetty Papati Pandian"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9503",
    "name": "Shinde Mohan Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20438",
    "name": "Sonawale Suresh Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12876",
    "name": "Sudi Surjansingh Labhsingh"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "24",
    "name": "Mejwani Snacks & Chinese Corner"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12058",
    "name": "Tate Hemant Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12853",
    "name": "Thomas Agnel Jose"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17408",
    "name": "Tiwari  Mayashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12155",
    "name": "Vaikul Vaibhav Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13352",
    "name": "Ware Prakash Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11890",
    "name": "Bhosale Gopichand Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "911",
    "name": "T A Vijay Ayyappa."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6608",
    "name": "Shirsat Laxman Mahadeo/Ujwala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "995",
    "name": "Gilgile Vilas Vithairao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7737",
    "name": "Kadam Ramchandra Bhairu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10060",
    "name": "Yadav Ranjana Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8922",
    "name": "Kashid Abhimanyu Gena"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4074",
    "name": "Sawant Dnyanu Ganapat ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3240",
    "name": "Ingale Punchshila Sudhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "498",
    "name": "Vanita Dyandeo Manjrekar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7718",
    "name": "Mane Sumukh Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10362",
    "name": "Chavan Vishnu Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10349",
    "name": "Jadhav Ashok Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10354",
    "name": "Kadam Madhukar Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10361",
    "name": "Kadam Parshuram Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10359",
    "name": "Kadam Ranjana Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10363",
    "name": "Kadam Suresh Madhav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12853",
    "name": "Kumbhar Sitabai Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10346",
    "name": "Londhe Tanaji Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10351",
    "name": "Mulik Tanaji Haribhau"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1383",
    "name": "Pathak Dilip Radheshyam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10341",
    "name": "Phadtare Yuvaraj Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10330",
    "name": "Phalke Adhikrao Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10357",
    "name": "Sawant Arvind Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9991",
    "name": "Sayyad Umarfaruk Allabaksh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11585",
    "name": "Shaikh Taslina Amjad Hussain"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9411",
    "name": "Solaskar Shashikant Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9151",
    "name": "Yadav Vithal Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9016",
    "name": "Jagtap Pradesh Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4470",
    "name": "Mahadik Prabhawati Kisanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9117",
    "name": "Sabale Baburao Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4011",
    "name": "Shende Uttam Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2663",
    "name": "Ghadge Sonubai Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7766",
    "name": "Mulani Jubera Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1788",
    "name": "Chavan Hanmant Dadaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2756",
    "name": "Gaikwad Omprakash Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18167",
    "name": "Bhansali Pankaj Chunnilal [Huf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14393",
    "name": "Bhoite Umesh Bhalerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12754",
    "name": "Bhosale Ganpat Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5562",
    "name": "Bohara Mohan Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15593",
    "name": "Choudhari  Upendra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12802",
    "name": "Davane Ashok Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12818",
    "name": "Dhumal Pramod Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1769",
    "name": "Metro Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9385",
    "name": "Jambhavadekar Jairam Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8745",
    "name": "Khadka Padam Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12764",
    "name": "Khan Farida Firoj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5508",
    "name": "More Sakhubai Hari/Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7563",
    "name": "Mulla Allauddin Abdullatif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12813",
    "name": "Nimbalkar Rekha Prabhkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10028",
    "name": "Pandey Rakesh Lalan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12837",
    "name": "Patil Vishant Bapuso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12544",
    "name": "Phalke Dipali Dnyaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14204",
    "name": "Raibhan Laxmibai Devram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10787",
    "name": "Rimal Jhanak Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10858",
    "name": "Sakpal Yashwant Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12792",
    "name": "Salunkhe Sanjeevani Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10194",
    "name": "Vishwakarma  Shyamnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5557",
    "name": "Zagde Shaila Sitaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1021",
    "name": "Ashok Baburao Bobade."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2716",
    "name": "Jadhav Bhagawan P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2656",
    "name": "Vadekar Kalpana Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9522",
    "name": "Singh Banarasi V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4910",
    "name": "Choudhari Sumitra M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1990",
    "name": "Khilare Sangita Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2126",
    "name": "Ambare Mohan Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10211",
    "name": "Shingate Shrirang Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4692",
    "name": "Jagtap Hindurao Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8937",
    "name": "Kahar Ramsabh Bhoar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3449",
    "name": "Suryavanshi Venkat Namdeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2718",
    "name": "Mastan Suleman Hasan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9192",
    "name": "Pawar Shirishkumar Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2771",
    "name": "Yadav Jagannath Dnanu ."
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1083",
    "name": "Ahire Keval Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14164",
    "name": "Begi Appnna Hiraswami."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11210",
    "name": "Bhandari Janabai Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12702",
    "name": "Bhoite Mahendra Buvasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15331",
    "name": "Chafekar Jashree Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14075",
    "name": "Chavan Dilip Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12648",
    "name": "Chavan Vishnu Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12660",
    "name": "Choudhary Chotelal Somai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12584",
    "name": "Dnyandeo Sable Trimbak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9614",
    "name": "Ganima Ravi Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12632",
    "name": "Gautam Gangaram Ramdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12715",
    "name": "Jadhav Bhanudas Dadasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12716",
    "name": "Jadhav Pallavi Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17691",
    "name": "Jadhav Rajendra Nandkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12805",
    "name": "Jagtap Anil Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12806",
    "name": "Jagtap Sharad Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12087",
    "name": "Kadam Chandra Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18777",
    "name": "Kambale Prakash Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12567",
    "name": "Katkar Ramdas Abaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12586",
    "name": "Khan Farid Gujar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12722",
    "name": "Kokane Ramesh Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10151",
    "name": "Lokare Shashikant Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12629",
    "name": "Mandhare Hanbir Sompal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2620",
    "name": "Mehata Indravadan P"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11232",
    "name": "More Kamal Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5220",
    "name": "Palalkatti Sunita Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7144",
    "name": "Panbude Balkrishna Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10268",
    "name": "Phalke Bhanudas Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12505",
    "name": "Phalke Namdeo Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10262",
    "name": "Phalke Satish Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12662",
    "name": "Pinto Anita Vincent"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12609",
    "name": "Pokha Nandkumar Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12608",
    "name": "Rane Subhash Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12649",
    "name": "Safi Mehmud Kalimiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10723",
    "name": "Shaikh  Tayarabdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6654",
    "name": "Sharma Shantaram Motilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11730",
    "name": "Shelar Kamal Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12587",
    "name": "Suckatali Khalil Ahamad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1036",
    "name": "Vanniyar Priya Panneer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7913",
    "name": "Yadav  Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2313",
    "name": "Kadam Prakash Vyankatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6682",
    "name": "Pawar Savita Jaganath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4604",
    "name": "Vandrik Mehmud Abdul Rahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10765",
    "name": "Chauhan Gauriram Sambhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "343",
    "name": "Kantilal Shrirang Bhosale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14599",
    "name": "Kondvilkar  Gloria Madhav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8516",
    "name": "Mangaonkar Rani Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10487",
    "name": "Bhoite Vishnu Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8400",
    "name": "Jagdale Ranjit Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1655",
    "name": "Jadhav Kashinath Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1112",
    "name": "Gaikawad Babu Dada."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5704",
    "name": "Shinde Ashok Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5155",
    "name": "Pille Jayvel Benjmin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5144",
    "name": "Vargis Gheevan Kochanman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8167",
    "name": "Gaikwad Shivaji Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10303",
    "name": "Jadhav Ramchandra Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10552",
    "name": "Jagtap Kalidas Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19343",
    "name": "Kavar Rajendra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10302",
    "name": "Nanaware Sanjay Dada"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10320",
    "name": "Nayakwade Iqbal Abbas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10299",
    "name": "Pawar Hanmant Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10271",
    "name": "Pawar Vithal Sudam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11371",
    "name": "Pisal Sudarshana Anil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10305",
    "name": "Sabale Ashok Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10380",
    "name": "Shedage Ramdas Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10312",
    "name": "Sutar Narayan Krushnaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7993",
    "name": "Dhane Vijay Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2078",
    "name": "Micronix Infotech"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7189",
    "name": "Wagh Bhanudas Dnayndeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3350",
    "name": "Milan Print"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3345",
    "name": "Salunkhe Bhanudas Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5502",
    "name": "Ghadge Tanaji Gulab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7198",
    "name": "Chavan Dilip Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3998",
    "name": "Borate Tanaji Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12742",
    "name": "Aware Mohan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11197",
    "name": "Chavan Suresh Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13032",
    "name": "Chigare Ajit Annasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14461",
    "name": "Chouhan Ujwalsing Chandarsing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6062",
    "name": "Desai Ranjankumar Kaliprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17626",
    "name": "Dighe Sameer Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9334",
    "name": "Divkar Tauseef Ismail"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "595",
    "name": "Jankar Mahadu Antu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3292",
    "name": "Kadam Shankar Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4881",
    "name": "Kanajiya  Usarabahan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12490",
    "name": "Kokane Ashok Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12461",
    "name": "Lingayat Purnima Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12564",
    "name": "Mane Sunita Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12470",
    "name": "Mourya Ramprasad Rammanorath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2633",
    "name": "Nalawade Uttam Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12828",
    "name": "Narkar Roshani Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9054",
    "name": "Pandit Prashant Shashikar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12373",
    "name": "Patil Smita Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5590",
    "name": "Sawant Gulab Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13073",
    "name": "Thasale Pradeep Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7784",
    "name": "Torave Sakharam Dasharatha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12500",
    "name": "Walawe Kavita Kishor"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12678",
    "name": "Yadav Dattatray Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "587",
    "name": "Madhukar Sanaba Ghugare"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3205",
    "name": "Jadhao Ankush Lakman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2243",
    "name": "Yedge Dattaram Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15816",
    "name": "Shivalkar Sunil Vikas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16859",
    "name": "Pisal Dashrat Sahebrao ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2925",
    "name": "Sabale Ramchandra Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1300",
    "name": "Jaiswal Raghunath Khadru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4029",
    "name": "Jadhav Balkrushna Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "589",
    "name": "Maruti Ganu Ghugare"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15038",
    "name": "Patel Sharad Hirjibhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "588",
    "name": "Vasant Govind Ghugare"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2720",
    "name": "Mahadik Tarabai Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6445",
    "name": "Salunkhe Kaushalya Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4619",
    "name": "Kurup Suresh Purushotam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2061",
    "name": "Yadav Rammilan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "432",
    "name": "Bharat Yashwant Jadhav."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "530",
    "name": "Josef Nikalb Vaity"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14897",
    "name": "Bhand Nitin Dinkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13867",
    "name": "Bhosale Deepak Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10250",
    "name": "Bhosale Vishwas Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12353",
    "name": "Both Anand Pyarelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13103",
    "name": "Chavan Pradeep Dyaneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9976",
    "name": "Chavan Vidhaya Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12284",
    "name": "Choube Subhash Tirthraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10397",
    "name": "Jadhav Kisan Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12566",
    "name": "Jadhav Namdeo Hariba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12377",
    "name": "Jadhav Prakash Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10188",
    "name": "Jadhav Tanaji Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10238",
    "name": "Jagtap Ravindra Bajarang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8622",
    "name": "Jain Asha Abhaykumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10191",
    "name": "Kadam Pradip Vishwas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10187",
    "name": "Kadam Premlata Padmakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10220",
    "name": "Kadam Rajendra Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9973",
    "name": "Kale Mahadeo Khandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15345",
    "name": "Kanojia Sunita Purushottam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10393",
    "name": "Lembhe Vikas Buvaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10310",
    "name": "Lohar Ratna Rajendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10742",
    "name": "Mandhare Ashok Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12428",
    "name": "Mandolkar Chandrakant Mahableswar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16672",
    "name": "More Mohan Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11949",
    "name": "More Pramod Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10228",
    "name": "Mulani Rajjak Mubarak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10257",
    "name": "Mulik Anjana Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17370",
    "name": "Nalawade Rupali Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8991",
    "name": "Nikam Dashrath Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12416",
    "name": "Pal Ramdawar Dwarikaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9104",
    "name": "Pal Subedar Thakurdin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13518",
    "name": "Patel Kalavatidevi R"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10210",
    "name": "Pawar Dattatray Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13569",
    "name": "Pawar Vimal Mohan."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10172",
    "name": "Phalke Kamlakar Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10170",
    "name": "Pharande Shankar Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10248",
    "name": "Sabale Kamalakar Anant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10485",
    "name": "Sambale Kundalek Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23153",
    "name": "Sarang Priyanka Prashanty"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12321",
    "name": "Shinde Anil Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10628",
    "name": "Shinde Sangeeta Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16148",
    "name": "Shinde Shailesh Laxman."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10160",
    "name": "Shinde Yashwant Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12272",
    "name": "Thosar Sudha Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12410",
    "name": "Vichare Sandeep Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9693",
    "name": "Vichare Shobha Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13449",
    "name": "Vishwakarma Mahadevi Harsuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10216",
    "name": "Wagh Sampatrao Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5781",
    "name": "Wagh Shankar Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10035",
    "name": "Aware Ramchandra Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1103",
    "name": "Dhuru Upendra Pandurang."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8884",
    "name": "Shinde Yuvraj Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12241",
    "name": "Aanpat Suresh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17097",
    "name": "Amare Shubhangi Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12248",
    "name": "Anapat Kisan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10058",
    "name": "Bhilare Bharat Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1464",
    "name": "Bhosale Dhansing Abaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11963",
    "name": "Biranje Mahesh Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11962",
    "name": "Biranje Namdeo Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11993",
    "name": "Charhate Balkrishna Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8757",
    "name": "Chavan Sudhir Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9854",
    "name": "Chourasia Shyamlal Ramkhilawan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15509",
    "name": "Dhumal Shaila Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10153",
    "name": "Disale Aruna Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10156",
    "name": "Gaikwad Vitthal Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10152",
    "name": "Ghadge Shankar Vadju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12760",
    "name": "Ghadi Sonali Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12496",
    "name": "Hule Sudarshan Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12220",
    "name": "Jadhav Bhanudas Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9098",
    "name": "Khandare Bhagwan P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6236",
    "name": "Lad  Khelanand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10447",
    "name": "Lohar Narayan Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11948",
    "name": "Makwana Kishor Khimji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12035",
    "name": "Mhaske Vasant Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9035",
    "name": "Mohite Dhananjay Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12050",
    "name": "More Mandakini Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3537",
    "name": "Nalawade Rajesh Murlidhar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12396",
    "name": "Pandit Vishal Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12057",
    "name": "Panwalkar Vishwanath Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9961",
    "name": "Pawar Narsingh Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13399",
    "name": "Pujari Bhagirti Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15137",
    "name": "Rani Kamleshwar Prasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12129",
    "name": "Sabale Shankar Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10147",
    "name": "Shinde Ashok Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10040",
    "name": "Shinde Sukhadeo Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12056",
    "name": "Shinde Suresh Mahadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12759",
    "name": "Wagh Sampat Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6475",
    "name": "Gawade Dharmaji Baba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2772",
    "name": "Thakkar Girish Harishan  ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5480",
    "name": "Kawade Rama Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11131",
    "name": "Amare Suresh Gangaram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10426",
    "name": "Chavan Walchand Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4566",
    "name": "Jain Chunnilal C."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4524",
    "name": "Dhembare Bhimrao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12875",
    "name": "Jadhav Suhas Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6053",
    "name": "Bobde Jayhind Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2951",
    "name": "Patel Gulam Mahamad Gulamgosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2545",
    "name": "Chavan Sandhya Raghunath."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10004",
    "name": "Babar Dhananjay Jaywant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10021",
    "name": "Babar Sandeep Jaywant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10015",
    "name": "Babar Shashikant Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10108",
    "name": "Chatur Shrimant Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10086",
    "name": "Chavan Hanmant Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9999",
    "name": "Chavan Nitin Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9984",
    "name": "Chavan Shankar Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12785",
    "name": "Gadhave Mohini Jayawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10329",
    "name": "Gaikwad Jayawant Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10096",
    "name": "Gikwad Sanjay Krishnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10002",
    "name": "Gujar Balkrishna Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10448",
    "name": "Jadhav Dilip Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10005",
    "name": "Jadhav Jyotiram Sagan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10118",
    "name": "Jadhav Vyankat Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10095",
    "name": "Kadam Jotiram Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4205",
    "name": "Kadam Maruti Bali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9998",
    "name": "Kadam Vilas Shriram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10258",
    "name": "Kumbhar Ramesh Babaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10079",
    "name": "Lohar Rajendar Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9802",
    "name": "Mane Balaso Mansingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10043",
    "name": "Phalke Ravindra Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10109",
    "name": "Sabale Suhas Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4593",
    "name": "Sabnis Vijaya Digambar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10017",
    "name": "Sakunde Dasharat Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10123",
    "name": "Sakunde Satish Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10104",
    "name": "Sakunde Vasant Amruta"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10036",
    "name": "Shevate Rajendra Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12713",
    "name": "Shinde Indumati Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10024",
    "name": "Yevale Lalsing Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10110",
    "name": "Zanzane Mahadeo Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "303",
    "name": "Mistry Laduram Kanaji Chawhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17878",
    "name": "Jadhav Ananda Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13647",
    "name": "Gurav Vivek Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3091",
    "name": "Jadhav Sarjerao Ganapati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3368",
    "name": "Salunkhe Gorakhanath Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3310",
    "name": "Nikam Aanandrao Rau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14611",
    "name": "Jadhav Sachin Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5916",
    "name": "Jagtap Dhansing Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1150",
    "name": "Sawant Shankar Maruti."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3983",
    "name": "Kadam Hindurao Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6526",
    "name": "Bhhosale Janardhan Wishvanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9996",
    "name": "Bhoite Ankush Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10031",
    "name": "Bhosale Ramesh J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9955",
    "name": "Chavan Vilas Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12135",
    "name": "Chinathyal Anil Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8157",
    "name": "Gahdge Kusum Duryodhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5344",
    "name": "Gawad Vasudha Vasudeo."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1432",
    "name": "Mithai Engineering Works"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1792",
    "name": "Mithalal Guanchand Jain (Huf)"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16660",
    "name": "Ghadge Rajkumar Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1589",
    "name": "Jadhav Gorakhanath Dattajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11932",
    "name": "Jaiswal Sangeeta Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16089",
    "name": "Jalgoankar Smita Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7401",
    "name": "Kadam Rambhau Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9155",
    "name": "Kadam Sampat Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7160",
    "name": "Kalekar Santosh Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10620",
    "name": "Kamble Ramesh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11909",
    "name": "Kharjuvekar Shubhangi Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11895",
    "name": "Pandey Trilokinath Chabiraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12274",
    "name": "Patil Suvarna Gopinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7035",
    "name": "Phalke Ashok Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9268",
    "name": "Sakunde Pramila Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5440",
    "name": "Sakunde Vasant Babu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10057",
    "name": "Shekh Abdulhamid Ismail"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10056",
    "name": "Shikalgar Altap Mohmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16574",
    "name": "Shinde Vikas Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7501",
    "name": "Tate Deelip Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8997",
    "name": "Varma  Ramlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12960",
    "name": "Waghekar Dasarat Diwal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11935",
    "name": "Waykar Ranjana Bhaskar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9954",
    "name": "Yadao Ashok Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11897",
    "name": "Yadav Lalchand Punwashi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5126",
    "name": "Phalke Sambhaji Netaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16677",
    "name": "Thakkar Manish Mahendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1560",
    "name": "Patil Hemant Dattaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6629",
    "name": "Bhosale Dashrath Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2585",
    "name": "Nalage Bapu Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4995",
    "name": "Salunkhe Vishnu Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11753",
    "name": "Ganglani Indira Jitendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3660",
    "name": "Tare Prakash Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8771",
    "name": "Pawar Satish Dnyandev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6786",
    "name": "Shinde Sahebrao Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11938",
    "name": "Solanki Ajemdra S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "726",
    "name": "Ramchandra Sadashiv Raut."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13180",
    "name": "Panchal Ambalal Kacharalal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10684",
    "name": "Lembhe Raghunath Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2852",
    "name": "Patel Nanhaku Ahivaran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9942",
    "name": "Aatar Hasan Ganni"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11860",
    "name": "Arya Dharmendra Chandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13020",
    "name": "Bharati Kamal Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8256",
    "name": "Bhhosale Shahaji Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9926",
    "name": "Bhoite Ravindra Vasantarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6835",
    "name": "Bhosale Vilas Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1491",
    "name": "Modern Welding Works"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7017",
    "name": "Budhan  Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7165",
    "name": "Chalke Bharat Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11180",
    "name": "Chavan Ankush Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11846",
    "name": "Chavan Bajirao Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9941",
    "name": "Chavan Sambhaji Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6196",
    "name": "Choudhari Rajani Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7212",
    "name": "Deshamukh Dilip Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7423",
    "name": "Dhamal Sunil Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9386",
    "name": "Gadhave Vilas Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9911",
    "name": "Gaikawad Sayaji Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11813",
    "name": "Gorivale Ramesh Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7658",
    "name": "Jadhav Pandurang Vishwanath."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9930",
    "name": "Jagatap Mahadeo Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13008",
    "name": "Kadam Ramadas Jaywantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11829",
    "name": "Kamtekar Ravindra Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11842",
    "name": "Karim Rizwat Aktar Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12019",
    "name": "Khade Gangadhar Wamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11872",
    "name": "Mane Sadshiv Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13595",
    "name": "Muley Chandrakant Vishwanath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14958",
    "name": "Naik Nilesh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4859",
    "name": "Patil Baburao D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14863",
    "name": "Patil Lahu Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7868",
    "name": "Pawar Sharada Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9889",
    "name": "Phadatare Nandkumar Dinakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9269",
    "name": "Phalke Ramdas Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11283",
    "name": "Phalke Sushila Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11862",
    "name": "Ranim Vasant Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11714",
    "name": "Salunkhe Sunita Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12824",
    "name": "Sarankar Sunil Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3806",
    "name": "Sawant Balu Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9882",
    "name": "Sawant Pralhad Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5390",
    "name": "Shinde Bhanudas Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8484",
    "name": "Shinde Shankar Chima"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7420",
    "name": "Mahadik Sampat Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9238",
    "name": "Dhobi Shriram Devari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6650",
    "name": "Jeswani Menjraj Chanchaldas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1219",
    "name": "Phalke Balkrushna Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6491",
    "name": "Momin Mohamadnisar Abdulla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10923",
    "name": "Kenjale Bhimrao Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3816",
    "name": "Disale Vishnu Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7954",
    "name": "Wagh Bhageerati Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10803",
    "name": "Badadare Mangesh Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7057",
    "name": "Cahvan Changdeo Vithal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "478",
    "name": "Choudhary Mularam Nenaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10097",
    "name": "Honrao Mahadev Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9854",
    "name": "Jadhao Sanjay Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17028",
    "name": "Jagtap Shakuntala Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9843",
    "name": "Kadam Arun Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17271",
    "name": "Kadam Sharad Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9918",
    "name": "Phalake Eknath Aanandarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7910",
    "name": "Pole Ankush Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9742",
    "name": "Raut Hanmant Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10364",
    "name": "Rout Anaita Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5398",
    "name": "Sabale Anant Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10952",
    "name": "Sawant Rajendra Awba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8843",
    "name": "Suryavanshi Vanita Nathoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18949",
    "name": "Tawade Prasad Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3595",
    "name": "Mohd Hassan Mohd Hanif"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7871",
    "name": "Yadav Udaysingh Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6211",
    "name": "Jadhav Pradip Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2667",
    "name": "Chavan Mohan Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7211",
    "name": "Kadam Samixa Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8202",
    "name": "Phalke Govindrao Khanderao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5404",
    "name": "Disale Ramu Rangu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11902",
    "name": "Chavan Sanjay Jyotiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17645",
    "name": "Lokhande Rangnath Budhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "642",
    "name": "Varpe Ualhas Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8210",
    "name": "Jadhav Chandrakant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10545",
    "name": "Adagale Chandrakant Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4963",
    "name": "Alva Chandrakala J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11837",
    "name": "Dait Amit Dhondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8643",
    "name": "Gaikawad Balkrishna Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9773",
    "name": "Garde Mahendra Sarajerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9772",
    "name": "Garde Sarjerao Kondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7056",
    "name": "Gole Popat Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11574",
    "name": "Gonsalves Gabriel Pascol"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9691",
    "name": "Gupta Siyaram Chhotelal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7422",
    "name": "Jagdale Hanmant Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4597",
    "name": "Kadam Shalan Tulshidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13642",
    "name": "Kale Pradeep Damodhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12562",
    "name": "Karande Ramchandra Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12142",
    "name": "Khanvilkar Vivek Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12051",
    "name": "Matharao Mukhwinder Sudarshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13229",
    "name": "Mirpagar Lawrence Samuel"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9693",
    "name": "Mohamad Sadiq Gulam Rasool Shaikh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5266",
    "name": "Mulik Vishwas Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7486",
    "name": "Nalge Shalan Balaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16142",
    "name": "Nathavani Leena Govindji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6564",
    "name": "Parashar  Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12669",
    "name": "Pawar Vinod Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9222",
    "name": "Sani Laxman Dayanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7732",
    "name": "Sardar Shivaji Kundlik."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12450",
    "name": "Sarma Rupnanda Keshavraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4864",
    "name": "Sharma Chanda Haresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11414",
    "name": "Shetty R Padma Chandran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9329",
    "name": "Shinde Manohar Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10597",
    "name": "Shinde Shivaji Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11782",
    "name": "Sonawane Anjani Jairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11129",
    "name": "Sonawane Vijaya Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7129",
    "name": "Sonkuwar Pramod B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11607",
    "name": "Talekar Surekha Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9337",
    "name": "Zoting Baban Bhaguji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2123",
    "name": "Dandge Pandurang Zinguji."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6107",
    "name": "Bhosale Trimbak Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5131",
    "name": "Akolkar Vinod Bhalchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1002",
    "name": "Jagdale Nivrutti Shivaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7914",
    "name": "Chavan Ekanath Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8495",
    "name": "Phalke Suresh Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1249",
    "name": "Jadhav Shivaji Dada."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2372",
    "name": "Shinde Narayan Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12246",
    "name": "Bhosale Kisan Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5965",
    "name": "Nhavkar Subhash Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4857",
    "name": "Pathak Rajaram Zamdatt"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8187",
    "name": "Prajapati Srinath M."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1791",
    "name": "Phalke Namdeo Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9631",
    "name": "Shah Madhuben Manbarilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4452",
    "name": "Khote Habib Gulam Malik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "201",
    "name": "Vithal Jaysing Bhosale."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9040",
    "name": "Pawar Gulchhabai Dnanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17056",
    "name": "Bait Rajeshree Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8622",
    "name": "Bhosale Narayan Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8326",
    "name": "Bhosale Vasant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5906",
    "name": "Chormale Sambhaji C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14579",
    "name": "Chougule Uttam Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11446",
    "name": "Dalavi  Laxman/Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9449",
    "name": "Gupta Munshi M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11753",
    "name": "Jagtap Satish Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6882",
    "name": "Kadam Pratap Aanandarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5225",
    "name": "Khatri  Khadaksingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6992",
    "name": "More Alka Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11429",
    "name": "Naik Nagappa Khemu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11426",
    "name": "Patel Ayaz Mohmed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4905",
    "name": "Pawar Janardhan Chandrarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12779",
    "name": "Pawar Vinayak Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9703",
    "name": "Phalke Anandrao Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8588",
    "name": "Rasal Shankar Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9690",
    "name": "Salunkhe Maruti Vyankat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11377",
    "name": "Shetty Surekha Chandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11431",
    "name": "Shinde Mohini Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11852",
    "name": "Shinde Sunita Deoram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8487",
    "name": "Shivhare Ramayan Sharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11394",
    "name": "Siddiqi Kuresh Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11467",
    "name": "Yashwant Shobha Shrimant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2254",
    "name": "Zajurne Patalu Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1193",
    "name": "Zanjurne Ramrao Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8448",
    "name": "Shinde Rajendra Sahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4034",
    "name": "Shinde Sudam Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3844",
    "name": "Mulik Hanmant Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6006",
    "name": "Barge Satish Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7381",
    "name": "Sawant Bharat Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "782",
    "name": "Sule Laxman Sadhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "867",
    "name": "Narendra Vallabhadas Chhatakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "149",
    "name": "Aravinad Vithoba Kadam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5372",
    "name": "Atul Vijay Shah/Bhavna Atul Shah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4009",
    "name": "Chavan Swati Krishna ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12523",
    "name": "Nikam Jagannath Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "148",
    "name": "Bhagwan Pandurang Chalke."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "76",
    "name": "Khandu Raghu Morde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "52",
    "name": "Malati Vinod Ghuge."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "377",
    "name": "Ramdas Manikrao Chandgude."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11622",
    "name": "Thakur Sunil Roopsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4256",
    "name": "Gaikwad Bhaskar Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "187",
    "name": "Vithal Sudam Pawar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1225",
    "name": "Gurav Prakash Krishna."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3677",
    "name": "Bhoite Ashok Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "325",
    "name": "Mohmad Salim Wooden Box"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8226",
    "name": "Paras  Nath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5635",
    "name": "Phalke Maruti Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1554",
    "name": "Ghadge Tatyaba Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7240",
    "name": "Shinde Sunita Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4139",
    "name": "Gotarne Jayawant Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4933",
    "name": "Phalke Baburao Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8479",
    "name": "Barge Bharat Manshing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3705",
    "name": "Pisal Laxmibai Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2540",
    "name": "Kahar Ujjain Ramsabad."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4249",
    "name": "Nikam Mandakini Shrimant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10128",
    "name": "Chavan Prakash Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9716",
    "name": "Gaikawad Krishnarao Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10200",
    "name": "Jadhav Ramdas Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9872",
    "name": "Jagatap Dadasaheb Sayaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9852",
    "name": "Kadam Jiwandas Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4346",
    "name": "Kadam Maruti Yadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9856",
    "name": "Kadam Premnath Madhaorao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18527",
    "name": "Kadam Sunil Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9860",
    "name": "Kadam Sunita Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9818",
    "name": "Kadam Tanaji Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8377",
    "name": "Kambale Eknath Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18725",
    "name": "Lawand Sanjay Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9849",
    "name": "Lokhande Sandeep Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5706",
    "name": "Mane Vasant Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9858",
    "name": "Maskar Shashikant Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5928",
    "name": "Mujawar Shamsuddhin Abdul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10411",
    "name": "Pandhare Samindra Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10916",
    "name": "Phalke Kalwati Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10915",
    "name": "Phalke Sujata Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9824",
    "name": "Pharande Mahadeo Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10292",
    "name": "Sabale Jaysing Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10219",
    "name": "Sakunde Zamal Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9791",
    "name": "Salunkhe Baban Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9868",
    "name": "Sapakal Vinod Babanarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9850",
    "name": "Sonawane Daji Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9875",
    "name": "Wagh Shiwaji Bhikoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8792",
    "name": "Yadav Pramodkumar Shrishivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2530",
    "name": "Sharma Mahavir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8962",
    "name": "Mane Shivaji Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7595",
    "name": "Kawade Vimal Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1351",
    "name": "Gaikwad Ramesh Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7596",
    "name": "Nisaruddin J"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5084",
    "name": "Bhosale Pandurang Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2949",
    "name": "Shinde Khandu Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6364",
    "name": "Momin Salim Sherekhuda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1579",
    "name": "Patil Ramchandra Annappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2532",
    "name": "Jadhav Kamal Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9078",
    "name": "Bhosale Madhukar Vyankat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9086",
    "name": "Khupse Jagannath Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9079",
    "name": "Urankar Mangal Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3753",
    "name": "Nalawade Hanmantrao Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6686",
    "name": "Kadam Suresh Nandkumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9779",
    "name": "Jadhao Sahadeo Pandyrang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2893",
    "name": "Tawade Vishanath Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6075",
    "name": "Phalke Dnandeo Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6413",
    "name": "A  Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9727",
    "name": "Bhargav Pawankumar Navrang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6010",
    "name": "Bhibanke Laxman Genu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17526",
    "name": "Bobale Mangesh Vishram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12906",
    "name": "Chandra Vivek Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12012",
    "name": "Chavan Jayshree Hanamnat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13006",
    "name": "Chikane Sampat Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11781",
    "name": "Dalavi Sunanda Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9704",
    "name": "Devakar Chaturbhaj Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11877",
    "name": "Gajjar Nilesh Kantibhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9886",
    "name": "Habib Mohd Rafiq Sayyad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9235",
    "name": "Jadhav Vishnu Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8107",
    "name": "Jagtap Sandeep Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11297",
    "name": "Jagtap Sangeeta Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12123",
    "name": "Jagushthe Savita Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9651",
    "name": "Jain Nandlal Hiralal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11161",
    "name": "Kadam Ravindra Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11389",
    "name": "Keni Abhimanyu Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11334",
    "name": "Khandare Madhukar Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11388",
    "name": "Mane Devshala U."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4337",
    "name": "More Bhimrao Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5862",
    "name": "Mukharji Ashish Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11290",
    "name": "Murkate Ashok Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9557",
    "name": "Nazir Azmuddin Sheikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5282",
    "name": "Pal Shivkumar Ramkumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11717",
    "name": "Pardeshi Ratansih Vilusih"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11270",
    "name": "Patne Shankar Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11338",
    "name": "Phalke Sangram Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9031",
    "name": "Phalke Shivaji Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8936",
    "name": "Sayyad Hazarat Abhas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11364",
    "name": "Shah Binky Rajiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11358",
    "name": "Sheikh Tariq Azam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11273",
    "name": "Shelke Sharada Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11098",
    "name": "Shirke Nita Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17352",
    "name": "Suryavanshi Prashant Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1475",
    "name": "Moon-Tex"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9781",
    "name": "Tahir Faqir Mohd Badiwala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5652",
    "name": "Vaidya Murlidhar/Shankarlal Sharma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13693",
    "name": "Vaidya Vijay Sukhdev."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9784",
    "name": "Vasale Venkatesh Dharmappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8099",
    "name": "Vichare Santosh Vishupant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2293",
    "name": "Kahar Rohan Radharaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "696",
    "name": "Suryakant  N.Sapate."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4102",
    "name": "Kadam Laxman Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9164",
    "name": "Mojar Suryakant Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1434",
    "name": "Bhandari Chandrkant Jayram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3472",
    "name": "Gulab Sakari Patpedi Ltd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "123",
    "name": "Tulsidas Kundlikrao Bhoite."
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "282",
    "name": "Lopes Bastya Joki"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "903",
    "name": "Pabale Thakuji Laxman."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12156",
    "name": "Chavan Gulabrao Balawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7664",
    "name": "Surve Pratibha Balkrishna/Balkrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15868",
    "name": "Mankar Rajjak Hamid"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9233",
    "name": "Pisal Parwati Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "159",
    "name": "Aphale Sureshkumar Chimaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4417",
    "name": "Chavan Vijaykumar Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6447",
    "name": "Bhosale Gulabrao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11199",
    "name": "Chouhan Babulal Shrisitai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7637",
    "name": "Das Arbind Ashitranjan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11068",
    "name": "Desai Shalakha S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11553",
    "name": "Devraj  James"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8318",
    "name": "Dhavale Navnath Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11090",
    "name": "Dhumal Sunilkumar Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11889",
    "name": "Gawai Madhukar Shahdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7495",
    "name": "Ghag Sumati Dhondu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10567",
    "name": "Herekar Savita Pradeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11181",
    "name": "Jadhav Hanumant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13681",
    "name": "Jadhav Ramesh Dhiraj."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8945",
    "name": "Jagtap Kondiram Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3524",
    "name": "Judge Kishore Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1191",
    "name": "Kalap Ravi Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11430",
    "name": "Kaskar Sakur Savfrancies Koli"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9220",
    "name": "Momin Abubkar Mahammadnisar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8928",
    "name": "Ovhal Sunita Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9794",
    "name": "Pawar Vijaya Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6305",
    "name": "Pendnekar Jaywant Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12039",
    "name": "Phalke Pradeep Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4411",
    "name": "Phalke Shamrao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11083",
    "name": "Pokharkar Surekha Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8274",
    "name": "Roy  Yogeshkumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4630",
    "name": "Salunkhe Dinkar Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11095",
    "name": "Sawardekar Ramesh Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4659",
    "name": "Shah Joshna Jagdish/Mr.Jagdish C.Shah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11214",
    "name": "Sharma Amitkumar Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10494",
    "name": "Shedge Nandkumar Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11004",
    "name": "Shetty Uttama Thangrel."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10956",
    "name": "Shinde Ashatai Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11041",
    "name": "Sikariya Sureshkumar Satyanarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8406",
    "name": "Sule Chandrakant Ramakant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11462",
    "name": "Thorat Avinash Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17754",
    "name": "Tiwari Sadhana Satish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17009",
    "name": "Sheikh  Najma Abdulla"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6333",
    "name": "Bhosale Dattatray Bhimrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4385",
    "name": "Vichare Malan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5205",
    "name": "Agwan Abdul Rajak Isqqbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "922",
    "name": "Nagavankar Krishna Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2554",
    "name": "Patil Bhalchandra Appa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8052",
    "name": "Suryavanshi Shivaji Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "597",
    "name": "Devidas  S.Kawade"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2037",
    "name": "Phalke Vithal Jijaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11804",
    "name": "Rane Vasidev Bjolako"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2799",
    "name": "Pansare Shilpa S ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "102",
    "name": "Shinde Kushalaya Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1450",
    "name": "Bhat Sushiladevi Premlal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1528",
    "name": "Mande Housabai Popat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10403",
    "name": "Dhumal Vikas Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4560",
    "name": "Zanzurne Suresh Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6905",
    "name": "Chougule Avinash Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3627",
    "name": "Bijagare Pandari Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "291",
    "name": "Sankpal Shantabai Ganapat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13372",
    "name": "Bihari Singh Ajit Awadh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12007",
    "name": "Bist Danbahadur Ganeshbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10773",
    "name": "Dalvi Anil Madukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10393",
    "name": "Deshmukh Sushma Kiran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11727",
    "name": "Desuri Subhash Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12631",
    "name": "Devlekar Vidhya Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6174",
    "name": "Farooqui  Fahim"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7983",
    "name": "Ghadge Rajendra Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6372",
    "name": "Golatkar Shashikant Pundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7479",
    "name": "Gomes  Edward"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9482",
    "name": "Iyer  Satyan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9439",
    "name": "Kadam Arun Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11572",
    "name": "Kenjale Balawant Piloba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7127",
    "name": "Lambhe Chandamani Vitthalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11417",
    "name": "Mahadik Dattatray Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11480",
    "name": "Mandave Subhash Bhagawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5861",
    "name": "Mhaske Madhukar Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10959",
    "name": "Mishra Munna Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10895",
    "name": "Mohite Subhash Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10802",
    "name": "More Harishchandra Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6173",
    "name": "Naik Rajiwan K."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7185",
    "name": "Palkar Shyam Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11612",
    "name": "Patkar Sudhir Nandkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10973",
    "name": "Phand Yashwant Rabhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9988",
    "name": "Pisal Laxmibai Vyankat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15884",
    "name": "Poojari Ravi Booba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10384",
    "name": "Pramila Bharat Pawar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10064",
    "name": "Qureshi Yasmin Sayeed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13129",
    "name": "Shinde Vaishali Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6604",
    "name": "Singh Gangaram Ramnandan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11429",
    "name": "Tankasale Rajendra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11918",
    "name": "Thorve Vishnu Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6523",
    "name": "Yadav Harichandra Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7538",
    "name": "More Machndar Mugutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5490",
    "name": "Phadtare Ashok Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3155",
    "name": "Phalake Bajarang Aaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "56",
    "name": "Shashikant Shivram Ugale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3411",
    "name": "Bhosale Mohan Sudamrao."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7442",
    "name": "Kadam Hanmant Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7938",
    "name": "Chavan Ramchandra Bandoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7591",
    "name": "Salunkhe Balaso Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7631",
    "name": "Kumbhar Sitabai Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9390",
    "name": "Sukre Shantaram Dnyanoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9783",
    "name": "Suratwala Shabbir Yusufali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1139",
    "name": "Jawa Girdhar Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2176",
    "name": "Nigarel Philip Eganes"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7494",
    "name": "Phalke Ravindra Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7098",
    "name": "Walunj Shankar Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14250",
    "name": "Panchal Sujata Sadashiv."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1209",
    "name": "Gawad Kishor Suresh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8921",
    "name": "Gangawane Dada Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2400",
    "name": "Sapkal Shiva Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2005",
    "name": "Chavan Nanda Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12492",
    "name": "Gaikwad Suresh Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9194",
    "name": "Jadhav Prakash Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7311",
    "name": "Jagdale Jotiram Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15693",
    "name": "Mahadik Chandrakant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "859",
    "name": "Mestry Dayal Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10259",
    "name": "Mistry Jayprakash Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9548",
    "name": "Salunkhe Ashok Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9152",
    "name": "Shinde Anandrao Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6154",
    "name": "Shitole Nitin Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17715",
    "name": "Tiwari Nandlal Fulchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15320",
    "name": "Yelamkar Smrutee Yashodatta"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7301",
    "name": "Phalke Ananda Bali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3015",
    "name": "Ghadage Ramchandra Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7365",
    "name": "Jadhav Pandurang Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8618",
    "name": "Jadhav Janardan Yadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7725",
    "name": "Kadam Ravindra Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7661",
    "name": "Shinde Vishnu Mugutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9030",
    "name": "Bhandari Rajan Kasturichand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7941",
    "name": "Vyadande Sampat Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3288",
    "name": "Thapa Khadakbahadur Danbahadur."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8999",
    "name": "Mulik Vilas Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "183",
    "name": "Nalvade Jyoti Ratu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "181",
    "name": "Jadhav Subhedar Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "263",
    "name": "Jadhav Tatya Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1209",
    "name": "Durgule Sahebrao Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "540",
    "name": "Darekar Vasant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11204",
    "name": "Anapat Ravindra Anadrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9914",
    "name": "Bhanage Dyandeo Ranchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10883",
    "name": "Chavan Prakash Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10807",
    "name": "Chavan Seetabai Bhikoba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "928",
    "name": "Chavan Shahu Rangnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10789",
    "name": "Dedhia Bharati Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9574",
    "name": "Gadhave Dattaray Eknath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1355",
    "name": "Girase Ranjitsing Hilalsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10825",
    "name": "Gois  Marcelino."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15540",
    "name": "Jadhav Prakash Sayaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16758",
    "name": "Kamble Ravindra Dagdu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21624",
    "name": "Kashyap Baleshwar Puran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8615",
    "name": "Katkar Rajani Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8728",
    "name": "Maheshwari  Laxminarayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5895",
    "name": "Matkar Mahadeo Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10900",
    "name": "Mohmad Yasin Mohd Ali Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12962",
    "name": "Monika Lambodar Prasad Maithani"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9359",
    "name": "Mulani Mubarak Kasim"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4613",
    "name": "Mulik Gulabrao Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10115",
    "name": "Natu Parvati Sunil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9451",
    "name": "Nikam Madan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10921",
    "name": "Pal Mulchand Haridwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6601",
    "name": "Patadia Heena Anilkumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "552",
    "name": "Patil Vikas Balaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7839",
    "name": "Pattanaik  Satyanarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11713",
    "name": "Pawar Laxman Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9869",
    "name": "Phalake Sambhaji Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10381",
    "name": "Sabale Sadashiv Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6178",
    "name": "Salunkhe Kumudini Shrikrushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7755",
    "name": "Senthilvel  S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11489",
    "name": "Shelke Rajendra Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10807",
    "name": "Solanki Chandu Bhikha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21637",
    "name": "Solanki Dharamraj Bhuraji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "780",
    "name": "Sonawane Kamlakar Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16018",
    "name": "Sutar Maruti Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11075",
    "name": "Wagh Mahadev Bhikoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10839",
    "name": "Yadav Ramjeet Munnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10918",
    "name": "Yadav Sumeradevi Ramraj."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5829",
    "name": "Sapkal Yeshwant Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4519",
    "name": "Sing H. Jitendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2044",
    "name": "Kutty M Krishnan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "788",
    "name": "Prabhakar Purshottam Parakar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2024",
    "name": "Masugade Bhiwa Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7841",
    "name": "Somvanshi Indubai Dattatrya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2192",
    "name": "Sabale Janrdhan Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "843",
    "name": "Barge Vasant Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7465",
    "name": "Chavan Kisan Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4196",
    "name": "Shinde Chandrakant T"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10395",
    "name": "Surve Shridhar Sarkiran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "635",
    "name": "Hemant Digambar Karalkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8654",
    "name": "Kumbhar Anil Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2046",
    "name": "Patil Gajanan Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "814",
    "name": "Phalke Yashwant Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8719",
    "name": "Pawar Kalawati Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "339",
    "name": "Chavan Bhagoji Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1820",
    "name": "Gaikwad Shilpa Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12137",
    "name": "Ayare Chandrakant Dattaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10648",
    "name": "Bhor Bapu Sahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7766",
    "name": "Chavan Mina Karmvir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7663",
    "name": "Chiplunkar Pandurang Tulaji."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9255",
    "name": "Durgule Prakash Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10528",
    "name": "Gujar Prafull Chintaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10212",
    "name": "Kamble Hari Satyappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9915",
    "name": "Kamble Rajendra Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11950",
    "name": "Kambli Arvind Gopinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10713",
    "name": "Khot Anita Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10857",
    "name": "Mahakal Swati Jayant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21470",
    "name": "Mishra Pankaj R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10693",
    "name": "Mistry Swati Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20650",
    "name": "More Santosh Appasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6022",
    "name": "Naik Jagdish Ganapat/Ravindra/Jaishing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10678",
    "name": "Paik Bistukumar Sura"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11427",
    "name": "Pisal Dattatray Sakharam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "991",
    "name": "Rai Vinod Abhimannu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10994",
    "name": "Sabale Indira Kundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8781",
    "name": "Salmani Mozma Khatun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10736",
    "name": "Salunkhe Chimaji Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9806",
    "name": "Saroj Rajman Bechan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13138",
    "name": "Sawant Jayant Shamrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15683",
    "name": "Vinod Chand Narepalepu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10399",
    "name": "Wagh Vasudeo Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5026",
    "name": "Rajbhar Hosalaprasad Paras"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1559",
    "name": "Sawant Narayan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "467",
    "name": "Shankar Malappa Teli."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2349",
    "name": "Shingate Balu Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2983",
    "name": "Mulik Baliram Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3209",
    "name": "Kadam Dattatray Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "147",
    "name": "Phalke Eknath Jijaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "451",
    "name": "Ramayan Jagbandhan Yadav."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11555",
    "name": "Bhosale Gorakh Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8328",
    "name": "Mahadik Dada Rramu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21758",
    "name": "Mane Rajesh Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11178",
    "name": "Sakpal Sudam Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13878",
    "name": "Sharma Ambika Surendra."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9309",
    "name": "Shete Suryakant Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15789",
    "name": "Yadav Mangal Shrikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7050",
    "name": "Shikare Parwati Balsaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5269",
    "name": "Chavan Suman Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4931",
    "name": "Aawade Dinkar Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9147",
    "name": "Shelar Dilip Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3811",
    "name": "Nikam Yashawant Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8714",
    "name": "Jagtap Abaji Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12182",
    "name": "Jadhav Sarjerao Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15643",
    "name": "Kadam Pravatibai Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3517",
    "name": "Shirtude Balawant Gundaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1299",
    "name": "Chatur Khashaba Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7816",
    "name": "Gole Tanaji Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "726",
    "name": "Lembhe Narsing Daji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5308",
    "name": "Aghav Shesharao Trambak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10324",
    "name": "Ayre Pravin Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10445",
    "name": "Dhamapurkar Ramesh Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7893",
    "name": "Dhumal Rajendra Hanumant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16026",
    "name": "Dhwale  Sachin Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10392",
    "name": "Gond Manojkumar Sangram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11040",
    "name": "Jaisingh Dimpal Manoharlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10432",
    "name": "Jaiswar Ramesh Ramcharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8105",
    "name": "Kankate Chandrakant Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12996",
    "name": "Lokhnde Latika Sadhashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7839",
    "name": "Matkar Dattatray Sahebarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9384",
    "name": "Maurya Suryaprakash Shyamavali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10433",
    "name": "Memon Salim Sattar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10419",
    "name": "Nalawade Balu Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5463",
    "name": "Rakshankar Raju Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9563",
    "name": "Ranpise Bhagaji Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7376",
    "name": "Rao Ramdeo Bhagirathi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4055",
    "name": "Raut Taramati Harichandra."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11142",
    "name": "Sapkal Ramdas Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8446",
    "name": "Shah Bharatkumar Chhotalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17164",
    "name": "Shahi Meen Bahadur."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10127",
    "name": "Shinde Shankar Paramanad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11994",
    "name": "Vandra Kundan Narendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7734",
    "name": "Waghmalw Sitaram Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5026",
    "name": "Shete Nana Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5222",
    "name": "Yadav Solaskar Hanamant Jagderao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4585",
    "name": "Naik Ankita Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4595",
    "name": "Chavan Rajaram Bali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "150",
    "name": "Ganpat Bayaji Bhosale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1174",
    "name": "Chouhan Kamtaprasad Singh."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9033",
    "name": "Jagtap Sumitra Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3886",
    "name": "Bhatt Lata Pramod."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3592",
    "name": "Bhandari Yesu Narayan."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2857",
    "name": "Dhane Dnaneshwar Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1611",
    "name": "Shaikh  Kamran."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6813",
    "name": "Chavan Kalpana Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2594",
    "name": "Jadhav Mahadeo Genu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2797",
    "name": "Bhongale Arun Shantaram ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2266",
    "name": "Rewale Govind Surya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12879",
    "name": "Ansari Nisar Ahamad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2319",
    "name": "Sabale Nivarutti Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6819",
    "name": "Bapat Atul Shriram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5115",
    "name": "Shinde Jaysing Piraji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13173",
    "name": "Pawar Vijay Trimbak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11181",
    "name": "Bobade Babanrao Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10080",
    "name": "Dhumal Satvashila Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9885",
    "name": "Gupta Ramjag Bholanath Gupta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15478",
    "name": "Gurav Madhavi Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12757",
    "name": "Jagtap Vithal Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9376",
    "name": "Nelson  Tidu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12271",
    "name": "Pawar Mugutrao Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13242",
    "name": "Phalke Balshiram Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9338",
    "name": "Phalke Santosh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17313",
    "name": "Raut Prashant Praful"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9552",
    "name": "Satam Ravindra Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17094",
    "name": "Shinde Chandrakant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15827",
    "name": "Tadke Asha Popatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3815",
    "name": "Tripathi Krishnachandra Dyandas."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6726",
    "name": "Chavan Shivaji Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5151",
    "name": "Wagh Madhav Bhaurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "191",
    "name": "Chavan Bapurao Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8779",
    "name": "Nawadkar Chandrakant Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4954",
    "name": "Ghanekar Mohan Madhav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1202",
    "name": "Raje Chandrabhaga Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8885",
    "name": "Yewale Sunil Gulbrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9346",
    "name": "Pawar Santosh Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2059",
    "name": "Singh  Tarandas Pritamdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2166",
    "name": "Bhosale Ganapat Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8781",
    "name": "Nikam Kalpana Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9345",
    "name": "Disle Tarabai Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11083",
    "name": "Nashikar Rukhsana Rajesaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6035",
    "name": "Phalke Tarabai Dattatrya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6341",
    "name": "Dayal Girish Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3644",
    "name": "Sul Jamadar Babaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5400",
    "name": "Acharya  Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10274",
    "name": "Chavan Smita Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10275",
    "name": "Chavan Subhash Bhkoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4382",
    "name": "Dahije Sitaram Dharma."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13179",
    "name": "Gandhi  Prabjhot"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6193",
    "name": "Hawale Dilip Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9275",
    "name": "Kambale Vasant Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11832",
    "name": "Katke  Nanda Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10284",
    "name": "Khire Balkrishna Govindrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12370",
    "name": "Lokhande Tanaji Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12688",
    "name": "Madane Hanmant Akaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10170",
    "name": "Mahurkar Sumalatha Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7494",
    "name": "Mathais  Dora"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6341",
    "name": "Narvekar Kishor Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9987",
    "name": "Pisal Savitra Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6002",
    "name": "Rajeshirke Ramdas Bhausaheb/Rekha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10345",
    "name": "Rawal Anjana Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9244",
    "name": "Sakunde Namdeo Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2805",
    "name": "Sakunde Pandurang Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10346",
    "name": "Sangale Lata Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14134",
    "name": "Shetty Ravi Subbyan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6798",
    "name": "Shinde Bharati Ram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11342",
    "name": "Shinde Lata Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12376",
    "name": "Shinde Yashwant Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9133",
    "name": "Thangam  A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10192",
    "name": "Thorade Suresh Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8378",
    "name": "Tupe Subhash Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6187",
    "name": "Khopade Vikas Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9300",
    "name": "Bhosale Jagu Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8650",
    "name": "Disale Rangnath Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2339",
    "name": "Palsakar Laxman Kondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3544",
    "name": "Shirke Rajendra Chandrakant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3662",
    "name": "Varte Mohan Gopal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "211",
    "name": "Mansing Dada Jadhav."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2494",
    "name": "Mhamane Prabhakar Rangu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6630",
    "name": "Shinde Baban Kalu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1522",
    "name": "Ghadage Dattu Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20386",
    "name": "Dhumal Sachin Shankarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6072",
    "name": "Shaikh Mohamd Hashakmajd"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10041",
    "name": "Dhumal Tukaram Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7583",
    "name": "Jadhav Sahebrao Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5796",
    "name": "Pawar Nivruti Patalu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8853",
    "name": "Bhosale Sandeep Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10009",
    "name": "Nalge Nakusa Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11608",
    "name": "Acharya Mohini Anan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11485",
    "name": "Bari  Rajuprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19057",
    "name": "Chavan Ankush Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9251",
    "name": "Chavan Motiram Mansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18515",
    "name": "Chavan Shamika Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12414",
    "name": "Dhami Jagatbahadur Lalsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17667",
    "name": "Dileep Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17066",
    "name": "Doke  Eknath Dashrath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11470",
    "name": "Gaikawad Dattatray Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9790",
    "name": "Jariwala Sanjay Kumar Radheshyam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10830",
    "name": "Kalal Rajjak Chandulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10068",
    "name": "Kunder David Ranold"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16698",
    "name": "Kuvalekar Sushma Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13343",
    "name": "Lembhe Ramdas Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10053",
    "name": "Mohite Dashrath Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10102",
    "name": "More Rambhau Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16596",
    "name": "Nadar Shekhar Chabastia"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10038",
    "name": "Nalla Chandrayya Anka"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2895",
    "name": "Parab Vishwanath Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10048",
    "name": "Prajapati Navin Mansukhbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12557",
    "name": "Priyadarshi Heena Neeraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10072",
    "name": "Shetty Vijaylaxmi Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5439",
    "name": "Shigwan Surekha Gunaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10001",
    "name": "Sonar Amrut Somnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14760",
    "name": "Sorap Rajesh Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10405",
    "name": "Talekar Mangesh Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2550",
    "name": "Mox Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8430",
    "name": "Tilak Sukumar Nandy/Bhavana."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12500",
    "name": "Wagh Chandrakant Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10060",
    "name": "Yadav Kamata Prasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8239",
    "name": "Sabale Rajaram Ravba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "897",
    "name": "Kisan  Rangarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3008",
    "name": "Mokashi Shankar Bhiwa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3378",
    "name": "Shakh Sadik Rajjak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11149",
    "name": "Jadhav Mangal Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12134",
    "name": "Bhosale Arjun Hariba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3071",
    "name": "Shinde Pushapalata Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2362",
    "name": "Patil Suresh Baburao."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7614",
    "name": "Sabale Parabati Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1865",
    "name": "Shinde Rama Dhondi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "133",
    "name": "Ghadage Natha Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2720",
    "name": "Kazi Kisara Siraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9125",
    "name": "Sawant Sudhir Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10273",
    "name": "Shinde Chappanrao Yadavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3772",
    "name": "Sonule Vitthal Piraji."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3926",
    "name": "Shinde Rakhamaji Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6277",
    "name": "Sooz  Manubhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6458",
    "name": "Pawar Balaso Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17786",
    "name": "Bagal Vynkatesh Uttam."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10878",
    "name": "Bhosale Balwant Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12988",
    "name": "Disale Pralad Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11086",
    "name": "Gade Jaywant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5633",
    "name": "Jadhav Jaising Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13559",
    "name": "Kanodiya Sharada Kashiprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10833",
    "name": "Nikam Prabhawati Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "727",
    "name": "Salunkhe Mohan Sarjerao."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7427",
    "name": "Bhoite Narshing Krushnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3100",
    "name": "Mukesh Fabrics"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9062",
    "name": "Jadhav Sharad Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6936",
    "name": "Sawant Dattatray Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2731",
    "name": "Jadhav Vishnu Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3385",
    "name": "Badekar Balu Manku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5634",
    "name": "Phalke Ramchandra Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8314",
    "name": "Sutar Abdulkarim Ajij"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9084",
    "name": "Nikam Lalaso Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7029",
    "name": "Ghadge Janrdan Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7233",
    "name": "Jadhav Mangal Ankush"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6242",
    "name": "Pawar Maruti Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22899",
    "name": "Matharu Inderjeet Singh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6957",
    "name": "Shekh Shakil Yasin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6023",
    "name": "More Rajashree Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7648",
    "name": "Pawar Sudam Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19446",
    "name": "Pisal Sahebrao Jaysingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16233",
    "name": "Shaikh Rashid Abdul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15779",
    "name": "Sonawale Manda Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4996",
    "name": "Zanjurne Pralhad Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8175",
    "name": "Bhosale Bhikabai Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1688",
    "name": "Shinde Yeshwant Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4170",
    "name": "Shedge Gangubai Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2764",
    "name": "Kadam Namdeo Jagu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6442",
    "name": "Jadhav Uttmrao Babaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4606",
    "name": "Pisal Nanda Balaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1711",
    "name": "Gaikwad Babaso Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1917",
    "name": "Bhosale Amol Ashok"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1168",
    "name": "Chavan Ajay Janardhan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1916",
    "name": "Chavan Sameer Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20976",
    "name": "Dhaske Sindhu Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21234",
    "name": "Kashid Arun Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "505",
    "name": "Nanavare Rajendra Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8737",
    "name": "Nikam Shankar Rama"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18777",
    "name": "Patel Ishak Mahamdasha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18795",
    "name": "Pawar Haribhau Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10011",
    "name": "Pisal Baban Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2986",
    "name": "Salunkhe Ghanshyam Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4143",
    "name": "Gaikawad Gunwant Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8274",
    "name": "Sankpal Balkrushna Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8984",
    "name": "Sarkade Prakash Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9127",
    "name": "Pawar Shivaji Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1847",
    "name": "Shinde Shalan Dinkara"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3215",
    "name": "Snna  Ullah"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8628",
    "name": "Bhosale Gautam Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3392",
    "name": "Jadhao Vithabai Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8252",
    "name": "Nawadkar Balwant Dasharath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8727",
    "name": "Sawant Deepa Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14933",
    "name": "Bhandari Malti Ramhari."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12258",
    "name": "Bhope Bharati Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11754",
    "name": "Bhosale Pradip Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7816",
    "name": "Chavan Mansing Nivrut"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9950",
    "name": "Chavan Sanjay Madhaorao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16850",
    "name": "Gawde Pradnya Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20678",
    "name": "Ghag Joyesh A."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11561",
    "name": "Jadhao Sanjay Sudhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9822",
    "name": "Jamble Sudhir Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8149",
    "name": "Lad Namita Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20662",
    "name": "Lotekar Sandeep Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8189",
    "name": "Mane Prakash Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17023",
    "name": "More Sopan Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7569",
    "name": "Sawant Laxman Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9923",
    "name": "Singh Ravindrakumar Jait"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2909",
    "name": "Pawar Jaywant Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2190",
    "name": "More Anusaya Mahadeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "270",
    "name": "Chalke Vimal Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2609",
    "name": "Uttam  K.J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6108",
    "name": "Parab Sandesh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1754",
    "name": "Singh  Brijesh."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4366",
    "name": "Dhaygude Minal Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "755",
    "name": "Yadav Motilal Dasae"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3176",
    "name": "Kadam Bharat Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2717",
    "name": "Mohhmad  Safikal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4028",
    "name": "Bhagwandas  D.R."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4262",
    "name": "Gole Laxman Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7680",
    "name": "Bhosale Yashwant Jagnnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "823",
    "name": "Raghu Babu Pujari."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "3",
    "name": "Sawant Dattatrya Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6623",
    "name": "Bhosale Nandkumar Sambhajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6621",
    "name": "Phadatare Narayanrao Anadarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6620",
    "name": "Shendge Shivaji Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8908",
    "name": "Bhosale Vinayak Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3090",
    "name": "Vagh Mohan Bhiku"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1257",
    "name": "Jadhav Somnath Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12071",
    "name": "Kadam Sanjay Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23617",
    "name": "Shinde Sandipan Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10294",
    "name": "Tawade Vaishali Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9921",
    "name": "Yadav Sachin Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2842",
    "name": "More Sunita Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7828",
    "name": "Dhavalikar Savita Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9130",
    "name": "Kshirsagar Tatoba Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9759",
    "name": "Lingayat Datt Gyanuji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5593",
    "name": "Jadhav Pramila Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6994",
    "name": "Sakunde Shankar Vishavanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5873",
    "name": "Bhagawat Namdeo Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2151",
    "name": "Kambale Namdeo Ramaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7609",
    "name": "Madane Sambhaji Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2942",
    "name": "Dapatre Shankar Dattatray."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7026",
    "name": "Ambre Sugndha Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11356",
    "name": "Anpat Rajendra Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16047",
    "name": "Chavan Dilip Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22704",
    "name": "Chavan Ranjana Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9598",
    "name": "Deshmukh Prabhakar Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22551",
    "name": "Dhotre Raviraj Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11960",
    "name": "Dhumal Shashikant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22889",
    "name": "Gangawane Prakash Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18012",
    "name": "Gudekar Shivaji Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12782",
    "name": "Jagtap Mukund Vijaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13734",
    "name": "Kusum"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23090",
    "name": "Lad Mohan Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9075",
    "name": "Mane Asha Popat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11096",
    "name": "Mastre Laxmibai Dhansingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22605",
    "name": "Meher Hitesh Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9555",
    "name": "Nikam Bhanudas Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10386",
    "name": "Nikam Hanmant Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7623",
    "name": "Pathe Sopanrao Ramrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11982",
    "name": "Pawar Jayvant Benjamin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22606",
    "name": "Pethe Nilesh Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9971",
    "name": "Pote Harshad Nagesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5335",
    "name": "Rajendran  Lakshmohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9626",
    "name": "Sarvankar Rashmi Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6097",
    "name": "Sawant Suman Suryakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "859",
    "name": "Sayyad Shanizeh Bano Tanvir Ahamad"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2056",
    "name": "Mumbai Glass Centre"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12418",
    "name": "Singh Saileshkumar Singh Kuldip Pal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22615",
    "name": "Surve Satish Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2266",
    "name": "Shinde Shivaji Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8658",
    "name": "Phalke Dnyandeo Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1436",
    "name": "Nawadkar Gokulabai Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1911",
    "name": "Kadam Balwant Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2835",
    "name": "Roman Pandurang Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4124",
    "name": "Padwal Suresh K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1555",
    "name": "Pawar Dattatray Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2117",
    "name": "Dubal Maruti Tatu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "178",
    "name": "Shushila Chandrakant Nikam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4236",
    "name": "Abdulla V K"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2112",
    "name": "Phalke Dinkar Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3975",
    "name": "Javeri Anwar Ebrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4497",
    "name": "Prajapati C. M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6572",
    "name": "Mehboobani Manisha Ishwardas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5106",
    "name": "Kolate Savita Suryakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16253",
    "name": "Babar Ashwani Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15984",
    "name": "Bhekare Reshma Sitaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "845",
    "name": "Bhilare Bharat Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10331",
    "name": "Chavan Bhikoba Kondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15855",
    "name": "Dapal Waman Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7783",
    "name": "Kadam Kantinath Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13767",
    "name": "Kadam Maruti Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22467",
    "name": "Kapadiya Sharyu Jay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14078",
    "name": "Korade Arjun Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19797",
    "name": "Mewada Giridhar Mitha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9887",
    "name": "Pawar Arjun Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9982",
    "name": "Prajapati Pramodkumar Harideo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22079",
    "name": "Shinde Vijaysing Anadrao"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "64",
    "name": "Ansari Allauddin Abdulrazzak"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "169",
    "name": "Jadhav Pushpalata Ramesh"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "121",
    "name": "Pawar Ganesh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1721",
    "name": "Yadav Rajkaran Hublal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5271",
    "name": "Sabale Ramdas Bali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7408",
    "name": "Sawant Ramchandra Akoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9214",
    "name": "Kete Bhimashankar Sidappa"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1033",
    "name": "Musale Enterprise"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7128",
    "name": "Mulani Badshah Lal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6853",
    "name": "Jadhao Shamrao Dyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7182",
    "name": "Nalge Pandurang Baba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6640",
    "name": "Gurao Shivaji Raghu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8313",
    "name": "Kadam Shivaji Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17543",
    "name": "Chavan Arjun Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9221",
    "name": "Gaikawad Rangrao Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9141",
    "name": "Gadhve Dilip Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "491",
    "name": "Phalke Hanmant Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6337",
    "name": "Amin Daba Sidhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6089",
    "name": "Baroth Kanchand Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9459",
    "name": "Desai Vinod Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5135",
    "name": "Hemadas A G"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3842",
    "name": "Jadhav Suman Nathuramm"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12737",
    "name": "Jagtap Shridhar Balaso"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1446",
    "name": "Khanolkar Mahadev Savalaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5737",
    "name": "Khatri Jay Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "819",
    "name": "Muttaya Construction"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19340",
    "name": "Mestry Sangeeta Mangesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7300",
    "name": "Moriya Vijaykumar Nikhidi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1516",
    "name": "My Dear Silk Mills"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2644",
    "name": "My India Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6849",
    "name": "Parmar Parul Dansukhlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2396",
    "name": "N.B.Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8276",
    "name": "Pathak Milind Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14605",
    "name": "Phutane Hemlata Rajesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9355",
    "name": "Satpute Vijay Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10228",
    "name": "Shetty Manisha Shamkant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14022",
    "name": "Shetty Sujata Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5386",
    "name": "Shinde Jitendra Devram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9316",
    "name": "Sonawane Dilip Madhav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10921",
    "name": "Sutar Shankar Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10637",
    "name": "Vanjare Vilas Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10407",
    "name": "Vankar Anita Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9239",
    "name": "Wayal Pratap Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8448",
    "name": "Zatye Pramod Yashawant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8846",
    "name": "Vedpathak Dipti Vishwnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3785",
    "name": "Chormale Uttam Chandar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18224",
    "name": "Wagh Pradeep Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2284",
    "name": "Kadam Suresh Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1998",
    "name": "Pujari Anni Venkaypa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4423",
    "name": "Esmaile Dinkar Naki"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4774",
    "name": "Kadam Shrimant Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7246",
    "name": "Kadam Bhanudas Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16858",
    "name": "Pawar Ragunath Maruti ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "405",
    "name": "Bhagwan Bhikaji Jadhav."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2593",
    "name": "Pawar Hirabai Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3829",
    "name": "Jaiswal Rajkumar Bajranglal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2444",
    "name": "Bhoite Lalsaheb Govindrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "448",
    "name": "Ramesh Shravan Patil."
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1187",
    "name": "Ahir Rajaram Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8065",
    "name": "Autugade Shivaji Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11488",
    "name": "Bagul Alka Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17651",
    "name": "Barge Shobha Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18387",
    "name": "Chavan Vinod Baburao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1369",
    "name": "Dange Pramod Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18045",
    "name": "Dhumal Satish Shankarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21939",
    "name": "Dubal Prakash Parsharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9254",
    "name": "Jadhav Gandharva Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8308",
    "name": "Jadhav Jyoti Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8054",
    "name": "Javale Suresh Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6717",
    "name": "Kalambe Krishna Daulati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9223",
    "name": "Kale Ananda Tatoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9667",
    "name": "Khan Nazim Jaman"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1219",
    "name": "Khan Salman Sikandar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1220",
    "name": "Malwade Anil Narendra"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1227",
    "name": "Mhatre Tukaram Kundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9217",
    "name": "Mistry Pratibha Y/Shubhangi S Chavan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12581",
    "name": "Naik Nitin Jayram / Savita Nitin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9194",
    "name": "Nawariya  Ramesh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1237",
    "name": "Pathak Deepa Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14690",
    "name": "Patil Maruti Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13033",
    "name": "Patil Sampat Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14914",
    "name": "Patkar Rohini Ragho."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9684",
    "name": "Pisal Jaysing Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13763",
    "name": "Raje Radhika Shaym"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5640",
    "name": "Ravat Lila Tapulla"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1215",
    "name": "Sakpal Yuvraj Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10453",
    "name": "Salunkhe Dilip Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8706",
    "name": "Shiwalkar Vinod Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9496",
    "name": "Singh Arun Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6634",
    "name": "Snehlata Shekhar/Shekhar Mishra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9851",
    "name": "Tanksal Navanath Bala"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1392",
    "name": "Upadhyay Santosh Kumar Prabhunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7937",
    "name": "Varma Shavankumar Puran Mal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1350",
    "name": "Waghoskar Naresh Rama"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1164",
    "name": "Yadav Sunita Roopchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8161",
    "name": "Barge Asha Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8372",
    "name": "Bhagwat Parvati Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2380",
    "name": "Bhosale Hanmant Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10082",
    "name": "Kadam Deepak Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3843",
    "name": "Jadhav Shakuntala Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6660",
    "name": "Chavan Malan Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6892",
    "name": "Choudhary Pandurang Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11363",
    "name": "Parulkar Sanjana Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16840",
    "name": "Navrat Mangesh Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13970",
    "name": "Bhosale Jagdish Dattatry"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14644",
    "name": "Dhavale Shivaji Malhari."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10975",
    "name": "Godse Santosh Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11954",
    "name": "Jagtap Chitrabai Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13746",
    "name": "Jaiswal Shantidevi Jawaharlal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1420",
    "name": "Kadam Amol Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11105",
    "name": "Kadam Suhasini Suryakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22372",
    "name": "Parmar Rohit Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13805",
    "name": "Patel Manish Maganlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22174",
    "name": "Pawar Sunita Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19889",
    "name": "Pisal Pruthviraj Balasaheb"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "696",
    "name": "Ruddewadi Sujata Chandrakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "769",
    "name": "Shirudkar Rohini Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6418",
    "name": "Surve Gajanan Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15753",
    "name": "Tambe Hemali Sangam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9895",
    "name": "Tiwari Ramdas Parasnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10890",
    "name": "Yaduvansi Ram Naval Vasudeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4428",
    "name": "Chatur Anusaya Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3421",
    "name": "Shetty Dayanand Venkappa."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21744",
    "name": "Bhosale Amol Gopichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22344",
    "name": "Chanderamani Kamana Girish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22411",
    "name": "Gaikwad Maruti Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19735",
    "name": "Maske Rita Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4539",
    "name": "Disale Ramchandra Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1416",
    "name": "Mane Popat Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15489",
    "name": "Chhetri Sarjansing Motising"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "658",
    "name": "Deshmukh Namdeo Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4759",
    "name": "Gavkar Devendra Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22338",
    "name": "Kadam Dasharath Dadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12428",
    "name": "Kamble Sarjabai Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11500",
    "name": "Mahadik Gajanan Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19663",
    "name": "Makawana Sava Vala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9014",
    "name": "Parab Manisha Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11379",
    "name": "Patekar Ajay Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12265",
    "name": "Phalke Namrata Babuirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13491",
    "name": "Rao Y Seshu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9192",
    "name": "Sarang Suryakant Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9494",
    "name": "Shaikh Mohmad Husen Kasam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9009",
    "name": "Singh Manikaprasad Vijaybahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11513",
    "name": "Tawade Prakash Shripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9022",
    "name": "U Ravi Raj"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "689",
    "name": "Waghmode Sampat Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10814",
    "name": "Yadav Housilaprasad Ramdhani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3573",
    "name": "Mhatre  Prakash."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3852",
    "name": "Sayyed Tansport Service."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2456",
    "name": "Kumbhar Shivram Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3984",
    "name": "Murgunde Ashok Baburao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3341",
    "name": "Modak  M.S."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4481",
    "name": "Chatur Sopan Pilu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9363",
    "name": "Sawant Mangesh Madhusudan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2241",
    "name": "Pohekar Suryakant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2079",
    "name": "Poojary Dodappa Sopanna ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3446",
    "name": "Mapare Najimuddin Hajimuddin."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7552",
    "name": "Chatur Sangram Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11148",
    "name": "Tambe Shantabai Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "538",
    "name": "Sadashiv Laxman Salunkhe"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3764",
    "name": "Kadam Surekha Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8668",
    "name": "Ahirekar Vandana Satisha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8227",
    "name": "Anup  Roy"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10719",
    "name": "Bhosal Vyankat Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4837",
    "name": "Charve Bhagwan Ukanda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8614",
    "name": "Chhakkal Ashok Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8780",
    "name": "Gaware Kailash Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8550",
    "name": "Gimvekalr Bhawan Rav  Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9367",
    "name": "Haseena Begma Sallauddin Khan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14984",
    "name": "Jadhav Sanjay Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8567",
    "name": "K Somdevan Nagraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8734",
    "name": "Kadam Sachidanand Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8709",
    "name": "Khan Majibudin Khan Mohmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5873",
    "name": "Lad Ghanshyam Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8765",
    "name": "Mohite Vijay Marutrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9195",
    "name": "Nadar Shravan Rajshekhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18130",
    "name": "Pawar Hanmant Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10175",
    "name": "Phadtare Laxman Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8519",
    "name": "Pol Suresh Mahadeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8422",
    "name": "Rasam Sujata Kashinath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10784",
    "name": "Sharef K Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9732",
    "name": "Shelar Dnyaneswar Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13783",
    "name": "Shinde Maruti Ananda."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13726",
    "name": "Shinde Santosh Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12141",
    "name": "Toskar Jairam Suryaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8595",
    "name": "Vashist  Sudhirkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8955",
    "name": "Yadhav Ram Milan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1878",
    "name": "Chitampalle Venkatrao Pirappa."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4742",
    "name": "Gavde Sunil Deu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10292",
    "name": "Shetty Sanjay Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4254",
    "name": "Nakoda  Metals  Agency"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "758",
    "name": "Ghorpade Shivaji Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8111",
    "name": "Pawar Narayan Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3381",
    "name": "Phalake Hanamant Dyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22694",
    "name": "Pujari Surendra Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12683",
    "name": "Sutar Prakash Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22219",
    "name": "Yadav Girijashankar Lalji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3991",
    "name": "Korade Yeshwant Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6497",
    "name": "Shinde Laxmi Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11519",
    "name": "Salunkhe Sanjay Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8525",
    "name": "Adsul Chandrakant Popat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20863",
    "name": "Warekar  Suraj  Harishchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6471",
    "name": "Sinkar Pandurang Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10334",
    "name": "Dhaigude Anant Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8816",
    "name": "Kadam Bhimrao Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18709",
    "name": "Bhoite Sudhir Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4188",
    "name": "Dhaygude Sunita Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2578",
    "name": "Paria Rukmani P"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6118",
    "name": "Phalke Dattu Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3292",
    "name": "Gupta Sunita Ramprasad"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "149",
    "name": "Badhe Ganpat Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12790",
    "name": "Bansode Sandeepan Nivrutti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "248",
    "name": "Bhosale Kanhayya Sitaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "125",
    "name": "Bobade Dasharath Rangarao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "418",
    "name": "Chavan Vinod Shivaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "419",
    "name": "Gaikwad Vijay Nanasaheb"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "493",
    "name": "Ghadge Laxmi Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10593",
    "name": "Gujar Ramchandra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7220",
    "name": "Hojage  Lilabai Namdeo."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "215",
    "name": "Jadhav Balkrishna Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "198",
    "name": "Jadhav Vijay Balu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "542",
    "name": "Kulkarni Durgaprasad Arvind"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "249",
    "name": "Londhe Sainath Baban"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "394",
    "name": "Monde Pooja Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10158",
    "name": "More Savita Balasaheb"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "363",
    "name": "Nikam Sonam Devendra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "325",
    "name": "Nimbalkar Hemant Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13346",
    "name": "Pakhare Netraprabha Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22192",
    "name": "Parekh Yagesh Ramanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23353",
    "name": "Pawar Pradeep Narayan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "544",
    "name": "Puranik Shirish Damodar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "450",
    "name": "Salunke Ankush Sayaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "481",
    "name": "Salunkhe Gajanan Jalindar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14088",
    "name": "Shedage Savitrabai Balwant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "568",
    "name": "Shelar Krushna Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15642",
    "name": "Shinde Chitra Pradip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19298",
    "name": "Solanki Champalal Chunilal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "152",
    "name": "Sonawale Shrirang Parsu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19100",
    "name": "Soni Vandana Madhukarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13120",
    "name": "Wachkavade Rekha Suryakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11395",
    "name": "Jadhav Vijay Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8673",
    "name": "Shinde Anusuya Shreepati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9002",
    "name": "Anchan Supriya Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22332",
    "name": "Bagal Mahesh Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6371",
    "name": "Bhatkar Sunil Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12288",
    "name": "Chavan Sangita Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8356",
    "name": "Choudhary Metabi Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9907",
    "name": "Chouhary Vasudeo Daulat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4593",
    "name": "Dharmendra  Sing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11458",
    "name": "Gaikawad Tanaji Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11717",
    "name": "Jadhav Sunita Ashok"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "374",
    "name": "Khaire Swati Santosh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22142",
    "name": "Lakhawade Raghunath Hariba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11689",
    "name": "Mahangade Krishna Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8467",
    "name": "Mane Narendra Dhanaji."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10883",
    "name": "Nikam Kamal Raghuveer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8289",
    "name": "Pisal Vishwas Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6175",
    "name": "Shahhbalam Abdul Kadar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2938",
    "name": "Shriyan Harish Jogi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9193",
    "name": "Solanki  Shivprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8239",
    "name": "Sudharma Raju Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11526",
    "name": "Vobalyya  Murti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5319",
    "name": "Waskar Lilli M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15934",
    "name": "Yadav Nitin Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3847",
    "name": "Prajapati Pathaniram Munnilal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8782",
    "name": "Shinde Deepak Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3163",
    "name": "Murarkar  Urmila."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3672",
    "name": "Kadam Popat Appaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9437",
    "name": "Shinde Laxman Genba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2016",
    "name": "Girap Minanath Sitaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "757",
    "name": "Ramdas Baburao Borade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "879",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9124",
    "name": "Jadhav Sanjay Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9504",
    "name": "Singh Manojkumar R."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3684",
    "name": "Gaikwad Dhananjay Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10963",
    "name": "Joil Pradip B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12325",
    "name": "Aanpat Kiran Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4550",
    "name": "Ahire  K.V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7464",
    "name": "Bhat Gangaram Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11469",
    "name": "Bhoite Ankush Jayasingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15317",
    "name": "Chavan Vijaya Vilasrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2299",
    "name": "Chohan  Jaysingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9109",
    "name": "Gadhave Sangita Ramsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8642",
    "name": "Ghag Smita Pravin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20220",
    "name": "Gupta Mahendra Motilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8279",
    "name": "Jaiswar  Rajkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11308",
    "name": "Joil Balkrishna Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12226",
    "name": "Nikam Balasaheb Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17061",
    "name": "Patil Anand Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16651",
    "name": "Patil Rajaram Chander"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15341",
    "name": "Pawar Krishna Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10667",
    "name": "Pawar Vitthal Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5166",
    "name": "Pisal Hanmant Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11445",
    "name": "Raje Droupadi Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22523",
    "name": "Sahai Indrakalm Bahadur"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "361",
    "name": "Sambare Sachin Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14970",
    "name": "Sawant Suresh Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8548",
    "name": "Sawant Vaishali Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12464",
    "name": "Shinde Hemant Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15419",
    "name": "Shinde Yashwant A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6986",
    "name": "Tawade Santosh Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8856",
    "name": "Thakur Shashikant Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1663",
    "name": "Vaidya Sharad Harichandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3691",
    "name": "Yevale Putlaji Dharma."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "297",
    "name": "Sahyadri Nagar Pragti Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10647",
    "name": "Kashid Vivek Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "449",
    "name": "Sawant Raghunath Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1073",
    "name": "Sawant Narayan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1921",
    "name": "Kinkar Haribhau Dattatrya ."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1050",
    "name": "Gajula Vishnukumar Tirupati"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "633",
    "name": "Jadhav Ashok Shankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "416",
    "name": "Landge Archana Bandu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "244",
    "name": "Shinde Arvind Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3913",
    "name": "Kirve Ramchandra Bhikaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8739",
    "name": "Kuran Dhanraj Purushottam"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1750",
    "name": "Nalini Enterprises"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8740",
    "name": "Kuran Nanda Purushottam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5479",
    "name": "Shinde Jayashree Dattajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4940",
    "name": "Chavan Bhiku Kondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7607",
    "name": "Gardi Jyotiram Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "658",
    "name": "Phalke Narayan Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4534",
    "name": "Ghadge Malan Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8619",
    "name": "Pachangne Anandrao Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8671",
    "name": "Gaikwad Vishwas Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1179",
    "name": "Shinde Sopan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8551",
    "name": "Ajit  K.Mahangade"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9370",
    "name": "Barge Arjun Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10717",
    "name": "Devkule Maruti Ramkisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5277",
    "name": "Gawade Laxmi Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10551",
    "name": "Ingale Chandrakant Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7829",
    "name": "Isak  Jaylatha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17592",
    "name": "Jadhav Suryakant Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6454",
    "name": "Jaiswal Ramesh Shriramkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5048",
    "name": "Kadam Vandana Daulat"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "577",
    "name": "Mane Sacheli Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9024",
    "name": "Mhatre Sumedha Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7977",
    "name": "Mosmakar Vasant Sonu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11738",
    "name": "Parmar Rakesh Nandkishore"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17068",
    "name": "Parsekar Surekha Gajanan/Vinay Parsekar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9885",
    "name": "Sayyad Altaf Hayyat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17922",
    "name": "Shetty Narayan Koraga."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15512",
    "name": "Singh Manoj Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9274",
    "name": "Yadav Namdeo Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3289",
    "name": "Pawar Shankar Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2840",
    "name": "Sabale Janardhan Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "748",
    "name": "Balu Dadasaheb Bhosale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3432",
    "name": "Patel Naeem Ibrahim."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3603",
    "name": "Jaimala A. Shah"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1361",
    "name": "Phalke Pandurang Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5142",
    "name": "Jagtap Muktabai Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "642",
    "name": "Salunkhe Baliram Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3564",
    "name": "Khedekar Manohar Sambhaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12342",
    "name": "Pinto Clara Patrik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5316",
    "name": "Namdar Shivaji Bhairu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2321",
    "name": "Miss Pratibha Kumari Varma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4396",
    "name": "Verma Premadevi Shivbodhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1115",
    "name": "Pable Savleram Rewaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12334",
    "name": "Kubal Yogesh Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10084",
    "name": "Barge Shakuntala Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10077",
    "name": "Chavan Godabai Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9813",
    "name": "Dhumal Dattatray Mugatarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11211",
    "name": "Gujar Muktabai Padurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12295",
    "name": "Gurakha Parshuram Ramsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12963",
    "name": "Gurav Hanmant Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10831",
    "name": "Jadhav Dhanaji Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12324",
    "name": "Joshi Rajashree Raju"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4016",
    "name": "Mahangre Raghunath Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13544",
    "name": "Mashere Sudarshan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13265",
    "name": "Nalage Mahadeo Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7590",
    "name": "Pandya Udaykumar Muttu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "514",
    "name": "Repale Mohan Ankush"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "26",
    "name": "Shingh Dinesh Masar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7132",
    "name": "Surve Nandkishore Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7580",
    "name": "Waghamare Ramesh Motiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8076",
    "name": "Chavan Narayan Kondeba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5359",
    "name": "Ghadge Vishnu Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1584",
    "name": "Kakade Bhagwan Shripati."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15206",
    "name": "Murkar Chandrakant Dattaram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1376",
    "name": "Pawar Baliram Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1022",
    "name": "Ramchandra Hari Bhandri."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1091",
    "name": "Kulakarni Vijay Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4688",
    "name": "Maske Bhimrao Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5311",
    "name": "Rane Pandurang L"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13621",
    "name": "Dharan Harilal Sarnga."
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1309",
    "name": "Angre Rupali Ulhas"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "382",
    "name": "Narendra Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7483",
    "name": "Bera  Sachin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11062",
    "name": "Chavan Ujwala Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17143",
    "name": "Deore Mahendra Supadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4965",
    "name": "Dhage Pandit Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7576",
    "name": "Jadhav Dilip Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7584",
    "name": "Kadam Ramakant Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7886",
    "name": "Kadam Revati Dynesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10488",
    "name": "Konde Chandrashekhar Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10315",
    "name": "Mestry Ramchandra A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8280",
    "name": "Nair Ramchandra K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8839",
    "name": "Parab Prabhakar Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17399",
    "name": "Sharif Asma Jamaluddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15752",
    "name": "Tambe Komal Sangam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17099",
    "name": "Tamsare Ramesh Bhagvan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8498",
    "name": "Tatkar Sunil Raman/Pramod M T"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7910",
    "name": "Tiwari Kanchan Rambhavari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18249",
    "name": "Vishwakarma Ashadevi Hemchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10604",
    "name": "Yadav Birbal Daljit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2029",
    "name": "Shetty Govind Narayan ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1519",
    "name": "Bagul Sushma Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6000",
    "name": "Dhumal Saraswati Dhansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4318",
    "name": "Devare Sharada Sudhakar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7252",
    "name": "Pal Jayant Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13597",
    "name": "Yadav Mahendra Ganpatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1756",
    "name": "Nawadkar Chhaya Hanmantrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5990",
    "name": "Shinde Mahesh Chatarbhuj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7936",
    "name": "Ghuge Sunil Dnandev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14616",
    "name": "Bankar Manik Bhikaji."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "669",
    "name": "Khan Altaf Salauddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19573",
    "name": "More Satish Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19802",
    "name": "Raje Santosh Trimbak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7957",
    "name": "Pawar Dhuryodhan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4725",
    "name": "Shirke Dilip Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2353",
    "name": "Kadam Mahadeo Kundlik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8717",
    "name": "Jadhav Kantaram Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7836",
    "name": "Rasal Sudhir Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7913",
    "name": "Sawant Akaoba Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4501",
    "name": "Kadam Pratap Nanaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5542",
    "name": "Sakat Chandrakant Dharmu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11687",
    "name": "Gardi Ramdas Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7218",
    "name": "Bhosale Pushpa Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7597",
    "name": "Chavan Jyotiram S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7546",
    "name": "Chavan Rupali Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12069",
    "name": "Choukekar Suman Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10745",
    "name": "Desai Satishkumar Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7608",
    "name": "Dound  Raju."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6263",
    "name": "Gill Anitadevi Kuldeepsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15063",
    "name": "Gondhali Narendra Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11638",
    "name": "Hawade Khemling Ambarayya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8420",
    "name": "Jadhav Vasant Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10154",
    "name": "Jalgaonkar Vevshnavi Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8570",
    "name": "Kadam  Tukaram Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10021",
    "name": "Kale Nandkumar H/Shashikala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7621",
    "name": "Koli Yayati Yashwant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7362",
    "name": "Kumhar  Mahabirprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21244",
    "name": "Mahadik Sujit Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "745",
    "name": "Manohar Ramchandra Bhoite."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7400",
    "name": "Pandey  Ramashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7820",
    "name": "Rao Chandadevi Vijaykumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7121",
    "name": "Sawant Anant Tulaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9808",
    "name": "Sawant Harish Govindrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11795",
    "name": "Shinde Vilas Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5561",
    "name": "Vishwakarma Ramtirath Ramashray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2589",
    "name": "Patil Jitendra R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "207",
    "name": "Ashok Kumar Mishra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14044",
    "name": "Chudji Aparna S."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3465",
    "name": "Navadurga Packing Work"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9106",
    "name": "Wagh Radhabai Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5484",
    "name": "Mulani Salim Nijam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4002",
    "name": "Shinde Hanmant Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2944",
    "name": "Bobade Yashoda Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3867",
    "name": "Jagtap Baban Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1584",
    "name": "Navin Fire Service"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1508",
    "name": "Navnit Textiles"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3562",
    "name": "Phalake Bhanudas Dyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4575",
    "name": "Sakunde Kisan Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13650",
    "name": "Borkar Harishchandra Dhondu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4227",
    "name": "Shinde Kalawati Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1048",
    "name": "Khem Sing Gorsai."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2087",
    "name": "Navyug Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1110",
    "name": "Krishna Chikya Kotian."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15141",
    "name": "Bhandari Sachin Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13557",
    "name": "Dhumal Pandurang Sahebrao & Dhumal Shalan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13245",
    "name": "Garud Santosh Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13390",
    "name": "Jadhav Vivek Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10589",
    "name": "Kadam Rajesh Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10542",
    "name": "Khande Padmakar Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7193",
    "name": "Khilari Sunil Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10726",
    "name": "More Sarita Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12564",
    "name": "Mujavar Ramjan Rasul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7161",
    "name": "Naik Shantabai Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14116",
    "name": "Nikalaje Ramesh Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7109",
    "name": "Pal Harshal Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13861",
    "name": "Phalke Gulabrao Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10475",
    "name": "Rathod Walabai Dhansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6699",
    "name": "Sapaliya Krishna Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5641",
    "name": "Shinde Sudhir Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20713",
    "name": "Shinde Suresh Y"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13540",
    "name": "Vedapathak Prakash Kondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11274",
    "name": "Verma  Pyarelal/Taradevi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8392",
    "name": "Yadav Samarnath Ramlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "534",
    "name": "Shrikrishn Giridhar Ghadge"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8909",
    "name": "Khandare Raju Mayappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1526",
    "name": "Jagtap Jamnabai Mugatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3986",
    "name": "Shedge Vilas Khashaba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9675",
    "name": "Malhar Ramdharan Gabbu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2210",
    "name": "Kalavariya Sudhakar Shamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17544",
    "name": "Bobale Sunita Vishram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7394",
    "name": "Chavan Suman Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9218",
    "name": "Gaikwad Baburao Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15815",
    "name": "Giri Ujjawala Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7184",
    "name": "Khatav Devendra Ghansham"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14732",
    "name": "Kudalkar Dilip Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12341",
    "name": "More Dropadi Tanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7945",
    "name": "Naik Dipika Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7694",
    "name": "Nepali Amarsingh Ramsing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11928",
    "name": "Pawar Avinash Benjamin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5916",
    "name": "Rahate Ashok Krishna/Ravindra/Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8634",
    "name": "Rawool Sunil Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3725",
    "name": "Nawadkar Sagar Kalidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11413",
    "name": "Shaikh Kamluddin Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9900",
    "name": "Sharma Radharani Ratankummar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15486",
    "name": "Waghmare Mayadevi Shrihari."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12261",
    "name": "Yadav Ravindra Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5626",
    "name": "Mane Sudam Yeshawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3611",
    "name": "Dimelo Rolan Josheph ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "444",
    "name": "Suresh Manik Patil."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3640",
    "name": "Jadhav Trimbak Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9403",
    "name": "Jagtap Gulabrao Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4872",
    "name": "Ghadage Shivaji Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7561",
    "name": "Giri Bharat Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "402",
    "name": "Rakshe Krishna Dagdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8070",
    "name": "Bhosale Chandrakant Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8296",
    "name": "Bhosale Chandrakant Sadashiv"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "306",
    "name": "Chavan Sharad Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10126",
    "name": "Chavan Sushila Khandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10550",
    "name": "Durgule Appa Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11009",
    "name": "Nalge Balkrishna Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "190",
    "name": "Gaikwad Ramdas Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7430",
    "name": "Bhoite Ranjana Raoosaheb"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1222",
    "name": "Chennori Shanta Laxmipati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6958",
    "name": "Desai Nandaji Bhairu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5816",
    "name": "Dhamal Gulab Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6945",
    "name": "Gaikwad Bandu Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4739",
    "name": "Gupta  Madhurik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18325",
    "name": "Kadam Pravin Narasu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6943",
    "name": "Lad Prakash Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7749",
    "name": "Nikam Savita Shamrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11572",
    "name": "Pal Mulchand Jautri"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13989",
    "name": "Pradhan Madhukar Kondiba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10988",
    "name": "Pradhan Sanjay Kaduba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12213",
    "name": "Shinde Dadarao Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3508",
    "name": "Khwaja Gulam Hussain Mohd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5170",
    "name": "Shah Gamant Vijpar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3651",
    "name": "Musale Puspa Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "974",
    "name": "Gawade Digamber Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2085",
    "name": "Neelam Industries"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6923",
    "name": "Bhaldar Salima Aalam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7956",
    "name": "Vicharay Vasant Bajarang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4500",
    "name": "Kumbhar Kisan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "900",
    "name": "Husen Kasam Mastan"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1014",
    "name": "Neha Products"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18474",
    "name": "Patil Nana Dadu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7343",
    "name": "Arekar Shraddha Shrikant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1010",
    "name": "Nem Textiles"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9619",
    "name": "Bhagat Dhananjay Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10851",
    "name": "Chavan Jagdish Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11703",
    "name": "Gaikwad Vilas Namdeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "833",
    "name": "Gosrani Mukesh Gulabchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13358",
    "name": "Jadhav Jagannath Appaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13415",
    "name": "Jadhav Mahadeo Sadashiv."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6402",
    "name": "Jadhav Sambhaji Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12297",
    "name": "Kadam Sangeeta Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11711",
    "name": "Narkar Sampat Savalaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11076",
    "name": "Phalke Tanubai Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8851",
    "name": "Pund Sunanda Marotrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9284",
    "name": "Raut Lahu Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8462",
    "name": "Roy  Reeta."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11931",
    "name": "Shah Sumitraben Ramanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10640",
    "name": "Sharma Asha Binod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15054",
    "name": "Sheth Arvind P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8360",
    "name": "Shinde Sudakar Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7067",
    "name": "Takke Sandeep Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9688",
    "name": "Tirwa Deepak Mohansingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "990",
    "name": "Net Warth Services"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12366",
    "name": "Yadav Swaminath Satyadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2926",
    "name": "Chonkar  Anita Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "44",
    "name": "Shinde Malan Babasaheb."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8094",
    "name": "Sabnis Digambar Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4515",
    "name": "Raut Dnyandeo Tayaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2273",
    "name": "More Santosh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2398",
    "name": "Tavare Ashok Prabhakar."
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "45",
    "name": "New Goodwill Fabrication"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "302",
    "name": "New Maa Vaishanav Express"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4462",
    "name": "New Nityanand Roadlines"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "923",
    "name": "New Prakash General Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3788",
    "name": "Gajendra  Singh."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3366",
    "name": "Vaidh Ravindra Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8852",
    "name": "Ghadge Rajendra Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12939",
    "name": "Shinde Sanjay Natu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8938",
    "name": "Bhandalkar Valutai Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6484",
    "name": "Chavan Ankush Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8307",
    "name": "Jadhav Madhukar Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11693",
    "name": "Gada Harish Lalji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13339",
    "name": "Gaikwad Bhagwan Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17262",
    "name": "Govale Laxman Sahdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6799",
    "name": "Haju Ashraf Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5411",
    "name": "Jadhav Suman Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13325",
    "name": "Jadhav Sunil Gulab"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "219",
    "name": "Kadam Charan Ishwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7303",
    "name": "Matkar Mansing Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11772",
    "name": "Mehta Bhupendra Laxmichand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7804",
    "name": "Mistry Ramuwadh ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8582",
    "name": "More Raghunath Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11348",
    "name": "More Vikas Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13318",
    "name": "Pawar Shashikant Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13321",
    "name": "Sakunde Laxman Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15248",
    "name": "Singh Hawaldarsingh Gorakhh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13982",
    "name": "Tapasi Subhash Pitru."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5613",
    "name": "Inamdar Gani Maktum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7327",
    "name": "Shinde Saroj Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8632",
    "name": "Chaugule Ajay Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4365",
    "name": "Singh Hawaldarsingh Gorakhh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10089",
    "name": "Londhe Shivaji Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "135",
    "name": "Shrirang Pandurang Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1221",
    "name": "Bhandari Hareshwar Gopal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9698",
    "name": "Bhagwat Aadik Savlaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22393",
    "name": "Dhumal Ramesh Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12101",
    "name": "Jadhav Bebi Bajarang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9393",
    "name": "Kakade Shaila Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11812",
    "name": "More Mangal Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13303",
    "name": "More Rekha Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13286",
    "name": "Phalke Nilesh Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7312",
    "name": "Rasal Sopan Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8568",
    "name": "Surve Mahadeo Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11689",
    "name": "Yadav Santosh Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8922",
    "name": "Jadhav Vinayak Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13035",
    "name": "Sutar Shantaram Ambadas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7223",
    "name": "Pardhi Anil Lakhanlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8045",
    "name": "Jadhav Shalini Shridhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4702",
    "name": "Jagatap Shivaji Bayaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8196",
    "name": "Patil Rajendra Marutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9908",
    "name": "Aaware Laxman Dyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6329",
    "name": "Annadurai  S."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4298",
    "name": "Babar Shamrao Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17503",
    "name": "Dhande Kalavati Parmeshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22301",
    "name": "Gaikwad Vasanti Purushottam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11292",
    "name": "Kadam Dnyandeo Appaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13253",
    "name": "Mahadik Shashikant Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5969",
    "name": "Mane Changuna Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7507",
    "name": "Mulik Shobha Prafulla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7313",
    "name": "Narak Khetar Nakul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6502",
    "name": "Palande Archana Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13249",
    "name": "Panbude Nanda Dayanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8426",
    "name": "Pasum Shailu Chandranna."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13256",
    "name": "Pawar Anil Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15847",
    "name": "Pawar Ravindra Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8095",
    "name": "Phalke Bhaskar Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8921",
    "name": "Phalke Kisan Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6630",
    "name": "Ralph Sheroo William"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13273",
    "name": "Sabale Ashok Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8716",
    "name": "Salunkhe Arun Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13277",
    "name": "Salunkhe Santosh Bhujang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6504",
    "name": "Shah Avinash Laldas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4807",
    "name": "Tawde Sandeep Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7238",
    "name": "Yadav Ramrais Kanta"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8077",
    "name": "Jamdhade Anil Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2401",
    "name": "Modak Balkrushna Baburao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6162",
    "name": "Sable Vandana M/Kamal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7950",
    "name": "Pisal Bhagawan Suryaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3339",
    "name": "Vishwakarma Ramkeval Chhabu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7308",
    "name": "Shirali Gurudatta Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18906",
    "name": "Thik Sangeeta Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9136",
    "name": "Hadge Santosh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9018",
    "name": "Bagave Sudesh Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6885",
    "name": "Bhandari Ravindra Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14914",
    "name": "Bhoite Kisan Appaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14329",
    "name": "Chalakkal Lijo John."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13203",
    "name": "Gaikwad Dinesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11325",
    "name": "Hussain Rabiulha Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18530",
    "name": "Kadam Swapnil Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13211",
    "name": "Mane Sangeeta Pramod"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "397",
    "name": "Mane Swati Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6087",
    "name": "Munegkar Nutan Nandkishor"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10772",
    "name": "Nalwade Chandrakant Kundlika"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6765",
    "name": "Purohit Andraj S/O Jwarji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13455",
    "name": "Shukla Vinodkumar Tejbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10538",
    "name": "Sonawane Vijay Dajiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6861",
    "name": "Soni Girdharlal Keshavji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "756",
    "name": "Semankar Narayan Gunagi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5025",
    "name": "Pawaskar Vivek Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "950",
    "name": "Bhandari Birsing D."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8681",
    "name": "Bhise Prakash Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3907",
    "name": "Shinde Babaji Keshev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3811",
    "name": "Sayyed Sultana Babu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3435",
    "name": "Siddqi Ragi Mohd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "892",
    "name": "Sharuppa  Soonar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2127",
    "name": "Rasal Vithabai Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3628",
    "name": "Kadam Tukaram Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13160",
    "name": "Babar Navnath Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13164",
    "name": "Bhingare Chaitanya Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13405",
    "name": "Desai Jagannath Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13178",
    "name": "Dhumal Genba Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12998",
    "name": "Dombare Rajesh Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15425",
    "name": "Jadhao Chhaya Hannmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18947",
    "name": "Kambale Raju Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17258",
    "name": "Kudtarkar Mahendra Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10615",
    "name": "Kumbhar Namdeo Miru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9788",
    "name": "Phalake Dipak Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3021",
    "name": "Gurav Kamal Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6763",
    "name": "Pawar Narmadabai Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2813",
    "name": "Kalvajiya Basdev Pitambarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15413",
    "name": "Bhosale Pranali & Pragati Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18716",
    "name": "Jadhav Dipak Vithalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8185",
    "name": "Dhumal Ankush Marutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8102",
    "name": "Bhosale Vishnu Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17437",
    "name": "Chawan Ramchandra Krishnaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18508",
    "name": "Ghare Adhik Shrirang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "849",
    "name": "Kumbhar Vedika Yogesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20865",
    "name": "Mohite Rupali Ankush"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13138",
    "name": "Phalke Balasaheb Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12954",
    "name": "Pisal Haribhau Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16461",
    "name": "Salunkhe Vilas Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20824",
    "name": "Jadhav Sudhir Sahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1285",
    "name": "Gaikwad Jaywant Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12822",
    "name": "Hol Mangesh Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13535",
    "name": "Ahire Anil Shivram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8370",
    "name": "Badekar Sharad R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7493",
    "name": "Bhadsale Pundlik Krushnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11034",
    "name": "Chalke Ishwar Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12061",
    "name": "Dhane Vishvas Jotiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5767",
    "name": "Gaimukhe Gangaram R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7757",
    "name": "Gupta Himmatlal Nanchuprasad."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "714",
    "name": "Haralkar Palak Pankaj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12491",
    "name": "Kalal Jafar Rajjak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9845",
    "name": "Khan Rashidabanu Abdul Hamid"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13129",
    "name": "More Shashikant Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14980",
    "name": "Nabi Rasool Kwaja Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12810",
    "name": "Pal Latu Prasad Rajendra Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7613",
    "name": "Pawar Rajendra Arjun."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12251",
    "name": "Phalke Yogita Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12539",
    "name": "Sharma Shambhu Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12016",
    "name": "Shinde Anita Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11385",
    "name": "Shukla Surendra Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6480",
    "name": "Talwalkar Laxman Daulat/Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8980",
    "name": "Yadav Ankush Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3600",
    "name": "Ambre Vishwanath Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15371",
    "name": "Mansukhani Jitendra Indrakumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1544",
    "name": "Kamalmaruti  Dubal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "149",
    "name": "Pawar Appa Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1813",
    "name": "Sable Madhukar Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "649",
    "name": "Beerbal Ramdhan Yadav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8826",
    "name": "Dhawan Vitthal Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3444",
    "name": "Javheri Ravindra Shyamji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16216",
    "name": "Bhagwat Sudhir Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6078",
    "name": "Chorasiya Gaytridevi Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13779",
    "name": "Chourasiya  Shailendra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9455",
    "name": "Dalavi Dinkar Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5943",
    "name": "Das  Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7453",
    "name": "Gupata B B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15737",
    "name": "Haldaar Akaashali Abdulmenan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11595",
    "name": "Jagushte Anjali Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6580",
    "name": "Jain Pravin Pannalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6390",
    "name": "Mandhare  Vimal Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7871",
    "name": "Mohammed Nurale Kasam Phakir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6144",
    "name": "Nadar Chitra Murgan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14305",
    "name": "Newase Rajendra Hanmant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15946",
    "name": "Nikam Rajendra Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5942",
    "name": "Pande Mukand Murari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15136",
    "name": "Patil Vandana Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11160",
    "name": "Pawar Rajendra Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8970",
    "name": "Shinde Mahadeo Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12683",
    "name": "Thapa  Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4814",
    "name": "Tiwari Vijaysankar Chandrasekhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10007",
    "name": "Vadhaiya Jayashree Mukund"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6299",
    "name": "Vaishnav Kamla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3220",
    "name": "Varma Kashiram Bansaraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9760",
    "name": "Pashilkar Tarabai G/Kanhaiya."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2017",
    "name": "Gaikwad Jijabai Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8767",
    "name": "Phalke Ranjit Shivajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8092",
    "name": "Bhosale Dhananjay Shrirang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "840",
    "name": "Shetty Sharad Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2189",
    "name": "Phalke Laxman Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13008",
    "name": "Raskar Sawata Nagesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4275",
    "name": "Mulik Vithal Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7628",
    "name": "Chavan Savita Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12874",
    "name": "Bhosale Shashikant Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10714",
    "name": "Dsouza Meena Manesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10352",
    "name": "Gond Bablu Durbali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12889",
    "name": "Jathar Anandrao Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22395",
    "name": "Kadam Maruti Krushnaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11252",
    "name": "Khatawakar Ramchandra Shanakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5855",
    "name": "Malaram  Harji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10059",
    "name": "Mishra Suresh Kumar Mankanday"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9851",
    "name": "Pawar Krishna Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5854",
    "name": "Safikul  Islam"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "151",
    "name": "Sanap Shaila Nandkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5907",
    "name": "Shetty Surekha Jaiprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11185",
    "name": "Shukla Santoshkumar Harikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10011",
    "name": "Thakur Karansingh Ramsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8810",
    "name": "Thorat Manohar Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5183",
    "name": "Tripathi Kamlesh Chandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7610",
    "name": "Jadhav Vikas Vishwanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10814",
    "name": "Nawadkar Pratap Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8809",
    "name": "Laate Prabha Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1810",
    "name": "Patrawala Moiz E."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15268",
    "name": "Amte Dipali Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10761",
    "name": "Bhoite Shankar Malyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6729",
    "name": "Chaillya  Devidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5456",
    "name": "Chougule Alka Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20462",
    "name": "Hule Tukaram Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12119",
    "name": "Kharat Shaila Gorakhanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5966",
    "name": "Manek Pooja Dwijendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15013",
    "name": "Patel Vasantiben Tribhovanbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1147",
    "name": "Nimeshri Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9364",
    "name": "Patere Amita Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9828",
    "name": "Patil Netaji Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5904",
    "name": "Rajbhar Bhaiyalal Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5447",
    "name": "Shinde Suhas Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6060",
    "name": "Sonar Dilip D/Motisingh Amarsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5129",
    "name": "Vagh Sunanda Kisanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5970",
    "name": "Yevale Ravindra Dattatrya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3165",
    "name": "Bobade Vanita Ashok."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3373",
    "name": "Aawade Aananda Kalu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2550",
    "name": "Kashid Bhanudas Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12635",
    "name": "Chavan Manoj Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4385",
    "name": "Shah Anilkumar M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13985",
    "name": "Smt. Bhagi Bhim Prasad Rai Shri Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1713",
    "name": "Niranjan Colour Works"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8894",
    "name": "Lembhe Sampat Dadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1275",
    "name": "Kadam Vithal Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1384",
    "name": "Kadam Vithal Kundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3464",
    "name": "Nakate Mahadeo Bhagoji ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10054",
    "name": "Jadhav Kashinath Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7523",
    "name": "Jadhav Eknath Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3656",
    "name": "Jadhav Mohan Parbati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15761",
    "name": "Bamne Santosh Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14226",
    "name": "Bina Prasad Samant"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1944",
    "name": "Nisha Construction & Pile Foundations"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "276",
    "name": "Chikane Vilas Parabati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5615",
    "name": "Hede Vijendra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7731",
    "name": "Jadhav Arun Rajaram/Vandana."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6320",
    "name": "K.K.Vasanth  Nair."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8994",
    "name": "Parab Santosh Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13053",
    "name": "Phalke Rahul Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "57",
    "name": "Sawant Vaishnavi Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10722",
    "name": "Sayyed Kasam Gani"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10284",
    "name": "Shelar Shankar Amruta"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2496",
    "name": "Nishith Poly Yarns"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11997",
    "name": "Shinde Kantabai Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11416",
    "name": "Shingate Shrirang Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5287",
    "name": "Sukumaran  Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1117",
    "name": "Nitin Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2251",
    "name": "Nitin Travels"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1870",
    "name": "Mali Vijaya Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2121",
    "name": "Shelar Jaywant Sadhu ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4161",
    "name": "Shamlal S Jayswal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5498",
    "name": "Bhosale Pratap Sudamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3546",
    "name": "Chaturvedi Manisha G."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7940",
    "name": "Jagdale Tarabai Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4908",
    "name": "Sakunde Pralhad Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13031",
    "name": "Habibullah Khan Lal Khan"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1083",
    "name": "Noble Construction Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4618",
    "name": "Noble Packaging"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7804",
    "name": "Pisal Appsaheb Paroba"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1596",
    "name": "Nova Nigman Nigam Builders & Developers"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "697",
    "name": "Bhoir Swati Leeladhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5019",
    "name": "Bobade Sunanda Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11866",
    "name": "Dhuri Santosh Sahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12710",
    "name": "Dubey Mandvi Gokarn"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8405",
    "name": "Jadhav Uddhav Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8412",
    "name": "Jayaram Devji Deyatnanda."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7706",
    "name": "Lokhande Sanjay Babanrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10716",
    "name": "More Janabai Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18369",
    "name": "Padwal  Santosh  Suryakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17244",
    "name": "Patankar Sanjay Gokuldas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10112",
    "name": "Pawar Vijaya Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11119",
    "name": "Shrivasthava Rajashree Sadan"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1680",
    "name": "Om Creations"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13999",
    "name": "Yadav Rajkumar Bhullarprasad."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "391",
    "name": "Shingate Kalidas Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "440",
    "name": "Popat Subhedar Bobade."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1638",
    "name": "Omkar Creation"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2102",
    "name": "Omkar Engineering Works"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1508",
    "name": "Omkar Motors"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8021",
    "name": "Shah Gunvant Laxmichand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2609",
    "name": "Thombare Anusaya Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2294",
    "name": "Sabale Shrirang Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11201",
    "name": "Bobade Rajesh Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7639",
    "name": "Mahadik Kailash Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11565",
    "name": "Bhosale Vivekanand Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10239",
    "name": "Jadhav Sunil Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10023",
    "name": "Kasid Sunil Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12927",
    "name": "Madane Pandurang Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9272",
    "name": "Nadar Parmal Solla Muttu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "328",
    "name": "Palande Ankita Avinash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8845",
    "name": "Patel Jayantibhai Babubhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11848",
    "name": "Pisal Vijaykant Nathuram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "651",
    "name": "Thube Roshni Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6311",
    "name": "Varte Vesti Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10010",
    "name": "Yadav Brijnath Shivmangal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4792",
    "name": "Sawant Mangal Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3962",
    "name": "Pendurkar Shriniwas Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5695",
    "name": "Yadav Bapu Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8748",
    "name": "Sakunde Balu Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4918",
    "name": "Bhagat Tukaram Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13083",
    "name": "Jaiswar  Jawaharlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4846",
    "name": "Kadam Pandurang Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4420",
    "name": "Paan Agencies"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13039",
    "name": "Badadre Yashwant Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14266",
    "name": "Kamble Sunil Ishwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9587",
    "name": "Salunkhe Dinkar Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4419",
    "name": "Salunkhe Dinkar Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5062",
    "name": "Rane Manisha Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11073",
    "name": "Silval Ravindra Shivsingh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "265",
    "name": "Jangam Prafull Pradip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10521",
    "name": "Jawale Sanjay Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8668",
    "name": "Kadam Sharad Sopanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18060",
    "name": "Kamble Hemant Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "424",
    "name": "Arvind Dyandeo Sawant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5347",
    "name": "Kazi Malik K Ahmed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8059",
    "name": "Mane Laxman Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8246",
    "name": "Kulkarni Bhagwan Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11437",
    "name": "Jadhao Shankar Shamarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7848",
    "name": "Jagdale Jaywant Kundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10101",
    "name": "Kadam Sudam Gangadhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10204",
    "name": "Kuchekar Subhash Sayaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8229",
    "name": "Lohar Sudhir Gopalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12565",
    "name": "Mahadik Suhas Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9388",
    "name": "Makbul Ahmed Jumman Shaikh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15317",
    "name": "Patel Naramada Lala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12611",
    "name": "Shinde Anil Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12518",
    "name": "Sutar Baban Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15305",
    "name": "Khilare Pandurang Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5109",
    "name": "Disale Sarjerao Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1184",
    "name": "Ghorpade Vishnu Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5644",
    "name": "Gaikwad Keshav Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12692",
    "name": "Asram Satish Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6260",
    "name": "Bande Surekha Suresh/Suvarna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10930",
    "name": "Bhapkar Macchindra Piloba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8967",
    "name": "Chandekar Govind Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10022",
    "name": "Dongare Sitaram Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12865",
    "name": "Jadhav Amol Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11303",
    "name": "Jambhale Vilas Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7280",
    "name": "Jasval Sunita Rambali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5613",
    "name": "Kodumadathil Unnikrishnan Bhaskaran"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "668",
    "name": "Kokane Pramila Manish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13102",
    "name": "Kumbhar Lilavati Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13195",
    "name": "M.  Dewanshu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "356",
    "name": "Pawade Satish Prabhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10838",
    "name": "Prajapati Harishchandra Soharan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12986",
    "name": "Saluke Dnanyadev Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14928",
    "name": "Shaikh Baksu Mohammad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10884",
    "name": "Shete Atul Shivling"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5845",
    "name": "Shinde Dattatray Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14356",
    "name": "Tripathy Mihir Dolagobinda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5824",
    "name": "Wagh Shankar Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9695",
    "name": "Yadav Shrikant Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3483",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2631",
    "name": "Sekharan Raja ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15970",
    "name": "Dadaso Ramchandra Kharade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3520",
    "name": "Bori Akbar Ismile"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5608",
    "name": "Sawant Ashok Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12781",
    "name": "Anpat Ramdas Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14981",
    "name": "Bagul Sakhubai Tulshiram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12431",
    "name": "Bhosale Sulochana Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4812",
    "name": "Choudhary Mahavirprasad/Ramavtar Choudha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15793",
    "name": "Ghadage Anita Nitin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11370",
    "name": "Kadam Dilip Shriram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9989",
    "name": "Kadam Sunita Vijay"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "315",
    "name": "Lokhande Vilas Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10945",
    "name": "Momin Mahammadrafique Amirhamja"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12752",
    "name": "Nadar Kanayraj Singandurai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7069",
    "name": "Naik Rajshri R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16737",
    "name": "Nakhava Hemant Kashinatha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14268",
    "name": "Nandusingh Narbahadur Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2640",
    "name": "Pandit Deepak Vasudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15710",
    "name": "Pawar Ankush Anandarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5836",
    "name": "Prajapati  Lavkush"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11472",
    "name": "Sawant Balkrishna Sahebarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5471",
    "name": "Sharma  Zubin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9538",
    "name": "Sharma Geetanjali Yashpal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5455",
    "name": "Shehnaz  Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7393",
    "name": "Shette Asha Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5167",
    "name": "Shirodkar Vishaya Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5412",
    "name": "Telang Nagnath Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15118",
    "name": "Wagh Amar Mahadeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5454",
    "name": "Sawant Suresh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5680",
    "name": "Walmik Ramesh Chhidra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5337",
    "name": "Ranpise Changadev Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "353",
    "name": "Kamble Dnyanu Chokhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7612",
    "name": "Sawant Rajendra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4920",
    "name": "Bafana Roshanlal Mohanlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9871",
    "name": "Dhumal Lalasaheb Bapusaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5247",
    "name": "Phanse Rajaram Keru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5622",
    "name": "Yadav Sambhaji Limbaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11187",
    "name": "Gavhane Ram Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3243",
    "name": "Agrawal Krishnpal B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "744",
    "name": "Mohan Bhikoba Chavan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "409",
    "name": "Eknath Narayan Mane."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5565",
    "name": "Kore Ramesh Madhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10288",
    "name": "Pawar Vinayak Jaywant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11220",
    "name": "Manjrekar Gopichand Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7146",
    "name": "Naik Kumar Pratap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18507",
    "name": "Chavan Ganesh Hanmant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "410",
    "name": "Surve Chandrakant Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12741",
    "name": "Yadav Shivkumar Bendeshwari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2726",
    "name": "Bhohara Jaiseas Mohanseed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3327",
    "name": "Bodare Jaganath Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5849",
    "name": "Kobnak Hirabai Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16211",
    "name": "Sawant Vijay Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9259",
    "name": "Baile Dinkar Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5107",
    "name": "Deshmukh Laxman Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4463",
    "name": "Gujar  D.Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8096",
    "name": "Kadam Sidubai Bhagawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5289",
    "name": "Nair Kumar Chneak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17920",
    "name": "Randive Raju Pramanik."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1001",
    "name": "Pal Motors"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "590",
    "name": "Salunkhe Kusum Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8401",
    "name": "Satelkar Vijay Shridhar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9629",
    "name": "Shinde Ashok Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7310",
    "name": "Shinde Baliram Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10730",
    "name": "Taposh Santosh Mandal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "460",
    "name": "Thale Dhanshri Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11416",
    "name": "Vadakara Vinodkumar Bhaskaran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "475",
    "name": "Bhosale Jagu Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1724",
    "name": "Sawant Baban Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5687",
    "name": "Barge Shivaji Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8919",
    "name": "Gupta Rajendra Ramkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5552",
    "name": "Kharade Shalini Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5268",
    "name": "Gulve Vimal Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4169",
    "name": "Jadhav Shantabai Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "810",
    "name": "Waykar Dinkar Pandrinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1688",
    "name": "Java Girdhar Manohar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7723",
    "name": "Dhanwade Pandit Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8039",
    "name": "Kanse Shobha Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "954",
    "name": "Pal Ramlakhan Siddhnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10524",
    "name": "Anpat Hanmant Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18452",
    "name": "Dabde Satish Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9273",
    "name": "Dixit Dinkar Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13591",
    "name": "Jangam Chetan Hari."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10971",
    "name": "Karadkar Varsha Santosh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7881",
    "name": "Matkar Madhukar Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11166",
    "name": "Patil Vandana Balram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12768",
    "name": "Phalake Anandrao Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23254",
    "name": "Sonar Sachin Rambhadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6673",
    "name": "Thakur Krishnakumar/Vyankatesh Inzapuri\\"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3761",
    "name": "Mulik Baburao Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7835",
    "name": "Shine Balasaheb Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8913",
    "name": "Nikalji Baburao Appaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1629",
    "name": "Ahamed Rais Khalil."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14916",
    "name": "Kadam Kanchana Nanaso ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "332",
    "name": "Jamdagni Balkrishna Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3350",
    "name": "Jadhao Dnyandeo Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3445",
    "name": "Pawar Baburao Rama"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5403",
    "name": "Ingulkar Dattatray Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3340",
    "name": "Ghorpade Dnyandev Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20594",
    "name": "Borge Prakash Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8430",
    "name": "Gaikwad Vinod Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8580",
    "name": "Jadhav Vishwas Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5160",
    "name": "Kadam Usha Uattamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7419",
    "name": "Madavi Ramnath Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11656",
    "name": "Mane Shivaji Bajarang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10185",
    "name": "Phalke Shankar Mahipati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18248",
    "name": "Ranware Panditrao Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12078",
    "name": "Shirswade Satish Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4309",
    "name": "Bhosale Baburao Ravji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4224",
    "name": "Khadaka Birsingh Dilipsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5572",
    "name": "Phadatare Ramchandra Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3367",
    "name": "Padale Housabai Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15417",
    "name": "Deshmukh Parbati Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5180",
    "name": "Gaikwad Parakash Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3110",
    "name": "Bhoite Sahebrao Mugatarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18312",
    "name": "Dholkia Tushar C."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3912",
    "name": "Deshmukh Nanasaheb Dagadoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16967",
    "name": "Bhosale Sham Yashwant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4996",
    "name": "Boudhajan Vikas Sangh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "108",
    "name": "Dewasi Rajuram Bhomaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13510",
    "name": "Doshi Amit Bhupendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14466",
    "name": "Ghone  Vasudeo Bapuji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11036",
    "name": "Hedge Baba Abha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13967",
    "name": "Kamble Jagannath Bhikaji."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "458",
    "name": "Kondhalkar Vilas Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5692",
    "name": "Sutar Vishvanath Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7768",
    "name": "Shinde Saraswati Suresh/Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4695",
    "name": "Bhosale Nandkumar Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4502",
    "name": "Pallavi Equipments And Chemicals"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10528",
    "name": "Bobhate Gorakh Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4625",
    "name": "Palmary Plantations Ltd."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11601",
    "name": "Gaikwad Ashok Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10837",
    "name": "Gurav Uddhav Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12793",
    "name": "Jagtap Vijay Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6694",
    "name": "Kawar  Balkrishna."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12560",
    "name": "Nalge Fatteshingh Balaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19531",
    "name": "Sawant Anil Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9991",
    "name": "Shelke Kavita Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15184",
    "name": "Shinde .Kisan Manaji."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3743",
    "name": "Palsetia Pradeep Ramaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13186",
    "name": "Shiv Krupa Bldg No -15  Kandivili-W"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11275",
    "name": "Yadav Shashikala Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5693",
    "name": "Dixit Shantaram Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3914",
    "name": "Palwankar Hemangi Hemant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7784",
    "name": "Bhosale Sadhana Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5524",
    "name": "Kalwale Mohan Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9124",
    "name": "Patil Satish Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1868",
    "name": "Nawadkar Balwant Vithoba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14076",
    "name": "Chaudhari Durga Lalbahadur."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3009",
    "name": "More Shankar Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7986",
    "name": "Banarashi  Kushwah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13668",
    "name": "Dalvi Shivaji Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8513",
    "name": "Ghadge Sampat Nathyba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17815",
    "name": "Gulab Jaffar Hussian"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11217",
    "name": "Jagatap Sabhaji Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5419",
    "name": "Joseph K V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15359",
    "name": "Kapadia Kasyap Jawahar."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2173",
    "name": "Modi Sharad Rajkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10461",
    "name": "Moklingam C Murugaiah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8566",
    "name": "Rahaman Md Hafigue"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3471",
    "name": "Borkar Roma Rajendra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8465",
    "name": "More Vishnu Anant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11992",
    "name": "Gujar Dropada Sopan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "654",
    "name": "Patil Devyani Devanand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11347",
    "name": "Ranbhare Mahesh Sudhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4741",
    "name": "Shinde Dhondubai Ganaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3887",
    "name": "Kokil Shivaji Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5124",
    "name": "Shirwadkar Pravina Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3174",
    "name": "Sakunde Shiwaji Parsharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3971",
    "name": "Kudale Maruti Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6679",
    "name": "Pisal Shankar Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12174",
    "name": "Bhoite Baban Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17558",
    "name": "Building D-3 A Wing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4545",
    "name": "Chachad Vijay P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17609",
    "name": "Gaikwad Baban Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12502",
    "name": "Jadhav Ashok Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8081",
    "name": "Jadhav Madhukar Vishwash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17622",
    "name": "Lad Sushma Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15733",
    "name": "Mahadik Tukaram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7544",
    "name": "Mokasare P F/Yelrale D S /Bajte N R"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10435",
    "name": "More Sakhubai Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17595",
    "name": "Pawar Rajkumar Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11247",
    "name": "Pednekar Surekha Gokul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "151",
    "name": "Lajwanti Shankar Pawar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3594",
    "name": "Wagh Sushila Gulab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10073",
    "name": "Yetapay Ganpat Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1790",
    "name": "Pawar Sanjana Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3741",
    "name": "Yadav Satiram Nageshwar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "374",
    "name": "Teli Sudhakar Savlaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3609",
    "name": "Bhosale Sonabai Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1102",
    "name": "Bhosale Namdeo Krushnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3387",
    "name": "Ghatwal Suhas Gunawant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6721",
    "name": "Ghopade Anilkumar Mansingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10022",
    "name": "Bhosale Kailas Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10979",
    "name": "Chavan Malan Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13664",
    "name": "More Deepak Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8491",
    "name": "Salavi Ajay Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13057",
    "name": "Shinde Navnath Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3735",
    "name": "Kadam Chandrabai Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12721",
    "name": "Ghorpade Dattatray Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5338",
    "name": "Sanas Hanumant Laxmanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10686",
    "name": "Patel Munaji Nanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "258",
    "name": "Prabhavati Ravindra Desai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6149",
    "name": "Kareuar Chandrakant Narhari/Minal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8375",
    "name": "Rout Balu Gopinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1335",
    "name": "Kenjale Balwant Piloba."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8903",
    "name": "Kadam Dinkar Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5101",
    "name": "Sapate Vasant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15807",
    "name": "Ahier Sarla Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8823",
    "name": "Gawade Ravindra Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17386",
    "name": "Gurav Ashok Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10044",
    "name": "Jadhav Hanmant Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17293",
    "name": "Jadhav Kisan Kundlika"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5234",
    "name": "Jamindar Haya Irfan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12349",
    "name": "Kammar Narendra Shashikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6644",
    "name": "Mane Savitri Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23296",
    "name": "Nalage Snehal Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18476",
    "name": "Nimbre Devendra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7834",
    "name": "Sadashivajan  G"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12997",
    "name": "Sankpal Viral Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7899",
    "name": "Sawant Pravin Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5267",
    "name": "Sawant Uttam Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5097",
    "name": "Shah Rashimikant J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5217",
    "name": "Shah Shilpa Akshay/Akshay Shah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6105",
    "name": "Singh Virendra V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6754",
    "name": "Solanki Chandu Bhika/Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11903",
    "name": "Thovender Palpandi Godaswami"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5455",
    "name": "Kadam Shanta Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2662",
    "name": "Ghadge Shevanta Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9775",
    "name": "Kanemani  Ailaiah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1142",
    "name": "Amol Khandekar Tempo Service"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5397",
    "name": "Kshirsagar Jagannath Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8979",
    "name": "Salunkhe Sadashiv Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8842",
    "name": "Jadhav Rajendra Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4897",
    "name": "Jadhav Sadashiv Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2572",
    "name": "Bhosale Shashikant Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2684",
    "name": "Chavan Narayan Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5139",
    "name": "Phalke Trimbak Gopalrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2209",
    "name": "Shinde Subash Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14143",
    "name": "Bhosale Suraj Sunil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21723",
    "name": "Dhakal Smita Ramkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12817",
    "name": "Gaikawad Rueben Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9880",
    "name": "Jadhao Dattatray Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8004",
    "name": "Jadhav Dinkar Jagu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3467",
    "name": "Pandey Ganesh Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17501",
    "name": "Keni Sunil Sadanand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "994",
    "name": "Pandhre Dhanraj Mahadev"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "420",
    "name": "Patil Deepak Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12363",
    "name": "Pawar Jeevita Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18824",
    "name": "Salunkhe Kusum Rangrav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12111",
    "name": "Shinde Dattu Vyankatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12792",
    "name": "Shinde Sachin Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7522",
    "name": "Shinde Shantaram G"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3569",
    "name": "Pandey Omprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1551",
    "name": "Prabhu Vithal S"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7903",
    "name": "Sakunde Dhanaji Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12134",
    "name": "Kate Mahadeo Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9022",
    "name": "Devkar Ankush Ramu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10906",
    "name": "Salunkhe Mohan Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5313",
    "name": "Badge Pandurang Gayanoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10279",
    "name": "Bane Chandrakant Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9042",
    "name": "Chavan Pradip Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9821",
    "name": "Chavan Sunanda H/Hanmant Jaganath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5903",
    "name": "Chheda Amrut Kunverji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16348",
    "name": "Desai Chandrakant Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5128",
    "name": "Dighe Navin Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15432",
    "name": "Jadhav Abhinay Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5397",
    "name": "Jadhav Dattaram Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11885",
    "name": "Jadhav Latifa Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8466",
    "name": "Jambhale Jayawant Krishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15330",
    "name": "Khatav Yogendra Ghanshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7175",
    "name": "Lad Rajeshbhai Kalyanbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5158",
    "name": "Patsute Mukund Bhagwan/Meena Mukund"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17261",
    "name": "Pujari Gulabi Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4753",
    "name": "Shetty Dinesh Shisha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4386",
    "name": "Jadhav Vilasrao Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6381",
    "name": "Shinde Baban Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9057",
    "name": "Mulik Subhash Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3468",
    "name": "Phalke Rajendra Vithalrao."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8665",
    "name": "Gaikawad Ananda Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1954",
    "name": "Pujari Popat Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8085",
    "name": "Lotekar Dwaraka Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9637",
    "name": "Murarka  Kamaldevi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8713",
    "name": "Nandeshwar Arun Ramappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1898",
    "name": "Salunkhe Bhanudas Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3945",
    "name": "Ambekar Sunanda Sudhakar."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "981",
    "name": "Agrawal Raju Ramniwas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1138",
    "name": "Borde Laxman Omkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17114",
    "name": "Chavan Shubhangi Subhash"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1144",
    "name": "Gaikwad Subhash Pundalik"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1134",
    "name": "Gawai Prakash Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17008",
    "name": "Harsora Anita Ranjit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15483",
    "name": "Jadhav Pralhad Bajirao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1125",
    "name": "Kadam Satish Genu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14113",
    "name": "Kohali Ravinder Singh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3259",
    "name": "Kumbhar Amrutrao Chinku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8966",
    "name": "Malpekar Nanda Avinash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11948",
    "name": "Pawar Rajaram Dhondi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12401",
    "name": "Pawar Vachhala Anna"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1310",
    "name": "Rajbhar Kuntidevi Harinath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1131",
    "name": "Salekar Sarjerao Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8631",
    "name": "Shelar Hausabai Kisan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1003",
    "name": "Vise Nagnath Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1399",
    "name": "Devarshi Sampatsavala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3385",
    "name": "Yadav Narayan Appa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "265",
    "name": "Kadam Ravindra Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8116",
    "name": "Bhagat Kamal Dada"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2306",
    "name": "Bhandari Hirubai Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11883",
    "name": "Agre Mahadev Ganaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11567",
    "name": "Bhosale Pramod Nivaruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12297",
    "name": "Chavan Nitin Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8232",
    "name": "Choursia Ram P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18293",
    "name": "Gaikwad Varsha Bhausaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20222",
    "name": "Ghandat Meena Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19008",
    "name": "Sawant Pandurang Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12635",
    "name": "Shahana Tanlija Ajgarali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14004",
    "name": "Solanki Manisha Manoj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5617",
    "name": "Vaghamare Shivaji Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4087",
    "name": "Chauhan Mullalal Gayadhin."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3928",
    "name": "Panchal Maruti Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1437",
    "name": "Nalawade Sakhubai Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10016",
    "name": "Verma Neeta Satyaprakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3263",
    "name": "Pankaj M Shah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "771",
    "name": "Ramesh Santaram Bhandari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9041",
    "name": "Vaity Navina Saphraras"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1071",
    "name": "Dattaram M. Tawade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1783",
    "name": "Pavri Chandrakant Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1866",
    "name": "Saigaonkar Vasant N."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5914",
    "name": "Dhanave Mohan Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9139",
    "name": "Gujar Gopaldas Vithaldas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12334",
    "name": "Jadhav Arun Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17921",
    "name": "Khan Karam Husain"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13158",
    "name": "Kharat Nanaso Kumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10605",
    "name": "Pidal Dnyanoba Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16245",
    "name": "Shahu  Ramesh Damu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22336",
    "name": "Shaikh Raja Yusuf"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5637",
    "name": "Patil Balkrishan Aba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7791",
    "name": "Reedy Laxman Yadhagiri"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4953",
    "name": "Kadam Mandakini Gandharva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9243",
    "name": "Rane Chandrakant Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3763",
    "name": "Lohar Suman Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16937",
    "name": "Bhosale Kiran Tanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11980",
    "name": "Gaikawad Appaso Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15915",
    "name": "Jaysi  Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16896",
    "name": "Kadam Anusaya Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11963",
    "name": "Kumbhar Shankar Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18503",
    "name": "Name Ramesh Ranu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "885",
    "name": "Pawar Santosh Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11349",
    "name": "Sabale Subhash Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10016",
    "name": "Sane Bipin Vasudeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5114",
    "name": "Kochikar Suresh Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7045",
    "name": "Salaskar Sumati Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6135",
    "name": "Kashid Sampat Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8795",
    "name": "Liddad Kiransing Shitalsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4319",
    "name": "Sakharkar Madhav Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6681",
    "name": "Jadhao Satish Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2251",
    "name": "Alam  Aftab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7415",
    "name": "Bobade Sindhu Ramdas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "884",
    "name": "Chavan Hanumant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18551",
    "name": "Chavan Vishwanath Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11524",
    "name": "Jadhav Manik Anturam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5226",
    "name": "Jadhav Rajendra Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10199",
    "name": "Lohar Kamalakar Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23283",
    "name": "Masal Sanjeev Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12495",
    "name": "Mishra  Mukesh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "671",
    "name": "Patel Mahesh Punjalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6886",
    "name": "Samant Sukhdev Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5919",
    "name": "Savekar Sanjay Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12259",
    "name": "Shah Nerupama Ambalal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12298",
    "name": "Shirtode Pralhad Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5051",
    "name": "Solani Rekha A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16732",
    "name": "Thakur Kanhaiya Chulhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5948",
    "name": "Veersingh  Lalbahaddur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2791",
    "name": "Patil Dattaram Ramjee  ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "337",
    "name": "Datir Maruti Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3866",
    "name": "Patel Pralhadbhai Manilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6998",
    "name": "Fernandes  Marie"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3332",
    "name": "Gadhave Ramchandra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12653",
    "name": "Gidday Shailesh Basappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12632",
    "name": "Gujar Eknath Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14197",
    "name": "Kambale Pandurag Bajirao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6904",
    "name": "Kambale Suman Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16761",
    "name": "Manjrekar Niketan Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10206",
    "name": "Naik Laxman Sahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17041",
    "name": "Newrekar Uttam Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21590",
    "name": "Pataria Santoshkumar Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2641",
    "name": "Potdar Ramchandra D ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13539",
    "name": "Rajpurohit Amar Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16777",
    "name": "Sharma Vijaykumar Girindraprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10914",
    "name": "Shelke Suryakant Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9046",
    "name": "Singh Amarjeet Vijaybahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12689",
    "name": "Solkar Dhondu Babya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19564",
    "name": "Waghela Nagin Dosa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8284",
    "name": "Yerunkar Naresh Dadabhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "86",
    "name": "Patil Appaso Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "210",
    "name": "Chandrakant Sarjerao Phalke."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3870",
    "name": "Mithani Manish Gunvantrai."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7064",
    "name": "Jadhav Prabhakar Marutrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "929",
    "name": "Joshi  R.H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4293",
    "name": "Wakkar Aruna Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "956",
    "name": "Rajbhar Satiram Savaru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11221",
    "name": "Davda Jayshree Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2717",
    "name": "Gaikwad Dnyadeo Aabaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7271",
    "name": "Lembhe Prakash Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8285",
    "name": "Waghchowre Ramesh Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13682",
    "name": "Lokhande Umesh S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4436",
    "name": "Gupta Latadevi M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "838",
    "name": "Kusum"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13236",
    "name": "Phalke Shivaji Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "262",
    "name": "Jadhav Laxman Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8914",
    "name": "Gadhave Ashok Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3986",
    "name": "Kamble Nandkumar Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2090",
    "name": "Paramount Floor -Coating Industries"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4306",
    "name": "Paras Packing Works"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2295",
    "name": "Sakunde Narayan Dhondiram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "630",
    "name": "Behera Laxmidhar Pitambar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3663",
    "name": "Pawar Vasantrao Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9533",
    "name": "Patil Deepak Krushnaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2386",
    "name": "Paresh Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "188",
    "name": "Parfect Binders"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12131",
    "name": "Damakale Raghunath Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10246",
    "name": "More Anusaya Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12062",
    "name": "Nikam Dattu Tukarm"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1002",
    "name": "Shinde Swapnil Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8482",
    "name": "Kharat Vijaya Lala"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4287",
    "name": "Parkash Kumar J Rawal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9047",
    "name": "Jagdale Sanjay Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1247",
    "name": "Phalke Sakharam Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8743",
    "name": "Shinde Chhayadevi Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8742",
    "name": "Shinde Jagannath Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8297",
    "name": "Takate Dattatray Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7843",
    "name": "Salunkhe Rohini Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21645",
    "name": "Hate Sandesh Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12578",
    "name": "Jagdale Namdeo Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12689",
    "name": "Kambale Jivraj Sakharam"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "27",
    "name": "Zanzane Shankar Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3428",
    "name": "Parmar Rajbahadursingh"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1266",
    "name": "Parsekar Polythene"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7145",
    "name": "Magar Subhash Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "660",
    "name": "Khodagale Suvarna Prafull"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8276",
    "name": "Sakunde Namdeo Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10974",
    "name": "Zanzurne Hirabai Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1883",
    "name": "Alagude Shivaji Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13009",
    "name": "More Satish Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8889",
    "name": "Ghodke Ranjeet Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11722",
    "name": "Pawar Shila Abaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "441",
    "name": "Phadatare Deepak Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10847",
    "name": "Rasal Suman Sopan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "747",
    "name": "Sarafe Deepak Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "269",
    "name": "Chavan Marutrao Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22276",
    "name": "Honrao Dyaneshwar Trimbak"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "70",
    "name": "Mhatre Jagdish Vishnu"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "185",
    "name": "Nadar Raj Shanmugam"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "393",
    "name": "Shah Rajendra Shamsunder"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4110",
    "name": "Pawar Shewantabai Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11471",
    "name": "Chavan Chhaya Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10360",
    "name": "Kadam Nandkumar Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13066",
    "name": "Phalke Mansing Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1274",
    "name": "Shinde Hunderao Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2811",
    "name": "Chavan Balkrishna Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7439",
    "name": "Wagh Tukaram Krushana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2279",
    "name": "Salunkhe Vasant Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7554",
    "name": "Khandale Pandurang Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1860",
    "name": "Patel Alpa Nitin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12414",
    "name": "Bhosale Vishwanath Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11496",
    "name": "Ghadage Sindhu Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1490",
    "name": "Jadhav Ramesh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7080",
    "name": "Kokane Pandurang Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2155",
    "name": "Chatur Sakhubai Pillu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6954",
    "name": "Kenjale Anant Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6728",
    "name": "Randive Vidhyadevi Yashwant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1093",
    "name": "Deshmukh Rajesh Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19697",
    "name": "Jyotiben Dhansukhbhai Kerawala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21886",
    "name": "Pachangane Sadhana Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5712",
    "name": "Apandkar Chandrakant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13220",
    "name": "Baser Jagdishchandra Pannalalji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7486",
    "name": "Ghag Manisha Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6193",
    "name": "Indalkar Sanjay Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10386",
    "name": "Jagdale Jotiram Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12633",
    "name": "Jagtap Surekha Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9740",
    "name": "Joshi Alka Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16624",
    "name": "Kandekar Sushila Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9101",
    "name": "Pandya Vijay Bhartbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9071",
    "name": "Parab Rajesh Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17848",
    "name": "Saroj Nirmala Dhanaguram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11698",
    "name": "Shaikh Jaiboon Rafik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11442",
    "name": "Singh Rakesh Bankelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13302",
    "name": "Tengaskar Swati Sudhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3491",
    "name": "Keni Francis Manvel."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "96",
    "name": "Dhumal Shankar Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4685",
    "name": "Murthyrao Chimangala Krishna/Mrs.Sundara"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5273",
    "name": "Bhandari Mahadeo Harishwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4364",
    "name": "Thakur Amarsing Gopinath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1138",
    "name": "Lad Sandhya Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5681",
    "name": "Awade Satyawan Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3843",
    "name": "Patel Narayanbhai Sukhabhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5654",
    "name": "Jadhav Prakash Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3424",
    "name": "Rajbhar Satiram Savaru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4188",
    "name": "Chile Anant Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6971",
    "name": "Waigankar Radha Shyam/Shyam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10194",
    "name": "Gaikwad Vitthal Baba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21530",
    "name": "Joshi Narayan Dharamlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13521",
    "name": "Kambale Vilas Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7029",
    "name": "Krishnan  S.R."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9985",
    "name": "Mulla Rameja Akalaka"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7487",
    "name": "Pisal Balkrushna Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16609",
    "name": "Prajapati Vindhyachal Lawjari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13093",
    "name": "Tupe Dilip Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12374",
    "name": "Choudhary Vaishali Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15729",
    "name": "Gupta Bidawasini Shivakumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9219",
    "name": "Kakad Girish Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10117",
    "name": "Khan Nasir Nazir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16540",
    "name": "Khilare Pandurang Sukhadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4401",
    "name": "Pawar Sunil Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7051",
    "name": "Rimal Rajprasad Shivalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5375",
    "name": "Rite Pushpa Dattatray"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1625",
    "name": "Sahu Surendra Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17336",
    "name": "Waghari Kanti Bala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4054",
    "name": "Sadik S. Halani."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4165",
    "name": "Shinde Gopal Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1838",
    "name": "Patel Ramkishor Ori"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5512",
    "name": "Wagholikar Vitthal Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3078",
    "name": "Phalake Laxaman Madhaorav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5606",
    "name": "Bhoite Rajendra Sadashiv"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "804",
    "name": "Choudhary Babulal Pannaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11585",
    "name": "Jadhao Nanda Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12066",
    "name": "Kadam Sarjerao Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2683",
    "name": "Anpat Sarswati Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1816",
    "name": "Pawar Shalan Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13037",
    "name": "Ghadge Shivaji Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6602",
    "name": "Babar Jayantarao Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9837",
    "name": "Pisal Shaila Jalindar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5667",
    "name": "Bhujbal Aba Khandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23345",
    "name": "Jain Nitesh Karulal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12825",
    "name": "Shinde Nitin Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8564",
    "name": "Bhosale Dipak Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8552",
    "name": "Jadhav Sujata Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8554",
    "name": "Mane Sunil Hanmantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8553",
    "name": "Vanjari Shushhama Shyamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2742",
    "name": "Sabale Ashok Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10676",
    "name": "Chavan Toliram Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14030",
    "name": "Mandavkar Vijay Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11105",
    "name": "Nikam Sangeeta Navnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18159",
    "name": "Rangane Krishna Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1539",
    "name": "Pawar Bhimrao Baji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7906",
    "name": "Shinde Deepak Trimbak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8682",
    "name": "Chatur Ganpat Mugutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8531",
    "name": "Kulkarni Makarand Shridhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8533",
    "name": "Magar Subhash Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8532",
    "name": "Shah Ghanshyam Natwarlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8544",
    "name": "Jadhav Reshma Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9995",
    "name": "Barge Santosh Sasharath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12478",
    "name": "Jadhav Dattatray Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10933",
    "name": "Kale Shriniwas Shashikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10752",
    "name": "Phalke Jagannath Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2027",
    "name": "Phalke Uma Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "446",
    "name": "Bhosale Anandrao Vitoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6826",
    "name": "Sankpal Umakant Krushanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "501",
    "name": "Gopal Nalini Lambodar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8359",
    "name": "Bhoite Dhansing Mansingrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "338",
    "name": "Bhosale Ramesh Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20055",
    "name": "Mahadik Shilpa Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8207",
    "name": "Gargote Shankar Ramgonda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1909",
    "name": "Gujar Sarswati Ganesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6789",
    "name": "Jadhao Dadasaheb Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2135",
    "name": "Gosrani Dipesh Gulabchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2871",
    "name": "Bhosale Vishwash Narsingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4328",
    "name": "Kadam Shivaji Shriram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1747",
    "name": "Jadhav Laxman Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2821",
    "name": "Jadhav Bhagirthi Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11115",
    "name": "Dhumal Pandharinath Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12630",
    "name": "Godase Vishnu Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9780",
    "name": "Kambale Bhimabai Jayaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12697",
    "name": "Pisal Dattatray Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2406",
    "name": "Kadam Kashinath Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8555",
    "name": "Pawar Mahadeo Martand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4786",
    "name": "Gupta Sunita Ramprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3729",
    "name": "Raturi Shivnandan H."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1504",
    "name": "Kadam Mansing Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2663",
    "name": "Korade Anjali Pramod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16584",
    "name": "Surve Bhalchandra Shamsundar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3096",
    "name": "Dheb Ratnakant Bhau ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1556",
    "name": "Sawant Kalidas Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3974",
    "name": "Chhagan Vasava Lalu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3725",
    "name": "Chodhani Nandakishor V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3970",
    "name": "Farnandes D. Joseph."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4646",
    "name": "Kadam Kusum Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1923",
    "name": "Roman Madhukara Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18489",
    "name": "Bhoite Revannath Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17333",
    "name": "Chouhan Surendra Shirpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14711",
    "name": "Gawade Uttam Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16813",
    "name": "Ghagre Ashok Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17964",
    "name": "Kadam Surekha Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8049",
    "name": "Khatav Sukhita Devendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8784",
    "name": "Khedekar Namrata Nitin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11152",
    "name": "Punawala Liyakat Husen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7879",
    "name": "Rawale Swati S ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7723",
    "name": "Shah Prakash H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16489",
    "name": "Shaikh Yusuf Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8986",
    "name": "Vaikul Prasad Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13023",
    "name": "Kambale Prakash Damu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6384",
    "name": "Dayal Sheela Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9184",
    "name": "Pawar Nandkumar Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15821",
    "name": "Lad Snehal Jagdish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4075",
    "name": "Kumavat Nanuram Girdharilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3856",
    "name": "Rajpurohit Mahadusing Faujrajsing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17938",
    "name": "Pojari Deepar Channapa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2402",
    "name": "Gandage Vaijnath Raghunath ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10893",
    "name": "Rajpure Sunil Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16093",
    "name": "Bendke Shivram Dhakatu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15930",
    "name": "Deshamukha Jayshree Kailasrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9141",
    "name": "Gimban Budhiya Devji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22778",
    "name": "Gotise Akash Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12093",
    "name": "Halankar Anand Ladoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21810",
    "name": "Jadhav Ashit Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11780",
    "name": "Matkar Vishnu Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10471",
    "name": "Pande Vindeshwari Prasad Kailasnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17952",
    "name": "Raje Bhagyawanti Megnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22801",
    "name": "Rijal Lokendra Jagdish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20973",
    "name": "Sabale Hanumant Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4443",
    "name": "Seliya Abida M."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10691",
    "name": "Srode Mohan Daulat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18659",
    "name": "Tarlekar Anil Pandharinath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8207",
    "name": "Telang Vitthal Gundaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18278",
    "name": "Lotekar Shrirang Hariba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3769",
    "name": "Jadhav Asha Dattatrya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3805",
    "name": "Joseph  Antony."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1463",
    "name": "Shinde Rukmini Yashwant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4329",
    "name": "Naresh Vishwanath Phaltanr"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1157",
    "name": "Shinde Sunil Atmaram B-7718"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3804",
    "name": "Kokare Sangita Laxman."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6838",
    "name": "Bahirat Snehalata Sumit"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8192",
    "name": "Ghadage Gorakhnath Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8794",
    "name": "Sutar Vikas Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "588",
    "name": "Kadam Vasant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17711",
    "name": "Aawade Pratap Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8329",
    "name": "George  Rovina"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4776",
    "name": "Govander Jeena Sunny"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13385",
    "name": "Jagtap Mahadeo S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16328",
    "name": "Jaiswal Savalal Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6751",
    "name": "Kadam Suman Lahuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7227",
    "name": "Mhatre Devdutta Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9973",
    "name": "Pote Prasad Nagesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7177",
    "name": "Rais Zulekha Usuf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11293",
    "name": "Rawandale Kasturibai Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5432",
    "name": "Sampat Chandrayya L"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11240",
    "name": "Yadav Kailashnath Govardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3938",
    "name": "Desai Sanjay Shivshankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3695",
    "name": "Dubali Ashok Vitthal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14068",
    "name": "Datt Narayan Chandramohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2508",
    "name": "Pulayya Jagannath Moglay."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1798",
    "name": "Lad Balkrishna Dagdoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7343",
    "name": "Shinde Ramesh Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "549",
    "name": "Tukaram Daulatrao Metil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9039",
    "name": "Ghag Sulbha Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7818",
    "name": "Salunkhe Ranjana Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "87",
    "name": "Salate Sitaram Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8996",
    "name": "Shirtode Mohan Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4763",
    "name": "Chatur Nivrutti Piloba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22803",
    "name": "Chavan Amol Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22345",
    "name": "Kadam Ashok Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12017",
    "name": "Phalke Shobha Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12268",
    "name": "Pisal Namdeo Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15794",
    "name": "Salunkhe Ashwini Rajendra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19613",
    "name": "Sheth Vinodrai Himmatlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "70",
    "name": "Babanrao Yadavrao Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16741",
    "name": "Bankar Harish Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10799",
    "name": "Bhosale Mahadeo Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11743",
    "name": "Chadankar Raghoba Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5697",
    "name": "Chavan Archalata Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15307",
    "name": "Gade Saru Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6620",
    "name": "Khamborkar Suresh Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13178",
    "name": "Lalan Bhanu Abhay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15380",
    "name": "Mangale  Tanaji Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5147",
    "name": "Parab Gurudas Digambar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18092",
    "name": "Pramanik Kamal Jogen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4565",
    "name": "Rasal Sampat Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12656",
    "name": "Saiyad Ramjan Babalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14241",
    "name": "Sawant Suresh Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7273",
    "name": "Shah Manjurali Mohmadali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9679",
    "name": "Sunkhe Narsaya Yalayya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10257",
    "name": "Zhajurne Vishnu Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3540",
    "name": "Lembhe Vilas Namdeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3687",
    "name": "Shekavkar Vinod Baliram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5324",
    "name": "Mane Appaso Kakaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5322",
    "name": "Sawant Kamal Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4962",
    "name": "Choudhari Satish Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14",
    "name": "Shinde Balwant Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4117",
    "name": "Bhosale Kusum Chandraknt"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3401",
    "name": "Pawar Kumar Shankar ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3430",
    "name": "Shyamsundar Sengrodea ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3578",
    "name": "Kale Laxman Genu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3682",
    "name": "Jana Mangal Arjun."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14117",
    "name": "Pagare Vijay Krishna."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2841",
    "name": "Kadam Rambhau Gyanba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6822",
    "name": "Gaiwade Asha Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9499",
    "name": "Gupta Kashinath Shaymlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11891",
    "name": "Jadhav Ankush Subhedar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4363",
    "name": "Jaiswal Rankhilawan Vasanta."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12966",
    "name": "Kadam Tukaram Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17695",
    "name": "Kamble Ramesh Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10799",
    "name": "Mahadik Pushpa Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7853",
    "name": "Medage Ragunath Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10260",
    "name": "Patil Nalini Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8517",
    "name": "Sherali  Moharamali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3821",
    "name": "Kawar  Balkrishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3366",
    "name": "Goyal Gulabchand G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3312",
    "name": "Kadav Jijabai Raghunath ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12122",
    "name": "Shaikh Hajarabi Umar Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5077",
    "name": "Gaikwad Murlidhar B"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4270",
    "name": "Mulik Atmaram Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17064",
    "name": "Mulani Javed Papamiya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10600",
    "name": "Nikam Sarjerao Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15624",
    "name": "Deshmukh Anandrao Vamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7711",
    "name": "Pisal Yeshwant Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11363",
    "name": "Sawant Ramchandra Yashwantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12395",
    "name": "Shah Pravinchandra A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7136",
    "name": "Sawant Gajanan Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13431",
    "name": "Ansari Farida Akbar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7079",
    "name": "Chavan Sharda Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18811",
    "name": "Jagtap Subhash Kisanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11489",
    "name": "Kadam Bhagirathi Madhao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16295",
    "name": "Kashte Vimal H"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13938",
    "name": "Koltharkar Ganpat Kashinath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14423",
    "name": "Mishra Raju Badriprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19759",
    "name": "Nimbalkar Pravin Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4834",
    "name": "Patel Mahesh Parag"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10305",
    "name": "Paul M Swamy Manikram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7788",
    "name": "Pisal Tahe Shamram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7964",
    "name": "Rajbhar Satiram Savaru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14261",
    "name": "Valani Dharmishta Ramesh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10427",
    "name": "Laud Sundara Mangesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5108",
    "name": "Ghorpade Sampatrao Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10644",
    "name": "Pote Suryakumar Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1993",
    "name": "Suryavanshi Anusaya Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4020",
    "name": "Jagtap Hanmant Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4202",
    "name": "Kadam Bharat Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3290",
    "name": "Mathuria Prataprai P."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1296",
    "name": "Pisal Jaising Daduji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3703",
    "name": "Chavan Pandurang Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3405",
    "name": "Masurekar Subhash B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3088",
    "name": "John  Johnson"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10035",
    "name": "Jagtap Dilip Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6424",
    "name": "Mashallar C.Kar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6174",
    "name": "Pachange Radhabai Namdevrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "484",
    "name": "Bhoite Vinayak Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15936",
    "name": "Acharekar Ramanand Shadev."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16621",
    "name": "Bate Tanaji Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21663",
    "name": "Chavan Kiran Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5151",
    "name": "Choudhari Rajak Daul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19030",
    "name": "Gauda Basavraj Mallya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5023",
    "name": "Jadhav Kamal Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7938",
    "name": "Kangutkar Surendra Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4950",
    "name": "Kheratkar Rekha Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7240",
    "name": "Khurshid Ahmed Ibnehasan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9890",
    "name": "Madhare Mahadeo Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10904",
    "name": "More Dyandeo Genaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4827",
    "name": "Pawar Pratibha Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5705",
    "name": "Pawar Usha Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6075",
    "name": "Shyamsundar Kalashala Manvala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13554",
    "name": "V  Thivakaniammal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1438",
    "name": "Gandiarvind  Bhagwandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13089",
    "name": "Ojha  Kewalchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1529",
    "name": "Matre Balu Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11069",
    "name": "Sharma Sharmishtha H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5562",
    "name": "Rai Ram Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4870",
    "name": "Pawar Mansingh Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2427",
    "name": "Pawar Namdeo Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5734",
    "name": "Yewale Suresh Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4068",
    "name": "Ahirekar Daivata Gorakh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "898",
    "name": "Chavan Bhagirathi Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3800",
    "name": "Gupta  Ramlakhan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4640",
    "name": "S.S.Works"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10998",
    "name": "Sankude Sayajirao Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12175",
    "name": "Kadam Ashok Shripat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5870",
    "name": "Gawde Ramakant Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13790",
    "name": "Rungaswamy"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2700",
    "name": "More Shrirang Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3952",
    "name": "Hasmatullah  Munnabhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3844",
    "name": "Kadam Amol Bhausaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5432",
    "name": "Satya Niwas Bhadekaru Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4846",
    "name": "Lembhe Prakash Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3976",
    "name": "Tondkar Sanjay Digambar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14255",
    "name": "Sonawane Sunil Ramchandra."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6143",
    "name": "Verlekar Shaila Pandharinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6148",
    "name": "Kadam Pralhad Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7153",
    "name": "Yewale Chandrakant Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12405",
    "name": "Kadam Pandurang Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12417",
    "name": "Shah Nita Chetan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12537",
    "name": "Tiwari Gyandar Harishankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10753",
    "name": "Awade Pratap Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12027",
    "name": "Barge Krishnabai Dasharath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15094",
    "name": "Gole Nitin Narsingh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14201",
    "name": "Jaiswal Paluram Rampyare ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17549",
    "name": "Matkar Jayprakash Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10761",
    "name": "Palve Kisan Govindrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15015",
    "name": "Patel Vishal Jitendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13998",
    "name": "Patil Rupali Ganesh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16101",
    "name": "Rewale Kamlesh V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12125",
    "name": "Suryavanshi Pramod Bhagwanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14558",
    "name": "Vadday  Naresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6078",
    "name": "Pisal Balasaheb Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2936",
    "name": "Rayis  Anjum Yusuf"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8034",
    "name": "Jamdade Dinkar Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4989",
    "name": "Kadam Kantabai Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12044",
    "name": "Chavan Shivaji Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12313",
    "name": "Dalvi Vasant Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11648",
    "name": "Jadhav Chandrakant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15408",
    "name": "Pawar Vilas Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2488",
    "name": "Phalke Namdeo Jijaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5643",
    "name": "Bhandari Kalpana Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9997",
    "name": "Chavan Ravindra Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6071",
    "name": "Dhawdaskar Ashok Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6384",
    "name": "Hojge Dharma Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7025",
    "name": "Joshi Devilal B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10614",
    "name": "Khan Zaheda Zaffrullah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17260",
    "name": "Mehatar Prabhakar Kashiram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5763",
    "name": "Narkar Vaishali Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13607",
    "name": "Phalke Abhimanu Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15062",
    "name": "Salunkhe Hanmant Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22024",
    "name": "Shinde Chandrabai Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5551",
    "name": "Jadhav Digambar Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3041",
    "name": "Yejarkar Atmaram Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3459",
    "name": "Singh Rakesh Ramshringar."
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "256",
    "name": "Patil&Patil Assciates"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4102",
    "name": "Usman Mohmhed Jakir Mohmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3109",
    "name": "Monani Bhanumati Praveenchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2270",
    "name": "Mahatre Dattatrey Namadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2845",
    "name": "Thanawala Rajnilant Tulsidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3029",
    "name": "Seema Deepak Alaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3060",
    "name": "Siwal Anant Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3853",
    "name": "Bhatnagar Madhu Arun."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1063",
    "name": "Kadav Kisan Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8898",
    "name": "Jagtap Uttamrao Shivajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2768",
    "name": "Bhosale Gulab Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3121",
    "name": "Ilaiparimal  Manikantan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15845",
    "name": "Bhosale Milan Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6411",
    "name": "Borate Ananda Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16694",
    "name": "Jadhav Yashwant Changdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15469",
    "name": "Joshi Jaideep P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6482",
    "name": "Mandal  Srimanta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15639",
    "name": "Mushibat Alli Subrati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22175",
    "name": "Patil Asha Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16843",
    "name": "Purane Jurilal Sukhlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8154",
    "name": "Rajeshstani S. P."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15942",
    "name": "Shinde Sanjiv Mahadevrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20289",
    "name": "Shinde Shamrao Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18453",
    "name": "Solanki Rekha Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5257",
    "name": "Tuniki Shrinivas Mallesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8640",
    "name": "Vast Reshma Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14539",
    "name": "Yewale Pramod Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "273",
    "name": "Roman Dnyanu Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3004",
    "name": "Khanvilkar Sanjay Vasant."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2272",
    "name": "Pawan Fabrics"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1500",
    "name": "Patil Atmaram Dadu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1815",
    "name": "Valavi Mahendra Ranchod."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5770",
    "name": "Popat Rupa Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2908",
    "name": "Kureshi Mahamadsalim Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2391",
    "name": "Matharoo Jasmindevi Singh."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6912",
    "name": "Jadhao Krushnay Swarupa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16699",
    "name": "Nimbalkar Ashok Hanmant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3791",
    "name": "Jagadale Bhanudas Vinayak"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "388",
    "name": "Borate Dadasaheb Daji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13941",
    "name": "Devakota Ravilal Devakhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11620",
    "name": "Jadhav Sharada Ramchanda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10260",
    "name": "Kadam Dharmaji Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20690",
    "name": "Patil Jagannath Sarjerao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18954",
    "name": "Rane Mayuri Shyamsundar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "608",
    "name": "Sawant Laxmi Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3987",
    "name": "Pawar Shashikant Abasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6745",
    "name": "Sawant Muktabai Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2047",
    "name": "Dafedar Sharifa Mahebub"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9002",
    "name": "Jadhav Asha Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5921",
    "name": "Borate Maya Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6090",
    "name": "Bhosale Dilip Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5752",
    "name": "Ansari Sartaz Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17480",
    "name": "Bombale Sharad Ganapat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18529",
    "name": "Giri Lalbihari Bijnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10135",
    "name": "Ibrar Shaikh Garib Ullha Shaikh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12577",
    "name": "Phalake Deepika Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15691",
    "name": "Shinde Pradeep Malikarjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10681",
    "name": "Singh Silwal Devendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4252",
    "name": "Gurnani Jasumal S"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2093",
    "name": "Rasal Khashaba Mura"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15330",
    "name": "Yadav Ramnaval Badriprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6224",
    "name": "Pawar Dnyanu Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7397",
    "name": "Barge Sarjerao Vyankat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5861",
    "name": "Masadivmata Shivmurtam Chanbasayya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10656",
    "name": "Bhosale Kantilal Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14225",
    "name": "Dabade Santosh Gunda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "122",
    "name": "Chagan Khashaba Mohite."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3880",
    "name": "Pawar Rajendra Jaising."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3745",
    "name": "Jain Namiraj B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2802",
    "name": "Vavhale Gulab Pandit."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2112",
    "name": "Joshi Krishnakant B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4302",
    "name": "Londhe Sindhu Ashok."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20002",
    "name": "Kharwatkar Shridhar Bhikuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1518",
    "name": "Dhotre Suman Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10015",
    "name": "Hulge Kaluram Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8416",
    "name": "Kadam Rajendra Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10728",
    "name": "Khilare Pandurang Sukhadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12184",
    "name": "Mane Chhaya Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6255",
    "name": "Naikal Jaywanti Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10654",
    "name": "Patil Pushpa Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15666",
    "name": "Pawar Dilip Maruti/ Awaghade Sunanda R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6474",
    "name": "Shah Bharatkumar Chhotalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4667",
    "name": "Singh Saroj Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7549",
    "name": "Thakur Rupa Motising"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9483",
    "name": "Vadar Padya Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20219",
    "name": "Kadam Popatrao B & Kadam Prashant P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3515",
    "name": "Gediya Satish S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14525",
    "name": "Ahire Eknath Trimbak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13697",
    "name": "Ambekar Anant Govind."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9686",
    "name": "Barkar Sangita Harishchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12858",
    "name": "Bhosale Avaba Genu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9038",
    "name": "Bhosale Ganesh Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18877",
    "name": "Chavan Rama Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5556",
    "name": "Chheda  Girish."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10435",
    "name": "Gade Kiran Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13035",
    "name": "Kadav Shalani Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12815",
    "name": "Khopade Sanjay Wamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8283",
    "name": "Motwani Meena Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15487",
    "name": "Parab  Bhagyshree"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7071",
    "name": "Patel Mina M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10232",
    "name": "Phalke Balkrushna Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5722",
    "name": "Salunkhe Tanaji Khemu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6675",
    "name": "Sawant Dipti Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15504",
    "name": "Shejawal Jagdish Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8410",
    "name": "Sondkar Vaishali Babaji/Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2733",
    "name": "Chavan Praksh Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1038",
    "name": "Rajaram Sripati Wangekar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2770",
    "name": "Dome Baburao Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9213",
    "name": "Dhembare Kusum Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2118",
    "name": "Patil Vishram Govind."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4582",
    "name": "Mulik Malan Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6710",
    "name": "Sabale Dyandeo Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2722",
    "name": "Mulik Bhagirthi Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3203",
    "name": "Salunkhe Sayaji Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "130",
    "name": "Ananda Baburao Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3281",
    "name": "Jakir Muhamed Jalaluddin Abdulgani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1670",
    "name": "Nalawade Meena P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7100",
    "name": "Bambade Prakash Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11647",
    "name": "Bhagat Ramchandra Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9825",
    "name": "Dehare Sulochana Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13185",
    "name": "Gaikwad Shilavati Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11718",
    "name": "Jagtap Popat Genba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20304",
    "name": "Kachare Sandip Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15331",
    "name": "Kadam Anil Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11179",
    "name": "Sawardekar Meena Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7272",
    "name": "Khatavkar Prakash Bhalchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13996",
    "name": "Parab Pramila Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8772",
    "name": "Pawar Balkrishna Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2682",
    "name": "Phakle Raghunath Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2364",
    "name": "Jagtap Shivaji Waman."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3191",
    "name": "Kadam Dnyandeo Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14049",
    "name": "Thakur Narayan Ghuir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9020",
    "name": "Garule Narayan Dattatrya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7824",
    "name": "Zanzurne Shashikant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3989",
    "name": "Shinde Krishnarao Dattoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20702",
    "name": "Parmar Sidhath M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12653",
    "name": "Jagtap Vishwas Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "828",
    "name": "Pawar Sudam Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6638",
    "name": "Kadam Mugatarao Shamarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10570",
    "name": "Beske Sunil Hanmantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22273",
    "name": "Dhamankar Ganpat Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12391",
    "name": "Kumbhar Yamunabai Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14093",
    "name": "Navashe Rameshwar Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1428",
    "name": "Yewale Waman Balaku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6217",
    "name": "Matkar Kusam Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6548",
    "name": "Salunkhe Shrirang Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7328",
    "name": "Shende Sitaram Baji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15836",
    "name": "Bhowad Deepak Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17450",
    "name": "Bobade Purnima Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10496",
    "name": "Gawas Aruna Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "137",
    "name": "Gond Nathubai Bhudhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11881",
    "name": "Javheri Pravin Shrikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18037",
    "name": "Potle Nitin Nathuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4985",
    "name": "Ravandle Dagadu Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5314",
    "name": "Sawant Hari Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10130",
    "name": "Shah Vinod Purshottamdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5766",
    "name": "Shaikh Husnodin Surafa Husein"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22256",
    "name": "Shaikh Khalil Allauddhin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22257",
    "name": "Shaikh Salim Allauddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9771",
    "name": "Sutar Virbhadra Balaappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2528",
    "name": "Patil Sunita Ramrao."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2390",
    "name": "Suryawanshi Suresh Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2427",
    "name": "Jadhav Tukaram Vishwanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7822",
    "name": "Zanzurne Shrimant Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8519",
    "name": "Nanavare Sunita Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13934",
    "name": "Jagtap Rajendra Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13158",
    "name": "Kadam Somnath Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20659",
    "name": "Phulsundar Santosh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14837",
    "name": "Pisal Ashalata Nanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17010",
    "name": "Pote Manohar Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "430",
    "name": "Raut Sitaram Bapuso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7731",
    "name": "Shedage Narayan Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2397",
    "name": "Soni Chandrakant Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "965",
    "name": "Mandhare Ramesh Sopan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1078",
    "name": "Munalal Ramdhari Rajbhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3171",
    "name": "Hairy  Robart"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2575",
    "name": "Bhosale Ramu Parbati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15606",
    "name": "Acharya Hridas Shamraya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7646",
    "name": "Bhosale Ankush Dadasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11452",
    "name": "Bhuwad Santosh Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19785",
    "name": "Dakve Shankar Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17878",
    "name": "Dixit Rajesh Ramashraya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9994",
    "name": "Ghorpade Savita Pratap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5370",
    "name": "Ghorpade Shivaji Mansingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6459",
    "name": "Kale Mahadeo S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12536",
    "name": "Kambale Hambirao Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12263",
    "name": "Kambli Sudhakar Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7645",
    "name": "Kate Shivaji Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9711",
    "name": "Lawand Ramchandra Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12847",
    "name": "Panday Kaviraj Viswanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10019",
    "name": "Parkar Radhika Rajan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8586",
    "name": "Rale Shalini Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10834",
    "name": "Adagale Santosh Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1885",
    "name": "Chawla  Harvinder."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17541",
    "name": "Dafde Thaku Vitthal"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "146",
    "name": "Dixit Sonika Rohit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13511",
    "name": "Mardhekar Vishnu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1043",
    "name": "Shah Dilip Udaylal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8764",
    "name": "Pandit Dashrath Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8431",
    "name": "Jadhav Hindurao Shyamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3535",
    "name": "Kambale Dadu Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17234",
    "name": "Mistry Rajesh Shamji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2289",
    "name": "Nagarkar Manohar Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6667",
    "name": "Dolane Dorraj Mukhtar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "125",
    "name": "Anandrao Daulatrao Deshmukh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17350",
    "name": "Keni Ramesh Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2662",
    "name": "Palojee Nazir Hussain ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10975",
    "name": "Bane Raghunath Baloji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10319",
    "name": "Chavan Pramila Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15498",
    "name": "Chavan Sachin Vishawas."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22117",
    "name": "Gade Sameer Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12910",
    "name": "Jadhav Sameer Hindurao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "488",
    "name": "Jawale Suresh Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18217",
    "name": "Nayik Ajit Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12433",
    "name": "Padave Sonu Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11909",
    "name": "Sandbhor Gajanan Baburao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1514",
    "name": "Suryawanshi Krushna Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8798",
    "name": "Teli Mohanlal Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13667",
    "name": "Warkhandkar Namrata Madhav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14105",
    "name": "Shelar Shivram Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16277",
    "name": "Bhujbal Dattatray Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4597",
    "name": "Reddi Ishwari Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12165",
    "name": "Chavan Hanmant Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4248",
    "name": "Pradhan Dadarao Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "177",
    "name": "Pawar Pradeep Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2772",
    "name": "Jain  Vimalchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1548",
    "name": "Sawant Eknath Khanderao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10495",
    "name": "Singh Rajnath Bhagavati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2788",
    "name": "Shinde Satish Madhavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10533",
    "name": "Hate Mahendra Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10416",
    "name": "Sawant Sampada Satyawan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "575",
    "name": "Ashok Samuel C"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5606",
    "name": "Bobade Hemant Gajanan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2955",
    "name": "Chouhan Bhanu Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14656",
    "name": "Dattary Atamaram Rane"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13148",
    "name": "Dethe Ramesh Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21714",
    "name": "Dhansade Raosaheb Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9317",
    "name": "Jaiswal Pappu Gangaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12583",
    "name": "Lagade Shankar Sopanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6671",
    "name": "Panchagane Harichandra Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12727",
    "name": "Pawar Sadanand Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6240",
    "name": "Rahate Anant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6490",
    "name": "Sawant Nandini S/Vrashali/Vranda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13283",
    "name": "Sawant Rajendra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5354",
    "name": "Thorat Ajit S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3255",
    "name": "Tate Shamarao Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4642",
    "name": "Banjari  Manikya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7585",
    "name": "Bhosale Jagannath Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7586",
    "name": "Bhosle Ankush Jijaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20014",
    "name": "Bhosale Laxmi Kondiba"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1039",
    "name": "Gholap Anand Rajaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1383",
    "name": "Gogawale Vithabai Krushna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "39",
    "name": "Hulage Rupali Rajkumar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "301",
    "name": "Kumbhar Amol Shantila"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8067",
    "name": "Mandhare Sachin Gangaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1406",
    "name": "Marathe Sunil Babulal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1378",
    "name": "More Asmita Kishor"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1368",
    "name": "Paradeshi Sanjay Hari"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1389",
    "name": "Pardeshi Bhagwan Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18644",
    "name": "Pednekar  Milind Bhagaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14535",
    "name": "Pisal Baburao Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12894",
    "name": "Sable Pushpa Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15112",
    "name": "Shah Gajendrabahaddur Deo Bahaddur."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5401",
    "name": "Shinde Ramchandra Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7241",
    "name": "Singh Anirudhasingh Shrishiv Pujan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9567",
    "name": "Vankar  Saraswati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18841",
    "name": "Vora Jagdish Meghaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5582",
    "name": "Ghorpade Navanth Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3175",
    "name": "Bhagyashali Bhandi Store"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2268",
    "name": "Bhosale Kisan Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "28",
    "name": "Daudmani Gurusidappa Gurupadappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7856",
    "name": "Barge Vijay Vasant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1030",
    "name": "Chavan Tanaji Sarjerao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1342",
    "name": "Daundkar Sushila Bhagwan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1343",
    "name": "Kadam Ujwala Vishnu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1340",
    "name": "Kadam Vinod Vishnu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1344",
    "name": "Phadtare Sunil Dnyaneshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19049",
    "name": "Pujari Sandip Atmaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1156",
    "name": "Rajput Rajendra Chatru"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1341",
    "name": "Sawant Bhavika Bharat"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1360",
    "name": "Shirsat Atmaram Sitaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1335",
    "name": "Umbarkar Netaji Tanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15079",
    "name": "Waghule Dattatray Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1577",
    "name": "Pore Surekha Suryakant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13010",
    "name": "Phalke Ravindra Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9953",
    "name": "Sabale Ramchandra Sahebarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17542",
    "name": "Dafade Baburao Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3905",
    "name": "Barge Dashrath Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12136",
    "name": "Acharekar Anand Jagannath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "117",
    "name": "Jadhav Ujwala Hanumant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7261",
    "name": "Mistry Suman Chandrkant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21446",
    "name": "Murgan Maniyar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3363",
    "name": "Navale Madhukar Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16621",
    "name": "Patel Ramesh Haribhai."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "625",
    "name": "Rane Ashok Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15517",
    "name": "Warulkar Shobha Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5460",
    "name": "Shinde Sahebrao Balaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13025",
    "name": "Kumbhar Dhneshwar Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8652",
    "name": "Jadhav Dashrath Yadavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1270",
    "name": "Jagdale Hanmant Nilkanth"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8624",
    "name": "Kate Lalasaheb Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11748",
    "name": "Sakpal Ananda Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14092",
    "name": "More Uttam Shankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "182",
    "name": "Mankar Krishnat Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10112",
    "name": "Mhatre Pandurang Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11672",
    "name": "Ahivale Pavan Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22145",
    "name": "Bhat Pallavi Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6898",
    "name": "Chauhan  Hiralal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11060",
    "name": "Dhumal Jaywant Gyanba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8385",
    "name": "Gangurde Mangala Madhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14950",
    "name": "Ghag Sameer Shivram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4969",
    "name": "Halgekar Vijaykumar Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12695",
    "name": "Kavankar Santosh Soma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22027",
    "name": "Koltharkar Ankit Umed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13487",
    "name": "Kudtarkar Sachin M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11728",
    "name": "Mandhare Balkrishna Jijaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7797",
    "name": "Mohanmad Husenabi Fakil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19616",
    "name": "Pawar Deepali Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14855",
    "name": "Pawar Suresh Bhiva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12149",
    "name": "Sadavarte Dattatray Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "146",
    "name": "Shantaram Raghunath Patkar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19628",
    "name": "Shinde Chandrakant Raghanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21980",
    "name": "Shinde Kiran Dhansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14989",
    "name": "Shinde Neeta Prafull."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19905",
    "name": "Surve Dulaji Raghu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12312",
    "name": "Waze Lata Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4397",
    "name": "Sheth Nimit Mukesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18551",
    "name": "Narvekar Siddhesh Santosh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8980",
    "name": "Menon Jayan Krishnan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14627",
    "name": "Singh Vidhur Ramdin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2748",
    "name": "Jadhav Rajesh Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3156",
    "name": "Reddy Subbiah R."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "806",
    "name": "Hule Narayan Genuji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3686",
    "name": "Rupla Ramlu Sah."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2733",
    "name": "Jadhav Uttam Bhiva"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6390",
    "name": "Jagadale Samindra Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21265",
    "name": "Baikar Gopichand Ganapat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10276",
    "name": "Kumbhar Godabai Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12310",
    "name": "Pawar Prakash Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5643",
    "name": "Sathe Vasant Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11223",
    "name": "Dalvi Vithal Digambar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12090",
    "name": "Pisal Santosh Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10920",
    "name": "Baswant Ramesh Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11899",
    "name": "Bhoite Phadnis Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7276",
    "name": "Chauhan  Umashanakr"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20091",
    "name": "Dhumal Sachin Vilasrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5827",
    "name": "Gaddam  Anandam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14649",
    "name": "Jagtap Somnath Babn"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19656",
    "name": "Matekar Savita Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11855",
    "name": "Phalke Santosh Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7604",
    "name": "Pilavare Vijay Shamrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15191",
    "name": "Rajput Vasumati Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23259",
    "name": "Sable Surekha A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8825",
    "name": "Shah Krupali Shailesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17399",
    "name": "Shelar Ramdas Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2518",
    "name": "Bathiya Deepak G."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7318",
    "name": "Kadam Vithal Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5511",
    "name": "Kamble Maruti Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5739",
    "name": "Kidlani Begam Raghuvir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12819",
    "name": "Lohar Chandrakant Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5128",
    "name": "Mulla Musa Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16",
    "name": "Panaskar Shivaji Govindrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20195",
    "name": "Ghanekar Ratnaprabha D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16634",
    "name": "Chaskar Ramesh Gulabrao ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13949",
    "name": "Kale Rakesh Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13102",
    "name": "Dhembare Deepak Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19495",
    "name": "Lad Kashibai Punjalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14719",
    "name": "Mehta  Vinod"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "367",
    "name": "Mhatre Nirupama Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14841",
    "name": "Pawar Mansing Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11741",
    "name": "Shinde Samata Santosh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22162",
    "name": "Urke Basavarat Lalappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13321",
    "name": "Zodge Shivaji Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4181",
    "name": "Amre Pravin Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12594",
    "name": "Shinde Umabai Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1583",
    "name": "Bonvate Shankar Dattatrya."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5898",
    "name": "Pawar Prakash Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1269",
    "name": "Damale Shobhana Sudhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1167",
    "name": "Regmi Bhaktaraj Kulananda."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14531",
    "name": "Desai Chandrakant Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15696",
    "name": "Jambukar Umesh Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22164",
    "name": "Naik Rajesh Seena"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17100",
    "name": "Naikule Chandrakant Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9517",
    "name": "Patil Satish Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5817",
    "name": "Salunkhe Mansing Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11776",
    "name": "Shetty Selvaraj Duraiswami"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13035",
    "name": "Singh Vidhur Ramdin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15378",
    "name": "Terne Manohar Santu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1736",
    "name": "Zele Dinkar Laxmanrao."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4421",
    "name": "Phalke Pushpa Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3283",
    "name": "More Vitthal Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5642",
    "name": "Sakate Shivaji Pundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "311",
    "name": "Faras Azimuddin Abdulrshik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4059",
    "name": "Rout Raghunath Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2088",
    "name": "Yewale Dnyaneshwar Mhatarba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3223",
    "name": "Nirmal Anil B."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8926",
    "name": "Joshi Sandeep Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2467",
    "name": "Jain Bhupendrakumar Gulabchand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4751",
    "name": "Mandhare Dhanaji Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3147",
    "name": "Narakanta  Khanal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14736",
    "name": "Damaliya Mulchand Haribhai."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12881",
    "name": "Dhumal Hanmant Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21866",
    "name": "Gupta Gopal Jokham"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19432",
    "name": "Jadhav Dattatrya Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21893",
    "name": "Kadam Madhukar Bhivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21789",
    "name": "Kadu Mahendra Khandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12977",
    "name": "Kambale Smitha Chnadrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16440",
    "name": "Kambli Suresh Vasudeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14565",
    "name": "Mahajan Raviraj Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21790",
    "name": "Malekar Prashant Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14793",
    "name": "More Atmaram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5809",
    "name": "Padiyar Babusingh Rajput/Bhamanidevi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11796",
    "name": "Pal Urmila Ramdavar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1229",
    "name": "Pathan Samina Sakur Khan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21877",
    "name": "Pawar Pandurang Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11428",
    "name": "Pawar Pratap Nivaruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21873",
    "name": "Pawar Rohidas Ramji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10932",
    "name": "Phalke Ravindra Dnyndeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21809",
    "name": "Raut Krupali Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21906",
    "name": "Shelke Sangita Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21905",
    "name": "Shelke Sayaji Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21883",
    "name": "Surve Sanjay Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16172",
    "name": "Yadav Amit Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4621",
    "name": "Matkar Jayram Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4680",
    "name": "Chouhan Dinesh Balkisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3960",
    "name": "Budha Harsha Manbahadur."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2390",
    "name": "Matharoo Surjeet Singh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2624",
    "name": "Makwani Khimaje Kanjibhai ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5516",
    "name": "Cardin  Clancy"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10980",
    "name": "Chatur Mohan Murlidhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17443",
    "name": "Chavan Shailesh Vishwanat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7957",
    "name": "Godase Balkrishna Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7274",
    "name": "Mane Sanjay Murlidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11697",
    "name": "Marade Eknath Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13451",
    "name": "Mondal Mohmad Alluddin."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18625",
    "name": "Talekar Kiran Mangesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9159",
    "name": "Chavan Deepak Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "959",
    "name": "Ghadage Appa Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1235",
    "name": "Rajbhar Dildar Halikaran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11764",
    "name": "Babar Bhaskar Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4164",
    "name": "Pant  Ramdat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1896",
    "name": "Shah Bharatkumar Amratlal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9847",
    "name": "Jadhao Rukmini Ganapat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14828",
    "name": "Rau Lokesh C B"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2020",
    "name": "Phalke Rajaram Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8773",
    "name": "Phalke Shalan Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1442",
    "name": "Mahangade Shrirang Bhausaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "760",
    "name": "Pawar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16935",
    "name": "Ghadigaonkar Neelima Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14222",
    "name": "Gholap Santosh Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10006",
    "name": "Jadhav Nathuram Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2622",
    "name": "Krishanan G ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21525",
    "name": "Pawar Ankush Nalaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15087",
    "name": "Varande Ganesh Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15799",
    "name": "Sabale Vithal Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17540",
    "name": "Sharif Jamaluddin Ahamed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12974",
    "name": "Santunae Dinkar Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5744",
    "name": "Wagh Suresh Shamarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "868",
    "name": "Pearl Consultancy"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5567",
    "name": "Dubasha Akashi Peshotan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13446",
    "name": "Burate Shobha Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5658",
    "name": "Doke Hari Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14465",
    "name": "Faras Baymabi Abdulrashid."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14786",
    "name": "Jadhav Sahadeo Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18038",
    "name": "Khanekar Sanjay Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4389",
    "name": "Mehra Ritu Y."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15310",
    "name": "Narakar Vishnu Babaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21739",
    "name": "Pawar Dashrath Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13690",
    "name": "Pawar Purshottam Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "535",
    "name": "Ravindra Shankar Mandhare"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5747",
    "name": "Phalke Bhagirthi Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3250",
    "name": "Chawan Shamrao Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5384",
    "name": "Bhosale Govind Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "104",
    "name": "Sangita Ankush Jadhav."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13542",
    "name": "Maner Abdulhamid Makbul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4361",
    "name": "Vichare Prabhakar Gopalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12991",
    "name": "Bhoite Vidhyadhar Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8929",
    "name": "Deshmukh Rajesh Ganesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4644",
    "name": "Jadhav Shashikant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22370",
    "name": "Yadav Raviprakash Pholchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16156",
    "name": "Aher Prakash Karbhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15302",
    "name": "Arote Vithal Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21640",
    "name": "Dhangade Tukaram Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13616",
    "name": "Ithape Pradip Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12636",
    "name": "Jagdale Devdas Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6346",
    "name": "Jagdale Prakash Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21736",
    "name": "Korde Baliram Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16971",
    "name": "Masurekar Vaibhav Shyamsunder"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11542",
    "name": "Phalke Chetan Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9622",
    "name": "Pharde Mohd Raffique Gaffoor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22709",
    "name": "Salvi Mahesh Motiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21538",
    "name": "Shinde Ramesh Bhimrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17701",
    "name": "Wairkar Arvind Jiji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15513",
    "name": "Rane Krishnakant Laxman."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15034",
    "name": "Gorivile Anandibai Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15954",
    "name": "Adhav Shrad Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12443",
    "name": "Chavan Ashok Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20107",
    "name": "Dubey Banshidhar Nagrinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23192",
    "name": "Ghadi Yashwant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11590",
    "name": "Kadam Tanaji Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5231",
    "name": "Khan Shabana Shahabuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1761",
    "name": "Pentagon Guards & Detective Services"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15970",
    "name": "Mulam Sadanand Anant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18440",
    "name": "Sanas Sachin Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4823",
    "name": "Sharma Ashok Dayashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18012",
    "name": "Soyane Monali Kamalakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "703",
    "name": "Mane Dharmu Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "574",
    "name": "Pawar Mansing Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13166",
    "name": "Shekh Javed Dadasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2080",
    "name": "Perfect Interiors"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2166",
    "name": "Macwan  Nataha.J."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4510",
    "name": "Bhosale Sharada Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13029",
    "name": "Shinde Narayan Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "763",
    "name": "Bujangrao Narayanrao Wagh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4460",
    "name": "Banjari Chawlabai Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1378",
    "name": "Kavhar Ashwini Santaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12368",
    "name": "Phalke Jitendra Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9107",
    "name": "Chavan Ranjana Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4391",
    "name": "Harmani Archana S."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17589",
    "name": "Bhoite Vilas Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6306",
    "name": "Chavan Shyam Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10613",
    "name": "Kapse Gangaram Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18279",
    "name": "Lembhe Dnyandeo Malhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5059",
    "name": "Lingayat Madhukar Gyanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14364",
    "name": "Patil Subhash Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12726",
    "name": "Phalake Satwashila Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10651",
    "name": "Prakash Harishchandra Jagtap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13591",
    "name": "Sable Archana Ashok"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "797",
    "name": "Shirke Kalidas Pabu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7253",
    "name": "Mane Laxman Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16370",
    "name": "Rane Suhas Dinkar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2589",
    "name": "Yadav Vasant Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10844",
    "name": "Kadam Avinash Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1627",
    "name": "Mali Jagannath Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20514",
    "name": "Aarote Madhavi Sachin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "547",
    "name": "Shinde Lalaso Baba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12501",
    "name": "Shinde Sangita Daulat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10711",
    "name": "Zajurne Sunanda Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5261",
    "name": "Pawar Ramchandra Khanderao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5085",
    "name": "Kharat Prabhavati Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1547",
    "name": "Pawar Pushpa Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3434",
    "name": "Pathan Harun Mukhats"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8122",
    "name": "Disoza  Fransis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13096",
    "name": "Chavan Jaywant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "285",
    "name": "Lad Shashikala Balkrishna ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1444",
    "name": "Anute Vithal Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2751",
    "name": "Kadam Chandra Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17469",
    "name": "Kadam Rajendra Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9642",
    "name": "Bansode Vimal Kalyani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11810",
    "name": "Chindarkar Sanjay Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17671",
    "name": "Jadhav Vishnu Bala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12190",
    "name": "Kadam Narayan Aba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6980",
    "name": "Keni Prabhakar Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17258",
    "name": "Kubal Yogesh Balaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10952",
    "name": "Shetty Jayant Sankappa"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1561",
    "name": "Yadav Yogendra Shivbhajan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5891",
    "name": "Jadhav Eknath Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6944",
    "name": "Raut Savita Dyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1014",
    "name": "Gopalkrlishnan  Balkrishnan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2639",
    "name": "Kadam Ranjana Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10552",
    "name": "Nikam Gulab Bandoba."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "901",
    "name": "Shinde Parasram Manaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2647",
    "name": "Shide Ramesh Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4187",
    "name": "Raut Prakash Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11421",
    "name": "Shinde Arvind Vishwasrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7139",
    "name": "Choudhary  Bhuraram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21870",
    "name": "Bhosale Rajendra Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21152",
    "name": "Chavan Shyamsundar Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10649",
    "name": "Devgude Sunil Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18921",
    "name": "Dhumal Niketan Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18361",
    "name": "Hode Shantaram Bhagoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11724",
    "name": "Kadam Alka Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21324",
    "name": "Madkar Vijay Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14617",
    "name": "Patil Shankar Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18885",
    "name": "Pawar Priti Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18937",
    "name": "Pawar Vishnu Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18286",
    "name": "Raje Mayur Meghnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15385",
    "name": "Rane Pradip Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21484",
    "name": "Shety Satish Vitthal."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1294",
    "name": "Sulkekar Ganesh Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8851",
    "name": "Bhosale Sushila Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4323",
    "name": "Mulik Ramchandra Shivba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4165",
    "name": "Jadhav Vilas Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21411",
    "name": "Parab Yatin Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12932",
    "name": "Shinde Laxmi Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13175",
    "name": "Pawar Nilesh Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14306",
    "name": "Ghadge Balasaheb Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8396",
    "name": "Iqbal Sagirhasan Khan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13902",
    "name": "Jadhav Shobha Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8324",
    "name": "Kadam Ashok Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16773",
    "name": "Kadam Sanjay Pandharinath."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18104",
    "name": "Patil Laxman Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17758",
    "name": "Saste Dilip Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "233",
    "name": "Mandhare Vitthal Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16863",
    "name": "Shinde Sahebrao Hanmant ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5031",
    "name": "Harvi Ratanappa Gundappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1624",
    "name": "Momin Mehboob Nabi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3386",
    "name": "Tekale Prakash Punjaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14063",
    "name": "Bhosle Gautam Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4785",
    "name": "Kumkar Dulaji Bhimaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10834",
    "name": "Borkar Sudhakar Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "416",
    "name": "Choraghe Narayan Sadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9013",
    "name": "Paradkar Prakash K."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23404",
    "name": "Subramaniam Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2952",
    "name": "Bhanavali Santosh Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7557",
    "name": "Chavan Bhimrao Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6563",
    "name": "Deshmukh Vandana Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11875",
    "name": "Dhumal Anita Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9362",
    "name": "G.  Ramulu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11619",
    "name": "Gade Prakash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13018",
    "name": "Galwe Bhausaheb Dondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20450",
    "name": "Gosavi Dattaram Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13821",
    "name": "Kamtekar Tukaram Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3864",
    "name": "Kolte Bharati B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10090",
    "name": "Mehta Jiten Narendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15742",
    "name": "Pataria Mikhil Shivraj."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10125",
    "name": "Phalke Hambirao Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6744",
    "name": "Samuel  Beby"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15145",
    "name": "Shripankh Shriram Patil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14394",
    "name": "Yelve Paresh Shashikant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5044",
    "name": "Dhekale Hanmant Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18849",
    "name": "Sakunde Mohan Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16779",
    "name": "Satare Dilip Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20882",
    "name": "Bhakre Yeshwant Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11700",
    "name": "Farande Sangita Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20883",
    "name": "Jilla Dhanjay Buchayya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20565",
    "name": "Makar Jotiram Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13285",
    "name": "Pawar Beby Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10623",
    "name": "Shedge Dattatray Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "887",
    "name": "Gawade Arjun Bhanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9486",
    "name": "Jagtap Aabaji Wamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5436",
    "name": "Malekar Mandakini Arvind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8222",
    "name": "Joshi Shyam Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11264",
    "name": "Manjrekar Vandana Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15967",
    "name": "Shewale  Vijay Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5772",
    "name": "Mungekar Namdev Pundalik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18199",
    "name": "Bhosale Amol Dyandev."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15399",
    "name": "Chavan Somnath Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15877",
    "name": "Jadhav Chandrakant Baban."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15892",
    "name": "Jaiswal Kishorilal Shobharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19587",
    "name": "Kanse Sambhaji Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15384",
    "name": "More Mukund Lahu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11734",
    "name": "Nanarkar Narayan Bhiwa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13330",
    "name": "Parkar Shivaji Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11654",
    "name": "Phalke Shobha Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21400",
    "name": "Shedge Anil Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11002",
    "name": "Pawar Ashok Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4127",
    "name": "Pariyani  Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1911",
    "name": "Gulekar Vishram Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1495",
    "name": "Kanekar Suresh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13137",
    "name": "Kadam Ramesh Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2421",
    "name": "Bhosale Chandrakant Appaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17365",
    "name": "Gaikwad Pritam Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16305",
    "name": "Kahar Manda Mayaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15275",
    "name": "Sakunde Hanmat Dhondiba."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14234",
    "name": "Sawant Pralhad Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "788",
    "name": "Rane Ramchandra Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3406",
    "name": "Kadam Tulshiram Deoo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3002",
    "name": "Lembhe Hirabai Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3036",
    "name": "Dilbahadur  Sherbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11880",
    "name": "Gawade Ramdas Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22751",
    "name": "Mishra Nandkishor Ramaasare"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21172",
    "name": "Parab Omkar Shrikrushna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1632",
    "name": "Pathak Rameshdatt Bhagwandatt"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12857",
    "name": "Phalke Radhabai Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10663",
    "name": "Shinde Rekha Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20939",
    "name": "Singh Ramnarayan Rambhajan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13987",
    "name": "Yewale Sangita Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2056",
    "name": "Allauddin Abdul Jalil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1257",
    "name": "Vijaykumar Shankar Shinde"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4532",
    "name": "Kawar  Balkrishna."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4651",
    "name": "Chavan Khashibai Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10159",
    "name": "Saroj Sheshmari Harishankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1794",
    "name": "Bhandwalkar Pandurang Shamrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1826",
    "name": "Ghorpade Tanajirao Sopanrao."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6868",
    "name": "Phalake Adhikarao Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7210",
    "name": "Jadhav Mansub Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7380",
    "name": "Joshi Shriniwas Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10373",
    "name": "Shah Sarojben Shantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2962",
    "name": "Jagtap Khashaba Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7762",
    "name": "Chavan Laxmibai Vishnupant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5473",
    "name": "Kolekar Ramchandra Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5111",
    "name": "Ghorpade Janardan Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17278",
    "name": "Pednekar Shradha Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13392",
    "name": "Babar Sachin Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20739",
    "name": "Kerkar  Shrikant  Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16583",
    "name": "Mane Vaibhav Ashok."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16075",
    "name": "Nikam Prathmesh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12359",
    "name": "Phalke Arjun Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12910",
    "name": "Shinde Rajendra Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8778",
    "name": "Vardam Gajanan Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18427",
    "name": "Salunkhe Shakuntala Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11436",
    "name": "Kadu Santosh Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18388",
    "name": "Pisal Murlidhar Parbati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7900",
    "name": "Mestri Pramila Sadanand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6162",
    "name": "Kambale Ramu Chandar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1175",
    "name": "Batawale Dattaram Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6341",
    "name": "Sawant Shankar Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5372",
    "name": "Vardam Mangala Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13829",
    "name": "Mirkute Balasaheb Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5268",
    "name": "Chavan Shobha Subhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10811",
    "name": "Bhosale Laxman Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14809",
    "name": "Ghadge Kantaram Krishna."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16701",
    "name": "Ghag Samiksha Sandip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13588",
    "name": "Jain Sanjay Raichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12386",
    "name": "Kamble Bhimrao Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14984",
    "name": "Patil Balaram Changu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10531",
    "name": "Pisal Shankar Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7592",
    "name": "Chavan Prakash Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8519",
    "name": "Gaonkar Mangesh Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5350",
    "name": "Sakhare Ashok Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7122",
    "name": "Chavan Anil Krishnarao"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "734",
    "name": "Phoenix Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "789",
    "name": "Mishra Housali Prasad Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8676",
    "name": "Agastin Vincent Louies"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9278",
    "name": "Barboj Arpina Micheal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13804",
    "name": "Bhambid Laxmi Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20672",
    "name": "Bhojane Swapnil Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13830",
    "name": "Dsouza Sunita Lawrence."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12163",
    "name": "Jagtap Vidya Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16536",
    "name": "Matkar Sanjivani Prakash."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12848",
    "name": "Mittal Sunilkumar Kesarilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4704",
    "name": "Pangare Sushila Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9173",
    "name": "Patel Manubhai Harmanbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12503",
    "name": "Tambe Anil Govindrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13550",
    "name": "Thakur Kailashchand Harmalchand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16240",
    "name": "Yadav Durgavati Indrajit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "74",
    "name": "Shantaram Shankar Shinde."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6998",
    "name": "Phalke Sunil Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21785",
    "name": "Shirgavkar Laxmibai Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13212",
    "name": "Pawar Sampat Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13755",
    "name": "Bhosale Mahadeo Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7125",
    "name": "Kumthekar Vijay Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6922",
    "name": "Phalake Dwarkabai Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20580",
    "name": "Mikam Dattatray Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4429",
    "name": "Pinki Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "130",
    "name": "Desai Tukaram Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "235",
    "name": "Gfaikwad Khashaba Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1676",
    "name": "Rai Ajay Hiralal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13282",
    "name": "Chavan Mathura Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18677",
    "name": "Jadhav Uzawala Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "492",
    "name": "Wagh Baburao Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8765",
    "name": "Bhat Kishorkumar S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1173",
    "name": "Nawadkar Balwant Dashrath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1201",
    "name": "Reshma Ratnakar Raikar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4745",
    "name": "More Rauso Dajiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6597",
    "name": "Phalke Chhaya Shivaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "196",
    "name": "Adate Yogesh Khanderao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20736",
    "name": "Adhavkar  Sambhaji  Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11607",
    "name": "Bobade Uttam Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3496",
    "name": "Khedekar Suryakant Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11711",
    "name": "Kirve Vitthal Dnyanoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10924",
    "name": "Rawal Jagat Bahadur Bal Bahadur"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11550",
    "name": "Salunkhe Rupchand Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20039",
    "name": "Shelar Eknath Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9836",
    "name": "Jaiswar Joharam Ramnandan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17537",
    "name": "Nangare Ramu Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14631",
    "name": "Khade Anusya Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10153",
    "name": "Choksi Snehvadan Chandulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5049",
    "name": "Katkar Nanda Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12928",
    "name": "Kale Naandkumar Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7545",
    "name": "Jadhav Suman Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "213",
    "name": "Pathan Mehibubkhan Yashinkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19372",
    "name": "Dongare Sagar Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6071",
    "name": "Surve Ravidra Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5807",
    "name": "Babugiri  Manugiri"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9770",
    "name": "Chavan Deepak Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5577",
    "name": "Diwedi  Umeshkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8510",
    "name": "Kambale Pandurag Bajirao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13091",
    "name": "Khan Baraktulla Mohamed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10949",
    "name": "Kumbhar Dilip Gulab"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14918",
    "name": "Kumbhar Shivaji Appa"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "49",
    "name": "Shetty Sudhakar Vasu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7825",
    "name": "Mithbawakar Ramachandra Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6228",
    "name": "Taware Vishvambar Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8259",
    "name": "Bhagat Sushil Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8421",
    "name": "Thorat Bhausaheb Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11344",
    "name": "Sawant Madukar Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1582",
    "name": "Siddiqee Dostmohammad Husain Ahmad."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11627",
    "name": "Jain Vinodkumar Babulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9655",
    "name": "Gavandi Vidya Pratapsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7795",
    "name": "Bhagat Vinayak Parashuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4250",
    "name": "Thapa  Balbahaddur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17520",
    "name": "Anuse Ramchandra Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18856",
    "name": "Satale Keshav Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3889",
    "name": "Chavan Yeshubai Ragho"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17053",
    "name": "Olavande Rajesh Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8092",
    "name": "Adi Indrjit M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10229",
    "name": "Naik Sunita Sahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11529",
    "name": "Shekh Satar Abbas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12512",
    "name": "Shinde Rupali Jayawant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17917",
    "name": "Surve Dadaso Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9934",
    "name": "Kadam Rajesh Pradam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7936",
    "name": "Kadam Deepak Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14825",
    "name": "Aruna Namadeo Lahute"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6621",
    "name": "Kandalkar Navinchandra Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6162",
    "name": "Mandhare Dattatray Bapuji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "907",
    "name": "Fopale Sunil Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12851",
    "name": "Phalke Ramchandra Jijaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11203",
    "name": "Tambe Ashok Hiroji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6950",
    "name": "Mane Vishnu Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18184",
    "name": "More Kantishila Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15038",
    "name": "Daatkhile Yashodabai Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6882",
    "name": "Bhosale Vilas Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11423",
    "name": "Bhuwad Ravindra Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16413",
    "name": "Chavan Bhanudas Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15631",
    "name": "Kalpana  Jitendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15198",
    "name": "Khot Dilip Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13658",
    "name": "Mane Pramod Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19668",
    "name": "Mayekar Rameswari Bhalchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20516",
    "name": "Pawar Rajesh Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19745",
    "name": "Rawal Jitendra Swaroopchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11188",
    "name": "Saroj Lalji Rambali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14307",
    "name": "Sawant Mithun Arun."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5174",
    "name": "Vrajlal  Bharati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11413",
    "name": "Zanzane Arvind Kalyanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9429",
    "name": "Kolekar Ramchandra Santu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8534",
    "name": "Shah V O"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8036",
    "name": "Washirde Subhraj D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13570",
    "name": "Nalwade Lalita Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10885",
    "name": "Hiraj Pushpatai Vyankatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4458",
    "name": "Jadhav Narayan Rangu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1628",
    "name": "Ahirekar Baban Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "108",
    "name": "Shinde Prabhavati Madhav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13108",
    "name": "Gadhia Shobha Shailesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12930",
    "name": "Tamkaria Subhashchand M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11002",
    "name": "Gore Baban Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11003",
    "name": "Kadam Changdeo Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21049",
    "name": "Khopade Dhananjay Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19277",
    "name": "Kolge Subhash Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8485",
    "name": "Muliya Tukaram Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3812",
    "name": "Indalkar Bhikubai Bajirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1708",
    "name": "Ayare Ujwala Prakash."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14945",
    "name": "Kadam Pradip Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6930",
    "name": "Bagwan Sirajuddin Ahmed Saheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9818",
    "name": "Kale Yashwanti Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7681",
    "name": "Salunkhe Gojabai Devaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2381",
    "name": "Mulik Ranjana Shrirang."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3979",
    "name": "Rakshe Malan Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5678",
    "name": "Acharekar Sanjay Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18960",
    "name": "Ansari Wasim Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7386",
    "name": "Banave Popat Bayaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15159",
    "name": "Jagadale Dadasaheb Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7214",
    "name": "Jagtap Nana Nanda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13514",
    "name": "Mestry Suryakant Kashiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22057",
    "name": "Paradkar Pratibha Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11541",
    "name": "Prasad Ramesh Magaru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11291",
    "name": "Sabale Ramdas Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9411",
    "name": "Singh Pratap Satydeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11498",
    "name": "Sonkar Ramchandra Radhelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16318",
    "name": "Tiwari Arunkumar Rambhavan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9027",
    "name": "Ukarde Vivek Mohan"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "132",
    "name": "Planet Sales Corporation"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6385",
    "name": "Chavan Sambhaji Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6568",
    "name": "Nerurkar Smita Nitin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3569",
    "name": "Sawant Baburao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "169",
    "name": "Tarde Abhimanyu Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5234",
    "name": "Patkar Lawdimir Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "127",
    "name": "Phalke Mugatrao Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1613",
    "name": "Pandit Shanti Brijmohan."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1846",
    "name": "Sayyad Gulab Kamrula"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13140",
    "name": "Desai Jagdish Lavjibhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13665",
    "name": "Dhadve Satish Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12427",
    "name": "Bhandari Lalit Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12190",
    "name": "Bhilare Pandharinath Ekanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15797",
    "name": "Chinchakr Vasant Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15088",
    "name": "Dhamal Chandrakant Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5758",
    "name": "Ghorpade Pratap Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4547",
    "name": "Joshi Sharda N."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12355",
    "name": "Kadam Vinod Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11549",
    "name": "Posture Anant Mamadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15412",
    "name": "Shelar Urmila Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12444",
    "name": "Utekar Sakubai Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11925",
    "name": "Vare Dhondiba Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12055",
    "name": "Walekar Sughdev Shnkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2648",
    "name": "Jagdale Dinkar Mukind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9089",
    "name": "Tivarekar Nitin Ganu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5095",
    "name": "Telangi Balwant Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9032",
    "name": "Kamerkar Eknath Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5696",
    "name": "Kadu Vijay Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1550",
    "name": "Khan Shabana Shahabuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1552",
    "name": "Prabhu Sudha V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6741",
    "name": "Undare Ramesh Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4567",
    "name": "Zanzurne Jagannath Awba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5104",
    "name": "Bagade Subhash Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2500",
    "name": "John  Johnson"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5094",
    "name": "Naidu Dipak Kanhya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10290",
    "name": "Pisal Vilas Vittalrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10230",
    "name": "Khajanwadkar Bajirao Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11208",
    "name": "Dhumal Aruna Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3234",
    "name": "Polite Printers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3362",
    "name": "Poma Fabrics Pvt Ltd"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13049",
    "name": "Hanchate Jashnath Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5275",
    "name": "Kharate Bhavana Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20266",
    "name": "Pokale Lau Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1051",
    "name": "Pooja Water Suppliers"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8098",
    "name": "Roy Rohi Kunjapi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11801",
    "name": "Salunkhe Waman Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10274",
    "name": "Shinde Dnyandeo Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7983",
    "name": "Shinde Pratap Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14672",
    "name": "Shukla Mishri Lal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6779",
    "name": "Verma Prahlad M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8026",
    "name": "Shekh Badasha Amin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5875",
    "name": "Shah Bhabutamal Chunilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8552",
    "name": "Solanki Jadhav Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1580",
    "name": "Chune Malba Hariba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2257",
    "name": "Kailpitchari D. Joshva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9544",
    "name": "Pabari Nayna Hasmukh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1291",
    "name": "Shetye Laxmibai Gopinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9082",
    "name": "Raut Dipty Dinesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13619",
    "name": "Bandkhale Sharad Harichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12914",
    "name": "Belvalkar Jagadish Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19708",
    "name": "Chudiyal Dayakisan Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17606",
    "name": "Dawade Kanta Gopinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18164",
    "name": "Gole Hanmant Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17039",
    "name": "Kadam Madhukar Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16114",
    "name": "Kambale Swapnil Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6628",
    "name": "Lembhe Pndurang Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14698",
    "name": "Sawant Gajanan Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5005",
    "name": "Uttekar Anil Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5669",
    "name": "Shinde Kundlik Jayasing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4288",
    "name": "Kadam Gangaram Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5042",
    "name": "Pore Chittaranjan Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13453",
    "name": "Diwane Nitin Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1569",
    "name": "Kate Sampat Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9516",
    "name": "Ambale Manik Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13335",
    "name": "Balakumar  R."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13798",
    "name": "Bhujbal Sachin Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12753",
    "name": "Chavan Hanmant Vittal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11341",
    "name": "Joshi Sunil Gunaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17398",
    "name": "Kamble Dattaram Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9320",
    "name": "Rawat Shersing Aansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13383",
    "name": "Salunkhe Hanmant Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "324",
    "name": "Thakur Kishan Ramsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19144",
    "name": "Thombare Amol Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13294",
    "name": "Upadhaya Omprakash Ramavad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21170",
    "name": "Vedruk Swapnil Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "962",
    "name": "Bhaldar Intaj Alam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8884",
    "name": "Satpute Maheshkumar Atyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14383",
    "name": "Jadhav Chandrakant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1752",
    "name": "Bist Narayan Singh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5690",
    "name": "Dumarchand Prasad Ishwar Sav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1448",
    "name": "Patel Gordhanbhai Ramjibhai."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21966",
    "name": "Anbhavne Aparna Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13696",
    "name": "Begam  Mumtaj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19907",
    "name": "Bhatt Harish Murariprasad"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "304",
    "name": "Bhilare Harshada Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11905",
    "name": "Dhamal Dattatray Yashawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12531",
    "name": "Harijan Rambrid Khedan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14369",
    "name": "Katkar Sudhakar Shrirang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20796",
    "name": "Mule Sitaram Sonu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16157",
    "name": "Panchal Manoj Chandrkant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18131",
    "name": "Pandav Anuja Umesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17729",
    "name": "Pawaskar Nishikant Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17528",
    "name": "Puthran Shyam Krishnappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14746",
    "name": "Sakpal Nagesh Baraku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22172",
    "name": "Sanap Ganesh Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7385",
    "name": "Pavaskar Bhaskar Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8734",
    "name": "Surve Kisan Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9739",
    "name": "Ghag Janardhan Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "983",
    "name": "Phalke Marutrao Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8002",
    "name": "Patil Dhondiram Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4355",
    "name": "Pilaware Maruti Ramchandra."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6861",
    "name": "Kapshikar Imptiyaj Rahimtulla"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6858",
    "name": "Shekh Husen Magbul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6859",
    "name": "Shekh Ismail Magbul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5504",
    "name": "Phalke Baburao Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "214",
    "name": "Pradeep Transport"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10830",
    "name": "Mehta Kamal Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5137",
    "name": "Chouhan Ramkisan Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15047",
    "name": "Dhumal Dattatray Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22050",
    "name": "Jadhav Suresh Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11460",
    "name": "Jagatap Anandarao Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7864",
    "name": "Katkar Vijay Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16553",
    "name": "Nadagery Dayanand Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16596",
    "name": "Palan Omkar Prem."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5885",
    "name": "Parmar Shital N."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4698",
    "name": "Patel Sangamlal Rammurat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19978",
    "name": "Shedge Baban Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20284",
    "name": "Vasa Amit Shapadchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7",
    "name": "Jyoti Engineering Works"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13486",
    "name": "Vora Jayesh Bhavani"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1788",
    "name": "Pragati Engineers & Associates"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3008",
    "name": "Pragati Sales Corporation"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "376",
    "name": "Nanso Baliram Sakunde."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8596",
    "name": "Chavan Aruna Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2987",
    "name": "Mane Baban Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1200",
    "name": "Murari Pankajkumar Hasmukhbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5694",
    "name": "Barge Mansing Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2086",
    "name": "Nanavre Kamal Popat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1064",
    "name": "Shiv Sahay Mestri ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5584",
    "name": "Khan Mohmed Isakali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2272",
    "name": "Adhav Tukaram Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "16",
    "name": "Jadhav Appu Nagappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8878",
    "name": "Patil Hindurao Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2402",
    "name": "Chavan Mohan Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22666",
    "name": "Chavan Sudhakar Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14520",
    "name": "Mane Akaram Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11887",
    "name": "Das Nityanand Gangadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7277",
    "name": "Delivala Parul Nitin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16119",
    "name": "Gharatkar Karan Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7587",
    "name": "Jadhav Shankar P/Bajrang Sawala J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11549",
    "name": "Kadam Dhondiram Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14005",
    "name": "Khade Sunita Sham"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12098",
    "name": "Makwana Mohan Narshi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9028",
    "name": "Mishra  Jugalkishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6516",
    "name": "More Anusaya Mahadeo."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11322",
    "name": "Salunkhe Tukaram Tayaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11030",
    "name": "Yadav Lalsaheb Ramasare"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5260",
    "name": "Kajale Dattatray Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3025",
    "name": "Prakashchandra Kantilal & Sons"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8571",
    "name": "Babulkar Ramchundra Vittal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2205",
    "name": "Vedpathak Rajesh Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4394",
    "name": "Yadav  Premnath."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17537",
    "name": "Dehiya Ajaypal Chattersingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19145",
    "name": "Jagtap Dada Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5169",
    "name": "Gujar Shankar Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "228",
    "name": "Suresh Sonu Lagavankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12680",
    "name": "Dalvi Shyamsunder Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3493",
    "name": "Prashant J. Esudar Nadar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1501",
    "name": "Prashant Oil Traders"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16958",
    "name": "Davre Laxmibai Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9014",
    "name": "Dixit Alka Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9916",
    "name": "Gadhave Sriram Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11643",
    "name": "Gaikwad Vikas Mansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "893",
    "name": "Prathamesh Arts"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "26",
    "name": "Prathmesh Tours & Travels"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4196",
    "name": "Pratik  Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5529",
    "name": "Jambhawadekar Dhku Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18546",
    "name": "Kadam Sudha Pradip"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "731",
    "name": "Praveen Transport."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17890",
    "name": "More Hanmant Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2737",
    "name": "Premji Madanji & Co"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18559",
    "name": "Patil Tukaram Dnandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9747",
    "name": "Pawar Shewantabai Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4044",
    "name": "Priya Traders"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14297",
    "name": "Rewale Babya Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11623",
    "name": "Sadavarte Vinayak Apparao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16562",
    "name": "Saroj Chandrawati Rampalat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8064",
    "name": "Sawant Anil Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12772",
    "name": "Sawant Nanda Rajan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13200",
    "name": "Sonawane Ujwala Nitin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21384",
    "name": "Tagala  Ismail Sanofjivan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4528",
    "name": "Zanzurne Dattatray Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "171",
    "name": "Puja Plastics"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20707",
    "name": "Roman Kamal Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2594",
    "name": "More Sharada Mohanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11081",
    "name": "Pawaskar Sandeep Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19727",
    "name": "Bhosale Anil Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9383",
    "name": "Deshmukh Lata Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12102",
    "name": "Dole Satish Babaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20866",
    "name": "Hagavane  Sandeep  Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10239",
    "name": "Lingam P Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14043",
    "name": "More Ramesh Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14442",
    "name": "Nalawade Ajitkumar Hanumant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11380",
    "name": "Phalke Subhadra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12133",
    "name": "Selvi  Manikraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11110",
    "name": "Shah Amisha Bhagwandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10906",
    "name": "Shah Natvar Valamchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6517",
    "name": "Shah Sharmista Prakash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1124",
    "name": "Sial Gadadhar Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9581",
    "name": "Surve Anita Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6735",
    "name": "Vaity Papi Bhalchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9427",
    "name": "Yadav Ishwardeo R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2158",
    "name": "Chouhan Sushiladevi Rampyare."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1312",
    "name": "Thomas P. T."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1832",
    "name": "Shaikh Abdul Majeed."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5035",
    "name": "Gawai Dharma Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3229",
    "name": "Ashra Devlataben Bhupatrai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1085",
    "name": "Dhimantlal P. Doshi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1086",
    "name": "Kumar Dhimanlal Doshi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "393",
    "name": "Eknath Raghunath Parab."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9928",
    "name": "Rege Prabhakar D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2354",
    "name": "Jagtap Malan Kashinath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3750",
    "name": "Girame Kondiram Dagadu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4721",
    "name": "Kate Shamrao Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8850",
    "name": "Shinde Sharad Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10311",
    "name": "Pawar Sonal Sunil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9895",
    "name": "Jodhawat Kantilal Bastimal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10965",
    "name": "Burase Suraj S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16954",
    "name": "Chinchkar Sulabha Shrikant/Chinchkar S.S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4614",
    "name": "Shikare Shalan Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12487",
    "name": "Vichare Sudhir Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8312",
    "name": "Awale Mangal Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2033",
    "name": "Desai Ganpat Gangaram ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1959",
    "name": "Chavan Hirabai Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4802",
    "name": "Jarandeshwar Sahakari Soc"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13411",
    "name": "Gadekar Kanhaiya Jagdish"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7947",
    "name": "Wagh Anandrao Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1430",
    "name": "Phalke Yadu Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5108",
    "name": "Shedge Sachin Pratap"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2660",
    "name": "Nikam Lahu Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14411",
    "name": "Avchar Bhimrao Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10751",
    "name": "Bodare Chhaya Vasantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17621",
    "name": "Desai Namrata Subhash."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16218",
    "name": "Jha Navin Surjyanandan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17260",
    "name": "Modhak Raghunat Arjun."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2055",
    "name": "Punamchand Velraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14380",
    "name": "Sharma Ramchandra Vasudeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1501",
    "name": "Shiravale Bhiku Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4662",
    "name": "Chatur Shakuntala Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17240",
    "name": "Gothal  Amit  Ravaji ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19488",
    "name": "Kolekar Sachin Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9848",
    "name": "Pisal Uttam Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18182",
    "name": "Wadkar Prakash Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2308",
    "name": "Shree Hanuman Tarun Mandal Babachiwadi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22582",
    "name": "Dhumal Manohar Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7252",
    "name": "Nerurkar Prakash Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2875",
    "name": "Salavi Laxman Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10034",
    "name": "Raut Bhaskarrao Kisanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "558",
    "name": "More Sidu Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15233",
    "name": "Kolekar Ramchandra Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3797",
    "name": "Anpat Vinayak Keshavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12820",
    "name": "Sabale Pramod Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9158",
    "name": "Sayyad Mahmmadhanif Allabaksha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19848",
    "name": "Katkar Vasant Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3512",
    "name": "Gawade Mahadeo Ramchandra."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1018",
    "name": "Palave Waman Chandrabhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13532",
    "name": "Desai Pandurang Desai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11101",
    "name": "Phalke Pramila Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13736",
    "name": "Pinto Cyprian R."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12691",
    "name": "Sali Sharad Ramnath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "886",
    "name": "Shejval Jitendra Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20439",
    "name": "Vichare Shamrao Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19518",
    "name": "Yadav Rammurat Kunai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12",
    "name": "Palkar Shankar Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "366",
    "name": "Dattatrya Namdeo Bobade."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4838",
    "name": "Wagh Dashrath Dada"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "975",
    "name": "Bhatt Harish Natawarlal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14361",
    "name": "Shetty Roshan Ravi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18508",
    "name": "Barot Milan Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12024",
    "name": "Bhosale Janabai Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15271",
    "name": "Gawde Mahesh Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14053",
    "name": "Kadam Supriya Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13682",
    "name": "Kshirsagar Padmavati Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15400",
    "name": "Shinde Neelam Ashok."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11154",
    "name": "Shinde Rausaheb Shivaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "346",
    "name": "Ferdinard  Rodricks."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "927",
    "name": "Joshi Balkrishna N."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6335",
    "name": "Shelke Dnyandeo Gopalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3515",
    "name": "Desai Chandrakant Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3465",
    "name": "Mulla Aslam Hamaja."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2620",
    "name": "Ghadge Vitthal Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7084",
    "name": "Nila Namdeo Sowar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10806",
    "name": "Kijbile Krishna Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3257",
    "name": "Desai  Sawant  Yamini Y."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1714",
    "name": "Patil Dattatray Laxman/Shantappa G Sutar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12943",
    "name": "Chouhan Ramsundar Harilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12465",
    "name": "Choukekar Shubhangi Suman."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20016",
    "name": "Datani Aarti Arvind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20015",
    "name": "Dattani Pooja Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12904",
    "name": "Gautam Ashokkumar Dipchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19151",
    "name": "Koli Laxmi Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13424",
    "name": "Lakhani Arvind Daylal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13483",
    "name": "Nadar Selvi Subramanyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9116",
    "name": "Pednekar Shekhar Damodar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10236",
    "name": "Phalke Suresh Dwarkoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17563",
    "name": "Shinde Priti Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20894",
    "name": "Shingate Shakuntala Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2692",
    "name": "Dhaygude Madhav Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12119",
    "name": "Parvathi N S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4206",
    "name": "Thakkar Suresh Babulal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9024",
    "name": "Shinde Sushila Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16421",
    "name": "Khond Shanta Madhukar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "859",
    "name": "Hemant Parshuram Keni."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "827",
    "name": "Thressa  Sequeira."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "513",
    "name": "Quality Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1590",
    "name": "Narayan Namdeo Pawar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14510",
    "name": "Morya Rajaram Timmat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4226",
    "name": "Ghadge Phulabai Kundlik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2242",
    "name": "Sankpal Balasaheb Jagdevrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15818",
    "name": "Bhoite Ashok Ekanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "988",
    "name": "Shinde Subhadra Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6922",
    "name": "Sanghavi Dhirendra Chunilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10500",
    "name": "Shinde Jayashree Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "149",
    "name": "Mandhare Mukunda Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4028",
    "name": "Pisal Shashikant Brahmadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "670",
    "name": "R B Industries"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2607",
    "name": "R Girish Kumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2313",
    "name": "R R Synthetics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2119",
    "name": "R. Sureshkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1609",
    "name": "R.K.Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3652",
    "name": "R.R.Synthetics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2077",
    "name": "R.S.Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1971",
    "name": "R.S.Kraft."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4334",
    "name": "Rabia Impex"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2572",
    "name": "Rachana Synthetics"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1864",
    "name": "Rachna Arts"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4325",
    "name": "Radhe Investment"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3818",
    "name": "Malhotra Malvika Vishwajeet."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12775",
    "name": "Chavan Parvati Bhagoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16205",
    "name": "Farnadish Minin Franshish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16751",
    "name": "Giri Vijay Hanumant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11757",
    "name": "Kadam Rajesh Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11884",
    "name": "Kochupurayil Shaiju Andrews"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18472",
    "name": "Kotion Monappa Suru."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8699",
    "name": "Mishra  Anilkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13897",
    "name": "Suryawanshi Arun Bhagwan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "761",
    "name": "Parte Ashok Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "915",
    "name": "Shamsuddin Nizamuddin Mirza."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "916",
    "name": "Sharma Satishkumar G."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2910",
    "name": "Chawan Deva Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4209",
    "name": "Sharma Arun Hemlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1232",
    "name": "Bandwalkar Sarvotam Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3823",
    "name": "Rahul Carring Corporation"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2137",
    "name": "Rahul Courier Service"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10181",
    "name": "Rane Raghoji Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1492",
    "name": "Kandharkar Suresh Murudhar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "750",
    "name": "Kangralkar Shantaram Payappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9842",
    "name": "Gupta Premjiprasad Asraniprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13454",
    "name": "Kakade Dinesh Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18473",
    "name": "Kapare Dattatray Ananta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13002",
    "name": "Parab Prashant Ramakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13125",
    "name": "Rao Dinanath Khedurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10529",
    "name": "Sable Prakash Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5031",
    "name": "Sakharkar Jyoti Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6689",
    "name": "Sawant Ranjana Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20605",
    "name": "Upadhyay Manmohan Krushnamohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1555",
    "name": "Jagtap Abaji Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21607",
    "name": "Joshi Deepak Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "472",
    "name": "Arote Ananda Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4398",
    "name": "Shitole Radhabai Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3444",
    "name": "Thakar Chandrakant Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11414",
    "name": "Chawan Chandrakant Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1972",
    "name": "Raj Fabrics"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9499",
    "name": "Jadhav Vanita Popat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17609",
    "name": "Khatu Tanay Arun"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "880",
    "name": "Raj Services"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17391",
    "name": "Pimple Harichandra Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "707",
    "name": "Shantidevi Bhushishet Gupta."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "626",
    "name": "Bindu Sing Yadav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17498",
    "name": "Chawan Bhanudas Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3302",
    "name": "Novel Rajesh Gonsalvis."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3457",
    "name": "Ansari Akhtar H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4988",
    "name": "Bhurke Dinesh Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3361",
    "name": "Yadav Shivaji Govinda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "778",
    "name": "Rajbhar Satiram Savaru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "573",
    "name": "Chabbria Dipchand Chandulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6183",
    "name": "Tanpure Shivaji Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14785",
    "name": "Angane Dinesh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12952",
    "name": "Jaiswal Shamnaryan Nataniprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7996",
    "name": "Kamath Asha M/Manjunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21498",
    "name": "Kandesion Thasrathan Sk"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6857",
    "name": "Mirpagar Grace Samuel"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12761",
    "name": "Parab Asmita Avinash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12696",
    "name": "Pawar Rekha Raju"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11212",
    "name": "Redij Vijay Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11248",
    "name": "Sharma Shankarpremi Radhakrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "492",
    "name": "Phanse Satish Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1709",
    "name": "Parulekar Suchita Sudhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8277",
    "name": "Jadhav Hindurao Dharmaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9549",
    "name": "Salunke Genba Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4378",
    "name": "Nanoskar Gurunath Sahadeo."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11517",
    "name": "Khaire Prakash Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3100",
    "name": "Linganna Baburao ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4628",
    "name": "Avate Sunanda Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18070",
    "name": "Chowhan Digambersinha Madansinha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12782",
    "name": "Gaud Kusum Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6983",
    "name": "Kapadia Pramila B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13531",
    "name": "Patil Ramesh Dyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22771",
    "name": "Pawar Ganesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4888",
    "name": "Shah Sushilaben Kantibhai/Chandulal V Sh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13961",
    "name": "Shevale Arun Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10234",
    "name": "Ambawale Bhiku Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6607",
    "name": "Nimbalkar Vimal Bhalchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2322",
    "name": "Bhandri Bhaskar Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2853",
    "name": "Rachh Deepa Jaysukh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8893",
    "name": "Jadhav Prakash Sahdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4447",
    "name": "Rajeev Dairy Farm"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4103",
    "name": "Disale Dinkar Rama"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2438",
    "name": "Rajendra Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12823",
    "name": "More Sushila Harishchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10661",
    "name": "Parab Sandeep Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3551",
    "name": "Rajesh Anirudh Agrawal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10474",
    "name": "Prabhu Krishna Srinivas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11212",
    "name": "Bhosale Suman Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15074",
    "name": "Chavan Archana Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9656",
    "name": "Goswami  S.M."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15785",
    "name": "Jabare Surendra Dattaram ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12927",
    "name": "Jadhav Sunanda Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13888",
    "name": "Jagtap Harischandra Genba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "897",
    "name": "Rajgadiya Trading Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20302",
    "name": "Jambodekar Sunita Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16676",
    "name": "Lakeshri  Nilesh Kashiram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13515",
    "name": "Pingulkar Arjun Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9033",
    "name": "Singh  Akhilesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1865",
    "name": "Rajhans Synthetics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2521",
    "name": "Rajhans Textiles (Prop-Kamal Kishor)"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9180",
    "name": "Ukarde Priyanka Vivek"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14394",
    "name": "Valantra Mani Khushal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4226",
    "name": "Gurkha Narbahaddur Ramsing"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1684",
    "name": "Rajlaxmi Electrical & Hardware Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7971",
    "name": "Yadav Ramshakal Jebunandan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "429",
    "name": "Abraham  Fernandes."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "490",
    "name": "Jagan B. Bhandari."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4366",
    "name": "Ajgaonkar Shrikant Sharad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "708",
    "name": "Kishor Chandrakant Raje."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "666",
    "name": "Kamalakar  D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13046",
    "name": "Bakshi Hema Vivek"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15182",
    "name": "Bhosle Jivan Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11562",
    "name": "Parab Dnyanabai Dattaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9119",
    "name": "Barge Kiran Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "187",
    "name": "Mujawar Dilawar Abdulkarim"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12448",
    "name": "Ghadge Rajendra Uddhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16539",
    "name": "Kambale Rajendra Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14253",
    "name": "Nikam Dnaynadeo Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12999",
    "name": "Sankunday Vittal Pandrinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4835",
    "name": "Shah Jayshri Mahendrakumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19153",
    "name": "Shinde Dipak Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2156",
    "name": "Gupta Radheshyam Baijnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4435",
    "name": "Bhagat Pandurang Bhujaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1169",
    "name": "Kadam Dhondu Babaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3531",
    "name": "Mahangade Suryakant Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "367",
    "name": "Rajshri Construction"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18319",
    "name": "Adivrekar Madhuri Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10555",
    "name": "Ghadge Vasanti Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4990",
    "name": "Kaji Faizan Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15659",
    "name": "Lad Balkrishna Dagdoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5080",
    "name": "Mahagande Vilas Barmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10304",
    "name": "More Anusaya Mahadeo."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4218",
    "name": "Rakshit  Impex"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19347",
    "name": "More Ganesh Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10791",
    "name": "Pawar Manukabai Abaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12526",
    "name": "Vinod K B"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "793",
    "name": "Ramakant Pendurkar & Sons"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19754",
    "name": "Chavan Pilaji Bapu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "420",
    "name": "Mane Nirmala Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18415",
    "name": "Patil Pandurang Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1146",
    "name": "Shinde Shivaji Bapu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "466",
    "name": "Mohamad  Shafi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3295",
    "name": "Gavali Anurut Sadashiv."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10134",
    "name": "Kuveskar Dhondu Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7517",
    "name": "Kadam Rajendra Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1731",
    "name": "Deshmukh Appa Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8760",
    "name": "Bane Ramesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17719",
    "name": "Dhamne Shubhangi Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13152",
    "name": "Gupta Arjun Shitlaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16015",
    "name": "Jagtap Arun Prabhakar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13751",
    "name": "Matakar Changdev Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6636",
    "name": "Gaikawad Rangrao Dharmaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3128",
    "name": "Shah Pankaj Jethabhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3602",
    "name": "Shinde Mahandra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1132",
    "name": "Katkar Ramchandra Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11255",
    "name": "Gaikawad Jayshree Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "477",
    "name": "Yadavrao Rakhama Tawale."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2936",
    "name": "Patil Bandu Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "33",
    "name": "Sawant Pandurang Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "384",
    "name": "Chandrakant Bhagwan Jadhav."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2675",
    "name": "Ramji S Chaturvedi & Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8825",
    "name": "Bhilare Yashwant Abaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11631",
    "name": "Chatur Vimal Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12315",
    "name": "Chavan Ravindra Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5764",
    "name": "Dave Minaxi Mahendrakumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6056",
    "name": "Dhumal Sambhagi Bhanso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14320",
    "name": "Kadu Chandrakant Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20152",
    "name": "Panchal Vasant Gunaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12316",
    "name": "Patole Suhash Gopinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15349",
    "name": "Phalke Anandrao Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12355",
    "name": "Shingru B K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8891",
    "name": "Singh Rajdeo Ramnaresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21763",
    "name": "Tarpe Jayshree Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14410",
    "name": "Vyadande Kamal Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1317",
    "name": "Keny Jayavant Khanderao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2213",
    "name": "Date Arun Shivram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3427",
    "name": "Kadam Jaysing Yadavrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3224",
    "name": "Kini Namdev Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "108",
    "name": "Kasar Subhash Jagdish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14370",
    "name": "Welode  Deepali Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5757",
    "name": "Kahane Sunil Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "513",
    "name": "Rajaram Raghunath Ansurkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11501",
    "name": "Satam Arati Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11716",
    "name": "Muntasir Bhakar Raja"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18358",
    "name": "Gaware Sachin Devram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16182",
    "name": "Kale Sanjay Sopan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17780",
    "name": "Khan Mohmad Salim Hanif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22154",
    "name": "Maccha Balamani Narsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5922",
    "name": "Mishra Monica Omprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16646",
    "name": "Panikar Krutika Madhavan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6138",
    "name": "Rajak Reena Jayant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13590",
    "name": "Rao Komanane Sriniwas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5438",
    "name": "Salemani Habib Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4717",
    "name": "Shaikh Z A/D.V.Pawar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12278",
    "name": "Vaghamare Bhujang Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14736",
    "name": "Yadav Anil Suryaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6634",
    "name": "Phalake Sudhir Vilasrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16521",
    "name": "Ahari Harishchandra Someshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11162",
    "name": "Yadav Ramchandra Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1900",
    "name": "Sulskar Anusaya Balwanat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13215",
    "name": "Bhilare Ganesh Pandharinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "786",
    "name": "Kazi Mohd Musarrat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2787",
    "name": "Esudas  Sekar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5395",
    "name": "Kadam Hanmant Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17611",
    "name": "Dhavle Varsha Bharat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18424",
    "name": "Raut Samir Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16356",
    "name": "Shirke Sudhir Dattaram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7837",
    "name": "Phalke Patang Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19081",
    "name": "Jaiswal Amit Harshnarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18101",
    "name": "Chawan Shankar Popat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17292",
    "name": "Gurav Chhagan Yashawant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10645",
    "name": "Kadam Ramesh Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14717",
    "name": "Kadav Santosh Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7503",
    "name": "Manjrekar Narendra P/Nameeta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6902",
    "name": "More Kavitabai Vishwanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10722",
    "name": "Sanas Dattatrya Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17857",
    "name": "Sarfare Bhalchandra Sakharam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6703",
    "name": "Satam Prakash Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8915",
    "name": "Shewale Suresh Mahdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5989",
    "name": "Awade Hausabai Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4519",
    "name": "Chavan Eknath Parbati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11853",
    "name": "Kanaujiya Chandrikaprasad Bhuender"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20839",
    "name": "Deshmukh  Chandrakant Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17009",
    "name": "Dhotre Dhrupad Bhaguram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19472",
    "name": "Marwania Durlbhaji Gopalbhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13046",
    "name": "Zazurne Narendra Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8404",
    "name": "Nashikar Aslam Hasan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1139",
    "name": "Khopade Mukutrao Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "161",
    "name": "Bhiku Nana Barge."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16088",
    "name": "Jalgoankar Sachin Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10052",
    "name": "Phalke Mahendra Babaurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12295",
    "name": "Phatak Kishor Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15745",
    "name": "Varik Sunil Pandurang."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10870",
    "name": "Khuthia Meeta Nitin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6771",
    "name": "Anpat Vishwanath Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14216",
    "name": "Bhosale Shivaji Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "194",
    "name": "Rangoli"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4442",
    "name": "Jadhav Mahadeo Bala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "130",
    "name": "Raut Yashwant Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17253",
    "name": "Ladke  Prabhawati  Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13414",
    "name": "Tejam Dattaram Motiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8679",
    "name": "Jadhav Tushar Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2038",
    "name": "Ranka Arts"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14667",
    "name": "Paasi Lalbahadur Sahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14176",
    "name": "Parab Saraswati Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8766",
    "name": "Gade Atmaram Genba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18366",
    "name": "Palkar Madhukar Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18862",
    "name": "Patil Rupali Dhoniba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19576",
    "name": "Pawar Dattatray Nathuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17353",
    "name": "Jagtap  Chandrakant Kisan ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5661",
    "name": "Bhosale Dnyandeo Sudam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20687",
    "name": "Dhopat Sandesh Jairam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16430",
    "name": "Jagtap Dashrath Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11444",
    "name": "Lembe Sambhaji Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13867",
    "name": "Shilimakar Hanumant Parashuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10144",
    "name": "Tembe Gajanan Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14130",
    "name": "Vichare Nitin Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13883",
    "name": "Waste Kishor Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13105",
    "name": "Yadav Deepak Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9294",
    "name": "Pisal Raghunath Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8075",
    "name": "Bhosale Aswathama Jaysingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3204",
    "name": "Surve Sunanda Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13074",
    "name": "Shevkar Kamal Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18822",
    "name": "Bhosale Sampta Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16784",
    "name": "Hussain Mohammed Akbarali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13046",
    "name": "Sabale Jaisingh Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1844",
    "name": "Chavan Rajaram Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11061",
    "name": "Shinde Anusaya Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13003",
    "name": "Madne Hanmant Sonba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10355",
    "name": "Gawade Madhuri Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14941",
    "name": "Kothari Mohanlal Bhaichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17885",
    "name": "Sangale Rupesh Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21389",
    "name": "Sangle Shivaji Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1800",
    "name": "Rasna Silk Mills"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1013",
    "name": "Ratanchand Trachand & Co"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8688",
    "name": "Warekar Shantaram Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17560",
    "name": "Shridhankar Durgesh V"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12829",
    "name": "Pawar Devendra Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14870",
    "name": "Yadav Umeshchand Tufani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18127",
    "name": "Sutar Waman Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4441",
    "name": "Thorat Vilas Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16491",
    "name": "Kambli Reema Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19597",
    "name": "Mirja Nabila Motsim"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "369",
    "name": "Thakur Jyoti Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10610",
    "name": "Vaydande Suresh Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14842",
    "name": "Yadav Rajendraprasad Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14120",
    "name": "Chavan Rajendra Mansinghrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8536",
    "name": "Dapake Vishnu Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9425",
    "name": "Disoza Madlyan Shalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8036",
    "name": "Gupta Asharam L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13906",
    "name": "Salian  Rajendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3920",
    "name": "Jadhav Baban Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2993",
    "name": "Suvarna Gopal R."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5901",
    "name": "Naik Chandrakant Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5573",
    "name": "Dhumal Prabhakar Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "609",
    "name": "Shankar Lal Swami"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3513",
    "name": "Shelar Shivram Dhondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10213",
    "name": "Sabale Maruti Parbati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "61",
    "name": "Ganpat Shamrao Khopde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3",
    "name": "Jagtap Shakarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3119",
    "name": "Kusum"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11980",
    "name": "Bane Rajendra Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16768",
    "name": "Awdannkar Pravin Vasudev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17599",
    "name": "Bhosale Kisan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14232",
    "name": "Bhuwad Avinash Babaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11849",
    "name": "Kalvankar Ram Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12064",
    "name": "Mahadik Archana Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8693",
    "name": "Mishra Shantidevi Harishankar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1515",
    "name": "Patil Rajaram Dharma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5496",
    "name": "Rasal Kiran Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13375",
    "name": "Sakpal Shankar Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5409",
    "name": "Sharma Shivkumar Shankarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8178",
    "name": "Tawade Radhika B/Gopinath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9687",
    "name": "Thappa  Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3364",
    "name": "Patil Anjana Deepak."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12813",
    "name": "Jadhav Baban Shreerang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14636",
    "name": "Devlekar Mahesh Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2660",
    "name": "Shinde Ranjana Shriram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1322",
    "name": "Raichura Kantilal Karsandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8164",
    "name": "Shivjayanti Ustav Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16990",
    "name": "Wagh Sunil Dadaso."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "648",
    "name": "Vishnu Tukaram Shiwade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "506",
    "name": "Gangaram Narayan Prasad Dube"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16441",
    "name": "Berde Santosh Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17750",
    "name": "D Souza William Mates."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1402",
    "name": "Gaikwad Rakesh Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15843",
    "name": "Kashiram Jaidev Pokharal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12666",
    "name": "Parab Satyawan Vinayk"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19959",
    "name": "Phanse Building Pooja Commitee"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9862",
    "name": "Sawant Aanandarao Shiwaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15984",
    "name": "Yadav Dattatray Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13059",
    "name": "Yadav Shahajirao Wamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "119",
    "name": "Balu Sadashiv Shinde."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11593",
    "name": "Chavan Surekha Sudhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3070",
    "name": "Sharma Vinod P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19080",
    "name": "Parte Suresh Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1706",
    "name": "Kharat Sitaram Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8677",
    "name": "Shinde Dilip Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1046",
    "name": "Jagatap Vithal Mugatrao Toli No 129/8"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5410",
    "name": "Suryawanshi Ratan Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13251",
    "name": "Bhosale Yashwant Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2635",
    "name": "Vedpathak Ashish P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8540",
    "name": "Rane Pratibha Deepak/Deepak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20651",
    "name": "Jagatap Mahesh Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8569",
    "name": "Khale Pradip Ambadas ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15134",
    "name": "Mistry Abdul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21414",
    "name": "Mohite Santosh Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7567",
    "name": "Mondkar Sahdeo Dattoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12419",
    "name": "Nikhare Pratibha Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11501",
    "name": "Rane Sudhakar Sahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12481",
    "name": "Salunke Uttam Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8667",
    "name": "Salunkhe Premlata V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14082",
    "name": "Zala Dinesh Bachhubhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16910",
    "name": "Dalvi Ravindra Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "323",
    "name": "Chalake Shrirang Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "939",
    "name": "Bhanushali Sakharben Laximidas."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7583",
    "name": "Bhosale Mahadeo Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4286",
    "name": "Hol Kamal Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7869",
    "name": "Pawar Dilip Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4701",
    "name": "Bagwe Prahlad G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2586",
    "name": "Keni Maryan Bastyav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2013",
    "name": "Deshmukh Sawak Jatha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20926",
    "name": "Yadav Ravindra Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13601",
    "name": "Jadhav Pramila Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16013",
    "name": "Pandey Rajkumar Vijay"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1428",
    "name": "Sawant Suresh Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11734",
    "name": "Shah Jayantilal Manmohandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16368",
    "name": "Shinde Manish Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2247",
    "name": "Shitap Hari Janu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5862",
    "name": "Mahind Sarjerao Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17309",
    "name": "Khedekar Ajitkumar Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1101",
    "name": "Kulakarni Mohan Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13811",
    "name": "Bhusane Dilip Dinkar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10143",
    "name": "Devkule Kamal Hanamant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3842",
    "name": "Deshmukh Kailas G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5189",
    "name": "Jadhav Duryodhan Bandu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5116",
    "name": "Patel Anis Abdul Affar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3175",
    "name": "Bhandari Laxman Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "945",
    "name": "Raviraj Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3961",
    "name": "Rawal Amritlal Annalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14509",
    "name": "Rajgaur Dineshkumar Valji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8821",
    "name": "Dhadam Sitaram Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11775",
    "name": "Chavan Renuka Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12516",
    "name": "Divkar Nakee Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8213",
    "name": "Gupta Rupchand Rambadan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13894",
    "name": "Kadam Shankar Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22003",
    "name": "Malpani Nirmala Kamal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8872",
    "name": "Nilakhe Suresh Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11628",
    "name": "Pagade Sadanand Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3023",
    "name": "Raxita Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18464",
    "name": "Pande Kartiki Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13045",
    "name": "Sawant Sarjerao Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5547",
    "name": "Shirsat Sharda Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17791",
    "name": "Solaskar Devanand Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11708",
    "name": "Varte Pandurang Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2638",
    "name": "Vijaykumar B Dixit"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "735",
    "name": "Rayans Construction"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1229",
    "name": "Shette Sadananda Ramchandra."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10915",
    "name": "Joshi Prakash Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16169",
    "name": "Lad Dipali Kamalakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9343",
    "name": "Rawal Chaganlal Malji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8152",
    "name": "Pisal Bhagawan Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3222",
    "name": "Real Prints"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4328",
    "name": "Real Trading Co"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1491",
    "name": "Chavan Ankush Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "567",
    "name": "Jerald Richard Dsouza."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15269",
    "name": "Kadam Santosh Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11425",
    "name": "Gaglani Mukesh Bhagwanji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14096",
    "name": "Parkar Supriya Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1349",
    "name": "Wavare Kashinath Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7625",
    "name": "Sable Anandrao Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "950",
    "name": "Reekey Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "272",
    "name": "Reema Creation"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3213",
    "name": "Anapat Nathu Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5631",
    "name": "Patil Rajendra Hiraji"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1766",
    "name": "Regency Construction"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15496",
    "name": "Bal Gopal Mandal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11855",
    "name": "Parde Dhondiram Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19463",
    "name": "Dhumal Shushila Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13215",
    "name": "Yadav  Bhelaiprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10101",
    "name": "Singh Santosh Kumar Vijay Pratap"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1758",
    "name": "Renuka Oil Traders"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13163",
    "name": "Agunde Gulabrao Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13843",
    "name": "Jadhav Vishwasrao Raghunath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7821",
    "name": "Kusum"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11456",
    "name": "Mohite Ashok Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20376",
    "name": "Naik Akshata Ajit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11510",
    "name": "Pawar Ramchandra Nagappa"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "242",
    "name": "Salunkhe Bhagwan Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19576",
    "name": "Salunkhe Shetal Nilkant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10671",
    "name": "Yadav Keshav Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3217",
    "name": "Singh Girija Prasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9774",
    "name": "Kadam Lata Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9775",
    "name": "Kadam Prabhavati Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7063",
    "name": "Shirke Vinay Daulat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11450",
    "name": "Basir Jamil Ahmed Mohamed"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3653",
    "name": "Ritu Rayon Pvt Ltd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20460",
    "name": "Jaat Laluram Bhawarlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1126",
    "name": "Rocket Express Courier"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11534",
    "name": "Kadam Dilip Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14772",
    "name": "Kalagutakar Gangadhar Babni"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18364",
    "name": "Kalantre Ananda Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10138",
    "name": "Katkar Vivekanand Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12912",
    "name": "Shee Narayan Subal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5316",
    "name": "Taware Dhanashree Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1230",
    "name": "Rohit Decoretors"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "33",
    "name": "Rohit Wade Wale"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2450",
    "name": "Darji Chandrabhai Haribhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4176",
    "name": "Dhoke Ganesh Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17632",
    "name": "Gadi Shriniwas Vaykatesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7966",
    "name": "Ghadge Anilkumar Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12097",
    "name": "Khan Rubina Abdul Kayyum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8161",
    "name": "Mahendru Rupa A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16755",
    "name": "Panjari Urmila Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11339",
    "name": "Patel Bharat Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11338",
    "name": "Patel Minesh Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4638",
    "name": "Prabhu Anjali Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3010",
    "name": "Sadekar Balkrishna Dattatraya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5331",
    "name": "Jadhav Shantaram Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9977",
    "name": "Chavan Walmik Buvaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19835",
    "name": "Chougale Sandeep Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14370",
    "name": "Dadas Dhondiba Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16809",
    "name": "Gaikwad Amol Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18549",
    "name": "Jadhav Prakash Balaku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18549",
    "name": "Sharma  Chuthi Ramprem"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13802",
    "name": "Shinde Rakesh Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12052",
    "name": "Yadav Shahajirao Vamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7655",
    "name": "Patel Keval Lavji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14233",
    "name": "Pawaskar Vijay Vasudev"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4319",
    "name": "Royal  Casual"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5025",
    "name": "Salunkhe Vithal Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1488",
    "name": "Ruchita Fab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11157",
    "name": "Ahirekar Babasaheb Krishnarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20530",
    "name": "Dhotre  Suresh    Vishwanth"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1953",
    "name": "Rupal Creations"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11041",
    "name": "Ghongade Shankar Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1232",
    "name": "Rupali Collection"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19024",
    "name": "Gurav Sheetal Bhagwat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17546",
    "name": "Jadhav Yogesh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22226",
    "name": "Kadam Swashant Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20644",
    "name": "Kadam Vilas Ramchandra."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2635",
    "name": "Rupesh Angadia Service"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15124",
    "name": "Vanjare Ramesh Bhashakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1075",
    "name": "Narvekar Dattatray Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2975",
    "name": "Kadam Jaysingh Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "452",
    "name": "S"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1020",
    "name": "S R Airconditioning System"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "79",
    "name": "S R Cooling Center"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1885",
    "name": "S S Enterprise"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "103",
    "name": "S.B.S. Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1921",
    "name": "S.K.Computer"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1995",
    "name": "S.K.Moulds & Die"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "859",
    "name": "S.M. Plastic Scraps"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2308",
    "name": "S.R.Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2790",
    "name": "Parab Sunil Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1334",
    "name": "S.S.Baldiya & Co."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12698",
    "name": "Bhat Vijay Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11091",
    "name": "Gaikwad Vandana Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11940",
    "name": "Ghadi Manali Mahendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11834",
    "name": "Lad Santosh Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6666",
    "name": "More Ramchandra Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11204",
    "name": "Pedamkar Vijay Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14498",
    "name": "Pujari Shivapa Visappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16863",
    "name": "Qureshi Namira Wasim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11300",
    "name": "Shaekh Khwaja Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11562",
    "name": "Sharma Santosh Ramnavel"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21884",
    "name": "Sonawane Neeta Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16205",
    "name": "Sunil Sanjay Bhuyad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12717",
    "name": "Yewle Dattatrya Gulab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5292",
    "name": "Hande Madhavrao Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5172",
    "name": "Jagtap Mahadeo Balaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18887",
    "name": "Sawant Jayshree Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3743",
    "name": "Chauhan Lalaji Hure."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6917",
    "name": "Waman Prabhakar Muktaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3627",
    "name": "Dimble Eknath Kanhu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12860",
    "name": "Gurav Mahadev Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1769",
    "name": "Loke Nilkanth Tabu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10253",
    "name": "Jadhav Uday Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11151",
    "name": "Dagli Chhaya Hiren"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7232",
    "name": "Kumbhar Pradeep Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7034",
    "name": "Manjoor  Ansari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11547",
    "name": "Nalage Mohan Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10704",
    "name": "Nikam Namdeo Santu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4371",
    "name": "Patil Sonabai Vishnu."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18155",
    "name": "Pomendkar Hemant Chandrkant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2109",
    "name": "Admuthe Bapu Parisa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2328",
    "name": "Fatima Abdul Esmail Rajan."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "564",
    "name": "Ghadge Gulab Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4464",
    "name": "Ghadi Sumitra Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "997",
    "name": "Thakulla Dhansing Ramsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "311",
    "name": "Patak Shyam Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2487",
    "name": "Rathinaswami  M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1261",
    "name": "Camar Azam Mohammad Yaqub"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8522",
    "name": "Gaikwad Gulab Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12261",
    "name": "Jagtap Ganesh Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17447",
    "name": "Kamathe  Ekhnath  Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20673",
    "name": "More Siddhesh Nandkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19740",
    "name": "Paste Yashwant Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15367",
    "name": "Shaikh Afsar Husain."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7402",
    "name": "Shirke Suresh Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4765",
    "name": "Shrimathi Somayya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10217",
    "name": "Singh Soni Rajkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9379",
    "name": "Tiwari Shriram Shivkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5762",
    "name": "Trivedi Pramila Mohanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1561",
    "name": "Pawar Vishnu Kisanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "304",
    "name": "Dhanwant Singh Bala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "229",
    "name": "Bhalerao Nanda Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13677",
    "name": "Bane Gangaram Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4375",
    "name": "Deshpande Minal Mohan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "543",
    "name": "Gaikawad Deelip Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6322",
    "name": "Khirwale Ramchandra Subhedar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13995",
    "name": "Gawade Chandrakant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14295",
    "name": "Lal Ravi Alakh."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12248",
    "name": "Mane Deepa Ravindra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13500",
    "name": "Mathai Varkey Jacob"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3146",
    "name": "Rasal Sambhaji Sadhurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10569",
    "name": "Hadakar Nita Dnyandev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7923",
    "name": "Nalawade Sunil Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9134",
    "name": "Shukla Ramlakhan Bhagwatiprasad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1524",
    "name": "Kadam Sachin Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19932",
    "name": "Kadam Sangita Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6910",
    "name": "Pawar Bharati Shamarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20464",
    "name": "Shri  Sai  Siddhi  Mitra Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18292",
    "name": "Kadam Kishore Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "1149",
    "name": "Kumthekar Prabhakar Ganesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3274",
    "name": "Pansare Popat Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12215",
    "name": "Ghag Shriram Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14327",
    "name": "Sawant Amruta Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6509",
    "name": "Salgaonkar Suresh Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3229",
    "name": "Jadhav Jagannath Antu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "375",
    "name": "Sachai Construction"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9232",
    "name": "Assia Khatun Amzad Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16028",
    "name": "Dhumal Shobha Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15213",
    "name": "More Bharat Khandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4874",
    "name": "P P K Brahmachainya Mahajani Maharj"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "238",
    "name": "Sachin Pattern Works"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13015",
    "name": "Pawar Mahendra Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17298",
    "name": "Rane Suhas Suresh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21225",
    "name": "Shirsekar Sulochana Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16947",
    "name": "Yadav Sabharaj Ramashrey"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "921",
    "name": "Sagar Construction"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14510",
    "name": "Rathod Jaimala Pravin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "811",
    "name": "Bobade Baliram Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3026",
    "name": "Ali  Sakir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6048",
    "name": "Warde Subhash Dwarkanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "456",
    "name": "Jyotiram Nathuram Mulik."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3699",
    "name": "Khawaja Mehboob S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20609",
    "name": "Birmole  Prabhakar Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6659",
    "name": "Choudhary Ramkrishna Sundar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10940",
    "name": "Dubal Mangal Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20117",
    "name": "Patil Ananda Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19102",
    "name": "Shah Hitendra Nagindas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13117",
    "name": "Mahata  Dip Bahadur M."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14146",
    "name": "Bhosale Pandurang Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1168",
    "name": "Mohite Charushila Chandrakant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13564",
    "name": "Manjarekar Sandhya Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8564",
    "name": "Jadhav Ratnamala D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16108",
    "name": "Bhoite Lalaso Govindrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8551",
    "name": "Shinde Vinod Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3168",
    "name": "Patel Jayaben Aravindbhai"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "158",
    "name": "Sai Automobiles & Service Centre"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1633",
    "name": "Sai Engineering"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "695",
    "name": "Sai Engineering Works"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1893",
    "name": "Sai Plast"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "64",
    "name": "Sai Prasad Graphic"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4453",
    "name": "Saichinam Bahudeshia Seva Trust"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20650",
    "name": "Bhise  Bhagawan  Abha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20860",
    "name": "Date Sharda Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4771",
    "name": "Dhobi Ashokkumar Rameswar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10797",
    "name": "Hairy  Robart"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17071",
    "name": "Khan Sultan Usman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7985",
    "name": "Kulkarni Suman Govindrav"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1461",
    "name": "Sailee Products"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10375",
    "name": "Mhaismale Nanasaheb Satwaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6513",
    "name": "Sarankar Sunil Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21435",
    "name": "Shaikh Naseem Saeed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21668",
    "name": "Varma Ramkishan Ghishiyavan"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "205",
    "name": "Sainik Kirana Stores"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13058",
    "name": "Wagh Surekha Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4068",
    "name": "Sairaj Trading Co."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "759",
    "name": "Saisiddhi Advertising&Printing Services"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3296",
    "name": "More Vasant Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11440",
    "name": "Shaikh Mohammad Husein Abdul Halim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3639",
    "name": "Gupta Zoolan Shivmangal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3663",
    "name": "Kamath Vijaya Kishor."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4310",
    "name": "Pawar Suryakant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2511",
    "name": "Mhamunkar Geetabai Baburao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14666",
    "name": "Ambraliya Nilesh Jayntilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19082",
    "name": "Bohara Kalu Dhansingh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15143",
    "name": "Datkhile Baban Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12744",
    "name": "Hiwale Visranti Murlidar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12589",
    "name": "Jadhav Madhukar Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16974",
    "name": "Shirke Ranjan Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17982",
    "name": "Wakade Shivaji Rambhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3027",
    "name": "Sawant Sonu Dhondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7705",
    "name": "Shinde Yashwant Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "488",
    "name": "Shetye Vishwanath Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14018",
    "name": "Kokate Balkrishna Govind."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10861",
    "name": "Wagh Shivaji Dagdoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "212",
    "name": "Ashok Shankar Bhide."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6786",
    "name": "Bhuwad Dhondu Nagoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14884",
    "name": "Banaye Ashok Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15132",
    "name": "Channe  Jitendra Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12446",
    "name": "Dhuri Shiva Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16349",
    "name": "Gurav Balkrishna Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10803",
    "name": "Pednekar Anupama Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15131",
    "name": "Yadav Abhijit Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "190",
    "name": "Devendra Sadashiv Nikam."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1578",
    "name": "Sabale Vasant Ravba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10573",
    "name": "Gaikawad Vijay Mugutrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4668",
    "name": "More Tukaram Daulat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16974",
    "name": "Jangal Ramalu Narsappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13781",
    "name": "Prabhu Vanita Varadraj."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12558",
    "name": "Shaikh Kadar Mohd Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4972",
    "name": "Yadav Dipak Pratap"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20002",
    "name": "Yadav Shubhangi Satish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5918",
    "name": "Sagvekar Rajendra Pundalik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4459",
    "name": "Tamboli Bansi Nathu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3561",
    "name": "Akhil Khudi Gramastha School Sangh-Bom"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12044",
    "name": "Chache Bhagirthi Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3348",
    "name": "Bachim Narayan Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11692",
    "name": "Gaikwad Sakharam Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "487",
    "name": "Shashikala Jayram Bhandari."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "295",
    "name": "Kadam Appaso Baba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17685",
    "name": "Parab Amit Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9543",
    "name": "Shinde Lata Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21826",
    "name": "Sonar Ransing Pahalsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9185",
    "name": "Chorage Uttam Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12096",
    "name": "Salunkhe Dattatray Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20597",
    "name": "Bhoir  Audombar  Suresh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22766",
    "name": "Chavan Manoj Arun"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "422",
    "name": "Giroh Jyotsna Ramchander"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13794",
    "name": "Haldankar Sanjiv Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12421",
    "name": "More Sunanda Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12806",
    "name": "Rane Maruti Wamanrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "88",
    "name": "Sheikh Nadeem Harun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8863",
    "name": "Yewale Ashok Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10999",
    "name": "Chalke Laxmi Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2356",
    "name": "More Vishnu Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7530",
    "name": "Gade Kalpana Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7096",
    "name": "Thorve Dinkar Dnyanoba/Vandana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17806",
    "name": "Sankpal Tanaji Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5082",
    "name": "Dube Shivchand Dudhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15452",
    "name": "Mahadik Dinesh Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5089",
    "name": "Naringrekar Swapna Surendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9413",
    "name": "Pandare Chandrakant Nhanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17818",
    "name": "Vanjare Shubhangi Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1311",
    "name": "Varkhade Sitaram Ravaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13707",
    "name": "Shinde Tukaram Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10718",
    "name": "Bhor Minakshi Krishnakumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1895",
    "name": "Goka Ganesh Padmanabha."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11357",
    "name": "Mahadik Sanjay Dadaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3914",
    "name": "Nalawade Chandrakant Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10551",
    "name": "Bhandare Aarti Gangadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12375",
    "name": "Chavre Dattaram Wamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16090",
    "name": "Dige Manisha Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11969",
    "name": "Gaikwad Raju Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6554",
    "name": "John  Johnson"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20308",
    "name": "Kambale Arjun Shivaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1303",
    "name": "Pandit Pappu Shriramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23541",
    "name": "Pashte Ranesh Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18664",
    "name": "Raval Kokilaben Rajnikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10073",
    "name": "Shinde Chandrakant Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15377",
    "name": "Ware Vikas Keshav."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9104",
    "name": "Sakhare Chandrakant Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5178",
    "name": "Sakunde Vasant Dadaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2916",
    "name": "Bhilare Sampat Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2630",
    "name": "Raje Mahadev Ganpat ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1161",
    "name": "Kadam Sharda Jaysing."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9025",
    "name": "Yadav Ranchandra Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6115",
    "name": "Kambale Ashok Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5201",
    "name": "Arya Manilal Dubal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11418",
    "name": "Chouhan Chandradev Ramprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22865",
    "name": "Dhole Amit Arvind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14938",
    "name": "Gunde  Shakuntala Popat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18864",
    "name": "Hajare Atmaram Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17486",
    "name": "Jadhav Satish Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6335",
    "name": "Kamil Mohmed Atul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18366",
    "name": "Katkar Vijya Sharad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10666",
    "name": "Masurkar Ashok Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5180",
    "name": "Pawar Yashwant Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12508",
    "name": "Shirtode Shivaji Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11185",
    "name": "Wagdole Subhash Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2650",
    "name": "Sabale Balkrishna Sawalaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7065",
    "name": "Dalvi Vijay Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8056",
    "name": "Jagtap Muralidar Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8233",
    "name": "Chavan Dilip Narayanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3505",
    "name": "Barskar Aayshabi Hidayat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10103",
    "name": "Shinde Murlidhar Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4563",
    "name": "Bohra  Mohnish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15750",
    "name": "Bele Mangal Bhojraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5222",
    "name": "Bhagat Sudhir Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13143",
    "name": "Jagtap Vijay Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13152",
    "name": "Khaire Ajit Madhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6968",
    "name": "Sahyadri Darshan Shikshan Sanstha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12037",
    "name": "Sakharkar Narendra Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5986",
    "name": "Shelke Latika S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9321",
    "name": "Shevate Sunanda S./Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21614",
    "name": "Yadav Bindeshwari Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3978",
    "name": "Patil Jivan Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "510",
    "name": "Narhari Shankar Kale"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4983",
    "name": "Shah Amichand Gautamchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6896",
    "name": "Kadam Ravindra Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "470",
    "name": "Narayan Ganpat Dangat."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8522",
    "name": "Aware Vinayak Vyankatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10506",
    "name": "God Lalanprasad Sinhmurod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10353",
    "name": "Kumbhar Dilip Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17652",
    "name": "Mulekar Rajan Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7777",
    "name": "Poojari Anita Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6249",
    "name": "Thapa  Lalsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1017",
    "name": "Vijay Sakharam Gawade."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13538",
    "name": "Shirke Nalini Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22739",
    "name": "Kambale Meena Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18028",
    "name": "Khalate Sunil Ashokrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15120",
    "name": "Khuspe Rajedra Ragunat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4355",
    "name": "Shinde Dattatray Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9990",
    "name": "Mane Shushila Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20207",
    "name": "Shinde Ashok Sopanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1273",
    "name": "Phalke Hanmant Jijaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6708",
    "name": "Shah Sureshkumar B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13572",
    "name": "Bait Sunil Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6909",
    "name": "Buchanna Bunty Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16568",
    "name": "Chauhan Munib Lalchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19661",
    "name": "Chorge Gorakh Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "550",
    "name": "Davaky A. Sukumaraw"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9301",
    "name": "Gaikwad Mahadeo Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7228",
    "name": "Gosavi Rekha Kanubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14956",
    "name": "Kadam Rajesh Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5954",
    "name": "Manikam Alan Agastin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7730",
    "name": "Shelar Vilas Vishnu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13151",
    "name": "Suryavanshi Ashok Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12108",
    "name": "Warkhadkar Raghoba Sawlaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1473",
    "name": "Tiwari Narsinh Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4570",
    "name": "Nisim Ahmed Kasim Shaikh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1515",
    "name": "Sawant Deepak Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8078",
    "name": "Solaskar Bhikoba Kondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3615",
    "name": "Santhanaraj  M.K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13348",
    "name": "Gaikwad Sarubai Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20619",
    "name": "Mestry Mangal Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17928",
    "name": "Nimbalkar Ramrao Dharmu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7594",
    "name": "Loke Deepak Ganpat/Jyoti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10246",
    "name": "Dighe Sindhu Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "958",
    "name": "Khochare Ganpat Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9388",
    "name": "Bakare Waman Vasudeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1309",
    "name": "Sathe Sayabu Dada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1023",
    "name": "Sangavi  Premaji Dharamshi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12539",
    "name": "Hudle Shantabai Damaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13173",
    "name": "Jadhav Sunil Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5921",
    "name": "Patil Daji Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1710",
    "name": "Kamble Raghunath Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6114",
    "name": "Mandhare Kisan Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11547",
    "name": "Padalkar Tanaji Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "808",
    "name": "Kungule Gulab Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2772",
    "name": "Doke Vitthal Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6774",
    "name": "Sonmale Vimal Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14083",
    "name": "Kotkar Vilas Shantaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16115",
    "name": "Rane Arun Mohan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19922",
    "name": "Yadav Ajit Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5881",
    "name": "Jambharkar Narayan Keru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12659",
    "name": "Sutar Govind Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1461",
    "name": "Bandgar Krishna Shamrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3855",
    "name": "Dhanavade Savalaram Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "561",
    "name": "Dasrath Mallappa Teli."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "420",
    "name": "Bagave Mohan Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13656",
    "name": "Gurkha Nandram Himlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18830",
    "name": "Kandar Nilu Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12423",
    "name": "Mestri Laxmi Dayal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23035",
    "name": "Nirela Raja Gowra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11279",
    "name": "Waghe Mahadeo Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8689",
    "name": "Ghadge Lala Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5064",
    "name": "Chavan Uddhav Jaising"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6110",
    "name": "Mahadik Tanaji Pilaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5265",
    "name": "Pawar Ravindra Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4865",
    "name": "Sharma Dropadi Ramaktar/Ramavatar Sharma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5220",
    "name": "Nawadkar Gopal Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10186",
    "name": "Mhaskar Shantaram Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1519",
    "name": "Jagtap Shashikant Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2150",
    "name": "Karkar Jijaba Balwantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5421",
    "name": "Ghagare Satyavan Hiroji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12583",
    "name": "Barik Prabas Balram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21515",
    "name": "Lavathe Krishna D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16803",
    "name": "Lawand Ramchandra Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11719",
    "name": "Lembhe Dattatray Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12700",
    "name": "More Laxman Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13871",
    "name": "Sakre Shashikant Atamaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5110",
    "name": "Shing Baljeetsingh Purshottam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17237",
    "name": "Vishvkarma Ghanshyam Nageshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7893",
    "name": "Barge Tulsabai Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10139",
    "name": "Khanvilkar Sandesh Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3343",
    "name": "Motalab Esmile Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1372",
    "name": "Pawar Vijay Dnyandev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10238",
    "name": "Jain Dilip Kumar Girnarsingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10020",
    "name": "Chinchakar Maruti Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22796",
    "name": "Parab Vilas Shridhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11351",
    "name": "Phalke Kumudini Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11372",
    "name": "Bade Navnath Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12968",
    "name": "Bhosale Tukaram Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12675",
    "name": "Ingale Tushar Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14824",
    "name": "Kadage Sanosh Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5096",
    "name": "Raut Kanchan Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22088",
    "name": "Sahani Rajkumar T."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4281",
    "name": "Pawar Jyoti Kumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15185",
    "name": "Gawde Balkrishna Sadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1493",
    "name": "Sayyad Sharfuddin Abdulkarim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10690",
    "name": "Pillai Dayanidhi Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9712",
    "name": "Best Amiel Ralph"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18030",
    "name": "Bhandari Juhika Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19184",
    "name": "Dalavi  Suvrana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9605",
    "name": "Ghadge Bebi Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12639",
    "name": "Naik Rupeshri Ramnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4459",
    "name": "Pawar Ramchandra Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10757",
    "name": "Rajy  Mathew/Anita"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11359",
    "name": "Vishwakarma Neelam D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8606",
    "name": "Yadav Pyarelal Rajai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10655",
    "name": "Parsekar Manisha Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1569",
    "name": "Kadam Saranganath Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4759",
    "name": "Jadhav Hari Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15609",
    "name": "Desai Sanjay Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20751",
    "name": "More Baban Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8837",
    "name": "Bhosale Laxmi Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3588",
    "name": "Nawadkar Kisan Dhanaji."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9796",
    "name": "Chavan Sadashiv Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4126",
    "name": "Siddi Zeenot Noor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2892",
    "name": "Pathak Radheshyam B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2019",
    "name": "Gadekar Vilas Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6364",
    "name": "Mahadik Ramachandra Bajarang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6186",
    "name": "Bhoite Mangesh Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18845",
    "name": "Ganiga Nagesh Nsimha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5467",
    "name": "Gupta Babita Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14845",
    "name": "Khoje Sangita Somnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11600",
    "name": "Prasad Mahesh Prasad A"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20379",
    "name": "Sakpal Sandeep Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19777",
    "name": "Phulsunder Manda Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3572",
    "name": "Walekar Somanath Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3848",
    "name": "Kadam Balkrushna Antu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13659",
    "name": "Badekar Nanubai Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15931",
    "name": "Jadhav Balkrishna Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6330",
    "name": "Jadhav Sanjay Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18984",
    "name": "Kavar Usha Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12563",
    "name": "Rathod Rupsingh Bhadru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13501",
    "name": "Shelar Sanjay Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20162",
    "name": "Tambe Mahadev Kalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7396",
    "name": "Thakur Dinkar/Barku Sanwane/Bhimraj Mask"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3522",
    "name": "Gori Simat Yusuf"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22490",
    "name": "Shejwal Shrirang Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15687",
    "name": "Hile Shankar Ramaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15427",
    "name": "Jadhav Surekha Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16559",
    "name": "Jaiswar Pannalal Rajaram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17768",
    "name": "Luis Joana"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1470",
    "name": "Momin Rahilahmad Abkayyum"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10606",
    "name": "Chavan Hirabai Khanderao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1989",
    "name": "Sakunde Vimal Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16327",
    "name": "Bideshi  Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13214",
    "name": "Bhagyalaxmi Co-Op Hsg. Society."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10001",
    "name": "Bhushanam Simpri Victor"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "341",
    "name": "Jain Prakash Kanhailal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12846",
    "name": "Jawan Dhanraj Limbanna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "596",
    "name": "Lad Amruta Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4907",
    "name": "Nikam Kamlakar Bapusaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16028",
    "name": "Salavi Ramchandra Gangaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13256",
    "name": "Shaikh Nuralum Hurmuj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14892",
    "name": "Sharma Narendra Hanuman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5266",
    "name": "Shetty Vanaja Divakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1373",
    "name": "Disle Hanmant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14500",
    "name": "Harijan Ramnaval Basant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3991",
    "name": "Pawar Jyosna Anant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3719",
    "name": "Suryawanshi Ashok Chandu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1297",
    "name": "Masurkar Anant Mahadeo ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15766",
    "name": "Doshi Bhogilal Damodaran"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5637",
    "name": "Gohil Karsan Laljee"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14822",
    "name": "Awasti Aruna Rakesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17475",
    "name": "Dayal  Kishan Dhansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13880",
    "name": "Feranandis Erina Mangal John."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18195",
    "name": "Kilaje Sudhakar Daji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12196",
    "name": "Ningavle Ganesh Mankoji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10925",
    "name": "Pawar Chhaya Sudhirrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12745",
    "name": "Rajpure Sneha Sudhir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15672",
    "name": "Thevare Sunanda Sadanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3517",
    "name": "Sheth Mukesh Himatlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8107",
    "name": "Shirtode Tatyaba Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4132",
    "name": "Gujar Kantabai Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2286",
    "name": "Shinde Hanamant Denakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17763",
    "name": "Mahale Vitthal Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7776",
    "name": "Sutar Tarabai Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13040",
    "name": "Bhosale Umesh Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9108",
    "name": "Deshmukh Muktabai Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20680",
    "name": "Dhumal Sadhana Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17028",
    "name": "Pachangane Yogesh Ratansinh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1031",
    "name": "Santalal Kulai Jaiswal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13574",
    "name": "Chatur Balkrishna Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12410",
    "name": "Devalekar Abhijit Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17640",
    "name": "Gawage Shridhar Shivram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9094",
    "name": "Chavan Arjun Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6472",
    "name": "Sawant Ashvini Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "972",
    "name": "Parab Janardhan Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8844",
    "name": "Bhillare Sahebrao Balwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4653",
    "name": "Arote D. Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "890",
    "name": "Bendre Prakash Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10450",
    "name": "D Souza Eliza Celine"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22071",
    "name": "Gawade Rajesh Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8585",
    "name": "Kudtarkar Arvind Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20734",
    "name": "Mestry Harshad Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12851",
    "name": "Patil Sunil Vilas"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "402",
    "name": "Sadhu Anup Manik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17856",
    "name": "Tondwalkar Vithal Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9736",
    "name": "Bait Yeshwant Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2120",
    "name": "Sam Corporation"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4889",
    "name": "Sawant Namdeo Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3697",
    "name": "Deshmukh Ankush Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5825",
    "name": "Asgar  Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14193",
    "name": "Ghosalkar Pooja Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5594",
    "name": "Jalgaonkar Surekha Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7265",
    "name": "Khatri Amarsingh Kamalsingh/Nanasingh So"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7085",
    "name": "Shinde Deepak Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20249",
    "name": "Yadav Amrut Mangal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15968",
    "name": "Yadav Pooja Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11080",
    "name": "Shirtode Sharda Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2212",
    "name": "Halade Gautam Ladoji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1433",
    "name": "Bhandari Manohar Sukur."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10293",
    "name": "Chavan Hirabai Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1297",
    "name": "Dhanawade Pratap Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "631",
    "name": "Sampadak Vishwakarma Panchal  Masik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3717",
    "name": "Harale Vilas B."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7272",
    "name": "Vani Dagdu Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6456",
    "name": "Maniyar Jitendra P."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9328",
    "name": "Shinde Sakhubai Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "529",
    "name": "Amarjeet Sing Bhatty"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2917",
    "name": "Phalke Atmaram Balvant"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "428",
    "name": "Sana Body Builders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "11",
    "name": "Sanap Printing Press"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "267",
    "name": "Devkar Laxman Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2152",
    "name": "Kubal Suresh Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8529",
    "name": "Ghagre Ashok Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5786",
    "name": "Gudekar Subhash Narayan/ Pandharinath/Ka"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11299",
    "name": "Karpe Ashok Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11481",
    "name": "Singh Omprakash Vanshnarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8332",
    "name": "Bagawe Madhuri Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "699",
    "name": "Janabai Meghnath Raje."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5844",
    "name": "Hire Dagu Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9233",
    "name": "Savla Harsha Kantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14202",
    "name": "Chavan Toliram Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "421",
    "name": "Mane Babso Dadaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5809",
    "name": "Jadhav Hanmant Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13386",
    "name": "Bhosale Ramesh Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "623",
    "name": "Sandeep Industries"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3686",
    "name": "Sandip Jagannath Rasal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14393",
    "name": "Bhoite Rajkumar Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11577",
    "name": "Jadhav Gulabrao Babasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13785",
    "name": "Khopde Sarjerao Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13689",
    "name": "Paramshivam  Natrajan."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12922",
    "name": "Shirtode Balu Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15522",
    "name": "Soni Ransing Pahalsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4417",
    "name": "Girnse  V.V."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "704",
    "name": "Sangam Motor Body Bilders"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "969",
    "name": "Bhogale Sulochana Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2805",
    "name": "Kondalkar Narayan Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3960",
    "name": "Kadam Dattatray Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13277",
    "name": "Bhalekar Sitaram V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11767",
    "name": "Chouhan Rampalat Shobnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16806",
    "name": "Mandhare Kalyani Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17840",
    "name": "Mohite Sakharam Anu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20314",
    "name": "Waghe  Avishkar Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10304",
    "name": "Parkar Dilip Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10686",
    "name": "Golipkar Vaishali Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14477",
    "name": "Salunkhe Ishwar Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8698",
    "name": "Ghadge Ashok Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16451",
    "name": "More Manda Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18831",
    "name": "Vishwakarma Natesh Rangchar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4964",
    "name": "Atkare Sunanda Ramnath/Ramnath D Atkare"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12754",
    "name": "Chavan Narayan Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13799",
    "name": "Kadam Komal Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2704",
    "name": "Shivshakti  Sanitation"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4311",
    "name": "Siddi Noormohamed Bilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1863",
    "name": "Bhoite Suresh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6759",
    "name": "Chavan Bhanudas Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13032",
    "name": "Babar Ankush Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20457",
    "name": "Gole Sachin Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14089",
    "name": "Rajeshwarprasad  Fulenaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7004",
    "name": "Salve Suresh Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12014",
    "name": "Talekar Raghupati Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13440",
    "name": "Ghadage Sawala Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2407",
    "name": "Santosh Kishan Packing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5077",
    "name": "Nadar E Rajendran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8009",
    "name": "Shinde Tarabai Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7061",
    "name": "Gavaskar Balkrishna Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16945",
    "name": "Sapkal Santosh Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13473",
    "name": "Shinde Pramod Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3246",
    "name": "Lad Manohar Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11413",
    "name": "Bhoite Gulabrao Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19949",
    "name": "Chowdhari Yashoda Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15066",
    "name": "Parab Vanita Harichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16591",
    "name": "Chawan  Memuha Jamal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13636",
    "name": "Karande Balkrushna Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11125",
    "name": "Rahangdale Rajendra Hariman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20504",
    "name": "Tanawade Laxmi Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3279",
    "name": "Mhatre Tukaram Kamalakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11500",
    "name": "Gade Ramachandra Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9481",
    "name": "Pawar Purushottam Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7684",
    "name": "Veralkar Mangesh Anant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17377",
    "name": "Wadekar Uday Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17181",
    "name": "Chawan Shantabai Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5048",
    "name": "Kumbhar Maya Baba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10281",
    "name": "Disale Anil Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20587",
    "name": "Hule Shraddha Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4681",
    "name": "Kamite Nanabhau Malhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7753",
    "name": "Khpade Prabha Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8903",
    "name": "Kulkarni Sunita Suresh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13714",
    "name": "Mahangade Shanta Kisan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14993",
    "name": "Masavkar Pramod Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9347",
    "name": "Niyaz Ahmad Gulam Hussain Choudhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20256",
    "name": "Shah Anilkumar Bharat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7231",
    "name": "Shah Shishir Amichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5009",
    "name": "Kamble Dhondu Sonu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4251",
    "name": "Saptgiri Impex"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14397",
    "name": "Chippa Srinivas Narasayya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14337",
    "name": "Gadade Chandrakant Bhimsen"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15358",
    "name": "Jadhav Kisan Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "618",
    "name": "Sarjerao Vishnu Devkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16052",
    "name": "Omale Jitendra Chandrakant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12917",
    "name": "Bhosale Vikas Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19356",
    "name": "Chohan Salim Mohamad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1121",
    "name": "Gutka Ankit Chimanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4334",
    "name": "Jagdeo Mukand Vaichand."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2478",
    "name": "Shinde Vasudeo Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8604",
    "name": "More Lxaman Balawant"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1987",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2050",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1620",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2892",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "650",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15400",
    "name": "Dharankar Sonal Rajendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7385",
    "name": "Dhumal Sunil Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14209",
    "name": "Swamy Madhu D."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3152",
    "name": "Bhoite Arun Ekanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1691",
    "name": "Tharod Shah  Suraji Kanchara"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10762",
    "name": "Mulani Ajmuddin Gafur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1726",
    "name": "Gosavi Sakhubai Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4569",
    "name": "Jadhav Ramchandra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1043",
    "name": "Nanaware Vithal Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12763",
    "name": "Bhosale Sunil Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12110",
    "name": "Bobde Kisan Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14123",
    "name": "Chavan Changdeo Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8475",
    "name": "Darlekar Minaxi Mangesh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21997",
    "name": "Gaikwad Vishal Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15917",
    "name": "Gangawane Umesh Dada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11462",
    "name": "Pawar Tanaji Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14865",
    "name": "Surwanshi Amol Hambirrao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13148",
    "name": "Ulalkar Ramchandra Nagoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7832",
    "name": "Aware Sulochana Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7220",
    "name": "Gadhave Ravindra Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3313",
    "name": "Rode Karbhari Santu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1867",
    "name": "Mhapankar Prema Sahadeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2127",
    "name": "Khobrekar Kamalakant Vishwanath."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6838",
    "name": "Surve Sudhakar Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3501",
    "name": "Raut Santosh Dinanath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15298",
    "name": "Giri Prabhakar Nathuni"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3694",
    "name": "Jagtap Ganpat Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16669",
    "name": "Jaiswal Ramagautam Munnilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17838",
    "name": "Sherekar Bhikaji Raghunath."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15334",
    "name": "Shinde Ananta Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14381",
    "name": "Disoza Franacies Samtes ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10298",
    "name": "Shah Shantilal Laxmichand Shah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4664",
    "name": "Rajmale Ramkisan Vyankatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11175",
    "name": "Jadhav Bharat Subhedar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10491",
    "name": "Kadam Mahadev Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "861",
    "name": "Seetaram  Gupta."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7492",
    "name": "Borate Bhanudas Shamrao"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "16",
    "name": "Sarthak Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4951",
    "name": "Bandiaga Swami Mallaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5902",
    "name": "Dhire Indu Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10822",
    "name": "Jagtap Jayashree Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10471",
    "name": "Namekar Ranjeet Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "715",
    "name": "Sarvodaya  Syndicate"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15507",
    "name": "Dhamapurkar Shital Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1668",
    "name": "Harjan Bire Lale."
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "955",
    "name": "Sasken  Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6661",
    "name": "Yadav Rajaram Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15568",
    "name": "Rane Udya Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18798",
    "name": "Sapate Anand Naryan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14390",
    "name": "Sawant Santosh Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10169",
    "name": "Tamboli Manda Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3571",
    "name": "Jadhav Arjun Baburao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2593",
    "name": "Wagh Dattatry Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10372",
    "name": "Band Gopal Vesta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16908",
    "name": "Deshmukh  Vasant Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4737",
    "name": "Dethe Rajesh Madukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20209",
    "name": "Liman Nutan Anant."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15313",
    "name": "Pawar Sanjay Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11351",
    "name": "Pinto Sunita Vincent"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17173",
    "name": "Takkar Onkar Nagesh./Keluskar Rekha Ekna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9036",
    "name": "Vaity Wilma Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9819",
    "name": "Ansari Abdulla Mohamad Unus"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12385",
    "name": "Barge Rajendra Bhagwan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1437",
    "name": "Mane Varsha Sidnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21795",
    "name": "Patil Vikas Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3717",
    "name": "Darekar Mohan Bhiku."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6344",
    "name": "Phalke Sushila Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "538",
    "name": "Bhosale Shyamrao Kundalik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14912",
    "name": "Chavan Machindra Vithalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18768",
    "name": "Jadhav Vitthal Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20023",
    "name": "Yadav Motilal Dharmraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17328",
    "name": "Ghadigaonkar Priyanka Bhikaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7935",
    "name": "Gujar Ranjana Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6021",
    "name": "Monterro  Derrick Felix"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10832",
    "name": "Bhosale Rekha Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2074",
    "name": "Shinde Laxmibai Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17039",
    "name": "Bhosale Bharat Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7509",
    "name": "Borkar Pramod Shyamsundar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5415",
    "name": "Dhere Kurshivati Ambadas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12708",
    "name": "Gavde Sitabai Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15656",
    "name": "Phatak Santosh Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4703",
    "name": "Shinde Avanti Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14929",
    "name": "Sing Bhupal Ganga."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14768",
    "name": "Varhadi Rupali Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9137",
    "name": "Palwankar Atmaram Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14391",
    "name": "Parab Prashant Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "934",
    "name": "Satyen Incorporated"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "917",
    "name": "Saurabhi Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3298",
    "name": "Rasal Vijaykumar Baban."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8414",
    "name": "Mulla Abbas Yusuf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4839",
    "name": "A M Raheman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5567",
    "name": "Alurkar Sunanda Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8403",
    "name": "Ambatkar Bajarang Shrihari."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7645",
    "name": "Chavan Shrirang J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5194",
    "name": "Desai Rekha Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2889",
    "name": "Jadhawar Vishwas Somnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11714",
    "name": "Kadam Balasaheb Savla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10537",
    "name": "Kedar Vijay Khandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12659",
    "name": "Palav Malini Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21121",
    "name": "Shinde Manohar Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11346",
    "name": "Yadav Bidawati C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14893",
    "name": "Yadav Jaysing Harinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9168",
    "name": "Agrawal Rajiv Kishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2985",
    "name": "Gulumkar Bajirao Bandoba."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4753",
    "name": "Jain Champabai V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3653",
    "name": "Kasbe Dadan Fakira"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3704",
    "name": "Gaikwad Dnyanoba Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10606",
    "name": "Ambavale Pandharinath Genba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8401",
    "name": "Gaikwad Pralhad Ramu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7539",
    "name": "Jain Sohanlal Phulchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20200",
    "name": "Ghadage Chandrakant Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21074",
    "name": "Karekar Chetana Anjankumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19637",
    "name": "Kokane Kisan Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5876",
    "name": "Manjarekar Namita N."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9006",
    "name": "Salunkhe Vijaya Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7682",
    "name": "Shah Kumud A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7743",
    "name": "Shaikh Hasan Ali."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15421",
    "name": "Wadekar Rupali Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3435",
    "name": "Gaikar Balshiram Jayram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9704",
    "name": "Ghag Krishna Sayaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3404",
    "name": "Dhanani Ibrahim Isa."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6004",
    "name": "Bhosale Rangrao Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2786",
    "name": "Mohite Subodh Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13340",
    "name": "Bhosale Maruti Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16751",
    "name": "Bobby Balan E.V."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22246",
    "name": "Chorge Swati Hemant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8344",
    "name": "Choudhary Bhearulal Aslaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10851",
    "name": "Halankar Aniruddha Ladoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7536",
    "name": "Sadhavani  Kavita"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13004",
    "name": "Sawad Nandasingh Ramsingh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "98",
    "name": "Sayyed Musa Mubarak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6619",
    "name": "Nayak Dinesh Babubhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12121",
    "name": "Chavan Sanjay Damodar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17875",
    "name": "Pendharkar Sidharth Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8508",
    "name": "Kadam Manojkumar Yashawant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12582",
    "name": "Kamble Tatya Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20135",
    "name": "Khariwal Gopal Manoj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9745",
    "name": "Patil Gajmal Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17074",
    "name": "Pawar Manohar Rongaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21158",
    "name": "Phadtare Shivaji Popatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20925",
    "name": "Shah Jitendra Jamanadas"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "588",
    "name": "Sawant Brothers"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2106",
    "name": "Parte Rajesh Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20817",
    "name": "Pawa R Sagar  Deepak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17841",
    "name": "Dudwadkar Pramod Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21750",
    "name": "Yadav Deepak Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3906",
    "name": "Pawar Anjirabai Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20115",
    "name": "Fernandes Manuel C."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21339",
    "name": "Shelar Kamal Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9963",
    "name": "Shirke Sahmala Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13481",
    "name": "Solanki Premji Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8774",
    "name": "Jagtap Ravindra Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10222",
    "name": "Pawar Hirabai Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8874",
    "name": "Bamne Priya Pramod"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15393",
    "name": "Dhuri Uday Bhiwaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "582",
    "name": "Gautam Sunil Harikesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9345",
    "name": "Gurav Ramesh Ratnakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9941",
    "name": "Kambale Sharda Raju"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11535",
    "name": "Kshirsagar Arun Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9229",
    "name": "Pawar Chandrakant Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13981",
    "name": "Shinde Shirish Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6549",
    "name": "Gosavi Dattaram Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2883",
    "name": "Ambekar Kashinath Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14948",
    "name": "Biredar Basawraj Gundappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14490",
    "name": "Khedekar Dagadu Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6514",
    "name": "Pandya Sunita B"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "870",
    "name": "Yadav Rakesh Chabu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7748",
    "name": "Yadav Salikram Gudar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3176",
    "name": "Bhandari Ganpat Motya ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1908",
    "name": "Sadavarte Sudhakar Vithoba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14819",
    "name": "Barfe Bhalchandra Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21940",
    "name": "Chavan Arya Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18734",
    "name": "Jagtap Sameer Shrikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9261",
    "name": "More Manohar Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5632",
    "name": "Wandhekar Bhausaheb Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21179",
    "name": "Chavan Ganpat Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13404",
    "name": "Abbas Ali Shehensha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21552",
    "name": "Gurav Ashok Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7007",
    "name": "Shaikh Ahemad Shaikh Navazaddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1472",
    "name": "Bhosale Laxman Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "53",
    "name": "Devrukhkar Yogesh G"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "550",
    "name": "Lopes John Alex"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9494",
    "name": "Parulkar Kalpana Nilkanth"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13252",
    "name": "Kokate Sagar Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1580",
    "name": "Desai Manohar Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9295",
    "name": "Jadhav Sindhu Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10458",
    "name": "Nimbalkar Sampat Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21303",
    "name": "Rasal Sadu Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18441",
    "name": "Surve Samiksha Santosh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10520",
    "name": "Zagde Anandrao Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6172",
    "name": "Arora Vijay Bhagat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20665",
    "name": "Kanse Sakharam Sonu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22474",
    "name": "Khanwar Omprakash Khedru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20223",
    "name": "Mamania Nirali Rajesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12805",
    "name": "Patil Anita Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8405",
    "name": "Thapa Nanda Bahadur."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "97",
    "name": "Zambare Prabhakar Mirlidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4205",
    "name": "Rachh Jaysavhalal T"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12967",
    "name": "Lotlikar Harishchandra S"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8695",
    "name": "Phalke Sadashiv Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20365",
    "name": "Tiwari Vinod Rajmani."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2762",
    "name": "Koli Pandurang Shimgya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23230",
    "name": "Kadam Rahul Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2569",
    "name": "James  Sunil."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "110",
    "name": "Jadhav Seema Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14771",
    "name": "Bhusare Mahesh Sudam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10912",
    "name": "Dhapse Katu Rupaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16542",
    "name": "Gada Vanita Kanji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1365",
    "name": "Kharwar Vijay Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9120",
    "name": "Salunkhe Dashrath Jotiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9086",
    "name": "Sonawane Minakshi Pramod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4167",
    "name": "Mone Jijarao Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6929",
    "name": "Gawade Vijaya Girish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12246",
    "name": "Dharne Chaitrali Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4681",
    "name": "Abhang Mahadu Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10577",
    "name": "Lad Shobha Shriram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3722",
    "name": "Kadu Ratnamala Shankarrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3380",
    "name": "Mistry Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15549",
    "name": "D D\"Souza Paul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15265",
    "name": "Gawde Supriya Madhusudan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5181",
    "name": "Kamble Manohar Jayram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21193",
    "name": "Karande Ratnamala Chandrakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "581",
    "name": "Karkate Anita Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4576",
    "name": "Mandhre T. S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11731",
    "name": "Shinde Aruna Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4481",
    "name": "Khanchandani Topondas R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4492",
    "name": "Chaurasia  D.Natwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "732",
    "name": "Bhise Harishchandra Natahji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13440",
    "name": "Bandgar Vitthal Annappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5109",
    "name": "Gavkar Rajashri Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13418",
    "name": "Ghusade Devchand Khandu."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10842",
    "name": "Gujar Pravin Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5134",
    "name": "Kakade Indira Digambar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17978",
    "name": "Khalid Immnnddin Ahmed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18512",
    "name": "Shinde Amol Adhikrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12679",
    "name": "Shinde Chhaya Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11654",
    "name": "Topre Sushma Vinod"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7946",
    "name": "Nimbalkar Sanjay Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4659",
    "name": "Sakunde Awaba Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15498",
    "name": "Revandkar Raghunath Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4607",
    "name": "Savla Paln Devji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4630",
    "name": "Pillai Kishorkumar T"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5822",
    "name": "Pramod  Ramkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16386",
    "name": "Balsaraf  Aprna Suresh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14253",
    "name": "Magar Krushna Shivaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12275",
    "name": "Shirsat Ananda Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5852",
    "name": "Wagh Popat Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16659",
    "name": "Devlekar Gunaji Rama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10048",
    "name": "Khond Sadanand Bhiksheth"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8438",
    "name": "Baig Javed Ramajanali."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12056",
    "name": "Bodhe Swati Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13417",
    "name": "Gadhave Rupali Sachin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6308",
    "name": "Khan Rehmatulla Khan Hukmdar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15014",
    "name": "Vilankar Kundan Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1080",
    "name": "Bandal Shilpa Digamber"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3374",
    "name": "Chavan Pramila S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "864",
    "name": "Angre Shantaram Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20013",
    "name": "Chavan Vaibhav Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12480",
    "name": "Kalokhe Baliram Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18745",
    "name": "Singh Rupali Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14990",
    "name": "Zanzane Aravind Kalyanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5032",
    "name": "Jadhav Natha Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11289",
    "name": "Tarade Milind Abaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "366",
    "name": "Raut Vijaykumar Anantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8617",
    "name": "Jagdale Shakuntala Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9245",
    "name": "Chavan Tukaram Bapuji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12079",
    "name": "Jadhav Rajaram Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7159",
    "name": "Kale Sharada Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14280",
    "name": "Renose Balkrushna Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6951",
    "name": "Dhodke Rajesh Digambar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10685",
    "name": "Sangeeta S Kothari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "484",
    "name": "Kanase Gabaji Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3384",
    "name": "Borakar Chandrabhaga Dhondu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14974",
    "name": "Khan Salma Jamal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6832",
    "name": "Choudhari Hiralal Dugaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14662",
    "name": "Harijan Anandram Lekhraj."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10644",
    "name": "Rane Prakash Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1483",
    "name": "Chavan Vilas Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14852",
    "name": "Kadam Shantaram Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1503",
    "name": "Vasant Mahadeo Kahadane."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11664",
    "name": "Kumbahr Rajendra Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12990",
    "name": "Kadam Mahesh Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2603",
    "name": "Phalke Ashok Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6029",
    "name": "Vichare Vikrant Harishchandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22331",
    "name": "Bandre Nathuram Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14739",
    "name": "Dhamal Babanrao Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12537",
    "name": "Durgule Ranjana Hanmant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "37",
    "name": "Pawar Heeru Sakru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1932",
    "name": "Asangihal Kasturabai Basappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10384",
    "name": "Kadam Satish Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12550",
    "name": "Bhanupratap Singh Gajraj Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11961",
    "name": "Bose Surojit Saroj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9029",
    "name": "Dhumal Vijay Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7887",
    "name": "Dongre Darshana Dattatrya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13824",
    "name": "Golgatkar Reshma Dattatre"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17929",
    "name": "Jadhav Sandip Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19647",
    "name": "Kadam Jagannath Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21304",
    "name": "Kadam Vinaya Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18263",
    "name": "Lad Jagadish Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11576",
    "name": "Mane Yashoba Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6916",
    "name": "Mohite Ganpat Dada."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11567",
    "name": "Panchal Subhash Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4055",
    "name": "Bodake Dropada Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1706",
    "name": "Gujar Nathuram Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7438",
    "name": "Wagh Sharad Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1338",
    "name": "Kalra Onkar Singh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4919",
    "name": "Kulkarni Govind Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8944",
    "name": "Avhad Jyoti Ramesh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20534",
    "name": "Bansode Mahendra Utkaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14476",
    "name": "Jaiswal Jagdishprasad Souruprasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3106",
    "name": "Surve Bharat Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3185",
    "name": "Shetty Sadanand H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19223",
    "name": "Bhosale Sunil Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13770",
    "name": "Ghodke Vikas Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10543",
    "name": "Kshirsagar Ganpat Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14167",
    "name": "Nalage Shivaji Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3308",
    "name": "Shinde Nathuram Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9370",
    "name": "Parab Babaji Amrut"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2090",
    "name": "Khan Mohamed Nabi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3355",
    "name": "Nayyar Arjun Dev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8914",
    "name": "Yadav Bhilla Gatadak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6265",
    "name": "Jadhav Tanaji Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5271",
    "name": "Choudhary Kalpana K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8996",
    "name": "Kamble Madhukar N./Anjali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15249",
    "name": "Masurkar  Sandya Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6672",
    "name": "Mehta Manohar Rameshchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3905",
    "name": "Shah  Rakesh  Jayantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16345",
    "name": "Raut Santosh Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8999",
    "name": "Singh Mahendra Satya Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2919",
    "name": "Bhandari Dwarkanath Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9603",
    "name": "Rasal Sunil Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6506",
    "name": "Ahamed  Nisar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12273",
    "name": "Bhosale Namdeo Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10718",
    "name": "Dendol Shankar H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7644",
    "name": "Khan Shamshuddin Khan Dinmahmad."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22180",
    "name": "Patil Prakash Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13983",
    "name": "Sondagar Thakarsibhai Dharamsibhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3410",
    "name": "Choudhari Lalbhadur Sukhraj."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3951",
    "name": "Shah Harashad Hargovinddas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6482",
    "name": "Raut Ranjeeta Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18042",
    "name": "Coutino Sabina Elroy"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8206",
    "name": "Telange Omprakash Irappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4909",
    "name": "Pawar Arun Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2179",
    "name": "Shah Meghji Kanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12425",
    "name": "Katte Shobha Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20016",
    "name": "Mule Anil Kushbhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "901",
    "name": "Shah Mohanlal Joharmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19596",
    "name": "Muppan  Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10612",
    "name": "Vaity Kosav Ansel"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16824",
    "name": "Jadhav Adik Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1183",
    "name": "Sawant Madhav Balu."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1307",
    "name": "Ansari Abdul Hameed Haji Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12266",
    "name": "Bhagat Sarita Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20101",
    "name": "Dalvi Swati Amol"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20262",
    "name": "Dhumal Pramod Vithal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15522",
    "name": "Khedekar Sujata Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9311",
    "name": "Pawar Raju Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10271",
    "name": "Rajput Ashok Kumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "942",
    "name": "Shaikh Salim Amin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15122",
    "name": "Sherlekar Dinesh Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2105",
    "name": "Gajjar Harjivan Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2956",
    "name": "Keni Laxman Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12003",
    "name": "Sabale Ujwala Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1474",
    "name": "Dalvi Laxman Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5411",
    "name": "Thalkar Jayshree Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16247",
    "name": "Patil Ashok Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21513",
    "name": "Tavhare Netaji Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9020",
    "name": "Sharma Raman R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4089",
    "name": "Sequiera  Jenny."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12887",
    "name": "Ingale Laxman Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1877",
    "name": "Padia Haresh J."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4532",
    "name": "Shah Sunil Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2270",
    "name": "Shah Tanvi Sachin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20788",
    "name": "Bhujbal Dattatray Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5507",
    "name": "Dicholkar Madhusudan Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11100",
    "name": "Jha Sikandar Brajkant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14873",
    "name": "Kambale Rahul Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7812",
    "name": "Patel Hiralal Dharmashi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20034",
    "name": "Pawar Sandeep Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6932",
    "name": "Shaikh Mohmed Irfan/Nitin/Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4212",
    "name": "Gaikwad Uttam Jyotiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5887",
    "name": "Sawant Geeta Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1804",
    "name": "Patil Kunda Dattatra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9066",
    "name": "Sharma Adharidevi Jawaharlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "773",
    "name": "Chavan Hindurao Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22029",
    "name": "Adhikari Uatam Nepali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13142",
    "name": "Anandkumar  C.K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5886",
    "name": "Chandy  Sherly"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11932",
    "name": "Dicholkara Sandeep Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7332",
    "name": "Gode Shekhar Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12580",
    "name": "Jaiswal Harichandra Maturadas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13569",
    "name": "Kothamire Milind Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20721",
    "name": "Mistry Shantabai Kashinath.."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11154",
    "name": "Sawant Sampat Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "541",
    "name": "Sharan Ranjnakumari Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7082",
    "name": "Tanawade Pratik Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1384",
    "name": "Patil Anandrao Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7409",
    "name": "Phalke Malan Bhanudas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7880",
    "name": "Sawant Maruti Pundalik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7733",
    "name": "Yadav Sushila Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15030",
    "name": "Doke Shantabai Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14966",
    "name": "Tawate Girish Jagdish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1131",
    "name": "Tikudve Dhondiram Keshav."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "303",
    "name": "Shirke Prabhakar Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14042",
    "name": "Indalkar Sandip Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1873",
    "name": "Kalal Harun Rajjak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7051",
    "name": "Barge Yashoda Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23623",
    "name": "Badle Neelam Nandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17891",
    "name": "Bari Rambharose Mangal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2353",
    "name": "Ghotilkar Kisan Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24109",
    "name": "Motiur Khalid Rehman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10603",
    "name": "Padalkar Mangesh Ashokraj"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2352",
    "name": "Patel Samarnath Lalji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11502",
    "name": "Phadatare Vanita Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24107",
    "name": "Shaikh Mohamed Abdul Salim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24115",
    "name": "Yadav Ramawadha Baijnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3383",
    "name": "Jadhao Shankar Jaggu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "133",
    "name": "Muktabai Vinayakrao Kadam."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6600",
    "name": "Gadhave Surekha Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24087",
    "name": "Gurav Amol Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14332",
    "name": "Kopekar Parveenbanu Fayaz."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19471",
    "name": "Lembhe Vikrant Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14879",
    "name": "Mulla Lalmohammad Bashir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16554",
    "name": "Nalawade Sunil Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24076",
    "name": "Parmar Minakshi Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8296",
    "name": "Suvre Nathuram Kamu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4982",
    "name": "Gaikar Bapu Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8202",
    "name": "Bhosale Jagannath Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14632",
    "name": "Modi Viku Snehal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14856",
    "name": "Bandal Ashok Bhausaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14863",
    "name": "Bhosale Sanjay Dinkar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2292",
    "name": "Patil Tukaram Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5648",
    "name": "Langekar Prakash Dhaktu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16308",
    "name": "Asha Dhaku Patade And Laxmi Dhaku Patade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24042",
    "name": "Biradar Nagorao Mohanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18462",
    "name": "Devaliya Maniben Karsan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18176",
    "name": "Dhargalkar Ranjana Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12758",
    "name": "Inamdar Rafiq Chaund"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10980",
    "name": "Jasiwal Om Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24048",
    "name": "Lalani Aziz Kayamli"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9341",
    "name": "Malusare Pushpa Raghoba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2251",
    "name": "Mishra Shashikant Berendra Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6019",
    "name": "Patel Vinod B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24047",
    "name": "Sagvekar Santosh Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16312",
    "name": "Sakunde Madan Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6915",
    "name": "Samant Jayant Haripad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5094",
    "name": "Telange Ramchandra Gundaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3041",
    "name": "Bhosale Ramchandra Krishnaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1399",
    "name": "Shingate Laxman Bahiru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "791",
    "name": "Peter Andrew Vaity."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3278",
    "name": "Maniyar Amita Bakul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6811",
    "name": "Devrukhkar Arun Ramakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23586",
    "name": "Jadhav Umesh Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18791",
    "name": "Jaiswal  Dnyandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16080",
    "name": "Kokane Sitaram Janaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12555",
    "name": "Naik Priyanka Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22224",
    "name": "Qurshi Khorshida Rahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10862",
    "name": "Samant Tanvi Atul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14824",
    "name": "Thorat Ganpat Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5664",
    "name": "Vishwakarma  Hosalaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13642",
    "name": "Mandavkar Vijay Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1170",
    "name": "Momin Babalal Hamidulla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17530",
    "name": "Zore Tanaji Thaku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2855",
    "name": "Vaity Paskal Zujhya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5086",
    "name": "Bhuptani Bakul Vinaychandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23567",
    "name": "Chaudhary Suresh Shankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "142",
    "name": "Deshmukh Vinayak Kamlakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20530",
    "name": "Dhage Bapu Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18354",
    "name": "Gazi Mohmmad Abdul Rajjak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19853",
    "name": "Ingavale  Pranav  Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18854",
    "name": "Kadam Dipak  Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16094",
    "name": "Kandalkar Pooja Ajit."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24016",
    "name": "Khan Hayat Maheboob"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14804",
    "name": "Khare Ganesh Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14816",
    "name": "Ombale Subhash Jyotiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24003",
    "name": "Sayyad Azgar Hussain Munafa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24022",
    "name": "Shenoy Rohidas Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11710",
    "name": "Shinde Bharat Ramachandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14802",
    "name": "Shinde Tarachand Shreerang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14264",
    "name": "Shirke Kamal Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2933",
    "name": "Thalkar  Usha Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2607",
    "name": "Kadam Kantabai Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2794",
    "name": "Bangar Sitaram Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14293",
    "name": "More Ravindra B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1710",
    "name": "Takalkar Baburao Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13943",
    "name": "Patil Sunil Yashvant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10629",
    "name": "Thakur Ashok Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12775",
    "name": "Thakkar Vijay Subhashchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5616",
    "name": "Bhosale Dattatrya Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12661",
    "name": "Barge Shanta Sarjerao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2003",
    "name": "Das Ajit Kumar Banarsi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "976",
    "name": "Deshmukh Pandharinath Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23595",
    "name": "Gaikwad Dinesh Ramesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2066",
    "name": "Jadhav Dattatray Vasant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1928",
    "name": "Kamble Shankar Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2028",
    "name": "Mande Kailash Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2129",
    "name": "Mhatre Bebibai Parshuram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1914",
    "name": "Mhatre Sandeep Bhanudas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22190",
    "name": "Otavkar Ganesh Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "722",
    "name": "Pawar Ramesh Raghu."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1768",
    "name": "Pawar Vijaykumar Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11674",
    "name": "Sanas Deoram Nathu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2076",
    "name": "Tangadi Sandhya Ratnakar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1895",
    "name": "Varathe Shanu Deva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21003",
    "name": "Yalgat Ajitabh Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2602",
    "name": "Gadre Prabhakar Vishavnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10232",
    "name": "Pujari Jaya Erappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15320",
    "name": "Agarwal Kamal Kishore"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4490",
    "name": "Bhagat Dhansing Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14573",
    "name": "Chavan Madhubala Yashavant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15855",
    "name": "Dhamal Shashikala Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14568",
    "name": "Gurav Rajendra Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14615",
    "name": "Mahamuni Sachin Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4957",
    "name": "Mansori Habib Tahsildar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1495",
    "name": "Pagare Panchsheela Pritam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19725",
    "name": "Pansare Yogesh Dileep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13038",
    "name": "Rane Mahesh Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12141",
    "name": "Salunkhe Mandakini Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14567",
    "name": "Shinde Sangita Dilip"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "843",
    "name": "Shivmare Nivruti Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23515",
    "name": "Singh Chhaya Jagmohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23970",
    "name": "Singh Nalini Haulaprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21608",
    "name": "Surve Sandeep Murari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17113",
    "name": "Thakur Chhathukumar Bindheshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5329",
    "name": "Gosavi Devgiri Babangiri"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1587",
    "name": "Kharade Ishwara Gundu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1879",
    "name": "Dhumal Pralhad Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5950",
    "name": "Jagtap Maruti Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14562",
    "name": "Bhilare Amar Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20539",
    "name": "Disale Sanjay Yeshwant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14549",
    "name": "Ghadage Dadasaheb Bhagavan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14561",
    "name": "Jadhav Anil Dinkar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1479",
    "name": "Kamble Tej Prakash"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1493",
    "name": "Katale Kaluram Dattu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1480",
    "name": "Kowar Ramesh Himmatsingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23493",
    "name": "Sapkal Shailaja Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13223",
    "name": "Shinde Suman Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15146",
    "name": "Shinde Vikas Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23513",
    "name": "Singh Jagmohan Bhagwati"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "813",
    "name": "Singhal Anil Keshoram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23488",
    "name": "Wadkar Sunanda Rohidas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1302",
    "name": "Yadav Ramasre Nirhu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14658",
    "name": "Babi Dagdu More"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16038",
    "name": "Ghorpade Navnath Malhari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14526",
    "name": "Jadhav Vijay Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11885",
    "name": "Kadam Sunil Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20393",
    "name": "Malap Sanjay Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14620",
    "name": "Matkar Hanmant Krushnrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10121",
    "name": "Sonavane Anita Kiran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8501",
    "name": "Ghadage Rajaram Balaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "974",
    "name": "Jain Jayantilal Jethamal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6931",
    "name": "Salunkhe Ramchandra Hanamant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "963",
    "name": "Kothadia Jinmani Dhanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10198",
    "name": "Chavan Changdeo Vitthal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1313",
    "name": "Chavan Nandkumar Sampat"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1387",
    "name": "Fullur Narasayya Posha"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1351",
    "name": "Gaikwad Vandana Kalidas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "111",
    "name": "Jondhale Kishor Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13479",
    "name": "Kaunali Ambarao Revanasiddappa"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1338",
    "name": "More Bharati Shyamrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1384",
    "name": "More Kishor Balu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1337",
    "name": "More Shyamrao Hanmant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1312",
    "name": "Mourya Vinodkumar Surai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10608",
    "name": "Saste Anil Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17962",
    "name": "Sethi Ashish Mohinderkumar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1398",
    "name": "Shevale Gajanan Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12682",
    "name": "Tanpure Sahadev Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1082",
    "name": "Varne Shivram Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9428",
    "name": "Sakharkar Savalabai Yamuna  Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "808",
    "name": "Ramshing Nainsing Gurkha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6469",
    "name": "Phalke Ashok Dwarkoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8183",
    "name": "Ali  Sakir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16296",
    "name": "Bhalekar Prakash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13685",
    "name": "Bhatkar Vijay Kashinath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1086",
    "name": "Birgad Satawaji Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14492",
    "name": "Chavan Shrikant Gorakhnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1051",
    "name": "Shailash Garment"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1307",
    "name": "Gokhale Latika Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5472",
    "name": "Goud Gangaram Shivcharan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1151",
    "name": "Kadam Sntosh Ankush"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23438",
    "name": "Negandhi Varsha Jayeshabbpnr"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1147",
    "name": "Nimbalkar Amit Bajirao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1177",
    "name": "Nishad Subhashchandra Birja"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14888",
    "name": "Pardeshi Abhilasha Pratapsing"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1140",
    "name": "Patil Prafull Ankush"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14491",
    "name": "Pisal Nitin Dnyanoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14487",
    "name": "Pisal Pravin Baban"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1178",
    "name": "Rambhog Paramatma"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1185",
    "name": "Sahani Ramchandra Ramprit"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1279",
    "name": "Salskar Raju Ram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3879",
    "name": "Shanhag  Sunil  Ramnath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1235",
    "name": "Sawant Dattatray Mahadeo"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1198",
    "name": "Sonawale Rajendra Dnyandeo"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1167",
    "name": "Yadav Arvindkumar Salikram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1152",
    "name": "Yadav Santoshkumar Salikram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19528",
    "name": "Yelave Chandrakant Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3760",
    "name": "Pawar Mohan Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12137",
    "name": "Wagh Tarubai Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1892",
    "name": "Shantanu Graphics"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1073",
    "name": "Shanti Cycle Stores"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2532",
    "name": "Shanti Garments"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2506",
    "name": "Shanti Jewellers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2640",
    "name": "Shanti Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1140",
    "name": "Sharad Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "360",
    "name": "Kamkule Madhukar Khanderao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1538",
    "name": "Dalvi Vikas Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23897",
    "name": "Gole Madhukar Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23408",
    "name": "Goyal Kiran Ashish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23384",
    "name": "Jadhav Narayan Parashuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19684",
    "name": "Jambukar Shital Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16478",
    "name": "Javkar Satyawan Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22038",
    "name": "Kate Kiran Manik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15547",
    "name": "Mistry Abdul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23407",
    "name": "Motwani Anil Pradip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23406",
    "name": "Motwani Mahesh Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23405",
    "name": "Motwani Pradip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23409",
    "name": "Sawant Sham Uttam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1555",
    "name": "Shah Sheela Sunil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14427",
    "name": "Shaha Jitendra Saralal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14426",
    "name": "Shaha Shital Saralal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14424",
    "name": "Shaha Sunil Rasiklal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14425",
    "name": "Shaha Swati Sunil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23385",
    "name": "Yadav Janardan Gharu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8303",
    "name": "Shete Suresh Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "724",
    "name": "Barai Ramkaran Dudhnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "99",
    "name": "Patil Gaudappa Annappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14340",
    "name": "Gaikawad Lata Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17534",
    "name": "Pandya Hiteshbhai Babalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19608",
    "name": "Sanas  Nalini  Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11340",
    "name": "Shetty Mahesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1700",
    "name": "Nagbhujange Tukaram Venkatrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10798",
    "name": "Dube Bhuvan Manorath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22091",
    "name": "Nare Shweta Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17357",
    "name": "Jagtap  Bhagwan  Kisan ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23333",
    "name": "Bhobe Shailesh Sitaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1362",
    "name": "Choudhary Motaram Nekaramji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1407",
    "name": "Choudhary Satishkumar Ramjwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11895",
    "name": "Girkar Pramod Yeshwant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1401",
    "name": "Jadhav Manjula Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23842",
    "name": "Jagtap Pradeep Sopan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1283",
    "name": "Jain Dinesh Gehrilal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1350",
    "name": "Kandakatla Ramesh Siddhya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17841",
    "name": "Khanvilkar Shashikant Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18119",
    "name": "Lingam Kalidas Kutha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19621",
    "name": "Mehta Rupesh Jagdish"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1356",
    "name": "Naikodi Dattatraya Narayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1256",
    "name": "Pabrekar Rupesh Praksh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12734",
    "name": "Phalake Nitin Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13614",
    "name": "Phalke Prakasharao Jotyajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23843",
    "name": "Randeria Tushar Pradip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22028",
    "name": "Raut Kalpana Vishram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22050",
    "name": "Shenoy Shweta Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23838",
    "name": "Vichare Nitin Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23839",
    "name": "Vichare Vishwanath Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22016",
    "name": "Wanivadekar Sayali Vikrant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1272",
    "name": "Yarra Vishwanathan Kalidas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7804",
    "name": "Kurhade Shivaji Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2226",
    "name": "Pagare Chandrakant Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "983",
    "name": "Patil Shrikant Sidgauda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17839",
    "name": "Mandhare Duryodhan Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18871",
    "name": "Wagh Tukaram Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11250",
    "name": "Dhuri Vasudha Dinanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13902",
    "name": "Bhagwat Baban Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14488",
    "name": "Avare Vinayak Vyankatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14258",
    "name": "Bhoite Sonali Fattesing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23813",
    "name": "Desai Pramod Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14284",
    "name": "Mane Anil Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14434",
    "name": "Mane Pranali Mangesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10436",
    "name": "Raut Suman Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14435",
    "name": "Shikalgar Imran Nazir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2493",
    "name": "Shah Mohanlal Muraji ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "278",
    "name": "Ramesh Namdeo Bobade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9916",
    "name": "Pawar Raghoba Ravji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16904",
    "name": "Dhanawade Pandurang Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21262",
    "name": "More Santosh Maruti."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14249",
    "name": "More Sapana Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16860",
    "name": "Shinde Tanaji Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23301",
    "name": "Shingrani Prakash Khiaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1605",
    "name": "Desai Lumaji Babaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17389",
    "name": "Patil Sandeep Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5940",
    "name": "Shinde Kisan Vithal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1236",
    "name": "Kolt E Babasaheb Ramdas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1458",
    "name": "Kumbhar Sanmgeeta Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23287",
    "name": "Maharashtra Gharelu Kamgar Union"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1630",
    "name": "Patil Radhabai Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16797",
    "name": "Kadam Shivaji Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1530",
    "name": "Sheetal Corporation"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18959",
    "name": "Desai Laxman Kisan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1271",
    "name": "Gupta Asha Ganesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14196",
    "name": "Sawant Nitin Vilasrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23255",
    "name": "Singh Abhishek P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23249",
    "name": "Singh Kamalkumar Amresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23247",
    "name": "Suvarna Kishorkumar S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23251",
    "name": "Tilakmonie Venkatachalan R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23264",
    "name": "Vakil Neelesh Sanat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23250",
    "name": "Venkatachalam R"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4800",
    "name": "Mahadik Shivaji Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3277",
    "name": "Phalake Nandkumar Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14864",
    "name": "Rambhiya Javerben L"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8842",
    "name": "Dudhe Yashodabai Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8673",
    "name": "Pawar Madhukar Tuakaram16/28"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8791",
    "name": "More Babu Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16767",
    "name": "Bhujbal Anjani Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5905",
    "name": "Chauhan Pragan N."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23222",
    "name": "Gaikwad Jagruti Pramod"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16204",
    "name": "Halnkar Shriram Narayan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17022",
    "name": "Jare Amol Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23223",
    "name": "Jawanjal Santosh Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23745",
    "name": "Kharade Sumita Subhash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16675",
    "name": "Patel Rajendeakumar Rampratap."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12951",
    "name": "Patil Karnsingh Premasingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21540",
    "name": "Patil Suchita Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20000",
    "name": "Pawar Rajendra Tukaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "632",
    "name": "Phadtare Balu Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23905",
    "name": "Salunkhe Sunanda Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4718",
    "name": "Chadha Dilip Gurudass"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1754",
    "name": "Kadam Raghunath Ganpati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15885",
    "name": "Parab Hrushikesh Suryakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9351",
    "name": "Pawar Hanmant Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12094",
    "name": "Barge Shashikant Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12961",
    "name": "Gavandi Vinod Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12782",
    "name": "Girkar Janardhan Gangaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11196",
    "name": "Kadam Santosh Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14174",
    "name": "Pawar Dattatray Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14175",
    "name": "Pawar Pradeep Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5075",
    "name": "Shaikh Mohamed Aslam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13807",
    "name": "Shinde Nandkumar Mansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5512",
    "name": "Siddique Walli Mohmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16187",
    "name": "Sutar Shivadan Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14055",
    "name": "Upadhayay Jairam S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18269",
    "name": "Yadav Rashmi Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8615",
    "name": "Sarfare Mahadev Tulaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15033",
    "name": "Pange Ashok Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14085",
    "name": "Panchal Saraswati Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2796",
    "name": "Pednekar Shreedhar Sayajee"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7212",
    "name": "Gaikwad Vishnu Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6161",
    "name": "Sonawane Mina Ulhasrao/ Ulhasrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14500",
    "name": "Gawade Anil Lumaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15610",
    "name": "Jadhav Surendra Ganapati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23687",
    "name": "Jaiswal Asha Umeshchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1108",
    "name": "Kinare Anil Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23334",
    "name": "Parab Prashant Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19042",
    "name": "Pophale Yogesh Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23197",
    "name": "Sinkar Madhusudan Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14510",
    "name": "Yadav Udayraj Kulafath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6530",
    "name": "Lembhe Navnath Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9547",
    "name": "Jadhav Shantabai Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6952",
    "name": "Waghamale Laxmibai Baburav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4652",
    "name": "Deshmukh Shrimant Niloba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2766",
    "name": "Sangli Zilka Mitra Namdal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23181",
    "name": "Baikar Mahadeo Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3375",
    "name": "Bajwe Deepak Shankar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18365",
    "name": "Bhilare Pranali Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5024",
    "name": "Chavan Sudhir Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17192",
    "name": "Divale Kiran Shripat"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "607",
    "name": "Gowda Prakash Nari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14130",
    "name": "Jadhav Prakash Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23681",
    "name": "Kakde Nilesh Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14134",
    "name": "Kale Sangita Dnyaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23661",
    "name": "Kawathekar Nitin G."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1252",
    "name": "Kelgane Mahesh Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11393",
    "name": "Mahurkar Avinash Gangadhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14128",
    "name": "Nanaware Sambahaji Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17415",
    "name": "Pal Narendrakumar Shrigaydin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23188",
    "name": "Patil Nilesh Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14135",
    "name": "Pawar Sandeep Vasantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14159",
    "name": "Pawar Sudhakar Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19492",
    "name": "Pisal Manoj Ankush"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1412",
    "name": "Shelekar Ashok Ananda"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1414",
    "name": "Shelekar Vinod Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16926",
    "name": "Singh Jayprakash Janakidhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11840",
    "name": "Sonawane Devidas Deoram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8636",
    "name": "Tambe Baban Hariba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "473",
    "name": "Asha Prakash Vishwasrao."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "694",
    "name": "Ansari Jareenabanu Nasruddin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "782",
    "name": "Bansode Prakash Arjun"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "779",
    "name": "Bhoite Prakash Haribhau"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "715",
    "name": "Bhosale Suhash Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "673",
    "name": "Chaudhari Pradip Baliram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "708",
    "name": "Chavan Rajendra Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "710",
    "name": "Devkar Sunil Sahebrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "702",
    "name": "Ghadage Ramchandra Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "864",
    "name": "Gudhka Ayush Bhavesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "851",
    "name": "Gudhka Kiran Bhavesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "863",
    "name": "Gudhka Veer Bhavesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23651",
    "name": "Jadhav Sunita Gajanan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "724",
    "name": "Jain Kamlesh Amrutlal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "836",
    "name": "Joshi Santosh Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23633",
    "name": "Kadam Sachin Ramesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "865",
    "name": "Kajrolkar Sayali Janardhan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "705",
    "name": "Mahale Ravi Ganpat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "713",
    "name": "Mohite Ramchandra Jayram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "311",
    "name": "Monde Padama Sanjaykumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "781",
    "name": "More Krishnkant Dattatray"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "953",
    "name": "Naik Ramuram Lunaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18664",
    "name": "Pal Ramashankar Ramsaraj"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "787",
    "name": "Patel Mevalal Pannalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23382",
    "name": "Patil Megha Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19340",
    "name": "Pawar Umesh Krishnarao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "721",
    "name": "Prajapati Arvind Ramkhiladi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18383",
    "name": "Sable Dnyandeo Aanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8897",
    "name": "Sable Nisha Gangaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "711",
    "name": "Sanas Vijay Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21862",
    "name": "Sanklecha Anilkumar Omprakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21864",
    "name": "Sanklecha Omprakash Chhaganraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21863",
    "name": "Sanklecha Pushpadevi Omprakash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "745",
    "name": "Shejval Santosh Sahebrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "703",
    "name": "Tavre Balaso Kaluram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "588",
    "name": "Vaid Hemangi Rohit"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "704",
    "name": "Varak Tatyasaheb Vitthal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "847",
    "name": "Waghmare Rajkumar Bhanudas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14304",
    "name": "Whalekar Mahesh Sadanand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "938",
    "name": "Yadav Shashi Nageshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3416",
    "name": "Panickar Radhakrishna Raghav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16019",
    "name": "Bhote Vijaya Shivajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18658",
    "name": "Chawlkar Mangesh Damoda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4720",
    "name": "Gohare Neha Nagesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15334",
    "name": "Gold Kamla Yamnna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8376",
    "name": "Harijan Hadayram Rameshor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18549",
    "name": "Kale Dattatray Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21123",
    "name": "Kerkar Kunal Kishore"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1325",
    "name": "Maurya Tulshiram Rampal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21897",
    "name": "Nikam Yashwant Uttam ."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "964",
    "name": "Pande Umashankar Prayag Narayan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "732",
    "name": "Sawant Payal Shriram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9633",
    "name": "Sharma Rajkumar T ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12499",
    "name": "Sondkar Kamal Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12068",
    "name": "Thackray Shubhangi Premlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23613",
    "name": "Thorve Bharti Ghansham"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11332",
    "name": "Kolekar Raghunath Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8623",
    "name": "Jain Kanchan Kumari Bhawarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4013",
    "name": "Sharma Ramashray Dalsingar ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4",
    "name": "Dhopate Rajiv Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14084",
    "name": "Bhoite Chandrashekhar Ashokrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8750",
    "name": "Pujari Vidhya Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14792",
    "name": "Sajgane Vasant Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4636",
    "name": "Satam Anupama Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5268",
    "name": "Shinde Akkatai Dadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14106",
    "name": "Shingate Sunil Tatyaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1618",
    "name": "Kokalu Poshanna Ushnna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18550",
    "name": "Sharma Shalaka Madan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13829",
    "name": "Bhawsar Nitesh H"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2106",
    "name": "Kadam Bhagirthi Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12574",
    "name": "Aachrekar Nandkumar Sabaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23556",
    "name": "Bhandare Pinky Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23084",
    "name": "Gole Pradeep Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23565",
    "name": "Gujar Umesh Bajirao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "752",
    "name": "Kamble Ganpat Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23093",
    "name": "Kanade Ajay Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23068",
    "name": "Patade Jaywant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23089",
    "name": "Rane Ranjeet Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23074",
    "name": "Shetty Shreenath L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23075",
    "name": "Shetty Sunilkumar Karunakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23561",
    "name": "Shinde Sindhutai Shashikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4395",
    "name": "Kumbhar Prakash Kamlu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18115",
    "name": "Dahije Rupali Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16383",
    "name": "Agavane Suresh P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14987",
    "name": "Bhoite Surekha Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23553",
    "name": "Dandekar Pinky Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6457",
    "name": "Ghagre Ashok Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23381",
    "name": "Jadhav Sachin Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23428",
    "name": "Jagtap Vilas Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14637",
    "name": "Kadam Sharmila Suresh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9205",
    "name": "Kalvankar Rajashree Ram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23039",
    "name": "Mandsaur Mazahir Kaizar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23041",
    "name": "Mandsaurwala Mehjabeen Kaizar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10586",
    "name": "Mane Ravindra Shankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "482",
    "name": "Misakar Ramesh Vasudeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19845",
    "name": "More Neelam Murari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23380",
    "name": "Munsi Firzo Abdul Hammed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "517",
    "name": "Pommama  Gopalan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1454",
    "name": "Sharma Shrikantkumar Brajbhushan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23390",
    "name": "Shekh Nasiruddin Mirasaheb."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23037",
    "name": "Waghmare Anil Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5627",
    "name": "Bagawan Saleem Rajmohmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4646",
    "name": "More Kashinath Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3954",
    "name": "Chavan Subhash Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6589",
    "name": "Meshte Arvind Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13804",
    "name": "Sawant Savitri Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "105",
    "name": "Sitaram Keru Gaikar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5515",
    "name": "Patil Uttamrao Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2490",
    "name": "Khade Shantabai Trimbak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22455",
    "name": "Chenna Rajganeshprasad Lingprasad."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13845",
    "name": "Deshmukh Pralhad Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18537",
    "name": "Joshi Dattatray Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7041",
    "name": "Mohamad Abdul Samad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22096",
    "name": "Pawar Satyawan Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9433",
    "name": "Sabale Bhanudas Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9043",
    "name": "Vaity Phulabai Domnic"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13858",
    "name": "Wagh Shivaji Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6466",
    "name": "Yadale Sushant Bhola"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6984",
    "name": "Gorivali Baya Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "944",
    "name": "Shekh Rafik Abudal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15128",
    "name": "Govekar Alka Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22929",
    "name": "Apsule Jagannath Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14745",
    "name": "Bandal Prakash Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23339",
    "name": "Barge Sachin Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22927",
    "name": "Bhosale Vikas Gunda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22907",
    "name": "Chajed Kundan Dhisulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22951",
    "name": "Chavan Ramakant Dadaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22949",
    "name": "Chavan Shilpa Ramakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22908",
    "name": "Chhajed Dhisulal Motilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22961",
    "name": "Desai Balasaheb Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22969",
    "name": "Desai Ganpatrao C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22914",
    "name": "Desai Sandesh Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7477",
    "name": "Dhawale Ramdas Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22934",
    "name": "Dhodi Umesh Chabildas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22936",
    "name": "Dingorkar Mahesh Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "601",
    "name": "Ghadage Sachin Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22999",
    "name": "Ghanawat Sharad Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22972",
    "name": "Ghotilkar Ananda Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22920",
    "name": "Gorule Deepak Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22919",
    "name": "Gorule Surekha Deepak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22935",
    "name": "Harugade Sanjay Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22979",
    "name": "Jadhav Dilip Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22930",
    "name": "Jadhav Krishnat Uttam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "593",
    "name": "Jadhav Ramchandra Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22978",
    "name": "Jadhav Sudhir Suresh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "608",
    "name": "Jadhav Sunil Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22938",
    "name": "Jadhav Suresh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22903",
    "name": "Kadam Deepak Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22990",
    "name": "Kadam Rajesh Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22901",
    "name": "Kanase Ananda Dahadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22925",
    "name": "Kanase Krushnadev Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22924",
    "name": "Kanase Minaxshi Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22902",
    "name": "Kanase Savita Krishndeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23001",
    "name": "Kanse Suresh Appa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22980",
    "name": "Katre Anandrao Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22860",
    "name": "Khan Mohammad Akabarali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23010",
    "name": "Khan Mohmd Tariqabdul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22911",
    "name": "Khare Makrand Mukund"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22973",
    "name": "Khot Yashwant Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22910",
    "name": "Kokate Pramod Dadarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22926",
    "name": "Kumbhar Suwarana Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22905",
    "name": "Mahadik Jyoti Jayant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13805",
    "name": "Malusare Umesh Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22986",
    "name": "Mokashi Abhijeet Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22987",
    "name": "Mokashi Jayashree Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22988",
    "name": "Mokashi Vishwajeet Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22900",
    "name": "More Pranali Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22939",
    "name": "More Tanaji Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1054",
    "name": "Mukadam Pramila Ishwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22904",
    "name": "Mule Promod Mukund"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22955",
    "name": "Nagre Hima Satish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22963",
    "name": "Nagre Satish Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22932",
    "name": "Naik Vishnu Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22984",
    "name": "Nalawade Nilam Pravin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "598",
    "name": "Narale Kakaso Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22942",
    "name": "Nikam Anandrao Gujaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22941",
    "name": "Nikam Shivaji Gujaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22948",
    "name": "Nikam Suryakant Gujaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22993",
    "name": "Pagare Savita Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22954",
    "name": "Palav Krishnakant Shridhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22896",
    "name": "Panaskar Anil Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22895",
    "name": "Panaskar Suvarna Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22968",
    "name": "Parle Balkrushna Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22966",
    "name": "Patil Babasaheb Krushna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "596",
    "name": "Pawar Avinash Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23347",
    "name": "Pawar Maruti Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13825",
    "name": "Pawar Ramchandra Anandrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "556",
    "name": "Pawar Santosh Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10119",
    "name": "Rane Vilas Jairam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "611",
    "name": "Raut Dattatray Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22913",
    "name": "Raut Varsha Sunil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22933",
    "name": "Sakharkar Raj Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22971",
    "name": "Salehittal Shailesh Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22922",
    "name": "Sankpal Arun Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22940",
    "name": "Sankpal Mahendra Arun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22921",
    "name": "Sankpal Ranjana Arun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22916",
    "name": "Sankpal Seema Shrikrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22915",
    "name": "Sankpal Shrikrishna Arun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22917",
    "name": "Sansare Amar Gangadhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22952",
    "name": "Saple Vishal Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22981",
    "name": "Shah Sweeta Kirit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22991",
    "name": "Shejwal Rahul Vinod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22994",
    "name": "Shejwal Raju Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22995",
    "name": "Shejwal Vedangi Vinod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22996",
    "name": "Shejwal Vinod Pandharinath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "607",
    "name": "Shinde Dhondiba Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22964",
    "name": "Shinde Ramesh Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "591",
    "name": "Shinde Santosh Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23004",
    "name": "Shirke Sanjay Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "576",
    "name": "Singh Vijay Ramlakhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4505",
    "name": "Sonawanr Ghanshyam B."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23000",
    "name": "Surve Rupesh Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22977",
    "name": "Thoda Dhaval Ajit"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "574",
    "name": "Umbarkar Shubhangi Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22912",
    "name": "Vaidya Amol R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22918",
    "name": "Vare Vijay Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22931",
    "name": "Vare Yogesh Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15430",
    "name": "Vishnakarma Rajesh Sitaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1035",
    "name": "Vishwkarma Sanjaykumar Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22943",
    "name": "Warandkar Shirish Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1871",
    "name": "Inamdar Hasan Dulemiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3490",
    "name": "Mengani Madhu Kishor."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17641",
    "name": "Bhosale Amol Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3367",
    "name": "Fernandis Salvador Miacal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5039",
    "name": "Padwal Ramhari Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3572",
    "name": "Savla Velji Devji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4499",
    "name": "Mahindrakar Ram Nagendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22854",
    "name": "Chavan Namdev B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16123",
    "name": "Mane Manisha Sanjay &Mane Sanjay Murlidh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "444",
    "name": "Sahu Haresh Puselal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15870",
    "name": "Salunkhe Gorakshanath Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8901",
    "name": "Shah Noorjahan Apsar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22842",
    "name": "Shaikh Imran Manzoor"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9171",
    "name": "Jadhav Ashok Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9937",
    "name": "Pawar Sunil Vamanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10579",
    "name": "Dafedar Ayyaj Shahbuddin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "714",
    "name": "Jadhav Suresh Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17916",
    "name": "Jagtap Sandeep Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14908",
    "name": "Sawant Amarnath Shiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2373",
    "name": "Shilpi Enterprise"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13891",
    "name": "Dangre Shantaram Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "214",
    "name": "Kadam Shankar Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23146",
    "name": "Amlani Jinesh Dilesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23199",
    "name": "Bhosale Kashinath Sahebrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "28",
    "name": "Chaudhary Archana Santosh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "49",
    "name": "Chiluka Praveenkumar Satynarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22819",
    "name": "Dhangar Tayappa Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23249",
    "name": "Gabhane Ashwin Ashok"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "171",
    "name": "Ghanvat Sanjay Dnyandeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "119",
    "name": "Hule Ashwini Sandeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23226",
    "name": "Joseph Nana Mical"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21662",
    "name": "Kale Prakash Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21650",
    "name": "Kokate Rupesh Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21649",
    "name": "Kurle Bharti Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18874",
    "name": "Maheshwari Samiksha Vinod"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "52",
    "name": "Mane Rukmini Baban"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "126",
    "name": "Mhatre Prahlad Vasant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "347",
    "name": "More Balkrishna Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "59",
    "name": "Panasare Vanita Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21639",
    "name": "Parab Vishawant Suryakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21752",
    "name": "Patil Sanket Mohan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "227",
    "name": "Pawar Popat Hindurao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "263",
    "name": "Phadtare Shahaji Pamaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21661",
    "name": "Rane Anant Sadashiv"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "98",
    "name": "Salunkhe Vijaya Ashok"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "336",
    "name": "Shah Mohmmadrais Nijamuddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22748",
    "name": "Shidhore Vivek Vinayak"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "411",
    "name": "Shinde Harishchandra Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23177",
    "name": "Shroff Prnav Pramod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14844",
    "name": "Soda Roshani Fattesingh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21713",
    "name": "Sonawale Vijay Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21693",
    "name": "Thale Amit Madhav"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "105",
    "name": "Veera Praful Lalaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1026",
    "name": "Waghela Arjunsingh Kartarrsingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "64",
    "name": "Yadav Rambali Prasad"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "739",
    "name": "Yadav Vaishali Sachin"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "360",
    "name": "Yewale Shivaji Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7808",
    "name": "Jadhav Tanaji Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19204",
    "name": "Banakar Suresh Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11281",
    "name": "Bhilare Subhash Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13775",
    "name": "Bhoite Pushpa Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17180",
    "name": "Chawan Anusaya Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1396",
    "name": "Ghadge Dnyaneshwar Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23170",
    "name": "Jadhav Laxmi Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "728",
    "name": "Jadhav Sachin Harichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12525",
    "name": "Kadu Prakash Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20613",
    "name": "Khapali Vijay Bhagwanta"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "57",
    "name": "Khilare Ananda Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6523",
    "name": "Parekh Jagruti Kantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8209",
    "name": "More Vitthal Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13490",
    "name": "Kotekar Avinash Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12730",
    "name": "Borge Prakash Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9793",
    "name": "Kambale Sharda Raju"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22856",
    "name": "Shaikh Imran Ajagarali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12201",
    "name": "Toragall Hamid Mainuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12918",
    "name": "Wagh Chhaya Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11153",
    "name": "Desai Prabhakar Bhikaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8465",
    "name": "Shekh Basir Vajir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8613",
    "name": "Shinde Ramesh Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10253",
    "name": "Kadam Sitabai Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11752",
    "name": "Jadhav Vikas Balku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "877",
    "name": "Dhami Pyarelal Kamaldas."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "784",
    "name": "Jadhav Bharati Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9802",
    "name": "Jafri Humahuraza Fidahussain"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19215",
    "name": "Mali Ruparam Shankarlalji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17017",
    "name": "Mohite Suresh Damu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23110",
    "name": "Parmar Rajesh Manji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14603",
    "name": "Reddi Sinthala Raj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13404",
    "name": "Shinde Pramod Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20132",
    "name": "Tambe Deepak  V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21574",
    "name": "Vishwakarma Hiralal Lalsingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1742",
    "name": "Nerurkar Prakash R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15495",
    "name": "Choudhari Sunilkumar Radheshyam"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "768",
    "name": "Bahire Nitin Dnayndev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5039",
    "name": "Dalvi Sonal Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13720",
    "name": "Kadam Anil Bhanudas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17245",
    "name": "Mane Sakshi Vivekanand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "386",
    "name": "Singh Roshan Visheshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16322",
    "name": "Vora Naresh Dharamshi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9000",
    "name": "Bandekar Amey Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "318",
    "name": "Tambe Ramesh Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "51",
    "name": "Pingale Tukaram Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "370",
    "name": "Khilare Maruti Dyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9371",
    "name": "Baieng Raghunath Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8670",
    "name": "Dalavi Trupti R/Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18342",
    "name": "Desai Baburao Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19639",
    "name": "Dewasi Bagdaram Parhaladji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23363",
    "name": "Masukar Vaibhav Vishwas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12387",
    "name": "Mulani Dilawar Sayyad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17681",
    "name": "Sawant Saraswati Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20386",
    "name": "Shinde Vandana Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11559",
    "name": "Panjari Sunita Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1899",
    "name": "Mahajan Vivek Madhav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14658",
    "name": "Katekar Gorakhnath Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7327",
    "name": "Sakunde Vithoba Mhaske"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "726",
    "name": "Shinde Santosh Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "565",
    "name": "Suman Chadrakant Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3455",
    "name": "Jadhav Kondiram Kisanrao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21595",
    "name": "Chaurasia Jitendra Chandrika"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13718",
    "name": "Gaikawad Dilip Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19370",
    "name": "Ghorpade Uttam Abaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13716",
    "name": "Mane Suman Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20332",
    "name": "Morya Naresh C."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19072",
    "name": "Salunkhe Abhay Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11664",
    "name": "Shah Rajesh K."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "448",
    "name": "Sahu Nanne Puselal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1213",
    "name": "Roman Namdeo Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21967",
    "name": "Bhagat Jyoti Narendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11356",
    "name": "Biswas Lakhan Tolakh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23022",
    "name": "Chavan Bharat Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19007",
    "name": "Jagtap Harshal Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13667",
    "name": "Jangam Renuka Dttatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5945",
    "name": "Kijbile Rajaram Dhondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13685",
    "name": "Mane Gouri Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23054",
    "name": "Mestry Sitabai Ramchandra"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1142",
    "name": "Mishra Deepakkumar Shivsagar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18088",
    "name": "More Sushma Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8698",
    "name": "Nirmal Sandip V"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12093",
    "name": "Salunkhe Sadanand Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14566",
    "name": "Shinde Dilip Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23019",
    "name": "Vaan Balaji Vaghji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "781",
    "name": "Chavan Balu Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17096",
    "name": "Bhoite Janabai Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4189",
    "name": "Pawar Ashok Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "215",
    "name": "Sajgane Anna Baba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11296",
    "name": "Babu S. Harinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15495",
    "name": "Dholam Shivram Satyawan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8852",
    "name": "Mahadik Smita Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16212",
    "name": "Mahakal Manisha J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19599",
    "name": "Matre Ravindra Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13159",
    "name": "Nprpmja  Bacthazar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9342",
    "name": "Parte Bala Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15319",
    "name": "Patil Yogesh Vishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9352",
    "name": "Surve Kishore Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18864",
    "name": "Todkar Ashok Datu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20183",
    "name": "Bhilare Yogesh Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5173",
    "name": "Jagtap Shankar Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7891",
    "name": "Sabale Balaso Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2854",
    "name": "Kashid Prakash Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5450",
    "name": "Surve Shantaram Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22748",
    "name": "Badekar Vaishali Shaym"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22629",
    "name": "Bais Abhijit Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22649",
    "name": "Bandekar Shreenidhi Laxmikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20024",
    "name": "Bane Ashok Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21315",
    "name": "Bansode Pavita Mahendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15928",
    "name": "Barge Rahul Bhanudas"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "252",
    "name": "Barge Sachin Balaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22658",
    "name": "Bhandare Aarti Gangadhar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "229",
    "name": "Bhojane Govind Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22640",
    "name": "Bhosale Mohan Nivruti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "64",
    "name": "Bhosale Naresh Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15087",
    "name": "Bhosale Vikas Mahadeo"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "36",
    "name": "Bhujbal Santosh Gangaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "287",
    "name": "Bichukale Bapurao Dagdu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22621",
    "name": "Chavan Somanath Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22595",
    "name": "Garg Sunil Omprakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12223",
    "name": "Gawde Ravindra Jagannath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "880",
    "name": "Imran Stiyak Ahamd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22620",
    "name": "Ingulkar Madhavi Manoj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22666",
    "name": "Jadhav Namdev Abaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21441",
    "name": "Jain Darshan Bharat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21442",
    "name": "Jain Dev Bharat"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "156",
    "name": "Kadam Sanjaykuamr Shankarrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "69",
    "name": "Kamble Anand G"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21289",
    "name": "Kamble Rahul Sitaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "176",
    "name": "Kanvalu Sahebrao Malhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22839",
    "name": "Mohite Sachin Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4580",
    "name": "More Anusaya Mahadeo."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22667",
    "name": "More Sitaram Aba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22611",
    "name": "Nagare Ramesh Sayaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18984",
    "name": "Nimbalkar Ravindra Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22660",
    "name": "Pavaskar Sunil Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22645",
    "name": "Pawar Prakash Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22638",
    "name": "Pawar Shraddha Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22617",
    "name": "Pote Dinesh Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12711",
    "name": "Ragade Mukund Sonaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "87",
    "name": "Rajapure Suresh Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22699",
    "name": "Sawant Bhaskar Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12712",
    "name": "Shah Jitendra Kantilal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "255",
    "name": "Shaikh Sayeed Issa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22596",
    "name": "Shetty Anil Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11832",
    "name": "Shetty Pravin J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12113",
    "name": "Walekar Suman Sukhdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7700",
    "name": "Yadav Kismatidevi Jogindar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21274",
    "name": "Zakare Anil Housiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4131",
    "name": "Chavan Manoj Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11735",
    "name": "Dhumal Mohan Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5933",
    "name": "Sarafdar Yeshwant Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8892",
    "name": "Vacchau Pratibha Dadaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2750",
    "name": "Jain Dilipkumar S"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1431",
    "name": "Chavan Archana Sanddep"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14665",
    "name": "Kare Ramchandra Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10256",
    "name": "Pal Raja Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18876",
    "name": "Patil Nirmala Dinesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19279",
    "name": "Rajbhar Lalji Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13810",
    "name": "Saroj Gangasagar Ramasare"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16805",
    "name": "Shinde Fatesingh Babulal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13617",
    "name": "Shinde Ganesh Vishwas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12826",
    "name": "Mohite Sagar Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20231",
    "name": "Chavan Nakuja Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23056",
    "name": "Kori Shankar Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13347",
    "name": "Mehta Premraj Pukhraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10001",
    "name": "Pawar Vishwas Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6042",
    "name": "Vishvakarma Shiyaram Sakhu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15934",
    "name": "Pavaskar Nirmala V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10953",
    "name": "Khopade Suresh Balkrushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11313",
    "name": "Pandit Shankar Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13589",
    "name": "Sawant Vijay Tanaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "355",
    "name": "Shah Mohdarif Mohdarif Yar Mohammad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21567",
    "name": "Wadkar Bajirao Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5837",
    "name": "More Malan Pralhad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13103",
    "name": "Jain Suresh C."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13569",
    "name": "Bhosale Sahebrao Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13560",
    "name": "Chendke Dattatry Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13849",
    "name": "Faras Zainuddin Abdulrashid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11739",
    "name": "Parmar Komal Nandkishor"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "823",
    "name": "Shedge Vilas Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3297",
    "name": "Phalake Laxman Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5740",
    "name": "Chavan Namdeo Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20170",
    "name": "Dalvi Suryakant Dajirao."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13633",
    "name": "Nalawade Sanjay Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15140",
    "name": "Singh  Brijesh."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "491",
    "name": "Singh Ripunajay Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14581",
    "name": "Yadav Sunil Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13823",
    "name": "Wadam Tukaram Chandru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3710",
    "name": "Kumbhar Pandurang Ganpati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10483",
    "name": "Tiwari Alakhniranjan Ramnaraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9405",
    "name": "Jain Apeksha Sureshkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6685",
    "name": "Natekar Dattaram Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21219",
    "name": "Bagwe Atul Janardan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21123",
    "name": "Bahadur Abdul Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22544",
    "name": "Bhosale Ashok Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17887",
    "name": "Chikane Yashvant Devji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21216",
    "name": "Dikshit Ravindrakumar Kalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22542",
    "name": "Gaikwad Mahesh Devanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20262",
    "name": "Gaikwad Manikrao Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21122",
    "name": "Jadhav Sanjay Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16424",
    "name": "Morvaskar Manohar Ganu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13545",
    "name": "Nalwade Vinod Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21205",
    "name": "Pawar Ajit Bhagawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17577",
    "name": "Sarkar Sanjay Jugesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13515",
    "name": "Shinde Vilas Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21153",
    "name": "Undalkar Dipak Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21107",
    "name": "Bhamare Sachin Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21103",
    "name": "Gorule Dayanand Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21068",
    "name": "Joshi Seema Dnyanesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22543",
    "name": "Kalambe Datta N"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21046",
    "name": "Keshavani  Mohan   Kisanchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15183",
    "name": "Monsap Sakir Ali."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "977",
    "name": "More Ashabai Hirachand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22578",
    "name": "Salunkhe Anna Amrut"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22542",
    "name": "Sanas A G"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10233",
    "name": "Shirtode Hanmant Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22053",
    "name": "Sutar Vaibhav Prabhakar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "587",
    "name": "Dudhal Amol Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16595",
    "name": "Patel Umashankar Ramprtap /Gomatadevi Ra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7042",
    "name": "Dungrani Poonam Mukesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10618",
    "name": "Thorat Natha Balguram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5637",
    "name": "Jagtap Megha Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20782",
    "name": "Kushwah Rammanohar Harishankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12539",
    "name": "More Pavitra Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8625",
    "name": "Pawaskar Chandrakala Bhaskar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12690",
    "name": "Phalake Vinayak Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13427",
    "name": "Thakur Shita Parmanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "714",
    "name": "Mahale Kishan Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16876",
    "name": "Varma Jayprakash Ramsundar ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4496",
    "name": "Sawant Chandrakant Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1292",
    "name": "Jagtap Uttam Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5843",
    "name": "Panchal Vinodini Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6690",
    "name": "Pathak Prabhakar J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1321",
    "name": "Pawar Kamlakar Vishnupant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13471",
    "name": "Awaghade Ramesh Uttamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20903",
    "name": "Biramne  Baburao Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11362",
    "name": "Bobade Arvind Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8428",
    "name": "Chipkar Pravin A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10561",
    "name": "Chouhan  Ramawati Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10226",
    "name": "Dhumal Pradip Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20938",
    "name": "Gawai Devidas Ambadas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8774",
    "name": "Jagdev Mina Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21013",
    "name": "Kamble Hari Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20929",
    "name": "Kshrisagar Sanjay Narhari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10029",
    "name": "Momin Jamal Azamuddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20904",
    "name": "Morbale Sanjay Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20902",
    "name": "Patil Rangrao Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17713",
    "name": "Salunkhe Mohan Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22784",
    "name": "Salvi Rashmi Ram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20978",
    "name": "Sawant Ajit Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13484",
    "name": "Shinde Dnyadeo Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22506",
    "name": "Thakur Swapnil Ajit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22118",
    "name": "Thorave Rahul Bhimrao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11205",
    "name": "Kadam Maruti Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13899",
    "name": "Pathan Sanauddinkhan Nasrulkhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1174",
    "name": "Kadam Vilas Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "258",
    "name": "Pednekar Sharad Jairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11494",
    "name": "Katkar Suresh Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4558",
    "name": "Hule Vasant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12545",
    "name": "Bhosale Dilip Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22342",
    "name": "Bhowar Suryakant Raghunath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "531",
    "name": "Choudhary Rampal Shivdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20890",
    "name": "Gangurde  Shiddharth  Dinakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20859",
    "name": "Kachare  Narayan  Dhyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8507",
    "name": "Pawar Tanaji Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20803",
    "name": "Sawant Nitin Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22352",
    "name": "Shaikh Mohammad Zahid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20893",
    "name": "Shekh Asif Yakub"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13430",
    "name": "Shinde Sushant Hambirrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18774",
    "name": "Shukla Pramodkumar Ravindrakumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14179",
    "name": "Tondulkar Prakash Vasantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "828",
    "name": "Thakkar Mulji Velji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1233",
    "name": "Kale Bhagwan Bhagoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6243",
    "name": "Ghag Shashikant Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20779",
    "name": "Choudhary Pradeepkumar Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20714",
    "name": "Kambli Shweta Surendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20777",
    "name": "Mahtre Mohan Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22443",
    "name": "Moraes Mary Philip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20724",
    "name": "More Vishal Ambaji."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18695",
    "name": "Panasare Mahendra Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20786",
    "name": "Pawar Amita Bhanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20769",
    "name": "Shaikh Abdul Salim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22453",
    "name": "Yeram Anil Vishram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14811",
    "name": "Dakave Baban Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5179",
    "name": "Sawant Hanamant Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3191",
    "name": "Gawade Subhash Dasharath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19925",
    "name": "Shinde Laxman Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6041",
    "name": "Bhuwad Raguhnath Shitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13706",
    "name": "Chavan Rajendra Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19814",
    "name": "Jadhav  Nilam  Vijaykumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13395",
    "name": "Karpe Sandeep Arun"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1286",
    "name": "Lokhande Bhagwan Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18426",
    "name": "Muzavar Mahamd Abbas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13356",
    "name": "Pachpute Atmaram Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11515",
    "name": "Pawar Prakash Devji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22282",
    "name": "Poskar Supriya Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22679",
    "name": "Salunkhe Suresh Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22275",
    "name": "Sarate Prakash Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13354",
    "name": "Sawant Dattatray Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16541",
    "name": "Siddiswar Vikas Mandal Vazoli"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3146",
    "name": "Shinde Ramchandra Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1005",
    "name": "Lokhande Nandkishore Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21642",
    "name": "Shinde Shyam Shripatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7271",
    "name": "Gujar Hirabai Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4690",
    "name": "Bansode Bhiku Savala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10214",
    "name": "Dhadave Rajesh Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4603",
    "name": "Sawant Lalsingh Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22430",
    "name": "Dake  Pritam  Purushottam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22406",
    "name": "Mehta Madhukar Mohanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12862",
    "name": "Nikam Mangal Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22295",
    "name": "Pisal Tatyaso Bandoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7633",
    "name": "Mestri Shankar Bhikaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7526",
    "name": "Shinde Bhanudas Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1263",
    "name": "Pawar Ranjana Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5963",
    "name": "Ghag Rajendra Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10443",
    "name": "Manjrekar Chandrakant T/Krishna B/Madhuk"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "676",
    "name": "Mewalal Gautam Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13071",
    "name": "Phadtare Vithal Khasaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16726",
    "name": "Shaikh Afjal Ali Fekuali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6349",
    "name": "Shinde Shivram Bhanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20681",
    "name": "Tawade Amit Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13310",
    "name": "Wakar Atmaram Khandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4582",
    "name": "Ghadge Tukaram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22694",
    "name": "Bhogale Narayan Pandhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15894",
    "name": "Mulik Sunita Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16566",
    "name": "Pal Raju Rajdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "425",
    "name": "Shinde Vithal Krishnarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4445",
    "name": "Joshi Sushila Mahendrakumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7081",
    "name": "Chavan Nilesh Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14217",
    "name": "Chudaji Sunita Sadanand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22048",
    "name": "Gawde Prakash Nagesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13394",
    "name": "Inamdar Fayad Sallaudin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20666",
    "name": "Patil Sanjay Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22471",
    "name": "Patil Shankar Ganpatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12415",
    "name": "Pawaskar Subhash Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22055",
    "name": "Petkar Vishnu Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3385",
    "name": "Mohanan N. S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1101",
    "name": "Kandalgaonkar  Balkrishna Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7912",
    "name": "Bhosale Hanmant Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7403",
    "name": "Dakhinkar Vaman Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12789",
    "name": "Ghubade Ramesh Sonu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17957",
    "name": "Gaikwad Chandrakant Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22336",
    "name": "Kurade Dilip Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21826",
    "name": "Mishra Kedarnath Ramkrupal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18317",
    "name": "Pujaree Pratap Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18594",
    "name": "Salunkhe Santosh Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22425",
    "name": "Senthilkumar  Chinnapaiyan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9589",
    "name": "Shekh Mubarak Abdul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13600",
    "name": "Shelke Bhausaheb Uttam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22102",
    "name": "Solanki Geeta Bakulesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "564",
    "name": "Vimula Prasad Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6042",
    "name": "Ghadge Maruti Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4500",
    "name": "Shri Vyankateshwar Autorepairs"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22052",
    "name": "Jande Ashwini Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15493",
    "name": "Kondra Prabhakar Gagaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13997",
    "name": "Vichare Suresh Yashawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20273",
    "name": "Yadav Shivkumar J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7130",
    "name": "Sanap Shivaji Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6187",
    "name": "Karne Rekha Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10977",
    "name": "Gujar Rajaram Daulatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6388",
    "name": "Dhumal Nandkumar Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10231",
    "name": "Chavan Shankar Vitthalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11204",
    "name": "Mane Pralhad Gangaram 1039/14"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22090",
    "name": "Dayal Sanjay P."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11607",
    "name": "Godse Nanda Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12519",
    "name": "Jawade Tushar Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17243",
    "name": "Kadam Sandeep Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21894",
    "name": "Magar Udhav Pandit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4893",
    "name": "Mhatre Vaman Daji/Prakash Vaman Mhatre"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20547",
    "name": "Pratap Gourav Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11625",
    "name": "Saste Vijay Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20232",
    "name": "Shinde Hanmant Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2080",
    "name": "Pisal Uttam Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "592",
    "name": "Shankar Dnyanu Patil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4592",
    "name": "Divekar  Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6947",
    "name": "Shewale  Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9679",
    "name": "Shinde Kondiba Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1502",
    "name": "Mandhare Dnyandeo Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21751",
    "name": "Gavane Keshav Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11690",
    "name": "Gawade Seema Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21824",
    "name": "Harane Parshuram Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21819",
    "name": "Kadam Kisan Dinkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19493",
    "name": "Kambar Monappa Hanumant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16754",
    "name": "Khan Sayrabi Karmali."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15570",
    "name": "Shinde Ganesh Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "487",
    "name": "Singh Akash Mahendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3856",
    "name": "Jagtap Digambar Machindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18788",
    "name": "Somalkar Prashant Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13633",
    "name": "Mandhare Dilip Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2646",
    "name": "Buday Ysamin Mubarak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19640",
    "name": "Jadhav Janardhan Yashvant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11899",
    "name": "Jadhav Laxman Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18439",
    "name": "Jadhav Vilas Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3937",
    "name": "Shinde Sulabha Rakesh ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21011",
    "name": "Jain Gautam Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22119",
    "name": "Koli Anusaya Sabbana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19546",
    "name": "Sabale Sharad Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16634",
    "name": "Sersingh Lalsingh Vishvakarma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21804",
    "name": "Bhalerao Kusum Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14013",
    "name": "Bhati Bhagwanram P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21784",
    "name": "Gupta Ravishankar Baburam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21740",
    "name": "Kadam Madhukar Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3369",
    "name": "Bhosale Rajaram Sadhuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13889",
    "name": "More Dattatray Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15799",
    "name": "Sonurlekar Shimon Ramchandra/Anuradh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3386",
    "name": "Jadhao Yashawantarao Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1778",
    "name": "Nanware Deepak Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22264",
    "name": "Achrekar Arti Anil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12283",
    "name": "Bhalerao Sneha Suhas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15847",
    "name": "Jadhav Rajeshwari Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14220",
    "name": "Khutale Dnyanada Padmakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21716",
    "name": "Londhe Prakash Nivruti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21722",
    "name": "More Reshma Kashiram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21657",
    "name": "Pal Devraj Ferai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21656",
    "name": "Patel Bhupendra Hargovind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21653",
    "name": "Sakharkar Vijay Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21715",
    "name": "Waghmare Rajesh Bharat."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22239",
    "name": "Yadav Uttam Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17313",
    "name": "Gole  Rajendra  Vishnu ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6184",
    "name": "Bhagat Sadashiv Vithalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11875",
    "name": "Mardhekar Raghunath A. 281/20"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18018",
    "name": "Shah Jay Jayant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "615",
    "name": "Manaji Pundlik Pawar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7763",
    "name": "Mane Yamuna Babasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9887",
    "name": "Sawant Bhimrao Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7856",
    "name": "Shah Narendra Manilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7220",
    "name": "Gaykar Ramchandra Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14754",
    "name": "Dhuri Vasu Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15587",
    "name": "Ghodake Kamalabai Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3426",
    "name": "Posam Vilas Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13338",
    "name": "Suryawanshi Vikas Mansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13625",
    "name": "Kajare Ashok Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21482",
    "name": "Deorukhakar Deepika Sunil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13849",
    "name": "Kesarkar Sharmila Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21591",
    "name": "Khan Ayub Anwar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "972",
    "name": "Kolekar Sanjay Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7420",
    "name": "Matan  Sellappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9920",
    "name": "Pawar Navanath Hanamant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9415",
    "name": "Putran Indira Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21584",
    "name": "Yadav Kedarnath Awadesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9636",
    "name": "Murarka Prakash Damodar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16748",
    "name": "Chavan Lilavati Appasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4304",
    "name": "Satpute Jagannath Tatoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1762",
    "name": "Mohite Vitthal Khashaba."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16800",
    "name": "Jaiswal Jitendrakumar Vidhyaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21622",
    "name": "Budhavle Deepak Ekanath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21606",
    "name": "Dawda Paresh Babulal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21604",
    "name": "Devade Vithal Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15144",
    "name": "Dhonde Ravindra Bhalchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11106",
    "name": "Gaikar Ramesh Skharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21595",
    "name": "Gupta Mithailal Ramacharya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21569",
    "name": "Gupta Ramayan Rampati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21549",
    "name": "Gupta Rameshram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21597",
    "name": "Jadhav Ramesh Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22161",
    "name": "Jadhav Vinayak Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21575",
    "name": "Jamkhedkar Sanjay Digambar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5211",
    "name": "Kanderi Ratnakar Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8040",
    "name": "Kotian Kushal S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4770",
    "name": "Mohmed Amin Gulamnabi Farid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21603",
    "name": "Mudaliyar Kannan Masalimani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21602",
    "name": "Singh Mansingh Jagroop"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21570",
    "name": "Talekar Mohan Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18365",
    "name": "Theware Mahendra Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21590",
    "name": "Yadav Harishchandra Ramavtar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3419",
    "name": "Kansabe Ramesh Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5562",
    "name": "Kadam Ramesh Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21550",
    "name": "Bari Rajeshkumar Jawaharlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21535",
    "name": "Bhor Dattu Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21541",
    "name": "Chudasama Batuk Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20294",
    "name": "Fereira Jouns M."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12747",
    "name": "Gaikwad Minaxi Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12968",
    "name": "Joshi Lograj Gajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21501",
    "name": "Nalge  Gajanan  Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21551",
    "name": "Pakhad Baburao Ganu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21536",
    "name": "Sarju Anil Devnath."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1923",
    "name": "Shireen Electricals"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "425",
    "name": "Satam Madhukar Bachuji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21556",
    "name": "Tawakkal Imtiyaz Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22110",
    "name": "Waghmare Vijay S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20670",
    "name": "Wardekar Hemant Sudhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18874",
    "name": "Salunkhe Kalpana Shashikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "949",
    "name": "Nadkar Chandrakant Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11033",
    "name": "Bhagwat Antu Janardan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16870",
    "name": "Kadam Raju Dinkar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14391",
    "name": "Kadam Vaibhav Harischandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21469",
    "name": "Nikam Shreya Sunil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21839",
    "name": "Padwal Mrunal Mahesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16091",
    "name": "Patel Subhodchandra Kantilal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1082",
    "name": "Shukla Umashankar Rakesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11257",
    "name": "Waghamare Ratan Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5643",
    "name": "Padwal Deepak Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3006",
    "name": "Sathe Vijay Krishnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "374",
    "name": "Waman Jagannath Yadav."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "327",
    "name": "Bhingarde Sampada Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11686",
    "name": "Kadam Rajani Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21882",
    "name": "Kambale Chandrakant Ganesh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "530",
    "name": "Machhi Shaila Ashish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9730",
    "name": "Yadav Kamal Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19106",
    "name": "Parte Ashok Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5624",
    "name": "Bhandari Dilip Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13507",
    "name": "Bhosale Narayan Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12760",
    "name": "Disale Tanaji Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18300",
    "name": "Ghare Krishna Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21478",
    "name": "Rajbhar Ramu Bhagwati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15232",
    "name": "Salunkhe Bhanudas Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8278",
    "name": "Sonar  Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6370",
    "name": "Mane Mahadeo Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16182",
    "name": "Bhosale Santosh Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22643",
    "name": "Chavan Sangeeta Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22037",
    "name": "Jagtap Vikram Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11707",
    "name": "Kamble Vikas Waman"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "179",
    "name": "Kapale Tanaji Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23544",
    "name": "Mandhare Kumar Vishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21405",
    "name": "Pagar Mohan Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21371",
    "name": "Shetty Mohan Nadeson"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21410",
    "name": "Ughade Aachutrao Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16864",
    "name": "Shinde Hanmant Kashinath ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13759",
    "name": "Govekar Sanjay Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20282",
    "name": "Pujari Mahadev T"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12347",
    "name": "Purohit Prabhuram Khumaramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20600",
    "name": "Singh Shivcharan Gurupal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3523",
    "name": "Pandit Jagannath Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2649",
    "name": "Gavi Sadashiv Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6340",
    "name": "Mane Harish B."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14544",
    "name": "Khan Samsulkamar Lalbahadur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2074",
    "name": "Rokade Sitaram Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18552",
    "name": "Aalve Gajanan Ghansham"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23531",
    "name": "Barge Chaitanya Ankush"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1692",
    "name": "Bharathi Lalji Shripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13145",
    "name": "Chenna Mahesh Kumar Prasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11478",
    "name": "Jadhao Vithal Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15402",
    "name": "Kandare Poonam Bharat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18447",
    "name": "Mulla Sharif Balekhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19215",
    "name": "Patange Haresh Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8619",
    "name": "Sharma Ratan Navraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21711",
    "name": "Solanki Foram Amrut"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15004",
    "name": "Thakur Ajaysing Chandeshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20083",
    "name": "Yelwnde Shivkumar Asaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17804",
    "name": "Gharal Chandrakant Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10339",
    "name": "Pashte Ramesh Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2594",
    "name": "Pawar Ganpatrao Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8675",
    "name": "Gujar Raghunath Rama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12115",
    "name": "Bhilare Mansing Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5931",
    "name": "Dhopawkar  Gurunath/Ganapat/Ravindra/Bala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21958",
    "name": "Shinde Pandurang Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18287",
    "name": "Vaiti Chanda Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3530",
    "name": "Padmawar Sudheer Arvind."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8985",
    "name": "Vichare Ashok Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5424",
    "name": "Pawar Sitaram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3872",
    "name": "Potdar Pradip K."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3674",
    "name": "Shiv Enterprise"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4131",
    "name": "Shiv Ganesh Courier & Cargo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19246",
    "name": "Patil Suresh Abhimanyu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2479",
    "name": "Shiv Shakti Enterprise"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20591",
    "name": "Chavan Shraddha Ramakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13510",
    "name": "Dhumal Youraj Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1575",
    "name": "Shivalik Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14386",
    "name": "Rane Ashamita Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19540",
    "name": "Shah Rajendra Jungabahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7289",
    "name": "Redkar Vikram Vilas"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "104",
    "name": "Shivam Enteprises"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2327",
    "name": "Shivam Enterprise"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15101",
    "name": "Ombale Suresh Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15066",
    "name": "Shirke Shivaji Nanasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21102",
    "name": "Abbas Ali Hussain Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17470",
    "name": "Cheulkar Rohini Rohidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21088",
    "name": "Ghag Prabhakar Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21100",
    "name": "Gupta Shrikant Satyanarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17387",
    "name": "Jadhav Anant Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11736",
    "name": "Khedkar  Chandrakant Bhimaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21096",
    "name": "Panday Mahendra Ramkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21094",
    "name": "Pawar Shantaram Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21095",
    "name": "Ramane Laxman Banu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21089",
    "name": "Shekh Rafik Abudal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16985",
    "name": "Shinde Hambirao Jagdeorao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6963",
    "name": "Singh Hawaldarsingh Gorakhh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22411",
    "name": "Tamboli Mehmood Noor Mohmed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11675",
    "name": "Yadhav Tushar Ragunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2849",
    "name": "Acharekar Mahadev Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10032",
    "name": "Jadhav Parvati Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20381",
    "name": "Sakpal Gaurav Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2685",
    "name": "Khan Abdula Mustafa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8814",
    "name": "Gaikwad Ramdas Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11102",
    "name": "Jaiswal Rajmani Bihari"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "278",
    "name": "Shivshankar Lawns"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21078",
    "name": "Abdul Munaf Abdul Kadar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21083",
    "name": "Ansari Ismail Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21079",
    "name": "Apate Raju Shyamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20019",
    "name": "Bhansode Bhagvan Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11366",
    "name": "Chakravati Archana Anupam"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "819",
    "name": "Shree Ambika Textile Agence"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "211",
    "name": "Shree Ashirwad Electronics"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "67",
    "name": "Shree Ashtavinayak Building Material Suppliers"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1081",
    "name": "Shree Auto Travellers"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1121",
    "name": "Shree Bhairavnath Vahatuk Seva Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4449",
    "name": "Shree Bhooriya Baba Agency"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21085",
    "name": "Dabhi Lila Kanji"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1511",
    "name": "Shree Ekyeera Dnyan Prasarak Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2140",
    "name": "Shree Electric Corporation"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2138",
    "name": "Shree Electrical"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4335",
    "name": "Shree Gajanan Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20996",
    "name": "Dawood Khan Akbar Khan Pathan"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1198",
    "name": "Shree Ganesh Steel"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "59",
    "name": "Shree Ganesh Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1512",
    "name": "Shree Gurudatt Transport"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1673",
    "name": "Shree Hanuman Kapad Deily Service"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13784",
    "name": "Ghorpade Pushpa Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16696",
    "name": "Kadam Anita Ankush"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "254",
    "name": "Shree Jarandeshwar Milk Centre"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21086",
    "name": "Kamble Ramesh Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "133",
    "name": "Shree Krishna Novelty & Book Depot"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "76",
    "name": "Shree Kshemkari Sweet & Dryfruit"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "635",
    "name": "Shree Laxmi Metal Works"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2283",
    "name": "Shree Laxmi Narayan Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1526",
    "name": "Shree Mahaveer Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23628",
    "name": "Kharade Sambhaji Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4579",
    "name": "Shree Parshuram Agrotech Pvt.Ltd."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "970",
    "name": "Shree Products"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "58",
    "name": "Shree Ram Medical & General Stores"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "21",
    "name": "Shree Ram Sanjiwani Medical & General Store"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3870",
    "name": "Shree Ram Traders"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2337",
    "name": "Shree Raymata Fabrics"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12991",
    "name": "Pawar Bhimrao Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1999",
    "name": "Shree Sai Electric Service"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2026",
    "name": "Shree Samarth Pet Industries"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "269",
    "name": "Shree Shiv Malhar Wire Industries"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12729",
    "name": "Pawar Sanjay Ganpat"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "60",
    "name": "Shree Shyam Estate Consaltant"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2682",
    "name": "Shree Siddhivinayak Angadia Services"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4492",
    "name": "Shree Sinvam Parcel Services"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "244",
    "name": "Shree Tex Engineers"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21521",
    "name": "Sarmalkar Vibhas Shrikant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2173",
    "name": "Shreeji Metals"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "206",
    "name": "Shreekrushna Traders"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1380",
    "name": "Shreenath Packing Work"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21080",
    "name": "Shaikh Ramjan Noor"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14160",
    "name": "Thombare Sangram Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "134",
    "name": "Shri Datta Krupa Electronics"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20963",
    "name": "Tiwari Arunkumar Rajendra"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "197",
    "name": "Shri Ganesh Saree Centre"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21084",
    "name": "Yadav Avaidhi Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20041",
    "name": "Yadav Nitish Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21081",
    "name": "Yadav Sanjay Harishankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6068",
    "name": "Lokhande Ramesh Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4082",
    "name": "More Laxmi Jayram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2569",
    "name": "Shri Ram Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "852",
    "name": "Shri Savtamali Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10065",
    "name": "Salvi Prerna Prakash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "802",
    "name": "Dodhiya Dilip Mansukhlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15238",
    "name": "Ovalekar Vivek Malsakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23783",
    "name": "Patil Archana Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17349",
    "name": "Pawar Geeta Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20717",
    "name": "Pawar Supriya Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15302",
    "name": "Shettigar Prabhakar Giriya"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "162",
    "name": "Shriram Chemicals"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5063",
    "name": "Bhngardive Ramesh Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4152",
    "name": "Salunkhe Bhagoji Ganpt 445/B/4"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16000",
    "name": "Wagh Haridas Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16362",
    "name": "Bhawarlal Mangilal Ladhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17026",
    "name": "Gaikawad Suresh Bajrang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19744",
    "name": "Samuyal  Chandanibai Tukki"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8672",
    "name": "Shukla  Manojkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20836",
    "name": "Singh Omprakash Ramjamaj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20837",
    "name": "Yadav Rampalat Jaganath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8447",
    "name": "Doke Ganesh Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9087",
    "name": "Kshirsagar Vijay Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15783",
    "name": "Pandit Jyoti Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11340",
    "name": "Pavaskar Jana Mahaeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16291",
    "name": "Kadam Santosh Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20799",
    "name": "Karade Vilas Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9697",
    "name": "Ramdharane Ashok B/Ganpat G B/Mohan D G"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20811",
    "name": "Shaikh Mohammad Rafik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14999",
    "name": "Solanki Karishma Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16207",
    "name": "Yadav Mohan Shrinandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "979",
    "name": "Kargutkar Bapu Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "891",
    "name": "Thoke Kiran Laxman."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2424",
    "name": "Jagdevi Krishna Phanse And Etc"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6313",
    "name": "Yadav Avinash Mugutrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18908",
    "name": "Chavan Ravindra Bajrang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11779",
    "name": "Jadhav Mangal Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21093",
    "name": "Jagtap Priyanka Shrikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13186",
    "name": "Kadam Prakash Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20651",
    "name": "Khan Hafeej Ullah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7625",
    "name": "Rane Bhalchandra Shivram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12048",
    "name": "Sahani Jayprakash B."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19206",
    "name": "Sawant Aparna Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5292",
    "name": "Yadav Tulsiram R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17961",
    "name": "Patil Pritam Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10788",
    "name": "Galande Dinkar Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2638",
    "name": "Shyam Enterprises"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13305",
    "name": "Bobade Shashikala Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20698",
    "name": "Bohara Mansingh Bhavansingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20733",
    "name": "Chauhan Mithailal Lalchand"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2154",
    "name": "Siddhakala Interior Decorators"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22005",
    "name": "Jadhav Pravina Kunal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20437",
    "name": "Nawadkar Sagar Kalidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20654",
    "name": "Parmar Mukesh Ramaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21713",
    "name": "Takale Namdeo Asaram"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "246",
    "name": "Siddhivinayak Arts"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6337",
    "name": "Kolekar Pandurang Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11890",
    "name": "Agrawal Rajesh Jainarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6028",
    "name": "Dombale Vithal Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21246",
    "name": "Dubey Santosh Ravinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20590",
    "name": "Jadhav Shripati Rawoo"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "48",
    "name": "Siddivinayak Crane & Transport Service"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21189",
    "name": "Kadam Amey Hemant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21704",
    "name": "Katalkar Sachin Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18297",
    "name": "Khedekar Kshama Sachin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10140",
    "name": "Kolge Mamata Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22237",
    "name": "Mayal Padam Singh Narasingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20620",
    "name": "Mohamed Hanif Ibrahim."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20565",
    "name": "Patil Ashok Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8624",
    "name": "Patil Vibhavari Virangan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20607",
    "name": "Saroj  Ramkishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20587",
    "name": "Shaikh Imran Usmangani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20555",
    "name": "Sharma Raju Ramkripal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4364",
    "name": "Silver Shine Synthetics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2685",
    "name": "Simander Steels & Engg.Co."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1797",
    "name": "Vaishnav Madandas Hanumandas."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10199",
    "name": "Narvekar Dattaram Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18534",
    "name": "Nalawade Atul Hanmantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7055",
    "name": "Damgude Parvati Dharmaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6315",
    "name": "Yadav Suryakant Mugutrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3845",
    "name": "Kamkar Jayaram Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3924",
    "name": "Manot Jakaran Motilal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "683",
    "name": "Phalke Balkrishna Keshavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13958",
    "name": "Desai Aabaso Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16693",
    "name": "Nandoskar Santosh Sadanand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1530",
    "name": "Paswan Badhan Lallan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20074",
    "name": "Salvi Mandar Umesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6204",
    "name": "Bangera Satish Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5198",
    "name": "Desai Charudatt Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11825",
    "name": "Gala Velbai Shyamaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11902",
    "name": "Gawai Indu Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17860",
    "name": "Kadam Amol Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18553",
    "name": "Kadam Ananda Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17246",
    "name": "Nishad Rajesh Chotalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "378",
    "name": "Gajanan Lalaji Raval."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11483",
    "name": "Chorge Dagadu Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6167",
    "name": "Dhadchire Ashok Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8892",
    "name": "Pawar Datta Kisanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15327",
    "name": "(2) Narewade Lahu Shanker"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21603",
    "name": "Auti  Dattatray  Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21476",
    "name": "Gaware Monish Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20537",
    "name": "Gupta Mahendrakumar Gurucharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11310",
    "name": "Gurav Ashok Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20528",
    "name": "Ibrahim Gulabmohd.Abdulkarim Sayyad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11626",
    "name": "Kadu Shripat Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18413",
    "name": "Owal Damu Rambhau"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1429",
    "name": "Patil Dilip Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21552",
    "name": "Raut Santosh Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13856",
    "name": "Sawant Narayan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20523",
    "name": "Sayeed Jainudeen Nizamali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14513",
    "name": "Shaikh Luthfar Rahaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23315",
    "name": "Singh Hariprasad Ambikaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16234",
    "name": "Tarde Ashwin Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14482",
    "name": "Yadav Mahendrakumar Premshankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9834",
    "name": "Chouhan Dwarka Bhagwandin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1352",
    "name": "Rane Balaram Anaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2002",
    "name": "Rahalkar Balkrishna Sonba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6718",
    "name": "Jadhao Uttam Ramchanra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10331",
    "name": "Aware Mohan Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3425",
    "name": "Lanjekar Bharti Sanjay."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13525",
    "name": "Asme Navnath Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17324",
    "name": "Kobnak Rakesh Bhuku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20422",
    "name": "Koli Haresh Pnndurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16320",
    "name": "Nair Vivek Venugopalan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22280",
    "name": "Negi Ranjitsingh Bachansingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13991",
    "name": "Wagh Usha Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2363",
    "name": "Surve Ganpat Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11622",
    "name": "Bhise Dilip Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17752",
    "name": "Fonseca Magdaline Cubert"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21928",
    "name": "Kanavia Suman N."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7168",
    "name": "Naik Manohar Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7979",
    "name": "Patel Mahendra Natubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22359",
    "name": "Randhave Ankush Sonaji."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13098",
    "name": "Shah Jitesh Sundar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "302",
    "name": "Singh Arvindkumar Kamlesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10214",
    "name": "John  Johnson"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8543",
    "name": "Pednekar Sushila Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5797",
    "name": "Daundkar Shalini Vasantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7304",
    "name": "Kolekar Ananda Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3820",
    "name": "Konde Ankush Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5209",
    "name": "Jagtap Ganpatrao Buvaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2008",
    "name": "Bhandari Dinesh Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12699",
    "name": "Bhise Gajrabai Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12750",
    "name": "Gaikwad Milind Nivrutti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1603",
    "name": "Kamat Shashi Tripit Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13528",
    "name": "Khot Jaywant Anna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20366",
    "name": "Pandey Gangaprasad Dudhnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21770",
    "name": "Pendurkar Sudhir Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20351",
    "name": "Shaikh Hasan Miya Fakur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20540",
    "name": "Shinde Nathuji   Nathuram   Hiraji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13939",
    "name": "Salaskar Yogesh Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4046",
    "name": "Katkar Ramdas Mandev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1503",
    "name": "Bobade Chandrkant Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18231",
    "name": "Sargar Bharat Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1633",
    "name": "Mahadik Tukaram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20225",
    "name": "Chauhan Manohar Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17638",
    "name": "Goriwale Karishma Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20208",
    "name": "Khan Rasid Usmandin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6202",
    "name": "Khopate Shrimant Bassapa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13037",
    "name": "More Ashok Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20231",
    "name": "Naik Johar Raju"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "330",
    "name": "Patil Mehul Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7185",
    "name": "Poojari Jaywant Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18261",
    "name": "Shaikh Mohd Ateeqkabir Ahmed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19424",
    "name": "Solanki Ghanashyam Ranchhod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10483",
    "name": "Zha Anand Mohan Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "650",
    "name": "Kapursingh Gaganshingh Thakur."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3065",
    "name": "Gurav Sahadev Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14594",
    "name": "Wadekar Shridhar Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10259",
    "name": "Durgakeri Krishna Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8215",
    "name": "Salate Laxman Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1402",
    "name": "Mohite Hari Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "240",
    "name": "Nanasaheb Dinkarrao Pawar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1",
    "name": "Patil Vasantrao Dada"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21639",
    "name": "Bandekar Chayya Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8182",
    "name": "Joshi Dhaku Vishram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10981",
    "name": "Modi Bijal Bhupendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22351",
    "name": "Nalwade Sonal Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13018",
    "name": "Nawadkar Mandira Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12667",
    "name": "Phalake Vaibhav Vikas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10300",
    "name": "Sawant Dattatray Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2552",
    "name": "Kadam Sitaram Genba"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4341",
    "name": "Singh Sattan Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "531",
    "name": "Jadhav Sitaram Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10544",
    "name": "Kotawadekar Mahesh Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3529",
    "name": "Sawant Sarjerao Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2191",
    "name": "Dhamal Vinayak Keshavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16389",
    "name": "Hule Savitra Ganpat/ Hule M.G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13295",
    "name": "Jadhav Pravinkumar Kondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8837",
    "name": "Kamath Swetha V."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18592",
    "name": "Kothari Chitra Rakesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17675",
    "name": "Parab Shrikant Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19980",
    "name": "Shaikh Munna Ashfaq"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21373",
    "name": "Ansari Ubaid Aslam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16429",
    "name": "Bhosale Anil Parmeshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19970",
    "name": "D\"Silva Jerry Manuel"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10561",
    "name": "Shinde Pravin Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19967",
    "name": "Singh Sangay Rajnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19946",
    "name": "Ujagawakar Maruti Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9458",
    "name": "Benadia Shanta Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16076",
    "name": "Chavan Sachin Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9328",
    "name": "Salunkhe Deepali Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13311",
    "name": "Sangare Dashrath Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7767",
    "name": "Sarkale Yashwant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21745",
    "name": "Shetty Dhanlaxmi D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18488",
    "name": "Sonawane Pratik Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21720",
    "name": "Sonawane Seema Pramod"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10517",
    "name": "Pawar Arjun Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "885",
    "name": "Ankush Raghunath Pawar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15998",
    "name": "Malusare Dasharath Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21755",
    "name": "Almelo  Kannan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19850",
    "name": "Gupta Bindukumar Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2069",
    "name": "Sirvi General Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6073",
    "name": "Jadhav Vinayak Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6802",
    "name": "Jawale Sidharth Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17641",
    "name": "Mamniya  Shah  Navin Devaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19884",
    "name": "Panchal Pankaj Ramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21838",
    "name": "Salunkhe Sheela Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2260",
    "name": "Skylimit Pictures"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2238",
    "name": "Skyvision Information Solutions Pvt.Ltd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6479",
    "name": "Samant Ganesh M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19873",
    "name": "Yadav Gayadin Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1095",
    "name": "Sneha Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "644",
    "name": "Society General Stores"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5054",
    "name": "Shelake Vasant Nana"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "449",
    "name": "Bhosale Mahadeo Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1653",
    "name": "So-Hementerprise"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "181",
    "name": "Ankus Shankar Salunkhe."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1529",
    "name": "Phalke Hari Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19639",
    "name": "Matre Kamal T"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17365",
    "name": "Sawant Sonal Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16640",
    "name": "Chavan Vaishali Annasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19765",
    "name": "Gaud Satyanarayan Kalu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21885",
    "name": "Kolpek Suvita Narendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19781",
    "name": "Narshamik Mahendra Kundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19746",
    "name": "Renuke Ashok Laxmanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21183",
    "name": "Topre  Vinod  Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15231",
    "name": "Kalantre Sanjay Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16424",
    "name": "Bind Shivram Babulal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14363",
    "name": "Solanki Rekha Dalsukh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10873",
    "name": "Khuthia Jyoti Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3668",
    "name": "Rajpurohit Sawaising Bhawarsing."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10614",
    "name": "Sawant Shanta Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4232",
    "name": "Kotuwal  Hirasing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15310",
    "name": "Kadam Yeshwant Laxman B-1261"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5959",
    "name": "Bhekare Aparna Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11066",
    "name": "Desai Arvinda Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15980",
    "name": "Ghosh Sutanu Pradeep"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11812",
    "name": "Jedhe Sanjay Nathuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20518",
    "name": "Rajpure Maya Sandeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7642",
    "name": "Tambe Hemant Babaji."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "641",
    "name": "Dhumal Sarjerao Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11394",
    "name": "Jadhav Vinayak Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16105",
    "name": "Mestry Nisha Mansukhalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4495",
    "name": "Yadav  R.T."
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3718",
    "name": "Solanki Natharam Thakarji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1725",
    "name": "Desai Sureshbhai Vanmalidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7864",
    "name": "Pawar Dhondiba Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11483",
    "name": "Badade Sampat Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1603",
    "name": "Bambardekar Pandharinath Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1853",
    "name": "Mayekar Shashikumar Harishchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12097",
    "name": "Jadhav Ravindra Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19655",
    "name": "Kamble Apparao Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9515",
    "name": "Nair Lata Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20213",
    "name": "Raut Ajay Rohidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19627",
    "name": "Tiwari Dharmendra Jainath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13634",
    "name": "Kshirsagar Shekhar Narayan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21780",
    "name": "Karekar Megha Chandrashekhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23537",
    "name": "Rasal Sunil Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4142",
    "name": "Gaikawad Gaunwanta Rangrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7475",
    "name": "Swami Rajan Narayan"
  },
  {
    "branch": "Kamothe",
    "type": "Term Deposit",
    "accountNo": "67",
    "name": "Gondhali Mahesh Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9778",
    "name": "Bulunge Vasant Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19529",
    "name": "D D\"Souza Paul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19530",
    "name": "Kamble Shivram Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23076",
    "name": "Thakur Kishansingh Ashoksingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13456",
    "name": "Kadam Vithal Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19501",
    "name": "Anbhule Santosh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22644",
    "name": "Bagul Vijay Poojaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1192",
    "name": "Bhandari Mishrimal Bhurmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12815",
    "name": "Dsoza Jasmin Nicolas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12633",
    "name": "Gautam Sunita Hitu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19414",
    "name": "Kalap Nita Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7410",
    "name": "Kalbhore Suman Hindurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20733",
    "name": "Kamthe Sushil Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19503",
    "name": "Khan Munnibegam M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12922",
    "name": "Nimbalkar Anandrao Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21670",
    "name": "Patil Amrut Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4804",
    "name": "Sugarkar Rajkumar Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9253",
    "name": "Swamu Ramchandra Arjundas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4991",
    "name": "Shinde Ramdas Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4671",
    "name": "Parulekar Vishal Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21905",
    "name": "Ahire Sandesh Balkrashina"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10664",
    "name": "D Souza  Victor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19835",
    "name": "Gawade Eknath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13960",
    "name": "Jain Kalpesh Bhawarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11436",
    "name": "Kand Rajendra Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14240",
    "name": "Mane Rajendra Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7049",
    "name": "Sapkal Nivrutti Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15098",
    "name": "Sawant Sanjay Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14118",
    "name": "Jaurat Jayshree Jayram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11708",
    "name": "Singh Shashi Bachchan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4194",
    "name": "Jadhav Lata Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3153",
    "name": "Bhandari Ramchandra Hira ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2081",
    "name": "Shinde Bhagwan Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17105",
    "name": "Ghanwat Bhama Rohidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6208",
    "name": "Ravindra Ganpat Jadhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15358",
    "name": "Dhekane Sunil Sampat."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "831",
    "name": "Giri Bharat Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16330",
    "name": "Kapli Sunanda Bhagwanta."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7428",
    "name": "Pednekar Waman Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15566",
    "name": "Selar Suryakant Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7882",
    "name": "Barge Balwant Ganapat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1402",
    "name": "Bobade Gangaram Narsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15673",
    "name": "Thevare Mahendra Sadanand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5671",
    "name": "Katti Ravaso Anna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10332",
    "name": "Bahadur Vijay Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17402",
    "name": "Chawan Santosh Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17518",
    "name": "Chile Ashok Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12129",
    "name": "Futak Kashiram Pandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21125",
    "name": "Kevat  Jitendra Shreenath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23233",
    "name": "Mandhare Sharad Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18153",
    "name": "Nikam Vijay Mahadeo"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "145",
    "name": "Sawant Keshar Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15811",
    "name": "Wagh Satish Kacharu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7062",
    "name": "Satam Sunita Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18047",
    "name": "Mishra Shruti Chandraprakash."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15957",
    "name": "Bhalekar Babalya Dhandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7375",
    "name": "Choudhari Woraram Ladaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8102",
    "name": "Gurav Anita Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15425",
    "name": "Kadge  Santosh Skharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22424",
    "name": "Kusum"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21952",
    "name": "Sable Vijay Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12872",
    "name": "Yadav Sharda Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2002",
    "name": "Ethape Maruti Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5683",
    "name": "Salunkhe Hanmant Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6003",
    "name": "Engle Govind Umaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15722",
    "name": "Fernandes Gloria Siymon"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19177",
    "name": "Khan Salim Shan Mohd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19355",
    "name": "Mourya Sunil Kumar Loknath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "415",
    "name": "Pal Jogendra Dhanpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17469",
    "name": "Pandhare Suman Laxman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5735",
    "name": "Pandit Navalsingh J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "566",
    "name": "Rajendraprasad Ramlal Maurya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21673",
    "name": "Shinde Paresh Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19141",
    "name": "Thakur Dineshsingh Pyarelalsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14524",
    "name": "Dalvi Santosh Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21428",
    "name": "Parkar Sudeep Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7398",
    "name": "Kamble Tanubai Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3642",
    "name": "Patil Sangita Dinesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4242",
    "name": "Mehra Mohansing Hirasingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17842",
    "name": "Dalvi Sunil Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14296",
    "name": "Kadam Lata Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20588",
    "name": "Modak Shivaji Daji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21997",
    "name": "Raut Mahindra Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19398",
    "name": "Sayed Shameer Vazir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11611",
    "name": "Shinde Anita Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14245",
    "name": "Swami Ratna Ashirwad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18797",
    "name": "Gaikwad Datta Nagnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6579",
    "name": "Gavane Keshav Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12554",
    "name": "Pachpute Niwas Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12500",
    "name": "Malap Nirmala Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13709",
    "name": "Gadhave Mahendra Pandurange"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18798",
    "name": "Gaikawad Vijay Mukund"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16919",
    "name": "Jain Milapchand Nihalchand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19014",
    "name": "Kudre Ambubai Shripat"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "224",
    "name": "Shaikh Sayyad Choto"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15771",
    "name": "Shinde Gajanan Jagnnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11035",
    "name": "Jain Fulchand Chelrajji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2561",
    "name": "Spj Enterprise"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8517",
    "name": "Bhilare Suresh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1417",
    "name": "Star Packing Supplier."
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "17",
    "name": "Star Road Carriers"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "90",
    "name": "Sterling Translift"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "974",
    "name": "Suaka  Aguater"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5650",
    "name": "Nalwade Hanmant Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13470",
    "name": "Bhandari Kashibai Dwarkanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "652",
    "name": "Subhashchand Vinodkumar Jain"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22379",
    "name": "Jadhav Nitesh Gautam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11260",
    "name": "Jain Pushpa Hirachand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7727",
    "name": "Parab Krishna J."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20859",
    "name": "Saldulkar Vikas Yeshwant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10442",
    "name": "Shinde Shashikant Deoram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5303",
    "name": "Solkar Shantaram Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1100",
    "name": "Suchak Tours & Travels"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14326",
    "name": "Bhalekar Sitaram Vishram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13669",
    "name": "Bhoite Rajendra Yashawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13703",
    "name": "Dadas Bapu Bhanudas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1048",
    "name": "Gutka Miren Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17700",
    "name": "Katalkar Jaya Sunder."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17044",
    "name": "Patil Vilas Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7813",
    "name": "Shinde Prabhavati Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13016",
    "name": "Bhandari Shanti Vaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "465",
    "name": "Vishnu Jagannath Bhandari."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "693",
    "name": "Chandrakant Govind Shinde."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2934",
    "name": "Shinde Shrirang Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16736",
    "name": "Bajaj Pramod Tarachand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14080",
    "name": "Bhuvad Viju Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5981",
    "name": "Chauhan Lalan Kumar/Virendra Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6836",
    "name": "Gurav Tukaram Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16078",
    "name": "Jain Najubai Sakalchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1023",
    "name": "Sule Subhash Vasantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17476",
    "name": "Kadam Jaywant Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20077",
    "name": "Kambale  Ankita Pandit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14474",
    "name": "Lokparivartan Shakari Patpedhi Ltd."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16027",
    "name": "Pawar Hanmant Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17464",
    "name": "Pejle Deepak Shreepat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13717",
    "name": "Salvi Sadashiv Gopal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2075",
    "name": "Sumer Enterprises"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1942",
    "name": "Sunder Trading Co"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "663",
    "name": "Sunil Enterprises"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2731",
    "name": "Sunita Agency"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4463",
    "name": "Sunita Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1333",
    "name": "Super Packs"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1782",
    "name": "Superfine Wire Industries"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1228",
    "name": "Supreme Consultant & Services."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16108",
    "name": "Rane Harihar Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18192",
    "name": "Bhalerao Santosh Dasharath"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3720",
    "name": "Surana Budhmal Nemchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9609",
    "name": "Kothari Savita Savalraj"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "958",
    "name": "Suresh Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1027",
    "name": "Suresh Krishna Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14171",
    "name": "Gala Deepti Vasant."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22871",
    "name": "Singh Jay Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5672",
    "name": "Vaya Hansa Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16436",
    "name": "Wachkawade Laxmi Suryakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13364",
    "name": "Yadav Bijay Pratap"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "471",
    "name": "Suresh Tailors"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1156",
    "name": "Suresh Textiles Traders"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7690",
    "name": "Sawant Shankarrao Dhondobarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4587",
    "name": "Patkar  K.S."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5694",
    "name": "Shinde Vitthal Savala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1525",
    "name": "Rane Bhagoji Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16241",
    "name": "Bhagekar Nanda Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14229",
    "name": "Nikam Pranav Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16462",
    "name": "Rupesh Kondiram Gaikwad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19522",
    "name": "Varma Ramprakash Hiralal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1663",
    "name": "Kadulkar Suryakant Shridhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17274",
    "name": "Goale Kiran Shirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13754",
    "name": "Khan Kafiya Haziz"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21451",
    "name": "Khan Najama Fajalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22028",
    "name": "Nigudkar Praneeta Sunil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10858",
    "name": "Phalke Namdeo Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12342",
    "name": "Tekade Meena Machhindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21818",
    "name": "Thakur Ranjitkumar Shailesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15453",
    "name": "Yadav Magan Kisanrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2967",
    "name": "Jawrat Jayram Bal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2184",
    "name": "Kadam Dinkar Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11285",
    "name": "Mohite Vrishali Vikas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18904",
    "name": "Jadhav Dilip Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11209",
    "name": "Ghag Parvtibai Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8629",
    "name": "Gosavi Janardan Devgiri"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18728",
    "name": "Kopekar Parveenbanu Fayaz."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1751",
    "name": "Manore Jitendra Shalik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3505",
    "name": "Shelar Shantaram Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12621",
    "name": "Bhosale Atul Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7858",
    "name": "Bharma Daljitsingh Randhirsingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12132",
    "name": "Pamanani Subhash Thakurdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11022",
    "name": "Sankpal Manoj Gulab"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3894",
    "name": "Suryavanshi  Ramdas   Madhavrav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2904",
    "name": "Yadav Hanmant Rao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4358",
    "name": "Nadavdekar Baburao Atmaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8158",
    "name": "Dube Ajay Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20141",
    "name": "Jadhav Mangesh T."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12456",
    "name": "Kakade Rajendrakumar Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11158",
    "name": "More Ashok Sripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17881",
    "name": "Ghag Yogini Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4030",
    "name": "Yadav Jagannath Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1128",
    "name": "Mandre Shankar Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15695",
    "name": "Mane Vijay Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16880",
    "name": "Martin Stephen Moses"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "169",
    "name": "Nishad Rampravesh Bechan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11773",
    "name": "Salunkhe Satish Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8194",
    "name": "Bhosale Sudam Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13108",
    "name": "Gole Meena Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21294",
    "name": "Lotankar Snehal Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "271",
    "name": "Nalawade Uttam Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8962",
    "name": "Zodage Khandu Mahadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6014",
    "name": "More Balu Ganu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7998",
    "name": "Veer Hirabai Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11487",
    "name": "Jain Mukesh Kumar Babulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12522",
    "name": "Mule Mandar Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17074",
    "name": "Babar Shalaindra Ramchandra / Vaishali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11468",
    "name": "Jagtap Anandrao Sarjarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14964",
    "name": "More Manoj Tatyaba."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14991",
    "name": "Sawant Prasad Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14817",
    "name": "Jadhav Kalpana Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4453",
    "name": "Pisal Sampat Parbati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9767",
    "name": "Patil Sahibai Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17404",
    "name": "Bhuvad Prakash Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13153",
    "name": "Gite Padmanath Sukhdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13309",
    "name": "Jadhav Shankar Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18467",
    "name": "Kawale Ramesh T."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19418",
    "name": "Sawant Jayesh Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14479",
    "name": "Sawant Vaibhavi Vidyadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4237",
    "name": "Ratan  Singh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5593",
    "name": "Jadhav Sanjay Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16778",
    "name": "Bhandari Geeta Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21780",
    "name": "Bhandary Vasant Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5605",
    "name": "Gorivale Pramod Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19296",
    "name": "Kharade Mahesh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15435",
    "name": "Salate Sarjerao Maruti 871/28"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4347",
    "name": "Suyog Enterprise"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18421",
    "name": "Chandarana Manoj D"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "16",
    "name": "Jadhav Rajendra Kondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14043",
    "name": "Shetawe Kundan Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18028",
    "name": "Tamboli  Puja  Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17633",
    "name": "Yadav Ramsurat Atwariprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2523",
    "name": "Swastik Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "11",
    "name": "Swastik Tyres"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "186",
    "name": "Swayam Printers"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1339",
    "name": "Swyam Sanganak Prashikshan Kendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "593",
    "name": "Phanse Vishwas Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14079",
    "name": "Wayangankar Suryakant M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12956",
    "name": "Yewale Avinash Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3623",
    "name": "T. R. Trading Agency"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11463",
    "name": "Jadhav Kisan Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1766",
    "name": "Tagala Packing Center"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "707",
    "name": "Jankar Maruti Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17728",
    "name": "Kokate Yogesh Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16573",
    "name": "Thorat Sandip Pandurang."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13930",
    "name": "Bilgekar Sunil Sheshnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21004",
    "name": "Chavan Yogesh Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20298",
    "name": "Mansuri Ehmad R."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13926",
    "name": "Patil Kisan Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4120",
    "name": "Rane Balkrishna Damodar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7779",
    "name": "Dhawade Praful Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8655",
    "name": "Padwal Mayur Anand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11745",
    "name": "Waychale Shankar Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15849",
    "name": "Chavan Sunil Sampatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17873",
    "name": "Kadam Vaibhav Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6931",
    "name": "Thomas Lakshan ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16619",
    "name": "Vaity Jeena Jaon"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23917",
    "name": "Hajare Abhilasha Jwalasing"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1466",
    "name": "Behera Srikant Sanatan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5783",
    "name": "Chavan Dattatray N/Dnyadeo/Rajendra/Utta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13405",
    "name": "Jadhav Sunil Kundalik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13748",
    "name": "Mishra  Omnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17822",
    "name": "Pakhare Pravin Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20099",
    "name": "Parkar Suvidhya Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18305",
    "name": "Pawar Shashikala Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13408",
    "name": "Pandye Dharmendra V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11659",
    "name": "Waychal Sambhaji Natha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23182",
    "name": "Khatate Amol Ekanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21369",
    "name": "Kotwani Haresh Bishandas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16297",
    "name": "Sheeteyar Tangvel Sundaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "400",
    "name": "Gaikar Prabhu Kondaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10783",
    "name": "Bhiravandekar Govind Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4669",
    "name": "Ghag Pradip Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3579",
    "name": "Kurmi Ramdular Matapalat."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8154",
    "name": "Bhagat Kisan Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17477",
    "name": "Acharekar Gautami Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16765",
    "name": "Asalkar Sambhaji Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21397",
    "name": "Bonvate Nishant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4815",
    "name": "Dhodia Ganesh R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15452",
    "name": "Gaud Rampalat Jiyalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15779",
    "name": "Jagtap Shobha Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18241",
    "name": "Jambhale Kashinath Mahadeo.Minaxi K."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19413",
    "name": "Kadem Rajendra Shanker"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18444",
    "name": "Kumbhar Abhay Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12576",
    "name": "Pawar Jitendra Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11108",
    "name": "Gawade Surendra Rawaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6539",
    "name": "Bhagwat Jaysing Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4619",
    "name": "Lohar Digambar Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9359",
    "name": "Ashif Ali Sharafat Husain"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19590",
    "name": "Bhati Kapoorchand Thanaramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11720",
    "name": "Ghoderao Sampat Ranuji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15849",
    "name": "Harisingh Ganesh Dayal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2976",
    "name": "Warlekar Kishor Jagnnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "779",
    "name": "Hegde  M.R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2249",
    "name": "Shetty Bhaskar D."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5751",
    "name": "Mane Yashwant Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1154",
    "name": "Progressive Bldg No 3 Committee"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4922",
    "name": "Ghanekar Madhav Ganesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11965",
    "name": "Sakpal Jaysing Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16075",
    "name": "Badal Sangeeta Ramchandra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "146",
    "name": "Bangar Babu Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7976",
    "name": "Bongane Ankush Bhagawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15524",
    "name": "Gowda Venkatesh Sannappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21272",
    "name": "Jadhav  Suresh  Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12147",
    "name": "Mane Changuna Nivruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13567",
    "name": "Bal-Gopal Datta Jayanti Utsav Mandal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6315",
    "name": "Kulkarni Ravindra Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13088",
    "name": "Hemani Dinesh Vrajlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18326",
    "name": "Bandebe Santosh Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10335",
    "name": "Barge Dasharath Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18367",
    "name": "Gandhi Sagar Haresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10091",
    "name": "More Shrikant Sadanand/Mangal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12530",
    "name": "Rampalat Hanman Saroj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11779",
    "name": "Shingate Shrirang Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18343",
    "name": "Tavade Santosh Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20276",
    "name": "Yadav Shivkumar K."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14703",
    "name": "Rananavare Vilas Popatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4634",
    "name": "Phalke Mangal Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11649",
    "name": "Kadam Rahul Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5550",
    "name": "Ballal Pradip Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18114",
    "name": "Dhas Prakash Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18063",
    "name": "Warik Pradip Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14495",
    "name": "Chavan Sunil Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "680",
    "name": "Tanu Art Printers"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16035",
    "name": "Birade Kamalesh Bhavlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17426",
    "name": "Bramhe Manoj Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22654",
    "name": "Ghosalkar Shashikant Parsuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17368",
    "name": "Kadam Manisha Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19709",
    "name": "Nihvekar Pranali Pravin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15395",
    "name": "Shinde Ravindra Shriram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16952",
    "name": "Bhide Ashok Jayram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21066",
    "name": "Sawant Narayan Rajaram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13038",
    "name": "Phadtare Uday Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21467",
    "name": "D Souza Stella Ligori"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17170",
    "name": "Gupta Ziguri Motilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14901",
    "name": "Karondikar Ashish Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17889",
    "name": "Mahadik Tukaram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18239",
    "name": "Sheth Maitri Navin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18960",
    "name": "Shigvan Mahadev Devaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15846",
    "name": "Tiwari Sheshmani Fulchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3863",
    "name": "Bhosale Vilas Dashrath."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19674",
    "name": "Jain  Pankajkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3380",
    "name": "Garade Bhanudas Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17085",
    "name": "Patil Maruti Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6095",
    "name": "Devale Mohan Datta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5658",
    "name": "Rane Madhuri Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "193",
    "name": "Chatura Adinath Londhe."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6528",
    "name": "Bhalekar Kavita Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18588",
    "name": "Dubey Dhruvnarayan S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12672",
    "name": "Gupta Arjunkumar Chandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16590",
    "name": "Kalugade Yuvraj Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20316",
    "name": "Makar Avinash Tanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9894",
    "name": "Nikam Rajendra Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17326",
    "name": "Padwal Mahesh Sahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13524",
    "name": "Pawar Anand Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20311",
    "name": "Pawar Rakesh L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18126",
    "name": "Rane Rajan Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18142",
    "name": "Rashtriya Bahuddeshiya Samaj Seva Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18284",
    "name": "Solanki Jayanti Damajee ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20044",
    "name": "Suthar Kamlesh Pratapji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4266",
    "name": "Salvi Sashikant Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1296",
    "name": "Salvi Shridhar Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3324",
    "name": "Bhosale Madhukar Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9966",
    "name": "Jonwal Laxman Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14299",
    "name": "Kachare Ramesh Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21194",
    "name": "Kolekar Ranjana Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12216",
    "name": "Rafik Saira Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17584",
    "name": "Solanki Hardik Bhupendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8534",
    "name": "More Maruti Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4568",
    "name": "Patel Chandrika N"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6286",
    "name": "Kambale Banubai Gunyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1567",
    "name": "Dalvi Pandurang Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6691",
    "name": "Dubey Sidhyanath Badriprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12958",
    "name": "Jadhav Malti Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16684",
    "name": "Kshirsagar Laxman Suryakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11906",
    "name": "Goriwale Vasant Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4576",
    "name": "Mane Vyankat Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11350",
    "name": "Bambarkar Prakash/Ramchandra Kule/Ravind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19530",
    "name": "Baragode Sonu Rawji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17915",
    "name": "Bhosale Pradeep Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17917",
    "name": "Bhosale Shaila Vishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11580",
    "name": "Dave Arun Ratilal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "77",
    "name": "Kadam Swapnil Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20759",
    "name": "Mistry Bharat Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17984",
    "name": "Singh Devinder Joga"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18028",
    "name": "Singh Rajkumar Jaymangal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20124",
    "name": "Veer Rajendra Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13344",
    "name": "Ajgonkar Sunil Mangesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20556",
    "name": "Pawar Vikas Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18861",
    "name": "Gaikwad Shashikant Ramaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12130",
    "name": "Hatkar Mohan Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20688",
    "name": "Lembhe Shankar Bapu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14973",
    "name": "Malankar Nandkishor Pandharinath/Malandk"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11113",
    "name": "Palshetkar Kiran Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16720",
    "name": "Wagh Santosh Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9202",
    "name": "Bhoj Laxmi Mavji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14187",
    "name": "Katekar Ishwar Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2200",
    "name": "Deudkar Sadashiv Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13491",
    "name": "Rajput Shaitan Singh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1189",
    "name": "Kandare Yashawant B. 145/4"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8265",
    "name": "Ahmed Jahir Ahmed Makbool"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15396",
    "name": "Gehlot Mishrilal Himtaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15901",
    "name": "Patil Vishwas Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21999",
    "name": "Sode Vinod Sannu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14830",
    "name": "Surve Sachin Shaligram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2264",
    "name": "Pawar Minal Kamalkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12662",
    "name": "Jadhav Shivaji Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8667",
    "name": "Pardeshi Jitendra Ratansinh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16289",
    "name": "Katkar Gopal Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16098",
    "name": "Salve Yashwant Pandit"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8454",
    "name": "Gandhi Shital Vijaykumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14701",
    "name": "Malusare Ramchandra Bali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5447",
    "name": "Jadhav Chandrakant Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4107",
    "name": "Dalvi Annapurna Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17729",
    "name": "Bhadrge Gulab Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10970",
    "name": "Chougule Pravin Jivandhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16531",
    "name": "Hinge Santosh Vithalrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10925",
    "name": "Naik Rajani Nitin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22099",
    "name": "Nath  Aruna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12857",
    "name": "Sheth Harshaben Narendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11370",
    "name": "Vichare Kiran Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18119",
    "name": "Singh Jayshankar Mithaiwala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9423",
    "name": "Jaiswar Kailashnath Shrinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8545",
    "name": "Kulkarni Shriram Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7061",
    "name": "Mahadik Rajendra Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1882",
    "name": "Shaikh Muzaffar Hussain."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17756",
    "name": "Chavan Shrikant Anat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13473",
    "name": "Duby Chandramohan Shriramlakhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21804",
    "name": "Tarade Dattatray Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6186",
    "name": "Avghade Gulab Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9028",
    "name": "Jadhav Kamal Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13034",
    "name": "Phathan Mohabbatali Kasimkhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4440",
    "name": "Arote Manohar Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18105",
    "name": "Gaud Sanai Shrikisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11074",
    "name": "Khan Baraktulla Mohamed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15422",
    "name": "Kondvilkar Beena Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13571",
    "name": "Lingayat Purnima Krishna./Krishna Pandur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10812",
    "name": "Salunkhe Navnath Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7055",
    "name": "Sharma Shitalaprasad Ramlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17769",
    "name": "Sing Lalachand Sethbahaddur."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20127",
    "name": "Singh Abhishek Kumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16013",
    "name": "Surve Paresh Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3536",
    "name": "Jangid Lunaram Birbaldas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7511",
    "name": "Vora Manjubai Devji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9469",
    "name": "Kule Rajashree Balaram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11179",
    "name": "Nimbalkar Dilip Dharyu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6778",
    "name": "Nimbalkar Vijaya Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4408",
    "name": "Bhosale Hambirrao Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9788",
    "name": "Sutar Gajanan Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7735",
    "name": "Bhilare Govind Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11594",
    "name": "Kahar Rohan Radharaman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13154",
    "name": "Dalvi Ujwala Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12482",
    "name": "Jadhav Mahadev Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12501",
    "name": "Jain Lalitkumar Bhairulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1978",
    "name": "Gaikar Prabhu Kondaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "398",
    "name": "Upadhyay  Kailashchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4481",
    "name": "Gaikawad Sambhaji Damrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10732",
    "name": "Vitkar Suresh A/Sulochana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2616",
    "name": "Disoza Nicolas Mates ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12074",
    "name": "Dinde Ramdas Sonu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15304",
    "name": "Ghadge Sadanad Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16139",
    "name": "Jadhav Manjula Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "319",
    "name": "Kamble Vinod Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11801",
    "name": "Nalawade Sharad Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12021",
    "name": "Neeta Valji Nandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9879",
    "name": "Thaker Vinay Baldeodas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1884",
    "name": "Janata Seva Society."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1792",
    "name": "Karwade Sakharam Balu."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6298",
    "name": "Jain Hastimal Bagaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13369",
    "name": "Katkar Popat Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17847",
    "name": "Chasker Kisan Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11906",
    "name": "Chavan Yashwant Bajrang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16360",
    "name": "Jogatar Navinchandra B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7417",
    "name": "Kakade Mangalabai Himmat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22085",
    "name": "Nigudkar Roshani Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14475",
    "name": "Rajbahadur Satyavati Rajendra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18851",
    "name": "Rajbhar Vinod Prahlad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20163",
    "name": "Shah Himbahadur Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1313",
    "name": "Devan Bharati Vasu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10178",
    "name": "Shinde Rajaram Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4607",
    "name": "Yadav Balkrishna Bhikoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19785",
    "name": "Farnandes Maryan Salu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15477",
    "name": "Khedekar Manorama Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19567",
    "name": "Kurade Babasaheb Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17452",
    "name": "Lembhe Popat Dhondiram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17725",
    "name": "Sawant Waman Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18656",
    "name": "Yadav Tilakraj Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3150",
    "name": "Sutar Dinkar Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10329",
    "name": "Yadav Bhagwan Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20061",
    "name": "Bhandari Sunil K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17980",
    "name": "Bhaud Handrakant Balaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16332",
    "name": "Dhumal Pandharinath Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21991",
    "name": "Mane Bhivaji Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18307",
    "name": "Pawar Sachin Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17979",
    "name": "Sawant Sandip Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13679",
    "name": "Shinde Ganesh Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18592",
    "name": "Shinde Shantaram Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7321",
    "name": "Kabli Amol Rajan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16563",
    "name": "Gujar Mulchand Banvarilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15131",
    "name": "Jitesh Rajanikant Shah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12920",
    "name": "Pradeep Pandarinath Wagh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5535",
    "name": "Tetme Bhiva Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2521",
    "name": "Safi Isharatali Ali Mohd."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5904",
    "name": "Kunbhar Jotibha Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12704",
    "name": "Surve Malati Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4191",
    "name": "Shinde Renuka R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6251",
    "name": "Whade Dhondiram Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9748",
    "name": "Bhosale Subhadra Shankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1053",
    "name": "Kukana Rameshwarlal Jashram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16716",
    "name": "Lahane Ujwala Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16419",
    "name": "Satvilkar Pragati Pramod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22323",
    "name": "Sawant Rahul Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18899",
    "name": "Sawant Seema Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22094",
    "name": "Thakkar Suresh Babulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13010",
    "name": "Vani Santosh Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3129",
    "name": "Shelar Mandakini Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17819",
    "name": "Devare Manga Phadku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8793",
    "name": "Shinde Uttam Rangarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20125",
    "name": "Doltani Sanjay Kanyalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17285",
    "name": "Mhatre Sandhya Sanjay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19426",
    "name": "Rathod Ramesh Danaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12799",
    "name": "Sheth Maya Mukesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11957",
    "name": "Thakur Mohan Nanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9716",
    "name": "Wagh Prakash Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19397",
    "name": "Patil Anil Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13901",
    "name": "Pisal Kiran Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14744",
    "name": "Purohit Mukesh Ratan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8705",
    "name": "Kadam Bapurav Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17276",
    "name": "Desai Bharat Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12367",
    "name": "Jain Dinesh B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8884",
    "name": "Surve Shashikant Bhagwat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18189",
    "name": "Dhammi Dinesh Ramsingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15186",
    "name": "Jain Jaichand Panechand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19055",
    "name": "Malawade Mohini Santosh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19054",
    "name": "Malawade Uday Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13258",
    "name": "Mulik Sunita Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13705",
    "name": "Panhale Vijay Dadu."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "243",
    "name": "Patil Sagar Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9318",
    "name": "Rawat Dhanadevi Shersing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18294",
    "name": "Shiakh Lalmoti Bibi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15978",
    "name": "Shirke Anil Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12691",
    "name": "Suthar Satishkumar Nandlalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19414",
    "name": "Tiwari Satyanarayan Ramprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17825",
    "name": "Nivdunge Vitthal Anna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17996",
    "name": "Sachdev Mona Madan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13118",
    "name": "Yadav Manik Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9070",
    "name": "Memane Dashrath M/Dnyandeo P Jadhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17231",
    "name": "Chowdhary Bhimaram Pemaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14005",
    "name": "Kerkar Megha Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9019",
    "name": "Chavan Shamrao Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8341",
    "name": "Marathe Ganesh D/Jayendra G/Arjun J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3382",
    "name": "Xavier K Kitechan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20136",
    "name": "Chache Sadanand Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17355",
    "name": "Bendre Prakash Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13331",
    "name": "Bhabal Dattaguru Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12082",
    "name": "Chouhan Hariprasad Ramkaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22139",
    "name": "Nigudakar Vinod Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17323",
    "name": "Patil Harshali Haresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20180",
    "name": "Pawar Shivaji Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6494",
    "name": "Shah Neenad Ratnakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16362",
    "name": "Yadav Vikas Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10831",
    "name": "Jadhav Sunita Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7954",
    "name": "Nikam Shanta Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2768",
    "name": "Talekar Jeevaji Shambaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21103",
    "name": "Anthony  Rodrigues"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17698",
    "name": "Jaiswal Meena Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12455",
    "name": "Kate Manorama Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13966",
    "name": "Rajan Sarona N."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4740",
    "name": "Soni Jyotsna Arvind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10664",
    "name": "Shirsat Manisha Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11517",
    "name": "Jaiswar Ramesh Baljor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22003",
    "name": "Bansode Komal Pradeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20125",
    "name": "Bhosale Pradeep Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9255",
    "name": "Choudhari Kapoorram S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15800",
    "name": "Ghotkar Ashok Umaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12394",
    "name": "Joshi Madhurika Rashiklal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10999",
    "name": "Khan Munna Abdulrehman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18758",
    "name": "Mahajan Sanjay Sashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14473",
    "name": "Nimbre Shankar Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18008",
    "name": "Sutar Vinod Shanttapa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11120",
    "name": "Swamy Jackey John"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2903",
    "name": "Mohamd Kitabunnisha Hasan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6314",
    "name": "Yadav Hirabhai Mugatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7260",
    "name": "Khatu Vinaya Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21669",
    "name": "Salunkhe Abhijit Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16780",
    "name": "Surve Mahendra Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4186",
    "name": "More Pravin Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5811",
    "name": "Gadhave Rajendra Babanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2503",
    "name": "Ujale Yashwant Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16220",
    "name": "Gurav Nandan Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6447",
    "name": "Shah Manju S"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8835",
    "name": "Phalke Pratap Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11047",
    "name": "Bhosale Kamlakar Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11793",
    "name": "Inamdar Salauddin Raheman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15653",
    "name": "Lembhe Sangeeta Ganesh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15180",
    "name": "Mahadeshwar Narayan Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9607",
    "name": "Sonawale Lahu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13912",
    "name": "Salunkhe Tanaji Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1622",
    "name": "Ansari Sadullah Akbarali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2553",
    "name": "Paryani Anju L ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7277",
    "name": "Salunkhe Suryakant Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19850",
    "name": "Dandavate Suresh Gundu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5309",
    "name": "Gawade Janardan Appa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12050",
    "name": "Kadam Shamrao Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22484",
    "name": "Magadum Sunil Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11332",
    "name": "Mane Vimal Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13436",
    "name": "Pathak Gouri V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7890",
    "name": "Saroj Kamlesh Ramprsad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9528",
    "name": "Dube Jayantiprasad L."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20957",
    "name": "Jadhav Vaishali Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12769",
    "name": "Mistry Vasanti Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16654",
    "name": "Purohit Savita Ashoksingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16126",
    "name": "Ahmmedali Kalasan Kaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13973",
    "name": "Gupta Lalchand Mevalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6529",
    "name": "Mane Ravindra N/Mr R.A.Mahamulkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18298",
    "name": "Niwate Trupati Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21521",
    "name": "Pandya Kishor Dhansukhlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16964",
    "name": "Verma Avtarsingh Musiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2781",
    "name": "Phitar M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19552",
    "name": "Kadam Suresh Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18401",
    "name": "Mane Kamal Arun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5892",
    "name": "Sawant Vijaya Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14902",
    "name": "Desai Krishna Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18206",
    "name": "Dhanawade Sachin Nathuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11494",
    "name": "Gaikawad Sunil Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9541",
    "name": "Lakhan Tanaji Awaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21725",
    "name": "Pawar Shweta Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11042",
    "name": "Sayyed Karamat Jameer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22999",
    "name": "Shaikh Mohd Ahtesham"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "233",
    "name": "Shedge Nitin Patangrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1366",
    "name": "Hariya Minish Somchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20232",
    "name": "Hule Savitra Ganpat/ Hule M.G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19451",
    "name": "Khan Bismillah Habibi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12052",
    "name": "Phalke Megha Sandeep"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6413",
    "name": "Gawade Mandakini Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2410",
    "name": "Jadhav Madhukar Chandru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15656",
    "name": "Jaiswal Maya Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17724",
    "name": "Pawar Sachin Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16831",
    "name": "Saroj Shivprasad Dwarikaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10201",
    "name": "Sawant Shobha Uttam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15620",
    "name": "Subhash Vrajalal Soni"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "924",
    "name": "Nair K.Unnikrishnan Narayan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1678",
    "name": "Kava Vijay Kumar R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1920",
    "name": "Wazha Remend Jon"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1243",
    "name": "Trimurti Art."
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2346",
    "name": "Trimurti Packing House"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1043",
    "name": "Trimurti Textile Packing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "560",
    "name": "Gujar Govindrao Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2871",
    "name": "Kotian Hirabai Vasu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9587",
    "name": "Pawar Laxman Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7460",
    "name": "Gadhave Anuradha Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14116",
    "name": "Dangra Radhadevi Badrinarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17975",
    "name": "Ghanekar Anushka Makarand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16804",
    "name": "Kamble Manahar Rawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17338",
    "name": "Kori Rajendra Bahadur Dayaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18265",
    "name": "Mithbavkar Vandana Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12857",
    "name": "Rimal Maniram Padamram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18355",
    "name": "Sawant Sharda Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15036",
    "name": "Shukla Arjun Himanshu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13154",
    "name": "Manjrekar Tukaram Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16040",
    "name": "Bobade Manohar Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13232",
    "name": "Nikam Suresh Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13883",
    "name": "Shetty Lavaka Chanddayya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21667",
    "name": "Jain Bhagyawati Mukesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10782",
    "name": "Bhoite Chhaya Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3667",
    "name": "True Tech"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6154",
    "name": "Sonawale Laxman Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7043",
    "name": "Pawar Bapu Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15683",
    "name": "Bhilare Shubhagi Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12803",
    "name": "Mayekar Ulhas Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14372",
    "name": "Patel Ashaben Shankarbhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21491",
    "name": "Pawar Deepak Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13792",
    "name": "Pawar Jyotiram Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16404",
    "name": "Sawant Maruti Shankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "415",
    "name": "Sawant Sweta Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16748",
    "name": "Shaikh Mohmad Miraj Ebrahim"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10648",
    "name": "Sawant Dadasaheb Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8900",
    "name": "Waghela Balwansingh Lalubha"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2695",
    "name": "Tushar Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1099",
    "name": "Suresh Shankar Rokade."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1605",
    "name": "U B Ngineering"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9166",
    "name": "Kadam Jyoti Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7405",
    "name": "Sutar Shakuntala Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19344",
    "name": "Bhosale Ravindra Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21064",
    "name": "Kadam Sangita Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14578",
    "name": "Sanghavi Umesh Daulatrai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12600",
    "name": "Pisal Himmat Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16595",
    "name": "Khan Bechu Indu."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21696",
    "name": "Ogamiya Lilabai Keshev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2019",
    "name": "Farade Bhagoji Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "493",
    "name": "Ujwal Creations"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16836",
    "name": "Kadam Trushna Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5745",
    "name": "Bhandari Suresh Mangal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13845",
    "name": "Burate Tukaram Vithal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13672",
    "name": "Jadhav Rukmini Ulhas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21256",
    "name": "Makwana Shweta Kalpesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14150",
    "name": "Salave Jagadeo Daulat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9283",
    "name": "Tapase Seema Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9158",
    "name": "Khadye Rajaram Moreshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3188",
    "name": "Parab Vijay Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20565",
    "name": "Gavas Satyawan Sitaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22630",
    "name": "Pawar Prakash Munji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "579",
    "name": "Lochhamandas T. Sapra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11979",
    "name": "Gill Ramadevi Gurbakhsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5642",
    "name": "Adhak Ganesh Kagar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15046",
    "name": "Advilkar Narayan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16269",
    "name": "Lembhe Krishnat Ganpat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1698",
    "name": "Singh Pradnya Ramsari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16005",
    "name": "Tawade Pushpalata Nandkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2839",
    "name": "Banaye Babaji Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11555",
    "name": "Bodhak Suresh Sundar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13555",
    "name": "Jain Rajendra Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9696",
    "name": "Badigar Veeresh L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "512",
    "name": "K R Balasubramnyam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13006",
    "name": "Patil Anand Malgoudar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14325",
    "name": "Vitthale Haresh Janu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11359",
    "name": "Avlaygavnkar Avinash Satayvan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7301",
    "name": "Jain Jawerchand Dalichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3647",
    "name": "Jadhav Lata Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12797",
    "name": "Chaugule Ramesh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20337",
    "name": "Gurav Vinod Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16617",
    "name": "Kamat Shalini Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15369",
    "name": "Khandelwal Pradeep Parmanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18762",
    "name": "Mahadik Sanjog Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15583",
    "name": "Walhekar Savitri Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16062",
    "name": "Yelamkar Yogesh Yashotta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "687",
    "name": "Shah Sarlaben Arunkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17029",
    "name": "Pawar Madhavi Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1744",
    "name": "Usman Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5387",
    "name": "Chhangur  Ram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1119",
    "name": "Helghar Kiran Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11319",
    "name": "Kadam Lahu Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12086",
    "name": "Vaity Rocky Mingel"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14555",
    "name": "George  Tressa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4230",
    "name": "Rajeshirke Bharat Raosaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15158",
    "name": "Dubay Sanjay Rajpati"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1129",
    "name": "V K Traders"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20559",
    "name": "Ghare Somesh Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2042",
    "name": "V.J.Laxmi Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8235",
    "name": "Soni Anand Dhirendra."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "939",
    "name": "Bhosale Rakmabai Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5919",
    "name": "Kadam Praklash Wamanrao"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "167",
    "name": "Vagdev Metals"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8250",
    "name": "Pawar Kundlik Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5260",
    "name": "Bendkhele Girish Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21735",
    "name": "Dhire Laxmi Sambhaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16583",
    "name": "Gupta  Madhurik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12935",
    "name": "Shaikh Nafis Ahamad Basir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19193",
    "name": "Thapa Vishunukumari Haribahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12842",
    "name": "Yadav Sabharaj Ramashrey"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1829",
    "name": "Vaibhavtextiles (Packing)"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3966",
    "name": "Yadav Shamdhani Shivmurat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3134",
    "name": "Rajia  Khoturi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19767",
    "name": "Indalkar Kanchan Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2991",
    "name": "Barge Janabai Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5794",
    "name": "Thorbole Vijayendra Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16525",
    "name": "Bhandare Haridas Chaturbhuj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18482",
    "name": "Gaud Dinesh Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19110",
    "name": "Kadam Baban Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21277",
    "name": "Mohamad Mustafa Mohd. Isrial"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21914",
    "name": "Shinde Ashok Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10234",
    "name": "Vaity Sushila Sapraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18204",
    "name": "Joshi Parvatidevi Shankarlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12886",
    "name": "Chavan Jotiram Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18518",
    "name": "Kolekar Aarti Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5120",
    "name": "Shah Chandanben Chandulal/Vidhubhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "952",
    "name": "Vaishnavi Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14947",
    "name": "Shinde Mahandra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1109",
    "name": "Sabale Mansingrao Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13686",
    "name": "Pitale Shantaram G"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3807",
    "name": "Jadhav Pushpalata Rajaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3837",
    "name": "Goke Hanumant Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7448",
    "name": "Rege Pushkaraj Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16499",
    "name": "Deshmukh Vijay Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13092",
    "name": "Gandhotra Anil Ramnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14835",
    "name": "Gundage Anand Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21853",
    "name": "Kadam Prafful Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16537",
    "name": "Loke Prakash Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22774",
    "name": "Manjarekar Santosh Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17071",
    "name": "Teli Ganpat G"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20194",
    "name": "Yadav Shyamnarayan Ramraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3703",
    "name": "Salve Asharam Davta."
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1380",
    "name": "Dhawade Ashok Khandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17794",
    "name": "Sapate Santosh Raman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18512",
    "name": "Maninair Plakat Chinnamma"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20946",
    "name": "Pawar  Sandip   Sanjivan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10794",
    "name": "Thorare Shweta Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22800",
    "name": "More Anant Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18004",
    "name": "Arekar Sanjiv Gopinath."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11385",
    "name": "Nikam Dattatray Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18267",
    "name": "Shinde Nilesh Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8537",
    "name": "Gupta Mehilal Ramsamuz"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18598",
    "name": "Parimaldas  Chandandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5620",
    "name": "Laddha Pradip N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15128",
    "name": "Shinde Snehal Sudhakar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19384",
    "name": "Dubey Girish Phoolchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13672",
    "name": "Kotian Geeta Krishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12395",
    "name": "Bhabal Vinod Rohidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10609",
    "name": "Dhamal Pramod Balkrishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "959",
    "name": "Gori Mohd Harun Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10781",
    "name": "Nanaware Sarika Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18057",
    "name": "Nishad Indrapal Nabburam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5426",
    "name": "Sadaphule Janabai Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14456",
    "name": "Shrihari Damodar Waghmare"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14814",
    "name": "Jadhav Ravindra Charan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5746",
    "name": "Rawat Rajnikant D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15828",
    "name": "Chavan Ramchandra Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9897",
    "name": "Dumalay Ajay Praladha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9004",
    "name": "Gaonkar Samita Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16529",
    "name": "Shivkumar Ramkrishna Gupta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14942",
    "name": "Chowdhary Salahuddin Liyakat Hasain /Ala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11738",
    "name": "Deshmukh Sharda Jalindar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7294",
    "name": "Kadam Nandkumar Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12411",
    "name": "Acharekar Manisha Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11710",
    "name": "Bhosale Atmaram Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1342",
    "name": "Vardhaman Traders"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2153",
    "name": "Vardhman Trading Co."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8605",
    "name": "Gabhane Ashok Istari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14966",
    "name": "Gowda Kirti Sannu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14243",
    "name": "Jain Prakashchand Gyanchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22458",
    "name": "Khilare Sanjay Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6862",
    "name": "Sharma Ambika Chanddrabali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12103",
    "name": "Singh Shamsher Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9335",
    "name": "Vadke Prabhavati Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1230",
    "name": "Sabale Govind Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1203",
    "name": "Chalke Ishwar Pandurang."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4989",
    "name": "Tonde Lata Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17072",
    "name": "Gaikwad Savitri Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15361",
    "name": "Phalke Sanjay Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8998",
    "name": "Jain Deviben Hirachand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9199",
    "name": "Acharekar Atmanand Vasudev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13944",
    "name": "Chorage Sampat Ganpat 405/13"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13269",
    "name": "Gundage Laxman Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "661",
    "name": "Gaikwad Vinayak Narsing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1168",
    "name": "Shinde Gorakhnath Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2462",
    "name": "Sharma Chandeshwar N."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16810",
    "name": "Palav Bhagvan Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5754",
    "name": "Shinde Dattatray Babanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15019",
    "name": "Borade Bhau Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18253",
    "name": "Chinyankandath Rinky D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21120",
    "name": "Karande  Dilip Shivaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8645",
    "name": "Lembhe Popat Dhondiram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14841",
    "name": "Mandhare Manisha Popat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17590",
    "name": "Sargar Namdeo Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1429",
    "name": "Shetty Shivaji Ganpat."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14914",
    "name": "Kadam Nandkumar Mansingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10942",
    "name": "Gurav Suresh Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22761",
    "name": "Kamble Dilip Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20431",
    "name": "Naik Uday Shekhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19792",
    "name": "Soni Sajan Ayodhyaprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18856",
    "name": "Hotelwala Shirin Ebrahim (Rass"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14907",
    "name": "Kansara Alpesh R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13611",
    "name": "Patil Dilip Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21008",
    "name": "Vardam Prathamesh Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9342",
    "name": "Salunkhe Sunil Mansing"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1379",
    "name": "Gotad Sadhana Vikas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12908",
    "name": "Haldankar Vijaylaxmi Gurunath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7750",
    "name": "Nikam Suresh Shamrao."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17493",
    "name": "Matre Sandeep Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15184",
    "name": "Phanse Mangal Pratap"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16119",
    "name": "Mane Suresh Jothiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15454",
    "name": "Pawar Raghunath Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17273",
    "name": "Ghadigaonkar Divya Deepak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3278",
    "name": "Dhamal Suresh Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8515",
    "name": "Awale Sadashiv Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16159",
    "name": "Badrujamah  Md.Aminkhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14059",
    "name": "Patel Samarbahadur Ramjatan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18251",
    "name": "Raibole Savita Devidas"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1883",
    "name": "Vastukala Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1565",
    "name": "Yogi Bhavin Kishorkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11046",
    "name": "Jamdade Pralhad Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7166",
    "name": "Bhoite Sugriv Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13452",
    "name": "Bobade Namdeo Raosaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17489",
    "name": "Gaikwad Ramesh Tatyaba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7093",
    "name": "Jadhav Vaishali Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3784",
    "name": "Naik Shriram Soma."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18049",
    "name": "Pujare Purushotam Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11542",
    "name": "Giri Sanjay Kailash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19050",
    "name": "Manjarekar Manohar Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16438",
    "name": "Mishra Manojkumar Ramnayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10779",
    "name": "Shinde Parshuram Balurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18140",
    "name": "Shinde Rahul Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17270",
    "name": "Surve Vandana Kishore"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11483",
    "name": "Chavan Mahadeo Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8945",
    "name": "Lakhe Rajesh Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17684",
    "name": "Vichare Swapnil Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16151",
    "name": "Bhosle Ankush Sudam  Toli No.54/10"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12407",
    "name": "Rajbanshi Hiralal Ratiya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5708",
    "name": "Ramgadiya Darshansing Sutarsing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11545",
    "name": "Shinde Narayan Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3102",
    "name": "Divekar Kaluram Anna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13946",
    "name": "Sharma Mahendra Rudmal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5079",
    "name": "Kulkarni Prabhakar Chintamani"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13791",
    "name": "Bhoite Sujit Jaywant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9426",
    "name": "Mohite Vilas Ganapati 835/58"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20835",
    "name": "Mohama D Javed  Yusuf   Momin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4883",
    "name": "Mohan B.Chavhan/Kisan A.Salunkhe/Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13840",
    "name": "Navghane Satish Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10534",
    "name": "Shekhawat Ashok Kalyansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3731",
    "name": "Khedekar Hemant Dattatrya."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12863",
    "name": "Sabale Rajaram Raoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21483",
    "name": "Maru Vishal Harish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1928",
    "name": "Dalvi Meera Balaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5999",
    "name": "Bhoir Vijaya Janardhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17106",
    "name": "Yadav Satyanarayan Ramraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3418",
    "name": "Mane Namdevrao Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16426",
    "name": "Joshi Vasant Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13916",
    "name": "Wagh Pravin Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17401",
    "name": "Amrutkar Eknath Jagnnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15911",
    "name": "Apandkar Sunita Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14475",
    "name": "Batwal Shantaram Ranu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8248",
    "name": "Deb  Roma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17147",
    "name": "Pandya Mohanlal Narsinghji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15730",
    "name": "Savant Meena Balkrishna."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10868",
    "name": "Wagh Sopan Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "937",
    "name": "Mansukhlal Dhabblia Saryulala ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14196",
    "name": "Jaiswar Lalnprasad Purushottam."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13180",
    "name": "Mhatre Moreshwar Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5191",
    "name": "Neware Govindram Surylal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4390",
    "name": "Vidhi Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2091",
    "name": "Vidhut Electronics"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1034",
    "name": "Vidhyutdhara Consumers Co-Op. Socity Ltd"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "218",
    "name": "Vighnahartra Enterprises"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2307",
    "name": "Dakve Hanmant Laxman"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "393",
    "name": "Gaonkar Amit Dattatraya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13117",
    "name": "Jain Heamraj Verchandji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15633",
    "name": "Kargutkar Anand Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10784",
    "name": "Phalke Dilip Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2513",
    "name": "Vijay Silk Mills."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1460",
    "name": "Vijay Transport Service"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11508",
    "name": "Sawant Ravindra Chimaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3463",
    "name": "Shinde Narayan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "989",
    "name": "Vikas Construction Co"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10246",
    "name": "Yadav Parasnath Thakuruddin"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1261",
    "name": "Vinit Enterprises."
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "277",
    "name": "Vinod Construction"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1136",
    "name": "Vipul Industries"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17420",
    "name": "Anshari Majibullah Sanallah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16773",
    "name": "Deshpande Rajani Vijaynand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11955",
    "name": "Devgude Shivaji Sopan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1494",
    "name": "Gawade Anuja Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19557",
    "name": "Guthale Indubai Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19235",
    "name": "Kadam Sachin Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15660",
    "name": "Shinde Ravindra Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1113",
    "name": "Vishal Steel Corporation"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "60",
    "name": "Vishal Tex"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1070",
    "name": "Vishal Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10235",
    "name": "Kahane Dattaram Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4572",
    "name": "Rane Shobha Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6752",
    "name": "Mascranhans  Jacinta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9617",
    "name": "Dhayfule Dharam Baswant"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4564",
    "name": "Vishnupriya Star"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17085",
    "name": "Bhoite Vijaykumar Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22400",
    "name": "Kale Dattatrya Anadrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10128",
    "name": "Salunkhe Dattatray Dnandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17988",
    "name": "Sathe Anil Harshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14302",
    "name": "Shetty Laxmi Ayakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3125",
    "name": "Pawar Bandhu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1470",
    "name": "Musrani Bhupendra Lalji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9913",
    "name": "Patil Radha Dipak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19520",
    "name": "Prabhu  Prasad Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15985",
    "name": "Shah Kejal Mukesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9831",
    "name": "Parkar Suresh Vasudeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7791",
    "name": "Savla Vallabhji Bhavanji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7790",
    "name": "Dharod Ramesh Bharji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2957",
    "name": "Chand Mahmad Babar Shaikh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6737",
    "name": "Chouhan Rangilal Dholai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14810",
    "name": "Dhure Dipali Anant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9967",
    "name": "Durgule Arun Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2449",
    "name": "Barva  Dilip."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9285",
    "name": "Mohammad Rizwan Hasan"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "43",
    "name": "Vishwanath Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13889",
    "name": "Choudhari Sangita Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4435",
    "name": "Dhotre Ashok S."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10771",
    "name": "Kadam Prakash Jaysing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22181",
    "name": "Marathe Vandana Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15882",
    "name": "Sankpal Sandeep Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "961",
    "name": "Gaikwad Shankar Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12836",
    "name": "Gaikawad Nilesh Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18159",
    "name": "Kokane Krushna Jayaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6266",
    "name": "Salve Nalini Y."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20502",
    "name": "Wagh Sangram Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10570",
    "name": "Bhapkar Ankush Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18091",
    "name": "Lade Meena Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11390",
    "name": "Mestri Neela Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17109",
    "name": "Warange Uma Uday"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "699",
    "name": "Khanolkar Jagannath Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6926",
    "name": "Chavan Sunita Parsharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14154",
    "name": "Nimbalkar Gajanan Hanumant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11540",
    "name": "Angwalkar Prema Tairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18760",
    "name": "Nachare Vanita Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17544",
    "name": "Kadam Sunil Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14635",
    "name": "Ligade Suvarna Dhananjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12983",
    "name": "Rajemahadik Kalyani Kiran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13291",
    "name": "Sharma Radeshyam Ramdin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15933",
    "name": "Deshmukh Jaywant Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9720",
    "name": "Lad Salil Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18438",
    "name": "Bagul Sushma Jayram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1446",
    "name": "Dhamane Ravindra Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "367",
    "name": "Nawadkar Kalidas Dagdoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7346",
    "name": "Shinde Shivaji Rau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16944",
    "name": "Kumbhar Atmaram Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9187",
    "name": "Sul Malan Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11424",
    "name": "Bhogle Latika Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16067",
    "name": "Prajapati Vimala Zinku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4465",
    "name": "Sawardekar Suresh Shiva"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3904",
    "name": "Savala Suresh Velaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3110",
    "name": "Luman Pramila Digmbar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "601",
    "name": "Shrirang Nivruti Nikam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16140",
    "name": "Shukla Bharatkumar Vijayshankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10230",
    "name": "Memon Siddhi Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14534",
    "name": "Shinde Rahul Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16279",
    "name": "Dhende Vitthal Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16306",
    "name": "Ghadigaonkar Deepak Sambhaji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18949",
    "name": "More Krishna Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12867",
    "name": "Negi Baldevsingh Mohansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "228",
    "name": "Tiwari Krishna Kumar Ramashankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "920",
    "name": "Dhumali Swapnil Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18687",
    "name": "Pawar Pradeep Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15177",
    "name": "Naik Viswanath Khanderao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2882",
    "name": "Mehta Bhanu Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9210",
    "name": "Chavan Uday Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4930",
    "name": "Nawadkar Jaysing Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16144",
    "name": "Chalake Snehal Chandrashekhar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21768",
    "name": "Karande Shakuntala P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18964",
    "name": "Khilari Harshali Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8473",
    "name": "Mutihian Parama Shivam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15995",
    "name": "Yadav Vandana Balaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4500",
    "name": "Joshi N. Kamla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12927",
    "name": "Kubal Gajanan Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4045",
    "name": "Mohmed Usman Basirehmed."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9068",
    "name": "1 Shidruk Sanjay Shankarb/"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22476",
    "name": "Balmiki Raja Sonpal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5784",
    "name": "Rane Ganpat Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5047",
    "name": "Shaikh Mohamed Rafiq Abdul"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3871",
    "name": "Waghdhare Deepak Keroji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8493",
    "name": "Thorat Mohan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1033",
    "name": "Anjana Suresh Kadam."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1375",
    "name": "Pawar Keshav Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12881",
    "name": "Attar Iliyas Mohamad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7759",
    "name": "Gaikwad Vidyulata Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7628",
    "name": "Dais Bhartul Lowrance."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16645",
    "name": "Manjrekar Santosh Laxman."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1077",
    "name": "Bhosale Nivrutti Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "956",
    "name": "Dhumal Prabhakar Babanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16212",
    "name": "Barge Dasharat Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12716",
    "name": "Gaikwad Meena Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13054",
    "name": "Gupta Khatai Tilakdhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18757",
    "name": "Thakur Setubai Sundarchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2881",
    "name": "Adhav Shantaram Rama"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "40",
    "name": "Chaudhary Dashrath Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17329",
    "name": "Gade  Kalpana  Jagannath ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19296",
    "name": "Gupta Kisanlal Ramgopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5513",
    "name": "Kale Jaya Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5433",
    "name": "Pradhan Gangadhar Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6837",
    "name": "Walimbe Anil Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5464",
    "name": "Gosavi Gadadhar Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21799",
    "name": "Arya Manjudevi Thakurprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5576",
    "name": "Gupta Suresh Algura"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10402",
    "name": "Jadhav Vijay Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14136",
    "name": "Pawar  Sivaji Sripati."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16660",
    "name": "Raut Gajanan Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5628",
    "name": "Dhodapkar Shubhada"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21611",
    "name": "Gharge Shrikant Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8088",
    "name": "Rane Ujwala Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9262",
    "name": "Patil Jyotsna Jivananand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3409",
    "name": "Chikane Vasant Barku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5182",
    "name": "Chavan Tukaram Babu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9165",
    "name": "Kadam Shamrao Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17843",
    "name": "Chauhan Maniben Hasmukh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11922",
    "name": "Keluskar Sitabai R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5734",
    "name": "Koli Mathura Harishchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16538",
    "name": "Mane Sanjay Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12841",
    "name": "Phalke Sindhu Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14407",
    "name": "Shelke Suresh Bablya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15473",
    "name": "Thomas Jolly Joi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "978",
    "name": "Madhavan  P.A."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13432",
    "name": "Shinde Shrirang Deoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "704",
    "name": "Jobanputra Bhushan Kantilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4941",
    "name": "Jadhav Kishor Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17483",
    "name": "More Krushna Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8726",
    "name": "Raja Mohmad Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3294",
    "name": "Doke Baban Vittal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5958",
    "name": "Teli Dulari Raghunat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10441",
    "name": "Gejage Draupada Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18567",
    "name": "Aarakade Pranali Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8904",
    "name": "Dalvi Tulsidas Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16023",
    "name": "Manjrekar Vishakha Laxmikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11590",
    "name": "Patil Netaji Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8822",
    "name": "Ramsurat Ram Amarjit Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8718",
    "name": "Sharma  Aruna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18121",
    "name": "Bawle Vasant Ananda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2845",
    "name": "Babade Bhagarhti Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13280",
    "name": "More Shoba Devidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20277",
    "name": "Wankhade Dilip Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1501",
    "name": "Kadam Bandu Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15957",
    "name": "Saket Rajmani R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "382",
    "name": "Ajalan  K.C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21678",
    "name": "Dhondwad Sagar Ganapat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10532",
    "name": "Andrades Belvina Brandon"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14308",
    "name": "D'Silva Poonam Jubert."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8880",
    "name": "Jadhav Sandip Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15711",
    "name": "Sawant Shailendra Vasant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12596",
    "name": "Shirsat Meena Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15719",
    "name": "Thakkar Suresh Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11992",
    "name": "Vajrekar Ravindra Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3184",
    "name": "Jadhav Asha Dattatrya."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1885",
    "name": "Koli Sahadeo Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10437",
    "name": "Patade Archana Arvind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21007",
    "name": "Vardam Nihar Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15670",
    "name": "Waghmare Bhagwat Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12807",
    "name": "Mahadik Tukaram Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7743",
    "name": "Shah Prakashchand Tarachand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13340",
    "name": "Mali Jayram Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23022",
    "name": "Dalvi Prakash Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23025",
    "name": "Ghanawat Sharad Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17136",
    "name": "Sawant  Narayan Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12161",
    "name": "Singh Savindarkaur Jaswant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10867",
    "name": "Tiwari Anilkumar Sankataprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1998",
    "name": "Welcome Country Bar"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3171",
    "name": "Well Pack"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4726",
    "name": "Parkar Mohan Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16789",
    "name": "Babar Madhan Babu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2096",
    "name": "Havsethe Appasaheb Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19435",
    "name": "Jain Silpes Champalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11871",
    "name": "Madane Gokulabai Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "788",
    "name": "Wireless World"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15548",
    "name": "Shetty Uday Mahabal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11633",
    "name": "Wadhen Lalubai Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11555",
    "name": "Shinde Prakash Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7632",
    "name": "Sharma Kashiram Premji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13822",
    "name": "Joshi Ramesh Toliram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8811",
    "name": "Khedekar Mangala Chimaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2423",
    "name": "Varkhadwadi Vikas Mandal-Mumbai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23003",
    "name": "Ghanawat Ankush Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22998",
    "name": "Raut Vandana Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12463",
    "name": "Jangale Sunita Dhaku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5079",
    "name": "Thorave Ganpat Rambhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7209",
    "name": "Gupta Lalji Shivbabu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9512",
    "name": "Chavan Ananda Chandru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11446",
    "name": "Shetty Narayan Balappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23008",
    "name": "Chavan Anita Amol"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20354",
    "name": "Hindelkar Pranali Dashrathi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16822",
    "name": "Jadhav Suman Janardhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20037",
    "name": "Kakade Sahaji Nanasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17617",
    "name": "Kuveskar Suvarna Anant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7478",
    "name": "Prusati  Pratap"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20665",
    "name": "Rodrigues Remond Jo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17358",
    "name": "Jagtap  Satish  Kisan ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13425",
    "name": "Jethva Kanta Manoj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8947",
    "name": "Matkar Anusaya Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22992",
    "name": "Meher Pramod Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2539",
    "name": "Nimbalkar Hanmant Vinayak"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1052",
    "name": "Sawant Tukaram Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11573",
    "name": "Shelar Sunil Bhiva"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4495",
    "name": "Raut Ganpat Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8051",
    "name": "Shinde Shobha Hanumant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1330",
    "name": "Kokitkaar Dattatray Ramu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13703",
    "name": "Gawde Ramchandra A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20409",
    "name": "Shelar Nilam Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17613",
    "name": "Yadav Anil Mugutrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8818",
    "name": "Bhangare Seema Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15093",
    "name": "Patil Avinash Atamaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8891",
    "name": "Tamboli Hajrabi Babubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13423",
    "name": "Tadake Smita Popatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3205",
    "name": "Parulekar Jyosna Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7631",
    "name": "Devara Ashok G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13212",
    "name": "Kadam Dattatray Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17775",
    "name": "Naik Kalpana Milind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2636",
    "name": "Desai Jignesh Sureshchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3648",
    "name": "Patil Mahesh Madan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "885",
    "name": "Shah Jewerchand Tarachand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6615",
    "name": "Veer Kondiba Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14614",
    "name": "Salunkhe Rajaram Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7217",
    "name": "Jagdale Ekanath Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3689",
    "name": "Parsekar Namdeo Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17589",
    "name": "Darji Raju Shivalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7547",
    "name": "Sapkota Gangadhar Sriprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5454",
    "name": "Rane Chandrabai Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11327",
    "name": "Sangare Meenakshi Dattaray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11550",
    "name": "Thapar Rajendra Kumar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13657",
    "name": "Modave Ram Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8544",
    "name": "Laxkar Pushplata Shyam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20486",
    "name": "Shirke Sharad Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14029",
    "name": "Vasanti Bhaskar R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10236",
    "name": "Sharma Ajitkumar Lalan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16240",
    "name": "Jadhav Manda Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16109",
    "name": "Bamboli Raksha Mulchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11264",
    "name": "Bomble Sunil Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19171",
    "name": "Barge Sanjay Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12207",
    "name": "Shedage Vishwas Kondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18100",
    "name": "Khan Jahangir Rajaakram Husen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18108",
    "name": "Lezar Hansal Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13751",
    "name": "Modak Pandurang Dhanagi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16355",
    "name": "Padhye Rekha Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15169",
    "name": "Barhate Rajendra Bhagwat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20278",
    "name": "Goud Mantoshkumar R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17576",
    "name": "Harijan Kululal Gaurishankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22288",
    "name": "Jaiswal Ranjeet Indrajeet."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15810",
    "name": "Kamble Santosh Appa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16190",
    "name": "Chikane Balwant Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18301",
    "name": "Chaturvedi  Rajenderprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12615",
    "name": "Kombekar Manda Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7809",
    "name": "Pal Pholchand Somanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13089",
    "name": "Thombare Padma Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17659",
    "name": "Yadav Indar Raj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20662",
    "name": "Palav Gauravi Sadanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6748",
    "name": "Mota Vasant Mulaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10221",
    "name": "Choudhari Kaluram Pukhraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3593",
    "name": "Shaikh Sohail Shakur."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13762",
    "name": "Mahadeo Nivrutti Salunkhe"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13605",
    "name": "Thorat Uday Haridas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9064",
    "name": "Shaikh Nabishah Jangli Shah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10497",
    "name": "Vishwakarma Ashadevi Patiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21604",
    "name": "Yadav Shakuntala Shivkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8576",
    "name": "Rathod Dhanaji Khoda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16409",
    "name": "Masurkar Rashmi Divakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "878",
    "name": "Arvind K. Jhakar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7918",
    "name": "Habiib Shah Rashimat Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13911",
    "name": "Mohamad Sagir Ahamad Mohamad Saukat Ali."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18491",
    "name": "Nikam Krishna Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6111",
    "name": "Ragjor Damji Lalji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11720",
    "name": "Chavan Dattatraya Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5805",
    "name": "Jha  Subhashchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18487",
    "name": "Sonawane Prasad Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12699",
    "name": "Chitoda Nita Chiman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12041",
    "name": "Kharase Narayan Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18372",
    "name": "Naik Madhavi Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19555",
    "name": "Pandey Sheshnarayan Omkarnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18421",
    "name": "Pawar Shreedhar Sitaram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19239",
    "name": "Sangoi Manilal Ravji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9067",
    "name": "Shravandr Rashmi Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11277",
    "name": "Tilak Navnath Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12043",
    "name": "Purohit Rameshkumar Hakamji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6419",
    "name": "Ujgare Nitin Vijayanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11390",
    "name": "Chippa Vishwanath A."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13745",
    "name": "Kanase Jigana Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17247",
    "name": "Patel Kailash Lalaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "515",
    "name": "Janardhan Shankar Mane"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13861",
    "name": "Lagavankar Shilpa Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5221",
    "name": "Patvekar Shama Umar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6577",
    "name": "Jadhav Kamal Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9333",
    "name": "Bhati Sunita Bharat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13840",
    "name": "D  Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7904",
    "name": "Kanojiya Bachan Lal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14640",
    "name": "Pandey Rakeshkumar Sabhajit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1558",
    "name": "Nikalje Prakash Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1180",
    "name": "Rajula Gangadhar Gangarm."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13200",
    "name": "Babar Vikram Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14496",
    "name": "Lakhan Somaji Devaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12067",
    "name": "More Ramchandra Bali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21743",
    "name": "Gamre Reshma Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17427",
    "name": "Varik Prachi Motiram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12366",
    "name": "Patil Bandu Pandurang 446/8"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5901",
    "name": "Mondkar Chandrakant Vishram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17020",
    "name": "A Laxman/P Dharmaraji/ R Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20022",
    "name": "Jain  Somchand"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1535",
    "name": "Khan Sajeed Nazir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13204",
    "name": "Mamidala  Tirupati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10741",
    "name": "Wagh Mansing/Ramdas Nalvade/Bhalerao Jag"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9571",
    "name": "Pisal Sambhaji Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5483",
    "name": "Parikh  Mahendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7689",
    "name": "Bhatt K.P/Shankar P/Yashwant S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18064",
    "name": "Handhe Pragati Shidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6181",
    "name": "Kambale Chandrakant Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10788",
    "name": "Paliwal Murarilal K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10187",
    "name": "Phulchand  Tikaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13345",
    "name": "Sharma Haresh Ramavtar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11404",
    "name": "Thakar Urmila Shantikumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13071",
    "name": "Thorve Ashamati Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14577",
    "name": "Shalini Krishnakanth Bijotkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13579",
    "name": "Gupta Patturam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7326",
    "name": "Sawant Dattatraya Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "370",
    "name": "Gawade Ravindra Arjun"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2164",
    "name": "Bharia Amarchand Baldevaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21672",
    "name": "Shitole  Ajaykumar  Dinkar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "363",
    "name": "Patil Ashru Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "195",
    "name": "Mandhare Ananda Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11606",
    "name": "Bhalerao Shobhana Bhimsen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16025",
    "name": "Kambale Rohidas Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13225",
    "name": "Raje Sanjaykumar Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20020",
    "name": "Shekh  Aashiq Hussen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15347",
    "name": "Shinde Prakash Eknath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15916",
    "name": "Talwar Kajal Jagdish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7534",
    "name": "Nimakar Ujwala Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "391",
    "name": "Babanrao Bhikoba Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11729",
    "name": "Kuswaha Birbal Ramnaresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15655",
    "name": "Pawar Balkrishna Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15559",
    "name": "Shekh Sabirali Abdulgafar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17185",
    "name": "Patil Ranjana Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12645",
    "name": "P  Dharamraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1046",
    "name": "Dnyandeo Laxman Mardhekar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12743",
    "name": "Bhatnagar Madhu Arun."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21564",
    "name": "Bhosale Pushpa Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "627",
    "name": "Pedru Jujya Vaity"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15800",
    "name": "Pawar Anil Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3472",
    "name": "Sawant Suvarna Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12579",
    "name": "Pawar Ramesh Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20763",
    "name": "Mapuskar Dayanand Madhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4709",
    "name": "Rasal Deepika Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17830",
    "name": "Pawar Ananda Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9566",
    "name": "Mali  Parmeshwaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11491",
    "name": "Patel Jayesh Maganlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16899",
    "name": "Bobade Hanmant Bakaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16819",
    "name": "Pawar Nitin Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20896",
    "name": "Bedse Shankar Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19013",
    "name": "Rajpurohit Navinsing Devising"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20928",
    "name": "Singh Pankaj Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12794",
    "name": "Tawate Pradeep Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5894",
    "name": "Trivedi Bhavesh G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2026",
    "name": "Pangale  Prakash Parsuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4601",
    "name": "Sharma Maya Keval"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15067",
    "name": "Bhosale Sandeep Mahadeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1890",
    "name": "Gaund Dashrath Kariman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12795",
    "name": "Sane Deepvati Nandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20217",
    "name": "Tagala Akram Nasir Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21909",
    "name": "Chauhan Arun V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18028",
    "name": "Pawaskar Sharad Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10704",
    "name": "Jaikar Satish Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5367",
    "name": "Chikane Jaiwant Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7923",
    "name": "Rane  Vishwnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1269",
    "name": "Byhosale Dinkar Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16007",
    "name": "Dimbale Aruna Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8151",
    "name": "Rath G. R/P S Ahire/H D Raut."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14551",
    "name": "Shetty Shantaram B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18080",
    "name": "Yadav Vilas Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5150",
    "name": "Kadam Kisanrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16054",
    "name": "More Chandrakant Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7876",
    "name": "Mandhare Dashrath Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5853",
    "name": "Chavan Arun Yadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4173",
    "name": "Majetia Rekha Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15767",
    "name": "Purohit Uday Kirit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14815",
    "name": "Jadhav Jayshri Kamlakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22051",
    "name": "Dubal Bhagwan Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17146",
    "name": "Gatte Baban Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8455",
    "name": "Krishna  Sanil."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17631",
    "name": "Mahadik Tukaram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17522",
    "name": "Parasharam Kalpita Deepak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17219",
    "name": "Kanojiya Iskelal Habilakh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19182",
    "name": "Yadav Sanjay Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16032",
    "name": "Pisal Hanmant Raosaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16294",
    "name": "Jain Pavan Nemichand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9860",
    "name": "Mahadik Survin Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18337",
    "name": "Pawar Rajaram  Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8584",
    "name": "Roy  Apupba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1924",
    "name": "Patel Babu Shikandar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3277",
    "name": "More Prakash Ramchandra."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8477",
    "name": "Raje Sunil Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18721",
    "name": "Gupta Subas Ramvruksha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14892",
    "name": "More Nandabai Ganapat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13312",
    "name": "Sanas Dipali Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7721",
    "name": "Shaikh Basir Ahmad Sardar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7231",
    "name": "Singh  Narendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17934",
    "name": "Singh Mala Rakesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9473",
    "name": "Yadav Rajashree Sing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18802",
    "name": "Chaskar Vrushali Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6767",
    "name": "Pal Lallu Bhisali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16505",
    "name": "Sawant Satish Shantaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20064",
    "name": "Singh  Brijesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15601",
    "name": "Thakar Deepali Ashvin / Thakar Girish As"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10390",
    "name": "Chavan Yatin Satyawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3925",
    "name": "Tendulkar Ulhas Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18102",
    "name": "Bhalerao Meena Bhimsen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14148",
    "name": "Patel Mulchand Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14422",
    "name": "Pujari Yallama Mallappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11624",
    "name": "Ramkrishan Govind Komath Meethal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22344",
    "name": "Salve Usha Jagdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16835",
    "name": "Dhanavde Babiita Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11743",
    "name": "Jagtap Baban Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8301",
    "name": "Naik Lalita Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "243",
    "name": "Kedar Suresh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14689",
    "name": "Prajapati Gyanchandra Ramsurat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5444",
    "name": "Bhosale Gokula Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13561",
    "name": "Jadhav Nilesh Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14493",
    "name": "Nalawade Sangeeta Mugutrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8520",
    "name": "Narkar Kunda Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6091",
    "name": "Rajmali Dattaji V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19578",
    "name": "Salunkhe Kalu Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3727",
    "name": "Vijay Road Lines"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16594",
    "name": "Dhuri Sudam Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14579",
    "name": "Jaiswal Tulshiram Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8190",
    "name": "Mewade Arvind A./Dilip Karanje"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4026",
    "name": "Mandhare Dattaram Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14650",
    "name": "Pudamsingh K. Vishwkarma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "310",
    "name": "Nalawade Jayshree Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13730",
    "name": "Mahadik Tukaram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6803",
    "name": "Jadhav Tukaram Bapuji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2497",
    "name": "Bandevadekar Shailaja Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3684",
    "name": "Patkar Gurunath Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16331",
    "name": "Bist Ganesh Bahaddur."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16015",
    "name": "Rathod Deepa Naveen"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14066",
    "name": "Adahav Praksh Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17685",
    "name": "Misal Maruti Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20493",
    "name": "Thakkar Khushbu Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20778",
    "name": "Vedre Mangesh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19572",
    "name": "Yadav Baburam Suku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2527",
    "name": "Wagh Shankar Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14244",
    "name": "Kadam Sandip Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12537",
    "name": "Khopade Ranjana Manikrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5554",
    "name": "Suresh Vinayak Dhumal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2914",
    "name": "Bhadawalkar Anant Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20585",
    "name": "Bhuvad Vijay Dhondui"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20653",
    "name": "Chliya Devdasan P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9440",
    "name": "Dethe Ragnath R/Sumant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13637",
    "name": "Goswami  Indranil Manik."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21389",
    "name": "Jagtap Madhuri Mohan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "61",
    "name": "Yash Fabrics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3554",
    "name": "Yash Printers"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13945",
    "name": "Kadam Shaline Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18163",
    "name": "Sawant Ashok Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20464",
    "name": "Ajmera Goonjan Chandrakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "318",
    "name": "Chavan Rajendrakumar Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20657",
    "name": "Gohil Trupti Vinod"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16998",
    "name": "Jai Mahamathdi Gumgen Kamgar Sena."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12091",
    "name": "Kambli Pritam S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17533",
    "name": "Waghmare Deepak Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2959",
    "name": "Shaikh Nibbar Ali Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8758",
    "name": "Chandekar Ajay Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10366",
    "name": "Bhosale Parvati Hanmantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7611",
    "name": "Jha  Baleshwar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8346",
    "name": "Saud Dalbahadur Mohansig"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18034",
    "name": "Shedge Shilpa Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23639",
    "name": "Ansari Yusufali Ashrafali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6515",
    "name": "Wakate Laxman Chimaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5533",
    "name": "Bhosale Arjun Ganpati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3542",
    "name": "Borkar Krishna Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2915",
    "name": "Kenjale Baban Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2990",
    "name": "Nair Radhakrishn Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1703",
    "name": "Kadam Jijaba Bhairau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7498",
    "name": "Shaikh Akbar Amit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4577",
    "name": "Ahirrao  K.A."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13043",
    "name": "Indulkar Sanjay Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13899",
    "name": "Perdeshi Ravi Ramasre"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18828",
    "name": "Pawar Dhondiram Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1806",
    "name": "Mehta Dulerai Pranjivan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "220",
    "name": "Karande Yashwant Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12524",
    "name": "Yevale Hemant Pratap"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15559",
    "name": "Momin Abdul Hayyum Sultan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16101",
    "name": "Mahadik Santosh L"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17262",
    "name": "Palande Nisha Nitin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12304",
    "name": "Phalke Deepak Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18555",
    "name": "Kadam Santosh Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21480",
    "name": "Dalvi Jagdish Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6718",
    "name": "Mohite Suryakant R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14802",
    "name": "Pawar Sushul Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15052",
    "name": "Nanegaonkar Rajendra Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9511",
    "name": "Shukla Chandramani Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3396",
    "name": "Milling Gurao Ramling"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21410",
    "name": "Kabre Shyam Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12225",
    "name": "Kamble Baban Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6727",
    "name": "Santosh  Vithu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10650",
    "name": "Shah Kokila Jitendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2351",
    "name": "Gavade Prakash Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4536",
    "name": "Ganlawand Laxman Yanappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11698",
    "name": "Akerkar Shubhangi Zilu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17689",
    "name": "Bhartiya Janta Party Paral Vidhansabha ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17634",
    "name": "Choudhari Bebijan Gulamali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16791",
    "name": "Datir Marotirao Nanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14967",
    "name": "Patil Sanjay Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22198",
    "name": "Topkar Vinayak Vasant."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6354",
    "name": "Nikam Navnath Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19917",
    "name": "Shinde Indumati Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9544",
    "name": "Mansukh Sanjay N. 19/21"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14749",
    "name": "Dalvi Deepa Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6815",
    "name": "Jadhao Sarjerao Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7135",
    "name": "Shah Kantilal Virchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13063",
    "name": "Daptare Sunanda Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2951",
    "name": "Dhumal Suresh Vilasrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15316",
    "name": "Patel Chhaya Lala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "570",
    "name": "Pisal Sachin Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5785",
    "name": "Ansari  Yakubali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12911",
    "name": "Bhosale Rajan Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2022",
    "name": "Sabale Dattatrya Parbati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19715",
    "name": "Chaudhari Nasimbanu Musafir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14799",
    "name": "Mestri Nitin Dattatrya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9386",
    "name": "D Souza Augustin Bernad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10997",
    "name": "Telw Pandurang Devba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1012",
    "name": "Jolly Sports Club"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16961",
    "name": "Dhanawade Ramchandra Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21560",
    "name": "Balsaraf Shobha Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13292",
    "name": "Mehta Mangaladevi Premraj"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1042",
    "name": "Patil Laxman Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19631",
    "name": "Shinde Swapnil Sharad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1414",
    "name": "Nawadkar Ankush Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11284",
    "name": "Patil Ramchandra Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18645",
    "name": "Tarde Vijay Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9798",
    "name": "Patkar Prachi Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8881",
    "name": "Khan Salaudin Shahbudin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9404",
    "name": "Jain Jiganesh Sureshkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "688",
    "name": "Zinal Collection"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19437",
    "name": "Ansari Mainuddin Nizamuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6775",
    "name": "Kahar Asha Raheraman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2728",
    "name": "Sabale Hanmant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2991",
    "name": "Patil Ganga Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4752",
    "name": "Ashra Nilesh Bhupatral"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3612",
    "name": "Khan Shabbir Hussain Khalil."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14668",
    "name": "Chavan Sangeeta Jayhind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16944",
    "name": "Gawde Vandana Krishnakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1654",
    "name": "Shaikh Ersadali Abdulruff"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1413",
    "name": "Sawant Kantibai Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7431",
    "name": "Patel Saroj V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21603",
    "name": "Pendurkar Sneha Sudhir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14532",
    "name": "Yadav Suryabali Raghupati."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5327",
    "name": "Chavan Jaychand Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15578",
    "name": "Abhang Ashok Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18011",
    "name": "Bhandari Deepali Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15220",
    "name": "Gavade Shreehari Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13189",
    "name": "Kakade Ahilya Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15586",
    "name": "Mohite Mohan Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16432",
    "name": "Pawar Parshuram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17737",
    "name": "Runshur Uttam Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15086",
    "name": "Sawant Anjali Gautam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "145",
    "name": "Z. A. Faras."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1228",
    "name": "Shah Radiyat Harakchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10562",
    "name": "Kale Devidas Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5927",
    "name": "Tiwari Jairam Dhruvapati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "584",
    "name": "Ramlakhan  Yadav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13870",
    "name": "Shah Jayant Hirachand."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6144",
    "name": "Ghosh Rekha Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14586",
    "name": "Acharekar Pandurang Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13412",
    "name": "Bhatnagar Arun Dayaswarup"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18400",
    "name": "Gosavi Vaishali Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8571",
    "name": "Netake Ramdas Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18043",
    "name": "Polaparampil  Binu Kurian"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16871",
    "name": "Surve Nisha Uday"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11803",
    "name": "Wakpanjar Manda Panditrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6735",
    "name": "Matre Hari Tatoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13645",
    "name": "Ghawada Minakshi Kumar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11180",
    "name": "Mandnare Ajay Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10043",
    "name": "Mhatre Narendra Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9430",
    "name": "Yadav Shashi N."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13624",
    "name": "Patel Uttam Dayabhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7253",
    "name": "Bhandari Hemant Kesrinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14901",
    "name": "Faimullh  Khan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5952",
    "name": "Gurav Shankar Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15156",
    "name": "Makwana Naza Aata"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16563",
    "name": "Pawar Laxmibai Devji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18842",
    "name": "Singh Rakeshkumar Parbhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22589",
    "name": "Zahid Nasir Ahmed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9626",
    "name": "Chavan Toliram Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10493",
    "name": "Gaikwad Sangeeta Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8905",
    "name": "Rane Mangesh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7898",
    "name": "Mahse Manohar Surajii"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16661",
    "name": "Warli Budhiya Devji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17789",
    "name": "Damugade Ankush Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15831",
    "name": "Kotkar Minal Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10738",
    "name": "Chavan Vinita Vinod"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13916",
    "name": "Shaikh Tofik Ali Ahmed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8931",
    "name": "Solsakar Ambubai Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12192",
    "name": "Chavan Nandkumar Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16868",
    "name": "Bamboli Archana M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19382",
    "name": "Kumbhar Dinkar Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11817",
    "name": "Pal Radheshyam Rupai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23274",
    "name": "Prem Manisha Satyapriy"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16545",
    "name": "Kadam Nilesh Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8687",
    "name": "Kadam Pratap Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21856",
    "name": "Tatkar Jagdish Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15967",
    "name": "Bhandari Dilip Vasant."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "908",
    "name": "Paswan Rajesh Ramsaran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19156",
    "name": "Pimpale Bharati Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18101",
    "name": "Pokale Kamalakar Shankar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15100",
    "name": "Vora Kanaklata Rajanikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10452",
    "name": "Yadav Siyaram Alakhi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13263",
    "name": "Bhise Ganpat Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9919",
    "name": "Champanery Nilesh K/Rajeshree"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23323",
    "name": "Sinh Bajranglal Mewalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17792",
    "name": "Somalkar Jyoti Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9068",
    "name": "Pawar Jaysingh Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15642",
    "name": "Rahate Shital Chandrakant."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "206",
    "name": "Gurjar Yadram Todaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18932",
    "name": "Ingale Balkrishna Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16364",
    "name": "Sushiladevi Bhawarlal Laden."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15775",
    "name": "Bhilare Satvashila Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13368",
    "name": "Jaiswal Ramdin Lodhiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23186",
    "name": "Maniar Sanjay Vasantlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13750",
    "name": "Pote Shukracharya Mahadeo.&Pote Bhimaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12739",
    "name": "Singh Radha Tribhavan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13780",
    "name": "Sonavane Mahadeo Bhagavan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3529",
    "name": "Sheth Prakash Harjivandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11295",
    "name": "Raut Dattaram Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9893",
    "name": "Mandare Suryakant Amrutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12470",
    "name": "Phalke Nivas Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8212",
    "name": "Shah Pukhraj Chogaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8600",
    "name": "Thakkar Sanjay Purushottam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3291",
    "name": "Desai Suresh Vanmalidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "95",
    "name": "Pawar Sadashiv Anadrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23351",
    "name": "Chavan Padmini N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7440",
    "name": "Gokhale Vitthal Sidu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18056",
    "name": "Omkar Singh Ramchandarsingh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18697",
    "name": "Patne Arvind Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4019",
    "name": "Savalkar Vidhyadhar Sambhaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11385",
    "name": "Shinde Vilas Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17462",
    "name": "Patel Kanubhai Ishwarlal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "431",
    "name": "Shewale Vishal Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4854",
    "name": "Phalke Tukaram Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17402",
    "name": "Dsouza Zita Veronica"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20470",
    "name": "Shirke Madhuri Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12153",
    "name": "Bhilare Vaishali Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11702",
    "name": "Gurakha Jaising Dansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16102",
    "name": "Mule Meena Vishavnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13292",
    "name": "Valvi Asha Mahendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15813",
    "name": "Yadav Banarasi Tarsu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10463",
    "name": "Sawant Ranjana Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9809",
    "name": "Gherwada Kishorekumar A/Sudha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3265",
    "name": "Parab Ganpat Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5804",
    "name": "Mane Usha Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15203",
    "name": "Pujari Ganesh Nandi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11345",
    "name": "Bhat Shantaram Aatmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9297",
    "name": "Lad Chandrakant Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9147",
    "name": "Mahangade Anita Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6282",
    "name": "Mhatre Pundalik Pandarinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11115",
    "name": "Sonawane Yashwant Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "688",
    "name": "Shilimkar Dagadu Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2484",
    "name": "Jain Panibai Niaalchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22351",
    "name": "Dhanawade Somnath Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12639",
    "name": "Bhagirathi Niwas Bhadekaru Utkarsha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20592",
    "name": "Patel Prakash Dowaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3943",
    "name": "Phadtare Ankush Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11267",
    "name": "Sadavarte Sakharam Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18811",
    "name": "Warik Dattaram Bhiva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21890",
    "name": "Yadav Dayaram S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11535",
    "name": "Jagtap Vilas Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12498",
    "name": "Joshi Sunita Bhaskar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1425",
    "name": "Dhaigude Narayan Gangadhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5238",
    "name": "Ghadigaonkar Chandrakant Hiraji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19865",
    "name": "Bane Nayana Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2058",
    "name": "Amritsing Suresh Sing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8643",
    "name": "Patil Kashinath Govind/Jitendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8445",
    "name": "Kusum"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19374",
    "name": "Manjarekar Alaka Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17470",
    "name": "Phadtare Sandeep Arjun."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11259",
    "name": "Bilimoria Jatin Tulsidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22729",
    "name": "Jagtap Ganesh Popat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18926",
    "name": "Mahamunkar Ajay Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15973",
    "name": "Poojary  Raghvendra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1253",
    "name": "Shinde Santosh Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13549",
    "name": "Thakur Uttamchand Rupchand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18686",
    "name": "Veralkar Netra  Mangesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5430",
    "name": "Yadav Manohar Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1486",
    "name": "Bhandari Rajesh Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13151",
    "name": "Gaikwad Ajay Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8737",
    "name": "Shelake Nanda Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13140",
    "name": "Wade Raju Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11578",
    "name": "Yadav Sheshnath Shriramkalap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3074",
    "name": "Thomas George ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16484",
    "name": "Sawant Pravin Anant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8473",
    "name": "Khedekar Madhukar Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4322",
    "name": "Vataparbil Manikunju Kuttan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5322",
    "name": "Malpote Namdeo Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20473",
    "name": "Punjabi Mohammedidrees Mohammedyusuf."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13160",
    "name": "Dubal Nanaso Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11444",
    "name": "Vishwakarma Nandlal Chinkan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13524",
    "name": "Walke Sandesh Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14438",
    "name": "Gupta Ashokkumar Deenalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12349",
    "name": "Jadhav Suhas Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14595",
    "name": "Kadam  Tukaram Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5573",
    "name": "Singh Ramashankar Ramnohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2759",
    "name": "Kadam Tanaji Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "740",
    "name": "Deokar Baban Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19078",
    "name": "Jadhav Baliram Barku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18643",
    "name": "Kumbhar Sunita Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18466",
    "name": "Pandey Brijeshkumar Krupashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17059",
    "name": "Rane  Balkrishna  Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15192",
    "name": "Sawant Shivaji Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20796",
    "name": "Mali  Akshaya  Bhanwarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15024",
    "name": "Gandhi Manoj Chandanmalji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16745",
    "name": "Khatate Sudesh Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21831",
    "name": "Khude Rupesh Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "964",
    "name": "Bhagwat Madhav Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "691",
    "name": "Sabale Jaysing Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7770",
    "name": "Parekh Jayantilal K/Savita"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6135",
    "name": "Panchal Anant Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22300",
    "name": "Parmar Bhavanaben Narendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21671",
    "name": "Pawar Shobha Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4699",
    "name": "Gavare Vimal Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8319",
    "name": "Dhupkar Balkrishna Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12783",
    "name": "Mane Kashinath Gopanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8560",
    "name": "Mudekar Jayshri Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3258",
    "name": "Varma  Dayaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13361",
    "name": "Deokate Dilipkumar Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14435",
    "name": "Pawar Pradip Maruti (Manager )"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21941",
    "name": "Mishara Akhilesh Krishankant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13161",
    "name": "Senjeet Sumetra Chandrasen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11135",
    "name": "Shaikh Shakila Moideen/Mariyam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13791",
    "name": "Fernandes  Custodion"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5929",
    "name": "Bhoite Uddhavrao Genba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17479",
    "name": "Duble Sarvesh Dinanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20934",
    "name": "Kamble Yashoda Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10680",
    "name": "More Prema Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2290",
    "name": "Khan Shabana Shahabuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4644",
    "name": "Kamble Maya Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20412",
    "name": "Patil Ganesh  Narayan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7902",
    "name": "Suryawanshi Shivaji Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11650",
    "name": "Parab Rukmini Vishram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1603",
    "name": "More Sadashiv Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7888",
    "name": "Khona Shranika P/Sadhana ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5882",
    "name": "Mane Gokulabai Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8659",
    "name": "Pawar D B/Rajaram Mohite/Vijaykumar Mane"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9185",
    "name": "Vast Subhash Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4443",
    "name": "Waghela Mansukhlal Shamji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4538",
    "name": "Singh  Brijesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "928",
    "name": "Sharma Ramesh Chand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2927",
    "name": "Arolkar Vishwanath Mangesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21678",
    "name": "Tamhankar Gulab Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "646",
    "name": "Rajaram Vasudev Ghadse"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15470",
    "name": "Jyotsna Lawoo Shirockae"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4490",
    "name": "Shinde Sitaram Khashada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21638",
    "name": "Tawre Balaso Kaluram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8291",
    "name": "Hadkar Rajaram Pundalik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20",
    "name": "Mohite Chandrakant Vishnu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9340",
    "name": "Mulik Hanumant Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18331",
    "name": "Yadav Shamrao Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15416",
    "name": "Adivrekar Dhanshri Nitesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7330",
    "name": "Bagade Vasant/Suchdeo Gavare/S N Puthran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10745",
    "name": "Charan Rajendra Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21495",
    "name": "Dethe Vanita Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7794",
    "name": "Kharat Shivaji Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17554",
    "name": "Ithape Maruti Popatrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3402",
    "name": "Sihag Hanuman Prasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2757",
    "name": "Sing Shambihari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17867",
    "name": "Shaikh Alim Azim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5065",
    "name": "Alam Naresh Sitaram/Milind Tawade/Deepak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20017",
    "name": "Dattani Manjula Arvind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13496",
    "name": "Gotad Chandrakant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5621",
    "name": "Mhatre Laxman Chandru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5569",
    "name": "Parab Rajani Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9344",
    "name": "Salunkhe Dyaneshwar Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18548",
    "name": "Agrawal Yogesh Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21945",
    "name": "Mishra Ankitkumar Krishnakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15098",
    "name": "Nardekar Sumati Ram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5196",
    "name": "Thombare Narayan Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14027",
    "name": "Ansari Mohammad Aslam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14509",
    "name": "Eqbal Ahmed Sharfuddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1455",
    "name": "Tembwalkar Narayan Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17655",
    "name": "Waghmode Babu Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18153",
    "name": "Prajapati Ramaujagir Bipat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15054",
    "name": "Shinde Devendra Vishwas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19012",
    "name": "Chauhan Ramshakal Sukhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16384",
    "name": "Mane Laxmi Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "847",
    "name": "Girijaprasad Shripal Dube/Babanadevi Dub"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "751",
    "name": "Kangralkar Narayan Payappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21974",
    "name": "Bhatt Prerna Darshan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2178",
    "name": "Das Rajkishor Laxmi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "542",
    "name": "Bhosale Jamnabai Mansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16097",
    "name": "Gowda Narayan Ommya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13389",
    "name": "Kolekar Mahadev Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9599",
    "name": "Jadhav Satish Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18377",
    "name": "Bhandari Anita Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13706",
    "name": "Dhavale Ankush Tulashiram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10845",
    "name": "Nayak Rosy Shrikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8061",
    "name": "Taware Adhik Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17880",
    "name": "Bhoite Ashwini Rajan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7355",
    "name": "Dhabale Parshuram Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16578",
    "name": "Pisal Madhuri Prakash."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6882",
    "name": "Kadam Chandrakant S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11653",
    "name": "Pawar Hanmant Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18635",
    "name": "Shinde Lalita Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4347",
    "name": "Jai Maharashtra Tarun Mitra Mandal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15628",
    "name": "Sarawgi Sunilkumar Devkaran"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14730",
    "name": "More Mohan Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18605",
    "name": "Bajaj Abhishek Pramod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5918",
    "name": "Dubey Radheshyam C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12791",
    "name": "Gaud Dharbharan Mahabal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14611",
    "name": "Mota Dhinendra Karmashi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14609",
    "name": "Mota Narendra Karmshi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17693",
    "name": "Shah Kajal Bipin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5536",
    "name": "Sagvekar Sadashiv Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8659",
    "name": "Batawale Laxman Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "752",
    "name": "Kangralkar Suresh Payappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21776",
    "name": "Bhosale Chandrakant Wamanrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13313",
    "name": "Khopde Aruna Bhalchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "637",
    "name": "Jaywant Yashwant Kolge"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2441",
    "name": "Chavan Jayant Shivaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11384",
    "name": "Momin Ishrad Begam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6547",
    "name": "Shetty  Sudhir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6396",
    "name": "Bhosale Madan Prataprao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6366",
    "name": "Divase Manda Sursh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7935",
    "name": "Abdul Kadar Shaikh Abbas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19624",
    "name": "Ghorpade Sanjay Madhusudan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17742",
    "name": "Mahindrakar Ashwini Vishnukant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7800",
    "name": "Kadam Popat Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4354",
    "name": "Jagdale Bajirao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17362",
    "name": "Salunkhe Prakash Murlidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2254",
    "name": "Patel Ranchodbai Ravji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22804",
    "name": "Thorat Ratnakar Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2224",
    "name": "Mohite Baburao Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10943",
    "name": "Rajkumar  Gaurishankerram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17783",
    "name": "Shirsekar Swati Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4335",
    "name": "Pawaskar Smita Ekanath."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8542",
    "name": "Shingre Dattaram Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "89",
    "name": "Lole Pratap Appaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6852",
    "name": "Kunnel Jacob Joseph"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9868",
    "name": "Mahadik Neeta Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4147",
    "name": "Powlekar Tukaram Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19287",
    "name": "Khan Zubaida Nawsher"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17164",
    "name": "Shinde Usha Ashok ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18389",
    "name": "Chari Tara Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4901",
    "name": "Chaturvedi Mangala N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17473",
    "name": "Mhatre Jyotsna Kanoj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13688",
    "name": "Dinde Sunanda Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18621",
    "name": "Salunkhe Santosh Dattaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1897",
    "name": "Salunkhe Ramchandra Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14961",
    "name": "Gorivale Pooja Prakash."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20237",
    "name": "Yadav Lalbahddur R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3167",
    "name": "Shaikh Yusuf Navajoddin."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2425",
    "name": "Nerurkar Vasanti Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18247",
    "name": "Kamerkar Pragati Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7333",
    "name": "Sardursing  Bhinsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3641",
    "name": "Lakhan Jaiprakash Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2211",
    "name": "Shikalgar Hamid Raheman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11534",
    "name": "Shinde Balakrishna Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "718",
    "name": "Pabale Savaleram Revaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6267",
    "name": "Ramteke Soniya Surndra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17196",
    "name": "Sarada  Shushil Bhawarlal ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7046",
    "name": "Phadtare Sukhdeo Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11152",
    "name": "Gwade Smita Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10",
    "name": "Pingale Tukaram Rau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12654",
    "name": "Haji Muhamadyhia Salamatali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "638",
    "name": "Suresh Gangaram Tulaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10627",
    "name": "Puralkar Dhondubai Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6832",
    "name": "Pethani Suresh Mulshankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21327",
    "name": "Bitling Mahesh Venkat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15944",
    "name": "Mewada Vikas Trikam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15677",
    "name": "Mohd  Suleman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5341",
    "name": "Palande Snehal Lahu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "112",
    "name": "Shaikh Israil Usman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15116",
    "name": "Singh Jalam Parbat Singh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9309",
    "name": "Jain Sangeeta Ghewarchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16785",
    "name": "Dhamane Ganesh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11153",
    "name": "Shinde Raghunath Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18906",
    "name": "Khan Abdulla S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12276",
    "name": "Sheth Navin Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13235",
    "name": "Shinde Jayshree Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10768",
    "name": "Jadhav Dnyanu Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17614",
    "name": "Jadhav Suresh Hariba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12422",
    "name": "Gaikwad Umesh Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21445",
    "name": "Jain Sushila Premchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18501",
    "name": "Shah Rita H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1830",
    "name": "Jadhav Ganpat Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23243",
    "name": "Patole Aruna Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3577",
    "name": "Burange Mahadeo Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "174",
    "name": "Sabale Maruti Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16412",
    "name": "Jogatar Babulal Shivlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7668",
    "name": "Khatri Narbahadur Thuire."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8581",
    "name": "Shinghi Ranjitkumar K"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1668",
    "name": "Shinde Vimal Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2223",
    "name": "Nalawade Premanand Anantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10560",
    "name": "Dalvi Prasad D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12736",
    "name": "Kakad Eknath Mahadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9011",
    "name": "Jain Sangita Hirachand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "867",
    "name": "Jadhav Lalita Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3499",
    "name": "Nimbalkar Ramchandra Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9130",
    "name": "Haldankar Manoj Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13815",
    "name": "Prajapati Ram Ujagir Dasa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1480",
    "name": "Bheda Ketan Megjibhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3242",
    "name": "Mishra Vijayalaxmi Chandraprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21504",
    "name": "Lembhe Sachin Bhagwanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18398",
    "name": "Rana Vaishali Shankarlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6102",
    "name": "Kurma Laltaram Devnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17254",
    "name": "Surve  Sandeep  Govind ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7116",
    "name": "Chavan Shrirang Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9044",
    "name": "Undre Gajanan Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5453",
    "name": "Bansekar Vijaya Shyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9623",
    "name": "Chinay Cyrus D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14229",
    "name": "Gupta Urmila Munna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16577",
    "name": "Malviya Laxmi Hiralal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7712",
    "name": "Mishra Rajdevi Omprakash."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11746",
    "name": "Naik Sanju H."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1270",
    "name": "Damale Sudhakar Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11847",
    "name": "Salate Nivrutti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9108",
    "name": "Vyas Mahadev Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14893",
    "name": "Chalke Vishnu Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18929",
    "name": "Gaikwad Ajit Raosaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7023",
    "name": "Purohit Basudev Nathulalji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11652",
    "name": "Guha Pradeep A/Devi Prasad Guha"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2075",
    "name": "Kure Raju Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14171",
    "name": "Tashniwal  Kailaschand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11242",
    "name": "Agarwal Rajkapoor B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7819",
    "name": "Anuse Rajana Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3791",
    "name": "Mehta  Prakash."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2744",
    "name": "Loohar Eqbal Ajit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14445",
    "name": "Gupta Sushiladevi Brijmohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7819",
    "name": "Jain Suresh Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "555",
    "name": "Shinde Vithal Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17434",
    "name": "Pimpale Ajit Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12972",
    "name": "Vashishtha Sharad Sudhir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12066",
    "name": "Abdul Zahidabanu Khatun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3332",
    "name": "Dhanave Dnyanu Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10059",
    "name": "Mistry Jayesh Nagindas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6686",
    "name": "Ghale Nilima Gulabsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3238",
    "name": "Shaik Shabuddin Magbul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9249",
    "name": "Kothari Anita Pushparaj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15871",
    "name": "Chavan Sulochana Vishnu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11879",
    "name": "Marwadi Surekha Chandrakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1076",
    "name": "Patil Pushpa Devidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8762",
    "name": "Sanas Suresh Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12006",
    "name": "Ajam  Mohammad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19162",
    "name": "Bhatt Leelabhai Karsanbhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21679",
    "name": "Mokaes Ignativs Malcolm"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19641",
    "name": "Patil Amit Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16183",
    "name": "Sawant Minal Manohar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1395",
    "name": "Upare Uday Vasudeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16847",
    "name": "Fofandi Hitesh Narayandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17132",
    "name": "Khude Dinkar Sawla"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16841",
    "name": "Masani Bharat Kanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10125",
    "name": "Nanaware Dnyaneshwar Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6417",
    "name": "Pandit Shyama Kewal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4442",
    "name": "Patil  R.Rekha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8640",
    "name": "Chawan Arvind Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3268",
    "name": "Gohil Chandulal B."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11791",
    "name": "Shah Teena D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17501",
    "name": "Kolekar Vitthal Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22400",
    "name": "Shaikh Altaf Anis Mohd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13553",
    "name": "Vaidya Rajendra Devravji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12008",
    "name": "Shah Premkumari Mohanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21947",
    "name": "Balsaraf Tejaswini Anant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12214",
    "name": "Jagtap Dattatray Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11283",
    "name": "Lodhia Rajesh J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14080",
    "name": "Zoharabi Mohmed Abdul."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14965",
    "name": "Desale Umesh Madhavrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10380",
    "name": "Khot Varsha Satyawan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18745",
    "name": "Yadav Satyanarayan Ramraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12801",
    "name": "Sagaonkar Surendra Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13272",
    "name": "Gupta Foolchand Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20723",
    "name": "Chogale Mithun Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17986",
    "name": "Saket Shankarlal Ramnihar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6130",
    "name": "Bhandari Kusum R."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5993",
    "name": "Yezarkar Sapana Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11841",
    "name": "Singh Geeta Khem"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1642",
    "name": "Salvi Dattatray Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19174",
    "name": "Javanjal Shobhana Vinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15109",
    "name": "Anadpara Pradeep Bhagwandas."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20366",
    "name": "Dixit Purshottom Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13048",
    "name": "Kendre Baban Dattarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3273",
    "name": "Tiwari Poonam Brijanandan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "552",
    "name": ".Keni Ramabai Moreshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23295",
    "name": "Dige Devendra Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17847",
    "name": "Rathod Kisan Tikiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16547",
    "name": "Yadav Ravindra Ramrup"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8135",
    "name": "Pawaskar Shailaja Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9236",
    "name": "Mhatre Hiraman Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23101",
    "name": "Desai Kiran Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19835",
    "name": "Gajbhiye Manda Vishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17821",
    "name": "Shroff Chirag J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9329",
    "name": "Tengaskar Sudhakar Sonaji/Prabhavati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3467",
    "name": "Gaglani Rajesh Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1262",
    "name": "Kadam Jaising Rangu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10574",
    "name": "Wagh Madhukar Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10134",
    "name": "Kadlag Kisan Ranganath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17987",
    "name": "Saket Ramdayal Rambhulan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18341",
    "name": "Khan Mohammed Shamim Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14028",
    "name": "Mistry Sangeeta Bharat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5263",
    "name": "Raut Prabhakar Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8057",
    "name": "Chanusingh  Sudhaisingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17546",
    "name": "Navab Ayyaj Alikhan Bhadekaru Sangtana N"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10509",
    "name": "Phadtare Shobha Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7903",
    "name": "Mascarendhas Eugene/Daphne"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13084",
    "name": "Manohar  K.M."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12812",
    "name": "Dasaram Mahalaxmi Ramu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19103",
    "name": "Chalwade Bhimrao Chandu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "791",
    "name": "Mukadam Sharada Pandharinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8853",
    "name": "Apte Vasant Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19990",
    "name": "Janjotri Paleram Rishal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13009",
    "name": "Qureshi Saira Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16853",
    "name": "Panchal Suhas Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5498",
    "name": "Parikh Usha Mahendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10933",
    "name": "Ramaiya Dineshchandra P/Hansa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15096",
    "name": "Shah Riddhi Kiran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13797",
    "name": "Shinde Arun Dinkar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19133",
    "name": "Yadav Rahul Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7487",
    "name": "Deora  Saroj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "662",
    "name": "Asitkumar  Aich."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3058",
    "name": "Khade Dasarath S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "941",
    "name": "Mahmed Sayyad Ahamed."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10002",
    "name": "Sawant Vivak Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14598",
    "name": "Godambe Vilas Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2752",
    "name": "Bharmal Yashwant Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20281",
    "name": "Akalujkar Ratnamala Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12798",
    "name": "Shukla Sharmila Roshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16039",
    "name": "Lad Nandkishor Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11459",
    "name": "Gujar Hirabai Narayan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9298",
    "name": "More Rajaram Danynu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10731",
    "name": "Mahadik Sharad Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10705",
    "name": "Dhawade Tukaram Babi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23490",
    "name": "Roowala  Shahid  Chahat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4085",
    "name": "Patkar Pandurang G."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8506",
    "name": "Dange Chandrakant Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21356",
    "name": "Rane Anil Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3238",
    "name": "Raut Vinaya Vijaykumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "787",
    "name": "More  Shantaram Ganpat More"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15355",
    "name": "Ranshevare Seema Harshad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18846",
    "name": "Sakunde Raju Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11183",
    "name": "Nawadakar Malati Madhavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6252",
    "name": "More Dagdu Ganpat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1433",
    "name": "Jukar Rahul Mukund"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15682",
    "name": "M  Subrsmniam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10422",
    "name": "Silwal Narendra Shivsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2551",
    "name": "Paryani Veena L."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11543",
    "name": "Prajapati Hasmukh Valjibhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18194",
    "name": "Gupta Satya Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16706",
    "name": "Sai Krupa Rahivashi Sangh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5402",
    "name": "Koraday Rajan Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18626",
    "name": "Bhatade Tukaram Vittal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11428",
    "name": "Naidu Balan Santhanraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15439",
    "name": "Patil Sudhir Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "555",
    "name": "Chavan Yogesh Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13298",
    "name": "Virbhadra Chandrashekhar A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7035",
    "name": "Virk Avtarsing Bansilsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1880",
    "name": "Bombay Sahakari Trading Co."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18029",
    "name": "Jadhav Vikas Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10335",
    "name": "Mistry Gulzarilal Chaganlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7472",
    "name": "Gajraj Nandkumar Shriwastav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6530",
    "name": "Patel Suresh Motibhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16691",
    "name": "Shejwal Suresh Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12207",
    "name": "Agarwal Dineshkumar Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12148",
    "name": "Jaiswal Vijayshankar Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1507",
    "name": "Jengid Sujandevi G"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7097",
    "name": "Palav Harshali Hemant/Hemant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16829",
    "name": "Samel Chandrakant Madan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20548",
    "name": "Sarvankar Ramesh Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22136",
    "name": "Shaikh Tajuddin Jhani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1803",
    "name": "Saroj Shamdhani Deonandan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14244",
    "name": "Jadhav Ramchandra Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13632",
    "name": "Dhanwade Tanaji Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9108",
    "name": "Patil Ashok Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14263",
    "name": "Shelar Shkuntala Govind."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4824",
    "name": "Mandhare Bhanudas Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16232",
    "name": "Bhuvad Narayan Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15854",
    "name": "Chavan Avinash Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7980",
    "name": "Ingawale Maruti Vtthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17440",
    "name": "Mandhre Prashant Surykant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20674",
    "name": "Shah Nalinchandra K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11917",
    "name": "Shaikh Shainaz Fahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3203",
    "name": "Fakir Mahmod Gulammohmamd Khaku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1604",
    "name": "Kapasi Ismail Akabarali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17902",
    "name": "Marathe Mangal Vithal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2220",
    "name": "Prajapathi Banarasilal Vikram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16161",
    "name": "Dedhia Dinesh Monji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2587",
    "name": "Rawal Prakash Shantilal."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18794",
    "name": "Ahir Lata Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12314",
    "name": "Chouhan Munshi Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17699",
    "name": "Pawar Shiwaji Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9548",
    "name": "Gaikwad Baban Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1002",
    "name": "Pingale Tukaram Rau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19519",
    "name": "Chheda Pradeep Hansraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5982",
    "name": "Jaiswal Bhupender Chandra Gupta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10634",
    "name": "Jain Shakuntala Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5486",
    "name": "Shedge Dnyaneshwar Vitthalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9905",
    "name": "Gujar Nivruti Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3331",
    "name": "Shah Subhadra Jaswantlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22816",
    "name": "Salunkhe Mangal Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9615",
    "name": "Shaikh Afzal Hussain Abdul Latif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15501",
    "name": "Bhosale Prabhakar Madhukar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22396",
    "name": "Morye Laxman Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2503",
    "name": "Dedhia Mukesh Talakshi."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5591",
    "name": "Jaiswal Amarnath Radheshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16416",
    "name": "Pawar Surekha Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10656",
    "name": "Singh Pravesh Ravindrapal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3133",
    "name": "Dacosta  Francis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3477",
    "name": "Yelve Pushpa Mohan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14787",
    "name": "Kharat Gangadhar Devidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15079",
    "name": "Pawar Raju Keraba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11160",
    "name": "Faria Manashi Lalji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9357",
    "name": "Marathe Laxman Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11123",
    "name": "Patel Ramila Jitendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "508",
    "name": "Sakubai Gangaram Jagtap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2968",
    "name": "Idankhan Abdul Majid"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1999",
    "name": "Dubal Baburao Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8948",
    "name": "Matkar Sanjay Shivaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1504",
    "name": "Chavan Machindra Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16392",
    "name": "Parab Tejaswini Sadanand."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17806",
    "name": "Passi Nandlal Rammurath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7395",
    "name": "Budhia Lalita Dayalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "467",
    "name": "Sardar Suresh Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13934",
    "name": "Bansal Praveenkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7598",
    "name": "T  Sundi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2768",
    "name": "Dixit Lilavati Bha ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17922",
    "name": "Dhobi Ranjit Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11174",
    "name": "Mandhare Sachin Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17243",
    "name": "Jaiswal  Ashishkumar  Jokhuprasad ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21686",
    "name": "Chakravarti  Saket"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13774",
    "name": "Bhosale Hausabai Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18037",
    "name": "Dhoke Parshuram Janrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14790",
    "name": "Manjrekar Arun Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11070",
    "name": "Sarkar  Madhu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22271",
    "name": "Shinde Pratibha Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11563",
    "name": "Soni Nayana Bipinbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11740",
    "name": "Ghadi Chaya Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17127",
    "name": "Mandave Baban Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12657",
    "name": "Shinde Ankush Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2362",
    "name": "Sindhal Gopalsinh Chahalsinh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19838",
    "name": "Sabale Chhaya Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6250",
    "name": "Sakate Shivaji Pundlik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11888",
    "name": "Pujari Suresh Siddu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17019",
    "name": "Mandvalkar Sudhir Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24096",
    "name": "Nationalist Youth Malad Dindoshi Taluka"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11604",
    "name": "Library Kajals Video"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2971",
    "name": "Katkar Raghunath Aabaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2319",
    "name": "Patil Ratilal Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23610",
    "name": "Patil Shankar Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13719",
    "name": "Shah Mohanlal Joharmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5208",
    "name": "Kabra Om Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10176",
    "name": "Purohit Lilavati Swarupram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16579",
    "name": "Pande Ramrangila Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15735",
    "name": "Parab Nagesh Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2323",
    "name": "Gaikwad Laxman Aanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1763",
    "name": "Salvi Kishor P."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13782",
    "name": "Achari Lilawati Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17045",
    "name": "Devkar Arvind Ganu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15438",
    "name": "Gupta Shyamlal Paltu."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5407",
    "name": "Barge Ramesh Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5749",
    "name": "Kanojia Ashokkumar V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12745",
    "name": "Shaikh Salima Baksuddin"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "119",
    "name": "Vishwakarma Sulekha Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8127",
    "name": "Yadav Rashmi Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3116",
    "name": "Raut Ramesh Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24039",
    "name": "Kevat Vinodkumar Buddhiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14492",
    "name": "Jadhav Yashoda P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18378",
    "name": "Maurya Satyprakash Ramlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4171",
    "name": "Rai  Shambhu."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18583",
    "name": "Sharma Ramchandra Bechai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14585",
    "name": "Manjrekar Arvind Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20138",
    "name": "Shirodkar Sudhir Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10790",
    "name": "Sing Sheshnath Badrinarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23164",
    "name": "Gaikwad Ravindra Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2834",
    "name": "Dherange Anand Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8689",
    "name": "Chawan Anandrao Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "976",
    "name": "Khopade Mukutrao Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8565",
    "name": "Shah Chetan Lalit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12512",
    "name": "Arora Jagmohan Singh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13190",
    "name": "Ghadge Bajirao Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13859",
    "name": "Gorivale Bharati Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23549",
    "name": "Malekar Saroj Dnyaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14938",
    "name": "Masarani Rajesh Mahendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5815",
    "name": "Jadhav Shivaji Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15979",
    "name": "E  Govindrajan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8034",
    "name": "Hasan  Shabbir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8399",
    "name": "Jain Lalitkumar Bastimal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11193",
    "name": "Joshi Pooja Manish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18432",
    "name": "Khamkar Shivaji Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2552",
    "name": "Chinchkar Deepak Muralidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14461",
    "name": "Bhosale Pralhad Daji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12072",
    "name": "Jaiswal Jaisuram Bapuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11440",
    "name": "Shekhar Nripanshu Shriharicharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17660",
    "name": "Ghatage Vilas Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16968",
    "name": "Katekar Babasaheb Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2298",
    "name": "Shrinath Gajanan Manaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1488",
    "name": "Surve Pourshottam Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13939",
    "name": "Chalke Vishwas Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12880",
    "name": "Mayur Vishram Parab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22049",
    "name": "Jaigade Vilas Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10708",
    "name": "Shinde Satish Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "447",
    "name": "Laxman Marotrao Dhoke."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18711",
    "name": "Sheth Mitesh Premchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14836",
    "name": "Tanawade Sandip Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4357",
    "name": "Magdum Pandurang Maruti."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21710",
    "name": "Arya Hemant Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13384",
    "name": "Bhalerao Kisan Bhagoji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1444",
    "name": "Pandit Ganesh Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8901",
    "name": "Phalke Dnyandeo Anandrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "766",
    "name": "Saud Khemsingh Gangasingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14189",
    "name": "Vyas  Vijaykumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16641",
    "name": "Yadav Rudal Tapshi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13085",
    "name": "Agarwal Asha Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7312",
    "name": "Vetkoli Pushpa Dutta."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4940",
    "name": "Doiphode Shalini Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5772",
    "name": "Bhosale Bhaskar B/Deepak K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16601",
    "name": "Bohora Sajjanraj Laxmichand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9215",
    "name": "Vishwakarma Devkabai Bansilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7420",
    "name": "Nerurkar Anant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1392",
    "name": "Keni Ramnath Damodar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1511",
    "name": "Kisan  Rangarao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1311",
    "name": "Aundhkar Archana Umakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22369",
    "name": "Chalke Sunita Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16875",
    "name": "Chavan Sadhana Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17727",
    "name": "Jadhav Mukud Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16795",
    "name": "Mistry Anita Chandsingh/Jambhale/Tripath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7411",
    "name": "Sarvajanik Ganeshostav Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20012",
    "name": "Soni Heena Kapoor"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1636",
    "name": "Yadav Sangeeta Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10186",
    "name": "Velhal Kusum Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4558",
    "name": "Ranjit  Chavbe"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1612",
    "name": "Mane Sulochana Balkrishna"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1281",
    "name": "Mahakal Suresh Pandurang"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1231",
    "name": "Mahale Dinesh Venkatesh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1323",
    "name": "Malpani Roopkishor Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8689",
    "name": "Kavthankar Sadhana Krishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13325",
    "name": "Mendon Shashikala Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13416",
    "name": "Nikam Laxman Rau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20686",
    "name": "Shelar Nitin Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10448",
    "name": "Yadav Dilip Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12889",
    "name": "Ohal Shankar Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8805",
    "name": "George Mersilin Stephen"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18855",
    "name": "Mistry Narmadaben Nagindas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10766",
    "name": "Patel Nigar Anjum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13826",
    "name": "Prabhuzatye Nitin Jayawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10889",
    "name": "Purohit Saitan Singh Pukhsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11830",
    "name": "Kendre Chakrapani Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15850",
    "name": "Khan Akbar Mustkin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22928",
    "name": "More Bhau Parasu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2642",
    "name": "Nakate Narmada Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4950",
    "name": "Kundlik Kashiram Varkhade"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7646",
    "name": "Pol Ramchandr Madan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8693",
    "name": "Sawant Vanita Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2194",
    "name": "Ahirekar Pandurang Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12379",
    "name": "Irani Sorabji Homi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1508",
    "name": "Konka Laxminarayan Ramaiah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23879",
    "name": "Singh Narendra Hauslaprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5060",
    "name": "More Sampat Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4748",
    "name": "Tahasildar Nasir Balamiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16736",
    "name": "Kusum"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9250",
    "name": "Kothari Neelam Pushparaj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21545",
    "name": "Chudasama Shruti Batuk"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23855",
    "name": "Keni Kailash Dnyaneshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13538",
    "name": "Pimple Usha Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13930",
    "name": "Mahadik Tukaram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13955",
    "name": "Dandekar Jitendra Ravindranath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15370",
    "name": "Bajwe Deepak Shankar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14297",
    "name": "Lembhe Ashok Raosaheb"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1345",
    "name": "Prajapati Biddhiram Rajbali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14446",
    "name": "Bhatde Sangeeta Lukaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8512",
    "name": "Kamble Raghunath Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10317",
    "name": "Khan Sharuddin Bassar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "358",
    "name": "Shinde Dnyandev Rakhmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15477",
    "name": "Pawar Jayshri Sandeep"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22753",
    "name": "Shah Meena Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8333",
    "name": "Ramni  Kojaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13237",
    "name": "Bhatade Namdeo Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21544",
    "name": "Khan Khushidabi Khaja"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "893",
    "name": "Patel Nirbhaykumar Ramprayag"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12391",
    "name": "Gadia Kailash Chand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15701",
    "name": "Ray Dinanath Chandravali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11918",
    "name": "Shaikh Chotu Nasruddin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1285",
    "name": "Gupta Chandan Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6560",
    "name": "Sharma Shanti Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4406",
    "name": "Musale Sunil Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3598",
    "name": "Manhot Sushil Kumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13172",
    "name": "Kale Vikram Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9676",
    "name": "Kapoor Vivek Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7163",
    "name": "Raut Ravindra Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6081",
    "name": "Tiwari S. B."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16207",
    "name": "Dadia Dharmesh D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11923",
    "name": "Kadam Tanaji Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14039",
    "name": "Yadav Rajendra Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7591",
    "name": "Ansari Mohmed Isaq Gulam Rasul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9625",
    "name": "Chavan Shrirang K/Ramesh A N/Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1011",
    "name": "Kadu Suresh Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "713",
    "name": "Bhosale Shyamrao Kundlik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8624",
    "name": "Gulambe Sahebrao Kondiba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1184",
    "name": "Joshi Nitesh Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23226",
    "name": "Poojary Krishna Uggappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14787",
    "name": "Pawar Rajendra Hariba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9177",
    "name": "More Deepak Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3979",
    "name": "Salunkhe Mandakini Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13761",
    "name": "Rajeghatage Vaibhav Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4657",
    "name": "Kadu Subhdra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23279",
    "name": "Gadre Santosh Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7005",
    "name": "Chavan Sunil Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5164",
    "name": "Kadam Dnyandeo Marutrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21435",
    "name": "Desai Aniket Annasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17827",
    "name": "Panday Vikrant Navnath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14432",
    "name": "Lohiya Amrita Kawr"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15479",
    "name": "Garud Mangala Anand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1295",
    "name": "Mhatre Vasant Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7617",
    "name": "Patade Shankar Samaji."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1514",
    "name": "Sonvane Prabhakar Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16712",
    "name": "Gurav Vipin Sunil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15229",
    "name": "Jain Kantilal V"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1095",
    "name": "Katta Sriniwas Kantaya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9252",
    "name": "Pisal Tatyaba Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5909",
    "name": "Shinde Arjun Vinayakrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18714",
    "name": "Nalawade Sanjay Ankush"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14759",
    "name": "Fernandes Cridon M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2711",
    "name": "Vaishnaw Kamaladevi Devidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5972",
    "name": "Chavan Bandu Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "790",
    "name": "Sangeeta Jewatraj Jain."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12201",
    "name": "Dhebare Avachit Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2065",
    "name": "Deole Deepak Murar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23662",
    "name": "Bhojane Avinash Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17753",
    "name": "Pawar Karunaratna Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7689",
    "name": "Pol Sarjerao Bayaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4479",
    "name": "Tawalkakhan  Chankhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10177",
    "name": "Jain Chandkumar H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1507",
    "name": "Bhosale Hanmant Krishnaraje"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7805",
    "name": "Kadam Shrikant Namdeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1010",
    "name": "Mane Tanaji Bajarang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5391",
    "name": "Sawant Manohar Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12423",
    "name": "Kasid Puja Pankaj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12386",
    "name": "Patil Hindurao Malu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1241",
    "name": "Davel Dattaram R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9012",
    "name": "Rane Ghanshyam Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5708",
    "name": "Gala Surji Khetshi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15204",
    "name": "Mishra Neerajkumar Dineshchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4181",
    "name": "Valanju Rajan Ramakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12976",
    "name": "Soni Manju Himmatlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14729",
    "name": "Jain Purnimakumari Amratlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8259",
    "name": "Saple Harishchandra Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11725",
    "name": "Shukla Bipinkumar Rajwali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18348",
    "name": "Mohite Abhishek Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9972",
    "name": "Mahadik Prabhvati Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3977",
    "name": "Suryawanshi Chandrakant Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23079",
    "name": "Arde Atul Anand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13926",
    "name": "Bhandlkar Hanmant Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23092",
    "name": "Dixit Ravikant Parsnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21868",
    "name": "Integrated Development Society"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23100",
    "name": "Salunkhe Anandrao Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22218",
    "name": "Tatkar Abhijit Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4103",
    "name": "Joseph Barrot Basco"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12075",
    "name": "Chatur Chandrabhaga Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16600",
    "name": "Building D-3 B Wing Sahyadri Nagar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "892",
    "name": "Ghanchi Babulal Bhaghaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "899",
    "name": "Mishra Vandana Avnish"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "842",
    "name": "Mistry Phularam Navaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13431",
    "name": "Pisal Dashrath Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2612",
    "name": "More Vimal Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15374",
    "name": "Kanojiya Bhagvatiprasad Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17182",
    "name": "Pradhan Birsingh Noutsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11998",
    "name": "Koyande Devendra Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15877",
    "name": "Prajapati Rambachan Banarashi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9465",
    "name": "Bappal Jayshree Vasant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "819",
    "name": "Behra Pramod Chintamani"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "759",
    "name": "Bone Datta Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20441",
    "name": "Gaikwad Swati Sandeep"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "748",
    "name": "Jaiswal Pankaj Munna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15736",
    "name": "Jaiswar Dudhanath Lochan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23019",
    "name": "Jajodia Poonam Deviprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23020",
    "name": "Jajodia Ravi Hariprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23426",
    "name": "Mistry Abdul"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "699",
    "name": "Pawar Ravindra Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14868",
    "name": "Shikhare Ajay Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23429",
    "name": "Singh Santosh Surendranath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10973",
    "name": "Mandhare Namdeo Sopanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16517",
    "name": "Aziz Abdul Rasid Shaikh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9721",
    "name": "Mulik Ankush Aburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5539",
    "name": "Yadav Gajanan Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2773",
    "name": "Patil Kashinath Shaniwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6790",
    "name": "Soni Ramesh Hasmukhlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22876",
    "name": "Jain Vanitakumari Shantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12569",
    "name": "Khan Abdul Sattar Mehandi Hasan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23184",
    "name": "Soni Minakshi Sanjay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22625",
    "name": "Deshmukh Shailaja C"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7049",
    "name": "Jadhav Pandurang Mahipati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5358",
    "name": "Gujar Subhash Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15159",
    "name": "Sawant Suresh Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11638",
    "name": "Dhumal Pandharinath Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1416",
    "name": "Tembwalkar Narayan Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19005",
    "name": "Lakhawade Sagar Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23306",
    "name": "Shinde Deepak Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9786",
    "name": "Vyas Vinay Ishwarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14912",
    "name": "Khan Abdulla S"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1065",
    "name": "Iyer Basu Raja"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "369",
    "name": "Sharma Santoshkumar Omkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7765",
    "name": "Kadam Mahesh Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19221",
    "name": "Jain Riya Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19222",
    "name": "Jain Saloni Shailesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1",
    "name": "Pawar Sameer Shivajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19195",
    "name": "Rathod Uttamchand Milpchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14406",
    "name": "Hodawale Santosh Janku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1260",
    "name": "Kadam Maruti Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1412",
    "name": "Yadav Ramshankar R."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5399",
    "name": "Vora Kapila Arunkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15792",
    "name": "Gajelli Girija Satyanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16615",
    "name": "Jain Kantilal Kalulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17802",
    "name": "Kudtarker Kishor Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5186",
    "name": "Shaikh Nuruddin Gysuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16869",
    "name": "Solkar Nilima Rajaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1781",
    "name": "Ravi K. G."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9764",
    "name": "Otavkar Aarti Arun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14472",
    "name": "Panhale Shyamsunder Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3228",
    "name": "Ashra Hiren Bhupatrai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4957",
    "name": "Phalke Sundarabai Madhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19333",
    "name": "Dhane Asmita Adhikrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11109",
    "name": "Bhilare Rajendra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20724",
    "name": "Choudhary Madanlal Lilarai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16127",
    "name": "Pilane  Dilip Waman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4821",
    "name": "Toraskar Bhikaji Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15424",
    "name": "Chikane Suresh Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4272",
    "name": "Thapa Tek Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12483",
    "name": "Bagdi Krishna Ishwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13167",
    "name": "Jambhale Prakash Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1599",
    "name": "Vadgave Ram Narayan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20421",
    "name": "More Kamlabai Moroo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16627",
    "name": "Pujari Kishore Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23191",
    "name": "Singh Shivprakash Udayraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20471",
    "name": "Varma Binu Kundan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16869",
    "name": "Bahutale Mahendra Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17227",
    "name": "Dodia Manoj Narayandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12527",
    "name": "Prajapti Sugeshkumar Chaturam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18240",
    "name": "Sheth Sagar Navinchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1870",
    "name": "Nagvekar Amrut G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22738",
    "name": "Jain   Mutha Devendrakumar Kantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21616",
    "name": "Jaiswar Lalaji Santlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10489",
    "name": "Konde Sushma Chandrashekhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9334",
    "name": "Shinde Laxman Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18770",
    "name": "Banner G.Rajan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18117",
    "name": "Bagkar Maniisha Devendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14763",
    "name": "Bahowmik Nirmalchandra Harandrachan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17228",
    "name": "Durafe Jagdish Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15928",
    "name": "Patel Maganlal Dulbhabhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9423",
    "name": "Salvi Sanjay Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17665",
    "name": "Shedge Mahadeo Dnyanoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16274",
    "name": "Tiwari Manojkumar Chhotelal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18904",
    "name": "Zanzane Santosh Yashawantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14609",
    "name": "Khale Prabhakar Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9874",
    "name": "Zha Binod Nathani"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2155",
    "name": "Sabale Bhimashankar Anand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17336",
    "name": "Jain Saklibai Jethmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4395",
    "name": "Varma Phulchand Srijasraj."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1089",
    "name": "Dhaka Lichhmanram Suganaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11976",
    "name": "Gupta Ram Kishan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14265",
    "name": "Aggarwal Mukund V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18462",
    "name": "Gupta Pradeep Ramdhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18805",
    "name": "Lembhe Sandeep Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21533",
    "name": "Dali Santosh Madhukar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "805",
    "name": "Jain Ashwin Kumar Champalalji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7524",
    "name": "Ramrekha  Ramsuresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5580",
    "name": "Banka Kantadevi Sajankumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1352",
    "name": "Vendge Harsh Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12599",
    "name": "Yadav Manrajidevi Ramkisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "494",
    "name": "Shinde Shamrao Govindrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6926",
    "name": "Wagh Baburao Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14600",
    "name": "Jain Bharat Jethamal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16884",
    "name": "Patil Devidas Buwaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14266",
    "name": "Agarwal Urmila"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11703",
    "name": "Salunkhae Kalavati Yadavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15720",
    "name": "Shinde Mohan Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11007",
    "name": "Bange Ratan S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8565",
    "name": "Jain Jagdish Chintamandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21523",
    "name": "Nikam Sunil Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21507",
    "name": "Tavhare Dattatray Dnyaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23005",
    "name": "Yadav Hanamant Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3433",
    "name": "Malbari Rashid Mohmed."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7234",
    "name": "Nagar Pradeep Dayashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16845",
    "name": "Palavi Vasant Bhoite"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3671",
    "name": "Singh Meghraj Hoshiar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10497",
    "name": "Bhosale Dnyaneshwar Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8767",
    "name": "Kapadia Mukund Vishweshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10836",
    "name": "Bhilare Maruti Ganpat/Sugandha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15909",
    "name": "Nikam Nilesh Bhikaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14680",
    "name": "Patel Asha Ramsurat."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1058",
    "name": "C M B Staff Welfare Committee"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17383",
    "name": "Choudhary  Jaiprakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5435",
    "name": "Jadhav Anandrao Dnyanu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1211",
    "name": "Bhosale Kakasaheb Rambhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12482",
    "name": "Bhosale Sampat Raghunath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2057",
    "name": "Shelke Sughanda Dayanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17732",
    "name": "Naik Samata Suryakant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15915",
    "name": "Shinde Shankar Tukaram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14411",
    "name": "Yadav Radhesham Brujlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16221",
    "name": "Bergal Narayan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15874",
    "name": "Kagada Sushila Rammehar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15078",
    "name": "Sawant Udhav Dayaghan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6011",
    "name": "Dhawade Pandurang Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6673",
    "name": "Baiude Tarini V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8649",
    "name": "Mulik Bhagwan Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15416",
    "name": "Mulla Shabnam Abdulmunaf"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19846",
    "name": "Pednekar  Sunita Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6720",
    "name": "Suryavanshi Rawan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17288",
    "name": "Choudhary Lila Ramlal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12210",
    "name": "Shinde Suresh Dadarao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "178",
    "name": "Chavan Neeta Sagar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8594",
    "name": "Dhumak Lata Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15744",
    "name": "Mehta Shobhanaben Shamjibhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21523",
    "name": "Thakulla Nar Dev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14248",
    "name": "Yelve Sugandha Sameer.."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "106",
    "name": "Pawar Kalpana Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18625",
    "name": "Dash Resmita Rajkishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5154",
    "name": "Jadhav Bhausaheb Ukaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13573",
    "name": "Agarwal Ghanshyam Babulaljee"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13674",
    "name": "Soni Baby (Babita) Laduram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12106",
    "name": "Raut Ramkumar Ramprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20123",
    "name": "Sawant Bharat Jyotiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19981",
    "name": "Yadav Ramchander Sobhanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19232",
    "name": "Yedege Baban Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16557",
    "name": "Suvarna Pratima A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15912",
    "name": "Chavan  Kantibabu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19953",
    "name": "Patil Ashok Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22771",
    "name": "Shaikh Shamim Bano Abid"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8574",
    "name": "Bobade Sharad Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4864",
    "name": "Shinde Baban Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5618",
    "name": "Sheikh Moh Yunus"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8964",
    "name": "Chendke Dattu Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22656",
    "name": "Kharwar Mitul Naresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "394",
    "name": "Chedda Kantilal Versi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10580",
    "name": "Waykar Khandu Shriram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8508",
    "name": "Bhanushali  Hastaben"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16290",
    "name": "Ghag Prakash Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16790",
    "name": "Jagtap Kiran Shyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8134",
    "name": "Kanse Balaso Dadaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18723",
    "name": "Shinde Janardhan Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10834",
    "name": "Sundary  Chandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5355",
    "name": "Dalvi Kishor Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11848",
    "name": "Agarwal Shailesh V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20428",
    "name": "Prabhulkar Anant Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21112",
    "name": "Ameya Co Op Housing Society"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1292",
    "name": "Khan Mohdali Hameed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15407",
    "name": "Pawar Dhananjay Trimbak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14424",
    "name": "Rane Rajendra Kesev."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11411",
    "name": "Kurlekar  Sunita/Anisha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23555",
    "name": "Shetty Jayaram Anand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10921",
    "name": "Gavali Asha Arun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11334",
    "name": "Patil Shivaji Ishwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11216",
    "name": "Chouhan Lalaji Ghure"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2092",
    "name": "Shinde Dattatray Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14319",
    "name": "Shinde Eknath Nathuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22938",
    "name": "Siddiqui Farooque Ahmed Akil Ahmed"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "134",
    "name": "Vaidya Purnima Pranay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12856",
    "name": "Yelve Samir Sashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17552",
    "name": "Motewad Subhash Babarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1345",
    "name": "Sable Ramdas Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6987",
    "name": "Shaikh Hanif Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3114",
    "name": "Khude Maruti Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20075",
    "name": "Saigaonkar Santosh Datta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "136",
    "name": "Keshav Ganpat Patil."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10981",
    "name": "Mali Ramesh Kumar Fattaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19340",
    "name": "Bhaskar Subba Chandan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14998",
    "name": "Solanki Hitesh Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12745",
    "name": "Matre Kundalik Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9388",
    "name": "Gaikwad Vinayak Narsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13951",
    "name": "More Kashinath Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10512",
    "name": "Sharma Hirdaynarayan K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4231",
    "name": "Fernandes  Felicidada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15285",
    "name": "Manuskare Ananda Nivrutti."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5517",
    "name": "Shah Usha Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17956",
    "name": "Baretha Lalmohan Vishwanath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4137",
    "name": "Patkar Kantilal Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7470",
    "name": "Ahmed Sayyad Nisar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "838",
    "name": "Mohalik Chittaranjan Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18954",
    "name": "Patil Krishna Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10451",
    "name": "Shetty Balkrishna Sanjiva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16057",
    "name": "Waghmare Rupali Sudhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4590",
    "name": "Bhurke Prakash V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9552",
    "name": "Belvalkar Saroj Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13639",
    "name": "Chavan Chandrakant Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9169",
    "name": "Jain Suresh Kumar A."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3177",
    "name": "Bhosale Aatmaram Rangarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13146",
    "name": "Yadav Gorakhnath Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13945",
    "name": "Taparia  Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7911",
    "name": "Shinde Vijay S/Pragati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20774",
    "name": "Hande Sachin Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15729",
    "name": "Pande Parshuram Premnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5184",
    "name": "Patil Vishnu Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14850",
    "name": "Rathod Himmat Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8843",
    "name": "Shaud  Danbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11336",
    "name": "Shetty Shilpa Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19200",
    "name": "Shirodkar Prathamesh Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14833",
    "name": "Vaidya Vijay Sukhdev."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10815",
    "name": "Chaturbhurandas  Ramadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9992",
    "name": "Shinde Shubash Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7294",
    "name": "Skaipwala Triliki Huttarsih"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2351",
    "name": "Kamble Dattaram Laxman."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15836",
    "name": "Chavan Tanaji Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6327",
    "name": "Gardade Subhash Jannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1196",
    "name": "Gurad Vasudev Nana."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14643",
    "name": "Patare Ashish Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4947",
    "name": "Shinde  Shyam Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "837",
    "name": "Pawar Tanaji Ganpat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1101",
    "name": "Momin Abdul Rahim Abdul Karim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11069",
    "name": "Salunkhe Bharat Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17816",
    "name": "Kondalkar Sushama Namdev."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8747",
    "name": "Bhoite Arjun Pandurang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1617",
    "name": "Bagadi Rahul Narendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21875",
    "name": "Daptare Sandesh Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21825",
    "name": "Pagare Pandurang Yashwant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "349",
    "name": "Ram Rajendrakumar Doman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17477",
    "name": "Sen  Mithalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14448",
    "name": "Gupta Brijmohan Deenalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7695",
    "name": "Doke Nivruti Chimaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22466",
    "name": "Bavishi Taraben Khushalchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21795",
    "name": "Ghulghle Vilas Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21752",
    "name": "Suradkar Ravindra Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3431",
    "name": "Vijaybhadur  Mangalprasad."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4533",
    "name": "Ganje Sardar Basappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1880",
    "name": "Gonsalves Philip Pascol."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14862",
    "name": "Agarwal Kanta Vinod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22176",
    "name": "Choudhary Budharam Swarupji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17274",
    "name": "Kishore Ashutosh Srishivbachanbhagat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16501",
    "name": "Musale Vikram Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10704",
    "name": "Patil Shakuntala Nandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22136",
    "name": "Salunkhe Ajit Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6092",
    "name": "Sathe Ashok Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9221",
    "name": "Lodh Ajay Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2514",
    "name": "Utekar Santosh Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18878",
    "name": "Pawar Alka Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2800",
    "name": "Ugale Bhagwan Eknath ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22602",
    "name": "More Vijay Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22448",
    "name": "Nagori  Mohamad Shafi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22086",
    "name": "Desmukh Nirmala Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20016",
    "name": "Singal Ranchhod Khoda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13101",
    "name": "Durgavale Dashrath Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17968",
    "name": "Gautam Hrudairam Zabbar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13984",
    "name": "Parab Manish Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16858",
    "name": "Bhilare Maruti Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16056",
    "name": "Tate Sanjay Sharad."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "790",
    "name": "S Gajanan Bhau"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1039",
    "name": "Gupta Ravishankar Shivprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22065",
    "name": "Kalantre Vidya Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22044",
    "name": "Rajput Chetan Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17034",
    "name": "Shaikh Tajuddin Jiyauddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8414",
    "name": "Sheth Radhakrushna Jairam."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14212",
    "name": "Lembhe Dnyandev Malhari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12120",
    "name": "Matre Dnyanu Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10166",
    "name": "Parab Jyoti Harischandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13088",
    "name": "Gupta Arun Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7577",
    "name": "Musale Ramdas Rangrao/Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22036",
    "name": "Loke Mahadev Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6233",
    "name": "Hindule Baliram Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16527",
    "name": "Adbal Atmaram Bhiva /Asmita Atmaram Adba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8260",
    "name": "Arwari Satish Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20583",
    "name": "Bagade Ramesh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8275",
    "name": "Jadhav Anant Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22009",
    "name": "Keshari Shivprasad Balgovind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17287",
    "name": "Manihar Ajijul Rehman Shahjaha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8258",
    "name": "Sabale Balu Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8272",
    "name": "Satvase Sudhir Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8277",
    "name": "Sawant Mangesh Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8236",
    "name": "Jain Mulchand Bhaghaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3982",
    "name": "Lawand Ramakant Yadavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4569",
    "name": "Shirke Yashawant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19364",
    "name": "Pansare Babaji Ramdas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1398",
    "name": "Pawar Sunanda Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16985",
    "name": "Shinde Sagar Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15158",
    "name": "Bhoite Jaywant Krishnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21218",
    "name": "Nagora Prakash Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20202",
    "name": "Binu K Sankunny"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11621",
    "name": "Gupta Phoolchand Ramlagan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15617",
    "name": "Kasle Dharmendra Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21983",
    "name": "Vaity Prashant Moreshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11361",
    "name": "Bobade Laxman Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21147",
    "name": "Hassainar Kuloor Yousaf."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "104",
    "name": "Nayak Pavan Jagbandhu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14027",
    "name": "Mishra Vagish Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12374",
    "name": "Dolare Durray Mukhtar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16874",
    "name": "Jaiswal Mahendra Kumar Arya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11301",
    "name": "Reddy K.Laxmi V."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21135",
    "name": "Bomble Sanjay Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18662",
    "name": "Mane Vandana Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14283",
    "name": "Kadav Dattaram Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14298",
    "name": "Kadav Manohar Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15148",
    "name": "Kailash Purnwashi Yadav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18129",
    "name": "Singh Pravesh Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4122",
    "name": "Sawant Kamlakar Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8152",
    "name": "Datta  Subhasini"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20521",
    "name": "Pawar Ramabai Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21801",
    "name": "Sharma Meena Umesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "763",
    "name": "Nagade Pundlik Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6582",
    "name": "Jadhav Vithabai Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3551",
    "name": "Bharatiya Janata Party [Central Bombay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16235",
    "name": "Azavedo Rozario Francis"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7423",
    "name": "Malani Dwarka Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4362",
    "name": "Bhosle Vishwas Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11834",
    "name": "Kayandekar  Dattaram Bhiva"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12686",
    "name": "Pawar Salim Mushtaq"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20587",
    "name": "Waghdhare Manali Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9880",
    "name": "Thaker Kirti Baldeodas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21600",
    "name": "Nalage Hanmant Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12436",
    "name": "Khamkar Ramesh Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1093",
    "name": "Nalawade Gangaram Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6795",
    "name": "Dave Niranjan Ratanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16901",
    "name": "Shinde  Vilas  Shankar ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12730",
    "name": "Chavan Sarswati Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16011",
    "name": "Ahirekar Digambar Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8773",
    "name": "Choudhari Prakash Chimanaramji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7132",
    "name": "Totare Dattatray Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6596",
    "name": "Waz  Jenniter"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "610",
    "name": "Mardhekar Mahipati Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2384",
    "name": "Vedpathak Aruna P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6131",
    "name": "Shah Shailesh B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17792",
    "name": "Jadhav Virendra Hanamant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11982",
    "name": "Mahadik Shivaji Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14118",
    "name": "Magane Anil Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12933",
    "name": "Netra Nandkumar Bhatakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18678",
    "name": "Ujgare Nitin Vijayanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3453",
    "name": "Pednekar Mangala Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11345",
    "name": "Venkatamma  I/Ashappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6022",
    "name": "More Nayna Nandkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1495",
    "name": "Shirsekar Satish Vasudeo."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17769",
    "name": "Mestry Rahul Purushottam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20973",
    "name": "Naik Amarnath Ramdas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1409",
    "name": "Singh Vinaykumar Gorakh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10499",
    "name": "Parab Vanita Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16680",
    "name": "Bangar Suresh Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21443",
    "name": "Chawan Mangesh Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21493",
    "name": "Singh Jogindra Bhagvant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6810",
    "name": "Dalvi Dattatraya Keshavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17322",
    "name": "Gore  Yogesh  Maruti ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6184",
    "name": "Chavan Sashikant Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22114",
    "name": "Mewara Vikram R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6955",
    "name": "Ranka Ranjan Jeewatraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11150",
    "name": "Waghmare Chandrakant Mariba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6656",
    "name": "Jadhav Baban Genu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19464",
    "name": "Alli  Samad Anvar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16505",
    "name": "Borges  Rony"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20439",
    "name": "Mulik Gojiri Sampat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16077",
    "name": "Savla Niket Kantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18799",
    "name": "Advilkar Shruti Surendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23525",
    "name": "Gorule Dilip Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21385",
    "name": "Sayyad Julfequar Husain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22113",
    "name": "Shinde Bharat Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5848",
    "name": "Chavan Bharat Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5576",
    "name": "Darekar Mohan Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13099",
    "name": "Sharma Prakash Bhanubhakta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19773",
    "name": "Vazare Sagar Deepakrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6216",
    "name": "Waghmare Ashok Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21640",
    "name": "Bandekar Pooja Kishor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22743",
    "name": "Kadam Sunil Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6829",
    "name": "Singh  Sunit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17127",
    "name": "Tiwari Kapil Deo Brijnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7602",
    "name": "Bhasme Sanjay Murlidhar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4032",
    "name": "Lohar Dattatray Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16162",
    "name": "Borkar Pankaj Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20212",
    "name": "Ramani Praveen Kumar Nathmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16494",
    "name": "Rathod Nandini Sunil."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10766",
    "name": "Shah Narayandas V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4692",
    "name": "Shinde Mansing Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15862",
    "name": "Goden Revansidappa Mutali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "125",
    "name": "Shinde Shankar Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3953",
    "name": "Chavan Arjun Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4425",
    "name": "Coutinho  Pitar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7654",
    "name": "Pujari Loncha Tipanna."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23199",
    "name": "Rele Surekha Harish"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3888",
    "name": "Kambale Dhondiram Changadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20823",
    "name": "Shinde Sanjay Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1597",
    "name": "Karape Parshuram Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9026",
    "name": "Dingorkar Mandakini Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5878",
    "name": "Patil Varsha Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13202",
    "name": "Patil Vidit Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23137",
    "name": "Pawar Suvarna Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13036",
    "name": "Devraje Gojabai Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21786",
    "name": "Kakade Panchfula Kadoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16704",
    "name": "Pandey Shivkumar Maheshwar Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21221",
    "name": "Shelar Vinod Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4748",
    "name": "Jarandeshwar Maruti Devsthan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17617",
    "name": "Shah Sonal Kaumin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16663",
    "name": "Chavan Sunil Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11200",
    "name": "Bhosale Narendra/Rajendra Kamble/Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14866",
    "name": "Khatare Geeta Premnath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13731",
    "name": "Sagare Kavita Namdeo."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8621",
    "name": "Sable Hanmant Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1098",
    "name": "Lata Vasant Purohit."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4673",
    "name": "Shah Divya Chhotalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11531",
    "name": "Batre Arvind Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20965",
    "name": "E.Muthupandi  P.Elangamani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20971",
    "name": "Kesari Chanda Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18106",
    "name": "Ranka Harsha Mukesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6866",
    "name": "Patel Prakash Manilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14850",
    "name": "Maharashtra Vahatuk Sena"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6248",
    "name": "Dave Pravin Chhaganlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21766",
    "name": "Chavan Suresh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5890",
    "name": "Patel Chetna V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19359",
    "name": "Salunkhe Nilesh Narhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7857",
    "name": "Shah Reena Narendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8936",
    "name": "Gadhave Ransingh Krishnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13755",
    "name": "Ghadge Shila Gorakhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15994",
    "name": "Mane Eshamber Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10370",
    "name": "Saroj Veerbhan Satiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19092",
    "name": "Varekar Ramchandra Baburao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "619",
    "name": "Jadhav Prabhakar Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12155",
    "name": "Pitale Satish Ramnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12959",
    "name": "Mondal Monarangan Dhirenchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21472",
    "name": "Jajodia  Deviprasad  S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7209",
    "name": "Jilaka Bhupendra Mohanbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13163",
    "name": "Vaity Ansel Shalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13576",
    "name": "Gharve Rajesh Vaman."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6938",
    "name": "Ganvir Ramesh Sravan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6784",
    "name": "Pawar Pandurang Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17893",
    "name": "Gavade Vilas Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20791",
    "name": "Gupta Omprakash Shankarprasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20792",
    "name": "Kunjikanta Sudhir Mammalik."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13631",
    "name": "Lakhani Heena Shantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21792",
    "name": "Shinde Parsuram Janu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18271",
    "name": "Upadhye Anandkumar Balavant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15223",
    "name": "Marathe Darshana Chandrakant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1016",
    "name": "Kangralkar Mohan Payappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12590",
    "name": "Asarani Haresh Girdharilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18587",
    "name": "Yadav Ajit Ramashankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10583",
    "name": "Parmar Sharda Dhanraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10511",
    "name": "Nirmal Ramprasad Ramnivas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20743",
    "name": "Dete Dondiram Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2321",
    "name": "Mavinkurve Niranjan Mangesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8446",
    "name": "Doke Amit Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17861",
    "name": "Fernandes  Allwyn"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14173",
    "name": "Gala Khetbai Sundrji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14616",
    "name": "Jadhav Tukaram Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10649",
    "name": "Parab N.S./P N Malye"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14146",
    "name": "Pujari Surendra Ananad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4922",
    "name": "Oza Dineshchandra Hargovinddas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21186",
    "name": "Jain Vinod Sampatraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8800",
    "name": "Bhatnagar Vijay Swarup"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6487",
    "name": "Ravji Premji Bhadekaru Sangh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20593",
    "name": "Bagal Gautam Tulshiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20711",
    "name": "Dahije Baban Malhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20704",
    "name": "Dahije Prasad Malhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20688",
    "name": "Maniyar Niyaz Ahmed Peshkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20726",
    "name": "Panchal Gha Nshyam Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20696",
    "name": "Sawant Rupesh Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8372",
    "name": "Vawel Sashikala Lakshman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20707",
    "name": "Vishwakarma Premlal Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1717",
    "name": "Chhatbar Varsha Gunwantrai."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15809",
    "name": "Kadam Tatyaba Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15736",
    "name": "More Malti Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1991",
    "name": "Mandhare Balwant Khanderao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13218",
    "name": "Bhilare Anita Raghu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17263",
    "name": "Mane Sandhya Dadaso."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20604",
    "name": "Chauhan Ramugrah Sukhram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19606",
    "name": "Jadhav Trupti Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11344",
    "name": "Bandogonda Laxmi A/Ashappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15870",
    "name": "Lad Rajesh Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7408",
    "name": "Yadav Lal Shivmangal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "795",
    "name": "Dilip Shankar Bangar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4211",
    "name": "Mehata Vasantrao K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "812",
    "name": "Shankar Rambhau Salve."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20514",
    "name": "Bhawar Ankush Bhanudas."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15636",
    "name": "Chalke Vasant Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22680",
    "name": "Rawal Sureshkumar V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5525",
    "name": "Chavan Pandurang Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8453",
    "name": "Joshi Champalal Bhimshankar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11973",
    "name": "Goel  Anand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15214",
    "name": "Lotlikar Jaya Suhas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16292",
    "name": "Sancheti Snehalata Hastimal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20805",
    "name": "Kharat Achit Sheshrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13336",
    "name": "Patil Neelima Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16913",
    "name": "Ramdyal Dinnanath Vishavakarma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17120",
    "name": "Shetty Prabhakar Bhoja"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12640",
    "name": "Shinde Pramod Shankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "387",
    "name": "Vasandani Chander Naraindas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9542",
    "name": "Shah Ketan B/Jasmina"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2495",
    "name": "Disale Dnyandeo Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10702",
    "name": "Puradkar Pramod T/Priyanka"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14996",
    "name": "Agarwal Anilkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21243",
    "name": "Nivendikar Baban Shreedhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4059",
    "name": "Patel Kantaben Arjunbhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11321",
    "name": "Singh Rajesh Chandrika"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20163",
    "name": "Shinde Mahendra Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14990",
    "name": "Kadam Vikas Vinayak"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "257",
    "name": "Khan Mahammed Abrar Mahammed Nisar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12578",
    "name": "Prasad Bhiharilal Ayodhya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8228",
    "name": "Yadav Rajkumar B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8812",
    "name": "Kolekar Kishan Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12060",
    "name": "More Shubhangi Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17801",
    "name": "Patel Shilpa Chhabildas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13657",
    "name": "Shinde Ashalata Sahebrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8494",
    "name": "Dube Chitamani Chandraprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13144",
    "name": "Parab Neha Nagesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7309",
    "name": "Abdin Mohmed Zainal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12006",
    "name": "Chavan Vithal Ekanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20354",
    "name": "Kadam Suvarna Kalidav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7074",
    "name": "Kanchan Yashoda Tilak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16194",
    "name": "Koli Hemalata Vidhyadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13581",
    "name": "Shantharaj Hebbalr Devaraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11096",
    "name": "Makwana Mahendra Ravji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1097",
    "name": "Mukesh Vasant Purohit."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3283",
    "name": "Ganerwala  Rameshkumar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16457",
    "name": "Kothari Tarabai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21844",
    "name": "Yadav Nanaso Vyankat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20779",
    "name": "Raje Ankita Dhananjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22675",
    "name": "Prabhodhankar Yuva Mitra Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "340",
    "name": "Tawade Mrunalini Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7766",
    "name": "More Shashikant Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1321",
    "name": "Wagh Pratapsing Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15876",
    "name": "Jadhav Umesh Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "694",
    "name": "Navanath  Panday."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19372",
    "name": "Sawant Reshma Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14462",
    "name": "Jamadar Ashok Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21969",
    "name": "Sawant Ramchandra Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20196",
    "name": "Suresh Kunnath Ramakrishnan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16417",
    "name": "Mohamad Ilias Mohammed Hagij Khan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8875",
    "name": "Jain Rajeshkumar Gyanchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23204",
    "name": "Waghule Dipak Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8165",
    "name": "Chorge Sampat Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12638",
    "name": "Sajgane Kamal Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14527",
    "name": "Sottany Praful Udairaj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7145",
    "name": "Patel Saroj Anjum"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12388",
    "name": "Phalke Sandeep Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17131",
    "name": "Walankar Manisha Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9650",
    "name": "Dixit Rajeshkumar Satyanarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10431",
    "name": "Kansara Sanjay Jaysukhlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16917",
    "name": "Kini Jaywant Ganpat."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22594",
    "name": "Satapathy Sachidananda Harihar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11513",
    "name": "Yadav Rammurat Ramlakhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7346",
    "name": "Pandya Ishwarlal Somnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21796",
    "name": "Yadav Umesh Vijaynath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11978",
    "name": "Chavan Nandini Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6995",
    "name": "Jadhav Sambhaji Tukaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "543",
    "name": "Kokare Rajendra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19944",
    "name": "More Pravin Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19912",
    "name": "Saroj Suganthi Lalman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12286",
    "name": "Shaikh Zakir Husain"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7251",
    "name": "Kamble Damyanti Harishchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18766",
    "name": "Sabale Kiran Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16471",
    "name": "Gaonkar Nandkumar Ravaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19337",
    "name": "Pawar Vaishali Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18813",
    "name": "Chawan Amita Yashvant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11616",
    "name": "Gade Balvant Ramachandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18176",
    "name": "Jain Atulkumar Pukhraji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19317",
    "name": "Jain Gaurav Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15140",
    "name": "Shah Ushaben Uttamchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15816",
    "name": "Shengale Nileema Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8421",
    "name": "Sawant Neela Kamlakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17423",
    "name": "Gajmal Gopal Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13171",
    "name": "Jadhav Sampat Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5814",
    "name": "Kanojiya Devaki Jamnaprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16831",
    "name": "Shirke Giridhar Diwanji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10001",
    "name": "Bhosale Hanmant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13239",
    "name": "Patil Shailesh Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12460",
    "name": "Kambale Rajendra Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20411",
    "name": "Pawar Pravin Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18184",
    "name": "Bane Ramakant Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19097",
    "name": "Khot Ambirao Bhausaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14863",
    "name": "Agarwal Vaijanti Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "217",
    "name": "Lakav Gangaram Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15846",
    "name": "Mehta Anarchand Laxmichandji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5987",
    "name": "Weshvikar Neeta N"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2640",
    "name": "Aavhad Narayan Ankush"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12061",
    "name": "Gandhi Shikha Parag"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16670",
    "name": "Khamkar Bhaskar Kisan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7074",
    "name": "Chikane Tukaram Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13379",
    "name": "Beldar Dasrath B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9493",
    "name": "Nalawade Sudeepta Harischandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19845",
    "name": "Motewad Sangeeta Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8938",
    "name": "Vora Dharamshi Somchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19532",
    "name": "Shaikh Mohd. Irfan Islam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4066",
    "name": "Bhosale Pradeep Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13081",
    "name": "Bhoite Devidas Dasharath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16246",
    "name": "Fernandes Jacob Milagres"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6128",
    "name": "Solke Kailas Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11361",
    "name": "Kothari Rakesh Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21500",
    "name": "Jaiswal Shailesh Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21322",
    "name": "Bambarkar Manisha Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13592",
    "name": "Raut Rajkumar Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21773",
    "name": "Pawar Yogesh Pandurang."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10038",
    "name": "Gaikwad Ashalata Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14787",
    "name": "Jain Dhiraj Devrajji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12395",
    "name": "Porwal Jayashri Devichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12331",
    "name": "Jain Prakashchandra Jethmalji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12220",
    "name": "Sawant Sandesh Madhusudan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8581",
    "name": "Sakpal Poonam Baliram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4654",
    "name": "Gohil Divali Damji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19566",
    "name": "Chheda Minal Bhavin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19594",
    "name": "Sawant Rajaram Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1466",
    "name": "Vakhe Ganesh Hamberao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13437",
    "name": "Kadam Narayan Aba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19599",
    "name": "Dhanawade Kailash Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9679",
    "name": "Pisal Sampat Bandoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17741",
    "name": "Pawar Popatrao Janu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19497",
    "name": "Adhikari Lata Sharad"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1223",
    "name": "Chavan Hobu Umala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7875",
    "name": "Dsouza  Premila/Manoj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19595",
    "name": "Gavhale Rajesh Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19460",
    "name": "Muchadiya Manjit Pitha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14865",
    "name": "Pansare Santosh Ramnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3118",
    "name": "More Maruti Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13364",
    "name": "Beldar Barsatiram Bachulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18349",
    "name": "Niskul Nivruti Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6643",
    "name": "Kadam Uttam Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16857",
    "name": "Yadav Vinayak Abasaheb ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16837",
    "name": "Tawade Dattatray Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13454",
    "name": "Sonawane Pundalik Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19833",
    "name": "Kasbe Bapu Shayam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21978",
    "name": "Purbiya Suresh Himmat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16442",
    "name": "Purohit Jabarsingh D."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19389",
    "name": "Sharma Vidhyavati Vyas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13244",
    "name": "Kulaye Rajaram Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21326",
    "name": "Chuadhary  Rajendra  Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12765",
    "name": "Khan Farida Firoj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9738",
    "name": "Mali Radhyesham Niraprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8001",
    "name": "Joshi Mitali Mahendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10659",
    "name": "Bohara  Vimladevi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19011",
    "name": "Jain Sangeeta Sampatkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10103",
    "name": "Davda Suresh V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12651",
    "name": "Jain Pritesh Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19307",
    "name": "Sylas Manas Maris"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11942",
    "name": "Bhanushali Devji Deyat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20239",
    "name": "Paul Alok Kalyan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7206",
    "name": "Gharge Baban Janardan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20150",
    "name": "Shetti  Mohandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7296",
    "name": "Malde Motichand Rauji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15389",
    "name": "Mahalley Shalini Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20579",
    "name": "Patel Jayshree Manoj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17774",
    "name": "Naik Harish Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6062",
    "name": "Gupta Hariprasad Parmanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21466",
    "name": "Katke Anand Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18896",
    "name": "Lawrence Celine Raphal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16802",
    "name": "Solanki Kishoresingh S"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7869",
    "name": "Shirtode Jairam Aaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7518",
    "name": "Waman Sitaram Sawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19820",
    "name": "Mane Lav Babanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18666",
    "name": "Potdar Rachana Ketan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18595",
    "name": "Kakade Pravin Hanuman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8718",
    "name": "Sakharkar Vasant Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4099",
    "name": "Bobade Bhimrao Nagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16943",
    "name": "Kirjat  Rajendra Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5500",
    "name": "Sawant Archana Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10094",
    "name": "Tiwari Kailashchand Nandkishore"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "598",
    "name": "Jadhav Usha Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13136",
    "name": "Oza Chandrika Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11427",
    "name": "Agarwal Mamta Pukhraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12139",
    "name": "Ansari Abul Hassan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20098",
    "name": "Sharma Rakesh Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11924",
    "name": "Shinde Vijay Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5018",
    "name": "Nalawade Dhondiram Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7591",
    "name": "Pawar Pandurang Bhagwanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19784",
    "name": "Jakhar Ramdev Bhagwanaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18086",
    "name": "Karnalu Pushpa Appa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12629",
    "name": "Malvankar Ramchandra Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8391",
    "name": "Shetty Shankappa Luka"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16846",
    "name": "More Maruti Shravan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22273",
    "name": "Mulani  Abdul Chaund ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16995",
    "name": "Jain Vikas Paras"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9498",
    "name": "Shah Nandkuvarben Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3360",
    "name": "Bagal Satish Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8606",
    "name": "Panchal Ganpat Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13301",
    "name": "Baldia Aditya Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3139",
    "name": "Sevani Ramesh Dhumandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "266",
    "name": "Shinde Netaji Jyoti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7981",
    "name": "Goutam Jai Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19388",
    "name": "Joshi Swapnali Dhaku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6246",
    "name": "Yadav Haridas Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6227",
    "name": "Phalke Vikram Sureshrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15513",
    "name": "Jaiswal Sabhajit Mahabali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18448",
    "name": "Vaiti Manisha Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9536",
    "name": "Varugese Antony John"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4315",
    "name": "Gangurde Shobha Madhav."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8424",
    "name": "Yadav Shrirang Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9555",
    "name": "Dhebare Deepak Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "547",
    "name": "Mahadev Dattatray Shirke"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18856",
    "name": "Bhandari Kalpana Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19753",
    "name": "Bhandari Namdev Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20951",
    "name": "Gawali Sheela Nilesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10772",
    "name": "Singh Indubala R."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "750",
    "name": "Waghe Ganesh Mangu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5925",
    "name": "Phalke Sudha Avinash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10585",
    "name": "Sharma Jyoti Prahladrai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2970",
    "name": "Bhosale Namdeo Raghu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6800",
    "name": "Solanki Jayanti Damajee ."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11236",
    "name": "Bobade Dattatray Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17564",
    "name": "Kandel Bishnu Tulshiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18807",
    "name": "Pujari Dejappa Kunkara"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5788",
    "name": "Dhumal Sitaram Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "799",
    "name": "Asangihal Basappa Bhogappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16841",
    "name": "Anaji Ramchandra Bavkar /Kalawati Anaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19571",
    "name": "Mansuri Mohd. Isaqu Akabarali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6660",
    "name": "Pandey Ravishankar Suryabali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17257",
    "name": "Priyadarshini  Vidyamandir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "852",
    "name": "Bhoite Baburao Madhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18753",
    "name": "Jagtap Deepak Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15850",
    "name": "Khade Anjana Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18748",
    "name": "Manas Shailesh Marias"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4608",
    "name": "Patil Harishchandra Damodar/Mr.Haresh D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18756",
    "name": "Shah Prajesh Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14469",
    "name": "Shettiyar Angama Subramanyam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10603",
    "name": "Ranjankar Maruti Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1211",
    "name": "Solanki Jayesh Damji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21347",
    "name": "Joshi Chetan Mangilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19009",
    "name": "Kadwadkar Sanjivani Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14899",
    "name": "Mahamad Qyyum Ansari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17515",
    "name": "Shah Jyotika M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2795",
    "name": "Disoza Paskol Huming"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18694",
    "name": "Khan Shameem Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8720",
    "name": "Dalavi Lochana Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10715",
    "name": "Rajane Sandeep Ragunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17693",
    "name": "Mahadik Raju Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15771",
    "name": "Kadam Rajesh Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21441",
    "name": "Chauhan Bishnudhari Naresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8358",
    "name": "Chavan Maruti Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13475",
    "name": "Gandhi Haresh Narayandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13895",
    "name": "Jadhav Kondiba Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7550",
    "name": "Banshraj Ramsingh Puta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18402",
    "name": "Kadam Tukaram Kalu.Mr Salate Annda Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4610",
    "name": "More Samadhan Vamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5776",
    "name": "Phadtare Sunil Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10133",
    "name": "Pisal Chandrakant Daulat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5171",
    "name": "Jundhare Sindhu Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18152",
    "name": "Maorya Chandram Hiraman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17981",
    "name": "Narkar Nanda Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12229",
    "name": "Rewale Chandrakant Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9404",
    "name": "Shahabadkar Satish Malappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10297",
    "name": "Shukla Ramesh Jawaharlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6584",
    "name": "Gawade Shrikrishna/Nandu Bagawe/Ashok Ka"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9728",
    "name": "Soni Gulab Balchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1520",
    "name": "Hande Jagannath Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18172",
    "name": "Shinde Mahesh Chatarbhuj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15188",
    "name": "Jain Manish Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8957",
    "name": "Choudhari Shyam Kripalsingh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "702",
    "name": "Kamble Subhash Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12684",
    "name": "Gaikwad Manoj Shashikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19291",
    "name": "Hule Maruti Dnyaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9999",
    "name": "Tharthare Sonal Nishikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13294",
    "name": "Sharma  Rajesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8801",
    "name": "Kaushik Mahesh Chandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20613",
    "name": "Choursiya Gayaprsad Lakshminarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13861",
    "name": "Satyanarayan  Kantadevi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6953",
    "name": "Tawade Shalini Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5893",
    "name": "Mathurdas Bhaktidas Dudhelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20795",
    "name": "Chavan Reshma Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2802",
    "name": "Desai Sharadadevi Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16966",
    "name": "Desai Ankita Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8427",
    "name": "Logh Dasharath Raghubar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18699",
    "name": "Tiwari Kanti Sheshmani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11857",
    "name": "Waghela Pratap Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13846",
    "name": "Ghadi Ajay Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20081",
    "name": "Yadav Rajendra Parasnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10198",
    "name": "Ghadge Baban Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19961",
    "name": "Manjrekar. Prajit Suhas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20732",
    "name": "Jain Anju Ashok"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "424",
    "name": "Dodhiya Chetan Prabhulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8886",
    "name": "Sharma Chandri Datta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10209",
    "name": "Tarade Nalini Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4105",
    "name": "Kadu Digambar Pundlik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16309",
    "name": "Tibrewala Anandkumar Jagmohanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2532",
    "name": "Palav Arun Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18644",
    "name": "Bobale Nathu Khandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6957",
    "name": "Ranka Sunita Kumari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12756",
    "name": "Lawand Seema Ramakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4191",
    "name": "Kandalkar Anuya Ajitkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6013",
    "name": "Bhosale Mahadev Appaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16337",
    "name": "Sankpal  Suhasini Dahrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5480",
    "name": "Vashishta Renu Anilkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11917",
    "name": "Khopade Dattatray Narayanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14541",
    "name": "Petkar Nathu Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16906",
    "name": "Sahu Devlal Vishand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21031",
    "name": "Bhatt Manish Girdharlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16246",
    "name": "Khan Muhammad Tafsir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5245",
    "name": "Nena Devaji Meghji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15938",
    "name": "Pobari Ghanshyam Harilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6893",
    "name": "Kotvadekar Umesh Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9666",
    "name": "Katkar Suresh Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13287",
    "name": "Pawar Sabbir Mustaq"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11198",
    "name": "Chavan  Gajanan  Gopal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17894",
    "name": "Waghela Pravin Dhanji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8144",
    "name": "Sonawale Ratnakant Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3050",
    "name": "Kalambe Dattatray Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9827",
    "name": "Chigekar Devayya Narsayya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18325",
    "name": "Desai Jayesh Mohanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15930",
    "name": "Sangani Ramesh V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12388",
    "name": "Lad Mangesh Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14099",
    "name": "Mishra Bhimsen S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19023",
    "name": "Shaha Minbahadur Padmabahadur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16201",
    "name": "Shelar Lahu Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15603",
    "name": "Purohit Gayatri Vasantsingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18939",
    "name": "Gaikwad Sangeeta Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5560",
    "name": "Chotia  Pawankumar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19255",
    "name": "Bhatt Vijay Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10777",
    "name": "Anawat  Husain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1371",
    "name": "Gardi Maruti Buvaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8472",
    "name": "Rout Mahendra Pralhad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10389",
    "name": "Chokshi Mukesh D/Smita"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9584",
    "name": "Durgamata Mandir Trust"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16968",
    "name": "Kadam Nilesh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10000",
    "name": "Tharthare Kanchan Nishikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8577",
    "name": "Patil Seema Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17110",
    "name": "Raje Rajaram Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15371",
    "name": "Shinde Sitaram Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14800",
    "name": "Brid Rajesh Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12100",
    "name": "Chavan Arvind Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6588",
    "name": "Chougule Margret Ujwalkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14569",
    "name": "More Aabaji Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20582",
    "name": "Udyavar Sudarshan Ramappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4155",
    "name": "Trivedi  Dharmadevi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17366",
    "name": "Jain Futarmal K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18238",
    "name": "Mascarenhas Alka John"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7872",
    "name": "Patel Ramjee Ladhaa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4406",
    "name": "Jagtap Vijaykumar Sampatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20475",
    "name": "Jadhav Ashok Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8020",
    "name": "Sonawane Prakash S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14448",
    "name": "Modi Reshma Bhupendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18168",
    "name": "Sankhe Sitaram Yeshawant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11615",
    "name": "Agarwal Kirankumar Pukhraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5187",
    "name": "Shingare Vaishali Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5596",
    "name": "Pawar Pravin Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15064",
    "name": "Ahamed  Nisar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5535",
    "name": "Raikar Ajay Vyankatesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18074",
    "name": "Dondkar Shantaram Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11155",
    "name": "Kadam Pravin Narasu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17795",
    "name": "Nimbalkar Shital Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17647",
    "name": "Sarica  Raghunath Zimur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17648",
    "name": "Zimur Manisha Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10263",
    "name": "Kaushik  Yogesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5655",
    "name": "Sharma Prem C"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19836",
    "name": "Siddiqui Insaf Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8890",
    "name": "Shinde Nikita S./Subhash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7365",
    "name": "Arothe Sudam Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17580",
    "name": "Shah Piyush Arvindkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10477",
    "name": "Kadam Gautam Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21586",
    "name": "Mishra Vandana  N &Mishra Archana N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6668",
    "name": "Pawase Namdeo Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13865",
    "name": "Ansari Mustaq Ahmed."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15081",
    "name": "Yadav Nanhelal Sahdeo."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8305",
    "name": "Kolekar Vithal Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17242",
    "name": "Ghadge  Dhanaji  Maruti ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12281",
    "name": "Shaikh Asif Zulfekar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21062",
    "name": "Shaikh Shahnaz Abdul Jabbar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8830",
    "name": "Chorge Narayan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7154",
    "name": "Charkop I  Sect-02 Sarvjanik Ganesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15744",
    "name": "Shinde Ramesh Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13147",
    "name": "Khan Barkat Asraf Abbas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20448",
    "name": "Motiwaras Pankaj Narsinha & Motiwaras A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10518",
    "name": "Ubale Balkrishna Lahu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5221",
    "name": "Shirodkar Anand Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21062",
    "name": "Gawnuk Dilip Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12100",
    "name": "Nimbalkar Vijaykumar Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7763",
    "name": "Patade Deepa Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12677",
    "name": "Shete Suresh Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21362",
    "name": "Soni Karansingh Dhansingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15228",
    "name": "Bhate Vijaykumar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16666",
    "name": "Nimbalkar Phulabai Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3420",
    "name": "Kolekar Saibai Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17363",
    "name": "Utekar Sangeeta Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7488",
    "name": "Jhon  Rajiyan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10770",
    "name": "Raithatha Vasantray Kanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1276",
    "name": "Patil Arvind Nana ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23328",
    "name": "Shaikh Rehana Mohammad Ghous"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9252",
    "name": "Ankam Suvarna Jayant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15551",
    "name": "Gaonkar Santosh Anand/ Sanjana Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8336",
    "name": "Pande  Bachhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "38",
    "name": "Ahirekar Dilip Vithalrao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "443",
    "name": "Rasal Krishna Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19924",
    "name": "Jadhav Dattatreya Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2940",
    "name": "Bhutal Pandurang Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10411",
    "name": "Sav Nashtar Bijo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1119",
    "name": "Kolage Bhalchandra Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20276",
    "name": "Jadhav Abhijit Murlidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20154",
    "name": "Patil Vitthal Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17598",
    "name": "Rathod Priti Hiren"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "875",
    "name": "Manohar Bhau Jadhav."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8766",
    "name": "Kapadia Chetankumar Mukund"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17644",
    "name": "Kavali Rajani Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17646",
    "name": "Kavali Suresh Jairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20636",
    "name": "Khan Husana Ali Banu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17645",
    "name": "Vartak Vilas Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7692",
    "name": "Veer Ramchandra Ganpati."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15067",
    "name": "Tamang  Leela"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11554",
    "name": "Jain Mahendrakumar M"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20578",
    "name": "Darekar  Mohini  Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14629",
    "name": "Desai Arvind Lavji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4981",
    "name": "Kadam Suman Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6414",
    "name": "Sattar Shaikh Mohammed Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1509",
    "name": "Mane Pralhad Ashroba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5461",
    "name": "Dhotre Baliram Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19709",
    "name": "Kirtonia Manju Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7906",
    "name": "Bhatt  Vishnu/Kokila/Nayna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19038",
    "name": "Patole Vijay Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18223",
    "name": "Sankpal Sambhaji Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8696",
    "name": "Ashuppa Iduppa T/Hanmanta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10661",
    "name": "Jain  Shantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4932",
    "name": "Agarwal  Nishil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8210",
    "name": "Bande Nandkumar Shankarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20210",
    "name": "Kadam Uttam Parashuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6203",
    "name": "Moopil  Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13693",
    "name": "Shirgaonkar Nita Omprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16485",
    "name": "Thakur Shivnath Ramjilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2509",
    "name": "Sonawane Vishnu Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2051",
    "name": "Mandhare Bharat Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15274",
    "name": "Aangre Ramesh Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10826",
    "name": "Kambale Jankabai Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22033",
    "name": "Bhilare Ganpat Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19051",
    "name": "Malawade Yashawant Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5168",
    "name": "Mane Janardhan Baburao/Bhalchandra/Laxma"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13750",
    "name": "Shende Vilas Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11939",
    "name": "Shinde Ganesh Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "132",
    "name": "Chandrashekhar Sambhaji Bhosale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8988",
    "name": "Jain Madanlal Kalulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19427",
    "name": "Agarwal Deepakkumar Hanumanprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15131",
    "name": "Rathod Seema Pannalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1712",
    "name": "Yewale Vilas Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23452",
    "name": "Kumthekar Akash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8437",
    "name": "Narkar Prakash Vasudev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12248",
    "name": "Thomas  Pinto"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "873",
    "name": "Ramrao Waman Shejole."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22290",
    "name": "Bavishi Mayuri Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7018",
    "name": "Buswalla  Jagdish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17569",
    "name": "Kamble Ravindra Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7468",
    "name": "Nikam Ramesh Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10265",
    "name": "Sharma Raviprabha Dineshkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13898",
    "name": "Waghmare Shrihari Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2157",
    "name": "Satpati Saratkumar Daitari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2567",
    "name": "Urmila J Gupta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17149",
    "name": "Shah Bharat Babulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11181",
    "name": "Jain Poptlal Hajarimal Jain Niramalp."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5715",
    "name": "Kanchan Tilak N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15242",
    "name": "Patade Deepa Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12823",
    "name": "Hol Yogesh Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5960",
    "name": "Abdul Shakar Abdul Kadar /Safiya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15908",
    "name": "Jain Pradeepkumar Jethamal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16721",
    "name": "Korgaonkar Rukhmini Sudkoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13770",
    "name": "Lembhe Ramesh Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20578",
    "name": "Nayak Prakash Shivappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17801",
    "name": "Qureshi Ayub Subrati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16247",
    "name": "Raval Purushottam Ragaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6430",
    "name": "Yadav Shobhana Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10763",
    "name": "Dhillu Kartarsing Harnamsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2941",
    "name": "Raokhande Baliram Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10800",
    "name": "Potines Ramakant Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12858",
    "name": "Singh Nagendra Bhadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10511",
    "name": "Yadav Dukhi Patiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14552",
    "name": "Shaikh Mahamadbaris Siddhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22142",
    "name": "Chheda Bindu Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13318",
    "name": "Patil Kamlakar Pitambar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20825",
    "name": "Jadhav Shushama Sudhir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10517",
    "name": "Patel Kishor Manilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4770",
    "name": "Dayalal Karuna Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23593",
    "name": "Gaikwad Aniket Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16927",
    "name": "Tawade Nirmiti Nitin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11688",
    "name": "Gharal Sambhaji Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20613",
    "name": "More Madan Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21563",
    "name": "Jagatap Mahesh Dhananjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14743",
    "name": "Patel Navanitbhai F"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20052",
    "name": "Yewale Kisan Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2832",
    "name": "Pandey Vimaladevi Ratanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12238",
    "name": "Jadhav Vasant Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13622",
    "name": "Konde Sunita M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2981",
    "name": "Nalawade Gunwant Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19954",
    "name": "Hussain Fatima Mohmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14051",
    "name": "Bist Chakrabahaddur Birbhdur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16612",
    "name": "More Tejrao Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7163",
    "name": "Pawar Mangala Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16547",
    "name": "Bhapkar Vilas Hanmantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9752",
    "name": "Shinde Saraswati Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11148",
    "name": "Chavan Bhagwan Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18263",
    "name": "Pujari Babanrav Baburav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10531",
    "name": "Varma Sunil Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2065",
    "name": "Balram Gandhrva Behera."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19643",
    "name": "Sharma Kamlesh Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4434",
    "name": "Vast Chandrakant Tatoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6344",
    "name": "Pareek Ashok Kumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2859",
    "name": "Desai Vanmalidas Meghjibhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16670",
    "name": "Lavangare Kisan Jotiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16689",
    "name": "Manchekar Anant Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6247",
    "name": "Jain Nareshkumar S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3178",
    "name": "Patel Sureshbhai F."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14607",
    "name": "Bhosale Laxman Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21263",
    "name": "Patel Naramada Lala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7807",
    "name": "Jadhav Kiran Rajaram/Shashikala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17159",
    "name": "Chavan Sunita Liladhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20251",
    "name": "Kesharia Vijay Subhaschandra (Thakkar)"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10843",
    "name": "Jadhav Rajeev Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14847",
    "name": "Patil Tukaram Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17740",
    "name": "Keertane Dinesh Neelkantha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6493",
    "name": "Kadam Ashok Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14273",
    "name": "Chawan Annasaheb Govindrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14780",
    "name": "Khopade Subhash Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22328",
    "name": "Shingh Ramabhilakh Ramprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11460",
    "name": "Gade Balu Dhondiba."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17560",
    "name": "Thokare  Hikamatrao Babasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8037",
    "name": "Kanaphi Sekar Slo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9161",
    "name": "Bhandari Hemant Pundalik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9277",
    "name": "Gaikawad Prakash Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4153",
    "name": "Dethe Mahendra Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17727",
    "name": "Bhatia Kapil Devkishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13447",
    "name": "Navdkar Seema Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13233",
    "name": "Jadhav Vidhyulata Vilasrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14440",
    "name": "Garate Sunil Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16464",
    "name": "Keshrial Munnilal Singh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19029",
    "name": "Rajpurohit Rajeshsing Devising"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12950",
    "name": "Vidate Mangala Arun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7371",
    "name": "Shingan Sampat Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4847",
    "name": "Giri Lata Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3725",
    "name": "Vichare Anusayabai Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14368",
    "name": "Dhumal Sanjay Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1560",
    "name": "Kanakia Mandal No-2."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2317",
    "name": "Shantaben N. Shah"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14329",
    "name": "Central Railway Majdoor Sangh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9692",
    "name": "Gupta Rajendra Prasad Satyanarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21625",
    "name": "Jain Ritesh Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12205",
    "name": "Pathre Dattaram Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16008",
    "name": "Sawant Prabhakar Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3942",
    "name": "Hingu Bachu Atmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16024",
    "name": "Lotlikar Rasika Suhas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10585",
    "name": "Ranka Jeewatraj Mohanraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19495",
    "name": "Jain Deepika Anil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19759",
    "name": "Padwal Shubhada Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "113",
    "name": "Patel Ramesh Jitubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11861",
    "name": "Gawai Anna Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13806",
    "name": "Pawar Mahesh Pandurang."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14423",
    "name": "Dherange Bajrang Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13215",
    "name": "Kamble Dagadu D"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1156",
    "name": "Momin Mohd Shoeb Mohd Shafique"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19936",
    "name": "Singh Deora Vikram/Singh Deora Rajat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18208",
    "name": "Parsekar Shubhsda V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18580",
    "name": "Jadhav Uttam Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14997",
    "name": "Solanki Komal Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15892",
    "name": "Shibe Amol Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14599",
    "name": "Yerunkar Sadanand P."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "165",
    "name": "Shinde Jayashree Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17203",
    "name": "Mehta Arvind  Dharamchand ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12732",
    "name": "More Shivaji Dhaktu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5865",
    "name": "Shingate Sahebrao Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14442",
    "name": "Gupta Ankushkumar Brijmohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10032",
    "name": "Ora Urmila Chirnjilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14380",
    "name": "Harijan Shivprasad Ramanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11056",
    "name": "Kayandekar Dipak Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11721",
    "name": "Chowdhary Bismillah Abdul Rehman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12160",
    "name": "Deshastha Lokseva Sangh Mumbai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5070",
    "name": "Hudda Mohamedalli Khusal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15365",
    "name": "Yadav Mishrilal Ramlallan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8518",
    "name": "Vora Dhiraj Gulabchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11369",
    "name": "Vite Ramdas/Gangadhar Chougule/Laxman Gu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8603",
    "name": "Gaikwad Rohidas Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4654",
    "name": "Bhor Shakuntala Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "921",
    "name": "Sangavi Nemji Premji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2195",
    "name": "Desai Ajitkumar Ratilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23530",
    "name": "Baikar Rakesh Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "160",
    "name": "Mandhare Vishnu Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "842",
    "name": "Doke Baban Vittal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15703",
    "name": "Jain Sunderlal Lalchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8859",
    "name": "Patra  Mritun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21927",
    "name": "Patil Sanjay Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3152",
    "name": "Sharma Rajaram Ramdhudar ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6416",
    "name": "Rajak Jayant Dulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16688",
    "name": "Chavan Mahendra Shantram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9043",
    "name": "Mutal Lavu Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19274",
    "name": "Parab Rashmi Rajan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10897",
    "name": "Khan Jahid Abdul Wahid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11539",
    "name": "Sonar Anant P/Monica"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18456",
    "name": "Bhajapa Ward No 29"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20683",
    "name": "Narvekar Priyanka Nandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16842",
    "name": "Bhoite Vinayak Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10362",
    "name": "Mahadik Anant Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14718",
    "name": "Pednekar Pralhad Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9021",
    "name": "Shinde Shankarrao Rudraji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15360",
    "name": "Waghela Dhanji Narshi."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5237",
    "name": "Todkar Parubai Antu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19956",
    "name": "Nagori Farzana Mohd Hasan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10127",
    "name": "Shah  Mansilalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4909",
    "name": "Chavan Sachinkumar Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13884",
    "name": "Karale Mahendra Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18437",
    "name": "Lembhe Rajendra Dharmaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10578",
    "name": "Panchal Shobha Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16998",
    "name": "Maurya Rajan Ramlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20340",
    "name": "Kusum"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20667",
    "name": "Yadav Jaysing Bhalchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11114",
    "name": "Jadhav Laxman Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19051",
    "name": "Kanade Vipul Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17611",
    "name": "Pisal Ramchandra Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16818",
    "name": "Sanyukta Rahiwashi Sewa Sangh (Reg.)"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14138",
    "name": "Chouhan Subhash Kapoorchand."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16873",
    "name": "Tamatta Ganesh Shersingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11328",
    "name": "Routhan  Sundersinh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9625",
    "name": "Sawant Baban Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16638",
    "name": "Dumbare Paresh Sudam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15497",
    "name": "Vishva Shanti Yadna Dattajayanti Comitt"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21561",
    "name": "Muhitule Sameera Mohamadsalim."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17606",
    "name": "Jay Bhavani Gruhanirman Sah. (N)San"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15510",
    "name": "Limachiya   Navi   Kamleshkumar Somalal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1154",
    "name": "Yadav Umashankar Kishrilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14031",
    "name": "Rodriques Alwin George"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18016",
    "name": "Saket Shyamlal Lachu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16159",
    "name": "Shedge Baban Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5392",
    "name": "Banka  Satishkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16723",
    "name": "Rathore Neelam Kalyansingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16092",
    "name": "Shinde Pandurang Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12820",
    "name": "Surve Prakash Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9230",
    "name": "Sapkal Dattray Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13823",
    "name": "Sindhav Yogesh Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17760",
    "name": "Soni Shyamlal Sundarji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9421",
    "name": "Jain Kumarpal Parasmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2340",
    "name": "Shinde Janabai Sampatrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8588",
    "name": "Dedhia Dhanji Monshi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16350",
    "name": "Gujar Anjana Bharat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15962",
    "name": "Kashid Sunil Narayan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11365",
    "name": "Ranay Biva Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15062",
    "name": "Modi Mahindra M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12002",
    "name": "Kashid Jaysing Ganapat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16078",
    "name": "Sakapal Anil Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5962",
    "name": "Ghag Jitendra Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6403",
    "name": "Yelve Vidya Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11730",
    "name": "Bhoite Ganpat Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12746",
    "name": "Bhuvad Sunita Sahdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10093",
    "name": "Phalke Sima Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2666",
    "name": "Joshi Vimal Bhiwa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19470",
    "name": "Bhandari Ajit Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19427",
    "name": "Mudbul Babu Malaippa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20728",
    "name": "Vichare Smita Rajendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16470",
    "name": "Agarwal Sandip Ashokkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16260",
    "name": "Gurav Mahesh Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15156",
    "name": "Arora Sanjay Ramprkash."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7293",
    "name": "Sabale Namdeo Nathuba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14441",
    "name": "Agarwal Ratanlal Ishwarlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12104",
    "name": "Arya Kshitij Premchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11749",
    "name": "Asher Kalpana Kanak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4087",
    "name": "Chavan Prithviraj Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18967",
    "name": "Jain Shankutaladevi/ Anil Jain"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9251",
    "name": "Kothari Rekha Pushparaj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18258",
    "name": "Jain Sanjeevkumar Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16043",
    "name": "Pawar Rohini Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22528",
    "name": "Davade Gopinath Devaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3582",
    "name": "Musale Ashok Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6344",
    "name": "Mewada Rajesh Jayantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15543",
    "name": "Walavalkar Sugandh Janardan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12700",
    "name": "Mardhekar Rekha Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15061",
    "name": "Jain Pavankumar Baburam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12898",
    "name": "Salaskar Rajan Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4994",
    "name": "Patel Badrinath Ramdular"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18386",
    "name": "Patil Prakash Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4805",
    "name": "Satindar R Sehgal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17705",
    "name": "Engawale Shankar Bhalchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17561",
    "name": "Modak Vikram Dnyaneshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13843",
    "name": "Thakur Madhavi Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10331",
    "name": "Jagani Naresh V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11249",
    "name": "Sharma Vibhishan Neur/Ramsagar Sharma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13005",
    "name": "Walnju Sadanand Bablya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18684",
    "name": "Mane  Mohan  Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11930",
    "name": "Prajapati Dineshkumar Jagidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3126",
    "name": "Pande Parasnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9419",
    "name": "Panchal Siddarth V/Priti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21300",
    "name": "Bhartiya Janta Party Ward No-202"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19002",
    "name": "Mhatale Sudhakar Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16750",
    "name": "Saroj Deepnarayan Hiralalram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1619",
    "name": "Chavan Pramila Shivaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8561",
    "name": "Rahate Prathamesh Givind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18981",
    "name": "Udeshi Rashmi Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4123",
    "name": "Sawatn Vilas Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16491",
    "name": "Gaikwad Gautam Devram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17136",
    "name": "Kushwaha Ravindra Ramnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17775",
    "name": "Sabale Raju Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8672",
    "name": "Vedpathak Vishwanath Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10085",
    "name": "Vaidya Arvind G/Jayshri."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15249",
    "name": "Remaje Maruti Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7991",
    "name": "Bhan  Sujata/Rokesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20408",
    "name": "Bhosale Uttamrao Wamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15872",
    "name": "Baheti Mahavir Indarchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10132",
    "name": "Khan Maruf Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11357",
    "name": "More Dattaram Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13995",
    "name": "Wadkar Mahadeo Ramling."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11590",
    "name": "Sathe Shivaji Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17798",
    "name": "Chavan Ravindra Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8555",
    "name": "Jagdamba Rameshprasad Pandey"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9948",
    "name": "Gala Mongiben J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15834",
    "name": "Chikane Suresh Balasaheb"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "34",
    "name": "Mali Nagnath Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16601",
    "name": "Sangle Kishan Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7397",
    "name": "Kumathekar Sanjay Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4768",
    "name": "Shinde Rangrao Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21036",
    "name": "Shetty Sumanth Subbaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17085",
    "name": "Mutiyala Krishnayya J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19171",
    "name": "Jalgaonkar Avinash Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19170",
    "name": "Jalgaonkar Sandip Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19582",
    "name": "Shekh Abdul Karim Abdul Razak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6679",
    "name": "Singh Alka R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1273",
    "name": "Jockim  Beritta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6061",
    "name": "Acharekar Usha Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15385",
    "name": "Bhor Vilas Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12895",
    "name": "Jadhav Vijay Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9153",
    "name": "Pawar Sanjay J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15499",
    "name": "Pawar Parshuram Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4023",
    "name": "Prajapati Hariram Sitram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8747",
    "name": "Jangid Mahesh Kumar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8502",
    "name": "Singh Manju/Shyamraj ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18274",
    "name": "Singh Manojkumar Yamuna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9302",
    "name": "Waykar Khandu S/Tukaram Gode/Vishvanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14553",
    "name": "D'Sa  Britton"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1978",
    "name": "Parkar Parvatibai S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14663",
    "name": "More Sanjay Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13382",
    "name": "Jaitapkar Bharati Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18505",
    "name": "Pal Ramlakhan Siddhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17671",
    "name": "Patil Ganga Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18865",
    "name": "Gauda Yogesh Anne"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17662",
    "name": "Trivedi Gijubhai Vallabji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17634",
    "name": "Mashelkar Deepali Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14258",
    "name": "Bhura Sadaram Maghaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10336",
    "name": "Jaiswal Tirtha Janaki"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21547",
    "name": "Singh Kamlakant B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11223",
    "name": "Raikar Satish Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9224",
    "name": "Solanki Manoj Shantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18267",
    "name": "Soni Prakashchandra C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8262",
    "name": "Patel Nayana Bhikhubhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18212",
    "name": "Gole Dada Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17615",
    "name": "Jain Priti Bhawarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23135",
    "name": "Ganjam Srinath Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14156",
    "name": "Pawar Pradnya Prakash."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13864",
    "name": "Gardas Narayan Gangayya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15513",
    "name": "Vichare Vasudeo Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9483",
    "name": "Mane Shankar Lala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13141",
    "name": "Mane Bharati Krishnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16221",
    "name": "Chavan Ganesh Jaywantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5814",
    "name": "Jadhav Suman Madhaorao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7129",
    "name": "Raut Bebi Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9519",
    "name": "Ali Hussainali Ramzan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16318",
    "name": "Lembhe Namdeo B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15655",
    "name": "More Shivaji Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5701",
    "name": "Gujar Dattatrya Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15853",
    "name": "Sawant Pooja Mangesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21589",
    "name": "Jadhav Raju Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16394",
    "name": "Parmar Shankarsingh Pitanathusingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9088",
    "name": "Bhatt Gulab Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7959",
    "name": "Rasal Tukaram Divkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16297",
    "name": "Remje Bhupendra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19067",
    "name": "Koli Prakash Basanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12320",
    "name": "Pal Kailasnath Hardev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4569",
    "name": "Sahyadri Nagar Vikas Nidhi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8243",
    "name": "Qureshi Shakil Ahmed Mohamed Indris"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1367",
    "name": "Korde Dyanoba Tukaram  ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6643",
    "name": "Ghanekar Raju Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10914",
    "name": "Patane Sunanda Nathuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18549",
    "name": "Kanse  Subhash Jittas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15202",
    "name": "Mestry Sonali Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7412",
    "name": "Wairkar Vasant Dyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19977",
    "name": "Jain Sanjay Sohanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20113",
    "name": "Pawar Pradip Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2534",
    "name": "Gundecha Badrising Pratapsing."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6979",
    "name": "Patel Vasantiben Tribhovanbhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9269",
    "name": "Vende D S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13042",
    "name": "Ghaguram Namrata Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5214",
    "name": "Sagwekar Ganesh Pundlik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6196",
    "name": "Kokane Damodar Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19347",
    "name": "Sakpal Archana Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7383",
    "name": "Shah Umesh Mohanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9973",
    "name": "Shah Hasmukh Popatlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17161",
    "name": "Bharankar Bhimsen Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12552",
    "name": "Thorat Shivaji Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14338",
    "name": "Modi Ramesh Shantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20371",
    "name": "Tawade Mahesh Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15883",
    "name": "Jain Jitendrakumar Phoolchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3469",
    "name": "Acharekar Shreyas B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11736",
    "name": "Jain Mulchand Genmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7473",
    "name": "Kormi Vishwanath Satidin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15459",
    "name": "Bagul Dnyaneshwar Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11435",
    "name": "Singh Raisahab Jagunandan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18369",
    "name": "Taliwar Unnati Ramakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1364",
    "name": "Hindustan Nagari Shakari Patsanstha Ltd.Bhiwandi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6686",
    "name": "Vir Tukaram Vishram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21054",
    "name": "Shaikh Mohammed Afsar Barkatullah."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14453",
    "name": "Iyer Vaidyanathan Shrinivasan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13338",
    "name": "Wagh Balasaheb Subhedar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6343",
    "name": "Padiyan  P.T."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "981",
    "name": "Mondkar  Hemlatavithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15573",
    "name": "Singh Kapoorchand Banshidhar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16826",
    "name": "Parab Santosh Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11616",
    "name": "Agarwal Lalitkumar Pukhraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10648",
    "name": "Lotlikar Shefali Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1563",
    "name": "Pandey Ratanlal Kanhaiyalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4044",
    "name": "Chaphekar Prabha P"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4548",
    "name": "More Babai Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19747",
    "name": "Ghevade Vishwas Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8485",
    "name": "Jaiswal Sitaram Mangru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15161",
    "name": "Shirkar Prakash Sitaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16696",
    "name": "Arekar Anandibai Bapu."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12712",
    "name": "Gujar Sujata Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9958",
    "name": "Prabhu Lata Yogesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15106",
    "name": "Chhajer  Bachharaj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19521",
    "name": "Bhosale Tulsa Shridhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2284",
    "name": "Pawar Rakhamabai Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6981",
    "name": "Ghadge Umesh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12619",
    "name": "Kadam Bhimrao Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11701",
    "name": "Jadhav Mahipati Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4200",
    "name": "Narkar Vasudha Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11408",
    "name": "Khanvilkar Purushottam Harischandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15745",
    "name": "Nadavadekar Varsh Baburao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8053",
    "name": "Patel Dinesh Popatbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4724",
    "name": "Nachan Awees Aziz"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3445",
    "name": "Barrot Suresh Abhayshing."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11869",
    "name": "Mohite Dilip Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21436",
    "name": "Jangid Pritam Pushkraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "356",
    "name": "Salvi Chandrakant Atmaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "180",
    "name": "Sharma Govindram Hariram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14283",
    "name": "Soni Bhaskar D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10124",
    "name": "Sabale Namdeo Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13968",
    "name": "Dubak  Balraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6712",
    "name": "Yadav Lalchand Bundul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20354",
    "name": "Poojari Chennaya Tawda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2294",
    "name": "Jain Kamala Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4138",
    "name": "Shetty Pravin Sadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7925",
    "name": "Kashid Shrikrishana Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7624",
    "name": "Shah Jafrun Nisa."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2024",
    "name": "Khairbee Moinuddin Abdul Rehman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15057",
    "name": "Ozarkar Bhimaji Amruta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15939",
    "name": "Khan Hasina Mahmad Esmile"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9672",
    "name": "Phalke Ravindra Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18537",
    "name": "Bhavsar Hansaben Hasmukhlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10596",
    "name": "Sawant Raju Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21967",
    "name": "Bhavesh Dhirukbhai Bhadereshwara"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1495",
    "name": "Chatur Ramchandra Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12901",
    "name": "Shivsena Shakha No 39"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12011",
    "name": "Agarwal Pawankumar Inder"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19633",
    "name": "Bhoite Urmila Sharad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15550",
    "name": "Shah Bhavesh Jashvantlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2430",
    "name": "Sapkal Tanaji Raghu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17623",
    "name": "Durivedi Anuj Kumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15815",
    "name": "Bhosale Mahadeo Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14654",
    "name": "Singh Balwinder Surajansingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13777",
    "name": "Thakur Rajendra Janardan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4997",
    "name": "Talkar Ram Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7928",
    "name": "Panday Dipashree Dinesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2078",
    "name": "Gaikwad Urmila Hanuman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10478",
    "name": "Kadam Deepak Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9291",
    "name": "Shah Rajesh Chunnilal/Alpa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14436",
    "name": "Gupta Manojkumar Deendayal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7833",
    "name": "Kadam Balkrishna Madhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18542",
    "name": "Mody Ashok Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17867",
    "name": "Kadam Shivaji Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18673",
    "name": "Khan Mohammad Yaqub"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16793",
    "name": "Farndish Lawrence Fransis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8559",
    "name": "Rahate Shradha Govind"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1485",
    "name": "Shukla Shrey Premkumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1486",
    "name": "Shukla Sparsh Premkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12204",
    "name": "Bhawar Mahadeo Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13136",
    "name": "Sawad Dalbahadur Nandasing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12222",
    "name": "Rathod Chirag B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21370",
    "name": "Patil Kailas Somnath."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14413",
    "name": "Samant Kamlakar P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6549",
    "name": "Jadhav Hanmant Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16071",
    "name": "Nalage Mahesh Sarjerao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4459",
    "name": "Varma Raghavprasad Hariram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14341",
    "name": "Bhor Baban Bapuji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14232",
    "name": "Nikam Anil Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15584",
    "name": "Khan Baraktulla Mohamed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13236",
    "name": "Hule Bhagwan Balaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13362",
    "name": "Samuel Samson Alappattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20699",
    "name": "Yadav Daya Shankar Prasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13246",
    "name": "Gandhi Dilip Hansraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11434",
    "name": "Chavan Santosh Ramachandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10340",
    "name": "Pawar Sanjay Gunaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14730",
    "name": "Rambhiya Javerben L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13283",
    "name": "Porwal Indira Dilipkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13826",
    "name": "Shaikh Karamhusen Riyasat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16332",
    "name": "Kadam Arti Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5458",
    "name": "Kadu Ramesh Chandra P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11101",
    "name": "Nivedkar Mahadev Dattu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1363",
    "name": "Salmani Husannara Anwar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1347",
    "name": "Thakur Saurabh Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10452",
    "name": "Joshi Pratik Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5163",
    "name": "Rao Krishna Narsing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8397",
    "name": "Bagde Sandip S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16306",
    "name": "Calagopi Sarosh D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19224",
    "name": "Veri Sushama Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2495",
    "name": "Salunkhe Renuka R."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16487",
    "name": "Jagtap Suresh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5296",
    "name": "Sonake Vithal Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12664",
    "name": "Bhaldar Jasmin Abdulrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4728",
    "name": "Shinde Nita Nandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14292",
    "name": "Shetty Ramanna Padu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20823",
    "name": "Gawankar Sarika Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14940",
    "name": "Purohit Jasraj B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8558",
    "name": "Ninave Ashok R."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14463",
    "name": "Ghadigaonkar Rakesh Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9680",
    "name": "Mane Pandurang Dadaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15346",
    "name": "Puri Sudershan Kumar Sardarilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "980",
    "name": "Shinde Namdeo Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9168",
    "name": "Lohar Vijayshree Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3367",
    "name": "Mandhare Ashok Kanhaiyalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19558",
    "name": "Jadhav Hindurao Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18247",
    "name": "Harne Parshuram Prakash Toli-No-1627/6"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3631",
    "name": "Mangal Singh Uday Sangh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8382",
    "name": "Chawhan Dnyaneshwar S"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7866",
    "name": "Jadhav Muktabai Yadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4764",
    "name": "Sawant Eknath Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9661",
    "name": "Agarwal Radheshyam A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11484",
    "name": "Jain Prakashchandra K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10058",
    "name": "Oza Hitesh Mithalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13937",
    "name": "Lade Rakmaji Dyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19619",
    "name": "Ninawe Lalita Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1026",
    "name": "Chavan Anandrao Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10418",
    "name": "Jadhav Dilip Bhimrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16093",
    "name": "Kandalkar Amit Ajit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14513",
    "name": "Pedanekar Hemant Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10684",
    "name": "Kothari Sudha J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21685",
    "name": "Rabari Lalaram Obaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16421",
    "name": "Parab  Snehal Jayesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15341",
    "name": "Parab  Vijay Harichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6316",
    "name": "Yadav Mugatrao Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5761",
    "name": "Mirza Riyazbanu Zafar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10753",
    "name": "Parab Chandrakant P/Prabhakar Bhosale/As"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13451",
    "name": "Bisnodi Jagdish Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10052",
    "name": "Shiledar Nikita Madhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15564",
    "name": "Omprakash  Mahashingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23256",
    "name": "Suryawanshi Sunil Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12408",
    "name": "Deshmukh  Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19017",
    "name": "Pavale Dhanaji Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2220",
    "name": "Bhatt Girishchand S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "67",
    "name": "Sambhaji Vinayak Chavan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14649",
    "name": "Waghela Prabhaben Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10314",
    "name": "Modi Batukbhai D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14905",
    "name": "Soni Babitadevi Ladduram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13224",
    "name": "Chavan Bhausaheb Vishwanath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "114",
    "name": "Choudhary Rameshkumar Hansaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11650",
    "name": "Mohite Madhukar Sahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17498",
    "name": "Parmar Pankudevi Shankarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17679",
    "name": "Singh Sadhna Ravipratap"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "652",
    "name": "Deshmukh Mahesh Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19701",
    "name": "Palkar Asha Madhukar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "949",
    "name": "Sasane Chandrakant Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16570",
    "name": "Chavan Priya Pradeep/Sapaliga Manisha Ra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14457",
    "name": "Jain Suresh H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15478",
    "name": "Porwal Pukhraj Gulabchandji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16994",
    "name": "Sabale Rushikesh Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15748",
    "name": "Prajapati Gopal Ayodhyaprasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3545",
    "name": "Mody Suryabala Harshadkumar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19069",
    "name": "Chopra Dilip Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4380",
    "name": "Jagtap Rajaram Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16419",
    "name": "Kapadia Pankaj Ranjitsingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12264",
    "name": "Jain Shailesh Jayantilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18198",
    "name": "Jagtap Bhiku Parabtrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21565",
    "name": "Solanki Kinjal Amrut"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14944",
    "name": "Chhabra Ramchand K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19480",
    "name": "Jadhav Krishnat Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13228",
    "name": "Yadav Shashikala Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3895",
    "name": "Gori Yusuf Fakir Mohammed."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18977",
    "name": "Bafna Kamlesh B"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "494",
    "name": "Jadhav Praveen Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "964",
    "name": "Vedpathak Shantaram Ganpat."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6539",
    "name": "Chavan Machindra B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13600",
    "name": "Tavsalkar Asha Dwarkanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "238",
    "name": "Higiste Dattaran Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8639",
    "name": "Kadam Vithal Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3261",
    "name": "Patel Walter Remand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2177",
    "name": "Bhandari Bhimabhai Pundlik."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22153",
    "name": "Soni Veenuben Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14554",
    "name": "Bhandari Sanjay Vitthal."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19511",
    "name": "Netke Bhagwat Raghu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1195",
    "name": "Bhosale Janardhan Jagnnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16715",
    "name": "Jaiswal Ramsrekh Prabhuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17578",
    "name": "Prasad Munna Shreemahangi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "620",
    "name": "Talkeri Jalamma Kalappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6064",
    "name": "Kadmadkar Nirmalabai Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12814",
    "name": "Jain Dilipkumar Dadamchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8399",
    "name": "Vaske Vasant Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4675",
    "name": "Mestry Geeta Bhalchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "365",
    "name": "Gaikwad Vijay Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "214",
    "name": "Chaudhary Ganeshram Poonamji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18390",
    "name": "Immanuvel R Sobstion"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15089",
    "name": "Singh Arjun Mohabbatsingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8664",
    "name": "Kulkarni Vinay Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8858",
    "name": "Jain Kantilal Tekchandji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10634",
    "name": "Dabhade Shrikant Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11641",
    "name": "Ganeriwala Shakuntala Banwarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4472",
    "name": "Kohli Baldev Sing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9324",
    "name": "Shinde Satish Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16712",
    "name": "Sapkal Shivaji Namdev."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9568",
    "name": "Sharma  Rajkumari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21680",
    "name": "Kariwadekar Manoj Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19328",
    "name": "Hasmulla Salim Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5897",
    "name": "Jadhav Mangal Bhanudas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15599",
    "name": "Jadhav Sanjay Chintamani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14479",
    "name": "Sankpal  Suhasini Dahrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12872",
    "name": "Chaskar Shivaji Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9532",
    "name": "Vedpatnak Sagar V."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7671",
    "name": "Sonawale Rekha Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18802",
    "name": "Bhoite Umesh Trimbak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8836",
    "name": "Bhagat Ankush Kondaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17018",
    "name": "Galaxy Co-Op Hsg Soc"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18067",
    "name": "Jadhav Ramchandra Anandrao ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17624",
    "name": "Binjuda Ratan Megha"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "600",
    "name": "Salavi Ruplal Udaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5991",
    "name": "Shah Gunvantlal Chandulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1628",
    "name": "Bangera Dadu Subbaya."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14830",
    "name": "Patel Maheshkumar Goverdhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19313",
    "name": "Patil Balkrishna Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12667",
    "name": "Ghosh Sandeepa Shivkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12381",
    "name": "Mehta Chainmal Gulabchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4560",
    "name": "Vadday  Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17092",
    "name": "Mansukh Sunil Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7592",
    "name": "Shah Sunita B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16862",
    "name": "Dhumal Vikram Jagnnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11354",
    "name": "Chavan Munilal G."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8492",
    "name": "Kaushik Suresh Chandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11554",
    "name": "Patil Shankar Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14145",
    "name": "Rayate Gopal Dada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10315",
    "name": "Warang Naresh Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16370",
    "name": "Goundgaon Santosh Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17667",
    "name": "Budhe Parshuram Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15005",
    "name": "Salian Sudhir Sunder"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15166",
    "name": "Gosalia Vinod M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14943",
    "name": "Shaikh Amimohamad Aliraza"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7401",
    "name": "Bhosale Sunil Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22891",
    "name": "Sonpipare Sanjeev Krishnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15994",
    "name": "Dias  Caltherina"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15441",
    "name": "Ravnang Pandurang Appa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19483",
    "name": "Dudhwadkar Shubhangi Gitesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1831",
    "name": "Choudhari Dattu Supada"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11417",
    "name": "Lad Darshana Deepak/Deepak B Lad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12400",
    "name": "Bhosale Savita Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12864",
    "name": "Shah Rajendra N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16258",
    "name": "Varma Munnalal Vasantlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12999",
    "name": "Chavan Sailey Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13502",
    "name": "Bhosale Namdeo Raghu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16875",
    "name": "Mohite Bhaskar Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8368",
    "name": "Ram Harishchandra Shivnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2324",
    "name": "Vaidya Satish Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5612",
    "name": "Agrawal Tanu Ramvilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9374",
    "name": "Taware Ramchandra Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13633",
    "name": "Chavan Shankarrao Ramchandra And Others."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7452",
    "name": "Bhoite Mahadeo Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12098",
    "name": "Koli Gulab Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17047",
    "name": "Gujaria Kishor Khimji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19992",
    "name": "Mahadale Ashok P."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16596",
    "name": "Parsnani Hemant C (Huf)"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13722",
    "name": "Phalke Abhijit Lakshman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8184",
    "name": "Tamboli Sharfoo Gulabbhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17890",
    "name": "Jagtap Chandrakant Narayanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8381",
    "name": "Sawant Vilas Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18302",
    "name": "Kadam Anusaya Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21302",
    "name": "Salunkhe Sunanda Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3971",
    "name": "Gupta Amrutlal Mistrilal."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1077",
    "name": "Mittapelli Sattyyanarayan Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15253",
    "name": "Shree Shyam Ek Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8366",
    "name": "Ghadiali Krishnakumar Chunilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13272",
    "name": "Tanwani Kumar K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16926",
    "name": "Ugale  Dnyaneshwar Nivrutti ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20900",
    "name": "Gupta Pushpa Hiralal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21483",
    "name": "Phanchal Prasad Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20541",
    "name": "Jain Manav V."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10465",
    "name": "Varma  Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4668",
    "name": "Waje Ashok Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17825",
    "name": "Dravid Girish Purushottam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18049",
    "name": "Zore Vijay Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21108",
    "name": "Chavan Shachi Prashant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14982",
    "name": "Muthuswami  Polayya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2195",
    "name": "Patil Kashibai Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14515",
    "name": "Koli Shilu Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10041",
    "name": "Shinde Pandurang Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3555",
    "name": "Barge Kalpana Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16125",
    "name": "Rotary Club Bombay Pier-Charities Trust"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1597",
    "name": "Dontul Laxman Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21012",
    "name": "Salecha Neetadevi Gautamchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15027",
    "name": "Shirke Vaibhav Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15857",
    "name": "V.Perumal @ Perumal Vadival Nadar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6891",
    "name": "D Souza  Richard"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7103",
    "name": "Purohit Mohan V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3886",
    "name": "Pingulkar Ramdas Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4241",
    "name": "Goankar Murlidhar Dajiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19741",
    "name": "Chodankar Viraj Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8429",
    "name": "P R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17404",
    "name": "Mamaniya Joti Rajesh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12079",
    "name": "Pujari Vasant Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10841",
    "name": "Thadeswar Bharat Najabhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21955",
    "name": "Sakpal Sanjay Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21922",
    "name": "Solanki Leela Gajanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18692",
    "name": "Khan  Moshib Khan Amin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7787",
    "name": "Modak Balkrishna Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11785",
    "name": "Dasari Devi Ramu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2349",
    "name": "Navadkar Shrirang Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20745",
    "name": "Rele Nirmala Shashank"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8998",
    "name": "Pujari Raghu Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10071",
    "name": "Jadhav Laxman Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13062",
    "name": "Alphanso Joaquim Inacio"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8059",
    "name": "Jain Devichand Bhurmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18675",
    "name": "Harijan Panmati Rambrij"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16918",
    "name": "Joly Machingal Govindan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18919",
    "name": "Bhilare Sunil Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7252",
    "name": "Dhobi Sadhusaran Ramsajivan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12859",
    "name": "Save Ramesh Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20782",
    "name": "Gupta  Durgesh  Ramshankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14198",
    "name": "Viswakarma Mahendra Ramvadan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12467",
    "name": "Tagala Yusuf J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6239",
    "name": "Bhosale Prabhakar Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22525",
    "name": "Nimbalkar Prithviraj Murlidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5203",
    "name": "Tendulkar Smita Vivekanand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "647",
    "name": "Shinde Dasharath Abasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9089",
    "name": "Bhoite Suresh Shahaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14719",
    "name": "Bhuvad Kamal Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16203",
    "name": "Maurya Parasnath Murlidhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10252",
    "name": "Upadhyay Raisahab Shobhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8906",
    "name": "Yadav Usha M."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10092",
    "name": "Vandur Kantilal Seva"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14041",
    "name": "Sutar Ashish Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17683",
    "name": "Jagtap Nitin Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4731",
    "name": "Bhatnase Sattar Bhuraji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12235",
    "name": "Jadhav Raghunath Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12516",
    "name": "Jaiswal Amarnath Radheshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20529",
    "name": "Shaikh Zorabi Masood"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8062",
    "name": "Yadav Moolchandra B."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4767",
    "name": "Kakade Bhaiyarao Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15471",
    "name": "Pal Rajkumar Bansaraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5246",
    "name": "Vichare Anil Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13927",
    "name": "Dhoke Hanumant Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12469",
    "name": "Panchal Jaya Manilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17413",
    "name": "Alima Khatun Rahamatullah Mulla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15266",
    "name": "Bedate Hanmant Daulat."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14332",
    "name": "Merchant Raj Mohammedali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8415",
    "name": "Jadhav Dattatray Marurtao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22253",
    "name": "Bandi Rajita Satyanarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1713",
    "name": "Pawar Sankruti Nitin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12677",
    "name": "Manihar Hakikkulla Kitabulla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10328",
    "name": "Pathan Phulkhan Sangrekhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16386",
    "name": "Ajmera Chandrakant T"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19175",
    "name": "Kashyap Dhaniram Siyaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17416",
    "name": "Dhavle Radhabai Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6189",
    "name": "Sonar Anant P."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18195",
    "name": "Kamdar Ummedlal Dayalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13717",
    "name": "Todkari Uday Shriram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10586",
    "name": "Ranka Vimal Mohanraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22915",
    "name": "Goswami Vinodkumar Ramsevak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "271",
    "name": "Bhilare Vijaya Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19900",
    "name": "Mestry Amit Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2635",
    "name": "Desai Kajal Kishorchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4980",
    "name": "Pednekar Avinash Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12923",
    "name": "Sawant Dilip Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4629",
    "name": "Shirgaonkar Ramchandra Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6316",
    "name": "Pawar Mohan Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8343",
    "name": "Gudekar Anant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10700",
    "name": "Patel Rajesh Shriram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4038",
    "name": "Jadhav Savitribai Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10868",
    "name": "Ghag Rupeshri Ambaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16606",
    "name": "Patil Dattajirao G"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11225",
    "name": "Jain Sneha Vinod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14443",
    "name": "Gupta Ushadevi Ashokkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11329",
    "name": "Patil Digambar Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21611",
    "name": "Ansar  Pathan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12560",
    "name": "Dare Vijay Hambirrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7752",
    "name": "Singh Chandrabhan Indarpal."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12306",
    "name": "Lotlikar Shaila K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21517",
    "name": "Mohammed Shamshad Ahmed Haroon"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15882",
    "name": "Jain Manoj Fulchand &"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12338",
    "name": "Mehta Vimla Bhanwarlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "655",
    "name": "Sutar Gajanan Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22373",
    "name": "Dolas Sandeep Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20915",
    "name": "Shah  Kapil  Uttamchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19648",
    "name": "Mane Meena Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9703",
    "name": "Shetty Jehappa Malappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21776",
    "name": "Naik Prabhu Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15856",
    "name": "Nakate Mahadeo Bhagoji ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11973",
    "name": "Dangra Kailash Madanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14386",
    "name": "Vishwakarma Lalchand Zharkhande."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20231",
    "name": "Sanghvi Disha Mayur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6514",
    "name": "Banavalkar Sujata Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9493",
    "name": "Charmakar Utkarsha Dnyati Panchayat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14262",
    "name": "Darji Virsing Lalbahadur."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13481",
    "name": "Pawar Popatrao Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2227",
    "name": "Shaikh Habibulla Shafi Mohammed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1216",
    "name": "Singh Alka R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8738",
    "name": "Mamta R Singh/Rajkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9277",
    "name": "Khan Shabana Sajid"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13560",
    "name": "Barge Sulochana Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1830",
    "name": "Salunkhe Shalan Tanaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17048",
    "name": "Varpe Mahendra Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10367",
    "name": "Sawant Shivaji Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17997",
    "name": "Durge Sanjay Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17862",
    "name": "Malaviya Pinkesh Vinod"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7262",
    "name": "Ghadge Pralhad Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22624",
    "name": "Dhavde Vasant Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4665",
    "name": "Gandhi Prashant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23648",
    "name": "Dilima Leela Jarel"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19192",
    "name": "Mourya Dhanraj Sakhram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12239",
    "name": "Chavan Ankush Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16571",
    "name": "Chauhan Ramharakh Lallan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14699",
    "name": "Prajapati Gobarbhai Somabhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21249",
    "name": "Waghmare Nandu Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14947",
    "name": "Katekar Nivrutti Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16762",
    "name": "Gaikwad Nivrutti Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10400",
    "name": "Patil Sandesh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8646",
    "name": "Prajapati Satydeo G"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20233",
    "name": "Bhambhani Anand Chooharsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17763",
    "name": "Thorat Arjun Babaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14452",
    "name": "Baheti Ghanshyamdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19579",
    "name": "Bhoite Pratibha Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18925",
    "name": "Salunkhe Arvind Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17457",
    "name": "Parte Ganesh Sakharam."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6900",
    "name": "Gaikwad Sanjay Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9102",
    "name": "Charkop Jain Shwetamber Murti Sangh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9215",
    "name": "Mane Tanaji Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2998",
    "name": "Shettigar Vishwanath Narayan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16617",
    "name": "Remaje Dipika Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13917",
    "name": "Kodlekar Sandhya N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4297",
    "name": "Patel Shanwaz Emamuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19268",
    "name": "Gupta Shivprasad Baijnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8413",
    "name": "Shingare Shobha Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15995",
    "name": "Pawar Rajaram Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6439",
    "name": "Sawant Vithal Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11638",
    "name": "Chavan Ganpati Savala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7882",
    "name": "Rughani Mitesh Narayan Das"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20429",
    "name": "Daultani Shankar K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18110",
    "name": "Kusum"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7139",
    "name": "Banka Vishwanath Radhesham"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3719",
    "name": "Jadhav Mansing Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15107",
    "name": "Mehata Shyam Sunder"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13521",
    "name": "Shah Sampatkumar Kantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15907",
    "name": "Sawant Kavita Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16419",
    "name": "Tawade Vijay Pundalik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "287",
    "name": "Kudatarkar Eknath Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22352",
    "name": "Agawane Sachin Manik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12532",
    "name": "Salunke Sudhakar Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6117",
    "name": "Sabale Shashikant Subhedar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13579",
    "name": "Mourya Heeralal Raghunath."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23164",
    "name": "Patil Meena Avinash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20471",
    "name": "Ratate Manohar Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11985",
    "name": "Vora Narendra Poatlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8613",
    "name": "Dubey  Khushiram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "320",
    "name": "Nishad Muniram Indraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10396",
    "name": "Naik Uday Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "343",
    "name": "Bhise Bhagwan Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15093",
    "name": "Khandagale Subhash Bhaskar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11540",
    "name": "Shah Phoolchand R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11800",
    "name": "Adarsh Mahila Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16080",
    "name": "Bonawate Yogeeta Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19175",
    "name": "Kubade Milind Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5975",
    "name": "Gandhi Pravinkumar Maagnlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10362",
    "name": "Jare Pralhad Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18702",
    "name": "Khan Nasruddin Ajmatali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19758",
    "name": "Nawadkar Rupali Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4971",
    "name": "Nivare Shivram Shravan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22363",
    "name": "Shaikh Rehana Mohd. Khalil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18327",
    "name": "Thakur Reeta Kishansingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21800",
    "name": "Ambulkar Tukaram Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17837",
    "name": "Kamble Nivas Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14440",
    "name": "Agarwal Manishkumar Prakashchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18606",
    "name": "Surve Mahendra Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7632",
    "name": "Chavan Hanumant Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14834",
    "name": "Joshi Hemant Purushottam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8599",
    "name": "Mungase Janardhan Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18785",
    "name": "Nimbalkar Prashant Shashikant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1450",
    "name": "Patil Kishor Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2874",
    "name": "Sehemby Amrik Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13914",
    "name": "Thapa Mansu Yamvir ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8687",
    "name": "Shinde Yeshwant Shivajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11708",
    "name": "Purohit Gopal Harnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16774",
    "name": "Sanchaniya Chetan V."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17094",
    "name": "Mujawar Minaj Shaukat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15853",
    "name": "Shah Yatinkumar Amritlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10803",
    "name": "Sabale Ashok Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12867",
    "name": "Raorane Pradip Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16953",
    "name": "Doifode Babu Malu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17203",
    "name": "Kadam Dharmji Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14385",
    "name": "Rathor Rameshkumar S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5576",
    "name": "Pande Chandrabhushan Parasnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2922",
    "name": "Randive Atmaram Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18857",
    "name": "Chaurasiya Dasharath Patiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3521",
    "name": "Shelar Kashiram Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22325",
    "name": "Rajpurohit Surendra Bhanwarsingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13575",
    "name": "Shinde Soni Pramod"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10492",
    "name": "Karbhal Nana Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17978",
    "name": "Ganndhi Kanak Rajesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11032",
    "name": "Salunkhe Vishwas Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12909",
    "name": "Chavan Yashwant Bimsen"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2712",
    "name": "Mandharer Kondiba Balasaheb"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "725",
    "name": "Mane Akrur Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19450",
    "name": "Shaikh Mohamed Arif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23666",
    "name": "Chavan Utkarsha Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22123",
    "name": "Kamble Shalaka Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8108",
    "name": "Dingorkar Shankar Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5598",
    "name": "Pereira  Veronica"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8979",
    "name": "Warkhade Pradeep Sidam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13921",
    "name": "Saifullah  Jamaluddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12933",
    "name": "Gawas Hemant Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12709",
    "name": "Soni Babulal Tej"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8963",
    "name": "Chavan Mansing Jayadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "997",
    "name": "Chavan Tanaji Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19426",
    "name": "Pathan Karim Mullah Munnakar Huain"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15356",
    "name": "Agarwal Ashokkumar Hansraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6223",
    "name": "Burvate  Prkash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14010",
    "name": "Shinde Atul Hanmantrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22798",
    "name": "Khedekar Pradeep Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12184",
    "name": "Thakur Asha Jayesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21606",
    "name": "Parihar Ramesh Mohabatram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1020",
    "name": "Jadhav  Satish  Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22310",
    "name": "Jajodia Pushpadevi Deviprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18201",
    "name": "Nachnekar Sakharam Gangaramvijaya S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15786",
    "name": "Nikam Jayshree Baburao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10585",
    "name": "Chawan Sanjay Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6868",
    "name": "Sandbhor Ramchandra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21463",
    "name": "Sawant Nitin Indrajeet."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17929",
    "name": "Tawade Prashant Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16000",
    "name": "Shah Halak Vishal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4926",
    "name": "Ambavane Nandkumar Parashuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17943",
    "name": "Sawant Ravindra Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12870",
    "name": "Jain Mohanlal V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19031",
    "name": "Kadam Priyanka Pravin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12090",
    "name": "Fernandes Joaquim Xavier"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12768",
    "name": "Mishra Ravindra Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20611",
    "name": "Dhumal Vilas Madhavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2183",
    "name": "Tawde Suresh Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16549",
    "name": "Sawant Ashok Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10453",
    "name": "Joshi Ishan Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6759",
    "name": "Shevale Laxman Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10793",
    "name": "Tanna Chandrakant Lalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11798",
    "name": "Dhule Bhagubai Badu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2047",
    "name": "Shah Vinod P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20216",
    "name": "Darekar Ravindra Shivaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "164",
    "name": "Shinde Raghuntah Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2527",
    "name": "Satara Zilla Pragati Mahamandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9508",
    "name": "Jagtap Shailaja Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8377",
    "name": "Majee Vidyarthi Sangh Madyamik Vidyalaya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11582",
    "name": "Gulekar Laxman Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14483",
    "name": "Nawadkar Sunil Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18900",
    "name": "Yadav Shobnath M."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14767",
    "name": "Agarwal Kaushalyadevi Madanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13071",
    "name": "Tamka Sohanlal Dhanraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13839",
    "name": "Mourya Bhagirthi Prasad."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16828",
    "name": "Bagwe Girish S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4993",
    "name": "Patel Kalavati Ramsuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4187",
    "name": "Jain  Ghanshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12062",
    "name": "Chaturvedi Mamata Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13275",
    "name": "Chavan Kunal Satyawant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15675",
    "name": "Mohd  Anwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17281",
    "name": "Kadam Shobha Bapu."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15681",
    "name": "Rahman  Habibur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22870",
    "name": "Kenjale Vaishali Jaywant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12542",
    "name": "Yadav  Ramnihare"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22023",
    "name": "Chavan Rajendra Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6627",
    "name": "Gawade Suryakant/Madhav Sawant/Shailendr"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14138",
    "name": "Mandlik Surekha Chandramohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15230",
    "name": "Jadhav Vilas Krishnarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14151",
    "name": "Parab Sadashiv Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7384",
    "name": "Sodi Hemlata Manubhai"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "227",
    "name": "Jose Divin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4250",
    "name": "Parab Mamata Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6102",
    "name": "Khwaja Mohd Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11097",
    "name": "Sonar Monica Anant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1348",
    "name": "Thakur Shubham Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8263",
    "name": "Ahmad Manjur Ahmed Mahbool   Mh-04 P-107"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9757",
    "name": "Munir Husen Mustak Ahmad Shaikh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15111",
    "name": "Pisal Jayvantrao Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10637",
    "name": "Koli Lilawati Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18559",
    "name": "Sutar Ramchandra Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19205",
    "name": "Gupta Rahul Omprakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14439",
    "name": "Agarwal Nishakumari Prakashchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17779",
    "name": "Kate Suhasini Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18708",
    "name": "Nimankar Chandrashekhar Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8819",
    "name": "G.  Satyaprasad/Padma"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "951",
    "name": "Nalawade Jaibai Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3796",
    "name": "Kapadia Bharat M."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18719",
    "name": "Kadam Shashikant Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3214",
    "name": "Dhuri Ganesh Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20067",
    "name": "Bhagirathi Niwas Bhadut Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5888",
    "name": "Sharma Shyam/Anil Bhoier"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13788",
    "name": "Jain Mithalal Foujmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22082",
    "name": "Pandit Devidas Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15241",
    "name": "Potale Rajesh Balkrisnna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8167",
    "name": "Kambale Namdeo Kerappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14096",
    "name": "Rokade Chandrakant Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19158",
    "name": "Kumbhar Suresh Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12846",
    "name": "Parmar Kisturchand Tekaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12266",
    "name": "Sudhaisingh Vijay Pratapsinh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15488",
    "name": "Chitroda Sarla Pravin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "698",
    "name": "Danavale Namdev Padu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19513",
    "name": "Palkar Swati Shyamsundar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6993",
    "name": "Rajeshirke Usha Raosaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3687",
    "name": "Shinde Vishwas Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17204",
    "name": "Mule Sushila Vishavnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14910",
    "name": "Vastimal  Devichand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "800",
    "name": "Agarwal Allok Pawan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15678",
    "name": "Rahuf Abdul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8493",
    "name": "Mehta Manilal Bhagwandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6159",
    "name": "Darekar Namdeo R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15735",
    "name": "Kadam Anusaya Narsu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22590",
    "name": "Khatri Pooja Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1051",
    "name": "Chadrakant Tukaram Shelar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10269",
    "name": "Pillai Alimuddin Noorhasan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14778",
    "name": "Angavalkar Taramati Tayaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6757",
    "name": "Sheikh Khatijabegum Alluddin"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "126",
    "name": "Shaikh Sufia Israil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11599",
    "name": "Sharma Pushpa Mahavir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6036",
    "name": "Surve Suchitra Hanumant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13142",
    "name": "Anpat Balu Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20678",
    "name": "Lobo  Sherwin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16321",
    "name": "Swati Vishnu Pawar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "881",
    "name": "Phadtare Girjadevi Inamdar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5300",
    "name": "Vetkar Rakesh Chandramohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9947",
    "name": "Gala Mongiben J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11497",
    "name": "Bee Aruna Narsingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15231",
    "name": "Varma Shivsagar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "342",
    "name": "Chavan Vijay Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21257",
    "name": "Sampat Heena Rathin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13337",
    "name": "Agrawal Babita Sanjiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21129",
    "name": "Shinde Anil Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5852",
    "name": "Sheth Priti Ajaykumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5241",
    "name": "Gadiyal Bhigabai Kantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6205",
    "name": "Jain Bhawarlal Mulchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4655",
    "name": "Sawant Vinayak Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3862",
    "name": "Gaikwad Shrirang Pandurang."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16935",
    "name": "Choudhary Wagaram Samaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13109",
    "name": "Shelatakar Jagannath Rau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16667",
    "name": "Kherud Chhabulal R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22117",
    "name": "Nalawade Harichandra Khanderao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12317",
    "name": "Mandhare Pandurang Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17950",
    "name": "Gujar Vijay Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6068",
    "name": "Salvi Viday Vday"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10508",
    "name": "Panchal Nirmala Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11321",
    "name": "Soni Shivprakash R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18365",
    "name": "Salvi Prakash Dharma"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14102",
    "name": "Shetye Anil Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3056",
    "name": "Bhatt Shashikant M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14737",
    "name": "Jain Vimla Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9537",
    "name": "Sharma  Bhavana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9126",
    "name": "Salunkhe Seema Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3198",
    "name": "Pokle Milind Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19948",
    "name": "Ingale Sudhakar Uddhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16904",
    "name": "Patil Vijay Devidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11879",
    "name": "Dundale Krishna Raghu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13516",
    "name": "Sambhare Milind Gotu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "552",
    "name": "Dhaygude Bhaskar Gangadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8860",
    "name": "Pulekar Sachin Gajanan/Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14816",
    "name": "Jadhav Trupti Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17457",
    "name": "Chavan Harish Mohan."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1097",
    "name": "Sharma Rakeshkumar Omprakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16403",
    "name": "Awasthi Rakesh Jattashankar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22230",
    "name": "Panhale Shraddha Jayesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13747",
    "name": "Rawat Rushi Narayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23817",
    "name": "D`Souza Lilly Stanley"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21274",
    "name": "Shah Pradeep Gabhalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21001",
    "name": "Joshi Bhavanishankar Shankarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21047",
    "name": "Burman Sampa Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21652",
    "name": "Shivsena  Shakha  No  8."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18264",
    "name": "More Baburao Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18510",
    "name": "Disale Bhausaheb Dhyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8759",
    "name": "Kapadia Mukund Vishweshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12814",
    "name": "Dalvi Nirmala Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17150",
    "name": "Bhagirathi Co-Op Hsg Society Ltd."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9130",
    "name": "Vora Dhanavantiben Dharamashi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14867",
    "name": "Gawas Rachana Ratnakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14183",
    "name": "Joshi Dineshkumar Narsinglal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16281",
    "name": "Yadav Ashokkumar Shabhajeet"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17748",
    "name": "Jain Arvind Kundanmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6257",
    "name": "Ramteke Surendrakumar R."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22866",
    "name": "Banerjee Sraboni Himadri"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12700",
    "name": "Assoomal  Tuljaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9902",
    "name": "Guha Muralilal Changur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19743",
    "name": "R.S.Raju  Rajmanikam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3841",
    "name": "More Gulab Premlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5102",
    "name": "Joshi Kashinath Bhikaji/Suman Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14427",
    "name": "Ambekar Laxman Rupa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13643",
    "name": "Amrelia Dharmendra Madhukant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14150",
    "name": "Deshmukh Balkrishna Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16503",
    "name": "Oval Siddharth Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16096",
    "name": "Jain Shripal Mohanraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19734",
    "name": "Kanodia Ajay Kailashchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22259",
    "name": "Ishrwar Babarav Motivad."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2800",
    "name": "Marathe Prabhakar Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11064",
    "name": "Dhekhg Nandkumar Dhondu/Gajanan Rane G"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14193",
    "name": "Jadhav Sahdeo Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16371",
    "name": "Ghag Pratibha Anant."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13974",
    "name": "Naik Kamlakar Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8045",
    "name": "Lad Satyabhama Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12975",
    "name": "Samant Saroj Nigam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18376",
    "name": "Sukhadia Meena Anandji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10055",
    "name": "Chauhan Anita Tejraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14171",
    "name": "Mestry Jitendra Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22002",
    "name": "Bansode Pradeep Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10769",
    "name": "Pagare R. K/M .R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10710",
    "name": "Singh Jay Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6652",
    "name": "Chavan Kalavati Appasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6598",
    "name": "Bhandari Rajendrasingh Ramsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6520",
    "name": "Palamy Gautam Manekji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13070",
    "name": "Kothari Radhika Vikram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5691",
    "name": "Sawant Savitri Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3555",
    "name": "Shah Meghaji Jethabhai."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14449",
    "name": "Gupta Lokeshkumar Brijmohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13328",
    "name": "Singh Sunita Sunil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14446",
    "name": "Agarwal Kantadevi Prakashchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10382",
    "name": "Jain Prakash Premchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14447",
    "name": "Gupta Kailashchand Deenalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16686",
    "name": "Kolekar Maruti Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11585",
    "name": "Kumthekar Nilesh Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11953",
    "name": "Gupta Sharadadevi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17529",
    "name": "Zore Baban Navlu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5579",
    "name": "Gadkari Parsharam Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14322",
    "name": "Yadav Surajnarayan Dulari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12487",
    "name": "Shah Ramesh Lalchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6051",
    "name": "Naik Devanna Rukmayya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14444",
    "name": "Gupta Ritukumari Brijmohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14027",
    "name": "Soni Rajendrakumar Laduramji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20702",
    "name": "Yadav Laxman Praladh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11730",
    "name": "Feroja Eqbal Loohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20730",
    "name": "Sahoo Narendra Kumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10996",
    "name": "Nikam Shankar Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15269",
    "name": "Ninawe Shankar Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6270",
    "name": "Pawar Chandrakant Mahipat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11750",
    "name": "Jagtap Shivaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12301",
    "name": "Chavan Ganesh Raghuvir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7966",
    "name": "Taral Suresh Surya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8543",
    "name": "Jagtap Balkrishna Rangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19286",
    "name": "Vasan Undariya Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3321",
    "name": "Pira Gulam Mahomed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1776",
    "name": "Patvekar Akbar Ismail"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15485",
    "name": "Kotiyan Nagesh Lingappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3949",
    "name": "Rege Pranam Manohar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1969",
    "name": "Kadam Madhukar Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11299",
    "name": "Tondvalkar Sandeep Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15881",
    "name": "Jadhav Vithabai Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18649",
    "name": "Chawdhari Mularam Sataraji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "443",
    "name": "Kadam Bhimrao Madhavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15247",
    "name": "Parab Meena Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2176",
    "name": "Pokle Chandrakant Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18821",
    "name": "Sukhadia Ramila Anandji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3548",
    "name": "Khan Rehana Abdulvali"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "553",
    "name": "Ughade Vijay Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5917",
    "name": "Lokhande Rohini Jaysing."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20718",
    "name": "Dhumal Nalini Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8989",
    "name": "Pradhan Swati P/Prafulla K P."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23403",
    "name": "Subramaniam Devyani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15921",
    "name": "Mahadik Arvind Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22144",
    "name": "Kasrung Vinayak Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7330",
    "name": "Joshi Bhupendra Haribhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7213",
    "name": "Manjarekar Vijay Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10861",
    "name": "Palrecha Motilal Bagmalji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8505",
    "name": "Tahkekar  Suvarna Krishana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15270",
    "name": "Yadav Ramachal Amarnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5146",
    "name": "Gawade Ramesh Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5486",
    "name": "Madhavi Shilesh A"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12116",
    "name": "Babar Niteen Shanker"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12402",
    "name": "Sharma Ajay Kumar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13050",
    "name": "Mahadik Suresh Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20017",
    "name": "Geeta Hemant Kotecha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13816",
    "name": "Kadam Vaibhav Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14221",
    "name": "Shaikh Gulam Yashdhani Md.Tamizul Hussai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9974",
    "name": "Chaudhari Ramaji Ram Wali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11219",
    "name": "Agarwal Shyamlal C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3642",
    "name": "Kore Raghunath Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11433",
    "name": "Patil Varsha Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18334",
    "name": "Dhanak Darshan K"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14171",
    "name": "Shinde Gulabrao Sinba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15665",
    "name": "Shinde Swati Prashant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8532",
    "name": "Keni Meena Praful"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11043",
    "name": "Shaikh Mehboob Narsudin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6209",
    "name": "Ghosh Sushama Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12368",
    "name": "Pawar Sulbha Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "854",
    "name": "Smita Sampatrao Desai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9864",
    "name": "Wahile Mahendra Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "480",
    "name": "Jagtap Sampat Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14084",
    "name": "D Souza James Sebestian"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6953",
    "name": "Ranka Arvind Jeewatraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21522",
    "name": "Mayekar Sangita Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19094",
    "name": "Pawar  Tanagi Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10879",
    "name": "Kusum"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21819",
    "name": "Shigvan Shital Santosh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11873",
    "name": "Kadam Baburao Nathu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1970",
    "name": "Nimbalkar Hanmant Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17874",
    "name": "Shinde Dilip Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "192",
    "name": "Adinath Tatyaba Londhe."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7158",
    "name": "Bhatt Rajivkumar Jitendrabhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17802",
    "name": "Shelar Shantabai Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11330",
    "name": "Balakwade Sanjay Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16504",
    "name": "Gadhave Damodhar Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16833",
    "name": "Sampatraj Jugraj Jain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9701",
    "name": "Bhawnani Sneha Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16446",
    "name": "Sawant Prabhakar Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12185",
    "name": "Harijan Bikai Timal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18209",
    "name": "Nalawade Vishal Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16692",
    "name": "Sapkal Sambhaji Namdeo."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10243",
    "name": "Nathani Mahendra Hiranandji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15885",
    "name": "Jain Sangita Jitendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16256",
    "name": "Nathwani Jinit Paresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12977",
    "name": "Sawant Malati Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16204",
    "name": "Rathi Shivdayal Harinarayan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16722",
    "name": "Mandal Jeyaul Rehman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19688",
    "name": "Maharashtra Rajya Kapad Ani Mathadi Transport General Kamgar Union (Reg)"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13602",
    "name": "Jain Prakash K"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1497",
    "name": "Dalvi Kamlabai Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11118",
    "name": "Raje Jagnnath Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1538",
    "name": "Kudtarkar Pushpa M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8829",
    "name": "Rathod Suresh Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4387",
    "name": "Jadhav Baburao Vithoba."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11539",
    "name": "Mane Bajirao Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13101",
    "name": "Mandhare Dattatray Bapuji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15924",
    "name": "Subhash Maidan Welfare &Charitable Trust"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15676",
    "name": "Mohd  Javid"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7333",
    "name": "Karande Parshuram Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7066",
    "name": "Dadas Bita Dongriba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13121",
    "name": "Chougule Namdeo Manu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7943",
    "name": "Phadkar Ravji Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2330",
    "name": "Pandit Sulochana V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18731",
    "name": "T.  Poopalan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4183",
    "name": "Navyug Vikas Mandal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12535",
    "name": "Barge Sujata Daulat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12138",
    "name": "Patel Rajendraprasad R"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6238",
    "name": "Bapat Shushhama Shriram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15920",
    "name": "Shinde Sunil Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23108",
    "name": "Phadke Bhagyashri Ashish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21198",
    "name": "Gurjar Pinky Vikram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4983",
    "name": "Koli Durga Devram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14225",
    "name": "Mane Vilas Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16271",
    "name": "Merchant Hasanali Taher'"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8981",
    "name": "Sawant Bharati Nilesh/Papinder Singh Ass"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2258",
    "name": "Khandavi Baban Ambo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12761",
    "name": "Matre Vilas Vithal  1142/6"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2369",
    "name": "Kothari Lalang S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19304",
    "name": "Kesanpalli Tirupamma Kondayya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9772",
    "name": "Dabholkar Suresh Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15167",
    "name": "Sampat Vasanti Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15878",
    "name": "Momin Shabbir Husain"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12334",
    "name": "Kirdat Madhavi Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18636",
    "name": "Bhoee Mukesh Shankarlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8318",
    "name": "Fernandes  Francisco"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11811",
    "name": "Sayhodri Dilip Premchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6534",
    "name": "Nilima S Chonkar / Shailendranath S Chon"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21950",
    "name": "Jain Bhawana Pradeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18501",
    "name": "Junaid Ahmed Abdul Aziz"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12994",
    "name": "Soni Latadevi Rajendrakumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9340",
    "name": "Devankar Smita Datta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16497",
    "name": "Mulgaonkar Samir P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15845",
    "name": "Kambale Rajashree Rajaram / Nikhil R."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12906",
    "name": "Sawardekar Pradeep Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2274",
    "name": "Phapale Shradha Santa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18834",
    "name": "Shaikh Gulam Mohimin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7289",
    "name": "Trivedi Taramati Girishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8091",
    "name": "Rathod Manohar Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7664",
    "name": "Manjappa  Nanjappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19749",
    "name": "Damani Hemang Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18251",
    "name": "Nisar Sarita Damji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9584",
    "name": "Thakkar Subhashchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14437",
    "name": "Agarwal Prakashchand Ishwarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18878",
    "name": "Bhoite Santosh Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10161",
    "name": "Jangid Atmaram L."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5101",
    "name": "Karalkar Kavishwar Dasharath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14885",
    "name": "Singhania Dwarkaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17024",
    "name": "Bagdi Krishna Ishwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6626",
    "name": "Gawade Suryakant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18268",
    "name": "Soni Prakashchandra C"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19378",
    "name": "Jadhav Sudhir Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18505",
    "name": "Malusare Ankush Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9950",
    "name": "Hogale Baban Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6969",
    "name": "Jadhav Vastala Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17779",
    "name": "Bhati Bherulal Jawanmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3201",
    "name": "Thakar Ravidas Baburao ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18250",
    "name": "Nisar Paresh Damji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14688",
    "name": "Choudahri Ramprakash Dyaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17771",
    "name": "Dhumal Sunil Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7447",
    "name": "Kamble Dilip Krishnaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14723",
    "name": "Sawant Eknath Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21943",
    "name": "Singh Mirasingh Ramyash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13586",
    "name": "Mehta Shital B"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6334",
    "name": "Phalke Asha Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17872",
    "name": "Parab Vinayak Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13567",
    "name": "Kadam Rajashree Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11420",
    "name": "Sheth Ghanshyam Mathuradas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1061",
    "name": "Bind Ajay Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10460",
    "name": "Dhanawade Hariba Aannapa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3700",
    "name": "Padli Station Maruti Devalaya Jirnoddhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17733",
    "name": "Bhoier Manjula Hemant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20656",
    "name": "Mahangare Amit Digamber"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13993",
    "name": "Shaikh Kadir Abdulkader"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3448",
    "name": "Kadam Hanamant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10795",
    "name": "Parikh Bharati S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17446",
    "name": "Pokhrel Bhanu Gaganbahdurji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18397",
    "name": "Raikar Pritam Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13527",
    "name": "Sahayog  Sadhana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16763",
    "name": "Kheraria Yogesh Birpal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22195",
    "name": "Naik Anil Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18430",
    "name": "More Suhas Annat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10100",
    "name": "Nate Rajesh Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4296",
    "name": "Manjrekar Sujata Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "134",
    "name": "Tarade Jaysingh Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10439",
    "name": "Lagvankar Sharada Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9862",
    "name": "Chougale Ujawalkumar Nanasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14759",
    "name": "Ghadge Nitin Hanmantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "537",
    "name": "Angre Suryakant Jairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19919",
    "name": "Patil Sunil Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14120",
    "name": "Suthar Dineshkumar Tanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2101",
    "name": "Bane Hari Ragho"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18159",
    "name": "Patil Laxman Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9307",
    "name": "Ranjeri Simla Kamlakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10792",
    "name": "Kahane Ujwala Ramakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13498",
    "name": "Doke Sapana Satish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14480",
    "name": "Chikhale Deepak Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3844",
    "name": "Ingale Dashrath Genu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3460",
    "name": "Munshi Nuzhat Hasam."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6715",
    "name": "Shah Virchand Nagaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4282",
    "name": "K Somdevan Nagraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9870",
    "name": "Bhawnani Lata Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7697",
    "name": "Purohit Suresh Meghsingaji."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9378",
    "name": "Saroj Banshraj Zhulai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19649",
    "name": "Yadav Ganpat Tilak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11994",
    "name": "Lad Vitthal Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14607",
    "name": "Pande Chayya Harihar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8832",
    "name": "Daphale Mahipat Savlaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13262",
    "name": "Shinde Prabhakar Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7963",
    "name": "Takale Prakash Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11809",
    "name": "Sayhodri Ashok Premchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18207",
    "name": "Chaugule Sachin Fhulchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17200",
    "name": "Rajput Madansinh Bhagusinh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20728",
    "name": "Amberkar Sankalpa Suryakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1072",
    "name": "Palav Bhiwa Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2385",
    "name": "Vedpathak Prakash V."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16287",
    "name": "Malpote Sunil Dnyaneshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12296",
    "name": "Mestry Manisha Purushottam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20633",
    "name": "Tahasildar Abid Dastagir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7979",
    "name": "Mane Dinkar Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3692",
    "name": "Gupta Aruna Hariprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20670",
    "name": "Upadhyay Hasumati Kunjbihari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11231",
    "name": "Ninawe Bharati Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2935",
    "name": "Naidu Ramdas Ramanjalu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16154",
    "name": "Shah Jyotika M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10456",
    "name": "Phalke Dnyandeo Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7485",
    "name": "Bhawsar Prakash H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14846",
    "name": "Mehta Surendrakumar Pukhraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19274",
    "name": "Rayavani Jaykishan Raghandas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9482",
    "name": "Kadam Sakharam Tukaram  Tn-79-9"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "481",
    "name": "Bhor Dattatray Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8200",
    "name": "Kadam Pradip Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7596",
    "name": "Khandekar Sitaram Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11243",
    "name": "Dhavade Vasant Mahadev/Vasanti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1407",
    "name": "Shelar Vasant Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18181",
    "name": "Bhilare Rajaram Jagnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2049",
    "name": "Singh Ramesh Chhattar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2641",
    "name": "Kharat Housabai Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3076",
    "name": "Yadav Ram Alakh ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15273",
    "name": "Jain Uttamchand Maganlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16354",
    "name": "Sharma Yogesh Babulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3416",
    "name": "Gothane [Panchkroshi  Sahakari Mandal-Bm"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11285",
    "name": "Trivedi Bhavna K"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "22612",
    "name": "Varankar Pratik Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8479",
    "name": "Bhatt Suman Balkrishana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17165",
    "name": "Parab Shubhada Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2634",
    "name": "Soje  Yatsh Antoj ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22151",
    "name": "Lambate Ajay Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6844",
    "name": "Charlie Video Club"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10673",
    "name": "Lodha  Dineshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16034",
    "name": "Shinde Dattatray Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15746",
    "name": "Rayate Neeta Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13041",
    "name": "Gadekar Sushila Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20404",
    "name": "Manjrekar Sanjay Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12296",
    "name": "Rohra Suresh Gopaldas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20826",
    "name": "Jire Pushpa Gulab"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14477",
    "name": "Ghodake Shobha Vikas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20361",
    "name": "Kureshi Usman Lala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12908",
    "name": "Budhia Sanjay Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8682",
    "name": "Lohar Nayana Bipin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17538",
    "name": "Jaiswal Arjun Ramujagir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6132",
    "name": "Sinkar Anil Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17363",
    "name": "More Sadanand Shripati."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16959",
    "name": "Jain Virendrakumar Bhopendrakumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7742",
    "name": "Bhandari Laxman Pandurang."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13728",
    "name": "Wade Ranjana Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15940",
    "name": "Bhandari Revati Moreshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12276",
    "name": "Kadambande Anuradha Shivajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5834",
    "name": "Awari Eknath Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13232",
    "name": "Phadatre Laxman Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12458",
    "name": "Thale Amita Rohidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "110",
    "name": "Ganpat Jagannath Sankpal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1979",
    "name": "Radha  Moorty"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14118",
    "name": "Mane Janu Dagdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "626",
    "name": "Phalke Sambhaji Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "7897",
    "name": "Shinde Pralhad Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7412",
    "name": "Sapa Balkisan R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9282",
    "name": "Vishal Sahyadri Co-Op Hsg Soc.Ltd"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9532",
    "name": "Pisal Bharat Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6780",
    "name": "Lubde Yeshwant Giridhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16230",
    "name": "Rathod Rakhi Vinod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10463",
    "name": "Tamboli Babar Gulab"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10919",
    "name": "Mane Kashinath Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3939",
    "name": "Shinde Dagadu Shivram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "653",
    "name": "Narkar Waman Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10109",
    "name": "Mehboobani Manisha Ishwardas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11480",
    "name": "Patil Alka Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10474",
    "name": "Chavan Krishnarao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5177",
    "name": "Akhil Chira Bazar Kolbhat Sarvajank"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16489",
    "name": "More Rajani Dnyaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7558",
    "name": "Gupta Radheshyam Hardeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6049",
    "name": "Sawant Madhavi Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18404",
    "name": "Pujare Bhagyashree Shring"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16017",
    "name": "Katariya Shripal Lalchand."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12534",
    "name": "Gundal Anil Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17410",
    "name": "Solanki Geeta Bachar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15437",
    "name": "Suthar Mohanlal Khubaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20821",
    "name": "Pedanekar Kiran Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11383",
    "name": "Vishwakarma Arjun Prasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9401",
    "name": "Chavan Kiran Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9461",
    "name": "Mandhare Santosh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8710",
    "name": "Sonmale Vithal Dada"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4404",
    "name": "Gramastha Mandal Dalvi Shidruk Wadi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14859",
    "name": "Chawan Maruti Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13511",
    "name": "Dhumal Devkabai Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15929",
    "name": "Mehta Mahendrakumar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14960",
    "name": "Rana Jayprakash K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13100",
    "name": "Mishra Usha Pankaj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13775",
    "name": "Yadav Jainath Amarbahadur."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17009",
    "name": "Kharade Padma Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12661",
    "name": "Varma Sushila Ramlakhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4877",
    "name": "Utkarsha Mahila Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1253",
    "name": "Sunanda Vasant Shinde."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3511",
    "name": "Patel Iqbal Mohd Amin."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6574",
    "name": "Mehboobani Chandan Ishwardas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "358",
    "name": "Hanmant Namdeo Rasal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3766",
    "name": "Kshirsagar Mohan Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18237",
    "name": "Ambojwadi  Rahiwashi Seva Mahasangh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11966",
    "name": "Jindal Sushil Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3997",
    "name": "Bansode Bhiku Savala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2569",
    "name": "Shinde Baburao Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21896",
    "name": "Devadiga Mohini Hariappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6914",
    "name": "Chavan Ashok Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12811",
    "name": "Shaikh Mohmad Miraj Ebrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3437",
    "name": "Michado Richard Joseph."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15315",
    "name": "Navbalak Krida Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10665",
    "name": "Soni Narayandas Champalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11613",
    "name": "Kambli Pritam S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17946",
    "name": "Mayekar Ajay Ramakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14230",
    "name": "Gupta Omprakash M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10874",
    "name": "More Latabai Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20507",
    "name": "Raipelly Aarti Anilkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5604",
    "name": "Wagh Vimal Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20237",
    "name": "Parab Manali Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12826",
    "name": "Mandhare Deepak Vittalrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9671",
    "name": "Sawant Narendra T"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2886",
    "name": "Raut Pradip Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16030",
    "name": "Bhilare Raghu Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18393",
    "name": "Chaurasiya Brhmanand Shriramnaresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14760",
    "name": "Walavalkar Dinanath Janardan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12468",
    "name": "Panchal Anandiben Maneklal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20418",
    "name": "Sawant Shubhangi Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14579",
    "name": "Chopra Maheshkumar Pawankumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18183",
    "name": "Yadav Prakash Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19207",
    "name": "Mohd. Ali Gulam Farid Bulawale."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9290",
    "name": "Sorate Sunayana Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4323",
    "name": "Chavan Neelabai Umesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14178",
    "name": "Jain Mukesh B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10243",
    "name": "Alvares Rasario Harry"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18147",
    "name": "Varma Gangaprasad Sapanprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6607",
    "name": "Ghadi Suhasini Bhanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14775",
    "name": "Ningawale Mukund G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15169",
    "name": "Cabral  Lawrita"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19893",
    "name": "Gada Amarshi Karshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17124",
    "name": "Gaud Virendra Gorkhnath."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8605",
    "name": "Shaha Hitesh Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9474",
    "name": "Kharat Shashikala Devidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11579",
    "name": "Shukla Neelam Virendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14374",
    "name": "Nitesh Vasantlal Parikh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "263",
    "name": "Biramane Sadashiv Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2059",
    "name": "Chavan Laxman Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12321",
    "name": "Urankar Varsha Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8188",
    "name": "Rahim Abdul Rasul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5684",
    "name": "Gaikwad Rajnikant Prataprao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14185",
    "name": "Katekar Hari Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12689",
    "name": "Brihanmumbai Co-Op Credit Soc.Employees"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16042",
    "name": "Shinde D. R./Nikam K.V./Nikam Laxman S."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12969",
    "name": "Shah Chanpaben Natvarlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3256",
    "name": "Sawant Babaso Daulatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17356",
    "name": "Jain Shantilal Sheshmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12383",
    "name": "Luis Vallery Anthony"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2045",
    "name": "Bandale Krishna Ramchadra ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12512",
    "name": "Sakharkar Mangala Madhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6321",
    "name": "Mohite Krishnarao R."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17743",
    "name": "Dewajsi Babulal M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19958",
    "name": "Gehlot Mohd.Hasan Mohdhanif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17065",
    "name": "Kale Kalish Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10091",
    "name": "Ithape Lavu Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10310",
    "name": "Anapat Hanmant Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "280",
    "name": "Jadhav Vishnu Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2708",
    "name": "Sawant Kashinath Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11591",
    "name": "Acharya Sangeeta Tapan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14343",
    "name": "Kesharsing  Bhirusing."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8195",
    "name": "Mhatre Satish Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10143",
    "name": "Satardekar Asha Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10438",
    "name": "Hajare Maya Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2008",
    "name": "Phalke Mohan Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13924",
    "name": "Navadkar Rajendra Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9674",
    "name": "Hirawat Pradeep K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16496",
    "name": "Sapkal Sambhaji Namdeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1592",
    "name": "Gaikawad Shivdas Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1838",
    "name": "Pawar Tanaji Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5138",
    "name": "Kakade Popat Digambar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12240",
    "name": "Bobade Sanjay Jyotiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12242",
    "name": "Salunkhe Krishna Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6314",
    "name": "Mahibulla  Inamulla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13217",
    "name": "Sable Nita Nitin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1920",
    "name": "Jadhav Jotiram Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7578",
    "name": "Wagdole Subhash Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14690",
    "name": "Sharma Vinod Sanwarmal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2428",
    "name": "Chavan Anandrao Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8746",
    "name": "Ranpariya Varsha Hasmukh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7425",
    "name": "More Santosh Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1711",
    "name": "Ghare Balu Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19447",
    "name": "Akhil Mumbai Chitrapat Sangh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15182",
    "name": "Prabhukelusakar Nandkishor Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4529",
    "name": "Vaidy  S.R."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "316",
    "name": "Sanas Ratnaprabha Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "547",
    "name": "Kadam Rajartam Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16806",
    "name": "Pendurkar Abhijeet Ramakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21117",
    "name": "Amberkar Prasida Jitendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16904",
    "name": "Chomal  Rajkamal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5323",
    "name": "Jawalekar Sunder Harishchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2767",
    "name": "Mulik Bhiku Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18792",
    "name": "Ahir Chandrakant Balaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2206",
    "name": "Salunkhe Prakash Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20489",
    "name": "Gole Priyanka Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7949",
    "name": "Maniar Jayantilal Manilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3319",
    "name": "Pathak Prakash H."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17815",
    "name": "Nikam Nitin Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11472",
    "name": "Jain Bharatkumar H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13402",
    "name": "Gaikawad Yashwant Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12998",
    "name": "Baikar Kisan Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12682",
    "name": "Rawal Binjaram S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12987",
    "name": "Gadia Rajkumar Kurichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15120",
    "name": "Agrawal Krishnadevi Dineshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9649",
    "name": "Shelar Shantaram Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15287",
    "name": "Singh Brajendra Swamicharan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5526",
    "name": "Pol Anilkumar Krishnarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22004",
    "name": "Bansode Sangita Pradeep"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11197",
    "name": "Chawlke Vasudev Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13860",
    "name": "Gogar Surendra Dwarkanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10623",
    "name": "Kavishwar Nabha Pradeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12642",
    "name": "Nachare Anant Devaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20781",
    "name": "Ingwale Laxmi Jagan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3268",
    "name": "Shingare Shyam Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19981",
    "name": "Udeshi Rashmi Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5252",
    "name": "Dange Ayaz G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19125",
    "name": "Tambe Gajanan Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1062",
    "name": "Dave Meena Mohanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10228",
    "name": "Chaugule Vilas Rau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10934",
    "name": "Rimal Chetraj Tikaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21473",
    "name": "Bhandari Dharmesh Moreshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14749",
    "name": "Jain Champalal P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6848",
    "name": "Chavan Mohan Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5124",
    "name": "Phalke Ajit Dnayndeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11810",
    "name": "Sayhodri Rajesh Premchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19931",
    "name": "Balimale Mohd Haroon Haji Gulam Mohd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5899",
    "name": "Bhosale Bipin Rameshchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11868",
    "name": "Tiwari Rajenderkumar Nandkishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10524",
    "name": "Purohit Madansinh Mulsih"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5898",
    "name": "Bhosale Jatin Sureshchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7987",
    "name": "Solanki Chandu/Sadanad S/Suresh A/Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4549",
    "name": "Jadhav Sharad Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14370",
    "name": "1 Shirke Shubhash Shripati1215"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1563",
    "name": "Nikam Laxman Bapusaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15746",
    "name": "Berde Rajiv Rajesh & Berde Isha Rajesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "660",
    "name": "Phalke Raghunath Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15188",
    "name": "Jadhav Umadevi Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9133",
    "name": "Kapadia Mukund Vishweshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18531",
    "name": "Jain Ramesh M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17054",
    "name": "Pawar Anil Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8604",
    "name": "Babar Suresh Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18340",
    "name": "Raut Lina Pradip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12567",
    "name": "Mistry Amy Navoraji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14798",
    "name": "Bergal Mahadeo Keru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12735",
    "name": "Kakad Bharat Mahadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5519",
    "name": "Yadav Rajaram Rambali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4663",
    "name": "Patel Gangaprasad Hrichand"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "730",
    "name": "Deshmukh Uttamrao Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14033",
    "name": "Gode Poornima Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23140",
    "name": "M Ramchandran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6725",
    "name": "Kuveskar Sonia Ramesh/Sonia"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14006",
    "name": "Angane Shankar Tatoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11704",
    "name": "Kanajiya  Usarabahan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8630",
    "name": "Shiv Sena Khakha No 154"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "952",
    "name": "Tawate Seetabai Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13969",
    "name": "Deshmukh Narayan Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6981",
    "name": "Ghige Hindurao Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9073",
    "name": "Bhandari Vinod Krishna."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19920",
    "name": "Kadam Sanjeev Prataprao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18980",
    "name": "Singh Pramodkumar Adyaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5518",
    "name": "Dasam Madhukar Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8431",
    "name": "Kedia Rajesh Kumar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6230",
    "name": "Jain Prakashmal Danmalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14392",
    "name": "Vaz Rozario Santaque"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12692",
    "name": "Bohra Amritlal L"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2014",
    "name": "Rupani Navroj Kamruddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1539",
    "name": "Ahirekar Vasant Vithalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7991",
    "name": "Shingan Rajaram Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16819",
    "name": "Bhosale Shrikant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17696",
    "name": "Chikhale Dipika Deepak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12387",
    "name": "Barge Sarjerao Vyankat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23321",
    "name": "Chavan Ashwini Bhagaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21798",
    "name": "Jain Mahendrakumar G."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20388",
    "name": "Satra Pankaj Khimajee."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15771",
    "name": "Rayate Ambabai Dada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17080",
    "name": "Jadhav Bajirao Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11828",
    "name": "Vithale Hari J"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10091",
    "name": "Kakade Sunil Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12707",
    "name": "Ithape Mohan Maruti 855 B/62"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6022",
    "name": "Ashameel  Muinuddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17803",
    "name": "Patil Shivaji Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13388",
    "name": "Medtiya Bhagavatsingh B."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21715",
    "name": "Mane Vijaya Sukhdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1586",
    "name": "Morde Vijay Radhu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17434",
    "name": "More Neha Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13522",
    "name": "Shree Cloth Center Employees Group Garatuti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3462",
    "name": "Rais Masooda Yasuf."
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "5757",
    "name": "Pancholi Yasika Dharmesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18662",
    "name": "Verma Bina Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13979",
    "name": "Pathe Manohar Mahadeo."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6866",
    "name": "Mahajan Swati Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14274",
    "name": "Bhandari Dwarkanath Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20416",
    "name": "Khandelwal Gaytri Harinarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3181",
    "name": "Ghorpade Tukaram Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12295",
    "name": "Rohra Sanjay Gopaldas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "381",
    "name": "Rasal Sopan Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6791",
    "name": "Chavan Baban Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17794",
    "name": "Pugonkar Nalini Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3649",
    "name": "Lotlikar Anil Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19020",
    "name": "Jedhe Sampatrao R.&Kakade Bharat Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "111",
    "name": "Shinde Vinayak Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17718",
    "name": "Kothari Chandrakant Rikhbchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "42",
    "name": "Pokle Sadashiv Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12931",
    "name": "Parab Radhika Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "450",
    "name": "Haribhau Singh Shenby."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7317",
    "name": "Vishwakarma Rajpati Shivashankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10699",
    "name": "Rajpurohit Babusingh P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7884",
    "name": "Kasu Shrimati Aanbade Kuttubuddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5737",
    "name": "Narvankar Sudhakar Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9745",
    "name": "Rajput Devkorben H/Rashmi S N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13913",
    "name": "Furtado  R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20442",
    "name": "Nayar Pushpan Narayanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6812",
    "name": "Jadhao Prakash Hanamantarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15051",
    "name": "Singhania Geetadevi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12716",
    "name": "Shinde Maruti Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13028",
    "name": "Mehta Ashwin B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18804",
    "name": "Jagtap  Manda  Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12460",
    "name": "Naik Ajit D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21020",
    "name": "Koli Leelabai Madhukar &Jagdish M Koli"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2386",
    "name": "Jain Babulal Rakhbichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7416",
    "name": "Kadam Baburao Savala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "936",
    "name": "Sangvi Kishor Kanji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7067",
    "name": "Jadhav Gokulabai Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3770",
    "name": "Shinde Ramchandra Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18476",
    "name": "Shivle Kiran Devram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18501",
    "name": "Warma Shivsagar Gayaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21624",
    "name": "Gorave Nivrutti Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11814",
    "name": "Agarwal Krishna Gopaldas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12327",
    "name": "Bhilare Sadashiv Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9382",
    "name": "Patil Prabhakr V."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17855",
    "name": "Shinde Nandkishor Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16399",
    "name": "Nalawade Hanmant Tulshiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14020",
    "name": "Pawar Parubai Chander"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "858",
    "name": "Pradnya Jamnadas Kantaria."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18420",
    "name": "Kadam Ramesh Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9039",
    "name": "Sakhare Shivasharan Swamirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3845",
    "name": "Vrudavan Mahila Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12225",
    "name": "E Or S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18054",
    "name": "Khut Kamlesh Mulshanker"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10902",
    "name": "Prajapati Ramlal Ramharan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "130",
    "name": "Jose Thanka K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15480",
    "name": "Rewdekar Arati Ganesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17540",
    "name": "6 Assemble Lane Bhadut Mandal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12257",
    "name": "Darade Phulchand Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6399",
    "name": "More Rajaran Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15870",
    "name": "Gawade Ajit Parsuram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14864",
    "name": "Mahajan Suresh Hemlal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6863",
    "name": "Nalawade Kisan Shreerang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6449",
    "name": "Sharma  Ramprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15236",
    "name": "Kori Savitridevi Ayodhyaprasad."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13284",
    "name": "Porwal Dilipkumar Lalchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4638",
    "name": "Bhosale Janardan Dadaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4607",
    "name": "Bhosale Ashok Jijaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11845",
    "name": "Lad Mangesh Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18336",
    "name": "Kalokhe Baliram Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10418",
    "name": "Kanojia Ramesh Badriprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8740",
    "name": "Chavan Ravindra Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6507",
    "name": "Shah Deepak D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10527",
    "name": "Ansari Anwar Ali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12239",
    "name": "Kajale Shekhar Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4235",
    "name": "Chaudhari Parshram Vasudeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16426",
    "name": "Parke Nisha Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6433",
    "name": "Kadam Shashikant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8076",
    "name": "Salunkhe Jaywant Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12050",
    "name": "Chougule Namdeo Manu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4288",
    "name": "Gupta  Ramcharan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11911",
    "name": "Varagade Supriya Jaywant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7383",
    "name": "Chawan Shankar Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18399",
    "name": "Gosavi Vaishali Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13751",
    "name": "Bhosale Ashok Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15309",
    "name": "Bhonsale Vijay Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14538",
    "name": "Satupe Rakhi Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17071",
    "name": "Patil Sagar Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9494",
    "name": "Taware Tukaram Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17878",
    "name": "Parmar Dilip Devidayal  Toli-1576/1"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16274",
    "name": "Shinde Vinayak Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15674",
    "name": "Ali  Sauket"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16511",
    "name": "Ramswami  Ramni"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5555",
    "name": "Salunkhe Kisan Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13402",
    "name": "A  Harish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9431",
    "name": "Ranware Surshing Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3461",
    "name": "Patel Najma A."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15329",
    "name": "Pathare Vilas Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12242",
    "name": "Munde Madhusudan Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12055",
    "name": "Gala Chandrakant Jethalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1386",
    "name": "Gurboy Narsayya Nagula."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13454",
    "name": "Naik Pundalik L"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6555",
    "name": "Regmi Tekraj T"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8751",
    "name": "Keer Digamber Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13855",
    "name": "Shirsat Laxman Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11569",
    "name": "Agarwal Satishkumar Babulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19620",
    "name": "Desai Dilip Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12173",
    "name": "Puralkar Sneha Suryakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12806",
    "name": "Jadhav Gulab Shitaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1611",
    "name": "Mhatre Kadam Balu ''Balya''"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1546",
    "name": "S Suresh Sairam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18186",
    "name": "Awate Hanumant Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13620",
    "name": "Sauket  Ali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3953",
    "name": "Deshmukh Sahebrao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8046",
    "name": "Patadia Madhuben Dinesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14059",
    "name": "Modi Jaswantiben Prataprai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14909",
    "name": "More Rajendrakumar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20326",
    "name": "Rathod Mohanlal Taraji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "371",
    "name": "Pushpa Bhagoji Chavan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9412",
    "name": "Shah Kalawati Madanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17335",
    "name": "Bhosale Balasaheb Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19916",
    "name": "Bhandari Malini Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "345",
    "name": "Jain Champalal Tejraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14851",
    "name": "Chaurasia Ajay Bankeylal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2699",
    "name": "Bhandari Rajeshree Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2702",
    "name": "Bhandari Vasant Jayshree"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15376",
    "name": "Dhumal Uday Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8749",
    "name": "Rao Shivaji Krishnaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18048",
    "name": "Durga Construction Co"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17960",
    "name": "Parikh Hitakshi Nilesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18335",
    "name": "Bhandari Vijay Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23329",
    "name": "Batavia Ramaben Maganlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1492",
    "name": "Yadav Baban Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8095",
    "name": "Davde Suresh Vithaldas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "631",
    "name": "Chaudhary Dhanaram Dungaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13390",
    "name": "Patel Hasan Omar 844/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17814",
    "name": "Yadav Swaminath Lalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5580",
    "name": "Angel  Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1083",
    "name": "Veershaiv Tarun Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21047",
    "name": "Pokharankar Arjun Ganpat & Others"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12737",
    "name": "Koli Laxmi Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15951",
    "name": "Hadawale Laxman Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4146",
    "name": "Sharma  Shivkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8412",
    "name": "More Pandurang Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3415",
    "name": "Gandhi Sureshkumar Babulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16797",
    "name": "Bldg No.25 Rahivasi Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10507",
    "name": "Sonawane Radha Gurusidh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7538",
    "name": "Tayade Pundalik Balvantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14382",
    "name": "Yadav Vishwanath Rasiyawan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14871",
    "name": "Kambale Rajendra Machindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16629",
    "name": "Kadam Amol Bhausaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "994",
    "name": "Rankhambe Vivekanand Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8270",
    "name": "Mane Sureshrao Babasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17277",
    "name": "Kamble Harshal Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8437",
    "name": "Fernandes Betty S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5028",
    "name": "Khan Mohmed Aslam Bakir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18804",
    "name": "Ferrao Anthony Paschal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13942",
    "name": "Ughade Vijay Sitaram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14435",
    "name": "Agrawal  Sunilkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8853",
    "name": "Malusare Nivrutti Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14923",
    "name": "Brahmane Asha Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21492",
    "name": "Shivalkar  Minanath Janardan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8700",
    "name": "Sarafdar Baburao Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11412",
    "name": "Sawant Subhash Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14171",
    "name": "Harijan Jaleshwar Lautu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16719",
    "name": "Sonavane Anand Ganesh/Ganesh Appaji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17282",
    "name": "Malkan Pooja Harshad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16373",
    "name": "Yadav Dilipkumar Chandrarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3051",
    "name": "Shaik Musha Shaik Nasir."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2749",
    "name": "Sable Sunil Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1163",
    "name": "Arote Dhondiba Mahadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11678",
    "name": "Upadhyay Mahendrakumar Umashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22713",
    "name": "Chavan Bhagaram Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4731",
    "name": "Kadam Maruti Rama"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11755",
    "name": "Shah Bina S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20664",
    "name": "Chitnis Prabhakar Pravin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14236",
    "name": "Mashelkar Anant V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18135",
    "name": "Waikar Krishna Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21897",
    "name": "Sahu Vinodkumar Dhukhiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10828",
    "name": "Nagarkar Sanchita Sanjay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19308",
    "name": "Baria Laxman Puroshottam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1094",
    "name": "Mhatre Shyamibai Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6567",
    "name": "Yadav Bhima Chandrika"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14465",
    "name": "Kadam Bhausaheb Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10610",
    "name": "Maval Taluka Nagrik Sangh Mumbai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9649",
    "name": "Urankar Kirati Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14313",
    "name": "Dhawade Santosh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18004",
    "name": "Rana Nagardas Bhagwandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17651",
    "name": "Chavan Dattaram Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5659",
    "name": "Lohar Ramlal Umarsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23291",
    "name": "Batavia Ramaben Maganlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15897",
    "name": "A  Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1032",
    "name": "Arjun Babaji Nimbare."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17410",
    "name": "Kadam Dhanaji Laxman ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11669",
    "name": "Rele Maya Krishnakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8291",
    "name": "Pandit Suresh N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16140",
    "name": "Gupta Neema Sanjeev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3293",
    "name": "Desai Kishor Vanmalidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14450",
    "name": "Yasinkhan Sabbirkhan Mohammad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17813",
    "name": "More Vitthal Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23619",
    "name": "Nikalje Sunita Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "882",
    "name": "Vencher E. D'Mello."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23050",
    "name": "Flower Growers Association"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7170",
    "name": "Dubal Laxman Nivritti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7363",
    "name": "Patil Dharma Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8830",
    "name": "Jadhav Venklatrao Vitthalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1887",
    "name": "Kalange Tukaram Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8550",
    "name": "Thakur Jayant Mahendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7824",
    "name": "Kanu T Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6352",
    "name": "Shah Ajay K/Pragna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3880",
    "name": "Sawant Alka Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7800",
    "name": "Pulekar Santosh Gajanan/Gajanan V"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9044",
    "name": "Samant Abhijit Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7746",
    "name": "Waikar Ratnakar Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21685",
    "name": "Salunkhe Ketan Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20634",
    "name": "Palani Laxmi Karpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5603",
    "name": "Mhatre Mahesh Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13473",
    "name": "Amruteshwar Co-Op Housing Society L"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21232",
    "name": "Bhongale Sanjay Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7563",
    "name": "Tulaskar Ramakant Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13896",
    "name": "Dr. Sawant Chhaya  Triambakrao."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4338",
    "name": "Chirame Raghunath Dashrath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6955",
    "name": "Gaikwad Pralhad Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9622",
    "name": "Bramhadev Prasad Morya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18412",
    "name": "Chavan Vinod Nagesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14416",
    "name": "Talekar Milind Digamber"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19211",
    "name": "Shah  Arjunbahadur Ratan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4873",
    "name": "Takwale Mayuri Balkrishna/Balkrishna R T"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10069",
    "name": "Jewale Manshi Sukriya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3034",
    "name": "Ohal Pramod Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11925",
    "name": "Agarwal Kamlaprasad C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21335",
    "name": "Soni Moxvaden Kaniilal."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1029",
    "name": "Awachar Vithal Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11306",
    "name": "Disale Abutai G"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17723",
    "name": "Patere Tukaram Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7794",
    "name": "Sawant Gangaram N."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17630",
    "name": "Ghare Vaibhav Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12780",
    "name": "Kambale Namdeo Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18059",
    "name": "Khan Farida Firoj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12297",
    "name": "Kadambande Anuradha Shivajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2766",
    "name": "Raul Subhash Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16283",
    "name": "Gupta Meena O"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19533",
    "name": "Patil Hemant Sudam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18531",
    "name": "Mehta  Anil  Jayantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18875",
    "name": "Morarji Lalji Tambakuwala Bldg Tenant As"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10674",
    "name": "Shah Prabhudas Vallabhdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13678",
    "name": "Pawar Sangeeta Ramchandra."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9713",
    "name": "Kadam Premlata Sonu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15205",
    "name": "Maner Ashok Mathuradas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13059",
    "name": "Shinde Satish Madhavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8146",
    "name": "Ganeshopasak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17031",
    "name": "More Anuradha Krishnakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16136",
    "name": "Dandekar Ravi Nathu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21141",
    "name": "Khanvilkar Mahesh Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21354",
    "name": "Gosavi Padmakar Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10182",
    "name": "Bhawnani Geeta S/Sonu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5596",
    "name": "Redij Rajani Ravindra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13580",
    "name": "Auhad Shashikant Z."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19963",
    "name": "Pujari Harshada Rajendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13553",
    "name": "Shivsena Shaka No 30."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4834",
    "name": "Bhatiya Janata Yuva Morcha Central Mumbi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6848",
    "name": "Bhosale Baburao Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13950",
    "name": "Sawant Avinash Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4819",
    "name": "Shah Chandulal Vidhubhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6427",
    "name": "Mane Dattatray Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9484",
    "name": "Dukhande Sandeep Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19905",
    "name": "Kambale Vasant Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8417",
    "name": "Mahadik Dnyandeo Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5723",
    "name": "Sawant Surekha Ravindra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5954",
    "name": "Raut Shankr Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17535",
    "name": "Patil Datta Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3155",
    "name": "Pol Chhaya Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14730",
    "name": "Bhilare Satish Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11411",
    "name": "Parmar Dineshkumar M"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16495",
    "name": "Vayngankar Chandrakant Mohan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5341",
    "name": "Nawadkar Kalidas Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15927",
    "name": "Barge Udaysing Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9992",
    "name": "Parmar Shankarlal Moteji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17898",
    "name": "Sanjay Bhattacharya /Ramchandr"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12720",
    "name": "Masani Purshottam Damji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4139",
    "name": "Yadav Ujwala Mugatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21433",
    "name": "Mandhare Rajendra Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9152",
    "name": "Barot Deoraj K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8732",
    "name": "Rane Harihar Sitaram/Acchelal S Kalwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11141",
    "name": "Shah Pallavi Rajubhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4358",
    "name": "Dhobi  Bechulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6742",
    "name": "Fatdare Bapu Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3177",
    "name": "Manuskare Kisan Manu324/4"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1385",
    "name": "Raikar Sunil Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21990",
    "name": "Bhadrashwara Manish Dhirubhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14495",
    "name": "Jadhav Lata Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19130",
    "name": "Gada Dilip Malshi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8856",
    "name": "Redkar Mohan Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15895",
    "name": "Jain Dinal Pravin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14522",
    "name": "Maskar Prakash S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22178",
    "name": "Mandal Sujitkumar Nagendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10364",
    "name": "Yadav Deepchandra Ramadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21935",
    "name": "Sawant Arvind Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5647",
    "name": "Aswani Ramesh Jiwatram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15059",
    "name": "Parekh Dipika P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18825",
    "name": "Kokanwashi Rahiwashi Vikas Sangh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14408",
    "name": "Revdekar Ganesh Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15730",
    "name": "Sawant Poonam Bhalchandra."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5610",
    "name": "Shidruk Shankar Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3580",
    "name": "Kamat Manohar Padmnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3345",
    "name": "Patil Yagneshwar Krwhna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "801",
    "name": "Ekambe Sharda Vidyalaya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12367",
    "name": "Hansraj Saraju Gautam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9361",
    "name": "Salunkhe Mohan Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15909",
    "name": "Vaiti Allish Anton/Vaiti Peetar Allish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1740",
    "name": "Dias Maxym V."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17994",
    "name": "Kadav Anand Vasantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12292",
    "name": "Nikam Lahu Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18485",
    "name": "Shivsena Shakha No 30"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17626",
    "name": "Kalange Rajendra Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11457",
    "name": "Jain Hastimal C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15058",
    "name": "Deshmukh Indu Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6399",
    "name": "Pore Surekha Suryakant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17547",
    "name": "Patel Vidya Manubhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14864",
    "name": "Sabale Arjun Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "959",
    "name": "Dhumal Vishwas Vamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17527",
    "name": "Jadhav Rukmanibai Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10192",
    "name": "Lawand Baburao Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23217",
    "name": "Dubal Suresh Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11999",
    "name": "Madane Popat Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8979",
    "name": "Chaskar Ashok Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19304",
    "name": "Salvi Krishna Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5956",
    "name": "More Bapu Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18441",
    "name": "Clemente Patson Valentino"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9383",
    "name": "Gawade Uttam Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17854",
    "name": "Panchal Jayantilal Vanmalidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12193",
    "name": "Rao Bamidipati Shrinivas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15261",
    "name": "Dudwadkar Gitesh P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3558",
    "name": "Raul Jayram Tukaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8979",
    "name": "Sabharwal  Shanta/Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13223",
    "name": "Nikam Yeshwant Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "269",
    "name": "Bhoite Sahebrao Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10932",
    "name": "Pilane Dashrath Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "359",
    "name": "Sambhaji Sadhurao Rasal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5442",
    "name": "Phalke Hirabai Rama"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10183",
    "name": "Gupta Dinesh Hariram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6434",
    "name": "Anthuraj Bali Mariadas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12645",
    "name": "Indradhanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20782",
    "name": "Dhuri Mahesh Muralidhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14555",
    "name": "Thakkar Prakash P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13847",
    "name": "Shejwal Santosh Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3285",
    "name": "Chavan Ashok Govind."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3397",
    "name": "Tiwari  Mayashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21636",
    "name": "Yadav Chhotelal Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19449",
    "name": "Khatun Rabiya Mohammad Umar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11254",
    "name": "Kale Kalpana Bhalchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19988",
    "name": "Patel Ratansi Jakhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17397",
    "name": "Gupta Pinky Brindaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10164",
    "name": "Tirlotkar Prakash Suryaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13850",
    "name": "Gupta Baban Prasad Radhya."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14911",
    "name": "Saha Vinita Dibendu."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19800",
    "name": "Murkute Ashok Y."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6621",
    "name": "Alorkar Balubai B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8665",
    "name": "Patel Dilloo Darius"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20517",
    "name": "Jain Vinit Vinod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12588",
    "name": "Kank Pandurang Dagadu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1323",
    "name": "Shree Vighnahar Nagari Sahakari Patsanstha Ltdbhiwandi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17226",
    "name": "Beni Bijendrsingh Desa-Thakur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3617",
    "name": "Kinger Kamlesh Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9577",
    "name": "Pawar Vijay Devji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16070",
    "name": "Karakera Kishore Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2552",
    "name": "Paryani Deepa L"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21920",
    "name": "Maturkar Kusum Ganesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8451",
    "name": "Pai Shobhana N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5165",
    "name": "Madhavji Thakarshi Bhandut Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19721",
    "name": "Parmar Kunda Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2164",
    "name": "Punjabi Gopal Narayandas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18253",
    "name": "Kumbhar Chetan Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9254",
    "name": "Pillai  Ravichandran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19955",
    "name": "Nagori Mohamed Hussain"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17798",
    "name": "Prajapati Ramjanam Ramkumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4407",
    "name": "Nilkanthbharati Biogas Vikas Sanstha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11972",
    "name": "Saraogi  Bhikamchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1708",
    "name": "Koyana Purva Vibhag Seva Sangh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6206",
    "name": "Shinde Shankar N/Prakash/Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6481",
    "name": "Shah Purnima S."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2987",
    "name": "Chawan Ananda Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6021",
    "name": "Pawar Dinkar Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16518",
    "name": "Shirke Chandrakant Doulat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3958",
    "name": "Shende Ashok Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12240",
    "name": "Panchal Sanjay Maniklal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13069",
    "name": "Darak Shyam Sunder"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16118",
    "name": "Ghadge Mahesh Vishwas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16067",
    "name": "Agarwal Govind M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6504",
    "name": "Aytoda Urmila S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5357",
    "name": "Kothari Deepchand C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3528",
    "name": "Ganesh Bhuvan Bhadut Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12783",
    "name": "Dhamdhere Eknath Gajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7719",
    "name": "Sayat  Salmakhatun."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18007",
    "name": "Jadhav Pratap Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1154",
    "name": "More Maruti Krushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8933",
    "name": "Pinto John Alarbt"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21490",
    "name": "Singh Dhananjay Kumar Arjun Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19942",
    "name": "Solanki Premji Mulaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15460",
    "name": "Pratima Pralhad Jadhav ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15978",
    "name": "Jangam Nagesh Sawalaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20345",
    "name": "Desai Rahul Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22185",
    "name": "Shaikh Salim Dawood"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13066",
    "name": "Baheti Rajesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6813",
    "name": "Bhosale Raja Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22294",
    "name": "Local Kapad Bazar Mukadam Mathadi & Gen"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9189",
    "name": "Salunkhe Madhusudan Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14139",
    "name": "Meher Prashant J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16618",
    "name": "Mahindrakar Vittal Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "556",
    "name": "Chinchkar Dattatray Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18079",
    "name": "Gawali Nirmala Hiralal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5688",
    "name": "Panaskar Pratapro Shripatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10835",
    "name": "Kadam Anant Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13339",
    "name": "Taparia Anand Rameshwarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10984",
    "name": "Nighot Bhagwat Jagatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14693",
    "name": "Parihar Pravin Motilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10024",
    "name": "Rodrigues Anthony Francis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13047",
    "name": "Zagade Pramod Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3568",
    "name": "Bhave Sunita Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14230",
    "name": "Gaikwad Babanrao Bajirao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "468",
    "name": "Aggarwal Vivek Vaibhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7319",
    "name": "Bharati  Chandrashekhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16485",
    "name": "Salunkhe Ramesh Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10968",
    "name": "Shah Hasmukh Pancharia"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10244",
    "name": "Chavan Kisan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17856",
    "name": "Dhotre Sunil Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4423",
    "name": "Dakave Ganpat Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "3905",
    "name": "Mazgaokar Gajanan Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3890",
    "name": "Sawant Chandra Arvind."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3889",
    "name": "Bhosale  D.S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4826",
    "name": "Naik Sadanand N/Narayan L.G./Babna L Gaw"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2974",
    "name": "No 1 Is Compulsory+Any One(Joi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17845",
    "name": "More Vishwanath Antu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6050",
    "name": "Devghare Tukaram Savala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15141",
    "name": "Sing  Udaypratat Sudaysinh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1238",
    "name": "Jagdale Satwashila Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14954",
    "name": "Choudhary Laxman Ramaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18454",
    "name": "Gupta Sushamita Kalyan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2674",
    "name": "Shinde Parwati Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2885",
    "name": "Ingale Nilkanth Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17747",
    "name": "Agarwal Manish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13828",
    "name": "Yadav Tukaram Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6342",
    "name": "Bhuyekar Sarjerao Dattatraya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12979",
    "name": "Ghorpade Dattaraya Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5502",
    "name": "Salate Balu Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14289",
    "name": "Rajbhar Shriram Mangaru."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23573",
    "name": "Mishra Rajeshkumar Haushilaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21631",
    "name": "Tawade Shrikant Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11031",
    "name": "Salunkhe Mahadev Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7708",
    "name": "Shetty Sukumar Kutty"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5777",
    "name": "Tirodkar Jagadish Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6895",
    "name": "Agarwal Ramvilas Damodar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9770",
    "name": "Kadam Lata Balkrushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12770",
    "name": "Barot Bansilal Mohanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22124",
    "name": "Chagti Sorabh Devraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6733",
    "name": "Solanki Bhawarlal Kesharmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19027",
    "name": "Sayyed Akhtar Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4694",
    "name": "Shelatkar Dattatray Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13766",
    "name": "Jain Khushal M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23655",
    "name": "Kakde Nanda Keruba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7311",
    "name": "Padhiyar Mukeshkumar/Daxaj/Nita Sudra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4525",
    "name": "Phalke Sambhaji Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17081",
    "name": "Jadhav Kisan Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5202",
    "name": "Shetty  Vimla"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16990",
    "name": "Flanagan Ernest Joseph"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9586",
    "name": "Jadhav Sitabai Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8426",
    "name": "Bhosale Bhanudas Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17330",
    "name": "Sawant Niraj Arvind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11300",
    "name": "Sanghvi Ramesh Ranchhoddas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21467",
    "name": "Shinde Suryakant Gnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6576",
    "name": "Navale Sadanand Shamji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12170",
    "name": "Bhilare Anant Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10772",
    "name": "Mankar Bhalchandra Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16052",
    "name": "Jain Abhay Mohanlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "174",
    "name": "Phalke Jagannath Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5815",
    "name": "Surve Pralhad Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13800",
    "name": "Jadhav Janardan Sakharam."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16718",
    "name": "Kolekar Nivrutti Dadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21588",
    "name": "Singh Archana Rahul."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15013",
    "name": "Nagare Vishnu Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19019",
    "name": "Charkop Gorai Residents Sahyog Welfare A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21021",
    "name": "Panday Vishwnath Udaybhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8909",
    "name": "Chavan Vijay Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5347",
    "name": "Nikam Balasaheb Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11049",
    "name": "Jain Meena V"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11216",
    "name": "Kshirsagar Dattu Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5788",
    "name": "Gudekar Subhash Narayan/ Pandharinath/Ka"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12964",
    "name": "Prajapti Ratana Raju"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17936",
    "name": "Shete Chandrakant Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12501",
    "name": "Ghoriwala Prakash Chandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1651",
    "name": "Shah Asha C."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5204",
    "name": "Gawade V V/Bhagwat/Bashir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8101",
    "name": "Mehta Kirti Kumar Munilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13917",
    "name": "Jayswal  Manjudevi Dayaram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9005",
    "name": "Madhare Kaushalyakumar Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11943",
    "name": "Deshmukh Sanjay Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15160",
    "name": "Chaudhary Kamaladevi Kanhyalal."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20784",
    "name": "Chandarana Kashmira J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9634",
    "name": "Kaheer Shobha Gurudeen"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17937",
    "name": "Umbare Sanjay Adhikrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "106",
    "name": "Jadhav Vithal Bhairu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6678",
    "name": "Singh Ramesh Shrinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18241",
    "name": "Chawan Kanchan Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9402",
    "name": "Kadam Nilam Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13867",
    "name": "Jadhav Uttam Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9158",
    "name": "Sonar Vinayprakash Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3031",
    "name": "Vedpathak Mangesh Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10599",
    "name": "Gokhile Rekha Devdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11012",
    "name": "Paryani Laxman Shewaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11030",
    "name": "Chaudhari Shankar Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4284",
    "name": "Gujar Kashiram Haripal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5032",
    "name": "Mane Shivaji Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17812",
    "name": "Bhosale Laxman Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15056",
    "name": "Phanse Bldg Rahiwashi Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11235",
    "name": "Jain Babulal Amichand"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "240",
    "name": "Gowari Ramesh Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15969",
    "name": "Jaiswal Kamladevi Algu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11025",
    "name": "Shah Arvind Jamanadas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12632",
    "name": "Bhosale Pandurang Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16166",
    "name": "Bhatt Hemant Jitendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13752",
    "name": "Dand Yogesh Narshi / Mrs. Nalini Y Dand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3073",
    "name": "Pokle Milind Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23397",
    "name": "Pawar Mitali Rajendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18146",
    "name": "Kamble  Ravindra  Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2513",
    "name": "Vaity Inas Lusha."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15920",
    "name": "Kadam Rajendra Hambirrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2436",
    "name": "Bobade Dnyanoba Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20572",
    "name": "Walzade Kishori Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18323",
    "name": "Bobade Ankita Mahavir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12488",
    "name": "Shah Nayana Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3492",
    "name": "Patel  Shantibhai."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15433",
    "name": "Mahadik Tukaram Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6761",
    "name": "Mulay Satyavijay Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12816",
    "name": "Gokharu Manoharlal Mangilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2559",
    "name": "Purohit Basantilal Gowardhanjee"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8057",
    "name": "Charkop Joy Co-Op Hsg.Soc.Ltd."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9188",
    "name": "Singh Kadebahadur Raghuraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11971",
    "name": "Agarwal Narayanprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1160",
    "name": "Chavan Sangram Ganpatrao."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9263",
    "name": "Dhar Ranjana/Suchita Fotedar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3994",
    "name": "Sabastian Francies Rodrigues"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11161",
    "name": "Shah Bachchoobhai Arazan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2775",
    "name": "Raju N A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6404",
    "name": "Navale Shantaram Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8542",
    "name": "Manisha Nagari Sahakari Patpedhi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3624",
    "name": "Kinger Renuka Motiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22674",
    "name": "Varpe Ranjana Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17256",
    "name": "Nawal Nariman Hayway"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11583",
    "name": "Bandekar Kumudini Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16309",
    "name": "Savla Shantaben Velji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14031",
    "name": "Pahilajrai  Lokram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13591",
    "name": "Kamble Sangeeta Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2507",
    "name": "Malhotra Mitali V."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8925",
    "name": "Magare Ashok Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2186",
    "name": "Shetye Ramesh Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15494",
    "name": "Hanuman Mandir Jirnodhar Samiti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3631",
    "name": "Pawar Ananda Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3567",
    "name": "Gurbani Ramesh M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8995",
    "name": "Sonawane Prasanna Martandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7887",
    "name": "Salunkhe Dinkar Abaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10791",
    "name": "Patil Jaywantibai Bhalchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5038",
    "name": "Gondekar Lalit Vishanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2956",
    "name": "Ghorpade Gangaram Buvaseb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18484",
    "name": "Trivedi Bhartiben Laxmidutta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4334",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17264",
    "name": "Tavsalkar Vinayak H"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9319",
    "name": "Mane Anandi Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15014",
    "name": "Ahir Punnabai Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2525",
    "name": "Satara Zilla Madyawarti Pragati Man"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2710",
    "name": "Chavan Laxman Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5646",
    "name": "Khan Abdulla S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13449",
    "name": "Kumar  Baburam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7599",
    "name": "Choudhari Kalawati Madanmohan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "497",
    "name": "Mony Mini Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3891",
    "name": "Bhosale Meghshyam Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16141",
    "name": "Purohit Sardararam Bhuraji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12695",
    "name": "Parte Indubai Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10075",
    "name": "Oza Meena Pravin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9391",
    "name": "Shinde Pandharinath Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15254",
    "name": "Jagtap Satyam Himmatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13807",
    "name": "Patange Sandhya Ganesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15570",
    "name": "Chawla Murli Narandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3372",
    "name": "Yakub  Mohamed."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3484",
    "name": "Sakunde Subhash Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10297",
    "name": "Chalke Smita Gopinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13434",
    "name": "Sabale Subhash Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16927",
    "name": "Raut  Shubhangi  Chandrakant ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9120",
    "name": "Bhagirathi Niwas Bhadekaru Utkarsh Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22728",
    "name": "Morparia Rajesh Gokuldas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4136",
    "name": "Gorsiy Kanchanben Kantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12884",
    "name": "Latke Snehsudha Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16721",
    "name": "Zodage Haribhau Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20269",
    "name": "Mofid M Ahemad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12324",
    "name": "Lekhak Ghanashyam Nandaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13745",
    "name": "Patil Prakash Bhauso"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1511",
    "name": "Choudhary Umesh Harichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19947",
    "name": "Shaikh Esak Yusuf"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13406",
    "name": "Smarak & Karyakarta Vikas Nidhi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11495",
    "name": "Singh Vajir Dhamikaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10227",
    "name": "Vaity Madlyan Shalu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10062",
    "name": "Savla Vasant Velji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12602",
    "name": "Shah Neepa Bhagwandas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5347",
    "name": "Gaikawad Kalidas Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20602",
    "name": "Raut Gouri Girish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5860",
    "name": "Shri Samartha Mandal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4659",
    "name": "Singh Bhavaniprasad Magdum"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8633",
    "name": "Dukhale Akash Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3075",
    "name": "Mohmed T. Hasmi ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13141",
    "name": "Nanalal A Khemrajji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14167",
    "name": "Shri Khanderao Vikas Mandal (Dhamar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1370",
    "name": "Raj Mitra Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9454",
    "name": "Gari Sameer Anis"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11270",
    "name": "Sharma Ramchandra Vasudeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5312",
    "name": "Salunkhe Laxman Joti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "435",
    "name": "Charudutt Babanrao Rasal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5350",
    "name": "Pille A Subramaniam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1499",
    "name": "Bhandari Moreshwar Balkrishna."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16587",
    "name": "Kubal Savita Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3252",
    "name": "Khandvilkar Tukaram Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6086",
    "name": "Dhumal Sampat Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9197",
    "name": "Bhosale Nandkishor Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13021",
    "name": "Awaghade Sanjay Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16437",
    "name": "Lad Nivedita Kamalakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14320",
    "name": "Yewale Dnyandeo Tulshiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21759",
    "name": "Chavhan Ajay Beachu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12802",
    "name": "Gaokar Kashiram Appa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16365",
    "name": "Khedekar Suhasini Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7600",
    "name": "Musale Chandrabhaga Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4154",
    "name": "Barge Anandrao Vyankat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22167",
    "name": "Devrukhkar Mahadeo Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "1634",
    "name": "Nasim Munir Chaudhary"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15417",
    "name": "Kamble Sushil Mukund"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19595",
    "name": "Tupe Dashrath Tulsiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "689",
    "name": "Torsekar Ganesh Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11851",
    "name": "Rathod Jayantilal C"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4451",
    "name": "Patil Gulab Shaligram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12930",
    "name": "Chalawane Lalbahadur Motising"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12343",
    "name": "Yogi Kishor Dhanajibai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3748",
    "name": "Keni Suresh Balu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5348",
    "name": "Bhatnagar Indu Mahesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4491",
    "name": "Seema Deepak Alaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4785",
    "name": "Thakur Sunita P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8597",
    "name": "Charkop Aparna Chs Ltd"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13753",
    "name": "Mahadeshwar Arjun Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21798",
    "name": "Shree Sadguru Bhalchandra Utsav Mandal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3757",
    "name": "Sonavane Balaso Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6358",
    "name": "Jadhav Ramchandra Ravaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8355",
    "name": "Sawant Rajendra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10754",
    "name": "Kutty Johney/Muthaya Samuel"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16086",
    "name": "Salaskar Chandrashekhar Mahadev"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "731",
    "name": "Thakur Sambhaji Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13681",
    "name": "Sawardekar Rajnikant B."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11514",
    "name": "Pawar Pushpa Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6377",
    "name": "Rane Kashinath Subhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17065",
    "name": "Satdive Vijay Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5478",
    "name": "Gandhi Kishan Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16196",
    "name": "Raikar Krishna Mortu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15182",
    "name": "Jain Jaya Parasmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23040",
    "name": "Nilkar Alka Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10798",
    "name": "Choudhari Baban Krishnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7977",
    "name": "Thakur Jayesh Mahendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3937",
    "name": "Bhosale Sonubai Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5747",
    "name": "Bhandari Balkrishna Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2198",
    "name": "Kelo Shankar Govindrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6566",
    "name": "Ingavale Hanmant Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "3742",
    "name": "Bachhuka Puspa S."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12706",
    "name": "Khan Baraktulla Mohamed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16082",
    "name": "Shree Motanka Rahiwashi Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12254",
    "name": "Hule Vasant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10409",
    "name": "Agarwal Dharmesh P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11454",
    "name": "Nayak Yashwant Ramlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10650",
    "name": "Ratan Co-Op.Housing Society Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13817",
    "name": "Kailash Purnwashi Yadav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13568",
    "name": "Shukla Namrata Roshan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11731",
    "name": "Tiwari Daya Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2385",
    "name": "Bhosale Vijay Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14636",
    "name": "Nivgune Dinkar Ramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21150",
    "name": "Jay Mahavir Bhadut Mandal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12835",
    "name": "Rawat Govindsingh Pratap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13381",
    "name": "Mandhre Ashok Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4621",
    "name": "Panchal Pravin Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15818",
    "name": "Shelkae Sulbha Sumant Pankaj Sumant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13796",
    "name": "Nadar John Bosco."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15681",
    "name": "Mehtry Sudesh Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17068",
    "name": "Bal Gopal Sarvjanik Ganeshotsav Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16180",
    "name": "Loniya Panchram Jagmohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12182",
    "name": "Bembi Rajendrakumar Harigopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2665",
    "name": "Kokunde Rajesh Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20108",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10638",
    "name": "Rana Rita A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15276",
    "name": "Murkute Hrishikesh R"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "432",
    "name": "Shelar Shantabai Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4309",
    "name": "Mahadik Rajaram Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6237",
    "name": "Bhosale Dattoba Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1875",
    "name": "Patil Pravin Vasant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6764",
    "name": "Shah Rajkumar R."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10719",
    "name": "Salvi Deepak J/Laxman Raghunath G"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13762",
    "name": "Patil Naresh Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6378",
    "name": "Shekh Rashid Kadir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17916",
    "name": "Bhosale Sunil Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20353",
    "name": "Sardar Abdul Jalil Noorchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18166",
    "name": "Bhadresha Vasant Karsan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13822",
    "name": "Sathe Balwant Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21861",
    "name": "Patil Paurnima Gangadhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15130",
    "name": "Rathod Lata Pannalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20079",
    "name": "Mehta Ramniklal Premchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9282",
    "name": "Bhalerao S D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8898",
    "name": "Gudhekar Rajaram Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17545",
    "name": "Chavan Soniya Sharad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2338",
    "name": "Jadhav Vishwanath Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7311",
    "name": "Banavalkar Reeta Pradip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13763",
    "name": "Bobade Madhukar Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11700",
    "name": "Kondvilkar Lalita Sandesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4425",
    "name": "Shinde Babasaheb Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17567",
    "name": "Dhumal Sunil Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19198",
    "name": "Nikam Sagar Gorakhnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21919",
    "name": "Chatur Ashok Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18046",
    "name": "Todkar Neelam Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23600",
    "name": "Chauhan Sandeep Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21811",
    "name": "Patil Vishakha Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2487",
    "name": "Maruti Ramrao Chavan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2043",
    "name": "Parmar Vaktaram Pemaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1453",
    "name": "Karande Priyanka Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15506",
    "name": "Lad Sanjay Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23154",
    "name": "Rananware Amol Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21024",
    "name": "Jain Narendra Ghisulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12990",
    "name": "Dhumal Haribhau Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20508",
    "name": "Salecha Priyanka Gautam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13951",
    "name": "Sinha Gauttam Kumar."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "399",
    "name": "Hariya Mahesh Keshavji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21047",
    "name": "Adelakar Nitin Nitin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24480",
    "name": "Ansari Iqbal Ahmed Abdul Wahid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24541",
    "name": "Anthony Kannamkunil Joseph"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24872",
    "name": "Bandal Balkrishna Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24522",
    "name": "Baniya Nagesh Baijnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24303",
    "name": "Baranwal Ramnarayan Ramkishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24883",
    "name": "Barretto Winnie Joseph"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1284",
    "name": "Barve Sandeep Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24729",
    "name": "Beg Maqbool Gafar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25171",
    "name": "Belose Shivaji Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2247",
    "name": "Bhagat Akshaykumar Rampyare"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23558",
    "name": "Bhamra Manindersingh Harcharansingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24527",
    "name": "Bharambe Manoj Huna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24799",
    "name": "Bhat Dinesh Jivotam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24528",
    "name": "Bhogal Samshersingh Gurmeetsingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2136",
    "name": "Bhoir Shivdas Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21575",
    "name": "Bhoite Chetan Babanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24062",
    "name": "Bhosale Eknath Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25108",
    "name": "Bhutelo Joseph John"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25186",
    "name": "Charwat Lalitkumar Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21693",
    "name": "Chatur Dilip Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22769",
    "name": "Chaulkar Shashank Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24492",
    "name": "Chavan Madhavi Madan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1632",
    "name": "Chavan Rahul Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24487",
    "name": "Choudhari Vijaykumar Rambaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24589",
    "name": "Chovhan Bajirao Pandurang"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1334",
    "name": "Dange Mininath Popat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25053",
    "name": "Deorukhakar Chandrashekhar Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24565",
    "name": "Dhamapurkar Mangesh Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24491",
    "name": "Dhangar Mahadevi Shivraya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24406",
    "name": "Dhasade Rajaram Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24810",
    "name": "Dhimate Suresh Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24484",
    "name": "Dhiver Radheshyam Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25149",
    "name": "Dhumal Amol Bhagwan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1610",
    "name": "Dhumal Rajendra Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21169",
    "name": "Dubey Ajaykumar Shyam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1322",
    "name": "Dubey Jagdishprasad Ramakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24805",
    "name": "Gadge Dattaram Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21506",
    "name": "Gadhave Surendra Madhukar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1608",
    "name": "Gathelu Sunil Harishchandra"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1586",
    "name": "Gavare Hanmant Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19609",
    "name": "Ghag Ankush Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24587",
    "name": "Ghodke Shrikrishna Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24970",
    "name": "Giri Narsu Dasharath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24428",
    "name": "Goraswa Manji Sawji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24661",
    "name": "Goswami Siyasaran Lakshmandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25159",
    "name": "Gound Rambadan Bunilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23002",
    "name": "Gupta Mukundlal Pancham"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24886",
    "name": "Gupta Ramkumar Ramkishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24863",
    "name": "Gupta Shivmurat Basgeet"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "835",
    "name": "Gupta Vijaykumar Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24394",
    "name": "Gupta Yeshwant Rama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20597",
    "name": "Gurav Mangesh Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24745",
    "name": "Hansora Harshad Virji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24878",
    "name": "Harjan Chedilal Algu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24456",
    "name": "Hatkhambkar Prakash Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25107",
    "name": "Jadhav Chhaya Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24355",
    "name": "Jadhav Kiran Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14224",
    "name": "Jadhav Rajendra Bandopant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20143",
    "name": "Jadhav Sandesh Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24393",
    "name": "Jaiswal Amarnath Radheshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23772",
    "name": "Jawade Devidas Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22779",
    "name": "Jha Shankar Babusaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24716",
    "name": "Joy Varghese K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17802",
    "name": "Kadam Ashok Shamrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1408",
    "name": "Kadam Santosh Chhagan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22278",
    "name": "Kadam Tarkesh Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17081",
    "name": "Kadam Uttam Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22895",
    "name": "Kalamkar Deepak Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24789",
    "name": "Kale Vittal Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24836",
    "name": "Kamble Haridas Ambaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21995",
    "name": "Karawade Bharat Sakharam."
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1781",
    "name": "Kerkar Govind Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25175",
    "name": "Khan Afzal Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24360",
    "name": "Khan Aziz Mohd Rais"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24672",
    "name": "Khan Hanif Abduchatij"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24545",
    "name": "Khan Mohamad Hanif Gulam Dastagir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24687",
    "name": "Khan Mohd Sharif Mohd Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24594",
    "name": "Khedaskar Ramchandra Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24852",
    "name": "Kolekar Laxman Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24631",
    "name": "Kolvankar Subhash Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14906",
    "name": "Kumbhar Bhau Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24519",
    "name": "Kundu Gopaldas Dinbandhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24359",
    "name": "Lavande Bansi Maloji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "934",
    "name": "Lihe Ravindra Namdeo"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1287",
    "name": "Limbole Bhagwat Banaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24558",
    "name": "Liyakat Husain Siraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24637",
    "name": "Lodh Ramsajeevan Suryabali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24658",
    "name": "Lulla Jaya Narendrakumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19897",
    "name": "Madhav Reshma Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24611",
    "name": "Mahadik Parshuram Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24219",
    "name": "Mahato Surendra Ramdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24425",
    "name": "Mahavir Saroj Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24376",
    "name": "Malik Mohd Yusuf Zamir Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19941",
    "name": "Malusare Sunita Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20122",
    "name": "Manchekar Sheetal Shashank"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23606",
    "name": "Mauriya Subhash Ramzora"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24877",
    "name": "Maurya Arun Kumar Ramkhilavan"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "205",
    "name": "Adinath Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "878",
    "name": "Maya Mahila Swayam Saha Bachat Gat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24662",
    "name": "Mehta Girish Vaikunthalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24297",
    "name": "Memon Mohdakram Mohd Yunus"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24876",
    "name": "Mhatre Satish Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24559",
    "name": "Mishra Manikchad Sabhajeet"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24410",
    "name": "Mishra Omprakash Shrikrushnaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24845",
    "name": "Mishra Ramesh Tejbhadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24454",
    "name": "Mishra Shivshankar Ramprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19510",
    "name": "Mohite Eknath Yaswant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4214",
    "name": "Mohite Ravindra Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24525",
    "name": "Morajkar Santosh Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23956",
    "name": "More Mangesh Harish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22464",
    "name": "More Swapnil Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24792",
    "name": "Mourya Chamelidevi Musairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24441",
    "name": "Mule Shashikant Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24714",
    "name": "Mulla Ismail Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25141",
    "name": "Mulla Yusuf Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24388",
    "name": "Muthaye Laxman Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10083",
    "name": "Nanaware Mangal Dnyaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24135",
    "name": "Naniskar Aarti Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24837",
    "name": "Narvekar Pravin Shivaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1102",
    "name": "Nath Sumandev Sapandev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24450",
    "name": "Nayak Anantha Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24381",
    "name": "Nimala Krishna Venkat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21228",
    "name": "Nisar Ahamad Ali Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24660",
    "name": "Pal Lalbahadur Baldev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24546",
    "name": "Pandey Ajaykumar Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24577",
    "name": "Pandey Badelal Radheshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24572",
    "name": "Pandey Dhaneshchandra Shasmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20272",
    "name": "Pandhare Sudhir Yashvantrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2332",
    "name": "Parmar Ashok Bheraram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24664",
    "name": "Patekar Vijay Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24520",
    "name": "Patel Arvind Gaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24521",
    "name": "Patel Bharat Kanjibhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24885",
    "name": "Patel Kiran Nagin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24612",
    "name": "Pathak Lalmani Kalikaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25059",
    "name": "Patil Hirabai Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24875",
    "name": "Patil Motilal Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20764",
    "name": "Patil Sandeep Bhimrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1627",
    "name": "Patil Santosh Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20273",
    "name": "Patil Shubhangi Deepak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20274",
    "name": "Patil Subhash Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2776",
    "name": "Patil Tushar Shamrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "911",
    "name": "Paul Rekha Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24833",
    "name": "Pawar Balkrishna Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20225",
    "name": "Pawar Ramnath Ananda"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1613",
    "name": "Pawar Shubhangi Sandeep"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "751",
    "name": "Pawar Umesh Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24795",
    "name": "Pawar Vasant Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24097",
    "name": "Pawar Vasanti Bharat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "618",
    "name": "Pethad Amit Mahendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23860",
    "name": "Pisal Pallavi Abhijeet"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24377",
    "name": "Poojari Janardan Manjappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22283",
    "name": "Poskar Chandrakant Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24290",
    "name": "Potdar Sham Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25160",
    "name": "Prabhu Mayur Vilas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2304",
    "name": "Prajapati Paras Pannalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24667",
    "name": "Quiney Condred Thomas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24842",
    "name": "Rajpure Dilip Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23322",
    "name": "Rasal Prashant Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24750",
    "name": "Rathod Mathurbhai Kalubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24632",
    "name": "Revadekar Ganesh Dhaku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24440",
    "name": "Sable Narayan Sidhram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23692",
    "name": "Salunkhe Sagar Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25106",
    "name": "Salvi Omprakash Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24746",
    "name": "Saniya Kantilal Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24777",
    "name": "Satam Mohan Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24697",
    "name": "Sawant Prakash Devnand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24614",
    "name": "Sawant Prakash Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24475",
    "name": "Sawant Sagar Bhimrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23450",
    "name": "Sawant Shivaji Rajaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1452",
    "name": "Sawant Vishal Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25124",
    "name": "Sayyad Nazma Shukat Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25172",
    "name": "Sayyed Mohd Saleem Mohd Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24818",
    "name": "Sayyed Rafiq Riyazddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24497",
    "name": "Shah Jayantilal Mohanalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24386",
    "name": "Shah Nisar Ahmed Mirarshah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24776",
    "name": "Shah Pukarnath Hiraman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24751",
    "name": "Shaik Rais Amir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21661",
    "name": "Shaike Sohal Mustafa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24413",
    "name": "Shaikh Abdul Latif Yasin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22972",
    "name": "Shaikh Abdul Qadir Abdul Sattar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24689",
    "name": "Shaikh Abdul Salim Abdul Kalam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24802",
    "name": "Shaikh Amin Usman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24466",
    "name": "Shaikh Ayub Sayyed Rahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24347",
    "name": "Shaikh Farooq Mohd Umer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24798",
    "name": "Shaikh Gulam Mustafa Rasul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24336",
    "name": "Shaikh Hamid Sahabuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24625",
    "name": "Shaikh Jafar Siddique Issak Imam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24586",
    "name": "Shaikh Mohamed Khalil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24688",
    "name": "Shaikh Mohd Israil Hamid Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24686",
    "name": "Shaikh Mohd Rafiq Abdul Ghani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24330",
    "name": "Shaikh Mohd.Rafi Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25133",
    "name": "Shaikh Mohd.Shafi Abdulkarim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24797",
    "name": "Shaikh Mukhtar Sharif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24490",
    "name": "Shaikh Mumtaz Hussain Sabirali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24258",
    "name": "Shaikh Nasir Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24663",
    "name": "Shaikh Salim Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25140",
    "name": "Shaikh Shafique Abdul Karim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24753",
    "name": "Shaikh Yasin Mohammed Hanif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25071",
    "name": "Shaikh Yusuf Nabilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24498",
    "name": "Shaikh Zahidali Alihasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24620",
    "name": "Sharma Brijkumar Mulchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18920",
    "name": "Sharma Deepak Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24536",
    "name": "Sharma Mohanlal Ramsakal"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "137",
    "name": "Agrawal Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24796",
    "name": "Shetave Jaybharat Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24304",
    "name": "Shigwan Ramakant Narayan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "935",
    "name": "Shinde Pawan Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24529",
    "name": "Shingote Ramesh Yamnaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1441",
    "name": "Shingve Santosh Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22439",
    "name": "Shirke Prafulla Shahaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11431",
    "name": "Shitaphe Purushottam Yashawant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22884",
    "name": "Shukala Pradeepkumar Adyap"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2086",
    "name": "Singh  Baghel Ashutosh Paramatma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24659",
    "name": "Singh Balvinder Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24710",
    "name": "Singh Hanuman Kedarnath Hanuman Kedarnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24679",
    "name": "Singh Mahendra Pratap"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1679",
    "name": "Singh Pradeep Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24642",
    "name": "Singh Rajneesh Adityaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24892",
    "name": "Singh Ramesh Chhattar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24693",
    "name": "Singh Virendrapratap Rajkishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24472",
    "name": "Solanki Gopal Dalpat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "215",
    "name": "Sonar Santosh Hajarilal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1155",
    "name": "Soni Mohini Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24651",
    "name": "Sonkar Lalji Babunandan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24313",
    "name": "Suchde Jayesh Bhogibhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24847",
    "name": "Sumara Ikabal Nooemahammed"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1607",
    "name": "Thakkar Hareshkumar Devji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22807",
    "name": "Thinge William David"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25139",
    "name": "Tiwari Geetadevi Rakeshchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24482",
    "name": "Tiwari Vijay Shankar Butuknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24707",
    "name": "Topale Pramod Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24392",
    "name": "Tulsicha Prakash Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24583",
    "name": "Vancuylenberg Terrence J Regonald Christopher"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24553",
    "name": "Varama Lalita Shivkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24881",
    "name": "Varma Bipatram Bhagwati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24627",
    "name": "Varma Shivkumar Ramratan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24324",
    "name": "Vavare Ramesh Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24215",
    "name": "Yadav Hawaldar Mithu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24581",
    "name": "Yadav Hawaldar Mithu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24566",
    "name": "Yadav Malti Shobhanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24535",
    "name": "Yadav Mewalal Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24790",
    "name": "Yadav Parasnath Ramashankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2134",
    "name": "Yadav Premchand Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24261",
    "name": "Yadav Rajkumar Shrinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25026",
    "name": "Yadav Ravindra Shivkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24840",
    "name": "Yadav Shyamkanhaiya Parasnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25042",
    "name": "Yadav Subhashchandra Vedeshi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24666",
    "name": "Yadav Sukhraj Kalichran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24312",
    "name": "Yadhav Rajendraprasad Dwarka"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1079",
    "name": "All India Human Rights & Citizen Option"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "248",
    "name": "Amar Parcel Service"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "202",
    "name": "Ambika Cycle Mart"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4090",
    "name": "Mohite Shobha Ravindra."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17702",
    "name": "Jagtap Ketan Prakash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "468",
    "name": "Madhavi Naresh Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23169",
    "name": "Kadam Sachin Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19128",
    "name": "Nimbalkar Somnath Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15245",
    "name": "Dhumal Sunil Jijaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8237",
    "name": "Yadav Sumit Ramdhani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19575",
    "name": "Chiwelkar  Shailesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15116",
    "name": "Bhogavekar Prasad Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22117",
    "name": "Wada Sandeep Mukesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23156",
    "name": "Rananware Vishal Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6663",
    "name": "Mohan Kashinath Bhilare"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11930",
    "name": "2 Ydav Dhanaji Bandu672/15"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11081",
    "name": "Aadate Kalawanti Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5522",
    "name": "Aadekar Ashok Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13640",
    "name": "Aamle Jagannath Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4040",
    "name": "Aanute Appa Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15609",
    "name": "Aarekar Dharma Rambhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6673",
    "name": "Aavate Hanumant Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6419",
    "name": "Aaware Bhalchandra Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11948",
    "name": "Aawate Vinayak Vyankatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13103",
    "name": "Achare Ananda Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3298",
    "name": "Achare Dattatraya Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13689",
    "name": "Achare Sangeeta Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5333",
    "name": "Adak Kailash Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9075",
    "name": "Addhav Shrirang Yadavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17482",
    "name": "Adhav Prakash Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5280",
    "name": "Adhav Waman Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12320",
    "name": "Adiwade Dagadu Sadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1487",
    "name": "Adsule Mahadev Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8311",
    "name": "Agarwal Subhash R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11049",
    "name": "Agrawal Vinodkumar R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "629",
    "name": "Ahirekar Dattatrya Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2914",
    "name": "Ahirekar Maruti Vithal 440/3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4396",
    "name": "Ahirekar Shivaji Mansing 548/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3939",
    "name": "Ahirekar Uttam Bhausaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13609",
    "name": "Ambre Pramod Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1459",
    "name": "Ananpat Namdev Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5763",
    "name": "Anapat Keshav Nilu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11795",
    "name": "Anapat Kisan Parabati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4097",
    "name": "Anapat Nathu Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5108",
    "name": "Anapat Nivrutti Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21987",
    "name": "Angane Vilas Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8564",
    "name": "Anpat Dnyandeo Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7944",
    "name": "Anpat Rajendra Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5550",
    "name": "Anpat Ramchandra Bhikoba 260/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7976",
    "name": "Anpat Vishwas Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14602",
    "name": "Ansari Shamshuddin Inayatali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9179",
    "name": "Anuse Bhaguji Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2063",
    "name": "Anute Nivarutti Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2600",
    "name": "Ashish  Sanisation"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3402",
    "name": "Atugade Ananda Dnyandev 263/10"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6762",
    "name": "Atugade Ananda Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15324",
    "name": "Atugade Kisan Ganpati."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14772",
    "name": "Atugade Sanjay Babaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3028",
    "name": "Atugade Shankar Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12924",
    "name": "Babar Dilip Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16902",
    "name": "Babar Jayashri Kundlik."
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2655",
    "name": "Anmol  Trading"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9002",
    "name": "Babar Mohan Dyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1434",
    "name": "Babar Vithal Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1315",
    "name": "Bachulkar Sakharam Daulu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4639",
    "name": "Badade Baban Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9682",
    "name": "Bagal Eknath Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5558",
    "name": "Baing Balu Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9521",
    "name": "Baing Dattatray Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12847",
    "name": "Bansode Ganesh Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12790",
    "name": "Bansode Sampat Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11443",
    "name": "Barathe Ramkamal Muneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8279",
    "name": "Barave Anil Visnu    101/45"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10834",
    "name": "Barave Daulat Sabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9762",
    "name": "Barge Deepak Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9609",
    "name": "Barge Vishwasrao Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14356",
    "name": "Barje Shankar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2827",
    "name": "Barve Raghunath Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2468",
    "name": "Barve Shankar Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13761",
    "name": "Bellai Baburao Chandrai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7385",
    "name": "Bendal Hari Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13200",
    "name": "Berade Kisan Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18766",
    "name": "Bhadricha Lalita Khimaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14696",
    "name": "Bhagat Ankush Gendev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6888",
    "name": "Bhagwat Jijaba Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10294",
    "name": "Bhagwat Sudhir Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5844",
    "name": "Bhaldar Ajmuddin Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7187",
    "name": "Bhapkar Shivaji Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18653",
    "name": "Bhatiya Prem Dwarkadas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13174",
    "name": "Bhavake Ashok Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14186",
    "name": "Bhedate Shankar Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4136",
    "name": "Bhilare Bhivaji Savlaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11671",
    "name": "Bhilare Kailas Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4198",
    "name": "Bhilare Pandurang Genu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13416",
    "name": "Bhilare Shakuntala Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11990",
    "name": "Bhilare Shantaram Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4473",
    "name": "Bhilare Uttam Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2375",
    "name": "Bhingardeve Sitaram S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13742",
    "name": "Bhirukhe Dnyandeo Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3244",
    "name": "Bhise Keshav Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9148",
    "name": "Bhoire Ashok Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13961",
    "name": "Bhoite Bhagwan Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13237",
    "name": "Bhoite Deepak Sampatrao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2165",
    "name": "Ansar Fastners"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9584",
    "name": "Bhoite Hanmant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2312",
    "name": "Bhoite Haribhau Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3709",
    "name": "Bhoite Jaywant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5266",
    "name": "Bhoite Kisn Punderang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11331",
    "name": "Bhoite Manik Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9424",
    "name": "Bhoite Rajendra Daulatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8511",
    "name": "Bhoite Ramesh Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9447",
    "name": "Bhoite Ramesh Jagdeo 140/17"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14934",
    "name": "Bhoite Sharad Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10003",
    "name": "Bhoite Shrikant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4050",
    "name": "Bhoite Sopan Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15643",
    "name": "Bhoite Subhash Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18197",
    "name": "Bhoite Vijay Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10147",
    "name": "Bhoite Virendra Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "382",
    "name": "Bhor Shripati Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6613",
    "name": "Bhorade Narayan Amrut"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6432",
    "name": "Bhosale Anandrao Bajirao  Tn-981-B-12"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8438",
    "name": "Bhosale Ankush Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7961",
    "name": "Bhosale Avida Gautam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4722",
    "name": "Bhosale Baban Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1756",
    "name": "Bhosale Bapu Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1693",
    "name": "Bhosale Dada Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11031",
    "name": "Bhosale Jaywant Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6586",
    "name": "Bhosale Kanif Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5115",
    "name": "Bhosale Khandu Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3314",
    "name": "Bhosale Kisanrao Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6902",
    "name": "Bhosale Machindra Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9921",
    "name": "Bhosale Mansingh Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "520",
    "name": "Bhosale Maruti Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9003",
    "name": "Bhosale Mohan Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13617",
    "name": "Bhosale Mohan Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3273",
    "name": "Bhosale Narayan Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16014",
    "name": "Bhosale Santosh Gorekh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16705",
    "name": "Bhosale Santosh Ramakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "171",
    "name": "Bhosale Sarjerao Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11392",
    "name": "Bhosale Sidram Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10128",
    "name": "Bhosale Suresh Dharmu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14365",
    "name": "Bhosale Umesh Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11849",
    "name": "Bhosale Uttam Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7962",
    "name": "Bhosale Vishnu Gautam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3078",
    "name": "Bhosale Vishwas Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7361",
    "name": "Bhuwad Narayan Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6708",
    "name": "Bichukale Kashinath Rau."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8123",
    "name": "Bobade Chandrakant Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7161",
    "name": "Bobade Dilip Madanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "482",
    "name": "Bobade Nanasaheb B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1426",
    "name": "Bobade Nathu Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6058",
    "name": "Bobade Sambhaji Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4303",
    "name": "Bodake Sadashiv Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13241",
    "name": "Borage Tanaji Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6322",
    "name": "Borage Tanaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15319",
    "name": "Borge Hanmant Hariba."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14734",
    "name": "Bunkar Ramnaresh Shrimahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2446",
    "name": "Chalake Baban Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15633",
    "name": "Chalake Krishna Parashuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6758",
    "name": "Chalake Shrirang Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2697",
    "name": "Chalke Anandrao Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9613",
    "name": "Chalke Kalabai Antu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "413",
    "name": "Chalke Laxman Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15634",
    "name": "Chalke Mohan Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10875",
    "name": "Chandora Milind Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15135",
    "name": "Chaskar Sitaram Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1754",
    "name": "Chatur Pralhad Tulshiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17206",
    "name": "Chaudhari Laxmibai Jaywant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14672",
    "name": "Chaudhari Radheshyam H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14987",
    "name": "Chaudhari Ramnaresh Bhagat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7933",
    "name": "Chaudhari Ramshankar Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15110",
    "name": "Chaugule Kisan Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9631",
    "name": "Chaurasia Rameshchand Chunnilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7114",
    "name": "Chaurdiya Manoj Kumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4183",
    "name": "Chavan Aba Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9508",
    "name": "Chavan Ananda Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2522",
    "name": "Chavan Anandrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16397",
    "name": "Chavan Anandrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11174",
    "name": "Chavan Anandrao Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2369",
    "name": "Chavan Arjun Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5681",
    "name": "Chavan Arjun Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "675",
    "name": "Chavan Baburao Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "742",
    "name": "Chavan Bajirao Bapuji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13725",
    "name": "Chavan Dadaso Dattoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4451",
    "name": "Chavan Dhanwant Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9863",
    "name": "Chavan Dnyanu Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8609",
    "name": "Chavan Durga Kanwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2160",
    "name": "Chavan Eknath Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18219",
    "name": "Chavan Ganesh Vasant."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5484",
    "name": "Chavan Ganpat Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7526",
    "name": "Chavan Gulabrao Bapuji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6665",
    "name": "Chavan Hindurao Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1129",
    "name": "Chavan Hunderao Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13225",
    "name": "Chavan Jaywant Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "939",
    "name": "Chavan Mahadev Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1890",
    "name": "Chavan Mohan Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3080",
    "name": "Chavan Nana Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18251",
    "name": "Chavan Prakash Shriraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "830",
    "name": "Chavan Pralhad Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2117",
    "name": "Chavan Ramdas Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10885",
    "name": "Chavan Sambhaji Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17270",
    "name": "Chavan Savita Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10611",
    "name": "Chavan Shankar Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19071",
    "name": "Chavan Shantaram Mahadev"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4405",
    "name": "Apsara Packing Works"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4315",
    "name": "Chavan Shivaji Bajrang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9034",
    "name": "Chavan Shivaji Dhondi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16835",
    "name": "Chavan Sindhubai Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13334",
    "name": "Chavan Suvarna Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10129",
    "name": "Chavan Tukaram Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8710",
    "name": "Chavan Tukaram Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8862",
    "name": "Chavan Vijay Nilkantha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14942",
    "name": "Chavan Vijay Rohidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13812",
    "name": "Chavan Vijaykumar Nagdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15796",
    "name": "Chavan Vinaykumar Namdevrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4364",
    "name": "Chavan Vitthal Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8342",
    "name": "Chavan Walmik Vithalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12334",
    "name": "Chawan Raghunath Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3989",
    "name": "Chawan Ramchandra Genba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8579",
    "name": "Chawan Ramdas Bhagelu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6307",
    "name": "Chawan Shamrao Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11301",
    "name": "Chawan Shankarrao Ramchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5876",
    "name": "Chawan Shivaji Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3022",
    "name": "Chawan Shrirang Antu"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2722",
    "name": "Arihant Impex"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7536",
    "name": "Chawan Suresh Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10121",
    "name": "Chawan Suresh Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16646",
    "name": "Chikane Ankush Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1967",
    "name": "Chikane Dada Bhairu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21358",
    "name": "Chikhale Prakash Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17682",
    "name": "Chinkate Waman Keru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9028",
    "name": "Chorage Adhik Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4532",
    "name": "Chorage Appaji Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13278",
    "name": "Chorage Eknath Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4632",
    "name": "Chorage Kondiba Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6894",
    "name": "Chorage Maruti Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7673",
    "name": "Chorage Shripat Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14491",
    "name": "Chorat Sahadeo Savala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17478",
    "name": "Chorge Suresh Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6912",
    "name": "Chorge Vasant Gunda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13872",
    "name": "Choubey Chintamani Badriprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8937",
    "name": "Chouhan Gajesing B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5746",
    "name": "Chouhan Gauriram Samuj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9647",
    "name": "Chouhan Jokhu Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9660",
    "name": "Chouhan Ramdev Bekaru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13707",
    "name": "Chouhan Ramkumar Ramchatter"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13886",
    "name": "Chouhan Rampyare Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2871",
    "name": "Dabhade Bhiku Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14600",
    "name": "Dakave Vasant Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7812",
    "name": "Dalvi Ananda Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4773",
    "name": "Dalvi Jaysing Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4231",
    "name": "Daphale Hari Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4260",
    "name": "Daphale Shamrao Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2069",
    "name": "Daptare Sudam Bajaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9175",
    "name": "Dere Virsen Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1112",
    "name": "Desai Anant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6766",
    "name": "Desai Balu Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12868",
    "name": "Desai Biren Shantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7868",
    "name": "Desai Sanjay Balaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14319",
    "name": "Desai Shankar Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16803",
    "name": "Desai Shobhatai Kishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5833",
    "name": "Deshmukh Dilip Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8502",
    "name": "Deshmukh Prakash Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10307",
    "name": "Deshmukh Sanjay Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9755",
    "name": "Devar Perumal Mucchuperumal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15617",
    "name": "Devaya Donti Sarayu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10140",
    "name": "Devkar Uttam Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12659",
    "name": "Dey Nayan Bomkim"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14200",
    "name": "Dhadave Dnyandeo Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15902",
    "name": "Dhamal Dhananjay Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6249",
    "name": "Dhamal Jaising Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16378",
    "name": "Dhamal Pradip Khandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5427",
    "name": "Dhamankar Balu Dhyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10301",
    "name": "Dharmadhikari Vivekkumar B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17820",
    "name": "Dhawale Deelip Dnyadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5346",
    "name": "Dheb Ratnakant Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12388",
    "name": "Dhekale Rajaram Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9800",
    "name": "Dhembare Rajaram Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14434",
    "name": "Dhobi Ramprasad Hariram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16386",
    "name": "Dhole Chandrakant Annaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8310",
    "name": "Dhole Dhananjay Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13125",
    "name": "Dhube Babu Manaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17332",
    "name": "Dhumal  Vasant  Haribhau ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "414",
    "name": "Dhumal Bajirao Jaysingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11937",
    "name": "Dhumal Deepak Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9025",
    "name": "Dhumal Dilip B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10502",
    "name": "Dhumal Jayram B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4421",
    "name": "Dhumal Jijyaba Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5274",
    "name": "Dhumal Pandurang Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13665",
    "name": "Dhumal Prashant Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22010",
    "name": "Dhumal Radhakisan Sahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6425",
    "name": "Dhumal Ramdas Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1051",
    "name": "Dhumal Sarjerao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2948",
    "name": "Dhumal Tukaram Piraji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7591",
    "name": "Dhumal Uttam Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10299",
    "name": "Dhumal Vijaysingh N"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5101",
    "name": "Disale Anandrao Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8681",
    "name": "Disale Ganpat Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17676",
    "name": "Disale Kusum Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15488",
    "name": "Disale Pilabai Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7087",
    "name": "Disale Ravaji Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12362",
    "name": "Doiphode Bhairu Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15680",
    "name": "Doiphode Sangeeta Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8508",
    "name": "Doshi Meera H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5831",
    "name": "Doshi Shashikant R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3831",
    "name": "Dubbal Mahadeo Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21985",
    "name": "Dubey Virendra Acharybarnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15164",
    "name": "Dudhe Patil Santosh Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14877",
    "name": "Dudskar Ashok Janardan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15593",
    "name": "Dwivedi Shravan Vishwambarprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17302",
    "name": "Gade  Pushpa  Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17330",
    "name": "Gade  Seema  Jagannath ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "898",
    "name": "Gadhave Eknath Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7771",
    "name": "Gaikawad Pandurang Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10455",
    "name": "Gaikawad Savitrabai Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1681",
    "name": "Gaikwad Bajirao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8639",
    "name": "Gaikwad Bhagwan Bajrang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7741",
    "name": "Gaikwad Bhalchandra Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8461",
    "name": "Gaikwad Bhimrao Aavba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9173",
    "name": "Gaikwad Kondiram Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10203",
    "name": "Gaikwad Laxman Jotiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16529",
    "name": "Gaikwad Pravina Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8271",
    "name": "Gaikwad Rajaram Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1852",
    "name": "Gaikwad Sampatrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3328",
    "name": "Gaikwad Shrirang Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13131",
    "name": "Gaikwad Uttam Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11680",
    "name": "Gaikwad Yashwant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2498",
    "name": "Garade Ganpat Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10813",
    "name": "Gardi Bapurao Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13918",
    "name": "Gate Suhas Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16223",
    "name": "Gauda  Nivas Timme."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11554",
    "name": "Gauda Dinesh P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14012",
    "name": "Gavade Kalu Ninu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7924",
    "name": "Gawade Balu Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7601",
    "name": "Gawali Baburao Malu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4134",
    "name": "Gawali Gangaram Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2523",
    "name": "Gawali Kisan Malhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11408",
    "name": "Ghadage Shamrao Kishan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1016",
    "name": "Ghadge Manshing Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15129",
    "name": "Ghadge Ramesh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10531",
    "name": "Ghanekar Ganpat Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14955",
    "name": "Ghanekar Shankar Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15567",
    "name": "Gharage Ramraje Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7545",
    "name": "Gharal Balu Keru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9940",
    "name": "Gharal Maruti Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8092",
    "name": "Gharal Yashwant Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1507",
    "name": "Ghare Anandrao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10993",
    "name": "Ghare Sanjay Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8623",
    "name": "Gholap Bhiku Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1624",
    "name": "Ghorpade Baban Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1481",
    "name": "Ghorpade Bhausaheb Buvasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1269",
    "name": "Ghorpade Mansing Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "619",
    "name": "Ghorpade Suresh Jotiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14973",
    "name": "Ghorpade Vilas Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15507",
    "name": "Giri Sandeep Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2182",
    "name": "Godase Jaising Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17269",
    "name": "Gogawale Sanjay Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14030",
    "name": "Gole Hanmant Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11900",
    "name": "Gole Vasant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14193",
    "name": "Gori  Shokat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16818",
    "name": "Goswami Ghevanath Harinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17388",
    "name": "Gothal  Amit  Ravaji ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16983",
    "name": "Gujar  Sirtajali  Asgarali ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14136",
    "name": "Gulabe Tanaji Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4321",
    "name": "Gundage Ramchandra Ganu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13888",
    "name": "Gupta Budhai Nanaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9760",
    "name": "Gupta Hiralal Ghishawan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8426",
    "name": "Gupta Jagai Tevatmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14977",
    "name": "Gupta Naresh Ramniwas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9759",
    "name": "Gupta Ramchander Ramsumayer"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10708",
    "name": "Gupta Sukhadeo Chotelal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17202",
    "name": "Gurav Parshuram Balu."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13781",
    "name": "Halankar Jayashree Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2660",
    "name": "Harjit  Singh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10958",
    "name": "Harugade Dnyandeo Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9493",
    "name": "Hinukale Ananda Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6372",
    "name": "Hinukale Khashaba Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12655",
    "name": "Hule Baban Abu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4916",
    "name": "Hule Prakash Venunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15316",
    "name": "Hule Vasant Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11461",
    "name": "Humane Ganpat Ragho"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3595",
    "name": "Inamdaar Jaibhun Dastagir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14957",
    "name": "Indulkar Raju Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16352",
    "name": "Indulkar Shukantala Prakesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12982",
    "name": "Ingale Shevantabai P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5989",
    "name": "Ithape Namdeo Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15408",
    "name": "Jadhav  Rajendra Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17030",
    "name": "Jadhav  Tatyaba  Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4980",
    "name": "Jadhav Aatmaram Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2158",
    "name": "Jadhav Ananda Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9434",
    "name": "Jadhav Ananda Kishan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9730",
    "name": "Jadhav Ananda Kishan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15092",
    "name": "Jadhav Anna Raosaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10376",
    "name": "Jadhav Arun Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9275",
    "name": "Jadhav Baban Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11072",
    "name": "Jadhav Bandu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5999",
    "name": "Jadhav Bhiva Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17209",
    "name": "Jadhav Chandrakant Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3962",
    "name": "Jadhav Chandru Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11269",
    "name": "Jadhav Daji Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "737",
    "name": "Jadhav Dashrath Bandoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12466",
    "name": "Jadhav Deepak Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3334",
    "name": "Jadhav Eknath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9764",
    "name": "Jadhav Fulakant Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3983",
    "name": "Jadhav Gautam Gulab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10953",
    "name": "Jadhav Gunabai Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5410",
    "name": "Jadhav Hanmant Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8353",
    "name": "Jadhav Hanumant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3317",
    "name": "Jadhav Janardan Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5912",
    "name": "Jadhav Kalidas Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6911",
    "name": "Jadhav Kisan Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20888",
    "name": "Jadhav Leena Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6590",
    "name": "Jadhav Mahadeo Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "217",
    "name": "Jadhav Malahu Bruja"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17650",
    "name": "Jadhav Pandurang Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7463",
    "name": "Jadhav Pandurang Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19043",
    "name": "Jadhav Pravin Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1229",
    "name": "Jadhav Rajendra Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14640",
    "name": "Jadhav Ramchandra Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16004",
    "name": "Jadhav Ramchandra Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13667",
    "name": "Jadhav Ramdas Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3425",
    "name": "Jadhav Ramesh Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15522",
    "name": "Jadhav Rangnath Mahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1247",
    "name": "Jadhav Sadashiv Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1285",
    "name": "Jadhav Sadashiv Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3848",
    "name": "Jadhav Sambhaji Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2597",
    "name": "Jadhav Sampatrao Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5791",
    "name": "Jadhav Shamrao Dnyanu"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4627",
    "name": "Baban Bhikoba More"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "773",
    "name": "Jadhav Shankar Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7559",
    "name": "Jadhav Shankar Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14209",
    "name": "Jadhav Shantabai Genu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12037",
    "name": "Jadhav Shantaram Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16531",
    "name": "Jadhav Sharada Kisan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7629",
    "name": "Jadhav Shivaji Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14912",
    "name": "Jadhav Shripati Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15577",
    "name": "Jadhav Tukaram Kundlik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "124",
    "name": "Jadhav Vasant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13885",
    "name": "Jadhav Vimal Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7265",
    "name": "Jadhav Vimal Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15240",
    "name": "Jadhav Vinod Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5669",
    "name": "Jadhav Vishnu Bhairu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16015",
    "name": "Jadhav Yeshwant Dhyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10402",
    "name": "Jagatap Dayanand Parapati Toli No 252/14"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2878",
    "name": "Jagdade Vithoba Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10187",
    "name": "Jagdale Harishchandra Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3184",
    "name": "Jagdale Jagannath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11267",
    "name": "Jagdale Yashodabai Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17154",
    "name": "Jagtap  Suhash  Mahipat ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16723",
    "name": "Jagtap Dhananjay Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3543",
    "name": "Jagtap Hanmant Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17282",
    "name": "Jagtap Hema Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12954",
    "name": "Jagtap Hindurao Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10693",
    "name": "Jagtap Laxman Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7570",
    "name": "Jagtap Madhukar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14017",
    "name": "Jagtap Mahesh Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6009",
    "name": "Jagtap Mahipatrao Marutirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6505",
    "name": "Jagtap Pralhad Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "813",
    "name": "Jagtap Sahebrao Ravji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9214",
    "name": "Jagtap Shankar Lakat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16536",
    "name": "Jagtap Suryakant Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11210",
    "name": "Jagtap Suryakant Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15333",
    "name": "Jaigude Rohidas Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14077",
    "name": "Jain Jinal Mukeshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8061",
    "name": "Jain Pardeep Kumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7927",
    "name": "Jain Prashant B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5901",
    "name": "Jain Pushpaben Amratlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16611",
    "name": "Jain Ranjeet Tejraj."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9763",
    "name": "Jain Uttamkumar Kantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14698",
    "name": "Jaiswal Asharam R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12718",
    "name": "Jaiswal Laltaprasad Gayadin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16080",
    "name": "Jaiswal Nohara Brijlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13652",
    "name": "Jaiswal Rajkumar Ramdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15477",
    "name": "Jaiswal Rajkumar Ramsamuj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14679",
    "name": "Jaiswal Ramlal Sulchain"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13651",
    "name": "Jaiswal Satiram Sobhe"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13485",
    "name": "Jambhale Dattatray Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21052",
    "name": "Jamkhande Manohar Jaywant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14264",
    "name": "Jarad Mahadeo Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10344",
    "name": "Jayaswal  Anilkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16530",
    "name": "Jayaswal Piyaridevi Laltaprasad."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9979",
    "name": "Jedhe Manohar Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21995",
    "name": "Jesinto Clafly Peater ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15899",
    "name": "Jiswal Rammilan Jaglal."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21577",
    "name": "Joshi Gokarana M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10965",
    "name": "Joshi Pravin Chunilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19846",
    "name": "Juwatkar Anand Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9149",
    "name": "Kachare Anna Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "676",
    "name": "Kadam Anandrao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8043",
    "name": "Kadam Arvind Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4909",
    "name": "Kadam Babu Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14072",
    "name": "Kadam Babubai Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11312",
    "name": "Kadam Baburao Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13957",
    "name": "Kadam Bandu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14843",
    "name": "Kadam Bhagwan Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2633",
    "name": "Kadam Bhanudas Krushnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19445",
    "name": "Kadam Chandrkant Ramchandra."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "630",
    "name": "Kadam Chandu Gunaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15833",
    "name": "Kadam Chetansing Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9112",
    "name": "Kadam Dadurao Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3878",
    "name": "Kadam Digambal Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13443",
    "name": "Kadam Ganpat Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10728",
    "name": "Kadam Gopal Tayappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6263",
    "name": "Kadam Hanmantrao Jagdevrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12000",
    "name": "Kadam Mahadeo Bali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13663",
    "name": "Kadam Nanda Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12674",
    "name": "Kadam Nanda Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1945",
    "name": "Kadam Narayan Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4289",
    "name": "Kadam Nathu Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "206",
    "name": "Kadam Popat Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3552",
    "name": "Kadam Ramu Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15085",
    "name": "Kadam Rohidas Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4379",
    "name": "Kadam Sambhaji Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5343",
    "name": "Kadam Sampat Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13988",
    "name": "Kadam Sangeeta Dnyana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8061",
    "name": "Kadam Savita Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2834",
    "name": "Kadam Shamrao Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7672",
    "name": "Kadam Shivaji Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14851",
    "name": "Kadam Shivaji Ishwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15358",
    "name": "Kadam Subhash Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3420",
    "name": "Kadam Tukaram Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4299",
    "name": "Kajale Ramchandra Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14504",
    "name": "Kajari Jaysingh Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10314",
    "name": "Kakade Arvind Bhaskar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5288",
    "name": "Kakade Dilip Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3228",
    "name": "Kakade Vilas Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15243",
    "name": "Kakade Vinayak Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14876",
    "name": "Kalage Vishnu Hanumant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2414",
    "name": "Kalambhe Tukaram Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3115",
    "name": "Kalange Bhanudas Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8901",
    "name": "Kalange Dhanaji Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10485",
    "name": "Kalantre Shirish Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10011",
    "name": "Kalokhe Dattatray Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2132",
    "name": "Kalugade Khashaba Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9425",
    "name": "Kalugade Suresh Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12943",
    "name": "Kalukhe Abasaheb Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "243",
    "name": "Kalukhe Mansingh Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12949",
    "name": "Kalukhe Ramdas Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16082",
    "name": "Kambale Ganpat Dhyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10101",
    "name": "Kambale Ishwar Savala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9309",
    "name": "Kamble Bhau Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13769",
    "name": "Kamble Chandrakant Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10421",
    "name": "Kamble Ramchandra Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13755",
    "name": "Kamble Sampat Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7997",
    "name": "Kamble Shankar Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5111",
    "name": "Kamdar Harshad Maganlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1350",
    "name": "Kanase Tukaram Marutirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13264",
    "name": "Kapure Rajendra Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7663",
    "name": "Karande Laxman Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4204",
    "name": "Karanjkar Anandrao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14700",
    "name": "Karanjwade Namdeo Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9186",
    "name": "Karape Hanmant Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16262",
    "name": "Karbhal Vithal Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5351",
    "name": "Karmalkar Vishwanath Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4928",
    "name": "Karne Mahadeo Bhivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10104",
    "name": "Karne Namdeo Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9468",
    "name": "Karpe Mahdeo Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "137",
    "name": "Karpe Shrirang Malhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14743",
    "name": "Kashid Raghunath Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10424",
    "name": "Kashid Ramchandra Kundlik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10905",
    "name": "Kashid Subhash Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9601",
    "name": "Kasid Balkrishna Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4757",
    "name": "Kate Kisan Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3684",
    "name": "Katekar Hirabai Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14182",
    "name": "Katekar Vasant Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13333",
    "name": "Katkar Jagannath Raosaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8356",
    "name": "Katkar Laxman Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2082",
    "name": "Katkar Shankar Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14986",
    "name": "Katkar Shivaji Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5454",
    "name": "Katkar Vishwas Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4943",
    "name": "Kemase Ramaji Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4336",
    "name": "Kenjale Bhagwan Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5816",
    "name": "Khadake Yeshwant Dnyanoba 954/3"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22011",
    "name": "Khadar Sayyed Musa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9471",
    "name": "Khade Chandrabhan Narhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1200",
    "name": "Khade Laxman Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13847",
    "name": "Khadekar Shankar Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12887",
    "name": "Khadzode Anumant Y"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14569",
    "name": "Khalate Prabhavati Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10001",
    "name": "Khalate Rukmini Nilkantharao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11783",
    "name": "Khamekar  Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "490",
    "name": "Khamkar Shankar Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15981",
    "name": "Khan Makbul Sabir Alikhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16934",
    "name": "Khan Shukatali Hubdar Mohamad ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9222",
    "name": "Khandagale Hanumant Motiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "715",
    "name": "Khandagale Yashwant Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4424",
    "name": "Khandagale Yeshwant Vaju"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "958",
    "name": "Khande Shivaji Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3963",
    "name": "Khandekar Vasant Ravaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13512",
    "name": "Khanjode Laxman Yadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13091",
    "name": "Khedekar Dagadu Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9551",
    "name": "Kherade Dnyaneshwar Chintamani"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15224",
    "name": "Kherade Umesh Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16412",
    "name": "Khilare Anandrao Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16730",
    "name": "Khilare Tanaji Namdev."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6740",
    "name": "Khopade Laxman Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13919",
    "name": "Khope Vilas Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2424",
    "name": "Khot Kundlik Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7176",
    "name": "Khot Mahipati Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5537",
    "name": "Khot Shamrao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16337",
    "name": "Kinre Shankar Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6660",
    "name": "Kokane Damodar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13521",
    "name": "Kokane Santosh Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16014",
    "name": "Kolambe Dilip Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3169",
    "name": "Kolekar Balaku Daulu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15527",
    "name": "Kolekar Laxmi Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4490",
    "name": "Kolekar Pandurang Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16761",
    "name": "Koli Sharanappa Sangappa."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6062",
    "name": "Konde Nathu Raosaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13025",
    "name": "Kori Ramshankar Ramvilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21657",
    "name": "Kote Godavari Bhaurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14797",
    "name": "Kothari Dipak Mohanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7577",
    "name": "Kotwal Baban Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7329",
    "name": "Kudale Rajendra Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8128",
    "name": "Kudale Subhash Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14140",
    "name": "Kumbhar Jitendra D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10212",
    "name": "Kumbharkar Vasant Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5223",
    "name": "Kundalkar Yeshwant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3820",
    "name": "Kurmi Durjan Dhanraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "370",
    "name": "Kurmi Hanraj Devaki"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7657",
    "name": "Lad Balkrushna Dagdoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13465",
    "name": "Lakhan Dinkar Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8643",
    "name": "Lakhan Ganpat Devaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4658",
    "name": "Lakhan Hanmant Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13650",
    "name": "Lakhan Kasabai Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10952",
    "name": "Lakhan Shivaji Savala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16649",
    "name": "Lakhani Ashok M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9366",
    "name": "Lambhe Rajaram Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6879",
    "name": "Lawale Balaso Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12395",
    "name": "Lawale Bhanudas Subhedar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2437",
    "name": "Lawale Satyawan Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3768",
    "name": "Lawand Ashok Sopanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3475",
    "name": "Lembhe Jagannath Kondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3017",
    "name": "Lembhe Prakash Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1975",
    "name": "Lembhe Pralhad Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8516",
    "name": "Lembhe Vasantrao Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8153",
    "name": "Lokare Vithal Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8231",
    "name": "Lokhande Ashok Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3077",
    "name": "Lokhande Balwant Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11186",
    "name": "Lokhande Bharat Raosaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4357",
    "name": "Londhe Ramchandra Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16720",
    "name": "Lotlikar Sunita Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22007",
    "name": "Madhgule Dattu Balaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17110",
    "name": "Mahadik Sandeep Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2897",
    "name": "Mahadik Tukaram Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1713",
    "name": "Mahagade Balu Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11821",
    "name": "Mahagade Sahebrao Pilaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5560",
    "name": "Mahangade Appa Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8715",
    "name": "Mahangade Ashok Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1859",
    "name": "Mahangade Govind Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7422",
    "name": "Mahangade Mahadeo Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1758",
    "name": "Mahangare Shankar Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17298",
    "name": "Mahanwar Mahadev Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15290",
    "name": "Makwana Mohanbhai Balabhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14027",
    "name": "Malap Sonabai Santu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6811",
    "name": "Mali Gopaldas Anildas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14379",
    "name": "Mali Subhaschandra Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12326",
    "name": "Mali Subhaschandra Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11445",
    "name": "Malpote Kisan Savalaram 1125/7"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9695",
    "name": "Malpote Pandharinath Rambhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3868",
    "name": "Malusare Ishwar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10076",
    "name": "Malusare Shamrao Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16403",
    "name": "Mamdani Mohmed Salim Fattemohmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16401",
    "name": "Manchekar Priti Surendra."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2825",
    "name": "Mandave Jaywant Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1913",
    "name": "Mandhare Bhikulal Raosaheb"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "87",
    "name": "Bajrang Super Market"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10591",
    "name": "Mandhare Dattatray Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13763",
    "name": "Mandhare Dharmaji Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7266",
    "name": "Mandhare Gorakh Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2164",
    "name": "Mandhare Kisan Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7276",
    "name": "Mandhare Madhukar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5415",
    "name": "Mandhare Popat Jaising"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14632",
    "name": "Mandhare Sandesh Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "933",
    "name": "Mandhare Vasant Pandurang 76/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4125",
    "name": "Mandve Nandeo Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14826",
    "name": "Mane Balu Govinda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11364",
    "name": "Mane Kishor Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11382",
    "name": "Mane Mohan Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9585",
    "name": "Mane Nathuram Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "618",
    "name": "Mane Pandurang Antu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1389",
    "name": "Mane Ramchandra Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3335",
    "name": "Mane Shamrao Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4332",
    "name": "Mankar Diganmbar Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12462",
    "name": "Manuskare Shamrao Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6585",
    "name": "Mardhekar Raghunath Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4058",
    "name": "Maskar Dinkar Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14268",
    "name": "Maskar Ishwar Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15625",
    "name": "Maskar Rajaram Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6500",
    "name": "Matale Ramu Satwa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10326",
    "name": "Matekar Manohar Jyoti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12841",
    "name": "Matekar Ramesh Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17343",
    "name": "Matekar Shrirang Nivrutti &Mane Kishan A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5154",
    "name": "Matkar Mahadeo Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8357",
    "name": "Matkar Pramod Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13409",
    "name": "Matre Khashaba Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8404",
    "name": "Matre Pandurang Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12664",
    "name": "Matre Shashikant Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18823",
    "name": "Mehta Urmila Vasantrai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8970",
    "name": "Mete Laxman Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15987",
    "name": "Mhamunkar Vinod Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1773",
    "name": "Mhaprekar Shivaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1267",
    "name": "Mhatre Abaji Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17408",
    "name": "Mirukhe Tukaram Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9096",
    "name": "Misal Dilip J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15553",
    "name": "Misal Tanaji Nanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9899",
    "name": "Mishra Jitendra Kumar Pyarelal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16743",
    "name": "Mishra Jitendrakumar Satyanarayan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10593",
    "name": "Mishri Rajmati H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4389",
    "name": "Miya Ruaaba Ali Mansukhali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5497",
    "name": "Modak Baburao Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5673",
    "name": "Modak Kisan Nayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10068",
    "name": "Modak Yashwant Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17928",
    "name": "Mohite Alka Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8682",
    "name": "Mohite Bhimrao Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4150",
    "name": "Mohite Mohan Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12363",
    "name": "Mohite Shivaji Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4077",
    "name": "Mohite Uttam Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8889",
    "name": "Mohite Vilas Natha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3905",
    "name": "Momin  Sayyad Aamir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7689",
    "name": "Momin Basheer Amir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4890",
    "name": "Momin Salim Hamid"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17197",
    "name": "More  Seema  Atmaram ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2711",
    "name": "More Ananda Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5486",
    "name": "More Atmaram Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7974",
    "name": "More Baburao Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1905",
    "name": "More Balasaheb Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4471",
    "name": "More Bapurao Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17057",
    "name": "More Chandrakant Parasram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2618",
    "name": "More Dnyanoba Dharmu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6089",
    "name": "More Ganpat Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4741",
    "name": "More Govind Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9635",
    "name": "More Jagdish Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1925",
    "name": "More Khashaba Bayaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3800",
    "name": "More Laxman Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12794",
    "name": "More Mahendra Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3976",
    "name": "More Maruti Subhana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "637",
    "name": "More Maruti Subhana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17512",
    "name": "More Mohan Dyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13271",
    "name": "More Mohan Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8242",
    "name": "More Parashram Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3869",
    "name": "More Parshuram Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "980",
    "name": "More Parsu Sindu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13785",
    "name": "More Parubai Raosaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17423",
    "name": "More Pradeep Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11012",
    "name": "More Pratap Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13242",
    "name": "More Ramchandra Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11839",
    "name": "More Shalan Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12597",
    "name": "More Shivaji Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14684",
    "name": "More Sunil Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "792",
    "name": "More Tukaram Dyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20013",
    "name": "More Uday Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6253",
    "name": "More Uttam Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2311",
    "name": "More Yeshwant Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14571",
    "name": "Motile Shivaji Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4686",
    "name": "Mudgal Rashmi Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1604",
    "name": "Mulani Abdul Lalbhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16909",
    "name": "Mulik  Anita  Sanjay ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6649",
    "name": "Mulik Bhagwan Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2190",
    "name": "Mulik Kisan Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2543",
    "name": "Mulik Laxman Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15309",
    "name": "Mulik Mahendrakumar Aatmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15236",
    "name": "Mulik Mohan Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4654",
    "name": "Mulik Parbat Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14099",
    "name": "Mulik Sanjay Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13747",
    "name": "Mulik Sharad Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11804",
    "name": "Mulik Vilas Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10782",
    "name": "Mulla Balekhan Adam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6608",
    "name": "Mundhra  Bhanwarlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10637",
    "name": "Nagaraji Anmuddin Shamshuddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8922",
    "name": "Nagare Balu Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12592",
    "name": "Nalage Balkrishna Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22027",
    "name": "Nalage Manisha Sunil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1295",
    "name": "Nalage Narayan Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2760",
    "name": "Nalage Ramchandra S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4953",
    "name": "Nalage Sarjerao Vynkatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3369",
    "name": "Nalage Shivaji Dada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1728",
    "name": "Nalage Uttam Kisanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2720",
    "name": "Nalawade Ankush Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2759",
    "name": "Nalawade Atmaram Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1450",
    "name": "Nalawade Dharmaji Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10645",
    "name": "Nalawade Gorakh Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "846",
    "name": "Nalawade Jagnnath Kakasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14484",
    "name": "Nalawade Kalidas Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15825",
    "name": "Nalawade Rohini Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8219",
    "name": "Nalawade Sitaram Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16178",
    "name": "Nalawade Sunil Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8165",
    "name": "Nalwade Ankush Rangoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "888",
    "name": "Nanavare Harishchandra Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13272",
    "name": "Nanavare Sahebrao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12729",
    "name": "Naringrekar Sangeeta Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8088",
    "name": "Nawadkar Ankush Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8563",
    "name": "Nawadkar Balkrishna Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13555",
    "name": "Nawadkar Hindurao Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9449",
    "name": "Nawadkar Jagannath Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14993",
    "name": "Nawadkar Sarjerao B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15027",
    "name": "Nawadkar Shantabai Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7859",
    "name": "Nawadkar Shantaram Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10026",
    "name": "Nawale Ganpat Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5238",
    "name": "Nere Shankar Balaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6188",
    "name": "Nevase Gajanan Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14311",
    "name": "Nevekar Shivaji Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16843",
    "name": "Nikam  Padma Narayan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6820",
    "name": "Nikam Anil Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13526",
    "name": "Nikam Ashok Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8460",
    "name": "Nikam Bhagwat Galagu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15722",
    "name": "Nikam Bharat Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15654",
    "name": "Nikam Dagdu Nathuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7024",
    "name": "Nikam Dattu Tukaram   514/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5888",
    "name": "Nikam Dhansing Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1275",
    "name": "Nikam Krushna Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21998",
    "name": "Nikam Kuldeep Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13604",
    "name": "Nikam Machindra Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11874",
    "name": "Nikam Maschindra Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1226",
    "name": "Nikam Subhash Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17386",
    "name": "Nikam Tulshiram Tukaram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13962",
    "name": "Nilure Chidanand Somanna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1359",
    "name": "Nimbalkar Devidas Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5324",
    "name": "Nimbalkar Prakash Devidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2780",
    "name": "Nimbalkar Ramchandra Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7637",
    "name": "Nimbalkar Sampat Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3180",
    "name": "Nimbalkar Sampat Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10159",
    "name": "Nimbalkar Sanjay Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13047",
    "name": "Nimbalkar Satish Dharma"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5332",
    "name": "Nimbalkar Tukaram Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8547",
    "name": "Nimbalkar Vasant Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16148",
    "name": "Nirule  Shivsharan Somanna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13726",
    "name": "Om Mitra Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13484",
    "name": "Oval Vithal Mariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12675",
    "name": "Ozarkar Khandu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16807",
    "name": "Pachangane Balu Parashram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16645",
    "name": "Pachangane Kisan Dada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4268",
    "name": "Padalghare Genu Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14676",
    "name": "Panchangane Raghunath Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22029",
    "name": "Pandey Mulchand Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8555",
    "name": "Pandey Omprakash Munnaprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "620",
    "name": "Pandurang Bandu Kadam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "468",
    "name": "Pandurang Bandu Kadam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19604",
    "name": "Pandye  Anil Kedarnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13418",
    "name": "Pandye Chandrikaprasad M"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15723",
    "name": "Pansare Vivek Anand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4056",
    "name": "Parab Chandrakant Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17158",
    "name": "Parab Sanjay Narhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15848",
    "name": "Parab Umesh Gopinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15257",
    "name": "Patane Ramchandra Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15306",
    "name": "Pathak Avdheshkumar Devtadin."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14842",
    "name": "Pathan Barhachi Hasali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16607",
    "name": "Pathan Emran Mhebubkhan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6593",
    "name": "Pathan Haddisputra K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6615",
    "name": "Pathan Jagbahadur Karamdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9672",
    "name": "Pathan Rukhiya Begam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5643",
    "name": "Pathan Safi Kula"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12408",
    "name": "Pathan Sahabani Baitulla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11600",
    "name": "Pathan Sakir Hussain"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12074",
    "name": "Pathan Sakunisha Abdulraheman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14524",
    "name": "Pathan Sharifkhan Bagirkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3224",
    "name": "Pathan Subrati Biji Ali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7035",
    "name": "Pathan Yakubkhan Balurkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5566",
    "name": "Pathan Yusuf Elahi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10605",
    "name": "Patil Ananda Pandurng"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4610",
    "name": "Patil Balu Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3013",
    "name": "Patil Balu Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17425",
    "name": "Patil Chandrakant Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17413",
    "name": "Patil Chandrakant Lahu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3011",
    "name": "Patil Dadu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10237",
    "name": "Patil Dilip Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1944",
    "name": "Patil Dnyanu Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10380",
    "name": "Patil Kondiba Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9781",
    "name": "Patil Maruti Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9476",
    "name": "Patil Nivrutti Dhondi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12333",
    "name": "Patil Ramchandra Y.  543/40"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14106",
    "name": "Patil Ramkrishna Akaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6929",
    "name": "Patil Shamrao Joti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11610",
    "name": "Patil Shankar Devji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7004",
    "name": "Patil Shantaram Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13471",
    "name": "Patil Shivaji Pandurang 1209/3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9228",
    "name": "Patil Tukaram Muraji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15665",
    "name": "Patil Vijay Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "437",
    "name": "Patil Yadavrao Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13623",
    "name": "Patne Ramesh Babaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17587",
    "name": "Pawar  Sadanand Narayan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9583",
    "name": "Pawar Amrut Daulat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10084",
    "name": "Pawar Anandrao Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3739",
    "name": "Pawar Ankush Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1747",
    "name": "Pawar Appaso Baburao 278/3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15983",
    "name": "Pawar Ashok Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5953",
    "name": "Pawar Baban Genba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3300",
    "name": "Pawar Baban Ravaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8615",
    "name": "Pawar Babu Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3210",
    "name": "Pawar Baburao Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3257",
    "name": "Pawar Balaku Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2583",
    "name": "Pawar Balkrushna Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5151",
    "name": "Pawar Bhujang Abaji 911/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10619",
    "name": "Pawar Dagadu Jyoti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3509",
    "name": "Pawar Dattatray Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7251",
    "name": "Pawar Dhondiba Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5305",
    "name": "Pawar Dinkar Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6352",
    "name": "Pawar Dnyandeo Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8075",
    "name": "Pawar Dnyandev Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6509",
    "name": "Pawar Gajanan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13382",
    "name": "Pawar Ganapati Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2213",
    "name": "Pawar Hanmant Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14144",
    "name": "Pawar Himmat Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5806",
    "name": "Pawar Indrajeet Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8638",
    "name": "Pawar Jagannath Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "915",
    "name": "Pawar Jaywant Dyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11967",
    "name": "Pawar Jitendra C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1330",
    "name": "Pawar Kalu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12298",
    "name": "Pawar Madhukar Vithal 218/A/9"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10947",
    "name": "Pawar Mohan Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "40",
    "name": "Pawar Mohan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6295",
    "name": "Pawar Narayan Bhairu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5617",
    "name": "Pawar Narayan Tatyaba 992/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2168",
    "name": "Pawar Narayan Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3894",
    "name": "Pawar Pandurang Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2171",
    "name": "Pawar Popat Jagdevrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2368",
    "name": "Pawar Prabhakar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4225",
    "name": "Pawar Pradeep Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14703",
    "name": "Pawar Rajendra Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9393",
    "name": "Pawar Ramesh Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5282",
    "name": "Pawar Ramesh Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16889",
    "name": "Pawar Ravindra Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11903",
    "name": "Pawar Ravindra Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1701",
    "name": "Pawar Sadashiv Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14946",
    "name": "Pawar Sambhaji Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15406",
    "name": "Pawar Sampatrao D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2249",
    "name": "Pawar Shamrao Jagadish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "196",
    "name": "Pawar Shankar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8822",
    "name": "Pawar Shankar Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8127",
    "name": "Pawar Shantaram Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14265",
    "name": "Pawar Shivaji Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9341",
    "name": "Pawar Shivaji Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1163",
    "name": "Pawar Shivaji Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14408",
    "name": "Pawar Shivram Jyoti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1751",
    "name": "Pawar Sudamrao Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17714",
    "name": "Pawar Sunil Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14683",
    "name": "Pawar Sunil Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16525",
    "name": "Pawar Suresh Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16601",
    "name": "Pawar Suvarna Anil."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13905",
    "name": "Pawar Tukaram Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8630",
    "name": "Pawar Tukaram Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "207",
    "name": "Pawar Tukaram Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5794",
    "name": "Pawar Tukaram Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8935",
    "name": "Pawar Vaishali Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12844",
    "name": "Pawar Vilas Dhodiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8470",
    "name": "Pawar Vishnu Bali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1588",
    "name": "Pawar Vithal Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3048",
    "name": "Pawar Yeshwant Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7431",
    "name": "Pawr Bhagubai Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20233",
    "name": "Pednekar Vinod Bhalchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6557",
    "name": "Pendhare Yeshwant Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7919",
    "name": "Phadtare Anand Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3432",
    "name": "Phadtare Ramchandra Gyanba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6599",
    "name": "Phadtare Vanchalabai Dadaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9581",
    "name": "Phadtare Vithal Pandharinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7751",
    "name": "Phalle Babasaheb Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8647",
    "name": "Pisal Ashok Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2817",
    "name": "Pisal Baban Gyanba 949/7"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5384",
    "name": "Pisal Balwant Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9666",
    "name": "Pisal Devidas Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9572",
    "name": "Pisal Hanmant Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1550",
    "name": "Pisal Jaising Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10078",
    "name": "Pisal Kashinath Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9832",
    "name": "Pisal Kishan Babasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10206",
    "name": "Pisal Muktabai Aabaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17310",
    "name": "Pisal Sadashiv Mahadev."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12862",
    "name": "Pisal Santosh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7229",
    "name": "Pisal Sopan Laxmanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1356",
    "name": "Pisal Sudam Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5455",
    "name": "Pisal Sukhdeo Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11587",
    "name": "Pisal Vasant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10072",
    "name": "Pisal Vasant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3126",
    "name": "Pisal Vishwanath Kondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "794",
    "name": "Pisal Yadavrao Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1518",
    "name": "Pisal Yadavrao Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7523",
    "name": "Pol Satish Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4870",
    "name": "Poojary Aityu Pardeshi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5363",
    "name": "Pophale Balaso Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17890",
    "name": "Potale Vandana Nathuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9264",
    "name": "Prabhu Shrikrishna Purushottam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3042",
    "name": "Pujari Aatmaram Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2869",
    "name": "Pujari Dnyaneshwar Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2596",
    "name": "Pujari Krushna Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3041",
    "name": "Pujari Krushnarao Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9886",
    "name": "Pujari Rekha Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8699",
    "name": "Pujari Uttam Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6240",
    "name": "Pujari Vijaykumar Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16844",
    "name": "Purohit Arjunraj Shambhuram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10349",
    "name": "Purohit Ranjeetsingh N"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11020",
    "name": "Rai Upendrakumar Nandilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15392",
    "name": "Rajbhar Ramdayal Bechan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5149",
    "name": "Raje Bajrang Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7834",
    "name": "Raje Dnyandeo Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2287",
    "name": "Raje Namdev Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13554",
    "name": "Raje Prashakar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4141",
    "name": "Raje Shantaram Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14215",
    "name": "Raje Vikas Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5195",
    "name": "Rajpure Rajaram Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5595",
    "name": "Ramkaran Dila Jaggu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14565",
    "name": "Rampyare Galli Sohrayya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16867",
    "name": "Ranaware Sushant Vitthal ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15836",
    "name": "Ranawde Pandurang Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15837",
    "name": "Ranawde Vijay Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20197",
    "name": "Rane Mahendra Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16109",
    "name": "Rannavare Vijaykumar Mohanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8796",
    "name": "Ranware Prakash Nanasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17368",
    "name": "Rao  Harijor  Dhure ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6754",
    "name": "Rao Omprakash Mohanlalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "764",
    "name": "Raskar Bajirao Santu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14673",
    "name": "Rathor Anraj Kisturchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15419",
    "name": "Ratvan Vasant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12917",
    "name": "Raykar Rajaram Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21988",
    "name": "Reddy G.Nanda Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16167",
    "name": "Roman Varsha Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2546",
    "name": "Sabale Aabaji Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1807",
    "name": "Sabale Ashok Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "961",
    "name": "Sabale Atmaram Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7615",
    "name": "Sabale Bharat Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6427",
    "name": "Sabale Dinkar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11442",
    "name": "Sabale Gajanan Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2970",
    "name": "Sabale Hanmant Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1183",
    "name": "Sabale Hanumantrao Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14098",
    "name": "Sabale Hemalata Bhimashankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11283",
    "name": "Sabale Mohini Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13494",
    "name": "Sabale Nanda Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2655",
    "name": "Sabale Shivaji Sindu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11987",
    "name": "Sabale Sudhir Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10561",
    "name": "Sabale Sunil Murlidhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5006",
    "name": "Sabale Suryakant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5600",
    "name": "Sabale Vishwas Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3482",
    "name": "Sabale Yeshwant Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16650",
    "name": "Said Lata Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2032",
    "name": "Said Narayan Bhau 38/21"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16694",
    "name": "Said Sonabai Laxman."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17441",
    "name": "Saket Sundarlal Jaylal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15311",
    "name": "Sakharam Dhanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6333",
    "name": "Sakpal Balasaheb Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9104",
    "name": "Sakpal Ramesh Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3134",
    "name": "Sakpal Satish Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8560",
    "name": "Sakpal Vaman Jagnnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17680",
    "name": "Sakunde Ankush Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6105",
    "name": "Sakunde Arjun Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5567",
    "name": "Sakunde Babu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12895",
    "name": "Sakunde Nandkumar Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13076",
    "name": "Sakunde Nirmala Satish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13145",
    "name": "Salate Anandrao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14309",
    "name": "Salate Baban Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8440",
    "name": "Salate Bandu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11063",
    "name": "Salate Bayabai Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11412",
    "name": "Salate Chintamani Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11115",
    "name": "Salate Dnyandeo Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8708",
    "name": "Salate Ramchandra Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2409",
    "name": "Salate Sitaram Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11446",
    "name": "Salate Vishnu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4290",
    "name": "Salate Vitthal Laxaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15227",
    "name": "Salian Dinesh Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "81",
    "name": "Salte Ananda Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6582",
    "name": "Salte Maruti Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5706",
    "name": "Salunkhe Babaurao Bayaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5168",
    "name": "Salunkhe Dnyandeo Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2484",
    "name": "Salunkhe Dnyandev Kundalik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16045",
    "name": "Salunkhe Hanmant Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5227",
    "name": "Salunkhe Kisan Khashab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7587",
    "name": "Salunkhe Kishan Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9866",
    "name": "Salunkhe Laxman Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16846",
    "name": "Salunkhe Lilabai Nilkanth ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13379",
    "name": "Salunkhe Nana Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4612",
    "name": "Salunkhe Narayan Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4925",
    "name": "Salunkhe Prabhawati Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "456",
    "name": "Salunkhe Sarjerao Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10508",
    "name": "Salunkhe Shivaji Antu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6097",
    "name": "Salunkhe Shrikrishna Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "678",
    "name": "Salunkhe Shrirang Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17624",
    "name": "Salunkhe Sindhu Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "67",
    "name": "Salunkhe Sopan Bhikuba (Toli No-416)"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14777",
    "name": "Salunkhe Sunil Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10763",
    "name": "Salunkhe Sunil Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6393",
    "name": "Salunkhe Suresh Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16414",
    "name": "Salunkhe Suresh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8791",
    "name": "Salunkhe Vishnu Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19303",
    "name": "Salvi Fatima Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7391",
    "name": "Salvi Vasant Janu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15083",
    "name": "Sanghvi Rakhi Amit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7731",
    "name": "Sanghvi Snehalata Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14931",
    "name": "Sapate Rekha Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9311",
    "name": "Sapkal Maruti Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13982",
    "name": "Sapkal Nivrutti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12889",
    "name": "Sapkal Rajendra Sadashiv859/17"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11633",
    "name": "Sapkal Rajendra Sadashiv859/17"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4915",
    "name": "Sapkal Vitthal Sadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4733",
    "name": "Sarafdar Dnyanu Antu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15252",
    "name": "Sarafdar Dyandeo Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8956",
    "name": "Sarafdar Kisan Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13666",
    "name": "Sarafdar Santu Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "687",
    "name": "Sarvade Ganesh Kacharu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4580",
    "name": "Saste Baban Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12710",
    "name": "Saste Vilas Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2663",
    "name": "Satpute Pandurang Nimbaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7769",
    "name": "Savale Balu Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17176",
    "name": "Sawant  Namdev  Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2256",
    "name": "Sawant Balaso Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10686",
    "name": "Sawant Chandrakant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7644",
    "name": "Sawant Changdeo Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13693",
    "name": "Sawant Dattatray Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15410",
    "name": "Sawant Dhondiram Aatmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6146",
    "name": "Sawant Dinkar Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12489",
    "name": "Sawant Dnyanu Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3347",
    "name": "Sawant Eknath D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9378",
    "name": "Sawant Eknath Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5865",
    "name": "Sawant Ganpat Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4709",
    "name": "Sawant Ganpat Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "663",
    "name": "Sawant Gulab Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22035",
    "name": "Sawant Hanmant Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "885",
    "name": "Sawant Kalidas Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17579",
    "name": "Sawant Kantabai Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3368",
    "name": "Sawant Maruti Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "633",
    "name": "Sawant Maruti Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7674",
    "name": "Sawant Priyanka Prabhakar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2922",
    "name": "Sawant Satish Dattatraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7953",
    "name": "Sawant Shamrao Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12621",
    "name": "Sawant Tukaram Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15580",
    "name": "Sawant Tukaram Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15124",
    "name": "Sawant Vasant Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13875",
    "name": "Sawant Vimal Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2792",
    "name": "Sawant Vinayak Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5192",
    "name": "Sawant Vishnu Savlaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10007",
    "name": "Sawant Vithal Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "722",
    "name": "Sawant Vithal Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16638",
    "name": "Sawant Yeshwant Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13857",
    "name": "Sawant Yogesh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16249",
    "name": "Sawant Yuvaraj Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1406",
    "name": "Sayed Chand Makbul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6231",
    "name": "Sayyad Iqbal Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22044",
    "name": "Shah Alam Amir Hasanhkan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9004",
    "name": "Shah Chetankumar N"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8746",
    "name": "Shah Kinjal Madanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10255",
    "name": "Shah Mangalaben Mafatlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9134",
    "name": "Shah Mangleshkumar Jawanmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9564",
    "name": "Shaikh Anwar Ali Rehamatali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14577",
    "name": "Shaikh Hamidulla Aibulla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5383",
    "name": "Shaikh Meheboob Amin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13427",
    "name": "Shaikh Muktar Ahamad Abdul Razak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "973",
    "name": "Shaikh Nasarlal Subhedar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3030",
    "name": "Shaikh Nibar Ooti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6721",
    "name": "Shaikh Rajakmohammad Mohammad Yakub"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22000",
    "name": "Shaikh Salim Zaiauddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3546",
    "name": "Shaikh Shanurabi Mahiboob"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14432",
    "name": "Shaikh Yarmohammed Sidhu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8377",
    "name": "Shedage Laxman Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3754",
    "name": "Shedage Nivrutti Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12760",
    "name": "Shedage Vishwas Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15575",
    "name": "Shejwal Vinod Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6517",
    "name": "Shelar Ananda Aaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1263",
    "name": "Shelar Narayan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4740",
    "name": "Shelar Raghunath Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6082",
    "name": "Shelar Ravaji Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16608",
    "name": "Shelar Sadashiv Tukaram ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2946",
    "name": "Shelar Shankar Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8040",
    "name": "Shelar Shivaji Ravaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "967",
    "name": "Shelke Dnyandev Gopalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18341",
    "name": "Shelke Naklabai Kanhaiyya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7258",
    "name": "Sherekar Sakharam Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6868",
    "name": "Shesmal  Jivanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15274",
    "name": "Shetkar Nikhil Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2483",
    "name": "Shewale Balkrushna Dattatraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2812",
    "name": "Shewale Dattatray Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2506",
    "name": "Shibe Aatmaram Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4628",
    "name": "Shibe Maruti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17845",
    "name": "Shidruk  Manisha Kishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "270",
    "name": "Shidruk Rajaram Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6410",
    "name": "Shigvan Baburao Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7326",
    "name": "Shilimkar Chandrakant M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2762",
    "name": "Shilimkar Dagadu Jaising"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11228",
    "name": "Shilimkar Dattatray Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17732",
    "name": "Shinde Amar Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15725",
    "name": "Shinde Anandrao Vaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7088",
    "name": "Shinde Arun Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1345",
    "name": "Shinde Baban Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "558",
    "name": "Shinde Babasaheb Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10193",
    "name": "Shinde Babaso Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13220",
    "name": "Shinde Banubai Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14918",
    "name": "Shinde Bapurao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "396",
    "name": "Shinde Bhagwan Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4822",
    "name": "Shinde Bhaskar Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "968",
    "name": "Shinde Bhiku Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14822",
    "name": "Shinde Dattatray Bhauso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7154",
    "name": "Shinde Dattatray Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4995",
    "name": "Shinde Dattatraya Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "873",
    "name": "Shinde Dattu Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9498",
    "name": "Shinde Devanand Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11426",
    "name": "Shinde Dhansing Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9625",
    "name": "Shinde Dilip Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3236",
    "name": "Shinde Dilip Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4832",
    "name": "Shinde Dnyaneshwar Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2763",
    "name": "Shinde Gulabrao Mahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4541",
    "name": "Shinde Hari Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1856",
    "name": "Shinde Hindurao Jijaba 89/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11913",
    "name": "Shinde Hindurao Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8233",
    "name": "Shinde Jaywant Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6402",
    "name": "Shinde Jaywant Vishwasrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1625",
    "name": "Shinde Kailas Raghunathrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10230",
    "name": "Shinde Kamal Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13291",
    "name": "Shinde Kamalabai Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3527",
    "name": "Shinde Kisanrao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5708",
    "name": "Shinde Kusum Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16294",
    "name": "Shinde Mahadeo Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9778",
    "name": "Shinde Maruti Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3275",
    "name": "Shinde Mohan Ramrao 318/18"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8101",
    "name": "Shinde Nandkumar Banyasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12947",
    "name": "Shinde Narayan Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5663",
    "name": "Shinde Narayan Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12717",
    "name": "Shinde Navnath Genba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6339",
    "name": "Shinde Navnath Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "797",
    "name": "Shinde Rajaram Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11127",
    "name": "Shinde Rajkumar Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2085",
    "name": "Shinde Ramchandra Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4013",
    "name": "Shinde Ramchandra Gopalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6973",
    "name": "Shinde Ramraje Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14050",
    "name": "Shinde Sachin Gorakhnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15163",
    "name": "Shinde Sachin Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1102",
    "name": "Shinde Sakharam Ganapat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9044",
    "name": "Shinde Sampat Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4563",
    "name": "Shinde Sampat Parbati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2932",
    "name": "Shinde Sarjerao Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1941",
    "name": "Shinde Satyawan Dinkarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7340",
    "name": "Shinde Shashikant Duryodhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10683",
    "name": "Shinde Shivaji Dadaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2692",
    "name": "Shinde Shivaji Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8389",
    "name": "Shinde Shivaji Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14838",
    "name": "Shinde Shivajirao Vyankatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11585",
    "name": "Shinde Shrirang Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3000",
    "name": "Shinde Shrirang Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4028",
    "name": "Shinde Sidu Mahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2136",
    "name": "Shinde Sopan Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9637",
    "name": "Shinde Subhash Laxman"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2565",
    "name": "Bhagwati Packing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "892",
    "name": "Shinde Tanaji Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12900",
    "name": "Shinde Trimbak Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5559",
    "name": "Shinde Tukaram Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1836",
    "name": "Shinde Tukaram Nanasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17297",
    "name": "Shinde Uamesh Chandrahari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15456",
    "name": "Shinde Vaibhav Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5886",
    "name": "Shinde Vasant Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "436",
    "name": "Shinde Vinayak Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9838",
    "name": "Shinde Vishnu Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3708",
    "name": "Shinde Vishwas Bausaheb 1214/9"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3411",
    "name": "Shinde Vishwas Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5875",
    "name": "Shinde Vitthal Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2579",
    "name": "Shinde Yeshwant Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1158",
    "name": "Shingan Dinkar Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13267",
    "name": "Shingan Dinkar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2679",
    "name": "Shingan Kashinath Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10177",
    "name": "Shingare Ganpat Chimaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2157",
    "name": "Shingate Kisan Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5296",
    "name": "Shingh  Banshgopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1321",
    "name": "Shirke Dharmu Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "380",
    "name": "Shirke Madhukar Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14887",
    "name": "Shirke Shakuntala Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8017",
    "name": "Shirke Sharad Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14585",
    "name": "Shirke Vikas Dharmu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1248",
    "name": "Shirsat Baburao Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15144",
    "name": "Shirsat Khashaba Dyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10650",
    "name": "Shirsat Sulochana Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5339",
    "name": "Shirsekar Chandrasen Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22030",
    "name": "Shirshat Mahavir Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "277",
    "name": "Shirtude Namdeo Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2874",
    "name": "Shivankar Chandrakant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13173",
    "name": "Shivankar Rajendra Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13067",
    "name": "Shriram Satyawan Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7958",
    "name": "Shukla Shivmurat Ambikaprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22045",
    "name": "Siddique Mohamad Akram Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18409",
    "name": "Singh Anil Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21996",
    "name": "Singh Mithai Sitaram ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22014",
    "name": "Singh Rajkumar Adyaprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22039",
    "name": "Singh Sunilkumar Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9525",
    "name": "Singh Tej Bahadur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4531",
    "name": "Sinha Shashi Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14122",
    "name": "Solanki Tarabai A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2001",
    "name": "Solaskar Nivrutti Kondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16053",
    "name": "Solse Harichandra Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12737",
    "name": "Sonawale Kalidas Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22041",
    "name": "Sonawane Dnyaneshwar Pundlik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8435",
    "name": "Sonawane Janardan Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2096",
    "name": "Sonawane Vishnurao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5584",
    "name": "Soni Vijayraj Saremalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16907",
    "name": "Sonkar  Rajaram  Ganpat ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1252",
    "name": "Sonmale Chandrakant Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15597",
    "name": "Sonmale Sanjay Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15789",
    "name": "Supat Suresh Ratan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7040",
    "name": "Supugade Dinkar Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15931",
    "name": "Surayawanshi Satish B."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15932",
    "name": "Suraywanshi Anil H."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14220",
    "name": "Surve Ishwar Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9121",
    "name": "Suryawanshi Baban Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12577",
    "name": "Suryawanshi Gajanan Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9193",
    "name": "Suryawanshi Ganpat Ravji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10668",
    "name": "Suryawanshi Jagannath Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5951",
    "name": "Suryawanshi Nathuram Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22012",
    "name": "Swami Raju Muthu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5285",
    "name": "Taigade Shamrao Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6431",
    "name": "Talape Maruti Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16928",
    "name": "Tambitkar  Jitendra Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13205",
    "name": "Tandale Pandurang Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8971",
    "name": "Tanksale Rajendra Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14347",
    "name": "Tapare Gopal Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3235",
    "name": "Taware Aatmaram Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3548",
    "name": "Taware Bhau Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3338",
    "name": "Taware Eknath Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4788",
    "name": "Taware Ganpat Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6671",
    "name": "Taware Kisan Chindhu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7945",
    "name": "Taware Kisan Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3140",
    "name": "Taware Laxman Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2331",
    "name": "Taware Sampatrao Maurit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2489",
    "name": "Taware Shankar Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5965",
    "name": "Tel Galli Bhadekaru Mandal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1392",
    "name": "Teli Shantaram Kashiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16469",
    "name": "Tetme Rajaram Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4442",
    "name": "Thick Aaba Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21986",
    "name": "Thirasu Ramdhari Mallah"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6276",
    "name": "Thombare Tukaram Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13835",
    "name": "Thorat Ashok Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7157",
    "name": "Thorat Dinkar Tatoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9955",
    "name": "Thorat Mansing Nivruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9085",
    "name": "Thorat Subhadra Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13129",
    "name": "Tikudave Shankar Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15051",
    "name": "Tiwari Rambodh Chediram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "367",
    "name": "Todkar Ananda Bali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1996",
    "name": "Toraskar Dnyandev Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11803",
    "name": "Tote Mahadeo Vaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7626",
    "name": "Totre Nandaram Bhagoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12764",
    "name": "Ugale Ajay Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13676",
    "name": "Ujgaonkar Ananda Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13119",
    "name": "Vajarkar Laxman Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10244",
    "name": "Vakate Ramchandra Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8474",
    "name": "Varekar Rajaram Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16733",
    "name": "Varma Devideen Dayaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14197",
    "name": "Varma Ramsunder Jagdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14659",
    "name": "Varpe Dinkar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8918",
    "name": "Veer Anandrao Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21317",
    "name": "Vijay Raj Babairao Maurya ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10094",
    "name": "Virkar Baban Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10921",
    "name": "Vyas Haribhai Shama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20374",
    "name": "Wadhel Paresh Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13752",
    "name": "Wadi Ganpati Budhana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16829",
    "name": "Wagh  Tanaji  Yashawant."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17971",
    "name": "Wagh Asha Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12818",
    "name": "Wagh Dhanwant Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3167",
    "name": "Wagh Hanmant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2473",
    "name": "Wagh Hanmant Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17587",
    "name": "Wagh Niwas Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14241",
    "name": "Wagh Pandurang Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11983",
    "name": "Waghmare Sampat Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2616",
    "name": "Walunj Namdeo Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10118",
    "name": "Wanare Abaso Ishwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15336",
    "name": "Warkhade Dattatray Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17323",
    "name": "Yadav  Anil  Bhagwan ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14170",
    "name": "Yadav Amarbahadur Birogi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6770",
    "name": "Yadav Babaso Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14763",
    "name": "Yadav Bambahadur Birogi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10486",
    "name": "Yadav Chtelal Sarju"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5928",
    "name": "Yadav Dattatraya Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9448",
    "name": "Yadav Dayaram Satyanarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4223",
    "name": "Yadav Ganubai Mukund"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12708",
    "name": "Yadav Gayaprasad Ramasare"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9563",
    "name": "Yadav Ghanshyam Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11444",
    "name": "Yadav Hanmant Bajrang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12819",
    "name": "Yadav Hari Charan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3346",
    "name": "Yadav Khashaba Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8376",
    "name": "Yadav Kisan Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10936",
    "name": "Yadav Lodik Bidur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16784",
    "name": "Yadav Madhukar Bajirao ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5263",
    "name": "Yadav Madhukar Bajirao ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9066",
    "name": "Yadav Mahadeo Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15765",
    "name": "Yadav Mohan Bipat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9194",
    "name": "Yadav Popat Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8533",
    "name": "Yadav Rajaram Dhanraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6759",
    "name": "Yadav Rajendra Hambirrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15056",
    "name": "Yadav Rajitram Ramdulare"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6303",
    "name": "Yadav Ramchander Tufani"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2444",
    "name": "Yadav Ramvaran Draou"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16277",
    "name": "Yadav Ravikumar Shreeprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5782",
    "name": "Yadav Seth Mahadeo Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14702",
    "name": "Yadav Sugrim Harilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16460",
    "name": "Yadav Tijadevi Sukhadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22022",
    "name": "Yadav Tilakdhari Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7941",
    "name": "Yadav Vasudeo Prasad Mangalram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14921",
    "name": "Yadav Yashwant Balku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6662",
    "name": "Yadav Yeshwant Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9256",
    "name": "Yadhav Radhesham Ramawadh  1052/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10536",
    "name": "Yelave Hanmant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15496",
    "name": "Yewale Kiran Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11147",
    "name": "Yewale Sarjerao Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8000",
    "name": "Zanzane Kashinath Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15805",
    "name": "Zaware Dilip Tulshiram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5310",
    "name": "Nikam Pandurag Shankar 262/26"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23433",
    "name": "Fernandes Francis Xavier"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "862",
    "name": "Dhanraj Pankaj Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24289",
    "name": "Khan Ziya Mohd Yakub"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19863",
    "name": "Rajpurohit Rajkumar Heersingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11543",
    "name": "Dhumal Vijay Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11479",
    "name": "Aadagale Mugat Ganapat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14164",
    "name": "Aadsare Vasant Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4458",
    "name": "Aamkar Harishchandra Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13642",
    "name": "Aamle Raghunath Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3098",
    "name": "Aarde Sitaram Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11505",
    "name": "Aavchar Anil Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7707",
    "name": "Aaware Haribhau Aanyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8327",
    "name": "Aaware Valmiki Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8776",
    "name": "Acharya Pradip N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21476",
    "name": "Adagale Subhash Dattatraya."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11551",
    "name": "Adhav Dinkar Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14208",
    "name": "Adhikari Ramesh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13693",
    "name": "Adivarekar Deodas Sonu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "229",
    "name": "Adsul Mahadeo Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17282",
    "name": "Advilkar Ravindra Lahu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21662",
    "name": "Agarwal Dhurendra Shankardeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13296",
    "name": "Ahemed Zamirulla Maqbal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14278",
    "name": "Aher Shivaji Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17345",
    "name": "Ahirekar Daivata Gorakh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9562",
    "name": "Ajgoankar Nayan Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19692",
    "name": "Akhade Santosh Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13904",
    "name": "Ali  Sultan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17987",
    "name": "Ambekar Nitin Babaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16649",
    "name": "Amberkar Arati Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18835",
    "name": "Amberkar Nitin Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7555",
    "name": "Amble Parvati Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14856",
    "name": "Ambolkar Bansi Kamalakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21448",
    "name": "Ambre Gajanan Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11433",
    "name": "Anchan Sadashiv D."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21746",
    "name": "Andrus John Rajan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18818",
    "name": "Angane Ashok Naryan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14591",
    "name": "Angat Anjana Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2359",
    "name": "Anita Ganpat Mandhare"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10690",
    "name": "Anpat Balwant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16499",
    "name": "Anpat Manda Santosh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5507",
    "name": "Anpat Namdeo Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7839",
    "name": "Anpat Ravindra Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21510",
    "name": "Ansari Israr Ahmad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14265",
    "name": "Anthony Theresa Philip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18919",
    "name": "Anubhavane Vidya Dattatram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14982",
    "name": "Anusay Uttam Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10682",
    "name": "Anute Ramchandra Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19756",
    "name": "Arate Sulbha Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21313",
    "name": "Arjun Dattu Ghatule ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10499",
    "name": "Armarkar Jagdish Sahdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10494",
    "name": "Arolkar Dwarkanath Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14456",
    "name": "Arolkar Jayshree Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6854",
    "name": "Ashar Nalini Yogesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13526",
    "name": "Atre Bhaskar V"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18819",
    "name": "Attaulla Hak Abdul Hak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17346",
    "name": "Atugade  Babasaheb  Laxman ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5141",
    "name": "Atugade Dadu Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18870",
    "name": "Atugade Rajaram Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3400",
    "name": "Atugade Sidhanath Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12931",
    "name": "Avare Jagannath Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16145",
    "name": "Avhad  Ambadas Mahadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1940",
    "name": "Aware Haribhaau Anyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9571",
    "name": "Awate Sandeep Dnyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2240",
    "name": "Baandal Shrirang Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20244",
    "name": "Babar Avinash Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12934",
    "name": "Babar Laxman Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "159",
    "name": "Babar Shamrao B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11163",
    "name": "Babar Shankar Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15634",
    "name": "Babar Shivaji Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7931",
    "name": "Babar Sunanda Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11851",
    "name": "Bachare Anita Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19536",
    "name": "Bachhe Parubai Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8677",
    "name": "Badgujar Bherulal Vasudeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11620",
    "name": "Bagewadikar Jyoti Narendranath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21319",
    "name": "Bagve Umesh Madhukar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17288",
    "name": "Baiar Vishram Ramji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14316",
    "name": "Baikar Suresh Balaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18663",
    "name": "Bakhe Arjun Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11707",
    "name": "Balatkar Dnyanoba Munjaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16664",
    "name": "Balsaraf  Aprna Suresh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2151",
    "name": "Bamane Suhasini Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16867",
    "name": "Bamboli Kalpak M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7340",
    "name": "Banawalkar Santosh Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11070",
    "name": "Bane Atmaram Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21614",
    "name": "Bangera Chandrashekhar Vankayya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5954",
    "name": "Bansal  Maheshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18191",
    "name": "Bansode Malan Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12402",
    "name": "Bansode Pralhad Dashrath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18497",
    "name": "Baragade Kondiba D"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10850",
    "name": "Barage Balakrishana Ragunatha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14583",
    "name": "Baraskar Sandip Dhevidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20179",
    "name": "Barge Shankar Abaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17358",
    "name": "Barge Sharad Popatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7063",
    "name": "Barge Shashikant Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8020",
    "name": "Barge Vasant Tatyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14886",
    "name": "Bariya Laxman Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13493",
    "name": "Barve Arjun Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18330",
    "name": "Barve Sujata Rangnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18437",
    "name": "Barve Vilas Ramaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10519",
    "name": "Basatkar Chandrakant Devendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4474",
    "name": "Batle Balaram Bhaga"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19984",
    "name": "Bavlekar Ashok Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21393",
    "name": "Belcheda Vithal M."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18769",
    "name": "Beldar Lalchand Jairam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16616",
    "name": "Bhagat Ankush Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2900",
    "name": "Bhagat Dhansing Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11490",
    "name": "Bhagat Kunda Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13990",
    "name": "Bhagchandani Shitaldas Nathuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8035",
    "name": "Bhagwat Arjun Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8620",
    "name": "Bhagwat Dnyandeo Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8380",
    "name": "Bhagwat Hindurao Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15220",
    "name": "Bhagwat Sangeeta Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14871",
    "name": "Bhaigade Shankar Raoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7846",
    "name": "Bhalekar Suresh Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16393",
    "name": "Bhalerao Kisan Bhaguji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10425",
    "name": "Bhalerao Shantaram Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10077",
    "name": "Bhandari Narendra Ambalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15041",
    "name": "Bhandigare Tanaji Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4843",
    "name": "Bhansali Tejraj Hastimal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11246",
    "name": "Bhanuse Narayan Sonaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21395",
    "name": "Bhanushali Mukesh Kalyanji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11520",
    "name": "Bhapkar Vasant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3853",
    "name": "Bhapkar Yeshwant Nanasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9614",
    "name": "Bharsing Gajanan Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20047",
    "name": "Bharsing Sahadeo Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4656",
    "name": "Bhatade Dagadu Bali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "642",
    "name": "Bhilare Baban Nagu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3778",
    "name": "Bhilare Baburao Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10415",
    "name": "Bhilare Kisan Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7955",
    "name": "Bhilare Kisan Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11119",
    "name": "Bhilare Kondiba Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11697",
    "name": "Bhilare Ravindra Nathuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16642",
    "name": "Bhilare Savita Balashaeb."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15861",
    "name": "Bhilare Vijay Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11878",
    "name": "Bhilare Vilas Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14774",
    "name": "Bhobhate Vasudeo Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9580",
    "name": "Bhogade Malhari Sahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9388",
    "name": "Bhohite Ravindra Vyankatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21650",
    "name": "Bhoir  Laxman  Nathu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10043",
    "name": "Bhoir Jairaj Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11725",
    "name": "Bhoite Ajit Jaywant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14939",
    "name": "Bhoite Anil Vamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19278",
    "name": "Bhoite Avinash Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1683",
    "name": "Bhoite Jaising Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18757",
    "name": "Bhoite Kiran Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11214",
    "name": "Bhoite Laxman Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16799",
    "name": "Bhoite Mahendra Mugatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14447",
    "name": "Bhoite Manisha Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18172",
    "name": "Bhoite Rajendra Fattesing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1152",
    "name": "Bhoite Ravsaheb Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12437",
    "name": "Bhoite Sharad Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2219",
    "name": "Bhoite Shivaji Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12361",
    "name": "Bhoite Sudhir M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1250",
    "name": "Bhoite Vasant K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6840",
    "name": "Bhoite Vilas Daulatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8980",
    "name": "Bhojane Prakash Chintamani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13725",
    "name": "Bhookaliya Shanta Premji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18500",
    "name": "Bhor Dattatraya Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18049",
    "name": "Bhor Dilip Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7864",
    "name": "Bhorade Pandurang Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17062",
    "name": "Bhosale Ashok Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9232",
    "name": "Bhosale Ashok Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13880",
    "name": "Bhosale Babasaheb Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18138",
    "name": "Bhosale Baburao Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2210",
    "name": "Bhosale Bajirao Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16351",
    "name": "Bhosale Balkrishna Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6136",
    "name": "Bhosale Bhalerao Dnyndeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2802",
    "name": "Bhosale Dilip Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7631",
    "name": "Bhosale Dinkar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1439",
    "name": "Bhosale Eaknath Genba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8234",
    "name": "Bhosale Eknath Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12804",
    "name": "Bhosale Gangubai Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8551",
    "name": "Bhosale Gorakhnath Nanaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18541",
    "name": "Bhosale Hanmant Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12618",
    "name": "Bhosale Hanumant Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11843",
    "name": "Bhosale Lahu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1831",
    "name": "Bhosale Laxman Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2408",
    "name": "Bhosale Madhavrao Keshavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14769",
    "name": "Bhosale Mahadeo Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7963",
    "name": "Bhosale Mahesh Gautam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8700",
    "name": "Bhosale Nana Kundilik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6067",
    "name": "Bhosale Pradeep Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15173",
    "name": "Bhosale Prakash Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14175",
    "name": "Bhosale Rajendra Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9636",
    "name": "Bhosale Ranjana Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12018",
    "name": "Bhosale Ratnamala Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19401",
    "name": "Bhosale Shamrao Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11836",
    "name": "Bhosale Shankar Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19832",
    "name": "Bhosale Sharda Hanamant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5491",
    "name": "Bhosale Shivaji Aabaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14576",
    "name": "Bhosale Shyamrao Kundalik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1593",
    "name": "Bhosale Sitaram Damodar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9287",
    "name": "Bhosale Sudhakar Madhavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20188",
    "name": "Bhosale Sunil Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12019",
    "name": "Bhosale Sushant Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14832",
    "name": "Bhosale Sushilkumar Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8822",
    "name": "Bhosale Tukaram Kundlik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13347",
    "name": "Bhosale Uttamrao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14075",
    "name": "Bhosale Vikas Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5402",
    "name": "Bhosale Vilas Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11386",
    "name": "Bhosle Sopan Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15436",
    "name": "Bhuj Ramlutavan Badri"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5989",
    "name": "Bhuvand Laxman Z"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9995",
    "name": "Bibekar Tukaram Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21497",
    "name": "Bichare Shivaji Karbhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7676",
    "name": "Bichukale Baban Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4079",
    "name": "Bobade Ankush Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12213",
    "name": "Bobade Chandrakant Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7931",
    "name": "Bobade Dashrath Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "176",
    "name": "Bobade Gangaram Narsingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10689",
    "name": "Bobade Laxman Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17497",
    "name": "Bobade Laxmi Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14025",
    "name": "Bobade Madhukar Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11637",
    "name": "Bobade Nivrutti Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "790",
    "name": "Bobade Shirishkumar Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1206",
    "name": "Bobade Suresh Dattu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14086",
    "name": "Bodake Kisan Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21440",
    "name": "Bodke Murlidhar Bhojaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21507",
    "name": "Bodke Tanaji Karbhari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11986",
    "name": "Bohra Dhansing Hansa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18848",
    "name": "Borade Ramdas Asaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18710",
    "name": "Borage Anil Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12335",
    "name": "Borage Baban Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18617",
    "name": "Borge Ishwar Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19624",
    "name": "Boricha Ramuubai Punamchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16703",
    "name": "Bote Anil Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14321",
    "name": "Budmal Kaluri Rajaya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9727",
    "name": "Chakrawarti  Munnaprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16581",
    "name": "Chalake Bharat Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13366",
    "name": "Chalake Vilas Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "827",
    "name": "Chalke Parshuram Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7880",
    "name": "Chalke Raghunath Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "442",
    "name": "Chalke Shrirang Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15612",
    "name": "Chamar Sanohar Shivprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18713",
    "name": "Chandarana Savita Chunilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8561",
    "name": "Chandoskar Vijay V."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21359",
    "name": "Chandrakant Kondiba Lalge ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "940",
    "name": "Chanskar Gulabrao Chimaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18797",
    "name": "Charahate Raju Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21558",
    "name": "Chaskar Madhav Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17267",
    "name": "Chatan Mafatlal Lohana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3107",
    "name": "Chatur Shankar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11315",
    "name": "Chaudhari Dalaram Gomaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13124",
    "name": "Chaudhari Indrajit Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14102",
    "name": "Chaudhari Parvati Vishram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14147",
    "name": "Chaudhari Shubhavatidevi J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14152",
    "name": "Chaudhari Sitaram Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21545",
    "name": "Chaugule Prakash Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18189",
    "name": "Chauhan Vimal Gurcharansingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19182",
    "name": "Chaure Nilesh Dasharath."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17045",
    "name": "Chavan Ashok Raghu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9577",
    "name": "Chavan Bhagwan Dnyandev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12020",
    "name": "Chavan Bhanudas Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9990",
    "name": "Chavan Ganpat Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3751",
    "name": "Chavan Govind Chainappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13088",
    "name": "Chavan Gulab Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3990",
    "name": "Chavan Haridas Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18212",
    "name": "Chavan Hindurao Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21571",
    "name": "Chavan Jalinder Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14821",
    "name": "Chavan Kailas Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8638",
    "name": "Chavan Kashinath Daulat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18876",
    "name": "Chavan Kiran Dhansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11413",
    "name": "Chavan Lalaso Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13045",
    "name": "Chavan Mahadeo Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12459",
    "name": "Chavan Malharrao Wamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21709",
    "name": "Chavan Mohan Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9545",
    "name": "Chavan Mugatrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3564",
    "name": "Chavan N R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1828",
    "name": "Chavan Namdeo Jyotiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13309",
    "name": "Chavan Namdeo Shankar 7380B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "693",
    "name": "Chavan Namdev Jotiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14721",
    "name": "Chavan Narayan Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16796",
    "name": "Chavan Nirmala Madhukar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6497",
    "name": "Chavan Parshuram Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10551",
    "name": "Chavan Prakash Shriraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12430",
    "name": "Chavan Prithviraj Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16570",
    "name": "Chavan Rajaram Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13841",
    "name": "Chavan Ramchandra Baba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14063",
    "name": "Chavan Ramesh Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12904",
    "name": "Chavan Rangrao Bhiwa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21713",
    "name": "Chavan Sainath Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21762",
    "name": "Chavan Sanjay Shamrao."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14526",
    "name": "Chavan Sanjay Shitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14150",
    "name": "Chavan Sanjay Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16323",
    "name": "Chavan Shamrao Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9064",
    "name": "Chavan Shankar Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2051",
    "name": "Chavan Shankar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20153",
    "name": "Chavan Shashikant Bandoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9080",
    "name": "Chavan Shivaji Bayappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11709",
    "name": "Chavan Sitaram Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13968",
    "name": "Chavan Surendra Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5316",
    "name": "Chavan Tarabai Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8732",
    "name": "Chavan Trimbak Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13963",
    "name": "Chavan Tukaram Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12405",
    "name": "Chavan Vijay Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7147",
    "name": "Chavan Vinayak Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6829",
    "name": "Chavan Vitthalrao Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18837",
    "name": "Chawan Ajitsingh Suryasingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15911",
    "name": "Chawan Ananda Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11608",
    "name": "Chawan Bajirao Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1610",
    "name": "Chawan Bandoba Jaishing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18144",
    "name": "Chawan Kashiram Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11901",
    "name": "Chawan Kiran Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1102",
    "name": "Chawan Krishnakant Janardan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8669",
    "name": "Chawan Krishnath Aaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3418",
    "name": "Chawan Narayan Muda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2694",
    "name": "Chawan Pandurang Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3213",
    "name": "Chawan Raghunath Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1280",
    "name": "Chawan Rajaram Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13995",
    "name": "Chawan Rajendra Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6554",
    "name": "Chawan Ramchandra Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13128",
    "name": "Chawan Ravindra Rohidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18576",
    "name": "Chawan Sanjay Akoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3707",
    "name": "Chawan Shivaji Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3258",
    "name": "Chawan Shrimantrao Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11921",
    "name": "Chawan Subhash Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3942",
    "name": "Chawan Suresh Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14158",
    "name": "Chawan Umesh Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18577",
    "name": "Chawan Vijay Akoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12194",
    "name": "Chawan Vijay Shrirangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14167",
    "name": "Chhohan Raksharam Sukhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18807",
    "name": "Chikane Nitin Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8988",
    "name": "Chikane Raghunath Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18457",
    "name": "Chitaliya Natwarlal R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21488",
    "name": "Chobey Ugrasen Bansrej"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6272",
    "name": "Chorage Baban Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11192",
    "name": "Chorage Bhagwan Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2675",
    "name": "Chorage Gunda Santu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15628",
    "name": "Chorage Subhash Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7321",
    "name": "Chorage Tanaji Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15701",
    "name": "Chorge Avinash Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15039",
    "name": "Chorge Dattatray Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16146",
    "name": "Chorge Ishwar Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16955",
    "name": "Choudhari Dilip Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15543",
    "name": "Choudhari Shriram Ramvilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8721",
    "name": "Chouhan Dukhai Subran"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18764",
    "name": "Chourasiya Rameshprasad Harbans"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18706",
    "name": "Chowan  Kishore Narayan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19450",
    "name": "Chowhan Rajesh Kantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18844",
    "name": "Chudasama Kasturee Lakha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15024",
    "name": "D Souza Enacine Rusoy"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18293",
    "name": "D Souza Matilda D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11404",
    "name": "Dabhade Dattatray Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18034",
    "name": "Dabhade Jagannath Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21617",
    "name": "Dais Banjamin Lawrence"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18885",
    "name": "Dakave Baban Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6532",
    "name": "Dakhave Ramchandra Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7813",
    "name": "Dalvi Ashok Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21496",
    "name": "Dalvi Gopal Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10004",
    "name": "Dalvi Manshing Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19444",
    "name": "Dalvi Subhash Ramaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17928",
    "name": "Dandekar Santosh Madhav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7990",
    "name": "Dapale Vithal Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4232",
    "name": "Daphale Laxman Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13865",
    "name": "Daphale Shivaji Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4163",
    "name": "Darge Dattaram Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13648",
    "name": "Darshale Nirmala Nathuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4920",
    "name": "Das Ashok Krishnragan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7386",
    "name": "Dere Balwant Khanderao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11187",
    "name": "Dere Rajiv Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17781",
    "name": "Desai Balasaheb Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18083",
    "name": "Desai Janak Thakurbhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18084",
    "name": "Desai Punita Janak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7806",
    "name": "Desai Sudha Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18848",
    "name": "Desai Vasantrao Keru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20040",
    "name": "Deshmukh Sachin Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16396",
    "name": "Deshmukh Shantaram Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15516",
    "name": "Deshmukh Sudhakar Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4975",
    "name": "Deshmukh Urmila Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1709",
    "name": "Devdhar Kisan Govind 219/9"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15127",
    "name": "Devhare Machindranath Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21514",
    "name": "Devkar Ramchandra Vithal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6258",
    "name": "Devkota Ravilal Devkhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13804",
    "name": "Dhaigude Vijayrao Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9980",
    "name": "Dhamal Leela Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2239",
    "name": "Dhamal Subhedar Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15006",
    "name": "Dhamal Tukaram Genba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8094",
    "name": "Dhanavade Kisan Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18957",
    "name": "Dhanwade Bajrang Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14440",
    "name": "Dharankar Chanda Rajendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "883",
    "name": "Dharmadhikari Prakash Damodar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18980",
    "name": "Dhas Laxman Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10784",
    "name": "Dhasal Suresh Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10412",
    "name": "Dhavale Anuradha Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6184",
    "name": "Dhavare Chandrakant Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18853",
    "name": "Dhawale Chandrakant Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14261",
    "name": "Dhawle Dattaram Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19587",
    "name": "Dhende Gautam Ekanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18963",
    "name": "Dhole Kishori Sanjay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15586",
    "name": "Dhole Shivaji Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17139",
    "name": "Dhonde Hanumant Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21553",
    "name": "Dhone Chandrakant Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11663",
    "name": "Dhumal Balasaheb Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4446",
    "name": "Dhumal Bhagwan Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4833",
    "name": "Dhumal Bhimrao Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1273",
    "name": "Dhumal Dattatray Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17612",
    "name": "Dhumal Dilip Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13873",
    "name": "Dhumal Hanmant Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3804",
    "name": "Dhumal Mohan Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6168",
    "name": "Dhumal Namdeo Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18527",
    "name": "Dhumal Prabhakar Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17963",
    "name": "Dhumal Pralhad Abaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2762",
    "name": "Dhumal Pratap Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1871",
    "name": "Dhumal Rajaram Vyankatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13980",
    "name": "Dhumal Rajashri Dnyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "292",
    "name": "Dhumal Ramchandra Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16655",
    "name": "Dhumal Sameer Tukaram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14962",
    "name": "Dhumal Shankar Mahadeo."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2580",
    "name": "Dhumal Shankar Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1611",
    "name": "Dhumal Tatyaba Appaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18192",
    "name": "Dhumal Uttam Kalyanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11174",
    "name": "Dhumal Vinayak Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17007",
    "name": "Dhurat Jagannath Harichandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21350",
    "name": "Dighe Rohidas Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16255",
    "name": "Dimellow Leo Dennis"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11806",
    "name": "Dinde Dnyandeo Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11335",
    "name": "Dingorkar Milind Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9412",
    "name": "Disale Laxman Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18427",
    "name": "Disale Sanjay Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6999",
    "name": "Disale Vasant Bhiva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21564",
    "name": "Disouza Anil Bona"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21597",
    "name": "Dixit Sunilkumar Rajnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19312",
    "name": "Doctor Moinuddin Ismail"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19664",
    "name": "Dodiya Kantilal Maghabai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3196",
    "name": "Dubal Bapu Gunda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16722",
    "name": "Dube Satyanarayan Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18291",
    "name": "Dumbre Ravindra Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13361",
    "name": "Dunbare Gajara Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8349",
    "name": "Durgavale Dashrath Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13646",
    "name": "Dutal Vasant Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19367",
    "name": "Dwivedi Indramani Bajrangi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19006",
    "name": "Dwivedi Sushil Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20552",
    "name": "E Or S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18749",
    "name": "Enjole  Kavita Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19695",
    "name": "Ethape Arjun Ramcchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2108",
    "name": "Fadtare Dnyandeo Ganpati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14607",
    "name": "Fathak Ragho Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12855",
    "name": "Fernandes  Janet"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21278",
    "name": "Fernandes Halland F"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2904",
    "name": "Fernandes Sushila Francis"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14640",
    "name": "Fernandis  Denis"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6784",
    "name": "Futarmal  Pukhraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16528",
    "name": "Gade Madhukar Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20084",
    "name": "Gade Sandeep Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15112",
    "name": "Gade Vishwanath Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7427",
    "name": "Gafoor  Aslam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18839",
    "name": "Gaikawad Balu Rambhahu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4651",
    "name": "Gaikawad Khandu Natha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4665",
    "name": "Gaikawad Madhukar Krishnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21348",
    "name": "Gaikwad Chandrakant Digambar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21312",
    "name": "Gaikwad Dinesh Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10095",
    "name": "Gaikwad Ganpat Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10943",
    "name": "Gaikwad Jalinder Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18763",
    "name": "Gaikwad Laxman Raosaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9216",
    "name": "Gaikwad Madhukar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18456",
    "name": "Gaikwad Nandkumar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1520",
    "name": "Gaikwad Pralhad Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13475",
    "name": "Gaikwad Rajaram Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1704",
    "name": "Gaikwad Sahebrao Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12498",
    "name": "Gaikwad Sampat Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18927",
    "name": "Gaikwad Sharad Shripat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15493",
    "name": "Gaikwad Sudhir Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2504",
    "name": "Gaikwad Tukaram Krushnaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16610",
    "name": "Gaikwad Vijay Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15277",
    "name": "Gaikwad Vilas Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2674",
    "name": "Gaikwad Vishnu Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12743",
    "name": "Gaikwad Vitthal Rangrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14425",
    "name": "Gandhi Vishnu Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15673",
    "name": "Gandhi Yuvaraj Thiravenkadam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13702",
    "name": "Garde Vilas Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1635",
    "name": "Gardi Jyotiram Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17963",
    "name": "Gardi Sachin Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11653",
    "name": "Gardi Sampat Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11171",
    "name": "Gardi Udhav Jotiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21441",
    "name": "Gaud  Pradipkumar  Tejpal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11628",
    "name": "Gauda Yogesh Lajjay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3623",
    "name": "Gavde Pralhad Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10044",
    "name": "Gavhane Bhagabai Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13832",
    "name": "Gavhane Kailash Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19699",
    "name": "Gavkar Sanjay Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14467",
    "name": "Gavkar Shankar Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11888",
    "name": "Gawade Ashok Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5779",
    "name": "Gawade Jagdish Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "508",
    "name": "Gawade Sitaram Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21629",
    "name": "Gawand Girish Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12573",
    "name": "Gaware Mukinda Sadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11100",
    "name": "Gawas Suhas Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13499",
    "name": "Ghadage Dilip Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11143",
    "name": "Ghadage Madhav Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13108",
    "name": "Ghadage Sindhu Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13761",
    "name": "Ghadge Dilip Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6108",
    "name": "Ghadge Pandharinath Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5759",
    "name": "Ghadge Parshuram Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20195",
    "name": "Ghadge Ravindra Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13214",
    "name": "Ghadge Sahebrao Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19190",
    "name": "Ghadge Santosh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19350",
    "name": "Ghadge Satyavan Uttamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14117",
    "name": "Ghadigaonkar Chandrakan Digambar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8877",
    "name": "Ghadigaonkar Vijay Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11617",
    "name": "Ghag Geeta Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20427",
    "name": "Ghag Rupesh Sahadev &Ghag Savita S."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12214",
    "name": "Ghanchi Vagaram M"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13621",
    "name": "Ghangale Ajit Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8302",
    "name": "Gharal Ananda Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7765",
    "name": "Gharal Sakharam Ramuji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18554",
    "name": "Gharasia Ramji Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9796",
    "name": "Gharge Raju G"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1066",
    "name": "Ghatage Jaywant Krishnarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13830",
    "name": "Ghatge Vasantrao Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5948",
    "name": "Ghige Hanumant Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6598",
    "name": "Gholam Bhiva Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10538",
    "name": "Gholap Sadashiv Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19331",
    "name": "Ghorapade  Danaji  Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9905",
    "name": "Ghorpade Bhausaheb Buvasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "281",
    "name": "Ghorpade Krushna Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3818",
    "name": "Ghorpade Mahadeo Buaaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10700",
    "name": "Ghorpade Namdeo Dadasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10718",
    "name": "Gidaye Prakash Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8019",
    "name": "Giri Ashok Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21702",
    "name": "Giri Sureshchand Amarnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14538",
    "name": "Girmkar Kailas Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15505",
    "name": "Goda Suresh J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14910",
    "name": "Godambe Kisan Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15370",
    "name": "Gode Shivaram Babaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7812",
    "name": "Gohil Reena Dhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21328",
    "name": "Gokrankar Ramakant Damaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "694",
    "name": "Golatkar Shrikant Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6282",
    "name": "Gole Arjun Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21670",
    "name": "Gole Nandkumar Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9863",
    "name": "Gole Nandu Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11087",
    "name": "Gomane Dnyanu Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18754",
    "name": "Gore Sampat Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21438",
    "name": "Gorje William Alfred ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16007",
    "name": "Gosavi Dhanaji Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10245",
    "name": "Gosavi Laxmibai Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14115",
    "name": "Gosavi Mahadeo Motigiri"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18830",
    "name": "Gowda  Parmeshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18937",
    "name": "Gowda Murti Nanje"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11060",
    "name": "Gulam Mohd.Noor Mohd Razui"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4564",
    "name": "Gulambe Bajirao Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10673",
    "name": "Gundage Balu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12193",
    "name": "Gundage Bhimrao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14717",
    "name": "Gundage Ramchandra Gunda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21406",
    "name": "Gupta  Arunkumar  Suryabali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14041",
    "name": "Gupta Babulal Ramkhilavan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14875",
    "name": "Gupta Babulal Ramkhilavan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19132",
    "name": "Gupta Devkumar Lakhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21642",
    "name": "Gupta Jiyalal Gomati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7957",
    "name": "Gupta Lalmani Shivbabu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21730",
    "name": "Gupta Mahendraprasad Bechen"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18773",
    "name": "Gupta Motichandra Govardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21370",
    "name": "Gupta Nandalal Munilal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10664",
    "name": "Gupta Shivchander Shivnarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21572",
    "name": "Gupta Subhashchandra Mevalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11893",
    "name": "Gupta Sunilkumar Z"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21404",
    "name": "Gupta Viddyananad Bansilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11524",
    "name": "Gupta Vijay Ramdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21621",
    "name": "Gurav Rajendra Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10929",
    "name": "Gurav Shankar Nath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19218",
    "name": "Hagawane Vishwas Gulabrao."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15368",
    "name": "Hajara Suvendu Tarapado"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18967",
    "name": "Hamid Mohd Hanif Abdul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13365",
    "name": "Harijan Druvakumar Shriram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17940",
    "name": "Harugade Rajesh Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21409",
    "name": "Hasnan Ahmed Mond Alam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20199",
    "name": "Hathiwala Pravin Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15808",
    "name": "Hawaldar Mangal Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4025",
    "name": "Hiwalkar Shrikant Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19867",
    "name": "Hoddar Narayan Kanji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18851",
    "name": "Hule Bharat Atmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12113",
    "name": "Hule Savitra Ganpat/ Hule M.G."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11867",
    "name": "Humane Ananda Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18765",
    "name": "Husain Mohammad Bajisaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21439",
    "name": "Imran Abdul Gani Shaikh ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13042",
    "name": "Indulkar Rajendra Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21413",
    "name": "Ingale  Shivaji  Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8530",
    "name": "Ingawale Akash Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6277",
    "name": "Ingawale Madhukar Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15438",
    "name": "Ingawale Rupali Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "757",
    "name": "Ingvale Shankar Navalu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15085",
    "name": "Ippelpelli Rukmini Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19535",
    "name": "Irani Lena Darayash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21349",
    "name": "Ismail Jan Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21489",
    "name": "Ismail Shmimbano Abdul Masjid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18975",
    "name": "Ismile Hussen Momin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12567",
    "name": "Ithape Balu Aaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12200",
    "name": "Ithape Subhash Kisanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12766",
    "name": "Jadhav Arun Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16726",
    "name": "Jadhav Baburao Ravji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18451",
    "name": "Jadhav Balkrishna Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13620",
    "name": "Jadhav Chandrakant Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7651",
    "name": "Jadhav Dagadu Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7030",
    "name": "Jadhav Dattatray Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18846",
    "name": "Jadhav Dilip Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12029",
    "name": "Jadhav Dilip Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7950",
    "name": "Jadhav Dnyaneshwar Khandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18763",
    "name": "Jadhav Gangaram Ganpati."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17008",
    "name": "Jadhav Ganpat Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7082",
    "name": "Jadhav Ganpat Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16998",
    "name": "Jadhav Gautam Changuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11977",
    "name": "Jadhav Govindrao Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3464",
    "name": "Jadhav Hanmant Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4539",
    "name": "Jadhav Janardhan Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17470",
    "name": "Jadhav Jayasree Sunil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4695",
    "name": "Jadhav Jotiram Baba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4566",
    "name": "Jadhav Kisan Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4812",
    "name": "Jadhav Kisan Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11216",
    "name": "Jadhav Mahadu Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13546",
    "name": "Jadhav Malhari Vithu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10786",
    "name": "Jadhav Manda Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18014",
    "name": "Jadhav Maruti D"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12169",
    "name": "Jadhav Minakshi Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18977",
    "name": "Jadhav Namdeo Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11075",
    "name": "Jadhav Narayan Babaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17960",
    "name": "Jadhav Narayan Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14608",
    "name": "Jadhav Natyaba Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14881",
    "name": "Jadhav Nitinkumar Marutirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16602",
    "name": "Jadhav Rajendra Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11485",
    "name": "Jadhav Ramchandra Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18920",
    "name": "Jadhav Ramdas Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "297",
    "name": "Jadhav Ramrao Krushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14481",
    "name": "Jadhav Ranjana Mahipat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9727",
    "name": "Jadhav Ranjendra Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20394",
    "name": "Jadhav Rohidas Laxman."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19691",
    "name": "Jadhav Sachin Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12001",
    "name": "Jadhav Sadashiv Bharat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16012",
    "name": "Jadhav Sahebrao Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17241",
    "name": "Jadhav Santosh Shnkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13279",
    "name": "Jadhav Satish Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2895",
    "name": "Jadhav Sayaji Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11014",
    "name": "Jadhav Shankar Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3280",
    "name": "Jadhav Shankar Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10334",
    "name": "Jadhav Shobha Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22866",
    "name": "Jadhav Shrirang Mugutrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13698",
    "name": "Jadhav Sudhir Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18675",
    "name": "Jadhav Tatyaba Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14592",
    "name": "Jadhav Tukaram Amritrav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8170",
    "name": "Jadhav Tukaram H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10656",
    "name": "Jadhav Tukaram Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11612",
    "name": "Jadhav Vaman Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15799",
    "name": "Jadhav Vijay Bhiva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3143",
    "name": "Jadhav Vilas Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5408",
    "name": "Jadhav Vitthal Krushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14833",
    "name": "Jagatap Avinash Hariba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19630",
    "name": "Jagatap Hanamant Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7303",
    "name": "Jagatap Mahipatrao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9505",
    "name": "Jagdale Ankush Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12874",
    "name": "Jagdale Bhaskar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10658",
    "name": "Jagdale Dadasaheb Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "880",
    "name": "Jagdale Eknath Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9296",
    "name": "Jagdale Mansingh Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18991",
    "name": "Jagirdar Amiruddin Aziz Pasha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22868",
    "name": "Jagtap Ankush Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15216",
    "name": "Jagtap Ashok Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18770",
    "name": "Jagtap Chandrkant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5453",
    "name": "Jagtap Dadaso Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "635",
    "name": "Jagtap Dnyaneshwar Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14522",
    "name": "Jagtap Gopal Kundalik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7446",
    "name": "Jagtap Laxman Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1583",
    "name": "Jagtap Madan Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5072",
    "name": "Jagtap Mugatrao A"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13912",
    "name": "Jagtap Popatrao Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18381",
    "name": "Jagtap Rahul Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17976",
    "name": "Jagtap Sayajirao Abasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12027",
    "name": "Jagtap Shatrughan Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16529",
    "name": "Jagtap Shrikrishna Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9525",
    "name": "Jagtap Tanaji Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "571",
    "name": "Jagtap Udhav Jaysinghrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7399",
    "name": "Jagtap Uttam Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18608",
    "name": "Jagtap Vijay Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14696",
    "name": "Jagtap Vilas Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19928",
    "name": "Jaid Balshiram Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11006",
    "name": "Jaikar Amrut Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11562",
    "name": "Jain Hemant P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1486",
    "name": "Jain Jaywanti I."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11563",
    "name": "Jain Ketan P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11061",
    "name": "Jain Manjula Dinesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7122",
    "name": "Jain Shantilal Achalchandji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11733",
    "name": "Jain Tansukhlal J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14779",
    "name": "Jain Yogeshkumar Dharamchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14892",
    "name": "Jaiswal Ashok Lalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13622",
    "name": "Jaiswal Indraprasad Somai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14951",
    "name": "Jaiswal Pudai Rambhoj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17689",
    "name": "Jaiswal Ramrekh Ramjas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16968",
    "name": "Jaiswal Ramvilas Bhavani Prasad ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21622",
    "name": "Jaiswal Santlal Ramlakhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21711",
    "name": "Jaiswar Suresh Lavjari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11205",
    "name": "Jambhale Gulab Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18786",
    "name": "Jambhale Nana Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5880",
    "name": "Jambharkar Narayan Keru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6102",
    "name": "Jamdade Ananda Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8111",
    "name": "Jamdade Ramchandra Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19166",
    "name": "Janardan Khashaba Jadhav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2406",
    "name": "Janugade Vishwanath Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15679",
    "name": "Jawale Mahadev Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13465",
    "name": "Jayarama D N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17766",
    "name": "Jedhe Manohar Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16661",
    "name": "Jethe Gautam Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11369",
    "name": "Joil Babu Narayan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10193",
    "name": "Jose Chellnkuddien D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20606",
    "name": "Joshi Baliram Sahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8646",
    "name": "Juvekar Vidyadhar Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7360",
    "name": "Kadam  Manikrao  Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21342",
    "name": "Kadam  Pradeep Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21217",
    "name": "Kadam  Sunil  Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17744",
    "name": "Kadam Ajit Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13399",
    "name": "Kadam Ananda Aba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9701",
    "name": "Kadam Arjun Rangrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8480",
    "name": "Kadam Baban Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14937",
    "name": "Kadam Baburao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4650",
    "name": "Kadam Baburao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2594",
    "name": "Kadam Balasaheb Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12109",
    "name": "Kadam Balasaheb Marutirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "760",
    "name": "Kadam Balkrushna Khanderao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13450",
    "name": "Kadam Bhagwan Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13909",
    "name": "Kadam Chandrakant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5376",
    "name": "Kadam Chandrkant Jaising"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11604",
    "name": "Kadam Devendra Kalyan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18214",
    "name": "Kadam Dhondiba Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20991",
    "name": "Kadam Dipak Dattu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13154",
    "name": "Kadam Ganesh Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9076",
    "name": "Kadam Gorakhnath Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16110",
    "name": "Kadam Haribhau Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10025",
    "name": "Kadam Hemant Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10447",
    "name": "Kadam Khanderao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7049",
    "name": "Kadam Khanderao Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18470",
    "name": "Kadam Laxman Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4553",
    "name": "Kadam Mahadeo Ganpati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16898",
    "name": "Kadam Mangesh Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6421",
    "name": "Kadam Maruti Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19644",
    "name": "Kadam Maruti Subarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8514",
    "name": "Kadam Mohan Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13834",
    "name": "Kadam Nimesh A."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9239",
    "name": "Kadam Pandurang Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4957",
    "name": "Kadam Pralhad Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20848",
    "name": "Kadam Pratap Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18824",
    "name": "Kadam Pravin Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13603",
    "name": "Kadam Raghunath Gangarm"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10610",
    "name": "Kadam Rajaram Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13858",
    "name": "Kadam Rajendra Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11689",
    "name": "Kadam Rajendra Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18864",
    "name": "Kadam Raju Hasu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14935",
    "name": "Kadam Ravindra Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20065",
    "name": "Kadam Sanjay Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2641",
    "name": "Kadam Shankar Ravaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8431",
    "name": "Kadam Shivaji Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14874",
    "name": "Kadam Sitaram Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14305",
    "name": "Kadam Sujata Arvind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4761",
    "name": "Kadam Suresh Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15812",
    "name": "Kadam Suvarna Sadanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15523",
    "name": "Kadam Vijaykumar Vishveshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "885",
    "name": "Kadam Vithal Bapuji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4024",
    "name": "Kadam Vitthal Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11168",
    "name": "Kadam Yashodabai Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6579",
    "name": "Kadam Yeshwant Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7318",
    "name": "Kadam Yeshwant Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18041",
    "name": "Kadav Ashwini Anand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1386",
    "name": "Kadav Jagannath Khandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11517",
    "name": "Kadav Sidu Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1526",
    "name": "Kadav Vasantrao Raosaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18674",
    "name": "Kadave Ramchandra Dashrath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20992",
    "name": "Kahar  Ajay Ramugrah"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11142",
    "name": "Kahare Ambikaprasat Lalmani"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2497",
    "name": "Kaingude Namdeo Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11899",
    "name": "Kajagale Tukaram Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12202",
    "name": "Kajari Pralhad Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21277",
    "name": "Kajarolkar Prakash Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19508",
    "name": "Kakade Anthony Karlas."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14502",
    "name": "Kakade Narayan Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18442",
    "name": "Kakade Suresh Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18087",
    "name": "Kalal Mukesh Kanaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21688",
    "name": "Kalambe Jaiprakash Jairam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2591",
    "name": "Kalange Kantilal Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17797",
    "name": "Kalantre Dhanaji Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21324",
    "name": "Kale  Shivdas  Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13332",
    "name": "Kale Shankar Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21643",
    "name": "Kale Suresh Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13937",
    "name": "Kale Tukaram Januji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2664",
    "name": "Kalekar Dhondibhau Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5080",
    "name": "Kalokhe Sunil Sudam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14011",
    "name": "Kalrane Champabai Gorakshanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "990",
    "name": "Kalugade Maruti Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14212",
    "name": "Kalugade Prakash Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11352",
    "name": "Kalugade Sanjay Kashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10725",
    "name": "Kamat Ramchandra Mallinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16243",
    "name": "Kambale Banabai Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21391",
    "name": "Kambale Pritam Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11831",
    "name": "Kambale Ramesh Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20161",
    "name": "Kambale Sunita Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14740",
    "name": "Kamble Kishor Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5982",
    "name": "Kamble Munja Devram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11094",
    "name": "Kamble Rajendra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12201",
    "name": "Kamble Ranjit Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15828",
    "name": "Kambli Karuna Sonu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14025",
    "name": "Kamerkar Vashant Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17268",
    "name": "Kamlesh Gangaram Solanki"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14322",
    "name": "Kanade Vasant Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4123",
    "name": "Kanagale Ramchandra Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2378",
    "name": "Kanase Vilas Sampatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19031",
    "name": "Kandhare Daulat Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10850",
    "name": "Kansara Charul Jashwantlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21419",
    "name": "Kanse  Prakash  Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10633",
    "name": "Kanse Arun Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9812",
    "name": "Kanse Arun Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17031",
    "name": "Kanthe Sudam Nivruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6483",
    "name": "Kapuria Sudhir S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12126",
    "name": "Karale Subhash Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9202",
    "name": "Karalkar Tulsidas Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7661",
    "name": "Karande Chandrakant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16005",
    "name": "Karande Laxman Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18542",
    "name": "Karande Mancheram Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1971",
    "name": "Karande Raghunath Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2172",
    "name": "Karane Rajaram Dnyandev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17993",
    "name": "Karanjwade Ananda Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5594",
    "name": "Kare Nivrutti Tatyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14584",
    "name": "Karmale Baban Shadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12507",
    "name": "Karne Dattatray Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11347",
    "name": "Karne Maruti Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10666",
    "name": "Karne Mohan Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11728",
    "name": "Karne Sarjerao Babaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1678",
    "name": "Karpe Namdeo Maruti 690/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12837",
    "name": "Karpe Prakash Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11584",
    "name": "Karpe Shivaji Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11398",
    "name": "Kasar Ramchandra Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21321",
    "name": "Kasbe  Ranjit  Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19866",
    "name": "Kashyap Gyandas Teju"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21355",
    "name": "Katake Hiraji Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11726",
    "name": "Katale Dattatray Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21596",
    "name": "Kataria Rameshwar Mona"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2584",
    "name": "Kate Gorakhnath Lobhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15793",
    "name": "Kate Sachin Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12710",
    "name": "Kate Subhash Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14188",
    "name": "Katekar Tanaji Nanaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17412",
    "name": "Katekar Yashoda K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18840",
    "name": "Katgeri Malakajappa Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17209",
    "name": "Katkar  Anil Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12475",
    "name": "Katkar Jagannath Raosaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18953",
    "name": "Katkar Ramdas Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20086",
    "name": "Katkar Shanker Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14485",
    "name": "Katvi Milind Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21695",
    "name": "Kedar  Vikas  Devram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13664",
    "name": "Kelbaikar Sujata Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7221",
    "name": "Khadake Sadashiv Dnyanoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8445",
    "name": "Khadapkar Manda Bhagwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7805",
    "name": "Khade Shyam Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10725",
    "name": "Khade Suvarna Sudhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11097",
    "name": "Khalate Laxman Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9000",
    "name": "Khamka Vishal Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13739",
    "name": "Khamkar Balkrishna Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19348",
    "name": "Khamkar Pandurang Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21396",
    "name": "Khan Abdul Rahim Peermohamad."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15801",
    "name": "Khan Ashfaq Niyaz Ahmed"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3742",
    "name": "Bubna Murari Tarun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14317",
    "name": "Khan Ayaz Ahamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14061",
    "name": "Khan Bhola Edris"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21411",
    "name": "Khan Firoj Khalil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8042",
    "name": "Khan Imtiyaz Ahmed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21718",
    "name": "Khan Mohamad Akbar Usman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18784",
    "name": "Khan Mohd Hanif Umar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13992",
    "name": "Khan Munavar Ebrahim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18838",
    "name": "Khan Nabikhan Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21295",
    "name": "Khan Shakil Mustak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18785",
    "name": "Khanbande Bilal Sabir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8537",
    "name": "Khandekar Bhagawan Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14639",
    "name": "Khandke Krupali Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11122",
    "name": "Khape Raghunath Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10738",
    "name": "Kharate Kailash Ramdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18783",
    "name": "Khare Madhukar Amruta"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12312",
    "name": "Khatri Madan Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18827",
    "name": "Khavale Tushar Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8300",
    "name": "Khedekar Kalpana Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21447",
    "name": "Khedekar Sadanand Tukaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13394",
    "name": "Khedekar Vitthal Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8483",
    "name": "Khengare Natha Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14821",
    "name": "Khochare Sunil Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14690",
    "name": "Khopade Anandrao Kondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18970",
    "name": "Khopade Atmaram Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15686",
    "name": "Khopade Jagnnath Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5157",
    "name": "Khopade Jaywant Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18711",
    "name": "Khopade Shrikant Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13772",
    "name": "Khopde Popat Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20024",
    "name": "Khot Raghunath Maruti / Khot Indubai Rag"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16280",
    "name": "Khot Tai Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14354",
    "name": "Khutwad Dnyanoba Kanhu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21346",
    "name": "Khutwad Dyaneshwar Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13529",
    "name": "Khutwad Kailash Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18659",
    "name": "Khutwad Ramdas Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12197",
    "name": "Kindre Mohan Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6578",
    "name": "Kinjalkar Kisan Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22160",
    "name": "Kobnak Laxman Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "619",
    "name": "Kochare Atmaram Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6857",
    "name": "Kokane Avinash Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19503",
    "name": "Kokane Santosh Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10612",
    "name": "Kolekar Baburao Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14312",
    "name": "Kolekar Balaso Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17980",
    "name": "Kolekar Balkrishna Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9456",
    "name": "Kolekar Bhau Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8999",
    "name": "Kolekar Chandru Santu 853/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12287",
    "name": "Kolekar Manish Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19394",
    "name": "Kolekar Shamrao Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17555",
    "name": "Kolekar Shivaji Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12456",
    "name": "Kolekar Tanaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10600",
    "name": "Kolekar Tukaram Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21334",
    "name": "Koli Balaya Anantrao."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19641",
    "name": "Koli Kesarinath Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21764",
    "name": "Koli Shankar Muthiya."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19143",
    "name": "Kondakar Shantaram Changoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8297",
    "name": "Korade Dnyandeo Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13590",
    "name": "Korgoankar Satish Gopal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15025",
    "name": "Kothari Manisha J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10448",
    "name": "Kotkar Sudhakar Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13101",
    "name": "Kshirsagar Rukminibai Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14052",
    "name": "Kudale Keshav Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21414",
    "name": "Kudatarkar Ashok Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15136",
    "name": "Kulal Dattatray Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14895",
    "name": "Kule Ashok Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14081",
    "name": "Kushte Ravindra Janardhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12633",
    "name": "Kutdarkar Shashikant Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21380",
    "name": "Lad  Uday  Ratnakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18419",
    "name": "Lad Maruti Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20512",
    "name": "Lad Tukaram Genu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15563",
    "name": "Lakhan Shobhna Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14135",
    "name": "Lande Hirabai Gulab"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14751",
    "name": "Lanjekar Sitaram Devu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5809",
    "name": "Latke Ananda Kesu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2826",
    "name": "Lawand Jaising Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16635",
    "name": "Lawand Sadashiv N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13244",
    "name": "Lawand Sampat Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18767",
    "name": "Lembhe Anjira Pratap"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4226",
    "name": "Lembhe Arjun Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16650",
    "name": "Lembhe Balu Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19067",
    "name": "Lembhe Dattatrey Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5490",
    "name": "Lembhe Dharmaji Wamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3406",
    "name": "Lembhe Madhukar Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "459",
    "name": "Lembhe Raghunath Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3900",
    "name": "Lembhe Shrirang Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21331",
    "name": "Ligayat Chandrakant Ramchandra."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18779",
    "name": "Lobo Stanley Martin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1651",
    "name": "Londhe Suresh Anna"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "84",
    "name": "Champion Stationery & Books"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21367",
    "name": "Lookman  Anwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14955",
    "name": "Lotlikar Yogesh Harishchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9105",
    "name": "Ludabe Subhash Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8617",
    "name": "Lugde Gopal Manu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14402",
    "name": "Lunia Bhavana Jethmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8566",
    "name": "Luniya Ramu Nibbar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14520",
    "name": "Madane Dasharath Dada"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18709",
    "name": "Madkaikar Vishnu Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9293",
    "name": "Magar Balu Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14104",
    "name": "Mahadeshwar Tukaram Ganu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13837",
    "name": "Mahadeshwar Vishwanath Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15519",
    "name": "Mahadik Ankush Ramcnandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11694",
    "name": "Mahadik Ashok Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8908",
    "name": "Mahadik Vashnti Manaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14379",
    "name": "Mahajan Prakash B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13453",
    "name": "Mahakal Jayant Baliram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5509",
    "name": "Mahalunge Pandharinath Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12127",
    "name": "Mahamud  Umar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15170",
    "name": "Mahamulkar Vikas Bhagwanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3880",
    "name": "Mahangade Jaywant Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6363",
    "name": "Mahangade Ramesh Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3591",
    "name": "Mahangade Vithal Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14597",
    "name": "Mahangare Dnaynoba Jaganath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18057",
    "name": "Mahapure Suryakant Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18968",
    "name": "Mahatre Bhikaji Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17261",
    "name": "Mahida Urmila Kishor."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21388",
    "name": "Maily Appu Bhoja"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21719",
    "name": "Makwana Jyoti Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13982",
    "name": "Malar Rajesh Pralhad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13673",
    "name": "Malekar Kalpita Kamalakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18756",
    "name": "Mali Mahendrakumar Pheku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13557",
    "name": "Mali Narendra Damodar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18096",
    "name": "Mali Rajendra Sadanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1196",
    "name": "Malusare Laxman Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13488",
    "name": "Malusare Shamrao Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21654",
    "name": "Malvade Ravindra Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21386",
    "name": "Mancekar Hanil Abdulla."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18736",
    "name": "Mandave Ashok Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10132",
    "name": "Mandave Baliram Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3097",
    "name": "Mandhare Ashok Kanaiyalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11891",
    "name": "Mandhare Balkrishna Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4382",
    "name": "Mandhare Rajaram Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4905",
    "name": "Mandhare Shankarrao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5050",
    "name": "Mandhare Suresh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22572",
    "name": "Mandhare Tejashri Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14112",
    "name": "Mandhre Damodar Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11472",
    "name": "Mandhre Laxman Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21329",
    "name": "Mane Ashok Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13437",
    "name": "Mane Balkrishna Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6390",
    "name": "Mane Govind Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4782",
    "name": "Mane Jotiram Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9806",
    "name": "Mane Krishna Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20935",
    "name": "Mane Manoj Satyavan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18852",
    "name": "Mane Nandan Dattatram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16101",
    "name": "Mane Pallavi Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18805",
    "name": "Mane Pandurang Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6503",
    "name": "Mane Pradip Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18058",
    "name": "Mane Rajendra Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10838",
    "name": "Mane Rajendra Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20021",
    "name": "Mane Rajesh Mahadev"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3411",
    "name": "Chate Coaching Classes Pvt Ltd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19260",
    "name": "Mane Sharad Yashawant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3466",
    "name": "Mane Tukaram Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14956",
    "name": "Mane Vinod Vishwas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14753",
    "name": "Manerkar Ananda Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7013",
    "name": "Manjarekar Sahadeo Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10793",
    "name": "Manjrekar Dattu Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4991",
    "name": "Manjrekar Vithal Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14089",
    "name": "Mantrawadi Kshama Shrikant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1942",
    "name": "Mantre Shamrao Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11253",
    "name": "Marathi Shamrao Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19936",
    "name": "Mardekar Subhash Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2613",
    "name": "Mardekar Tatyaba Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13202",
    "name": "Mardhekar Aatmaram Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13669",
    "name": "Maskar Madhukar Tatoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10933",
    "name": "Maskar Maruti Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14183",
    "name": "Matekar Nivrutti Ganu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16726",
    "name": "Matekar Tanaji Laxman."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8971",
    "name": "Mathew  Sally"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18782",
    "name": "Matkar Janardan Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2635",
    "name": "Matkar Sadashiv Rangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18703",
    "name": "Matkar Vasant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11314",
    "name": "Matre Atmaram Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3642",
    "name": "Matre Dinkar Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5399",
    "name": "Matre Dnyanu Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14678",
    "name": "Matre Ramchandra Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11867",
    "name": "Matre Shamrao Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7991",
    "name": "Mayekar Gopinath Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18069",
    "name": "Mayekar Madhukar Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21450",
    "name": "Maykar Sanjay Shridhar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14067",
    "name": "Medhekar Bharati Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11340",
    "name": "Mehta Jayesh Indermalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12998",
    "name": "Mehta Nalini Ashwin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14156",
    "name": "Melavane Yashwant Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14154",
    "name": "Mestri Vaishali Bhaskar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19758",
    "name": "Mestry Ravindra Janardhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14929",
    "name": "Mestry Sneha Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15943",
    "name": "Mewada Shobha Trikam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18633",
    "name": "Mhamunkar Aarati Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14311",
    "name": "Mharugude Shivaji Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13735",
    "name": "Mhaskar Manohar Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10304",
    "name": "Mhaskar Vijay Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9893",
    "name": "Mhatale Keshav Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5531",
    "name": "Mhatre Rajaram Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19855",
    "name": "Mhatre Vijay Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21394",
    "name": "Mishra   Chotelal Rajkumar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18780",
    "name": "Mishra Anandkumar Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21638",
    "name": "Mishra Ghansham Amela Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13754",
    "name": "Mishra Hari Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21280",
    "name": "Mishra Narsing Bhollur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9093",
    "name": "Mishra Rajkumar Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15672",
    "name": "Mishra Rohit Thakurprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21341",
    "name": "Mishra Suhas Suhaschandra Trilochan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18976",
    "name": "Mishra Sureshkumar Shivnaryan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13477",
    "name": "Mishra Thakurprasad Oari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21306",
    "name": "Mishtry Sanjay Ratilal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4837",
    "name": "Modak Dagadu Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14191",
    "name": "Modak Shantaram Shripat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21318",
    "name": "Mohd Sarif Samsuddin Qureshi ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17021",
    "name": "Mohite Harichandra Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6383",
    "name": "Mohite Hindurao Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20329",
    "name": "Mohite Mahesh Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7222",
    "name": "Mohite Mandakini Anand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4540",
    "name": "Mohite Parbati Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14803",
    "name": "Mohite Prakash Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21352",
    "name": "Mohite Rajendra Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3475",
    "name": "Mohite Sampatrao Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14613",
    "name": "Mohite Shashikant Mukunf"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13898",
    "name": "Mohite Umesh Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15875",
    "name": "Mohmmad Sharif Mhebubshab Talband"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21561",
    "name": "Mohmod Arif Mohmod Ayub"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4973",
    "name": "Moholkar Madhukant Shivrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13741",
    "name": "Mohte Krishna Kashiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21538",
    "name": "Mohto Virendrakumar Ramnandan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13351",
    "name": "Mokashi Vithal Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21297",
    "name": "Momiin  Adam  Babalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15161",
    "name": "Momin Nazir Wooden"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "561",
    "name": "More Balwant Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13551",
    "name": "More Bhau Bala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13430",
    "name": "More Bhau Parsu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3975",
    "name": "More Dhansing Jaising"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3103",
    "name": "More Dhondiram Chimaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9392",
    "name": "More Dilip Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "239",
    "name": "More Janardan Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14715",
    "name": "More Jayshri Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2841",
    "name": "More Kisan Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6316",
    "name": "More Laxman Ranu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15872",
    "name": "More Manohar Parsuram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11748",
    "name": "More Pralhad Shankar"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2215",
    "name": "Chaurasia Enterprisea"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16463",
    "name": "More Rajaran Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15429",
    "name": "More Ramchandra Balaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8593",
    "name": "More Ramchandra Dyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13493",
    "name": "More Ravindra Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1933",
    "name": "More Sampat Ganapat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13844",
    "name": "More Santosh Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9683",
    "name": "More Shamrao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4208",
    "name": "More Shidu Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21412",
    "name": "More Shivaji Rangoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18335",
    "name": "More Shobha Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8347",
    "name": "More Sitaram Rmchandra 852/1"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15726",
    "name": "More Subhash Sayaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13688",
    "name": "More Sumita Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9335",
    "name": "More Vishwas Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "807",
    "name": "More Yashwant Bayaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21368",
    "name": "Morkar Ganesh Giridhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7708",
    "name": "Mote Akkatai Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12806",
    "name": "Mpore Premchand Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13000",
    "name": "Mudralankar Dilip Mahipati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18454",
    "name": "Mujawar Makbul Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14654",
    "name": "Mujawar Nasir Kadar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21509",
    "name": "Mulani Inaytulla Shahabuddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4565",
    "name": "Mulik Ashok Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2530",
    "name": "Mulik Dinkar Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8722",
    "name": "Mulik Laxman Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8454",
    "name": "Mulik Maruti Masku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6458",
    "name": "Mulik Mohan Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15110",
    "name": "Mulik Motiram Jyotiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1352",
    "name": "Mulik Raghunath Masku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12294",
    "name": "Mulik Shankar Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11095",
    "name": "Munayat Vimalakumari Mahavirchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15676",
    "name": "Mungase Smita Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14432",
    "name": "Mungekar Sumitra D"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15760",
    "name": "Munj  Ashok Bapu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14806",
    "name": "Munj Sanjay Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16479",
    "name": "Murajkar Rukmini Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13010",
    "name": "Murathiya Kunju P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18981",
    "name": "Mustapa Mohmad Yusuf"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6800",
    "name": "Mutal Chandrakant Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21664",
    "name": "Muzamil Abdula Mina."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21745",
    "name": "Nadar Manuvel Danyel"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8084",
    "name": "Nagare Ramchandra Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16755",
    "name": "Naik  G.A."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10477",
    "name": "Naik Sudam Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18761",
    "name": "Nair Dhanraj Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16523",
    "name": "Nakti Seema Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16689",
    "name": "Nalage Arjun Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2065",
    "name": "Nalage Kisan Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8102",
    "name": "Nalage Satyawan Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21379",
    "name": "Nalage Sunil Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4793",
    "name": "Nalage Tanaji Dadaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8113",
    "name": "Nalawade Ankush Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12278",
    "name": "Nalawade Ashok Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14411",
    "name": "Nalawade Baban Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8584",
    "name": "Nalawade Gopichand Abasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15448",
    "name": "Nalawade Housabai Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2769",
    "name": "Nalawade Laxman Ratoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5228",
    "name": "Nalawade Pillu Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7654",
    "name": "Nalawade Ramdas Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4224",
    "name": "Nalawade Vilas Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4347",
    "name": "Nanavare Namdev Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5189",
    "name": "Nanavare Narsing Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21689",
    "name": "Nandgoankar Sanjay Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12842",
    "name": "Naringrekar Mahesh Ramdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14572",
    "name": "Narkar Shalini Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21929",
    "name": "Narvekar Pardeep Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1717",
    "name": "Narvekar Rajan Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18036",
    "name": "Narvekar Santosh Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9522",
    "name": "Navadkar Dashrath Dagsoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11920",
    "name": "Nawadkar Dattatray Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7481",
    "name": "Nawadkar Dinkar Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10158",
    "name": "Nawadkar Hanmant Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16135",
    "name": "Nawadkar Keshar Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3392",
    "name": "Nawale Bhagwan Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18855",
    "name": "Naydu Narendran Rammurti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15395",
    "name": "Naykwadi Tanaji Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2639",
    "name": "Nere Laxman Antu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17404",
    "name": "Nhivekar Pravin Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15013",
    "name": "Nigade Suryakant Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13423",
    "name": "Nikam Anil Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15648",
    "name": "Nikam Appa Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7309",
    "name": "Nikam Arjun Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11937",
    "name": "Nikam Dnyaneshwar Subhanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18705",
    "name": "Nikam Ganesh Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1288",
    "name": "Nikam Gopal Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11741",
    "name": "Nikam Jalinder Dhaulat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15977",
    "name": "Nikam Mangesh Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20182",
    "name": "Nikam Nagesh Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3029",
    "name": "Nikam Namdeo Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1805",
    "name": "Nikam Prataprao Dinkarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10695",
    "name": "Nikam Raghu Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14201",
    "name": "Nikam Ramachandra Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15485",
    "name": "Nikam Sambhaji Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7047",
    "name": "Nikam Shankar Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13862",
    "name": "Nikam Shivaji Bajaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18905",
    "name": "Nikam Shiwaji Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14299",
    "name": "Nilkanth Sanjay Savalaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16266",
    "name": "Nimbalkar Sambhaji Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3290",
    "name": "Nimbalkar Subhash Chandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18424",
    "name": "Nirala Shriram D"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18860",
    "name": "Nishar Warish Amirali Ahmed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7907",
    "name": "Odiyan Govindraj T"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11602",
    "name": "Ozarkar Laxman Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16104",
    "name": "Ozarkar Shankar Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15142",
    "name": "Pachangane Narayan Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10398",
    "name": "Pachpute Ashok Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10022",
    "name": "Padave Shriram Sabaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17749",
    "name": "Padhiar Geeta P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3095",
    "name": "Padwal Baliram Manjaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13706",
    "name": "Pagare Dilip Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18813",
    "name": "Pal   Chotelal Jokhuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21537",
    "name": "Pal Ramji Bhagwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21562",
    "name": "Pal Rammurti Ramjiyavan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11915",
    "name": "Pal Ramsuyog Ramsabad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21291",
    "name": "Pal Shobhnath Giridharilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14818",
    "name": "Palav Manali Mahesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21630",
    "name": "Palav Prakash Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9681",
    "name": "Paleja Ashok Kalyanji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14163",
    "name": "Palkar Sharad Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1379",
    "name": "Panaskar Shivaji Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9661",
    "name": "Panchal Anandi Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14940",
    "name": "Panchal Chandrakant Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14180",
    "name": "Panchal Samita Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22042",
    "name": "Panday Shalikram Shiroman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18766",
    "name": "Pandey Akhileshkumar Shyambihari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21555",
    "name": "Pandey Dinesh Ramiyavan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13496",
    "name": "Pandey Sanjaykumar Hausala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21506",
    "name": "Pandey Shivdevi Suryanarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18767",
    "name": "Pandidhar Nityanand Minakshi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21381",
    "name": "Pandy  Ramkishor Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17118",
    "name": "Panhale  Paresh Vilas."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11530",
    "name": "Pansare Dilip Balakrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18094",
    "name": "Pansare Ramesh Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16925",
    "name": "Papal Rajendra Mansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15529",
    "name": "Parab Jayendra Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11934",
    "name": "Parab Jitendra Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10891",
    "name": "Parab Shushma Naresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13402",
    "name": "Parab Sunanda Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12971",
    "name": "Parab Vitthal Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14566",
    "name": "Paradkar Sadashiv Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19716",
    "name": "Pardule Priya Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14378",
    "name": "Pareek Om Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15363",
    "name": "Parihar Motilal Manaji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5925",
    "name": "Parkar Anil Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13180",
    "name": "Parkar Prerna Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6732",
    "name": "Parmar Devaram L"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4103",
    "name": "Parte Ganpat Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7196",
    "name": "Parte Shakuntala Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13185",
    "name": "Pashte Rushikumar Gunaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20803",
    "name": "Pasi  Shiv   Bhagan  S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18861",
    "name": "Paswan Awadesh Jaguram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11141",
    "name": "Patane Ramchandra Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16250",
    "name": "Patankar Nilesh Anand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14284",
    "name": "Patankar Ranjana Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7780",
    "name": "Patekar Sitaram Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19117",
    "name": "Patel Dhruvesh Javanbhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7800",
    "name": "Patel Nareshkumar Kunwarji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21754",
    "name": "Patel Rajaram Dasaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14789",
    "name": "Patel Saraswati S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14784",
    "name": "Patel Vikas Chandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15588",
    "name": "Patel Vikas Chandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7586",
    "name": "Pathak Anandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16334",
    "name": "Pathak Lalan Ballu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21343",
    "name": "Pathak Ramasre Rammilan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21351",
    "name": "Pathak Ramshiroman Vasudev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7670",
    "name": "Pathan Adilkhan Marinkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14692",
    "name": "Pathan Kallukhan Vajirkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6446",
    "name": "Pathan Kifatulla Karamdar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12461",
    "name": "Pathan Madar Husen"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7367",
    "name": "Pathan Noor Mohammad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13807",
    "name": "Pathan Safadkhan Vajidali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14844",
    "name": "Pathare Rupesh Dasharath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14349",
    "name": "Patil Aakaram Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11829",
    "name": "Patil Ananda Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19238",
    "name": "Patil Ananda Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22867",
    "name": "Patil Anandrao Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18408",
    "name": "Patil Arun Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11138",
    "name": "Patil Ashok Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11256",
    "name": "Patil Baban Dyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10710",
    "name": "Patil Baburao Bayaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11886",
    "name": "Patil Baburao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4118",
    "name": "Patil Balasaheb Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12409",
    "name": "Patil Balu Sadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9995",
    "name": "Patil Bhaiyyasaheb Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6395",
    "name": "Patil Bhanudas Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18862",
    "name": "Patil Devidas Bhalchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11590",
    "name": "Patil Dinkar Patalu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21283",
    "name": "Patil Ganesh Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10615",
    "name": "Patil Lalasaheb Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2624",
    "name": "Patil Laxman Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18863",
    "name": "Patil Liladhar Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22862",
    "name": "Patil Nanda Jaywant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13377",
    "name": "Patil Nanda Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6546",
    "name": "Patil Naresh Kamalakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12349",
    "name": "Patil Prakash G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9276",
    "name": "Patil Raghunath Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8646",
    "name": "Patil Raghunath Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9638",
    "name": "Patil Rajaram Chander"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14026",
    "name": "Patil Ramchandra Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9018",
    "name": "Patil Sadashiv Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11815",
    "name": "Patil Sakharam Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14037",
    "name": "Patil Sandeep Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13580",
    "name": "Patil Sanjay Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21357",
    "name": "Patil Santosh Malhari ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18126",
    "name": "Patil Santosh Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13618",
    "name": "Patil Sarjerao Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "274",
    "name": "Patil Shankar Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4753",
    "name": "Patil Shankar Balaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13062",
    "name": "Patil Shantabai Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14752",
    "name": "Patil Sudhir Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22857",
    "name": "Patil Surekha Sanjay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21264",
    "name": "Patil Tanaji Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16783",
    "name": "Patil Tukaram Gunda."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19441",
    "name": "Patil Vidhya Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18969",
    "name": "Patil Vijay Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20141",
    "name": "Patil Vijaya Anand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13838",
    "name": "Patil Vijaykumar Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21633",
    "name": "Patwa Shambhuprasad Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7373",
    "name": "Pawar Anand Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14568",
    "name": "Pawar Ananda Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5522",
    "name": "Pawar Ankush Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9959",
    "name": "Pawar Ashok Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7042",
    "name": "Pawar Baban Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9296",
    "name": "Pawar Babasaheb Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1988",
    "name": "Pawar Bajirao Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20395",
    "name": "Pawar Balaram Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2723",
    "name": "Pawar Bapurao Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11332",
    "name": "Pawar Bapurao Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10043",
    "name": "Pawar Bhaskar A."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10759",
    "name": "Pawar Bhimrao Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12709",
    "name": "Pawar Dilip Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8860",
    "name": "Pawar Dilip Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2415",
    "name": "Pawar Dinkar Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "972",
    "name": "Pawar Dnyandeo Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11981",
    "name": "Pawar Jagdish Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13660",
    "name": "Pawar Jitendra Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18636",
    "name": "Pawar Kashinath Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18809",
    "name": "Pawar Kiran Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7568",
    "name": "Pawar Malan Appaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "583",
    "name": "Pawar Maruti Balwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13851",
    "name": "Pawar Maruti Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14903",
    "name": "Pawar Milind Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14669",
    "name": "Pawar Mohan Bhiwa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13050",
    "name": "Pawar Nanaso Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4729",
    "name": "Pawar Nathuram Vasudeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1647",
    "name": "Pawar Pandurang Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13738",
    "name": "Pawar Prabhakar Murlidhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15912",
    "name": "Pawar Pramod Mohan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13424",
    "name": "Pawar Rajaram Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11313",
    "name": "Pawar Rajendra Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9094",
    "name": "Pawar Ramchandra Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18156",
    "name": "Pawar Ramesh Raghu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6209",
    "name": "Pawar Sakharam Bajrang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18509",
    "name": "Pawar Santosh M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16348",
    "name": "Pawar Shahaji Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3135",
    "name": "Pawar Shankar Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1222",
    "name": "Pawar Shivaji Chandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11518",
    "name": "Pawar Shivaji Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19208",
    "name": "Pawar Shivaji Sudam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9379",
    "name": "Pawar Sitaram Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14166",
    "name": "Pawar Sopan Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16319",
    "name": "Pawar Subhash Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1710",
    "name": "Pawar Subhash Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16408",
    "name": "Pawar Surekha Tukaram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13093",
    "name": "Pawar Suresh Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8498",
    "name": "Pawar Suresh Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11898",
    "name": "Pawar Tukaram Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11723",
    "name": "Pawar Tukaram Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12565",
    "name": "Pawar Tukaram Uttamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15615",
    "name": "Pawar Tushar Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15284",
    "name": "Pawar Uttam Pandurang."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13678",
    "name": "Pawar Vinayak Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15826",
    "name": "Pawar Vishwanath Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7478",
    "name": "Pawar Vithal Rajaram 1025/3"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3791",
    "name": "Pawar Vithal Vyankatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13994",
    "name": "Pawar Yashwant Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2121",
    "name": "Pawar Yashwant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18139",
    "name": "Pawaskar Arvind Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12703",
    "name": "Pednekar Tanuja Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21612",
    "name": "Peer Mond Abdul  Rehman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13921",
    "name": "Pendnekar Avinash Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14816",
    "name": "Petkar Kalpana Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9752",
    "name": "Phadatare Vishwas Patangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9824",
    "name": "Phadkar Sonabai M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13995",
    "name": "Phadkar Sunderabai Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7648",
    "name": "Phadtare Shankar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5534",
    "name": "Phalke Dattu Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14516",
    "name": "Phalke Milind Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17600",
    "name": "Phalke Nandkumar Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8222",
    "name": "Phalke Suresh Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12867",
    "name": "Phalke Yuvraj Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14820",
    "name": "Pharate Prakash Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15933",
    "name": "Phatak Suhas Yashwantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15003",
    "name": "Phopale Kanchan Shashikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21581",
    "name": "Pilai Perumal Perswami"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7926",
    "name": "Pilankar Kisan Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17776",
    "name": "Pillai Narayanan Ramkrishnan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21473",
    "name": "Pingale Narayan Ramchandra."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7945",
    "name": "Pingulkar Vijay Ramakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10071",
    "name": "Pisal Ankush Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12353",
    "name": "Pisal Chandrabhaga Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4896",
    "name": "Pisal Dhondiram Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5305",
    "name": "Pisal Jagannath Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18142",
    "name": "Pisal Laxman Jivaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18095",
    "name": "Pisal Mahadeo Parbatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2848",
    "name": "Pisal Shamrao Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17997",
    "name": "Pisal Shantaram Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11065",
    "name": "Pisal Sunita Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16932",
    "name": "Pisal Suresh Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17859",
    "name": "Pisal Uttam Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8529",
    "name": "Pisal Uttam Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1726",
    "name": "Pisal Vasant Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8734",
    "name": "Pisal Vilas Vithalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11434",
    "name": "Pisal Vishwas Mahdep"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19993",
    "name": "Pitale Moreshwar Bhalchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3755",
    "name": "Pokale Urmila Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21615",
    "name": "Pol  Dayanand  Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4805",
    "name": "Pol Ashok Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13264",
    "name": "Pol Sunil Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13968",
    "name": "Pol Vijay Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10600",
    "name": "Pomendkar Mahesh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21288",
    "name": "Poojari Ratnakar Sina"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14830",
    "name": "Pophale Reshma Shashikant."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13126",
    "name": "Porwal Rajesh Pukhraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15717",
    "name": "Poshture Anant Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15889",
    "name": "Pote Dattram Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13817",
    "name": "Potnis Ajay Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10464",
    "name": "Prajapat  Mohanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "952",
    "name": "President/Tresurer/Secretery"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10361",
    "name": "Pujari Babanrao Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16978",
    "name": "Pujari Baburao Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21499",
    "name": "Pujari Bhaskar K."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14159",
    "name": "Pujari Chhagan Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1965",
    "name": "Pujari Dattatray Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10360",
    "name": "Pujari Krishnarao Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "29",
    "name": "Pujari Laxmanrao Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12461",
    "name": "Pujari Shankar Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6632",
    "name": "Pujari Shantaram Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3572",
    "name": "Pujari Vishwas Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19724",
    "name": "Purabia Suresh Motilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19714",
    "name": "Purabiya Prakash Motilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19715",
    "name": "Puribya Dilip Motilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11416",
    "name": "Purohit Babulal Tejaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14516",
    "name": "Purohit Jagdish M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19169",
    "name": "Puttapaka Rajaiah Rajeshom"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21651",
    "name": "Qureshi  Atahullh  Abdul  Razzak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5293",
    "name": "Raikar Vyankatesh Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21658",
    "name": "Rajak Vinodkumar Shobhanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18535",
    "name": "Rajbhar Hiralal Ramnaresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18924",
    "name": "Raje Arvind Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4479",
    "name": "Raje Mahadeo Gopalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9364",
    "name": "Raje Suresh P."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14270",
    "name": "Rajmane Satish Bhausaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21731",
    "name": "Rajora  Narayan  Rudaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13151",
    "name": "Rajput Pramesh D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21725",
    "name": "Ram Rajnath Murari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14604",
    "name": "Rambade Vasant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21425",
    "name": "Rameshchnadra  Bhushansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13131",
    "name": "Rane Babaji Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11009",
    "name": "Rane Gajanan Vishram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14212",
    "name": "Rane Maruti Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14399",
    "name": "Rane Nandkumar Sahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14121",
    "name": "Rane Raghoji Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9407",
    "name": "Rane Sambhaji Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14190",
    "name": "Rane Vandana Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4426",
    "name": "Ranjane Sahebrao Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10627",
    "name": "Rao Babusing J"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3969",
    "name": "Rasal Vithal Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18768",
    "name": "Rathod Manoj Khoda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17265",
    "name": "Rathod Ramubai Chunilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19572",
    "name": "Rathod Shivaji Golu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16143",
    "name": "Raut Jagdish Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1670",
    "name": "Raut Laxman Manu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11196",
    "name": "Raut Nandkumar Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11193",
    "name": "Razvi Mohd Salim Noor Mohd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21631",
    "name": "Reddy Ganesh Krishanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16644",
    "name": "Redekar Shahaji Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9109",
    "name": "Reenge Balu Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14405",
    "name": "Revankar Rajani Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18408",
    "name": "Rikibe Vandna Ratan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21613",
    "name": "Rokade  Prakash  Ramji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2524",
    "name": "Rokade Tukaram Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20122",
    "name": "Roman Nalini Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15807",
    "name": "Roy Sattyahari Shilendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14987",
    "name": "Rudra Gangadhar Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21275",
    "name": "S Saroj Rajkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16361",
    "name": "Sabale Anandrao Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3026",
    "name": "Sabale Ashok Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11885",
    "name": "Sabale Dnyandeo Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12009",
    "name": "Sabale Nitin Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1298",
    "name": "Sabale Sadashiv Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18114",
    "name": "Sabale Shivaji Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9283",
    "name": "Sabale Sulochana P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "269",
    "name": "Sabale Tukaram Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12989",
    "name": "Sabale Vijay Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11316",
    "name": "Sabale Vilas Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "295",
    "name": "Sabalea Vasant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11972",
    "name": "Sable Bharti Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11841",
    "name": "Sable Sanjay Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18596",
    "name": "Sagevekar Laxmi Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13384",
    "name": "Sagwekar Sandhya Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18847",
    "name": "Sahu Umeshkumar Brijnandan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11294",
    "name": "Sakharkar Sanjay N"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14686",
    "name": "Sakpal Baban Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21446",
    "name": "Sakpal Gautam Kashiram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15062",
    "name": "Sakpal Krishnat Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8649",
    "name": "Sakpal Rajendra Yadav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21481",
    "name": "Sakunde  Nanadkumar  Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6923",
    "name": "Sakunde Balu Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7106",
    "name": "Sakunde Dilip Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3736",
    "name": "Sakunde Gulabrao Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8012",
    "name": "Sakunde Madhav Vyankatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "252",
    "name": "Sakunde Shankar Gyanba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11724",
    "name": "Sakunde Shivaji Pandharinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21527",
    "name": "Salankhe Narayan Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2725",
    "name": "Salate Dadu Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6038",
    "name": "Salate Dagadu Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4333",
    "name": "Salate Dnyanu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4366",
    "name": "Salate Dnyanu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10790",
    "name": "Salate Laxmibai Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19870",
    "name": "Salate Pilabai Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12369",
    "name": "Salave Uttam Y"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12500",
    "name": "Salavi Madhukar Ratanrav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19163",
    "name": "Salekar Dhanaji Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8079",
    "name": "Salekar Shantaram Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10156",
    "name": "Salekar Vijay Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9807",
    "name": "Salgaonkar Namdeo Ramkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21573",
    "name": "Salian Dharmappa Somayya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19249",
    "name": "Salunke Balasaheb Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14619",
    "name": "Salunke Namdev Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11678",
    "name": "Salunke Shahaji Haberao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21327",
    "name": "Salunke Sohan Subhas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18912",
    "name": "Salunkhe Arvind Gulabrav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3409",
    "name": "Salunkhe Balwant Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19418",
    "name": "Salunkhe Bharat Bayaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17175",
    "name": "Salunkhe Chandrakant Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6305",
    "name": "Salunkhe Daji Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3353",
    "name": "Salunkhe Dattatraya Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15765",
    "name": "Salunkhe Dinkar Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16026",
    "name": "Salunkhe Gajanan Parsharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6893",
    "name": "Salunkhe Gangaram Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11983",
    "name": "Salunkhe Hemangi Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10747",
    "name": "Salunkhe Kalawati Yadav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12604",
    "name": "Salunkhe Kishor Avinash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1797",
    "name": "Salunkhe Laxman Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2525",
    "name": "Salunkhe Mahadev Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11161",
    "name": "Salunkhe Ramchandra Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16198",
    "name": "Salunkhe Sachin Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5857",
    "name": "Salunkhe Sadashiv Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16041",
    "name": "Salunkhe Santosh Krushnat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4377",
    "name": "Salunkhe Sarjerao Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10918",
    "name": "Salunkhe Satish Arjunrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5778",
    "name": "Salunkhe Satish Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7874",
    "name": "Salunkhe Shailaja Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4353",
    "name": "Salunkhe Shamrao Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13522",
    "name": "Salunkhe Shashikala Manikrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15430",
    "name": "Salunkhe Sunil Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18843",
    "name": "Salunkhe Suresh Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11781",
    "name": "Salunkhe Umesh Sopanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4048",
    "name": "Salunkhe Vaijanta Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9460",
    "name": "Salunkhe Vijal Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1522",
    "name": "Salunkhe Vyankat Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12632",
    "name": "Salvi Balkrishna Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8178",
    "name": "Salvi Gajanan Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13640",
    "name": "Salvi Sudhakar Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2934",
    "name": "Sanake Dattaran Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18794",
    "name": "Sanas Ankush Jagu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21383",
    "name": "Sane Sudhir Moreshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8986",
    "name": "Sankapal Dilip Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14342",
    "name": "Sapkal Rajaram Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2622",
    "name": "Sapkal Vilas Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9698",
    "name": "Sarafdar Mahadeo S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4452",
    "name": "Sarafdr Mahadeo Sadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21515",
    "name": "Sargod Mithumiya Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18832",
    "name": "Saroj  Rajendraprasad Kaluram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13820",
    "name": "Sarvaiyya Pala Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19594",
    "name": "Sathe Vithal Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21475",
    "name": "Satpute Digamber Dhondiba."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16209",
    "name": "Satpute Harichandra Kondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4990",
    "name": "Saune Rangnath Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "544",
    "name": "Sawant Aadika Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20258",
    "name": "Sawant Archana Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15589",
    "name": "Sawant Ashok Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3159",
    "name": "Sawant Baburao Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4743",
    "name": "Sawant Bajirao Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8845",
    "name": "Sawant Balu Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21569",
    "name": "Sawant Deepa Shashikant."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15337",
    "name": "Sawant Devendra D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8240",
    "name": "Sawant Dhansing Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11145",
    "name": "Sawant Dilip Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9443",
    "name": "Sawant Eknath Balakrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12275",
    "name": "Sawant Kalabai Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16539",
    "name": "Sawant Kalpana Kisan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17793",
    "name": "Sawant Kamal Bapurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10595",
    "name": "Sawant Krishna Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10695",
    "name": "Sawant Mahendra Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4898",
    "name": "Sawant Mansingh Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10442",
    "name": "Sawant Mansingh Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5838",
    "name": "Sawant Maruti Jagdeorao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11669",
    "name": "Sawant Mohan Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13043",
    "name": "Sawant Naina Jagannatha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12078",
    "name": "Sawant Rajan Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20746",
    "name": "Sawant Rajani Shriram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8620",
    "name": "Sawant Ramchandra Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13839",
    "name": "Sawant Ramesh Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21360",
    "name": "Sawant Ravindra Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10067",
    "name": "Sawant Sahebrao Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19380",
    "name": "Sawant Sampat Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12738",
    "name": "Sawant Shankar Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4145",
    "name": "Sawant Shivaji Gunda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13920",
    "name": "Sawant Subhash Bhagvan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15103",
    "name": "Sawant Subhash Hindurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14296",
    "name": "Sawant Suresh Kushabha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15238",
    "name": "Sawant Tukaram Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11762",
    "name": "Sawant Umesh Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21676",
    "name": "Sawant Vijay Shrikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12610",
    "name": "Sawant Vishwanath Vittal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18640",
    "name": "Sawant Yogesh Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12268",
    "name": "Sawant Yuvaraj Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18849",
    "name": "Sayyad Ansar Babulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21500",
    "name": "Sayyad Husein Khadim Husen"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18851",
    "name": "Sayyad Irfan Mehmood"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21594",
    "name": "Sayyad Sikanadar Gulab"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11186",
    "name": "Seth Raju Shambunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10074",
    "name": "Shah Bharatkumar Himatlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3596",
    "name": "Shah Binjraji Babulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4408",
    "name": "Shah Dhirajlal K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18414",
    "name": "Shah Dilipkumar P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12513",
    "name": "Shah Mahendra Lalchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21287",
    "name": "Shah Riyaz Ahmed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18088",
    "name": "Shah Trusha Umesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14898",
    "name": "Shaikh Aabulal Adam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21574",
    "name": "Shaikh Abdulsalam Abdulaziz"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8381",
    "name": "Shaikh Abdulwahab Insanali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21410",
    "name": "Shaikh Anwar Yusuf"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21345",
    "name": "Shaikh Babu Abdulmajid"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21747",
    "name": "Shaikh Basu Abdul Karim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11177",
    "name": "Shaikh Ismail Yusuf"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13892",
    "name": "Shaikh Jawed Husaindulle"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21426",
    "name": "Shaikh Mohamad Hasain Bismilla"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21715",
    "name": "Shaikh Mohamad Kamaluddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13403",
    "name": "Shaikh Murtuja Lalmohd."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11409",
    "name": "Shaikh Nasimulla Janali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22684",
    "name": "Shaikh Nazir Ahmed Mohd Hussain"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21743",
    "name": "Shaikh Nisar Ahamd Jamiuddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21589",
    "name": "Shaikh Noorullah Rafik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18966",
    "name": "Shaikh Sagir Ahmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19806",
    "name": "Shaikh Shafinoor Mohd."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11777",
    "name": "Shaikh Sherali B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18129",
    "name": "Shamishthe Jagannath Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9802",
    "name": "Sharma  Rakesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13214",
    "name": "Sharma Ashok Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21737",
    "name": "Sharma Dineshchandra Bhaguram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12836",
    "name": "Sharma Hari Prasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21405",
    "name": "Shau Pyarelal B."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1376",
    "name": "Shedage Baburao Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20531",
    "name": "Shedge Sampat Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19560",
    "name": "Shedge Sanjay Popatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9925",
    "name": "Shedge Yadu Jotiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21508",
    "name": "Sheikh Chandbabu Abdulkarim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21505",
    "name": "Sheikh Yasmin Abdulkadar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13316",
    "name": "Shejwal Shankar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10816",
    "name": "Shejwal Suresh Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13792",
    "name": "Shekh Gohar Sultana Javed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18098",
    "name": "Shekh Mohamedyashin Mohamedhanif"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18580",
    "name": "Shelake Suresh D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13661",
    "name": "Shelar Dagadu Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3520",
    "name": "Shelar Dnyaneshkumar Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18795",
    "name": "Shelar Gorknath Baliba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6564",
    "name": "Shelar Haribhau Gunda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12131",
    "name": "Shelar Kisan Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6642",
    "name": "Shende Shankar Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21556",
    "name": "Shetty Dinesh Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21554",
    "name": "Shetty Jaya Muttu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8575",
    "name": "Shetye Vasant Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21417",
    "name": "Shewale  Aba  Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14325",
    "name": "Shewale Dhanaji Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18193",
    "name": "Shewane Bharat Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13751",
    "name": "Shibe Maruti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "65",
    "name": "Shidruk Khashaba Keshav (Toli No-188)"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4820",
    "name": "Shigavan Mahadeo Devaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5059",
    "name": "Shigavan Ramesh Daulat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10416",
    "name": "Shigvan Dilip Daulat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7915",
    "name": "Shilimkar Dagdu Jayshing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4455",
    "name": "Shinde Aboso V./ No 756/15"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11311",
    "name": "Shinde Adhikrao Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13149",
    "name": "Shinde Anandrao Jaywantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9110",
    "name": "Shinde Anandrao Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4923",
    "name": "Shinde Arun Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6110",
    "name": "Shinde Ashok Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13688",
    "name": "Shinde Ashok Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2377",
    "name": "Shinde Baban Balkurshna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6823",
    "name": "Shinde Balkrushna Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3933",
    "name": "Shinde Balu Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16517",
    "name": "Shinde Beby Hanmant."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19904",
    "name": "Shinde Chintaman Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8423",
    "name": "Shinde Dadaso Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3329",
    "name": "Shinde Dattatraya Appaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19095",
    "name": "Shinde Dattatrey Sampatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10410",
    "name": "Shinde Dilip Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9494",
    "name": "Shinde Dilip Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5839",
    "name": "Shinde Dinkar Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12589",
    "name": "Shinde Dyanand Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "348",
    "name": "Shinde Dyandev Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "632",
    "name": "Shinde Eknathrao Namdevrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11957",
    "name": "Shinde Jagannath Appaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15251",
    "name": "Shinde Jagannath Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3999",
    "name": "Shinde Jagannath Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11528",
    "name": "Shinde Kisan Appaji."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7820",
    "name": "Shinde Kisan Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6119",
    "name": "Shinde Kundalik Vyankat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9235",
    "name": "Shinde Laxman Bajrang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17064",
    "name": "Shinde Manohar Bhimaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16874",
    "name": "Shinde Maruti Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6392",
    "name": "Shinde Narayan Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "389",
    "name": "Shinde Narayan Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15236",
    "name": "Shinde Narayan Vaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5163",
    "name": "Shinde Pandharinath Appaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2351",
    "name": "Shinde Popat Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18774",
    "name": "Shinde Prakash Keru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14107",
    "name": "Shinde Prakash Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21601",
    "name": "Shinde Prakash Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7581",
    "name": "Shinde Pramod Abasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18968",
    "name": "Shinde Rajendra Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11776",
    "name": "Shinde Rajendra Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13887",
    "name": "Shinde Ramesh Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18796",
    "name": "Shinde Ravindra Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14226",
    "name": "Shinde Ravindra Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15278",
    "name": "Shinde Sampat Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9154",
    "name": "Shinde Sanjay Awba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21276",
    "name": "Shinde Sanjay Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17085",
    "name": "Shinde Sanjay Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15418",
    "name": "Shinde Shankar Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11420",
    "name": "Shinde Sharmila Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14446",
    "name": "Shinde Shashikant Duryodhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7505",
    "name": "Shinde Sopan Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "332",
    "name": "Shinde Subhash Malharrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8330",
    "name": "Shinde Sukhdeo Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15440",
    "name": "Shinde Sukumar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13261",
    "name": "Shinde Sunil Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11850",
    "name": "Shinde Sunil Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18820",
    "name": "Shinde Sunil Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2903",
    "name": "Shinde Tanaji Joti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9086",
    "name": "Shinde Tanaji Joti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11130",
    "name": "Shinde Tatyaba Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2894",
    "name": "Shinde Uttam Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8330",
    "name": "Shinde Vasant Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4286",
    "name": "Shinde Vilas Dinkarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15913",
    "name": "Shinde Vitthalrao Atmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9350",
    "name": "Shinde Vivek Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21526",
    "name": "Shinde Yeshwant Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18654",
    "name": "Shinde Yuavaraj Lalasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12159",
    "name": "Shinde Yuvaraj Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "636",
    "name": "Shingan Ramchandra Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5740",
    "name": "Shingan Vishwanath Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17450",
    "name": "Shingate Chhaya Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19003",
    "name": "Shingate Gulab Nilu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11013",
    "name": "Shingate Satish Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11445",
    "name": "Shiralkar Baban Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9218",
    "name": "Shirambekar Yeshwant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6685",
    "name": "Shirambekar Yeshwant Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14036",
    "name": "Shirashakar Vijay Bhagawan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18809",
    "name": "Shirkande Sunil Damu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14617",
    "name": "Shirke Anjana Hanamant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12591",
    "name": "Shirke Rajashree Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21536",
    "name": "Shirvankar Pramod Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14295",
    "name": "Shitole Kondiba Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21298",
    "name": "Shivaji Singh Ramdhan Singh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10425",
    "name": "Shivale Asha Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8610",
    "name": "Shivankar Vithal Vyankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1877",
    "name": "Shivde Vishnu Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18696",
    "name": "Shive Bhore Paragsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9802",
    "name": "Shivnekar Arvind Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2573",
    "name": "Shiwankar Baburao Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9588",
    "name": "Shri Om Jaibhawani Tarun Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4927",
    "name": "Shrigaonkar Omprakash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15289",
    "name": "Shroff Gev Behramji B."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21640",
    "name": "Shukla Kapurchand Prabhunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13568",
    "name": "Shukla Lallu Prasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7716",
    "name": "Shukla Munnilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21390",
    "name": "Shukla Shyam Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21511",
    "name": "Shukla Vindhyabasini Sidddhnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21766",
    "name": "Sidhiki Ali  Mohmed Kasam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21113",
    "name": "Sigwan Sameer Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18808",
    "name": "Sinalkar Santosh Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21282",
    "name": "Singh  Ajitkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21294",
    "name": "Singh  Banarasi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21378",
    "name": "Singh  Lalmani  Rajbahadur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21557",
    "name": "Singh  Manojkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21337",
    "name": "Singh Chatradhari Dayashankar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20255",
    "name": "Singh Dipali Sanamjit"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "326",
    "name": "Chintamani Constructions"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15136",
    "name": "Singh Kaushlendra Ramshakal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21535",
    "name": "Singh Mukutdhari Dayashankar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15540",
    "name": "Singh Rajeshkumar Parmhans"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18817",
    "name": "Singh Shyam Kanayai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21632",
    "name": "Singh Upendra Subedar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21663",
    "name": "Singh Vidyakaur Mansingh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21623",
    "name": "Singh Vijay Kesariprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21710",
    "name": "Singh Vinodkumar Chandrama"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21539",
    "name": "Singh Virendraprasad Chanai."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14055",
    "name": "Solanki Asha Dayalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1461",
    "name": "Solaskar Gulabrao Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21437",
    "name": "Somaroo Balai Pasi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10059",
    "name": "Sonawale Namdeo Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14763",
    "name": "Sonawane Laoo Amruta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18107",
    "name": "Sonawane Manik Amruta"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1885",
    "name": "Sonawane Sampat Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20837",
    "name": "Sonawane Sanjay Vishanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21369",
    "name": "Sonawane Sanjeev Sadashiv."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15603",
    "name": "Sonawane Shivaji Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15820",
    "name": "Soni Shripalkumar N"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1117",
    "name": "Sonmalw Balkrishna Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21344",
    "name": "Souda Premsingh Dayachand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19632",
    "name": "Supat Suresh Ratan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15097",
    "name": "Surati Prembhai Ranchoddas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19344",
    "name": "Suresh Rangaswami Annegoda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18345",
    "name": "Surutkar Parashuram Kallapa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11939",
    "name": "Surve Bandu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11422",
    "name": "Surve Indubai Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21281",
    "name": "Surve Santosh Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14287",
    "name": "Surve Shantaram Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21712",
    "name": "Surwade Lalita Yuvraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21315",
    "name": "Suryakant Pandurang Shinde ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20328",
    "name": "Sutar Maruti Dattu."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11495",
    "name": "Sutar Yashwant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8260",
    "name": "Taigade Shamrao Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18787",
    "name": "Taki  Ayub Khan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10297",
    "name": "Talekar Milind Digamber"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21296",
    "name": "Tambe Santosh Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12260",
    "name": "Tambe Vilas Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16901",
    "name": "Tamhanekar Sangam Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18782",
    "name": "Tapal Popat Jayram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7742",
    "name": "Tarachand  Maganiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9246",
    "name": "Tarade Dnyaneshwar Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13913",
    "name": "Tarde Shanta Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14052",
    "name": "Tari Anand Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14133",
    "name": "Tari Sangita Vasudeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8832",
    "name": "Tate Dhanaji Chander"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19220",
    "name": "Tate Shailesh Sharad."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2353",
    "name": "Tavare Atmaram Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21606",
    "name": "Taware Laxman Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11090",
    "name": "Taware Samadhan A. T.No 27/59"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14160",
    "name": "Tejam Jaywant Sahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15973",
    "name": "Tele Vithal Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "216",
    "name": "Teli Ashi Koli Khun Khun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14491",
    "name": "Telure Mahendra Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10380",
    "name": "Tetme Uttam Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17965",
    "name": "Thakur Phatesing Baldevsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9612",
    "name": "Thakur Suresh Guruprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14110",
    "name": "Thatera Pappulal Alis Ajaykumar Chunilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "258",
    "name": "Thombre Maruti Waghji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18803",
    "name": "Thopate Anil Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10268",
    "name": "Thorat Sanjay Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11280",
    "name": "Thorave Shital Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12720",
    "name": "Tidake Sambhaji Balaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13096",
    "name": "Timegaunde Sivanna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21397",
    "name": "Tiwari Anandkumar Lalji."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18965",
    "name": "Tiwari Harendra Nath Radheshyam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18960",
    "name": "Tiwari Pappu Ramlakhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18962",
    "name": "Tiwari Rajendra Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18528",
    "name": "Tiwari Rameshchandra Ramnarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21364",
    "name": "Todankar Vijay Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14457",
    "name": "Toraskar Ashok Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1844",
    "name": "Toraskar Nana Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3220",
    "name": "Toraskar Shivaji Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18326",
    "name": "Totre Tanaji Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20693",
    "name": "Tripathi Arati Krishnachandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21742",
    "name": "Tripatti Arunkumar Jainath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21495",
    "name": "Umar Abdul Vahid Abdul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21415",
    "name": "Umar Mohemad Salim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14211",
    "name": "Umberkar Shrirang Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17273",
    "name": "Undalkarvilash  Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12650",
    "name": "Unde Ananda Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18694",
    "name": "Upadhyay Kishorkumar Jatashankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19964",
    "name": "Upadhyay Rajeshkumar Janardhanprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9140",
    "name": "Upe Kisan Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14074",
    "name": "Utekar  Pratik Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21408",
    "name": "V. Modha Swamy  Velukumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13069",
    "name": "Vairkar Vasant Dyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14370",
    "name": "Vaishampanyam Yeshwant Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14219",
    "name": "Valanju Sunil Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10183",
    "name": "Valatra Dhanibai Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21402",
    "name": "Valunj Jayram Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9942",
    "name": "Varkhade Chandrakant Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21307",
    "name": "Varma Bachanlal Babulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21714",
    "name": "Varma Ramsagar Ramnaresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13512",
    "name": "Vaste Shrutuja Kishor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14053",
    "name": "Vaste Sunil Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21279",
    "name": "Vawal Madhukar Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11142",
    "name": "Veer Laxman Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4804",
    "name": "Veer Laxman Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14306",
    "name": "Veer Sambhaji Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20406",
    "name": "Vellari Devji Bava"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10912",
    "name": "Vetkar Satyawan Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14387",
    "name": "Vichare Madhusudan Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11730",
    "name": "Vighate Avinash Dattatraya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21311",
    "name": "Vikash Nana Jagtap ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11083",
    "name": "Virkar Shamkant Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21765",
    "name": "Vishawakarma Tulshidas Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11776",
    "name": "Vishnoi Bheraram T"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21717",
    "name": "Vishwakarma Kamlesh Shreenath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13449",
    "name": "Vishwakarma Navraj Bhadur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "411",
    "name": "Vora Hasumati Jagjivandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10448",
    "name": "Vora Narendra Dulaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4708",
    "name": "Vora Suresh Mohanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1599",
    "name": "Wadekar Rajashri Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4780",
    "name": "Wadkar Malati D."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6408",
    "name": "Wadkar Raghunath Babaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14434",
    "name": "Wadke Prasad Jaykumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15084",
    "name": "Wadrala Chandrabhaga Harischandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1997",
    "name": "Wagh Hindurao Sadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18793",
    "name": "Waghamare Sanjay Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15275",
    "name": "Waghambare Surendra Ganesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17266",
    "name": "Waghela Praveen Manu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15202",
    "name": "Waghmare Bharat Bajrang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17801",
    "name": "Waghmare Deepak Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6495",
    "name": "Waghmare Sampat Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12206",
    "name": "Waghmare Sampat Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9781",
    "name": "Waghmare Vishnu Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "556",
    "name": "Waghu Kesu Bhagwat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10753",
    "name": "Wagle Binita Nikunj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14576",
    "name": "Wala Jaya Mahendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14162",
    "name": "Walankar Yashwant Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18850",
    "name": "Walmiki Rajendra Harising"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18816",
    "name": "Wani Dattatary Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4522",
    "name": "Warkhade Vinayk Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21513",
    "name": "Warma Ramsajivan Munilal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10602",
    "name": "Warule Satyawan Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17072",
    "name": "Yadav Baban Yashawant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "681",
    "name": "Yadav Baburao Harichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18802",
    "name": "Yadav Bakelal Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8255",
    "name": "Yadav Balu Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21449",
    "name": "Yadav Chugadi Chandrashekhar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13519",
    "name": "Yadav Dashrath Swami"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12850",
    "name": "Yadav Dashrathprasad R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3927",
    "name": "Yadav Dattatraya Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21741",
    "name": "Yadav Devindraprasad Vishwnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21305",
    "name": "Yadav Girijashankar C."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9618",
    "name": "Yadav Hanmant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12059",
    "name": "Yadav Jitendra Vijaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18775",
    "name": "Yadav Kakicharan Vikram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21445",
    "name": "Yadav Kanayalal Basantlal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18982",
    "name": "Yadav Lalaji Jairam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10955",
    "name": "Yadav Lalan Ramchet"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18815",
    "name": "Yadav Lalchand Amarnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3519",
    "name": "Yadav Mansing Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4124",
    "name": "Yadav Matabada Shrikhyali Prasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14482",
    "name": "Yadav Muneshwar Chulai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21403",
    "name": "Yadav Nandlal Jaddu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18755",
    "name": "Yadav Nandu Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17100",
    "name": "Yadav Prakash Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21292",
    "name": "Yadav Raghuraj Chankya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21498",
    "name": "Yadav Rajdev Bodha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21735",
    "name": "Yadav Rajendra Prasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21401",
    "name": "Yadav Rakeshkumar Sarvjeet"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11464",
    "name": "Yadav Rambahadur Munnilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4065",
    "name": "Yadav Ramchandra Dadaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21767",
    "name": "Yadav Ramdhari Ramavadh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17038",
    "name": "Yadav Ramkewal Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21503",
    "name": "Yadav Ramkrishan Harichandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21494",
    "name": "Yadav Ramshankar Fulchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11066",
    "name": "Yadav Sachin Dubar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21736",
    "name": "Yadav Shyamsudar Harshu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2423",
    "name": "Yadav Sitaram Jokhuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21382",
    "name": "Yadav Siyaram Shamdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7985",
    "name": "Yadav Subhash Bhivaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21618",
    "name": "Yadav Subhashchandra Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18513",
    "name": "Yadav Subhedar Ramraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18971",
    "name": "Yadav Subrame Ramaya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2553",
    "name": "Yadav Sukhdev Prasad Ramlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3057",
    "name": "Yadav Tukaram Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18854",
    "name": "Yadav Vimleshkumar Kedarnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1168",
    "name": "Yelave Ganpat Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10311",
    "name": "Yevane Vijay Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7630",
    "name": "Yewale Dharmaji Narsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15347",
    "name": "Yewale Ganpat Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11467",
    "name": "Yewale Hanmant Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7485",
    "name": "Yewale Jaysing Nana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18990",
    "name": "Yewale Shankar Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7459",
    "name": "Yezarkar Chandrakant Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21320",
    "name": "Yusuf Ibrahim Safi."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3256",
    "name": "Zanzane Ganpat Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12108",
    "name": "Zanzurne Shrikant Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15526",
    "name": "Zodge Suresh Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10496",
    "name": "Gharal Yashwant Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12114",
    "name": "Pawar Anandrao V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10489",
    "name": "Pichurale Shankar Daulat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "412",
    "name": "Dhadave Laxman Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7726",
    "name": "Chawan Dinkar Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17629",
    "name": "Tale Prabhakar Madan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24277",
    "name": "Parave Zakir Nuramohammad"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "585",
    "name": "Dattakrupa Roadways"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "438",
    "name": "Sonawane Vishnurao Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13451",
    "name": "Aajgaonkar Chandrakant Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11295",
    "name": "Achare Bajrang Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17922",
    "name": "Advasi Manbharan Chovanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10822",
    "name": "Agarwal Anguridevi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8288",
    "name": "Agarwal Vimladevi Kesharimal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9862",
    "name": "Ahirekar Nandkumar Chanderrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2893",
    "name": "Aliraja Mohammed Islam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16573",
    "name": "Ambatkar Pralhad Shrihari/Kamal Pralhad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5495",
    "name": "Ambekar Ramchandra Sudkoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14614",
    "name": "Ambekar Vijay Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16313",
    "name": "Ambre Sachin Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1488",
    "name": "Ananpat  Keshav Neelu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15147",
    "name": "Anawkar Pandurang Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17324",
    "name": "Anchan Shivram R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12688",
    "name": "Andrade  Alba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13079",
    "name": "Anekar Pradeep Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11729",
    "name": "Angachekar Vidula Vikas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2961",
    "name": "Anpat Kisan Parbati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21355",
    "name": "Ansari Fahimuddin Khurshid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21346",
    "name": "Ansari Md Imjad Md Yaamin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11894",
    "name": "Arate Lata Manoj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "702",
    "name": "Arote Baban Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15790",
    "name": "Atugade Kiran Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9652",
    "name": "Atugade Vishnu Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4852",
    "name": "Auti Bhagwanta Rambhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7257",
    "name": "Avhad Dinesh Kachru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16071",
    "name": "Aware Sunil Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12109",
    "name": "Ayare Prakash Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12696",
    "name": "Baalay Shashikant Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5666",
    "name": "Babar Mohan Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4055",
    "name": "Babar Vyankat Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4546",
    "name": "Bafana Hakamichand Rawatmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14165",
    "name": "Bagawe Kamalakar Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16355",
    "name": "Bagla Sunil H"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11775",
    "name": "Bagul Rekha Devidas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16120",
    "name": "Bait Dilip Gangaram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7649",
    "name": "Balkrishnan M K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22683",
    "name": "Balmiki Govindram Chiranjilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8962",
    "name": "Balsaraf Pandurang Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6422",
    "name": "Balva Mohammad Salim Jamilkha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1682",
    "name": "Bamavalkar Wasudeo Laxmanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8240",
    "name": "Bandal Deepak Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12700",
    "name": "Bandal Sonba Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17261",
    "name": "Bane Dilip Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16456",
    "name": "Barai Jwalaprasad Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14785",
    "name": "Barai Ramnath Kanhaiyalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19409",
    "name": "Barge  Prashant  Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17619",
    "name": "Barge Rajendra Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18321",
    "name": "Barve Hanumant Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11151",
    "name": "Basantkhan Mohammad Mustafa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17217",
    "name": "Bavisi Hasmukh Khushalchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15465",
    "name": "Belvalkar Prabhakar Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13103",
    "name": "Belwalkar Pandurang Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16139",
    "name": "Bendake Nitin Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "195",
    "name": "Beske Hanmant Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15975",
    "name": "Bhadwalkar Vinayak Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13644",
    "name": "Bhagat Smita Satish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13385",
    "name": "Bhagat Waman Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16209",
    "name": "Bhagwat Balasao Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8051",
    "name": "Bhagwat Mohan Vinayakrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4168",
    "name": "Bhagwat Nanasaheb Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12343",
    "name": "Bhagwat Ravindra Shashikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1058",
    "name": "Bhagwat Shamrao Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8105",
    "name": "Bhaip Dhaku Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1213",
    "name": "Bhandari Ghanshyam Ramnath."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16374",
    "name": "Bhandwalkar Gorakh Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13936",
    "name": "Bhandwalkar Tukaram Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9053",
    "name": "Bhangde Vijaykumar Gokuldas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13308",
    "name": "Bhangle Ranjana Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16245",
    "name": "Bhapkar Rajendra Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2457",
    "name": "Bharadwaj Subhash Rajkumar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8929",
    "name": "Bharkar Vaman Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16102",
    "name": "Bharugade Suresh Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9298",
    "name": "Bhat Shrichand Tarachand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4376",
    "name": "Bhatewara Shah Ramchandra Wanechand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12848",
    "name": "Bhatt Lokesh Radheshyam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7826",
    "name": "Bhavsar Kantaben Narayandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7822",
    "name": "Bhavsar Sushma Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12948",
    "name": "Bhawake Arun Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12821",
    "name": "Bhawnagar Gita Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5398",
    "name": "Bhilare Balasaheb Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5130",
    "name": "Bhilare Bharat Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13554",
    "name": "Bhilare Dhananjay Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17700",
    "name": "Bhilare Hanmant Aabaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12608",
    "name": "Bhilare Jaywant Daulati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8418",
    "name": "Bhilare Jaywant Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15679",
    "name": "Bhilare Kondiba Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14055",
    "name": "Bhilare Shantaram Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14430",
    "name": "Bhilare Yashwant Abaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1158",
    "name": "Bhise Rajaram Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12869",
    "name": "Bhise Umesh Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10688",
    "name": "Bhodhe Kashinath Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "900",
    "name": "Bhoite Anandrao Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16623",
    "name": "Bhoite Ankush Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1783",
    "name": "Bhoite Baban Balwantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17166",
    "name": "Bhoite Balasaheb Dhansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17348",
    "name": "Bhoite Devidas Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2842",
    "name": "Bhoite Dilip Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16464",
    "name": "Bhoite Hanmant Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1627",
    "name": "Bhoite K K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11660",
    "name": "Bhoite Kalawati Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "655",
    "name": "Bhoite Madhavrao Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17198",
    "name": "Bhoite Nanaso Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3916",
    "name": "Bhoite Pralhad Bhausaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17023",
    "name": "Bhoite Rajendra Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16330",
    "name": "Bhoite Sangita Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17209",
    "name": "Bhoite Shankar Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8010",
    "name": "Bhoite Vikrant Shivagirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16887",
    "name": "Bhor Eknath Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8332",
    "name": "Bhor Sambhaji Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2690",
    "name": "Bhosale Bajirao Nilkanth"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5602",
    "name": "Bhosale Balkrishna Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18148",
    "name": "Bhosale Bharat Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2851",
    "name": "Bhosale Chandrakant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2045",
    "name": "Bhosale Dayaram Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3452",
    "name": "Bhosale Dnyandeo Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5064",
    "name": "Bhosale Gorakh Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12210",
    "name": "Bhosale Haibatrao Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6794",
    "name": "Bhosale Hanmant Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8476",
    "name": "Bhosale Kalidas Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6606",
    "name": "Bhosale Kisan Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3763",
    "name": "Bhosale Krishna Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16690",
    "name": "Bhosale Laxman Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18389",
    "name": "Bhosale Megha Mahesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16793",
    "name": "Bhosale Nana Kundilik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16633",
    "name": "Bhosale Pandurang Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12139",
    "name": "Bhosale Parshuram Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1445",
    "name": "Bhosale Prashantkumar Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14571",
    "name": "Bhosale Rajendra Fatesing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16450",
    "name": "Bhosale Ranjana S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16188",
    "name": "Bhosale Satish Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "399",
    "name": "Bhosale Shamrao Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17232",
    "name": "Bhosale Sunil Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14666",
    "name": "Bhosale Suresh Dharmu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7568",
    "name": "Bhosale Suresh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17492",
    "name": "Bhosale Suresh Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6862",
    "name": "Bhosale Tanaji Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8023",
    "name": "Bhosle Anand Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1912",
    "name": "Bhosle Baburao Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16562",
    "name": "Bhuvad Anand Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14331",
    "name": "Bijan Shankar Devaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13027",
    "name": "Bisani Mahendra Jamnadas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11738",
    "name": "Bizye Suryakant Vishram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6128",
    "name": "Bobade Chandrakant Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13302",
    "name": "Bobade Jagannath Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13994",
    "name": "Bobade Jaywant Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17674",
    "name": "Bobade Rajendra Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16643",
    "name": "Bobade Subhash Ghankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17299",
    "name": "Bombale Ajit Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14056",
    "name": "Bombale Dnyaneshwar Dasu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23298",
    "name": "Bomble Rajesh Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17944",
    "name": "Borage Tukaram Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13605",
    "name": "Borge Tanaji Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11728",
    "name": "Borhade Dhondu Chimaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16973",
    "name": "Borkar Vilas Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12907",
    "name": "Brid Suresh Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10030",
    "name": "Calkey Pandurang Chnaynu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18627",
    "name": "Chalake Krishna Parashuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17669",
    "name": "Chalake Sarjerao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12743",
    "name": "Chalke Anil Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10507",
    "name": "Chalke Govind Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21316",
    "name": "Chalke Sanjay Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18428",
    "name": "Chandarana Tarun D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18359",
    "name": "Chandre Seby Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13446",
    "name": "Chandwade Yogesh Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12290",
    "name": "Chari Pramod Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3287",
    "name": "Chaskar Haribhau Mahadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4530",
    "name": "Chatur Baban Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13727",
    "name": "Chaudhari Krishnawatidevi Rajendrap"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11059",
    "name": "Chaudhari Rambharose Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21461",
    "name": "Chaudhary Sonu Sanib"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10838",
    "name": "Chaurasiya Harilal Raghunathprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11218",
    "name": "Chaurasiya Ramswarup Balichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17265",
    "name": "Chavan  Kiran   Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19021",
    "name": "Chavan  Sushama Bhimrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10490",
    "name": "Chavan Anant R."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17835",
    "name": "Chavan Anil Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12353",
    "name": "Chavan Ankush Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11457",
    "name": "Chavan Appa Daulat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13016",
    "name": "Chavan Arun Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14936",
    "name": "Chavan Ashok Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12392",
    "name": "Chavan Balasaheb Krishnarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15649",
    "name": "Chavan Chandrakant Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11850",
    "name": "Chavan Dasharath Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12399",
    "name": "Chavan Deepak Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10636",
    "name": "Chavan Dilip Sudam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11620",
    "name": "Chavan Jagannath Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5983",
    "name": "Chavan Kalpana Tulshiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12804",
    "name": "Chavan Machhindranath Uddhav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8867",
    "name": "Chavan Prakash Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10612",
    "name": "Chavan Pramod Janardan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15784",
    "name": "Chavan Pratibha Pandurang."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16771",
    "name": "Chavan Pushpa Changdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1694",
    "name": "Chavan Ramchandra Bandoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5646",
    "name": "Chavan Ramesh Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10508",
    "name": "Chavan Ranjana Tanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11447",
    "name": "Chavan Satyawan Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12116",
    "name": "Chavan Seema Ajitsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12447",
    "name": "Chavan Sunanda Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16992",
    "name": "Chavan Sunil Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1620",
    "name": "Chavan Suresh Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8050",
    "name": "Chavan Tanajirao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17603",
    "name": "Chavan Vasant Bapurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11735",
    "name": "Chavan Vilas Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13127",
    "name": "Chavan Vinayak Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8662",
    "name": "Chavan Vishram Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15269",
    "name": "Chavan Vivek Shivaji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8780",
    "name": "Chawan Chandrakant Madhavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1697",
    "name": "Chawan Daulat Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17860",
    "name": "Chawan Dnyaneshwar Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "205",
    "name": "Chawan Hanmant Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7188",
    "name": "Chawan Hanmant Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17058",
    "name": "Chawan Jalinder Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3210",
    "name": "Chawan Mahadeo Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9167",
    "name": "Chawan Narayan Buvaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2785",
    "name": "Chawan Nivrutti Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15707",
    "name": "Chawan Prakash Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16993",
    "name": "Chawan Raghunath Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17120",
    "name": "Chawan Rajaram Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3085",
    "name": "Chawan Ramchandra Bayaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "474",
    "name": "Chawan Ramchandra Bayaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10370",
    "name": "Chawan Ramchandra Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14181",
    "name": "Chawan Ramchandra Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8688",
    "name": "Chawan Shamrao Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17597",
    "name": "Chawan Shivaji Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17221",
    "name": "Chawan Suresh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18562",
    "name": "Chawan Tulshi Parshottam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17165",
    "name": "Chawan Vandana Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12885",
    "name": "Chhabria Kalawantibai R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15191",
    "name": "Chikane Bajarang Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17672",
    "name": "Chikane Jaysingh Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18737",
    "name": "Chikane Ramchandra Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "576",
    "name": "Chilekar Anil Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11055",
    "name": "Chodhari Mottaram M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16100",
    "name": "Chorge Umesh Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9719",
    "name": "Chorge Vasant Gunda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15977",
    "name": "Choudhari  Manojkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16132",
    "name": "Choudhari Gulava Devi Hanuman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17464",
    "name": "Choudhry Pravina Savarmal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14506",
    "name": "Chouhan Bechan Ramanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18855",
    "name": "Chowdhri Shantidevi Vijaykumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13870",
    "name": "Chowhan Govindlal Buralal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5614",
    "name": "Dabhade Hindurao Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1212",
    "name": "Dabhade Kisan Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19911",
    "name": "Dabhade Urmila Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17938",
    "name": "Dakave Laxman K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17082",
    "name": "Dakave Shankar Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9774",
    "name": "Dake Pradeep Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15488",
    "name": "Dalal Shamsundar Kisanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15458",
    "name": "Dalavi Suresh Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16365",
    "name": "Dalvi Baban Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6089",
    "name": "Dalvi Hanmant Natha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11006",
    "name": "Dalvi Harnabai Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3214",
    "name": "Dalvi Khashaba Appa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5246",
    "name": "Dalvi Shivaji Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12420",
    "name": "Dalvi Vinayak Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10347",
    "name": "Dambare Sarjerao Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8029",
    "name": "Dani Rupa M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13933",
    "name": "Daptare Vinayak Sudam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10499",
    "name": "Darak Murli Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14849",
    "name": "Das Tarun K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18044",
    "name": "Date Bhau Navrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3949",
    "name": "Dawankar Laxmibai Yashwantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17279",
    "name": "D'Costa Caroline Desousa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13220",
    "name": "Dekale Anil Hindurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10288",
    "name": "Dere Sanjay Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7678",
    "name": "Dere Suresh Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17422",
    "name": "Desai Appaso Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17651",
    "name": "Desai Dhyandeo Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12404",
    "name": "Desai Dilip Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12715",
    "name": "Desai Kanan Yogesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12405",
    "name": "Desai Nitin Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17877",
    "name": "Desai Vitthal Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1007",
    "name": "Deshmukh Anandrao Daulatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "598",
    "name": "Deshmukh Krishna Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13484",
    "name": "Deshmukh Narayan Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19309",
    "name": "Deshmukh Sonabai Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "654",
    "name": "Devkar Baburao Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7585",
    "name": "Devkar Popat Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16208",
    "name": "Devlekar Sunil Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17041",
    "name": "Dhadve Prakash Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17912",
    "name": "Dhaigude Krishnat Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20050",
    "name": "Dhanawade Geeta Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17556",
    "name": "Dhane Shivaji Balaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17670",
    "name": "Dhane Vishwas Jotiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11760",
    "name": "Dhavale Dattarm Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6348",
    "name": "Dhembare Shrirang Vittal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13500",
    "name": "Dhole Sulochana Vasantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12259",
    "name": "Dhole Tukaram Tulshiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16276",
    "name": "Dhumade Shalini Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3597",
    "name": "Dhumal Bhikoba Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6101",
    "name": "Dhumal Dattatray Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12876",
    "name": "Dhumal Dattatray Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2871",
    "name": "Dhumal Ganpat Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15816",
    "name": "Dhumal Gorakhanath Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2809",
    "name": "Dhumal Hari Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14155",
    "name": "Dhumal Jitendra Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5467",
    "name": "Dhumal Sadashiv Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4032",
    "name": "Dhumal Sambhaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9432",
    "name": "Dhumal Shivaji Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17916",
    "name": "Dhumal Vaibhav Bapurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9176",
    "name": "Dhumal Vijay Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15909",
    "name": "Dhuri Arun Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14191",
    "name": "Dhuri Santosh Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14681",
    "name": "Dingankar Anant Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14404",
    "name": "Disa Lavin P."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14386",
    "name": "Disale Ramchandra Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18322",
    "name": "Disale Shalan Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7202",
    "name": "Disale Shamrao Aavaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7967",
    "name": "Disale Shewantabai Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11291",
    "name": "Dombale Haribhau Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7505",
    "name": "Doshi Kanta Prabhudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12548",
    "name": "Dosi Devaji Adaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10170",
    "name": "Dubal Sunil Baburao 74/13"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13751",
    "name": "Dube Sabhajit Rajnarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21460",
    "name": "Dubey Vimalkumar Shivsagar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "884",
    "name": "Dumare Shataram Sawaleram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11928",
    "name": "Dundale Narayan Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15812",
    "name": "Ethape Hindurao Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4098",
    "name": "Ethape Shamrao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9363",
    "name": "Fadtare Pandurang Amrut"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14009",
    "name": "Falke Kashinath S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2732",
    "name": "Fernandes Franchise"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9286",
    "name": "Gadade Subhadrabai Khandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5147",
    "name": "Gadave Bhiku Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7634",
    "name": "Gade Dada Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16182",
    "name": "Gade Pramod Dnyanoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12869",
    "name": "Gadekar Purushhottam Dnyandev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18774",
    "name": "Gadhave Rajendra Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9145",
    "name": "Gadhave Usha Tulshiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8732",
    "name": "Gadwe Balkrishna Tulsiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15611",
    "name": "Gaglani Chhaya Jayesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13955",
    "name": "Gaikawad Santosh Sackaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5760",
    "name": "Gaikwad Anandrao Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14718",
    "name": "Gaikwad Arvind Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17163",
    "name": "Gaikwad Bajrang Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17901",
    "name": "Gaikwad Bhaskar Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8833",
    "name": "Gaikwad Gulabrao Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18309",
    "name": "Gaikwad Kashinath Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16890",
    "name": "Gaikwad Manoj Shashikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14313",
    "name": "Gaikwad Ravindra Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10097",
    "name": "Gaikwad Sanjay Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16620",
    "name": "Gaikwad Shripati Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12828",
    "name": "Gangawane Mohan Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11253",
    "name": "Garade Baban Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2788",
    "name": "Garade Ganpat Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9837",
    "name": "Gautam Gitaram Pannalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16304",
    "name": "Gautam Ramkumar Jhinkan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15060",
    "name": "Gawda  Ramesha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13460",
    "name": "Gawde Pramod Kamlakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7434",
    "name": "Gayakwad Sakharam Sudkoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16427",
    "name": "Geeri Bharat Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9455",
    "name": "Gehlot Tarachand Himmatmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14638",
    "name": "Genappa Kalpana Vedu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17532",
    "name": "Ghadage Bhanudas Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17200",
    "name": "Ghadge Pralhad Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4837",
    "name": "Ghadge Vishnu Savala"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15423",
    "name": "Ghadigaonkar Deepak Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5941",
    "name": "Ghag Shubhngi Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13357",
    "name": "Ghag Vijay Vikram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7626",
    "name": "Ghagare Mohan Ladoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13207",
    "name": "Ghanekar Shantaram Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12984",
    "name": "Ghanwat Seema Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17826",
    "name": "Gharal Ananda Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2902",
    "name": "Gharal Baburao Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16968",
    "name": "Gharami Pinaki Shital"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12032",
    "name": "Ghare Bajirao Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9512",
    "name": "Ghare Dattatraya Parashuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12694",
    "name": "Ghare Vilas Rajaram 855/B/66"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2992",
    "name": "Ghatawakar Laxmibai Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9462",
    "name": "Ghatwal Gulab Manwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "185",
    "name": "Ghodekar Chandrakant Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6821",
    "name": "Gholap Balu Kesu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17518",
    "name": "Gholap Keshav Shripat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12274",
    "name": "Ghorapade Vilas Amruta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17657",
    "name": "Ghorpade Anil Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17473",
    "name": "Ghorpade Arjun Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "794",
    "name": "Ghorpade Krishna Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17248",
    "name": "Ghorpade Prakash Bhauso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15824",
    "name": "Ghorpade Sanjay Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "406",
    "name": "Ghorpade Vishnu Tatyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11491",
    "name": "Ghume Anil Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13673",
    "name": "Godase Swati Balaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17754",
    "name": "Gohil Pradip M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18225",
    "name": "Goil Kalpana Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16642",
    "name": "Gole Bharat Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5748",
    "name": "Gole Laxman Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18317",
    "name": "Gole Madhukar Genu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3621",
    "name": "Gole Vishnu Kondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11396",
    "name": "Gole Vithal Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12731",
    "name": "Gopal Dipak Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15989",
    "name": "Goradia Devendra Chhabildas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15911",
    "name": "Gorakha Virbahadur Jyotising."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17148",
    "name": "Gosavi Ravindra Uttam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14256",
    "name": "Govekar Kishori Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11081",
    "name": "Gujar Jayshri Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14768",
    "name": "Gundesa Lalsingh Hartingji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14613",
    "name": "Gunjal Shrikrishna Balaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21197",
    "name": "Gupta Rameshchandrda Kantapradsa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17775",
    "name": "Gurav Baliram Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16743",
    "name": "Gurav Mangesh Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15945",
    "name": "Gurav Sambaji Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18119",
    "name": "Halankar Sameer Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15304",
    "name": "Haldankar Kavita Kishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10652",
    "name": "Harijan Daramraj K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6074",
    "name": "Hendre Kalpana Gopinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15563",
    "name": "Hinukale Kisan Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1178",
    "name": "Hiondurao Tukaram Kadam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18698",
    "name": "Hule  Kishor  Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11887",
    "name": "Hule Dattatray Khandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21342",
    "name": "Husain Hajimalang Baba Khwaja"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13551",
    "name": "Indrapal  Dudhnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "500",
    "name": "Indulkar Sadhana Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21320",
    "name": "Indulkar Vilas Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8146",
    "name": "Ingawale Babu Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6506",
    "name": "Ingawale Hanumant Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1472",
    "name": "Ingawale Sampatrao Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1852",
    "name": "Ingulkar Sumitra Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21306",
    "name": "Iqbal Kasam Hingora"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16717",
    "name": "Irave Prakash Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16759",
    "name": "Ithape Jeevan Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16466",
    "name": "Ithape Ravindra Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12321",
    "name": "Ithape Sahebrao Kisanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13292",
    "name": "Jadhav  Shivaji Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8074",
    "name": "Jadhav Annarao Balwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16594",
    "name": "Jadhav Ashok Ganesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9327",
    "name": "Jadhav Bandu Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8025",
    "name": "Jadhav Chandrakant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12992",
    "name": "Jadhav Dashrath Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16983",
    "name": "Jadhav Dashrath Zilanji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1495",
    "name": "Jadhav Dhondiram Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13659",
    "name": "Jadhav Dilip Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17881",
    "name": "Jadhav Dinkar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10122",
    "name": "Jadhav Dnyandeo Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16803",
    "name": "Jadhav Ganapat Gundu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1317",
    "name": "Jadhav Hindurao Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14482",
    "name": "Jadhav Hirabai Mahipat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21307",
    "name": "Jadhav Kishor Dhanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9070",
    "name": "Jadhav Madhukar Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11651",
    "name": "Jadhav Manoj Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7229",
    "name": "Jadhav Namdeo Dharmu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17502",
    "name": "Jadhav Nanadkumar Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5479",
    "name": "Jadhav Narayan Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "921",
    "name": "Jadhav Nivrutti Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14989",
    "name": "Jadhav Prakash Hariba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17871",
    "name": "Jadhav Pravin Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15821",
    "name": "Jadhav Rajendra Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1138",
    "name": "Jadhav Ramchandra Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1886",
    "name": "Jadhav Ramchandra Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17458",
    "name": "Jadhav Ravindra Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7586",
    "name": "Jadhav Ravindra Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18951",
    "name": "Jadhav Sachin Sonaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16912",
    "name": "Jadhav Sadashiv Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13695",
    "name": "Jadhav Shankar Jaywant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3022",
    "name": "Jadhav Shivaji Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3309",
    "name": "Jadhav Shivaji Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17851",
    "name": "Jadhav Shobha Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8637",
    "name": "Jadhav Shreemant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "913",
    "name": "Jadhav Sopan Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6095",
    "name": "Jadhav Suresh Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16768",
    "name": "Jadhav Sushant Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10267",
    "name": "Jadhav Uddhav Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16745",
    "name": "Jadhav Vikas Kisan."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19074",
    "name": "Jadhav Vikas Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7572",
    "name": "Jadhav Vilas Krushnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1774",
    "name": "Jadhav Vinayak Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10814",
    "name": "Jadhav Vithal Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4232",
    "name": "Jagadale Kisan Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8431",
    "name": "Jagdale Bhagwan Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12837",
    "name": "Jagdale Sanjay Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17809",
    "name": "Jagdale Shankar Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14825",
    "name": "Jagtap Bapusaheb Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16656",
    "name": "Jagtap Duryodhan Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15597",
    "name": "Jagtap Harish Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9308",
    "name": "Jagtap Mahadeo Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18399",
    "name": "Jagtap Narayan Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15043",
    "name": "Jagtap Pratap Jagdevrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12843",
    "name": "Jagtap Rahul Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9475",
    "name": "Jagtap Sahebrao Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3019",
    "name": "Jagtap Shivaji Shyamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15002",
    "name": "Jagtap Shrimant Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12576",
    "name": "Jagtap Suresh Ramhari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17862",
    "name": "Jagtap Vitthal Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16936",
    "name": "Jaikar Satish Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10574",
    "name": "Jain Alka Champalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10730",
    "name": "Jain Chandulal Roopchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10311",
    "name": "Jain Dilipkumar Bhabatmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3799",
    "name": "Jain Jayantilal Hirachandji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12285",
    "name": "Jain Jayantilal Neeta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9456",
    "name": "Jain Jethmal Danmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5398",
    "name": "Jain Mohanlal Chunilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17503",
    "name": "Jain Shilpa Paresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16254",
    "name": "Jain Sushila V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17307",
    "name": "Jaiswal Chamilal Bhageluram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17976",
    "name": "Jaiswal Dindayal Mahangi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13704",
    "name": "Jaiswal Giridharilal Lutawan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13407",
    "name": "Jaiswal Rammurat Z"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14032",
    "name": "Jaiswal Ramuagir Bihari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16549",
    "name": "Jaiswar Bhagelu Hanumant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10530",
    "name": "Jaiswar Rajbali Phaguram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13711",
    "name": "Jaitapkar Sakharam Babaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13011",
    "name": "Jamble Ravindra Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14817",
    "name": "Jambulkar Mangesh Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18352",
    "name": "Jamdar Eknath Sidu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7224",
    "name": "Jamdar Tanaji Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17122",
    "name": "Jangam Shankar Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11092",
    "name": "Jathar Sagabhau Bajaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10083",
    "name": "Javal Ganpat Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9987",
    "name": "Jaysval Santabai Ganesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4687",
    "name": "Jeram Sampat Jaisingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9937",
    "name": "Joshi Dhaneshwar Punjiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4133",
    "name": "Joshi Jaylal Nandlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16138",
    "name": "Joshi Maganlal Palluram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11440",
    "name": "Joshi Ramlal Divelal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4682",
    "name": "Joshi Sulkshna R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11147",
    "name": "Joshi Vipul Rashmikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10294",
    "name": "Junghare Chandar Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14939",
    "name": "Kaasar Vinayak Digambar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11614",
    "name": "Kachare Dayaram Chindu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5427",
    "name": "Kad Vilas Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13946",
    "name": "Kadam Anant Mahadao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11716",
    "name": "Kadam Ankush Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18408",
    "name": "Kadam Anusaya Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17667",
    "name": "Kadam Arun Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9913",
    "name": "Kadam Ashok Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8208",
    "name": "Kadam Baburao Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3578",
    "name": "Kadam Bandu Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5362",
    "name": "Kadam Bapu M."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13543",
    "name": "Kadam Bhivaji Y"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11759",
    "name": "Kadam Chandrakant Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14780",
    "name": "Kadam Dadaso Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17937",
    "name": "Kadam Daji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9691",
    "name": "Kadam Dattatrey Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16214",
    "name": "Kadam Dattatreya Vishwasrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8124",
    "name": "Kadam Deepak Dattu Tn-631-13"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11654",
    "name": "Kadam Deepak Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5193",
    "name": "Kadam Dharmaji Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11175",
    "name": "Kadam Ghonu Babaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "553",
    "name": "Kadam Gopalrao Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14981",
    "name": "Kadam Jaykumar Visheshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12952",
    "name": "Kadam Jayvant Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18023",
    "name": "Kadam Kailas  Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12571",
    "name": "Kadam Kundalik Dashrath 795/7"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14826",
    "name": "Kadam Madhavrao Sopanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11681",
    "name": "Kadam Mahendra Vyankatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10470",
    "name": "Kadam Malan Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3922",
    "name": "Kadam Mugatrao Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8082",
    "name": "Kadam Namdeo Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2710",
    "name": "Kadam Narayan Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21319",
    "name": "Kadam Pradeep Mukund"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8014",
    "name": "Kadam Pralhad Shivaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15154",
    "name": "Kadam Rajendra Shatrughan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2939",
    "name": "Kadam Ramesh Manshing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16065",
    "name": "Kadam Rangrao Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22958",
    "name": "Kadam Sachin Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9398",
    "name": "Kadam Sanjay Tatyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6872",
    "name": "Kadam Shankar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15165",
    "name": "Kadam Shivaji Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7123",
    "name": "Kadam Sonabai Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12199",
    "name": "Kadam Sulabha Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8665",
    "name": "Kadam Suresh Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18913",
    "name": "Kadam Tukaram Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18688",
    "name": "Kadam Ujwala Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10982",
    "name": "Kadam Vandana Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16089",
    "name": "Kadambande Pushpa Tanajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13976",
    "name": "Kahane Savita Suraykant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9122",
    "name": "Kakade Harischandra Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11883",
    "name": "Kakade Sambhaji Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17836",
    "name": "Kalambekar Sandeep Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10740",
    "name": "Kale Kondaji Dagdu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14348",
    "name": "Kale Shaligram Dhonduji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12875",
    "name": "Kale Sunita Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9991",
    "name": "Kale Vikram Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16836",
    "name": "Kalekar Krushnakant Bhagwat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17934",
    "name": "Kalekar Vasant Tuljaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17334",
    "name": "Kalugade Balu Shankar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9614",
    "name": "Kalyankar Pravin Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8682",
    "name": "Kamadar Nikunj Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17787",
    "name": "Kambale  Ankita Pandit"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10401",
    "name": "Kambali Ajit Shridhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17433",
    "name": "Kamble Namdeo Karppa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "586",
    "name": "Kanase Marutrao Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6725",
    "name": "Kandalkar Jagdish Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21332",
    "name": "Kandu Jayram Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15485",
    "name": "Kannyakubja Vaishya Halwai Samajbambai["
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17382",
    "name": "Kansara Daksha Deepak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "64",
    "name": "Kanse Sampat Balwantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16996",
    "name": "Karande Mahadeo Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11327",
    "name": "Karane Sharad Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16357",
    "name": "Karanjwade Tukaram Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15732",
    "name": "Karbhal Tanaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8970",
    "name": "Karekar Chandrashekhar Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8936",
    "name": "Karekar Sanjay Shamrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1330",
    "name": "Karmokar Narayan Ramratna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2323",
    "name": "Karpe Ashok Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13601",
    "name": "Karpe Dilip Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10527",
    "name": "Karpe Kashiram Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5109",
    "name": "Kashid Jagannath Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4614",
    "name": "Kate Goraknath L"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17472",
    "name": "Kate Kiran Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19707",
    "name": "Katekar Mahadev Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13638",
    "name": "Katekar Nana Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9862",
    "name": "Katekar Pandurang Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13641",
    "name": "Katekar Shamrao Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11795",
    "name": "Katkade Rohini Manik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11268",
    "name": "Katkar Prakash Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13336",
    "name": "Katkar Shivaji Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16338",
    "name": "Kedare Madhukar K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11143",
    "name": "Kedari Dinkar Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8404",
    "name": "Keer Prakash Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10201",
    "name": "Kenjale Dattatray Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16604",
    "name": "Kerkar Babajee Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9885",
    "name": "Kewadkar Anant Shripat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14030",
    "name": "Khade Arun Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14513",
    "name": "Khade Vandana Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18631",
    "name": "Khalchandani Prakash H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12177",
    "name": "Khale Sakharam Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9723",
    "name": "Khalekar Krishnat Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10542",
    "name": "Khamkar Savitri Tanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12029",
    "name": "Khamkar Vishvesh Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21293",
    "name": "Khan Arif A."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21457",
    "name": "Khan Shahid Jalaluddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8712",
    "name": "Khandelwal Rajesh Giriraj Prasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18125",
    "name": "Khanderkar Anjali Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17596",
    "name": "Khanekar Dashrath Kaluram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9419",
    "name": "Khanvilkar Anil Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16314",
    "name": "Khape Popat Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15979",
    "name": "Kharade Kisan Antu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8984",
    "name": "Kharade Ratnakar Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2517",
    "name": "Kharmate Dadasaheb Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12829",
    "name": "Khedekar Indrayani Vidyadhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16325",
    "name": "Khedekar Raje G"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "621",
    "name": "Khetmar Baburao Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12919",
    "name": "Khond Narendra Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7573",
    "name": "Khopade Balu Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9706",
    "name": "Khopade Balu Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12189",
    "name": "Khopde Babanrao Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16301",
    "name": "Khot Ashok Hindurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5186",
    "name": "Khot Bhanumati Harichandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16299",
    "name": "Khot Prakash Hindurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16300",
    "name": "Khot Shamrao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11824",
    "name": "Khot Shankar Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16234",
    "name": "Kinjale Datta Janu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14087",
    "name": "Kobnak Namdeo Ramji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21234",
    "name": "Kochak Shabbir Ahmed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1606",
    "name": "Kokane Bhikaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4935",
    "name": "Kolage Vinta Bhalchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14426",
    "name": "Kolekar Balasaheb Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13351",
    "name": "Kolekar Dadu Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5847",
    "name": "Kolekar Ganpat Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18547",
    "name": "Kolekar Jagnnath Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18354",
    "name": "Koli Urmila Vasudeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12164",
    "name": "Kolkate Shaherbanu Phajloot Rehman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12461",
    "name": "Kolte Devu Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13447",
    "name": "Kolte Pravin Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21459",
    "name": "Kori Satishkumar Phoolchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1464",
    "name": "Kotkar Baban Baiu."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17901",
    "name": "Koyande Umaji Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8329",
    "name": "Kshirsagar Sanjay Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8055",
    "name": "Kudale Kishor Yadavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7683",
    "name": "Kudatarkar Hari Vishvanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19570",
    "name": "Kumawat Heeralal Girdharilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14275",
    "name": "Kumbhar Dattatray Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2146",
    "name": "Kumbhar Pushpawati Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12636",
    "name": "Kumbhar Saraswati Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4590",
    "name": "Kumbhar Shobha Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12720",
    "name": "Lad Rajendra Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10743",
    "name": "Lakade Vasant Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11875",
    "name": "Lakhan Kisan Bhiwa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17663",
    "name": "Lakhotia Sushil Brijmohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10029",
    "name": "Lawand Rekha Ramakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5481",
    "name": "Lawand Sopan Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18146",
    "name": "Lembhe Vijay Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4698",
    "name": "Lembhe Vilas Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12265",
    "name": "Limbasiya Achut Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8893",
    "name": "Lodha Chandrakant Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10737",
    "name": "Lokade Ramku Potanna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13113",
    "name": "Lokegaonkar Sudhanand Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3305",
    "name": "Lokhande Baban Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17753",
    "name": "Lotlikar Chaitali Raya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2715",
    "name": "M D Patil & Co."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12385",
    "name": "Mahadeshwar Balkrishna Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13150",
    "name": "Mahadeshwar Dinkar Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12009",
    "name": "Mahadik Anil Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12576",
    "name": "Mahadik Chandrakant Kanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14794",
    "name": "Mahadik Suryakant Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14314",
    "name": "Mahangade Keshav Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3555",
    "name": "Mahangade Vijay Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12203",
    "name": "Mahimkar Nishad Jagdish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13908",
    "name": "Mahindarkar Laxmi Nakul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11618",
    "name": "Maladkar Arun Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13257",
    "name": "Malar Ramchandra Ramnal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14868",
    "name": "Malchandaka Madanlal Dhanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13408",
    "name": "Malekar Sachin Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16131",
    "name": "Malhar Kavita Atul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16086",
    "name": "Maloo Ratan Devi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3737",
    "name": "Malusare Ananda Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10559",
    "name": "Malusure Vimal Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10168",
    "name": "Mandave Hanuman Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12188",
    "name": "Mandavkar Shantaram Kashiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17559",
    "name": "Mandhare Baburao Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14124",
    "name": "Mandhare Dnyandeo Sopan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3373",
    "name": "Mandhare Doulu Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "657",
    "name": "Mandhare Kondiba Balaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2047",
    "name": "Mandhare Mugatrao Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11561",
    "name": "Mandhare Sambhaji Jijaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1382",
    "name": "Mandhare Sampat Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15953",
    "name": "Mandhare Satyam Suryakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17512",
    "name": "Mandhare Savita Machindranath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8173",
    "name": "Mandhare Shakuntala Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8121",
    "name": "Mandhare Shrirang Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18703",
    "name": "Mandhare Vijaya Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9624",
    "name": "Mane  Aruna Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13228",
    "name": "Mane Abhishekh Babaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10032",
    "name": "Mane Bhagwan Megha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15744",
    "name": "Mane Ganpat Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5671",
    "name": "Mane Kirtiwan Babasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11920",
    "name": "Mane Madhuri Devram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6290",
    "name": "Mane Maruti Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "522",
    "name": "Mane Pandurang Antu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19377",
    "name": "Mane Ranjit Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17618",
    "name": "Mane Sanjay Kundalik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13283",
    "name": "Mane Shankar Tatya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3121",
    "name": "Mane Shivaji Nathu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15521",
    "name": "Mane Sulabai Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8239",
    "name": "Mane Vishnu Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12004",
    "name": "Manjarekar Vinaya Dattatram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12885",
    "name": "Mansuri Irdu Nabu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2940",
    "name": "Manuskare Rajaram Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18134",
    "name": "Mardhekar Bhiku Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13720",
    "name": "Mardhekar Prakash Raghu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15006",
    "name": "Martins Raj Alba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15850",
    "name": "Masheuddin Nisar Ahmed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16475",
    "name": "Maskar Sanjay Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6856",
    "name": "Maskar Yeshwant Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23761",
    "name": "Master Jayasingh Ramasingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13111",
    "name": "Masurkar Pravin Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17452",
    "name": "Matkar Chandrabhaga Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17242",
    "name": "Matkar Kusum Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4001",
    "name": "Matre Shankar Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13833",
    "name": "Matre Subhash Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21322",
    "name": "Maurya Vijaykumar Kanhaiyalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8515",
    "name": "Mayekar Prabhakar Raghoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5951",
    "name": "Mehta Ambashankar L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17684",
    "name": "Mehta Shreepal B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8770",
    "name": "Merchant Shailesh S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5233",
    "name": "Meshram Rajesh Bishram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10744",
    "name": "Mestry Anant Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9757",
    "name": "Mestry Vinayak Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4725",
    "name": "Metal Bazar Kamgar Sangha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18499",
    "name": "Mhamunkar Subhash Anand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2761",
    "name": "Mhangade Pralhad Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "105",
    "name": "Mhaskar Vasant Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12748",
    "name": "Mhatre Gajendra Hiru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9478",
    "name": "Mhatre Shankar Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7822",
    "name": "Mishra H. A."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3548",
    "name": "Mishra Juganu Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10237",
    "name": "Mishra Matafer Ramdular"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1357",
    "name": "Modak Baburao D.705/10"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17420",
    "name": "Modak Laxman Sidu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3092",
    "name": "Modak Shitaram Bhiva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8390",
    "name": "Modak Sitaram Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9537",
    "name": "Modakle Dilip Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12138",
    "name": "Modhave Dattatray Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18476",
    "name": "Mohane Shamrao Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21341",
    "name": "Mohd Hasan Mohd Hanif"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12705",
    "name": "Mohite Anandrao Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8241",
    "name": "Mohite Kashinath Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5331",
    "name": "Mohite Manmohan Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4945",
    "name": "Mohite Mohan Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16829",
    "name": "Mohite Savita Dnyaneshwar"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3838",
    "name": "Dhumal Ramesh T"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6814",
    "name": "Mohite Shivaji Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6289",
    "name": "Mojar Baban Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17578",
    "name": "Mojar Vitthal Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1179",
    "name": "Mojar Yashwant Santu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10803",
    "name": "Mokashi Ganpat Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12209",
    "name": "Molake Narayan Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8063",
    "name": "Monde Rajaram Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4726",
    "name": "More Ananda Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9312",
    "name": "More Ashok Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "92",
    "name": "More Balwant Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12230",
    "name": "More Bharat Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6797",
    "name": "More Bharatkumar Bhauso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11840",
    "name": "More Bhimrao Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7725",
    "name": "More Chandrakant Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12661",
    "name": "More Dagadu Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14565",
    "name": "More Dattu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17964",
    "name": "More Dilip Ankush Toli-1463/2"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10536",
    "name": "More Dilip Vamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "306",
    "name": "More Ganpati Parbati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15552",
    "name": "More Gorakhnath Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4858",
    "name": "More Laxman Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16282",
    "name": "More Laxmi Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17647",
    "name": "More Namdeo Parabati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9531",
    "name": "More Narayan Ninu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7787",
    "name": "More Sakharam Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9639",
    "name": "More Shivram Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13882",
    "name": "More Surekha Adhik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13539",
    "name": "More Suryakant Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2292",
    "name": "More Tanaji Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17460",
    "name": "More Vitthal Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23117",
    "name": "Motivaras Hansa Dhansukh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10504",
    "name": "Mucchala Reshma Chandulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18215",
    "name": "Mulani Najma Eqbaleqbal Hajrat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13491",
    "name": "Mulani Papamiya Babulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1800",
    "name": "Mulik Anandrao Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17521",
    "name": "Mulik Balu Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16006",
    "name": "Mulik Bhanudas Baliram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16566",
    "name": "Mulik Dattatray Kisanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12952",
    "name": "Mulik Dattatray Kisanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "285",
    "name": "Mulik Laxman Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10272",
    "name": "Mulik Mahadeo Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17204",
    "name": "Mulik Sambhaji Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7768",
    "name": "Mulik Tanaji Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15473",
    "name": "Mutake Jijaba Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21200",
    "name": "Nachre Ganesh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8322",
    "name": "Nadkarni Arvind Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16665",
    "name": "Nagap Mohan Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11589",
    "name": "Nagavekar Sangeeta Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3005",
    "name": "Nagwekar Asha Amrut"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8452",
    "name": "Nagwekar Sandhya Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9472",
    "name": "Naik Dilip Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20714",
    "name": "Naik Nagraj Nagappa."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9473",
    "name": "Naik Sunil Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2839",
    "name": "Nalage Mohan Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3291",
    "name": "Nalage Namdev Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "48",
    "name": "Nalawade  Nanasaheb Dinkarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16317",
    "name": "Nalawade Balu Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "259",
    "name": "Nalawade Bapurao Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12978",
    "name": "Nalawade Dhanaji Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16513",
    "name": "Nalawade Dilip Dayaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1039",
    "name": "Nalawade Janardhan Hariba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13334",
    "name": "Nalawade Khanderao Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2687",
    "name": "Nalawade Maruti Malhari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7624",
    "name": "Nalawade Ramdas Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17870",
    "name": "Nalawade Sachin Hiralal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2428",
    "name": "Nanavare Hanmant Bhiva"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8305",
    "name": "Nandgaonkar Mahesh Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16994",
    "name": "Naringrekar Pushpawati Vishwambhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12532",
    "name": "Natekar Shubhangi Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18784",
    "name": "Navadkar Shashikant Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11596",
    "name": "Navrat Rajesh Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6049",
    "name": "Nawadkar Suman Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10043",
    "name": "Nayakwadi Pradip Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17765",
    "name": "Naylipalli Yatirajam Bhimya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21222",
    "name": "Nerurkar Balkrishna Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16506",
    "name": "Newage Yashwant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10713",
    "name": "Nigade Gajanan Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18468",
    "name": "Nigadekar Baburao Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12266",
    "name": "Nikalje Manda D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4504",
    "name": "Nikam Chandrakant Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13811",
    "name": "Nikam Chandrakant Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5075",
    "name": "Nikam Daulat Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3968",
    "name": "Nikam Dilip Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17488",
    "name": "Nikam Janardhan D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9128",
    "name": "Nikam Laxman Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15850",
    "name": "Nikam Nita Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1965",
    "name": "Nikam Sadashiv Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8693",
    "name": "Nikam Sahadeo Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7900",
    "name": "Nikam Shirish Janardan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13211",
    "name": "Nikam Shrirang Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16725",
    "name": "Nikam Sukhdeo Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17922",
    "name": "Nimbalkar Bhushan Hanumantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1177",
    "name": "Ninbalakar Anandrao Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13459",
    "name": "Ninkar Dnyandeo Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11808",
    "name": "Ozarkar Shankar Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10027",
    "name": "Pa0Ar Shivaji Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15924",
    "name": "Pacharane Sushila Dnyaneshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18954",
    "name": "Pacharne Arun Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14365",
    "name": "Pachpute Nayana Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16226",
    "name": "Padwal Dilip Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14017",
    "name": "Pagade Hari Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9426",
    "name": "Pai Ramesh Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14375",
    "name": "Palande Sumati Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16091",
    "name": "Palande Surekha Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12407",
    "name": "Palkar Shatrugnha Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5801",
    "name": "Palkar Vaijayanti Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1949",
    "name": "Pallor Motilal Hiralal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18035",
    "name": "Panaskar Duryodhan Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4765",
    "name": "Panchal Bholanath Das"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17530",
    "name": "Pandeerkar Keru Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14041",
    "name": "Pandule Sanjay Baban 889/13"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17099",
    "name": "Panmand Dattatray Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "537",
    "name": "Panskar Ashok Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9051",
    "name": "Panwal Sambhaji Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13092",
    "name": "Panwar Jaswant Singh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7233",
    "name": "Parab Anant Ramchandra"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "354",
    "name": "Diamond Electronics"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9279",
    "name": "Parab Ashok Jayasingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16364",
    "name": "Parab Girish Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3931",
    "name": "Parab Parshuram Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11302",
    "name": "Parab Pramod Babi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11518",
    "name": "Parab Shankar Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11471",
    "name": "Parakhe Dinesh Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11624",
    "name": "Parawe Jagan Parashuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17837",
    "name": "Parekh Hemanshu Jawaharlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10070",
    "name": "Parihar Narayan Singh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8096",
    "name": "Parmar Dhanraj G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17156",
    "name": "Parmar Narendrabhai Keshavlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12736",
    "name": "Parmar Parasmal Premchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1326",
    "name": "Parte Vithal Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "86",
    "name": "Patankar Yashwant Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21321",
    "name": "Patel Amiruddin Nasiruddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12629",
    "name": "Patel Divali Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11303",
    "name": "Patel Jagdish Ladhabhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15179",
    "name": "Patel Munna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13924",
    "name": "Pathan Abdul Aziz Baitulla"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21456",
    "name": "Pathan Kamran Zubeir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18709",
    "name": "Pathare Datta Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13634",
    "name": "Patil Ananda Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3150",
    "name": "Patil Anandrao Chandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8953",
    "name": "Patil Appa Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7376",
    "name": "Patil Ashok Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4914",
    "name": "Patil Baburao Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13097",
    "name": "Patil Baby Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13598",
    "name": "Patil Dadu Mahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11992",
    "name": "Patil Deepak Shankar 270/B/17"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "847",
    "name": "Patil Dnyanu Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2775",
    "name": "Patil Hareshwar Kashinath."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12654",
    "name": "Patil Kondiram Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14434",
    "name": "Patil Krishna Sanga"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16781",
    "name": "Patil Lata Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3283",
    "name": "Patil Laxman Ramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7937",
    "name": "Patil Mahadeo Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4092",
    "name": "Patil Maruti Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4556",
    "name": "Patil Nathuram Pandurang"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "148",
    "name": "Dipesh Enterprises ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14073",
    "name": "Patil Pandurang Shivaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15992",
    "name": "Patil Prakash Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13900",
    "name": "Patil Seema Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14367",
    "name": "Patil Shashikant Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16899",
    "name": "Patil Shivaji Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18521",
    "name": "Patil Suresh Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8205",
    "name": "Patil Vasant Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10220",
    "name": "Patil Vitthal Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16572",
    "name": "Patkar Nathuram Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13495",
    "name": "Patkar Ujwala Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "323",
    "name": "Patole Gunaji Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15471",
    "name": "Patole Prakash Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17663",
    "name": "Pauda Kunjbihari K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16218",
    "name": "Pawar Abising Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16517",
    "name": "Pawar Ananda D-4005"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17432",
    "name": "Pawar Anant Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13390",
    "name": "Pawar Archana Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16643",
    "name": "Pawar Bajrang Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5986",
    "name": "Pawar Balkrishna Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10076",
    "name": "Pawar Balkrishna Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10295",
    "name": "Pawar Balwant Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "650",
    "name": "Pawar Bhiku Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17609",
    "name": "Pawar Buwaji Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13767",
    "name": "Pawar Chandrakant Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7962",
    "name": "Pawar Dattaram Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17367",
    "name": "Pawar Dilip Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2619",
    "name": "Pawar Dnyandeo Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17357",
    "name": "Pawar Hanmant Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5487",
    "name": "Pawar Hanmant Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16954",
    "name": "Pawar Hanmant Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4618",
    "name": "Pawar Kishan Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2973",
    "name": "Pawar Lalsing Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18717",
    "name": "Pawar Lata Suraykant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17124",
    "name": "Pawar Laxman Gunda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14504",
    "name": "Pawar Mahendra Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13745",
    "name": "Pawar Maruti Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8973",
    "name": "Pawar Mina Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7372",
    "name": "Pawar Nandkumar Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1483",
    "name": "Pawar Narayan Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13966",
    "name": "Pawar Narayan Mugutrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12228",
    "name": "Pawar Nirmala Dnyaneshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11612",
    "name": "Pawar Nivruti Kondaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15999",
    "name": "Pawar Prakash Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6250",
    "name": "Pawar Rajaram Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14831",
    "name": "Pawar Rajendra Kundalik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7862",
    "name": "Pawar Rajshekhar Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6632",
    "name": "Pawar Ramdas Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9750",
    "name": "Pawar Sahebrao Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16500",
    "name": "Pawar Sangeeta Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18170",
    "name": "Pawar Sangita Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19753",
    "name": "Pawar Santosh Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "947",
    "name": "Pawar Shamrao Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3871",
    "name": "Pawar Shankarrao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3424",
    "name": "Pawar Shivaji Govindrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9230",
    "name": "Pawar Shrirang Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5461",
    "name": "Pawar Sitaram Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14545",
    "name": "Pawar Sudha Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17528",
    "name": "Pawar Suresh Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16937",
    "name": "Pawar Suresh Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16845",
    "name": "Pawar Tanaji Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18819",
    "name": "Pawar Tukaram Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17541",
    "name": "Pawar Tukaram Rahu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17347",
    "name": "Pawar Vilas Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7435",
    "name": "Pawar Vithal Rambhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3204",
    "name": "Pawaskar Baban Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11715",
    "name": "Pedanekar Hemant Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13701",
    "name": "Pednekar Manik Ganesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17142",
    "name": "Pednekar Manohar Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9383",
    "name": "Pednekar Ulhas Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17325",
    "name": "Pereira  Belinda"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4650",
    "name": "Divya Darshak Consultancy"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17390",
    "name": "Pereira  Selvino"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21455",
    "name": "Peshimam Nazim Nasir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16588",
    "name": "Pethe Ravindra Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16047",
    "name": "Phadkar Dagadu Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7305",
    "name": "Phadtare Anant Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14256",
    "name": "Phadtare Balasaheb Parbati."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3579",
    "name": "Phadtare Ganesh Nathuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9257",
    "name": "Phadtare Shivaji Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5264",
    "name": "Phadtare Vishwanath J."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12676",
    "name": "Phalake Balu Shanakr"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7521",
    "name": "Phalake Khandu Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9912",
    "name": "Phalake Sharada Diliparao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3529",
    "name": "Phalake Vijay Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17595",
    "name": "Phalke Pradeep Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6294",
    "name": "Phalke Pratap Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "719",
    "name": "Phalke Sahadu Jijaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "378",
    "name": "Phanasgaonkar Vinaya Vidhyadhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10626",
    "name": "Phanse Jayashri Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6669",
    "name": "Phatak Baburao Lumaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9541",
    "name": "Pingale Eknath Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12387",
    "name": "Pingale V T"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4224",
    "name": "Pisal Bahira Rangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12199",
    "name": "Pisal Balawant Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5199",
    "name": "Pisal Balkrishna Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17733",
    "name": "Pisal Dipak Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5376",
    "name": "Pisal Gopal Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1423",
    "name": "Pisal Haribhau Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2942",
    "name": "Pisal Rohidas Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2747",
    "name": "Pisal Sadashiv Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12619",
    "name": "Pisal Sanjay Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "413",
    "name": "Pisal Shankar Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20246",
    "name": "Pisal Sunil Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1674",
    "name": "Pisal Tukaram Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2286",
    "name": "Pisal Uttam Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "87",
    "name": "Pisal Vasant Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9026",
    "name": "Pise Dnyandeo Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10338",
    "name": "Pise Sadashiv Joti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11104",
    "name": "Poipkar Prakash Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2507",
    "name": "Pol Mahadeo Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11123",
    "name": "Poojari Chhaya Kamlakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16049",
    "name": "Pophale Sadhana Shashikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18731",
    "name": "Powar Jyotsna Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16366",
    "name": "Pujari Avinash Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18275",
    "name": "Pujari Basavraj Ningappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18207",
    "name": "Pujari Mahesh Madappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11836",
    "name": "Pujari Sadanand Kantappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17722",
    "name": "Pujari Suresh Sunder"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18274",
    "name": "Pujari Vitthal Birappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9314",
    "name": "Puranik Pramod Chandrashekhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5898",
    "name": "Purohit Babulal Dhanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16783",
    "name": "Pursnani Tejumal Hemantkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16083",
    "name": "Qazi Mohammed Azeemuddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16084",
    "name": "Qazi Rashidabano Iqbal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4444",
    "name": "Raikar Laxmibai Vyankatesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19557",
    "name": "Raja Aakanksha Surendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4002",
    "name": "Raje Chandrakant Rau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12119",
    "name": "Raje Maruti Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18604",
    "name": "Rajpure Rajendra Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12854",
    "name": "Rakshe Hanmant Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13307",
    "name": "Rakte Mahadeo Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14976",
    "name": "Rambhiya Sandeep Laxmichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18288",
    "name": "Rana Himanshu (Hemant) Deepak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12340",
    "name": "Rane Vishwanath Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10402",
    "name": "Ranga  Rangswami"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10451",
    "name": "Ranware Krishna Vithalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15418",
    "name": "Rao Diwankumar Babusingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6286",
    "name": "Rao Krishna V"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10518",
    "name": "Rasal Ganpat Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10546",
    "name": "Ratate Dattatray Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5833",
    "name": "Rathod Mavji Mangal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16951",
    "name": "Raut Sandeep Devaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9875",
    "name": "Raut Sangita Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18429",
    "name": "Rayatta Dinesh P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18430",
    "name": "Rayattha Hansaben P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11750",
    "name": "Raymangya Ashok Motiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14272",
    "name": "Redij Bhalchandra Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10719",
    "name": "Redkar Sangita Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7770",
    "name": "Rodrigues  Joaguim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17171",
    "name": "Rodrigues Humberto A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17870",
    "name": "Rokade Ashok Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19891",
    "name": "Roy Ramkumar Ramnaresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17168",
    "name": "Sabale Ashok Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13562",
    "name": "Sabale Dattatry Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10148",
    "name": "Sabale Vinayak Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21231",
    "name": "Saeed Mohd Saleem Mohd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5016",
    "name": "Sahebakha  Isuphakha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2734",
    "name": "Said Dnyandev Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10659",
    "name": "Sakate Ashok Dnyndev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15381",
    "name": "Saket Kausalyabai Mathuradas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8482",
    "name": "Sakpal Dilip Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12068",
    "name": "Sakre Sanjay Anad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13772",
    "name": "Sakunde Arjun Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11778",
    "name": "Sakunde Maruti Pandharinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "188",
    "name": "Sakunde Pandurang Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14874",
    "name": "Sakunde Sangeeta Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8681",
    "name": "Sakunde Shankar Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8691",
    "name": "Sakunde Shivaji Pandharinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16189",
    "name": "Sakunde Yuvraj Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10887",
    "name": "Salate Ananda Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11103",
    "name": "Salate Sakharam Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5024",
    "name": "Salate Tukaram Bhairu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16553",
    "name": "Sale Bharat Dagdu ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17762",
    "name": "Salekar Chandrashekar Tukaram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4265",
    "name": "Dream Finance"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13728",
    "name": "Salekar Vishwas Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7935",
    "name": "Salte Baburao Chandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20820",
    "name": "Salunk He Shashikant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17643",
    "name": "Salunkhe Arun Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12593",
    "name": "Salunkhe Arun Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17114",
    "name": "Salunkhe Baburao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17953",
    "name": "Salunkhe Ganpat Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14282",
    "name": "Salunkhe Jyotiram Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18506",
    "name": "Salunkhe Kamal Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17485",
    "name": "Salunkhe Nandadeep Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5573",
    "name": "Salunkhe Narhari Nilu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11982",
    "name": "Salunkhe Neelam Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7548",
    "name": "Salunkhe Ramchandra Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16674",
    "name": "Salunkhe Ramdas A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12023",
    "name": "Salunkhe Satish Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10899",
    "name": "Salunkhe Shahaji Haibatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18255",
    "name": "Salunkhe Shankar Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12007",
    "name": "Salunkhe Tanaji Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14237",
    "name": "Salunkhe Trimbak Dashrath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11984",
    "name": "Salunkhe Trupti Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14592",
    "name": "Salunkhe Vilas Daji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19637",
    "name": "Salunkhe Yogesh Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9307",
    "name": "Salvi Sachidanand B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8988",
    "name": "Salvi Sanjay Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12311",
    "name": "Salvi Sulochana Jagan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "523",
    "name": "Samgir Nivrutti Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13278",
    "name": "Sanas Pandurang Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1570",
    "name": "Sandav Laxman Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8627",
    "name": "Sane Vilas S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9242",
    "name": "Sankpal Anandrao Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22497",
    "name": "Sankpal Ravindra Shrikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9480",
    "name": "Sankpal Sahebrao Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9267",
    "name": "Sankpal Savita Hindurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14419",
    "name": "Sankpal Shivaji Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13323",
    "name": "Sankpal Vilas Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15570",
    "name": "Sannakke Meera Ranoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21733",
    "name": "Sapkal Anand Rago"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9672",
    "name": "Sapkal Hausabai Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11828",
    "name": "Sapkal Pradnya Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9941",
    "name": "Sapkal Ramchandra Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16055",
    "name": "Sapkal Vilas Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8175",
    "name": "Sarambale Tukaram Bhairu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2158",
    "name": "Sarang Dattaram Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11989",
    "name": "Sawant  Shubhgi Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11742",
    "name": "Sawant Ajit Namdao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12995",
    "name": "Sawant Bhima Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7851",
    "name": "Sawant Charusheela Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12740",
    "name": "Sawant Dhondibai Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11535",
    "name": "Sawant Gopinath Krishnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19491",
    "name": "Sawant Jaikisan Vasudeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10403",
    "name": "Sawant Kisan Shyamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13422",
    "name": "Sawant Lalsing Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14030",
    "name": "Sawant Machindra Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7602",
    "name": "Sawant Raghunath Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8133",
    "name": "Sawant Ramchandra Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10657",
    "name": "Sawant Ramkrishna Shanakr"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13277",
    "name": "Sawant Ravindranath Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17188",
    "name": "Sawant Sandeep Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16191",
    "name": "Sawant Sanjay Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1330",
    "name": "Sawant Shantabai Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13428",
    "name": "Sawant Shivram Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "783",
    "name": "Sawant Tanaji Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5369",
    "name": "Sawant Vaishali Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4090",
    "name": "Sawant Vasantrao Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12013",
    "name": "Sawant Vijay Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14689",
    "name": "Sawant Vishwas Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12423",
    "name": "Shah Champaklal Amrutlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10050",
    "name": "Shah Kamini Kiran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12419",
    "name": "Shah Krishnakant K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7855",
    "name": "Shah Manish Narendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12656",
    "name": "Shah Mayur Nagindas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21229",
    "name": "Shah Pradeep Mohanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17411",
    "name": "Shah Rohita R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21309",
    "name": "Shaikh Abdul Moin Abdul Qadar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15141",
    "name": "Shaikh Abdul Raheman Mehaboob"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21280",
    "name": "Shaikh Akbar Nasir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21311",
    "name": "Shaikh Alam Khurshid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19271",
    "name": "Shaikh Anis Ismile"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21278",
    "name": "Shaikh Asfaz Lalmohmmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21275",
    "name": "Shaikh Bashir Naushad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21232",
    "name": "Shaikh Faiyaz Ahmed Rehmatali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20176",
    "name": "Shaikh Gulam Mahamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21344",
    "name": "Shaikh Husain Aliahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21204",
    "name": "Shaikh Kalu Amin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2247",
    "name": "Shaikh Maulana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21308",
    "name": "Shaikh Md Rafiq Tinnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21343",
    "name": "Shaikh Mehdihasan Mohar Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21345",
    "name": "Shaikh Mohd Yakub Musafirali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21458",
    "name": "Shaikh Naseermiya Abbasmiya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21279",
    "name": "Shaikh Neelofar Hafis"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21233",
    "name": "Shaikh Rafique Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "338",
    "name": "Shaikh Shafuddin Amariuddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21277",
    "name": "Shaikh Shamem Waseem"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10767",
    "name": "Sharma Hitesh Meghraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5855",
    "name": "Sharma Radheshyam Hiralal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11498",
    "name": "Sharma Ramavtar Phanjdar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7321",
    "name": "Sharma Ramesh Vaidyanarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17178",
    "name": "Shedge Dagadu Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12093",
    "name": "Shedge Jagdish Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17268",
    "name": "Shedge Kisan Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17513",
    "name": "Shedge Rajesh Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12889",
    "name": "Shedge Suchita Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4676",
    "name": "Shegar Bhagchand Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18395",
    "name": "Shejwal Pravin Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "89",
    "name": "Shelar Anandrao Balwantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17280",
    "name": "Shelar Gulab Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14060",
    "name": "Shelar Kisan Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9661",
    "name": "Shelar Kisan Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10289",
    "name": "Shelar Namdeo Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3499",
    "name": "Shelar Nathu Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16778",
    "name": "Shelar Popat Gopinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11087",
    "name": "Shelar Rajaram Navaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17443",
    "name": "Shelar Shivaji Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14301",
    "name": "Shelar Sunita Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12411",
    "name": "Shelatakar Jagannath Rau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12369",
    "name": "Shelke Prakash Kashiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10014",
    "name": "Shenoy Laxman B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10017",
    "name": "Shenoy Premabai L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10015",
    "name": "Shenoy Sadashiv L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10016",
    "name": "Shenoy Vivek L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1802",
    "name": "Sheriwari Gramstha Mandal (Mum"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12868",
    "name": "Sherkar Prafful Bhaurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4540",
    "name": "Shete Vijay Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11218",
    "name": "Sheth Naresh C."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17548",
    "name": "Sheth Rajesh Chhabildas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18013",
    "name": "Shetty Amar K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13462",
    "name": "Shetty Anand Jaya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16388",
    "name": "Shetty Mahesh G"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8890",
    "name": "Shetty Tanuja Vomaya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12411",
    "name": "Shetty Umesh M"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "92",
    "name": "Durga Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12861",
    "name": "Shetty Vomaya Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12003",
    "name": "Shetye Rohidas Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13358",
    "name": "Shevkar Shivaji Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17396",
    "name": "Shewale Tukaram Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15774",
    "name": "Shidruk Sanjay Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21276",
    "name": "Shikh Arif Kadir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13492",
    "name": "Shilimkar Kanta Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14595",
    "name": "Shinde Ajay Nathuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8326",
    "name": "Shinde Appa Kashiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16784",
    "name": "Shinde Asha Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8684",
    "name": "Shinde Ashok Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2650",
    "name": "Shinde Baburao Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17333",
    "name": "Shinde Chandrakant Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15965",
    "name": "Shinde Dattatray Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17022",
    "name": "Shinde Devraj Bhanudas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "295",
    "name": "Shinde Dinkar Raoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "46",
    "name": "Shinde Dnyandeo Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "31",
    "name": "Shinde Gulabrao Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1839",
    "name": "Shinde Gulabrao Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17370",
    "name": "Shinde Hanmant Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12622",
    "name": "Shinde Hanmant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2103",
    "name": "Shinde Hindurao Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15691",
    "name": "Shinde Jaywant Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18683",
    "name": "Shinde Komal Manik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18209",
    "name": "Shinde Krishnakant Vyankatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10546",
    "name": "Shinde Lilabai Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "604",
    "name": "Shinde Machindra Rangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12858",
    "name": "Shinde Manohar D"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13520",
    "name": "Shinde Nandkumar Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12",
    "name": "Shinde Nivrutti Yadavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7763",
    "name": "Shinde Paratap Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18026",
    "name": "Shinde Parvin Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18719",
    "name": "Shinde Pramod Chatrapati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11227",
    "name": "Shinde Prashant Nivrutti"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2660",
    "name": "E Or S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16352",
    "name": "Shinde Praveen N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17968",
    "name": "Shinde Pravin Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14545",
    "name": "Shinde Rahul Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16927",
    "name": "Shinde Rajendra Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8270",
    "name": "Shinde Ramrao Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18525",
    "name": "Shinde Sachin Ashok."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16347",
    "name": "Shinde Sahebrao Marutrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11274",
    "name": "Shinde Sanjay Yeshwantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5236",
    "name": "Shinde Shivaji Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14961",
    "name": "Shinde Shobha Hanumant"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3522",
    "name": "Empire Silk Mills"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10569",
    "name": "Shinde Sopan Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15639",
    "name": "Shinde Sopanrao Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8670",
    "name": "Shinde Subhash Parbatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17814",
    "name": "Shinde Sunil Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17902",
    "name": "Shinde Suryakant Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4809",
    "name": "Shinde Suryakant Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13564",
    "name": "Shinde Sushila D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4977",
    "name": "Shinde Tatyaba Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17021",
    "name": "Shinde Vijay Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4924",
    "name": "Shinde Vilas Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14558",
    "name": "Shinde Vilas Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16900",
    "name": "Shinde Vjaykumar G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2611",
    "name": "Shirgaonkar Jagdish Sudhir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15954",
    "name": "Shirke Chandrakant Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5906",
    "name": "Shirke Popat Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12503",
    "name": "Shitole Manik Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12148",
    "name": "Shivalkar Janardan Ravaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13681",
    "name": "Shivankar Santosh Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15292",
    "name": "Shivgan Ramesh Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11144",
    "name": "Shukla Jagdishprasad Shrikant 1068-3"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21310",
    "name": "Siddiqui Shafi Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21329",
    "name": "Singh Dadan Shivshankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8717",
    "name": "Singh Suryanarayan Rambholas Singh"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "998",
    "name": "Faizabadi Restaurant & Bar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15885",
    "name": "Solanki Ashwin Tulsidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18463",
    "name": "Solanki Shanu Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10504",
    "name": "Solankiraj Jitender Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "626",
    "name": "Solaskar Gulabrao Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3015",
    "name": "Solaskar Laxman Jijyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6387",
    "name": "Solaskar Satish Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21230",
    "name": "Sonar Harishchandra Nanku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14598",
    "name": "Sonawale Tanaji Nivruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10696",
    "name": "Sondulkar Dhondiram Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15891",
    "name": "Sudam Bhuvan Utsav Mandal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13037",
    "name": "Sulke Suresh Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1034",
    "name": "Suresh Dada Gayakwad."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7477",
    "name": "Surve Bapu Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17643",
    "name": "Surve Rajaram Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16321",
    "name": "Surve Sambahji Umakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11974",
    "name": "Surve Vinayak Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18312",
    "name": "Surve Vitthal Antu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14591",
    "name": "Suryawanshi Anandrao Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "768",
    "name": "Suryawanshi Hambirao Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23671",
    "name": "Suryawanshi Harsha Pradeep"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11571",
    "name": "Swali Maytri Dilipsinh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20769",
    "name": "Swamy Lardu Bhivaniraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12874",
    "name": "Taajne Atmaram Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14273",
    "name": "Taakwale Vijay Vithalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15841",
    "name": "Takalkar Dhondibhau Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17267",
    "name": "Tambat Sanjay Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7369",
    "name": "Tambat Sunil Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17878",
    "name": "Tambe Rajan Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7487",
    "name": "Tandel Shankar Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13267",
    "name": "Taneja  Ranbirlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9157",
    "name": "Tanpure Narayan Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12359",
    "name": "Tara Ravindra Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10433",
    "name": "Teli Satish Himmatlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5320",
    "name": "Telwadi Rahiwashi Sahakarya Mandal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13093",
    "name": "Tembkar Dilip Ramkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18579",
    "name": "Temghare Anand Ganapt"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13269",
    "name": "Tewar Turatrajan Karupayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18962",
    "name": "Thakur Hajarichand Harichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11336",
    "name": "Thakur Mohansing Gurubachasing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2334",
    "name": "Thakur Murlidhar Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5756",
    "name": "Thapania Ashok Dhanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14102",
    "name": "Thatikonda Kishan Chinnayya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4547",
    "name": "Therade Budhaji Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6867",
    "name": "Thick Maruti Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16157",
    "name": "Thombre Santosh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9566",
    "name": "Thorat Nanasaheb Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17516",
    "name": "Thorat Nanasaheb Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10305",
    "name": "Thorat Niwas Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10395",
    "name": "Thorat Shamrao Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13333",
    "name": "Thorat Sunanda Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7526",
    "name": "Thore Namdeo Shripat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12660",
    "name": "Tike Phulabai Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14871",
    "name": "Tikudave Tukaram Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16711",
    "name": "Tiwari  Sntosh Madan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14837",
    "name": "Tiwari Anandkumar Ganeshlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10357",
    "name": "Tiwari Sabhamani Gopichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21330",
    "name": "Tiwari Shyam Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21331",
    "name": "Tiwari Vinaykumar Mohanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11547",
    "name": "Toke Jayram Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2682",
    "name": "Toraskar Nanasaheb Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1909",
    "name": "Toraskar Nanosa Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1333",
    "name": "Totre Bharat Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17832",
    "name": "Trivedi Narendrakumar Neelkant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11774",
    "name": "Udaram  Kaluramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7709",
    "name": "Undare Prakash Shripat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17551",
    "name": "Upadhyay Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1184",
    "name": "Vagani Pravina Purshotam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3731",
    "name": "Vaghe Dhondibai Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21333",
    "name": "Vaidya Rajendra Vasudev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10711",
    "name": "Vairag Santosh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17093",
    "name": "Vaishampayan Sharaddha Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17092",
    "name": "Vaishampayan Yeshwant Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11594",
    "name": "Vaishnav Mahendrakumar M."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14741",
    "name": "Vaje Suryakant Babaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15040",
    "name": "Valantra Ratilal Khushal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1576",
    "name": "Vande Jagannath Ganapati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9853",
    "name": "Vanmali Leena Moreshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11065",
    "name": "Varekar Parshuram Tanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12888",
    "name": "Varekar Vaman Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14038",
    "name": "Varma Rameshkumar Ramsakha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13334",
    "name": "Vayal Rajendra Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8324",
    "name": "Ved Sudhir Dilipkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12017",
    "name": "Vedpathak Prakash Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8453",
    "name": "Vichare Kashiram Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11544",
    "name": "Vichare Sanjay Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3850",
    "name": "Vidhate Nathuram Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9892",
    "name": "Virwani Mahesh P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14143",
    "name": "Vishwakarma Prembahadur Manilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7905",
    "name": "Vitmal Laxman Ramu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9224",
    "name": "Wadake Vasudev Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17562",
    "name": "Wadkar Atul Bhalchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9236",
    "name": "Wagh Balaso Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17490",
    "name": "Wagh Dadu Govinda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17226",
    "name": "Wagh Prabhakar Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17533",
    "name": "Wagh Ramesh Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17990",
    "name": "Waghchaure Kalawati Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17160",
    "name": "Waghela Arjun Ramesh."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5673",
    "name": "Waghmare Saraswati O"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13255",
    "name": "Waghmare Suresh Yashawant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12560",
    "name": "Walagade Shankar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9626",
    "name": "Walavalkar Vijay Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16502",
    "name": "Warekar Khashaba Tatoba."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17524",
    "name": "Warudkar Ramesh Khushalrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11379",
    "name": "Wete Suryakant B."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15577",
    "name": "Yadav  Yuvraj Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13122",
    "name": "Yadav Chandrakant Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6922",
    "name": "Yadav Dattatray Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21318",
    "name": "Yadav Devnarayan Ramsamukh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8494",
    "name": "Yadav Hanmant B"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5847",
    "name": "Yadav Kalidas Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21328",
    "name": "Yadav Kartarsing Tapebahadur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10542",
    "name": "Yadav Kisan Balak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5276",
    "name": "Yadav Laxman Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16212",
    "name": "Yadav Mahendra Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4561",
    "name": "Yadav Pandurang Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16349",
    "name": "Yadav Ramesh Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14086",
    "name": "Yadav Ramjanak Ramfer"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12318",
    "name": "Yadav Ramkumar Balikaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16213",
    "name": "Yadav Ravindra Ganpatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14398",
    "name": "Yadav Sandeep Shivajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18351",
    "name": "Yadav Shakuntala Shivkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13120",
    "name": "Yadav Shivsahai R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16171",
    "name": "Yadav Subhash Bachau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17620",
    "name": "Yadav Sunil Mugutrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13998",
    "name": "Yadav Sureman Katesar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17997",
    "name": "Yadav Vaishali Ravindra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9125",
    "name": "Yelave Gangaram Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9926",
    "name": "Yewale Pramod Vinayakrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8527",
    "name": "Yewale Raju Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18137",
    "name": "Yewale Sarjerao Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4888",
    "name": "Yewale Suresh Hanmantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13205",
    "name": "Zagade Jayashri Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16580",
    "name": "Zagade Shrikant Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11878",
    "name": "Zanzane Sheshabai Kalyanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13904",
    "name": "Zinde Subash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1693",
    "name": "Zodage Vitthal Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14716",
    "name": "Davale Shrirang Balaku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12036",
    "name": "Ithape Raghunath Mahadeo"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "158",
    "name": "Gagangiri Engg & Power Projects"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2295",
    "name": "Galaxy Motors"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1154",
    "name": "Ganesh Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12361",
    "name": "Nigawale Yogesh Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8860",
    "name": "Salunkhe Shivaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3801",
    "name": "Magar Dadasaheb Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11628",
    "name": "Patil Hanmant Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2947",
    "name": "Bodake Haribhau Khandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18519",
    "name": "Bhardwaj Bharti Nishant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9867",
    "name": "Aarekar Dattaram Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9553",
    "name": "Abgul Vithal Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4903",
    "name": "Adhav Tukaram Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13553",
    "name": "Agarwal Mukeshchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9813",
    "name": "Agarwal Rajat Jwala Prasadji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "326",
    "name": "Ahirekar Dattatray Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7458",
    "name": "Ahirekar Dilip Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "955",
    "name": "Ahirekar Vishwas Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14543",
    "name": "Ajmera Ramesh Hemraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19007",
    "name": "Ambavale Santosh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5131",
    "name": "Ambawale Jaywant Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11312",
    "name": "Ambawale Laxman Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11225",
    "name": "Ambre Gita Gopichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10999",
    "name": "Ambrulkar Ramchandra Govinda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1547",
    "name": "Amit Trading Co"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2856",
    "name": "Anapat Vithal Appaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11330",
    "name": "Anekar Vijay Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "75",
    "name": "Anpat Sopanrao Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15117",
    "name": "Anpat Vitthal Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7758",
    "name": "Anute Ramchandra Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9319",
    "name": "Arekar Ramesh Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10821",
    "name": "Arumugam  K"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4518",
    "name": "Atugade Babu Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9472",
    "name": "Atugade Sidhanath Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15454",
    "name": "Avadkar Hanmant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3284",
    "name": "Babar Ankush Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15973",
    "name": "Babar Eknath Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10309",
    "name": "Babar Sunanda Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16929",
    "name": "Babar Vikram  Ankush"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1048",
    "name": "Babar Vithal Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7891",
    "name": "Bachulkar Tukaram Daulu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9590",
    "name": "Badiyani Sharad Karasandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5018",
    "name": "Bagayatkar Kamal Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14873",
    "name": "Baikar Sheetal Vishram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8563",
    "name": "Bajpai Dayashankar Shivkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15689",
    "name": "Bandre Pandurang Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11326",
    "name": "Bangera Vasudeo Kitta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13445",
    "name": "Barge Gajanan Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13709",
    "name": "Barge Tukaram Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7826",
    "name": "Baswankar Kisan Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10660",
    "name": "Bavdekar Khashibai Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5415",
    "name": "Bawle Geetabai Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18043",
    "name": "Belkar Maruti Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4568",
    "name": "Bendal Dnyandev Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15033",
    "name": "Bhagat Bharat Bhalchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17374",
    "name": "Bhagne Mahadu Sonu ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4295",
    "name": "Bhagwat Mohan Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17438",
    "name": "Bhagwat Vilas Savlaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13050",
    "name": "Bhais Sahebrao Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5954",
    "name": "Bhalerao Pandurang Shripat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14697",
    "name": "Bhalshankar Navnath Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10709",
    "name": "Bhandari Sangita Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4842",
    "name": "Bhapkar Tanaji Dattatraya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14816",
    "name": "Bharmal Uttam Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3933",
    "name": "Bhatiya Janata Party Ward No 35"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9281",
    "name": "Bhavarlal G Vastimal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "355",
    "name": "Bhilare Baban Nagu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9680",
    "name": "Bhilare Ganpat Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "70",
    "name": "Bhilare Vasant Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7280",
    "name": "Bhilare Vithal Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7141",
    "name": "Bhingardeve Baban Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12980",
    "name": "Bhobate Arjun Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19306",
    "name": "Bhohir  Prakash  Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9461",
    "name": "Bhoite Dattatray Dynanoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "694",
    "name": "Bhoite Govindrao Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "838",
    "name": "Bhoite Hanmant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9107",
    "name": "Bhoite Harish Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "545",
    "name": "Bhoite Jaydevraj Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7959",
    "name": "Bhoite Laxman Narayanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6901",
    "name": "Bhoite Mahadeo Krushnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13525",
    "name": "Bhoite Mangesh Kisanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13231",
    "name": "Bhoite Nitin Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14429",
    "name": "Bhoite Rajendra Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2680",
    "name": "Bhoite Ramchandra Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11389",
    "name": "Bhoite Sarjerao D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18150",
    "name": "Bhoite Subhash Bhagwanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3801",
    "name": "Bhoite Sudam Vithalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2282",
    "name": "Bhoite Vishwas Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16122",
    "name": "Bhor Shahaji Nagesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11136",
    "name": "Bhorate Hanmant Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13465",
    "name": "Bhorde Bhausaheb Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20209",
    "name": "Bhosale Adhik Parmeshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9936",
    "name": "Bhosale Anil Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18277",
    "name": "Bhosale Aniruddha Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7697",
    "name": "Bhosale Baban Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5659",
    "name": "Bhosale Bajirao Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "711",
    "name": "Bhosale Gulabrao Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4372",
    "name": "Bhosale Hirabai Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9081",
    "name": "Bhosale Jaywant Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16155",
    "name": "Bhosale Khanderao Rajaram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9266",
    "name": "Bhosale Mansingh Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10180",
    "name": "Bhosale Narayan Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1920",
    "name": "Bhosale Narayan Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11479",
    "name": "Bhosale Narayan Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4947",
    "name": "Bhosale Sampat Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15917",
    "name": "Bhosale Santosh Pralhad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11085",
    "name": "Bhosale Vitthal Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11341",
    "name": "Bhosle Ramesh Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15434",
    "name": "Bhuj Mangalprasad Ramlutavan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16966",
    "name": "Bhuj Ramprakash Pachuprasad."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15993",
    "name": "Bhute Chandrabhaga Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15212",
    "name": "Bobade Arun Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8025",
    "name": "Bobade Nana Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11627",
    "name": "Bobade Prabhakar Baliram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2635",
    "name": "Bobade Ramchandra Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13648",
    "name": "Bodhe Kumar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4994",
    "name": "Bodhe Prabhakar Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11176",
    "name": "Bolave Yashwant Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1577",
    "name": "Boradi Narayan Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12883",
    "name": "Bore Shankar Tayappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13734",
    "name": "Brid Shridhar Gunaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14894",
    "name": "Chalke Laxman Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9573",
    "name": "Chalke Prakash Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4261",
    "name": "Chandox Makhan Singh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13147",
    "name": "Chatur Nandu Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9967",
    "name": "Chaudhari Aadnyaram Lochai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14757",
    "name": "Chaudhari Gyanmati Radheshyam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6250",
    "name": "Chaudhari Mahadeo Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13308",
    "name": "Chaudhari Ramdulhare A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9053",
    "name": "Chaudhary Tilakram R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12243",
    "name": "Chauhan Bhuleshar S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2915",
    "name": "Chavan Ashok Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6649",
    "name": "Chavan Ashok Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10161",
    "name": "Chavan Bhiku Kondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14693",
    "name": "Chavan Chandrakant Mahadevrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13105",
    "name": "Chavan Dattatray Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6544",
    "name": "Chavan Kisan Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16190",
    "name": "Chavan Kisan Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13400",
    "name": "Chavan Lata Sharadrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1402",
    "name": "Chavan Madhavrao Dinkarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12581",
    "name": "Chavan Pandharinath Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12320",
    "name": "Chavan Ramchandra Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15343",
    "name": "Chavan Ramdas Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7273",
    "name": "Chavan Shantaram Sahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12351",
    "name": "Chavan Shobha Appaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10241",
    "name": "Chavan Tukaram Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6004",
    "name": "Chavan Valmik Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1300",
    "name": "Chavan Vinayak Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13247",
    "name": "Chawan Mahadev Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9431",
    "name": "Chawan Narendra Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2647",
    "name": "Chawan Prakash Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13261",
    "name": "Chawan Sharad Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11988",
    "name": "Chawan Shivaji Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7509",
    "name": "Chawan Suresh Shrirangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15861",
    "name": "Chawan Umakant Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7657",
    "name": "Chawan Vinaykumar Namdevrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10671",
    "name": "Chorage Babaso Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5257",
    "name": "Chorge Khashaba Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6389",
    "name": "Chowdhari Subhashchandra Rajeshwarprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11238",
    "name": "Chunnilalji Prajapati Devaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10614",
    "name": "D Souza  Miechel"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15567",
    "name": "D Souza Aagostion Bernad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6824",
    "name": "Dakave Anusaya Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4627",
    "name": "Dalvi Bhagwan Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9435",
    "name": "Dalvi Shripat Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17224",
    "name": "Dalvi Shubhangi Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8597",
    "name": "Das Uttamkumar Panchanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9322",
    "name": "Deege Hanmant Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19899",
    "name": "Deherkar Satish Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "290",
    "name": "Deogude Baburao Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15306",
    "name": "Deorukhkar Shrikant Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14659",
    "name": "Deshmukh Maruti Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7990",
    "name": "Dete Atmaram Ravji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16305",
    "name": "Dethe Chandrashekhar Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4604",
    "name": "Dhadave Saraswati G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18693",
    "name": "Dhage Sanjay Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12493",
    "name": "Dhainje Shakuntala Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10890",
    "name": "Dhamane Shanta Harishchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6707",
    "name": "Dhanawade Ganpat Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9551",
    "name": "Dhanve Shankar Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15186",
    "name": "Dhargalkar Dnyaneshwar Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13649",
    "name": "Dharod Sunil Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9951",
    "name": "Dhere Ravaji Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13449",
    "name": "Dhindale Subhash Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10114",
    "name": "Dhole Pandurang Dulaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5442",
    "name": "Dhotre Sahebrao Hariba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13801",
    "name": "Dhumal Arvind Gajaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18117",
    "name": "Dhumal Balasaheb Marutrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16027",
    "name": "Dhumal Bhauso Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2945",
    "name": "Dhumal Deepak Parbatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16088",
    "name": "Dhumal Devraj Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14680",
    "name": "Dhumal Dhananjay Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3242",
    "name": "Dhumal Jagannath Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1682",
    "name": "Dhumal Shrirang Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7486",
    "name": "Dhuri Dashrath Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16896",
    "name": "Dhuri Vijaya Vijay."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18042",
    "name": "Dihge Vilas Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11278",
    "name": "Disale Shantaram Shankar  Tn-610-6"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13028",
    "name": "Dixit Kumar Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9831",
    "name": "Doloy Bansibadan Radanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3309",
    "name": "Duduskar Krishna Kanku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4244",
    "name": "Eaditor & Publisher"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14762",
    "name": "Fernandes Caetand D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14679",
    "name": "Fernandes Rufus P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17648",
    "name": "Fonde Sagan Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4719",
    "name": "Gadave Ramesh Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12397",
    "name": "Gadhave Rajendra Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9528",
    "name": "Gadhavi Yashwant Anandbha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10690",
    "name": "Gaikar Arjun Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4547",
    "name": "Gaikawad Dattu Bajrang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9883",
    "name": "Gaikawad Rajendra Hanmantarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12002",
    "name": "Gaikawv Bharat Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13179",
    "name": "Gaikwad Chhaya Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17255",
    "name": "Gaikwad Dnyanoba Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22238",
    "name": "Gaikwad Kalpana Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4951",
    "name": "Gaikwad Laxman Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "799",
    "name": "Gaikwad Maruti Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7549",
    "name": "Gaikwad Navnath Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17510",
    "name": "Gaikwad Nitin Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10255",
    "name": "Gaikwad Padma Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7488",
    "name": "Gala Arjun Karamshi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3681",
    "name": "Gala Sureshkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12345",
    "name": "Ganapuram Jayama Istry"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5592",
    "name": "Gaonuka Ganesh Ragho"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22064",
    "name": "Gathe Suhas Devidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16696",
    "name": "Gauda Khutraj Subhe"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14047",
    "name": "Gautam Saraiprasad Subhavan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14606",
    "name": "Gavandi Supriya Jayprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19411",
    "name": "Gavare Karan Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9008",
    "name": "Gawada Ramu Giri"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9208",
    "name": "Gawade Dagadu Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "469",
    "name": "Gawali Shamu Mahadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5973",
    "name": "Gazdar Pervez N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11281",
    "name": "Geeje Suresh Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15726",
    "name": "Gehlot Shravankumar Bastimal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18570",
    "name": "Ghadage Ankush Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1621",
    "name": "Ghadage Namdev Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8015",
    "name": "Ghadage Suresh Daulat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10067",
    "name": "Ghadage Suresh Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2976",
    "name": "Ghadge Hirabai Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8811",
    "name": "Ghadge Yashwant Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17305",
    "name": "Ghadi Prakash Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13949",
    "name": "Ghanekar Devadas M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5755",
    "name": "Gharage Ashok Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14261",
    "name": "Ghare Ratnakar Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13480",
    "name": "Gholap Hanmant Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5394",
    "name": "Ghorpade Dilip Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12189",
    "name": "Ghorpade Mugatrao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "194",
    "name": "Ghorpade Parshuram Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2651",
    "name": "Ghorpade Shivaji Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14609",
    "name": "Giri Angad Ramadhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13019",
    "name": "Giri Sanjay Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19066",
    "name": "Godase Ramdas Surash."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20074",
    "name": "Gole Dattatrya Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1335",
    "name": "Gosavi Shobha Deo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16960",
    "name": "Gouda Narayan Omya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10769",
    "name": "Goyal Ramlal Ambalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12873",
    "name": "Gujar Pramod Nathuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4097",
    "name": "Gujar Ranjana Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16202",
    "name": "Gunjwate Santosh Nivruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14273",
    "name": "Gupta Shivchander Shivnarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15315",
    "name": "Gupta Vinodkumar Shivcharan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16096",
    "name": "Gurav Krishnat Popatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14757",
    "name": "Gurav Madhukar Shankar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4227",
    "name": "Guthale Mahadeo Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15747",
    "name": "Havale Dinkar Shivram  99/B/32"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9141",
    "name": "Hirgude Shrirang Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13053",
    "name": "Ithape Hanmant Gyanba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6199",
    "name": "Ithape Suresh Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2547",
    "name": "Jaaykar Vithal Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3643",
    "name": "Jadhav Bapurao Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6178",
    "name": "Jadhav Chandrakant Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15551",
    "name": "Jadhav Dilip Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11233",
    "name": "Jadhav Dilip Mukund"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4466",
    "name": "Jadhav Dinkar Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12091",
    "name": "Jadhav Dnyaneshwar Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5378",
    "name": "Jadhav Gorakhnath Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3786",
    "name": "Jadhav Hanmant Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12018",
    "name": "Jadhav Kalyan Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11187",
    "name": "Jadhav Khashaba Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13959",
    "name": "Jadhav Kondiba Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3426",
    "name": "Jadhav Madhavrao Vithalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3443",
    "name": "Jadhav Manshing Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1708",
    "name": "Jadhav Maruti Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2501",
    "name": "Jadhav Narayan Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3228",
    "name": "Jadhav Nivrutti Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6512",
    "name": "Jadhav Prabhakar Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15542",
    "name": "Jadhav Prakash Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2748",
    "name": "Jadhav Ramchandra Ravaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20569",
    "name": "Jadhav Ramesh Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16391",
    "name": "Jadhav Rohidas Laxman."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2825",
    "name": "Jadhav Sadashiv Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2242",
    "name": "Jadhav Sadashiv Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7149",
    "name": "Jadhav Shamrao Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6311",
    "name": "Jadhav Shrimant Nanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8536",
    "name": "Jadhav Vinayak Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8888",
    "name": "Jadhav Yesabai Nathu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15622",
    "name": "Jagannath  Vijaykumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14580",
    "name": "Jagatap Rajendra Hanumanth"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15809",
    "name": "Jagdale Mahadev Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14241",
    "name": "Jagdale Shankar Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1205",
    "name": "Jagtap Abaji Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18181",
    "name": "Jagtap Balasaheb Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10510",
    "name": "Jagtap Balasaheb Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13828",
    "name": "Jagtap Dashrath U. 302/8"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19065",
    "name": "Jagtap Dilip Jagannath."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5971",
    "name": "Jagtap Dilip Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7316",
    "name": "Jagtap Ganpat Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "120",
    "name": "Jagtap Narayan N"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14140",
    "name": "Jagtap Pratap Krishnaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18819",
    "name": "Jagtap Rahul Balkrushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10712",
    "name": "Jagtap Ramchandra Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16770",
    "name": "Jagtap Shivaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18498",
    "name": "Jagtap Vikram Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17241",
    "name": "Jain Amit B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6782",
    "name": "Jain Basant Kumar P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10190",
    "name": "Jain Indrakumari Veerchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10639",
    "name": "Jain Jiviben K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2482",
    "name": "Jain Nayana Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21837",
    "name": "Jain Rajesh Mangilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12376",
    "name": "Jain Ramesh Chaganlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7542",
    "name": "Jain Sureshkumar Shantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12905",
    "name": "Jain Vinodkumar Pyarchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13876",
    "name": "Jaiswal Lalchand Mangare"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16721",
    "name": "Jaiswal Patiram Bhihari."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12478",
    "name": "Jaiswar Rajitram Vishvanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15243",
    "name": "Jaitapkar Devu Atmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11295",
    "name": "Jawade Leelabai Sopan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15290",
    "name": "Jhadav Sagita Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7622",
    "name": "Joshi Zeema Dema"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11178",
    "name": "Kaari Shivaji Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9699",
    "name": "Kadam Ananda Pilaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7425",
    "name": "Kadam Archana Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10197",
    "name": "Kadam Baban Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "80",
    "name": "Kadam Balwant Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7745",
    "name": "Kadam Chandrakant Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7308",
    "name": "Kadam Chhaban Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3293",
    "name": "Kadam Dattu Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8005",
    "name": "Kadam Daulat Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11003",
    "name": "Kadam Dinkar Kundalik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8443",
    "name": "Kadam Dnyandeo Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11143",
    "name": "Kadam Maruti Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11580",
    "name": "Kadam Rajaram Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7541",
    "name": "Kadam Rajaram R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11439",
    "name": "Kadam Ramdas Narhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1803",
    "name": "Kadam Ramu Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9481",
    "name": "Kadam Savaji Devaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13463",
    "name": "Kadam Shalan Mahendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5270",
    "name": "Kadam Shivaji M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9011",
    "name": "Kadam Shrimant Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10295",
    "name": "Kadam Tanaji Jaysingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9091",
    "name": "Kadam Vilas Mansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8491",
    "name": "Kadarkar Prema Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2025",
    "name": "Kadav Balkrishna Dhondi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10920",
    "name": "Kadlag Dhondibhau Kushaba."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11852",
    "name": "Kadlag Suryakant R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11281",
    "name": "Kairamkonda Shailam Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1618",
    "name": "Kakade Namdev Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6639",
    "name": "Kalantre  Bhaurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13514",
    "name": "Kalle Dattatray Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6439",
    "name": "Kalpavruksh Shantabai M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13715",
    "name": "Kamath A Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12488",
    "name": "Kambale Malan Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10037",
    "name": "Kamble Babasaheb Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17439",
    "name": "Kamble Santosh J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11814",
    "name": "Kamble Vikas Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8481",
    "name": "Kanase Vinayak Raosaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3049",
    "name": "Karade Vithal Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16055",
    "name": "Karadekar Janardhan Kashiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19396",
    "name": "Karagutkar Santosh Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12892",
    "name": "Karande Anant Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16612",
    "name": "Karanjekar Dattatreya Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18041",
    "name": "Kardile Sandip Sopan Toli-"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16567",
    "name": "Karekar Chandrashekhar B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4379",
    "name": "Karle Vidya Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8048",
    "name": "Karmarkar Murlidhar Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11390",
    "name": "Karne Tukaram Babaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3270",
    "name": "Kashid Chandrakant Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "811",
    "name": "Kashid Kisan Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4410",
    "name": "Kasurde Anandrao Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4893",
    "name": "Kate Bandu Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12735",
    "name": "Katekar Kashinath Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4415",
    "name": "Katekar Parshuram Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7315",
    "name": "Kavalekar Rajendra Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9892",
    "name": "Kavankar Meena Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20001",
    "name": "Keluskar Rajan Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "760",
    "name": "Kemase Baburam Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10097",
    "name": "Kenjale Bharat Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5303",
    "name": "Kesarkar Ganpat Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14034",
    "name": "Khade Rajyndra Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13955",
    "name": "Khan Mohammad Hafij"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4625",
    "name": "Khan Nafeesabegum Hasan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4992",
    "name": "Khandekar Yeshwant Daji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13896",
    "name": "Khandke Ratnaprabha Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15613",
    "name": "Khedekar Suresh Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13478",
    "name": "Khopade Balu Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14365",
    "name": "Khopade Dilip Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16647",
    "name": "Khopade Dipak Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11231",
    "name": "Khot Dhondiba Jyoti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9782",
    "name": "Khot Nathuram Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18857",
    "name": "Kilanje Kalpesh K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12382",
    "name": "Kindre Dattatray Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17293",
    "name": "Kokane Sanjeev Damodar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13293",
    "name": "Kolambekar Dinesh Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14563",
    "name": "Kolekar Balu Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15447",
    "name": "Kolekar Shankar Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11279",
    "name": "Kolge Devendra Bhalchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5148",
    "name": "Korade Ashok Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3176",
    "name": "Kshirsagar Gangubai Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3987",
    "name": "Kudtarkar Pushpa M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13477",
    "name": "Kulkarni Shreedhar S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3557",
    "name": "Kumbhar Dnyandeo Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8346",
    "name": "Kumbhar Krushna Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1846",
    "name": "Kumbhar Ramchandra Babasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17439",
    "name": "Kumbhar Sampat Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18030",
    "name": "Lahane Rambhau Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18618",
    "name": "Lakhan Ganesh Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11624",
    "name": "Lakhan Ramchandra Joti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14335",
    "name": "Lama Indrejeet Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14708",
    "name": "Landge Subhash H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2633",
    "name": "Lembhe Duryodhan Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11604",
    "name": "Lod Sharmila Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8876",
    "name": "Lodha Sudhakar Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18963",
    "name": "Lohakare Ranganath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8445",
    "name": "Lokhande Sudhir Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6852",
    "name": "Londhe Babasaheb Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9586",
    "name": "Londhe Baliram Vinayakrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11239",
    "name": "Ludbe Sunil Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14691",
    "name": "Luniya Chiniprasad N"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10811",
    "name": "Madale Surekhaa Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13331",
    "name": "Madhani Naveenchandra F"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9085",
    "name": "Madon Rusi J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6375",
    "name": "Mahadik Dattaram Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13431",
    "name": "Mahadik Tukaram Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17555",
    "name": "Makamle Shivaji Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13195",
    "name": "Malekar Manohar Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12526",
    "name": "Mali Harishchandra Basant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14132",
    "name": "Mali Sujaram Muraji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8705",
    "name": "Malpote Gabalu Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15591",
    "name": "Malusare Maruti Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2231",
    "name": "Malusare Suresh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1499",
    "name": "Malvankar  Prakash Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16882",
    "name": "Mamdani  Sabir  Mohamad ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17844",
    "name": "Mandal Maksudan Matuk"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22165",
    "name": "Mandave Pratibha Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15503",
    "name": "Mandhare Mugatrao Bhagwanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2714",
    "name": "Mandharer Kondiba Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11195",
    "name": "Mane Bhimrao Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7761",
    "name": "Mane Jalinder Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12233",
    "name": "Mane Jalindra Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9756",
    "name": "Mane Lala Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12161",
    "name": "Mane Mohan Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6624",
    "name": "Mane Namdeo Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12519",
    "name": "Mane Popat Sidoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11435",
    "name": "Mane Pratibha Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9394",
    "name": "Mane Ramchandra Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5136",
    "name": "Mane Shankar Kesu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10177",
    "name": "Manjrekar Anjali Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20119",
    "name": "Manjrekar Niranjan Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13037",
    "name": "Mankumare Parbati Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10714",
    "name": "Marathe Anil Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12829",
    "name": "Mardhekar Vithal Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8729",
    "name": "Maskar Sangeeta Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18025",
    "name": "Mastud Balu Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3647",
    "name": "Matekar Ananda S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13654",
    "name": "Matekar Dnyandeo Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4653",
    "name": "Matkar Bhalchandra Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17856",
    "name": "Matre Chandrakant Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14282",
    "name": "Matre Laxmibai Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4246",
    "name": "Matre Parubai Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17013",
    "name": "Matre Rajaram Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17321",
    "name": "Matre Vilas Dhyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14305",
    "name": "Maukatta Sujit Nagappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13270",
    "name": "Mayekar Prakash Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15480",
    "name": "Mhatre Narendra Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15481",
    "name": "Mhatre Usha Narendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9514",
    "name": "Mirukhe Shivaji Rajaram 1132/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5536",
    "name": "Modak Ravaji Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14503",
    "name": "Modak Shantaram Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7735",
    "name": "Modak Shripati Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9014",
    "name": "Mode Ram Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8312",
    "name": "Mody Lalbhai Ratilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17101",
    "name": "Mohamad Ashraf Abdul Satar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11052",
    "name": "Mohamad Imran Mohamad Harun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5581",
    "name": "Mohite Shankar Tatoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15009",
    "name": "Mojar Krishna Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19077",
    "name": "Mokal Vishwanath Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9865",
    "name": "Momin Ayub Nisar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9962",
    "name": "Mondhave Mandakini Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1477",
    "name": "More Ananda Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7183",
    "name": "More Ankush Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5915",
    "name": "More Anusaya B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8263",
    "name": "More Balaram Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "719",
    "name": "More Chandrakant Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "564",
    "name": "More Jagannath Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11879",
    "name": "More Laxman Ambaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3165",
    "name": "More Maruti Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13346",
    "name": "More Parvati Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17451",
    "name": "More Pradip Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9000",
    "name": "More Shrirang Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1305",
    "name": "More Shrirang Wamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10687",
    "name": "More Vilas Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15986",
    "name": "More Yashwant Bayaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10503",
    "name": "Mucchala Smita Chandulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1029",
    "name": "Mugade Balku Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10346",
    "name": "Mulali Papamiya Babulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3844",
    "name": "Mulani Salauddin Vajirbhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7205",
    "name": "Mulik Bajirao Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8613",
    "name": "Mulik Bharat Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12289",
    "name": "Mulik Chandrakant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6747",
    "name": "Mulik Dilip Daiwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9403",
    "name": "Mulik Prakash Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6033",
    "name": "Mulik Shankar Ganu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5180",
    "name": "Mulik Triveni Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10310",
    "name": "Mulik Tukaram Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11527",
    "name": "Mulla Babaso Aabaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12185",
    "name": "Nagvekar Madhavi Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18010",
    "name": "Naik Shivram K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10372",
    "name": "Naik Subhash Antu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22314",
    "name": "Naikawadi Pandurag Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7642",
    "name": "Naikodi Chandrabhaga Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3239",
    "name": "Nalage Shivaji Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "693",
    "name": "Nalawade Dhondiram Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7802",
    "name": "Nalawade Mansing Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1508",
    "name": "Nalawade Namdev Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1232",
    "name": "Nalawade Ramdas Hariba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13572",
    "name": "Nalawade Vaman Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9242",
    "name": "Nangare Namdeo Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13332",
    "name": "Narkar Uday Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9170",
    "name": "Nasser  Husseinali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5870",
    "name": "Navadkar Balwant Dashrath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9410",
    "name": "Navadkar Suresh Dashrath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11227",
    "name": "Nawadkar Baburao S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15682",
    "name": "Nawale Ramesh Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16120",
    "name": "Nayak Manoj T"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11334",
    "name": "Nerurkar Prakash Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13946",
    "name": "Nevarekar Nirmala Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15110",
    "name": "Nikam  Ashok Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8621",
    "name": "Nikam Dattu Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1428",
    "name": "Nikam Ramchandra Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15407",
    "name": "Nikam Sanjay Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13474",
    "name": "Nikam Shankar Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8168",
    "name": "Nikam Shankar Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3903",
    "name": "Nikam Vasant Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22300",
    "name": "Nikam Yashwant Uttam ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16766",
    "name": "Nilnkar Mohan Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9870",
    "name": "Nimbalkar Dadasaheb Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21970",
    "name": "Nimbalkar Dilip Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2134",
    "name": "Nimbalkar Yadu Joti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14148",
    "name": "Nimbalkat Bhagwan S.  B-8691"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7608",
    "name": "Nirmal Gajanan Ramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14380",
    "name": "Ogale Sushila Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9792",
    "name": "Ovalekar Manda Vivek."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10364",
    "name": "Pachogane Shivaji Aba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11254",
    "name": "Pachpute Sopan Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11058",
    "name": "Padval Bajrang Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12308",
    "name": "Padwal Ramhari Mahadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13505",
    "name": "Pal  Swapan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12927",
    "name": "Pandit Sharad Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11470",
    "name": "Paraakhe Shailesh Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3375",
    "name": "Parab Prakash Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12277",
    "name": "Parab Tanaji Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2689",
    "name": "Parade Kashinath Genaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9636",
    "name": "Parekh Geeta Pranlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17877",
    "name": "Parmar  Ramesh Babulal Toli-1576/3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17876",
    "name": "Parmar Sanjay Siyaram Toli-1576/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2313",
    "name": "Parti Baburao Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5552",
    "name": "Patane Bhiku Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10504",
    "name": "Patel Hemaram Dhularamji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9740",
    "name": "Patel Ram Asar  Ram Lochan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4996",
    "name": "Pathan Kalu Jabar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13157",
    "name": "Pathan Rehaman Babalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20036",
    "name": "Patil Ashok Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3366",
    "name": "Patil Laxman Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17737",
    "name": "Patil Milind Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16224",
    "name": "Patil Rajesh Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1535",
    "name": "Patil Ramchandra Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10292",
    "name": "Patil Sahadeo D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15467",
    "name": "Patil Sahaji Shankar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14499",
    "name": "Patil Sanjana Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4459",
    "name": "Patil Shamrao Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16237",
    "name": "Patil Shivaji Jaysingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8085",
    "name": "Patil Subhash Vasudeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16241",
    "name": "Patra Atanu Niranjan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9174",
    "name": "Pavaskar Vijay Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22425",
    "name": "Pawar  Vitthal  Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7844",
    "name": "Pawar Baban Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12115",
    "name": "Pawar Balvant Chandru 633/C/12"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9553",
    "name": "Pawar Bandu Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9581",
    "name": "Pawar Bapu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2828",
    "name": "Pawar Bhimrao Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9326",
    "name": "Pawar Dagadu Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13930",
    "name": "Pawar Damodar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20001",
    "name": "Pawar Dhyaneshwar Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6904",
    "name": "Pawar Dilip Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10923",
    "name": "Pawar Dnyandev Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10978",
    "name": "Pawar Hari Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9199",
    "name": "Pawar Kisan Daji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8403",
    "name": "Pawar Kisan Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2098",
    "name": "Pawar Laxman Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10107",
    "name": "Pawar Laxman Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13825",
    "name": "Pawar Madhukar Fulaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11042",
    "name": "Pawar Mohan Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17730",
    "name": "Pawar Nagesh Balaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3365",
    "name": "Pawar Ramchandra Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5284",
    "name": "Pawar Sarjerao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9543",
    "name": "Pawar Shivaji Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9132",
    "name": "Pawar Subhash Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14845",
    "name": "Pawar Sulochana Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11113",
    "name": "Pawar Sunil Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3009",
    "name": "Pawar Uttamrao Begatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11405",
    "name": "Pawar Vijay Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11026",
    "name": "Pawar Vijay Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15584",
    "name": "Pawar Vijay Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5599",
    "name": "Pendkar Keshav Joti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7968",
    "name": "Pendurkar Shweta Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4394",
    "name": "Phadtare Sakharam Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11659",
    "name": "Phalke Satyawan Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13172",
    "name": "Phalke Suresh Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14145",
    "name": "Phonde Baban Santu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8363",
    "name": "Pisal Bhagwan Suryaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12606",
    "name": "Pisal Bhikulal Raosaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10077",
    "name": "Pisal Dattatray Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3992",
    "name": "Pisal Hanmantrao Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11439",
    "name": "Pisal Rajendra Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9127",
    "name": "Pisal Sahadev Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16861",
    "name": "Pisal Shyamrao Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2649",
    "name": "Pisal Suresh Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11152",
    "name": "Pisal Vilas Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10516",
    "name": "Pol Nandkumar Arvind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2877",
    "name": "Pol Ramchandra Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4690",
    "name": "Poojari Krishnarao Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5620",
    "name": "Proprietor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11882",
    "name": "Proprietor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14904",
    "name": "Pujare Rupali Vishram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13563",
    "name": "Pujare Subhlaxmi Vishram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16701",
    "name": "Pujari Gunakar Kanthu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17644",
    "name": "Pujari Raksha Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15160",
    "name": "Pujari Sanjay Pandit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15345",
    "name": "Purohit Ramesh Achlaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7283",
    "name": "Purohit Sawai Siha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19004",
    "name": "Puthran Hemlata Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11443",
    "name": "Puthran Subhash M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8742",
    "name": "Raigade  Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14351",
    "name": "Rajak Shivram Ramavad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8763",
    "name": "Raje Dagdu Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13970",
    "name": "Raje Dnyandeo Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18486",
    "name": "Raje Ramesh Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9989",
    "name": "Rajput Omprakash Govardhansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14028",
    "name": "Rale Shantaram Daulat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11452",
    "name": "Rana Jeetandra Karsandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5523",
    "name": "Rane Mohan Bhiva"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13954",
    "name": "Rane Prashant Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11119",
    "name": "Rane Shailaja Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7072",
    "name": "Rane Sunita Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12650",
    "name": "Rankhambe Arjun Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11328",
    "name": "Rasam Prabakar Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15570",
    "name": "Rathod Ashok M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16368",
    "name": "Rathod Pushpabai Popatlal."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12616",
    "name": "Raut Jayawant Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2542",
    "name": "Raut Narayan Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14187",
    "name": "Raval Jyotindra Ishwarlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13561",
    "name": "Reddy T. Jayarami"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15466",
    "name": "Rhate Dashrat Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7957",
    "name": "Roman Ramchandra Parabati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1028",
    "name": "Roman Sampat Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23489",
    "name": "Roowala  Shahid  Chahat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13901",
    "name": "Rozario  Sacrament"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15623",
    "name": "Ruparelia Minaxi Jayantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15063",
    "name": "Sabale Ashok Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17557",
    "name": "Sabale Asmita Bharat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4373",
    "name": "Sabale Baburao Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2454",
    "name": "Sabale Ramchandra Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4849",
    "name": "Sable Lahu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16358",
    "name": "Sadahana Amitkumar Shah."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "804",
    "name": "Sail Tarabai Balaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14768",
    "name": "Saiyyad Abdul Mohammad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2332",
    "name": "Sakpal Sopan Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "202",
    "name": "Sakunde Dnyandeo Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17951",
    "name": "Sakunde Lahuraj Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11674",
    "name": "Sakunde Madhukar Baliram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16558",
    "name": "Sakunde Santosh Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11635",
    "name": "Sakunde Vithal Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8314",
    "name": "Salate Laxman Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14245",
    "name": "Salekar Vithoba Ramji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10423",
    "name": "Salte Sitaram Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7044",
    "name": "Salunkhe Antu Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6262",
    "name": "Salunkhe Ashok Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16859",
    "name": "Salunkhe Babanrao Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11877",
    "name": "Salunkhe Bharat Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11308",
    "name": "Salunkhe Hanmant Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17675",
    "name": "Salunkhe Janardhan Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4213",
    "name": "Salunkhe Janardhan Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12529",
    "name": "Salunkhe Popat Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15749",
    "name": "Salunkhe Ramesh Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2686",
    "name": "Salunkhe Rangrao Jaisingrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10961",
    "name": "Salunkhe Sahebrao Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6480",
    "name": "Salunkhe Shankar Buvasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2527",
    "name": "Salunkhe Vasant Dadasau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14137",
    "name": "Sanas Chandrakant Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12087",
    "name": "Sanas Suresh Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17214",
    "name": "Sanas Tukaram Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1011",
    "name": "Sankpal Jagannath Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9266",
    "name": "Sankpal Maya Rohidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15231",
    "name": "Sankpal Sandip Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18145",
    "name": "Sankpal Viraj Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20346",
    "name": "Sapakal Uttam Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12432",
    "name": "Sapkal Dattatray Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16277",
    "name": "Sapkal Vilas Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9748",
    "name": "Sarafdar Ananda Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15794",
    "name": "Saraswat Bhagwatiprasad Govindlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20171",
    "name": "Sarvade Shailendra Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6805",
    "name": "Sawadkar Ashok Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16949",
    "name": "Sawant Ashwini Arvind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13028",
    "name": "Sawant Bairunath Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4744",
    "name": "Sawant Chandrakant Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9100",
    "name": "Sawant Chaya Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1144",
    "name": "Sawant Eknath Khanderao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14399",
    "name": "Sawant Jotiram Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10116",
    "name": "Sawant Jotiram Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19153",
    "name": "Sawant Kunal Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11521",
    "name": "Sawant Mangala Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14263",
    "name": "Sawant Nathaji Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11845",
    "name": "Sawant Pandurang Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5810",
    "name": "Sawant Prakash Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7772",
    "name": "Sawant Sarsabai Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18053",
    "name": "Sawant Vitthal Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21166",
    "name": "Sayyad Zainabi Adam."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17660",
    "name": "Shah Rajendrakumar Chandlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14985",
    "name": "Shah Rakesh Mohanlalji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6627",
    "name": "Shah Ratanbai Damji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10062",
    "name": "Shaikh Mohammad Hanif  Sahamatali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10883",
    "name": "Shaikh Varis Ali Sherali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13894",
    "name": "Sharma Matadin Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8714",
    "name": "Shejwal Tanaji Govinda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12141",
    "name": "Shelake Hanmant Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21801",
    "name": "Shelake Krushna Manku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10035",
    "name": "Shelake Mahadav Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22309",
    "name": "Shelar Atmaram Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2637",
    "name": "Shelar Chandru Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4721",
    "name": "Shelar Hariba Daynu 627/7"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9678",
    "name": "Shelar Keshav Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10531",
    "name": "Shelar Yashwant Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9345",
    "name": "Shelte Tukaram Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3668",
    "name": "Sherekar Sharda Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15266",
    "name": "Shete Manoj Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22431",
    "name": "Shinde  Shivaji  Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7998",
    "name": "Shinde Aatmaram Appaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10802",
    "name": "Shinde Abhaysingh Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5923",
    "name": "Shinde Ananda Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "928",
    "name": "Shinde Anandrao Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8516",
    "name": "Shinde Ankush Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10728",
    "name": "Shinde Ankush Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14481",
    "name": "Shinde Ashok Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10522",
    "name": "Shinde Babanrao M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10756",
    "name": "Shinde Bharat Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12533",
    "name": "Shinde Chandrkant Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11935",
    "name": "Shinde Dagadu Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18684",
    "name": "Shinde Dattatraya Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7508",
    "name": "Shinde Dattu Vyankatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5956",
    "name": "Shinde Dharma Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5450",
    "name": "Shinde Dinkar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9466",
    "name": "Shinde Gorakh Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1201",
    "name": "Shinde Gulabrao Sonba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12014",
    "name": "Shinde Hanmant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9994",
    "name": "Shinde Hanmant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5119",
    "name": "Shinde Krushnat Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1244",
    "name": "Shinde Maruti Devram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9412",
    "name": "Shinde Narayan Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "485",
    "name": "Shinde Partaprao Manshingrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7357",
    "name": "Shinde Rajaram Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15797",
    "name": "Shinde Ravindra Dnyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11402",
    "name": "Shinde Sadashiv Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2149",
    "name": "Shinde Sadashiv Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15946",
    "name": "Shinde Shankar Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7514",
    "name": "Shinde Shankar Lakhu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11567",
    "name": "Shinde Shantaram Bahiru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12344",
    "name": "Shinde Shrikant Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16518",
    "name": "Shinde Subhash C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20136",
    "name": "Shinde Sunita Suryakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1197",
    "name": "Shinde Tukaram Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15070",
    "name": "Shinde Vilas Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10582",
    "name": "Shinde Vishnu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5020",
    "name": "Shinde Vitthal Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11501",
    "name": "Shingan Dhondiram Aaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2598",
    "name": "Shingate Shivaji Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18146",
    "name": "Shirke Bhrati Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8186",
    "name": "Shirke Dilip Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16719",
    "name": "Shirkule Ashok Gulab"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22452",
    "name": "Shirsat Vitthal Khasaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7658",
    "name": "Shirtode Tai Gajaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14325",
    "name": "Shivthare Anandrao Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15261",
    "name": "Shukla Mahadeo Rajendraprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19827",
    "name": "Sing Navalsing Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15075",
    "name": "Sing Sibansing Shrigopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15402",
    "name": "Singh Kishorkumar Ramautar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22002",
    "name": "Singh Umesh Ashokbansraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16914",
    "name": "Siroya Hasmukh B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11530",
    "name": "Solankhi Mohanlal Balabhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "617",
    "name": "Solaskar Lalaji Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17286",
    "name": "Sonawale Pravin Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10823",
    "name": "Sonawane Sampat Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16398",
    "name": "Sonawane Suresh Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11167",
    "name": "Soni Bakelal Ramloat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13738",
    "name": "Soni Bharatkumar Laxminarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9944",
    "name": "Sonigra Bhavna Vallabhdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17188",
    "name": "Stanley  Chellappen."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13199",
    "name": "Sukale Anil Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8674",
    "name": "Surma Banwari Mahapur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8978",
    "name": "Surtingji  Punamchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15329",
    "name": "Surve Vilas Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9773",
    "name": "Suryawanshi Ashok Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5473",
    "name": "Suryawanshi Habirao Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9467",
    "name": "Suryawanshi Shantabai Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18277",
    "name": "Suryawanshi Subhash Manik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18002",
    "name": "Sutar Yashwant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7693",
    "name": "Taigade Vijay Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16550",
    "name": "Tarade Jaiprakash Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18276",
    "name": "Tarde Manohar Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6373",
    "name": "Tawade Keshav Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13144",
    "name": "Taware Kashinath Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "485",
    "name": "Taware Ramchandra Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14299",
    "name": "Thakur Sucheta Jayesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2985",
    "name": "Thembare Vasant Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14401",
    "name": "Thick Yashwant Aaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13671",
    "name": "Thorave Pralhad Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14843",
    "name": "Tiwari Maskar Tirthraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11048",
    "name": "Tiwari Shriram Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18367",
    "name": "Tomar Dhubrsingh Gopaldas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11012",
    "name": "Toraskar Vijay Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10067",
    "name": "Tupe Shivaji Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14920",
    "name": "Undalkar Yashwant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21038",
    "name": "Vadam Suresh Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15225",
    "name": "Vadkar Mangal Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9807",
    "name": "Vaishnav Udaykumar Ranchordas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19038",
    "name": "Valanju Snehalata Rajan."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14339",
    "name": "Varhadi Vasant Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5768",
    "name": "Varkhade Mahadev Waghu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20733",
    "name": "Varma Shivsagar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13920",
    "name": "Vedpathak Kamini Ulhas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20499",
    "name": "Veer Ranjna Ankush."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11415",
    "name": "Venerkar Bharati Pravin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7438",
    "name": "Wadekar Vijay Ganesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13568",
    "name": "Wagh Anil Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20106",
    "name": "Wagh Deepak Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12694",
    "name": "Wagh Lata Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5155",
    "name": "Wagh Madhukar Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7755",
    "name": "Wagh Mahadev Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8254",
    "name": "Wagh Ranba Biyaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14399",
    "name": "Wagh Sahebrao Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5497",
    "name": "Wagh Shivaji Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "454",
    "name": "Wagh Vasantrao Bapurao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "586",
    "name": "Waghu Karim Kadir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4645",
    "name": "Wanarkar Anil Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7744",
    "name": "Waychal Parubai Parasram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19554",
    "name": "Wod Ganga Katak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15969",
    "name": "Yadav Anjanabai Abasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1408",
    "name": "Yadav Kisan Nivruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15932",
    "name": "Yadav Rajendra Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14095",
    "name": "Yadav Rajendra Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6401",
    "name": "Yadav Ramchandra Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13736",
    "name": "Yadav Ramsunder Jabar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3397",
    "name": "Yadav Sahebrao Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6620",
    "name": "Yadav Shantiprasad Tameshwarprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4124",
    "name": "Yewale Jaywant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7523",
    "name": "Yewale Lalsing Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8660",
    "name": "Yewale Pandharinath Thakaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8928",
    "name": "Zanzane Madhukar Jaising"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10484",
    "name": "Zodage Dnyaneshwar Khandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20679",
    "name": "Zuleekha"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4305",
    "name": "Gulab Trading Co."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15420",
    "name": "Yadav  Harishchandra Shriramkishor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11817",
    "name": "Agarwal Gaytri B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13157",
    "name": "Agarwal Harikishan Hiralal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11257",
    "name": "Agarwal Jagdishprasad Gulabchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15264",
    "name": "Agarwal Mukeshkumar Poonamchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11816",
    "name": "Agarwal Pushpa P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12771",
    "name": "Agarwal Radheshyam A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6338",
    "name": "Agrawal  Kailash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8387",
    "name": "Agrawal Prakash B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2496",
    "name": "Ahirekar Chanderrao Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13358",
    "name": "Ahirekar Dattatray Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18895",
    "name": "Ahirekar Sunita Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7405",
    "name": "Ajmera Vinod Ujmashi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13597",
    "name": "Andhale Chandrakala Ajinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10669",
    "name": "Angane Rachana Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1308",
    "name": "Anpat Suryakant Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7413",
    "name": "Ansari Jalil Dayal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9389",
    "name": "Ansari Jubeda Banu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7408",
    "name": "Ansari Mohd Mohiuddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1584",
    "name": "Atakare Shiva Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11827",
    "name": "Atgude Dnyandeo Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7892",
    "name": "Atre Hareshwarprasad Bhaskar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11489",
    "name": "Atugade Dnyandev Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13315",
    "name": "Autade Sanjay Pilaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18699",
    "name": "Awhale Asha Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13296",
    "name": "Babar Avinash Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13452",
    "name": "Babar Nandkumar Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11112",
    "name": "Babar Shobha Hindurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13065",
    "name": "Baheti Maniklal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7878",
    "name": "Bahujan Samaj Co-Op Labour Society"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4284",
    "name": "Balsaraf Deoram Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5021",
    "name": "Banawadekar Sugandha Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13714",
    "name": "Bandal Rajendra Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11807",
    "name": "Bangur Mohan Rangnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5985",
    "name": "Banku Sujankumar G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4175",
    "name": "Baraskar Ashok Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13289",
    "name": "Bardwa Surajkumar Durgadas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5037",
    "name": "Bendal Pandurang Ganpati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9629",
    "name": "Bhagat Vrushali Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6953",
    "name": "Bhagawat Prabhakar Jaganath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8052",
    "name": "Bhagwat Vilas Savlaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10518",
    "name": "Bhandari Phoolwanti C"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17417",
    "name": "Bhapakar Jaywant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7282",
    "name": "Bhapkar Dadasaheb Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13002",
    "name": "Bharmal Kusum Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9419",
    "name": "Bharuka  Subhashchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8337",
    "name": "Bhaumik Kanai Chandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2131",
    "name": "Bhilare Balkrishna Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17724",
    "name": "Bhise Chandrakant Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4096",
    "name": "Bhoite Balasaheb Shankar 137/2"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9126",
    "name": "Bhoite Ulhas Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8436",
    "name": "Bhoite Uttam Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15391",
    "name": "Bhoite Vishwas Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1532",
    "name": "Bhosale Ankush Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7439",
    "name": "Bhosale Ashok Jijaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6440",
    "name": "Bhosale Dashrath D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "210",
    "name": "Bhosale Gautam Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10087",
    "name": "Bhosale Gorakhnath Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "120",
    "name": "Bhosale Haribhau Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15645",
    "name": "Bhosale Jaywant Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3007",
    "name": "Bhosale Mansing Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13784",
    "name": "Bhosale Prakash Venkat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18024",
    "name": "Bhosale Ravindra Janardan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1729",
    "name": "Bhosale Sambhaji Wamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10906",
    "name": "Bhosale Shahaji Khandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15803",
    "name": "Bhosale Suresh Kashiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16555",
    "name": "Bhosale Sushama D"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10647",
    "name": "Bhosale Tanaji Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17605",
    "name": "Bhosale Vanita Sambhajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18510",
    "name": "Bhowar Kishor Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16969",
    "name": "Bhuj Vinodprasad Pachuprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2142",
    "name": "Bibi Gramastha Tarun Seva Mandalmu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10749",
    "name": "Birwatkar Prakash Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1689",
    "name": "Bobade Baburao Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12213",
    "name": "Bobade Dilip Madanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1059",
    "name": "Bobade Jayhind N"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6220",
    "name": "Bobade Sayaji Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5819",
    "name": "Bobade Somatabai V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5291",
    "name": "Bobade Uttam Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12195",
    "name": "Bohra Bhavarlal B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19485",
    "name": "Borage Parvati Ishwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16699",
    "name": "Borage Suresh Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8897",
    "name": "Bud Dadising Harising"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14624",
    "name": "Chalake Narayan Eshwara 131/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4852",
    "name": "Chalke Bhagwan Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14895",
    "name": "Chalke Pandurang Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17682",
    "name": "Chalke Rajaram Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4296",
    "name": "Chandurkar Shripad Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8841",
    "name": "Chatur Chhaya Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2387",
    "name": "Chaudhari Vrujlal Sahadev Prasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9054",
    "name": "Chaudhary Ramsavare R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12257",
    "name": "Chauhan Raja Karsan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17304",
    "name": "Chavan  Sagar  Maruti ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13413",
    "name": "Chavan Ajit Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9226",
    "name": "Chavan Anil Hiramal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "45",
    "name": "Chavan Hanmant Dadasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13672",
    "name": "Chavan Hindurao Maganrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14442",
    "name": "Chavan Hiralal A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13501",
    "name": "Chavan Jagdish D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12155",
    "name": "Chavan Kanta Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "935",
    "name": "Chavan Mahadev Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "178",
    "name": "Chavan Parashram Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3222",
    "name": "Chavan Rajesh H."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16052",
    "name": "Chavan Sarjerao Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10148",
    "name": "Chavan Shivram Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4559",
    "name": "Chavan Suryakant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3929",
    "name": "Chavan Vilasrao Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12637",
    "name": "Chawan Kailas Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14776",
    "name": "Chawan Mina Ramnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3150",
    "name": "Chawan Pramod Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5069",
    "name": "Chawan Shrirang Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11636",
    "name": "Chawan Sudhakar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14490",
    "name": "Chawan Sunil Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7403",
    "name": "Cheulkar Ramesh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4089",
    "name": "Chhaganlal  Dineshkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8022",
    "name": "Chhajed Moolchand Samrathmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19772",
    "name": "Chikane Prakash Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6072",
    "name": "Chikane Vishwas Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12200",
    "name": "Chikhale Shrikrishna Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18059",
    "name": "Chikne Vitthal Keshav / Chikne Ankush K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18468",
    "name": "Choudey Chintamani Badriprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6579",
    "name": "Choudhari Husainji Mohmed Ismail"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12346",
    "name": "Choudhary Hariram Zinku 462/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17475",
    "name": "Choudhary Suresh Lalaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10817",
    "name": "Chouhan  Budhiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14229",
    "name": "Chouhan Shriram Badalu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15290",
    "name": "Chouhanramkumar  Balikram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16960",
    "name": "Dabhade Suresh Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17405",
    "name": "Dalal Suresh Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3025",
    "name": "Dalavi Laxman Ramchandra"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2115",
    "name": "Gupta Ravishankar Baburam."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11425",
    "name": "Dalbir  Singh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7412",
    "name": "Deghe Khandu Devaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19840",
    "name": "Deora Lalit Shankarlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1656",
    "name": "Dere Pradeep Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16422",
    "name": "Desai Ashok Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3536",
    "name": "Desai Bandu Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10451",
    "name": "Desai Sadashiv Balaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16477",
    "name": "Desai Sasabai Khashaba."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10687",
    "name": "Deshmukh Sangeeta Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7090",
    "name": "Deshmukh Suresh Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12379",
    "name": "Deshmukh Vishnu Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20854",
    "name": "Devale Subhash Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8928",
    "name": "Devgude Vilas Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11568",
    "name": "Dhangar  Anilkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9117",
    "name": "Dhanve Pavitrabai Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12859",
    "name": "Dharme Prabhakar Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5421",
    "name": "Dhavale Anant Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14888",
    "name": "Dhavan Veena Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10060",
    "name": "Dhodke Shivaji Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12056",
    "name": "Dhumal Dattatray Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4501",
    "name": "Dhumal Namdeo Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2268",
    "name": "Dhumal Pandurang Bapuji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18078",
    "name": "Dhumal Ratansinh Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1848",
    "name": "Dhumal Sampat Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14007",
    "name": "Dhumal Shivaji Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8220",
    "name": "Dhumal Tanaji Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3653",
    "name": "Dhumal Vinayak Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5444",
    "name": "Disale Bandu Mahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2491",
    "name": "Disale Parashram Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3012",
    "name": "Disale Tukaram Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8955",
    "name": "Dodia Durlabhdas Vithaldas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1541",
    "name": "Doiphode Thaku Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1602",
    "name": "Doshi Geeta Mahendrarai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17918",
    "name": "Dubal Rajendra Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11303",
    "name": "Dudhuskar Pravin Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20160",
    "name": "Fernandes Savio Peter"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9202",
    "name": "Fulchand S/O Gulabchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1098",
    "name": "Gadave Baban Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12227",
    "name": "Gadia Abhyakumar Ratanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12223",
    "name": "Gadia Kishorekumar Ratanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2074",
    "name": "Gaikawad Hariba Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11822",
    "name": "Gaikwad Baliram Shravan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12734",
    "name": "Gaikwad Nivrutti Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12098",
    "name": "Gaikwad Sarjerao Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9504",
    "name": "Ganacharya Mahendra M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15646",
    "name": "Gaud Chandrabhan Jagnnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9804",
    "name": "Gaund Saraswati Bharatlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15763",
    "name": "Gawada Raju Javrem"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14022",
    "name": "Gawade Hanumant Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11402",
    "name": "Gawade Rajesh Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11185",
    "name": "Gawas Dayanand Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13860",
    "name": "Ghadage Amar Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13981",
    "name": "Ghadage Nandatai Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20695",
    "name": "Ghadge Ankush Appaji  Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "700",
    "name": "Ghadge Vasant Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19348",
    "name": "Ghagrum Bhiku Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19898",
    "name": "Ghanchi Mohmed Abdulla"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11362",
    "name": "Gharay Sunanda Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2601",
    "name": "Ghare Balu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5049",
    "name": "Ghige Ramesh Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15958",
    "name": "Gholap Kantabai Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7952",
    "name": "Ghorpade Suresh Jotiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7084",
    "name": "Gighe Shalan Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17275",
    "name": "Goale Dattatry Shirange"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7523",
    "name": "Gohil Dinesh Harkhachandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12932",
    "name": "Gole Ramesh Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12011",
    "name": "Gole Sanjay Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12911",
    "name": "Gomane Shamrao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5002",
    "name": "Gosavi Goreknath Dayagiri"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5275",
    "name": "Gosavi Kisan Genu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6583",
    "name": "Gotal Dagadu Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15344",
    "name": "Govind  Kanayalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3128",
    "name": "Gujar Rajendra Nathuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16256",
    "name": "Gujar Rupesh Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6012",
    "name": "Gupta Fulchand Punavshil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16724",
    "name": "Gupta Kailash N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13300",
    "name": "Gurav Shivdas Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16118",
    "name": "Halwai Bajranglal Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11965",
    "name": "Hande Ganesh Ambadas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18032",
    "name": "Hanvate Manik Raosaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2313",
    "name": "Hargude Janabai Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6203",
    "name": "Harijan Ojoreram Sahatu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12014",
    "name": "Harijan Santram Badari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14839",
    "name": "Harijan Santram Ramkishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17456",
    "name": "Harijan Sunitadevi Warkhuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2956",
    "name": "Hate Ramala Sadanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10288",
    "name": "Hendre Dada Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8737",
    "name": "Hingane Balkrishna Martand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "931",
    "name": "Humane Shivram Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8507",
    "name": "Inamdar Salim Lukman812/3"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6755",
    "name": "Indulkar Ravindra Daji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12185",
    "name": "Ingavale Prabhakar Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4286",
    "name": "Ingawale Nivrutti Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "730",
    "name": "Ingawale Sampatrao Piloba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16661",
    "name": "Jadhav Ananda Tanaji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "351",
    "name": "Jadhav Anandrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9906",
    "name": "Jadhav Anandrao Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12676",
    "name": "Jadhav Champu Udaysing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10890",
    "name": "Jadhav Chandrakant B"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12487",
    "name": "Jadhav Dadaso Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2226",
    "name": "Jadhav Dhanaji Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1643",
    "name": "Jadhav Dharmaji Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4898",
    "name": "Jadhav Dinkar Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8260",
    "name": "Jadhav Dinkar Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16577",
    "name": "Jadhav Godavari Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1572",
    "name": "Jadhav Hanmant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7099",
    "name": "Jadhav Mahadeo Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9330",
    "name": "Jadhav Mansingh Madhavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2852",
    "name": "Jadhav Parshuram Gunda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3603",
    "name": "Jadhav Ramchandra K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14746",
    "name": "Jadhav Ramesh Madhavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11283",
    "name": "Jadhav Sadashiv Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19511",
    "name": "Jadhav Shaila Jalindhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2453",
    "name": "Jadhav Shankar Keru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "448",
    "name": "Jadhav Shashikant Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14731",
    "name": "Jadhav Shrikant Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18260",
    "name": "Jadhav Subhash Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14363",
    "name": "Jadhav Suman Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13249",
    "name": "Jadhav Sunil Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9998",
    "name": "Jadhav Sunil Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15269",
    "name": "Jadhav Suresh Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9942",
    "name": "Jadhav Tanaji Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17640",
    "name": "Jadhav Vijay Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16147",
    "name": "Jadhav Vijay Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4907",
    "name": "Jadhav Vinayak Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1111",
    "name": "Jagatap Sahebrao Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12318",
    "name": "Jagdale Maruti Ekanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11401",
    "name": "Jagtap Aabaji Wamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10842",
    "name": "Jagtap Keshav Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9287",
    "name": "Jagtap Ramesh Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "489",
    "name": "Jagtap Shivaji Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16307",
    "name": "Jagtap Tulsidas Dinker"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12901",
    "name": "Jain  Agarchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12009",
    "name": "Jain  Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12611",
    "name": "Jain Arvindkumar Mansukhlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7797",
    "name": "Jain Ashish Mahendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3429",
    "name": "Jain Ashokkumar Pyarchandji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5939",
    "name": "Jain Harbanslal L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11822",
    "name": "Jain Mahesh B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7798",
    "name": "Jain Pragya Dinesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10216",
    "name": "Jain Ratanbai Sagarmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8416",
    "name": "Jain Ronak Dilipkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7548",
    "name": "Jain Siddharth Sureshkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8415",
    "name": "Jain Sunny Paras"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8348",
    "name": "Jain Sushil Devchandji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13963",
    "name": "Jain Vikramkumar Pukhrajji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10066",
    "name": "Jaiswal Jokhanram Pholeshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10833",
    "name": "Jaiswal Nika Mohilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4936",
    "name": "Jedhe Govind Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18263",
    "name": "Joshi Narad Harilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11472",
    "name": "Kachare Nitin Dinkarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13009",
    "name": "Kadam Atmaram Kashiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2222",
    "name": "Kadam Baburao Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7877",
    "name": "Kadam Balwant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "480",
    "name": "Kadam Dnyanu Balku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8091",
    "name": "Kadam Ganesh Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18401",
    "name": "Kadam Harishchandra Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2786",
    "name": "Kadam Jaising Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7138",
    "name": "Kadam Janabai Nandkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10490",
    "name": "Kadam Laxmibai Kashiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2221",
    "name": "Kadam Mohan Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5207",
    "name": "Kadam Nandkumar Udhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18688",
    "name": "Kadam Nitin Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4798",
    "name": "Kadam Nivrutti Bali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2629",
    "name": "Kadam Sampat Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5846",
    "name": "Kadam Shankar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3680",
    "name": "Kadam Sonabai Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8349",
    "name": "Kadam Vasant Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9207",
    "name": "Kalantre Baburao Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12480",
    "name": "Kale Laxman Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9596",
    "name": "Kale Shamrao Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11164",
    "name": "Kalekar Shamrao Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19462",
    "name": "Kambale Sidhu Raghu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22100",
    "name": "Kambale Sudesh T."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16535",
    "name": "Kamble Mahadeo Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "774",
    "name": "Kandare Bapu Savala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2547",
    "name": "Karande Baban Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7216",
    "name": "Karande Baburao Balaku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18226",
    "name": "Karande Hirabai Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12313",
    "name": "Karanjekar Namdeo Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11354",
    "name": "Karne Ashok T"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6543",
    "name": "Kasurde Tanaji Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18836",
    "name": "Katee Pralhad Yelappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7110",
    "name": "Katkade Manik Baburao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2234",
    "name": "Hajra Telecome"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2054",
    "name": "Katkar Chandrakant Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6607",
    "name": "Katkar Vijay Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19455",
    "name": "Kavde Vishwnath Rajarm"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10094",
    "name": "Kawale Shivaji Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5482",
    "name": "Kenjale Balwant Piloba."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5365",
    "name": "Kenjale Maruti Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7148",
    "name": "Kerkar Balkrishna Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18544",
    "name": "Khan Amjad Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12144",
    "name": "Khan Mehabobkhan Sadar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14614",
    "name": "Khan Mohd Islaj Alliraja"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4901",
    "name": "Khande Ramesh Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14514",
    "name": "Khanekar Sopan Limbaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15897",
    "name": "Khanvilkar Sarita Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12884",
    "name": "Kharat Bhimrao Jayram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8815",
    "name": "Khare Prakash Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18235",
    "name": "Kharvi Lalita Raman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11776",
    "name": "Khedekar Atmaram Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9231",
    "name": "Khedekar Rajendra Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12312",
    "name": "Khendelwal  Raju"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8446",
    "name": "Khengare Bajirao Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2945",
    "name": "Khilari Digambar Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4878",
    "name": "Khochare Pandurang Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12921",
    "name": "Khopade Ananda Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6360",
    "name": "Khopade M. B."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16207",
    "name": "Kochale Vithal Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9088",
    "name": "Kokate Laxman Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7814",
    "name": "Kolekar Baburao Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4700",
    "name": "Kolekar Maruti Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4636",
    "name": "Kolekar Tanaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10984",
    "name": "Kolpek Shankar Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4612",
    "name": "Konde Jagannath Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7052",
    "name": "Kotawade Ananda Salhram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14241",
    "name": "Kshirsagar Ramakant Govid"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10446",
    "name": "Kulkarni Indu Anil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17151",
    "name": "Kumbhar Rukminibai Chandrakant."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15883",
    "name": "Kumbhar Sanjay Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13077",
    "name": "Kumhar Babulal Gomaramji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19193",
    "name": "Kuwar Mangesh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4483",
    "name": "Labde Kishor Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8006",
    "name": "Ladke Bhagwan P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11185",
    "name": "Lakhan Ganpat Devaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9776",
    "name": "Lakhan Shamrao Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5215",
    "name": "Lalwani Vashulal Jinkiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12242",
    "name": "Lavekar Prakash Dattatreya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13787",
    "name": "Lawand Kaushalya Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4912",
    "name": "Lodha Sudhakar Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11000",
    "name": "Lohar Maruti Bhagavan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14415",
    "name": "Lotlikar Shantaram Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11543",
    "name": "Lotlikar Somnath N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9471",
    "name": "M Shivkumar Rudrappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11622",
    "name": "Mahadik Sadashiv Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "416",
    "name": "Mahangade Babasaheb Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13135",
    "name": "Maheshwari Shanker R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4108",
    "name": "Malpote Vishnu Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5542",
    "name": "Malusare Nivruti Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11716",
    "name": "Malusare Tukaram Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11791",
    "name": "Manavkar Ajay Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5911",
    "name": "Mandhare Gajanan Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3354",
    "name": "Mandhare Shrirang Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11685",
    "name": "Mandhare Sunil Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9230",
    "name": "Mandot Khyali Lal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5096",
    "name": "Mane Baburao Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8640",
    "name": "Mane Dilip Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18433",
    "name": "Mane Ganesh Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3211",
    "name": "Mane Nilkanth Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4546",
    "name": "Mane Prakash Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3044",
    "name": "Mane Shankar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12112",
    "name": "Mane Shivram Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4954",
    "name": "Mane Sopan Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8385",
    "name": "Manisha Devanaryan Varmi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3040",
    "name": "Manjrekar Pradip Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14721",
    "name": "Marathe Chandan Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18786",
    "name": "Mardhekar Bhiku Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12115",
    "name": "Mardhekar Shankar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11044",
    "name": "Maskar Prakash Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18033",
    "name": "Mastud Shivaji Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7418",
    "name": "Matkar Anusaya Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1761",
    "name": "Matkar Dinkarrao Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6438",
    "name": "Matre Ananda Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11547",
    "name": "Matre Pandurang Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13426",
    "name": "Matre Shivaji Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11861",
    "name": "Matre Vinayak Jyotiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19526",
    "name": "Maundekar Vasudev Atmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12394",
    "name": "Megharaj Pravin L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5023",
    "name": "Mehta Kantilal Jethalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16828",
    "name": "Mende Sharad Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14987",
    "name": "Mestry Vitthal Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13320",
    "name": "Mhadeshwar Vijay Nagesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4285",
    "name": "Mhaskar Krushna Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5505",
    "name": "Mhaskar Yeshwant Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13460",
    "name": "Mhatekarwadi Gramastha Mandal Mumba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11732",
    "name": "Mhatre Gangabai Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13018",
    "name": "Mhatre Shashikant Nagu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12460",
    "name": "Mhatre Shirish V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15462",
    "name": "Misal Bhagwat Pamji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12793",
    "name": "Mistry Ramesh Lachhiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7337",
    "name": "Modak Maruti Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2342",
    "name": "Mohite Chagan Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19415",
    "name": "Mohite Rajaram Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8584",
    "name": "Momin Liyaqat Musabhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8187",
    "name": "Monde Laxman Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13349",
    "name": "Morarka Arun Prabhudayal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9151",
    "name": "More Ashok Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "909",
    "name": "More Baburao Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10265",
    "name": "More Baburao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10895",
    "name": "More Bapurao Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10139",
    "name": "More Kisan Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7080",
    "name": "More Maruti Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10120",
    "name": "More Pandurang Chander"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3668",
    "name": "More Raghunath Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "60",
    "name": "More Ramchandra Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11860",
    "name": "More Ramchandra Dyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8866",
    "name": "More Rao Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2067",
    "name": "More Shankar Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9040",
    "name": "More Vinod Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9459",
    "name": "Mulchandani Vijay Kumar H"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7776",
    "name": "Muleya Dattaram Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14671",
    "name": "Mulik Bajirao Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14324",
    "name": "Mulik Gulabrao Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1539",
    "name": "Mulik Laxman Bajirao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1691",
    "name": "Hastkamal Texchem Pvt Ltd"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7018",
    "name": "Mulik Madhukar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4938",
    "name": "Mulik Mohan Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16020",
    "name": "Mulik Prakash Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5188",
    "name": "Mulla Abdulla Aadam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10052",
    "name": "Mulla Gani Aboo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13810",
    "name": "Musala Askarali Ghulkhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11761",
    "name": "Nadankar Eknath G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14574",
    "name": "Nagveker Bina Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17317",
    "name": "Naidu Rajendra Manipadi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15278",
    "name": "Naik Rajaram Chango"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9448",
    "name": "Naik Surendra Jayram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13097",
    "name": "Naik Vilas Jairam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8435",
    "name": "Naikkare Ganpat Dwarku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12327",
    "name": "Nalawade Chandrakant Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17787",
    "name": "Nalawade Dattatray Dinkar  Tn-1566-6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5202",
    "name": "Nalawade Maruti Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12961",
    "name": "Nalawade Ramchandra Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10509",
    "name": "Nalawade Shambhaji Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9122",
    "name": "Nalawade Shankar Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "384",
    "name": "Nalawade Trimbak Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10222",
    "name": "Nalwade Rajesh Murlidhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5182",
    "name": "Nanavare Narad Harishchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12134",
    "name": "Narkar Milind Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5563",
    "name": "Navadkar Balwant Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2292",
    "name": "Nawadkar Bhagwan Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "618",
    "name": "Nawadkar Bhiku Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1379",
    "name": "Nawadkar Hari Krishnrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9336",
    "name": "Nawadkar Keshav Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8714",
    "name": "Nawadkar Sharad Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13796",
    "name": "Netke Shankar Wamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2139",
    "name": "Nikam Dnyaneshwar Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3829",
    "name": "Nikam Ganpat Kondaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6833",
    "name": "Nikam Keshav Jijyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15931",
    "name": "Nikam Pramod Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18422",
    "name": "Nikam Sulochana Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16148",
    "name": "Nikam Vimal Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10845",
    "name": "Nimbalkar Dattatray Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "559",
    "name": "Nimbalkar Prakash Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3272",
    "name": "Ninbalakar Anandrao Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11092",
    "name": "Padave Suvarna Shriram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3405",
    "name": "Padwal Atmaram Manjaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12635",
    "name": "Palkar Deepak Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14891",
    "name": "Panbude Vilas Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10457",
    "name": "Pande Badriprasad Ramnandan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14999",
    "name": "Pandey Anandkumar M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11565",
    "name": "Pandya Harendra B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7618",
    "name": "Panskar Nanasaheb Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12461",
    "name": "Parab Dattatray Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10061",
    "name": "Parab Jagannath Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3148",
    "name": "Parab Mangesh Vishram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6470",
    "name": "Parab Sunanda Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6803",
    "name": "Parab Waman Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1102",
    "name": "Parapureth  Kuttanchandran."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15748",
    "name": "Parashar Janardan Shrijagdishprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6028",
    "name": "Pasari Hemantkumar B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12997",
    "name": "Patade Vasant Suryaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13846",
    "name": "Patane Santosh Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4317",
    "name": "Patekar Shankar Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11927",
    "name": "Patel Navneetbhai Babubhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11603",
    "name": "Pathan Yar Ali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5169",
    "name": "Patil Ananda Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18310",
    "name": "Patil Arvind Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5449",
    "name": "Patil Ashok Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8925",
    "name": "Patil Dagadu Ramu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12520",
    "name": "Patil Dagau Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2668",
    "name": "Patil Jamunabai Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8129",
    "name": "Patil Maruti Bali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18392",
    "name": "Patil Narayan Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12442",
    "name": "Patil Rajaram Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10824",
    "name": "Patil Rajaram Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13971",
    "name": "Patil Sanjay Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1779",
    "name": "Patil Shamrao Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11492",
    "name": "Patil Shankar Dhondi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10467",
    "name": "Patil Shivaji Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13321",
    "name": "Patil Sudhakar Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11957",
    "name": "Pawar Amin Majid"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10811",
    "name": "Pawar Babu Pandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14385",
    "name": "Pawar Deepak Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10874",
    "name": "Pawar Dilip Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10000",
    "name": "Pawar Eknath Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15921",
    "name": "Pawar Hanmant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17734",
    "name": "Pawar Kishor Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1716",
    "name": "Pawar Krushnarao Dajiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4517",
    "name": "Pawar Mohan Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10856",
    "name": "Pawar Pandurang Khanderao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9695",
    "name": "Pawar Pushpa Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10323",
    "name": "Pawar Ramdas Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4369",
    "name": "Pawar Shivaji Y"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12483",
    "name": "Pawar Sonubai Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12417",
    "name": "Pawar Suryakant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16434",
    "name": "Pawar Tukaram Bapu"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "93",
    "name": "Hotel Sandhya  Restaurant & Bar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8345",
    "name": "Pawar Udaysing D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2807",
    "name": "Pawar Vithal Raoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11752",
    "name": "Pawar Vithal Sadhu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1455",
    "name": "Pawar Vithalrao Vyankatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18918",
    "name": "Pawer Sampatrao Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11800",
    "name": "Paypute Indutai Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11390",
    "name": "Pereira Micheal D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5017",
    "name": "Phadatare Vijay Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10438",
    "name": "Phalke Baburao Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9157",
    "name": "Phalke Gorakh Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5825",
    "name": "Phalke Tukaram Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5281",
    "name": "Pisal Bhalchandra Kisanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1232",
    "name": "Pisal Manukabai Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4818",
    "name": "Pisal Nivrutti Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1141",
    "name": "Pisal Vishwas Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "162",
    "name": "Pisal Yashwant Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4950",
    "name": "Pishu  Chandiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9390",
    "name": "Pol Balu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9622",
    "name": "Pol Kisan Sampatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11929",
    "name": "Potale Raju Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9742",
    "name": "Prabhudas Jaylal Mithani"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21258",
    "name": "Pramodkumar Saraugi  Karta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9079",
    "name": "Pujare Surekha Sridhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4373",
    "name": "Pujari Krishnarao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3815",
    "name": "Pujari Subhash Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3574",
    "name": "Pujari Vilas Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7475",
    "name": "Purohit  Jwarsingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7686",
    "name": "Purohit Babulal F"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6191",
    "name": "Purohit Joitaram A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18633",
    "name": "Rajbhar Bimalkumar Dharmraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14664",
    "name": "Rajput Manik Singh Kanhaiya Singh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13153",
    "name": "Rajput Mehul T"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12026",
    "name": "Rajput Prakash D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14103",
    "name": "Ramoshi Devanand Rajdhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7977",
    "name": "Rane Asha Muralidhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17446",
    "name": "Rane Mayur Bhau."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9310",
    "name": "Ranware Arun Jayaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11835",
    "name": "Ranware Ramchandra Jaysingrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11596",
    "name": "Rao Chabilal Rakhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12925",
    "name": "Raskar Balu Somnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8951",
    "name": "Raut Dhondu Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7938",
    "name": "Rawool Dilip Rama"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3093",
    "name": "Rodrigues  T"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1511",
    "name": "Rojane Dhondiba Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15232",
    "name": "Roy Dilipkumar Vaidhnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10359",
    "name": "Rustoom Mohamad Rashid"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7547",
    "name": "Sabale Baburao Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11182",
    "name": "Sabale Chandrakant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2091",
    "name": "Sabale Laxman Neelu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5226",
    "name": "Sabale Pandurang Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8877",
    "name": "Sabale Rajendra Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1721",
    "name": "Sabale Shivram Bhairu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6682",
    "name": "Sahani Bechanlal Chauthi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18203",
    "name": "Said Lalita Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14589",
    "name": "Saket Mathuradas Bhillu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14788",
    "name": "Saket Ramashray Chotelal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3277",
    "name": "Sakpal Niwas Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4815",
    "name": "Sakpal Vaman Jagnnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9993",
    "name": "Sakunde Jijaba Anandarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1086",
    "name": "Sakunde Pandurang Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3920",
    "name": "Sakunde Ramchandra Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14077",
    "name": "Sakunde Sadashiv Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4802",
    "name": "Salate Dattaram Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14538",
    "name": "Salunkhe Anita Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8131",
    "name": "Salunkhe Baban Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8748",
    "name": "Salunkhe Balku Bala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3785",
    "name": "Salunkhe Dnyandeo Dagadu"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1012",
    "name": "Idea Enterprise"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17431",
    "name": "Salunkhe Jaywant Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "140",
    "name": "Salunkhe Laxman Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16988",
    "name": "Salunkhe Madhu Rekha Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13516",
    "name": "Salunkhe Minaxi Dnyaneshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6959",
    "name": "Salunkhe Sarjerao K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1148",
    "name": "Salunkhe Sarjerao Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14173",
    "name": "Salunkhe Shahaji Haibatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11627",
    "name": "Salunkhe Shankar Buvasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8007",
    "name": "Salunkhe Vasant Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2810",
    "name": "Salunkhe Vishwas Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5605",
    "name": "Sampkal Chandkant S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16331",
    "name": "Sanas Chandrakant Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11908",
    "name": "Sandbhor Gajanan Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9989",
    "name": "Sangavkar Ravindra Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9435",
    "name": "Santha K. Ravi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2399",
    "name": "Sapkal Jagannath Aaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1513",
    "name": "Sapkal Mahadeo Dagdu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2943",
    "name": "Sapkal Pandurang Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15867",
    "name": "Sapkal Vasant Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4513",
    "name": "Sarvajanik Ganeshostav Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10480",
    "name": "Sase Gopichand Balku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15787",
    "name": "Satle Vikas Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16773",
    "name": "Sawant Ashok Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "421",
    "name": "Sawant Balkrishna Ravji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1888",
    "name": "Sawant Dnyanu Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "897",
    "name": "Sawant Jagannath Bapuji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11528",
    "name": "Sawant Kalpana Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4801",
    "name": "Sawant Popat Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16795",
    "name": "Sawant Prathamesh Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1067",
    "name": "Sawant Ramu Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4368",
    "name": "Sawant Shankar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10890",
    "name": "Sawant Sundrabai Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10745",
    "name": "Sawant Vithal Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14799",
    "name": "Sawant Waman Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4111",
    "name": "Sawant Waman Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12459",
    "name": "Sehgal  Pankaj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7402",
    "name": "Shah  Vilaschandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12940",
    "name": "Shah Ashakumari M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "39",
    "name": "Shah Babubhai G"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13076",
    "name": "Shah Bharatkumar Himatlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2820",
    "name": "Shah Chandrakant Prabhudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11790",
    "name": "Shah Dilip L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12121",
    "name": "Shah Dilip Rasiklal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5761",
    "name": "Shah Jayashree Jayachand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12357",
    "name": "Shah Jayashree Mukesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3274",
    "name": "Shah Kirtilal Laherchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16571",
    "name": "Shahu Bhola Kumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6704",
    "name": "Shaikh Jabbarali Mohammad Yakub"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8923",
    "name": "Shaikh Jaggulal Chohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12747",
    "name": "Shaikh Javed Husain"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12465",
    "name": "Shaikh Moinuddin N"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7417",
    "name": "Shaikh Wahid Nabijan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16170",
    "name": "Shanbhag Sunil Ramnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13213",
    "name": "Sharma Ramesh Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11747",
    "name": "Sharma Ramkaran Mangilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1996",
    "name": "Sharma Sholrha Sunil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14136",
    "name": "Shedge Dilip Sahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8286",
    "name": "Shedge Tatyaba Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5061",
    "name": "Shejawal Shankar Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9868",
    "name": "Shejwal Shivaji Govinda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2854",
    "name": "Shelar Krishna Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12672",
    "name": "Shelar Laxmibai Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8801",
    "name": "Shelar Vithal Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8678",
    "name": "Sherekar Pandurang Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7419",
    "name": "Shettaye Dattakumar Shrikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13300",
    "name": "Shetty Ganesha S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3981",
    "name": "Shetye Kashinath Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15262",
    "name": "Shetye Nakul Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "105",
    "name": "Shewale Prakash Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7370",
    "name": "Shidruk Suresh Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11964",
    "name": "Shilimkar Rajendra Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4824",
    "name": "Shinde Aabaji Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4583",
    "name": "Shinde Arjun Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1893",
    "name": "Shinde Arun Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1046",
    "name": "Shinde Baban Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10106",
    "name": "Shinde Baban Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9125",
    "name": "Shinde Dattatray Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19394",
    "name": "Shinde Deepak Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14354",
    "name": "Shinde Kashinath Appaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12057",
    "name": "Shinde Koyana Sudhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10628",
    "name": "Shinde Mahadeo Babaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9773",
    "name": "Shinde Mahadeo Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12224",
    "name": "Shinde Narayan Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12194",
    "name": "Shinde Pandurang Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10543",
    "name": "Shinde Rajaram Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12854",
    "name": "Shinde Rajendra Wamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4138",
    "name": "Shinde Rambhau Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18339",
    "name": "Shinde Seema Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1823",
    "name": "Shinde Shivaji Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8052",
    "name": "Shingan Aabaji Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5879",
    "name": "Shingan Balasaheb Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19408",
    "name": "Shinh Santoaskumar Gulab"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3249",
    "name": "Shirke Mahadeo Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9633",
    "name": "Shirke Narayan Mukunda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9907",
    "name": "Shirsat Ashok Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5554",
    "name": "Shirsat Damaji Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13946",
    "name": "Shivankar Dhananjay Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2688",
    "name": "Shivankar Sadashiv Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1756",
    "name": "Shivthare Bharat Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9059",
    "name": "Shukla Ganga P (President"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10173",
    "name": "Solanki Laxmansing Ramsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "122",
    "name": "Solaskar Bhagwan Appasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "820",
    "name": "Solaskar Sampat Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9476",
    "name": "Sonake Dnyandev Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16683",
    "name": "Sonawale Somnath Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8011",
    "name": "Sonawane Chandrakant S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18456",
    "name": "Sonawane Milind Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13737",
    "name": "Soni Mahendrakumar Kundanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15017",
    "name": "Soni Narmadaben Narayanji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15012",
    "name": "Soni Ramniklal Naranji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15016",
    "name": "Soni Vanita Amritlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3551",
    "name": "Sul Akoba Babaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9526",
    "name": "Sulake Rani Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16770",
    "name": "Suriya  Saraswatidevi Rangilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7003",
    "name": "Suryawanshi Maruti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11902",
    "name": "Suryawanshi Mira Shashikant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11458",
    "name": "Susai  Mani"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18248",
    "name": "Sutar Amol Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7249",
    "name": "Suthar Pukhraj Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11203",
    "name": "Sutradhar  Rekha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1775",
    "name": "Takalkar Maruti Chimnaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17792",
    "name": "Tarade Arvind Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15578",
    "name": "Tarade Jyoti Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5937",
    "name": "Tarade Khashaba Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "368",
    "name": "Teli Chinath Jagai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2993",
    "name": "Thakkar Dayaji Janak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13845",
    "name": "Thorave Santosh Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15777",
    "name": "Tiwari Anilkumar Rajmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15133",
    "name": "Tiwari Balkeshwar Suryanarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17005",
    "name": "Tupe Dattatray Santu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10181",
    "name": "Tyagraj Javregaunda Najgaunda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7421",
    "name": "Ugale Arjun Nanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22507",
    "name": "Upadhayay Bharat Bhagylal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19345",
    "name": "Uppdhyai Ramajor Bateshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9589",
    "name": "Vageria Ashok S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2848",
    "name": "Varkad Sarjerao Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7754",
    "name": "Vibhute Suresh Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12575",
    "name": "Vodnala Rajesham Bheem"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19414",
    "name": "Walivdekar Maruti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17479",
    "name": "Yadav Arjun Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19341",
    "name": "Yadav Bhalerao Vyankatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12713",
    "name": "Yadav Bharat Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8495",
    "name": "Yadav Bhikoba Tukaram / Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11106",
    "name": "Yadav Mahendra Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14223",
    "name": "Yadav Rajaram Dhanraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16211",
    "name": "Yadav Rajendra Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10466",
    "name": "Yadav Ramanand Jagmohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10400",
    "name": "Yadav Ramchandra Bheru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10211",
    "name": "Yadav Ramesh Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12928",
    "name": "Yadav Ramjeet Dukhi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10468",
    "name": "Yadav Ramkishore Jagmohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5440",
    "name": "Yadav Santram Lalya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8697",
    "name": "Yadav Satish Vasantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9627",
    "name": "Yadav Vilas Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3172",
    "name": "Yadav Visai Bruja"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1741",
    "name": "J R Traders"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2597",
    "name": "J. S. Enterprise."
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "100",
    "name": "J.V.Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12877",
    "name": "Yamkar Janu Dhaku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19519",
    "name": "Yeole Subhash Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8050",
    "name": "Yeshwantrao Shantaram Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2599",
    "name": "Yewale Dnyandeo Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13054",
    "name": "Yewale Vijay Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14784",
    "name": "Yewale Vilas Ganapt"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22095",
    "name": "Zala Ashok K."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10371",
    "name": "Zanjurne Arun Babaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4784",
    "name": "Zanzune Kashinath Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12641",
    "name": "Zodage Tukaram Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14111",
    "name": "Zore Dhaku Vithu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16832",
    "name": "Zore Housabai Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7933",
    "name": "Nakti Shrikant Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5225",
    "name": "Aambekar Hari Ravaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4626",
    "name": "Aauti Balshiram Mahadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1403",
    "name": "Ahirekar Vyankatrao Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7759",
    "name": "Anute Shripati Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12047",
    "name": "Ashiyakhatun Maqabul Husen Khan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10180",
    "name": "Babar Minakshi Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11078",
    "name": "Baddare Raghunath Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6871",
    "name": "Bafana Priya Parashmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6847",
    "name": "Bagate Raghu Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13338",
    "name": "Bajaj Mukesh Harinarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13773",
    "name": "Barge Santosh Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4633",
    "name": "Barve Shankar Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10576",
    "name": "Batwal Shyam Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1961",
    "name": "Bhagwat Dattatray Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1469",
    "name": "Bhagwat Ramchandra Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18022",
    "name": "Bhagwat Shashikala Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11099",
    "name": "Bhandari Vimala Dhanraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12663",
    "name": "Bhandwalkar Ramesh Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1443",
    "name": "Bhanushali Prakash Laxmidas."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "62",
    "name": "Bharmal Pandurang Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4800",
    "name": "Bhatade Tukaram Manka"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18803",
    "name": "Bhatkar Vikash Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11062",
    "name": "Bhidare Vishnu Govinda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1181",
    "name": "Bhilare Vinayak Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16905",
    "name": "Bhoite  Suresh  Sadashiv ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11335",
    "name": "Bhoite Ramesh Jagdeo 140/17"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5594",
    "name": "Bhoite Vyankatrao Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11665",
    "name": "Bhosale Appasaheb Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9753",
    "name": "Bhosale Girish Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6746",
    "name": "Bhosale Jaysing Vyankat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8817",
    "name": "Bhosale Jaywant Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11057",
    "name": "Bhosle Chandrakant Dayaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10898",
    "name": "Bhudricha Jasuben Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14074",
    "name": "Bobade Dilip Shivaji 655/4"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16970",
    "name": "Bobade Keshav Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7954",
    "name": "Bobade Mohan Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10665",
    "name": "Borate Rajaram Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16519",
    "name": "Chalke Khasabai Daji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14576",
    "name": "Chaudhari Muniram Vasudeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7622",
    "name": "Chavan Balasaheb Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2700",
    "name": "Chavan Dashrath Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22485",
    "name": "Chavan Gulasabai Bandoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6725",
    "name": "Chavan Hanmant Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9825",
    "name": "Chavan Mahendra Hiralal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1260",
    "name": "Chavan Namdev Madhavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18377",
    "name": "Chavan Prakashkumar Amrutlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5936",
    "name": "Chavan Sanjay Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "542",
    "name": "Chavan Vishnu Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15487",
    "name": "Chawan Arun Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7007",
    "name": "Chorage Ramchandra Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6229",
    "name": "Choudhari Harilal Mukadam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14479",
    "name": "Chouhan Nankant Bandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9686",
    "name": "Chouhan Ramkaran Jiyawan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11651",
    "name": "Chouhan Shivpujan Motilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11112",
    "name": "D Souza Anthony Constace"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10690",
    "name": "Dakhile Shivram Bhivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11519",
    "name": "Dalvi Shankar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4869",
    "name": "Dave Ganpatlal Jetharamji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1055",
    "name": "Desai Aba Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1182",
    "name": "Desai Shankar Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4774",
    "name": "Deshmukh Mugatrao Rangarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14806",
    "name": "Dhumal Hanumant Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20701",
    "name": "Disale Bhausaheb D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9450",
    "name": "Disale Ganpat Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16655",
    "name": "Doshi Amit Rajesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4085",
    "name": "Ethape Sahebrao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12999",
    "name": "Faste Bandu Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15260",
    "name": "Fd'S Paixao Francis"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5570",
    "name": "Gaikawad Maruti Dajiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9710",
    "name": "Gaikwad Bhanudas Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19158",
    "name": "Gaikwad Nandkumar Yaswant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16203",
    "name": "Gawali Geeta Hiralal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10876",
    "name": "Gawali Kishor Paparam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5079",
    "name": "Gholap Sunanda V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7811",
    "name": "Gohil Champa Ratna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15309",
    "name": "Gothankar Vijay Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3037",
    "name": "Gurav Dnyanu Vithu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17797",
    "name": "Hajare Sabaji Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10736",
    "name": "Haldar  Deepak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14174",
    "name": "Harijan Sukhu Gunjan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9329",
    "name": "Hule Sunanda Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "313",
    "name": "Jadhav Ashok Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3060",
    "name": "Jadhav Gangaram Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6707",
    "name": "Jadhav Keshav Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15463",
    "name": "Jadhav Kisan Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16400",
    "name": "Jadhav Prakash Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8792",
    "name": "Jadhav Ramdas Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14022",
    "name": "Jadhav Ravji Damaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10373",
    "name": "Jadhav Satish Nathuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14929",
    "name": "Jadhav Shankar Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6651",
    "name": "Jadhav Sitaram Kundalika"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19147",
    "name": "Jagtap Amitkumar Harichandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4956",
    "name": "Jagtap Arvind Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8190",
    "name": "Jagtap Balasaheb Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16157",
    "name": "Jagtap Dilip Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17362",
    "name": "Jagtap Prakash Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1510",
    "name": "Jagtap Shankar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8048",
    "name": "Jagtap Subhash Yeshwantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2379",
    "name": "Jagtap Uttam Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4460",
    "name": "Jagtap Vithal Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3445",
    "name": "Jain Arun Kumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9313",
    "name": "Jain Dinesh Gyanchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16126",
    "name": "Jain Jelibai Mithalalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9971",
    "name": "Jain Vimalchand Premchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13476",
    "name": "Jaiswal Ramkaran Somai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9980",
    "name": "Jare Prakash Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6886",
    "name": "Jogani Smita V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7133",
    "name": "Kadaam Vasant Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1227",
    "name": "Kadam Ananda Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13275",
    "name": "Kadam Babu Jayshing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21884",
    "name": "Kadam Ishwar Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3130",
    "name": "Kadam Jaising Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2261",
    "name": "Kadam Kisan Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4348",
    "name": "Kadam Kisan Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13566",
    "name": "Kadam Malan Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8225",
    "name": "Kadam Mansing Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8944",
    "name": "Kadam Pradip Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8409",
    "name": "Kadam Vithal Kundlik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3802",
    "name": "Kadav Sidram Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12822",
    "name": "Kakade Bhagwan Godaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1580",
    "name": "Kamath Poornima V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12953",
    "name": "Kanade Vishwas Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16768",
    "name": "Kanase Vaijayanta Pandharinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13497",
    "name": "Karne Kisan Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8720",
    "name": "Keshri  Biharilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16758",
    "name": "Khadaka Tagatbhadur Lalbhadur."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18490",
    "name": "Kharade Sandeep Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10677",
    "name": "Khator Anil Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15475",
    "name": "Khengare Bajrang Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7111",
    "name": "Khopade Gorakhnath Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7556",
    "name": "Khuspe Mahadeo Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11920",
    "name": "Konde Suresh Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13632",
    "name": "Korade Rajaram Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15217",
    "name": "Kumbhar Ananda Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14390",
    "name": "Lad Balwant Dagdoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5216",
    "name": "Lalwani Rameshlal Jonkiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7574",
    "name": "Lembhe Gajarabai Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6937",
    "name": "Lembhe Laxman Dagadoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16298",
    "name": "Luis Arunala S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12630",
    "name": "Mandhare Jagdev Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3461",
    "name": "Mandhare Namdeo Sopanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16584",
    "name": "Mane Bhagwan Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15646",
    "name": "Mane Kailas Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1956",
    "name": "Mane Kamal Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5176",
    "name": "Mane Vishnu Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5036",
    "name": "Mankar Dnyaneshwar Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17251",
    "name": "Mardekar  Dyaneshwar  Raghu ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8814",
    "name": "Maskar Babu Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14193",
    "name": "Maskar Shankar Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4792",
    "name": "Matkar Shobha Ratnoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11297",
    "name": "Matre Chandrakant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13829",
    "name": "Matre Shobha Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8753",
    "name": "Mete Laxman Ramchandra Toli No-264/A/20"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12723",
    "name": "Mhasalkar Gopika Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18297",
    "name": "Modak Bharat Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9145",
    "name": "Modak Tukaram Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11863",
    "name": "Molake Kavita Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3823",
    "name": "More Baburam Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2972",
    "name": "More Dnyanu Ravaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4515",
    "name": "More Ishwar Vishnu 1403/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13794",
    "name": "More Mukesh Shankar1410/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1370",
    "name": "More Sarjerao Laxman Toli-229-47"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14517",
    "name": "More Tanaji Parbati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4505",
    "name": "More Vasant Shitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5377",
    "name": "More Vasant Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12833",
    "name": "Mukhtar Ali Mahamad Yakub"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1543",
    "name": "Mulik Marutirao Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8110",
    "name": "Musale Anita Prbhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7510",
    "name": "Nalage Vasant Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18226",
    "name": "Nikam  Vithal Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "128",
    "name": "Nikam Dyaneshwar Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11802",
    "name": "Nikam Jalinder R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7569",
    "name": "Nikam Kalyan Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7270",
    "name": "Nikam Premlata Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17610",
    "name": "Nimbalkar Himat Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8472",
    "name": "Nimbalkar Satish Jagdeorao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14098",
    "name": "Nimbalkar Tulshiram Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7627",
    "name": "Nimbalkar Vitthal Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7628",
    "name": "Nimbare Harichandra Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6964",
    "name": "Panchage Prakash Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15384",
    "name": "Pandey Vijayshankar V. 770/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10322",
    "name": "Pandia Rajendra Nagraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10533",
    "name": "Parte Ankush Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15629",
    "name": "Patel Geeta Jaykumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8338",
    "name": "Pathan Abdul Raheman Baitulla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9153",
    "name": "Patil Baban Dyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15657",
    "name": "Patil Babaso Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13740",
    "name": "Patil Mohan Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17773",
    "name": "Patil Pandurang Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11784",
    "name": "Patil Yuvaraj Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17392",
    "name": "Pawar  Mangal Sadashiv ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9224",
    "name": "Pawar  Vyankat  Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11476",
    "name": "Pawar Aatmaram Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16245",
    "name": "Pawar Ashok Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14246",
    "name": "Pawar Balaram Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15736",
    "name": "Pawar Maruti Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11681",
    "name": "Pawar Popat Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14104",
    "name": "Pawar Prakash Dnyanu.."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6046",
    "name": "Pawar Ramchandra Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3468",
    "name": "Phalake Ashok Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5289",
    "name": "Phalke Dattu Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2705",
    "name": "Pingale Nanda Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8119",
    "name": "Pisal Himmat Hanmantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1631",
    "name": "Pisal Jaywantrao Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11474",
    "name": "Pisal Prakash Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2322",
    "name": "Pisal Ramchandra Jagdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2563",
    "name": "Pisal Shankarrao Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6377",
    "name": "Poddar Vinod Kumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5836",
    "name": "Pujari Dattatrey Nagesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8782",
    "name": "Purohit Ambalal J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7066",
    "name": "Purohit Dineshkumar Chamnaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13705",
    "name": "Purohit Govindram H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4773",
    "name": "Purohit Mangalsiha Walsihaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17794",
    "name": "Purohit Pukhraj Hakamji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12413",
    "name": "Purohit Shankerlal Ukaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8198",
    "name": "Raghavan Pramila Shaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19896",
    "name": "Ramane Babya Panurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6984",
    "name": "Rathod Jagdish B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "948",
    "name": "Sabale Eknath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "725",
    "name": "Sabale Ramchandra Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "918",
    "name": "Sabale Yamuna Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8164",
    "name": "Sagarmal Shakuntala Ben"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "921",
    "name": "Said Vithal Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3984",
    "name": "Sakpal Sampat Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17985",
    "name": "Salket Rambulan Lachhu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18292",
    "name": "Salunkhe Ashok Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10309",
    "name": "Salunkhe Shrirang Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11019",
    "name": "Sanghavi Kirankumar Achalchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15069",
    "name": "Sapkal Narayan Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5100",
    "name": "Sapkal Shivaji Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4798",
    "name": "Sarkale Dadasaheb Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10152",
    "name": "Saroj Premchand Pumzangai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3619",
    "name": "Saste Vyankat Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14548",
    "name": "Savadkar Sadhu B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1414",
    "name": "Sawant Jagannath Bapuji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15230",
    "name": "Sawant Ramesh Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12860",
    "name": "Shah Ragini Gunvant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15087",
    "name": "Shaikh Ajamali Razakmohammed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13400",
    "name": "Shaikh Mohamad Hadis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "630",
    "name": "Shashikant Atamaram Kandalgoankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7312",
    "name": "Shedage Hanmant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6751",
    "name": "Shelar Baburao Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18984",
    "name": "Shetty Prakash Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8499",
    "name": "Shibe Tukaram Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9373",
    "name": "Shikalgar Basir Balbhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6021",
    "name": "Shimpi Murlidhar Shriram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16319",
    "name": "Shinde Bhushan Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1540",
    "name": "Shinde Hanmant Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "333",
    "name": "Shinde Himmat Malharrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10688",
    "name": "Shinde Narayan Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9891",
    "name": "Shinde Navnath Genba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2078",
    "name": "Shinde Ramchandra Genu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "257",
    "name": "Shingan Atamaram Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6654",
    "name": "Shivthare Shivaji Yodha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9538",
    "name": "Sidhwant Jaidevi Bhagwandas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16214",
    "name": "Sing Rajendra Babulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11021",
    "name": "Singhi Jaichand Maganlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14295",
    "name": "Solanki Mohammad Sabir M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5789",
    "name": "Solaskar Murlidhar Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8095",
    "name": "Sonawale Raosaheb Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16626",
    "name": "Soni Nandsingh Dhansingh."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9881",
    "name": "Supnekar Maruti Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4981",
    "name": "Surve Dinkar Savala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2404",
    "name": "Suryawanshi Vithalrao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2875",
    "name": "Tambave Navtarun Utkarsha Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13424",
    "name": "Tarade Sanjay Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17930",
    "name": "Tawade Nitin Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20139",
    "name": "Tawade Vikrant Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9823",
    "name": "Thimbare Dattarey Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9130",
    "name": "Thombre Laxman Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7001",
    "name": "Thosani Dilip H"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16572",
    "name": "Vaidha Vitthal Gokul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17662",
    "name": "Varma Bhagwanadevi Ramdulare"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18560",
    "name": "Varma Major Suvadin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10374",
    "name": "Wagh Bajirao Sadhu  481/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5471",
    "name": "Yadav Dashrath Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16788",
    "name": "Yadav Rampayre Jayjayram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5208",
    "name": "Yadav Sadashiv Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12316",
    "name": "Yadav Santaram Budhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5503",
    "name": "Yadav Tufani Ramlaut"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16955",
    "name": "Yamkar  Gangaram  Bhagoji ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9949",
    "name": "Yedage Baburao Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16629",
    "name": "Yelkar Rajendra Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "398",
    "name": "Yelve Sakharam Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7310",
    "name": "Yewale Dilip Vishnupant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8057",
    "name": "Yewale Ghansham Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3495",
    "name": "Shinde Mohan Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5355",
    "name": "Shigvan Shripati Goroji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5406",
    "name": "Panday Bharat Bhushan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11682",
    "name": "Dige Baban Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12965",
    "name": "Khan Haniuddin Sabuddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10765",
    "name": "Awate Bhalchandra Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11300",
    "name": "Ingawale Sadashiv Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6630",
    "name": "Aawate Sukaji Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18024",
    "name": "Adsare Ganesh Dnyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10269",
    "name": "Agade Tukaram Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1551",
    "name": "Ahirekar Babasaheb Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4529",
    "name": "Anapat Shivaji Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7837",
    "name": "Anpat Nanda Dattatraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7656",
    "name": "Anpat Narayan Ekanath 260/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11871",
    "name": "Anute Anusaya Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4478",
    "name": "Anute Nana Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8122",
    "name": "Asha Trust"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17238",
    "name": "Awchar  Shaliwan  Khashaba ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1641",
    "name": "Baarve Sambhaji Ananta"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17027",
    "name": "Bavadekar  Laxman Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5029",
    "name": "Bhagwat Dilip Waghu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15750",
    "name": "Bhilare Mansingh Jagnnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "546",
    "name": "Bhoite Anandrao Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9479",
    "name": "Bhoite Mahadev Kundalik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15724",
    "name": "Bhoite Sushila Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10975",
    "name": "Bhosale Raghunath Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14006",
    "name": "Bobade Nanda Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3142",
    "name": "Bodake Parshuram Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11892",
    "name": "Bonde Sitaram Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15345",
    "name": "Chalake  Ramesh Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18272",
    "name": "Chalke Shalan Ishwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3332",
    "name": "Chavan Balasaheb Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14014",
    "name": "Chavan Bipin Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11733",
    "name": "Chavan Shankar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11064",
    "name": "Chawan Ramchandra Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6628",
    "name": "Chawan Sakharam Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15671",
    "name": "Choudhari Ramesh Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14859",
    "name": "Chouhan Aasaram Ramnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9744",
    "name": "Chouhan Mohanlal Ramsaran"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15028",
    "name": "Chouhan Rajoi Jawaharlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18308",
    "name": "Chouhan Shamraji Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8324",
    "name": "Chowdhary  Narendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10282",
    "name": "Daga Aswini Thakarmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6149",
    "name": "Dalvi Aatmaram Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "536",
    "name": "Dathave Balkrushna Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10408",
    "name": "Devkar Umesh Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5428",
    "name": "Dhamankar Ananda Dyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8863",
    "name": "Dhebare Sadashiv Waghu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7100",
    "name": "Dhindale Kisan Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6365",
    "name": "Dixit Mahendra Kumar B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11738",
    "name": "Durkar Laxman Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16930",
    "name": "Gadhave  Santosh Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6391",
    "name": "Gaikwad Bhagwan Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11099",
    "name": "Gaikwad Dilip Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4535",
    "name": "Gaikwad Pundalik Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8452",
    "name": "Gaikwad Vijay Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18830",
    "name": "Gavade Sanjay Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9007",
    "name": "Gawada Balaram Chiki"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12938",
    "name": "Ghadage Dipak Dharmu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18624",
    "name": "Ghadage Namdev Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3374",
    "name": "Ghadage Shivaji Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3610",
    "name": "Ghadage Uttamrao Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9204",
    "name": "Ghanekar Ganpat Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3561",
    "name": "Ghorpade Atmaram Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6299",
    "name": "Godamba Chandru Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11950",
    "name": "Gole Yashwant Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17356",
    "name": "Gole Yashwant Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2485",
    "name": "Gujar Nivrutti Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14096",
    "name": "Gurav Prakash Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18741",
    "name": "Guthale Punyavan Harishchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11906",
    "name": "Ingale Dnyaneshwar Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8246",
    "name": "Isak Babu Shekh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15708",
    "name": "Jadhav Hindurao Baba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15490",
    "name": "Jadhav Umesh Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1898",
    "name": "Jagatap Jijyaba Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9617",
    "name": "Jagtap Gopal Parasram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1503",
    "name": "Jagtap Ramesh Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9957",
    "name": "Jain  Kesodas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5130",
    "name": "Jain Dhapubai Mishrimalaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10628",
    "name": "Jain Rameshkumar Babulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8989",
    "name": "Jain Sukan Ray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14988",
    "name": "Jaiswal Ramsamuj Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8799",
    "name": "Jinjal Sakharam Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11545",
    "name": "Joshi Shankar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12078",
    "name": "Kadale Rajendra Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2816",
    "name": "Kadam Appasaheb Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6175",
    "name": "Kadam Babu Savala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "995",
    "name": "Kadam Dinkar Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13871",
    "name": "Kadam Hanmant Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3758",
    "name": "Kadam Hariba Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15664",
    "name": "Kadam Parushram Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7667",
    "name": "Kadam Popat Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15501",
    "name": "Kadam Pramod Ankush."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6125",
    "name": "Kadam Ramchandra Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18494",
    "name": "Kadam Sadahna Deepak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11897",
    "name": "Kajari Mahadeo Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "364",
    "name": "Kakde Sadashiv Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9649",
    "name": "Kale Ravindra Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7015",
    "name": "Kamble Dyanand Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6738",
    "name": "Kashyap  Harikrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9115",
    "name": "Katkar Ajit Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8934",
    "name": "Kavankar Ramdas Atmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17170",
    "name": "Khan  Chotu  Habibulla  ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8362",
    "name": "Khan Hubdar Moh Basant 211/B/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11629",
    "name": "Khot Biru Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2202",
    "name": "Korade Dnyandev Ganu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11645",
    "name": "Lalwani Shripal T"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7299",
    "name": "Lawale Gulabrao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "761",
    "name": "Lembhe Sampat Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3389",
    "name": "Lembhe Uttam Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3195",
    "name": "Lotake Bapu Vithu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12269",
    "name": "Lotale Pandurang Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13389",
    "name": "Mandhare Usha Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9684",
    "name": "Mane Hari Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11334",
    "name": "Mane Vithal Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6449",
    "name": "Matre  Bandu Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10167",
    "name": "Merot Khemraj D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15299",
    "name": "Mirmal Durgashankar Binadin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3067",
    "name": "Mishra Jaganprasad Jagatnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11765",
    "name": "Modak Maruti Hari."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11675",
    "name": "Mohite  Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12920",
    "name": "More Anandrao Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "134",
    "name": "More Balkrushna Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13859",
    "name": "More Bhiku Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4339",
    "name": "More Ganpat Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19641",
    "name": "Mulik Sachin Balaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4483",
    "name": "Mulik Shankar Ganu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5197",
    "name": "Mulik Shankar Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16613",
    "name": "Nalawade Nilesh Mohan."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3471",
    "name": "Nanavare Laxman Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15106",
    "name": "Nikam Dnyandeo Bapurao  878-13"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8583",
    "name": "Nikam Mahadev Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4469",
    "name": "Nimbalkar Balasaheb Yashvant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11787",
    "name": "Nimbalkar Madhukar Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3438",
    "name": "Nimbalkar Vilas Nilkantha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3361",
    "name": "Padale Vijay Krushnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8674",
    "name": "Palsamkar Rukhmini Vitthal/Vitthal Laxma"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13514",
    "name": "Parkar Kishore H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13456",
    "name": "Patil Arun Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15920",
    "name": "Patil Bajrang Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10261",
    "name": "Patil Dilip Rajaram    430/10"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10969",
    "name": "Patil Hirabai Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23738",
    "name": "Patil Jyoti Keshrinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10827",
    "name": "Patil Pandurang Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9809",
    "name": "Patil Prakash Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3715",
    "name": "Patil Tukaram Dnandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1305",
    "name": "Patil Vithal Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1993",
    "name": "Pawar Anandrao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5745",
    "name": "Pawar Balwant Aakoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10461",
    "name": "Pawar Bharat Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3518",
    "name": "Pawar Sarjerao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2761",
    "name": "Pawar Shantaram Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6405",
    "name": "Pawar Tanaji Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12449",
    "name": "Pawar Yashoda Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2638",
    "name": "Phadkar Dnyanu Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5854",
    "name": "Pisal Ravindra Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7535",
    "name": "Pol Lahu Maruti  329/42"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5232",
    "name": "Pol Shrirang Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18998",
    "name": "Potwade Sampat Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13698",
    "name": "Purohit Kapuraram Juharmalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10768",
    "name": "Purohit Khimsingh H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10428",
    "name": "Purohit Khushabu Kishore"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5903",
    "name": "Purohit Mansalal Dolaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "149",
    "name": "Raje Dhondiram Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7561",
    "name": "Rajput Premsing H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2138",
    "name": "Ranware Vithal Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14554",
    "name": "Retharekar Avinash Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2548",
    "name": "Sabale Shankar Datta.386/10"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9693",
    "name": "Sadikmia  M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12968",
    "name": "Sahani Lalaji Hariram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17982",
    "name": "Saket Katahur Jagganath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "487",
    "name": "Salate Bhimrao Antu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10217",
    "name": "Sawant Ananda Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13658",
    "name": "Sawant Suresh Janardan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3225",
    "name": "Sawant Tukaram Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6008",
    "name": "Shah Keshavji Goshar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14440",
    "name": "Shaikh Abdul Majid"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13985",
    "name": "Shaikh Maksurali Nashibulla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8942",
    "name": "Shaikh Sadikmestri Nabisahab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4244",
    "name": "Shelar Hanumant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11512",
    "name": "Shibe Laxmi Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18035",
    "name": "Shinde Dattaram Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7270",
    "name": "Shinde Dattatray Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "90",
    "name": "Shinde Gulabrao Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12401",
    "name": "Shinde Hambirrao Jagdeorao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1566",
    "name": "Shinde Hanmant Aatmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16749",
    "name": "Shinde Shobha Hanumant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1847",
    "name": "Shinde Tukaram Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16373",
    "name": "Shinde Vikas Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9767",
    "name": "Solaskar Ganpat Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18423",
    "name": "Sonake Yashoda Shyamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13227",
    "name": "Sonawale Vinayak Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15498",
    "name": "Soni Shearsing Dhansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1361",
    "name": "Suryawanshi Parshuram Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15118",
    "name": "Sutar Shamrao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11033",
    "name": "Sutar Subhash Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7142",
    "name": "Tate Vaman Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15077",
    "name": "Tawar Dilip Vittal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10939",
    "name": "Toraskar Suresh Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5301",
    "name": "Varma Shobhadevi Devnarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13453",
    "name": "Varma Shraddha Devnarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8194",
    "name": "Vyas Mahesh J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13116",
    "name": "Yadav Balkrishna Ramnayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3565",
    "name": "Yadav Fakkad Pancham"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4620",
    "name": "Yadav Gajanan Vithalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11771",
    "name": "Yadav Salikram Kanahiyalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15801",
    "name": "Yadav Satish Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14854",
    "name": "Yadav Shivpujan Bhagwati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3593",
    "name": "Yadav Vishnu Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23667",
    "name": "Nalage Ajay Uttam"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1096",
    "name": "Singh Karan Pahila"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4283",
    "name": "Aahirekar Uttam Bajrang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14081",
    "name": "Achale Balasaheb Rambhau."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11696",
    "name": "Ahuja Veena Veena"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8869",
    "name": "Anthony  Selvaraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4967",
    "name": "Babar Shripati Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16794",
    "name": "Bagal Bhimrao Anandrao."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14549",
    "name": "Barai Aniram Baledin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8419",
    "name": "Bhilare Baban Baburao 631/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5373",
    "name": "Bhoite Narayan Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12994",
    "name": "Bhosale Shankar Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15403",
    "name": "Bhosale Vidya Kundalik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2709",
    "name": "Bhosale Vishwas Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4084",
    "name": "Bobade Trimbak Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18535",
    "name": "Bole Sidesh Rajendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "509",
    "name": "Chaturvedi Lalna Prasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10776",
    "name": "Chaudhari Shrirang Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2430",
    "name": "Chavan Hindurao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12314",
    "name": "Chavan Ramchandra Gauri"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12451",
    "name": "Chavan Umesh Hanmantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16538",
    "name": "Chawan Shalan Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9691",
    "name": "Chouhan Tehal Beghul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12518",
    "name": "Dagade Balaso Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8142",
    "name": "Dalvi Sitabai Ramchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10074",
    "name": "Daphale Bapu Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12759",
    "name": "Daphale Rajaram Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7352",
    "name": "Desai Vasantrao Keru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15173",
    "name": "Dhere Shankar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11693",
    "name": "Dhumal Balasaheb Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "679",
    "name": "Dhumal Murlidhar T. A-2047"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10399",
    "name": "Doiphode Jaywant Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11100",
    "name": "Domb Rajaram Sona"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6487",
    "name": "Gaikwad  Madhukar Balwantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5204",
    "name": "Gaikwad Popat Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10709",
    "name": "Gaikwad Sangeeta Rohidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10608",
    "name": "Gaikwad Shripati Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7424",
    "name": "Ghadge Bhanudas Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11206",
    "name": "Gole Chagan Kisanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6672",
    "name": "Gujar Chandramal Vevechanji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9958",
    "name": "Gupta  Veersain"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11372",
    "name": "Harijan Arahadevi Rammilan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17940",
    "name": "Ithape Shakuntala Janardhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10056",
    "name": "Jadhav Ashok Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7516",
    "name": "Jadhav Balu Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7305",
    "name": "Jadhav Dnyandeo Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12030",
    "name": "Jadhav Hanmant Bhiwaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5947",
    "name": "Jadhav Kisan Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2724",
    "name": "Jadhav Shamrao Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6555",
    "name": "Jagdale Gulab Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8414",
    "name": "Jain Paxal Babulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8943",
    "name": "Jain Rameshbhai B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9892",
    "name": "Javarat Santosh Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1422",
    "name": "Jengid Manek Sataji."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17355",
    "name": "Joiel Vijay Kashinath ."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11230",
    "name": "Joshi Shankarlal Dhaniram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10105",
    "name": "Kadam Dadaso Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10706",
    "name": "Kadam Sampat Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2326",
    "name": "Kadav Baburao Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11499",
    "name": "Kakade Shivaji Digambar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14613",
    "name": "Kalamkhan Ayubkhan Abdul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16163",
    "name": "Kapad Bazar Mathadi & Janaral  Kamgar Un"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13172",
    "name": "Kapase Prakash Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4416",
    "name": "Khanekar Raghunath Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4237",
    "name": "Khicha Mohan Bai M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6730",
    "name": "Khivsara Ratnamala Hiralal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14023",
    "name": "Khopade Dnyanoba Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10799",
    "name": "Khopade Ramdas Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8760",
    "name": "Khot Shivaji Sawala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2143",
    "name": "Kochale Aatmaram Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18065",
    "name": "Kolekar Malan Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2260",
    "name": "Kolekar Maruti Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14419",
    "name": "Loniya Panchram Jagmohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "502",
    "name": "Malusare Ananda Balkrushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15179",
    "name": "Mane Adhikrao Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8692",
    "name": "Mane Nishikant Dnyanojirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11486",
    "name": "Mane Pralhad Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18200",
    "name": "Mane Vikram Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16727",
    "name": "Marathe Prakash Vishnu."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2321",
    "name": "Maskar Kanta Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2587",
    "name": "Maskar Yeshwant Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14298",
    "name": "Matre Sakharam Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11858",
    "name": "Maye Kantabai Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4727",
    "name": "More Atmaram Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1265",
    "name": "More Baban Ramchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4930",
    "name": "More Shrirang Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21082",
    "name": "Mourya Ramprakash Hiralal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12970",
    "name": "Mulik Anil Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7495",
    "name": "Mulik Baliram Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14204",
    "name": "Mulik Keshav Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9257",
    "name": "Mumtaz Jabir Mohd."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7560",
    "name": "Nalawade Shankar Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15723",
    "name": "Nalwade Sanjay Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6633",
    "name": "Nawadkar Bhagwan Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8906",
    "name": "Nawadkar Hindurao Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11436",
    "name": "Nevase Prabhakar Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18230",
    "name": "Nikam Anusaya Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6151",
    "name": "Nikam Pandurang Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6204",
    "name": "Nikam Ratan Sarjerao 1172/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15512",
    "name": "Nikam Shrirang Balvant Toli No.1439/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13203",
    "name": "Nikam Uttam Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15874",
    "name": "Pande Anant Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18182",
    "name": "Patil Manohar Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7651",
    "name": "Pawar Ananda Chandru 659/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10046",
    "name": "Pawar Gulabrao Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19494",
    "name": "Pawar Rajesh Dattatraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7540",
    "name": "Pawar Ramchandra Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12351",
    "name": "Pawar Sarjerao Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11105",
    "name": "Pillai Perumal Ramswamy"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1559",
    "name": "Pol Dagadu Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7525",
    "name": "Purohit Laxman Gomath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15727",
    "name": "Purohit Shaitansingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10607",
    "name": "Rathi G B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3407",
    "name": "Sabale Baban Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14625",
    "name": "Said Anna Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18017",
    "name": "Saket Vishwanath Lachu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2889",
    "name": "Sakunde Pandharinath Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3454",
    "name": "Salunkhe Baban Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "669",
    "name": "Salunkhe Maruti Bhairu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7267",
    "name": "Sangale Dilip Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16259",
    "name": "Saraphadar Dhyandev Janu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15448",
    "name": "Sawant Ananda Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10594",
    "name": "Sawant Dattatray Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "533",
    "name": "Sawant Haribhau Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7584",
    "name": "Sawant Raosaheb Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11264",
    "name": "Shewale Satwasheela Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1762",
    "name": "Shibe Tukaram Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10412",
    "name": "Shilimkar Vilas Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4387",
    "name": "Shinde  Vilas Anandarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1198",
    "name": "Shinde Anandrao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1734",
    "name": "Shinde Baburao Harishchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1325",
    "name": "Shinde Eknath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11749",
    "name": "Shinde Khashaba Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6375",
    "name": "Shinde Laxman Khandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1047",
    "name": "Shinde Maruti Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "942",
    "name": "Shinde Maruti Deoram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "952",
    "name": "Shinde Pralhad Yeshwantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16669",
    "name": "Shinde Shankar Dyandeo."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4557",
    "name": "Shinde Shivaji Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8178",
    "name": "Shinde Sudam Parasram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1367",
    "name": "Shinde Viswas Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11419",
    "name": "Shukla Ayodhya Prasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9815",
    "name": "Soni Omprakash Brijbhushan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2094",
    "name": "Tarun Vikas Mandal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6988",
    "name": "Varekar Laxman Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "172",
    "name": "Wagh Mansingh Mukundrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "182",
    "name": "Wagh Mugat Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12387",
    "name": "Yadav Amarjeetkaur Ajaykumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6936",
    "name": "Yadav Anandrao Jagannath."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14563",
    "name": "Yadav Dilipkumar Ramsunder"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13375",
    "name": "Yadav Suresh Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7899",
    "name": "Yadav Tanaji Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1415",
    "name": "Yadav Yashwant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2744",
    "name": "Yewale Vithal Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1385",
    "name": "Zagadu  Mangaram Rajbhar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24272",
    "name": "Bhoir Narayan Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21920",
    "name": "Panchal Rajesh Bhailalbhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18289",
    "name": "Chibade Ananda Dnanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7112",
    "name": "Kemase Bharat Sadhu 732/4"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9809",
    "name": "Parkar Deepak Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20436",
    "name": "Rokade Ajay Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13532",
    "name": "Teli Sudhakar Dhondu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "824",
    "name": "Jha Jayshankar Rambulash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8210",
    "name": "Bhoite Pralhad Dhansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17672",
    "name": "Chalke Ramesh Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6559",
    "name": "Gaikwad Ramesh Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7995",
    "name": "Nalawade Prakash Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11388",
    "name": "Patil Sampat Hariba"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2075",
    "name": "Jain Premchand Kasturchand."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21992",
    "name": "Rajput Beena Pramesh"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2638",
    "name": "Jayempee Cration"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17630",
    "name": "Vishwakarma Sanjay Lalchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13821",
    "name": "Adsul Uttam Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17093",
    "name": "Annsari Aabadul Najir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9547",
    "name": "Gharge Shankar Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16077",
    "name": "Pawar Bhima Mahadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9631",
    "name": "Pradhan Gyan Nath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9840",
    "name": "Reddy G Nagi"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2237",
    "name": "Jyoti Detective Services"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15788",
    "name": "Dhumal Chandrakant Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21389",
    "name": "Sabu Babool Kamdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18484",
    "name": "Jadhav Mahendra Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16161",
    "name": "Dhumal Datta Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14145",
    "name": "Ghodake Kanchan Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22415",
    "name": "Shah Manish Pramod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24703",
    "name": "Yadav Dilipkumar Bachuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3955",
    "name": "Shinde Hindurao Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2365",
    "name": "Matkar Vasant Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18198",
    "name": "Nangare Vishnu Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16151",
    "name": "Kadav Ananda Kisan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2880",
    "name": "Gardi Shashank Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12545",
    "name": "Bobade Prabhakar Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21195",
    "name": "Mankar Bharat Dattaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "233",
    "name": "Tarai Santosh Gaurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17739",
    "name": "Nikam Machindra Dattatrya"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1528",
    "name": "Mandavkar Balu Tukaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "792",
    "name": "Vhavale Baban Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10027",
    "name": "Oza Manoharlal Babulal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21636",
    "name": "Chikate Shashikant Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5017",
    "name": "Gole Vithal Rajaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "656",
    "name": "Mohanti Jayant Narahari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24869",
    "name": "Patil Nisha Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19126",
    "name": "Kokekar Vaman Babasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18529",
    "name": "Shedage Santosh Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15065",
    "name": "Bhosale Gunwant Vithal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2183",
    "name": "Mourya Kamlesh Ramugrah"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1172",
    "name": "Godse Rekha Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23653",
    "name": "Tarde Ganesh Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16257",
    "name": "Igwe Pandurang Ramkrishna"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1149",
    "name": "Sonone Ramrao Sakharam"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1353",
    "name": "Masne Mahendra Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14933",
    "name": "Kadam Priyanka Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23643",
    "name": "Nalawade Rohini Dadasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15105",
    "name": "Shelar Ankush Pandurang."
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1314",
    "name": "Jadhav Santosh Pandurang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "848",
    "name": "Chaudhari Sunil Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18128",
    "name": "Pisal Vijaya Pradeep"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5765",
    "name": "Mulik Pratap Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20606",
    "name": ".Bhanushali Pramod Sevak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22164",
    "name": "Hirve Dipali Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17473",
    "name": "Kadam Subhash Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22028",
    "name": "Sharma Kamaladevi Gulabchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18180",
    "name": "Baniya Bhavesh Jagdish"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14830",
    "name": "Jamadar Zahir Ahamad"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "858",
    "name": "Salunke Lahu Sayaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "969",
    "name": "Sonar Saraswati Ransigh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20072",
    "name": "Panchal Dinesh A"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2598",
    "name": "Salunkhe Namdeo Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21750",
    "name": "Babar Pandurang Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2174",
    "name": "Mahangade Baban Dharmaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "412",
    "name": "Shetty Suresh Sanjeeva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23634",
    "name": "More Shashikant Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6775",
    "name": "Jadhao Satish Gorakhanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20995",
    "name": "Beg Maqbool Gafoor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22441",
    "name": "Bhoite Sambhaji Shivaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "761",
    "name": "Das Pareshkumar D"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "365",
    "name": "Patil Ashwini Rambhau"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "915",
    "name": "Upadhyay Pankajkumar Jagdambaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19584",
    "name": "Patel Jitendra Maganlal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "661",
    "name": "Momin Shanaz Nasir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20500",
    "name": "More Dilip Dagdu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2118",
    "name": "Bhosale Kalidas Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17439",
    "name": "Choudhari Jeevan Shankar/Snehal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11995",
    "name": "Pisal Namdeo Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14801",
    "name": "Bhoite Mohan Vitthalrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20215",
    "name": "Karekar Siddhesh Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24888",
    "name": "Mendonsa Peter Silvester Peter Silvester"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1597",
    "name": "Pandey Brijesh Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13410",
    "name": "Pednekar Bharti Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20592",
    "name": "Kasar Pranaya Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20496",
    "name": "Karande Vijay Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24680",
    "name": "Joshi Jagdishchandra Bherulal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "657",
    "name": "Chavan Arjun Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14301",
    "name": "Desai Rahul Shivajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22930",
    "name": "Vaidya Mahendra Jayvant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19794",
    "name": "Yadav Jangbahadur Ramphal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19615",
    "name": "Mohmad Salim Mohmad Naim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24211",
    "name": "Kawale Ramesh T."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19651",
    "name": "Kadam Yuraj Dattu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15086",
    "name": "Chavan Dilip Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22322",
    "name": "Kenjale Ganesh Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20100",
    "name": "Surve Sangeeta Jaywant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1982",
    "name": "Dube Rupeshchand Mahendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16423",
    "name": "Jadhav Dinker Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17051",
    "name": "Waghmare Ashok Ganpat"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "168",
    "name": "Gaikwad Jyotsna Sachin"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "953",
    "name": "Sapkal Arun Hanumant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "865",
    "name": "Gaikwad Sunita Genba"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "789",
    "name": "Jadhav Rajendra Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17899",
    "name": "Kewat Dalsinger Mansu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20790",
    "name": "More  Shrirang Vitthal."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5700",
    "name": "Jadhav Tanaji Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18412",
    "name": "Jadhav Suchita Shantaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "622",
    "name": "Botre Sumitra Jaysing"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "659",
    "name": "Baraf Seema Yuvraj"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "781",
    "name": "Lambor Dhondia Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14150",
    "name": "Sabale Puindlik Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3937",
    "name": "Gole Vithal Rajaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1853",
    "name": "Ansari Nafees Ahmed"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "962",
    "name": "Idrisi Moinuddin Abdul Hamid"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "837",
    "name": "More Vijay Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23864",
    "name": "Pawar Dipali Sunil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18654",
    "name": "Pawar Anil Vithal Toli No-174/19"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14047",
    "name": "Bhingardeve Vishal Ramaswami"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "362",
    "name": "Mali Lalita Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19781",
    "name": "Ghanekar Tukaram Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23327",
    "name": "Tiwari Manoj Vijayshankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23975",
    "name": "Bhanat Shankar Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23965",
    "name": "Gole Sunil Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24539",
    "name": "Kadam Shantaram Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22483",
    "name": "Shaikh Rubina Maqsood"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22484",
    "name": "Shaikh Sajidabegam Lalmahammad"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2598",
    "name": "Kashish Metal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1773",
    "name": "Patwardhan Jitendra Sharadchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20162",
    "name": "Pawar Gautam Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21283",
    "name": "Pawar Ashok Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2283",
    "name": "Bhoite Ankush Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23875",
    "name": "Borge Shivaji Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22455",
    "name": "Vora Kalpesh Kishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18677",
    "name": "Bhosale Samadhan Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23854",
    "name": "Barje Prabhakar Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22447",
    "name": "Ghadi Manasi Milind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23839",
    "name": "Nawadkar Dadasaheb Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23841",
    "name": "Pawar Vanita Santosh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22452",
    "name": "Shelar Kailash Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22440",
    "name": "Avishkar Sports Club"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "970",
    "name": "Kadam Rupesh Suresh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "966",
    "name": "Tarade Vishranti Ganseh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21202",
    "name": "Chauhan Rakeshkumar R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22428",
    "name": "Baswant Babu Hanumant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "368",
    "name": "Kulkarni Manjiri Shriram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16522",
    "name": "Dhuriya Manjitkumar Ramsagar."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20637",
    "name": "Ghadigaonkar Harshad Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22074",
    "name": "Kadam Janaki Satyawan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "957",
    "name": "Shelar Santosh Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9927",
    "name": "Gaikwad Krishna Narayan"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3271",
    "name": "Kedia Dharmendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20103",
    "name": "Kadam Sachin Shankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1086",
    "name": "Kinare Vikas Kashinath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1652",
    "name": "Sarvade Vasant Dnyanoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22404",
    "name": "Singh Shitalaprasad Zuru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24403",
    "name": "Jagtap Amol Vishwas"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "940",
    "name": "Vajekar Suresh Changa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23349",
    "name": "Shinde Sachin Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19729",
    "name": "Baraskar Vijay Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20088",
    "name": "Manoj Topandas Khanchandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22328",
    "name": "Kamble Anand Dattu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22335",
    "name": "Khaire Anandkumar Janardhan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "379",
    "name": "Shilewant Deepali Rahul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22329",
    "name": "Tambe Anand Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24234",
    "name": "Bhuwad Ramesh Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19920",
    "name": "Kadam Vijay Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19921",
    "name": "Khobragade Amol Prakash"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "653",
    "name": "Aher Rina Rajendra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "899",
    "name": "Dhukate Amol Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22288",
    "name": "Majalkar Saroj Santosh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "898",
    "name": "Raut Vilas Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15005",
    "name": "Sabale Tanaji Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22046",
    "name": "Shinde Harshada Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22286",
    "name": "Shinde Suryakant Jaysingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17926",
    "name": "Dube Pradeep Shrinarayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2563",
    "name": "Thakare Anil Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19880",
    "name": "Yadav Ramugrah Satiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13758",
    "name": "Pawar Leelawati Dattatray."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20853",
    "name": "Shah Salim Rasul"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "230",
    "name": "Jagdale Manohar Dadaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24059",
    "name": "Patil Pooja Jaywant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14718",
    "name": "Raje Balu Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11084",
    "name": "Naik Premanand Rajaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1639",
    "name": "Chohan Dattaram Deepak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22237",
    "name": "Kadam Poonam Sachin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17315",
    "name": "Jagtap Subhash Sadashiv ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15609",
    "name": "Nawadkar Rani Bhanudas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1501",
    "name": "Yadav Sangram Satish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21874",
    "name": "Dhumal Shushant Devidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23265",
    "name": "Mestry Ashok Chintaman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22309",
    "name": "Khaire Anant Sudkoji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22311",
    "name": "Khopkar Dhondiram Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22310",
    "name": "Sawant Ravindra Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4643",
    "name": "Bhusane Sachin Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14328",
    "name": "Sawant Aarti Ashok"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "310",
    "name": "Khandelwal Construction"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "555",
    "name": "Bhoite Sangita Chandrakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "423",
    "name": "Kale Mangal Ratnakar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "869",
    "name": "Mahato Murlidhar Dhaneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10748",
    "name": "Wagh Asha Hanmantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20519",
    "name": "Gracias Agnelo Wolfango John"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18020",
    "name": "Pawar Shalini Ganesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10589",
    "name": "Murav Rajaram (Budhu)"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15928",
    "name": "Chavan Vijaysing Ramchandra."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20272",
    "name": "Rahate Shobha Bhargav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19433",
    "name": "Yadav Somnath Siyaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2102",
    "name": "Tiwari Mahendra Prasiddhanarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "400",
    "name": "Wagh Bajirao Sadhu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8157",
    "name": "Jagtap Namdeo Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17740",
    "name": "Sawant Babanrao Ekanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22143",
    "name": "Almieda Steven John."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18657",
    "name": "Pawar Balu Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18807",
    "name": "Mangal Bandu Malusare"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22235",
    "name": "Khopade Seema Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7711",
    "name": "Shankar Tukaram Phalke"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1072",
    "name": "Adivade Maruti Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7027",
    "name": "Kadam Ramchandra Baburao Toli No-4158/8"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "266",
    "name": "Kiran Traders"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16200",
    "name": "Sawant Mohan Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7589",
    "name": "Sakunde Shahji Madhav 239/20"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14162",
    "name": "Varma Giripal Subheran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14907",
    "name": "Adhate Namdev Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17864",
    "name": "Mahida Hasmukh Kishor."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23653",
    "name": "Patil Adveta Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19700",
    "name": "Saware Ganesh Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20528",
    "name": "Jadhav  Mahesh  Anant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1015",
    "name": "Pawar Sunil Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19834",
    "name": "Kadam Sachin Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15149",
    "name": "Gujar Parshuram Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9262",
    "name": "Mujawar Hajimoiddin Allauddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3394",
    "name": "Bhosale Laxman Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1576",
    "name": "Chile Premnath Ganu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14226",
    "name": "Raut Vijaykumar Nandkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15897",
    "name": "Parikh Manaharlal Ashalal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "95",
    "name": "Jaiswal Prakash Daljeet"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19852",
    "name": "Rai Birendra Indrasen"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18927",
    "name": "Dalvi Pandurang Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19137",
    "name": "Medhe Sanjay Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12517",
    "name": "Thavare Sadanand Kaluram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16662",
    "name": "Modak Ashok Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23798",
    "name": "Jain Manish Mahendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1634",
    "name": "Khopade Ashok Wamanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19940",
    "name": "Malusare Kavita Bandu"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "291",
    "name": "Kunal Transportp"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1572",
    "name": "Deshmukh Ashwini Sambhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21979",
    "name": "Ram Vijay Ramdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22229",
    "name": "Waghela Rituja Chandrakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1147",
    "name": "Varma Santoshkumar Chandraprakash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "798",
    "name": "Bhoite Sachin Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8114",
    "name": "Shingate Gulab Nilubhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20584",
    "name": "Shetty Rekha Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17162",
    "name": "Chandurkar Arvind Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23382",
    "name": "Jadhav Vilas Dinkar Toli No-756/A/45"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21530",
    "name": "Kadam  Tukaram Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1058",
    "name": "Kewat Hirachand Panchdev"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2238",
    "name": "Mahapatra Dusmanta Akashya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23652",
    "name": "Patil Ayush Manohar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "193",
    "name": "Mali Ramesh Parbhat"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1096",
    "name": "Loke Neha Shankar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1036",
    "name": "Ingole Rahul Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20068",
    "name": "Sapariya Vinod P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19436",
    "name": "Shaikh Yunus Shaikh Moosa"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1913",
    "name": "Chaudhary Kanyadevi Rataramji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11356",
    "name": "Kadam  Anil Sitaram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "65",
    "name": "M R K Motors"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "308",
    "name": "M/S Raigad Developers"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3816",
    "name": "Shingate Shrirang Shankar"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4244",
    "name": "Mahadev Textile Packing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19993",
    "name": "Karawade Hemant S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18447",
    "name": "Sud Milind Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19116",
    "name": "Patel Mohnish Jivanlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14852",
    "name": "Jadhav Dattatray Mahadeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "879",
    "name": "Patel Pradip Kumar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "967",
    "name": "Tarade Ganesh Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20186",
    "name": "Vichare Vinayak Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14819",
    "name": "Shaikh Rashid Sultan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "635",
    "name": "Motibane Ankush Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1112",
    "name": "Hule Santosh Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23853",
    "name": "Joshi Hameer Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19463",
    "name": "Patil Netaji Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20430",
    "name": "Patel Asif Kasam."
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2678",
    "name": "Maharani Tours & Travels"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2065",
    "name": "Agarwal Ranglal Chandmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21738",
    "name": "Kale Randhir Ankush"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3358",
    "name": "Mahaveer Traders"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2170",
    "name": "Mahesh Novelty Stores"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22080",
    "name": "Chalke Akshay Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5859",
    "name": "Sabale Dilip Maruti  380/17"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20672",
    "name": "Kotawadekar Abhijit Rajendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11814",
    "name": "Shinde Duryodhan Marutrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17498",
    "name": "Bhisale Sneha Chandrahas."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20510",
    "name": "Salecha Dhanesh Gautam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7860",
    "name": "Gaikwad Vijaya Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12941",
    "name": "Jadhav Savitra Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17735",
    "name": "Kolekar Vilas Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18825",
    "name": "Kokare Ajay Kondiba"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "916",
    "name": "Bhilare Arjun Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17952",
    "name": "Bhoite Sudhir Tanaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "472",
    "name": "Bharati Ramakant Motilal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1529",
    "name": "Yadav Vikram Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2051",
    "name": "Ambika Ramesh Bharat"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1038",
    "name": "Kadam Jagdish Nathuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22603",
    "name": "Mahatre Sachin Sahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "756",
    "name": "Waragade Shamrao Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20751",
    "name": "Pawar Suresh Ganpat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1251",
    "name": "Valpadas Rambabu Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7883",
    "name": "Kolekar Sadashiv Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "14",
    "name": "Hule Vandana Deepak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14180",
    "name": "Chavan Mahadevrao Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13264",
    "name": "Jagtap Sadashiv Genaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11339",
    "name": "Phalke Deepak Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13029",
    "name": "Patil Pandurang Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10357",
    "name": "Gawade Mohan Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7597",
    "name": "Jadhav Tanaji Kalyanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16358",
    "name": "Bhogvekar Latesh Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13884",
    "name": "Parsekar Shubhsda V"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2197",
    "name": "Manish Motor Works"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "108",
    "name": "Manisuvrat Construction"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22248",
    "name": "Desai Vimal Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12695",
    "name": "Mulik Anil Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4099",
    "name": "Gujar Uttam Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18704",
    "name": "Rane Tejas Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14938",
    "name": "Nalwade Shantaram Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19526",
    "name": "Mahatre Baban Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14533",
    "name": "Dalvi Yashwant Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9901",
    "name": "Kadam Jagannath Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6045",
    "name": "Yadav Joginder Sochan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16474",
    "name": "More Balkrishna Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22333",
    "name": "Sawant Rajkumar Ziphra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17991",
    "name": "Naik Sukhaji Ramchandra"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3822",
    "name": "Mateshwari Parcel Express"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2023",
    "name": "Matharu Enginering Works"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1549",
    "name": "Lakkad Kishor Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14852",
    "name": "Bhagyawant Shrirang Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4071",
    "name": "Ahirekar Subhash Baburo 344/10"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15649",
    "name": "Pande Omnarayan Dinanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21925",
    "name": "Upadhya Shivprasad Hariprasad"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "104",
    "name": "Mauli Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14684",
    "name": "More Shamal Vijay"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3738",
    "name": "Mehata Arun Nathalal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "373",
    "name": "Pawar Tejashree Mangesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17138",
    "name": "Sawant Sadhana Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19589",
    "name": "Shinde Sagar Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19522",
    "name": "Joe Neil D'Cunha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3687",
    "name": "Kadam Devaji Ravaji Tn.698-2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17772",
    "name": "Bhosale Sunil Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7965",
    "name": "Warkhade Vinayak Anna"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1386",
    "name": "Dhanawade Kavita Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23806",
    "name": "Hate Sakshi Sandesh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "783",
    "name": "Yedage Biru Kalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16193",
    "name": "Bodre Adhik Nanaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19877",
    "name": "Shinde Shivaji Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2395",
    "name": "Mhapankar Mukund Vitthal."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2891",
    "name": "Mohite Bharat Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7242",
    "name": "Shah Amisha Bhagwandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15566",
    "name": "Khedekar Usha Vidyadhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18696",
    "name": "Dhamal Amol Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8197",
    "name": "Kambli Sneha Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23341",
    "name": "Desai Deepak Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24169",
    "name": "Singh Ramavati Rampratap"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18142",
    "name": "Kashid Sachin Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20985",
    "name": "Rathod  Rajesh  Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14493",
    "name": "Akeyla Sanjay Lakhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21113",
    "name": "Newalkar Mahesh Kashinath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "428",
    "name": "Zalte Archana Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6886",
    "name": "Sakunde Shahaji Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7566",
    "name": "Chavan Vijay Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12453",
    "name": "More Ananda Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15884",
    "name": "Parab Rahul Suryakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20509",
    "name": "Salecha Manali Gautam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2828",
    "name": "Shinde Shivaji Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20735",
    "name": "Dhamal Sachin Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23588",
    "name": "Chavan Ashok Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7683",
    "name": "Latke Gajanan Shivram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19938",
    "name": "Dhotre Santosh Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11782",
    "name": "Pawar Prakash Narayanrao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1593",
    "name": "Mourya Traders"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "405",
    "name": "Mugipa Road Carrier Mumbai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24196",
    "name": "Salunkhe Vidya Arvind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13935",
    "name": "Chawan Jagannath Vitthalrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14274",
    "name": "Deorukhakar Sunil Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3074",
    "name": "Jagtap Kisan Somaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "229",
    "name": "Gaikwad Vikas Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20791",
    "name": "Verlekar Ekta Pravin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22347",
    "name": "Pawar Sanchita Santosh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15026",
    "name": "Suhas Suresh Sabale"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19547",
    "name": "Shaikh Hanif Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24985",
    "name": "Yadav Tejbahadur Devnath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2799",
    "name": "Pardhi Ranjana Buva"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1331",
    "name": "Khan Rehana Shaukat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20639",
    "name": "Jadhav Sagar Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11644",
    "name": "Jagdale Sandeep Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18655",
    "name": "Pawar Anusaya Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24850",
    "name": "Sawant Anant Shridhar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "955",
    "name": "Singh Manojkumar Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24815",
    "name": "Bhartiya Siyanath Jhulanram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22980",
    "name": "Dalvi Gopal Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24717",
    "name": "Gadda Mulchand Damji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24704",
    "name": "Gaud Brijmohan Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24755",
    "name": "Khan Mohd Muslim Sayyed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24783",
    "name": "Maredia Karimbhai Noorji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24817",
    "name": "Prajapati Pravin Devasi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24752",
    "name": "Raut Devendra Manik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24819",
    "name": "Shaikh Jahid Latif"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17921",
    "name": "Saket Sukhinand Sarjuprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1428",
    "name": "Ayyar Subhash Ramni."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24605",
    "name": "Chavan Bajiranj Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24615",
    "name": "Kisan Narayan Mahale"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22213",
    "name": "Poojari Anand P."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21817",
    "name": "Pote Vinod Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24643",
    "name": "Qureshi Mehandi Hasan Mohd Sharif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24621",
    "name": "Shah Sayed Shif Shaki"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24638",
    "name": "Varma Santoshkumar Ramautar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24657",
    "name": "Yadav Thakurprasad Vishwanath."
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4552",
    "name": "N.B.Chavan & Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11872",
    "name": "Shinde Ashok Sopan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14311",
    "name": "Ghadigoankar Varsha Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24547",
    "name": "Ambre Shyamsunder Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24465",
    "name": "Gangavane Bhagawan Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22964",
    "name": "Gautam Dayaram Medhiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24552",
    "name": "Giri Ramdin Bhola"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24570",
    "name": "More Shrikant Sadanand/Mangal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24501",
    "name": "Pandey Ramji Dayashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24564",
    "name": "Pawar Shekhar Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24511",
    "name": "Pilaware Sarjerao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24476",
    "name": "Shelke Sindhu Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24544",
    "name": "Sonawala Subhodh Ramanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22958",
    "name": "Yadav Hansraj Mewalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8618",
    "name": "Pawar Dnyanu Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24362",
    "name": "Kadam Keshav Aaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24405",
    "name": "Pal Ramkailash Shivnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24447",
    "name": "Pawar Vishwas Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24434",
    "name": "Shaikh Mohd Umar Mohd Amin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24385",
    "name": "Yadav Brahmanand Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24461",
    "name": "Yerle Babu Virendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5490",
    "name": "Bagde Ratnaprabha Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24337",
    "name": "Pawar Devidas Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24231",
    "name": "Deshmukh Balkrishna Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23671",
    "name": "Dhumal Usha Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19253",
    "name": "Ghadshi Sachin Hiru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24256",
    "name": "Jadhav Hanmant Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6077",
    "name": "Chavan Walmik Buwasaheb"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "885",
    "name": "Avhad Lilesh Chimanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17123",
    "name": "Sutar Mahendra Tarachand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11959",
    "name": "Godambe Maruti Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22458",
    "name": "Shaikh Kayum Habib"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2613",
    "name": "Bhairi Hymavathi Prasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6259",
    "name": "Yadav Ashok Aatmaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "540",
    "name": "Verma Adeuta Ravindra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "812",
    "name": "Pol Seema Ajay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14947",
    "name": "Shinde Akash Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24824",
    "name": "Jagtap Nathsaheb Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18548",
    "name": "Raturi Deepak Shivanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5423",
    "name": "Sabale Bharat Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19664",
    "name": "Kadam Uttam Parsuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7188",
    "name": "Dinkar Barge Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15681",
    "name": "Kadam Sunil Ramchandra Toli No-6336/55865"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "719",
    "name": "Sharma Pravinkumar Ganga"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16154",
    "name": "Choudhari Shripat Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20234",
    "name": "Jadhav Rajendra Shamsunder"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23214",
    "name": "Mane Satish Shankarrao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "376",
    "name": "National Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2379",
    "name": "Natraj Trading Co"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19101",
    "name": "Chavan Sudhakar Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13714",
    "name": "Thorat Kisan Antu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22065",
    "name": "Pol Nitin Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20766",
    "name": "Shinde Abhijit Narayan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "303",
    "name": "Arote Manisha Ravindra"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1581",
    "name": "Nidhi Nidhi Sarees"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12196",
    "name": "Bhoite Vandana Kalidas."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21014",
    "name": "Shirke Motiram Genu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4257",
    "name": "Bhosale Namdeo Raghu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "784",
    "name": "Shingade Janu Bamu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22355",
    "name": "Soni Shitalaprasad Shamlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21957",
    "name": "Mulaye Pooja Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19860",
    "name": "Naik Mohan Fransis"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4211",
    "name": "Nikhi Transport Clearing Agency."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11756",
    "name": "Khuspe Dattatray Dhula"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "720",
    "name": "Gavarkar Ravindra Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20137",
    "name": "Pawar Dnyandev Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22649",
    "name": "Karande Neelam Vishvnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24031",
    "name": "Sarode Vasant Asharam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1368",
    "name": "Gaikwad Ganesh Mhalu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19595",
    "name": "Modak Pravin Ramesh"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "721",
    "name": "Nirmal Watch Co"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9650",
    "name": "Shirke Popat Genba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7178",
    "name": "Sapakal Annaso Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19987",
    "name": "Shelar Pandurang Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17155",
    "name": "Yadav Rakesh Shiv Shay ."
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "257",
    "name": "Om Associate"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4215",
    "name": "Omkar Art."
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "168",
    "name": "Omnath Enterprises & Medical Surgical"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "365",
    "name": "Oms Construction"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "786",
    "name": "Dhavle Pankaj Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17729",
    "name": "Nanavare Rajendra Vithoba"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "335",
    "name": "P.G.M.Agro Tech"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "163",
    "name": "Mane Randhir Shivaji"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2248",
    "name": "Padiyar Kadam & Associates"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "682",
    "name": "Jadhav Birudev Kamaladas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17454",
    "name": "Sawant Sunil Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22238",
    "name": "Nirmal Rakeshkumar Maiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18332",
    "name": "Rajput Sangita Rajesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1068",
    "name": "Sarde Appa Agatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18771",
    "name": "Modak Kanchan Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10951",
    "name": "Shinde Aabaso Jagannath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2581",
    "name": "Godbole Kaushalya Eaknath"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "80",
    "name": "Palak Interiors"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19737",
    "name": "Kaji Sultan Rahim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18612",
    "name": "Shaikh Seruddin Misbahaddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13613",
    "name": "Shinde Ramchandra Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "795",
    "name": "Deshmukh Kisan Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21989",
    "name": "Mane Dhiraj Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11298",
    "name": "Sayyad Mehboob Jamal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18868",
    "name": "Mohite Ashok Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16920",
    "name": "Ambolkar Archana Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20939",
    "name": "Chouhan  Ramsing Shriram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2699",
    "name": "Addagatla Ganesh Narayana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18821",
    "name": "Kamble Sunil Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17917",
    "name": "Momin Kayant Abdul Kayyum"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17802",
    "name": "Salunkhe Subhash Mukundrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15364",
    "name": "Misal Gunagi Nanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "494",
    "name": "Subhash Jagdeorao Bhoite."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8412",
    "name": "Mulik Mohan Baburao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "628",
    "name": "Pankaj Water Supply Co."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9900",
    "name": "Chavan Rangarao Aanandarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12150",
    "name": "Nikam Vimal Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15682",
    "name": "Kuveskar Sanjay S."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16298",
    "name": "Shinde Mahesh Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7797",
    "name": "Sutar Chandrakant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11975",
    "name": "Wagh Rajaram Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19928",
    "name": "Shirsekar Prajakti Vinod"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9376",
    "name": "Shinde Shankr Namdeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1044",
    "name": "Darna Raju Satyayya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14231",
    "name": "Lakhan Ananda Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15530",
    "name": "Kadam Bandu Balu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "954",
    "name": "Sapkal Ganesh Hanumant"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "282",
    "name": "Parshva Steel Coporation"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16107",
    "name": "Shah Sumatilal Gabalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20791",
    "name": "Shelar Shirish Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20607",
    "name": "Nandoskar Poonam Narendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11770",
    "name": "Nalge Ashok Jaysing"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "562",
    "name": "Tupe Ravindra Damodar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10059",
    "name": "Jadhav Rohidas Sopan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14539",
    "name": "Jagtap Jitendra Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14959",
    "name": "More Dattatray Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8832",
    "name": "Mandhare Ankush Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12748",
    "name": "Mohite Surekha Satish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21988",
    "name": "Kadam Atul Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22214",
    "name": "Manjarekar Shreya Sachin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17571",
    "name": "Gopale Ramesh Manjaba T-730/A/11"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19339",
    "name": "Khot Maruti Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23165",
    "name": "Chavan Ajay Murlidhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24014",
    "name": "Jadhav Samir Sadanand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13721",
    "name": "Kale Pravin Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25188",
    "name": "Kuchekar Tushar Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19870",
    "name": "Natikar Mohan Basappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24012",
    "name": "Sakpal Pallavi Pramod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23555",
    "name": "Patil Baburao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14033",
    "name": "Wadghare Ramdas Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22223",
    "name": "Dalvi Vishwas Rohidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20358",
    "name": "Dinesh Tukaram Kadam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15284",
    "name": "Gaikwad Suryakant Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15287",
    "name": "Kashid Rajendra Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15288",
    "name": "Mandhare Machhindra Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20352",
    "name": "Tiwari Arun Kalpnath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1827",
    "name": "Ahire Ravindra Bhivsan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15268",
    "name": "Jadhav Vaishali Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25143",
    "name": "Kabadi Bashumiya Abdul Hamid"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1826",
    "name": "Mundhe Pramod Balaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15264",
    "name": "Narute Pravinkumar Lalaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15274",
    "name": "Pawar Shobha Chandrakant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1833",
    "name": "Shimpi Sandip Bhika"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15266",
    "name": "Shinde Namdeo Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15265",
    "name": "Shinde Sampat Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15267",
    "name": "Varnekar Dattatrya Bhimrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7352",
    "name": "Phalke Jitendra Anandrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1812",
    "name": "Bhatia Naraindas Purushottam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15251",
    "name": "Bhilare Dattatray Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15260",
    "name": "Devade Ganesh Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15255",
    "name": "Jadhav Dilip Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20307",
    "name": "Jondhale Sonali Ramesh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1807",
    "name": "Kajre Bhupendra Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15253",
    "name": "Marale Pravin Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22485",
    "name": "Naik Faruk Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25117",
    "name": "Nikam Neeta Satyawan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1799",
    "name": "Patel Deepak Parbat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25109",
    "name": "Patole Vijay Mahadeo"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1802",
    "name": "Pol Shrikant Bhagwan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1820",
    "name": "Rathod Ramesh Baliram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1803",
    "name": "Sahu Umesh Raghunandan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23968",
    "name": "Shah Chandresh Haridas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23967",
    "name": "Shah Jayesh Nyalchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20290",
    "name": "Duduskar Pravin Bhimrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1795",
    "name": "Iwalekar Ashok Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15242",
    "name": "Jadhav Kundlik Bhiwa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15246",
    "name": "Kumkar Sudhakar Shivaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1796",
    "name": "Madkholkar Keshar Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15248",
    "name": "Patel Paresh Ramnbhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23960",
    "name": "Shetty Harish Dayanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23958",
    "name": "Shetty Raghupathi Kalappa"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1785",
    "name": "Turbadkar Dharma Gaurya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12584",
    "name": "Gaikwad Ramesh Sampatrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "819",
    "name": "Bhosale Ankush Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25073",
    "name": "Chavan Shivaji Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15236",
    "name": "Dhere Dhananjay Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25055",
    "name": "Jagtap Ashwani Govardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24969",
    "name": "Kotkar Nitin Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22475",
    "name": "Mane Prashant Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25064",
    "name": "Nalawade Surekha Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15232",
    "name": "Pathan Ayyaj Liyakat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14218",
    "name": "Sabale Niteen Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7025",
    "name": "More Vijay Hari     734/8"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7451",
    "name": "Pisal Gopal Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23949",
    "name": "Bhandari Kamlesh Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25035",
    "name": "Bhardwaj Chandrashekhar Harakh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15219",
    "name": "Kambale Rajendra Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20269",
    "name": "Manerkar Anil Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23679",
    "name": "Pawar Kirti Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23951",
    "name": "Shere Abhijit Anil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15207",
    "name": "Patil Hemnat Harishchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2906",
    "name": "Shinde Nagesh Harichand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14125",
    "name": "Jadhav Anuja Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15194",
    "name": "Shinde Atul Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24053",
    "name": "Kalpana Narsing Mandhare"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15182",
    "name": "Bhoite Madhavrao Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15170",
    "name": "Gole Chandrakant Arjun"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1741",
    "name": "Naikwadi Chandrakant Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2860",
    "name": "Thanve Yogesh Nandkumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20042",
    "name": "Salunkhe Arun Shyamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23862",
    "name": "Gholap Sajan Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23861",
    "name": "Hande Anil Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23864",
    "name": "Kale Padma Deepak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15160",
    "name": "Lokhande Subhash Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23859",
    "name": "Ruparel Meeta Kiran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15161",
    "name": "Shaikh Salamat Isaq"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22911",
    "name": "Shaikh Sarfuddin Mohd Ayub"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24906",
    "name": "Wakte Sunil Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12691",
    "name": "Dhanrale Bhojraj Soma"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23843",
    "name": "Ambavale Akshay Sayaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24890",
    "name": "Ambre Supriya Bharat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23855",
    "name": "Karande Sunil Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15136",
    "name": "Mahadik Mahendra Jagannat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15133",
    "name": "Shinde Suhas Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23842",
    "name": "Wagh Tanaji Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15120",
    "name": "Bhosale Pavan Kantilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15119",
    "name": "Chavan Dattatray Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15115",
    "name": "Jadhav Vishnu Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15128",
    "name": "Kadam Indrajeet Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23833",
    "name": "Kamble Sanjay Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24868",
    "name": "Kulkarni Preeti Sandesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15130",
    "name": "Nerurkar Vishwas Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15124",
    "name": "Sabale Vinod Dhanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23834",
    "name": "Satve Yogesh Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15123",
    "name": "Shinde Arun Joti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15122",
    "name": "Shinde Rupesh Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15113",
    "name": "Waghmale Kiran Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15111",
    "name": "Karpe Sanjay Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24812",
    "name": "Mondkar Prabhana Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15110",
    "name": "Sakunde Subhash Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22465",
    "name": "Shevale Rajesh Shivram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2321",
    "name": "Thakur Ashish Santosh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20160",
    "name": "Bhoite Somnath Dhansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18841",
    "name": "Chavan Prakash Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22431",
    "name": "Dalvi Prashant Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15277",
    "name": "Nikam Baburao Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22426",
    "name": "Sadwelkar Swapnila Gurunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19885",
    "name": "Murudkar Shweta Nitin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16502",
    "name": "Sonawane Dushyant Dnyaneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15089",
    "name": "Chavan Chandrakant Bapurao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2769",
    "name": "Rathod Govind Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17561",
    "name": "Jagtap Avinash Tatyaba."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18255",
    "name": "Salunkhe Suresh Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17738",
    "name": "Dongare Ashutosh Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15093",
    "name": "Kadam Bandu Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18086",
    "name": "Suware Harishchandra Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22414",
    "name": "Gawade Rajan Shantaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "854",
    "name": "Jiman Sharad Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22376",
    "name": "Maskar Sandeep Bhimrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1709",
    "name": "Mhaske Gangadhar Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20141",
    "name": "Patil Swarupkumar Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24649",
    "name": "Shaikh Sajid Gaffar Hasmi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20131",
    "name": "Shukla Kamalchand Babadin"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1696",
    "name": "Mhetre Sunita Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23777",
    "name": "Mishra Mahesh Chandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21270",
    "name": "Bandekar Vilasini Satish."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15060",
    "name": "Gogavale Navnath Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15055",
    "name": "Kadam Pramod Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15052",
    "name": "Magar Mangal Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20098",
    "name": "Mohite Satish Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15066",
    "name": "Nikam Pramod Jagannath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "159",
    "name": "Yadav Vijay Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24526",
    "name": "Choudhary Azimullah S"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15036",
    "name": "Kadam Sachin Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2178",
    "name": "Phadtare Mahadeo Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23725",
    "name": "Kambale Sunita Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22380",
    "name": "Tapase Vidya Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20009",
    "name": "Modak Vinayak Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25134",
    "name": "Kambale  Ankita Pandit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12509",
    "name": "Chavan Dnyandev Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12643",
    "name": "Disale Chandrakant Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4174",
    "name": "Mhatre Rohini Nitin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12940",
    "name": "Kanade Ekanath Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6514",
    "name": "Yadav Madhukar Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14996",
    "name": "Sakunde Dadaso Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17872",
    "name": "Patil Pandurang Namdeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2571",
    "name": "Dhinde Ramesh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14984",
    "name": "Sayyed Gulab Chand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11365",
    "name": "Veer Anna Genaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24286",
    "name": "Bhowad Aniket Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14978",
    "name": "Bobade Hanmant Gulabrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2585",
    "name": "Jadhav Vithal Bapurao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "273",
    "name": "Bhilare Dnyaneshwar Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24260",
    "name": "Parab Prakash Gopal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2515",
    "name": "Patil Karishma Sushant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24247",
    "name": "Shaikh Nafees Ahmed Bashir"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1627",
    "name": "Shewale Ganpat Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16450",
    "name": "Kadam Vaishali Damodar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16385",
    "name": "Katre Maruti Chandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11228",
    "name": "Ashok Baburao Sherekar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24773",
    "name": "Bansode Sudhakar Vyankat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24228",
    "name": "Chavan Sharad Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14955",
    "name": "Khamkar Kiran Madhukar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1621",
    "name": "More Amol Bhivaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1616",
    "name": "Naik Manoj Shrikrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12753",
    "name": "Sawant Nathuram Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23399",
    "name": "Biradar Mahadeo Narsingrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24203",
    "name": "Bohara Vaijayanti Madan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20836",
    "name": "Chache Anushka Suhas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2439",
    "name": "Jain Vikram Basantkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19910",
    "name": "Kadam Sharad Jaising"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2452",
    "name": "Qureshi Mohemed. Laik Jumman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6403",
    "name": "Aware Pandurang Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23831",
    "name": "Bodake Hindurao Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12341",
    "name": "Chavan Ganpat Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17986",
    "name": "Jadhav Digambar Tukaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1582",
    "name": "Dabholkar Ashwin Sadanand"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1587",
    "name": "Nikam Vishal Savlaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2429",
    "name": "Upparipelly Puroshotam Venkatrajan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9048",
    "name": "Sabale Kundalik Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19146",
    "name": "Sawant Balaso Popat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2392",
    "name": "Dalvi Dnyaneshwar Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "383",
    "name": "Dalvi Suresh Nathu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24141",
    "name": "Kanaujiya Munnalal Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24132",
    "name": "Korde Jyotsna Anil"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "302",
    "name": "Lembhe Amol Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23848",
    "name": "Gupta Dineshkumar Bechanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19834",
    "name": "Sonmale Anita Yogesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19776",
    "name": "Jain Pankajkumar C"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11592",
    "name": "Kadam Harichandra Gopal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "951",
    "name": "More Dnyandev Bhairu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2433",
    "name": "Katkade Mahadev Tirupati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21786",
    "name": "Nilekar Lahu Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24082",
    "name": "Shaikh Ali Abdulla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24088",
    "name": "Shaikh Salim Abdul Rahim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21896",
    "name": "Chorge Sarathi Sahdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12752",
    "name": "Chavan Ashok Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14999",
    "name": "Mulik Kiran Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20250",
    "name": "Salunkhe Rupali Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4107",
    "name": "Shinde Vilas Hanmant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1589",
    "name": "Vankhede Sanjay Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3233",
    "name": "Roman Babaurao Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24038",
    "name": "Ansari Khurshid Ahmed Mohd Hanif"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14231",
    "name": "Pawar Ashish Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22046",
    "name": "Nimbalkar Pushpa Duryodhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17401",
    "name": "Ahirekar Pradeep Balaso  Tn.1540-1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19138",
    "name": "Bhosale Nilesh Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6825",
    "name": "Katkar Bhaskar Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20133",
    "name": "Patil Shekhar Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20900",
    "name": "Dhaske Sindhu Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22289",
    "name": "Mohite Prakash Yashvant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21658",
    "name": "Jain Ankit Arvind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21097",
    "name": "Jadhav Nitesh Sudhir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1489",
    "name": "Dhumal Shivaji Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4120",
    "name": "Jadhav Savitra Savitra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23915",
    "name": "Mahesh Chatarbhuj Shinde"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2622",
    "name": "Gujar Kumar Satyanarayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14484",
    "name": "Nawadkar Santosh Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7650",
    "name": "Ghadage Shrikrushna Natha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16301",
    "name": "Mudliyar Manakshi Ramlingam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2027",
    "name": "Pisal Mahadev Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11465",
    "name": "Phalake Babasaheb Anandarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23353",
    "name": "Sawant Milind Jijaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "455",
    "name": "Shaikh Firoz Abdul Rehman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14961",
    "name": "Salunkhe Pratima Yuvraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19668",
    "name": "Mohite Ganpat Dada."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18874",
    "name": "Mulik Keshav Shriram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14920",
    "name": "Phalke Sujata Sonu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11661",
    "name": "Disale Atmaram Dnyandev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5680",
    "name": "Shetye Madhukar Sambhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4269",
    "name": "Vaity John Anthony"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18848",
    "name": "Surve Kavita Kishor"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1045",
    "name": "Mhisdhune Sushil Kishor"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10683",
    "name": "Sayyad Alltaphusen Allabksh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11578",
    "name": "Tak Ganesh Bheraramji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8013",
    "name": "Sawant Sangita Chimaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17830",
    "name": "Kewat Subhashchand Vasdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16724",
    "name": "Patil Anandi Suresh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24584",
    "name": "Karantary Sangeeta Shubhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14934",
    "name": "Nigave Dhiraj Dhanykumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22020",
    "name": "Sawant Prashant Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21317",
    "name": "Jogi Narsanna Yalanna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8830",
    "name": "Kajabale Kanu Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14597",
    "name": "Bhoir Ramesh Dattaram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16549",
    "name": "Khot Sunil Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17478",
    "name": "More Sayali Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22138",
    "name": "Jain Rahul Rajendra ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17950",
    "name": "Kazi Asif Abdul Latif"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18673",
    "name": "Bhoite Balaso Dhansingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2150",
    "name": "Pawar Gopal Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23617",
    "name": "Agre Sachin Hiraji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2290",
    "name": "Bhoir Nareshrao Nago"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "408",
    "name": "Yadav Santaram Rammurat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24328",
    "name": "Chouhan Jyoti Champalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5536",
    "name": "Raikar Sanjay Vyankatesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14280",
    "name": "Kakade Shalan Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10641",
    "name": "Patil Karuna Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23383",
    "name": "Dongri Sabana Riyaz"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "640",
    "name": "Kadam Datta Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10699",
    "name": "Mandol Safiabibi Kamaladdin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15000",
    "name": "Kalpavruksh Deepak Bandusa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23872",
    "name": "Pathak Birendra Ramnarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17402",
    "name": "Ahirekar Deepak Balaso  Tn.1540-2"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "753",
    "name": "Adhav Vivek Chandrakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "777",
    "name": "Nikam Dadasaheb Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18823",
    "name": "Maurya Ramsurat Sardar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22440",
    "name": "Khalate Vishal Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22939",
    "name": "Chauhan Sikandar Rajanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18083",
    "name": "Kasekar Ramesh Keru"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2120",
    "name": "Mhatre Kiran Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19631",
    "name": "Mali Diparam Nanaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17966",
    "name": "Jaiswal Laduprasad Dhaniram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19653",
    "name": "Sharma Kirandevi Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13579",
    "name": "Bhosale Dattatray Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19879",
    "name": "Gaikar Shantibai Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18321",
    "name": "Rautla Shailesh Rajaram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3092",
    "name": "Plus Point Courier Services"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23197",
    "name": "Agavane Rajesh Kundlik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4579",
    "name": "Mulik Balu Dasarat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12348",
    "name": "Jadhav Suryakant Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21273",
    "name": "Thorat Siddhesh Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16396",
    "name": "Barge Shrikrushna Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11650",
    "name": "Chaudhari Rangilal Sukhdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8825",
    "name": "Mane Krishnan Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21944",
    "name": "Sapakal Santosh Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23063",
    "name": "Gawde Sagar Hemant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2624",
    "name": "Phad Pandurang Ramrao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "98",
    "name": "Praj Indust"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23070",
    "name": "Kale Kusum Sajjan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "834",
    "name": "Yadav Rekha Bablesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17782",
    "name": "Shinde Lahu Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10290",
    "name": "Yadav Suradu S"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17461",
    "name": "Javle Ganesh Chintaman"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3972",
    "name": "Prakash  G. Chitalia"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20004",
    "name": "Jaiswal Amarnath Radheshyam"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "225",
    "name": "Pratap Octroi Service"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4313",
    "name": "Premson Printers"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2157",
    "name": "Priya Marble & Granits"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16434",
    "name": "Palande Sachin Chandrakant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1623",
    "name": "Jaiswar Sahagiram Devanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21402",
    "name": "Peddigar Raju Durga"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22477",
    "name": "Bohara Puran Bahadur"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "886",
    "name": "Pawar Suryakant Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21415",
    "name": "Chavan Priyanka Madan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23656",
    "name": "Kadam Ritesh Jaysing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23364",
    "name": "Shigwan Mitesh Devaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "748",
    "name": "Jadhav Suresh Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23980",
    "name": "Gaikwad Amesh Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14853",
    "name": "Kenjale Suraj Navnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14968",
    "name": "Nalawade Kedar Muralidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14872",
    "name": "Pawar Devanand Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13270",
    "name": "Jadhav Sagar Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22445",
    "name": "Mohite Pritam Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14132",
    "name": "Bobade Sushila Namdeo"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "828",
    "name": "Nikam Vaibhav Dilip"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "214",
    "name": "Khedekar Samruddhi Umesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1344",
    "name": "Alane Ganpat Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14532",
    "name": "Anpat Kiran Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4354",
    "name": "Thik Pandurang Krushna"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2573",
    "name": "R K Textiles"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "590",
    "name": "R.K.Engineering Works"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1528",
    "name": "R.K.Engineering Works"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21048",
    "name": "Jadhav Uday Shantaram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3638",
    "name": "Radhika Textiles"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2177",
    "name": "Rafique Tempo Service"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8787",
    "name": "Gaikwad Vishnu Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9929",
    "name": "Moriya Aklesh Kumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14737",
    "name": "Rane Madhuri Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12277",
    "name": "Ansari Maulana Mohamad Umar"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3311",
    "name": "Rahul Enterprises"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20204",
    "name": "Savle Kiran Dnydev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9875",
    "name": "Sawant Namdeo Mahadeo"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "822",
    "name": "Zore Prakash Balkrushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20034",
    "name": "Shelke Sangeeta Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8830",
    "name": "Taware Narayan Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18904",
    "name": "Thorat Sambhagi Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17351",
    "name": "Tiwarekar Dipti Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22499",
    "name": "Gurav Yogesh Krushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19868",
    "name": "Teli Pradnya Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20425",
    "name": "Rao Pooja Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18180",
    "name": "Jain Shantilal Rupchandji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18511",
    "name": "Shinde Sachin Mansing"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "339",
    "name": "Rajeshri Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19145",
    "name": "Kamat Subhash Vasudeo."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10922",
    "name": "Phalke Sulochana Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23776",
    "name": "Raichura Swati Hemal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16926",
    "name": "Karekar Dipali Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9016",
    "name": "Walkunde Appa Dadaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15192",
    "name": "Mane Ankush Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2310",
    "name": "More Rani Navnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22219",
    "name": "Yewale Sandeep Baburao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "829",
    "name": "Jadhav Shankar Bhimrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18032",
    "name": "Tamboili Vishwambar Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18494",
    "name": "Ghorpade Shatrughan Kisanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21518",
    "name": "Waghela Bharat Vallabh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8433",
    "name": "Dalvi Vijay Shankar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18103",
    "name": "Gaikwad Rupesh Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8112",
    "name": "Pisal Ravsaheb Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22316",
    "name": "Wagh Sachin Nanaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23574",
    "name": "Jadhav Sunny Sudam"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "743",
    "name": "Gaikwad Ankush Ganba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14844",
    "name": "Pathan Shamim Dastgir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3740",
    "name": "Yadav Ganpat Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14897",
    "name": "Nalawade Nita Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22240",
    "name": "Pawaskar Sanika Sunil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19226",
    "name": "Aarde Suryakant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18799",
    "name": "Shinde Daulat Zhanzu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1484",
    "name": "Pandit Bebi Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21688",
    "name": "Bhambid Dattaram Gopal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2445",
    "name": "Lad Abhijit Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17527",
    "name": "Jagtap Sushama R"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2317",
    "name": "Patale Manisha Randeep"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1747",
    "name": "Singh Arvindkumar Udaynarayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "653",
    "name": "Behura Mahendra Charan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22127",
    "name": "Jadhav Manish Shrirang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1391",
    "name": "Khandavi Mahadeo Ambo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2535",
    "name": "Shaikh Nashir Nazeer"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14037",
    "name": "Inamdar Salim Hanif"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17990",
    "name": "Sakpal Sunil Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19546",
    "name": "Mojar Sunil Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14866",
    "name": "Yadav Ramsudhar Dataram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12066",
    "name": "More Subhesh Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22071",
    "name": "Sawant Subhash Chandrakant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1128",
    "name": "Khopade Dinesh Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12645",
    "name": "Jadhav Dada Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20454",
    "name": "Rane Narayan Waman"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "698",
    "name": "Punde Mahesh Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19535",
    "name": "Shaikh Ysuf Esmail"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11298",
    "name": "Tula Singh Nain Singh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13527",
    "name": "Babar Ganesh Hanamant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19905",
    "name": "Wagh Kailash Dnyandev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24367",
    "name": "Sapkal Suraj Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6932",
    "name": "Waghamale Narayan Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24012",
    "name": "Palkar Nishigandha Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21464",
    "name": "Ghube Kavita Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23644",
    "name": "Bhilare Ganesh Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22125",
    "name": "Gaikwad Sunil Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11155",
    "name": "Jadhav Satish Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8449",
    "name": "Dhane Vishwas Jyotiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17928",
    "name": "Ghadigaonkar Bharati Subhash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "528",
    "name": "Shah Sachin Kanaiyalal"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "19",
    "name": "Roshani Optician"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "229",
    "name": "Roshani Road Lines"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22141",
    "name": "Kharade Mahendra Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17619",
    "name": "Jaiswar Lalanprasad Mohitram."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "802",
    "name": "Sawant Ankush Aba"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3964",
    "name": "S . V . Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12225",
    "name": "Sabale Shrirang Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23033",
    "name": "Sawant Prabhakar Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "133",
    "name": "Chavan Tukaram Bapuji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12685",
    "name": "Badekar Nandkumar Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21913",
    "name": "Dalvi Santosh Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15237",
    "name": "Jadhav Sushmila Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15556",
    "name": "Gaikawad Prakash Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9079",
    "name": "Sapaliga Chitra Raghu."
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "733",
    "name": "Sawant Abhishek Shriram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12781",
    "name": "Taware Balkrushna Ganpat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2270",
    "name": "Bhoir Pankesh Shantaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1048",
    "name": "Gaikawad Digamber Dattrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1515",
    "name": "Shaikh Mohd Shamim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20426",
    "name": "Kadam Ashok Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22135",
    "name": "Malandkar Kanan Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2094",
    "name": "Gupta Shailesh Shivpujan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24019",
    "name": "Wagh Jagdish Shivaji"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "385",
    "name": "Sacchai Prints"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4225",
    "name": "Sachin Silk Mills"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1125",
    "name": "Sachin Transport"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22381",
    "name": "Parthe Suraj Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12228",
    "name": "Chawanv Maruti Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16688",
    "name": "Pawar Keshav Vasant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16764",
    "name": "Naik Shankar A."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7864",
    "name": "Phalke Laxman Gulabrao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3771",
    "name": "Sai Communication Centre"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1904",
    "name": "Sai Traders"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4674",
    "name": "Sainath Cargo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17211",
    "name": "Parab Ganesh Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13435",
    "name": "Sakharkar Milind Narayan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "225",
    "name": "Udugade Tukaram Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7785",
    "name": "Waghela Jayshree Kirit"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1422",
    "name": "Pungale Eknath Dadarao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "81",
    "name": "Sakshi Textiles"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9367",
    "name": "Chavan Vijay Buwasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22408",
    "name": "Waghela Deepti Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21789",
    "name": "Manjrekar Gaurav Chandrakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "629",
    "name": "Jadhav Sanjay Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14898",
    "name": "Salunkhe Madhavi Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20651",
    "name": "Jadhav Gangubai Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15922",
    "name": "Bhosale Mahadeo Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1000",
    "name": "Chavan Kashiram Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6597",
    "name": "Sawant Trimbak Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14900",
    "name": "Mahamuni Jayant Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17777",
    "name": "Lad Vivek Vithoba"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "118",
    "name": "Jena Firojkumar Navin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2291",
    "name": "Naik Savita Santosh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14051",
    "name": "Gaikwad Shilendra Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22141",
    "name": "Tamase Ujwala Uhlas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13734",
    "name": "Bahiramkar Rajendra Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19251",
    "name": "Shaikh Husnain Sikandar Baksh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20338",
    "name": "Pawashkar Mangesh P."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16543",
    "name": "Kumbhar Bhogati Prasad Somai."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13868",
    "name": "Bhosale Vishal Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17549",
    "name": "Zala Mituba Mahipatsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13306",
    "name": "Khopade Gulab Govind"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1046",
    "name": "Kore Ramchandra Vyankat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1482",
    "name": "Nai Omprakash Shobhachand"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1091",
    "name": "Banarshi Lalmohan Shree"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20339",
    "name": "Parthe Ganpat Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17017",
    "name": "Kumbar Dipak Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22314",
    "name": "Devlekar Vinod Shankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "878",
    "name": "Shewale Mahendra Rohidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13641",
    "name": "Shah Kaumin Vinodchand."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14215",
    "name": "Jagtap Sadanand Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19132",
    "name": "Jadhav Sanjay Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12784",
    "name": "Maillappa Mudbul Nagappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12060",
    "name": "Phalke Dhanaji Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22438",
    "name": "Phalke Jyoti Vikas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19995",
    "name": "Mishra Dilipkumar Subhashchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17528",
    "name": "Jagtap Godabai Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18093",
    "name": "Panchmatia Divyesh Mukesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16556",
    "name": "Katkar Satish Bhikaji."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20163",
    "name": "Yadav Shubhavati Santram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19222",
    "name": "Kasrung Ramesh Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23893",
    "name": "Shinde Priyanka Dasharath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11176",
    "name": "Jadhav Suresh Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24993",
    "name": "Rana Kamlesh Mangeram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "695",
    "name": "Sandip Traders"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1634",
    "name": "Bhojiya Girdhan Kaju"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15674",
    "name": "Patil Laxman Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1882",
    "name": "Singh Arjun Jayram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2048",
    "name": "Sankalesha Silk Mills"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14172",
    "name": "Chavan Mohanrao Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15107",
    "name": "Yadav Anandrao Jagnnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2401",
    "name": "Shinde Avinash Vishwas."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13098",
    "name": "Jadhav Santosh Hirba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10771",
    "name": "Yadav Ramrudi Zinu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "583",
    "name": "Gaikwad Laxman Jyotiba"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1964",
    "name": "Santosh Engineering"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22537",
    "name": "Surve Bhagyashree Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7913",
    "name": "Chavan Vijay Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22031",
    "name": "Kadam Vittal Ekanth"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22056",
    "name": "Tupe Ketan Madhukar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "832",
    "name": "Nalwade Kiran Balaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14925",
    "name": "Ithape Pradip Rajendra"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2272",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2284",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23602",
    "name": "Pawar Jay Vasant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "483",
    "name": "Giri Ganesh Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13683",
    "name": "Doke Bacherao Genaji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16478",
    "name": "Atugade Bhimrao Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23750",
    "name": "Keni Sharad Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23411",
    "name": "Kadam Baburao Ramu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "559",
    "name": "Pawar Daivata Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17011",
    "name": "Nalawade  Yogesh Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14791",
    "name": "Sawant Tushar Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18384",
    "name": "Raje Sampat Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19808",
    "name": "Mandaliya Dalpat Mangalji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14418",
    "name": "Pawaskar Sandip Budhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24626",
    "name": "Badekar Shyam Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20049",
    "name": "Bhandari Ravindra Namadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11419",
    "name": "Shinde Mahadev Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13890",
    "name": "Nalwade Prakash Laxman"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "782",
    "name": "Yedage Pandurang Kalu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3018",
    "name": "Kadam Vishanu Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17944",
    "name": "Bhosale Suryakant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19777",
    "name": "Gaikwad Vikas Manu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18520",
    "name": "Mishra Sunaina Shrikant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1810",
    "name": "Margaj Anant Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21812",
    "name": "Bawadekar Sushama Sadanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15762",
    "name": "Gaud Sudama Yaduvandan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8639",
    "name": "Jadhav Ashok Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20595",
    "name": "Gavhane Kartki Sanjay"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1308",
    "name": "Shinde Ramdas Kondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8420",
    "name": "Nalge Sadashiv Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22095",
    "name": "Chavan Hanmant Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14298",
    "name": "Dhane Rajendra Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "250",
    "name": "Shirsat Vijay Pundalik"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "440",
    "name": "Shinde Komal Tanaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1298",
    "name": "Kamble Kiran Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3704",
    "name": "Sawant Bhimrao Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12055",
    "name": "Palaskar Pranav Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23610",
    "name": "Joshi Nirmala Virendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16054",
    "name": "Berde Meena Anant."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19947",
    "name": "Ahire Dinkar Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14340",
    "name": "Patil Suresh Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17152",
    "name": "Pawar Ganesh Bhivaji."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6139",
    "name": "Khadake Mahadeo Dnannoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19855",
    "name": "Khupase Mahadeo Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13558",
    "name": "Gunsagar Anwar Kha Tabakha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16431",
    "name": "Jadhav Babsaheb Damodhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14820",
    "name": "Bagkar Devendra Dattaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "823",
    "name": "Shinde Sunil Dhondiba"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "757",
    "name": "Dudhal Bandu Shivaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2421",
    "name": "Rajak Ranjeet Ramtahal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19616",
    "name": "Rathod Vinod Punja"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14368",
    "name": "Pawar Shalan Khandu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "920",
    "name": "Gupta Sanjaykumar Budhairam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19755",
    "name": "Dsouza  Bapist"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12243",
    "name": "Kadam Shivaji Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17006",
    "name": "Shinde  Rajendra  Vasantrao ."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16924",
    "name": "Godambe Suresh Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19799",
    "name": "More Jitendra Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22488",
    "name": "Talekar Ravindra Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25111",
    "name": "Chauhan Guddu Hardev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15261",
    "name": "Jadhav Anil Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15252",
    "name": "Phalke Madhukar Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15396",
    "name": "Shingan Sampat Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "419",
    "name": "Surve Ananda Rau"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1359",
    "name": "Varma Chhotkanram Ajore"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15230",
    "name": "Phalke Krunal Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8581",
    "name": "Shinde Ramesh Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16826",
    "name": "Vichare Kiran Chandrakant / Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1065",
    "name": "Shinde Mhaku Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14135",
    "name": "Ayare Ramesh Tukaram."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18081",
    "name": "Gharal Ramchandra Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22873",
    "name": "Deshapande Bhairavi Ulhas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24438",
    "name": "Kawalkar Rajesh Janu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21803",
    "name": "Kudle Ajit Hanumant."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17811",
    "name": "Disale Dattatray Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12936",
    "name": "Inamdar Liyakatali Shadaqmiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11294",
    "name": "Moria Ramkewal Bhosu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20219",
    "name": "Sawant Ramesh Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8935",
    "name": "Jain Hasmukhlal Ajayrajji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12856",
    "name": "Jadhav Alka Bhikuchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15134",
    "name": "Zanzurane Bhaskar Babaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1195",
    "name": "Jadhav Balkrushna Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15216",
    "name": "Lembhe Dashrath Narsing"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2644",
    "name": "Salunkhe Bhairavnath Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24635",
    "name": "Momin Munna Shamshuddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12957",
    "name": "Bodke Shankar Dinker"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15071",
    "name": "Pawaskar Anil Bhaskar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12362",
    "name": "Awade Mahendra Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24807",
    "name": "Pal Yogendrakumar Rajnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10389",
    "name": "Kumbhar Shamrao Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15029",
    "name": "Gangatire Dhiraj Chandan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20053",
    "name": "Pawar Amol Shrimant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17713",
    "name": "Raut Kalpesh Ramesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13188",
    "name": "Bhoite Sanjay Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9743",
    "name": "Wadkar Shivaji Namdeo"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "532",
    "name": "Khedekar Umesh Shankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1420",
    "name": "Khandagale Yash Dnyaneshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18171",
    "name": "Shaikh Mohamed Izahar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5276",
    "name": "Matre Hari Chandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18701",
    "name": "Sahyadri Mathadi Transport And Ganeral Kamgar Union (Reg"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11061",
    "name": "Shinde Baburao Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15000",
    "name": "Tarkar Shrikant Dwarkanath."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14928",
    "name": "Gholve Babasaheb Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24134",
    "name": "Khan Rasheed Asad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19623",
    "name": "Khankal Sujata Devdatt"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20177",
    "name": "Jangali Vijay Lahu"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1810",
    "name": "Sherkhane Suresh Limbaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10113",
    "name": "Mayekar Sangeeta Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18367",
    "name": "Gaikwad  Bhakti Bhalchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "957",
    "name": "Patil Sachin Hanamant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15266",
    "name": "Viswakarma  Balbhhadur"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "827",
    "name": "Lambor Dhondiba Siddhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23881",
    "name": "Rane Nagesh Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19647",
    "name": "Mahida Meena Ratilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10013",
    "name": "Rajbhar Deepchand Punvati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20006",
    "name": "Parmar Harish Ramaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21561",
    "name": "Ambre Ashish Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7909",
    "name": "Babar Rajendra Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19527",
    "name": "Solanki Laxmi Jetha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20231",
    "name": "Bhaste Namdev Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "655",
    "name": "Pandhavale Mukesh Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18863",
    "name": "Disale Santosh Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16458",
    "name": "Pawar Pandurang Dhondiba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "883",
    "name": "Panaskar Kishor Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12947",
    "name": "Pawar Baburao Parshu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19679",
    "name": "Pisal Nikhil Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21581",
    "name": "Bohara Tej Gagan Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24140",
    "name": "Mahamulkar Kailas Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20501",
    "name": "Wagh Sachin Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23562",
    "name": "Charaisaia Ramtapeshwat Ramnagina"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20043",
    "name": "Khaire Sharad Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21020",
    "name": "Kheware Vansubai Tulshi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19856",
    "name": "Rathod Mahendra Jaisungh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17721",
    "name": "Yadav Rashmi Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23245",
    "name": "Nalawade Priya Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2628",
    "name": "Chavan Malharrao Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14249",
    "name": "Rao Ramlot Chabilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20025",
    "name": "Bansode Sanjay Lahuji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15670",
    "name": "Bosale  Yogita Ranoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23257",
    "name": "Borge Amol Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22101",
    "name": "Patil Sujata Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11869",
    "name": "Sharma Ganpat Gevilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21379",
    "name": "Pawar Ujwala Hanamant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "954",
    "name": "Sachin Swari Mahila Swanya Sahakari Bachat Gat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2055",
    "name": "Yadav Reshma Dadaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22468",
    "name": "Chavan Nilam Prashant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14367",
    "name": "Nimbalkar Priti Vikram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22552",
    "name": "Adivarekar Sneha Vinod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9735",
    "name": "Bista Padam Singh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15133",
    "name": "Chavan Purushottam Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23030",
    "name": "Sahoo Jaswant Vinod"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13341",
    "name": "Mishra Pateshwari Chhedi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6651",
    "name": "Mane Madhukar Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11132",
    "name": "Kedari Sulochana Dattatrey"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23763",
    "name": "Mane Anil Ishwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14350",
    "name": "Maskar Hirabai Bhimrao."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18118",
    "name": "Yadav Ananda Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6481",
    "name": "Rane Amita Harihar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "29",
    "name": "Choudhary Mohan Dattu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1164",
    "name": "Bhosale Sampat Pandharinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15550",
    "name": "Manusakare Maruti Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14223",
    "name": "Kulkarni Mrudula Bindumadhav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4022",
    "name": "Nimbalkar Mohan Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14168",
    "name": "Shah Asha Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4977",
    "name": "Vijaya Dattatray Kadam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11343",
    "name": "Bandogonda Sainath Ashappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12847",
    "name": "Ghorpade Prashant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19732",
    "name": "Malankar Gurunath Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14495",
    "name": "Nalawade Mohan Bhikoba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2354",
    "name": "Khan Mumtaz Zaheer"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18171",
    "name": "Parmar Nagindas Mansukhalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18048",
    "name": "Dalvi Sanjay Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16145",
    "name": "Waghela Sharada Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8811",
    "name": "Sakunde Lahuba Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14815",
    "name": "Pawar Maruti Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10787",
    "name": "Dhumal Suresh Balasaheb"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2175",
    "name": "Gunjal Vasant Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22163",
    "name": "Shelar Jayashree Vinod"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21960",
    "name": "Chavan Sachin Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23286",
    "name": "Pawar Chhaya Anand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21731",
    "name": "Kamatekar Siddhi Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19899",
    "name": "Bramhe Arun Popat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23729",
    "name": "Barot Navneet Shantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20314",
    "name": "More Dagadu Bhiku"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2033",
    "name": "Devkar Vilas Malikarjun"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "831",
    "name": "Nikam Sandip Shivaji"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "833",
    "name": "Shiv Shakti Provision Stores"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14548",
    "name": "Sawant Shivaji Shankar"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4082",
    "name": "Shoaiba Plastic"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2571",
    "name": "Shopin"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "289",
    "name": "Shree Gajanan Transport"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "483",
    "name": "Shree Ganpati Carrier"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "172",
    "name": "Shree Laxmi Ravi Janseva Sanstha"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "401",
    "name": "Shree Om Packing"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2322",
    "name": "Shree Ram Seva Society"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "72",
    "name": "Zagade Sudha Jagannath"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "82",
    "name": "Shruti Scale"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17116",
    "name": "Shilimkar Ganesh Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18747",
    "name": "Chavan Bhavna Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18634",
    "name": "Chandurkar  Sachindra Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13199",
    "name": "Sawant Pralhad Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14972",
    "name": "Chavan Vijay Dharmu"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1884",
    "name": "Shyam Jewellers"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "966",
    "name": "Siddhivinayak Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21599",
    "name": "Surve  Chandrakant  Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24307",
    "name": "Alhat Santosh Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21724",
    "name": "Bobade Bhagirarh Athucharao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "605",
    "name": "Ghadage Milind Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21434",
    "name": "Shaikh Ammanulla Ameer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16516",
    "name": "Bhosale Rajesh Tukram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13291",
    "name": "Dhumal Shailesh Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9962",
    "name": "Matre Tanaji Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13115",
    "name": "Phalke Shitalrao Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15108",
    "name": "Shingate Yeshwant Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13109",
    "name": "Kolhe Sunil Yeshwantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13262",
    "name": "Santoshi Ravindra  Bhagat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2289",
    "name": "Nalwade Shankar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "460",
    "name": "Lembhe Dhansingh Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13860",
    "name": "Momin Saba Riyaj"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "820",
    "name": "Gawade Pandurang Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17706",
    "name": "Choudhari  Manojkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17491",
    "name": "Bhoir Vimal Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14864",
    "name": "Jadhav Vaishali Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14917",
    "name": "Shetage Bhikaji Shivaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1132",
    "name": "Salekar Parbati Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13959",
    "name": "Choudhari Shanti Upendra."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7798",
    "name": "Nalawde Namadev Nanyadev"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2125",
    "name": "Skoda Developers"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22076",
    "name": "Gupta Govind Ramvilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13521",
    "name": "Mahatre Rekha Amarnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3886",
    "name": "Sakpal Vilas Kashinath"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "468",
    "name": "Soham Construction"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13386",
    "name": "Jaiswal Shivprasad Bhagwandas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1352",
    "name": "Shivgan Sharad Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20054",
    "name": "Pawar Dnyaneshwar Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8219",
    "name": "Salunkhe Dilip Babanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21937",
    "name": "Anandprem Nagari Sah Path Sanstha Maryad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12948",
    "name": "Gaikwad Aruna Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8077",
    "name": "Monhiro Martin Simon"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1190",
    "name": "Baramde Dharmaraj Bajirao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2179",
    "name": "Shaikh Mohd.Yusuf Ayyub"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17608",
    "name": "Dalavi Ravindra Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11507",
    "name": "Kokare Dhansingh Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3351",
    "name": "Adhav Vilas Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13089",
    "name": "Chavan Nandkishore Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23211",
    "name": "Bedekar Jaydas Devaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17736",
    "name": "Ghadigoankar Vijay Nilu"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4055",
    "name": "Sonu Creation"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14922",
    "name": "Phalke Komal Shekhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11850",
    "name": "Sable Vijay Mahadeo"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3236",
    "name": "Sriram Krishna Dary"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1120",
    "name": "Star Binder"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20027",
    "name": "Bagat Suresh Bhauso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19894",
    "name": "Pawar Abhising Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10584",
    "name": "Jain Laxmibai J"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4662",
    "name": "Sumeirr Impex"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3520",
    "name": "Sun Synthetics"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8917",
    "name": "Kubhar Ramling Vitobha"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13545",
    "name": "Deshmukh Sachin Vasantrao"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2106",
    "name": "Suresh Hessian Stores"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22068",
    "name": "Dake Hanmant Shankar"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3309",
    "name": "Suryakant K. Kanodia"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25049",
    "name": "Dudwadkar Sudam Shripat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "486",
    "name": "Jagtap Hanmant Genba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17357",
    "name": "Chaturvedi Dinesh Ramakant."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20634",
    "name": "Dhumal Ravindra Balkrishna."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8476",
    "name": "Shinde Anilkumar Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13238",
    "name": "Kalebere Sujata Shantaram."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13578",
    "name": "Chavan Pralhad Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16298",
    "name": "Chindaliya Ashok Nivas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21701",
    "name": "Kamthe Rajesh Hanumant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13743",
    "name": "Salunkhe Ashok Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22669",
    "name": "Qureshi Javed Raisahmed"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "101",
    "name": "Swame Ho Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2493",
    "name": "Systems Solutions"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13603",
    "name": "Soni Ramjanam Shivpujan"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1068",
    "name": "T.D Mittal & Co."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14156",
    "name": "Sabale Bhumika Vishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7039",
    "name": "Vajrava  Rajanna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "808",
    "name": "Yamgar Ananda Biru"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "915",
    "name": "Kokare Ajay Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3584",
    "name": "Baban Narayan Kirdat."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14123",
    "name": "Jagadale Prema Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13104",
    "name": "Bhosale Sopan Shankar. 1170/3"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9275",
    "name": "Hirve Hirabai Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22383",
    "name": "Gorule Deepali Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13558",
    "name": "Satardekar Snehal Prakash."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2335",
    "name": "Dalavi Sharada Govind"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "778",
    "name": "Jadhav Laxman Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13417",
    "name": "Patil Devendrakumar S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9513",
    "name": "Mane Madhukar Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14976",
    "name": "Bobade Balaso Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21705",
    "name": "Jadhav Dattatray Chandrakant"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2076",
    "name": "Taukeer Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17539",
    "name": "Dhange Sunita Bhimashankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13698",
    "name": "Chavan Shahaj Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20104",
    "name": "Kapse Gangaram Shivram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1479",
    "name": "Mahangare Eknath Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14214",
    "name": "Kulkarni Prasad Dhananjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22098",
    "name": "Vishwagarma Ajay Kashinath"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "3295",
    "name": "Thakkar Leena Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18260",
    "name": "Mulik Sneha Bharat /Mr Bharat Tukaram Mu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1612",
    "name": "Mhatre Chandrakant Balu ''Balya''"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15204",
    "name": "Nikam Vikas Aatmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20390",
    "name": "Nawadkar Umesh Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11785",
    "name": "Ghorpade Dattatray Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1459",
    "name": "Singh Umashankar Ramraj"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2408",
    "name": "Jagtap Archana Santosh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14534",
    "name": "Kundalkar Sandeep Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18957",
    "name": "Chavan Laxmikant Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11953",
    "name": "Disale Mahadeo Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10269",
    "name": "Mehta Chothamal Badalchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16834",
    "name": "Adhav  Dilip   Dinkar."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18357",
    "name": "Aadivade Balu Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14209",
    "name": "More Ganesh Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11229",
    "name": "Sapkal Maruti Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14606",
    "name": "Chavan Sunil Sahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20969",
    "name": "Prabhu  Prashant Gangaram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "27",
    "name": "Tiles Plaza"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1281",
    "name": "Mane Laxman Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21884",
    "name": "Pimpalkar Yogita Dinesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2357",
    "name": "Bhatt Bhupen Bhogilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11523",
    "name": "Gupta Ramesh Shivpujan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11438",
    "name": "Lokhande Madhuri Nandakishore"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2496",
    "name": "Agalave Manisha Sukhdev"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1907",
    "name": "Dodhia Jigar Jayantilal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2324",
    "name": "Patil Atmaram Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17283",
    "name": "Bhilare Nitin Vishvnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3424",
    "name": "Kale Bhaurao Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18569",
    "name": "Bhandari Ashok Laxman"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4595",
    "name": "Transprint"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2264",
    "name": "Habare Santosh Abhimanyu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2614",
    "name": "Shaikh Kasam Husain"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9903",
    "name": "Disale Sanjay Hanamant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13765",
    "name": "Jagtap Neelam Kundlik"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2616",
    "name": "Shiakh Mudassir Basheer"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11718",
    "name": "Sabale Sanjay Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21065",
    "name": "Chorage  Amol  Vishwas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17421",
    "name": "Pal Sabhajit Bechan."
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4649",
    "name": "Ultimate Search Services"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "1144",
    "name": "Uma Enterprises"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15056",
    "name": "Shingate Shrikant Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15148",
    "name": "Kolape Chandrakant Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15490",
    "name": "Kambale Kisan Mukund"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2347",
    "name": "Vaibhav Enterprises"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19963",
    "name": "Achare Anjana Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19761",
    "name": "Poria Tapankumar Porbodh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "463",
    "name": "Ghadge Ankush Murlidhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15151",
    "name": "Karande Uttam Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19410",
    "name": "Keni Devidas Yashwant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2387",
    "name": "Sarvade Archana Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13965",
    "name": "Mali Lalitkumar Babuji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17189",
    "name": "Gound Mahendra Tengari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14291",
    "name": "Salunkhe Dattu Ravaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "464",
    "name": "Bhati Kailas Vijaram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2306",
    "name": "Vani Graphics"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16618",
    "name": "Shukla Virendra Ramlakhan."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8927",
    "name": "Nimbarlkar Hanumant R."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20006",
    "name": "Phadtare Balaso Parbati 308/10"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23091",
    "name": "Kothari Kalpesh Devraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21637",
    "name": "Sutar Smita Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22307",
    "name": "Deshmukh Kirti Dhansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8815",
    "name": "Tarkar Akshay Ajit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18533",
    "name": "Gandhi Rukmini Pravin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15763",
    "name": "Nikam Ravindra Dipak."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12381",
    "name": "Jadhav Narayan Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10968",
    "name": "Pawar Shalan Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10617",
    "name": "Shinde Mohan Yashwant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1529",
    "name": "Koli Milan Ananta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16747",
    "name": "Jagdale Shivaji Bhairu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24548",
    "name": "Jadhav Vivek Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20232",
    "name": "Shinde Jyoti Nilesh"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "103",
    "name": "Vastushilp Builders & Developers"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1027",
    "name": "Patil Vijaykumar Vishwanath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "884",
    "name": "Belakar Yenubai Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20295",
    "name": "Dayal Gorakh K."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12436",
    "name": "Jagtap Augustine Lucas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20648",
    "name": "Karawade Mahendra S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7735",
    "name": "Relekar Sonal Srikant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "106",
    "name": "Bobade Vishal Subhash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17581",
    "name": "Ghanekar Mangesh Dattaram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18493",
    "name": "Kadam Navnath Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21123",
    "name": "Kadyam  Tirumalai  Selvaraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22585",
    "name": "Bhosale Jitendra Krishna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "824",
    "name": "Zore Kashinath Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13578",
    "name": "Chatur Adik Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1005",
    "name": "Laghi Chintaman Dhondiba"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4478",
    "name": "Vikram Tex India"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "436",
    "name": "Vimla Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23641",
    "name": "Kandhare Yogesh Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18143",
    "name": "Pawar Nikhil Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14963",
    "name": "Chouhan Prabhatsingh M"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21548",
    "name": "Bhilare Sindhu Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18621",
    "name": "Shetty  A.Venktesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13638",
    "name": "Kadam Surekha Bandu."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17284",
    "name": "Pohekar Vanmala Naresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18205",
    "name": "Jadhav Reshma Janardhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12646",
    "name": "Sonawane Pravin Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2067",
    "name": "Vishvam N. Baren.."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20198",
    "name": "Chafekar Anjali Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20639",
    "name": "Koli Milan Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21779",
    "name": "Baltugade Pratap Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "76",
    "name": "Gada Kaushika Jayesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16617",
    "name": "Guttam Rampati Ramdas ."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8331",
    "name": "Wankhede Uttam Kacharuji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9823",
    "name": "Jaiswal Kanhayalal Ramlout"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19698",
    "name": "Yadav Vidhyaprakash Ramtirath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7574",
    "name": "Kanhar Bhuvar Manhaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19585",
    "name": "Kolekar Shankar Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19376",
    "name": "Shingan Vimal Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7205",
    "name": "Phalke Bhauso Daji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10875",
    "name": "Kadam Tanaji Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20899",
    "name": "Shetti  Harish  Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22760",
    "name": "Singh Santosh Subedar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2009",
    "name": "Parkar Pramod Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15481",
    "name": "Yadhav Tanaji Kantilal."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20568",
    "name": "Ghosalkar Sarvesh Ravindra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19891",
    "name": "More Madhavi Rahul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18347",
    "name": "Chavan Pramod Harishchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21161",
    "name": "Chadwa Ruchit Manilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7896",
    "name": "Jagtap Ananda Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23139",
    "name": "Mehta Sureshkumar Mulchand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1500",
    "name": "Saini Vijay Ramkumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2956",
    "name": "Shinde Kisan Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15611",
    "name": "Kale Sumit Shashikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22478",
    "name": "Jaiswal Rajbahadur Sarju"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2243",
    "name": "Yadav Sevalal Nanhaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17066",
    "name": "Gharal Shankar Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25069",
    "name": "Joseph Shila Franklin"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "992",
    "name": "Rajpure Ankush Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15216",
    "name": "Tikunde Maharudra Kadaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16016",
    "name": "Kamble Ankush Dnyanoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12852",
    "name": "Jagdale Anshuman Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24932",
    "name": "Malpekar Roshan Fakir"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2854",
    "name": "Patil Amol Rajendra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2847",
    "name": "Patil Reshma Bindas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16902",
    "name": "Tapa Subhash Haribhadur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11769",
    "name": "Mali Sawalaram Prakaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24907",
    "name": "Wakte Sachin Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16286",
    "name": "Solaskar Jayashree Agannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14789",
    "name": "Pawar Yuvaraj Jalindar  Tn.-543-58"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "495",
    "name": "Khopade Balasaheb Jagannath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2829",
    "name": "Poswal Dharmichand Premaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23302",
    "name": "Jaiswar Hirawatidevi Amarnath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2794",
    "name": "Thakur Vijay Kabir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "506",
    "name": "Mahajan Shalini Mahaling"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10098",
    "name": "Shinde Vishnu Malhari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14330",
    "name": "Nalawde Subhash Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14469",
    "name": "Jain Rajendra Kumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2784",
    "name": "Borude Sadashiv Babaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1720",
    "name": "Davand Jayram Chima"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8859",
    "name": "Pandey Gulabdhar Lalji."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19853",
    "name": "Pisal Tushar Rajendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16259",
    "name": "Urankar Vibhav Prabhakar&Urankar Prabhak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20263",
    "name": "Jaisawal Lalaman Sunayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14329",
    "name": "Kadam Gunaji Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19755",
    "name": "Chorge Bharat Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2757",
    "name": "Malde Bhumi Vishal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17003",
    "name": "Angane Umesh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14200",
    "name": "Shinde Anil Balkrushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21387",
    "name": "Bhoite Chabutai Nanasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11825",
    "name": "Salunkhe Pandurang Vinayak 837/5"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1702",
    "name": "Pawar Mangesh Mohan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2710",
    "name": "Bhise Bhaskar Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23746",
    "name": "Gore Ananda Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23747",
    "name": "Gore Pandurang Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22315",
    "name": "Panhale Bhakti Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21160",
    "name": "Chhadwa Kinal Manilal."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13503",
    "name": "Thakur Gulabsingh Shriatma"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2630",
    "name": "Maity Muktipada Hemanta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21276",
    "name": "Pawar Manoj Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22459",
    "name": "Yadav Hindprakash Ramdavar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24851",
    "name": "Pagare Ravindra Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23701",
    "name": "Jain Hemalata Dilkhush"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2572",
    "name": "Shaikh Mehboob Badshah Ahmed  Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24278",
    "name": "Bhosale Jitendra Rajaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2550",
    "name": "Khan Mustak Umarav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20257",
    "name": "Sawant Nanda Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15136",
    "name": "Pawar Prakash Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23938",
    "name": "Patil Suvarna Vasant"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "2676",
    "name": "Yash Corporation"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4875",
    "name": "Narvekar Vasudha Sudhir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24419",
    "name": "Tiwari Pradeep Shreeram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11221",
    "name": "Raut Sangeeta Satyawan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13218",
    "name": "Pawar Vikramsinha Anandrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1606",
    "name": "Patil Sanjay Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15751",
    "name": "Pawar Hemant Dinkar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24460",
    "name": "Sasane Sandeep Kantilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19894",
    "name": "Phalke Rahul Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12426",
    "name": "Vaydande Bharat Sampat"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "4690",
    "name": "Yugandhar Developers & Constructors Private Ltd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21784",
    "name": "Bagade Anand Baliram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10290",
    "name": "Jaiswal  Amarnath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2311",
    "name": "Singh Rudrapratap Yogendra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2879",
    "name": "Shinde Chandan Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "320",
    "name": "Dhanu Prakash Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22249",
    "name": "Surve Aditi Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24964",
    "name": "Dhami Java Ransingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2666",
    "name": "Gurude Gulab Gurunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20821",
    "name": "Kadam Vikrant Padmakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12764",
    "name": "Pisal Kishan Babasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21599",
    "name": "Jadhav Vijay Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25166",
    "name": "Kadam Pravin Narasu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "289",
    "name": "Kadam Shamrao Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15772",
    "name": "Kalambe Ahilaya Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13843",
    "name": "Salunkhe Mahadev Nivruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "307",
    "name": "Sumariya Narshi Murag"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19599",
    "name": "Devasi Dewaram Hamiratanji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19810",
    "name": "Kadam Seema Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15710",
    "name": "Kadam Balasaheb Savla"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19512",
    "name": "Solanki Harshad Mohanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15563",
    "name": "Kadam Adhik Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24699",
    "name": "Kamble Manohar Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14552",
    "name": "Singh Sarojkumar Sankataprasad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2677",
    "name": "Patil Gorak Bhagwan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2661",
    "name": "Mhatre Sunita Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15842",
    "name": "Wada Rasila Mukesh / Mukesh J."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23102",
    "name": "Pawar Shashikala Ankush"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1432",
    "name": "Gavali Pravin Mukund"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2448",
    "name": "Jain Ashokkumar Champalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16629",
    "name": "Jain Akshta Vipul."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9704",
    "name": "Sakpal Haridas Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22997",
    "name": "Jadhav Vikrant Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13224",
    "name": "Shinde Ramesh Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14201",
    "name": "Patil Rajendra Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1419",
    "name": "Gupta Ramkesharprasad Ramshankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19438",
    "name": "Bhurke Ajit Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23148",
    "name": "Pogula Vijay Narsaiah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12817",
    "name": "Rane Gori Dattaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2186",
    "name": "Dhumal Vaibhav Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22993",
    "name": "Pawar Mahindra Ramu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2072",
    "name": "Mulani Iqubal Hajrat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2172",
    "name": "Naik Jayendra Ramnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13379",
    "name": "Sharma Maniram D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18149",
    "name": "Solaskar Jagannath S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21900",
    "name": "Vyas Vijay Kanubhai"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "847",
    "name": "Nikam Shashikant Bharat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12898",
    "name": "Pednekar Nandkumar Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19889",
    "name": "Mohite Ashish Anant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14903",
    "name": "Deshmukh Megharani Udhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21532",
    "name": "Patil Vishwas Shukhalal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1319",
    "name": "Shah Upendra Mahavir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16582",
    "name": "Patil Nikita Mohan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "130",
    "name": "Mishra Mukeshkumar Vaikunth"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7701",
    "name": "Rajbhar Ramdhari Budhuram."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23563",
    "name": "Ghusale Gautam Devchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24335",
    "name": "Bhosale Harshada Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24691",
    "name": "Ruke Pranali Pravin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17852",
    "name": "Patkar Rekha R./Ravindra P."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "849",
    "name": "Yadav Munib Foolchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22159",
    "name": "Dhumal Jaydeep Hindurao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1609",
    "name": "Kumkar Surekha Vilas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2411",
    "name": "Chamar Rajaram Shyamdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9026",
    "name": "Pawar Pradip Laxman /Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12670",
    "name": "Bhosale Rangrao Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1003",
    "name": "Bhandari Vinod Krishna."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24623",
    "name": "Dalvi Mahesh Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19734",
    "name": "Shinde Tushar Rajaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "499",
    "name": "Sathe Seema Shahuraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10929",
    "name": "Yadav Dayaram Aadhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18036",
    "name": "Talekar Varsha Vithal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2543",
    "name": "Khandekar Shankar Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16820",
    "name": "Dhumal Santosh Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2398",
    "name": "Ahirekar Mahadev Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22164",
    "name": "Shaikh Altaf Banneminya"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1378",
    "name": "Chavan Sushila Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4525",
    "name": "Haldankar Raju Chandrakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1646",
    "name": "Gupta Dhannudevi Sanjaty"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11161",
    "name": "Bobade Ashok Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20494",
    "name": "Bhapkar Gouri Shivaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "943",
    "name": "Karaniya Kunjal Chandulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15109",
    "name": "Shukla Surajmal Ramkamal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17487",
    "name": "Katkar Shantabai Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12549",
    "name": "Chavan Sunil Vithalrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18464",
    "name": "Nakashe  Devendra Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23803",
    "name": "Balgopal Mitra Mandal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "640",
    "name": "Yadav Rajendraprasad Chhabilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22157",
    "name": "Shinde Meena Appalswami"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16438",
    "name": "Naik Aatmaram Krishnaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22068",
    "name": "Shukla Rakesh Pravinchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12200",
    "name": "Yadav Anilkumar Tufani"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "775",
    "name": "Kalal Santosh Mallaya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16341",
    "name": "Parab Shital Madhukar."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1610",
    "name": "Mhatre Suresh Balu Balya"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2384",
    "name": "Devghare Ananda Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13467",
    "name": "Jadhav Devrao D."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1504",
    "name": "Jadhav Rita Parmeshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14329",
    "name": "Nalawade Mahesh Subhash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2494",
    "name": "Chauhan Bharatprasad Siddheshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8769",
    "name": "Sawant Bhiku Shonba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20632",
    "name": "Naik Ramchandra Sukhaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "79",
    "name": "Singh Ajyakumar Rajendraprasad"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1520",
    "name": "Valanju Rahul Sataywan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14801",
    "name": "Kolekar Eknath Yashwant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "359",
    "name": "Mali Babbutram Sonaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15150",
    "name": "Sonawale Vishwas Jagnnath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2576",
    "name": "Dodhia Pritesh Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16895",
    "name": "Bhosale Lata Ramesh."
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1336",
    "name": "Shelke Raju Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15098",
    "name": "Shigvan Naresh Ambaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14133",
    "name": "Pataki Manoj Machindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14569",
    "name": "Pawar Pralhad Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13107",
    "name": "Chavan Vaishali Ankushrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22235",
    "name": "Ghosh Sairabano Manvar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21512",
    "name": "Karande Subhadra Parshuram ."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11637",
    "name": "Poshe Prashant Dhondu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2777",
    "name": "Wagh Shivaji Anna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17865",
    "name": "Yadav Gaytri Omprakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7732",
    "name": "Pawar Mohan Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22211",
    "name": "Upadhyay Rammani Durgaprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15238",
    "name": "Kanagale Bandu Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22162",
    "name": "Ghevade Dilip Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5110",
    "name": "Saundekar Ramesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19984",
    "name": "Jadhav Sudam Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2326",
    "name": "Bohara Dhansingh Motisingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5190",
    "name": "Naik Dasharath Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23562",
    "name": "Shah Dhiraj Tayasi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21544",
    "name": "Kadam Jyoti Dipak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15776",
    "name": "Chavan Rahul Harichandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10943",
    "name": "Parekh Satish Manilal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2063",
    "name": "Singh Mahavir Shyojiniash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13718",
    "name": "Chandoskar Sonali Vinay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15259",
    "name": "Mane Tukaram Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21021",
    "name": "Thorat Sachin Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16738",
    "name": "Shah Chirag Ratilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20284",
    "name": "Yadav Ramchandra B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9800",
    "name": "Patkar Kedar R"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1440",
    "name": "Jha Sanosh Mahavir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9572",
    "name": "Kamble Jayashree Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22169",
    "name": "Kumthekar Mandar Sanjay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20563",
    "name": "Yadav Nandkumar Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14657",
    "name": "Arya Udaybhan R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21585",
    "name": "Varhadi Mangal Muralidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23936",
    "name": "Harpati Suresh Ravi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2203",
    "name": "Ingle Usha Parmeshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22670",
    "name": "Shaikh Shadab Abdul Rahim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17814",
    "name": "Satvase Ramesh Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25021",
    "name": "Barchha Krishang Tejas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21486",
    "name": "Jadhav Manoj Mukteshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20675",
    "name": "Shinde Eknath Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10776",
    "name": "Shinde Sunil Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19737",
    "name": "Pisal Vishal Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3788",
    "name": "Dangat Narayan Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15351",
    "name": "Darji Hasmukhlal N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24809",
    "name": "Pal Shyamadhar Khaderu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24804",
    "name": "Kamle Mahadev Apparao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2459",
    "name": "Rasal Devidas Kondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21748",
    "name": "Yadav Ramesh Maniram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15546",
    "name": "Choudhari Nasrin Abdul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16487",
    "name": "Shedge Sandeep Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17005",
    "name": "Bhinge Ajay Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7220",
    "name": "Kadam Prakash Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18613",
    "name": "Sakpal Archana Chandrashekhar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1128",
    "name": "Sharma Mulchand Sureshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20498",
    "name": "Jain Jayantilal Mishrimal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22862",
    "name": "Pachangane Mahadev Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16798",
    "name": "Dhumal Yogesh Sambhajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19830",
    "name": "Bhosale Sagar Suresh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2702",
    "name": "Nandurkar Avinash Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15103",
    "name": "Kotekar Kalpana Amol"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "146",
    "name": "Choudhari Lakaram Ramaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19665",
    "name": "Ashthul Laxmi Shyam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10818",
    "name": "Raut Balsaheb Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17678",
    "name": "Singh Ravi Pratap"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15762",
    "name": "Jagtap Kashinath Sahebrao."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8907",
    "name": "Bhosale Hanmantrao Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17563",
    "name": "Pawar Geeta Nathu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1623",
    "name": "Patil Aruna Vasudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14300",
    "name": "Patne Santosh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12502",
    "name": "Bhuwad Sahadeo Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2520",
    "name": "Bhavsar Purshottam Shivlalji."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2521",
    "name": "Sambari Rakesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18365",
    "name": "Rane Sunil Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9298",
    "name": "Rege Sushila P/Patkar Ravindra P/Patkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20124",
    "name": "Nikam Vishwas Shankar Toli No. 234/4"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23371",
    "name": "Poojari Santosh Chandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16356",
    "name": "Chairman/Vice  Chairman/Tresu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15101",
    "name": "Naik Vandana Ulhas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16753",
    "name": "Shaikh Rizwan Mehmood"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19130",
    "name": "Taigade Rajendra Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3229",
    "name": "Mandhare Dattatray Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14755",
    "name": "Jain Bhoopendra K"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14248",
    "name": "Machale Archana Ravindra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "887",
    "name": "Mhatre Santosh Maya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20520",
    "name": "Thakur Ramchandra Deepchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11970",
    "name": "Gaikwad Dattu Parmeshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16864",
    "name": "Gita Suresh Mishra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10946",
    "name": "Chouhan Kamlesh Hari"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1601",
    "name": "Singh Narendra Yogendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13698",
    "name": "Jain Hemlata Manojkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20694",
    "name": "Sonar Rupadevi Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18978",
    "name": "Gundage Laxman Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21135",
    "name": "Singh  Janvijay  Ramnath."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1185",
    "name": "Jhajhariya Fularam Pokharram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23570",
    "name": "Shah Dhiren Navin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17295",
    "name": "Gade Snehal Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5796",
    "name": "Jadhav Vasant Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15656",
    "name": "More Hanumant Ravaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20471",
    "name": "Kadam Hrishikesh Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22693",
    "name": "Patil Rajvilas Keshavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12191",
    "name": "Kolekar Shankar Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16190",
    "name": "Thakur Prasadsing Rajdevsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16980",
    "name": "Naik Sushila Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10002",
    "name": "Kavthankar Shubhada Shrikant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19676",
    "name": "Darade Bhagwan Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14827",
    "name": "Dalaram Chautaram Chaudhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1933",
    "name": "Patil Hareshwar Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21318",
    "name": "Ghanchi Bhavarlal Babulal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14077",
    "name": "Nanaware Prakash Sayaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16222",
    "name": "Bobade Jeevan Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24670",
    "name": "Gaikwad Manoj Shashikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17409",
    "name": "Asha Shripat Kusale"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "941",
    "name": "Choudhary Poonaram Jagaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "55",
    "name": "Pagire Manda Banshi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "111",
    "name": "Kanike Ankush Yellappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14926",
    "name": "Patil Ashok Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22346",
    "name": "Mehta Ashi Hitesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "939",
    "name": "Patil Sajan Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3959",
    "name": "Manjarekar Chandrakant Tatya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19857",
    "name": "Chikane Govinda Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21761",
    "name": "Rajgor Mansukh Walji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1619",
    "name": "Vishwakarma Chotelal Shivprakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9083",
    "name": "Bhtiya Ritesh Omprakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14206",
    "name": "Shirke Suresh Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14010",
    "name": "Jain Motilal J."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2584",
    "name": "Choudhary Balu Yashwant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1681",
    "name": "Shaikh Sadik Ibrahim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19314",
    "name": "Sharad Ramchandra Patil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11393",
    "name": "Kumkar Pandurang Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14761",
    "name": "Kadam Shakuntala Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19431",
    "name": "Gaud Anand Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18273",
    "name": "Lokapure Suhas Narasu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19000",
    "name": "Lakhawade Amar Raghunath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "887",
    "name": "Shukla Ratan Premkumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "42",
    "name": "Sahani Subhash Dinanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19001",
    "name": "Kar Prasanta Ranjith"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24172",
    "name": "Nimbalkar Mahadev Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8761",
    "name": "Surve Gajanan Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14323",
    "name": "Gujar Ramdheeraj Jageshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24102",
    "name": "Shah Vikram Himatlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18945",
    "name": "Javalekar Madhavi Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14423",
    "name": "Pawar Rajaram Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4845",
    "name": "Patil Pandurang Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14628",
    "name": "Jain Rekha Vinodkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19708",
    "name": "Walgude Sunil Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1779",
    "name": "Jain Anilkumar Girnarsingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2312",
    "name": "Mhatre Prakash Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9618",
    "name": "Gaikawad Laxmi Ranjendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11705",
    "name": "Gosavi Asha Vasant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2588",
    "name": "Satpute Suresh Kanhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16487",
    "name": "Karawade Sushama Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4407",
    "name": "Desai Smita Sampatroa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9951",
    "name": "Singh Arvind Jangbahadur"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13638",
    "name": "Shinde Shankar Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18647",
    "name": "Nikam Dnyaneshwar Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4154",
    "name": "Mendke Sikandar A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20692",
    "name": "Rajput Vijay Ramsingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17743",
    "name": "Disale Pradeep Dyandev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13605",
    "name": "Kadam Vilas Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22268",
    "name": "Katakar Pramod Ramesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1250",
    "name": "Maru Neetu Veerchand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1476",
    "name": "Labade Janku Chandar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13577",
    "name": "Bhosale Laxman Mahadeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "115",
    "name": "Rajpurohit Kanshing Shreeram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10888",
    "name": "Chavan Walmik Vithalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11262",
    "name": "Jain Rohit Futarmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16920",
    "name": "Saroj Gangasagar Ramasare"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11072",
    "name": "Manjrekar Pramod Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14182",
    "name": "Gala Misha Deepak."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18034",
    "name": "Khandagale Pandurang Chintaman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14496",
    "name": "Chavan Omkar Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23620",
    "name": "Fonde Bhagwan Baburao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "533",
    "name": "Yadav Ramnivas Kedarnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12838",
    "name": "Pawar Namdeo Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17436",
    "name": "Vishnoi Laduram Malaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2840",
    "name": "Patil Vasu Shanivar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5520",
    "name": "Pawar Prakash Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2937",
    "name": "Katta Suvarna Shriniwas"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "826",
    "name": "Avkire Yashwant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21572",
    "name": "Chakre Sayali Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21212",
    "name": "Bhoite Abhijit Nandkumar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "42",
    "name": "Shinde Sunita Tanaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "196",
    "name": "Paswan Vijay Ramashrey"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23526",
    "name": "Rana Kishor Shiva"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2299",
    "name": "Mhatre Gajanan Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11336",
    "name": "Shinde Vikash Dnyaneshwar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1166",
    "name": "Choudhary Savaram Bhavaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9820",
    "name": "Pedamkar Suvarna Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16948",
    "name": "Dhanawade Pandurang Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16493",
    "name": "Palte Santosh Harishchandra."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "670",
    "name": "Pawar Sampatrao Bandu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "201",
    "name": "Sawant Sanjay Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22722",
    "name": "Ladse Avinash Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9420",
    "name": "Jain Kamleshkumar Parasmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13520",
    "name": "Khalatkar Manoj Rajendrababu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2567",
    "name": "Kharwar Shambhu Shivdarshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18187",
    "name": "Mahagade Manisha Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4571",
    "name": "Potphode  A.V."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22345",
    "name": "Mehta Hetika Hitesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13175",
    "name": "Mohite Chandrakant Kashiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "119",
    "name": "Jadhav Laxman Gyanba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "548",
    "name": "Nagada Satish Raichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20094",
    "name": "Sharma Ramlal Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13835",
    "name": "Lad Shilpa Damodar."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12749",
    "name": "Kadam Babanrao Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13323",
    "name": "Kakugade Amrutrao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21529",
    "name": "Jalgaonkar Swapnil Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9034",
    "name": "Vaity Natal Simon"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17034",
    "name": "Aarzoo Educational Society"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17242",
    "name": "Jadhav Dinesh Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18482",
    "name": "Bhosale Neelam Nandkumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2688",
    "name": "Bamane Ratnabai Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2214",
    "name": "Nadar Anandraj Aayature"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16855",
    "name": "Shitole Rekha Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14053",
    "name": "Shaikh Nadim Habib"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21573",
    "name": "Chakre Vishakha Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3727",
    "name": "Jagtap Haribhau Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18581",
    "name": "Pethe Bharati Shrikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24669",
    "name": "Pisal Rupali Mahesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2408",
    "name": "Chavan Tanaji Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3738",
    "name": "Yadav Pavdharam Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6251",
    "name": "Knojiya Ramchandra Chotelal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12680",
    "name": "Phadatare Sulochana Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7248",
    "name": "Deshmukh Ramrao Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16289",
    "name": "Hindlekar Kirtimalini Dasharath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19147",
    "name": "Kadam Vikas Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15030",
    "name": "Jejurkar Mahesh Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18234",
    "name": "Salunkhe Bhanudas Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21582",
    "name": "Gaud Rajesh Ramkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22427",
    "name": "Gala Mittal Nenshi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "74",
    "name": "Singh Saihlesh Chottyelal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16851",
    "name": "Sawant Jayant Bhalchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12385",
    "name": "Kadav Shalindar Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16034",
    "name": "Mandal  Shabbirali Ajirbax"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8137",
    "name": "Shirodkar Bhgyshree Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21089",
    "name": "Rewale Sandeep Rajaram."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19000",
    "name": "Chavan Minnath Anandrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1686",
    "name": "Patil Sunil Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17040",
    "name": "Kawale Vaibhavi Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21163",
    "name": "Jain Amita Rajendrakumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2663",
    "name": "Bakale Sandeep Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15668",
    "name": "Bhosle  Kamal Pramod"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1924",
    "name": "Shah Basiben Kishanlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12983",
    "name": "Chalke Milind S."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13279",
    "name": "Pawar Dnyaneshwar Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12341",
    "name": "Sawant Varsha Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18814",
    "name": "Jadhav Dinkar Shiva"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1440",
    "name": "Ushamulla Shriniwas Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12182",
    "name": "Mehta Rajesh Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24071",
    "name": "Mishra Arundhati Sanjay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17204",
    "name": "Gaikwad Milind Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11306",
    "name": "Bohara  Tilakbahadur"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9895",
    "name": "Mulik Navnath Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9831",
    "name": "Lalan Manisha Abhay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20749",
    "name": "Nayek Umesh Buvanga"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22027",
    "name": "Choudhary Jagdish Dungaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "830",
    "name": "Nikam Somnath Vilas"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "706",
    "name": "Waghchaure Ramchandra Nana"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2787",
    "name": "Suryavanshi Vilas Maragu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5695",
    "name": "Joshi Manisha Jaideep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14471",
    "name": "Bhosale Jaymala Sunil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18867",
    "name": "Sundesha Rahul Kesharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17989",
    "name": "S Thanga Raj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13574",
    "name": "Shah Ramilaben Navinchandji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16885",
    "name": "Panda  Harekrushna Shibnarayan ."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1847",
    "name": "Suthar Sanjay Himmatram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23657",
    "name": "Yadav Parvati Ramkhilavan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11184",
    "name": "Askar Ananda Savala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17250",
    "name": "Shah Bharatkumar Chhotalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17625",
    "name": "Ghorpade Laxman Chandru."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23892",
    "name": "Bhilare Suresh Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19717",
    "name": "Desai Ramakant Popatrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "352",
    "name": "Shetty Gopal Sanjiva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13894",
    "name": "Thakur Jaisinh C."
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14197",
    "name": "Zimbre Kashinath Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17923",
    "name": "Waje Dattaram Deoram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16900",
    "name": "Varma Navratan Ramlakhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12741",
    "name": "Kumar Sonaram Samarathaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4076",
    "name": "Katkar Shankar Jagnnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15698",
    "name": "Bagwe Pankaj Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24216",
    "name": "Karundia Krishna Motilal Krishna Motilal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2018",
    "name": "Chaudhari Sureshkumar Lalaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14321",
    "name": "Rajapure Pundalik Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3361",
    "name": "Kadam Narayan Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15455",
    "name": "Subhas Balaram Kule"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18750",
    "name": "Kute Sagar Ramesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "830",
    "name": "Salunkhe Dhanaji Shivaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2026",
    "name": "Patil Manoj Sukhlal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2023",
    "name": "Patil Pramod Yuvraj"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2456",
    "name": "Nayak Sanjay Adikand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18808",
    "name": "Chauhan Naresh Kanti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23064",
    "name": "Yadav Ajit Sadanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2595",
    "name": "Chavan Narayan Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13495",
    "name": "Rathod Atul Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16068",
    "name": "Jambavadekar Vinisha Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18054",
    "name": "Tharval Mayuri Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16807",
    "name": "Gorule Kishor Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "262",
    "name": "Patil Tanaji Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18511",
    "name": "Mohite Anand Pandurang."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21226",
    "name": "Parihar Bhanwarlal Gulabchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9910",
    "name": "Yadav Ramindradevi Bachuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3629",
    "name": "Veer Suresh Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1886",
    "name": "Kerkar Janardan Baboo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13622",
    "name": "Bhadare Rekha Somnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15833",
    "name": "Gavkar Ranjana Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2824",
    "name": "Jadhav Sidharth Vittal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15811",
    "name": "Nikam Avadhut Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22736",
    "name": "Jagtap Suraj Dayanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19906",
    "name": "Sawant Rajendra Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1678",
    "name": "Sharma Suman Ghanshyam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2287",
    "name": "Mujahid Sajid Abdul Hameed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18924",
    "name": "Jajodia Rekha Pawan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18582",
    "name": "Moghe Madhav Ganesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23354",
    "name": "Ghenand Nilam Nilesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21538",
    "name": "Kalantre Santosh Dattu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2504",
    "name": "Markandey Rama Mahesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11994",
    "name": "Adhav Nathuram Dinkar 281/18/A"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22152",
    "name": "Jain Pinky Vikas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18547",
    "name": "Agrawal Vipin Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19351",
    "name": "Yewale Sunita Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3274",
    "name": "Tawade Milind Manohar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2562",
    "name": "Sharma Ramshankar Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13238",
    "name": "Ghodke Sanjay Akaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19774",
    "name": "Mehata Ishwarlal Bhaichand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13814",
    "name": "Naidu Shivprakash Kallimahakola"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2871",
    "name": "Khutvad Kirti Kailas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16810",
    "name": "Khanekar Anjana Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7745",
    "name": "Pokale Dattaram Shambu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9402",
    "name": "Jain Lata Chandulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19922",
    "name": "Mohite Mangesh Shardrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "925",
    "name": "Antagiri Saraswati Sharanapya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1223",
    "name": "Salunkhe Vishnu Gonvid 199/A/5"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15606",
    "name": "Shinde Anil Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8802",
    "name": "Kanekar Sunil Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15089",
    "name": "Shah Kiran Jayantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17882",
    "name": "Narvekar Ashalata A"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2748",
    "name": "Choudhary Girish Rambuzarat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2831",
    "name": "Salate Atmaram Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19010",
    "name": "Raipelly Neeta Anilkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21727",
    "name": "Shaikh Ansur Muiddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21016",
    "name": "Kothari Atit Umedmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21685",
    "name": "Vichare Varsha Suhas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23840",
    "name": "Kamat Hirendra Sukhdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12454",
    "name": "Phalke Sulochana Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19181",
    "name": "Poojari Shekhar Sanju"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19805",
    "name": "Konde Sushant Dattram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2022",
    "name": "Singh Kapildev Triloki"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21959",
    "name": "Berdiya Dhanji Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14443",
    "name": "Ghadi  Digambar Kanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19854",
    "name": "Thombare Dattatray Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15886",
    "name": "Anpat Gorakh Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11377",
    "name": "Agarwal Pukhraj H"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23985",
    "name": "Mohite Tanaji Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8682",
    "name": "Chaudhary Lalan Ramashish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22125",
    "name": "Pawar Swapnil Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25097",
    "name": "Bhoite Prachi Devendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22115",
    "name": "Raut Rajesh Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12067",
    "name": "Chouhan Noorbanu Nisarkhan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2936",
    "name": "Ithikkat Manoj Devraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17687",
    "name": "Rajesh Chandrakant  Jadhav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6398",
    "name": "Modi Ajay Nagardas"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "567",
    "name": "More Abaji Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23076",
    "name": "Shetty Vijay Sheena"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "483",
    "name": "Zagade Pradnya Yogesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15250",
    "name": "Ojha  Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3037",
    "name": "Rakshe Bachherao Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15660",
    "name": "Vijay Prakash Shree Sarvjanik Ganeshosta"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "842",
    "name": "Vhavle Dinesh Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15921",
    "name": "Rathod Komalshing Rahulsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7172",
    "name": "Ghare Bhimrao Anandrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2805",
    "name": "Choudhary Laxman Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24156",
    "name": "Ghai Gaurav Krishankumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21301",
    "name": "Parwate  Ankush  Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14436",
    "name": "Shaikh Gulzar Musibat Ali."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14127",
    "name": "Chavan Jaiprakash Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14507",
    "name": "Khan Amanulah Abdulahmi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21526",
    "name": "Kadam Navnath Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10366",
    "name": "Joshi Prakash Trimbak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23761",
    "name": "Mhatre Shubhangi Harishchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "259",
    "name": "Shah Bhavin Kanaiyalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16121",
    "name": "Chavan Namrata Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23244",
    "name": "Gameti Ghashiram Modaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21339",
    "name": "Gujar Santosh Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19787",
    "name": "Kavde Chandrakant Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3900",
    "name": "Salokhe Maruti Balu."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22962",
    "name": "Shinde Mahendra Krishnrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9565",
    "name": "Raul Ashok Rama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17015",
    "name": "Gawade Huvanna Sidram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6883",
    "name": "Nawadkar Suresh Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17636",
    "name": "Chavan Sudhir Shankaromakar Traders"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "522",
    "name": "Jagtap Ashish Jaywant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17545",
    "name": "Shinde Leelabai Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12344",
    "name": "Rathod Mamta Kapoorchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19694",
    "name": "Zore Sagan Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14283",
    "name": "Shirodkar  Bhanudas Nagesh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7927",
    "name": "Kifaye  Tunnisa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19693",
    "name": "Gavade Thaku Sakhru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13654",
    "name": "Kindre Yeshwant Shankar."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1071",
    "name": "Mali Durgaprasad Jhingru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17075",
    "name": "Waghmare Jayshree Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17808",
    "name": "Singh Triveniprasad Girijashankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21579",
    "name": "Mohd Hanif Abdul Hakim Gehlot"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12595",
    "name": "Mahesh Chatarbhuj Shinde"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10275",
    "name": "Sakunde Sanjay Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17693",
    "name": "Nandgaonkar Milind Keshav."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2727",
    "name": "Patel Laxmanbhai Sujabhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1165",
    "name": "Lokre Kesharbai Shivmurti."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14793",
    "name": "Kolekar Dnyandev Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11658",
    "name": "Waychal Shivaji Natha"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "918",
    "name": "Shinde Dilip Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24910",
    "name": "Takshshila Shikshan Sanstha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15483",
    "name": "Jagtap Sakuntala Ashok."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21729",
    "name": "Mandhare Sunil Vishrwas."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11673",
    "name": "Jain Amitkumar Kantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18366",
    "name": "Mohite Kedarnath Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16132",
    "name": "Wagh Sanjay Subhedar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13533",
    "name": "Talekar Vimal Mangesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16753",
    "name": "Phale Mahadeo Jotu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9750",
    "name": "Jain Ramesh Kumar Pukhrajji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16209",
    "name": "Dalvi Suhash Shamsundar."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7429",
    "name": "Gavkhadkar Pramila Vithal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "999",
    "name": "Khimasiya Binal Chandulal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1144",
    "name": "Prajapati Talasabhai Mangalbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17172",
    "name": "Girap Kishor Dhondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13807",
    "name": "Shivthare Dilip Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13531",
    "name": "Patil Dharma Shantilal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2224",
    "name": "Choudhary Rajkumar Gayaprasad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "491",
    "name": "Gaikwad Amar Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12508",
    "name": "Sonar Ransingh Pahalsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18344",
    "name": "Solanki Bhavar Lal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10426",
    "name": "Phanguskar Suhas Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12990",
    "name": "Bagwe Shubhada Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24725",
    "name": "Mohammed Hanif Suleman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15823",
    "name": "Sharma Pratibha Pannalal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14922",
    "name": "Gurav Laxman Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20862",
    "name": "Padania Noori Shaizad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2487",
    "name": "Ghare Bajirao Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3441",
    "name": "Revankar Tukaram Gopal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2488",
    "name": "Punyarthi Santosh Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18406",
    "name": "Hiralal Lalaram Choudhary"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21151",
    "name": "Chheda Bhavna Mulchand."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13482",
    "name": "Chalke Shyam Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14157",
    "name": "Shinde Vijay Chandrakant Toli No 57/53"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17657",
    "name": "Gupta Mishrilal Harichandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13684",
    "name": "Harijan Parasram Newaru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12742",
    "name": "Jain Sushil Sheshmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8400",
    "name": "Yadav Ramkeval Liveni"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12482",
    "name": "Mohare Ashok Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16439",
    "name": "Vaidya Prafulla Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22456",
    "name": "Bongane Ashok Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4325",
    "name": "Chavan Hindurao Manganrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14815",
    "name": "Dwivedi Sheshram Ambikaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14316",
    "name": "Ethape Sachin Suresh."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18419",
    "name": "Chavan Sunanda Sahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14619",
    "name": "Jain Sanjay Uttamchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19593",
    "name": "Nimbalkar Prithviraj Murlidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20371",
    "name": "Mahto Dhananjay Prasad Bhagwat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18425",
    "name": "Shinde Santosh Motiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19975",
    "name": "Jadhav Jaydeep Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24183",
    "name": "Gambhir Mayuresh Ajit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21806",
    "name": "Raibole Vijay Devidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18751",
    "name": "Chandan Shive Bhimrao  Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19858",
    "name": "Vetal Sunil Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21696",
    "name": "Shaikh Khushbunissa Abdulkadir."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21753",
    "name": "Bane Poonam Vikas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9023",
    "name": "Shaikh Mohamad Ismail"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2718",
    "name": "Chowdhary Nainu Ganeshram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19263",
    "name": "Bhimde Ramchandra Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21174",
    "name": "Durgoli Babya Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16000",
    "name": "Chavan Vishal Vijaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19002",
    "name": "Kadam Bajirao Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18503",
    "name": "Surve Sanjay Jagnnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20771",
    "name": "Kusum"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14833",
    "name": "Kansara Bharat Jayantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6253",
    "name": "Bagwe Deepak Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23829",
    "name": "Sapakal Sunita Rambhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13219",
    "name": "Sankpal Malan Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6611",
    "name": "Gawade Pratima Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18513",
    "name": "Patil Balkrishan Dadaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4868",
    "name": "Buddikhan Mahamod Imran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17716",
    "name": "Kudalkar Nilam Digamber"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2806",
    "name": "Jadhav Vidya Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23162",
    "name": "Ashar Sameera Hussein"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18557",
    "name": "Choudhari Amal J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8482",
    "name": "Lad Damodar Sahadev"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2193",
    "name": "Mashru Jagruti Ashwin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21505",
    "name": "Kalugade Ananda Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10626",
    "name": "Jain Babulal Devichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22268",
    "name": "Tevar Raju Mutppa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20213",
    "name": "Khilari Tushar Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19676",
    "name": "Yedge Vithal Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9350",
    "name": "Shinde Dashirath Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18320",
    "name": "Nimbalkar Anandrao Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13162",
    "name": "Madane Shivaji Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16458",
    "name": "Sapaliga Sanjiva Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5646",
    "name": "Pawar Balkrishna Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19300",
    "name": "Scc 191 Cavel"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14087",
    "name": "Sawant Ashok Tukaram 272/22"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7976",
    "name": "Bavale Bhimabai Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12755",
    "name": "Choudhary Bholaram Motiji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1411",
    "name": "Chaudhary Jagaram Umaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12972",
    "name": "Padval Suryakant Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12565",
    "name": "Jain Shantilal Sirehmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19684",
    "name": "Padiyar Liladevi Narayanji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12045",
    "name": "Salunke Nisha Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17095",
    "name": "Kadam Narayan Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13348",
    "name": "Mali Archana Abhimanyu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8514",
    "name": "Bhadricha Divalibai Khamji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17395",
    "name": "Salgaonkar Prkash Mangesh."
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18718",
    "name": "Purkait Seema Robin"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "655",
    "name": "Pawar Madhuri Santosh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2742",
    "name": "Purohit Ashok Harsanji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12039",
    "name": "Thorat Subhash Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "958",
    "name": "Shewale Jaywant Jaysing"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2725",
    "name": "Chaudhary Deepa Santosh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22032",
    "name": "Jawlekar Resma Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18490",
    "name": "Musale Poonam Sharad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18113",
    "name": "Mhaske Aarti Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22406",
    "name": "Tambe Prabhat Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10005",
    "name": "Rathod Gamaram L"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17249",
    "name": "Gaikwad Sanjay Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2741",
    "name": "Patil Ravikant Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15567",
    "name": "Ghag Runali Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8733",
    "name": "Bohara Madan Dharamsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4301",
    "name": "Gujrathi Jahur Gaffurmiya."
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1653",
    "name": "Aswale Vishal Yashavant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3133",
    "name": "Jagtap Mahipat Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16614",
    "name": "Shaikh Mohmad Irfan Asgar Ali."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "447",
    "name": "Kadam Ananda Nathu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22265",
    "name": "Matele Uttam Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21726",
    "name": "Manikare Laxmi Ramesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2514",
    "name": "Patil Ramesh Ragho"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12773",
    "name": "Vaitay Moreshwar Naru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17047",
    "name": "Sakpal Pradeep Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8612",
    "name": "Salvi Anjali Anant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "478",
    "name": "Bansode Ishwar Lahu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11982",
    "name": "Phadatare Popat Shripati Tn-543-44"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18963",
    "name": "Patil Maruti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6518",
    "name": "Shinde Ramchandra Vitthal  Tn-341-7"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1626",
    "name": "Mhatre Priya Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15507",
    "name": "Jain Surekha Parasmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24500",
    "name": "Kandekar Minakshi Ragunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19883",
    "name": "Pawar Kalpana Mahan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19804",
    "name": "Yedge Dadu Dhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19490",
    "name": "Shah Bharat Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8910",
    "name": "Mistry Hasmukh Naryan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2766",
    "name": "Mhatre Devraj Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17956",
    "name": "Sharma Ramswaroop"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6597",
    "name": "Mandhare Popat Jaysing."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20921",
    "name": "Shah Malati Chhotelal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18458",
    "name": "Khivishra Sanjay Madanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15130",
    "name": "Kambale Balu Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14873",
    "name": "Pisal Sandeep Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10431",
    "name": "Tamka Kalpana Kirtikumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "500",
    "name": "Patil Akshata Vikas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2915",
    "name": "Jagtap Ashok Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22282",
    "name": "Jain Amit Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21280",
    "name": "Sarpate  Shantabai  Baliram."
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23703",
    "name": "Dr K C Sharma Election Officer"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6703",
    "name": "Shah Jagdish Prabhudas"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "554",
    "name": "Ughade Tanmay Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16421",
    "name": "Chavan Nandkumar Rajaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "69",
    "name": "Nayak Chandan Jagbandhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14530",
    "name": "Jadhav Lalit Hanumant."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8468",
    "name": "Sidique Saidabano Wasim."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17036",
    "name": "Waghe Vaishali Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24692",
    "name": "Karande Shivaji Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17829",
    "name": "Bhoite Vijay Anadrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12537",
    "name": "Londhe Satish Balu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "623",
    "name": "Chaudhary Otaram Ganeshram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4489",
    "name": "Jaising Indra Manoharalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16748",
    "name": "Kadam Ramesh Vithoba."
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15153",
    "name": "Tonde Jagdish Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19989",
    "name": "Janjotri  Fatesing Paleram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21413",
    "name": "Kotian Lalitha Appa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12834",
    "name": "Mandhare Mahadeo Piloba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19539",
    "name": "More Sumesh Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8266",
    "name": "Varma Savitridevi Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8598",
    "name": "Tamka Kirtikumar Dhanraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14594",
    "name": "Jaiswal Shivdhari J"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16033",
    "name": "Mahida Hariba Gopal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "170",
    "name": "Mhanera Deepak Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14097",
    "name": "Yadav Ramjas Rupai"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2017",
    "name": "Singh Raju Kishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9718",
    "name": "Bhandari Devaki Bhaskar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17194",
    "name": "Maharashtra Marathi Mukta Patrakar Sangh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18246",
    "name": "Retharekar Rajendrakumar Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2336",
    "name": "Patil Pravin Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14539",
    "name": "Sawant Dinkar Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18954",
    "name": "Jha Bibhutikumar Narsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20901",
    "name": "Sawant Saiprasad Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18516",
    "name": "Poojari Mahabal Channa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18439",
    "name": "Devduga Satish Lachha."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15647",
    "name": "Devandar Shermakani Swami"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12624",
    "name": "Todakar Ramesh Ishwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17772",
    "name": "Mohite Mohan Rangoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14890",
    "name": "Bhat Bhavani Shankar."
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8846",
    "name": "Shivneri Mitra  Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17132",
    "name": "Soni Prakashchandra C"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1224",
    "name": "Mhatre Seema Mahanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13893",
    "name": "Bhosle Pramod Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18099",
    "name": "Shetty Viva Dayanand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2045",
    "name": "Gaikwad Jyoti Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4269",
    "name": "Kadam Kashibai Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20241",
    "name": "Vijaya Dattatray Kadam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13711",
    "name": "Begam  Mumtaj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3055",
    "name": "Gaikawad Popat Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25304",
    "name": "Ansari Fatma Mohdashfar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22758",
    "name": "Ansari Vakil Ahmed Sagir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19902",
    "name": "Bhisale Chandrahas Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25271",
    "name": "Chauhan Raichan Heer"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "902",
    "name": "Chavan Dattatray Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25243",
    "name": "Dube Omprakash Radeshyam"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1567",
    "name": "Gade Dhondiram Damu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15293",
    "name": "Ghadage Bhimrao Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25336",
    "name": "Gupta Gunidevi Shambhuprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25312",
    "name": "Gupta Jitendra Ramnayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25198",
    "name": "Jadhav Kishor Chhagan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25200",
    "name": "Kadam Jayprakash Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25347",
    "name": "Khan Mohd Sharif Mohd Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25327",
    "name": "Loriya Loyatin Thomas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25306",
    "name": "Pandey Subhashchandra Herday Pandey Subhashchandra Herday Pandey Subhashchandra Herday"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25266",
    "name": "Pandey Suryanarayan Chintaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25286",
    "name": "Patil Arun Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25227",
    "name": "Patil Rajendra Eknath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2213",
    "name": "Patil Vinod Sheshrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25343",
    "name": "Pavar Santosh Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25204",
    "name": "Pitale Subhash Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25300",
    "name": "Purabiya Dhanji Magan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25335",
    "name": "Qureshi Riyazahmed Abdulhamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25361",
    "name": "Rao Prabhakar Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2266",
    "name": "Rathod Santosh Chandrakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "950",
    "name": "Sabar Angad Dnoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25357",
    "name": "Sawant Rajashri Raju"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25307",
    "name": "Sayyad Farukh Ajgarali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25256",
    "name": "Shaikh Asimuddin Muradali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25268",
    "name": "Shaikh Fateh Mohd Bismillah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25310",
    "name": "Shaikh Mohd Babu Ahmed Saheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25369",
    "name": "Shetty Raju Dev"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1436",
    "name": "Singh Ragendra Jaipraksh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25305",
    "name": "Singh Rajneesh Adityaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25379",
    "name": "Singh Ramkamal Ramkaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25328",
    "name": "Varma Ramanand Ramrup"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20925",
    "name": "Yadav Hariprasad Vijaybahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25356",
    "name": "Yadav Ramakant Ramachaibar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23982",
    "name": "Yadav Shriram Tilakdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21879",
    "name": "Yadav Subedar Baburam"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4404",
    "name": "An Interior India Associate"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22032",
    "name": "Dhumal Sushila Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2734",
    "name": "Atoz Uniform Suppliers"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "390",
    "name": "Balaji Motors"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24271",
    "name": "Salunkhe Pandurang Vakoba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "494",
    "name": "Umbarkar Dattatray Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23086",
    "name": "Ghule Bhagubai Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11682",
    "name": "Kamite Shivaji Malhari"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "772",
    "name": "Gupta Raju Ramdhani"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1130",
    "name": "Hegde Sunil Venkatesh"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2319",
    "name": "High Class Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "99",
    "name": "J V Brothers & Co"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1622",
    "name": "Khobare Suryakant Raghoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18459",
    "name": "Sonawane Mohan Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1696",
    "name": "Jay Renuka Roadways"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14612",
    "name": "Gaikwad Ashok Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3314",
    "name": "Joshi Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14528",
    "name": "Visawadia Girish B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10928",
    "name": "Gurav Murlidhar Nath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24206",
    "name": "Kamble Dilip Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15921",
    "name": "Shinde Sachin Babanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24165",
    "name": "Singh Rewati Raman R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21605",
    "name": "Dhumal Aprana Rajendra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1351",
    "name": "Chaughule Shravan Abhimannu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16660",
    "name": "Jain Pinkesh Nareshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16443",
    "name": "Pawar Hanmant Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16299",
    "name": "Parmar Pravin Muljibhai/Mrs Devika P Par"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23699",
    "name": "Khopade Satish Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1928",
    "name": "Phalke Lalaji Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21890",
    "name": "Aangchekar Madhukar Zilu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18847",
    "name": "Khan Sadrealam A  Kalam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22366",
    "name": "Bhusari Bhimrao Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2018",
    "name": "Kadam Ramu Chandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24035",
    "name": "Jagtap Kanchan Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18355",
    "name": "Sarmalkar Prashant Shrikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22442",
    "name": "Jaid Chhaya Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21377",
    "name": "Ray Lilajit Lalta"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "380",
    "name": "Kuswaha Raju"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18453",
    "name": "Tawade Siddharth Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20242",
    "name": "Jagtap Ganesh Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17002",
    "name": "Nalawade Arjun Govind"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1097",
    "name": "Singh Kusum Karan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10987",
    "name": "Bhosale Hanmant Mansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22536",
    "name": "Kadam Ujwala Swapnil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22535",
    "name": "Warang Vaishnavi Vinod"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22534",
    "name": "Nakhwa Uday Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24068",
    "name": "Sanjay Gangaram Taigade"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1038",
    "name": "Mathkar Dajiram Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22053",
    "name": "Jadhav Shankar Dayanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22501",
    "name": "Shaikh Abdul Aziz Ali Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22514",
    "name": "Barje Mahendra Tanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20326",
    "name": "Nangare Sunil Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22506",
    "name": "More Rasik Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23986",
    "name": "Koundar Balakrishna Pichkaran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6611",
    "name": "Jadhav Shivaji Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12774",
    "name": "Shah Mohd Farooq Noor Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23312",
    "name": "Sabale Pankaj Sunil"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1771",
    "name": "Sorte Pratibha Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21164",
    "name": "Sugarkar Ashok Shekhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19696",
    "name": "Khan Mehtab Khan Abdul Haq"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18428",
    "name": "Ghadage Anand Shankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "775",
    "name": "Kokare Janardhan Raya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23860",
    "name": "Shende Umesh Shrirang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "283",
    "name": "Khushi Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18778",
    "name": "Barge Pushapa Vijay & Barge Vijay Gulabr"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1012",
    "name": "Dudhal Sandip Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14921",
    "name": "Kadam Jagannath Subhedar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "267",
    "name": "Zinjad Rajaram Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4074",
    "name": "Yewale Ramdas Dnyanoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15810",
    "name": "Pawar Balkrushna Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19977",
    "name": "Yadav Ravindranath Shivdas"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "44",
    "name": "Krishna Estate"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20451",
    "name": "Chouhan Kailashpati Ramajor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3494",
    "name": "Yewale Krishnabai Ramdas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "407",
    "name": "Kunal Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20644",
    "name": "Masalkar Subhash P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22302",
    "name": "Chavan Anil Krishnarao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "773",
    "name": "Dhas Pradip Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21636",
    "name": "Yejarkar Devendra Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20006",
    "name": "Gawade Ruchira Vinayak Gawade"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1583",
    "name": "M Y Pile Foundations"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "341",
    "name": "M/S Patil& Salunkhe Associates"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "779",
    "name": "Nikam Pradip Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4206",
    "name": "Jadhav Shivaji Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23282",
    "name": "Ahire Suresh Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20993",
    "name": "Subhedar Pradip Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20416",
    "name": "Pawar Vikram Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12183",
    "name": "Deshmukh Dnyandeo Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13893",
    "name": "Chavan Narayan Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16848",
    "name": "Sawant Kondiram Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21887",
    "name": "Sawant Ravindra Dhaku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9644",
    "name": "Patil Dattatray Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10251",
    "name": "Sawant Subhadra Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12088",
    "name": "Jadhav Shivaji Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19148",
    "name": "Shinde Dhukaji Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18897",
    "name": "Supugade Shankar Khashaba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1217",
    "name": "Jha Vivekanand Raman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21767",
    "name": "Kesarkar Pradeep Anant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1974",
    "name": "Yadav Shriram Budhdu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16690",
    "name": "Palwankar Sandhya Atamaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "862",
    "name": "Sargar Samadhan Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13826",
    "name": "Singh Narsinghbahadur Satynarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3725",
    "name": "Nagre Pushpa Chandrakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "446",
    "name": "Khichi Dashrath Sher Singh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17485",
    "name": "Gaikwad Nilesh Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15104",
    "name": "Sawardekar Tanaji Bhau  1461-4"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25346",
    "name": "Machekar Subhesh Vasudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25345",
    "name": "Pandey Rajnath Kamalashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25342",
    "name": "Shaikh Mohd Rafiq Gani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25289",
    "name": "Paneriya Suraji Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25295",
    "name": "Yadav Sewalal Ramkhilawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21871",
    "name": "Dayal Satyanarayan Laxminarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22020",
    "name": "Karale Suryakant Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23957",
    "name": "Jagtap Mahendra Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17755",
    "name": "Tek Ajay Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24758",
    "name": "Khan Jahangir Rajaakram Husen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24639",
    "name": "Ahmed Vakil Bashir"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2302",
    "name": "Naike Infotech"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1505",
    "name": "Yadav Rahulkumar Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6398",
    "name": "Utekar Dnyaneshwar Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1314",
    "name": "Singh Babadin Aaphat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6545",
    "name": "Ghadge Shamsunder Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12457",
    "name": "Anpat Appa Dada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4168",
    "name": "Cheda Laxmiben Shantilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11977",
    "name": "Gaikwad Suman Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13679",
    "name": "Kuvesakar Dnyaneshar Shankar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1684",
    "name": "Chorge Bajirao Bandu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "467",
    "name": "Deshmukh Haridas Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21127",
    "name": "Lipare Savita Sushil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20116",
    "name": "Gond Dineshkumar Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9763",
    "name": "Shaikh Ismail Muneer"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22048",
    "name": "Mandawkar Ramchandra Deoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19072",
    "name": "Shinde Suryakant Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25386",
    "name": "Siddique Irshad Ahmed Shamsuddin"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1921",
    "name": "Wagh Nandkumar Omkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25374",
    "name": "Ambati Chandrabhaga Somayya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25376",
    "name": "Meman Farooq Abdul Latif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25377",
    "name": "Mishra Krishnachandra Badrinath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1917",
    "name": "Valkunde Nana Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17828",
    "name": "Jain Chelna Chandulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25333",
    "name": "Bobade Prashant Muralidhar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1894",
    "name": "Miss  Patil Rupali Pandurang"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1896",
    "name": "Sawant Sonia Prashant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15326",
    "name": "Bagwan Shahnaj Babubhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22525",
    "name": "Deshmukh Bhagwatrao Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15337",
    "name": "Mane Vikas Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15332",
    "name": "Mulla Musa Mahammadhusain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25311",
    "name": "Pawar Sachin Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24053",
    "name": "Salunkhe Arun Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15334",
    "name": "Shaikh Rais Harun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15339",
    "name": "Shinde Subhash Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25319",
    "name": "Valanj Devendra Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22510",
    "name": "Dalvi Ramchandra Dhondu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1863",
    "name": "Lende Sandeep Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25281",
    "name": "Nikam Pavitra Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25292",
    "name": "Pawar Amit Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22508",
    "name": "Phansekar Madhukar Dayal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25269",
    "name": "Rai Hirdaya Nath Kashi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25273",
    "name": "Shinde Tejaswi Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15302",
    "name": "Bobade Amol Dnyaneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15310",
    "name": "Ghorpade Nitin Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15311",
    "name": "Ghorpade Sachin Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15303",
    "name": "Jadhav Gayatri Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15306",
    "name": "Jadhav Punit Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15313",
    "name": "Mane Anagha Avinash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24042",
    "name": "Mane Apeksha Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24041",
    "name": "Mane Shamal Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15316",
    "name": "Shinde Uday Shivajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16175",
    "name": "Lembhe Sudershan Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23255",
    "name": "Appare Darashan Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25211",
    "name": "Bhoir Deepak Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15292",
    "name": "Bobade Mahadeo Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20378",
    "name": "Gadhave Govindrao Appaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24020",
    "name": "Mohite Chitrak Janu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1029",
    "name": "Rajpurohit Jabbarsingh Narpatsingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24022",
    "name": "Sawant Vishwajit Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25225",
    "name": "Shinde Vikas Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24030",
    "name": "Satav Omkar Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5231",
    "name": "Pawar Balkrishna Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24016",
    "name": "Amberkar Mrunal Manoj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24015",
    "name": "Khilari Avinash Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25121",
    "name": "Shinde Datta Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12289",
    "name": "Bhosale Balaso Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13618",
    "name": "Jain Nitin Uttamchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22079",
    "name": "Dudaye Mahesh Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "948",
    "name": "Savita Anil Jadhav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13328",
    "name": "Lawale Duryodhan Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23998",
    "name": "Patel Sagar Anil"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1706",
    "name": "Bhujang Bhagwan Ramkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19635",
    "name": "Kadam Vandana Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5682",
    "name": "Salunkhe Ramchandra Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14852",
    "name": "Nalage Sampat Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13466",
    "name": "Shivankar Balwant Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15087",
    "name": "Sankpal Hemant Sundarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22305",
    "name": "Gaikwad Tarachand Chimaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21762",
    "name": "Vishwakarma Rameshkumar Mohanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23331",
    "name": "Ansari Asfaq Ahamed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23261",
    "name": "Shaikh Shafiqe Mohd Gouse"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6844",
    "name": "Kolekar Vishnu Krishna 93/19"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "921",
    "name": "Gharat Dnyaneshwar Dashrath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11520",
    "name": "Patel Gajraj Ishwarlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3724",
    "name": "Nagre Chandrakant Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8458",
    "name": "Jagtap Ashok Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15754",
    "name": "Kolekar Ananda Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21602",
    "name": "Soni Sersing Dhansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14884",
    "name": "Kir Geeta Devidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14426",
    "name": "Chavan Anil Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15353",
    "name": "Pisal Shivaji Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12561",
    "name": "Nikam Ankush Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17540",
    "name": "Sawant Amar Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12898",
    "name": "Vichare Kisan Bajrang"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1250",
    "name": "Khan Nisar Ahmed Murtaza"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1894",
    "name": "Pooja Plastic Mould"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25387",
    "name": "Honrao Sanjeev Trimbak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24044",
    "name": "Sawant Hemlata Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15305",
    "name": "Mahadik Dattakripa Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1951",
    "name": "Prasad Tools"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18514",
    "name": "Thapa Sitakumari Dulbahadur"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1326",
    "name": "Chauhan Shivanand Kishan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23704",
    "name": "Mutal Vanita Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18941",
    "name": "Konde Jalinder Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2107",
    "name": "R N Engineering"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2093",
    "name": "Radhakrishna Genaral Stores"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10235",
    "name": "Sakunde Gajanan Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19164",
    "name": "Rao Ramashankar Vishnathprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9972",
    "name": "Shinde Savita Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21803",
    "name": "Chavan Pradeep Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23739",
    "name": "Patil Marutrao Appaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21052",
    "name": "Shri  Sai  Siddhi  Mitra   Mandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7203",
    "name": "Jagtap Dayanand Parbati"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2294",
    "name": "Ramesh Agrawal& Co"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4616",
    "name": "Bhosale Balkrishna Pandharinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17332",
    "name": "Shah Mohammed Yusuf Nizamuddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22078",
    "name": "Tari Kshama Shyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20022",
    "name": "Ghanekar Sunita Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23789",
    "name": "Thakkar Mithun Arvind"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4675",
    "name": "Ruparel Estate ( India ) Pvt Ltd"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3268",
    "name": "Sahyog Printers"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1346",
    "name": "Nishad Bashantkumar Lalluprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9380",
    "name": "Potale Balakrishna Jayram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8854",
    "name": "Vyadande Chandrabhaga Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11329",
    "name": "Inamdar Sameer Lala"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "155",
    "name": "Sasbale Amar Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18137",
    "name": "Yadav Keshari Prasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22423",
    "name": "Chavan Charushila Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22442",
    "name": "Kate Nikhil Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25015",
    "name": "Poshampally Laxman Chandranna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1315",
    "name": "Chaudhari Mangilal Mularam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "481",
    "name": "Dighe Baban Dinkar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2268",
    "name": "Singh Manoj Suryadeo"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "337",
    "name": "Satara Motors"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18347",
    "name": "Chavan Anusaya Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "770",
    "name": "Kadam Namdeo Hanamant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "237",
    "name": "Sarade Sayaji Bhagvat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3823",
    "name": "Yadav Mahavir Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18262",
    "name": "Shah Kamleshdevi Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18945",
    "name": "Jain Mehul Karanraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9310",
    "name": "Nigudkar Santosh Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13712",
    "name": "Correia  Sunit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14419",
    "name": "Natkar Ramesh Sopanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22201",
    "name": "Gadoya  Kirit Vallabhdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3952",
    "name": "Pisal Jaiwant Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11039",
    "name": "Gaikwad Supriya Shashikant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "785",
    "name": "Yedage Jayram Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4297",
    "name": "Kemase Pandurang Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25291",
    "name": "Pawar Archana Bhaskar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3099",
    "name": "Kadam Vithal Narayan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "274",
    "name": "Pathan Akram Adam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3002",
    "name": "Chouhan Gangaram Hanuman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15176",
    "name": "Kolape Phulabai Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15147",
    "name": "Kolape Yogesh Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19964",
    "name": "Sabale Rahul Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23163",
    "name": "Kale Rakesh Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13224",
    "name": "Shekh Amin Vajeer"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4125",
    "name": "Yewale Dilip Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22490",
    "name": "Sarwade Satyawan Sandeepan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1650",
    "name": "Yadav Deviprasad Kariyaprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9248",
    "name": "Chatur Kusum Vasant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "399",
    "name": "Hakke Gajanan Dattatrya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16051",
    "name": "Baur Jagannath K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21058",
    "name": "Mane Tukaram Dhanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4142",
    "name": "Jaiswal Rambhiksh Ramsevak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23535",
    "name": "Bhosale Punam Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20270",
    "name": "Jagtap Poonam Tatayaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "64",
    "name": "Dattatray Chandrakant Mojar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "432",
    "name": "Shiv Packing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14818",
    "name": "Mulik Tukaram Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15050",
    "name": "Nikam Kamal Balaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14740",
    "name": "Kenjale Sulabai Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "648",
    "name": "Patil Ujvala Sandeep"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14152",
    "name": "Shinde Balkrishna Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20189",
    "name": "Verma Ramakant Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15718",
    "name": "Chande Vaibhav Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12892",
    "name": "Disale Dattatray Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2077",
    "name": "Suraj General Stors"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4596",
    "name": "Sure- Choice"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19514",
    "name": "Ingale Asha Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25002",
    "name": "Bhardava Dharmika Ratilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21948",
    "name": "Dhatavkar Maya Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17036",
    "name": "Pachapute Tanaji Shripati    1494/4"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5444",
    "name": "Bahadkar Ganesh Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10570",
    "name": "Pujare Shitaram Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16503",
    "name": "Kadam Shruti Sunil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11696",
    "name": "Shukla Ajay Ramshankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19768",
    "name": "Sampat Rashmi Parag"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20078",
    "name": "Jadhav Nitin Y"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21778",
    "name": "Dhole Arvind Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1703",
    "name": "Vaishno  Plastics"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20162",
    "name": "Pujare Nitin Namdev"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "801",
    "name": "Choudhary Machhindra Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13064",
    "name": "Keniya Navnit Ramaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17527",
    "name": "Gujaria Usha Kishor"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13366",
    "name": "Mahadik Shamrao Dnaynu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21701",
    "name": "Gujar Sunil Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15091",
    "name": "Chavan Namdev Madhavrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3073",
    "name": "Jaiswal Pradeep Mahaveer"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3066",
    "name": "Sumaria Narshi Murag"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22529",
    "name": "Salvi Vishal Suresh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3048",
    "name": "Shahi Navraj Dan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12572",
    "name": "Chavan Nanda Vikas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3034",
    "name": "Chavan Avinash Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25298",
    "name": "Pawar Supriya Krishna"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1855",
    "name": "Walimbe Jagan Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24023",
    "name": "Poojari Saroja Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23067",
    "name": "Jagdale Santosh Hanmantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22844",
    "name": "Goje Varshalata Vipin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15696",
    "name": "Gupta Shivmurat Buddu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3488",
    "name": "Mutal Rajaram Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9251",
    "name": "Bhomkar Chandrakant Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13814",
    "name": "Shedage Rekha Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18395",
    "name": "Gawade Surekha Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13818",
    "name": "Tambe Saudamini Ramakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1040",
    "name": "Gaikwad Santosh Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21951",
    "name": "Jain Sahil Lalitkumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14812",
    "name": "Nikam Archana Navnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23942",
    "name": "Vassa Bhavna Fancy"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1888",
    "name": "Shetty Jagdish Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22242",
    "name": "Sawant Vishal Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22313",
    "name": "Sawant Krishnakant Gopal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1846",
    "name": "Rathod Narmada Ramesh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "790",
    "name": "Nikam Vinod Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18210",
    "name": "Prabhu Prashant Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21208",
    "name": "Vishwakarma  Teksinghlalsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6177",
    "name": "Parab Aparna Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13990",
    "name": "Kharat Sakhubai Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18554",
    "name": "Maurya Surendra K"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1588",
    "name": "Rayama Anwar Mamand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10136",
    "name": "Phadtare Ashok Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19732",
    "name": "Pawar Sandip Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15289",
    "name": "Ithape Seema Dattatray"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1208",
    "name": "Gurav Aruna Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24857",
    "name": "Sardar Sushma Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14438",
    "name": "Shaikh Saminbanu Musibatali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11822",
    "name": "Yadav  Radi  Rambohar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1801",
    "name": "Kamble Sandeep Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24683",
    "name": "Mishra Renu Jayprakash"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2801",
    "name": "Ingale Anusaya Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25168",
    "name": "Shinde Dilip Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25316",
    "name": "Hedavkar Parnika Yashavant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22514",
    "name": "Vaiti Dilip Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13951",
    "name": "Ithape Ashok Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18670",
    "name": "Satardekar Pradeep Anant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "674",
    "name": "Tetme Dhanaji Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23038",
    "name": "Walave Janardhan Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17604",
    "name": "Labde Rajendra Kashiram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "798",
    "name": "Gaikwad Dhanaji Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20270",
    "name": "Jai Malhar Bachat Gat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1960",
    "name": "Bagal Mahadeo Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23115",
    "name": "Shree Ganesh Krupa Co-Op Hsg So"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22361",
    "name": "Patidar Pratap Nathu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16030",
    "name": "Sawant Nilesh Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10049",
    "name": "Barge Shashikant Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21962",
    "name": "Choudhari Hasan Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23326",
    "name": "Pawar Nilesh Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17306",
    "name": "Raut Ganesh Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5402",
    "name": "Shirgaonkar Jayashree Jagdish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12592",
    "name": "Magar Suresh Pandit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23922",
    "name": "Bunnan Surendra B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22520",
    "name": "Kalugade Ganesh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18950",
    "name": "Nalawade Minaxi Dayaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18831",
    "name": "Tiwari Jaydevi Shriram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16575",
    "name": "Shah Khushali Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15241",
    "name": "Mistry Vimala Himmatlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17827",
    "name": "Jain Pankaj Chandulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22472",
    "name": "Bhangre Sachin Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18921",
    "name": "Patel Kishor Raman"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1870",
    "name": "Sakpal Pallavi Pramod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16847",
    "name": "Khambal Sanjay Ravikant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2405",
    "name": "Pathak Veerendra Hirdaykant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23925",
    "name": "Kadam Sadashiv Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15363",
    "name": "Pisal Jaydip Balasaheb"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1938",
    "name": "Jadhav Parmeshwar Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12809",
    "name": "Jain Manojkumar Mohanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16344",
    "name": "Dhole Anant Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12966",
    "name": "Agarbattiwala Arvindkumar Maganlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "826",
    "name": "Salwador  Fernandis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13090",
    "name": "Pathak Rajendra Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24382",
    "name": "Gardi Sandip Jayprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15451",
    "name": "Jamnis Mrunadini Ashok  /Miss Smrutika A"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2093",
    "name": "Rajbhar Subash Jamuna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12562",
    "name": "Parihar Gulabchand Hakmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8861",
    "name": "Satardekar Prakash Vitthal/Vidya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12543",
    "name": "Kumlbhar Mangal Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14965",
    "name": "Shaikh Arif Dilawar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1616",
    "name": "Shaikh Kalamuddin Rafik"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1857",
    "name": "Chavan Ranjit Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23929",
    "name": "Yewale Vandana Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16558",
    "name": "Peshkar Asmita Dashrathrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11353",
    "name": "Jadhav Rajendra Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12444",
    "name": "Shitole Mangal Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16860",
    "name": "Borhade Yogita Gajanan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "240",
    "name": "Naik Bharat Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6962",
    "name": "Ranka  Hitesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24319",
    "name": "Pandey Kashiram Shivprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25325",
    "name": "Patel Ashok Bhanji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5883",
    "name": "Patil Marutrao Appaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19827",
    "name": "Motiwad Digambar Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25146",
    "name": "Maingade Nathuram Laxman"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "569",
    "name": "Sale Gorakhnath Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24057",
    "name": "Keni Reshma Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19779",
    "name": "Nanda Manvindersing Mohansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14925",
    "name": "Kilanje Mangala Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19897",
    "name": "Dasal Sunil Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17987",
    "name": "Satvase Tukaram Vitthal/Vanita Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15884",
    "name": "Jain Bharti Manoj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17718",
    "name": "Bhartiya Janta Parti Ward No 31"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "358",
    "name": "Bengade Narayan Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19942",
    "name": "Raut Mahesh Pandurang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2560",
    "name": "Saroj Madan Chaitu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16889",
    "name": "Das Rajkishore Ganunidhi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1273",
    "name": "Choudhari Kailash Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18520",
    "name": "Kadam Harish Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21091",
    "name": "Jadhav Varsha Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11941",
    "name": "Nikam Anuradha Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15790",
    "name": "Mane Anna Ganpat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2278",
    "name": "Patil Sarla Narsinh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12239",
    "name": "Rajapure Sunil Pundlik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17041",
    "name": "Gosavi Archana Vishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19913",
    "name": "Pawar Hardik Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19134",
    "name": "Kadam Ankush Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18332",
    "name": "Bisht Chetna Harisingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2277",
    "name": "Chavan Jyoti Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13205",
    "name": "Patel Rajendraprasad R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11582",
    "name": "Gadhave Chandrakant Atmaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20709",
    "name": "Barge Dhananjay Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19542",
    "name": "Bagade Sachin Balkrishna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "914",
    "name": "Patil Sanjay Balkrushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23400",
    "name": "Kahale Shobha Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25041",
    "name": "Devarukhkar Bhalachandra Shankar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1375",
    "name": "Shinde Ramakant Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12718",
    "name": "Bhapkar Shivaji Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16469",
    "name": "Joshi Sandeep Bhupendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21719",
    "name": "Jadhav Chandrakant Jotiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5462",
    "name": "Chauhan Munib Lalchand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1291",
    "name": "Patil Laxman Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11269",
    "name": "Ghag Anandibai Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14242",
    "name": "Binani Maya Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14279",
    "name": "Matre Maruti Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19811",
    "name": "Keni Hemant Persuram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2719",
    "name": "Chauhan Sanjay Jagnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20012",
    "name": "Maru Rajesh Shamji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10351",
    "name": "Shinde Prabhavati Madhavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13139",
    "name": "Chaphekar Nirmala Sharad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2778",
    "name": "Kanjariya Lalji Petha"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1210",
    "name": "Gupta Mahesh Ramlakhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8554",
    "name": "Parihar Premraj Jasaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20397",
    "name": "Mishra Upendranath Virendranath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19999",
    "name": "Maksad  Ali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7381",
    "name": "Rege Prabhakar D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7044",
    "name": "Yadav Shailesh Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19865",
    "name": "Jadhav Anil Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11600",
    "name": "Chavan Arjun Ramrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2140",
    "name": "Pisal Deepak Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24389",
    "name": "Bansode Ramesh Sukhdev"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1484",
    "name": "Dhanvant Dayaram Bind"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1711",
    "name": "Mane Mohan Hanmant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2697",
    "name": "Rai Rakesh Jaymangal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "213",
    "name": "Tiwari Shivgovind Ramaajor"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1855",
    "name": "Yadav Prithiviraz Radhesham"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "875",
    "name": "Air Conditioning House"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2148",
    "name": "Gole Sudhir Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22471",
    "name": "Dolas Arun Rajaram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "67",
    "name": "Bhavani Textiles"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "68",
    "name": "Bhavesh Textiles"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19217",
    "name": "Dayal Badwal Prabhu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10215",
    "name": "Chavan Dattatray Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2517",
    "name": "Singh Bablu Lagande"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16509",
    "name": "Phadtare Anil Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23936",
    "name": "Das Pratapkumar Pradip"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "982",
    "name": "Choudhary Sukhraj Bhanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22543",
    "name": "Nawale Kishor Kashiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1204",
    "name": "Ghadge Vishwas Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24317",
    "name": "Miss  Pawar Sandhya Bharat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23803",
    "name": "Bhosale Ramesh Vyankat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23598",
    "name": "Rokde Rukmini Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2240",
    "name": "Konark Enterprises"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "593",
    "name": "Pagire Bhaskar Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21771",
    "name": "Khalde Pradeep Dynaneshwar"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "70",
    "name": "Mahesh Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14590",
    "name": "Saket Suryabhan Hariprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14471",
    "name": "Momin Shirin Imam"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2336",
    "name": "Manomay Travels"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20139",
    "name": "Panchum Mahadev B"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14873",
    "name": "Jagtap Amol Vishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11143",
    "name": "Dige Manisha Deepak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15285",
    "name": "Jadhav Nandkumar Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25248",
    "name": "Kadam Damodar Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7349",
    "name": "Shinde Mahadeo Jijaba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "32",
    "name": "Nakoda Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8192",
    "name": "Salate Vitthal Laxaman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "235",
    "name": "Om Sai Services"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18448",
    "name": "Pol Bapu Tukaram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "60",
    "name": "Pankaj Textiles"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6787",
    "name": "Pisal Shivaji Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25423",
    "name": "Chorge Rajan Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22545",
    "name": "Deoolkar Rama Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25424",
    "name": "Hussain Farooq Ashiq"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25417",
    "name": "Jada Salma Latif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25418",
    "name": "Khan Kamruddin Amiruddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15368",
    "name": "Landage Narayan Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25421",
    "name": "Mishra Bhagwant Suryamani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25419",
    "name": "Morya Ramji Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15375",
    "name": "Phalke Ramdas Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25404",
    "name": "Andurlekar Nagesh Manmohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25408",
    "name": "Gupta Gulabchand Indradev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25397",
    "name": "Paithne Bhikaji Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24079",
    "name": "Pereira Victoria Earl"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25402",
    "name": "Pujari Vishwanath Shinkara"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15367",
    "name": "Sakunde Dattatray Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25415",
    "name": "Shaikh Khurshid Ahmed Abdul Majid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25405",
    "name": "Shaikh Mohd Yusuf Amir Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25395",
    "name": "Singh Bansraj Khunnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11129",
    "name": "Sabale Sanjay Tatyaba"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1030",
    "name": "Tirmare Satish Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20018",
    "name": "Manave Vinayak Ramaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14054",
    "name": "More Pralhad Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12758",
    "name": "Ratnprakhe Sunil Asaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15630",
    "name": "Shinde Sudhakar Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13632",
    "name": "Jaiswal Jagdish Dewari"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "73",
    "name": "Pooja Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25394",
    "name": "Yadav Subhashchandra Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1451",
    "name": "Prasad Transport"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20189",
    "name": "Salunkhe Ajay Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21883",
    "name": "Bandal Santosh Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15114",
    "name": "Bansode Sanjay Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13344",
    "name": "Momin Febedabi Imam"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "59",
    "name": "Ravi Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10403",
    "name": "Kamble Gajara Ambanda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2565",
    "name": "Pawar Kamal Jyotiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10058",
    "name": "Khond Pradip Bhikusheth"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14272",
    "name": "Jaiswal Dhaniram Ramkripal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2255",
    "name": "Sharma Prakash Indarmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19041",
    "name": "Kale Sachin Ekanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17897",
    "name": "Patil Shankar Mukund"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23992",
    "name": "Jagtap Santosh Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24037",
    "name": "Mahangde Popat Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22572",
    "name": "Jagtap Tushar Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4138",
    "name": "Tambe Ramdas Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13752",
    "name": "Gade Mahesh Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20308",
    "name": "Moses Francis Jayraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23121",
    "name": "Haldankar Shweta Shekhar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1037",
    "name": "Bhagare Sharada Vishram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "61",
    "name": "Sunil Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20515",
    "name": "Nikam Sapna Kishore"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22921",
    "name": "Vaid Rakhi Mahendra"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "72",
    "name": "Swastik Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17291",
    "name": "Mahadik Nitin Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16165",
    "name": "Suraya Nandlal Mhanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13909",
    "name": "Bharattan  Gemcy"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3083",
    "name": "Mandhare Raghunath Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10954",
    "name": "Phalke Radhika Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "852",
    "name": "Vijay Engraving  Work"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15369",
    "name": "Chavan Tanaji Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20157",
    "name": "Panchal Kirit Kumar Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13718",
    "name": "Pratik And Prajkta S Haladankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "28",
    "name": "Dongare Sandip Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17673",
    "name": "Zodage Sangita Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21370",
    "name": "D'Silva Stanislaus Joseph"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23436",
    "name": "Shah Madhukant P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8948",
    "name": "Yadav Ramchander Tufani"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "133",
    "name": "Sroj Harikesh Ramniwas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20448",
    "name": "Kasable Geeta Ganesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3103",
    "name": "Nagaria Nikunj Amrutlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22070",
    "name": "Phanse Narayan Dharamraj"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1175",
    "name": "Pujare Bhiva Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17316",
    "name": "Jadhav Sunil Sudam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20158",
    "name": "Prasad Hiralal Govardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19894",
    "name": "Charkop Siddharath Co Op  Hsg  Soc  Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18671",
    "name": "Gulekar Prakesh Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22908",
    "name": "Shinde Riya Mahesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14635",
    "name": "Khopde Suresh Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9694",
    "name": "Radia Sejal Ajit"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2481",
    "name": "Ram Gautamkumar Satendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21380",
    "name": "Gavhane Devendra Vishawnathji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16624",
    "name": "Agarwal Sanwalchand H"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3879",
    "name": "Patel Sureshchand Lalji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1264",
    "name": "Rathod Govind Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21609",
    "name": "Gupta Sunil Ramkishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23125",
    "name": "Bhandari Jagruti Nagesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20041",
    "name": "Kolekar Rahul Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2838",
    "name": "Jaiswal Amarnath Radheshyam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17880",
    "name": "Vora Palak Sunil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21326",
    "name": "Meher Dnyaneshwar Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13360",
    "name": "Mistry Raghunath Dhondu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2807",
    "name": "Chandariya Kasturben Manikchand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3105",
    "name": "Bhoir Jayawant Kacher"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14884",
    "name": "Singhania Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24944",
    "name": "Salunkhe Vishnu Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21183",
    "name": "Jain Nilesh Aidanmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9271",
    "name": "Mane Akaram Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16009",
    "name": "Naik Vaibhav Ajit"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "789",
    "name": "Mukadam Dnyaneshwar B"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "867",
    "name": "Ithate Harishchandra Vitthal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1602",
    "name": "Mudgade Rahul Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22054",
    "name": "Zende Deepak Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2752",
    "name": "Avichal & Associates"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "399",
    "name": "H A  Chemicals"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16185",
    "name": "Gupta Gulabchand Ramdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18031",
    "name": "Desai Marmik Hemant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1037",
    "name": "Jaiswar Ramanand Ramnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16428",
    "name": "Desai Sambhaji Baburao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1460",
    "name": "Sakpal Chandrakant Narayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1889",
    "name": "Mukadam Arvind Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14547",
    "name": "Borate Santosh Rajaram  Tn-636-12"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22208",
    "name": "Hate Dhanswi Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20032",
    "name": "Shelke Baburao Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23208",
    "name": "Bodake Bharat Ganpat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1343",
    "name": "Rayat Kailash Jiva"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1288",
    "name": "Shinde Ramchandra Madhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15292",
    "name": "Salunkhe Vishwas Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19965",
    "name": "Shaikh Salim Dastgeer"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22287",
    "name": "Kokate Atul Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14665",
    "name": "Bane Vaishali Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6026",
    "name": "Magaveera Chanrashekhar Sukara"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23479",
    "name": "Mhatre Sangeeta Anil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15593",
    "name": "Salunkhe Mohan Sarjerao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "303",
    "name": "Nikunj Fabrics"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "57",
    "name": "Nishad Apparels"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "578",
    "name": "Dhumal Suresh Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15388",
    "name": "Deshmukh Shital Hanamnt"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15392",
    "name": "Kadam Balkrishna Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15391",
    "name": "Kadam Harichandra Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25437",
    "name": "Allana Dilshad Javid"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24092",
    "name": "Botre Dipak Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20468",
    "name": "Kadam Rajashri Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15380",
    "name": "Nalawde Nitin Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15366",
    "name": "Phalke Amol Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15278",
    "name": "Sabale Laxman Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23551",
    "name": "Jadhav Rajendra Appaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25116",
    "name": "Pable Sugandha Balshiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24189",
    "name": "Patil Vitthal Dattatreya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15125",
    "name": "Gaikwad Raosaheb Dinkar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1929",
    "name": "Tupe Daya Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17063",
    "name": "Shukla Pramodkumar Virendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20343",
    "name": "Baley Santosh Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19135",
    "name": "Zore Tanaji Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6033",
    "name": "Ransing Raghunath Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18690",
    "name": "Udeshi Ajita Nilesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18691",
    "name": "Udeshi Janvi Nilesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "218691",
    "name": "Udeshi Janvi Nilesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3688",
    "name": "Ghadge Dasharath Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20112",
    "name": "Biradar Vishwanath Annarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22113",
    "name": "Shaikh Tehseen Usmanagani"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "77",
    "name": "S H  Trading Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4143",
    "name": "Sai Mobile Gallery"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18704",
    "name": "Chavan Sukhada Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20244",
    "name": "Kolekar Anusaya Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10530",
    "name": "Yadav Balikaran Jaggu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4470",
    "name": "Sant Tukaram Shikshan Sanstha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7823",
    "name": "Zanzurne Pralhad Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21687",
    "name": "Salaskar Nirmala Shridhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17210",
    "name": "Kadav Sandip Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15395",
    "name": "Kadam Aniket Hanmantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10246",
    "name": "Bhoite Narsing Khanderao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25096",
    "name": "Parab Santosh Dhaku"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "276",
    "name": "Shinde Manohar Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8389",
    "name": "Khedekar Prakash Vithoba"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "121",
    "name": "Shree Khatu Shyam Builders & Developers"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1556",
    "name": "Yadav Umeshkumar Mahendraprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19989",
    "name": "Khochare Kisan Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "916",
    "name": "Sony Centre"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11709",
    "name": "Naik Arti Anil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14289",
    "name": "Pigale Rashmi Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17137",
    "name": "Bharatratna Dr Babasaheb Ambedkar Pratis"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1932",
    "name": "Nalawade Pravin Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12686",
    "name": "Phalake Suresh Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3200",
    "name": "Lad Lata A"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1881",
    "name": "Pedamkar Ragini Shashikant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19118",
    "name": "Gauttam Muncilal Dubar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20831",
    "name": "Gavkar Prerana Pradip"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3081",
    "name": "Ubale Sushila Ashok"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2960",
    "name": "Mane Baban Bajarang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "295",
    "name": "Konka Rajesham Ramyya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17201",
    "name": "Kumbhar Praksh Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20743",
    "name": "Barge Vivek Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18385",
    "name": "Khan Salim Jajammul Hussein"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15163",
    "name": "Deorukhakar Vilas Mahadeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2762",
    "name": "Singh Ritukumari Uday"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23165",
    "name": "Bothe Sayli Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7593",
    "name": "Phalke Nitin Bhgwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20084",
    "name": "Mishra Udaychand Hiralal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13132",
    "name": "More Satish R  1462/2"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14451",
    "name": "Wagh Shamal Suhas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14490",
    "name": "Trivedi Shantilal Amrutlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24144",
    "name": "Temkar Mohan Tanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22350",
    "name": "Malekar Somnath Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19967",
    "name": "Sonawane Sanjay Sukhadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19964",
    "name": "Yadav Vikram Sadashiv"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1127",
    "name": "Rajbhar Shyamnarayan Gangaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1143",
    "name": "Khan Shahnawaj Mangu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1903",
    "name": "Bhagyawant Mangal Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14367",
    "name": "Siddhiki Amir Ahemad Rafi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19764",
    "name": "Jadhav Ravindra Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19806",
    "name": "Shaikh Ilias Mohmed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17893",
    "name": "Sawant Harishchandra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8236",
    "name": "Yadav Sunita Ramdhani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2276",
    "name": "Sawant Rajendra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24171",
    "name": "Nimbalkar Jagnnath Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20260",
    "name": "Sawant Srushti Chetan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11666",
    "name": "Salunkhe Ramchandra Bhau Tn-93-24"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2242",
    "name": "Jain Kunal Karanraj"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1907",
    "name": "Bhagyawant Subhash Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13367",
    "name": "Mane Ashok Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23587",
    "name": "Thakkar Kalpesh Nitinkumar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "708",
    "name": "Parijat Sahakari Gruh Nirman Sanstha Ltd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18370",
    "name": "Javlekar Aarti Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20016",
    "name": "Patil Sadashiv Sahdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5994",
    "name": "Sawant Prakash Balkrishna/Tejaswita"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19949",
    "name": "Yadav Prakash Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19762",
    "name": "Khopade Sanjay Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17999",
    "name": "Khot Arun Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20025",
    "name": "Nalawade Sachin Balkrishna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "943",
    "name": "Deshmukh Vijay Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24358",
    "name": "Dubli Navin Babu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1263",
    "name": "Gaikwad Jaysingh Jivanram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1709",
    "name": "Gupta Pankaj Paltu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1637",
    "name": "Mane Pintu Ambadas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1238",
    "name": "Pandey Meena Krishnachand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24400",
    "name": "Shaikh Faiyyaz Ahmed"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "344",
    "name": "Amar Seeds Pvt Ltd"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20481",
    "name": "Jedhe Usha Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21497",
    "name": "Shaikh  Mustafa  Shakhur"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13690",
    "name": "Pradeep Sakalchand Solanki"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "48",
    "name": "Harshada Kirana Stores"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13986",
    "name": "Pednekar Vitoba Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21107",
    "name": "Choohan Jaysheela Ramprakash"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "377",
    "name": "Gurav Aprna Chandrashekhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23783",
    "name": "Thakulla Premsingh Balram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5297",
    "name": "Choudhari Rajaram Lalitram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19736",
    "name": "Doiphode Gangaram Thaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8160",
    "name": "Pawar Dhananjay Bhiku"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "604",
    "name": "Ghag Nitin Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14241",
    "name": "Nikam Jaysing Dnyanu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2316",
    "name": "Kunwar Maniram Krishnalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14968",
    "name": "Mazagaonkar Ankush Shivaram/Mazagaonkar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "358",
    "name": "Nilkanth"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21859",
    "name": "Nikam Laxman Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17291",
    "name": "Surendra Vasant Dalvi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12354",
    "name": "Gawade Ganesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25462",
    "name": "Boinwad Sapna Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15410",
    "name": "Chavan Santosh Narsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15403",
    "name": "Chavan Vinod Narsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24109",
    "name": "Joshi Ramesh Tammaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15415",
    "name": "Kadam Sangram Veersen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25472",
    "name": "Pathan Rasool Gafurkhan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1949",
    "name": "Pratapan Gopalan Nilambi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24105",
    "name": "Dodia Ganesh Ratilal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1940",
    "name": "Gaikwad Ankush Bapurao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1945",
    "name": "Shah Jaysukh Popatlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20880",
    "name": "Gorakane Ramesh Babu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15249",
    "name": "Phalke Yuvraj Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15282",
    "name": "Pisal Sudhir Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22680",
    "name": "Roge Sunil Kashiram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3064",
    "name": "Gupta Abhishekkumar Lakindar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15271",
    "name": "Salunkhe Shivraj Machhindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19288",
    "name": "Dholare Vilas Eknath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2137",
    "name": "Yesale Dnyandev Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9111",
    "name": "Kadam Sanjay Kashinath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1947",
    "name": "Singh Amit Narendrapratap"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3246",
    "name": "Priyanka Packing Works"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1039",
    "name": "Pure Drop Services"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24911",
    "name": "Sawant Arun Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16219",
    "name": "Punglia Bhawana K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24803",
    "name": "Chavan Ashok Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12979",
    "name": "Shinde Santosh Arun  Tn"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4589",
    "name": "Sadguru Transport"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14964",
    "name": "Sabale Mansing Namdev"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2540",
    "name": "Wagh Seema Bapu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "740",
    "name": "Dahire Avinash Navnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12775",
    "name": "Disale Arun Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15412",
    "name": "Kadam Surekha Vikram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15414",
    "name": "Kadam Vikram Veersen"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1950",
    "name": "Pookodan Shivdasan Unni"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22356",
    "name": "Thombare Swati Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11842",
    "name": "Kadam Dattatray Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14124",
    "name": "Jadhav Pooja Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24478",
    "name": "Shinde Balkrushna Mahadev"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "612",
    "name": "Shinde Sanjay Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10222",
    "name": "Jagdale Dattatray Kundalik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7860",
    "name": "Dhane Dnyaneshwar Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4697",
    "name": "Shree Siddhivinayak Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "292",
    "name": "Shri Kheteshwar Courier Services"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6723",
    "name": "* Sarafdar Janu Baji 742/2"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1424",
    "name": "Andhure Dnyanoba Prabhu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21559",
    "name": "Hatle Nitin Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7571",
    "name": "Shirsat Sarjerao Jairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15784",
    "name": "Jadhav Amey Ramchandra /Gaurav Ramchandr"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14013",
    "name": "Satvase Umesh Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4238",
    "name": "Ved  Carrier"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19299",
    "name": "Chavan Ashok Bandoba"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "926",
    "name": "Vinay Plastic Moulds"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3128",
    "name": "Shewale Shivaji Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1056",
    "name": "Argade Amol Appasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25022",
    "name": "Das Santoshi Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "221",
    "name": "Gaikawad Vishal Abhimanyu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12606",
    "name": "Kadav Janardhan Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19729",
    "name": "Gorule Vithoba Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12980",
    "name": "Chawan Balchandra Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22062",
    "name": "Patil Sachin Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24152",
    "name": "Maurya Balgovind Ramloutan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "284",
    "name": "Kudale Sadashiv Aabaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13664",
    "name": "Salunkhe Ramesh Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23290",
    "name": "Jaiswar Jagdish Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17817",
    "name": "Chawan Kisan Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22056",
    "name": "Pawar Kavita Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20861",
    "name": "Kocharekar Minal Haridas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1141",
    "name": "Khan Mohamad Saddam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21596",
    "name": "Velahar Shyamsundar Ganeshan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2394",
    "name": "Jha Vinodkuma Rupdhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14453",
    "name": "Ghadi Darshana Sudarshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14593",
    "name": "Dhanawade Nanda Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22773",
    "name": "Thakkar Vipul Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19154",
    "name": "Kanase Abhijit Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20891",
    "name": "Vishwkarma  Ramsajivan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1939",
    "name": "Sansare Anupama Pratap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25235",
    "name": "Gaikwad Geeta Dilip"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3124",
    "name": "Patil Papita Vishal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2907",
    "name": "Marathe Prakash Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15379",
    "name": "Bhoite Pradip Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18142",
    "name": "Baria Lalitkumar Govindaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22551",
    "name": "Warvatkar Rajesh Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12455",
    "name": "Momin Farukh Abdulla"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3033",
    "name": "Haraniya Aryan Manish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21011",
    "name": "Walekar Chetan Rajiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4647",
    "name": "Patel Pervez B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16405",
    "name": "Salunkhe Sharad Yadavrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2327",
    "name": "Sable Anand Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17048",
    "name": "Raje Bapu Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15859",
    "name": "Doke Anjana Kailash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11304",
    "name": "Rakshe Vaishali Jitendra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "48",
    "name": "Adarsh Construction Co"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3112",
    "name": "Matre Santosh Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1287",
    "name": "Nagada Dipesh Raichand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21419",
    "name": "Navalu Chiranjiv Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2426",
    "name": "Durga Packing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2249",
    "name": "J J Yarns Pvt Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21233",
    "name": "Hande Amol Manohar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "601",
    "name": "Chorge Sagar Suryakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "978",
    "name": "Tarade Bharati Prabhakar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1058",
    "name": "Bhosale Jaywant Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "365",
    "name": "Hule Vasantrao Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2370",
    "name": "Yadav Ramsajeevan Sardar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6817",
    "name": "Chavan Hindurao Bhagwanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "484",
    "name": "Makhamale Pradeep Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16271",
    "name": "Shinde Sidhi Ramchandra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "991",
    "name": "Pisal Akshay Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10432",
    "name": "Sutar Sujata Kalappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20271",
    "name": "Ramane Rahul Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2756",
    "name": "Lalit Impex Pvt Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21406",
    "name": "Divekar Krishna Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2326",
    "name": "Kande Deepak Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20586",
    "name": "Jadhav Bhakti Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18197",
    "name": "Bagwe Deepak Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13034",
    "name": "Gokulkumar  Praharaj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16447",
    "name": "Kadam Sanjay Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19667",
    "name": "Swar Tushar Rajan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15505",
    "name": "Deshmukh Priya Praful"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15247",
    "name": "Kolekar Mahadev Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18766",
    "name": "Dharje Surendra Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25504",
    "name": "Kamani Manisha Babulal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20506",
    "name": "Kanse Shivaji Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15434",
    "name": "Nikalaje Chandrakant Dadu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1954",
    "name": "Gurav Ashok Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15425",
    "name": "Kadam Ramchandra Kondiram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1952",
    "name": "Raorane Shridhar Dasharath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15386",
    "name": "More Hanmant Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3071",
    "name": "Kinre Baliram Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24018",
    "name": "Tambe Sachin Siddharth"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2215",
    "name": "Bansode Sadanand Malikarjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23725",
    "name": "Mane Rajesh Ramakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15329",
    "name": "Parab  Hemant Satish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24030",
    "name": "Surekha  Suryakant Pore"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15399",
    "name": "Mahajan Ganpati Bhiku"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1441",
    "name": "Ambhore Kiran Rama"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2246",
    "name": "Momin Sohil Bashir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13639",
    "name": "Mali Vandana Jaykumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21794",
    "name": "Salunkhe Sheetal Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2223",
    "name": "Radhika Saree"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20356",
    "name": "Jaid Shankar Rambhau/ Chaya S  Jaid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24949",
    "name": "Pawar Sakhubai Anna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "810",
    "name": "Jaiswal Sanjay Ramlakhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17851",
    "name": "Kamble Vishnu Raju"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "1510",
    "name": "Kambhar Gangawa Kalappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17301",
    "name": "Chavan Komal Dattatry"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19978",
    "name": "Mayekar Ankur Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1318",
    "name": "Late Atish Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13815",
    "name": "Sakharkar Vandana Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19115",
    "name": "Mestry Deepak Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24008",
    "name": "Lad Madhuri Mangesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6931",
    "name": "Pawar Arvind Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15435",
    "name": "Randive Shreekant Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25483",
    "name": "Kenjale Ashalata S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9873",
    "name": "Nikam Ashok Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1540",
    "name": "Saha Santosh Satish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21783",
    "name": "Modak Pravin Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19151",
    "name": "Bhojane Ramchandra Birbal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8343",
    "name": "Navalu Seema Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2431",
    "name": "Shree Nanda Trading Co"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22626",
    "name": "Kambale Sushilbai Machchhidra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "6128",
    "name": "Jaiswal Dhanraj Ramsevak"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "73",
    "name": "Shah Dipesh Lalaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18053",
    "name": "Pisal Bhagwan Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20627",
    "name": "Gaikwad Ashok Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20495",
    "name": "Gajakos Anita Narshima"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20497",
    "name": "Vira Khushali Praful"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20504",
    "name": "Yadav Sharadaprasad Baiju"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15427",
    "name": "Thorat Santosh Gopinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25484",
    "name": "Tiwari Santadevi Sheshmani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25455",
    "name": "Molla Rejaul Abdul Rajjak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4331",
    "name": "Gawade Jayashri Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5671",
    "name": "Tambe Ashok Pandurang T No 690"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1647",
    "name": "Pawar Archana Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "7990",
    "name": "Executive Engineer South Mumbai Electrical Division (P W D  )Mum"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2449",
    "name": "Dudwadkar Gitesh P"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "8913",
    "name": "Yadav Vijaykumar Gunnilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14862",
    "name": "Bhalavi Parmanand Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16584",
    "name": "Ghadigaonkar Shalaka Bhikaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2468",
    "name": "Gupta Santram Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19371",
    "name": "Mishra Monica Omprakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16087",
    "name": "Gaikwad Govind Sudam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19032",
    "name": "Panchal Dipti Vinay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12250",
    "name": "Merchant Raj Mohammedali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20069",
    "name": "Yadav Manbhasadevi Radheshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25494",
    "name": "Malusare Prakash Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20498",
    "name": "Vira Aarti Praful"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20499",
    "name": "Vira Praful Lalji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5667",
    "name": "Jaiswal Somai Sultan Toli No 1029/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "6633",
    "name": "Dhumal Sanjay Dhansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19091",
    "name": "Phansagaonkar Rupali Vasant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1337",
    "name": "Shah Rajesh Premchand"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "5363",
    "name": "Shabnam Shabbir Sayyad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18092",
    "name": "Jaiswar Nanhibai Durbliram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13873",
    "name": "Yadav Badriprasad Triveni"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19035",
    "name": "Patil Ashwini Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12997",
    "name": "Panchal Vinay Pravin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21039",
    "name": "Katalakar Subhash Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "774",
    "name": "Khan Yar Mohammad Aas Mohammad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24655",
    "name": "Chavan Sushama Sahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "6112",
    "name": "Pal Ramajore Jaglal 861/3"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20532",
    "name": "Hedau Sunil Shyamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "3114",
    "name": "Dhanawade Pandurang Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8930",
    "name": "Nikam Hanumantrao Keshv/Kadam Poat A/Sal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20267",
    "name": "Chaskar Sadhana Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "1719",
    "name": "Yadav Anandrao Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "2189",
    "name": "Yadav Ramchandra Jagdishprasad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2219",
    "name": "Patil Chandrabai Bhagirath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25390",
    "name": "Pandey Mahendra Tilakdarilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14870",
    "name": "Kambale Pramod Machhindra-Toli-1642/3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5700",
    "name": "Malpote Kondiba Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10045",
    "name": "Pisal Narsing Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "6238",
    "name": "Dutal Mahadev Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "6484",
    "name": "Kajale Shekhar Mansing"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "5656",
    "name": "Jagdale Dilip Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "4299",
    "name": "Pal Ramlakhan Siddhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19216",
    "name": "Gavhane Narendra Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9670",
    "name": "Malwade Ratan Narsinha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14782",
    "name": "Kamble Raju Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22617",
    "name": "Keni Prabhakar Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5783",
    "name": "Bandal Arjun Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5872",
    "name": "Jaiswal Suresh Haraku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "6375",
    "name": "Hansraj Bhurmal Harijan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20591",
    "name": "Yadav Priya Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3180",
    "name": "Rana Jyotiben Amratlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16856",
    "name": "Hindurao Maruti Shinde"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5911",
    "name": "Yadav Suryakant Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "6691",
    "name": "Manuskare Vithal Manu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5758",
    "name": "Lavale Gulabarao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5756",
    "name": "Mardhekar Mahadeo Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "6200",
    "name": "Waghambare Shashank Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "3100",
    "name": "Bhosale Gungrao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5109",
    "name": "Chaudhari Ramkishan Magare"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21622",
    "name": "Walve Nishad Suhas"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "9010",
    "name": "Executive Engineer South Mumbai Electrical Division (P W D  )Mum"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "7038",
    "name": "Chourasia Auto"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "2749",
    "name": "Nalawade Subhash Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5695",
    "name": "Shinde Vinod Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "5920",
    "name": "Pansare Santosh Ramnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Term Deposit",
    "accountNo": "6565",
    "name": "Shinde Vijaysing Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16554",
    "name": "Miss Sawant Vaishali N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24723",
    "name": "Singh  Brijesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3147",
    "name": "Panchal Akshay Jasvant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14418",
    "name": "Adsool Sharad Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2203",
    "name": "Sathe Vrinda Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "7596",
    "name": "Jain Sukanraj Chunilal"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "15959",
    "name": "Luhar Dhairya Gaurav"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "3468",
    "name": "Pawar Maruti Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "3740",
    "name": "Kadam Dnyandeo Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "17513",
    "name": "Luhar Dhairya Gaurav"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "6535",
    "name": "Shingh Shriparkash Rajamani"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "5103",
    "name": "Manjgaonkar Pratibha Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "5894",
    "name": "Katkar Ramdas Abaji"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "5860",
    "name": "Sawant Subhash Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15736",
    "name": "More Rohit Suryakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "17",
    "name": "Bhagat Ankush Kondaji"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "7941",
    "name": "Venkatachalam  V S Muthu"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "1287",
    "name": "Kakkad Bipin Kalyanji"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "8764",
    "name": "Mehta Viral Vikram"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "16232",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20571",
    "name": "Sachin Arjun Shinde"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1821",
    "name": "Ganerwala Vimala Devi"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "22",
    "name": "Karale Ramesh Harishchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "2378",
    "name": "Mulam Sadanand Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "7147",
    "name": "Patel Naramada Lala"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "16052",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "15276",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "15930",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "15953",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "9692",
    "name": "Nivatkar Mahadeo Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "16228",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "16230",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "16231",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "20319",
    "name": "Asian Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "16229",
    "name": "Bagave Pravin Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Term Deposit",
    "accountNo": "9219",
    "name": "Durgavali Ramchandra Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "4048",
    "name": "109 Cavel Street Bhadut Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4435",
    "name": "Nagwekar Yashwant Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15229",
    "name": "Deshmukh Dipak Lalasaheb"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3092",
    "name": "Dhumal Pratiksha Hanumant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9699",
    "name": "Jagdale Nandkumar Gangaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2653",
    "name": "Patel Munnalal Duthnath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1289",
    "name": "Shinde Ratnamala Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1017",
    "name": "Amit Creation"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2524",
    "name": "Tandel Swapnil Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "216",
    "name": "B K Buffing Works"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18566",
    "name": "Kamble Anand Baban"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "326",
    "name": "Nalawade Sandeep Ashok"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "239",
    "name": "Pawar Rajendra Parshuram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "43",
    "name": "Jainam Textiles"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "787",
    "name": "Nikam Amol Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24463",
    "name": "Vaity David Juran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12703",
    "name": "Phadatare Shivaji Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20558",
    "name": "Parab Santosh Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2242",
    "name": "Kumawat Packing Works"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20478",
    "name": "Dhadve Poonam Raghunath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "352",
    "name": "Mahesh Kirana Stores"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2063",
    "name": "Majee Silk Mills"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1004",
    "name": "Kondhalakar Tukaram Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3014",
    "name": "Chavan Mohan Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2744",
    "name": "Manshi Fab"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "668",
    "name": "Mohite Warehousing Corporation"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "221",
    "name": "Nageshwar Textiles"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24508",
    "name": "Gaikwad Bhagwant Shayanna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21804",
    "name": "Shigwan Ashok Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3144",
    "name": "Om Sai Packing"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2780",
    "name": "Singh Indreshkumar Sarvan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12456",
    "name": "Mandhare Murlidhar Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24136",
    "name": "Botre Anil Rajaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3170",
    "name": "Harijan Govindkumar Harishchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15447",
    "name": "Phalke Sandeep Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24133",
    "name": "Poojari Mahabala Nakra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20521",
    "name": "Shaikh Mohammed Ilyas Mohammed Umar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25528",
    "name": "Yadav Manojkumar Rajbahadur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15652",
    "name": "Mestry Haideralikhan Lalmohammad"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1452",
    "name": "Bhosale Nilesh Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25147",
    "name": "Shetty Sangita Ganesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2153",
    "name": "Bhoir Jankubai Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20520",
    "name": "Kolekar Dattatyay Dadasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24134",
    "name": "Poojari Shobha Shekhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24736",
    "name": "Humane Nikhil Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18640",
    "name": "Indulkar Nitin Shaantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14869",
    "name": "Zore Vitthal Navlu 527/13"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "348",
    "name": "Rachana Infrastructure"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13732",
    "name": "Faras Suraiyya Jainuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12629",
    "name": "Gujar Sandeep Uttam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22451",
    "name": "Jaiswar Priyanka Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23931",
    "name": "Teli Anant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18680",
    "name": "Disale Pankaj Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18024",
    "name": "Solkar Vinod Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13599",
    "name": "Shaikh Nisar Mahamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8686",
    "name": "Madhoki Nemaram Chelaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17040",
    "name": "Ghag Vijay Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2315",
    "name": "Kalebere Shantaram Keshav"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2167",
    "name": "Sharma Sanjay Omprakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12873",
    "name": "Bansode Govind Laxman"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "174",
    "name": "Shiv Aradhana Kirana & General Stores"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "381",
    "name": "Shivam Textile"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1441",
    "name": "Shree Hashmukh Tea Centre"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2700",
    "name": "Shree Om Packing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13732",
    "name": "Bobade Ganpat Madanrao"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "265",
    "name": "Silver Digital Photo & Xerox"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12639",
    "name": "Jadhav Uttam Shivaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1296",
    "name": "Khopade Sulbha Dinesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16959",
    "name": "Ambolkar Ganpat Khotu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16641",
    "name": "Jadhav Shankar Kaniram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15746",
    "name": "Konde Sharad Vishwanath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "565",
    "name": "Marathe Deepak Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24143",
    "name": "Shah Kartik Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25526",
    "name": "Kadam Sunil Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24137",
    "name": "Patange Ganesh Mangesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3171",
    "name": "Dubey Vipinkumar Ramsare"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5368",
    "name": "Sankpal Vijaya Suresh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2525",
    "name": "Gujar Nemaram Dalaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3162",
    "name": "Rathod Ramesh Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24742",
    "name": "Shrigan Pushpa Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24144",
    "name": "Ghosh Sanghamitra Santi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2714",
    "name": "Mohite Vijay Hambirrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1164",
    "name": "Modi Rajkumar Mahaveer"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24122",
    "name": "Rathod Krushna Bajarang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "372",
    "name": "Gunjal Ujwala Nilesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2982",
    "name": "Jhanwar Pushpadevi Jayprakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12236",
    "name": "Phalke Shivaji Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17290",
    "name": "More Sagar Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20597",
    "name": "Jaiswar Harikesh Prabhuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16257",
    "name": "Sakpal Chandrashekhar Nathuram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2537",
    "name": "Giri Sunil Omkarnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15796",
    "name": "Nayadu Susila Balaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "988",
    "name": "Dubal Milind Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18018",
    "name": "Shah Gala Arjun K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24506",
    "name": "Maurya Ashok Kumar Kailashnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3825",
    "name": "Jadhav Vasant Sarjerao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1434",
    "name": "Harijan Suryaprasad Bhagvandin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18268",
    "name": "Talwar Jagdish Ramsaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18469",
    "name": "Rane Soniya Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21287",
    "name": "Bhosale Sanjay Balkrishna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "32",
    "name": "Shinde Anil Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23243",
    "name": "Paswan Rajkumar Tulasi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19940",
    "name": "Rajeevan Smitha Kodumathil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22566",
    "name": "Parab Jagannth Santosh"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "6747",
    "name": "Shirke Ashok Popat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17569",
    "name": "Salvi Apeksha Anant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "794",
    "name": "Sayyad Tahmoor Razzaque"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "864",
    "name": "Zaware Sahebrao Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15413",
    "name": "Kadam Hemant Hanmantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21775",
    "name": "Zanzurne Kiran Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17635",
    "name": "Sahyadrinagar Building No 10"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19297",
    "name": "Nishad Sarswatidevi Pitambar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16807",
    "name": "Jain Hasmukhlal Premchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15146",
    "name": "Kolape Dada Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13807",
    "name": "Murkute Dipti Dipak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21073",
    "name": "Shivseva Feriwala Sangh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16317",
    "name": "Salunkhe Bhagwat Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17166",
    "name": "Shirke Vidya Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21951",
    "name": "Zatakiya Bina Kiriti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19283",
    "name": "Trivedi Parimal R [Huf"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1920",
    "name": "Gharge Madhukar Narayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1740",
    "name": "Salunke Vishwanath Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11648",
    "name": "Chavan Sanjay Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9097",
    "name": "Pal Rajnath Heeralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3391",
    "name": "Kadalag Suraykant Rangnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15227",
    "name": "Bodake Tushar Baban"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1946",
    "name": "Chheda Naresh Meghji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23620",
    "name": "Dasgaonkar Prabhakar Raghunah"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3123",
    "name": "Dodhia Chintan Jayesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22521",
    "name": "Ghorpade Prashant Pratap"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1425",
    "name": "Jige Sahadev Sheshrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19499",
    "name": "Mehta Dhrmendra Prataprai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7921",
    "name": "Pataria Shivraj Chotulal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2138",
    "name": "Rathod Laxmanlal Jetharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22221",
    "name": "Satpute Sandip Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "24",
    "name": "Agrawal Stone & Marbal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2499",
    "name": "Singh Shivkumar Ramjanam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24591",
    "name": "Varma Anilkumar Chatakikumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11674",
    "name": "Bhoite Rohidas Baban"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1734",
    "name": "Salunke Kanhaiya Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16833",
    "name": "Kadam Vikas Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3706",
    "name": "Sawant Narayan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2367",
    "name": "Bharat Sahakari Gruhanirman Sanstha"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1133",
    "name": "Pawar Sangeeta Damu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2915",
    "name": "Agrawal Dipak Shyamlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23496",
    "name": "Agrawal Manoj Wasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18213",
    "name": "Alve Manjiri Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1513",
    "name": "Bamnolkar Hiraji Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17597",
    "name": "Bhanushali Hariram Verasi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17598",
    "name": "Bhanushali Ratanshi Shamji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1456",
    "name": "Bhave Anil S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17073",
    "name": "Bijwe Mugdha Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5687",
    "name": "Choudhari Gopinath Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3665",
    "name": "D Souza Petrik Remond"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17664",
    "name": "Dama Muraji Shamaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23499",
    "name": "Dhumak Suvarna Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2305",
    "name": "Dias Robert John"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18387",
    "name": "Doshi Kalpana Rajendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5649",
    "name": "D'Silva Gilbert Elais"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8525",
    "name": "Dube Krishana Murari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2265",
    "name": "Dukhande Shahaji Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15442",
    "name": "Gadoya Nayana Kirit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2988",
    "name": "Gavali Shantram Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1718",
    "name": "Ghag Mansing Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4944",
    "name": "Golatkar Vijay Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2989",
    "name": "Gurav Vilas Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2261",
    "name": "Jadhav Ravindra Kamalakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9841",
    "name": "Jagdhane Raju Tulsiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23505",
    "name": "Jamsundekar Manisha Sujit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3316",
    "name": "Jopule Suhash Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8255",
    "name": "Kadar Aslamkhan Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2957",
    "name": "Kambale Sitaram Tatoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8358",
    "name": "Karale Rajaram Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2124",
    "name": "Khadapkar Dhurdhar Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17665",
    "name": "Khetale Satish Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3347",
    "name": "Kinnarkar Harshad Arvind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23482",
    "name": "Kumbhar Sunil Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19466",
    "name": "Kusum"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18135",
    "name": "Lavte Jalindar Kerappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18134",
    "name": "Lawate Machindra J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8648",
    "name": "Lembhe Vikas Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5648",
    "name": "Lopis Francis Manu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4414",
    "name": "Mali Dashrath Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19489",
    "name": "Mandhare Manisha Popat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23512",
    "name": "Mandhare Suresh Vithalrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2584",
    "name": "Mane Anada Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4616",
    "name": "Mane Shivaji Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14285",
    "name": "Mardekar Deepak Khandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2868",
    "name": "Mhatre Mukund Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6742",
    "name": "Mishra Ravishankar Rampratap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9389",
    "name": "Miya Nazir Mohmed Nausad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3314",
    "name": "More Ramesh Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5957",
    "name": "Mule Satyawan Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2174",
    "name": "Nadu Kandi Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2438",
    "name": "Nair P  Vijayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2448",
    "name": "Nair S Jayakumaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3525",
    "name": "Nargolkar Shashikant Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2808",
    "name": "Neharkar Shivaji Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15443",
    "name": "Nigade Deepak Hanumant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3505",
    "name": "Nihalani Jethanand Anandraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2597",
    "name": "P  Kulandai Swami"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9838",
    "name": "Pal Jaynandan Nanhuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9839",
    "name": "Pal Premnath Nanhuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2260",
    "name": "Palande Ramesh Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2580",
    "name": "Panchal Hargovind D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2128",
    "name": "Parab Sunil Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5332",
    "name": "Patel Abdul Rajak Abdul Kadir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6948",
    "name": "Patel Ganesh Momaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4104",
    "name": "Patel Shantilal Hansraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3968",
    "name": "Patil Dilip Pandharinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5384",
    "name": "Pawar Rangrao Vamanram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5383",
    "name": "Pawar Saraswati Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2116",
    "name": "Pawar Sumant Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22954",
    "name": "Pawar Vilas Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2930",
    "name": "Pawskar Chandrakant Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1706",
    "name": "Potkar Shardul Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9762",
    "name": "Pujari Narayan Mahabal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16247",
    "name": "Purav Uday Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16248",
    "name": "Purav Vilas Moreshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3753",
    "name": "Raut Rajendra Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9664",
    "name": "Roy Manju Yogesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2931",
    "name": "Salunkhe Vasant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17409",
    "name": "Sapkale Ashok Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2238",
    "name": "Sawant Ramchandra Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1870",
    "name": "Serrao John Boniface Cornelius"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9569",
    "name": "Shaekh Khaja Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8362",
    "name": "Shaikh Bashir Mainuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1288",
    "name": "Shaikh Usman Abdvl Latif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2353",
    "name": "Sharma Kaviraj Kamalapati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2809",
    "name": "Sing B Birbal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9409",
    "name": "Sing Ramcharitra B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17666",
    "name": "Singh Devinder Joga"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9804",
    "name": "Singh Vinodkumar Parasnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23517",
    "name": "Soni Santosh Bhimsen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17828",
    "name": "Suryavanshi Pramila Sachin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5630",
    "name": "Thakur Shrikant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2417",
    "name": "Unnikrishnan C P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3982",
    "name": "Vaishnav Suresh Lahardas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3892",
    "name": "Wage Laxman Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2350",
    "name": "Warpe Kashinath Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9453",
    "name": "Yadav Chandrabali Rajpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18820",
    "name": "Yadav Vijaykumar Gunnilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7647",
    "name": "Ansari Mohd Haroon Mohd  Fate"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17531",
    "name": "Prabhu Damodar Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2815",
    "name": "Chavan Dattaram Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9121",
    "name": "Bhandari Kantilal Ghamandimal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1248",
    "name": "Gharat Ramesh Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11990",
    "name": "Jitekar Prabhakar Bajrang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9811",
    "name": "Parab Jaywant Harishchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2012",
    "name": "Yadav Doodhnath Jhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2256",
    "name": "Ansari Amir Hamza"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2456",
    "name": "Haria Dhiraj Jivraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3575",
    "name": "Pawar Dhanaji Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12985",
    "name": "Chavan Lalu Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2011",
    "name": "Chelwan Michal Thiro"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8715",
    "name": "Chemburkar Umesh Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10123",
    "name": "Dhapse Anil Purushottam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7626",
    "name": "Gharat Anant Nathuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8060",
    "name": "Gharat Krishna Chango"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7627",
    "name": "Gharat Satish Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12115",
    "name": "Halaye Prakash Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12336",
    "name": "Jadhav Mahendra Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10118",
    "name": "Kadam Gorakhnath Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10119",
    "name": "Kadam Jivandas Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2286",
    "name": "Kale Kashinath Pijaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3482",
    "name": "Keni Unnati Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "740",
    "name": "Mohite Alka Namadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8714",
    "name": "Mokashi Anand Krishnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2222",
    "name": "More Ashok Shripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12290",
    "name": "More Sarita Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6025",
    "name": "Nalwade Kusum Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8270",
    "name": "Natekar Nilakshi Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3697",
    "name": "Nimbre Nandkumar Devji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10509",
    "name": "Pandey Shyamsundar Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1379",
    "name": "Pawar Balasaheb Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1353",
    "name": "Pilaware Sarjerao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3835",
    "name": "Pingale Dinkar Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10523",
    "name": "Pol Prakash Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2435",
    "name": "Pujari Sanjeev Khariya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10250",
    "name": "Rai Anilkumar Shambhunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12411",
    "name": "Sankpal Malan Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13069",
    "name": "Sankpal Ravindra Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12486",
    "name": "Sawant Dattatray Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3710",
    "name": "Sawant Eknath Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2285",
    "name": "Shivalkar Chandrakant Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10254",
    "name": "Siddhique Moeen Ahmad Moh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10513",
    "name": "Tailor Prafullkumar Shantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10012",
    "name": "Yadav Kailashnath Kantaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10530",
    "name": "Yadav Premchand Jukhairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12350",
    "name": "Yadav Ramdas Shrirang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "662",
    "name": "Pundekar Pallavi Jotiram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1094",
    "name": "Rayte Ganesh Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3746",
    "name": "Batra Lalit R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1514",
    "name": "Chavan Hanumant Gundaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9048",
    "name": "Kamble Jayant Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12721",
    "name": "Barboj Maical Philip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12720",
    "name": "Barboj Norbart Philip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11212",
    "name": "Bhakare Shrikant Hiranath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12446",
    "name": "Bhoite Vikas Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12484",
    "name": "Chaskar Baban Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12238",
    "name": "Chavan Mangal Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12198",
    "name": "Chavan Nirmala Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11107",
    "name": "Chavan Popat Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12551",
    "name": "Dave Nila Dipak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12606",
    "name": "Ganekar Harsh Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11975",
    "name": "Gole Jitendra Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12077",
    "name": "Jadhav Rajesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12199",
    "name": "Kajale Surekha Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12441",
    "name": "Kakade Shobha Ramraje"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12453",
    "name": "Kale Sanjeev Bhika"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12317",
    "name": "Karbal Rajaram Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12833",
    "name": "Kondalkar Prakash Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12200",
    "name": "Lawand Jayashri Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11976",
    "name": "Lembhe Shashikala Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12579",
    "name": "Mahamulkar Vilas Nathbuva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "40",
    "name": "Mandhare Bindutai Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12767",
    "name": "Manjrekar Vijay Jivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10658",
    "name": "Mishra Hriday Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12636",
    "name": "More Ganesh Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9308",
    "name": "Murkute Manoj Kundalik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11326",
    "name": "Parab Dilip Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12076",
    "name": "Parikh Milan Sundarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11213",
    "name": "Parmar Vinod Rajiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10311",
    "name": "Patil Mohan Hasuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12671",
    "name": "Patil Premnath Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "606",
    "name": "Pawar Tukaram Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12252",
    "name": "Ranaware Kusum Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12318",
    "name": "Salam Rijwana Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12552",
    "name": "Salian Shrinivas Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11292",
    "name": "Shaikh Nasir Idris"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12766",
    "name": "Sheikh Aurangzeb Farid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9978",
    "name": "Shinde Arvind Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12042",
    "name": "Shinde Nathuram Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12946",
    "name": "Teke Ramchandra Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12840",
    "name": "Yadav Balram Palatu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12841",
    "name": "Yadav Kanayalal Patalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12869",
    "name": "Yadav Lalman Nandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12834",
    "name": "Yadav Ramchandra P"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1299",
    "name": "Jetendra Metal Industries"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1090",
    "name": "Tekale Bhausaheb Dadarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6747",
    "name": "Bhoite Malan Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2601",
    "name": "Chavan Kashiram Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11348",
    "name": "Jadhav Deepak Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8611",
    "name": "Jadhav Ravindra Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12240",
    "name": "Jagtap Sangeeta Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9912",
    "name": "Jalavi Chandrakant Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7738",
    "name": "Khan Samadkhan Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9975",
    "name": "Shaikh Noor Ahmad Nisar Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11182",
    "name": "Shinde Chandrakant Vittal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11295",
    "name": "Ukirde Dattatray Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6556",
    "name": "Bhandari Subhash Vishwapal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "239",
    "name": "Chavan Vijayshri Vilasrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10519",
    "name": "Durg Vijaysingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1123",
    "name": "Kalsi Lakhwinder Ujagarsingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16167",
    "name": "Kirdat Suvarna Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12641",
    "name": "Nalawade Pushpa Rajesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11128",
    "name": "Nikam Mandakini Devendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4253",
    "name": "Patil Dharmaji Gana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11726",
    "name": "Shirke Nayana Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5188",
    "name": "Vasista Radha Anilkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12458",
    "name": "Yadav Minal Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8889",
    "name": "Chavan Vasanti Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1220",
    "name": "Jadhav Aruna Vishwasrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7989",
    "name": "Lohar Ashok Jyotiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1381",
    "name": "Salunkhe Amrut Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12172",
    "name": "Sawant Pramila Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12676",
    "name": "Kadam Virendra Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10124",
    "name": "Choudhary Chotelal Somai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3130",
    "name": "Jadhav Subhash Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7883",
    "name": "Patil Shrikant Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3500",
    "name": "Sodi Kartarsingh Surjansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8635",
    "name": "Thapa Manbahaddur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11239",
    "name": "Tripathi Jayprakash Sabban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10421",
    "name": "Vashista Manishakumar Anilkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1549",
    "name": "Thakkar Dineshkumar N"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2315",
    "name": "Bhosale Deepak Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "568",
    "name": "More Baburao Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2311",
    "name": "Yadav Janardan Vishram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1900",
    "name": "Lonkar Vishnu Piraji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2359",
    "name": "Shinde Shyam Shripatrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2144",
    "name": "Yadav Ramesh Bechan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1902",
    "name": "Khale Anant Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1786",
    "name": "Rewandkar Mahadeo Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21167",
    "name": "Dhumal Deepak Devidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22066",
    "name": "Bhoite Deepali Rohidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12443",
    "name": "Shinde Rakeshkumar Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22881",
    "name": "Yadav Sabhanand Rambhuval"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "299",
    "name": "Kotkar Yashwant Punaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1067",
    "name": "Shewale Janardan Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "751",
    "name": "Bhosale Chandrakant Raghunath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1263",
    "name": "Knnoujia Sheshnarayan Pancham"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1475",
    "name": "Anerao Damodar Mukundrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1044",
    "name": "Shivaji Shamrao Shinde"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1194",
    "name": "Dethe Amol Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2060",
    "name": "Rathod Jayantilal S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2162",
    "name": "Tawade Lata Vijay"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2914",
    "name": "Pathak Pradeep Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2934",
    "name": "Pradan Hemant Jogendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1457",
    "name": "Sheode Hemant K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1325",
    "name": "Shinde Yashwant Babasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2023",
    "name": "Gore Chandrakant Hareshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1266",
    "name": "Kadam Manohar Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1238",
    "name": "Kalekar Harichandra Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "32",
    "name": "Nalvade Hirabai Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "963",
    "name": "Palsaniya Qulamhusen H"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3489",
    "name": "Kadam Mangal Dyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2946",
    "name": "Patel Pratap M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10517",
    "name": "Upadhyay Dinkar Guruprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1823",
    "name": "Chavan Namdeo Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8938",
    "name": "Mohite Kamal Chagan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16319",
    "name": "Pawar Vijay Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22320",
    "name": "Raut Ankush Bhaguji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1957",
    "name": "Bhave Purushottam Mahadeorao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4618",
    "name": "Chikkerur Sudhindra Dhirendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2820",
    "name": "Gamare Prakash Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4379",
    "name": "Khade Pravin Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12694",
    "name": "Mane Sanjay Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3972",
    "name": "Sawant Vikas Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4211",
    "name": "Shah Sudip Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2167",
    "name": "Pawar Prakash Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2034",
    "name": "Sawant Sadashiv Dyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1342",
    "name": "Vartak Ganesh Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2679",
    "name": "Karlekar Jagan Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2821",
    "name": "Bhosale Sharad Pandurang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3151",
    "name": "Ghotilkar Ananda Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9620",
    "name": "Bhosle Mohan Bhairu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7801",
    "name": "Gupta Rajman Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9887",
    "name": "Jule Ramesh Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7554",
    "name": "Kirdat Shivaji Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5946",
    "name": "Memon Mohammad Hanif Habib"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9448",
    "name": "Naik Mahadeo Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7398",
    "name": "Patel Ramkilavan Kedarnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8114",
    "name": "Patel Valibhai Islam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7502",
    "name": "Prajapati Kishorkumar Maganbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9137",
    "name": "Sharma Jagdish Kisanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6617",
    "name": "Vakil Meena Pradip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6870",
    "name": "Vichare Dilip Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7267",
    "name": "Vichare Vasudeo Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7581",
    "name": "Xavier L Francis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7349",
    "name": "Bhanushali Kantilal Budhiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3443",
    "name": "Lobo Henry Banochar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22576",
    "name": "Manjrekar Ramesh Tavji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20783",
    "name": "Shaikh Karim Bakshu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22877",
    "name": "Singh Surendra Pratap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3526",
    "name": "Hire Waman Genu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3878",
    "name": "Ranpise Prakash Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20525",
    "name": "Kadam Suresh Budhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22829",
    "name": "Shigwan Subhash Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3876",
    "name": "Shelar Rajendra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22754",
    "name": "Tiwari Ramchandra Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3700",
    "name": "Lokare Vasant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12095",
    "name": "Sable Archana Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19178",
    "name": "Chorge Deepak Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22769",
    "name": "Malkani Ismail Abdulkarim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22326",
    "name": "Sayed Jafar Ali Yakub Ali"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2013",
    "name": "Thakur Akshay Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4662",
    "name": "Bangera Sudhakar Karoga"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10027",
    "name": "Ghadigaonkar Prakash Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4799",
    "name": "Jadhav Rajendra Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12223",
    "name": "Jadhav Rekha Suryakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10049",
    "name": "Pathan Siraj Alam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4722",
    "name": "Patil Ramakant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1004",
    "name": "Pawar Yeshwant Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4902",
    "name": "Poojari Sheena Laxmikorega"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12094",
    "name": "Sabale Shashikant Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5013",
    "name": "Tejani Siraj Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9889",
    "name": "Thapa Tankaprasad Chabe"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4415",
    "name": "Vedak Bhalchandra Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4905",
    "name": "Waghela Ramchandra Mansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4651",
    "name": "Yadav Jaysing Surynath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23098",
    "name": "Gupta Pusha Kedarnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4670",
    "name": "Patel Suman Ranchodji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4617",
    "name": "Pradhan Najmuddin Gulam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5142",
    "name": "Rasam Dilip Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5301",
    "name": "Sawant Chandrkant Murari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7751",
    "name": "Solaskar Chandrakant Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5153",
    "name": "Topale Pandurang Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1759",
    "name": "Wagh Supudu Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4337",
    "name": "Yadav Chandrashekhar Rajpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22530",
    "name": "Gupta Yashwant Bramhadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22414",
    "name": "Michale S Kuruz Muttiu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1451",
    "name": "Borjes Stivan Philip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1304",
    "name": "Dhure Vithal Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3079",
    "name": "Samuel J E"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1530",
    "name": "Sharma A P Nagesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5206",
    "name": "Patil Haresh Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7418",
    "name": "Shah Babulal Karamhusen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20980",
    "name": "Dalvi Vilas Vasudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22727",
    "name": "Patil Mahesh Anant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1612",
    "name": "Pawar Sandeep Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22621",
    "name": "Shukla Shrinath Shamnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22767",
    "name": "Zende Prakash Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19800",
    "name": "Divekar Uday Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22772",
    "name": "Kalkar Rajaram Shiva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22367",
    "name": "Khan Umar Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22726",
    "name": "Malap Sitaram Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22787",
    "name": "Patil Dhyaneshwar Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5425",
    "name": "Joshi Lalaji Nakharlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4702",
    "name": "Kamble Arvind Eshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6273",
    "name": "Khan Javed Yusuf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7555",
    "name": "Mali Ashokbhai Galbari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8142",
    "name": "Pawar Vasant Kalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8031",
    "name": "Rajbhar Gyanprakash Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5530",
    "name": "Sawant Rajnikant Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8008",
    "name": "Sayyad Abdul Raheman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5574",
    "name": "Sharif Kalim Mohmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8299",
    "name": "Singh Kallu Bhola"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7943",
    "name": "Singh Laxmishankar Ramshankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8023",
    "name": "Singh Urmila Birendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8143",
    "name": "Solanki Dayaben Premji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8139",
    "name": "Solanki Nanda Pravin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7350",
    "name": "Ther Harshan Velu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5450",
    "name": "Varma Siddhigopal Vichari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9564",
    "name": "Zakir Mohamad Baba"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1416",
    "name": "Mane Pandurang Maruti"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1427",
    "name": "Sakpal Tulshiram Narayan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1226",
    "name": "Badgujar Mahesh Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9553",
    "name": "Mohamad Javed Ahmad Jan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9590",
    "name": "Panchal Narendra Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9616",
    "name": "Shaikh Mohammed Yunus"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9315",
    "name": "Sharma Ravi Lal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9747",
    "name": "Shetty Sudhakar Chempanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9852",
    "name": "Tirodkar Vishnu Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9826",
    "name": "Fernandes John Luis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7585",
    "name": "Gadade Ramdas Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9382",
    "name": "Gawade Shankar Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7646",
    "name": "Gupta Dinanath Laxman Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9518",
    "name": "Gupta Harilal Ramsumer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8180",
    "name": "Gupta Ramaji Motilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9665",
    "name": "Gupta Ramlakhan Premnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6878",
    "name": "Kamble Dinkar Chudappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9778",
    "name": "Khan Afraz Aziz"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7677",
    "name": "Kurkute Khandu Darsharath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9803",
    "name": "Mahato Rajkumar Laxmi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8112",
    "name": "Nakate Deepak Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9670",
    "name": "Pal Rajpat Bindeswari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9768",
    "name": "Pandey Yadyanarayan Balaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9313",
    "name": "Parab Visharam Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9450",
    "name": "Patel Kantilal Dahyabhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9554",
    "name": "Pawar Mahendra Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7269",
    "name": "Phansekar Suhas Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9393",
    "name": "Rane Vijay Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9396",
    "name": "Saroj Rajendra Prasap S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9724",
    "name": "Sawant Bharat Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9531",
    "name": "Sayyed Rafique Rehman Abdul Rehman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9619",
    "name": "Sayyed Sultanali Mukhtarali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9505",
    "name": "Shaikh Ahmad Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8179",
    "name": "Sharma Shivprasad Nandlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9751",
    "name": "Shinde Santosh Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9520",
    "name": "Siddam Devayna S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9807",
    "name": "Yadav Harishankar Rajpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9630",
    "name": "Yadav Rajesh Baburam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9398",
    "name": "Yadav Saheblal Banasraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9859",
    "name": "Yadav Sanjaykumar Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6889",
    "name": "Pai Anandraya Annappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6887",
    "name": "Pathan Faiyas Nyantulla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6808",
    "name": "Rane Anand Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7542",
    "name": "Rathod Pratapbhai Moraraji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6952",
    "name": "Shinde Govind Gopalrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5856",
    "name": "Singh Vijayveer Shyamraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7545",
    "name": "Singh Virendrapratap Rajbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7566",
    "name": "Sonkar Ashok Khainee"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7835",
    "name": "Tamse Kiran Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19079",
    "name": "Khoja Siraj Ebrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6155",
    "name": "Dabral Krushna Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6128",
    "name": "Dhuri Ramesh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6157",
    "name": "Jasnkar Mohmad Erfhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6104",
    "name": "Lokhande Dnaneshwar Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6166",
    "name": "Tikudve Vishnu Sayaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22575",
    "name": "Pandey Anil Ramsajivan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6370",
    "name": "Khedekar Ganpat Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5956",
    "name": "Koli Gorakh Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6034",
    "name": "More Pramod Shitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6645",
    "name": "Pinto Rufel Marshal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6616",
    "name": "Salunkhe Sambhaji Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6422",
    "name": "Shah Sureshchandra Bhalchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13600",
    "name": "Shinde Bhimrao Genba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23513",
    "name": "Bhatiwada Purushottam Tulsiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23473",
    "name": "Bhedse Vishwas Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23490",
    "name": "Chavan Uttam Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23506",
    "name": "Dhumal Anandrao Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23456",
    "name": "Jadhav Tanaji Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23504",
    "name": "Kule Sudhakar Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20858",
    "name": "Landge Anil Shyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23461",
    "name": "Maingade Anand Ishwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23459",
    "name": "Maingade Anuradha Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23452",
    "name": "Maingade Archana Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23455",
    "name": "Maingade Shivaji Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23457",
    "name": "Maingade Sneha Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23465",
    "name": "Maingade Sungadha Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23495",
    "name": "Mishra Chitrasen Shivbaran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23437",
    "name": "Miss  Kadam Deepali Deu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23441",
    "name": "Parlekar Vishwas Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23449",
    "name": "Patil Ananda Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23451",
    "name": "Patil Balkrishna Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23472",
    "name": "Patil Laxman Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23477",
    "name": "Patil Rajaram Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23439",
    "name": "Patil Sambhaji Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23442",
    "name": "Patil Tanaji Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23454",
    "name": "Pawar Nitin Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23497",
    "name": "Salunkhe Ramchandra Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23446",
    "name": "Sawant Ganpati Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20214",
    "name": "Shaikh Nazir Suleman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23498",
    "name": "Shetty Balesh Bhoja"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23488",
    "name": "Shetty Bhoja Kantappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23434",
    "name": "Shetty Sadanand Chandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23433",
    "name": "Shetty Shobha Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23432",
    "name": "Shetty Vranda Jagdish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23515",
    "name": "Sonavane Deepak Ramchndra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23487",
    "name": "Sonvane Gajrabai Ramchndra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23489",
    "name": "Sonvane Jyoti Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23485",
    "name": "Sonvane Ramchndra Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23443",
    "name": "Sukkhu Brijmohan Nishad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20102",
    "name": "Shinde Anil Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22303",
    "name": "Abdul Rehman Abdul Majid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20572",
    "name": "Andhe Abdul Mohammad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19778",
    "name": "Ansari Mushafa Kurbanali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22441",
    "name": "Bhalsingh Kishan Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20444",
    "name": "Daripkar Vijay Vivekanad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19667",
    "name": "Farnadies Jaral David"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20238",
    "name": "Ghadge Vijay Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22950",
    "name": "Ghare Raghunath Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20583",
    "name": "Gupta Mahendrakumar Gurucharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19630",
    "name": "Jadhav Yallapa Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19408",
    "name": "Jain Kantilal Devichand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22347",
    "name": "Kambre Atmaram Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21797",
    "name": "Khan Iqbal Karam Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19217",
    "name": "Khatri Fazal Mehmood Mohd  Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22648",
    "name": "Khot Hasanmiya Nooruddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22755",
    "name": "Meman Arif Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22471",
    "name": "Mishra Omprakash Shivanarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20479",
    "name": "Mishra Rakesh Kumar Suymini"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21110",
    "name": "Mohd Aslam Mohd Hussien"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22702",
    "name": "Pandey Kamalashankar Ramanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22952",
    "name": "Pisal Ganesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20221",
    "name": "Salagare Anant Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22432",
    "name": "Saldanha Richard Francis"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19236",
    "name": "Shah Kalpesh Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22389",
    "name": "Shaikh Allauddin Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22372",
    "name": "Shaikh Arif Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21868",
    "name": "Shaikh Khalil Mohammad Hasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20347",
    "name": "Shaikh Yadullha Murtuza"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22956",
    "name": "Sharma Ramkalap Ramkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22312",
    "name": "Shigwan Chandrakant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22502",
    "name": "Shukla Shivkumar Ramnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22673",
    "name": "Singh Birbahadur Ramkuber"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22404",
    "name": "Thakkar Bholanath Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22416",
    "name": "Thakkar Birju Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22327",
    "name": "Tiwari Narendrapratap Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22413",
    "name": "Tripathi Shriniwas Bibhutimani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22511",
    "name": "Upadhayay  Ramujigir Satyanarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22944",
    "name": "Utekar Priyanka Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22379",
    "name": "Varunkar Mohdshafi Amina Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19737",
    "name": "Yadav Jiyaram Harilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22486",
    "name": "Yadav Naginchandra Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22346",
    "name": "Yadav Rambharos Ramdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22190",
    "name": "Yadav Ramraj Ramadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22249",
    "name": "Abdul Hadi Abdul Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22180",
    "name": "Ahmed Shamshad Nasim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21215",
    "name": "Bokophode Mohan Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22074",
    "name": "Gaikwad Dattaram Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22217",
    "name": "Gupta  Devtadin  Laltaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22260",
    "name": "Gupta Phoolchand Thakurprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22262",
    "name": "Jadhav Nandu Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22270",
    "name": "Kesari Sureshchandra Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20982",
    "name": "Khan Gulrahman Fazal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20483",
    "name": "Krishnamurthi Meghraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21867",
    "name": "Mali Sankar Sidharma"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21938",
    "name": "Miss  Rajak Savitri Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22168",
    "name": "Pinto Sheldon Triza"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22075",
    "name": "Popat Suresh Gordhandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22256",
    "name": "Satpute Popat Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22072",
    "name": "Sawant Satish Lawoo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21257",
    "name": "Sayed Iqbal Mastan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22274",
    "name": "Sayyad Akbar Tolas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21041",
    "name": "Shaikh Azam Adam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22194",
    "name": "Shaikh Azimuddain Riyastali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19750",
    "name": "Shaikh Mohd Khaja Abdul Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22268",
    "name": "Singh Markande Shivprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22220",
    "name": "Singh Suryabali Chabinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22060",
    "name": "Yevle Kishan Chindu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19985",
    "name": "Bhosale Prashant Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3912",
    "name": "Bhoite Rajendra Laxmanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12053",
    "name": "Bhosale Rajashree Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16930",
    "name": "Bijwe Shradha Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21945",
    "name": "Devele Giridhar Mohan Badi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21613",
    "name": "Hedaoo Deepak Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16423",
    "name": "Jadhav Vaishali Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22007",
    "name": "Jahaud Abdulkhalid Mohammad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21934",
    "name": "Kambale Kisan Mukund"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21223",
    "name": "Kureshi Mriyambi Rahimbaksh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21782",
    "name": "Mane Sunil Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21292",
    "name": "Miss  Khan Sunnabi Sher"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8598",
    "name": "Musale Madhukar Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21224",
    "name": "Nadar Benjamani Ponemani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20944",
    "name": "Nirmal Manulal Mahavir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22607",
    "name": "Pandey Rameshchandra Sabhapati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "303",
    "name": "Parab Anmdev Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20962",
    "name": "Pawar Bharat Hanumant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20964",
    "name": "Pujari Sudhakar Ramanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20914",
    "name": "Selvi Rajendra Devendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7850",
    "name": "Sharma Ramakant Satyanarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "160",
    "name": "Tanaji Anandrao Ghadge"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20406",
    "name": "Tiwari  Ramshiromani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21851",
    "name": "Valwekar Laxman Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3084",
    "name": "Vyas Govind D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10522",
    "name": "Hadwale Janku Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13628",
    "name": "Sawant Uttam Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18066",
    "name": "Shaikh Rafiq Gulam Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19259",
    "name": "Chandaliya Kisan Ramdaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15245",
    "name": "Dhumal Meenakshi Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14727",
    "name": "Gaikawad Bharat Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19403",
    "name": "Mascarantas Gabrial Damnic"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22144",
    "name": "Patel Ayub Adam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18133",
    "name": "Patel Rashid Amin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17535",
    "name": "Patel Subhodchandra Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1715",
    "name": "Suryawanshi Ajitkumar Tanajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22511",
    "name": "Mhaskar Priyanka Praful"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14745",
    "name": "Adarkar Dnyandeo Raghuveer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14710",
    "name": "Bawdekar Krishna Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14808",
    "name": "Bhate Sandip Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14752",
    "name": "Bogham Vimala Venkatrama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14753",
    "name": "Bolar Sumona Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14195",
    "name": "Christopher Badigiri James"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14758",
    "name": "Deshmukh Rajendra Lalasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14718",
    "name": "Dhadve Ramchandra Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8442",
    "name": "Dhuri Gajanan Krushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14749",
    "name": "Gaikawad Anil Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14750",
    "name": "Gaikawad Dilip Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14725",
    "name": "Gaikawad Vasant Vishram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14724",
    "name": "Gaikwad Vinayk Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14713",
    "name": "Gawas Sanjay Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16287",
    "name": "Ghadigaonkar Pramod Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14726",
    "name": "Ghadigaonkar Vothoba Janba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14702",
    "name": "Jadhav Shyam Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14754",
    "name": "Kudale Hanmant Raoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14746",
    "name": "Malla Rajaram Jaglal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14722",
    "name": "Marathe Sonu Vittal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14748",
    "name": "Mirjolkar Narayan Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14717",
    "name": "Mohite Satish Lalasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14747",
    "name": "Naik Santosh Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14730",
    "name": "Paste Prabhakar Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23462",
    "name": "Patil Deepak Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23468",
    "name": "Patil Shobha Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14733",
    "name": "Sawant Balkrishna Bhoruji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14194",
    "name": "Sawant Sajjad Ummer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14711",
    "name": "Shinde Dnyandev Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14704",
    "name": "Shinde Ramchandra Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14731",
    "name": "Sutar Narayan Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14895",
    "name": "Sutar Sayajirao Krishnarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13787",
    "name": "Tambe Vijay Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14732",
    "name": "Warang Sadanand Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "770",
    "name": "Salunkhe Gulabrao Ganpatrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1121",
    "name": "Gaikawad Sachin Mansing"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1158",
    "name": "Gharat Balu Gopal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1001",
    "name": "Kochale Devidas Sadashiv"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1054",
    "name": "Kochale Sanjay Mahadeo"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1191",
    "name": "Pandit Ramkrushna Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19407",
    "name": "Sunil Uttam Sapkal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20484",
    "name": "Sawant Raju Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10491",
    "name": "Gayawal Mukund Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10487",
    "name": "Godbole Anand Ashokrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10486",
    "name": "Jadhav Bharat Wamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10485",
    "name": "Konde Atmaram Yasajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10484",
    "name": "Nawadkar Mahesh Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10490",
    "name": "Valhekar Vijay Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21068",
    "name": "Singh Ramakant Fauzdar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12406",
    "name": "Musale Arun Rangrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12405",
    "name": "Musale Dilip Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6961",
    "name": "Sharma Ravindra Rakesh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1253",
    "name": "Bhoir Amit Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15014",
    "name": "Mane Subhash Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6890",
    "name": "Ghadge Sanjay Ravsaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "616",
    "name": "Hansa Balkrishn Shirke"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12218",
    "name": "Shirke Deepak Balkrishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "897",
    "name": "Pujari Pravinkumar Ramanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21930",
    "name": "More Harishchandra Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15368",
    "name": "Ramane Rajesh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23720",
    "name": "Khan Nazim Hasmat"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1130",
    "name": "Kochale Shantaram Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18903",
    "name": "Patani Abdul Rehman Noor Mohd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6051",
    "name": "Kambale Govind D"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2069",
    "name": "Mhatre Mohan Hadakya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1223",
    "name": "Bhosale Kamini Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12640",
    "name": "Jagtap Sangeeta Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2004",
    "name": "Laxmi Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22378",
    "name": "Matkar Nilesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23483",
    "name": "Desai Smita Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23516",
    "name": "Mandhare Dilip Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23479",
    "name": "Patil Hari Keru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21446",
    "name": "Mane Chhaya Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22791",
    "name": "Kazi Abdulaziz Abdulsattar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18221",
    "name": "Gandhi Hemant Nagardas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5742",
    "name": "Patil Jatin Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22686",
    "name": "Chavan Premnath Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22008",
    "name": "Gawthe Lata Vishwanath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1789",
    "name": "Sutar Deepak Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21502",
    "name": "Khan Masroor Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24173",
    "name": "Nimbalkar Sakharam Uttam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2855",
    "name": "Shaikh Vikram Sirajuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2975",
    "name": "Singh Samsher Baleshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1057",
    "name": "Maroliya Bakulesh Laxmanbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3969",
    "name": "Garat Vijay Manohar"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1047",
    "name": "Paswan Shivkumar Dhoda"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1043",
    "name": "Khandebharad Samadhan Sheshrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21522",
    "name": "Modak Tanaji Ganpati/Kavhar Dhanaji P"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20895",
    "name": "Aadvilkar Narendra Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15575",
    "name": "Bhoite Ramesh Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21127",
    "name": "Yadav Motilal Bhagirath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24437",
    "name": "Manjare Shivaji Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15153",
    "name": "Yadav Geetadevi Lalji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9877",
    "name": "Jadhav Vilas Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17094",
    "name": "Pawar Vikas Sampat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2596",
    "name": "Thorat Amol Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18879",
    "name": "Chavan Pravin Shrirang"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1376",
    "name": "Lahkan Dilip Barku"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "147",
    "name": "Om Sai Corporation"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1305",
    "name": "Omkar Communication Center"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12055",
    "name": "Sabale Hanmant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9723",
    "name": "Gupta Jivanlal Sukharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7499",
    "name": "Nimunkar Ashok Nathuram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1668",
    "name": "Khetle Abhijit Gangaram"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "54",
    "name": "Pankaj Developers & Builders"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "930",
    "name": "Takale Namdev Budhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4615",
    "name": "Charles Richard Leslie"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "791",
    "name": "Nikam Pramod Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17199",
    "name": "Pawar Dipali Bharat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24154",
    "name": "Chisty Sajidali Mumtazali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24155",
    "name": "Mehta Mansur Abubakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24161",
    "name": "Miss  Patil Manali Nandkishor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22579",
    "name": "Talekar Vinayak Prakash"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1074",
    "name": "Tidke Milind Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1482",
    "name": "Salunkhe Ramchandra Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15470",
    "name": "Salunkhe Sudhir Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15475",
    "name": "Shaikh Kasam Bakshulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12821",
    "name": "Hule Lata Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "930",
    "name": "Mehtre Dwarkadhish Trimbak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23436",
    "name": "Maingade Tanaji Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23467",
    "name": "Bhosale Siddhant Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15444",
    "name": "Gaikawad Narayan Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21937",
    "name": "Joshi Vilas Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22348",
    "name": "Pawar Sudhir Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24960",
    "name": "Sale Parshuram Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22026",
    "name": "Gupta Vijaykumar Jitu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22208",
    "name": "Shaikh Tipusultan Hyderali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20569",
    "name": "Singh Mayashankar Fouzdar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22403",
    "name": "Bhatkar Ashok Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15840",
    "name": "Sonawale Jayshree Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22683",
    "name": "Pawar Sanjay Uddhav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24601",
    "name": "Bagde Archana Rupesh"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2305",
    "name": "Pavnai Tours & Travels"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23088",
    "name": "Jagtap Anil Nathuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8026",
    "name": "Nurmohamad Liyakat Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20975",
    "name": "Khan Mukhtar Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "215",
    "name": "Gadhave Dilip Balasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23948",
    "name": "Parmar Rajkumar Venilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13811",
    "name": "Jain Kapil Jayantilal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1041",
    "name": "Gupta Shivshankar Shivprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20933",
    "name": "Fale Anand Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14463",
    "name": "Rahate Mahesh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12077",
    "name": "Yadav Nanda Sharad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15797",
    "name": "Chavan Gulabrao Bapuji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20110",
    "name": "Chavan Abhijit Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21037",
    "name": "Pol Roopali Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22170",
    "name": "Hussain Mohd Gullu Khaja"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16872",
    "name": "Kadam Rahul Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19018",
    "name": "Shinde Sujata Sahadev"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "489",
    "name": "R R Fashion"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24775",
    "name": "Chadana Kishnsingh Tejsingh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1240",
    "name": "Bhagat Suresh Dadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15390",
    "name": "Borate Bharat Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15389",
    "name": "Shaikh Aliam Isak"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1241",
    "name": "Khan Iqbal Vazir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22138",
    "name": "More Santosh Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22581",
    "name": "Dhangar Balram Blappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6927",
    "name": "Ghuge Vinod Bhimaji"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1701",
    "name": "Mahadik Shubhangi Naresh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1691",
    "name": "Golwalkar Aditya Balkrishna"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1693",
    "name": "Prabhudesai Arati Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16779",
    "name": "Bhalekar Sanjay Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24496",
    "name": "Nanaware Kishor Dnyaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24495",
    "name": "Nanaware Sandeep Dnyaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22321",
    "name": "Kumbhar Shankar Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21227",
    "name": "Pandey Subhash Ramakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24430",
    "name": "Chavan Chandrakant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20222",
    "name": "Shukala Mukesh Rajkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "2768",
    "name": "Gorule Omkar Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "2766",
    "name": "Gorule Yash Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "2767",
    "name": "Gorule Yogita Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3208",
    "name": "Rathi Govardhandas Badriprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24164",
    "name": "Kitta Ilaben Shivprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21510",
    "name": "Bodake Varsha Bharat"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1573",
    "name": "Arane Ashish Harishchandra"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1570",
    "name": "Rode Prakash Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1760",
    "name": "Ravi Steel Traders"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21260",
    "name": "Yadav Amarbahadur Jangnarayan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1525",
    "name": "Kasbe Shekhar Harishchandra"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1526",
    "name": "Sargade Suhas Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23163",
    "name": "Ghadge Jayashree Umesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22715",
    "name": "Charuvukalayil Saji Bhaskaran"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1476",
    "name": "Jadhav Niwas Sitaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1467",
    "name": "Lokhande Ramchandra Sahebrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1477",
    "name": "Magare Rajveer Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23950",
    "name": "Mhaske Neelkanth Prataprao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1482",
    "name": "More Dilip Jagannath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1481",
    "name": "Patil Ramchandra Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23949",
    "name": "Sawant Vijay Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23944",
    "name": "Mhaske Prajwal Neelkanth"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23943",
    "name": "Mhaske Yogita Prajwal"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1324",
    "name": "Baheti Moolchand"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1322",
    "name": "Mohta Sureshkumar Shyamsunder"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11843",
    "name": "Shinde Suresh Prataprao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23821",
    "name": "Babaria Hitesh Praful"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23826",
    "name": "Jadhav Ganesh Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23827",
    "name": "Jadhav Harsha Ganesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17817",
    "name": "Kadam Vinod Nandkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1036",
    "name": "Pandit Sudhakar Satwaji"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "10",
    "name": "Sachin Sales"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13552",
    "name": "Mane Sanjivani Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23752",
    "name": "Bagul Gaurav Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23755",
    "name": "Mehta Rashmikant Jayantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "534",
    "name": "Sainath Roadways Pvt Ltd"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "564",
    "name": "Mohite Kiran Niwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21634",
    "name": "Yadav Meenadevi Sheromani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "401",
    "name": "Chavan Vijayalaxmi Ashokrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16376",
    "name": "A  Murugesan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15053",
    "name": "Nanavare Priyanka Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12417",
    "name": "Said Lata Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1923",
    "name": "Nawadkar Sindhu Kalidas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1523",
    "name": "Gaikwad Sampat Tulshiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3490",
    "name": "Sanjay Ramnij Panday"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18799",
    "name": "Sana Purnima Akhok"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1760",
    "name": "Ansari Atikurrahaman Nishar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4014",
    "name": "Mistri Abdul A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18165",
    "name": "Bhansali Pankaj Chunilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21259",
    "name": "Dabhade Vasant Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21264",
    "name": "Jadhav Balkrishna Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21197",
    "name": "Miss  Gupta Laxminadevi Gulabchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21198",
    "name": "Palsara Amin Adam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21258",
    "name": "Shaikh Anwar Hussain Gulam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21248",
    "name": "Solanki Abdul Mazid Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21330",
    "name": "Tawar Dare Basraj Gurling"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12164",
    "name": "Jagtap Nanaso Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19041",
    "name": "Shukla Santoshkumar Harikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16375",
    "name": "Pisal Hanumant Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21261",
    "name": "Singh Aish Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13543",
    "name": "Jagtap Umakant Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18936",
    "name": "Murudkar Prabhakar Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12188",
    "name": "Nikam Ushadevi Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "544",
    "name": "Dhanesh Shantaram Bhandari"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1071",
    "name": "Matere Sanjay Laxman"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1065",
    "name": "Tidke Abhijit Sahebrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1069",
    "name": "Tidke Amol Prakash"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1070",
    "name": "Tidke Aparna Amol"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1067",
    "name": "Tidke Mithilesh Sahebrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1072",
    "name": "Tidke Prakash Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1064",
    "name": "Tidke Sahebrao Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1066",
    "name": "Tidke Sujata Abhijit"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1063",
    "name": "Tidke Vanita Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1167",
    "name": "Shah Prakash C  [ H U F"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15461",
    "name": "Shirale Dinkar Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17826",
    "name": "Jain Vipul Chandulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20683",
    "name": "Balshiram Narayan Kadam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4106",
    "name": "Jadhav Vitthal Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16996",
    "name": "Sanas Hanmant Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3049",
    "name": "Kadam Madhavrao Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18985",
    "name": "Gole Madhukar Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3052",
    "name": "Gaikawad Tulsiram Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23405",
    "name": "Chougale Manohar Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23427",
    "name": "Kadam Bhikaji Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23411",
    "name": "Miss  Nalawade Shubhangi Hanmantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23424",
    "name": "Patil Rajesh Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23425",
    "name": "Patil Rajesh Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15306",
    "name": "Khande Lata Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23148",
    "name": "Chavan Namdeo Khashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23192",
    "name": "Jadhav Mohan Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23184",
    "name": "Khatri Shantilal Mohanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23276",
    "name": "Rathod Kajal Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23106",
    "name": "Sawant Vijay Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23166",
    "name": "Singh Awdhesh Kishor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23122",
    "name": "Vora Sanket Kirit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23186",
    "name": "Yadav Rajesh Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12415",
    "name": "Pisal Mahesh Jayawantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23036",
    "name": "Nalawade Yallappa Bhima"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12603",
    "name": "More Hiralal Masku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16734",
    "name": "Devlekar Shamal Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14807",
    "name": "Bhapkar Mohan Antaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14032",
    "name": "Muthayya  Saji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1901",
    "name": "Kahar Ramchandra Ramdhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17010",
    "name": "Pawar Sunil Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10434",
    "name": "Pande Vijayshankar Rajdeo"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1466",
    "name": "Bhaskar Viidyanand Rahul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19810",
    "name": "Shah Lata Arvindkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21313",
    "name": "Javed Ahmed Khurshid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10258",
    "name": "Hussain Asphaque Istiyak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3630",
    "name": "Kumar Vijaykumar Premnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22904",
    "name": "Kamath Sunil Vasudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11778",
    "name": "Gimvekar Uttam Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21612",
    "name": "Chaugule Sachin Fulchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3929",
    "name": "Rokade Ramesh Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2803",
    "name": "Hetavkar Fakirmahammad Abdullatif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2452",
    "name": "Amnre Gajanan Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15251",
    "name": "Mulik Govind Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24556",
    "name": "Sabale Amit Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12117",
    "name": "Shinde Kanchan Veersing"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "678",
    "name": "Sona Auto Sales"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1869",
    "name": "Jambudekar Ankush Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15511",
    "name": "Rananware Rahul Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12179",
    "name": "Maskar Gajarabai Kanta"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4256",
    "name": "Sri Shyam Handloomazyps6875L"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22905",
    "name": "Shaikh Gulam Dastagir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22845",
    "name": "Telange Rupesh Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22517",
    "name": "Dharani Amirali Husainbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22515",
    "name": "Sawant Pramod Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22560",
    "name": "Salunkhe Subhash Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22559",
    "name": "Tamboli Anant Purushottam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22467",
    "name": "Luhar Rajesh Laxmidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22341",
    "name": "Banbe Ganpat Damodar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22340",
    "name": "Jha Sunil Bedanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22263",
    "name": "Rawale Mahadeo Genu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1260",
    "name": "Sonawale Dashrath Dagdu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22182",
    "name": "Tatkar Jyoti Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22148",
    "name": "Chavan Rahul Dhairyasing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22077",
    "name": "Pawar Piyush Keshaw"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12189",
    "name": "Dhumal Shekhar Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9673",
    "name": "Pawar Eknath B/Narayan Mahadev S"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1688",
    "name": "Jage Sagar Shamkant"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1384",
    "name": "Technofeas  Computer Education"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7806",
    "name": "Gaikwad Kamlakar Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21087",
    "name": "Nayyappa Eshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4844",
    "name": "Hule Bharat Attamaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12306",
    "name": "Sable Sanjay Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2986",
    "name": "Indulkar Deelip Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1512",
    "name": "Shah Kirit Shantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11189",
    "name": "Mandhre Satish Balwantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3757",
    "name": "Atkire Laxman Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3724",
    "name": "Deshmukh Ramchandra Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3875",
    "name": "Mascarenhas Raymond Lowrance"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3874",
    "name": "Satardekar Ankush Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "239",
    "name": "Trishul  Transport Service"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15050",
    "name": "Mhatre Ashok Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17131",
    "name": "Sayed Amjad Hamid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11567",
    "name": "Shetye Shivram Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3635",
    "name": "Devulkar Sunil Indranath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3633",
    "name": "Jiwani Yusufali Allahrakha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3637",
    "name": "Mishra Ramashankar Shivnayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10034",
    "name": "Kadam Vilas Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5394",
    "name": "Khan Abbas Ahmed Salim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1367",
    "name": "Shinde Anandrao Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2132",
    "name": "Patil Suresh Bhiva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13819",
    "name": "Jagtap Satyawan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12367",
    "name": "Pisal Sangeeta Shantaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1266",
    "name": "Pawar Prashant Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2906",
    "name": "Rajbhar Parashuram Ramdhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22595",
    "name": "Patil Sunil Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2153",
    "name": "Pal Hariram Dularam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22902",
    "name": "Sawant Rajesh Madhusudan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22903",
    "name": "Sawant Swati Madhusudan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18635",
    "name": "More Kalapna Dnyandev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15795",
    "name": "Shinde Mahandra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16239",
    "name": "More Sahebrao Keshavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10974",
    "name": "Khan Ibrahim Shafat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16225",
    "name": "Koli Yeshwant Chandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10899",
    "name": "Khan Amir Mirakbar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10901",
    "name": "Sagar Ashok Sharanappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22552",
    "name": "Nanavare Ranjit Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10521",
    "name": "Pise Gajanan Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21465",
    "name": "Gaikwad Bipin Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19752",
    "name": "Nikam Mukesh Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4113",
    "name": "Prabhu Rajaram Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4112",
    "name": "Rehman Mohmmed Anwar Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3873",
    "name": "Chitrekar Bhumaiya Narsayya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4105",
    "name": "Dhuri Yatin Balaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4208",
    "name": "Jakhia Dinkar Raoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10446",
    "name": "Yadav Ramachal Indrajeet"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2082",
    "name": "Raul Vilas Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12024",
    "name": "Bhosale Vidhaya Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "821",
    "name": "Kokare Kashinath Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10261",
    "name": "Gaikwad Nagnath Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9934",
    "name": "Menon Mohd Akram Mohd Yunus"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "7",
    "name": "Vikram Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9964",
    "name": "Bhoir Narsinha Bhimayya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9979",
    "name": "Chouhan Indraj Kanhaiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9976",
    "name": "Gupta Harishchandra Chedilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10103",
    "name": "Gupta Lalu Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10025",
    "name": "Gupta Vinodkumar Nikilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10047",
    "name": "Nimbalkar Satish Dharmagi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9962",
    "name": "Patil Prakash Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9932",
    "name": "Verma Hajarilal Ramjeevan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21795",
    "name": "Viswakarma Omprakash Ramlakhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23554",
    "name": "Pagade Chandrakant Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23416",
    "name": "Kurane Abhijeet Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23423",
    "name": "Kurane Avinash Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23414",
    "name": "Kurane Sampat Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23422",
    "name": "Kurane Seema Avinash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23415",
    "name": "Kurane Veena Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23418",
    "name": "Miss  Kurane Amruta Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23417",
    "name": "Miss  Kurane Anita Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23410",
    "name": "Miss  Nalawade Rekha Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23412",
    "name": "Nalawade Anandi Hanmantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23409",
    "name": "Nalawade Pavitra Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23408",
    "name": "Nalawade Rupali Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23413",
    "name": "Nalawade Shital Hanmantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23407",
    "name": "Nalwade Krishna Bhima"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23420",
    "name": "Shinde Mangal Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23419",
    "name": "Shinde Sheetal Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23421",
    "name": "Shinde Suraj Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9897",
    "name": "Kadam Dagadu Annasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9898",
    "name": "Nadar Palraj Pandi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9893",
    "name": "Yadav Bateshwarnath Shobhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11833",
    "name": "Sawant Rajendra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22005",
    "name": "Shetty Asha Satish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1056",
    "name": "Iyer Jayaram Ramaswami"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "480",
    "name": "Raghunath Bhagoji Mahadik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16392",
    "name": "Vaidya Raju Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20355",
    "name": "More Kiran Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18922",
    "name": "Gupta Sanjaykumar Rajdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21628",
    "name": "Devdas Digambar Shiva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18840",
    "name": "Gupta Ramsnehi Asharam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2374",
    "name": "Khan Noormohammad Najeebullah"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10777",
    "name": "Yadav Sushma Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11696",
    "name": "Chari Sunil Laxmikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3083",
    "name": "Kanse Gangaram L"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21482",
    "name": "Gurao Sandesh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10898",
    "name": "Doke Mohan Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "947",
    "name": "Dhopat Hrichandra Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12229",
    "name": "Bhoite Rekha Pradeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22395",
    "name": "Gawali Sujata Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22308",
    "name": "Mehta Jignesh Jayant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22475",
    "name": "Shaikh Abdul Wahab Chand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25538",
    "name": "Murkar Prakash Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1140",
    "name": "Keni Suresh Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13167",
    "name": "Yadav Tejbahadur Devnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3973",
    "name": "Dandekar Ravindra Moreshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9925",
    "name": "Choube Krupashankar Chandradeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2278",
    "name": "Jaiswal Lalman Jaykisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1075",
    "name": "Amberkar Vishwanath Sonu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9351",
    "name": "Ahirwar Vijay Khemchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23865",
    "name": "Shinde Priyanka Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1210",
    "name": "Kapadia Pramila B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6013",
    "name": "Gupta Jaibhagawan Jainarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18911",
    "name": "Khan Dilshad Mohamd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18913",
    "name": "Vishvakarma Sudarshan Deburam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18914",
    "name": "Yadav Kamalashankar Prabhunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18888",
    "name": "Saw Ashok Karan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18869",
    "name": "Yadav Indrapal Mahavir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17800",
    "name": "Tamhane Sanjay Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2018",
    "name": "Parera Myathu Jon"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1137",
    "name": "Taware Sandeep Dadaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16292",
    "name": "Raut Hema Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20533",
    "name": "Anute Laxman Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21388",
    "name": "Jagtap Mangal Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14707",
    "name": "Kumbhar Lahoo Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1074",
    "name": "Samgir Krishna Mukutrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18953",
    "name": "Kadam Ashok Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21785",
    "name": "Ghadge Shivaji Dattatrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18959",
    "name": "Ahire Sanjay Nimba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17550",
    "name": "Lipare Sushil Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21423",
    "name": "Miss  Chavan Laxmi Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22532",
    "name": "Devadekar Ashok Bhukaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12466",
    "name": "Khopade Kalavati Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2822",
    "name": "Mahendra C Challaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12181",
    "name": "Mandhare Vandana Satish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17914",
    "name": "Jinka Balama Bakana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21305",
    "name": "Tupe Balwant Nivruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19917",
    "name": "Salunkhe Arvind Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10887",
    "name": "Shinde Manik Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2129",
    "name": "Patil Prasannakumar Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2958",
    "name": "Kadam Vijay Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3370",
    "name": "Miss  Rasania Kiran Dhanjibhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23172",
    "name": "Chaphale Sagar Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22612",
    "name": "Bhanushali Arvind Kanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18175",
    "name": "Patkar Bhushan Ramakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13837",
    "name": "Faras Suraya Jainbuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22543",
    "name": "Salunkhe Yashwant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22587",
    "name": "Sawant Surendra Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1169",
    "name": "Patel Bhikhabai Kesurbhai"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1216",
    "name": "Dixit Abhishek Dattaray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9618",
    "name": "Shaikh Rafiq Shaikh Munnir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5380",
    "name": "Chourasiya Ramshish Shivnandan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1194",
    "name": "Tarde Namdeo Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18604",
    "name": "Pisal Sachin Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1935",
    "name": "Pagdhare Sudhari Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18912",
    "name": "Shaikh Mohamd Muddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18889",
    "name": "Shaikh Moosa Peermohd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18868",
    "name": "Singh Shamnarayan Ramprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18979",
    "name": "Dalvi Surendra Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18930",
    "name": "Sarvankar Balkrishna Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18839",
    "name": "Gupta Prabhunath Laxmi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18862",
    "name": "Mapari Salim Mohmad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18838",
    "name": "Shaikh Anwarali Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18837",
    "name": "Shaikh Asgarali Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21480",
    "name": "Lad Vishwanath Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17932",
    "name": "Sonar Jagat Motising"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22454",
    "name": "Yadav Suhas Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16259",
    "name": "Gole Sweta Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20941",
    "name": "Miss  Hingora Hawabai Rajjak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20093",
    "name": "Patel Raju Moulana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17830",
    "name": "Chindarkar Suhas Subhash"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "794",
    "name": "Kamble Lahu Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18902",
    "name": "Yadav Premchand Ramnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12365",
    "name": "Ghadage Anand Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2028",
    "name": "Konar Subbaiah P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24237",
    "name": "Lad Gorakshnath Dnyandeo"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1618",
    "name": "Sakpal Swati Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21358",
    "name": "Kadam Kamlesh Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11114",
    "name": "Khochare Prakash Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21515",
    "name": "Pathare Gajanan Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8435",
    "name": "Shinde Vimal Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23503",
    "name": "Jamsundekar Sujit Ravindranath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13924",
    "name": "Dhumal Santosh Babanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8673",
    "name": "Shelake Pandurang Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19907",
    "name": "Mahangade Anurat Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23689",
    "name": "Wagh Sukhdev Sonaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14077",
    "name": "Kambale Rajashree Rajaram / Nikhil R"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1577",
    "name": "Jagtap Digmbar Ekanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16365",
    "name": "Inamati Ramesh Vyankatesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15340",
    "name": "Mavani Hitesh Babulal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17239",
    "name": "Shinde Shankar Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13289",
    "name": "Bhartiya Janta Party-Ward No 18"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3681",
    "name": "Lad Balkrishna Dagdoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20403",
    "name": "Mandhare Sagar Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10203",
    "name": "Arote Sushila Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21793",
    "name": "Gupta Ashok Baiyalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6296",
    "name": "Waghela Nilesh R /Waghela Vanita N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4346",
    "name": "Shinde Anandrao Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9969",
    "name": "Lembhe Pandharinath Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21585",
    "name": "Miss  Warekar Darshana Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21571",
    "name": "Pathak Madhu Sadan Satyadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3264",
    "name": "Pisal Vatsala Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2833",
    "name": "Gurav Shridhar Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21977",
    "name": "Nikam Vinayak Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18942",
    "name": "Qureshi Nadim Mohamad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18864",
    "name": "Khan Jafar Mohd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18866",
    "name": "Pandey Dharmendra Kamlashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21632",
    "name": "Patil Yogesh Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21568",
    "name": "Shaikh Mustak Ahmed Babasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21554",
    "name": "Innayat Hussain Kasam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21826",
    "name": "Mandhare Swarup Shuvaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8185",
    "name": "Gupta Gangaram Ramashrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18968",
    "name": "Gupta Ganesh Laltaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18969",
    "name": "Jagale Anthony Yallapa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23578",
    "name": "Modak Anusaya Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18212",
    "name": "Alve Vasant Mahadeo Mahadeo V  Alve"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22212",
    "name": "Hule Rajesh Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19827",
    "name": "Babar Ganpat Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12651",
    "name": "Chavan Prasant Khanderao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18076",
    "name": "Kadam Pradnya Pravin Pravin R Kadam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16385",
    "name": "Patil Dashrath Satuppa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18841",
    "name": "Singh Ramlochan Chhakkan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14992",
    "name": "Patil Ujawala Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2498",
    "name": "Thapa Nandabahadur N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11808",
    "name": "Madane Nanasaheb Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6185",
    "name": "Naram Jaywanti Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11964",
    "name": "Chavan Narayan Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22199",
    "name": "Kambale Latika Ambadas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1956",
    "name": "Takle Anada Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18882",
    "name": "Pal Shashikant Hariprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14133",
    "name": "Chavan Jayprakash Bhikobha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7409",
    "name": "Gupta Shravankumar Shamsundarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19474",
    "name": "Ware Sarjerao Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2621",
    "name": "Jadhav Latika Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9100",
    "name": "Pawar Ranjana Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1240",
    "name": "Mulla Maksud Jainuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14026",
    "name": "Gabhud Vasant Tatyaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1341",
    "name": "Kedare Devkumar Nathuji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17933",
    "name": "Mehta Dhirajben Shashikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15201",
    "name": "Gulumbe Ushadevi Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12311",
    "name": "Jadhav Vimal Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14069",
    "name": "Gupta Rajaram Kokil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18336",
    "name": "Disale Ramesh Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17835",
    "name": "Mascarenhas Anita Rocky"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21675",
    "name": "Kalantre Vijay Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2363",
    "name": "Phalke Nutanmala Ashokrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19188",
    "name": "Kasam Mohmmad Javed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15614",
    "name": "Mandhare Savita Jitendra"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1206",
    "name": "Singh Narendrakumar Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "874",
    "name": "Vaity Haresh Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "73",
    "name": "Dattatray Devram Shinde"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24051",
    "name": "Chavan Prashant Malharro"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "597",
    "name": "Jadhav Shankar Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18870",
    "name": "Sale Ankush Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18580",
    "name": "Sabale Eshwari Amit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12647",
    "name": "Salekar Chandrashekhar Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12630",
    "name": "Shinde Balwant Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1368",
    "name": "Kadam Vikash Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12285",
    "name": "Abhang Vilas Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14645",
    "name": "Pawar Bavasaheb Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5674",
    "name": "Patil Jayraj Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16675",
    "name": "Trivedi Jayant Naryan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24542",
    "name": "Mahamunkar Manohar Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21471",
    "name": "Pawarumesh  Deoram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9685",
    "name": "Londe Surendra Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19003",
    "name": "Sharma Alokprasad Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13175",
    "name": "Shah Jigna Narendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7666",
    "name": "Mandhare Jitendra Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11904",
    "name": "Yadav Dattatray Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14017",
    "name": "Shinde Ashwini Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13265",
    "name": "Bande Bhavkumar Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22311",
    "name": "Shaikh Mariyambi Musa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20103",
    "name": "Kadam Archana Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15202",
    "name": "Tanaji Bajirao Gulambe"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16386",
    "name": "Satarkar Rajendra Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17886",
    "name": "Ghatage Ramakant Shivajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24962",
    "name": "Malusare Vikram Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12108",
    "name": "Shah Bharti Bhagawandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6347",
    "name": "Shinde Sahebrao Marutrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1829",
    "name": "Patil Ananta Baliram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17131",
    "name": "Pulekar Surendra Rajanikant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9249",
    "name": "Ghadge Satish Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10823",
    "name": "Chavan Vijaykumar Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13831",
    "name": "Pawar Geeta Hariba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12737",
    "name": "Kshirsagar Tanaji Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7225",
    "name": "Chaudhary Vijay Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18812",
    "name": "Khan Hamid Hussein"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16113",
    "name": "Kashid Nanda Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17967",
    "name": "Shah Natwarlal K"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12572",
    "name": "Yadav Ramvrukhsha Jangli"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23688",
    "name": "Wagh Sunita Sukdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1931",
    "name": "Mandhre Kusum Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2109",
    "name": "Joseph R Mascarenhds"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1241",
    "name": "Bhosale Krishna Janu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14549",
    "name": "Bhapkar Vidhya Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18071",
    "name": "Mishra Brijlal Ramnihur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18069",
    "name": "Sawant Sarjerao Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18068",
    "name": "Tambodkar Naresh Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14159",
    "name": "Patil Sanjay Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13285",
    "name": "Jagatap Vaibhav Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23359",
    "name": "Ahire Sandeep Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17683",
    "name": "Misal Vithal Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1472",
    "name": "Gole Sampat Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21494",
    "name": "Kambale Jayashri Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20831",
    "name": "Maingade Suresh Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12839",
    "name": "Jadhav Bandu Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19106",
    "name": "Bhalekar Chandrakant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16300",
    "name": "Chavan Bharat Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11425",
    "name": "Shikare Dilip Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13264",
    "name": "Navadkar Shilpa Sachitanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17471",
    "name": "Sarmalkar Praddep Parsuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11053",
    "name": "Mandhre Dattatray Khanderao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10092",
    "name": "Lokhande Babasaheb Jaysingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12357",
    "name": "Chavan Vijay Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1699",
    "name": "Bhandari Sitaram Sukur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13851",
    "name": "Bhatawadekar Shekhar Bhalchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13852",
    "name": "Sorap Prakash Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13759",
    "name": "Ingawale Bhushan Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18809",
    "name": "Pandey Gangaram Doodhnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20446",
    "name": "Bhosale Dhanaji Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12195",
    "name": "Nimbalkar Sudhakar Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12180",
    "name": "Chavan Pramila Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13709",
    "name": "Sable Sanjay Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11698",
    "name": "Kondvilkar Manisha Sandesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8631",
    "name": "Pawar Udhao Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21692",
    "name": "Gaikwad Bharati Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1521",
    "name": "Jadhav Mohan Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17410",
    "name": "Sapkale Dinkar Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13055",
    "name": "Shinde Chandrakant Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19128",
    "name": "Jain Gajendra Maniklal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10231",
    "name": "Yadav Hanuman Ramkhilawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15449",
    "name": "Deshmukh Vikas Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9689",
    "name": "Chavan Dattatry Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20430",
    "name": "Mallah Achelal Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20357",
    "name": "Nilakh Raju Piraji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19947",
    "name": "Mistri Ashok Amruatlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19966",
    "name": "Sherkhan Faruque Gafur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14586",
    "name": "Harijan Hiralal Sahati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14978",
    "name": "Dhormale Mahadeo Yadav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21474",
    "name": "Pawar Chandrakant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10155",
    "name": "Singh Ramjit Rajbahadur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18153",
    "name": "Jain  Leelaben  Chandanmalji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16358",
    "name": "Jadhav Manohar Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16320",
    "name": "Pawar Deepak Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9773",
    "name": "Parab Vishwanath Harishchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1569",
    "name": "Sankpal Prakash Dattatray"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1145",
    "name": "Shinde Kisan Jayshing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12493",
    "name": "Shinde Sarjerao Ananda"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12194",
    "name": "Nimbalkar Kamal Hanmatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20472",
    "name": "Shaikh Zainuddin Shamsuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "486",
    "name": "Ramchandra Narayan Bandal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18304",
    "name": "Kale Shailendra Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21654",
    "name": "Gaikawad Sunil Dnynadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12286",
    "name": "Dhumal Santosh Babanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2879",
    "name": "Jaiswal Chandaprasad Khudbhud"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13788",
    "name": "Ingavale Kallyan Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19195",
    "name": "Nayadu Mallika Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16226",
    "name": "Koli Neeru Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1106",
    "name": "Vaidya Rajaram S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8675",
    "name": "Tupe Bajrang Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16307",
    "name": "Jadhav Abhijeet Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21674",
    "name": "Kalantre Sanjay Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5224",
    "name": "Agrawal Rajiv Kishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8039",
    "name": "Hate Sudhakar Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21721",
    "name": "Shinde Vikas Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23367",
    "name": "Kadam Sanjay Shankarrao"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1475",
    "name": "Tupe Sangita Anil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "705",
    "name": "Satam Raghunath Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14327",
    "name": "Naik Hanuman Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24177",
    "name": "Sawant Pramod Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1932",
    "name": "Mandhare Shivaji Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10199",
    "name": "Navale Suryakant Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2307",
    "name": "Pandit Vasudeo Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19386",
    "name": "Sattar Mohd Afsar Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20109",
    "name": "Joshi Babudevi Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9332",
    "name": "Kshirsagar Shashikala Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12305",
    "name": "Bhalshankar Vijaykumar M"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19961",
    "name": "Darade Pandharinath Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19960",
    "name": "Ghuge Ravindra Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16387",
    "name": "Patil Govind Bayappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2098",
    "name": "Kadam Anant Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20533",
    "name": "Padwal Arvind Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20825",
    "name": "Gaikwad Ashwin Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18764",
    "name": "Yadav Uday Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2987",
    "name": "Pardule Suresh Kushaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12158",
    "name": "Mandhare Vijaya Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5908",
    "name": "Bhosale Dattatray Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8626",
    "name": "More Mangal Shebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18752",
    "name": "Suryavanshi Sachin Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14997",
    "name": "Ahirekar Vandana Satisha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4714",
    "name": "Miss  Shinde Saroj Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1723",
    "name": "Katurde Ramesh Ramji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11537",
    "name": "Naik Ashish Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19211",
    "name": "Ambhure Subhash Kishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19101",
    "name": "Devare Ishwar Avchit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19072",
    "name": "Gupta Gayatridevi Ramsahaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19071",
    "name": "Jaiswal Vedprakash Deviprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19077",
    "name": "Joshi Anand Jogindar Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19155",
    "name": "Phutane Kalpana Parsuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19202",
    "name": "Poojari Damodar Lokoya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19113",
    "name": "Shinde Ashok Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12692",
    "name": "Desai Ramdas Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17919",
    "name": "More Suresh Gopal & Mrs Chanda Suresh Mo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14715",
    "name": "Nikam Santosh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10244",
    "name": "Salunkhe Prakash M/Kishore"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11587",
    "name": "Mahangade Ajit Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13270",
    "name": "Pawar Vijay Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19818",
    "name": "Sisodia Premlata Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5549",
    "name": "Kanoja Papuchandika Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "569",
    "name": "Anita Shankrao Shinde"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9549",
    "name": "Jain Mahendrakumar D"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12291",
    "name": "Bobade Shashikala Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20502",
    "name": "Bijwe Alka Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21635",
    "name": "Chavan Prasant Khanderao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23185",
    "name": "Singh Sanjaykumar Birbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1973",
    "name": "Prajapati Ramajee Chabiraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18775",
    "name": "Shah Bela P"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5542",
    "name": "Hule Manda Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14714",
    "name": "Lad Jaidas Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17974",
    "name": "William Silvester Mascernhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19118",
    "name": "Kaushok Sarla Rani Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20197",
    "name": "Khan Samsherali Gulabali"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2905",
    "name": "Shinde Sangram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19087",
    "name": "Dandage Rajesh Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20380",
    "name": "Lad Tirthaj Kiran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12038",
    "name": "Rahate Sulabha Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15550",
    "name": "Shaikh Tajuddin Jiyauddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14009",
    "name": "Jagatap Satish Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3652",
    "name": "Patel Makasud Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12205",
    "name": "Bhoite Vijay Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18053",
    "name": "Desai Rajendra Bajrang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "896",
    "name": "Chavan Avinash Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21872",
    "name": "Gaikwad Asmita Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18196",
    "name": "Desai Anil Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18225",
    "name": "Shringarpure Shailesh Sudhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18052",
    "name": "Mistry Satish Harkishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1468",
    "name": "Prabhakaran Krishnan A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12497",
    "name": "Chavan Dattatray Dnyanoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17972",
    "name": "Shinde Yashvant Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15702",
    "name": "Chavan Narendra Shubhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19121",
    "name": "Talwadekar Prabhakar Ganpatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20716",
    "name": "Mulik Bharat Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12464",
    "name": "Shinde Kiran Babanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22989",
    "name": "Gavit Dada Chintaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13671",
    "name": "Chavan Narayan Bhiku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3576",
    "name": "Dherange Bajrang Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3698",
    "name": "Keny Yeshawant B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15446",
    "name": "Ghorpade Sunil Mansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14417",
    "name": "Chavan Geetanjali Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10467",
    "name": "Chaturvedi Sukhraj Udaybhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13652",
    "name": "Pawar Pandurang Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19123",
    "name": "Dangat Ashok Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23810",
    "name": "Jadhav Ramchandra Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25048",
    "name": "Dukhande Suryakant Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25047",
    "name": "Sawant Mukesh Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14703",
    "name": "Jorvekar Nanasaheb Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14570",
    "name": "Gaikwed Vikas Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "908",
    "name": "Pawar Murlidhar Bhagawan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5355",
    "name": "Naik Mallappa Kallappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13402",
    "name": "Bhosale Asha Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18148",
    "name": "Hande Vasant Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18120",
    "name": "Thim Jhubeda Usman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18073",
    "name": "Sayyad Subhan Bashir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14729",
    "name": "Pawar Prakash Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3841",
    "name": "Elbhadre Ramkrishna Pralhadrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14066",
    "name": "Naringrekar Santosh Vishwambhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5552",
    "name": "Patil Mohan Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16309",
    "name": "Karanjkar Pramod Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18224",
    "name": "Sakpal Vishnu Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4240",
    "name": "Kadam Mangal Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12226",
    "name": "Pawar Gokula Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1452",
    "name": "Patel Jayantibhai Babubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13185",
    "name": "More Atmaram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15329",
    "name": "Gaikwad Suresh Keru"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12351",
    "name": "Vasistha Sunita Anilkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "99",
    "name": "Lokhande Ratnaprabha Jayshing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6518",
    "name": "Mate Bharat Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5469",
    "name": "Agarwal Jyoti Rajiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4313",
    "name": "Nakhawa Shankar Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12574",
    "name": "Saroj Motilal Bachulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1430",
    "name": "Panaskar Suman Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22298",
    "name": "Joshi Pooja Niranjan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15773",
    "name": "Jagatap Sanjay Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3723",
    "name": "Shah Badresh Ramniklal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15456",
    "name": "Sanap Rajashri Popat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "445",
    "name": "Ranjana Mohan Jagadale"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2537",
    "name": "Shirke Chandrakant Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14568",
    "name": "Shinde Uttam Jagdeorao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6355",
    "name": "More Manohar Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2211",
    "name": "Somvanshi Tukaram Narsu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5681",
    "name": "Choudhari Radhesham Ramlakhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15637",
    "name": "Mhatre Ramchandra Balaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4853",
    "name": "Chavan Prakash Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12803",
    "name": "Solanki Kanaji Mala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16602",
    "name": "Saroj Shyamnarayan Sureshballi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3657",
    "name": "Hasan Haji Suleman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9414",
    "name": "Namdar Mehboob Anwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2677",
    "name": "Kharwa Bhavesh Harish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13192",
    "name": "Agrawal Rajiv Kishan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15636",
    "name": "Mhatre Sujit Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8813",
    "name": "Bhangare Ramesh Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9968",
    "name": "Chokashi Vasantkumar Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2884",
    "name": "Sutar Maruti Bhimrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18713",
    "name": "Barge Ramesh Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8337",
    "name": "Lobo Michael Mouzu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13406",
    "name": "Kamate Vitthal Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15560",
    "name": "Chavan Ravindra Vttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8204",
    "name": "Pawar Dnyaneswar Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12256",
    "name": "Pisal Deshraj Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16099",
    "name": "Mehta Dalpatraj Dhulchand Huf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3950",
    "name": "Shah Bharatkumar Chhotalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19142",
    "name": "Mandhare Ankush Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19878",
    "name": "Harijan Birelal Lalya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9873",
    "name": "Rai Banor Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18991",
    "name": "Miss  Nimbalkar Anita Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12132",
    "name": "Salunkhe Kisan Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17914",
    "name": "Mehta Ratan Dalpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1343",
    "name": "Shinde Kalpana Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21813",
    "name": "Virulkar Sushma Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15565",
    "name": "Mandhare Shivaji Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14781",
    "name": "Mishra Gangaprasad Rambachan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5608",
    "name": "Thakur Buddhakrishna Sudhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12830",
    "name": "Shetty Balkrishna Sanjiva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14514",
    "name": "Maniyar Sayyad Kashim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15055",
    "name": "Shinde Laxman Mahipati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6648",
    "name": "Shukla Premshankar Rajnarayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9815",
    "name": "Khan Shagir Shabbir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3531",
    "name": "Jain Shantilal Bhikchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13560",
    "name": "Miss  Kondvilkar Harshla Sandesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20167",
    "name": "Siddhiki Moharmalli Mahmadjalil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7830",
    "name": "Gharat Atmaram Haidar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3187",
    "name": "Sankhe Vilas Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18072",
    "name": "Adidravidar Leena Manikam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23818",
    "name": "Patil Baburao Santu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9785",
    "name": "Natekar Jagannath Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1117",
    "name": "Rahate Dattaram Ronga"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3342",
    "name": "More Sandeep Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7108",
    "name": "Choudhari Shridhar Jaiywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12607",
    "name": "Patil Rajendra Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6687",
    "name": "Choughule Keshrinath Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14056",
    "name": "Salunkhe Mahesh Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1291",
    "name": "Thakar Vilas Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7934",
    "name": "Kaskar Motashingh Rafik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7740",
    "name": "Barsing Suresh Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15622",
    "name": "Shaikh Ijaj Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7149",
    "name": "Gupta Lulai Sukhdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13696",
    "name": "Jain Vimalchand Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8834",
    "name": "Patil Namdeo Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7045",
    "name": "Bulunge Pradeep Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7845",
    "name": "Mahangade Shraddha Ajit"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2910",
    "name": "Gardi Yogesh Mininath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3846",
    "name": "Adhikari Ashok Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3916",
    "name": "Shelar Shivaji Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18176",
    "name": "Rajpurkar Deepak Dwarkanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17506",
    "name": "Patil Marutrao Appaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17484",
    "name": "Kadam Rajendra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12546",
    "name": "Jagtap Sambhaji Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15168",
    "name": "Pawar Shankar Daulat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "910",
    "name": "Tiwari Mayashankar Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8899",
    "name": "Mishra Shankar Jaganath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9771",
    "name": "Bhandwalkar Bhagwan Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "255",
    "name": "Vichare Pramila Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16552",
    "name": "Salunkhe Shamrao Mukund"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12442",
    "name": "Kagda Rammehar Jogiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21565",
    "name": "Maniyar Sadab Sayyed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12986",
    "name": "Pawar Shattappa Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9472",
    "name": "Keni Laxman Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10724",
    "name": "Wanjale Madukar Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6209",
    "name": "Naik Arun Jagdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7940",
    "name": "Kambale Anil Dayaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "909",
    "name": "Salunke Vimal Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18146",
    "name": "Vyas Rashmikant Dineshchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7216",
    "name": "Dunekar Dinesh Premji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9442",
    "name": "Pawade Vilas Dattu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8835",
    "name": "Acharya Krishna Raja"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11863",
    "name": "Gangurde Nita Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9420",
    "name": "Raut Hemant Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4290",
    "name": "Gupta Ashok Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20266",
    "name": "Singh Shailesh Durgaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8437",
    "name": "Kureshi Atik Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3154",
    "name": "Shaikh Yasin Mehmud"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21771",
    "name": "Mandhare Laxman Genba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13556",
    "name": "Chougale Sunita Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5356",
    "name": "Patil Shirish Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8702",
    "name": "Patankar Ramdas Murlidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21888",
    "name": "Dhumal Sunil Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4289",
    "name": "Jamindar Jamil Ahmed Dost Mohmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13876",
    "name": "Desai Sureshbhai Vanmalidas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16224",
    "name": "Koli Shashikant Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7226",
    "name": "Shaikh Manjur Abdul Rehman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4122",
    "name": "Jain Bharatkumar Tejpal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3503",
    "name": "Bhoite Shivaji Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10023",
    "name": "Shaikh Hanif Suleman"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1680",
    "name": "Vinchurkar Praveen Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7739",
    "name": "Hundare Sunil Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5656",
    "name": "Bubere Ghazal Ridwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3751",
    "name": "Bagul Mangesh Parshuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12400",
    "name": "Mishra Jamunaprasad Rambachan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19898",
    "name": "Padavi Deepak Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9436",
    "name": "Sankhe Subhash Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4725",
    "name": "Patil Vasant Haidar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13606",
    "name": "Desai Jignesh Sureshchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5633",
    "name": "Masana Ramchandra Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18181",
    "name": "Salunkhe Vaijant Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3499",
    "name": "Sankhe Anil Gangadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14499",
    "name": "Patil Viswanath Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4300",
    "name": "Dhavate Maksud Yusuf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9326",
    "name": "Rameshsingh Singh Shambhosingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16466",
    "name": "Coutinho Elroy Sabistin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5334",
    "name": "Patel Danish Harnoon"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6495",
    "name": "Giri Chandravati Ramashankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22717",
    "name": "Singh Pillai Seema Santosh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3643",
    "name": "Bubere Musdik Abdulkadir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10114",
    "name": "Patil Balaram Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3202",
    "name": "Singh Mistrilal Dalsingar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4419",
    "name": "Patel Ashim Mustak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13540",
    "name": "Bhabe Khalil Gulamnabi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6379",
    "name": "Mhatre Waman Kalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7217",
    "name": "Khan Mansub Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12162",
    "name": "Chavan Mugat Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6544",
    "name": "Kadu Vitthal Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3747",
    "name": "Patil Subhash Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2275",
    "name": "Nigade Uttam Vithalrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9082",
    "name": "Shaikh Javed Azam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21772",
    "name": "Mandhare Kiran Bhogwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6207",
    "name": "Sonawane Nandkumar Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9655",
    "name": "Shukla Rajanlal Shivdarshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8707",
    "name": "Patil Jugesh Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8708",
    "name": "Patil Vishwas Giridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10472",
    "name": "Kale Angad Pundalikrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9876",
    "name": "Prabhudesai Sandesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9065",
    "name": "Patil Vasant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7690",
    "name": "Thakur Gajanan Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6522",
    "name": "Sankhe Anil Gangadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10593",
    "name": "Shelar Sudhakar Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10805",
    "name": "Narvekar Ajit Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10115",
    "name": "Patil Tukaram Sukrya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4511",
    "name": "Pavse Sitaram Kamalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12440",
    "name": "Mulik Pradeepkumar Shivajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4953",
    "name": "Raul Jagdish Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10910",
    "name": "Patil Arun Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10796",
    "name": "Bhoir Sunil Hariram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12157",
    "name": "Mandhare Suman Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8697",
    "name": "Bhoir Hemant Mukund"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14765",
    "name": "Pathole Kishore Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10880",
    "name": "Purav Prabhakar Gopinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6497",
    "name": "Divakar Prasanna Divakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4510",
    "name": "Chorge Nandu Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10882",
    "name": "Naik Deepak Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3388",
    "name": "Shah Nikunjkumar Poonamchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5657",
    "name": "Tandel Meghnath Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11986",
    "name": "Wagh Pavitra Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18907",
    "name": "D Souza Veleriyan Silvester"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12550",
    "name": "Dave Deepak Dhirajlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8694",
    "name": "Kerawalla Percy Phiroze"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13541",
    "name": "Tiwari Ramshankar Kaluram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14797",
    "name": "Maskar Ramesh Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23132",
    "name": "Singh Sarvajeet Ramtapsya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16374",
    "name": "Hatkar Prakash Madanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3170",
    "name": "Pandey Thakur Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6229",
    "name": "Patil Balkhrushna Shirkhrushna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10097",
    "name": "Pawadee Vinod Purshottam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3327",
    "name": "Patil Tukaram Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11194",
    "name": "Patil Anil Sakharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5298",
    "name": "Sawant Shrirang Vaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3473",
    "name": "Lokhande Jagannath Chandrashekhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20911",
    "name": "Patil Ganesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21733",
    "name": "Fadtare Sopan Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3436",
    "name": "Rais Jabeen Shahanawaz"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3331",
    "name": "Kharase Pradip Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9424",
    "name": "Bhandwalkar Laxmi Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "18605",
    "name": "Dave Asha Jayesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16559",
    "name": "Goyal Udai Premkrishan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1468",
    "name": "Bhaskar Rahul Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23311",
    "name": "Deshmukh Anil Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12674",
    "name": "Jaiswal Nagendrakumar Chandragupta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12295",
    "name": "Momin Jabina Liyakit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14451",
    "name": "Sutar Kachabaram Nabharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10474",
    "name": "Suryavanshi Gopalrao Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15052",
    "name": "Gopal Mahendra Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5548",
    "name": "Bubere Rizwan Anwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9187",
    "name": "Yadav Narendra Prakash"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "4398",
    "name": "Newase Pandurang Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18180",
    "name": "Kamdar Pinakin Virendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14298",
    "name": "Yadav Tukaram Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24170",
    "name": "Tandel Mahesh Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8242",
    "name": "Yadav Kusum Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2140",
    "name": "Shetty Sadashiv J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2135",
    "name": "Chavan Pralhad Nivruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22349",
    "name": "Kakad Minakshi Bharat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17529",
    "name": "Bhor Dhanashri Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5236",
    "name": "Shetty Umavati Chandrashekhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9931",
    "name": "Fernandes Philip Alex"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6230",
    "name": "Taware Archana Gurunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12603",
    "name": "Miss  Shah Amish Bhagwandas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8831",
    "name": "Sakunde Abhay Tanajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22640",
    "name": "Muthu Jayesh Ashokan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2141",
    "name": "Dubey Murali Satyanarayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1286",
    "name": "Nerlekar Shankar Tatoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17521",
    "name": "Lembhe Laxman Suryakant  58-B-16"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3131",
    "name": "Ghorpade Sambhajirao Bapusaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19282",
    "name": "Katekar Sanjay Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3702",
    "name": "More Ramchandra Keshav(Bala)"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "506",
    "name": "Shah Snehal Paras"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17113",
    "name": "Suyawashi Ankush Eakhanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13732",
    "name": "Nawadkar Bhanudas Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16463",
    "name": "Solaskar Ujwala Dattatrey"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18187",
    "name": "Joshi Anil Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21915",
    "name": "Jadhav Deepak Piraji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23774",
    "name": "Karpe Vinod Nivruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2227",
    "name": "Dhumal Mansing Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5823",
    "name": "Sadashiv Kashiram Ghadage"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6683",
    "name": "Sawant Shivaji Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7239",
    "name": "Shinde Dilip Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11841",
    "name": "Kadam Pradip Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12450",
    "name": "Sabale Santosh Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12926",
    "name": "Manohar  Shankar Sawant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15566",
    "name": "Khilare Sanjay Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16065",
    "name": "Gaikwad Suryakant Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17185",
    "name": "Dude  Suresh  Krishnarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15107",
    "name": "Jadhav Ramchandra Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15555",
    "name": "Khopade Ramchandra Nagoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15677",
    "name": "Chavan Arun Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19201",
    "name": "Mourya Ramashray Baburam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23780",
    "name": "Takle Sanjay Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23877",
    "name": "Shrestha Renu Sanjaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24028",
    "name": "Bobade Jatin Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25216",
    "name": "Mishra Sinduladevi Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25262",
    "name": "Suru Kamlesh Himatlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3618",
    "name": "Barge Sadashiv Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9666",
    "name": "Bhoite Mohan Laxmanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10254",
    "name": "Zombarde Balu Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12598",
    "name": "Shinde Ashok Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12607",
    "name": "Shinde Kondiba Ravaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14033",
    "name": "Dudhe Daulat Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14040",
    "name": "Shelke Rajendra Shatrughna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14940",
    "name": "Randhare Somnath Revan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "750",
    "name": "Pokharkar Rahul Jijabhau"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1095",
    "name": "Borade Janabai Sudam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "743",
    "name": "Patil Sachin Dada"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "799",
    "name": "Salunkhe Sachin Mohan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "967",
    "name": "Mali Maheshkumar Sabhajeet"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "975",
    "name": "Kale Ajay Balasaheb"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1308",
    "name": "Singh Yogendraprasad Chandrabali"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2283",
    "name": "Nirmnale Ishwar Rajendra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2574",
    "name": "Vani Vilas Vishwanath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2876",
    "name": "Naik Sunil Bhiva"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1997",
    "name": "Singh Jayprakash Nageshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13913",
    "name": "Ghadage Deepak Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7119",
    "name": "Jadhav Sanjay Yadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19849",
    "name": "Pawar Monali Murlidhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10754",
    "name": "Pisal Shivaji Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15526",
    "name": "Pisal Pravin Baban  Tn"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4972",
    "name": "Shinde Hanmant Mugutrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9717",
    "name": "Desai Laxman Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5460",
    "name": "Pawar Mansing Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17645",
    "name": "Miss  Khair Arti Narendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18394",
    "name": "Shejwal Santosh Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17984",
    "name": "More Sanket Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17046",
    "name": "Said Harichandra Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2250",
    "name": "Maru Paras Hasmukh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "889",
    "name": "Takale Gajanan Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20264",
    "name": "Patel Kantibhai Ambubhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20538",
    "name": "Pathak Shivpujan Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20861",
    "name": "Thorat Nilesh Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15849",
    "name": "Mojar Bapurao Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16682",
    "name": "Bhosale Hanumant Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17488",
    "name": "Chavan Arjun Dattatrya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18981",
    "name": "Kule Laxman Dasharath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19063",
    "name": "Kale Ekanath Umaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16755",
    "name": "Shinde Jagannat Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18228",
    "name": "Jadhav Krishnath Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2093",
    "name": "Shetty Dinesh Rama"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20875",
    "name": "Avere Nitin Damodar &"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16270",
    "name": "Yadav Rameshkumar Harilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4583",
    "name": "Powale Shashikant Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1139",
    "name": "Chavan Mohan Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6423",
    "name": "Pawar Pandurang Vyankatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7057",
    "name": "Shinde Suresh Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8835",
    "name": "Mandhare Hanmant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12959",
    "name": "Pisal Dashrath Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16836",
    "name": "Nimbalkar Pravin Babanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22114",
    "name": "Giri Vijay Hanumant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25481",
    "name": "Bohara Chetman Bhavanisingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11501",
    "name": "Shinde Kasyap Suraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16189",
    "name": "Bhosale Sunil Shyamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11266",
    "name": "Sabale Chandrakant Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16042",
    "name": "Chawan Anusaya Marutirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16728",
    "name": "Pawar Dattatray Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7333",
    "name": "Bhoite Ankush Jaywantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14036",
    "name": "Lohar Sangram Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1014",
    "name": "Jagtap Vasant Mugutrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8576",
    "name": "Madane Dnyaneshwar Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8810",
    "name": "Chikane Jotiram Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8896",
    "name": "Ghorpade Vishnu Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12739",
    "name": "Jadhav Hanmant Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9780",
    "name": "Khopade Sopan Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7763",
    "name": "Karne Chandrakant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10898",
    "name": "Jadhav Subhash Yashwant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "670",
    "name": "Tiwari Dinesh Shivgovind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5172",
    "name": "Patne Rupali Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17712",
    "name": "Yadav Rajpat Matabadal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8339",
    "name": "Yadav Rajitram Ramlakhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8572",
    "name": "Ghorpade Sanjay Shivajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9702",
    "name": "Kadam Dhanshing Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10632",
    "name": "Jagdale Raghunath Mahadeo"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1165",
    "name": "Yadav Vikas Mansingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15162",
    "name": "Dhumal Vilas Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4699",
    "name": "Yadav Vilas Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7903",
    "name": "Chibade Maruti Santu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8243",
    "name": "Desai Ashok Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8307",
    "name": "Thorat Jalandar Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8334",
    "name": "Yadav Hubdaar Ramlakhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8567",
    "name": "Luniya Chiniprasad N"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8729",
    "name": "Sawant Maruti Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8987",
    "name": "Mulla Badasha Babalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9037",
    "name": "Mane Ashok Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9205",
    "name": "Mohite Bajirao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9232",
    "name": "Doiphode Bhairu Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9295",
    "name": "Sawant Dharmendra Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9749",
    "name": "Pisal Vinayak Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10175",
    "name": "Zanzane Suresh Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10366",
    "name": "Jadhav Sakharam Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10378",
    "name": "Pise Vilas Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10469",
    "name": "Disale Sakharam Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11324",
    "name": "Jadhav Sarjerao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11361",
    "name": "Bhagwat Vilas Savlaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11936",
    "name": "Dhumal Suresh Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12332",
    "name": "Gundage Eknath Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12716",
    "name": "Ithape Hanmantrao Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13336",
    "name": "Shedage Suresh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13959",
    "name": "Ghodake Birappa Huleppa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14224",
    "name": "Pathan Hussain Yakub"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14227",
    "name": "Yadav Chandrashekhar Chabilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14785",
    "name": "Alugade Amar Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15916",
    "name": "Bhoite Ashok Dattatraya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6528",
    "name": "Vare Ramchandra Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14409",
    "name": "Virkar Balu Dada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14535",
    "name": "Sonawane Namdeo Pralhad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1878",
    "name": "Sabale Anandrao Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4086",
    "name": "Dubal Kisan Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4129",
    "name": "Pol Sampat Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5418",
    "name": "Bobade Hanmant Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5538",
    "name": "Shinde Ganpati Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6915",
    "name": "Wagh Baburao Shitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7701",
    "name": "Pathan Lalkhan Najirkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8032",
    "name": "Bhagwat Arjun Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8148",
    "name": "Kharade Damodar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8253",
    "name": "Yewale Vitthal Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8587",
    "name": "Shinde Bapurao Subhedar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8740",
    "name": "Bhoite Arjun Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9284",
    "name": "Thorat Ananda Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9879",
    "name": "Chawan Rajendra Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10826",
    "name": "Mane Laxman Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10877",
    "name": "Dudhade Bajirao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11125",
    "name": "Jagtap Kisan Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11189",
    "name": "Nalawade Sunil Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11266",
    "name": "Patil Bandu Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11377",
    "name": "Avtade Balu Panda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11414",
    "name": "Dhembare Kailas Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11424",
    "name": "Bhagwat Gajanan G"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11625",
    "name": "Gholap Kashinath Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11720",
    "name": "Waychal Natha Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11905",
    "name": "More Eknath Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11923",
    "name": "Mishra Harivilas Shivpujan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12169",
    "name": "More Babaso Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12308",
    "name": "Shinde Dnyaneshwar Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12376",
    "name": "Sawant Rajendra Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12444",
    "name": "Phalke Bharat Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12491",
    "name": "Gaikwad Shivaji Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12506",
    "name": "Khot Dagadu Taku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12635",
    "name": "Sawant Shrirang Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12680",
    "name": "Dighe Maruti Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12703",
    "name": "Bagal Tanaji Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12711",
    "name": "Patil Prakash Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12797",
    "name": "Sawant Ananda Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13045",
    "name": "Kakade Mohan Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13190",
    "name": "Bhoite Balkrishna M  1046/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13310",
    "name": "Gharal Yashwant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13331",
    "name": "Shinde Ramchandra Anand 931/9"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13643",
    "name": "Chorage Kashinath Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13712",
    "name": "Kemashe Jaywant Sadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13770",
    "name": "Tiwari Rampratap Mahesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13932",
    "name": "Kachare Babu Viru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14025",
    "name": "Bobade Santosh P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14417",
    "name": "Pawar Prakash Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14469",
    "name": "Sakunde Dattatray Suryakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14495",
    "name": "Shinde Balkrishna Devram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14791",
    "name": "Kolase Baburao Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14972",
    "name": "More Subhash Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15032",
    "name": "Bhosale Sulochana Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15897",
    "name": "Khopade Dagdu Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17448",
    "name": "Lohar Ashok Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10356",
    "name": "Shelar Balkrishna Baburav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15591",
    "name": "Sonawale Kalidas Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17554",
    "name": "Gaikwad Arun Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9399",
    "name": "Barge Kalpana Shahaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17985",
    "name": "Dhumal Pradeep Bapuso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5885",
    "name": "Jagtap Chatrapati Bajiraon"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10553",
    "name": "Nanavare Anil Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12935",
    "name": "Bandal Chandrakant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14721",
    "name": "Jaiswal Ashokprasad Santram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14761",
    "name": "Adsul Vaibhav Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14661",
    "name": "Gavandi Jayprakash Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7316",
    "name": "Pawar Hindurao Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20297",
    "name": "Joshi Ratanlal Giridharilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "314",
    "name": "Mane Shrirang Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5805",
    "name": "Babar Babaso Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6476",
    "name": "Salunkhe Sarjerao Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7218",
    "name": "Kadam Balasaheb Namdevrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8965",
    "name": "Ghorpade Shivajirao Subhedar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9328",
    "name": "Ithape Vilas Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10254",
    "name": "Khot Ananda Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10679",
    "name": "Sawant Baburao Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11427",
    "name": "Pangare Shrimant Tulshiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11532",
    "name": "Bodake Dinkar Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12143",
    "name": "Rajpure Yeshwant Shnakar 235/3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12163",
    "name": "Varekar Ashok Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12896",
    "name": "Matkar Hanmant Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12946",
    "name": "Kolpe Ramdas Biru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13146",
    "name": "Jadhav Santosh Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13740",
    "name": "Harijan Dayaram Zagdiprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14173",
    "name": "Bhosale Dnyaneshwar Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14607",
    "name": "Gadave Chandrakant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15007",
    "name": "Sawant Sandeep Gulab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15631",
    "name": "Sabale Bajrang Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15658",
    "name": "Mali Santosh Jairam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16064",
    "name": "Gaikar Keshav Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16691",
    "name": "Ghadge Sandeep Duryodhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16870",
    "name": "Sonawane Sachin Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16906",
    "name": "Kadam Dilip Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1385",
    "name": "Chavan Kisanrao Shripatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7193",
    "name": "Dabhade Baburao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8248",
    "name": "Mojar Suresh Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8399",
    "name": "Mane Vishnu Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8436",
    "name": "Mohite Hindurao Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8947",
    "name": "More Shivaji Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9178",
    "name": "Dubal Prakash Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9260",
    "name": "Waghmale Sadashiv Madhu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9279",
    "name": "Shinde Waman Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9765",
    "name": "Pawar Vishnu Dattatraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10407",
    "name": "Bhilare Maruti Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10575",
    "name": "Vakate Dnyandev Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11045",
    "name": "Yadav Ramu Mallu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12546",
    "name": "Mane Dilip Govinda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13106",
    "name": "Kadam Prakash Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17225",
    "name": "Kale Ashok Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17227",
    "name": "Kumbhar Kiran Vishnu Tn-1528-7"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17796",
    "name": "Khamkar Bhausaheb Keru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9916",
    "name": "Bhagwat Narsing Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11945",
    "name": "Bhosale Laxman Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12686",
    "name": "Barge Bhanudas Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13204",
    "name": "Parte Sopan Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15525",
    "name": "Jadhav Anil Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16940",
    "name": "Sahani Rajendra Prasad Rambachan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17218",
    "name": "Pawar Shripati Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17239",
    "name": "Ghode Santosh Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9039",
    "name": "Roy Sameer Harinarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "78",
    "name": "Chawan Rajaram Bayaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7053",
    "name": "Bhosale Suresh Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9062",
    "name": "Parte Sarjerao Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12774",
    "name": "Devkar Gangaram Shidu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13083",
    "name": "Nawadkar Balasaheb Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13322",
    "name": "Pawar Dattatray Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14163",
    "name": "Pisal Vasant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15940",
    "name": "More Dadaso Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16826",
    "name": "Sabale Mahendra Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17848",
    "name": "Ladkat Pravin Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17919",
    "name": "Suryawanshi Tushar Anandrao Toli 99-36"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3291",
    "name": "Salunkhe Arjun Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5167",
    "name": "More Bhanudas Harichandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5342",
    "name": "Mohite Vishnu Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9274",
    "name": "Jagtap Chatrapati Bajiraon"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12661",
    "name": "Pawar Shankar Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12775",
    "name": "Kasture Jayram Govinda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13472",
    "name": "Jagatap Bhiku P   1209/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13778",
    "name": "Yadav Mugatrao Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15280",
    "name": "Jadhav Ashok Jayram96/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18190",
    "name": "Kirdat Shankar Ganapat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2305",
    "name": "Mahamulkar Shivaji Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5432",
    "name": "Nikam Gorakh Shahu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7791",
    "name": "Shinde Dinkar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9243",
    "name": "Nikam Chandrakant Bapusaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13117",
    "name": "Chikane Balaso Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13289",
    "name": "Baswankar Yashwant Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7599",
    "name": "Jagtap Dattatray Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9245",
    "name": "Jadhav Sakharam Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8343",
    "name": "Chavan Pralhad Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10670",
    "name": "Chavan Duryodhan Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17452",
    "name": "Bamne Ram Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8579",
    "name": "Wagh Shashikant Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "511",
    "name": "Dixit Ramkrushna Tulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "395",
    "name": "Sutar Subhash Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3175",
    "name": "Pujari Uttam Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12689",
    "name": "Kate Sarjerao Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18638",
    "name": "Bhosale Sharad Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4248",
    "name": "Patil Vijaykumar Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3857",
    "name": "Kadam Bapu Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8931",
    "name": "Ghorpade Dilip Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11881",
    "name": "Tambe Ramchandra Sawala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8369",
    "name": "Mane Aaba Balaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8884",
    "name": "Mane Anandrao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9644",
    "name": "Tikudavae Kundalik Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9646",
    "name": "Zanzugade Kisan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16866",
    "name": "Sarafdar Raoji Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20635",
    "name": "Gadhave Rupali Sachin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9525",
    "name": "Jadhav Kiran Datta"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6235",
    "name": "Kadav Bhagwan Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7371",
    "name": "Salunkhe Mansing Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7492",
    "name": "Salunkhe Balkrushna Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18026",
    "name": "Shinde Prathamesh Jitendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21962",
    "name": "Nalawade Pravin Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17632",
    "name": "Jagtap Santosh Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23477",
    "name": "Sabale Tushar Anil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "477",
    "name": "Shinde Narayan Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23032",
    "name": "Bansode Suresh Niwrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13003",
    "name": "Bandekar Vaishali Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "592",
    "name": "Jadhav Ganpat Baba"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "406",
    "name": "Yewale Sagar Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5852",
    "name": "Chavan Dattaram D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6123",
    "name": "Bobade Hanmant Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7296",
    "name": "Mahangade Raghunath Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8113",
    "name": "Sakpal Vinayak Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8597",
    "name": "Bhosale Sanjay Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14345",
    "name": "Saket Mahadlal Chotelal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1919",
    "name": "Shelar Khashaba Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3132",
    "name": "Shewale Vithal Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5268",
    "name": "Mane Jakinder Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5615",
    "name": "Bhosale Shashikant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7209",
    "name": "Gaikwad Ramesh Vaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8355",
    "name": "Taigade Ramchandra Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8626",
    "name": "Jadhav Jijaba Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8912",
    "name": "Kadam Balu Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9169",
    "name": "Mane Sampat Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9727",
    "name": "Chavan Ashok Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6036",
    "name": "Chavan Dinkar Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7182",
    "name": "Gaikwad Balkrushna Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8570",
    "name": "Ludhiya Parhali Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9689",
    "name": "Shinde Yuvaraj Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14015",
    "name": "Shidruk Jayram Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10876",
    "name": "Sakunde Rajendra Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12315",
    "name": "Nalge Ganpat Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6287",
    "name": "Pawar Raosaheb Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7863",
    "name": "Bhilare Damodar Pilaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17378",
    "name": "Karande Sunil Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8162",
    "name": "Nalawade Bhimrao Parasram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4450",
    "name": "Chavan Prakash Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7849",
    "name": "Jamdade Ganpat Parbati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6384",
    "name": "Dabhade Narendra Rangarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8864",
    "name": "Chawan Suresh Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10667",
    "name": "Shinde Mahadeo J"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "158",
    "name": "Sawardekar Sayli Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9656",
    "name": "Chawan Shahani Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18939",
    "name": "Thakur Geeta Indrasing"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1558",
    "name": "Jadhav Vilas Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15432",
    "name": "Chawan Kaushalya Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6349",
    "name": "Pawar Pandurang Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17522",
    "name": "Yadav Jeetnarayan Mevalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15143",
    "name": "Shaikh Abdulwahab Sidu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16178",
    "name": "Bhagwat Hindurao Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5937",
    "name": "Sabale Vijaykumar Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15795",
    "name": "Nalwade Rohidas Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15891",
    "name": "Chalke Shankar Dhyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16147",
    "name": "Wadi Basanna Budhanna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16783",
    "name": "Chavan Kisan Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2999",
    "name": "Pawar Sampat Malhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8146",
    "name": "Jadhav Uttam Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12065",
    "name": "Thorat Rajendra Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13976",
    "name": "Pandey Ramakbal Amarnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14088",
    "name": "Shinde Ajit Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14453",
    "name": "Varekar Sunil Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18589",
    "name": "Desai Nilkanth Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19094",
    "name": "Pathan Mustafa Mehibub"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5323",
    "name": "Jagdale Jaywant Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8060",
    "name": "Mahind Anandrao Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11823",
    "name": "Patil Laxman Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18195",
    "name": "Mhetre Raju Vchappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18329",
    "name": "Holkund Dilip Shivraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18726",
    "name": "Yadav Rajendra Chandrakant Toli No-242/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18763",
    "name": "Lawale Avinash Hanumant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19020",
    "name": "Khopade Shivprasad Vikas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16557",
    "name": "Wagh Shivaji Janardhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18990",
    "name": "More Hanmant Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4821",
    "name": "More Prakash Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19489",
    "name": "Valunj Gopinath Ravaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19490",
    "name": "Thange Gangadhar Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9656",
    "name": "Raut Dattatray Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6777",
    "name": "Solaskar Kashinath Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7968",
    "name": "Jadhav Baban Vyankatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14199",
    "name": "Kadam Tukaram Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14414",
    "name": "Shukla Indraraj Dhanurdhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17142",
    "name": "Gire Santhose Gorakhenath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17628",
    "name": "Kalantre Maruti Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18596",
    "name": "Matre Satish Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9090",
    "name": "Kakade Gopal Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15629",
    "name": "Nalawade Nitin Mugutrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15826",
    "name": "Kadam  Ramu  Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18829",
    "name": "Desai Akaram Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7939",
    "name": "Nikam Dinkar Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8627",
    "name": "Nalawade Tanaji Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8145",
    "name": "Sakunde Ramesh Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1630",
    "name": "Shinde Bhimrao Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9197",
    "name": "Jadhav Ulhas Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9198",
    "name": "Pisal Jagannath Sayaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9720",
    "name": "Adsul Gorakh Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15908",
    "name": "Sakunde Umesh Gopal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19692",
    "name": "Kutkelwar Anjayya Narsayya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17227",
    "name": "Ahirekar Shankar Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17356",
    "name": "Chavan Surekha Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17429",
    "name": "Kamble Shobha Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17474",
    "name": "Shaikh Siraj Ahemed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17475",
    "name": "Shaikh Nizamuddin Imamuddin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17523",
    "name": "Yadav Rajkumar Somnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7986",
    "name": "Kumbhar Balasaheb Ranu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8809",
    "name": "Karne Dinkar Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9158",
    "name": "Bhosale Hanumant Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8986",
    "name": "Aaglave Sahebrao Genu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17855",
    "name": "Sawant Yashoda Rama/Rama"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11496",
    "name": "Chikane Sampat Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12768",
    "name": "Sarvaiya Bharat Ramniklal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21072",
    "name": "Kadam Tukaram Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13902",
    "name": "Kadam Vinit Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14726",
    "name": "Borgaonkar Ashok Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17118",
    "name": "Pisal Mahadeo Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8575",
    "name": "Bhoite Dilip Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8562",
    "name": "Latnekar Ashok Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15996",
    "name": "Khanolkar Devidas V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3884",
    "name": "Babar Vyankat Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7480",
    "name": "Pawar Prakash Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9542",
    "name": "Kadam Sitaram Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21589",
    "name": "Pawar Prakash Wamanrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2838",
    "name": "Jadhav Narsing Vyankatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10203",
    "name": "Agnihotri Bhushan Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9259",
    "name": "Gogawale Kisan Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9306",
    "name": "Sapkal Suresh Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11282",
    "name": "Yadav Sadashiv Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21573",
    "name": "Mane Shashikant Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21582",
    "name": "Mane Snehal Shashikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16880",
    "name": "Bhoite Rajendra Vishwas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13790",
    "name": "Ghadage Sawala Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7067",
    "name": "Bhoite Ravindra Vyankatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3806",
    "name": "Jain Shakunlata H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13394",
    "name": "Jadhav Balkrishna Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19774",
    "name": "Patel Yusuf Dawood"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10870",
    "name": "Shinde Subhash Balasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13753",
    "name": "Trivedi Ashok Kantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17116",
    "name": "Bobade Shivaji Namdeorao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5146",
    "name": "Pisal Mahadeo Parbatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5935",
    "name": "Kakade Vitthal Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6972",
    "name": "Disale Suresh Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7838",
    "name": "Sakunde Eknath Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14385",
    "name": "Solaskar Kashinath Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "309",
    "name": "Yadav Waman Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8199",
    "name": "Karne Sopan Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20686",
    "name": "Sawant Jitendra Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11508",
    "name": "Jadhav Prabhakar Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14292",
    "name": "Taware Hanumantrao Narhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14324",
    "name": "Pawar Babanrao Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14325",
    "name": "Pawar Pushpa Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9748",
    "name": "Shinde Pralhad Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15217",
    "name": "More Dnyandeo Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4131",
    "name": "Salunkhe Ramesh Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5549",
    "name": "Pisal Ashok Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5941",
    "name": "Jamdade Kisan Parbati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6103",
    "name": "Kakade Rajendra Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7045",
    "name": "Kadam Shivaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7988",
    "name": "Jagtap Ashok Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19347",
    "name": "Pawar Vikas Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7117",
    "name": "Gaikwad Tanaji Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15938",
    "name": "Warang Baburao Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "914",
    "name": "Mandhare Jagdev Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6899",
    "name": "Pawar Ramchandra Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17381",
    "name": "Bhurke Amar Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7059",
    "name": "Shinde Ramrao Balkrushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9138",
    "name": "Kadav Akaram Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10757",
    "name": "Jadhav Duryodhan Sadashiv"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1967",
    "name": "Panzade Gajanan Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17044",
    "name": "Kajale Ramchandra Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "91",
    "name": "Bobade Dhansingh Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6409",
    "name": "Gaikwad Madhukar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7313",
    "name": "Borate Anandrao Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21422",
    "name": "Navale Shashikant Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22124",
    "name": "Salaskar Anil Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13562",
    "name": "Kadam Kailash Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24371",
    "name": "Patel Shankar Dhanaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11991",
    "name": "Sabale Subhash Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8595",
    "name": "Mulik Dattatray Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3153",
    "name": "Jadhav Ramchandra Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6847",
    "name": "Jadhav Pandurang Aapparao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20623",
    "name": "Suryavanshi Subhash Tulshiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9771",
    "name": "Suryawanshi Manik Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6107",
    "name": "Jadhav Vasant Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9576",
    "name": "Kenjale Dadaso Piloba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18171",
    "name": "Budhawale Sachin Kailash"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "693",
    "name": "Bhalerao Satish Sarjerao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "694",
    "name": "Jadhav Bhiku Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "716",
    "name": "Donde Nitin Krishna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "728",
    "name": "Dhumal Tushar Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7449",
    "name": "Karpe Pandurang Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8519",
    "name": "Kokare Bapurao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8602",
    "name": "Sawant Maruti Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8847",
    "name": "Potekar Parshuram Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22242",
    "name": "Rane Vasant Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13881",
    "name": "Nalawade Sanjay Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14085",
    "name": "Kasabe Ashok Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16794",
    "name": "Bhalekar Tanvi Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18586",
    "name": "Pawar Ashok Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19665",
    "name": "Sosa Dinesh Premji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20851",
    "name": "Jadhav Kiran Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21005",
    "name": "Molawade Dattatray Dattatray  Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21144",
    "name": "Jori Dinkar Dinkar  Ganapat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22145",
    "name": "Sankpal Balasaheb Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6676",
    "name": "Sakunde Tukaram Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9281",
    "name": "Gorivale Maruti Santu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9670",
    "name": "Ingale Raghunath Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20632",
    "name": "Kambale Sunil Sharnppa"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "691",
    "name": "Gadage Pradeep Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "692",
    "name": "Benke Vikas Vitthal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "637",
    "name": "Mane Ajit Lalaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3917",
    "name": "Babar Dharmaji Bajirao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1035",
    "name": "Deshmukh Nilesh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3010",
    "name": "Kadav Maruti Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10794",
    "name": "Shinde Dnyanu Chandru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22585",
    "name": "Bendre Prasad Sudhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14923",
    "name": "Shinde Anil Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18828",
    "name": "Kadam Sunil Pilaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18426",
    "name": "Shinde Ranjit Janardan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17974",
    "name": "Gaikwad Pravin Lahu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8985",
    "name": "Shinde Himmatrao Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16222",
    "name": "Mangrule Kavita Rajendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21579",
    "name": "Shinde Kavita Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17590",
    "name": "Mane Santosh Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21631",
    "name": "Kamble Gorakhnath Kisan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2314",
    "name": "Palkar Arun Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21511",
    "name": "Raut Rajesh Motiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23236",
    "name": "Mulik Dattatray Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7788",
    "name": "Bhosale Ramesh Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10654",
    "name": "Jadhav Samaidin S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17009",
    "name": "Ujgavkar Rajaram Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1760",
    "name": "Shinde Eknath Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8616",
    "name": "Gole Mohan Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21829",
    "name": "Bhujbal Vishal Shivkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23285",
    "name": "Dhere Deepak Tabaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23321",
    "name": "Rana Manoj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7547",
    "name": "Jadhav Pandurang Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10196",
    "name": "Gaikwad Ramesh Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15673",
    "name": "Pitale Moreshwar Bhalchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15868",
    "name": "Dube Brujeshkumar Shyamsunder"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9501",
    "name": "Salunkhe Santosh Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2639",
    "name": "Pawar Nanu Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6749",
    "name": "Mulik Dattatray Eknath 265/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7177",
    "name": "Salunkhe Vilas Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8287",
    "name": "More Vasant Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8494",
    "name": "Jagdale Mansingh Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9395",
    "name": "Sakunde Suryakant Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11265",
    "name": "Mahagade Vijay Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12054",
    "name": "Gaikwad Sharad Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14195",
    "name": "Kadam Vithal Kundlik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15357",
    "name": "Kanjan Murlidhar Jaganmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16185",
    "name": "Mandadkar Jaidas Murilidar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16266",
    "name": "Kashid Santosh Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16555",
    "name": "Borge Sadashiv Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16681",
    "name": "Shetye Shivdas Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18112",
    "name": "Jadhav Shivaji Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18440",
    "name": "Pujari Suresh Naga"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18700",
    "name": "Pawar Satvshila Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14338",
    "name": "Shingate Santosh Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1493",
    "name": "Nikam Dyaneshwar Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8143",
    "name": "Jadhav Ramchandra Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9694",
    "name": "Mandhare Vijay Jagdevrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10914",
    "name": "Bhosale Gungrao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11252",
    "name": "Ghadage Anilkumar Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12062",
    "name": "Patil Vilas Chander"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15777",
    "name": "Shinde Satish Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15866",
    "name": "More Ramesh Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6459",
    "name": "Kahar Omprakash Ayodhyaprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7467",
    "name": "Jadhav Baban Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9960",
    "name": "Kolekar Baban Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10280",
    "name": "Mohite Ashok Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11167",
    "name": "Nikam Rajendra Bapusaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14573",
    "name": "Bhandalkar Bajrang Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16325",
    "name": "Pawar Pandurang Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18082",
    "name": "Manere Sudhakar Sadhashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18117",
    "name": "More Vishnu Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18555",
    "name": "Shedge Shashikant Genba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18593",
    "name": "Pawar Vishwas Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18615",
    "name": "Kolekar Ishwar Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17560",
    "name": "Chaudhari Ramkumar Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5979",
    "name": "Nikam Kisan Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7104",
    "name": "Kadam Baban Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8028",
    "name": "Bhosale Popat Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18381",
    "name": "Kadam Rajashree Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20617",
    "name": "Shinde Mahesh Dattaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2098",
    "name": "Kadam Nilesh Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2981",
    "name": "Bhoite Satyawan Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10513",
    "name": "Bodhe Kumar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14574",
    "name": "Pawar Hari Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17946",
    "name": "Salunkhe Vilas Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18116",
    "name": "Chikane Ramchandra Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10063",
    "name": "Phalke Chandrakant Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16754",
    "name": "Shinde Navnath Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2114",
    "name": "Kale Mahadev Khade"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9558",
    "name": "Matre Tanaji Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11310",
    "name": "Shinde Anil Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16744",
    "name": "Bhadvankar Arun Gunda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16746",
    "name": "Patil Ananda Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16747",
    "name": "Tanawade Anil Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6353",
    "name": "Anpat Dattatraya Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8021",
    "name": "Tare Pandurang Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17160",
    "name": "Dhobale Prafulla Bhalchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9902",
    "name": "Kadav Jalindar Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4847",
    "name": "Dhumal Suresh Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "759",
    "name": "Bhoite Kirtiwan Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2023",
    "name": "Bhagawat Tukaram Satu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2246",
    "name": "Mahadik Gulabrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3157",
    "name": "Nawadkar Hanmant Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3358",
    "name": "Sabale Chandrasheela Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4509",
    "name": "Jadhav Anandrao Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4717",
    "name": "Shinde Arjun Vinayakrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6047",
    "name": "Jadhav Janardhan Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "505",
    "name": "Chavan Balwant Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2796",
    "name": "Mulik Aatmaram Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6052",
    "name": "Sakunde Balu Vaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11328",
    "name": "More Tukaram Chingu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14020",
    "name": "Ghadigaonkar Atul Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4510",
    "name": "Chavan Vasant Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5028",
    "name": "Kadam Babu Devaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7840",
    "name": "Babar Tanaji Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1377",
    "name": "Gond Nathubai Bhudhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17377",
    "name": "Bamane Shankar Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9617",
    "name": "Pawar Ashok Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3330",
    "name": "Surve Tanaji Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17993",
    "name": "Ghare Ankush Janu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3437",
    "name": "Phadtare Tukaram Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11662",
    "name": "Salate Kashinath Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17863",
    "name": "Desai Santosh Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3101",
    "name": "Tiwari Rajendraprasad Jainath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8770",
    "name": "Pawar Chandrakant Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20273",
    "name": "Chavan Meena Ramnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1118",
    "name": "Garud Prabhakar Jayshing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3887",
    "name": "Sabale Prakash Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21814",
    "name": "Dudaye Maruti Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3797",
    "name": "Shinde Dnyaneshwar Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5000",
    "name": "Chavan Namdev Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8064",
    "name": "Mulik Prakash Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16265",
    "name": "Sabale Laxman Chadru Toli No 620/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12231",
    "name": "Shinde Chandrakant Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21961",
    "name": "Nalawade Lata Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "833",
    "name": "More Baburao Bala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5843",
    "name": "More Yeshwant Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7764",
    "name": "Nalawade Baburao Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10744",
    "name": "Methe Natha Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10262",
    "name": "Nawadkar Kiran Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11949",
    "name": "Pawar Uttamrao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19832",
    "name": "Mane Nagesh Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "731",
    "name": "Kadam Madhukar Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2324",
    "name": "Gaikawad Namdev Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3493",
    "name": "More Shashikant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6968",
    "name": "Bandal Chandrakant Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9488",
    "name": "Jadhav Ramchandra Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12178",
    "name": "Khot Dinkar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13307",
    "name": "Jadhav Atmaram Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13380",
    "name": "Chalake Chandrakant Dnyanu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "697",
    "name": "Shinde Mohan Bhalchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13563",
    "name": "Chavan Rajkumar Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1824",
    "name": "Pisal Arvind Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8316",
    "name": "Korade Balwant Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10457",
    "name": "Khalate Vilas Vithalrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16735",
    "name": "Chandanshive Santosh Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3063",
    "name": "Surve Maruti Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3133",
    "name": "Babar Shamrao Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13916",
    "name": "Jadhav Shankarrao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17130",
    "name": "Bobade Sanjay Murlidhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1605",
    "name": "Bhosale Maruti Daulatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2460",
    "name": "Mulik Sampatrao Nathuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3193",
    "name": "Jadhav Shivaji Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4507",
    "name": "Sawant Jagannath Bapuji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "630",
    "name": "Kulal Narayan Krishna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "923",
    "name": "Jadhav Vijay Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12517",
    "name": "Ghorpade Sanjay Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17231",
    "name": "Yadav Swati Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15857",
    "name": "Jain Ajit Khushalchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8447",
    "name": "Pandy Shyamnarayan Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12812",
    "name": "Nalawade Prakash Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19354",
    "name": "Pingat Suman Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8504",
    "name": "Dhaigude Vaman Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11768",
    "name": "Sakunde Anil Shyamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5463",
    "name": "Pawar Sadashiv Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9600",
    "name": "Matekar Shivaji Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9307",
    "name": "Phalke Tanaji Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9438",
    "name": "Dhumal Sambhaji Raosaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22217",
    "name": "Gole Ankush Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11269",
    "name": "Wagh Suhas Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21453",
    "name": "Chaukekar Sagar Sagar  Shrikrishana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9589",
    "name": "Gaikawad Shankar Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1063",
    "name": "Sabale Ankush Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21969",
    "name": "Lembhe Bhusan Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17029",
    "name": "Bhoite Uddhavrao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11108",
    "name": "Shelar Anandrao Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17499",
    "name": "Nimbalkar Sanjay Dasharath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15799",
    "name": "Iyer Shekar Sethuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12046",
    "name": "Naar Sanjay Dattaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19353",
    "name": "Pandey Arunkumar Rajdhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20329",
    "name": "Kadam Ramesh Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12973",
    "name": "Mulik Digambar Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13284",
    "name": "Kahar Rameshchanasra O  902/8"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19283",
    "name": "Jadhav Vijay Jivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19284",
    "name": "Kadam Dhonduram Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13958",
    "name": "Mahadik Pravin Kamalakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2028",
    "name": "Chavan Shivaji Basappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10163",
    "name": "Gundage Maruti Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10279",
    "name": "Jadhav Pratap Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13151",
    "name": "Mane Sadashiv Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16996",
    "name": "Pawar Mahesh Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17222",
    "name": "Shejwal Dhanaji Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17224",
    "name": "Kavar Balu Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6583",
    "name": "Pawar Kantilal Shyamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9820",
    "name": "Sawant Archana Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11060",
    "name": "Chawan Ramesh Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12384",
    "name": "Santosh Sitaram Rokade"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17026",
    "name": "Pawar Suresh Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12393",
    "name": "Sabale Abhijeet Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6430",
    "name": "Bobade Dilip Shivaji 655/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6653",
    "name": "Lokhande Jaysing Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8962",
    "name": "Chavan Tanaji Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9804",
    "name": "Aavale Tukaram Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17341",
    "name": "Sonawane Ratan Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5361",
    "name": "Chalake Vilas Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7867",
    "name": "Bhagat Mahadeo Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11048",
    "name": "Kolekar Ganpat Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12771",
    "name": "Ghorpade Vijay Mansing 899/15"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13127",
    "name": "Patil Hanumant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13474",
    "name": "Dhere Vishwas Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13489",
    "name": "Jaiswal Ramchandra Mutur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14886",
    "name": "Malpote Ram Kishan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15758",
    "name": "Waghambare Shashank Bhaghwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17226",
    "name": "Pawar Vijay Vishnu  Tn-1528-8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13053",
    "name": "Khopade Dhanaji Khondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10838",
    "name": "Kadam Sampat Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9895",
    "name": "Verpe Chandrakant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15260",
    "name": "Ingavale Shashikant Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21926",
    "name": "Ware Suresh Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3184",
    "name": "Kulkarni Jayant Ranganath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5988",
    "name": "Babar Madhavrao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3900",
    "name": "Chavan Dilip Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17068",
    "name": "Nimbalkar Vinayak Kondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17755",
    "name": "Pawar Sitaram Tukaram  Tn-1573-1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10968",
    "name": "Nalwade Laxman Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8163",
    "name": "Jagtap Pradesh Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6790",
    "name": "Pawar Mohan Dyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6865",
    "name": "Chavan Rajashri Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18045",
    "name": "Gore Vijay Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10062",
    "name": "Katkar Sangeeta Satish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20649",
    "name": "Rane Sunil Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3216",
    "name": "Nikam Bhanudas Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4617",
    "name": "Dhanawade Krishna Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17231",
    "name": "More Raghunath Tukaram  Tn-1528-9"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7361",
    "name": "Khamkar Dilip Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21574",
    "name": "Patil Yashwant Nasik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21576",
    "name": "Shinde Vithoba Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21577",
    "name": "Sawant Vinod Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21581",
    "name": "Dhnavade Kisan Dagdu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17205",
    "name": "Sable Ashok Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16029",
    "name": "Yadav Shivprasad Harilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12047",
    "name": "Parab Santosh Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12048",
    "name": "Dhuri Ramesh Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5949",
    "name": "Sabale Ramesh Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6841",
    "name": "Ozarde Rajendra Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6843",
    "name": "Ingawale Hanmant Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6844",
    "name": "Jadhao Ramchndra Govindrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12784",
    "name": "Dhumal Sadashiv Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6700",
    "name": "Mulik Dilip Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10614",
    "name": "Nandgavkar Suresh Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11040",
    "name": "Satam Prakash Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5501",
    "name": "Kadam Madhukar Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21300",
    "name": "Kadam Santosh Santosh  Jaganath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17019",
    "name": "Khopade Harichandra Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "253",
    "name": "Pawar Bhausaheb Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7756",
    "name": "Mulik Appasaheb Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13143",
    "name": "Sabale Kiran Chandrasheel"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16023",
    "name": "Borge Tukaram Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5180",
    "name": "Chawan Shivaji Ramrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "999",
    "name": "Jadhav Pandurang Namdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4666",
    "name": "Jadhav Tanaji Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9496",
    "name": "Katkar Jagannath Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9677",
    "name": "Jadhav Pratap Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18508",
    "name": "Mandhare Mangesh Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1793",
    "name": "Pawar Babanrao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15237",
    "name": "Chawan Anil Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1293",
    "name": "Pawar Anandrao Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3356",
    "name": "Jadhav Vasant Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4417",
    "name": "Barge Yeshwant Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10562",
    "name": "Pudik Arvind Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15331",
    "name": "Ghode Vithal Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9355",
    "name": "Newase Parvati Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9356",
    "name": "Bhoite Latadevi Chandrsen"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9398",
    "name": "Barge Sambhaji Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9466",
    "name": "Sable Sunil Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9640",
    "name": "Shinde Premsing Sardarsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9644",
    "name": "Shinde Vasant Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9649",
    "name": "Shinde Sindhubai Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9665",
    "name": "Sanas Pandurang Gynaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14044",
    "name": "Shelke Sachin Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15391",
    "name": "Salunkhe Shrirang Sadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9434",
    "name": "Kakade Shivaji Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9445",
    "name": "Khatal Balaso Sonba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9462",
    "name": "Nimbalkar Sangeeta Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9476",
    "name": "Ghadage Suhas Vithalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9478",
    "name": "Jadhav Pratibha Gorakh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9486",
    "name": "Pisal Ramdas Genaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9488",
    "name": "Pisal Tanaji Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9514",
    "name": "Phalke Bhimrao Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9523",
    "name": "Lembhe Purushottam Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9528",
    "name": "Shinde Sangramsing Ashokrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9550",
    "name": "Nalwade Kedar Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9607",
    "name": "Salunkhe Baburao Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11946",
    "name": "Gaikwad Sanjay Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6511",
    "name": "Kapale Trambakrao Ramappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10766",
    "name": "Pathan Phiroj Sikandarkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1737",
    "name": "Ingale Pandurang Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6382",
    "name": "Bodhe Mohan Bhauso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12224",
    "name": "Nawadkar Pralhad Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12236",
    "name": "Pathan Mohammad Idris Walimohamad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13518",
    "name": "Jaiswal Krupashankar Ramdulare"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9315",
    "name": "Jagtap Yashoda Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9335",
    "name": "Dhumal Vilas Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9336",
    "name": "Nimbalkar Narayan Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2679",
    "name": "Khiravale Bajarang Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21459",
    "name": "Ved Hitesh Narottam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8085",
    "name": "Chalke Uttam Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12031",
    "name": "Karpe Bapu Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9551",
    "name": "Nalawade Sanjay Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9552",
    "name": "Nalawade Kastura Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9553",
    "name": "Nalawade Murlidhar Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9559",
    "name": "Dhumal Mahesh Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9735",
    "name": "Miss  Jadhav Shobha Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4655",
    "name": "Jadhav Rajendra Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17104",
    "name": "Dhumal Nandkumar Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10009",
    "name": "Kadam Rangrao Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18892",
    "name": "Mane Pravin Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14205",
    "name": "Ghadge Ramchandra Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14978",
    "name": "Luis Annie Constantine"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14357",
    "name": "Karantrekar Vasant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19061",
    "name": "Kharade Vikram Jalindar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13102",
    "name": "Sawant Ashok Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23751",
    "name": "Chavan Somnath Shivajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17895",
    "name": "Mojar Sandeep Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9826",
    "name": "Nanavare Sanjay Dada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16020",
    "name": "Patil Maruti Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14198",
    "name": "Patel Dhiraj Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22156",
    "name": "Patel Dhanaji Narshi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22179",
    "name": "Holdar Sunilchandra Kartik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15197",
    "name": "Khandekar Hanmant Ravaji  Tn-1415-1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14384",
    "name": "More Subhash Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14067",
    "name": "More Harichandra Pralhad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1126",
    "name": "More Vilas Bhaskar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15412",
    "name": "Kadam Sunil Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23826",
    "name": "Matre Suresh Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14630",
    "name": "Shinde Balasaheb Jaywant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1940",
    "name": "More Ananda Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5661",
    "name": "Patil Balu Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6842",
    "name": "Ingawale Narahari Ganapati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19523",
    "name": "Chaudhary Mohd Idrish Gaffur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1451",
    "name": "Chavan Shahajirao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9175",
    "name": "Desai Babasaheb Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9729",
    "name": "Jadhav Usha Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9762",
    "name": "Jadhao Pushpalata Dharmraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6254",
    "name": "Gade Babasaheb Janrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15255",
    "name": "Sabale Sunil Krishnat 519/13"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15887",
    "name": "Nalawade Sambhaji Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16586",
    "name": "Kale Rahul Dashrath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20069",
    "name": "Mahangade Chandrakant Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6016",
    "name": "Kadam Dnyanoo Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13764",
    "name": "Dhole Sunil Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10061",
    "name": "Katkar Satish Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6797",
    "name": "Bhosale Baban Nivaruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6800",
    "name": "Pawar Balaso Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8916",
    "name": "Mandhare Veersen Wamanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6794",
    "name": "Pawar Dilip Marutrao Nanaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9979",
    "name": "Bhoite Kalyan Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2072",
    "name": "Nalawade Shankarrao Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7214",
    "name": "Chawan Rajendra Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12061",
    "name": "Dhumal Gajanan Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12976",
    "name": "Yadav Shrikant Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15878",
    "name": "Nawadkar Vijay Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20974",
    "name": "Temkar Manisha Manisha  Rajan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9606",
    "name": "Malusare Chandrakant Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7360",
    "name": "Khamkar Amol Kisanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "719",
    "name": "Jagtap Narayan Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1430",
    "name": "Shivankar Jagannath Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3429",
    "name": "Gujar Sherali Laddan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6130",
    "name": "Pawar Balkrishna Ramchadnra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8468",
    "name": "Disale Suresh Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11877",
    "name": "Mardhekar Vilas Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6839",
    "name": "Ingawale Parshuram Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4576",
    "name": "Talwar Laxman Kadappa"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1660",
    "name": "Patil Prabhakar Gopinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10330",
    "name": "Shinde Ramchandra Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4971",
    "name": "Nikam Jaising Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19996",
    "name": "Chalke Deepali Dattaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9291",
    "name": "Nevase Muktabai Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4682",
    "name": "Avate Shrirang Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5970",
    "name": "Chavan Jagannath Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10540",
    "name": "Disale Chandrakant Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12432",
    "name": "Dhadam Ananda Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12956",
    "name": "Bhatade Ananda Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13275",
    "name": "Shilimkar Ashok Samapt 968/15"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14003",
    "name": "Karajwade Anandrao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14918",
    "name": "Mishra Dilipkumar Ramnaresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15156",
    "name": "Kolap Nandu Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17625",
    "name": "Shingate Abhijeet Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10082",
    "name": "Kadam Balasaheb Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17940",
    "name": "Sawant Vilas Vishram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17238",
    "name": "Kadam Shivaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "729",
    "name": "Chawan Shankar Jaisingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4236",
    "name": "Ghadge Subhas Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4405",
    "name": "Ujgaonkar Ananda Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6601",
    "name": "Badad Yeshwant Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8005",
    "name": "Chavan Laxman Nagu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8244",
    "name": "Sabale Baban Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10930",
    "name": "Bhosale Chandrakant Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11620",
    "name": "Nawadkar Nathuram Dagdoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12348",
    "name": "Surve Babasaheb Balkrushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13297",
    "name": "Kadam Ajit Jaysing T No 328/48"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13393",
    "name": "Bobade Shankar Mugutrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15612",
    "name": "Choudhari Parasnath Gangaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21887",
    "name": "Shikhre Trupti Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3820",
    "name": "Sawant Balwant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22348",
    "name": "Dodke Yogesh Machindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9830",
    "name": "Taware Sanjay Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11194",
    "name": "Shinde Bhimrao Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17032",
    "name": "Chhoudhari Vijayakumar Basant 220-24"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11051",
    "name": "Kadam Ashok Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16637",
    "name": "Barve Rajesh Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2291",
    "name": "Kadam Bhiva Shiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9150",
    "name": "Kadav Hanmant Sidram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9428",
    "name": "Shinde Ramchandra Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11630",
    "name": "Kadam Mangesh Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "815",
    "name": "Chavan Shahji Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13479",
    "name": "More Gajanan Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8848",
    "name": "Nanaware Tukaram Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14387",
    "name": "Waghmare Baburao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2741",
    "name": "Jagtap Kondiba Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5500",
    "name": "Chavan Nandkumar Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9029",
    "name": "Kadav Shivaji Shankar 545/B/22"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5422",
    "name": "Jadhav Anandrao Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14553",
    "name": "Bhosale Balwant Vyankat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7898",
    "name": "Nalage Shrirang Savlaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15114",
    "name": "Pawar Hanmant Dattu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5203",
    "name": "Sonawane Gulabrao Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4610",
    "name": "Khudse Prakash Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6546",
    "name": "Chavan Jaysing Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8667",
    "name": "Matkar Janardan Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15119",
    "name": "Pandey Mahendra Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9645",
    "name": "Shinde Ranjana Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9647",
    "name": "Shinde Vijaya Dattu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9650",
    "name": "Shinde Rekha Rajendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9664",
    "name": "Gaikawad Sudam Kisanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9676",
    "name": "Bhosale Rajendra Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9678",
    "name": "Pisal Shahaji Ganapati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9681",
    "name": "Jagtap Surekha Rajendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9682",
    "name": "Jagtap Sarita Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9685",
    "name": "Shinde Jitendra Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9688",
    "name": "Pisal Tanaji Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9732",
    "name": "Bhosale Ravindra Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9733",
    "name": "Bhosale Mahendra Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5804",
    "name": "Shinde Rupchand Krushnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9381",
    "name": "Kadam Subhash Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9400",
    "name": "Dhumal Neelam Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9404",
    "name": "Dhumal Ankush Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9608",
    "name": "Shinde Ramakant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20933",
    "name": "Kasbe Mnaoj Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9607",
    "name": "Dhumal Baban Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9439",
    "name": "Khatal Rajendra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9441",
    "name": "Budhawale Nandkumar Bhimrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9449",
    "name": "Jagrtap Shrirang Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9475",
    "name": "Ghadage Sujata Suhas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9482",
    "name": "Nimbalkar Ashok Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9532",
    "name": "Mudralkar Mahipati Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15070",
    "name": "Gaikwad Bajrang Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12441",
    "name": "Sabale Shivaji Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21510",
    "name": "Patil Eknath Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21462",
    "name": "Potdar Ashwini Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12338",
    "name": "Alagude Shivaji Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21433",
    "name": "Hanif Chippa Rangwala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22665",
    "name": "Dhumal Santosh Dyanoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22759",
    "name": "More Balu Karbhari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23007",
    "name": "Chavan Nilesh Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14827",
    "name": "Bhosale Deepak Pralhad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2373",
    "name": "Dhumal Prlahad Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9352",
    "name": "Dhumal Shobha Shobha Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9463",
    "name": "Jagdale Lahu Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9468",
    "name": "Sonavane Sadashiv Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9487",
    "name": "Shinde Maruti Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9489",
    "name": "Bobade Dilip Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9490",
    "name": "Bobade Raosaheb Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9494",
    "name": "Katkar Satish Laxmanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9498",
    "name": "Mahajan Dattatray Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9500",
    "name": "Bhandalkar Laxman Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9520",
    "name": "Shinde Udaysing Arjunsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9529",
    "name": "Pawar Sambhaji Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9538",
    "name": "Katkar Bhagwan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9544",
    "name": "Katkar Vijay Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23784",
    "name": "Sawant Milind Bhaskar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23785",
    "name": "Kadam Jaywant Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10316",
    "name": "Monde Suraj Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14572",
    "name": "Kale Anil Bhaskar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1012",
    "name": "Jadhav Ramchandra Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9176",
    "name": "Desai Subhash Aba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15053",
    "name": "Ghorpade Pravin Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10674",
    "name": "Khot Dattu Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12757",
    "name": "Desai Ananda Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13694",
    "name": "Toraskar Tanaji Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10337",
    "name": "Pujari Dhondiram Baloo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2704",
    "name": "Ghevade Tabaji Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9304",
    "name": "Jamdar Mohan Dnyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18678",
    "name": "Ghode Pravin Dagdu  Toli No-489/15"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13748",
    "name": "Kondalkar Ranjeet Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13749",
    "name": "More Jitendra Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9241",
    "name": "Jagtap Kashinath Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1336",
    "name": "Jambhale Vithal Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9563",
    "name": "Bhoite Vijay Narsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9567",
    "name": "More Shankar Hariba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9580",
    "name": "Pisal Tukaram Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9592",
    "name": "Barge Shivaji Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22387",
    "name": "Shinde Sunil Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8457",
    "name": "Chavan Ramrao Jagdeorao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10892",
    "name": "Dave Natvarlal Kalidas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8182",
    "name": "Pawar Baban Bandoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17060",
    "name": "Singh Rajesh Devilash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10582",
    "name": "Bobade Hanmant Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4732",
    "name": "Jadhav Rohidas Harichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22359",
    "name": "Parab Namita Bharatbhusan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23677",
    "name": "Jadhav Mayur Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6314",
    "name": "Shinde Babu Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6472",
    "name": "Jadhav Nanaso Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7137",
    "name": "Babar Sanjay Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9783",
    "name": "Mulik Dattatray Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17981",
    "name": "Kajari Vitthal Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4383",
    "name": "Bhagwat Parshuram Genaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9508",
    "name": "Nimbalkar Jayashri Uday"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9568",
    "name": "More Suhas Shreerang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4801",
    "name": "Jadhav Vithal Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14865",
    "name": "Matakar Mansing Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15192",
    "name": "Dhanawade Narayan Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20070",
    "name": "Jadhav Shankar Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5302",
    "name": "Chawan Ramesh Hanmantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14337",
    "name": "Gardi Krishnat Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8760",
    "name": "More Bharat Dattaray"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "348",
    "name": "Jadhav Suresh Changdev"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "349",
    "name": "Jadhav Prakash Rangrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "414",
    "name": "Patil Sandesh Santosh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "498",
    "name": "Shelke Balasaheb Eknath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "545",
    "name": "Miss  Chavan Neelam Kisan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "546",
    "name": "Bobade Rajendra Genba"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "547",
    "name": "Chavan Manohar Dattu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "570",
    "name": "Mulik Rajendra Ramchandra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "571",
    "name": "Kolape Bapurao Sampat"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "595",
    "name": "Shinde Ananda Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19313",
    "name": "Zanazane Vishnu Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "512",
    "name": "Pisal Rajaram Bahiru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7174",
    "name": "Sathe Ravindra Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5776",
    "name": "Suryawanshi Shivaji Jijaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20451",
    "name": "Kanam Raju Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "400",
    "name": "Pisal Shrimant Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3563",
    "name": "Nayakawadi Ramchandra Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9718",
    "name": "Kadam Jaywant Bhagoji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9810",
    "name": "Nikam Bhiku Antu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12601",
    "name": "Shinde Pandurang Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12606",
    "name": "Miss  Shinde Savitra Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12609",
    "name": "Bhosale Mangal Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "529",
    "name": "Babar Shankar Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5560",
    "name": "Barge Mansing Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5356",
    "name": "Nanaware Waman Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15851",
    "name": "Jaujal Adhikrao Sakharam Tn-467-14"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7952",
    "name": "Kadam Sudhir Vishawas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3353",
    "name": "Zanzurne Shrimant Nivarutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5217",
    "name": "Bhope Sakharam Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17858",
    "name": "Bavdekar Ananda Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11073",
    "name": "Kadam Subhash Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3723",
    "name": "Kadam Yashawant Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7720",
    "name": "Pawar Dattatray Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3046",
    "name": "Dhumal Uday Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18115",
    "name": "Jagtap Jaydeep Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10235",
    "name": "Shinde Shivaji Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19565",
    "name": "Phalke Rajendra Ganpatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14623",
    "name": "Chandrakant Shantaram Khedakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "711",
    "name": "Dhumal Chandrakant Madhavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21881",
    "name": "Patil Somnath Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8617",
    "name": "Pawar Narsing Keshavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21343",
    "name": "Kurade Ramesh Shetti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7378",
    "name": "Ghogardare Ramakant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "982",
    "name": "Shinde Pralhad Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21916",
    "name": "Singh Ramrati Ramashankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6966",
    "name": "Barave Hanuman Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6448",
    "name": "Jadhav Arjun Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14964",
    "name": "Jagtap Balkrishna Rangrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "780",
    "name": "Nimbalkar Sunil Changdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15207",
    "name": "Pawar Vikas Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2921",
    "name": "Dhumal Kisan Narsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4416",
    "name": "Chavan Ramesh Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23773",
    "name": "Karpe Nivruti Balku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9484",
    "name": "Nimbalkar Shankar Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12365",
    "name": "Bhoite Hindurao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12120",
    "name": "Kadav Shalindar Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9623",
    "name": "Shinde Madanrao Arjun"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "745",
    "name": "Karbhal Sandeep Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "288",
    "name": "Jadhav Vishwanath Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21852",
    "name": "Jain Disha Jagdish"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9616",
    "name": "Dhumal Dattatray Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23394",
    "name": "Kumbharkar Dilip Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15808",
    "name": "Asha Rawan Suryawanshi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13664",
    "name": "Joshi Rajan Ganesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13665",
    "name": "Bagwan Samina Abidali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "403",
    "name": "Shaikh Aminuddin Ramjan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12474",
    "name": "Kumar Ratanlal Chagaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7073",
    "name": "Monde Baban Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22069",
    "name": "Shetye Vimal Madan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16792",
    "name": "Patil Hanmant Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3457",
    "name": "Mane Kisan Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5201",
    "name": "Pawar Rajendra Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9898",
    "name": "More Shivaji Damodhar 320/B/8"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14358",
    "name": "Jumankhan Mohd Hanifkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13892",
    "name": "Shinde Jyoti Pandurang 1424/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16078",
    "name": "Kambale Indrajit Shivram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1116",
    "name": "Sharma Santoshkumar Rameshkumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8183",
    "name": "Murumkar Shyamrao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17882",
    "name": "Pawar Ajit Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "697",
    "name": "Jadhav Maruti Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8212",
    "name": "Jagtap Hindurao Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8622",
    "name": "Jadhav Vikas Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8662",
    "name": "Karande Ananda Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13313",
    "name": "Kolate Baban Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16707",
    "name": "Nakate Bipin Chagan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3927",
    "name": "Shingate Shankar Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8586",
    "name": "Shinde Hindurao Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7177",
    "name": "Matkar Satyawan Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4534",
    "name": "Bhoite Anandrao Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6076",
    "name": "Nalage Sadashiv Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7181",
    "name": "Gogawale Shrawan Jotiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16551",
    "name": "Marathe Vittal Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8004",
    "name": "Chavan Bajirao Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3800",
    "name": "Salunkhe Narmadabai Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8660",
    "name": "Sutar Ashok Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8661",
    "name": "Chaugule Ashok Daryappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9959",
    "name": "Mulik Suresh Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13910",
    "name": "Pawar Dattatray Nathuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13486",
    "name": "Yadhav Sulochana Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5527",
    "name": "Taware Aabaso Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6520",
    "name": "Khot Biru Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9218",
    "name": "Karape Bhagwan Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14882",
    "name": "Shinde Samtosh H  1140/A/17"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18088",
    "name": "Sawant Suman Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9415",
    "name": "Kadam Sangeeta Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11667",
    "name": "Sakpal Babaji Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8735",
    "name": "Liddad Rajendra Shitalsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11123",
    "name": "Bobade Vikas Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21889",
    "name": "Atale Shrikant Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12961",
    "name": "Ranamware Dinkar Sursing Toli 75/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15258",
    "name": "Sawant Prakash Atamram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17550",
    "name": "Sharma Omkarnath Ramjivan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4789",
    "name": "Bendre Jagannath Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20537",
    "name": "Gamare Sarita Ajit"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2557",
    "name": "Mane Arun Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9375",
    "name": "Chavan Dnyaneshwar Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18526",
    "name": "Dhumal Shankar Kalyanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16515",
    "name": "Warkad Deepak Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17125",
    "name": "Dixit Popat Murlidhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17187",
    "name": "Shedge Anil Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17399",
    "name": "Miss  Sabale Snehlata Bhimashankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12693",
    "name": "Mandhare Kailas Malhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22285",
    "name": "Dalvi Snehal Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15401",
    "name": "Shinde Kantilal Hanmantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16057",
    "name": "More Sambhaji Damodhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16865",
    "name": "Sarfare Sanjay Parshram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2340",
    "name": "Shinde Pralhad Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8633",
    "name": "Nikam Chandrasen Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2322",
    "name": "Pawar Maruti Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16498",
    "name": "Tetme Arvind Balku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9521",
    "name": "Shinde Arjunsing Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9965",
    "name": "Pisal Prabhakar Sanjar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4790",
    "name": "Bendre Rajendra Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5087",
    "name": "Barge Vilas Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5167",
    "name": "Borate Devidas Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5202",
    "name": "Pawar Anil Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4034",
    "name": "Ahirekar Janardhan V 921/19"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12445",
    "name": "Kadam Sanjay Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4432",
    "name": "Chavan Ganpat Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4601",
    "name": "Chawan Gorakhnath Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2909",
    "name": "Chalake Ramchandra Sidu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "120",
    "name": "Dere Ramrao Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "810",
    "name": "Patil Vasant Balagaunda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12873",
    "name": "Kadam Atmaram Dinkar 544/13"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11202",
    "name": "Mane Gulabrao Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12602",
    "name": "Shinde Anil Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7306",
    "name": "Shinde Pramod Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23656",
    "name": "Chavan Atul Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17980",
    "name": "Chavan Taramati Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5660",
    "name": "Matre Shamrao Ramchndra B-2736"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3524",
    "name": "Dhumal Kamal Kisanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1896",
    "name": "Phalke Dnyandeo Nagesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15941",
    "name": "Jadhav Gopal Seetu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13653",
    "name": "Sutar Shivram Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1080",
    "name": "Mane Pandurang Sadashiv 514/14"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1339",
    "name": "Divekar Parighaa Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3351",
    "name": "Chalake Maruti Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "969",
    "name": "Solaskar Dattatray Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16393",
    "name": "Deshmukh Anil Suryakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2974",
    "name": "Barge Dashrath Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13788",
    "name": "Awate Bharat Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15108",
    "name": "Patil Rajendra Harichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17203",
    "name": "Chikane Sanjay Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3904",
    "name": "Pawar Narayan Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7936",
    "name": "Bobade Balu Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10221",
    "name": "Ghorpade Dnyandev Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14417",
    "name": "Khopde Avinash Sudam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12933",
    "name": "Jadhav Balasaheb Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8548",
    "name": "Kadam Harichandra Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15796",
    "name": "Karne Kashinath Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "451",
    "name": "Wagh Namdev Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14983",
    "name": "Nalawade Popat Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3647",
    "name": "Sonawale Suresh Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17483",
    "name": "Waghela Lalit Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17491",
    "name": "Anjarlekar Shubhangi Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17524",
    "name": "Bilye Rohini Ravji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2280",
    "name": "Chavan Pralhad Gulabrao69/07"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1216",
    "name": "Dhavan Dattatray Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2659",
    "name": "Shinde Sarjerao Tukaram/ Anand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15132",
    "name": "Sawant Rajaram Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17247",
    "name": "Pinagat Dattatrya Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10045",
    "name": "Pawar Dilip Genaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17507",
    "name": "Desai Kalpana Ajit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18461",
    "name": "Tambe Smita Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15544",
    "name": "Pawar Sadanand Kisanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14897",
    "name": "Pal Amarnath Chhedi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11908",
    "name": "Suryawanshi Hanmant Uddhav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17688",
    "name": "Barge Vinod Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3789",
    "name": "Ghadge Popat Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18315",
    "name": "Sankhe Mahesh Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18316",
    "name": "Sankhe Pradeep Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14840",
    "name": "Mishra Nagendraprasad Vishweshwar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14846",
    "name": "Sinh Deviprasad Shivnarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13963",
    "name": "Chavan Dhanesh Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13434",
    "name": "Sakat Ankush Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13605",
    "name": "Jagtap Hiralal Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14725",
    "name": "Kher Jagdish Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11130",
    "name": "Yadav Solaskar Sandeep Balaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5945",
    "name": "Salunkhe Mohan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10533",
    "name": "Bhosale Bhanudas Dharmaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6152",
    "name": "Pawar Arvind Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13690",
    "name": "Pawar Suresh Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8693",
    "name": "Phalke Sudhakar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9182",
    "name": "Nalawade Rajendra Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9456",
    "name": "More Tanaji Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10462",
    "name": "Shinde Shankarrao Malharrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9983",
    "name": "Jagtap Avinash Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7151",
    "name": "Pathan Habibkhan Noorkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17234",
    "name": "Desai Bhimrao Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18190",
    "name": "Doshi Shashi Shantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18194",
    "name": "Purohit Jagdish Purushottam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18196",
    "name": "Gandhi Vijay Bahuchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14422",
    "name": "Parte Ashok Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14443",
    "name": "Ghadage Dilip Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21215",
    "name": "Dalvi Pramodini Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7682",
    "name": "Jadhav Dhanaji Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17828",
    "name": "Indalkar Pravin Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4720",
    "name": "Mane Govind Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10066",
    "name": "Nikam Mohan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16717",
    "name": "Shaikh Aashpak Balekhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14303",
    "name": "Zanzane Sunil Bajirao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14389",
    "name": "Solaskar Prakash Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14413",
    "name": "Chavan Ajit Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5705",
    "name": "Sapkal Chandrakant Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21187",
    "name": "Jadhav Jyitiram Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14345",
    "name": "Dhumal Bhagwan Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7382",
    "name": "Shinde Eknath Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8824",
    "name": "Bhoite Prataprao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5639",
    "name": "Raje Dhondiram Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21457",
    "name": "Soni Dilip Chunilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8470",
    "name": "Chavan Kalyan Jayshing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3036",
    "name": "Pawar Udhav Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15466",
    "name": "Chavan Santosh Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11727",
    "name": "Bhosale Pralhad Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9433",
    "name": "Nimbalkar Jagannath Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2185",
    "name": "Upadhayay Santoshkumar Uditnarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13304",
    "name": "Chavan Hindurao Dattoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "888",
    "name": "Kalpat Kartik Rama"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10859",
    "name": "Kadam Namdeo Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11723",
    "name": "Mahadik Dilip Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10622",
    "name": "Ghadge Dadasaheb Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14035",
    "name": "Sayyad Ramjan Babulal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9637",
    "name": "Shinde Usha Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4956",
    "name": "Bidkar Chandrakant Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6663",
    "name": "Phalake Jitendra Jayasingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11521",
    "name": "Shinde Arun Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21856",
    "name": "Mishra Roshni Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "936",
    "name": "Mandhare Parashram N  110/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16021",
    "name": "Khopade Laxman Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16947",
    "name": "Kangutkar Vinod Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13715",
    "name": "Raigade Tanaji Shankar 908/29"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17886",
    "name": "Chavan Nirmala Parthraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3223",
    "name": "More Raghunath Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19392",
    "name": "Shinde Chandrakant Buvaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12613",
    "name": "Shinde Madhukar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13999",
    "name": "Shende Satish Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13398",
    "name": "Ghige Umesh Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11441",
    "name": "Jambhale Dattatray Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17799",
    "name": "Sayyed Rafiq Nazir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17869",
    "name": "Kadam Daji Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1132",
    "name": "Pandit Hemlata Madhav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21497",
    "name": "Bohra Kamlesh Gagansingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20971",
    "name": "Yadav Daneshwar Hemlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18834",
    "name": "Vankar Vasudev Sahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3866",
    "name": "Bagade Suresh Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7204",
    "name": "Phalke Chandrakant Ramrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19609",
    "name": "Nikam Sundar Tulshiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21563",
    "name": "Sakate Laxman Dharmrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21686",
    "name": "Kashid Prashant Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21851",
    "name": "Roy Rupesh Charandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21858",
    "name": "Muliya Bhaskar Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21860",
    "name": "Singh Dharmendra Abhayjit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "248",
    "name": "Gaikwad Sangita Rohidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13508",
    "name": "Joglekar Arun Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13815",
    "name": "Pawar Vikas Ramchandra    Tn 1167-7"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3015",
    "name": "Patil Anil Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8842",
    "name": "Nawadkar Sharad Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10184",
    "name": "Padave Shrikrishna Sabaji   File"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15704",
    "name": "Kadam Satish Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14456",
    "name": "Bodake Rajaram Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9446",
    "name": "Nimbalkar Suresh Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4225",
    "name": "Shinde Jalinadar Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17716",
    "name": "Raul Sarita Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10777",
    "name": "Pisal Ashok Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12603",
    "name": "Miss  Shinde Hausabai Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12614",
    "name": "Shinde Dinkar Ramaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9219",
    "name": "Jadhav Vanita Jyotiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4768",
    "name": "Phalke Dattatray Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9284",
    "name": "Nimbalkar Vyankat Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10339",
    "name": "Kharade Kamalakar Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10353",
    "name": "Kadam Balaso Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12610",
    "name": "Shinde Sakhubai Anaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16922",
    "name": "Shinde Suresh Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9429",
    "name": "Pisal Shivaji Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17713",
    "name": "Kolekar Ashok Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14666",
    "name": "Dhuri Omprakash Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4706",
    "name": "Chalake Baburao Mahadeo 490/1"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8070",
    "name": "Sadekar Prabhakar Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16711",
    "name": "Sawant Sambhaji Yeswant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10270",
    "name": "Shinde Rajendra Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4495",
    "name": "Jagtap Sampatrao Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21785",
    "name": "Gaikwad Sandesh Jabaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5382",
    "name": "Kadam Gajanan Jyotiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17336",
    "name": "Dhumal Usha Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17350",
    "name": "Ahirekar Shankar Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17449",
    "name": "Dhumal Ramesh Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9582",
    "name": "Jagtap Rajendra Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12611",
    "name": "Matre Tukaram Pandurang 728/19"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15995",
    "name": "Salte Shivaji Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10166",
    "name": "Shinde Sukhadeo Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10255",
    "name": "Pawar Subhash Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12594",
    "name": "Shinde Subhash Devaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6317",
    "name": "Jadhav Bhimrao Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9296",
    "name": "Gaikawad Shashikant Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12788",
    "name": "Mandave Pralhad Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15340",
    "name": "Phule Dattatray Trimbak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3111",
    "name": "Mandhare Prakash Jaysing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20932",
    "name": "Shaikh Mohd Shakil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13977",
    "name": "Shinde Vasant Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17296",
    "name": "Thakkar Ajay Bhagwandas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19309",
    "name": "Jadhav Nandkumar Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21853",
    "name": "Pal Ramesh Surendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21854",
    "name": "Kurmi Pramila Ramaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21855",
    "name": "Malwade Mitali Milind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21859",
    "name": "Sharma Vivek Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21861",
    "name": "Singh Rahul Rupnarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16824",
    "name": "Shinde Balbhim G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17109",
    "name": "More Dilip Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17125",
    "name": "Sarafdar Ankush"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17126",
    "name": "Lembhe Ravindra Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17128",
    "name": "Mulik Dattatray Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17147",
    "name": "Naik Deepak V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17183",
    "name": "Ghorpade Ravindra Amrutrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17184",
    "name": "Warke Krishna Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17194",
    "name": "Ahirekar Dilip Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17195",
    "name": "Sakunde Bharat Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17196",
    "name": "Dhumal Ramesh Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17197",
    "name": "Bhoite Ashok Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17201",
    "name": "Pisal Shahaji Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17212",
    "name": "Jadhav Namdeo Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17236",
    "name": "Shinde Vijay Sopanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17244",
    "name": "Shinde Satish Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17260",
    "name": "Chavan Shankar Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14138",
    "name": "Vichare Somnath Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7780",
    "name": "Jadhav Ramchandra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9493",
    "name": "Katkar Ashok Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9546",
    "name": "Jadhav Jagdish Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10083",
    "name": "Dhumal Vijaykumar Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6795",
    "name": "Pawar Dilip Marutarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22140",
    "name": "Bhandare Mangesh Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16780",
    "name": "Bhagwat Sopan Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16319",
    "name": "Ghatke Ramesh Maruti Toli 1448"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9958",
    "name": "Mulik Hanamant Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10068",
    "name": "Jadhav Manohar Jotiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12615",
    "name": "Shinde Pandurang Ranu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9765",
    "name": "Jagatap Dyandeo Uttam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21679",
    "name": "Rangavkar Karuna Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16888",
    "name": "Raikar Rajaram Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16890",
    "name": "Todkar Yashwant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16958",
    "name": "Bhoite Ashok Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16986",
    "name": "Chavan Ashok Trimbakrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16998",
    "name": "Pawar Sanjay Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17003",
    "name": "Jagtap Krishna Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17004",
    "name": "Jagtap Anita Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17015",
    "name": "Katekar Shivaji Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17047",
    "name": "Nimbalkar Murlidhar Jaysing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17069",
    "name": "Pawar Ramchandra Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17073",
    "name": "Shinde Jaipal Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17086",
    "name": "Sawant Gajanan Jijaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17186",
    "name": "Lembhe Vasantrao Narayanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17191",
    "name": "Dhumal Ratan Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17192",
    "name": "Sable Ramesh Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17199",
    "name": "Gaikwad Baban Gajaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "291",
    "name": "Jadhav Sitaram Tatya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9696",
    "name": "Yadav Shivaji Govinda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16810",
    "name": "Shah Paresh K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16813",
    "name": "Pawar Dilip D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16814",
    "name": "Pawar Savita Dilip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16821",
    "name": "Gaikwad Rajashree U"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16827",
    "name": "Raikar Manik Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16883",
    "name": "Valunj Sachin Satish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16918",
    "name": "Pawar Balaso Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17544",
    "name": "Yewale Suvarna Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7170",
    "name": "Barge Shanker Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16761",
    "name": "Babar Sandeep Jaywant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11450",
    "name": "Jadhav Shantaram Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "560",
    "name": "Sawant Balwant Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4664",
    "name": "Gandhi Vihachand Ratanchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7173",
    "name": "Pisal Ramchandra Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5995",
    "name": "Dhumal Harichandra Pilajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22763",
    "name": "Deshpande Gopal Natthuji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22768",
    "name": "Padyar Prabhakar Gokul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6700",
    "name": "Dangat Revaji Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16740",
    "name": "Kambale Prabhakar Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16667",
    "name": "Sahani Dharmendra Bechanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2195",
    "name": "Kadam Kundalik Dashrath 795/7"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7394",
    "name": "Salunkhe Shashikant Navnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9751",
    "name": "Dudhe Shamrao Raosaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9753",
    "name": "Phalake Ravindr Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9761",
    "name": "Sabale Pramod Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9789",
    "name": "Yadao Gulab Vijaysinh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9790",
    "name": "Yadao Saraswati Gulab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9811",
    "name": "Pisal Latabai Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11971",
    "name": "Shinde Vitthal Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17483",
    "name": "Patil Baburao Ishwara"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18762",
    "name": "Shinde Hanumant Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13573",
    "name": "Bhosale Laxman Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8614",
    "name": "Kalukhe Ramchandra Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20954",
    "name": "Patole Usha Shrikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9700",
    "name": "Dhumal Seema Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "704",
    "name": "Jaymali Balasaheb Gyanba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "676",
    "name": "More Shankarrao Daji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1427",
    "name": "Gujar Jagprasad Ramdhiraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3984",
    "name": "Chavan Tanaji Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14947",
    "name": "Matkar Prakash Bajirav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6674",
    "name": "Salunkhe Shivajirao D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21876",
    "name": "Bhosale Raju Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21879",
    "name": "Jagdale Uday Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17193",
    "name": "Sable Popat Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9635",
    "name": "Chougule Vasant Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13596",
    "name": "Bobade Anil Vyankat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5102",
    "name": "Kavade Dattatray Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9633",
    "name": "Phalke Samadhan Bajrang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14339",
    "name": "Shewale Suresh Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "837",
    "name": "Jadhav Shivram Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17300",
    "name": "Bansode Kalpana Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9904",
    "name": "Jagatap Pushpa Vasantarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10348",
    "name": "Bhagat Babai Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9565",
    "name": "Aware Hanmant Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17230",
    "name": "Kadam Sujata Bharat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8103",
    "name": "Anpat Hanmant Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12470",
    "name": "Pawar Sampat Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9350",
    "name": "Wagh Kalawati Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8091",
    "name": "Bhsale Madhukar Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1259",
    "name": "Ghadage Anandrao Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22538",
    "name": "Malvankar Santosh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15455",
    "name": "Matekar Kishor Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22478",
    "name": "Khairwar Ghanshyam Jainath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "345",
    "name": "Jadhav Dilip Sadhu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "417",
    "name": "Chavan Vijay Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14936",
    "name": "Ghorapade Santosh Abaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14219",
    "name": "Sawant Arjun Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7261",
    "name": "Shikhare Shrikant Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17150",
    "name": "Niwadunge Vitthal Shankar 1523-2"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21336",
    "name": "Mishra Radhe Radhesham"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9357",
    "name": "Salunkhe Laxmi Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9358",
    "name": "Salunkhe Sharada Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9282",
    "name": "Kale Appaso Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "987",
    "name": "Jaykar Maruti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12891",
    "name": "Mandhare Hasinand Vithalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4670",
    "name": "Shinde Jotiram K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16946",
    "name": "Mandhare Suresh Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15260",
    "name": "Pawar Nitin Arajun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9768",
    "name": "Shinde Bharati Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10078",
    "name": "Shinde Tulshiram Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12427",
    "name": "Chavan Bhaskar Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10313",
    "name": "Borage Kondiba Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10315",
    "name": "Attar Ajij Sardar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1376",
    "name": "Walke Sulochana Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17436",
    "name": "Nalawade Sudhir Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10193",
    "name": "Jedhe Ankush Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10265",
    "name": "Sabale Madhukar Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16202",
    "name": "Yadav Sadabraksh Chabilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25533",
    "name": "Londhe Ranjana Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13781",
    "name": "Kandare Namdeo Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2693",
    "name": "Pawar Yeshwant Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10013",
    "name": "Bhosale Prabhakar Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12599",
    "name": "Shinde Bhagirthi Munaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6499",
    "name": "Chavan Sudarshana Arvand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21977",
    "name": "Lad Sunil Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17842",
    "name": "Jadhve Kalash Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14090",
    "name": "Chavan Santosh Appasaheb 272/24"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15386",
    "name": "Patil Bhimrao Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7710",
    "name": "Shinde Kalyanrao Kisanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12253",
    "name": "Bhoite Ajit Raosaheb 137/9"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21910",
    "name": "Aher Milind Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2115",
    "name": "Bhosale Gulab Jaising"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4",
    "name": "Gujar Jaywant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8747",
    "name": "Nikam Jalinder Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9902",
    "name": "Kadam Vithal Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5937",
    "name": "Jagtap Shivajirao Daulatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3587",
    "name": "Kadam Dharmaji Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23185",
    "name": "Bhoite Pramod Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14264",
    "name": "Ulhalkar Tukaram Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9268",
    "name": "Mandhare Machhindranath Golabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7590",
    "name": "Sakunde Shivaji Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5047",
    "name": "Pandit Murlidhar Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5242",
    "name": "Raut Shakuntala Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9469",
    "name": "Jagtap Shalan Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20553",
    "name": "Jagtap Prakash Rajaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "838",
    "name": "Raut Chandrakant Rakmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12696",
    "name": "Kadam Ramchandra Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16574",
    "name": "Bhosale Lilabai Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13793",
    "name": "Pawar Ramdas Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17243",
    "name": "Nalawade Bahirnath Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12038",
    "name": "Mulik Sanjay Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6157",
    "name": "Chavan Balchandra Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9842",
    "name": "Bobade Raghunath Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5509",
    "name": "Kale Chandrakant Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17187",
    "name": "Lembhe Ramesh Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9786",
    "name": "Pawar Kalpana Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9800",
    "name": "Dhumal Avinash Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9801",
    "name": "Kokil Aappa Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9819",
    "name": "Chavan Pandurang Ramu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9820",
    "name": "Kadam Namadeo Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9822",
    "name": "Gole Dilip Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9834",
    "name": "Bhandari Rajan Kasturichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15048",
    "name": "Chandak Indrapal Singh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22394",
    "name": "Pawar Ganesh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22485",
    "name": "Sayyad Javed Usman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24055",
    "name": "Barge Shashikant Uttam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18229",
    "name": "Kalse Rajaram T"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16599",
    "name": "Jadhav Anil Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9708",
    "name": "Jagtap Jayant Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9724",
    "name": "Chavan Malti Bhagwantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9725",
    "name": "Kadam Pandurang Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9726",
    "name": "Miss  Kadam Vijaya Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9759",
    "name": "Bhosale Anita Pratapsinh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9767",
    "name": "Jagatap Sambhaji Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9814",
    "name": "Shinde Shiwaji Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8033",
    "name": "Harchure Vijay Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2420",
    "name": "Kadam Vinayak Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3598",
    "name": "Rakshe Ramdas Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9701",
    "name": "Dhumal Sambhaji Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8861",
    "name": "Phadtare Ramakant Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18075",
    "name": "Ruke Haresh Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21979",
    "name": "Berdiya Jiu Vinod"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5982",
    "name": "Jadhav Vijay Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1396",
    "name": "Solaskar Vilas Dagdoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9613",
    "name": "Ghadge Rajendrakumar Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9621",
    "name": "Kadam Dinkar Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9624",
    "name": "Wagh Sanjay Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9630",
    "name": "Shinde Shamrao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1484",
    "name": "Shingate Lalasaheb Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14950",
    "name": "Thite Tarabai Raju"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13742",
    "name": "Chawan Tanaji Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9360",
    "name": "Dhumal Nalini Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9413",
    "name": "Deshmukh Nandkumar Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9426",
    "name": "Kadam Vinod Vasantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9471",
    "name": "Kadam Dilip Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9472",
    "name": "Kadam Ramchandra Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10824",
    "name": "Madane Dhanaji Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12938",
    "name": "Jagtap Ramdas Raosaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12942",
    "name": "Yadav Ravikiran Dinkarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "703",
    "name": "Jaymali Ganpatrao Gyanba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14451",
    "name": "Matre Ramchandra Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17188",
    "name": "Dhumal Bhimrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17431",
    "name": "Vairat Krishna Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14229",
    "name": "Dekale Sulabha Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17180",
    "name": "Yadav Ramsajan Dharmaraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10577",
    "name": "Surve Sukhdeo Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6305",
    "name": "Pise Sadashiv Joti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15961",
    "name": "Shinde Pandurang Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10821",
    "name": "Hol Ramesh Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8904",
    "name": "Jadhav Shivaji Bhairu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4718",
    "name": "Jagtap Babanrao Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6470",
    "name": "Pawar Balwant Gopalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24220",
    "name": "Shetty Mulki Damodar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20864",
    "name": "Vichare Sushil Gajanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20867",
    "name": "Nikam Nitin Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20964",
    "name": "Pawar Hanmant Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20975",
    "name": "Kadam Ganesh Vitthalrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21140",
    "name": "Pawar Vanita Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21141",
    "name": "Kedari Dattaram Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21162",
    "name": "Singh Sureshkumar Brijraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21193",
    "name": "Pidade Vilyam Moses"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21218",
    "name": "Jadhav Sunil Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21220",
    "name": "Pawar Krushna Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16834",
    "name": "Bhoite Kalpana Dattatrya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3924",
    "name": "Kharat Ramchandra Dadaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14470",
    "name": "Salunkhe Dagadu Balku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11477",
    "name": "Naikawadi Pravin Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17791",
    "name": "Sawant Arjun Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2652",
    "name": "Shinde Chandrakant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24213",
    "name": "Yadav Suchanda Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24214",
    "name": "Patil Vikas Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24217",
    "name": "Keni Pramod Chintaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24197",
    "name": "Iyer Vivekanand Sankaranarayanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20548",
    "name": "Patil Amit Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20616",
    "name": "Vishwakarma Dinesh Nanelal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20622",
    "name": "Parab Anant Dhaku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20654",
    "name": "Shinde Hanumant Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20655",
    "name": "Nagaonkar Sandeep Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20656",
    "name": "Vishwakarma Rajesh Nanhelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25615",
    "name": "Kasalkar Anant Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25622",
    "name": "Pawar Ritesh Shivchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25623",
    "name": "Sale Sachin Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13184",
    "name": "Kadam Maruti Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6788",
    "name": "Jadhao Shrikant Sopanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6158",
    "name": "Bhilare Subhash Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9763",
    "name": "Jadhao Shiwaji Dada"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24178",
    "name": "Pol Veerdhaval Nathu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24179",
    "name": "Bagle Manoj Sahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24185",
    "name": "Hegde Rohan Kumar Chandayya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24186",
    "name": "Shetty Vinod Sanjiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20545",
    "name": "More Navanath Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20546",
    "name": "Ithape Dharamraj Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1087",
    "name": "Gade Vasant Appasaheb"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1992",
    "name": "Prajapati Mayur Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5234",
    "name": "Jadhav Subhash Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22511",
    "name": "Patade Bhaskar Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22553",
    "name": "Chavan Prashant Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22647",
    "name": "Bagwe Vasant Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22648",
    "name": "Prajapati Devnarayan Ramjivan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22658",
    "name": "Jagtap Raj Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24171",
    "name": "Sinnarkar Tanmay Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24172",
    "name": "Sinnarkar Neha Tanmay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24173",
    "name": "Sinnarkar Jagannath Nanabhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24174",
    "name": "Sinnarkar Vijaya Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15535",
    "name": "Gadhave Sachin Nivrutti"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1976",
    "name": "Monterion Gordon Maurice"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1977",
    "name": "Jain Mahendra Amichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12588",
    "name": "Mohite Ashok Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20121",
    "name": "Bhosale Pandurang Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22468",
    "name": "Ithape Abhay Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23112",
    "name": "Chorge Arjun Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25578",
    "name": "Hanumanadans Naresh Sidupapa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15526",
    "name": "Sawant Anil Namdeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3198",
    "name": "Ray Balyugeshwar Harikoshor"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8613",
    "name": "Shinde Madhukar Rupchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8614",
    "name": "Shewate Rajendra Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9658",
    "name": "Bhoite Lalaso Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8201",
    "name": "Sabale Dattatray Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3892",
    "name": "Chavan Wamanrao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22421",
    "name": "Hate Himanshu Narendranath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15505",
    "name": "Ghorpade Sushant Sudhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6253",
    "name": "Pawar Suresh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15483",
    "name": "Sawant Harshad Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15484",
    "name": "Sawant Tejas Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6803",
    "name": "Solskar Jaganath Aanandarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17270",
    "name": "Chavan Asha Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8370",
    "name": "Kadam Dattatry Shrirang  Toli No 37"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13645",
    "name": "Jawalkar Nirmala Vasantarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6364",
    "name": "Chawan Ramchandra Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22444",
    "name": "Narkar Subhash Babaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19509",
    "name": "Nikam Vijay Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16425",
    "name": "More Rajesh Aatmaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1729",
    "name": "Upadhya Upadhya Lavkushkumar Krishnakumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9632",
    "name": "Pawar Nivas Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2234",
    "name": "Bhoite Prakash Lalasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9105",
    "name": "Pawar Prakesh Dnynu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21575",
    "name": "Shinde Anil Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21578",
    "name": "Ghadge Pravin Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21580",
    "name": "Gurav Shashikant Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13961",
    "name": "Jadhav Sandip Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2586",
    "name": "Sawant Anandrao Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11028",
    "name": "Chavan Mayur Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13649",
    "name": "Rajendra Jijaba Shinde"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16242",
    "name": "Kadam Rajendra Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "42",
    "name": "Kolekar Kisan Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3137",
    "name": "Bhosale Baban Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22245",
    "name": "Khan Mohd Farooq Shabbir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10840",
    "name": "Nalawade Sanjay Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21967",
    "name": "Deshmukh Neeta Vinod"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8198",
    "name": "Ghanwat Pralhad Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18743",
    "name": "Chawan Satish Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2155",
    "name": "Pise Shivaji Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11918",
    "name": "Pachupate Mahadeo Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12289",
    "name": "Pawar Hanmant Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12149",
    "name": "Wagh Vikas Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5516",
    "name": "Nalge Kisan Amruta"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13642",
    "name": "Veer Satyajit Suresh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2531",
    "name": "Disale Yashwant Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6189",
    "name": "Jagtap Dilip Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5019",
    "name": "Ghorpade Dharmraj Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10171",
    "name": "Sutar Tyaba Ibrahim"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "57",
    "name": "Pisal Dinkar Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21830",
    "name": "Yadav Kiran Balu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21851",
    "name": "Pagare Mahendra Nimba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21859",
    "name": "Gaikar Karuna Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3617",
    "name": "Lembhe Manik Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9687",
    "name": "Pisal Shivaji Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7384",
    "name": "Rajamne Vinayak Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15697",
    "name": "Nivilkar Manda Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12136",
    "name": "Salunkhe Ramchandra Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4323",
    "name": "Kadam Maruti Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9961",
    "name": "Sakunde Madhukar Baliram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1137",
    "name": "Chavan Rangrao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17106",
    "name": "Jagtap Ramrao Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9461",
    "name": "Jagtap Vilas Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13890",
    "name": "Pawar Sharda Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13891",
    "name": "Jadhav Rupali Satish"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13893",
    "name": "Jadhav Vidya Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13894",
    "name": "Miss  Ghorpade Supriya Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13895",
    "name": "Miss  Ghorpade Sheetal Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13896",
    "name": "Jadhav Jaywant Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13899",
    "name": "Nikam Adhinath Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "471",
    "name": "Pabale Thakuji Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23507",
    "name": "Kamble Kumar Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13412",
    "name": "Shaikh Shoyeb Rashid"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13413",
    "name": "Shaikh Haidarali Rashid"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13414",
    "name": "Barshikar Bapusaheb Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11629",
    "name": "Pawar Chhaya Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17369",
    "name": "Shinde Appasaheb Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21290",
    "name": "Varma Chandrabhan Avshan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5800",
    "name": "Pisal Arvind Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8978",
    "name": "Shinde Chandrakant' Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5711",
    "name": "Ghorpade Sudhakar Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5650",
    "name": "Dhumal Chandrakant Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13092",
    "name": "Pawar Nirmal Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13647",
    "name": "Bagwan Abidali Mohmadhusen"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15408",
    "name": "Gaikwad Rahul Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20696",
    "name": "Shelatkar Wishwambhar Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12262",
    "name": "Gole Dashrath Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18390",
    "name": "Yadav Balkrishna Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21968",
    "name": "Sawant Sambhaji Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22715",
    "name": "Gangarde Goverdhan Kasinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22798",
    "name": "Parab Sayali Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22799",
    "name": "Bagawe Kripa Gurunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19156",
    "name": "Godase Rajaram Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21621",
    "name": "Salve Janu Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22203",
    "name": "Shinde Sandeep Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18429",
    "name": "Sawant Navnath Sadashiv"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1836",
    "name": "Gawade Deepak Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16852",
    "name": "Chavan Kishore Dattoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6401",
    "name": "Jadhav Tukaram Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20524",
    "name": "Marathe Prakash Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6945",
    "name": "Nikam Adhikrao Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14208",
    "name": "Pathan Mohammad Umar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4963",
    "name": "Chavan Nivasrao Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10874",
    "name": "Anapat Uttam Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13943",
    "name": "Ghatage Vijay Dinkar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "699",
    "name": "Aher Sanjay Kundlik"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "717",
    "name": "Chavan Nilkanth Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21188",
    "name": "Salunkhe Rahul Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17996",
    "name": "Dakve Pravin Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6164",
    "name": "Bobade Kisan Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17138",
    "name": "Shelar Mahadeo Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6544",
    "name": "Nimbalkar Sanjay Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22151",
    "name": "Shikhare Tushar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18038",
    "name": "Londhe Pankaj Adinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16605",
    "name": "Dhumal Ashok Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3427",
    "name": "Phalake Balasaheb Yadaorao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7922",
    "name": "Sabale Anil Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9545",
    "name": "Welekar Dilip Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18178",
    "name": "Upendra Putan Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13058",
    "name": "Dane Rajendra Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9201",
    "name": "Jagtap Jalinder Baburao 1104/7"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18404",
    "name": "Vitnor Popat Jaggnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14376",
    "name": "Dhebare Prabhakar Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20993",
    "name": "Jagatap Dattatray Raghunath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3057",
    "name": "Shahu Pinki Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13079",
    "name": "Baniye Jagdish Asharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8887",
    "name": "Salunkhe Arjun Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1849",
    "name": "Pisal Suresh Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9346",
    "name": "Pisal Mansing Babasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11012",
    "name": "Kadam Santosh Kondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3796",
    "name": "Salunkhe Bhimrao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12152",
    "name": "Sabale Vilas Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10526",
    "name": "Pisal Meghshyam Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2409",
    "name": "Chavan Shankar Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14702",
    "name": "Rananavare Satish Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3956",
    "name": "Shingate Shankar Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20646",
    "name": "Chavan Swati Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21632",
    "name": "Sutar Sudhakar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9328",
    "name": "Shinde Vanita Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8684",
    "name": "Salunkhe Pandurang Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16240",
    "name": "Bhoite Sambhaji Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16315",
    "name": "Dhumal Rajaram Dagadoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16355",
    "name": "Vichare Madhukar Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12458",
    "name": "Mahajan Kishor Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "710",
    "name": "Gaikawad Jagannath Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4833",
    "name": "Nimbalkar Pralhad Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10383",
    "name": "Garde Sambhaji Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7562",
    "name": "Kadam Sopan Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10797",
    "name": "Kadam Sambhaji Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18059",
    "name": "Tambe Sunita Dipak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18033",
    "name": "Shinde Santosh Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6148",
    "name": "Nimbalkar Hindurao Sampatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17081",
    "name": "Gaikwad Sunil Ramchandra/Gaikwad Vijaya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12615",
    "name": "Kakade Gorakh Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23309",
    "name": "Lokhande Kiran Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3214",
    "name": "Wagh Pandurang Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12300",
    "name": "Dudhe Ramesh Janardhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13441",
    "name": "Dhamal Rajendra Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "126",
    "name": "Kadam Sadashiv Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13808",
    "name": "Mulik Ramesh Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17077",
    "name": "Gade Laxman Haribhau B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8204",
    "name": "Nikam Dashok Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8237",
    "name": "Shinde Shankar Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15426",
    "name": "Dhanawde Mahesh Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9668",
    "name": "Chikane Chandrakant Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12605",
    "name": "Chavan Shankar Rakhamaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3937",
    "name": "Dhumal Chandrakant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11302",
    "name": "Nawadkar Deepak Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7169",
    "name": "Desai Rajendra Bajrang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11340",
    "name": "More Rahul Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20862",
    "name": "Naik Mangesh Harinchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7792",
    "name": "Falake Janardhan Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9396",
    "name": "Honrao Vishwanath Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13011",
    "name": "Shirke Vishnu Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3409",
    "name": "Gadekar Shalini Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4634",
    "name": "Jagtap Hanmant Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17364",
    "name": "Sayyed Gulab Chand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "389",
    "name": "Tiwari Vinodkumar Mataprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20931",
    "name": "Memon Rahim Ebrahim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21463",
    "name": "Salvi Shilpa Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11718",
    "name": "Malap Chandrakant H"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17071",
    "name": "Kolekar Sakharam Dnyadeo  Tn 1457-13"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13468",
    "name": "Nimbalkar Sandip Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13459",
    "name": "Yadav Suresh Kundalik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22376",
    "name": "Surve Milind Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10461",
    "name": "Momin Firoz Mahmmad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11303",
    "name": "Chavan Mohan Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16789",
    "name": "Pisal Shivaji Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8238",
    "name": "Solaskar Babanrao Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10832",
    "name": "Bhilare Shakuntala Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5212",
    "name": "Chavan Dhansing Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9304",
    "name": "Pawar Hanmant Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20953",
    "name": "Patole Shrikant Gopichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "937",
    "name": "Shinde Suresh Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17948",
    "name": "Matre Sunanda Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13917",
    "name": "Waghmare Shivaji Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9526",
    "name": "Mandhare Duryodhan H  757/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "687",
    "name": "Chavan Arjun Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2771",
    "name": "Vichare Tukaram Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4148",
    "name": "Bhoite Popat Mansing 443-45"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8569",
    "name": "Raje Daulatrao Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3861",
    "name": "Jadhav Anandrao Krushnaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5581",
    "name": "Mane Gautam Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10371",
    "name": "Shinde Sudam Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14300",
    "name": "Kadam Manohar S T No 408/5"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17143",
    "name": "Ghorpade Anandrao Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17629",
    "name": "Shinde Bhalerao Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18527",
    "name": "Dhumal Dattatray Kalyanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18686",
    "name": "Pawar Vijaykumar Krishnrav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9692",
    "name": "Jadhav Yashwant Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "322",
    "name": "Phalke Sahebrao Gopala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15152",
    "name": "Ghanvat Sanjay Dnyndeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16372",
    "name": "Chavan Ramchandra Mahadeo Toli No 510/B/"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3276",
    "name": "Ahirekar Vasant Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2231",
    "name": "Kadam Hemant Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11226",
    "name": "Pawar Vilas Ganapat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13036",
    "name": "Jadhav Vishwanath Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4119",
    "name": "Jagtap Dilip Dajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20537",
    "name": "Chavan Balasaheb Balvant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13629",
    "name": "Ghadge Vikas Dhansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13247",
    "name": "Acharekar Vijay Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "370",
    "name": "Mane Dnyaneshwar Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15938",
    "name": "Salunkhe Shivaji Chindrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21836",
    "name": "Chavan Satish Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7770",
    "name": "Ambike Umesh Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14924",
    "name": "More Subhash Anada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9539",
    "name": "Ahirekar Satish Sadashiv 437/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4512",
    "name": "Shinde Suresh Appa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5757",
    "name": "Kadam Vithal Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20067",
    "name": "Nikam Swapnil Dilip"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20364",
    "name": "Veturkar Chandrashekhar J"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5086",
    "name": "Patil Ashok Jagannath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2169",
    "name": "Gunjal Sudeep Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8118",
    "name": "Jagtap Rajendra Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9340",
    "name": "Kadam Gunaji Dattu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18320",
    "name": "Jadhav Santosh Baburav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20863",
    "name": "Panse Shashikant Sharad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14303",
    "name": "Bankar Prakash A  299/25"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12077",
    "name": "Kadam Sadashiv Ananda"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "501",
    "name": "Khokarale Dinesh Sudam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11069",
    "name": "Ithape Seema Sharad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14263",
    "name": "More Shankar Dhondiba 1133/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19323",
    "name": "Malusare Anil Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2879",
    "name": "Kadam Bhimrao Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13565",
    "name": "Gurkha Kamal Nayansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13509",
    "name": "Gaikwad Ananda Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21481",
    "name": "Parkar Tukaram Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21485",
    "name": "Rane Shreyas Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4502",
    "name": "Dhumal Hanmant Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6060",
    "name": "Nalawade Syresh Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11384",
    "name": "Suryawanshi Dattatray Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1637",
    "name": "Bhoite Shivaji G  53/7"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9249",
    "name": "Khanolkar Suresh Damoder"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3474",
    "name": "Gadekar Mohan Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12832",
    "name": "Dhumal Vilas Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14588",
    "name": "Chawan Sandesh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6875",
    "name": "Mane Madhu Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13281",
    "name": "Khopade Satish Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21029",
    "name": "Bhuwad Prashant Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21466",
    "name": "Surve Samir Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13441",
    "name": "Jadhav Adhik Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19039",
    "name": "Jadhav Appa Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22642",
    "name": "Sonawane Sweta Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13420",
    "name": "Kulkarni Sharadchandra Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13421",
    "name": "Kulkarni Tejaswini Sharadchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5714",
    "name": "Galinde Kishor Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9004",
    "name": "Godambe Shantaram Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13661",
    "name": "More Raghunath Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13813",
    "name": "Punekar Chandrakant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12887",
    "name": "Gadekar Jagdish Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8549",
    "name": "Kadam Mahendra Vyankatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "805",
    "name": "Kadam Ramrao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1346",
    "name": "Solaskar Bhagwan Appaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11326",
    "name": "Dhumal Ravindra Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1059",
    "name": "Pisal Aabaji Jagdevrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5305",
    "name": "Zunjare Hanamant Shankarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12765",
    "name": "Jadhav Mahendra Tanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8998",
    "name": "Chavan Sharda Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17102",
    "name": "Taigade Rajendra Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18111",
    "name": "Harchirkar Shabbir A Rahiman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18238",
    "name": "Vadke Satish Balaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18240",
    "name": "Amipara Vinod Haribhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18359",
    "name": "Bagve Kamlakar Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18371",
    "name": "Gurav Suresh Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15043",
    "name": "Phalke Dhiraj Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10019",
    "name": "Gole Dattatray Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18103",
    "name": "Juwatkar Sharad Sahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15289",
    "name": "Jamdar Arvind Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2653",
    "name": "Chawan Shrirang Rau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11369",
    "name": "Nimbalkar Sanjay Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12489",
    "name": "Bhoite Shivaji Jagdeorao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18522",
    "name": "Suryavanshi Viswas Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6270",
    "name": "Nimbalkar Ravindra Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18014",
    "name": "Agnel Aril Thomas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8783",
    "name": "Yadav Sunil Parshram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1542",
    "name": "Nimbalkar Mahadev Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "317",
    "name": "Yadav Mugatrao Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6855",
    "name": "Kadam Ajay Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18863",
    "name": "Vakte Shankar Ramu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2232",
    "name": "Dhole Rufi Abdul Aziz"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2912",
    "name": "Tiwari Pavankumar Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17633",
    "name": "Chaugule Shubhangini Subhash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17648",
    "name": "Kambale Vilas Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10896",
    "name": "Dhaware Dilip Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8755",
    "name": "Mandave Chandrakarnt Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14821",
    "name": "Sawant Sachin Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2177",
    "name": "Hule Vasant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11490",
    "name": "Miss  Chavan Shobha Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20604",
    "name": "Bawle Sachin Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20960",
    "name": "Shinde Pravin Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21136",
    "name": "Ingle  Devidas Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21190",
    "name": "Sawant Sachin Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21253",
    "name": "Jadhav Sangram Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21254",
    "name": "Kambale Amol Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16972",
    "name": "Kadam Vikas Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8852",
    "name": "Jogi Ramkeval Harihan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13433",
    "name": "Khopade Sandip Vitthalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11258",
    "name": "Kadam Suresh Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20776",
    "name": "Chavan Pradeep Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1404",
    "name": "Bhoite Hariba Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2040",
    "name": "Mandhare Dnyandev Mandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18338",
    "name": "Jagtap Rajeshri Jitendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3895",
    "name": "Jadhav Dharmaraj Nivrutti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17259",
    "name": "Pansare Dilip Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20608",
    "name": "More Ajay Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7387",
    "name": "Kadam Ashok Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10325",
    "name": "Chavan Mahadeo Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8676",
    "name": "Dhawale Dattatraya Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20300",
    "name": "Dabholkar Manoj Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2875",
    "name": "Shinde Hanmant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3343",
    "name": "Mandhare Vishwas Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1640",
    "name": "Sabale Sambhaji Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5850",
    "name": "Anapat Shivaji Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12053",
    "name": "Nikam Ashok Dnyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18870",
    "name": "Shinde Ankush Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20034",
    "name": "Suryawanshi Baburao Sadhu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20043",
    "name": "Salunkhe Mahipati Nathuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20064",
    "name": "Mandhare Sachin Dhondiba"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "427",
    "name": "Sapkal Dilip Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11952",
    "name": "Raskar Ramesh Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20241",
    "name": "Jadhav Bhimrao Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20276",
    "name": "Pawar Pradip Gagngaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22646",
    "name": "Bagwe Uday Vitthal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "154",
    "name": "Bhoite Jagannath Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13509",
    "name": "Jadhav Sangita Nanaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20240",
    "name": "Billimoria Kurush Jimmy"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7993",
    "name": "Salunkhe Pravin Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12196",
    "name": "Sakunde Kondiram Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8085",
    "name": "Bhosale Anil Atamaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16963",
    "name": "Malusare Maruti Laxman  1126-29"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21656",
    "name": "Nathe Pushpa Hiraman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21753",
    "name": "Dubey Laxmikant Parasnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16482",
    "name": "Gaikwad Arun Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22420",
    "name": "Tripathi Satyadev Ramnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21460",
    "name": "Kadam Sachin Chandrakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3118",
    "name": "Dodhia Vinit Pravin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12858",
    "name": "Panskar Pandurang Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17519",
    "name": "Tambe Rupali Balkrushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14019",
    "name": "Tikhe Hari Devaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13820",
    "name": "Pawar Santosh Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19182",
    "name": "Mandhare Supriya Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19236",
    "name": "Singh Harpreet Kaur Talvindar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19298",
    "name": "Giri Chandramohan Ramprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13121",
    "name": "Sakunde Ashok Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3458",
    "name": "Bhoite Mohan Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23316",
    "name": "Ghatge Vanita Avinash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23317",
    "name": "Baddade Sunita Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23319",
    "name": "Gupta Sureshkumar R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23320",
    "name": "Venenkot Sharad Shankaran"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4403",
    "name": "Jagtap Laxman Balkrushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3015",
    "name": "Chawan Suresh Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9787",
    "name": "Phalke Vinod Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "180",
    "name": "Sutar Mahadeo Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15332",
    "name": "Kithe Sadashiv Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19631",
    "name": "Tambe Sudha Vishavnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21387",
    "name": "Pawar Dilip Genaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19541",
    "name": "Bhagat Sanjay Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6522",
    "name": "Ghadage Hiralal Abaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21807",
    "name": "Mandale Vasant Bhairu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3159",
    "name": "Nikam Popat Yashawant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16496",
    "name": "Kadam Hanmant Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20168",
    "name": "Chavan Baban Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12832",
    "name": "Sadekar Sandhya Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12910",
    "name": "Tankaria Jayesh Ramniklal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20908",
    "name": "Chavan Ketan Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3952",
    "name": "Bhosale Pandurang Rau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11189",
    "name": "Jadhav Shreekant Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13641",
    "name": "Veer Anjali Satyajit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4009",
    "name": "Shinde Vijaysing Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6856",
    "name": "Chavan Anil Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7630",
    "name": "Ghadge Chandrakant Dharmaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12091",
    "name": "Bhosale Vijay Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22018",
    "name": "Keskar Amol Jaysingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17381",
    "name": "Wagh Santosh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13424",
    "name": "Dhumal Pradeep Uttamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17446",
    "name": "Bambras Shrirang Umaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "37",
    "name": "Salunkhe Balkrushna Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6978",
    "name": "Phalake Shakuntala Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11193",
    "name": "Shinde Uttam Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16937",
    "name": "Bhamle Ramesh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9505",
    "name": "Phalke Shashikant Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10332",
    "name": "Sabale Shankar Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "605",
    "name": "Gaikar Natha Gunaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "957",
    "name": "Yadav Shriprasad Ramdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18814",
    "name": "Gardi Machindra Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5841",
    "name": "Wagh Mohan Mahipati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10736",
    "name": "Kadam Ramesh Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13429",
    "name": "Kadam Vilas Ramchandra   A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18313",
    "name": "Solaskar Nanda Ashok"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1863",
    "name": "Saroj Munnakumar Hublal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1864",
    "name": "Kank Pradeep Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4513",
    "name": "Jadhav Bhagwan Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11634",
    "name": "Jadhav Suman Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7193",
    "name": "Pisal Anandrao Marutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6693",
    "name": "Kadam Prabhakar Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16802",
    "name": "Shinde Mahesh Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14382",
    "name": "Bhosale Sakharam Chimaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11118",
    "name": "Chavan Prakash Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20874",
    "name": "Dhavare Dinesh Vishwanathrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20875",
    "name": "Bhere Anil Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20120",
    "name": "Pawar Nitin Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17505",
    "name": "Shaikh Sultan Allabaksha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "42",
    "name": "Gadhve Vasantrao Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11558",
    "name": "Pawar Deepak Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16858",
    "name": "Shinde Dattatrey Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9917",
    "name": "Yadav Bajirao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1788",
    "name": "Dhumal Dhansing Dadasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "666",
    "name": "Nivatkar Mahadeo Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19308",
    "name": "Pingat Maruti Sidray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7124",
    "name": "Sonawane Vilas Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10716",
    "name": "Ghadage Bhimrao Narayanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20184",
    "name": "Jadhav Kavidas Shanawar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21325",
    "name": "Shah Tej Bahadur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17290",
    "name": "Garde Sandeep Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14855",
    "name": "Bhosale Santosh Pralhad  Tn-22-B-10"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21824",
    "name": "Shaikh Enusshaikh Mohmad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21832",
    "name": "Mohammad Amin Hanif"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21847",
    "name": "Shaikh Mohamad Salim Mohmad Ibrahim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21889",
    "name": "Solanki Dharmaji Bhuraji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22180",
    "name": "Panday Darshana Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9210",
    "name": "Shelake Ramchandra S  1036/15"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2308",
    "name": "Sharma Surya Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5342",
    "name": "Jadhav Baliram Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23542",
    "name": "Jain Anil Naresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21284",
    "name": "Soni Murlidhar Radhakrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18624",
    "name": "Chile Mohan Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10636",
    "name": "Sapkal Ganapat Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22387",
    "name": "Salunkhe Ananda Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17058",
    "name": "Dukhande Ajit Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17083",
    "name": "Gaikwad Dattaram Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20536",
    "name": "Manjrekar Ganesh Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20437",
    "name": "Kadam Manohar Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20459",
    "name": "Nene Abhay Prabhakar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20460",
    "name": "Pathare Ranjan R"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20493",
    "name": "Adivarekar Niketan Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20494",
    "name": "Jathar Anil Motiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20505",
    "name": "Pillai K  Vigneshwaran"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20506",
    "name": "Shelar Suresh Anna"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1562",
    "name": "Jadhav Prathama Nilish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15596",
    "name": "Matre Ravindra Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22315",
    "name": "Virkar Ashok Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22326",
    "name": "Andhale Babaji Sabaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22342",
    "name": "Inamdar Arshad Javed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18437",
    "name": "Borage Nivruti Dnyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20396",
    "name": "Kamble Sanjay Bhimrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15400",
    "name": "Jagtap Sangita Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12440",
    "name": "Jagtap Balaso Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21862",
    "name": "Sharma Sandeep Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9788",
    "name": "Raje Datta Ramchandra 456/16"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11038",
    "name": "Solaskar Pramod Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9524",
    "name": "Mohite Sambhaji Banyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22258",
    "name": "Dhumal Mahendra Parmeshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7795",
    "name": "Bhoite Ashok Hanmant 169/"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6400",
    "name": "Jagtap Kantilal Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12877",
    "name": "Bhoite Rajendra Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17577",
    "name": "Dhumal Ravindra Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11508",
    "name": "Gaikawad Baba Atmaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5730",
    "name": "Bhoite Chandrasen Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2547",
    "name": "Deshmikh Shivaji Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24158",
    "name": "Haldankar Sunil Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "85",
    "name": "Bankhele Popat Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9238",
    "name": "Solaskar Shivaji Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9131",
    "name": "Shinde Suresh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8601",
    "name": "Madane Vishwas Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22189",
    "name": "Miss  Thorat Mamata Vishwasrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14336",
    "name": "Pawar Nitin Bhagwanb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22105",
    "name": "Kolekar Nilesh Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20115",
    "name": "Shelake Prakash Shripatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16062",
    "name": "Ambekar Sakharam Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13469",
    "name": "Kadam Ramchandra Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13723",
    "name": "Bhondwe Lata Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11709",
    "name": "Pisal Suresh Subhedar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17501",
    "name": "Rane Satish Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25076",
    "name": "Bhowmika Riyaa Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6043",
    "name": "Jagdale Jagannath Mukundrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21096",
    "name": "Thorat Santosh Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21097",
    "name": "Thorat Bhagwan Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16150",
    "name": "Bhandirge Chandrakant Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15074",
    "name": "Chavan Manoj Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15077",
    "name": "Khamkar Dhananjay Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15078",
    "name": "Sonawane Suryakant Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15079",
    "name": "Ghorpade Digamber Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15083",
    "name": "Pol Girish Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10852",
    "name": "Salunkhe Rajendra Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11505",
    "name": "Rathod Bhupeshkumar Mohanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23737",
    "name": "Jain Hasmukh Amichand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13824",
    "name": "Awalkanthe Manjusha Kishor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7152",
    "name": "Parab Dilip Krishnaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14333",
    "name": "Pharande Hanmant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14997",
    "name": "Bhapkar Mininath Pandharinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17086",
    "name": "Shelar Rajendra Dnyanoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20070",
    "name": "Kasurde Ankush Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15061",
    "name": "Dudhe Vikram Nagnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15062",
    "name": "Inamdar Aasma Najir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9827",
    "name": "Kudale Shivaji Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15945",
    "name": "Sabale Ananda Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13967",
    "name": "Yadav Taraprasad Durgaprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1479",
    "name": "More Dnyanu Kondi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5161",
    "name": "Chavan Ranjana Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10450",
    "name": "Kudale Suresh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9318",
    "name": "Jagtap Vilas Shivajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3914",
    "name": "Pawar Vitthal Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18788",
    "name": "Bhoite Sarjerao D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10946",
    "name": "Nalawade Ashok Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22786",
    "name": "Jadhav Kamalakar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15013",
    "name": "Dhumal Jagannath Gulabarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15020",
    "name": "Dhumal Mohan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15024",
    "name": "Pisal Rajendra Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15027",
    "name": "Raut Rajaram Balaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12910",
    "name": "Patil Subhash Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14886",
    "name": "Bandekar Sandesh Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11653",
    "name": "Parab Arvind Dashrath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23689",
    "name": "Das Mansi Manoj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23690",
    "name": "Pillai Mohankumar Venugopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23697",
    "name": "Mohite Tushar Sampatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15654",
    "name": "Patel Veena Babulal & Babulal M Patel"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7174",
    "name": "Bhagwat Aadik Savalaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "921",
    "name": "Sawant Amol Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16854",
    "name": "Shinde Baburao Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13229",
    "name": "Jadhav Vikas Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11048",
    "name": "Chavan Gangaram Ramsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8166",
    "name": "Phalke Sanjay Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1840",
    "name": "Chavan Tanaji Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "39",
    "name": "Phalke Anandrao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12146",
    "name": "Awari Rangnath Damu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "88",
    "name": "Shinde Maruti Vithal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "46",
    "name": "Shelke Balasaheb Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1355",
    "name": "Bhosale Madan Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7001",
    "name": "Pawar Sunil Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13237",
    "name": "Dilip Haribhau Shingate"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11301",
    "name": "Bhalerao Pandharinath B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20160",
    "name": "Kank Raju Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13730",
    "name": "Ghorpade Santosh Malhari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4247",
    "name": "Jadhav Baburao Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4514",
    "name": "Jadhav Sarjerao Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17025",
    "name": "Matre Pilaji Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10242",
    "name": "Prabhu Dinesh Narsinha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5425",
    "name": "Thombare Ramchandra Bhairu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15984",
    "name": "Geeri Bharat Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8865",
    "name": "Kadam Chandu Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17095",
    "name": "Jagtap Hanmant Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22677",
    "name": "Manjrekar Arun Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22764",
    "name": "Deshpande Monika Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10901",
    "name": "Shinde Sulochana Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4360",
    "name": "Lembhe Popat Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15453",
    "name": "Taware Santosh Sampat 27/B/68"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8031",
    "name": "Bhagwat Namdeo Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7150",
    "name": "Bhosale Mansing Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23662",
    "name": "Sayed Nisar Ahmed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18976",
    "name": "Khopade Bhupendra Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2245",
    "name": "Chavan Narayan Keshavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22276",
    "name": "Gavas Rajendra Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14956",
    "name": "Darekar Abhijit Shivaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2378",
    "name": "Ghag Shirish Anant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2379",
    "name": "Patil Kasturi Sachin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2380",
    "name": "Patil Sachin Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18995",
    "name": "Joshi Chandrakant Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3873",
    "name": "Jagtap Shrirang Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23618",
    "name": "Jadhav Deepak Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23619",
    "name": "Ajabe Dadasaheb Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14942",
    "name": "Nalawde Suryakant Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22479",
    "name": "Nalage Prakash Ankush"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23611",
    "name": "Vaje Ashok Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23614",
    "name": "Mhatre Tukaram Lahu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2102",
    "name": "Said Laxman Chimaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9955",
    "name": "Dhumal Vishwas Dinakarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14919",
    "name": "Pawar Kishor Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10899",
    "name": "Kadam Bhiku Parshram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4814",
    "name": "Phalke Anil Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17222",
    "name": "Dhumal Kiran Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23590",
    "name": "Shetye Sanjay Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23591",
    "name": "Mahadik Rajendra Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23593",
    "name": "Shetye Kavita Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3212",
    "name": "Palaskar Sampat Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14876",
    "name": "Pawar Pramod Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14877",
    "name": "Pawar Jayawant Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4620",
    "name": "Zanzurne Hari Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8066",
    "name": "Bapkar Sampatrao Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9200",
    "name": "Shinde Ravindra Amarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13345",
    "name": "Pawar Sadashiv Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14854",
    "name": "Pathan Benzaer Vajirkhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14866",
    "name": "Gaikwad Sadashiv Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19957",
    "name": "Belvai Kiran Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21984",
    "name": "Dethe Rajendra Rajendra  Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21989",
    "name": "Ankush Ashok Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21990",
    "name": "Misal Popat Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21999",
    "name": "Manjrekar Purshottam Ramakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22001",
    "name": "Ansari Eisa Allaudin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22015",
    "name": "Giri Bhaskar Rambharan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22016",
    "name": "Guptta Motichand Punni"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22017",
    "name": "Miss  Shedge Pramila Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22023",
    "name": "Mishra Rampal Deotadin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22024",
    "name": "Bagakar Prakash Dwarkanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22026",
    "name": "Ahire Raju Nanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8603",
    "name": "Pawar Vasant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9935",
    "name": "Shelake Rajendra Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12862",
    "name": "Mane Hariba Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3655",
    "name": "Kadam Ganpatrao Rambhau 33/14"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15504",
    "name": "Kolekar Uttam Parshram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23568",
    "name": "Sakharkar Meera Devidas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23569",
    "name": "More Reena Vishal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23570",
    "name": "Sakharkar Santosh Bhagwat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23574",
    "name": "Sawant Avinash Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18245",
    "name": "Bhakre Yeshwant Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24474",
    "name": "Khadka Ram Singhe"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1461",
    "name": "Aligeti Srinivas Narsaiah"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13603",
    "name": "Musale Rajesh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16933",
    "name": "Pawar Tanaji Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "507",
    "name": "Mandhare Bhanudas S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12777",
    "name": "Gaikwad Bhimrao Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6716",
    "name": "Bhosale Sampat Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14275",
    "name": "Shinde Hanumant Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14831",
    "name": "Shinde Shekhar Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14760",
    "name": "Chalke Mahadev Kashinath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "395",
    "name": "Rana Roshanlal Basantsingh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "508",
    "name": "Jadhav Santosh Sudam"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "509",
    "name": "Jadhav Deepali Santosh"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "549",
    "name": "Sawant Pradeep Dattaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "550",
    "name": "Sawant Rajesh Jayram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5981",
    "name": "Jadhav Vilas Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23543",
    "name": "Tondwalkar Sunil Suryakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23544",
    "name": "Barretto Diago Rosario"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22172",
    "name": "Sharma Virendra Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22173",
    "name": "Shipurkar Anil Ravu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22174",
    "name": "Shaikh Innus Sikandar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22175",
    "name": "Yadav Mahendra Ramkisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14813",
    "name": "Chavan Dhananjay Jagadevrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14817",
    "name": "Shriasawde Deepak Shrikant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23519",
    "name": "Sharma Anil Tarachand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23520",
    "name": "Pinto Joaquim"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "836",
    "name": "Tamboli Kamlakar Harischandra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "837",
    "name": "Pawar Pradeep Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23496",
    "name": "Shirke Sumit Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23500",
    "name": "Bandre Manish Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23512",
    "name": "Barikhan Yaar Mohmad Abdul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18992",
    "name": "Jagtap Jyoti Santosh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23468",
    "name": "Kobnak Nilesh Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23470",
    "name": "Khan Nasirali Haiderali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23471",
    "name": "Khan Akramhaji Bituwah"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23472",
    "name": "Khan Haiderali Bhairchi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23473",
    "name": "Khan Fatama Haiderali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23474",
    "name": "Dabholkar Sushma Sudhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14784",
    "name": "Pawar Vijay Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23447",
    "name": "Pondkule Nitin Vijaysingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14709",
    "name": "Rananavare Trupti Abhijeeta"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14757",
    "name": "Tayakandi Isamail Abubakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14081",
    "name": "Jedhe Arjun Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9657",
    "name": "Shinde Dhanaji Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23423",
    "name": "Desai Archana Sunil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23430",
    "name": "Nayak Girish Shrinivas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23439",
    "name": "Gandhi Rajendra Roshanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23441",
    "name": "Malpe Shailesh Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23442",
    "name": "Joshi Mangesh Anant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14525",
    "name": "Koli Mane Sampat Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14527",
    "name": "Ranbhare Abhijeet Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14528",
    "name": "Chavan Mahadeo Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4014",
    "name": "Waragde Sampat Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10072",
    "name": "Katakr Suresh Popatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2911",
    "name": "Hule Tukaram Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22691",
    "name": "Kumbhar Santosh Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23402",
    "name": "Shirke Hitesh Sadanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22134",
    "name": "Joshi Vinod Krushnaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5825",
    "name": "Jain Harbanslal (Huf)"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23361",
    "name": "Patel Ramesh Meghji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23379",
    "name": "Desai Shrikrishna Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23381",
    "name": "Sakpal Pallavi Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22106",
    "name": "Tiwari Chaturanand Vindhyavasini"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22108",
    "name": "Kokare Prakash Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22109",
    "name": "Naik Krantee Atul"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22116",
    "name": "Shelke Pandurang Dhondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14500",
    "name": "Bhosale Ababsaheb Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14502",
    "name": "Bhosale Anamika Amit"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14512",
    "name": "Ghorpade Ashok Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14514",
    "name": "Kambale Manisha Pramod"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14515",
    "name": "Ingawale Ramesh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3171",
    "name": "Pawar Gautam Yadavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16513",
    "name": "Bhilare Balu Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12825",
    "name": "Atugade Sankar Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6806",
    "name": "Atkekar Ramchandra Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9947",
    "name": "Doiphode Sadashiv Bayaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22038",
    "name": "Mishra Jaiprakash Indradev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22059",
    "name": "Belcheda Vithal Utappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22060",
    "name": "Patel Enush Ismail"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12157",
    "name": "Gaikwad Rajendra Janadran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23358",
    "name": "Patel Bharat Harji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23359",
    "name": "Patel Kesharben Bharat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14481",
    "name": "Navghane Balu Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14483",
    "name": "Nalawade Sanjay Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14497",
    "name": "Dhumal Avinash Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14498",
    "name": "Dhumal Prakash Kisanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2875",
    "name": "Pisal Hanumant Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11333",
    "name": "More Vithal Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14385",
    "name": "Gaikawad Vijay Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14386",
    "name": "Shewale Jivan Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14387",
    "name": "Nalawade Pandurang Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14388",
    "name": "Gaikwad Anil Dnayneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14392",
    "name": "Gaikwad Dharmaji Mukinda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14393",
    "name": "Salunkhe Satish Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14394",
    "name": "Nikam Shankar Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14395",
    "name": "Jadhav Dipak Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14396",
    "name": "Yadav Ashok Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14397",
    "name": "Nikam Manohar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14405",
    "name": "Phalke Ravindra Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14412",
    "name": "Kadam Hemant Vasantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14414",
    "name": "Kharade Sarjerao Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14415",
    "name": "Dhumal Sabhaji Bapuso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14417",
    "name": "Dhumal Bhimrao Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14418",
    "name": "Ghadge Dayanand Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14419",
    "name": "Jagtap Sujit Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14420",
    "name": "Jagtap Vishwajit Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14421",
    "name": "Ghadge Shital Dayanand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14422",
    "name": "Bhavar Dattatry Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14428",
    "name": "Nimbalkar Bhimrao Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14431",
    "name": "Jagdale Anil Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14432",
    "name": "Lipare Dilip Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14433",
    "name": "Patole Prakash Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14447",
    "name": "Chavan Nilesh Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14448",
    "name": "Chavan Bajirao Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14454",
    "name": "Pawar Pradeep Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14456",
    "name": "Deshmukh Mansing Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14460",
    "name": "Deshmukh Chetan Madanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14466",
    "name": "Chavan Hanmant Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14467",
    "name": "Deshmukh Tanaji Prataprao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14468",
    "name": "Chavan Sunil Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14472",
    "name": "Ghorpade Dhananjay Jaysingrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14478",
    "name": "Nadaf Vazir Babalal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14480",
    "name": "Bondre Jawansing Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13705",
    "name": "Pawar Hanmant Jijaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13729",
    "name": "Jadhav Gulabrao Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14552",
    "name": "Bhosale Ankush Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14319",
    "name": "Jadhav Bajirao Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14332",
    "name": "Pawar Jaywant Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14333",
    "name": "Bandal Vijay Nanasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14337",
    "name": "Gaikawad Sanjay Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14341",
    "name": "Bandal Kiran Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14342",
    "name": "Bandal Nilesh Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14349",
    "name": "Bhosale Ramesh Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14355",
    "name": "Bhosale Sanjivan Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14359",
    "name": "Ghodake Sachin Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14363",
    "name": "Chavan Mahadev Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14364",
    "name": "Sakunde Nilesh Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14365",
    "name": "Deshmukh Malojirao Ravsaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14366",
    "name": "Shinde Ankush Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14371",
    "name": "Chavan Shamrao Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14376",
    "name": "Jadhav Ajit Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14380",
    "name": "Jadhav Hanmant Jyotiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14381",
    "name": "Kharat Vishnu Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21028",
    "name": "Paradkar Sachin Shreedhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21030",
    "name": "Gaikwad Pravin Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19099",
    "name": "Bhoite Suraj Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4577",
    "name": "Jagtap Ganpat Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5134",
    "name": "Pisal Dipak Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3912",
    "name": "Shinde Babanrao Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1372",
    "name": "Shinde Vithal Siddaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14315",
    "name": "Godase Pralhad Vithoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12179",
    "name": "Tanksale Chandrakant Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6533",
    "name": "Bhoite Krushna Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9346",
    "name": "Shinde Maruti Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9363",
    "name": "Jawale Shobha Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10454",
    "name": "Jadhav Baburao Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13013",
    "name": "Mandhare Rajendra Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14295",
    "name": "Wadkar Somnath Baliram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "931",
    "name": "Yadav Madhukar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18536",
    "name": "Chinchwade Narayan Dhondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22628",
    "name": "Walanj Jyoti Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10589",
    "name": "Raut Subhash Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14268",
    "name": "Pandit Vasant Krishnaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14269",
    "name": "Gaikwad Shankar Nathuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14270",
    "name": "Landage Vijaykumar Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14271",
    "name": "Jadhav Ramesh Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14273",
    "name": "Phadtare Giridhar Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14282",
    "name": "Tamboli Shahid Hamid"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15045",
    "name": "Phalke Nalini Dilip"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "645",
    "name": "Mani Mohan Kvs"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9575",
    "name": "More Balwant Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13585",
    "name": "Gurkha Harshad Nayansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "817",
    "name": "Pawar Sambhaji Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12151",
    "name": "Jadhav Baban Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14236",
    "name": "Disale Gorakhnath Pralhad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21500",
    "name": "Mohite Suresh Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7512",
    "name": "Nimbalkar Sanjivan Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25284",
    "name": "Payra Minati Ratan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3163",
    "name": "Jadhav Ashok Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14230",
    "name": "Khude Dattatray Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15394",
    "name": "Devkar Vithal Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8034",
    "name": "Chavan Valmik Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8813",
    "name": "Phalke Shatrughna Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5893",
    "name": "Mahangade Sampat Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7304",
    "name": "Mohite Shantaram Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22001",
    "name": "Nair Kumar Kamal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22003",
    "name": "Todakari Yogendra Baliram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1175",
    "name": "Tambe Milind Dattatray"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1178",
    "name": "Shaikh Rahimoddin Samshoddin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1182",
    "name": "Chitte Manohar Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18203",
    "name": "Disale Sanjay Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4042",
    "name": "Babar Khanderao Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4300",
    "name": "Pisal Vishwas Bandoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12824",
    "name": "Bodare Arvind Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12831",
    "name": "Shinde Sharad Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16518",
    "name": "Rannavre Sunil Surshingrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9578",
    "name": "Pol Sachin Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7604",
    "name": "Shinde Sampat Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17407",
    "name": "Nalawade Jaywant Tulshiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21156",
    "name": "Sutar Dhanwant Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11371",
    "name": "Anpat Rajendra Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15277",
    "name": "Shinde Datatray Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3662",
    "name": "Mulik Ramesh Ramchandra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "628",
    "name": "Sonawane Dilip Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21935",
    "name": "Shinde Amol Babanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20626",
    "name": "Ghag Rupesh Janardan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21395",
    "name": "Sonawane Chandrakant S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23187",
    "name": "Gidhwani Amarlal Shamdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14190",
    "name": "Kakade Vaishali Sachin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10895",
    "name": "Ved Prabha M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18873",
    "name": "Kadam Hindurao Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17970",
    "name": "Chorge Sangeeta Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9566",
    "name": "Bhosale Prabhakar Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13260",
    "name": "More Jagannath Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21923",
    "name": "Desai Balaso Shripati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20138",
    "name": "Kalbate Laxman Dhaku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5574",
    "name": "Miss  Gala Bhanumati Kanji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9103",
    "name": "Zanzurane Ramesh Babaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9812",
    "name": "Pisal Padma Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14344",
    "name": "Gaikwad Shubhangi Santosh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14277",
    "name": "Gardi Balu Baban  A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18055",
    "name": "Pawar Phulabai Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11160",
    "name": "Jagtap Ravindra Genaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14149",
    "name": "Shinde Ravindra Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21079",
    "name": "Miss  Jadhav Priti Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6581",
    "name": "Bhoite Ravindra Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15350",
    "name": "Nimbalkar Vitthal Bacharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10729",
    "name": "Pawar Yeshwant Chandrasen"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18764",
    "name": "Kadam Santosh Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7679",
    "name": "Jadhav Sampat Baba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3936",
    "name": "Pawar Shilvaji Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3823",
    "name": "Waragade Yashawant Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4687",
    "name": "Dhumal Kisan Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3637",
    "name": "Sawant Sampatrao Keshavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6455",
    "name": "Chavan Anna Parbati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7336",
    "name": "Dhumal Jaywant Tatyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20060",
    "name": "Mandhare Prakash Dadasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20063",
    "name": "Mandhare Santosh Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20066",
    "name": "Nikam Dilip Shivnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22008",
    "name": "Patel Ishaq Mahamadsha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1445",
    "name": "Durgule Shrirang Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5268",
    "name": "Kansara Kantilal Chunilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21694",
    "name": "Gupta Rameshchandra Mavalal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9321",
    "name": "Jadhav Kalpana Bharat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11553",
    "name": "Nikam Bharat Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22422",
    "name": "Kawale Manish Deepak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3462",
    "name": "Yewale Suresh Hanmantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4400",
    "name": "Jagtap Vasant Genaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4831",
    "name": "Barge Vilas Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17781",
    "name": "Yadav Kalidas Dadaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3434",
    "name": "More Ankush Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "501",
    "name": "Jagtap Mahadev Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9903",
    "name": "Shinde Popat Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11647",
    "name": "Chawan Rajendra Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5046",
    "name": "Sabhasad Vinayak Gangadhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1090",
    "name": "Khot Shrirang Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21619",
    "name": "Panigrahi Sitaram Sitaram  Bhajgovind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21660",
    "name": "Ranware Asha Asha  Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17553",
    "name": "Wade Suresh Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10702",
    "name": "Garade Jaywant Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21583",
    "name": "Patil Rajratan Jagdevppa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19092",
    "name": "Deshmukh Hanmantrao Madhavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19109",
    "name": "Purbiiya Rukminibai Dayabhaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19249",
    "name": "Taak Ramkumar Umarsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19250",
    "name": "D Souza Peter Ligori"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19438",
    "name": "Pawar Rajesh Yanku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19544",
    "name": "Mane Ramesh Sibba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15380",
    "name": "Anekar Ramchandra Tatoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11250",
    "name": "Chavan Ashalata Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4277",
    "name": "Pawar Shankar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6075",
    "name": "Mulik Ramdas Bhagaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20061",
    "name": "Mandhare Somnath Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14021",
    "name": "Pawar Sanjay Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7783",
    "name": "Awate Prakash Jyotiram 224/3"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21373",
    "name": "Jagtap Ganesh Mahipat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21374",
    "name": "Jagtap Mahipat Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18892",
    "name": "Mishra Omprakash Chintamani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12699",
    "name": "Kindre Vishnu Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12266",
    "name": "Bhosale Shivaji Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12259",
    "name": "Sakunde Mohan Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15524",
    "name": "Dhumal Sanjay Dhansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25399",
    "name": "Gohil Kuvar Magan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14480",
    "name": "Gole Suresh Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21122",
    "name": "Usha Usha Anathanarayanan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18577",
    "name": "Vengurlekar Govind Damodar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14073",
    "name": "Kaldhone Pratibha Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22297",
    "name": "Nimbalkar Sangita Kakasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9683",
    "name": "Chavan Baburao Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5943",
    "name": "Shinde Chandrakant Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8014",
    "name": "Sakunde Lahuba Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15988",
    "name": "Yelawe Pandurang Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "464",
    "name": "Gujar Nathuram Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9361",
    "name": "Pisal Pandharinath Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20903",
    "name": "Gawali Virendra Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23389",
    "name": "Vaydande Sanjay Gunyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11016",
    "name": "Chorage Bhagwan Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4153",
    "name": "Jadhav Sampat Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14334",
    "name": "Gaikawad Santosh Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19828",
    "name": "Gaikwad Bajarang Bhausaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20892",
    "name": "Bhalekar Popat Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20907",
    "name": "Bombale Babaji Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20934",
    "name": "Salunke Vikram Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13152",
    "name": "Mali Jaykumar Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4494",
    "name": "Chavan Maruti Bhau"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "343",
    "name": "Rathi Suresh Kanhaiyalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16971",
    "name": "Kadam Chandrkant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18533",
    "name": "Kadam Prakash Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24128",
    "name": "Kamble Mahesh Vilas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20738",
    "name": "Shishupal Ulhas Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16663",
    "name": "Borge Hanmant Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3760",
    "name": "Sakunde Shankar Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20632",
    "name": "Varma Nareshchand Nandkishore"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20637",
    "name": "Varma Ghanshayamdas Guljarilalnanda"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "604",
    "name": "Shinde Ramchandra Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5528",
    "name": "Pawar Vithal Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8037",
    "name": "Shaikh Mushahid Husen Wahidali"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17372",
    "name": "Panskar Manisha Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12688",
    "name": "Yadav Pandurang Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6829",
    "name": "Kadam Amar Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19183",
    "name": "More Dhananjay Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10989",
    "name": "Surve Aadhik Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17487",
    "name": "Ahirekar Rajaram Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12945",
    "name": "Ithape Sarjerao Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10519",
    "name": "Mandhare Bharat Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6521",
    "name": "Bhoite Pandurang Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13235",
    "name": "Nikam Ravindra Vishwasrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20482",
    "name": "Kurte Prabhakar Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20654",
    "name": "Guhagarkar Dattaram Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17691",
    "name": "Sangolkar Sadashiv Baba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2011",
    "name": "Kadam Rajaram Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20322",
    "name": "Dange Chandrakant Changadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20355",
    "name": "Dalvi Vishnu Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7202",
    "name": "Bhosale Pratapsing Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5529",
    "name": "Pawar Tanaji Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6024",
    "name": "Shirswade Suhas Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17457",
    "name": "Chorge Manohar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14481",
    "name": "Harijan Harkhu Medai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12199",
    "name": "Jagtap Kishor Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8818",
    "name": "Jagtap Dashrath Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21791",
    "name": "Dhumal Yogesh Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20387",
    "name": "Sawant Dinkar Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17495",
    "name": "Bansode Ahinsak Mahipat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17496",
    "name": "Bansode Sunita Ahinsak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17504",
    "name": "Shaikh Abanu Shekh Abdulla"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11152",
    "name": "Kadam Sharad Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17330",
    "name": "Jadhav Ravindra Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20000",
    "name": "Vartak Dilip Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17760",
    "name": "Shinde Pramod Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23349",
    "name": "Bhanushali Govindji Valji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15700",
    "name": "Pawar Suresh Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19887",
    "name": "Mane Vijay Janardan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19888",
    "name": "Pisal Balasaheb Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5929",
    "name": "Yadav Sopanrao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16018",
    "name": "More Prakesh Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20142",
    "name": "Singh Manojkumar Hridaynarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19742",
    "name": "Shaikh Mohd Taher Mohd Yusut"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17019",
    "name": "Rawale Narendra Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17042",
    "name": "Pawar Prabhakar Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17056",
    "name": "Ambavale Vilas Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12469",
    "name": "Nalwade Mahadeo Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14155",
    "name": "Shedage Atul Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19657",
    "name": "Barge Ajay Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19694",
    "name": "Purbiya Mothi Bhagu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16941",
    "name": "Shelar Umakant Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20458",
    "name": "Bhoier Vandana Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20465",
    "name": "Yadav Sandeep Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20492",
    "name": "Akerkar Milind Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11934",
    "name": "Kudalkar Prakash Dattatraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "825",
    "name": "Shinde Manshing Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17059",
    "name": "Singh Asha Rajesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11325",
    "name": "Sutar Ramesh Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17365",
    "name": "Kadam Pushpalata Popatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19252",
    "name": "Belkune Ramrao Martandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19258",
    "name": "Patel Iqbal Janmohmd"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19328",
    "name": "Gandhi Bharat Chunilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19336",
    "name": "Sangoi Bhamini Nikhil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19337",
    "name": "Sangoi  Nikhil Manilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19513",
    "name": "Sasane Ramesh Bhimrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19524",
    "name": "Maskar Sachin Vithhal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16843",
    "name": "Raut Chandrakant Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16844",
    "name": "Raut Akubai Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16845",
    "name": "Raut Ramchandra Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20401",
    "name": "Salunkhe Hemant Sahdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20402",
    "name": "Shinde Uttam Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17182",
    "name": "Ghadge Dattatray Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22025",
    "name": "Karim Jamalluddin Abdul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11101",
    "name": "Sutar Vijay Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9293",
    "name": "Nevase Sanjay Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22252",
    "name": "Chavan Dinesh Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20457",
    "name": "Sawant Baban Gunaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "763",
    "name": "Suryawanshi Satyawan Namdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11117",
    "name": "Pahalke Uttam Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9504",
    "name": "Pawar Mohan Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1087",
    "name": "Ghadge Ramchandra Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19000",
    "name": "Rawat Kuldeep Singh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24064",
    "name": "Bhakta Anil Vijaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15714",
    "name": "Karwal Anu Balvinder Singh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12141",
    "name": "Jadhav Sahebrao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17034",
    "name": "Shelar Ashok Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21964",
    "name": "Jagtap Santosh Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23205",
    "name": "Palicha Rupal Ketan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16852",
    "name": "Patil Ravindra Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11360",
    "name": "Sakunde Sadashiv Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16606",
    "name": "Desai Vidya Tushar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9417",
    "name": "Newase Sambhaji Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6603",
    "name": "Doundkar Dnyandeo Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14236",
    "name": "Jagtap Shashikant Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14440",
    "name": "Bhagwat Suyog Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8794",
    "name": "More Chandrakant Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16826",
    "name": "Kadam Ananda Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19842",
    "name": "Shelar Sunil Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19914",
    "name": "Thorat Nandkishor Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8018",
    "name": "Chavan Ankush Maruti"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "925",
    "name": "Devkar Priya Umesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9324",
    "name": "Sarafdar Pandurang Savada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7163",
    "name": "Dongare Akaram Nagu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8154",
    "name": "Mulik Ankush Jotiram 1025/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9492",
    "name": "Patil Dinkar Shankar 612/15"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18111",
    "name": "Pawar Narayan Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10863",
    "name": "Salunkhe Ankush Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6562",
    "name": "Shinde  Veersing Sardarsing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14056",
    "name": "Desai Ganesh Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1339",
    "name": "Nalawade Subhash Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16098",
    "name": "Shinde Pramod Abasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17654",
    "name": "Maskar Mahadeo Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21791",
    "name": "Shaikh Khajabhai Ismail"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21806",
    "name": "Pujari Raghunath Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21809",
    "name": "Miss  Ansari Zinatunisa Salim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21811",
    "name": "Kureshi Mohamad Rafik Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21812",
    "name": "Miranda Vinnie Rodani"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21813",
    "name": "Pol Ramesh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21815",
    "name": "Mishra Radhysham Amalashnkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16320",
    "name": "Kale Sanjay Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16455",
    "name": "Khopde Ravindra Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15044",
    "name": "Phalke Shrirang Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6237",
    "name": "Chavan Prakash Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8942",
    "name": "Sabale Vijaya Jaywant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18990",
    "name": "Ingale Sachin Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19515",
    "name": "Lembhe Kishor Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9845",
    "name": "Dorwat Prasad Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10184",
    "name": "Phalke Dilip Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3419",
    "name": "Pisal Haribhau Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18125",
    "name": "Jadhav Sunil Sheshrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5641",
    "name": "Dhumal Sadashiv Kondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17228",
    "name": "Suryawanshi Jitendra Jaywant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9224",
    "name": "Sable Prakash Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8336",
    "name": "Chavan Dattatray Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5608",
    "name": "Lembhe Shankar Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14013",
    "name": "Pawar Shubhada Madhav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17290",
    "name": "Gaikwad Santosh Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2534",
    "name": "Bobade Ramesh Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "833",
    "name": "More Tukaram Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12562",
    "name": "Sakunde Yuvaraj Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6465",
    "name": "Kukreja Uttamchand Kanaiyasingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9876",
    "name": "Sakunde Vitthal Pandharinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6372",
    "name": "Parab Laxman Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9616",
    "name": "Patil Ajit B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8237",
    "name": "Lembhe Uttam Dagadoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6385",
    "name": "Ghagare  Vithal Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10035",
    "name": "Chavan Nandkishor Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13069",
    "name": "Pawar Vilas Sampatrao 1183/11"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12230",
    "name": "Kadam Sangeeta Dhanajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7989",
    "name": "Saste Kisan Jijaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9141",
    "name": "Shinde Dilip Annasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16994",
    "name": "Dhotre Balaram Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15966",
    "name": "Kadam Ramchandra Goverdhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16087",
    "name": "Jadhav Kashinath Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16088",
    "name": "Mishra Lalitkumar Gulab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12213",
    "name": "Shinde Sakharam Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8016",
    "name": "Bhosale Krushnat Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10541",
    "name": "Shinde Ramrao Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "223",
    "name": "Chavan Ashok Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "816",
    "name": "Chavan Maruti Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4265",
    "name": "Nikam Shrirang Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5703",
    "name": "Shinde Sharad Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6554",
    "name": "Jadhav Sayaji Sopanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15906",
    "name": "Salunkhe Ramchandra Bhau Tn-93-24"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9458",
    "name": "Shinde Ramesh Rajaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "860",
    "name": "Suryawanshi Aruna Kerappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8541",
    "name": "Shinde Kisan Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22266",
    "name": "Chavan Vinayak Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15162",
    "name": "Kondawale Narayan Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16023",
    "name": "Shitole Jayshri Kailas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7747",
    "name": "Bobade Sharad Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "716",
    "name": "Gharal Shamrao Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21821",
    "name": "Pandey Shitalaprasad Sabhajit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21822",
    "name": "Sahu Rambalak Nanuprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21823",
    "name": "Waikar Devraj Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21831",
    "name": "Parab Atmaram Bhaskar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21833",
    "name": "Pawar Pratibha Bhaskar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21841",
    "name": "Shekh Nizamuddin Azgar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21845",
    "name": "Vishwkarama Bhagelu Bansraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21867",
    "name": "Shingare Sarjerav Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21868",
    "name": "Singh Suresh Ramnarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21880",
    "name": "Ubale Kantilal Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8680",
    "name": "Chavan Laxman Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10008",
    "name": "Shelke Swapnaja Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1483",
    "name": "Bhoite Viswas Narayanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11046",
    "name": "Vhalkar Dattaram Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5994",
    "name": "Karne Mahadeo Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21633",
    "name": "Kamble Satyawan Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14820",
    "name": "Thorat Dattatraya Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23592",
    "name": "Shetye Urmila Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18288",
    "name": "Kambale Vishnu Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12771",
    "name": "Nalage Satyawan Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19562",
    "name": "Aher Kiran Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6574",
    "name": "Nalawade Maruti Genu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12386",
    "name": "Yadav Sunil Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23563",
    "name": "Vakil Fardoon Erach"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23564",
    "name": "Masurekar Smita Parashuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23565",
    "name": "Vakil Rohini Fardoon"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23566",
    "name": "Masurekar Parashuram Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14857",
    "name": "Phalke Vasant Bhauso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4688",
    "name": "Bhosale Phatesing Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16907",
    "name": "Kadam Shivaji Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9229",
    "name": "Chorage Babaso Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6342",
    "name": "Shinde Bharat Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2964",
    "name": "Jadhav Datta Dada"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8160",
    "name": "Mulik Abhay Jaysing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8032",
    "name": "Adodra Prakashchandra G"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18118",
    "name": "Jagtap Suresh Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8963",
    "name": "Mohite Sanjay Vishwnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7567",
    "name": "Retharekar Shrirang Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22822",
    "name": "Gowda Shivakumar Paramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1276",
    "name": "Pisal Mahadev Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14540",
    "name": "Dube Omkar Nath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14901",
    "name": "Vichare Kisan Bajirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4144",
    "name": "Bobade Tulshidas Krishnarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21966",
    "name": "Pendurkar Swati Sitaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2122",
    "name": "Prajapati Sanjay Premshankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14057",
    "name": "Salunkhe Prakash Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3144",
    "name": "Shinde Madhao Aanandarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23516",
    "name": "Jha Rama Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12452",
    "name": "Kadam Tukaram Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13216",
    "name": "Kambale Gautam Bhimrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23514",
    "name": "Khan Mohammed Imrank"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16445",
    "name": "Totre Mangal Bharat & Yogesh Bharat Totr"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23476",
    "name": "Amonkar Sunita Laxmikant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "762",
    "name": "Abdagire Anant Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3840",
    "name": "Pol Gajanan Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21817",
    "name": "Sapkal Anandrao Jagnnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20306",
    "name": "Tayde Milind Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20307",
    "name": "Matne Ramchandra Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20308",
    "name": "Pujari Vishwanath Lokaya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20324",
    "name": "Kamble Nandkumar Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20333",
    "name": "Shelar Mohan Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20334",
    "name": "Nishad Mangal Ramlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20336",
    "name": "Shivota Laxman Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20346",
    "name": "Mahadik Ashok Pandharinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20360",
    "name": "Phulsundar Sharad Murlidhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12155",
    "name": "Dhumal Hindurao Vittal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18118",
    "name": "Anjarlekar Rajashree Ravindra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23460",
    "name": "Miss  Pandey Alka Sheshmani"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23461",
    "name": "Pandey Rinki Ashish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23462",
    "name": "Pandey Ashish Sheshmani"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13244",
    "name": "Sutar Dawood Shahabuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14885",
    "name": "Kambale Akshay Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5655",
    "name": "Bhoite Ankush Jaising"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12880",
    "name": "Kirdat Jagannath Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13986",
    "name": "Kharat Chandrakant Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17256",
    "name": "Jagtap  Kiran Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12779",
    "name": "Modak Laxman Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3456",
    "name": "Jagtap Nathu Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21289",
    "name": "Bhalerao Suresh Damodar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20086",
    "name": "Bande Vishnu Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20122",
    "name": "Katkar Suresh Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20188",
    "name": "Chavan Vijaya Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23417",
    "name": "Kadave Sushil Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8748",
    "name": "Vagh Ankush Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7131",
    "name": "Khopade Rajendra Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20799",
    "name": "Hirave Yuvraj Mahipati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5867",
    "name": "Bhosale Kundalik Raghu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13263",
    "name": "Salunkhe Santosh Hanmantrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1542",
    "name": "Khopade Sarjerao Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1079",
    "name": "Patil Vilasrao Antu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14060",
    "name": "Salunkhe Ashok Murlidhar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21929",
    "name": "Pol Laxman Haibatti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21937",
    "name": "Tari Sanjay Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21945",
    "name": "Khawaliya Shayar Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21949",
    "name": "Yadav Rajnath Ramdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21951",
    "name": "Marathe Laxman Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21971",
    "name": "Shinde Rajan Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21972",
    "name": "Mankar Anand Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21974",
    "name": "Singh Dhananjay Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21975",
    "name": "Jaiswal Ramkishor Kantaprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12399",
    "name": "Sakunde Murari Mhaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8872",
    "name": "Jagtap Dashrath Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "512",
    "name": "Jagtap Himmat Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14192",
    "name": "Jagdale Suresh Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21902",
    "name": "Safi Abdul Latif M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21903",
    "name": "Dhiwar Popat Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21906",
    "name": "Patel Fredy Domnik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21911",
    "name": "Choudhary Ravindra Ramvilash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7303",
    "name": "Shinde Jagannath Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23342",
    "name": "Shetty Sudam Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14429",
    "name": "Nikam Sampat Bapusaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13116",
    "name": "Nujawar Kasam Abdul"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17813",
    "name": "Saawant Subhash Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15700",
    "name": "Bhosale Uttam Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19842",
    "name": "Sapate Balasaheb Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7581",
    "name": "Kolekar Laxman Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12890",
    "name": "Bhambare Amit Viajay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6443",
    "name": "Kadam Sharada Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6559",
    "name": "Pawar Suryakant Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21628",
    "name": "Yadav Laltaprasad Punnalal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21641",
    "name": "Yadav Ramfer Ramnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21687",
    "name": "Khan Mohiddin Abdul Masjid"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12884",
    "name": "Solaskar Suryakant Laxmanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19010",
    "name": "Shetty Ratnakar Sinna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20699",
    "name": "Naringrekar Hemangee Deepak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14264",
    "name": "Pawar Suresh Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14285",
    "name": "Shaikh Shamim Khudbuddin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1912",
    "name": "Tekale Jitendra Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21540",
    "name": "Chauvan Maheshkumar Ramsukh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21605",
    "name": "Fernandes Angel Domnic"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22383",
    "name": "Jadhav Nayana Mangesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8565",
    "name": "Nalge Vasant Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2791",
    "name": "Rohira Khemchand Madhavdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21863",
    "name": "Kochare Bhaskar Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21434",
    "name": "Khot Khot Hanif Hasan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10242",
    "name": "Mujawar Ijarahil Abbas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15168",
    "name": "Patil Balaram Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9784",
    "name": "Barge Vilasrao Shankar Rao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11355",
    "name": "Jadhav Rajendra Bhalerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7212",
    "name": "Jagtap Mahadeo Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17865",
    "name": "Mulik Sangeeta Kishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10748",
    "name": "Bobade Ravindra Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15168",
    "name": "Ghare Shivaji Rangnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9527",
    "name": "Chalke Ashok Pilaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18218",
    "name": "Jadhav Babanrao Jaganath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18140",
    "name": "Salnani Jagadish Naryan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12485",
    "name": "Dhumal Malan Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12486",
    "name": "Dhumal Sujata Mahesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12574",
    "name": "Chavan Jitendra Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14114",
    "name": "Jagtap Nitin Hanmantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2433",
    "name": "Mulik Motiram Jotiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10897",
    "name": "Dhaware Prashant Arvind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13245",
    "name": "Sutar Tabassum Dawood"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13246",
    "name": "Nalawade Sudam Uddhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13283",
    "name": "Bhosale Mangesh Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13284",
    "name": "Chavan Rajendra Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6851",
    "name": "Kadam Hanmant Balkrushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10174",
    "name": "Sonawale Shashikant Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16837",
    "name": "Gaikwad Sanjay Ravji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18104",
    "name": "Kedar Ashok Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "363",
    "name": "Dhumal Sitaram Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10535",
    "name": "Bhoite Sanjay Vithalrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18306",
    "name": "Tiwari Shyamprakash Chndrabadan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3938",
    "name": "Jagtap Namdeo Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6194",
    "name": "Kadam Vaman Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14186",
    "name": "Kadam Vikrant Padmakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "789",
    "name": "Chavan Hanumant Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11598",
    "name": "Kadam Maruti Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6339",
    "name": "Rapaskar Ghanashyam Khengar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4489",
    "name": "Nikam Vyankat Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5078",
    "name": "Kadam Laxman Nathu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "629",
    "name": "Mandhare Sadashiv Piloba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4435",
    "name": "Jadhav Balasaheb Mhapaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11603",
    "name": "Dudhe Jaysing Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12995",
    "name": "Sakunde Arvind Hanmantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13056",
    "name": "Kundap Nanda Puroshottam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13057",
    "name": "Pawar Rahul Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13070",
    "name": "Jadhav Madhukar Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13071",
    "name": "Malusare Bhiku Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13073",
    "name": "Kundap Ajit Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13076",
    "name": "Shinde Nivrutti Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7845",
    "name": "Chavan Prakash Ramchadnra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17575",
    "name": "Gaikwad Jaywant Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "975",
    "name": "Padte Jagdish Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2230",
    "name": "Sabale Vilas Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17139",
    "name": "Bhagwat Hanmant Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16623",
    "name": "Bhoite Ajit Hanmantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12154",
    "name": "Lakde Dharmu Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17068",
    "name": "Anpat Hanmant Parbati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17634",
    "name": "Dalvi Shashikant Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12794",
    "name": "Solaskar Dayanand Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12835",
    "name": "Mandhare Prabhakar Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12837",
    "name": "Mandhare Sudhakar Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12907",
    "name": "Borate Vikram Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12908",
    "name": "Kakde Umesh Popatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12930",
    "name": "Kokane Shantaram Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12931",
    "name": "Kokane Vijaykumar Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12935",
    "name": "Kakade Suresh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12937",
    "name": "Narde Rajendra Vasantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12939",
    "name": "Kakade Shivaji Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12957",
    "name": "Ghadge Shamrao Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7970",
    "name": "Jadhav Deepak Ananadrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8922",
    "name": "Jagtap Suryakant Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25449",
    "name": "Chikne Nayana Umesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16879",
    "name": "Shinde Darshna Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3988",
    "name": "Jadhav Dattatray Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12308",
    "name": "Pisal Santosh Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12309",
    "name": "Kadam Vikram Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12314",
    "name": "Motling Balasaheb Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12343",
    "name": "Godse Nanaso Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12347",
    "name": "Gole Baburao Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12357",
    "name": "Salunkhe Kashinath Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13994",
    "name": "Desai Prasad Shripad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13956",
    "name": "Nawadkar Nandkumar Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20696",
    "name": "Afandkar Suresh Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20970",
    "name": "Bane Deepak Ganu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21217",
    "name": "Salunkhe Hemlata Anil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21267",
    "name": "Naik Arun Anant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10215",
    "name": "Sadakale Bhupendra Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8257",
    "name": "Kadam Nandkumar Sakharam  Tn-605-3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6141",
    "name": "Jedhe Bhimrao Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13437",
    "name": "Bhoite Shailendra Mohanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11981",
    "name": "Jagdale Samadhan Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12178",
    "name": "Kakade Tanaji Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12735",
    "name": "Bhoite Hanmant Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12772",
    "name": "Bhori Shirin Imran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12773",
    "name": "Borate Shankar Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12774",
    "name": "Pawar Kiran Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8691",
    "name": "Kalokhe Bharat Sudam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7462",
    "name": "Sakunde Anandrao Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14046",
    "name": "Unde Rajendra Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17032",
    "name": "Bhoite Dattatray Dynanoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2822",
    "name": "Wayaal Murlidhar Rambhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17906",
    "name": "Shinde Ravindra Sampatrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17271",
    "name": "Kumau Kishorilal Bansira"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12430",
    "name": "Jagtap Kalidas Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9840",
    "name": "Jadhao Chandrakant Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1498",
    "name": "Sabale Murlidhar Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12248",
    "name": "Tambe Ashok Pandurang T No 690"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20301",
    "name": "Mainkar Santosh Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20303",
    "name": "Panchal Navin Kodarmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16281",
    "name": "Mohite Dadaso Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12273",
    "name": "Bandal Dattatray Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12502",
    "name": "Bhoite Pralhad Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10732",
    "name": "Pawar Nivruti Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12022",
    "name": "Phalke Saveeta Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12646",
    "name": "More Dilip Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22852",
    "name": "Dere Udaysingh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11374",
    "name": "Jagtap Bharatkumar Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20234",
    "name": "Panthri Harischandra Maheshanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20235",
    "name": "Rawat Amarsingh Motisingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20236",
    "name": "Rawat Radhadevi Amarsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22583",
    "name": "Dige Vishram Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14602",
    "name": "Bhosale Surekha Shrinivas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1980",
    "name": "Poojary Janardhan Rama"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1982",
    "name": "Rangavkar Dattaram Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7770",
    "name": "Jagtap Popat Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12658",
    "name": "Gaikwad Hanmant Hindurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2651",
    "name": "Barge Mahadeo Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22494",
    "name": "Waghmare Rahul Namdev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20574",
    "name": "Patil Ashok Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11982",
    "name": "Jagdale Sachin Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12004",
    "name": "Shinde Prakash Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12583",
    "name": "Kalange Pralhad Daulati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12588",
    "name": "Phalke Padma Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12625",
    "name": "Yadav Suresh Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1301",
    "name": "Shinde Hanmant Mugatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11747",
    "name": "Mane Shrirang Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20408",
    "name": "Ranaware Machindra Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12504",
    "name": "Gaikwad Ramdas Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12511",
    "name": "Garde Shivaji Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12541",
    "name": "Pawar Dattatray Kundlik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12547",
    "name": "Bhosale Satish Dnyanoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12548",
    "name": "Patil Sayajirao Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12568",
    "name": "Pawar Adhik Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12570",
    "name": "Kakade Satyawan Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12589",
    "name": "Ghorpade Vasant Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12643",
    "name": "Bhosale Tanaji Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15517",
    "name": "Patil Vikramrao Narayanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8609",
    "name": "Jahav Samruddhi Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4650",
    "name": "Suryawanshi Anandrao Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11046",
    "name": "Pawar Ravindra Sudam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12453",
    "name": "Lembhe Ashalata Raviraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12469",
    "name": "Kadam Jalindar Shyamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11788",
    "name": "Phalke Sahebrao Dnyanadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12403",
    "name": "Dixit Hanmant Trimbak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12413",
    "name": "Shinde Mahendra Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5518",
    "name": "Shinde Vilasrao Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2099",
    "name": "Panvelkar Shankar Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "594",
    "name": "Nikam Madhav Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22102",
    "name": "Patil Kishor Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11645",
    "name": "Jadhav Sandeep Vishwash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12301",
    "name": "Shinde Yashwant Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12303",
    "name": "Gangawane Babai Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12326",
    "name": "Velekar Dattatray Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12338",
    "name": "Pawar Vivek Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12367",
    "name": "Sakunde Hanmant Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "901",
    "name": "Chavan Hanmant Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2247",
    "name": "Kanse Manohar Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "201",
    "name": "Kadam Sadashiv Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19625",
    "name": "Charniya Danji Naran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19645",
    "name": "Purbiya Mannubhai Babubhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2007",
    "name": "Shinde Dattatraya Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4630",
    "name": "Bhosale Janardhan Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "490",
    "name": "Yewale Shankar Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10870",
    "name": "Deshmukh Anil Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2854",
    "name": "Bhosale Arjun Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13887",
    "name": "Shinde Vijaykumar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2058",
    "name": "Panskar Vithal Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17094",
    "name": "Nawadkar Gulabrao Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13057",
    "name": "Sawant Kailash Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12290",
    "name": "Nalwade Raghunath Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17548",
    "name": "Bhosale Sandeep Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7310",
    "name": "Jagtap Nivrutti Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12186",
    "name": "Ghorpade Aruna Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12211",
    "name": "Jagtap Deepakrao Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12218",
    "name": "Adsul Kalpana Dhanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12219",
    "name": "Adsul Dhananjay Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12221",
    "name": "Mane Umesh Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12229",
    "name": "Chavan Vithal Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10500",
    "name": "Ghodekar Eknath Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3899",
    "name": "Kakade Laxman Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4384",
    "name": "Dhumal Pandurang Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16550",
    "name": "Nalawade Suryakant Krishna  Tn-1072-14"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16318",
    "name": "Lembhe Vijay Popat  Tn-621-19"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12097",
    "name": "Babar Nivruti Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12122",
    "name": "Bhandwalkar Pritam Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12180",
    "name": "Attar Ajij Bapumiyya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "923",
    "name": "Sabale Yamunabai Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14042",
    "name": "Sawant Anil Mugutrao  Tn-889-11"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "44",
    "name": "Sabale Pralhad Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3855",
    "name": "Dhumal Ashok Hanmantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10408",
    "name": "Kadam Vasant Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12025",
    "name": "Kamble Sushilkumar Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12051",
    "name": "Kadam Sunil Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9155",
    "name": "Pawar Phattesingh Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2739",
    "name": "Chavan Keshav Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17316",
    "name": "More Raghunath Tukaram  Tn-1528-9"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4493",
    "name": "Kakade Sadashiv Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4039",
    "name": "Pawar Kashinath Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21853",
    "name": "Shinde Bhausaheb Hiraman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10806",
    "name": "Bhosale Pravin Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11999",
    "name": "Phalke Kapil Satish"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12023",
    "name": "Phalke Sanjay Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13648",
    "name": "Chavan Mansing Parsharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13649",
    "name": "Chavan Ujwala Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12926",
    "name": "Chavan Vitthal Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10107",
    "name": "Dhumal Anil Nanaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11861",
    "name": "Sakunde Vikas Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11872",
    "name": "Mane Pradeep Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11921",
    "name": "Vaidhya Ravindra Madhusudhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11922",
    "name": "Patil Sanjay Bakajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18636",
    "name": "Kandare Ganesh Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12436",
    "name": "Ghadage Sunil Jaywantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7712",
    "name": "Lawand Sanjay Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23110",
    "name": "Londhe Jalindra Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23111",
    "name": "Shewde Rahul Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1696",
    "name": "Bhoite Shankar Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4787",
    "name": "Bhoite Bhujangrao Balwantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11896",
    "name": "Nikam Sunita Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13397",
    "name": "Pachupate Adhikarao Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11021",
    "name": "Bhoite Sanjay Mugutrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12025",
    "name": "Mestri Vandana Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11481",
    "name": "Shinde Santosh Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11314",
    "name": "Solaskar Hanmantrao Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11397",
    "name": "Dhumal Shantabai Harichandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11807",
    "name": "Barkade Muktabai Malhari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11809",
    "name": "Mehta Prashant Sandesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11818",
    "name": "Barkade Malhari Baba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11829",
    "name": "Jagtap Pushpa Lahu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11830",
    "name": "Lole Pratap Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11831",
    "name": "Mandhare Ajay Vishwas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11832",
    "name": "Mandhare Vishwas Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11833",
    "name": "Sable Sanjay Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11839",
    "name": "Bodhe Vinayak Raosaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11848",
    "name": "Shinde Kalidas Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11905",
    "name": "Kolpe Jagannath Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12079",
    "name": "Ahire Suresh Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12712",
    "name": "Pawar Dnyandev Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10296",
    "name": "Rajmane Usha Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10881",
    "name": "Phalke Rajendra Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13446",
    "name": "Khan Fayaz Gous"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13453",
    "name": "Bhoite Ratandip Arvind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13459",
    "name": "Khude Sanjay Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13494",
    "name": "Kadam Satvshila Pandhrinath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "903",
    "name": "Chaudhary Amol Pralhad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7739",
    "name": "Jagtap Shankar Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11655",
    "name": "Anute Bharat Bandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11838",
    "name": "Kadam Ramchandra Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23105",
    "name": "Jare Dnyaneshwar Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14045",
    "name": "Nimbalkar Mahendra Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10768",
    "name": "Jadhav Nivas Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11335",
    "name": "Bobade Dilip Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11731",
    "name": "Sutar Bharti Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11760",
    "name": "Pawar Jaywant Suryakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13357",
    "name": "Bhoite Ashok Laxmanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13386",
    "name": "Bhoite Arun Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13410",
    "name": "Shirke Santosh Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13418",
    "name": "Shinde Vijay Hanmantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13420",
    "name": "Dhumal Rajendra Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14129",
    "name": "Chavan Sharada Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8934",
    "name": "Phalke Savita Uttamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10501",
    "name": "Pawar Jagannath Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11682",
    "name": "Ranavare Shankar Uadhava"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11702",
    "name": "Gadhave Sanjay Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11704",
    "name": "Dhumal Ramchandra Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11707",
    "name": "Shirsawade Vinod Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11778",
    "name": "Bhujbal Balasaheb Divkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12769",
    "name": "Dsouza Venita Albert"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13313",
    "name": "Salunkhe Ashok Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13315",
    "name": "Kadam Dadasaheb Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13319",
    "name": "Sakunde Laxman Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13320",
    "name": "Sakunde Lalchand Gulchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13333",
    "name": "Shinde Jalandar Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23088",
    "name": "Kenjale Rajendra Shankar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "534",
    "name": "Darwajkar Salim Ibrahim"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2492",
    "name": "Wagh Vishwas Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9896",
    "name": "Jadhav Uttam Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9515",
    "name": "Bandodkar Devidas D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8356",
    "name": "Bhoite Baban Shahaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21546",
    "name": "Suryawanshi Navnath Kalba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10845",
    "name": "Gopali Usha Devendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13293",
    "name": "Patil Navnath Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13295",
    "name": "Patil Sarjerao Yashawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13296",
    "name": "Patil Muktabai Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13298",
    "name": "Jadhav Bhagwan Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23033",
    "name": "Sawant Vilas Hari"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "484",
    "name": "Pandey Hariprakash Nathuni"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "485",
    "name": "Pandey Anamika Hariprakash"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "486",
    "name": "Kenjale Ashok Hariram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6069",
    "name": "Chawan Ramdas Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11335",
    "name": "Pawar Rajendra Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9869",
    "name": "Pawar Narayan Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20449",
    "name": "Ahir Umesh Balaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6675",
    "name": "Bhilare Hanmant Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14089",
    "name": "Chavan Shital Nitin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14101",
    "name": "Bhosale Bapurao Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14102",
    "name": "Shingate Jitendra Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14103",
    "name": "Yadav Anil Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2582",
    "name": "Kandare Kisan Bapu Toli No 145/12"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9098",
    "name": "Lawand Shashikant Gorakhnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22982",
    "name": "Salunkhe Krishant Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22983",
    "name": "Shinde Krishna Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21978",
    "name": "Waghchoure Sachin Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19775",
    "name": "Disale Tanaji Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3538",
    "name": "Shinde Uttam Dinkarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1952",
    "name": "Sabale Bhimashankar Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13862",
    "name": "Ghorpade Ajit Vishwas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13865",
    "name": "Kenjale Abhijeet Jaywantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13879",
    "name": "Kenjale Jaywantrao Narayanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13900",
    "name": "Waghmale Niwas Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13903",
    "name": "Jagdale Haridas Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13904",
    "name": "Jagadale Rajendra Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13905",
    "name": "Humbe Bhimrao Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13909",
    "name": "Gharge Ankushrao Anantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13915",
    "name": "Shinde Sampatrao Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13917",
    "name": "Chaware Gajanan Babasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14059",
    "name": "Jadhav Arun Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14060",
    "name": "Jadhav Nanda Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14069",
    "name": "Agate Vijay Trimbak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15440",
    "name": "Pawar Vijay Aabaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24757",
    "name": "Mahtle Rohini Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6811",
    "name": "Shinde Anandrao Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16369",
    "name": "Sapakal Santu Sahdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9639",
    "name": "Shinde Jayprakash Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3915",
    "name": "Sabale Baliram Tatylaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3993",
    "name": "Phadtare Prakash Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11670",
    "name": "Metkari Jamir Abdulrajak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11813",
    "name": "Kadam Rupchand Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7407",
    "name": "Kadam Suresh Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19384",
    "name": "Patil Ganesh Chndrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21216",
    "name": "Gaikwad Amol Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11591",
    "name": "Chalake Aatmaram Mahadeo Tn"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9556",
    "name": "Jagtap Ramesh Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1643",
    "name": "Pujari Gajanan Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8434",
    "name": "Nikam Sakharam Sankhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11331",
    "name": "Pawar Vijay Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4467",
    "name": "Savadkar Dhanaji Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13835",
    "name": "Bhosale Dhananjay Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4574",
    "name": "Chavan Mahadeo Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11403",
    "name": "Pol Narayan Ankush"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13813",
    "name": "Bhoite Tushar Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14928",
    "name": "Shirke Avinash Diwanji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11279",
    "name": "Jagtap Dattatray Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11315",
    "name": "Solaskar Deepak Hanmantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11352",
    "name": "Shinde Vishnu Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11368",
    "name": "Nimbalkar Divakar Appasao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11394",
    "name": "Dhumal Dhananjay Harichandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11915",
    "name": "Kadam Dilip Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16679",
    "name": "Pathan Shamsuddin Sagarekha"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "368",
    "name": "Khandagale Ramchandra Waju"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12435",
    "name": "Ghadage Anil Jaywantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22814",
    "name": "Puthran Sushma Santosh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22815",
    "name": "Puthran Santosh Shina"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21721",
    "name": "Dalavi Prasad Pandharinath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "390",
    "name": "Varne Sambhaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "36",
    "name": "More Narayan Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1480",
    "name": "Bhoite Mahadeo Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14091",
    "name": "Jagtap Tanaji Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17016",
    "name": "Chavan Anandrao Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15049",
    "name": "Miss  Pawar Chhaya Dadasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12175",
    "name": "Phalke Mohan Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16808",
    "name": "Valve Vijay Dinkar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "576",
    "name": "Ghorpade Mahesh Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25219",
    "name": "Nadar Marykamla Hdavid"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4209",
    "name": "Kadam Shrirang Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2211",
    "name": "Mulik Bhiku Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11254",
    "name": "Sawant Maruti Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3354",
    "name": "Samindar N D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8379",
    "name": "Kadam Vasant Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15174",
    "name": "Ghadage Shahaji Jaywantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6108",
    "name": "Jagtap Kantilal Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10054",
    "name": "Jadhav Krishnat Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23579",
    "name": "Mehetre Sunil Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9859",
    "name": "Chavan Gorakhnath Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11601",
    "name": "Bhoite Prabhakar Vishwnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2545",
    "name": "Wagh Balwant Subhedar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1827",
    "name": "Pawar Ramchandra Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12784",
    "name": "Ghorpade Dattatray Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7516",
    "name": "Gaikwad Popat Nathu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20007",
    "name": "Jain Kalpana Jitesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11300",
    "name": "Sabale Kamal Ramdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14409",
    "name": "Ghadge Shankar Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3756",
    "name": "Salunkhe Bhagwan Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10976",
    "name": "Jagtap Trimbak Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22712",
    "name": "Sawant Sharad Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22725",
    "name": "Bagal Meena Balasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22726",
    "name": "Bagal Balasaheb Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10764",
    "name": "Kadam Ashok Dadaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11229",
    "name": "Bobade Lalasaheb Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11239",
    "name": "Dere Harichandra Subhedar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11017",
    "name": "Mete Baburao Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6476",
    "name": "Ingavale Chandrakant Bajarang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10769",
    "name": "Kadam Avachitrao Dadaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11109",
    "name": "Pawar Dilip Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11138",
    "name": "Ghadge Suresh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "691",
    "name": "Bhosale Vithal Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8463",
    "name": "Jadhav Krushna Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12234",
    "name": "Kolekar Shivaji Dattatray"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21539",
    "name": "Thamke Arvind Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13746",
    "name": "Bhoite Vinod Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13747",
    "name": "Kondalkar Nandini Ranjeet"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13750",
    "name": "Duduskar Shankar Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7595",
    "name": "Maskar Ramchandra Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8059",
    "name": "Kadam Manshing Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10167",
    "name": "Dhumal Nitin Shivjirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11087",
    "name": "Newase Sunil Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13731",
    "name": "Chavan Nandkumar Vaman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13737",
    "name": "Bhoite Prashant Mohanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13738",
    "name": "Yadav Balkrishna Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12996",
    "name": "Sawant Sanjay Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11673",
    "name": "More Pradip Vasantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16274",
    "name": "Matre Suresh Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11710",
    "name": "Phalke Hanmant Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2238",
    "name": "Shinde Shankar A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6893",
    "name": "Bhilare Mahadeo Pandurang"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "221",
    "name": "Lale Dagadu Shripati"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "524",
    "name": "Ghadge Anil Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20263",
    "name": "Patel Ranjit Chandbhas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22126",
    "name": "Newage Shivaji Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8544",
    "name": "Kute Ramnath Sukhdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15740",
    "name": "Shinde Kiran Vishwas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10577",
    "name": "Kenjale Devendra Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10638",
    "name": "Sakhare Chandrakant Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10640",
    "name": "Kumbhar Jagannath Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13672",
    "name": "Jadhav Vilas Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13684",
    "name": "Bhintade Rajan Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13687",
    "name": "Chavan Manoj Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2345",
    "name": "Sabale Maruti Appasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3908",
    "name": "Katkar Kumar Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16234",
    "name": "Pawar Maruti Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "294",
    "name": "Bhilare Shamrao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15893",
    "name": "Jaiswal  Ramsahy"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14310",
    "name": "Inamdar Mumtaj Dada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15731",
    "name": "Dongare Ramdas Mhasuji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11480",
    "name": "Sakhunde Laxman Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10701",
    "name": "Sutar Ashfak Ekabal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13954",
    "name": "Miss  Bagwan Saltanat Aliakbar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22825",
    "name": "Khandagale Sunanda Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10548",
    "name": "Bhoite Mahendra Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18833",
    "name": "Shaikh Ajeet Babaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5726",
    "name": "Bobade Hanmant Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4447",
    "name": "Solaskar Satish Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6361",
    "name": "Shinde Krishnakant Vyankatrao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "861",
    "name": "Suryawanshi Swapnil Kerappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10829",
    "name": "Sawant Popat Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8701",
    "name": "Sapkal Vilas Krishna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "430",
    "name": "Mokale Rahul Shantaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8004",
    "name": "Yadav Vasantrao S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10023",
    "name": "Kadam Vithal Kundlik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3948",
    "name": "Salunkhe Hanmant Jagdeorao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22630",
    "name": "Mahadik Dattaram Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12068",
    "name": "Mane Santosh Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12376",
    "name": "Chavan Yuvraj Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12897",
    "name": "Kakade Sarjerao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6380",
    "name": "Bhoite Pradeep Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9377",
    "name": "Bhoite Fatesingh Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12908",
    "name": "Pawar Baliram Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7509",
    "name": "Pawar Hanmant Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11931",
    "name": "Garde Shivaji Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9116",
    "name": "Wagh Suresh Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11502",
    "name": "Lawand Anilkumar Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "938",
    "name": "Jadhav Ramesh Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17352",
    "name": "Patil Sanjay Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7665",
    "name": "Javaregoda Kala Kalegoda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13387",
    "name": "Shinde Dhananjay Hindurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11763",
    "name": "Ghorpade Ravindra Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3267",
    "name": "Bhoite Dadasau Namdevrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3703",
    "name": "Phalke Balasaheb Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17661",
    "name": "Nikam Suresh Bajrang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2560",
    "name": "Jadhav Waman Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19142",
    "name": "Pol Gunawant Daulat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9744",
    "name": "Chavan Jayashree Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18849",
    "name": "Pathak Dayanarayan H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22340",
    "name": "Chavan Balaram Dhondu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17701",
    "name": "Pawar Mahesh Yeswant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12876",
    "name": "Solaskar Lalaso Vishwasrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3522",
    "name": "Chawan Shivaji Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10908",
    "name": "Parab Vishwanath Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12150",
    "name": "Chalake Sunil Laxmanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21960",
    "name": "Lembhe Ramrao Anadrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6757",
    "name": "Dhumal Sanjay Hanamant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11818",
    "name": "Sawant Shankar Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2969",
    "name": "Bhilare Dnyandeo Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7104",
    "name": "Babar Laxman Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7114",
    "name": "Babar Vijaya Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13262",
    "name": "Saste Jagnnath Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8061",
    "name": "Phalke Dattatraya Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11128",
    "name": "Pawar Shankarrao Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18332",
    "name": "Bhosale Sachin Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9170",
    "name": "Chavan Sadashiv Parasram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12799",
    "name": "Jagtap Satish Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11677",
    "name": "Shinde Mahadeo Baliram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6445",
    "name": "Anapat Ghanshyam Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8850",
    "name": "Gharal Kashinath Dyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10378",
    "name": "Salvi Maruti Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11498",
    "name": "Pawar Jaganath Baba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4010",
    "name": "Jadhav Vijay Vyankat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12510",
    "name": "Choudhari Arjun Jayshing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13839",
    "name": "Desai Suresh Mahadeo 543/55"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20064",
    "name": "Pawar Ramesh Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11903",
    "name": "Pawar Balkrishna Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14100",
    "name": "Gaikwad Ganpat Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7166",
    "name": "Chavan Krushnath Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15274",
    "name": "More Popat Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8149",
    "name": "Gaikwad Arvind Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10798",
    "name": "Kadam Hemant Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13717",
    "name": "Solaskar Ravindra Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3415",
    "name": "Chawan Rangrao Appasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2713",
    "name": "Bhosale Ankush Sudamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13118",
    "name": "Mhamane Sushma Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4856",
    "name": "Lembhe Hanmant Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10272",
    "name": "Nikam Ramesh Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13287",
    "name": "Jadhav Nagesh Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6996",
    "name": "Ghorpade Chandrakant Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11295",
    "name": "Jagtap Vijaykumar Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3393",
    "name": "Bhilare Eakanath Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21537",
    "name": "Shinde Prakash Jayram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13457",
    "name": "Dhanawade Santosh Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19023",
    "name": "Salunkhe Rajendra Jagdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14253",
    "name": "Bhosale Santosh Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9421",
    "name": "Gaikwad Gulab Shravan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1245",
    "name": "Bhilare Baban Mahadev 37/2"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21361",
    "name": "Surve Ramesh Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21501",
    "name": "Kabadi Vithal Rambhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15042",
    "name": "Phalke Jayashree Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15556",
    "name": "Ghadage Anil Vitthalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10746",
    "name": "More Suresh Raghu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12820",
    "name": "Bhosale Dattatray Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9005",
    "name": "Fernandes Andrew Anthony"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9719",
    "name": "Gadhave Siddheshwar Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12540",
    "name": "Ghadage Tanaji Dhanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11605",
    "name": "Patil Suresh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6596",
    "name": "Awade Sanjay Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8147",
    "name": "Phalke Anjana Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18768",
    "name": "Mulaye Nilesh Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11626",
    "name": "Jagtap Ramchandra Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12474",
    "name": "Pawar Vijaya Duryodhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11403",
    "name": "Malpote Dattu Raghunath 477/21"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2257",
    "name": "Koli Latabai Kailesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16540",
    "name": "Lokhre Prashant Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18895",
    "name": "Pawar Prakash Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11929",
    "name": "Pawar Varsha Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12631",
    "name": "Sanas Ramesh Sadashiv Tn-563-27"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11537",
    "name": "Chikne Shankar Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13937",
    "name": "Patil Vaishali Ualhas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5716",
    "name": "Phalke Suresh Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11390",
    "name": "Sakunde Shivaji Mugutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4036",
    "name": "Shinde Arvind Wishvasrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2183",
    "name": "Mandhare Shivaji Namdeo B-537"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12221",
    "name": "Shinde Satish Dadaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14288",
    "name": "Jagdale Shivaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "304",
    "name": "Chawan Rajaram Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11544",
    "name": "Nalge Sunil Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9084",
    "name": "Bobade Bapusaheb Dashrath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13829",
    "name": "Dharmadhikari Vilas Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7126",
    "name": "Narvekar Nandkumar Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11348",
    "name": "More Dilip Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2053",
    "name": "Bhosale Vasant Sawala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9946",
    "name": "Pisal Ashok Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10397",
    "name": "Khopade Chandrkant Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5562",
    "name": "Jadhav Vithal Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17425",
    "name": "Kadam Laxman Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11938",
    "name": "Jadhav Sharmila Siddhanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2844",
    "name": "Bhilare Nivruti Shamrao 694/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14545",
    "name": "Shidruk Adhik Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5848",
    "name": "Lembhe Balasaheb Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3156",
    "name": "Sabale Baban Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18504",
    "name": "Shelar Prakash Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4078",
    "name": "Chavan Vinayak Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8025",
    "name": "Nikam Mahadeo Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19295",
    "name": "Jadhav Suresh Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20045",
    "name": "Dhanwade Shaliendra Dhanjayrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20059",
    "name": "Sule Pankaj Purushottam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20062",
    "name": "Nikam Manoj Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9291",
    "name": "Dhere Vasudeo Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18769",
    "name": "Mulaye Vivek Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8772",
    "name": "Ithape Dnyaneshwar Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13491",
    "name": "Ghorpade Dilip Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6142",
    "name": "Sakunde Pralhad Dadu Toli No 395/A19"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21669",
    "name": "Tak Pradeep Prsdeep  Jagdish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21673",
    "name": "Chavan Ganesh Ganesh  Kishan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21674",
    "name": "Chavan Rajendra Rajendra  Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21703",
    "name": "Mishra Anil Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21729",
    "name": "Gadhiya Yasmin Yasmin Chootu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21738",
    "name": "Ambale Shivaji Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21763",
    "name": "Patil Manohar Amrut"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18436",
    "name": "Ranvare Manik Hiralal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22662",
    "name": "Shenoy Swapnil Chanrdakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18391",
    "name": "Yadav Kishore Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8810",
    "name": "Nimbalkar Madhav Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4971",
    "name": "Palskar Shashikant Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "520",
    "name": "Karne Ramchandra Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17462",
    "name": "Bobade Shivaji Popatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21701",
    "name": "Shikh Abdul Nabi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21732",
    "name": "Shaikh Kamarujima Sabibullh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21752",
    "name": "Shaikh Salma Makbul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12419",
    "name": "Jadhav Anil Kisanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19766",
    "name": "Abdul Majid Latif Alwari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19785",
    "name": "Waghmode Dattu Subhash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19792",
    "name": "Tare Chintaman Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19796",
    "name": "Yadav Deolas Bihari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21323",
    "name": "Singh Jagdishkumar Bechan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21330",
    "name": "Walmiki Risipal Bhoduram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21387",
    "name": "Khade Sanjay Maroti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21418",
    "name": "Sarvade Nagnath Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21442",
    "name": "Pal Chandrapal Purushottam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21477",
    "name": "Pangerkar Anand Sharad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21478",
    "name": "Amrute Kiran Ravindra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21542",
    "name": "Galav Datta Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19095",
    "name": "Gupta Lalaji Bholanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19135",
    "name": "Mane Ramchandra Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19169",
    "name": "Yadav Prakash Jelu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19209",
    "name": "Sawant Ashok Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19210",
    "name": "Raje Ajit Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19321",
    "name": "Katkar Raghunath Tatoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19326",
    "name": "Dhande Vilas Vishwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19330",
    "name": "Palya Uddaya Hiru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19335",
    "name": "Yadav Kansraj Murli"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19383",
    "name": "Ahamad Istiyak Isak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19385",
    "name": "Tiwari Ramchandra Chandrama"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19386",
    "name": "Pal Mahendrapratap M"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19397",
    "name": "Khan Firoz Gulam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19431",
    "name": "Pandye Devmani Chandrika"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19477",
    "name": "Hatiskar Surendra J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19478",
    "name": "Pasi Shyam-Bahadur B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19494",
    "name": "Ahemed Shafik Rasool"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19495",
    "name": "Hasin Ahemad Abdul Kudrus Shidhaki"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19521",
    "name": "Upadhay Shashikant Brijlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19522",
    "name": "Shinde Gokul Babasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19588",
    "name": "Chavan Ramdas Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19590",
    "name": "Lomate Dnyaneshwar Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19599",
    "name": "More Rajendra Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19616",
    "name": "Rajbhar Ramavad Sakku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19619",
    "name": "Shaha Sanat Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19626",
    "name": "Parab Shrikant Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19630",
    "name": "Danwale Vilas Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19672",
    "name": "Patil Ravindra Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19687",
    "name": "Patil Yashwant Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19696",
    "name": "Mohmod Hushen Abdul Hamid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19697",
    "name": "Prajapati Brujabhan Bhiriram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19698",
    "name": "Sibte Hasan Afjal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19702",
    "name": "Gorule Ramesh Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19708",
    "name": "Mishra Ramdatta Rambuzarat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19720",
    "name": "Virkar Shubhash Appa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19727",
    "name": "Pal Sabha Shankar Satiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19737",
    "name": "Dhavale Tukaram Mariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19740",
    "name": "Navsupe Ramesh Shivram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19745",
    "name": "Ravan Shivaji Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19753",
    "name": "Bagade Sanjay Dashrat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19754",
    "name": "Patil Jagadish Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10862",
    "name": "Bhagat Ankush Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6468",
    "name": "Rajeshirke Nitin Prataprao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10638",
    "name": "Imandar Shabbir Dastgir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11719",
    "name": "Jadhav Sunil Gajanan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20341",
    "name": "Matkar Johny Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6385",
    "name": "Lembhe Vikas Buasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5273",
    "name": "Nikam Ankush Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11113",
    "name": "Shinde Krishnat Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19876",
    "name": "Paranjpe Digamber Sharad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5732",
    "name": "Karne Pandurang Damodar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5733",
    "name": "Dhumal Subhash Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18253",
    "name": "Tiwari Subhashchandra Harishchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3898",
    "name": "Jadhav Sumant Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6791",
    "name": "Pawar Virsen Aanandarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18200",
    "name": "Kavale Mohan Janardhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18631",
    "name": "Karan Mohan Badal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15064",
    "name": "Nalwade Raju Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6924",
    "name": "Pisal Dilip Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10733",
    "name": "Maharugade Raghunath Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14350",
    "name": "Mohite Rajendra Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12305",
    "name": "Gaikwad Krishna Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1307",
    "name": "Jaikar Vithal R     199/A/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5351",
    "name": "Shinde Arun Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20904",
    "name": "Siriya Brijalal Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9736",
    "name": "Jagtap Mahipat Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14505",
    "name": "Chavan Umakant Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19763",
    "name": "Mane Mahadev Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17002",
    "name": "Jagtap Prafulla Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14235",
    "name": "Kindre Dattatray Nathoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10912",
    "name": "Pol Ashok Meghraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14336",
    "name": "Salunkhe Appaso Pralhad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "717",
    "name": "Shitole Sanjay Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20952",
    "name": "Dhuri Sheetal Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18266",
    "name": "Bhuwad Dattaram Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8856",
    "name": "Salunkhe Sampat Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20941",
    "name": "Madiwar Krishna Ramanna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19966",
    "name": "Katkar Sachin Popat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16991",
    "name": "Wagh Kamlesh Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18521",
    "name": "Kadam Abasaheb Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17120",
    "name": "Mashakar Namdev Ganapthi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13567",
    "name": "Ghanwat Pramod Anandraob-9149"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18237",
    "name": "Khopade Narsing Gulab Rao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13655",
    "name": "Sakunde Dattatray Hindurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20404",
    "name": "Sakpal Sidharth Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17447",
    "name": "Waikar Pradeep Hanumant  Tn-1544-1"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10497",
    "name": "Mulla Abdulrashid Najmuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12558",
    "name": "Rajpure Dattatray Nathoba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2230",
    "name": "Poonia Sandeep Nanar Ram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10512",
    "name": "Shaikh Mahmmadsharif Shamshuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13340",
    "name": "Pawar Bhausaheb Atmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20532",
    "name": "Dhole Maruti Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18254",
    "name": "Yadav Ravindra Kalpanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17007",
    "name": "Bhagwat Jaywant Kundlik"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20031",
    "name": "Patil Ramchandra Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20545",
    "name": "Dhole Subhash Yadavrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "600",
    "name": "Londhe Tanaji Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6771",
    "name": "Kumbhar Ramesh Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20458",
    "name": "Jadhav Bhardwaj Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17579",
    "name": "Waghamare Lahanu Santu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7464",
    "name": "Yadav Balkrishna Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23136",
    "name": "Kunder Somnath Dooja"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9313",
    "name": "Jagtap Chandrakant Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9638",
    "name": "Jagtap Nirmala Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18061",
    "name": "Sapkal Hanmant Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20942",
    "name": "Godse Rupesh Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8539",
    "name": "Deshmukh Sambhaji Shivajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8858",
    "name": "Bhagwat Shivaji Savlaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17279",
    "name": "Jadhav Prabhakar Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7501",
    "name": "Garud Ashok Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20378",
    "name": "Ahirwar Umesh Baijnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20445",
    "name": "Ubhare Sadanand Sripat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17827",
    "name": "Kapse Shrikant Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17481",
    "name": "Desai Anil Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17497",
    "name": "Warange Santosh Vasant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "709",
    "name": "Nikam Laxman Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11031",
    "name": "Yadav Alka Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12164",
    "name": "Kadam Pramod Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4296",
    "name": "Sangle Dadasaheb Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13009",
    "name": "More Suresh Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4836",
    "name": "Chavan Vijay Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11530",
    "name": "Shekh Begam Satar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7181",
    "name": "Chawan Mohan Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2427",
    "name": "Mohite Namdev Khashaba  135/11"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17332",
    "name": "Konar Ollahummal Muthswami"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8735",
    "name": "Jain Raj Tarsenlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23173",
    "name": "Uchil Ranjith Madhav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20032",
    "name": "Narvekar Dilip Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20363",
    "name": "Chari Mohan Mohan Vardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20586",
    "name": "Chalke Ashok Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12662",
    "name": "Phalake Jayashri Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8411",
    "name": "Kadam Sanjay Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22054",
    "name": "Jadhav Umesh Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16317",
    "name": "Shedage Mahesh Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14072",
    "name": "Gijare Satish Moreshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4868",
    "name": "Chavan Dilip Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5718",
    "name": "Phalke Vijay Pantagrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19890",
    "name": "Jadhav Dnyandev Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17229",
    "name": "Dhayalkar Rajani Rajesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17235",
    "name": "Chavan Bhagwan Soma"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13493",
    "name": "Kadam Pandhrinath Appa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6533",
    "name": "Kadam Hanmant Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16999",
    "name": "Chandanshive Gautam Shirpa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17013",
    "name": "Jadhav Krishna Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17016",
    "name": "Tambe Niranjan Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17061",
    "name": "Chudasma Ramniklal Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17075",
    "name": "Salvi Ajay Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17076",
    "name": "Salvi Sandhya Ajay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8345",
    "name": "Bhoite Shivajirao Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22845",
    "name": "Pillai Mony Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14438",
    "name": "Mahangade Balkurashna S 326/14"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18477",
    "name": "Mandhare Vikas Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16925",
    "name": "Puri Awadheshpuri Jaganpuri"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16934",
    "name": "Singh Shobnath Hardayal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20452",
    "name": "Khankar Sunil Bhagawant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20468",
    "name": "Manjarekar Vedika Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19248",
    "name": "Mane Ashwini Vithhal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19250",
    "name": "Sapkal Ravindra Gambhirrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19251",
    "name": "Mane Ameet Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19329",
    "name": "Gandhi Pritesh Bharat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19330",
    "name": "Gandhi Saurabh Bharat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19334",
    "name": "Patil Bhagwan Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19335",
    "name": "Shah Manilal M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19338",
    "name": "Sangoi Rohini Manilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19475",
    "name": "Upadhyay Dwarkaprasad Badriprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19521",
    "name": "Pawar Sanjay Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22317",
    "name": "Choksi Rashmi Pravin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18435",
    "name": "Ranvare Jitendra Hiralal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19365",
    "name": "Todkar Santosh Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11950",
    "name": "Jadhav Prakash Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13888",
    "name": "Shinde Santosh Jijaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1534",
    "name": "Bhoite Vithalrao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "854",
    "name": "Pisal Vinayak Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9123",
    "name": "Sakhare Veena Vikas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9730",
    "name": "Jadhav Kamal Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8966",
    "name": "Ghadge Ramchandra Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17853",
    "name": "Pawar Ranjana Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22747",
    "name": "Madhavi Bhalchandra Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22811",
    "name": "Jindal Sanjay G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22824",
    "name": "Khandagale Nitin Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22831",
    "name": "Gandhi Riddhi Pritesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22834",
    "name": "Tayade Madhukar Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6414",
    "name": "Jadhav Vijay Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8251",
    "name": "Nawadkar Dashrath Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18997",
    "name": "Mantri Shubhangi Surendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19001",
    "name": "Randive Shubhada Kamlakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19047",
    "name": "Bedsur Suresh Dattatrey"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19110",
    "name": "Nerurkar Bhalchandra Anantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22207",
    "name": "Yadav Girijashankar Lalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22231",
    "name": "Parmar Sanjay Tribhuvan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5308",
    "name": "Rane Mahadeo Appaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9343",
    "name": "Jadhav Dhanaji Dada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16836",
    "name": "Pisal Kondiba Parabati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2917",
    "name": "Marathe Govind Bhiva"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3876",
    "name": "Pathare Dagadu Balku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18108",
    "name": "Salunkhe Laxman Ananda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22188",
    "name": "Mandhare Rakesh Subhash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20177",
    "name": "Hak Riyaz Ahmad Abdul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12331",
    "name": "Shinde Madhukar Piloba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22085",
    "name": "Parab Prakash Ankush"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22106",
    "name": "Miss  Kolekar Mangala Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22107",
    "name": "Kolekar Jayesh Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22109",
    "name": "Kolekar Sunanda Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20092",
    "name": "Gurav Balaram Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20094",
    "name": "Tarmale Satish Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20095",
    "name": "Patel Amin Jahir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20100",
    "name": "Parera Rajendra John"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20105",
    "name": "Gurav Namdeo Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20106",
    "name": "Patil Ashok Appa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20116",
    "name": "Yadav Rajaram Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20127",
    "name": "Chavan Santosh Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20134",
    "name": "Nage Yojana Vikas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20139",
    "name": "Darekar Shivaji Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20154",
    "name": "Mhatre Jitendra Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20156",
    "name": "Shelar Jagannath Rambhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10347",
    "name": "Chauhan Ramsevak Jagharisingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11709",
    "name": "Deshmukh Shantabai Vishwash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22313",
    "name": "Tetme Rajaram Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3626",
    "name": "Salate Anandrao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5387",
    "name": "Bhosale Chandrakant Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10810",
    "name": "Gaikawad Ashok Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10049",
    "name": "Mane Sunil Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3882",
    "name": "Bhosale Pratap Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23657",
    "name": "More Vinayak Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13795",
    "name": "Pathan Amir Mhamud"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17774",
    "name": "Dhumal Hindurao Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6964",
    "name": "Kshirsagar Mohan Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18806",
    "name": "Borge Ganpat Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18854",
    "name": "Khamkar Satish Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16989",
    "name": "More Chandrakant Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2718",
    "name": "Kharat Anandrao Girjappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11484",
    "name": "Mhamane Mahanada Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17459",
    "name": "Shinde Shivaji Dnyaneshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5675",
    "name": "Duraphe Dattatray Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2558",
    "name": "Desai Bajirao Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10735",
    "name": "Gaikwad Dnyandeo Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11889",
    "name": "Dhumal Chandrasen Vishwanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12213",
    "name": "Sawant Santosh Genuba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15075",
    "name": "Chavan Shekhar Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "839",
    "name": "Dhumal Vinayak Genaba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2432",
    "name": "Chaudhary Devendrakumar Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11208",
    "name": "Chavan Avinash Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18452",
    "name": "Gholap Madhav Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17844",
    "name": "Kapse Sampat Dnyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "177",
    "name": "Sawant Sudhakar Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10991",
    "name": "Sabale Balaso Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24124",
    "name": "Shibe Vilas Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20470",
    "name": "Mozer Ganesh Gopinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14025",
    "name": "Khot Kashinath Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13121",
    "name": "Jadhav Gunaji Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18658",
    "name": "Shingan Ravindra Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21416",
    "name": "Ravan Kiran Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15282",
    "name": "Patil Bandu Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13696",
    "name": "Kureshi Aarif Hamja"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15222",
    "name": "Solaskar Hanmant Mahadeorao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11037",
    "name": "Jadhav Lalaso Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9686",
    "name": "Kadam Suresh Shreerang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18485",
    "name": "Katkar Suresh Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18519",
    "name": "Sukale Hanmant Karbhari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18559",
    "name": "Soni Ashokkumar Kesani"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18560",
    "name": "Mandhare Sachin Vilasrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18563",
    "name": "Hegishte Prashant V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18564",
    "name": "Vichare Sushil D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22664",
    "name": "Yadav Amol Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9043",
    "name": "Rajpure Baban Dagdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15023",
    "name": "Pawar Jaysing Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13656",
    "name": "Pisal Santosh Hanmantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9846",
    "name": "Sakunde Vijay Balkrishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18256",
    "name": "Sharma Rajeshkumar Deviprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7314",
    "name": "Shinde Vishwas Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18406",
    "name": "Dakave Hari Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18460",
    "name": "Rathod Laxman T"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19937",
    "name": "Sawant Rajendra Eknath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7460",
    "name": "Kanojiya Rajaram Dakhini"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19292",
    "name": "Hule Manda Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3299",
    "name": "Phalake Pralhad Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19829",
    "name": "Patil Sandip Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10826",
    "name": "Anpat Popat Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13232",
    "name": "Sapkal Kailas Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13233",
    "name": "Angre Atul Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13260",
    "name": "Kalnge Kundlik Daulati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13261",
    "name": "Kambale Navnath Aba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13268",
    "name": "Choudhari Mansing Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13269",
    "name": "Jadhav Siddharth Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13280",
    "name": "Lembhe Vishwas Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5098",
    "name": "Bhoite Jitoba Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10935",
    "name": "Gaikwad Vijay Pralhad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16575",
    "name": "Chavan Dattatray Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11708",
    "name": "Deshmukh Vishwash Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13204",
    "name": "Chavan Arjun Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13205",
    "name": "Dhumal Krushnarao Jayawantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13218",
    "name": "Jadhav Pravin Harichandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13220",
    "name": "Suryavanshi Dilip Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13221",
    "name": "Avghade Santosh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10862",
    "name": "Jagtap Sangeeta Balaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14277",
    "name": "Mahangare Nivrutti Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17426",
    "name": "Sakunde Mahendra Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13171",
    "name": "Mandhare Sandeep Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13176",
    "name": "Shinde Vitthal Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4534",
    "name": "Karekar Subhash S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17258",
    "name": "More Babutai Yeswant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16662",
    "name": "Nikam Tukaram Subhanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9255",
    "name": "Jadhav Satyawan Prataprao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "128",
    "name": "Patole Bhimrao Malhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14190",
    "name": "Patil Ashok Balku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23637",
    "name": "Mediratta Arpana Atul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3113",
    "name": "Mane Sopan Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11327",
    "name": "Phalke Ranjeet Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13146",
    "name": "Sawant Bharat Tanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13151",
    "name": "Borate Tejaswini Vikram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13153",
    "name": "Dhumal Dilip Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3726",
    "name": "Shinde Rajram Bhagwan 443/46"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3461",
    "name": "Kenjale Gangaram Rangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18160",
    "name": "Shelar Ramesh Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18179",
    "name": "Patil Bharat Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23633",
    "name": "Mehta Saurabh Brijmohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13964",
    "name": "Shelake Vishnu Chimaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11321",
    "name": "Shivankar Madhukar Malhari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11897",
    "name": "Shinde Mahadeo Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13127",
    "name": "Yadav Vinod Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13128",
    "name": "Chavan Lahu Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13136",
    "name": "Sahikh Ramjan Babalal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13959",
    "name": "Kulkrani Snehlata Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14418",
    "name": "Shinde Trimbak Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13075",
    "name": "Jadhav Sopan Dagdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13094",
    "name": "More Prakash Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13109",
    "name": "Malusare Dnyaneshwar Dharmu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13112",
    "name": "Ghorapade Sanjay Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18106",
    "name": "Fonde Baban Santu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18134",
    "name": "Kapse Gangaram Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23597",
    "name": "Gharat Nitin Arjun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18301",
    "name": "Gaikwad Vishnu Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6689",
    "name": "Phalake Anil Sampatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11234",
    "name": "Shinde Dattaray Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12885",
    "name": "Sakunde Ramesh Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13081",
    "name": "Khuspe Jagannath Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1784",
    "name": "Pawar Tukaram Sawalaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19559",
    "name": "Lohar Ravindra Kalu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7136",
    "name": "Barge Raghunath Vyankat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "61",
    "name": "Bhasagare Dattatraya Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14882",
    "name": "Yadav Uttam Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17965",
    "name": "Kenjale Jaywant Subhedar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9317",
    "name": "Jagtap Bharati Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6591",
    "name": "Phadtare Dhansing Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9694",
    "name": "Chavan Rajendra Sampatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19872",
    "name": "Dhamanaskar Sudhir Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12923",
    "name": "Bhilare Shivaji Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10278",
    "name": "Konde Ashok Laxman  Tn"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3995",
    "name": "Pawar Arun Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18422",
    "name": "Nirala Mahendra Shriram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22171",
    "name": "Parab Naresh Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9515",
    "name": "Budhawale Bhairu Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9746",
    "name": "Sakunde Balkrishna Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13015",
    "name": "Bhosale Sachin Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17678",
    "name": "Jadhav Hanmant Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23528",
    "name": "Thapar Parin Harbans"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23529",
    "name": "Patankar Satish Hanmantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10517",
    "name": "Nalawade Pradeep Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10983",
    "name": "Zanzurne Sharad Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11218",
    "name": "Sakpal Rohidas Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14722",
    "name": "Sawant Arjun Gopala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23475",
    "name": "Bhuskute Deepak Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14803",
    "name": "Kamatev Pravin Nitin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14805",
    "name": "Shedage Kiran Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15082",
    "name": "Jagtap Jayant Bhimrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12607",
    "name": "Nimbalkar Pratap Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17503",
    "name": "Khan Abdulla Kadar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17486",
    "name": "Jagdale Ganesh Jaywant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16073",
    "name": "Soda Bangali Bharti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12729",
    "name": "Kadam Vikaram Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "788",
    "name": "Kadam Rajaram Khashab"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14785",
    "name": "Pawar Sanjay Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9485",
    "name": "Nimbalkar Sushila Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18736",
    "name": "Dhumal Santosh Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4136",
    "name": "Ahirekar Balkrishna Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11092",
    "name": "Shinde Vikas Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14659",
    "name": "Sakunde Kiran Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14758",
    "name": "Sawant Shankar Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14930",
    "name": "Kadam Sachin Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14933",
    "name": "Chavan Dnyaneshwar Shivajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8178",
    "name": "Dhanawade Jagannath Rau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13886",
    "name": "Mohile Sarika Motiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1209",
    "name": "Shinde Jaysing Yadavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23388",
    "name": "Shimpi Pradip Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23398",
    "name": "Miss  Raghupati Sonal Hiranna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22133",
    "name": "Gadgil Samruddhi Vikram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14554",
    "name": "Kshirsagar Dilip Bhimrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14555",
    "name": "Kshirsagar Vijaya Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8362",
    "name": "Pisal Rohidas Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23376",
    "name": "Kotawadekar Chandrakant Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17594",
    "name": "Sakat Nanda Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9509",
    "name": "Nimbalkar Uday Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14531",
    "name": "Bhosale Ajit Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14533",
    "name": "Kambale Balaso Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10728",
    "name": "Bhosale Sadashiv Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11263",
    "name": "Mandhare Balu Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12568",
    "name": "Kashid Rajesh Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10365",
    "name": "Valekar Suresh Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17101",
    "name": "Wagh Santosh Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23360",
    "name": "Patel Pamiben Parbat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14511",
    "name": "Deshmukh Prashant Bhujangrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16193",
    "name": "Gujar Suvarna Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8214",
    "name": "Pawar Shamrao Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23337",
    "name": "Shah Rajesh Premchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23343",
    "name": "Shetty Suchitra Jayuikram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17368",
    "name": "Shinde Ratnamala Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15006",
    "name": "Sangar Sachin Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23330",
    "name": "Patel Nilesh Parshuttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23331",
    "name": "Patel Ashishkumar D"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10574",
    "name": "Sutar Anirudda Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14389",
    "name": "Pawar Shreedhar Hindurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14390",
    "name": "Patane Suhas Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14398",
    "name": "Mane Jyoti Adhik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14399",
    "name": "Shinde Atul Mahesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14437",
    "name": "Narsingshetty Sunil Dundappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14446",
    "name": "Dhamal Subhash Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14449",
    "name": "Dhumal Sandhya Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14451",
    "name": "Dhumal Ramrao Buvasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14453",
    "name": "Dhumal Nanaso Mansingrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14455",
    "name": "Miss  Dhumal Manisha Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14457",
    "name": "Dhumal Sujata Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14464",
    "name": "Pawar Rekha Pradip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14465",
    "name": "Jadhav Dipak Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14469",
    "name": "Chavan Mahesh Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14477",
    "name": "Kulkarni Vinod Suryanarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20436",
    "name": "Bhoite Prithviraj Bhushan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17088",
    "name": "Jagtap Ravindra Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23304",
    "name": "Gajbhiye Surendra Someshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23305",
    "name": "Gajbhiye Pradnya S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23306",
    "name": "Pothran Navish Narayana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23310",
    "name": "Lokhande Suresh Sukhdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11108",
    "name": "Nikam Rajesh Uttamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14331",
    "name": "Inamdar Ajija Mahamad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14335",
    "name": "Bandal Mahesh Sharad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14362",
    "name": "Chitragar Swati Devidas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14377",
    "name": "Taware Abhay Anirudha"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14379",
    "name": "Bhosale Nitin Arjunrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "401",
    "name": "Jadhav Narayan Yeswant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22578",
    "name": "Sonawane Vishwas Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21298",
    "name": "Jadhav Sunil Keru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21385",
    "name": "Jadhav Sheshrao Ghyanuji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "125",
    "name": "Nalawade Gajanan Chandrakant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "170",
    "name": "Sansare Mahaendra Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9312",
    "name": "Bhoite Sunanda Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23270",
    "name": "Chavan Sanjay Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23271",
    "name": "Wayangankar Yogesh Suryakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23273",
    "name": "Kirve Sachin Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23276",
    "name": "Bhosle Sneha Sudeshchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23278",
    "name": "Vakil Sanat Ramanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23279",
    "name": "Rai Sudhakar Surendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23280",
    "name": "Shenoy Prashant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23284",
    "name": "Kambli Shashikant Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23286",
    "name": "Tamhankar Shailesh Vishnupantaggptr"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7226",
    "name": "Salate Kashinath Rau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23245",
    "name": "Dabholkar Neha Nitin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23254",
    "name": "Masurkar Umesh Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14294",
    "name": "Mulani Rafik Balekhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10808",
    "name": "Shinde Vishwas Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14260",
    "name": "More Uttam Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14262",
    "name": "Solaskar Laxman Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14263",
    "name": "Sawant Subhash Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14265",
    "name": "Doshi Maniklal Chhaganlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14266",
    "name": "Shinde Sanjay Bhavsaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14267",
    "name": "Agam Nandkumar Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14272",
    "name": "Kharate Suresh Bhausaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7280",
    "name": "Jagtap Digambar Machindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12730",
    "name": "Patil Ananda Rajaram 938-18"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9379",
    "name": "Dhumal Madhukar Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11762",
    "name": "Kadam Dilip Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19123",
    "name": "Patil Sharad Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23082",
    "name": "Chikane Bharat Dnyandev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23220",
    "name": "Sakunde Santosh Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23224",
    "name": "Shah Santoshkumar Chandanalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23225",
    "name": "Jain Ajay Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23228",
    "name": "Masurkar Mahesh Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23229",
    "name": "Jain Sangeeta Sunil"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1176",
    "name": "Kulkarni Purva Kedar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13637",
    "name": "Veer Vijaya Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9351",
    "name": "Dhumal Ashok Pilaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8546",
    "name": "Bhoite Rohidas Dasharath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21015",
    "name": "Halde Shyamsunnisa Alimiya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21032",
    "name": "Adhatrao Vinayak Neelkanth"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18454",
    "name": "Solanki Vinod Karsen"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16552",
    "name": "Yewale Sachin Suresh  Tn-103-A-36"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11865",
    "name": "Gaikawad Dattatray Shreerang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6434",
    "name": "Barge Tanaji Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13624",
    "name": "Shete Amitraj Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13907",
    "name": "Deshmukh Rajendra Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23179",
    "name": "Mishra Awadhesh Sadanand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12562",
    "name": "Deshmukh Kamalakar Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13594",
    "name": "Ahirekar Laxman Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11625",
    "name": "Pawar Dilip Sudam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13579",
    "name": "Nalawade Hemant Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20976",
    "name": "Shaikh Ismail Ismil Lateef"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18191",
    "name": "Mane Vasant Krushnat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13942",
    "name": "Kulkarni Vrishali Jayant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14194",
    "name": "Kumbhar Valmik Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17132",
    "name": "Salunkhe Bajarange Shirpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8849",
    "name": "Thele Baburao Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17112",
    "name": "Pawar Dadaso Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6849",
    "name": "Vanarase Ashok Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18626",
    "name": "Narkar Prashant Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9793",
    "name": "Chavan Ranarao Wamanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13535",
    "name": "Bagal Bharat Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13537",
    "name": "Patil Suresh Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16580",
    "name": "Dhamal Abhijit Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11036",
    "name": "Kamble Ravindra Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11592",
    "name": "Nalawade Dayanand Gundo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7381",
    "name": "Ghadage Vijay Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2295",
    "name": "Shinde Shankar Nivrutti  Tn-232-20"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21471",
    "name": "Jagatap Dayanand Dadaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20972",
    "name": "Parulekar Suresh Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13481",
    "name": "Kadam Vikas Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22445",
    "name": "Kamble Suresh Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20783",
    "name": "Mane Maruti Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16864",
    "name": "Gurav Satyawan T"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4627",
    "name": "Vibhute Nandkumar Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13971",
    "name": "Miss  Kalkundre Nayantara Bhairu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15590",
    "name": "Jagtap Chaaya Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11956",
    "name": "Mane Bhagwat Navji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10027",
    "name": "Ithape Sampat Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12377",
    "name": "Jadhav Dadasaheb Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22435",
    "name": "Deshmukh Devendra Prabhakar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "334",
    "name": "Ahire Popat Gajmal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4785",
    "name": "Sapkal Subhash Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10568",
    "name": "Mane Ravindra Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17352",
    "name": "Shinde Chandrakant Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13666",
    "name": "Kadam Nitin Yadavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18233",
    "name": "Jaiswal Rampayare Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18264",
    "name": "Pandey Arunkumar Vishwanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7999",
    "name": "Kambali Mahendra Manohar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20589",
    "name": "Rasam Shyamsunder Balaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18193",
    "name": "Dmello Cagetane John"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8851",
    "name": "Chavan Dinkar Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15223",
    "name": "Nalawade Navnath Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21247",
    "name": "Parmar Rupesh Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9237",
    "name": "Pathan Sahidkhan Jalalkhan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12410",
    "name": "Shinde Dattatray Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7506",
    "name": "Kokate Chandrakant Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12817",
    "name": "Pawar Subhash Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11827",
    "name": "Phalke Balasaheb Nathu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12902",
    "name": "Sakunde Sunil Sitamra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1718",
    "name": "Bhoite Shivaji Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1413",
    "name": "Chavan Gulab Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2143",
    "name": "Jadhav Shankar Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15594",
    "name": "Tripathi Raja Muipadin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16312",
    "name": "Sabale Sangita Ashok ( G )"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8823",
    "name": "Bhoite Arun Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9697",
    "name": "Yadav Mahadeo Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1861",
    "name": "Kahare Ramabhavan Ayodhyaprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2146",
    "name": "Jadhav Dattatraya V"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11236",
    "name": "Harijan Hansraj Bhusal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9354",
    "name": "Dhumal Vishwas Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9891",
    "name": "Pisal Shiwaji Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10908",
    "name": "Salunkhe Ankush Dadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15298",
    "name": "Shelar Vitthal Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14381",
    "name": "Zanzane Ramdas Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10247",
    "name": "Kolekar Dinkar Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11512",
    "name": "Chavan Sandeep Vilasrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3871",
    "name": "Bhosale Haribhau Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9833",
    "name": "Mujawar Daud Jainudeen"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19646",
    "name": "Mahida Ratilal Jetha"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14739",
    "name": "Sonawale Somnath Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3560",
    "name": "Potdar Shankarrao Vithalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10620",
    "name": "Chavan Nandkumar Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8630",
    "name": "Mane Lalasaheb Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12707",
    "name": "Veer Sujit Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16873",
    "name": "Ahirekar Bhagwan Chanderrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15348",
    "name": "Bodhe Kashinath Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14016",
    "name": "Salunkhe Jaywant Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9265",
    "name": "Jagtap Vithal Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11800",
    "name": "Pujari Sunanda Bhagwan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3225",
    "name": "Ansari Abrarahmad Jameel"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18276",
    "name": "Vange Vithal Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18282",
    "name": "Surve Rajesh Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18311",
    "name": "Shukla Pramodkumar Shivdular"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3860",
    "name": "Babar Balkrushna Raosaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20554",
    "name": "Sawant Manshing Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18172",
    "name": "Gohil Ashwin Goradhaandas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16225",
    "name": "Shinde Vijay Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9502",
    "name": "Yadav Laxman Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13932",
    "name": "Miss  Shelar Ujwala Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10713",
    "name": "Shinde Jaywant Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19039",
    "name": "Dongare Anita Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17481",
    "name": "Patil Ananda Chandrappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10876",
    "name": "Lonkar Sampat Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13938",
    "name": "Patil Ulhas Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5319",
    "name": "Patole Sarjerao Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13703",
    "name": "Kindre Dnyaneshwar Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21888",
    "name": "Shikhare Madhukar Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8341",
    "name": "Shirsat Maruti Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9850",
    "name": "Lembhe Surykant Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9923",
    "name": "Chavan Laxman Ganapati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11960",
    "name": "Rewadikar Chandrakant Vishwanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10242",
    "name": "Katkar Vilas Popat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11539",
    "name": "Chikne Jitendra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12698",
    "name": "Bhosale Kiran Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17294",
    "name": "Gole Laxman Khadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19187",
    "name": "Shelake Rajeshkumar Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17043",
    "name": "Warishe Shivaji Sonu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20547",
    "name": "Kadam Dattatray Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7069",
    "name": "Bulunge Vijay Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16910",
    "name": "Chhapwala Rajashree Rajesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22695",
    "name": "Saliyan Kavita K"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12795",
    "name": "Bansode Dayanand Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2062",
    "name": "Phalke Ravindra Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6468",
    "name": "Pawar Surykant Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7134",
    "name": "Jadhav Ramchandra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9223",
    "name": "Kadam Rajendra Baluiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9601",
    "name": "Phalke Sunil Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11588",
    "name": "Shinde Ramchandra Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11734",
    "name": "Dave Umesh D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12911",
    "name": "Tankaria Ramniklal Ghelabhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16995",
    "name": "Kadam Bhakti Rambhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14941",
    "name": "Shelake Mohan Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5841",
    "name": "Solaskar Dattatray Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18105",
    "name": "Desai Rajendra Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12859",
    "name": "Chavan Sunil Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9870",
    "name": "Kadam Bhausaheb Shankararao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12108",
    "name": "Sawant Amol Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3932",
    "name": "Pathan Rishalkhan Vajirkhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3375",
    "name": "Barge Nivrutti Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12557",
    "name": "Jadhav Adik Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13369",
    "name": "Momin Ekbal Ajamuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9785",
    "name": "Shingate Pandurang Ganapatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7693",
    "name": "Shinde Duryodhan Marutirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8670",
    "name": "Gardi Madhukar Bhairu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17198",
    "name": "Yadav Vrashali Vikram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17430",
    "name": "Bobde Manoj Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15277",
    "name": "Shinde Lalaso Jagdeorao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17119",
    "name": "Pisal Narsing Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7135",
    "name": "Nikam Ankush Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8228",
    "name": "Kadam Tukaram Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6014",
    "name": "Jagtap Uttam Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19834",
    "name": "Purohit Hanumansing Sultansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3959",
    "name": "Poi Dinkar Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15904",
    "name": "Kadam Anandrao Dada"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18244",
    "name": "Taware Bajrang Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6615",
    "name": "Jadhao Manjula Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6616",
    "name": "Jadhao Suryaji Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6617",
    "name": "Jadhao Sujata Suryaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6618",
    "name": "Pandit Surekha V"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6619",
    "name": "Mahagavkar Anil Shrinivas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19224",
    "name": "Sayyad Junaid Ahmad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22760",
    "name": "Patil Narayan Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11029",
    "name": "Chavan Rekha Hindurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11499",
    "name": "Kondave Jagannath Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16269",
    "name": "Chavan Shahaji Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4550",
    "name": "Deshmukh Kishor Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18483",
    "name": "Nigade Bhalchandra Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13337",
    "name": "Pawar Vijay Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9261",
    "name": "Waghmale Arjun Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14015",
    "name": "Yewale Sunanda Mansingrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11123",
    "name": "Kale Sripatrao Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20033",
    "name": "Dafale Nathuram Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21043",
    "name": "Chavan Bhagyashree  Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3530",
    "name": "Lembhe Daulat Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9705",
    "name": "Ugale Deepak Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12224",
    "name": "Pisal Shamrao Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17644",
    "name": "More Vishal Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11716",
    "name": "Dadas Pangru Raghu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3863",
    "name": "Babar Vilas Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "29",
    "name": "Chavan Shankar Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16006",
    "name": "Nigade Sharad Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12552",
    "name": "Dhumal Balaso Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9941",
    "name": "Bhagwat Sakharam Gyanba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10021",
    "name": "Joil Vasant Sonu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5813",
    "name": "Chavan Bhalchandra Bandoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8661",
    "name": "Kale Nivrutti Devraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3461",
    "name": "Kadam Suresh Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13443",
    "name": "Deshmukh Jayashree Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2403",
    "name": "Chawan Suryasing Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13006",
    "name": "Kumbhar Someshwar Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14090",
    "name": "Shinde Ajit Ravindra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10866",
    "name": "Chavan Jaywant Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15574",
    "name": "Date Baban Mahadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9364",
    "name": "Kadam Hambirrao Shamrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "765",
    "name": "Mandhare Haridas Pandharinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7055",
    "name": "More Laxman Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11432",
    "name": "Barge Kisan Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10762",
    "name": "Kadam Mugatrao Dadasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17223",
    "name": "Shewale Jagannath Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17964",
    "name": "Nikam Hanmantrao Dnyanoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13815",
    "name": "Bhoite Lata Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14430",
    "name": "Salate Pandurang Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11786",
    "name": "Shinde Tukaram Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6030",
    "name": "Dhumal Tukaram Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6079",
    "name": "Mandhare Balu Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20981",
    "name": "Kelusakar Gopal Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21923",
    "name": "Yadav Punam Annandhu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11023",
    "name": "Shaikh Amin Issaq"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11024",
    "name": "Yadav Balaso Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11026",
    "name": "Mohite Balaso Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11027",
    "name": "Yadav Ramesh Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8849",
    "name": "Jagtap Vilas Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10516",
    "name": "Nalawade Navnath Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13903",
    "name": "Barve Sunil Khandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19216",
    "name": "Suryawanshi Hanmantrao Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23374",
    "name": "Bagwe Suresh Barkya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9781",
    "name": "Bhosale Shiwajirao Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16987",
    "name": "Ruparel Geeta Mulraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10617",
    "name": "Jagtap Sunil Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10689",
    "name": "Raut Sanjay Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24138",
    "name": "Jain Vasantiben Hasmukh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13469",
    "name": "Deshmukh Sukumar Jagadeorao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12645",
    "name": "Bhalerao Vishwas Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4858",
    "name": "Lembhe Vishnu Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23596",
    "name": "Sanap Rajesh Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11324",
    "name": "Nimbalkar Praveen Dnyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1500",
    "name": "Shinde Vithal Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6204",
    "name": "Mulik Sudhir Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12222",
    "name": "Katkar Yashwant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10716",
    "name": "Khedekar Dinanath Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15811",
    "name": "Pawar Anand Gautam  Tn-9718-A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19568",
    "name": "Shinde Dilip Gurudatta"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2813",
    "name": "Jadhav Ashok Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7479",
    "name": "Lembhe Bharat Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17656",
    "name": "Shinde Arun Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14299",
    "name": "Inamdar Ansar Hamdulla"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8647",
    "name": "Pawar Mangal Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19960",
    "name": "Muke Surekha Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20847",
    "name": "Waghamare Arun Kashinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15391",
    "name": "Ambulkar Smita Sudhir"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19533",
    "name": "Shaikh Jafhar Shaikh Anwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4038",
    "name": "Jatal Dnyanoba Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11743",
    "name": "Nikam Dilip Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4760",
    "name": "Bhosale Bajirao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20123",
    "name": "Joshi Kamala Ramlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9221",
    "name": "Miss  Jagtap Sunita Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18270",
    "name": "Sayad Abdul Razak Mohdfakir"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "479",
    "name": "Kalugade Rupesh Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6669",
    "name": "Lembhe Dilip Yashawantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11830",
    "name": "Suryawanshi Subhash Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6857",
    "name": "Chavan Vithal Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4000",
    "name": "Kamble Ekanath Jotiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4729",
    "name": "Jadhav Yashwant Subhedar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19982",
    "name": "Pal Mahesh Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21353",
    "name": "Panchal Kamalakar Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9915",
    "name": "Deshmane Prakash Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10839",
    "name": "Jadhav Sanjay Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22513",
    "name": "Kadam Radhika Raviraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1272",
    "name": "Sabale Baban Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15362",
    "name": "Jagtap Deepak Sopanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9561",
    "name": "Bhoite Ramesh Narsing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11130",
    "name": "Mohite Dilip Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8047",
    "name": "Bhosale Sunil Bajirao  135/20"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8486",
    "name": "Kadam Raogi Vittal 658/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16345",
    "name": "Matre Sunil Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11678",
    "name": "Bobade Dattatray Nathuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8284",
    "name": "Patel Kartik Vasudeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18790",
    "name": "Kadam Hanmant Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18948",
    "name": "Bhujbal Dilip Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7760",
    "name": "Awade Gaurav Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13543",
    "name": "Nalawade Shashikant Atmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8989",
    "name": "Subbarao Jonnaragadda Venkata"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4658",
    "name": "Pisal Balasaheb Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16982",
    "name": "Chalke Dinkar Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8145",
    "name": "Mulik Chhaya Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4380",
    "name": "Sanas Raghunath Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19559",
    "name": "Mulik Hemant Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22432",
    "name": "Deshmukh Mahendra Hambirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18590",
    "name": "Rane Yashwant Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10522",
    "name": "Dhumal Anandrao Gojaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10655",
    "name": "Bhosale Sunil Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10720",
    "name": "Chavan Pralhad Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8018",
    "name": "Ghanwat Shivaji Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4057",
    "name": "Jadhav Sampat Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8321",
    "name": "Ghadage Anandrao Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2110",
    "name": "Pawar Mohanrap Bapurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9288",
    "name": "Kadam Ramdas Harishchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22434",
    "name": "Bhosale Prakesh Balwantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10892",
    "name": "Lohar Ramesh Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6338",
    "name": "Engulkar Jaysingh Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4027",
    "name": "Pisal Vishnu Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7034",
    "name": "Jamdade Ashok Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9940",
    "name": "Vedpathak Maruti Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11765",
    "name": "Waghamale Nagesh Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9133",
    "name": "Salunkhe Vilas Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9332",
    "name": "Jadhav Laxman Gangaram  1057/5"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18386",
    "name": "Ghadge Chandrakant Machindra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18495",
    "name": "Indulkar Pranali P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18496",
    "name": "Indulkar Pradeep Purshottam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8935",
    "name": "Salunkhe Bharat Dagdoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22661",
    "name": "Mane Shivaji Kandiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22398",
    "name": "Sawant Archita Amod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18256",
    "name": "Pathare Satish B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18299",
    "name": "Bhoite Hanmant Mukundrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9805",
    "name": "Salunkhe Sharad Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15140",
    "name": "Jadhav Rajendra Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11891",
    "name": "Ghorpade Arjun Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6520",
    "name": "Bhoite Dattatray Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20888",
    "name": "Parte Dipak Ankush"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "511",
    "name": "Unde Sakharam Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6793",
    "name": "Pawar Sahebrao Krushanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10602",
    "name": "Chavan Tanaji Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11599",
    "name": "Shingate Dharmu Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1908",
    "name": "Musale Namdeo Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19930",
    "name": "Chavan Ramnath Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15224",
    "name": "Nalawade Aprukabai Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4738",
    "name": "Pawar Dattatray Bababnrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12569",
    "name": "Nawadkar Umesh Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17482",
    "name": "Jadhav Anant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2531",
    "name": "Anpat Narayan Ekanath 260/8"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9402",
    "name": "Dhumal Hanmant Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11612",
    "name": "Kambale Suresh Namdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11636",
    "name": "Bhosale Mohan Dnyanoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11637",
    "name": "Bhosle Balkrishna Dnyanoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11639",
    "name": "Bhosale Chandrakant Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11657",
    "name": "Bhosale Devidas Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11660",
    "name": "Pawar Suresh Kiasan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20872",
    "name": "Mhatre Jaywant Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9532",
    "name": "Pharande Sunil Manikrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11591",
    "name": "Jagadale Subhash Yoganath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6198",
    "name": "Dhanawade Pandurang Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15508",
    "name": "Shinde Hanmant Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16401",
    "name": "Sabale Sunil Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4749",
    "name": "Disale Rajaram Dnyandev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10669",
    "name": "Dhumal Shivaji Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9365",
    "name": "Dhumal Bhanudas Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6292",
    "name": "Shinde Vilas Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9414",
    "name": "Kadam Mahadeo Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11500",
    "name": "Chawan Sanjay Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18807",
    "name": "Lenbhe Nilesh Pralhad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8868",
    "name": "Pethkar Devidas Khandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17696",
    "name": "Bhingardive Namdev Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14977",
    "name": "Phadake Kishor Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15037",
    "name": "Surve Ravindra Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11262",
    "name": "Mandhare Avinash Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1219",
    "name": "Kadam Narayan Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14369",
    "name": "Karne Vijay Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9337",
    "name": "Kakade Rajendrakumar Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14832",
    "name": "Nalawade Sunil Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9919",
    "name": "Sakunde Rupchand Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8525",
    "name": "Sapakal Tukaram Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1666",
    "name": "Chavan Krishna Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14255",
    "name": "Kadam Shashikant Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23155",
    "name": "Bhatiya Prem Dwarkadas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11014",
    "name": "Jadhav Surekha Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11022",
    "name": "Kokil Chandrakant Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11040",
    "name": "Pisal Sindhu Dagdu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17895",
    "name": "Desai Ashok Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19837",
    "name": "Kadam Krishnakant Vilasrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23106",
    "name": "Patankar Urmila Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23131",
    "name": "Mediratta Sandeep Krishanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23132",
    "name": "Mediratta Tarun K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23134",
    "name": "Devadiga Ashok Muthappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23135",
    "name": "Shetty Suresh Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11010",
    "name": "Shinde Vijay Gujaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11306",
    "name": "Chavan Mohan Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11307",
    "name": "Jagtap Subhash Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11312",
    "name": "Kadam Uttam Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11328",
    "name": "Yadav Tarasing Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11391",
    "name": "Kadam Pratap Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22898",
    "name": "Gangawane Hemant Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22899",
    "name": "Gangawane Mangala Hemant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22937",
    "name": "Gangawane Rohit Hemant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15694",
    "name": "Matre Deepak Ananda 721 B 12"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6478",
    "name": "Pawar Rajendra Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18255",
    "name": "Shaikh Sirajuddin Abdul Gafoor"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18268",
    "name": "Jadhav Rajendra Jaggnnath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18313",
    "name": "Bhanushali Hiralal Sevak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23061",
    "name": "Patil Vitthal Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23062",
    "name": "Patil Ananda Yashwant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "537",
    "name": "Shaikh Mubashar Ahmed Akhtar Ahmed"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "538",
    "name": "Kadam Neena Madhukar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "560",
    "name": "Kharade Padmaja Nilesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4176",
    "name": "Bhoite Ramchandra Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20624",
    "name": "Gardi Machindra Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9419",
    "name": "Bhosale Anil Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11121",
    "name": "Dhumal Rajesh Keshavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11584",
    "name": "Dhumal Pradipsinh Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5559",
    "name": "Shinde Hindurao Parbati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "302",
    "name": "Surve Shankar Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13950",
    "name": "Mehta Dhirajbala Ishwarlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22365",
    "name": "Prabhu Swati Prasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10100",
    "name": "Mulani Hissain Gani"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4805",
    "name": "Shinde Prakash Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3020",
    "name": "Mohite Vishvanath Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10665",
    "name": "Pisal Rajendra Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10727",
    "name": "Bhosale Dinkar Rau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10780",
    "name": "Waikar Anil Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10782",
    "name": "Waikar Dharmaji Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11085",
    "name": "Shidture Rukmini Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11140",
    "name": "Bhosale Prakash Haribhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11141",
    "name": "Pawar Mohan Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6267",
    "name": "Shinde Sampat Wamanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22872",
    "name": "Deshapande Ulhas R"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22874",
    "name": "Pawar Ashok Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22944",
    "name": "Shethia Bharat H"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22945",
    "name": "Savla Urmila Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22953",
    "name": "Shethia Ritesh Bharat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22975",
    "name": "Ghotilkar Kisan Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10717",
    "name": "Inamdar Asif Nisar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11699",
    "name": "Gadve Vijay Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14082",
    "name": "Dhanawade Sudhir Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14096",
    "name": "Ghanvat Sangita Vishal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10491",
    "name": "Gaikwad Sanjay Bhimrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9782",
    "name": "Mulik Mohan Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22337",
    "name": "Shinde Pravin Sukhadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24356",
    "name": "Shibe Maya Sunil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22843",
    "name": "Mony Deepthi Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22846",
    "name": "Gada Manish Girish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22847",
    "name": "Kenia Kamalkant Velji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22848",
    "name": "Momaya Kamlesh Navinchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22849",
    "name": "Kenia Nilesh Kamalkant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13877",
    "name": "Kenjale Anant Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13878",
    "name": "Kenjale Ashwini Abhijeet"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13880",
    "name": "Bagalkote Sushila Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13881",
    "name": "Marda Madhusudan Kachrulal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13882",
    "name": "Kate Shankar Damodar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13883",
    "name": "Kenjale Nilesh Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13884",
    "name": "Kate Nitin Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13910",
    "name": "Sawant Mahendra Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13912",
    "name": "Sawant Ranjit Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14067",
    "name": "Kale Sharad Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14068",
    "name": "Agate Pradnya Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14070",
    "name": "Gijare Vinita Satish"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14071",
    "name": "Kale Deepa Sharad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1695",
    "name": "Purandare Digamber Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10582",
    "name": "Shinde Mahesh Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10696",
    "name": "Gade Hindurao Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10698",
    "name": "Mane Bhaskar Krishanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12962",
    "name": "Shinde Sharad Henmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7173",
    "name": "Mojar Krushna Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22277",
    "name": "Bhosale Bharat Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14810",
    "name": "Sapkal Dattatray Ram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1467",
    "name": "Sawant Bhagwan Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10541",
    "name": "Bhoite Mukund Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13833",
    "name": "Miss  Dharmadhikari Nutan Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13847",
    "name": "Dharmadhikari Omkar Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6094",
    "name": "Dhumal Shankar Dadaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10108",
    "name": "Sapkal Dnyandeo Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22782",
    "name": "Dcruz George Albert"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22783",
    "name": "Dcruz Nelson Albert"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22810",
    "name": "Shinde Bhagyashree Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22813",
    "name": "Kasar Sayali Sanjay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22816",
    "name": "Agrawal Sanjeev Madan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22817",
    "name": "Pathak Rishinarayan Lalbahadur"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13830",
    "name": "Dharmadhikari Sangita Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14572",
    "name": "Miss  Kadam Monali Shahaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14581",
    "name": "Shaikh Ajmuddin Tajuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14591",
    "name": "Devkar Sachin Suresh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14592",
    "name": "Jadhav Ranjana Siddheshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14594",
    "name": "Kashid Shrikant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14655",
    "name": "Jadhav Kanifnath Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14660",
    "name": "Kalange Mahesh Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14662",
    "name": "Mane Yogesh Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14663",
    "name": "Pathan Imran Shamshuddin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14666",
    "name": "Shingate Vikaram Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14670",
    "name": "Shingate Shubhangi Vikaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14684",
    "name": "Kadam Santosh Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14693",
    "name": "Jagtap Nina Sandeep"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14695",
    "name": "Bodake Vaibhav Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "674",
    "name": "Jagtap Shivaji Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10511",
    "name": "Dhumal Vaishali Deepak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17409",
    "name": "Shirtode Dilip Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7033",
    "name": "Mulik Mahadeo Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22121",
    "name": "Dharamshi Ajay Jethalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6538",
    "name": "Sabale Pandurang Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9534",
    "name": "Pisal Manish Yuvraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15579",
    "name": "Zingade Surekha Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14897",
    "name": "Chalke Krishnat Parshuram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "391",
    "name": "Jadhav Mangal Mukund"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22720",
    "name": "Shedge Tukaram Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22724",
    "name": "Pal Ramsamujh Puranmasi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13783",
    "name": "Kadam Chetan Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13787",
    "name": "Shaikh Faruk Bashir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13788",
    "name": "Shaikh Shamshuddin Ali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6624",
    "name": "Bhintade Manohar Dinakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15076",
    "name": "Kolekar Mahadev Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10564",
    "name": "Dhumal Yashwant Abaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22684",
    "name": "Mane Pramodkumar Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22685",
    "name": "Mane Madhuri Nanasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22690",
    "name": "Indulkar Kamlakar Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22693",
    "name": "Jaiswal Mahesh Avasanprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22697",
    "name": "Kenjale Utkantha Ajit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22701",
    "name": "Shedge Sunanda Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21540",
    "name": "Tamhankar Mahadev Parsuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21541",
    "name": "Thamke Dilip Krushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10263",
    "name": "Sabale Ravilndra Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10264",
    "name": "Sabale Rajashri Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13771",
    "name": "Kadam Mangesh Subhash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7700",
    "name": "Jadhav Sampat Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13982",
    "name": "Jadhav Vivek Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11868",
    "name": "Sakunde Parshuram Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7384",
    "name": "Patil Jalinder Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18252",
    "name": "Singh Dasharath Tahsildar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18266",
    "name": "Jaiswal Jagdishprasad Abharfilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18312",
    "name": "Gupta Bholenath Shrinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5118",
    "name": "Phalke Vilas Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3874",
    "name": "Jagtap Dajiram Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18173",
    "name": "Shaikh Mahammad Farookali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7767",
    "name": "Salunkhe Jagannath Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13689",
    "name": "Shinde Tanaji Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13676",
    "name": "Godase Suresh Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18229",
    "name": "Malkan Prity Vinod"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21628",
    "name": "Supal Deepak Balkrushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22594",
    "name": "Chavan Manali Sahdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25637",
    "name": "Malkan Vinod Mohanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25645",
    "name": "Bharati Sunita Prabhakar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3241",
    "name": "Kolla Krishnarao Vishunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16760",
    "name": "Chavan Vilas Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19245",
    "name": "Shinde Umesh Balawant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22826",
    "name": "Khandagale Dinkar Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3233",
    "name": "Ambonkar Prashant Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14074",
    "name": "Ianamdar Anuradha Shripad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13394",
    "name": "Bobade Kundalik Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24193",
    "name": "Patankar Manali Pramod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24194",
    "name": "Tripathy Anirudh Pareshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24195",
    "name": "Tripathy Yogeeta Anirudh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6650",
    "name": "Bhaigade Pandurang Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10300",
    "name": "More Raju Sambhaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1090",
    "name": "Junghare Prakash Dnyaneshwar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1092",
    "name": "Junghare Prasad Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14695",
    "name": "Ranware Hanumant Jaisingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8886",
    "name": "Kolekar Laxman Balaku"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3207",
    "name": "Sutar Vrushali Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9574",
    "name": "Aware Laxman Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12179",
    "name": "Kadam Arun Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20737",
    "name": "Pawar Vijaya Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2819",
    "name": "Nimbalkar Mohan Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9227",
    "name": "Modak Shripat Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4056",
    "name": "Kambale Ramu Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16911",
    "name": "Rana Poonam Mahesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9245",
    "name": "Gaikwad Vandana Vilas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3197",
    "name": "Pawar Deepak Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7587",
    "name": "Mujawar Isakmiya Abdul Karim"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9643",
    "name": "Shinde Krishnrao Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10149",
    "name": "Shinde Bhagwan Trimbak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15507",
    "name": "Thorat Ganesh Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10913",
    "name": "Gupta Narinder N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18223",
    "name": "Jadhav Varsha Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11231",
    "name": "Bhoite Shivaji Shankararo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4325",
    "name": "Mishra Chandramohan Ramlohat Toli-145/23"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3100",
    "name": "Jadhav Ravindra Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4420",
    "name": "Salunkhe Satyawan Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16465",
    "name": "Babar Bharat Janradhan Toli No 250/15"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10178",
    "name": "Kulkarni Vijay Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9325",
    "name": "Shinde Sujata Satish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10557",
    "name": "Chaudhari Santram Dasdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21705",
    "name": "Jagtap Ratan Tavba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10604",
    "name": "Pisal Indumati Dnyanoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3343",
    "name": "Bhosale Hanmant Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10926",
    "name": "Raut Hanmant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15449",
    "name": "Kulkarni Abhay Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10556",
    "name": "Chaudhari Sohan Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9570",
    "name": "Hublikar Premnath Abasa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1375",
    "name": "Gaikwad Mansing Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5359",
    "name": "Nimbalkar Bapurao Gulabrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1417",
    "name": "Rathod Kanchankawar Puransinh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16513",
    "name": "Kadam Pandharinath Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16234",
    "name": "Jadhav Ananda Tanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10338",
    "name": "Pawar Hindurang Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17000",
    "name": "Sapkal Laxman Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11759",
    "name": "Dhumal Rangrao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15208",
    "name": "Salekar Dilip Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5962",
    "name": "Borkar Hanmant Dhindibhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11721",
    "name": "Chavan Gajanan Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21435",
    "name": "Sandhya  Impex"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6199",
    "name": "Sonwale Rekha Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2742",
    "name": "Jadhav Vilas Nivrutti 648/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13030",
    "name": "Mandhare Sanjay B  T No 692/45"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15719",
    "name": "Bhosale Ashok Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16134",
    "name": "Mandhare Vikas Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12503",
    "name": "Kolekar Shamrao Govinda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13657",
    "name": "Jadhav Rekha Anant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14152",
    "name": "Mehta Ganpatraj Chandmalji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10119",
    "name": "Pisal Bhagawan Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20435",
    "name": "Bhoite Dharmraj Bhusan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16594",
    "name": "Nalawade Vijaya Sunil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20645",
    "name": "Posture Ganesh Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4396",
    "name": "Jain Tarsemlal K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22223",
    "name": "Govalkar Dilip Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4911",
    "name": "Mahadik Laxman Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10749",
    "name": "Kadam Sanjay Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11788",
    "name": "Jagtap Baburao Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10546",
    "name": "Kadam Mahendra Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8642",
    "name": "Kadam Shankar Ramkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22890",
    "name": "Haldar Mohdansarali Abdulmannan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4600",
    "name": "Jagatap Dasharath Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10875",
    "name": "Shaikh Faiyaz Nazir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11638",
    "name": "Bhosale Yashwant Dnyanoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17080",
    "name": "Kumbhar Bharat Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11663",
    "name": "Adsul Vilas Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1567",
    "name": "Aggarwal Nisha Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9557",
    "name": "Malpote Govind Chindu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1821",
    "name": "Vichare Shamrao Khashaba Tn"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16886",
    "name": "Babar Sanjay Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18859",
    "name": "Ingvale Shard Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13482",
    "name": "Jedhe Sanjay Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8332",
    "name": "Bhoite Tukaram Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14032",
    "name": "Bhosale Balbhim Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6018",
    "name": "Sabale Dayanand Dattatrya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4154",
    "name": "Bhilare Trimbak Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15006",
    "name": "Sabale Jalindhar Vyankat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10607",
    "name": "Nigade Arun Bhujangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17430",
    "name": "Kamble Maruti Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20147",
    "name": "Nanaware Sharad Sudam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12467",
    "name": "Jagtap Ganpat Nanaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1921",
    "name": "Sabale Kamalakar Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12913",
    "name": "Ghagre Nivrutti Bhagoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19540",
    "name": "Prajapati Manju Pukhraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14386",
    "name": "Chorage Bharat Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8072",
    "name": "Bhohite Bharat Konderao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9562",
    "name": "Bhoite Tarachand Ramchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10288",
    "name": "Godbole Narottam Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2431",
    "name": "Matkar Jaiprakash Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15189",
    "name": "Chawan Santosh Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13508",
    "name": "Doiphode Bhagoji Kondiba Tn 708"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21456",
    "name": "Sheth Neha Yagnesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6116",
    "name": "Pawar Anil Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5207",
    "name": "Jagtap Balaso Bhauso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11310",
    "name": "Chavan Amol Mohanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6602",
    "name": "Doundakar Mahadeo Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15172",
    "name": "Shelar Sambhaji Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12726",
    "name": "Maskar Prakash Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20566",
    "name": "Jadhav Suresh Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12773",
    "name": "Phalke Nandkumar Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6236",
    "name": "Babar Hanmant Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12640",
    "name": "Shinde Sambhaji Shahaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8267",
    "name": "Taware Sahebrao Aatmaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18992",
    "name": "Katkar Krushanat Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19392",
    "name": "Patole Rajesh Pandhari"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "172",
    "name": "Pawar Siddhesh Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18522",
    "name": "Disale Sanjay Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15780",
    "name": "Kolekar Hanmant Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17082",
    "name": "Dhatrak Sumati Deepak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15246",
    "name": "Kajari Prakash Baburao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "127",
    "name": "Jadhav Anandrao Abasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8776",
    "name": "Shikalgar Majnuhuddin Chand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15102",
    "name": "Jagdale Anil Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14289",
    "name": "Lembhe Ramesh Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17229",
    "name": "Yadav Bharat Suryaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21827",
    "name": "Kadam Santosh Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12777",
    "name": "Jagtap Jayashri Subhash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18152",
    "name": "Upadhya Lalmani Ramlakhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9118",
    "name": "Doiphode Baburao Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18620",
    "name": "Kapadia Jignesh Bipin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18211",
    "name": "Ambilpure Ambadas Pandharinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18244",
    "name": "Yadav Swaminath Ramkedar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18291",
    "name": "Shukla Damodar Lxminarayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14001",
    "name": "Miss  Kadam Shweta Satish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12582",
    "name": "Nikam Sandeep Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9717",
    "name": "Bobade Gajanan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9206",
    "name": "Chavan Sujata Rajendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19442",
    "name": "Mane Pramod Sukhdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10352",
    "name": "Prabhakar Tukaram Wagh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20047",
    "name": "Dhanwade Vishal Dhondiram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1453",
    "name": "Chaudhary Rajpal Fularam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2649",
    "name": "Salunkhe Vishnu Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4480",
    "name": "Nikam Bhagwan Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16035",
    "name": "Walgude Vinod Popat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16256",
    "name": "Kadam Vaibhav Vasantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7014",
    "name": "Jadhav Arjun Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2232",
    "name": "Kadam Vasant Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6581",
    "name": "Babar Dilip Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13754",
    "name": "Shinde Tanaji Kundalik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11959",
    "name": "Yadav Ananda Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9728",
    "name": "Lonkar Dnyandeo Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17161",
    "name": "Jagtap Sujit Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8637",
    "name": "Pawar Mahadeo Aabaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11070",
    "name": "Yadav Eknath Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18244",
    "name": "Agrawal Girdharlal Govindas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4572",
    "name": "More Hariba Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4965",
    "name": "Jamdade Aakaram Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12383",
    "name": "Mane Suresh Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9982",
    "name": "Yadav Sandeep Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9983",
    "name": "Yadav Ujwala Dattatry"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7356",
    "name": "Fadtare Raosaheb Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3530",
    "name": "Momin Murad Husen"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20909",
    "name": "Jadhav Vishnu Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10843",
    "name": "* Matkar Umesh Vamanrao 1401/2"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2222",
    "name": "Sharma Bhim Omprakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22545",
    "name": "Shinde Dilip Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14309",
    "name": "Pawale Akaram M 6668"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20653",
    "name": "Bhandvalkar Tukaram Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9976",
    "name": "Salunkhe Ashok Jaising"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23914",
    "name": "Patil Sharad Anant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2199",
    "name": "Shaikh Saeed Baburaja"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16895",
    "name": "Ghumare Rajesh Kishor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19864",
    "name": "More Yashwant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10746",
    "name": "Mhaske Sunil Barikrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2855",
    "name": "Pathan Buran Yakub"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7842",
    "name": "Desai Sanjay Bajrang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14673",
    "name": "Shinde Shrikant Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18362",
    "name": "Gaikwad Madan Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15620",
    "name": "Shinde Mohan Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17569",
    "name": "Shukla Rajkumar Devnarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20274",
    "name": "Khadye Krishnakant Sonu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17702",
    "name": "Tambe Harish Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3614",
    "name": "Chavan Bhagwan Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6494",
    "name": "Bobade Shivaji Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19496",
    "name": "Anpat Gorakh Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4019",
    "name": "Mane Kirtiwan Babasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1369",
    "name": "Matkar Vasant Laxman 739/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8261",
    "name": "Chawan Rajaram Shripati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9825",
    "name": "Dhumal Rajendra Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10286",
    "name": "Shedge Dnyaneshwar Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16073",
    "name": "Bhusari Deepak D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19223",
    "name": "Patil Shivaji Barmu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2809",
    "name": "Karania Paresh Zaverchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23506",
    "name": "Kamble Atin Kumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14783",
    "name": "Sapkal Dattatray Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11158",
    "name": "Nalawade Umesh Shivajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22215",
    "name": "Bhende Kedari Gurupad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2447",
    "name": "Shirasekar Bhashkar Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23045",
    "name": "Devkar Asha Kirtivan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22167",
    "name": "Dolas Bhargav Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22168",
    "name": "Kolwankar Anagha Ajit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6358",
    "name": "Pisal Uttam Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4926",
    "name": "Salunkeh Rajendra Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17866",
    "name": "Mulik Dilip Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9412",
    "name": "Madane Jayawant Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24017",
    "name": "Dhami Bam Bahadur Ransingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13329",
    "name": "Kachalia Sarala J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19022",
    "name": "Pawar Pravin Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1194",
    "name": "Kadam Kisanrao Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9749",
    "name": "Shinde Sanjay Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10651",
    "name": "Dhumal Somanath Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10510",
    "name": "Jembhe Bhimrao Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19514",
    "name": "Jadhav Durgabai Amrut"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16138",
    "name": "Purohit Sardararam Bhuraji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1332",
    "name": "Dadhich Manojkumar Bajranglal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22130",
    "name": "Lapasia Rajesh Bhavanji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18251",
    "name": "Frank Josepf Domnic"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18277",
    "name": "Sawant Anant Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18308",
    "name": "Salvi Sudesh Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18309",
    "name": "Mishra Chandramani Balgovind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18310",
    "name": "Sayyad Mohammedali Amirali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11957",
    "name": "Kadam Rohan Arun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8586",
    "name": "Kadam Dharmaji Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15101",
    "name": "Pisal Chandrakant Krishnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23850",
    "name": "Tole Arjun Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11605",
    "name": "Dudhe Shivaji Krishanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8550",
    "name": "More Vishnu Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11824",
    "name": "Sawant Vitthal Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13776",
    "name": "Sawant Nandkumar Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8298",
    "name": "Deshmukhl Suryakant Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10021",
    "name": "Sakunde Madhav Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16690",
    "name": "Shinde Prakash Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21452",
    "name": "Chaukekar Siddharth Sidharth Shrikrishana"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16906",
    "name": "Panchal Sangita Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11375",
    "name": "Surve Dilip Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18189",
    "name": "Yadav Prakash Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13884",
    "name": "Mulik Dattatray Parbatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8683",
    "name": "Mandhare Chandrakant Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21954",
    "name": "Shinde Tukarm Patilbuva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21955",
    "name": "Shinde Ramdas Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21957",
    "name": "Shinde Santosh Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19106",
    "name": "Sanas Dattatray Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17017",
    "name": "Gaikwad Ramchandra Vithalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8881",
    "name": "Jain Arvind Kumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18225",
    "name": "Shivankar Nitin Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16745",
    "name": "Malekar Dhanaji Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9517",
    "name": "Ransing Sukesh Sharad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10449",
    "name": "Matkar Vishnu Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11097",
    "name": "Phalke Sarjerao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23451",
    "name": "Pawar Anandrao Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12167",
    "name": "Dhumal Bhikoba Appasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3813",
    "name": "Pisal Valmik Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6049",
    "name": "Jadhav Chandrabai Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19435",
    "name": "Shinde Sadhu Khashaba"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "133",
    "name": "Mulani Rafik Vajir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15813",
    "name": "Kalange Baban Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19461",
    "name": "Pingale Dattatray Sonaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15783",
    "name": "Bhosale Angaddha Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18829",
    "name": "Gandhi Vishwas Dagdu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20350",
    "name": "Sharma Sushilkumar Govindram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12129",
    "name": "Khot Vithal Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "705",
    "name": "M/S  Xerox Copy Centre"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "966",
    "name": "Bombay Ware House Clearing Agency"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1303",
    "name": "Dhiren Trading Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1696",
    "name": "R K  Silk Mills"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1732",
    "name": "Vora Praful J"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2014",
    "name": "Dudwadkar Gitesh P"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2083",
    "name": "E Or S"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2368",
    "name": "Amol Tempo Service"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2375",
    "name": "Vallabh Cloth Merchants"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2526",
    "name": "Snehal Packing Works"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2924",
    "name": "Merchant Raj Mohammedali"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3007",
    "name": "Bhavani Traders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3098",
    "name": "G R Corporation"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3154",
    "name": "Ravilon Textile Agency"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3179",
    "name": "Chheda Kirti Chhaganlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3338",
    "name": "Shree Sagar Clearing Agency"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3413",
    "name": "Suvarna Jents Parler"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3502",
    "name": "Comfield  Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3597",
    "name": "Mistry Harshad Shantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3849",
    "name": "Shah Paras D"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3850",
    "name": "Shah Amar D"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3880",
    "name": "Gupta Pratik"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3962",
    "name": "Kanodia Yogesh Yogesh  B"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4168",
    "name": "Spandana Films"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4190",
    "name": "Santro Metal Industries"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4381",
    "name": "Messers Home Builders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4382",
    "name": "Messers Home Builders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4383",
    "name": "Messers Home Builders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4384",
    "name": "Messers Home Builders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4396",
    "name": "Malhar Trading"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4422",
    "name": "Kuveskar Kalawati J"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4538",
    "name": "Raj Trading"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4550",
    "name": "Sea King Fisheries"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4557",
    "name": "Mauli Hospital & Medical Research Centre Pvt Ltd"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4566",
    "name": "Sahil Hospitality Services"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4590",
    "name": "Khushaboo Metal Works"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4598",
    "name": "Zone Infra Projects Pvt Ltd"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4602",
    "name": "Jayantilal & Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4614",
    "name": "K K Exports"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4633",
    "name": "Shree Hari Mobile Shoppe"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "286",
    "name": "Arun Clearing Agency"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "297",
    "name": "S Rakeshkumar & Co"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "773",
    "name": "Katrela Associates"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "836",
    "name": "Pawar Furniture Pawar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "854",
    "name": "Shri Ganesh Transport"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "885",
    "name": "Ambika Synthetics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1170",
    "name": "Monogram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1175",
    "name": "Hitendra Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1316",
    "name": "Rajesh & Co"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1497",
    "name": "Bhairav Corporation"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1653",
    "name": "Shah Dineshkumar Amratlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2032",
    "name": "Ambalene Fabrics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2139",
    "name": "Abhishek Enterprise"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2460",
    "name": "Thakkar Trading Co"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2478",
    "name": "Kavita Fabrics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2489",
    "name": "S A  Enterprise"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2654",
    "name": "Sun  Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "269",
    "name": "Mahendra Traders"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "374",
    "name": "Gore Dineshkumar Paramshi"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "402",
    "name": "Guru Krupa Roadways"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "661",
    "name": "Rose L International"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "683",
    "name": "Shivshakti Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "699",
    "name": "S R Stiching Works"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "727",
    "name": "Sadguru Synthetics"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "818",
    "name": "Icon Graphic"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "834",
    "name": "Kailash Roadline"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "874",
    "name": "Mahavir Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "919",
    "name": "Mahavir Steel Centre"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1061",
    "name": "Siddeshwar Welding Works"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1067",
    "name": "Mittal M G Real Estate Pvt Ltd"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1075",
    "name": "Eagle Yash Trading Co"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1128",
    "name": "Sa Consultants"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1708",
    "name": "Lucky Timber Mart"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2041",
    "name": "Yadav Fabricator"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2350",
    "name": "Sas Group Of Company"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2380",
    "name": "Shreyash Products Pvt Ltd"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "18",
    "name": "Dnyanganga Pustakalay"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "83",
    "name": "Vyanktesh Mudrnalaya"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "104",
    "name": "Hotel Deepali"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "145",
    "name": "Vipul Industries"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "169",
    "name": "Chavan General Stores"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "174",
    "name": "Mudhaidevi Hardware Deur"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "175",
    "name": "Shriram Agencies"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "183",
    "name": "Ajinkya Tailors Pimpode Bk"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "184",
    "name": "Ravikiran Agro Centre"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "187",
    "name": "Panchwati Steel  Furniture"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "188",
    "name": "Kohinoor Medecal And General Stores"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "191",
    "name": "Rohit Trders S"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "192",
    "name": "Kohinoor Foot Wear"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "195",
    "name": "Prachimedical &Ganaral Stoars"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "222",
    "name": "Ajinkya Milk Can"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "225",
    "name": "Shiv Sagar Construction   Company"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "227",
    "name": "Maruti Concret Product"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "231",
    "name": "Adhyaksha Jivandhara Gram Vikas Prathistan"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "237",
    "name": "Vishwa  Karma Industris"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "241",
    "name": "Sagar Furniture House"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "249",
    "name": "Shree Gurukrupa Indistries"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "251",
    "name": "Namdeo Steel Furniture Propra  Alka Ashok Shende"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "263",
    "name": "Adarsh Developers"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "264",
    "name": "Adarsh Enterprises"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "268",
    "name": "Principal S E Societys Late Suman Dhekane Department Of Pharmacy"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "270",
    "name": "Ame Ya Developers"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "273",
    "name": "Propra Mahendra Gulabrao Jadhav"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "279",
    "name": "Kruturaj Traders Karita"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "286",
    "name": "Ayush Consructions Satara Road"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "288",
    "name": "Garee Developers Propra Swarada Suhas Kasar"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "299",
    "name": "Rajendra Junior College Khandala"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "300",
    "name": "Ahireshwar Junior College Ahire"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "301",
    "name": "Khandalavibhag Shikshan Samiti  Khandala"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "51",
    "name": "New Millenum Hospital"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "93",
    "name": "Allied Sales & Service"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "102",
    "name": "Hasti Transways"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "109",
    "name": "Tcz Automotive (I) Pvt  Ltd"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "161",
    "name": "Natkhat Saree Centre"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "8",
    "name": "Pansare Vinayak Khandu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "172",
    "name": "Ganpati Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "207",
    "name": "Sakshi Polish"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "316",
    "name": "Roopali Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "335",
    "name": "T Balaji Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "336",
    "name": "N & K Enterprises"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "369",
    "name": "Dhanlaxmi Sizers"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15449",
    "name": "Thakur Raju Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14808",
    "name": "Salunkhe Yashwant Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8073",
    "name": "Surve Laxman Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14048",
    "name": "Sawant Arvind Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16915",
    "name": "Ghorpade Sanjay Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9437",
    "name": "Kadam Sunil Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10515",
    "name": "Pawar Dnyandev Ganapati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9090",
    "name": "Choudhary Shashikant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17455",
    "name": "Mulik Mahendra Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24948",
    "name": "Nikam Kanta Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15831",
    "name": "Kolekar Laxman Jagnnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10653",
    "name": "Yadav Dilip Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14681",
    "name": "Mali Rambachan Mangalprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12123",
    "name": "Kadam Pralhad Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14344",
    "name": "Nikam Ravindra Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22190",
    "name": "Pal Manikchandra Ramnihor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5994",
    "name": "Shirgaonkar Rakesh Jagdish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17656",
    "name": "Chalake Anil Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11253",
    "name": "Dixit Vishwanath Arun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14693",
    "name": "Sevale Sarla Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9919",
    "name": "Awalkar Shrikant Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18151",
    "name": "Chandalia Ramesh Tekchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10165",
    "name": "Kambale Dnyandeo Jagnnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19951",
    "name": "Jadhav Santosh Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23267",
    "name": "Shah Hetal Devendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16658",
    "name": "Salunkhe Prakash Hanmant Tn-93-25"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21461",
    "name": "Badekar Sunil Pappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13412",
    "name": "Kadam Kisan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13473",
    "name": "Salunkhe Tanaji Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14651",
    "name": "Bhilare Dilip Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5029",
    "name": "Pisal Balkrushna Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15244",
    "name": "Ingale Satish Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4573",
    "name": "Deshmukh Laxman Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9258",
    "name": "Sakunde Baliram Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18467",
    "name": "Chavan Daulati Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17039",
    "name": "Pawar Dilip Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1781",
    "name": "Jadhav Dilip Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21235",
    "name": "Rathod Pravin Harji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15997",
    "name": "Kadam Ravindra Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11576",
    "name": "Bhosale Tanaji Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9536",
    "name": "Nikam Kalyan Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13625",
    "name": "Bagwan Rafiq Abdul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15033",
    "name": "Nagaraji Hamid Buran"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8314",
    "name": "Pawar Jagannath Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9823",
    "name": "Salunkhe Madhukar Subhedar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14111",
    "name": "Mhaske Ramchandra Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11461",
    "name": "More Shrirang Jotiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13975",
    "name": "Pandey Ramprabhav Amarnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12140",
    "name": "Shinde Sunil Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14685",
    "name": "Jagtap Vithal Mansingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "342",
    "name": "Reddi Anil Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13524",
    "name": "Mandhare Sunil Ramrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16276",
    "name": "Dholakia Indubai Chunilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11419",
    "name": "Bhoite Panditarao Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12723",
    "name": "Phalake Rajeshri Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14965",
    "name": "Pujari Rajendra Shantiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8335",
    "name": "Gandhi Prakash D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23171",
    "name": "Kotisn Naveen Lokayya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13486",
    "name": "Bhosale Arvind Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "572",
    "name": "Londhe Namdev Jagdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13538",
    "name": "Aatar Bashir Nurmohammed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8282",
    "name": "Shigvan Bandu Maruti 1027/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3448",
    "name": "Bhosale Mahadeo Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4817",
    "name": "Palaskar Ganpat Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8080",
    "name": "Gaikwad Kashinath Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9425",
    "name": "Raje Sanjay Vasantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4670",
    "name": "Shilimkar Narayan Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4390",
    "name": "Bhosale Dilip Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10161",
    "name": "Jamdade Baba Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1362",
    "name": "More Sadashiv Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13591",
    "name": "Patil Shivaji Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1254",
    "name": "Bobade Sadashiv Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7660",
    "name": "Shinde Ananda Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17108",
    "name": "Jadhav Bhimrao D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22429",
    "name": "Miss  Vichare Sapana Sadanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10090",
    "name": "Jamdade Sadashiv Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2251",
    "name": "Kadam Dnyandev Appaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1142",
    "name": "More Balaram Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12870",
    "name": "Dabhade Dattatray Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2585",
    "name": "Nikam Shankarrao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15538",
    "name": "Ambike Ravindra Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13314",
    "name": "Ithape Sunil Shaymrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9425",
    "name": "Upadhyay Shivprasad Ramraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21451",
    "name": "Kesarkar Abhishek Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21455",
    "name": "Sheth Yagnesh Dinkarrai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21464",
    "name": "Belle Dattatray Girmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18697",
    "name": "Kadam Yuvaraj Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12137",
    "name": "More Ramesh Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13479",
    "name": "Jadhav Jitendra Subhedar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13498",
    "name": "Kale Dattatry Vilasrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17888",
    "name": "Yadav Subash Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16999",
    "name": "Yadav Anand Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7457",
    "name": "Chorge Keshav Pandurang A-5796"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3202",
    "name": "Gaikwad Bhagyashree Rupesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9406",
    "name": "Bhandalkar Chandrakant Kashiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8071",
    "name": "Yadav Tukaram Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4877",
    "name": "Gaikwad Ramchandra Jagu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12370",
    "name": "Barve Vasant Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18292",
    "name": "Rithe Dilip Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4727",
    "name": "Pawar Balkrushna Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20046",
    "name": "Dhanwade Dhananjarao Jagadeorao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20048",
    "name": "Kamble Dada Shiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12296",
    "name": "Mohite Yashwant Gojaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8151",
    "name": "Dhane Vishwas Jotiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21256",
    "name": "Mishra Ravi Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3710",
    "name": "Jadhav Kisan Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7295",
    "name": "Mandhare Chandrakant Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12618",
    "name": "Mane Vinayak Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5517",
    "name": "Matre Ananda Chandru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11244",
    "name": "Mulik Sanjay Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15270",
    "name": "Kadam Parshuram Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1070",
    "name": "Pawar Chandrakant Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18157",
    "name": "Pawar Dashrath Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11228",
    "name": "Kadam Pandurang Bayaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11260",
    "name": "Dhumal Satish Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14308",
    "name": "Arya Shivpujan Sukhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11144",
    "name": "Shah Rajendrakumar Chandlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12532",
    "name": "Yadav Vilas Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19391",
    "name": "Sonawale Manda Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4681",
    "name": "Shinde Suresh Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1968",
    "name": "Dhumal Vishwas Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6500",
    "name": "Chavan Vijay Laxmanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11125",
    "name": "Shinde Ramdas Sudamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11209",
    "name": "Bhoite Balasaheb Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15004",
    "name": "Jadhav Hanmant Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13039",
    "name": "Sarafdar Bandu Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23196",
    "name": "Miss  Salunkhe Vijaya Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11164",
    "name": "Pisal Rajesh Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19533",
    "name": "Chavda Palubai Giridhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5821",
    "name": "Bhoite Pratibha Pradeep"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4511",
    "name": "Bhoite Pradeep Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7153",
    "name": "More Dashrath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12719",
    "name": "Surve Raghunath Kondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18573",
    "name": "Giri Lalbihari Brijnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4512",
    "name": "Dhumal Subhash Krishnarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16174",
    "name": "Tarde Ashok Shamrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17070",
    "name": "Salunkhe Vimal Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12433",
    "name": "Dudhe Nagnath Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9706",
    "name": "Kumbhar Kiran Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9401",
    "name": "Dhumal Vilas Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1841",
    "name": "Pisal Mohan Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8188",
    "name": "Jamdade Bajrang Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18243",
    "name": "Yadav Rampal Bhukhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18263",
    "name": "Ghodke Vasant Sonu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18302",
    "name": "Gund Ashok Bhimaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18304",
    "name": "Patel Siraj Masak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2847",
    "name": "Nanavare Arjun Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18174",
    "name": "Dube Bharatlal Ramshiromani"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7208",
    "name": "Sawant Pravin Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "727",
    "name": "Ranvare Baban Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18212",
    "name": "Tiwari Yagyanarayan Batuknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18214",
    "name": "Shukla Vivek Chunilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18231",
    "name": "Nakate Anil Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18280",
    "name": "Gupta Gulabchandra Achelal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18355",
    "name": "Chaurasiya Shivkumar Dukanti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "829",
    "name": "Chavan Vasant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18524",
    "name": "Chorge Arvind Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "44",
    "name": "Phalke Ganpat Nagesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "841",
    "name": "Shakuntala Ashok Patil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4193",
    "name": "Kakade Digambar Bhauso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7545",
    "name": "Bhosale Vinayak Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9943",
    "name": "Jadhao Harichandra Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10821",
    "name": "Patel Rajesh Bhagwandas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12551",
    "name": "Pawar Kondiba Hari 494/26"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2658",
    "name": "Bhosale Atmaram Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8015",
    "name": "Zanjurne Shrikant Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10635",
    "name": "Dhumal Kalyan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10871",
    "name": "Deshmukh Anil Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15413",
    "name": "More Sanjay Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8959",
    "name": "Chavan Sharad Bhikoba692/35"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3524",
    "name": "Shivthare Baburao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17907",
    "name": "Shelar Vaishali Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12180",
    "name": "Lembhe Madhukar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11993",
    "name": "Shinde Shivaji Raghu 139/16"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20130",
    "name": "Sabale Chandrakant Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1165",
    "name": "Ghadge Dashrath Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12005",
    "name": "Sawant Yashwant Sagun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6542",
    "name": "Bhoite Dasharath Krushnaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18360",
    "name": "Khaire Umesh Damodar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7144",
    "name": "Sawant Vinayak Vitthal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1937",
    "name": "Sah Santosh Lakhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7320",
    "name": "Jadhav Baburao Yadavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14841",
    "name": "Dube Suryanarayan Ramdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16532",
    "name": "Chavan Shivaji Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10163",
    "name": "Mohite Ashok Nivas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12241",
    "name": "Sapkal Ganpat Bhiwa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8919",
    "name": "Gaikwad Dhansing Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13063",
    "name": "Kindre Bhagwan Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15299",
    "name": "Bangar Vasant Dyanu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15300",
    "name": "Bangar Mahindra Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15824",
    "name": "Rajbhar Ramvijay Sani"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10",
    "name": "Galinde Shamrao Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8539",
    "name": "Zolamkar Pandurag Ramchndra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15713",
    "name": "Kadam Yuvraj Balaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13846",
    "name": "Thorave Prakash Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18557",
    "name": "Penkar Chandrakant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17958",
    "name": "Nimbalkar Pandurang Bacharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17111",
    "name": "Pisal Arvind Atmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11539",
    "name": "Chawan Pralhad Bayappa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14489",
    "name": "Patil Arun Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7773",
    "name": "Kakade Popat Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21432",
    "name": "Agarwal Rajan Satyanarayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9511",
    "name": "Nimbalkar Rajendra Appaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1031",
    "name": "Ghadage Radhabai Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17318",
    "name": "Dhonde Manohar Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11953",
    "name": "Nagare Bhargav Bhanudas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16969",
    "name": "Katekar Sonaji Ananda"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1631",
    "name": "Rane Mahesh Pratap"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7753",
    "name": "Kadam Raosaheb Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1114",
    "name": "Pokle Suresh Shambhu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9610",
    "name": "Mandhre Mangal Suryakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13419",
    "name": "Shinde Ashok Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13028",
    "name": "Anapat Appa Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12875",
    "name": "Chavan Somnath Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12822",
    "name": "More Ananda Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16336",
    "name": "Kokare Sandhya Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16307",
    "name": "Pawar Hiralal Sudamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "968",
    "name": "Chavan Namdeo Madhavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18405",
    "name": "Shinde Ankush Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13246",
    "name": "Shinde Tanaji Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9806",
    "name": "Kamble Krishna Chandru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14184",
    "name": "Londe Ashok Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1895",
    "name": "Shiwankar Vishwanath Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9302",
    "name": "Doifode Anil Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18491",
    "name": "Ghorpade Vilas Hanmant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14113",
    "name": "Mandhare Namdeo Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4302",
    "name": "Jadhav Prakash Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3928",
    "name": "Chavan Gorakh Bandoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "498",
    "name": "Mane Baban Raghunath 563/19"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11566",
    "name": "Pisal Sadashiv Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7194",
    "name": "Davkar Sanjay Kantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7159",
    "name": "More Shankar Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9758",
    "name": "Jadhao Bhuraj Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9785",
    "name": "Kadam Chandrakant Vyankat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14960",
    "name": "Sonawale Rohidas Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8960",
    "name": "Pawar Sampat Savlaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12851",
    "name": "Zanzurane Hindurao Subhedar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12204",
    "name": "Shinde Subhash Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6321",
    "name": "Chavan Balkrushna Babasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8940",
    "name": "Mulik Babaurao Dhondiram 265/4"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6946",
    "name": "Nair Krushnan Preman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13687",
    "name": "Gaikwad Chandrakant Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10510",
    "name": "Dhumal Deepak Laxman"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1073",
    "name": "Tidke Sweta Milind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2368",
    "name": "Sanap Yamunabai S"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5137",
    "name": "Jadhav Pravin Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16939",
    "name": "Tambat Prabhakar Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11919",
    "name": "Chavan Dattatray Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9722",
    "name": "Dhumal Sandesh Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17119",
    "name": "Shinde Laxmi Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20056",
    "name": "Mahadik Sanjay Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13973",
    "name": "Mishra Ramavadh Sarasu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9097",
    "name": "Lawand Madhukar Gorakhnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20544",
    "name": "Dhole Nanasaheb Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9808",
    "name": "Nalawade Chandrkant Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18524",
    "name": "Dhumal Bharat Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11319",
    "name": "Wagh Usha Mahadeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2383",
    "name": "Yadav Dharmendra Ramkishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8312",
    "name": "Gaikwad Nandkumar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9316",
    "name": "Shinde Baban Aburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10285",
    "name": "Pawar Lalsing Shlivraml"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8578",
    "name": "Dalavi Ramesh Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8211",
    "name": "Shirke Kishore Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9187",
    "name": "Mode Laghuraj Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17185",
    "name": "Desai Dattatray Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9931",
    "name": "Bhosale Balasaheb Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10316",
    "name": "Mahadik Shivaji Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13411",
    "name": "Salunkhe Tukaram Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11309",
    "name": "Salunkhe Gajanan Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21588",
    "name": "Todankar Vrushali Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14104",
    "name": "Bhagwat Netaji Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9093",
    "name": "Gardi Krushnat Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "711",
    "name": "Shinde Sardarsing Narsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9255",
    "name": "Shaikh Yusuf Papabhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13113",
    "name": "Jadhav Maruti Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12949",
    "name": "Gharge Shivajirao Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9826",
    "name": "Dhumal Jitendra Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13724",
    "name": "Shaikh Amjad Amiruddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4530",
    "name": "Mane Pralhad Gangaram 1039/14"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21458",
    "name": "Mehta Nilesh Nawin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9779",
    "name": "Madane Yashwant Hira"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7713",
    "name": "Bhosale Gorakh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3845",
    "name": "Gaikwad Balwant Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8595",
    "name": "Yewale Dattatray Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11976",
    "name": "Ghadage Mahadev Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22216",
    "name": "Niungare Ramchandra Appa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23497",
    "name": "Chavan Santosh Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14202",
    "name": "Bhange Vithoba Raghu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14941",
    "name": "Yewale Ashok Pandharinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18847",
    "name": "Shinde Deepak Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11635",
    "name": "Jadhav Baban Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11610",
    "name": "Kadam Asha Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9836",
    "name": "Shinde Baban Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13853",
    "name": "Dhumal Vilas Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12148",
    "name": "Gaikwad Manohar Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10753",
    "name": "Bhosale Navnath Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3299",
    "name": "Kadav Ashok Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9507",
    "name": "Shinde Narayan Appasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6518",
    "name": "Bhoite Govindrao Bhivrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13618",
    "name": "Kadam Bharat Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8994",
    "name": "Pansare Ramnath Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17711",
    "name": "Yadav Ramashankar Mataprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10775",
    "name": "Sonawane Bharat Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11551",
    "name": "Jadhao Janardhan Yashawant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10109",
    "name": "Kakade Dynandeo S   944/10"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6612",
    "name": "Patil Jayawant Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6613",
    "name": "Patil Sharad Hindurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6614",
    "name": "Pandit Vishanupant Murlidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5194",
    "name": "Waghamale Vitthal Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11128",
    "name": "Jadhav Satish Nathuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17273",
    "name": "Kalantre Vishnu R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8608",
    "name": "Mohite Mohan Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10159",
    "name": "Chavan Shashikant Pralhad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14214",
    "name": "Ghorpade Prakash Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14396",
    "name": "Jamdade Santosh S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "573",
    "name": "Jadhav Bhiku Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16957",
    "name": "Kadam Ananda Ravaji  Tn-1457-15"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21184",
    "name": "Modak Vilas Savalaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21212",
    "name": "Shirke Mangesh Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21213",
    "name": "Miss  Vichare Nandini Dinesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22063",
    "name": "Thorve Kanchan Pramod"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6348",
    "name": "Dhumal Subhash Hindurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11684",
    "name": "Shirke Shankarrao Vasantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9055",
    "name": "More Bharat Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10092",
    "name": "Chavan Yuvraj Nanaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8090",
    "name": "Ransing Sharad Sadashi"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "465",
    "name": "Chalke Shivaji Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "365",
    "name": "Nalawade Damodar Dajiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10304",
    "name": "Davare Vishnu Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11691",
    "name": "Nimbalkar Vijay Yedu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17055",
    "name": "Khope Vilas Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7784",
    "name": "Dhavle Vithal Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21118",
    "name": "Suvarna Lalitraj Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21119",
    "name": "Jadhav Ramchandra Jayaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14765",
    "name": "Kadam Navnath Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11316",
    "name": "Kadam Arun Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12815",
    "name": "Jaiswal Baliram Bharose"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18731",
    "name": "Jain Kirti Champalal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9470",
    "name": "Shinde Madhukar Dnyaneshwar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5381",
    "name": "Bhosale Gajanan Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6777",
    "name": "Shinde Sudhir Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10961",
    "name": "Phadkar Chandrkant Dyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14146",
    "name": "Gawade Baban Thaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11453",
    "name": "Shinde Shobha Hanumant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8036",
    "name": "Jadhav Rajendta Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17440",
    "name": "Katekar Ananda Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16964",
    "name": "Phalke Atul Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14624",
    "name": "Dhumal Ajaykumar Pralhad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20185",
    "name": "Babar Ganapat Nivruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9331",
    "name": "Mane Shrirang Balavant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "842",
    "name": "Katekar Kashinath Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6877",
    "name": "Chalke Prakash Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12838",
    "name": "Dhumal Uttam Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9022",
    "name": "Botre Shivram Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19574",
    "name": "Supat Ashok Ratanshi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18213",
    "name": "Shaikh Shabbir Ahmad Mohmmad Ismail"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9897",
    "name": "Khedekar Nanda Ramakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3477",
    "name": "Kadam Ramchandra Chandru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11362",
    "name": "Kadam Satish Dhansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5107",
    "name": "Pawar Mukund Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9901",
    "name": "Jagatap Vasantarao Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10563",
    "name": "Dhumal Abasaheb Rambhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11681",
    "name": "Muliya Ahoka Madhu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6340",
    "name": "Chavan Bansi Khandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2918",
    "name": "Mahadik Bapurao Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13294",
    "name": "Khot Dadasaheb Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9188",
    "name": "Chouhan Ramasare Bhagawandin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17582",
    "name": "Barge Maruti Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10701",
    "name": "Lembhe Rajendra Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12516",
    "name": "Choudhari Kamtaprasad Sukhdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18607",
    "name": "Tele Ananda Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14460",
    "name": "Ingavale Shankar Bhalchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "335",
    "name": "Pawar Shankar Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22304",
    "name": "Raut Ajit Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22305",
    "name": "Raut Pratibha Sudhir"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22306",
    "name": "Raut Sudhir Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12805",
    "name": "Malusare Santosh Ragunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20443",
    "name": "Gaonkar Pravina Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16795",
    "name": "Bandal Sachin Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7579",
    "name": "Nikam Balkrishna Gulabrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12543",
    "name": "Gadhave Rekha Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12915",
    "name": "Jadhav Shivaji Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "324",
    "name": "Sabale Maruti Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10919",
    "name": "Thick Ramchandra Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13571",
    "name": "Ghorpade Raju Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12162",
    "name": "Pawar Manohar Jayaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13691",
    "name": "Shinde Tanaji Sitaram B-2676"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14793",
    "name": "Kadam Maruti Lalaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14797",
    "name": "Shinde Swati Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14807",
    "name": "Lokhande Suhas Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9816",
    "name": "Nawadkar Suryakant Sopanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17373",
    "name": "Panaskar Narayan Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16896",
    "name": "Phalake Rahul A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18463",
    "name": "Lembhe Nandkumar Buvasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9418",
    "name": "Bhosale Sunil Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17755",
    "name": "Pandey Ramjanam Durgaprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22259",
    "name": "Tiwari Ramprakash Ramanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16863",
    "name": "Sarvankar Swapnil Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22214",
    "name": "Chavande Ravindra Manohar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22228",
    "name": "Lakhani Yatin Ranchoddas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10460",
    "name": "Yadav Hemant Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10697",
    "name": "Bagal Adhikrao Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14640",
    "name": "Bhosale Dhananjay Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14644",
    "name": "Shaikh Tousif Musa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14656",
    "name": "Miss  Lohar Supriya Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14689",
    "name": "Jadhav Sachin Hambirarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14700",
    "name": "Shinde Hanmant Anant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14750",
    "name": "Chorat Santosh Haribhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7956",
    "name": "Barve Shivaji Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12560",
    "name": "Pawar Anandrao Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12203",
    "name": "Jadhav Shankar Sopan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15286",
    "name": "Dere Pratap Bhagatsingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1177",
    "name": "Borse Nilesh Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11846",
    "name": "Shinde Popat Vyankat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13234",
    "name": "Khabale  Patil Dhanaji Shyamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22169",
    "name": "Dolas Suresh Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22170",
    "name": "Dolas Rupesh Bhargav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9957",
    "name": "Mulik Bhikoba Kashinath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3219",
    "name": "Chile Lata Datta"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2860",
    "name": "Joshi Ravindra Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2461",
    "name": "Mulik Ashok Samapatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9692",
    "name": "Pawar Tanaji Rangrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7054",
    "name": "Deshpande Raghunath Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10615",
    "name": "Jadhav Sudhir Balwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10202",
    "name": "Pawar Shashikant Arjun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13277",
    "name": "Pawar Mohan Haribhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20042",
    "name": "Negandhi Asha Hemant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22120",
    "name": "Dand Puspa Rajnikant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18267",
    "name": "Tiwari Santoshkumar Kamalashankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18281",
    "name": "Shaikh Shamshad Mohd Nasim Ahmed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14796",
    "name": "Desai Vasant Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3282",
    "name": "Mirukhe Baburao Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17186",
    "name": "Dhanawade Vilas Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10209",
    "name": "Mardhekar Sahebrao Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "844",
    "name": "Bhosale Hanmant Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17179",
    "name": "Mardhekar Dhondiram Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5051",
    "name": "Pawar Vithal Rambhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7323",
    "name": "Chavan Pruthviraj M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13236",
    "name": "Sakpal Ramchandra Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9610",
    "name": "Nivadunge Yashawant Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14781",
    "name": "Shinde Sandeep Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6456",
    "name": "Pisal Pralhad Govindrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21956",
    "name": "Shinde Dyaneshwar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11475",
    "name": "Shaikh Karim Mehaboob"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9698",
    "name": "Sapkal Kalu Mahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9354",
    "name": "Bandal Ramchandra Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19140",
    "name": "Palande Ravindra Krishnaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9558",
    "name": "Mulik Kishan Jagdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3297",
    "name": "Mulik Tatyaba Dhondiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13322",
    "name": "Jagatap Dilip Krishnarav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "557",
    "name": "Bhosale Shankar Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12443",
    "name": "Nikam Shivaji Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13348",
    "name": "Giri Ganpat Sampat 514/25"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2417",
    "name": "Bhoite Uttam Vinayakrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21285",
    "name": "Gouda Chike M"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13753",
    "name": "Nanavre Arvind Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10652",
    "name": "Yadav Shamrao Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10293",
    "name": "Chavan Shivaji Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7071",
    "name": "Shinde Trimbak Krushnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9079",
    "name": "More Rajendra Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22202",
    "name": "Doiphode Vijay Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22203",
    "name": "Mahadik Manisha Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5114",
    "name": "Kolekar Keshav Pandurag"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6093",
    "name": "Bhosale Pralhad Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20053",
    "name": "Sule Anita Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14726",
    "name": "Pawar Sunil Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9119",
    "name": "Nikam Chandrakant Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18906",
    "name": "Sidhpura  Nita Harkisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10191",
    "name": "Chawan Sunil Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16997",
    "name": "Pancharia Dinesh M"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "677",
    "name": "Sayyad Sameera Javed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19550",
    "name": "Dalvi Yashwant Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14850",
    "name": "Ghatge Tanaji Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11054",
    "name": "Phalke Sharad Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11290",
    "name": "Dhuaml Shailesh Keshavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21625",
    "name": "Salunkhe Macchindranath Machindranath   Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12752",
    "name": "Chavan Mahadeo Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13577",
    "name": "Devidas Baban Pawar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18444",
    "name": "Sapkal Dinkar Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7482",
    "name": "Sakpal Shamrao Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2142",
    "name": "Sawant Ankush Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15077",
    "name": "Mane Anna Vishnu B-10471"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "643",
    "name": "Said Ganesh Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7068",
    "name": "Bulunge Vasant Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19736",
    "name": "Gohil Mani Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "118",
    "name": "Kadam Maruti Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19429",
    "name": "Bhorraut Indrakumar Basvantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11183",
    "name": "Gaikar Sitaram Keru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9145",
    "name": "Gaikawad Kamal Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14879",
    "name": "Dhumal Hemant Marutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9627",
    "name": "Jagtap Hanmant Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16193",
    "name": "Bhaste Sanjay Dhyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5005",
    "name": "Chavan Narayan Bapuji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13395",
    "name": "Kakade Balasaheb Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6804",
    "name": "Solskar Mangal Balasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8214",
    "name": "Gaikwad Mahadeo Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6192",
    "name": "Bahulekar Baburao Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18183",
    "name": "Pandey Jaikumar Parmatmaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17639",
    "name": "Shriramwar Gangadhar Jairampant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14861",
    "name": "Parmar Ashokbhai Vithalbhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11035",
    "name": "Deshmukh Dattatray Yashwantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12952",
    "name": "Mirukhe Sakharam Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2670",
    "name": "Bobade Sitaram Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16846",
    "name": "Raut Sunil Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7274",
    "name": "Jadhav Vilas Malharrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7703",
    "name": "Chawan Maruti Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16775",
    "name": "Pawane Sambhaji Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10315",
    "name": "Babaso Namdev B"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9715",
    "name": "Jadhav Yuvraj Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11286",
    "name": "Pisal Uttam Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13482",
    "name": "Yadav Balu Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12471",
    "name": "Pawar Sanjay Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5357",
    "name": "Yewale Dilip Vishnuwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3987",
    "name": "Chavan Appasaheb Kerba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2099",
    "name": "Shinde Sadashiv Vyankat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3943",
    "name": "Nalawade Shivaji Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11928",
    "name": "Hawaldar Anil Aabaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1727",
    "name": "Pisal Sahebrao Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17967",
    "name": "Thakur Gurudevsing Baldevsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15918",
    "name": "Chorge Pandurang Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9635",
    "name": "Dhumal Lalsaheb Mansingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6153",
    "name": "Bobade Vilas Gangaram 103/A/23"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14770",
    "name": "Umberkar Shivaji Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7019",
    "name": "Kadam Ramchandra Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8015",
    "name": "Pawar Balkrishna Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16774",
    "name": "Mandkare Kashinath P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16882",
    "name": "Valunj Sujit Satish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8553",
    "name": "Kadam Ramdas Narhari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17413",
    "name": "Katekar Rajendra Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17084",
    "name": "Gaikwad Tanaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7442",
    "name": "Jadhav Kisan Dnyandeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5136",
    "name": "Phalke Prakash Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14750",
    "name": "Patil Laxman Ramji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1078",
    "name": "Khopade Ganpat Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11234",
    "name": "Kadam Narayan Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9346",
    "name": "Sarkale Tukaram Dadasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22457",
    "name": "Barge Hemant Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1736",
    "name": "Tate Chandru Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10401",
    "name": "Chavan Ramrao Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23414",
    "name": "Ovalekar Mahendra Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "531",
    "name": "Jadhav Dinkar Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13497",
    "name": "Dhumal Bhagwan Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1717",
    "name": "Salate Dattatray Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17030",
    "name": "Pawar Ramesh Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11857",
    "name": "Lotale Pandurang Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1095",
    "name": "Dhumal Genaba Namdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12672",
    "name": "Phalke Manoj Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13430",
    "name": "Gade Hanmant Savala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5934",
    "name": "Kadavekar Adhikrao Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14657",
    "name": "Mohite Rekha Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11895",
    "name": "Shirtode Tanaji Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8773",
    "name": "Dhumal Bhimrao Namdev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19582",
    "name": "Makawana Velubai Aravind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1452",
    "name": "Lembhe Duryodhan Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8190",
    "name": "Jagtap Chandrakant Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10411",
    "name": "Dhumal Marutirao Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13709",
    "name": "Dhumal Vishal Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9301",
    "name": "Mandhare Pradyuman Meruling"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17361",
    "name": "Jain Neeta Parasmal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12587",
    "name": "Miss  Gaikwad Sheela Banaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4712",
    "name": "Chawan Shankar Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3660",
    "name": "Nawadkar Maruti Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1336",
    "name": "Sabale Balkrishna Sawalaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19579",
    "name": "Kambale Ramesh B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11798",
    "name": "Bhosale Chandrakant Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6350",
    "name": "Pisal Hanmant Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12003",
    "name": "Dhumal Rajendra Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3211",
    "name": "Kadam Shivaji Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "657",
    "name": "Panaskar Shivaji Parasram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13458",
    "name": "Yadav Ramjirath D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9848",
    "name": "Dapade Eknath Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12254",
    "name": "Naik Yogesh Pundalik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23871",
    "name": "Kolekar Tushar Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6260",
    "name": "Bhambure Chhaya Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19991",
    "name": "Phanse Atmaram Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15022",
    "name": "Parab Vilas Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13213",
    "name": "Ghode Pandurang Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11746",
    "name": "Lokare Balasaheb Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14650",
    "name": "Matekar Suraj Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9726",
    "name": "Gholap Vishnu Vittal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7682",
    "name": "Shelar Sitaram Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14392",
    "name": "Dutal Mahadev Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12398",
    "name": "Sakunde Sudenna Murari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4411",
    "name": "Bhapkar Bhausaheb Nanasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11633",
    "name": "Jadhav Rajashri Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1922",
    "name": "Phalke Tanaji Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19385",
    "name": "Sanas Suryakant Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8396",
    "name": "Sanas Hanumant Ravaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3508",
    "name": "Oyale Krishna Bhiaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "641",
    "name": "Shaikh Vahidunnisa Akther"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11005",
    "name": "Shinde Pravin Narsingrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1164",
    "name": "Zagade Ramchandra Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19140",
    "name": "Malusare Maruti Dhondiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20544",
    "name": "Gamare Ajeet Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8144",
    "name": "Chavan Kalpana Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7796",
    "name": "Barge Shivaji Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19399",
    "name": "Sonawale Jayashri Madhukar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1690",
    "name": "Waghmare Shalivahan Sabaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19201",
    "name": "Barave Ramadas Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11947",
    "name": "More Prakash Anada  524/14"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23142",
    "name": "Pawar Nagesh Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "819",
    "name": "Shinde Hanmant Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18131",
    "name": "Shibe Sunil Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8984",
    "name": "Dhembare Bhimrao Gopalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5366",
    "name": "Yadav Prakash Bhikoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18269",
    "name": "Jain Babulal Devichand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18278",
    "name": "Panday Prabhunath Vedvyas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8586",
    "name": "Katekar Shankar Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10752",
    "name": "Marathe Hanmant Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12088",
    "name": "Kolekar Dinesh Mahadeo 445/A/21"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5406",
    "name": "Kadam Shamrao R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6947",
    "name": "Yadav Shivaji Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19351",
    "name": "Mishra Gulbchndra Shmbhulal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "616",
    "name": "Phalke Baburao Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12553",
    "name": "Modak Krishna Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19913",
    "name": "Sawant Yashapal Gopinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13022",
    "name": "Kamble Dagadu Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17278",
    "name": "Zite Balaso Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1482",
    "name": "Jadhav Vilas Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10515",
    "name": "Jadhav Laxman Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13460",
    "name": "Shinde Shakuntala Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1984",
    "name": "Shinde Shriram Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20982",
    "name": "Kambli Shamala Sudhir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13926",
    "name": "Miss  Korade Lalita Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19591",
    "name": "Khuman Jitendra Mahand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5317",
    "name": "Pawar Vilas Babaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13536",
    "name": "Jadhav Milind Shridhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8890",
    "name": "Phalke Rukmini Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13886",
    "name": "Pathan Jahangir Gulab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15746",
    "name": "Mane Rajendra Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5909",
    "name": "Kadam Sitaram Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14812",
    "name": "Borge Anil Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16772",
    "name": "Gaikwad Jaywant Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11372",
    "name": "Phadtare Prakash Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11375",
    "name": "Phadtare Shantaram Sidaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11376",
    "name": "Phadtare Nitin Pralhad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2068",
    "name": "Shinde Bhujang Jagdeorao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6399",
    "name": "Modi Dharmesh Nagardas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15705",
    "name": "Ombale Vittal Bhagawan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14018",
    "name": "Vedpathak Saroj Pradeep"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5634",
    "name": "Gurav Mahadeo Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8804",
    "name": "Saste Laxman Damu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12105",
    "name": "Mungase Rajendra J      478/13"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11122",
    "name": "Mohite Laxman Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5430",
    "name": "Dhumal Yashwant Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15515",
    "name": "Khot Mahipati Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16059",
    "name": "Kadam Balwant Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7450",
    "name": "Sabale Kundalik Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15342",
    "name": "Yadav Subhash Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17001",
    "name": "Jagtap Prakash Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1887",
    "name": "Sawant Jagannath Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17450",
    "name": "Kenjale Vishwanath Shamrao Tn-1544-2"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1929",
    "name": "Mhatre Pandit Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5685",
    "name": "Chavan Tanaji Nilkanth"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1036",
    "name": "Chaudhari Dattatray Vinayakrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8450",
    "name": "Jadhav Tukaram Waman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12497",
    "name": "Kadam Rajendra Balu    Balkrushna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12479",
    "name": "Jagtap Gulab Sahebrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13434",
    "name": "Jagtap Sanjay Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7146",
    "name": "Kadam Shamrao Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7643",
    "name": "Wagh Hanmant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15580",
    "name": "Shirshat Raju Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12557",
    "name": "More Samir Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18105",
    "name": "Gawade Baban Thaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4428",
    "name": "Pawar Shankar Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1259",
    "name": "Shetye Gopinath Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5912",
    "name": "Chavan Shivaji Jagdeorao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4552",
    "name": "Chawan Ramchandra Krushnaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14469",
    "name": "Jadhav Suhas Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11314",
    "name": "Baikar Vishram Ramaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12800",
    "name": "Shinde Dattatray Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4957",
    "name": "Sabale Mahadeo Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5009",
    "name": "Mahamuni Umesh Krushnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10682",
    "name": "Jadhav Bajarang Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "288",
    "name": "Jadhav Dnyandeo Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21082",
    "name": "Ghadge Dnyneshwar Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5694",
    "name": "Kadam Tanaji Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3075",
    "name": "Chavan Namdev Dnyandev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14567",
    "name": "Khopade Wasant Sonba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11984",
    "name": "Kudale Bhagwan Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17904",
    "name": "Chavan Balkrishna Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18128",
    "name": "Pawar Sudhakar Somnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13935",
    "name": "Inamdar Kirti Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5695",
    "name": "Jagdale Ashok Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "989",
    "name": "Vichare Pandurang Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21818",
    "name": "Ghadage Shashikant Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20071",
    "name": "Yadav Abhishek H"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13633",
    "name": "Dhumal Krishna Baliram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13288",
    "name": "Bhoite Chandrakant Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10134",
    "name": "Vidhate Nathuram Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14291",
    "name": "Patil Pandurang Bandu 611B/9"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13932",
    "name": "Kadam Sharad Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18008",
    "name": "Banka Jagdishprasad Badriprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13989",
    "name": "Bhosale Bharat Vijaysingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1880",
    "name": "Dhumal Suresh Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23087",
    "name": "Kagalwala Imran Mansoor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18132",
    "name": "Chalke Mohan Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14863",
    "name": "Mojar Ramchandra Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10805",
    "name": "Salunkhe Kisan Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16019",
    "name": "Pawar Balwant Chandru"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22191",
    "name": "Yadav Kantaprasad Indradev"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1541",
    "name": "Momin Mohammed Sajid Mohammed Yusuf"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23014",
    "name": "Jadhav Deepak Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7109",
    "name": "Kadam Ramesh Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1530",
    "name": "Sawant Sahebrao Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11796",
    "name": "Katala Shivanandha Dhondiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1465",
    "name": "Shinde Vithal Jijyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3186",
    "name": "Salunkhe Buasaheb Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7215",
    "name": "Matre Vasant Dnyanu  430/12"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7960",
    "name": "Jadhav Vilas Bhausaheb  Tn    A"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11119",
    "name": "Patil Narayan Annappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "881",
    "name": "Kadam Dhondiram Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22877",
    "name": "Pachupate Deepak Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3926",
    "name": "Salunkhe Sopan Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18955",
    "name": "Chavan Vandana Pralhad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13244",
    "name": "Kadam Dhanaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5248",
    "name": "Shinde Aruna Dnyaneshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21520",
    "name": "Pandya Kishor Dhansukhlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13836",
    "name": "Bhosale Namdeo Dattatry"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2511",
    "name": "Pokharkar Janaji Makaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17258",
    "name": "Chavan Namdeo Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3984",
    "name": "Bhosale Suresh Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9597",
    "name": "Dhas Suresh Tanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19827",
    "name": "Jadhav Somnath Ekanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10567",
    "name": "Chavan Mangesh Govinda"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18623",
    "name": "Pawar Tanaji Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6059",
    "name": "Gaikawad Shankar Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16937",
    "name": "Yadav Sachin Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10294",
    "name": "Mhamane Ramchandra Rangusheth"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9522",
    "name": "Lembhe Vijat Dharmaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10595",
    "name": "Atar Rafique Chand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21936",
    "name": "Singate Bhanudas Bhanudas Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14117",
    "name": "Ughade Umakant Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9387",
    "name": "Chavan Sachin Vasantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9652",
    "name": "Shinde Vimal Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2105",
    "name": "Shinde Dnyaneshwar Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2439",
    "name": "Chawan Narayan Muda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19513",
    "name": "Pawar Sudhakar Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13749",
    "name": "Jagtap Rajendra Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9553",
    "name": "Lanke Shivaji Kashiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12534",
    "name": "Chavan Balu Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1403",
    "name": "Shinde Shamrao Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10989",
    "name": "Sakhare Suvrna Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13188",
    "name": "Dhumal Vaibhav Janardhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1567",
    "name": "Kapase Bajirao Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14043",
    "name": "Kadam Maruti Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "623",
    "name": "Pawar Laxman Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5604",
    "name": "Chorage Keshav Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9314",
    "name": "Jagtap Nanda Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18869",
    "name": "Rane Mangesh Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11989",
    "name": "Dakave Maruti Bala"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19926",
    "name": "Mane Manisha Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3963",
    "name": "Ithape Pralhad Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1957",
    "name": "Nalage Shivaji Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5840",
    "name": "Bhosale Rangnath Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18100",
    "name": "Ansari Ashpakahmad Faiyaz Ansari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4673",
    "name": "Jagtap Prithviraj Shripati"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "324",
    "name": "Kadam Prakash Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19402",
    "name": "Miss  Chavan Sheetal Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20653",
    "name": "Korade Dhyanoba Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7698",
    "name": "Kadam Rajendra Baban"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13129",
    "name": "Fanse Vasant Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10459",
    "name": "Yadav Mahadeo Dagdoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7070",
    "name": "Ghare Raghunath Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12528",
    "name": "Chaudhari Shevaman Mahatma"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11797",
    "name": "Kadam Chandrakant Mugatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9859",
    "name": "Dhumal Balaso Dasharath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9925",
    "name": "Kadam Pratap Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18290",
    "name": "Jaiswal Udaychand Vijayshankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18305",
    "name": "Gupta Radheshyam Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18374",
    "name": "Mali Jagadish Gangadhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12802",
    "name": "Chavan Bhagwan Ganapati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11058",
    "name": "Babar Shivaji Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18150",
    "name": "Sonwane Pramod Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3901",
    "name": "Chavan Hemant Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6740",
    "name": "Matkar Hanmant Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21006",
    "name": "Jaishwal Varma Shivprakash Hariprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1202",
    "name": "Mandhare Vasant Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10907",
    "name": "Pol Dilip Meghraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19200",
    "name": "Date Abaji Sonaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17037",
    "name": "Shinde Sangita Sursh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4177",
    "name": "Dhoiphode Balku Vithal Toli No 259/B/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4846",
    "name": "Yadav Balu Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15084",
    "name": "More Mahadev Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2560",
    "name": "Shinde Baban Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19525",
    "name": "Bornare Vikas Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19430",
    "name": "Salekar Prakash Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3940",
    "name": "Pawar Uttam Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8166",
    "name": "Barave Ranganath Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9203",
    "name": "Salate Baburao Daji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9898",
    "name": "Kadam Vijay Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16217",
    "name": "Kolekar Ashok Ganapati"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "510",
    "name": "Parkale Purshottam Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13960",
    "name": "Kadam Swati Umesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17703",
    "name": "Shinde Manohar Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17414",
    "name": "Shinde Sunil Atmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15588",
    "name": "Pawar Savitra Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4786",
    "name": "Sherekar Sadashiv Dnyandeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1223",
    "name": "Mahajan Prashant Motiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "494",
    "name": "Shirke Balkrishna Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15171",
    "name": "Rao Suryakant Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9691",
    "name": "Pawar Janardan Bhagwanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14646",
    "name": "Yadav Sitalaprasad Harilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8264",
    "name": "Chavan Indumati Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13040",
    "name": "Jagtap Kisanrao Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2967",
    "name": "Yadav Kisan Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13496",
    "name": "Dhumal Sanjay Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "158",
    "name": "Mahale Kisan Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2294",
    "name": "Jadhav Gangaram Ganpati  Tn-659-18"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22675",
    "name": "Bansode Mahavir Homdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7615",
    "name": "Lokhande Ravindra Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7472",
    "name": "Mulik Ravsaheb Jagnnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11428",
    "name": "Kakade Shrikant Manikrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19974",
    "name": "Thorat Shobha Nandkishor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5209",
    "name": "Sapkal Hanmant Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19357",
    "name": "Dandekar Ravi Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14917",
    "name": "Mishra Raghunath Ramnaresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1953",
    "name": "Sabale Shrirang Jagnnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7714",
    "name": "Jagtap Jitendra Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "527",
    "name": "Kadam Baburao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6845",
    "name": "Mahangade Krushna Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15552",
    "name": "Vora Paresh Dharamshi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7191",
    "name": "Jagatap Gajanan Sankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18429",
    "name": "Anavkar Hemant Harikant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10392",
    "name": "Jagtap Nanasaheb Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13367",
    "name": "Chavan Tanaji Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14623",
    "name": "Gaikwad Tanaji Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5394",
    "name": "Durgule Shankar Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9366",
    "name": "Dhumal Kalawati Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13171",
    "name": "Kende Kailash Dyaneshwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "636",
    "name": "Babar Bhikoba Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8598",
    "name": "Gole Sahebrao Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10737",
    "name": "Sayyad Sameer Gulab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5557",
    "name": "Sawant Sampatrao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10830",
    "name": "Sawant Sanjay Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16269",
    "name": "Parte Suvarna Sahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4110",
    "name": "Pisal Sahaji Anadrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5842",
    "name": "Patil Dinkar Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8607",
    "name": "Pawar Sampat Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10781",
    "name": "Mulik Vikas Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12651",
    "name": "Kadam Dadaram Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12391",
    "name": "Wakate Raghunath Chimaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19649",
    "name": "Shinde Manoj Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4184",
    "name": "Shinde Chandrkant Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14218",
    "name": "Sawant Rajesh Dnyandeo  689/10"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4292",
    "name": "Indalkar Balkrishna Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19726",
    "name": "Gaikwad Pramod Bhaskar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10829",
    "name": "Sabale Baliram Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20895",
    "name": "Shinde Sachin Sachin  Narhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18295",
    "name": "Surve Uttam Kondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14321",
    "name": "Choursiya Brijeshkumar Rajaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18544",
    "name": "Rai Jitendra Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18545",
    "name": "Mishra Kamlashankar Lalmani"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18555",
    "name": "Chouhan Lalmani Pancham"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11241",
    "name": "Agarwal Mahesh K"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18461",
    "name": "Bandal Jayant Naryan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14421",
    "name": "Deshmukh Rajendra Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9227",
    "name": "Kadam Maruti Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10798",
    "name": "Mandhare Pravin Shnakar 509/30"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7493",
    "name": "Bhosale Mohan Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18078",
    "name": "Dhumal Sunil Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11274",
    "name": "Katkar Vasant Jijaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10616",
    "name": "Pojari Popat Pralhad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12912",
    "name": "Tankaria Kishor Ghelabhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5109",
    "name": "Kesare Ramu D No 672/2"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11985",
    "name": "Shevate Kusum Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8213",
    "name": "Nalawade Vilas Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10988",
    "name": "Sakhare Vilas Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8924",
    "name": "Jadhav Raghunath Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9928",
    "name": "Sakunde Subhash Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18602",
    "name": "Mohite Vinod Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16759",
    "name": "Phadtare Raghunath Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10373",
    "name": "Nalawade Prakash Dhanwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5871",
    "name": "Pawar Dhondiba Santu 323/11"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12888",
    "name": "Gavali Dilipkumar Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "229",
    "name": "Dhaygude Yashwant Gangadhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5253",
    "name": "Ghadigaonkar Madhukar Nilu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15232",
    "name": "Agarwal Laxminarayan Atmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11438",
    "name": "Shinde Ramdas Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19383",
    "name": "Sayyed Sadik Gulab"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14675",
    "name": "Chavan Prashant Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23503",
    "name": "Sakpal Devidas Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "723",
    "name": "Solaskar Marutirao Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9039",
    "name": "Shilimkar Ravindra T   807/6"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13951",
    "name": "Gavhane Kumar Ambrushi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16792",
    "name": "Kolekar Sambhaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14578",
    "name": "Ansari Shabbir Ahmad Abduljabbar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13",
    "name": "Jadhav Subhash Laxaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19796",
    "name": "Gohil Mohan Palji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13406",
    "name": "Chaudhari Vishram Mahatam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4158",
    "name": "Mane Sadashiv Patalu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8328",
    "name": "Bhoite Dilip Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10427",
    "name": "Chavan Subhash Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23287",
    "name": "Bhosale Vikas Gunda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14286",
    "name": "Kadam Tanaji Mahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2867",
    "name": "Kadam Gopal Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11460",
    "name": "Khopade Balasaheb Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5409",
    "name": "Nikam Udhav Keshavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17042",
    "name": "Jagtap Shankar Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2035",
    "name": "More Shrirang Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17380",
    "name": "Shinde Sachin Mugutrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4012",
    "name": "Patil Vishnu Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8300",
    "name": "Shelar Shamrao Aaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22541",
    "name": "Desai Kiran Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2643",
    "name": "Jadhav Vilas Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16288",
    "name": "Matre Vilas Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1192",
    "name": "Chavan Nivrutti R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7046",
    "name": "Gharal Shivram Keruji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1866",
    "name": "Deshmukh Krishnarao Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12879",
    "name": "Pawar Ganpatrao Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9856",
    "name": "Kadam Bhagwan Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13784",
    "name": "Saskar Aruna Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6925",
    "name": "Sabale Ashok Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18046",
    "name": "Jadhav Bharat Vitthal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9981",
    "name": "Bandal Jitendre Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7008",
    "name": "Jagtap Rajaram Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16947",
    "name": "Sharma Umakant Brijmohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14165",
    "name": "Gadhave Deepak Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12865",
    "name": "Pawar Vithal Joti 915/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11496",
    "name": "Nikam Macchindra Yeshwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19839",
    "name": "Adivade Balu Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10372",
    "name": "More Maruti Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14860",
    "name": "Parmar Hareshbhai Vithalbhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3902",
    "name": "Bhadwalkar Pralhad Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16580",
    "name": "Pisal Baban Gyanaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8873",
    "name": "Bhosale Sanjay Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18860",
    "name": "Tupe Bajrang Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10994",
    "name": "Ghare Bhausaheb Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6210",
    "name": "Solaskar Vasant Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13470",
    "name": "Mohite Prakash Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16333",
    "name": "Nikam Shard Keshv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16334",
    "name": "Nikam Bhanudas Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4413",
    "name": "Salunkhe Kashinath Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12791",
    "name": "Bansode Maruti Babu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4544",
    "name": "Ghadge Rajendra Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12860",
    "name": "Khot Ashok Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19575",
    "name": "Medha Ramesh Tulsi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5966",
    "name": "Barve Vasant Dhondu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6026",
    "name": "Dhumal Dinkar Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4973",
    "name": "Mane Nivruti Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12431",
    "name": "Ithape Sharad Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3320",
    "name": "Sabale Jaising Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16967",
    "name": "Pawar Jagannath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6661",
    "name": "Shinde Prakash Sukhdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18216",
    "name": "Karande Raghunath Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6638",
    "name": "Bansode Dhondiram Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14631",
    "name": "Pawar Ramesh Balasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10648",
    "name": "Kadam Prashant Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17207",
    "name": "Matkar Ajay Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18442",
    "name": "Inamdar Sharipha Shabbir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7807",
    "name": "Desai Sneh Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2167",
    "name": "Patil Chandru Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8258",
    "name": "Gadage Bhimaji Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17504",
    "name": "Khande Vijay Devidas Toli-1546/14"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7172",
    "name": "Pisal Yuvraj Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8956",
    "name": "Duduskar Jaysing Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18378",
    "name": "Thakur Manoj Ramsumer"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "581",
    "name": "Bhaldar Alam Kondi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8390",
    "name": "Kadam Anil Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20665",
    "name": "Wadkar Dattaram Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2776",
    "name": "Kolekar Pandurang Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "985",
    "name": "Sabale Ramchandra Namdeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15551",
    "name": "Vora Ramesh Dharamshi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13569",
    "name": "Jadhav Mansingh Dada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11069",
    "name": "Chalke Govind Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15343",
    "name": "Desai Kishor Parsharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9074",
    "name": "More Dattatray Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15082",
    "name": "Mane Bhimrao Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7379",
    "name": "Shinde Suresh Ganpat  375/10"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11209",
    "name": "Karpe Balaram Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9733",
    "name": "Bobade Sharad Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5742",
    "name": "Phalke Satish Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9554",
    "name": "Gole Yashwant Ganapati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9221",
    "name": "Kalatre Jagannath Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4548",
    "name": "Sakunde Tanaji Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1167",
    "name": "More Vishnu Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9943",
    "name": "Sawant Kumar Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7185",
    "name": "Manerkar Ramchandra Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12953",
    "name": "Yewale Suresh Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17311",
    "name": "Shinde Manohar Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7684",
    "name": "Shuke Mahendra Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4112",
    "name": "Raje Balkrishna Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15549",
    "name": "Sawant Sanjay Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5110",
    "name": "Phalke Avinash Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16215",
    "name": "Sapkal Vijay Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13992",
    "name": "Yadav Rajdev Chandrabali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9619",
    "name": "Gogawale Navnath Rajram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14130",
    "name": "Thombare Mahadeo Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7524",
    "name": "Tetame Nathuram Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8606",
    "name": "Ranjane Bhau Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12220",
    "name": "Ingawale Sharad Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9312",
    "name": "Veer Anandrao Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18542",
    "name": "Wadwania Asraf Karimbhai"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12466",
    "name": "Matkar Shashikant Krishnarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11756",
    "name": "Nikam Deepak Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1084",
    "name": "Mulik Tukaram Mhasku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16809",
    "name": "Dhumal Rajendra Pralhad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15417",
    "name": "Babar Ankush Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12256",
    "name": "Salunkhe Gorakh Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11937",
    "name": "Jadhav Siddhanath Tukarm"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11429",
    "name": "Chawan Shamrao Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20867",
    "name": "Bhanse Dattaram Kundlik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "215",
    "name": "Wagh Sadashiv Nana B Class"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16129",
    "name": "Kadam Suresh Anandao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16636",
    "name": "Khopade Shivaji Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7228",
    "name": "Bhosale Shashikant Narsingrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8556",
    "name": "Jaisalwal Ashok Kumar Ramlobat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13673",
    "name": "Katre Dattatray Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22254",
    "name": "Gole Yashwant Nilkanth"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22255",
    "name": "Kambale Bhagwan Ramu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22256",
    "name": "Jadhav Dattatry Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7918",
    "name": "Jagtap Tukaram Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22205",
    "name": "Nanka Ami Amichand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22206",
    "name": "Reddy Dilip Sayanna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "204",
    "name": "Kadam Jaysing Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18908",
    "name": "Jumare Prakash Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18514",
    "name": "Shaikh Khaja Ishaquddin Nizamuddin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18575",
    "name": "Tiwari Anilkumar Fulchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18618",
    "name": "Mahida Shaukat Husain Ismail"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18619",
    "name": "Borade Nilkanth Pundalik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18632",
    "name": "Pathan Abdul Rasheed Sussain Saheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18645",
    "name": "Fakir Mohammad Alli Mohabatali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18646",
    "name": "Salve Nana Ravba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13329",
    "name": "Choudhari Vishwanath Mahattam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18431",
    "name": "Ajeetsing Didarsing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18496",
    "name": "Ahmed Maqsood Mehboob"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2028",
    "name": "Bhosale Manshing Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18009",
    "name": "Katekar Anil Aananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18413",
    "name": "Shaikh Dawood Ismail"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14276",
    "name": "Yadav Maruti Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12303",
    "name": "Yewale Ramchandra Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13376",
    "name": "Jadhav Ananda Nvrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10801",
    "name": "Salate Dnyanu Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11952",
    "name": "More Arun Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7062",
    "name": "Matre Rajaram Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21070",
    "name": "Agrawal Harichandra Rameshlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1319",
    "name": "Jagtap Yashwant Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7975",
    "name": "Nawadkar Kalidas Dagadu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14731",
    "name": "Ranavare Hanaumant Bhimrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19711",
    "name": "Jadhav Manohar Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9612",
    "name": "Pisal Jitendra Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10893",
    "name": "Shinde Ajit Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2297",
    "name": "Dubal Shivaji Nana"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14007",
    "name": "Babar Anandrao Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12501",
    "name": "Maskar Sanjay Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9876",
    "name": "Pisal Sopan Jayawantarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10298",
    "name": "Dhumal Sanjay Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21098",
    "name": "Alwa Ramesh Seena"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8616",
    "name": "Jagtap Mahendra Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10647",
    "name": "Kirdat Sadashiv Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4528",
    "name": "Barve Dinkar Ranu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15387",
    "name": "Bhoite Hanmant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12125",
    "name": "Jadhav Arun Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5851",
    "name": "Lakhan Bandu Santu 1036/7"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14942",
    "name": "Pisal Phulabai Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23517",
    "name": "Chaudhari Kiran Jitendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8352",
    "name": "Sabale Shivaji Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20310",
    "name": "Lad Jalinder Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17185",
    "name": "Gaikwad Tanaji Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7195",
    "name": "Kumbhar Laxman Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9478",
    "name": "Bhoite Baliram Shankarrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "517",
    "name": "Patil Tanaji Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12549",
    "name": "Shinde Sarjerao Waman 106/12"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9483",
    "name": "Nimbalkar Bhikoba Nanaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22402",
    "name": "Dhumal Milind Sarjerao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21986",
    "name": "Shere Shalaka Kiran"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12028",
    "name": "Khopade Shankar Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6032",
    "name": "Dhumal Avinash Lalasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6283",
    "name": "Salunkhe Bharat Bayaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12427",
    "name": "Maral Sarjerao Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12637",
    "name": "Kadam Ramesh Ramchandra 831/23"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "465",
    "name": "Rajmane Datta Govind"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "23",
    "name": "Dhumal Kavita Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2357",
    "name": "Jadhav Yeshwant Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9754",
    "name": "Jadhao Ramdas Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9741",
    "name": "Dhumal Avinash Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9662",
    "name": "Shinde Dinesh Shantaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13837",
    "name": "Bhapkar Vijay Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10049",
    "name": "Kawar Vijay Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10815",
    "name": "Salunkhe Sashikant G  362/15"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16074",
    "name": "Patil Ram Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2665",
    "name": "Dhanavade Bapu Genu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4051",
    "name": "Kadam Narsing Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18460",
    "name": "Chavan Rajnarayansing Gaurising"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5309",
    "name": "Nalawade Ankush Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20605",
    "name": "Salunkhe Vasant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3059",
    "name": "Bhosale Bajirao Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16275",
    "name": "Hajare Atmaram Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2196",
    "name": "Kadam Hanmant Genu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18242",
    "name": "Pathan Aslam Alam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15370",
    "name": "Shelar Santosh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9437",
    "name": "Yadav Satram Triveni"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4746",
    "name": "Modak Baburao Rakhamaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22792",
    "name": "Patil Shivaji Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3874",
    "name": "Kadam Arvind Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2716",
    "name": "Miss  Jadhav Gokulabai Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18554",
    "name": "Singh Vinod Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12622",
    "name": "Mandhare Dilip Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3428",
    "name": "Mandhare Suresh Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9305",
    "name": "Gaikwad Ashok Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18651",
    "name": "Nagore Mohd Ali Zina"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8712",
    "name": "Chouhan Nandan Bhagwati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4742",
    "name": "Shidruk Mahadeo Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18414",
    "name": "Shaikh Husain Rashid"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18415",
    "name": "Chaudhari Dattaram Devaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9479",
    "name": "Bhoite Vijay Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19651",
    "name": "Solanki Narottam Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22220",
    "name": "Yadav Brijban Bajrangi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5534",
    "name": "Kadam Madhuri Sharad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "157",
    "name": "Ghadge Arjun Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18829",
    "name": "Jadhav Suresh Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7621",
    "name": "Kadam Deepak Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11159",
    "name": "Nimbalkar Dadaso Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5437",
    "name": "Barve Narayan Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19762",
    "name": "Holgir Balu Mhatarba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19653",
    "name": "Solanki Kanji Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9924",
    "name": "Pawar Tanaji Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19428",
    "name": "Pawar Maruti Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19440",
    "name": "Singh Sushil Lallan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11772",
    "name": "Lavand Jayvant Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4321",
    "name": "Wagh Leelawati Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9397",
    "name": "Bobade Jagannath Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10554",
    "name": "Nanavare Sunil Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17228",
    "name": "Chavan Vilash Soma"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17234",
    "name": "Mandavkar Kashiram Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12389",
    "name": "Hinukale Shivaji Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14159",
    "name": "Matre Ramesh Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19618",
    "name": "Rajput Kishor Billabai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11343",
    "name": "Anpat Sanjay Maruti 323/12"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11248",
    "name": "Jadhav Kisan Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12980",
    "name": "Sarafdar Mahadeo Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17441",
    "name": "Nimbalkar Ranjana Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19954",
    "name": "Jadhav Vijaya Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12020",
    "name": "Ithape Balu Gulab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12329",
    "name": "Mane Dhanaji Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5315",
    "name": "More Balasaheb Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1204",
    "name": "Mandhare Bhikulal Ravso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8711",
    "name": "Sawant Jagannath Baban 926/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16842",
    "name": "Miss  Bodhe Harshda Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9353",
    "name": "Dhumal Amol Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7654",
    "name": "Chavan Mohan Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9792",
    "name": "Pawar Bapurao Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13148",
    "name": "Raje Dashrath Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13149",
    "name": "Raje Hanmant Tatyaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8614",
    "name": "Zodge Haribhau Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13428",
    "name": "Ahirekar Digambar Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16276",
    "name": "Dhumal Sandeep Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20380",
    "name": "Adsul Sanjay Dadaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4113",
    "name": "Jadhav Dattatraya V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18556",
    "name": "Lande Hirabai Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9791",
    "name": "Yadav Samaidin Z"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3922",
    "name": "Bhori Imran Sadik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17268",
    "name": "Miruke Uatame Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6609",
    "name": "Sabale Maruti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10453",
    "name": "Shilimkar Deepak Devram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9369",
    "name": "Chavan Laxmi Walmik"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18601",
    "name": "Mohite Shankar Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4444",
    "name": "Malpote Kondiba Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16752",
    "name": "Kadam Parshuram Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19104",
    "name": "Kamble Lata Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3246",
    "name": "Sawant Waman Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15254",
    "name": "Bhilare Pralhad Balasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23107",
    "name": "Jadhav Nisha Anand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15545",
    "name": "Chavan Baban Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12102",
    "name": "Shivankar Mahendra Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14853",
    "name": "Yadav Suryakant Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21635",
    "name": "Dhumal  Niketan  Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3324",
    "name": "Kadam Tukaram Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14710",
    "name": "Mulgoankar Anna Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10209",
    "name": "Chavan Arvind Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19366",
    "name": "Deshmukh Rajendra Yadavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8574",
    "name": "Sangar M G"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14322",
    "name": "Nalawde Rajendra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7636",
    "name": "Pardeshi Vilas Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5419",
    "name": "Sabale Dilip Sudam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "97",
    "name": "Bhosale Laxman Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19129",
    "name": "Jadhav Nilesh Dhanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7544",
    "name": "Pawar Ramchandra Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14378",
    "name": "Sawant Sanjay Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10738",
    "name": "Kolekar Shivaji Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19259",
    "name": "Jawal Pradeep Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10512",
    "name": "Dutal Arjun Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9988",
    "name": "Anapat Nivrutti Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5721",
    "name": "Jadhav Kisan Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17331",
    "name": "Shewale Usha Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11370",
    "name": "Shilimkar Ashok Samapt 968/15"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16458",
    "name": "Pawar Rajaram Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13374",
    "name": "Mohite Shubhangi Pradeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25593",
    "name": "Sawant Priya Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22512",
    "name": "Kadam Raviraj Anantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19326",
    "name": "Mehta Mona Praful"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19327",
    "name": "Mehta Hemal Madhusudan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4588",
    "name": "Kolekar Dattu Bhagoji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22218",
    "name": "Tiwari Harichandra Sabhjit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11833",
    "name": "Borute Pandurang Popat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14139",
    "name": "Chikhale Tukaram Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "266",
    "name": "Jadhav Ramchandra Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18724",
    "name": "Bairai Khyati Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8254",
    "name": "Chavan Sambhaji Narayanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7744",
    "name": "Gholap Bandu Bhiwa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11297",
    "name": "Tankaria Narayan G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17011",
    "name": "Kadam Ramesh Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6564",
    "name": "Bhosale Pralhad Gulab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13585",
    "name": "Nimbalkar Rajaram Devidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13708",
    "name": "Salunkhe Prashant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6848",
    "name": "Jadhao Shubhangi Madhaorao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17241",
    "name": "Pawar Sunil Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12165",
    "name": "More Baburao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13186",
    "name": "Sabale Hanmant Balaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22829",
    "name": "Shah Harshad Jayantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15138",
    "name": "Patel Suresh Gulabchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22827",
    "name": "Ramesh Parmeswaran"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3559",
    "name": "Mohite Mahadeo Bhau   A"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "888",
    "name": "Nagda Riken Chimanlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9327",
    "name": "Ghadge Mahendra Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2360",
    "name": "Jadhav Dinkar Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1305",
    "name": "Jadhav Hanmant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6273",
    "name": "Kundap Purushottam V"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12160",
    "name": "Jadhav Vijay Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10102",
    "name": "Yadav Sidu Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3893",
    "name": "Chavan Pratap Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17136",
    "name": "Sawant Mahendra Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13627",
    "name": "Atugade Laxman R"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14172",
    "name": "Gala Aarti Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13940",
    "name": "Kindre Nathu Dagdu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18262",
    "name": "Mane Tatoba Pilaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12671",
    "name": "Bhagat Kashinath Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4675",
    "name": "Chavan Sharad Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5290",
    "name": "Liddad Pritam Shitalsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4752",
    "name": "Gaikawad Mansing Vaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12878",
    "name": "Ranware Vijay Nanasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5403",
    "name": "Bhosale Dnyaneshwar Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8318",
    "name": "Gaikwad Arjun Aavaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2960",
    "name": "Kadam Natha Chandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14002",
    "name": "Miss  Patil Sheetal Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "274",
    "name": "Jadhav Ashok Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5530",
    "name": "Shivankar Vishnu Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7828",
    "name": "Sarafdar Balu Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11432",
    "name": "Disale Tanaji Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16378",
    "name": "Joil Yogita Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14522",
    "name": "Arya Ramkumar Baldeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13941",
    "name": "Bhat Manjusha Sudhir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11729",
    "name": "Bhoite Nivrutti Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9504",
    "name": "Fadtare Madhukar Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7706",
    "name": "Matekar Maurti Vithal 396/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10978",
    "name": "Suryawanshi Udhav Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19660",
    "name": "Jathar Shoba Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19662",
    "name": "Rathod Indu Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17453",
    "name": "Karande Hanmant Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10949",
    "name": "Bhagat Dadaso Chintu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16818",
    "name": "Bagla Suresh Hukamchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3136",
    "name": "Sawant Dashrath Kesu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21423",
    "name": "Hule Sundeep Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20939",
    "name": "Sawant Vinaya Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2318",
    "name": "Kadam Ramchandra Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13643",
    "name": "Mahadik Nilesh Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5134",
    "name": "Pawar Pratap Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12040",
    "name": "Mane Ravindra Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4344",
    "name": "More Vithal Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10990",
    "name": "Gandhi Prashant Ratanchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2341",
    "name": "Kadam Vithal Bapuji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17509",
    "name": "Dhumal Pandurang Bapuso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7740",
    "name": "Sawant Yeshwant Rajaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1442",
    "name": "Bengade Sunanda Sadshiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15184",
    "name": "Shelake Vithal Bajrang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10726",
    "name": "Kadam Chandrkant Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12105",
    "name": "Phalke Mohan Ekanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20868",
    "name": "Bhanse Ashok Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3598",
    "name": "Kadam Pandurang Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9299",
    "name": "Pawar Madhukar Phulaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7699",
    "name": "Mahangre Ekanath Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14923",
    "name": "Wadwalkar Prakash Shantaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1261",
    "name": "Singh Meena Dharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19012",
    "name": "Prasad Rajeshwar Dukhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19013",
    "name": "Khan Nilofar Varis"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19014",
    "name": "Gupta Pradeep Shivshankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8074",
    "name": "Surve Uttam Dasharath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11116",
    "name": "Salunkhe Sharadkumar Yadav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4850",
    "name": "Shinde Eknath Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2612",
    "name": "Disale Ananda Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18515",
    "name": "Inamdar Munirahmed Hasan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18518",
    "name": "Sharma Deviprasad Harinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18553",
    "name": "Daund Ramnath Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18574",
    "name": "Sundaram Venkatesh Panduram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18607",
    "name": "Kumbhar Rajaram Nagu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18609",
    "name": "Naik Bhalchandra Dhondu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18665",
    "name": "Shaikh Abdul Salim Abdul Rehman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18666",
    "name": "Prajapati Meela Devi Ram Ratan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17642",
    "name": "Nalawade Yogesh Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18459",
    "name": "Pasi Mulchandra Chhakhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18495",
    "name": "Chouhan Ashok Bahaddur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11211",
    "name": "Kadam Dagadu Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20282",
    "name": "Sawant Vishwas Nivruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14154",
    "name": "Mane Shashikant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11509",
    "name": "Thorat Sangeeta Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9262",
    "name": "Ithape Pradeep Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8807",
    "name": "Chalke Baburao Tatoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22793",
    "name": "Patil Adhik Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "743",
    "name": "Khurd Sadashiv Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14166",
    "name": "Chouhan Murlidhar T"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9806",
    "name": "Gujar Chandrakant Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18478",
    "name": "Naik Vilas Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22660",
    "name": "Powale Hitesh Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13678",
    "name": "Parte Bhagwan Jyotiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10751",
    "name": "Bhosale Laxman Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2320",
    "name": "More Nivrutti Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5325",
    "name": "Anapat Govind Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18947",
    "name": "Nisar Damji Bachu/Paresh Damji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20257",
    "name": "Dawari Darshan Dasharath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4609",
    "name": "Bhosale Dashrath Daulat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4140",
    "name": "Kakade Manik Laxman 921/15"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17027",
    "name": "Jagtap Laxman Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9668",
    "name": "Bhoite Shahaji Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11690",
    "name": "Jagdale Shankar Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3677",
    "name": "Pendharkar Hira Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6181",
    "name": "Chavan Udaysing Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9474",
    "name": "Marathe Uttam Dadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18178",
    "name": "Bhoite Deepak Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18403",
    "name": "Salunkhe Ramesh Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11342",
    "name": "Bhosale Laxman Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9380",
    "name": "Chavan Vilash Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11268",
    "name": "Sankapal Mahesh Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19196",
    "name": "Dudwadkar Parag Pramod"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18185",
    "name": "Nishad Baburam Santram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13939",
    "name": "Salvekar Sunnada Suryakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10958",
    "name": "Tupe Nanaso Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12960",
    "name": "Bhoite Tanaji Suryakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1340",
    "name": "Bhosale Vasant Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16053",
    "name": "Kadam Shivaji Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1171",
    "name": "Shinde Laxman Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3266",
    "name": "Kirave Ramchandra Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4555",
    "name": "Chavan Ganesh Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18374",
    "name": "Gupta Bajrangbali Ramdular"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14152",
    "name": "Salkar Ganesh Bhiva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8280",
    "name": "Ambekar Manohar Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16077",
    "name": "More Sadashiv Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10342",
    "name": "Wagh Anil Vithoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18865",
    "name": "Patil Murlidhar Janu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9285",
    "name": "Mendhe Namdeo Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2259",
    "name": "Jadhav Bhau Baba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5441",
    "name": "Awate Mangaldas Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5186",
    "name": "Thick Tukaram Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7697",
    "name": "Kudale Sanjay Hanmant"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "25",
    "name": "Patil Pravin Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12596",
    "name": "Sabale Sanjay Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15882",
    "name": "Gaikwad Ramakant Antu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9126",
    "name": "Zagade Neetin Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13997",
    "name": "Salvekar Shreyas Suryakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13114",
    "name": "Pawar Dhansing Pralhad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12488",
    "name": "Jagatap Hanuman Tatyba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7327",
    "name": "Pawar Shivaji Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12306",
    "name": "Bhoite Nitin Baburao Tn-344-18"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "871",
    "name": "Jadhav Laxman Gyanaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9561",
    "name": "Patil Tanaji Appa Tn-1528-1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8392",
    "name": "Ithape Hanmant Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10785",
    "name": "Kane Sahebrao Prabhu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4475",
    "name": "Shinde Vasant Deoram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11786",
    "name": "Jagtap Krishna Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3967",
    "name": "Salate Tukaram Kisan 62/12"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20284",
    "name": "More Vijay Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20708",
    "name": "Sawant Shobha Bhagwan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1049",
    "name": "Talawar Shantaapa Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6223",
    "name": "Mohite Shankar Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11936",
    "name": "Dhawade Santosh Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12944",
    "name": "Deshmukh Trimbak Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2699",
    "name": "Pawar Baburao Tukaram 680/32"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13166",
    "name": "Karpe Krushnat Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14604",
    "name": "Nagaraji Sayyad Buran"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14847",
    "name": "Jadhav Kisan Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2051",
    "name": "Kadam Ramrao Baliram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8784",
    "name": "Mojar Govinda Rau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "189",
    "name": "Matekar Ananda Tatoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "983",
    "name": "Shinde Kisan Vithu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6169",
    "name": "Nikam Mohan Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18889",
    "name": "Jagtap Nitin Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10646",
    "name": "More Vilas Rauso  468/9"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7951",
    "name": "Jagtap Shivaji Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10840",
    "name": "Bhoite Shailendra Ashokrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14324",
    "name": "More Bharat Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3313",
    "name": "Bhosale Dharmaji Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8559",
    "name": "Anpat Sopan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8398",
    "name": "Mane Shivaji Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17072",
    "name": "Pawar Tanaji Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22791",
    "name": "Patil Jayashri Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9539",
    "name": "Kadam Haridas Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10087",
    "name": "Sabale Haribhau Kundlik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11784",
    "name": "Shinde Ravindra Jijaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15395",
    "name": "Jadhav Uttam Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10521",
    "name": "Patil Suresh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7695",
    "name": "Suryawanshi Sanjay Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13266",
    "name": "Wagh Hanmant Vishwasrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10488",
    "name": "Dere Sanjay Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8964",
    "name": "Desai Shivaji Vishnu  Tn-366-8"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22576",
    "name": "Patil Sunil Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17607",
    "name": "Kadam Suresh Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17703",
    "name": "Chalke Sonaji Maruti  Tn-366-18"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8754",
    "name": "Bhosale Dilip Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6771",
    "name": "Mahangade Keshav Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23277",
    "name": "Vengurlekar Archana Sandeep"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3460",
    "name": "Kadam Vishnu Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19923",
    "name": "Saste Dilip Babanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "587",
    "name": "Chavan Damodar Amruta"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13556",
    "name": "Kale Leela Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19082",
    "name": "Ambre Sanjay Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5098",
    "name": "Barave Khandu Dhondu 13/16"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18620",
    "name": "Upadhyay Pramodkumar Kapoorchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18630",
    "name": "Singh Prahlad Amarnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2039",
    "name": "Sawant Namdev Antu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2066",
    "name": "Shinde Netaji Jyoti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7578",
    "name": "Bamane Suresh Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9414",
    "name": "More Ramesh Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9713",
    "name": "Jadhav Anandrao Vishwanath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2833",
    "name": "Mahadik Jotiram Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1525",
    "name": "Shinde Hanmant Parbati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19999",
    "name": "Muke Dhondiram Gaurihar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15791",
    "name": "Nazare Rajesh Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7734",
    "name": "Sakpal Deepak Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8503",
    "name": "Tawade Atul Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7736",
    "name": "Botre Ramchandra Daji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14554",
    "name": "Thakur Ashok Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7485",
    "name": "Mohite Shamrao Madhavrao 650/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12045",
    "name": "Jagtap Sandeep Gulabrao 174/18"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17404",
    "name": "Pawar Prakash Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20873",
    "name": "Gaikwad Sanjay Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9973",
    "name": "Shaikh Sabir Ali Khudadin 1120-4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8691",
    "name": "Pawar Chandrakant Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9163",
    "name": "Kadam Suresh Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "622",
    "name": "Shinde Baburao Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4671",
    "name": "Salunkhe Namdeo Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17549",
    "name": "Sharma Rajeshkumar Ramsanjivan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8539",
    "name": "Sonawane Achaldas Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10344",
    "name": "Nimbalkar Ganesh Sampatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2200",
    "name": "Bhoite Shivaji Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1181",
    "name": "Jadhav Mohan Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "826",
    "name": "Dhumal Laxman Nagoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8344",
    "name": "Shinde Kundalik Gopal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16656",
    "name": "Jalgaonkar Prashant Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16871",
    "name": "Salunkhe Vikas Rangrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16743",
    "name": "Bhadvankar Vasant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10266",
    "name": "Shinde Tukaram Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12634",
    "name": "Shinde Sanjay Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3519",
    "name": "Borkar Jayashree Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12857",
    "name": "Katekar Tukaram Dnyanu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14308",
    "name": "Ingale Manohar Genaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14323",
    "name": "Alag Bansilal Wajirchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7761",
    "name": "Wagh Pralhad Jyotiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10918",
    "name": "Chatur Vilas Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4333",
    "name": "Dhumal Arun Vithalrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12626",
    "name": "Shinde Suyrakant Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14699",
    "name": "Ranware Pandharinath Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12454",
    "name": "Mahadik Vishwas Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1969",
    "name": "Chavan Maganrao Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20294",
    "name": "Chalke Vasant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8592",
    "name": "More Ashok Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4037",
    "name": "Chikane Arvind Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12006",
    "name": "Mulik Arjun Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14075",
    "name": "Yadav Satish Vasantrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13607",
    "name": "Khopade Baban Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "684",
    "name": "Bhoite Kisan Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21748",
    "name": "Pawar Sandesh Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17189",
    "name": "Sakunde Sagar Trimbak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14922",
    "name": "Agarwal Sanjaykumar Shambhunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20910",
    "name": "Gowda Satish Satish Dodde"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10273",
    "name": "Chavan Sambhaji Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16940",
    "name": "Pansare Devdas Krishnakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4309",
    "name": "Jagtap Shrirang Bapuji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1108",
    "name": "Mandhare Sampat Babaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18850",
    "name": "Bhilare Mansing Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8827",
    "name": "Pachangane Ankush Dada 1173/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5499",
    "name": "Salunkhe Sanpat Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7668",
    "name": "Bhosale Sanjay Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16740",
    "name": "Mulik Balu Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17213",
    "name": "Horambe Suresh Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14260",
    "name": "Jaiswal Suresh Haraku"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2080",
    "name": "Jadhav Dasharath Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8487",
    "name": "Bagal Ramchandra Dada"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1123",
    "name": "Mallah Harikesh Acchelal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15459",
    "name": "Nikam Prakash Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6622",
    "name": "Bhosale Nandkumar Sambhajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "250",
    "name": "Nimbalkar Prakash Nilkanth"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17824",
    "name": "Khopade Machindra Bhagwan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20711",
    "name": "Tiwari Rupeshkumar B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18294",
    "name": "Chaurasiya Jitendra Radhesham"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5589",
    "name": "Chav Dattu Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11340",
    "name": "Patel Ranchhod Mammu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2847",
    "name": "Kadam Laxman Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6558",
    "name": "Salte Ramchandra Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19654",
    "name": "Jadhav Bhaguram Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12539",
    "name": "Pawar Avinash Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9450",
    "name": "Phalke Uttam Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "801",
    "name": "Shinde Maruti Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12975",
    "name": "Bhosale Vilas Gangaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8598",
    "name": "Newase Pandurang Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9570",
    "name": "Velekar Shashikant Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10416",
    "name": "Thombare Vithal Kaluram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13257",
    "name": "Jadhav Anandrao Yashwantrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4703",
    "name": "Sawant Mohan Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10947",
    "name": "Sapkal Nitin Raman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10677",
    "name": "Mulik Tukaram Kondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11387",
    "name": "Nalage Balkrushna Dada"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14115",
    "name": "Bhosale Suresh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10944",
    "name": "Yadav Anil Suryaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20928",
    "name": "Nikam Abhijit Shyamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "703",
    "name": "Mandhre Dattatrya Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15501",
    "name": "Shinde Shamrao Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16979",
    "name": "Mardekar Ganpat Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13161",
    "name": "Bhilare Bajirao Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11500",
    "name": "Deshmukh Hemant Aappaso"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16780",
    "name": "Chorge Sanjay Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20645",
    "name": "Sing Vinod Subedar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12653",
    "name": "Pawar Vithal Raoji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10575",
    "name": "Ithape Vilas Yadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5470",
    "name": "Dhumal Suresh Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13989",
    "name": "Khopade Santosh Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11932",
    "name": "Nalage Sambhaji Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6259",
    "name": "Bhat Suryakant Bhalchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "911",
    "name": "Mandhare Mahadeo Piloba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15811",
    "name": "Chikne Sunita Rajesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16943",
    "name": "Kadam Hanumant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12041",
    "name": "Gole Shrirang Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7719",
    "name": "Kadam Ashok Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8306",
    "name": "Pol Ankush Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14493",
    "name": "Jadhav Sima Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9878",
    "name": "Yadao Mohan Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13207",
    "name": "Chavan Hanmant Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15353",
    "name": "Phadatre Sudham Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24",
    "name": "Bobade Baliram Namdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5991",
    "name": "Mulik Laxman Dajiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13970",
    "name": "Rajage Appa Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17372",
    "name": "Bhoite Dhanbjay Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4020",
    "name": "Shedage Suryakant Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4698",
    "name": "Nimbalkar Tulshiram Vinayak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18194",
    "name": "Khan Rafique Hussian Razak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8836",
    "name": "Dhumal Balasaheb Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12776",
    "name": "Shinde Jalinder Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8179",
    "name": "Nawadkar Baliram Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8218",
    "name": "Shinde Vitthal Ramchandra Tn-733-3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9761",
    "name": "Gupta Rajeshwarprasad Hiralal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16742",
    "name": "Chalke Shivaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5395",
    "name": "Salunkhe Gorakh Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18047",
    "name": "Vagare Appaso Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14555",
    "name": "Yadav Jagdishprasad Haribansh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5090",
    "name": "Jadhav Ramesh Madhavrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12734",
    "name": "Bhoite Sharad Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13691",
    "name": "Bhosale Hanmant Pandurangtoli-1525/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15294",
    "name": "Sawant Yogesh Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3153",
    "name": "Bhoir Aruna Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19596",
    "name": "Joshi Ashok Shankarlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4137",
    "name": "Shinde Ashok Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7553",
    "name": "Salunkhe Tanaji Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7801",
    "name": "Salte Ramchandra Bhairu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6906",
    "name": "Sawant Gulab Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18396",
    "name": "Salunkhe Govinda Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18880",
    "name": "Jagtap Pralhad Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15694",
    "name": "Nawal Rameshchandra Omkarmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20057",
    "name": "Bobade Mangal Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9746",
    "name": "Phalke Rajendra Dattatraya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20205",
    "name": "Matekar Ravindra Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20969",
    "name": "Rupawate Vilas Khandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9853",
    "name": "Chavan Mahendra Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4264",
    "name": "Kadam Damu Shamu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14508",
    "name": "Chavan Vikas Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5612",
    "name": "Matre Shankar Laxman 359-2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4991",
    "name": "Chavan Vishwas Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5528",
    "name": "Chikne Anandrao Dadoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20785",
    "name": "Godse Deepak Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12999",
    "name": "Kindre Uttam Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11182",
    "name": "Vasant Sopan Dane"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8125",
    "name": "Sawant Vasant Anandrao 328/27"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20703",
    "name": "Nawadkar Amol Kalidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13075",
    "name": "Sawant Sudam Pandurang 1183/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13610",
    "name": "Nikam Madhukar Jagnnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9067",
    "name": "Kadam Mahadeo Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2334",
    "name": "Chalake Vasant Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13349",
    "name": "Chavan Dyanand Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9574",
    "name": "Ghorpade Sanjay Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13789",
    "name": "Mane Yuvraj Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11766",
    "name": "Jadhav Nanda Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12509",
    "name": "Kindre Vasant Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4135",
    "name": "Jagtap Bhikoba Vithoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17192",
    "name": "Shah Rakesh Jayantilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6611",
    "name": "Nawadkar Chandrashekhar Rangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3764",
    "name": "Momin Musabhai Husen"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19364",
    "name": "More Vikas Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9050",
    "name": "Doiphode Baiju Santu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1475",
    "name": "Tayde Sulbha Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16402",
    "name": "More Prakesh Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2364",
    "name": "Sawant Shamrao Krishan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10082",
    "name": "Newase Sanjay Appaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14597",
    "name": "Bhoite Santosh Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9829",
    "name": "Kambale Arjun Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9492",
    "name": "Jadhav Jijaba Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3897",
    "name": "Jadhav Tanaji Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17018",
    "name": "Lembhe Sudhakar Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2119",
    "name": "Bhosale Ramesh Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13535",
    "name": "Kakade Shivaji Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3153",
    "name": "Patil Dagadu Pandurang 612/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4979",
    "name": "Shinde Balu Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14951",
    "name": "Mandhare Dayanand Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11574",
    "name": "Sahani Rambachan Chou 923/3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15376",
    "name": "Durgude Kisan Maruti  Tn-641-C-13"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7086",
    "name": "Kadam Madhukar Sopanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8023",
    "name": "Bhosale Ankush Khashaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18497",
    "name": "Shamsunder Vishnu Barge"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15125",
    "name": "Yedav Prakesh R T No 438/8"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13897",
    "name": "Deshmukh Archana Rahul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10643",
    "name": "Fadatare Tanaji Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4929",
    "name": "Shinde Madhukar Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12616",
    "name": "Bhor Dattatrya Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6469",
    "name": "Kadam Nandkumar Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8182",
    "name": "Pisal Ramchandra Sayaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2458",
    "name": "Mulik Sitaram Nathuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17809",
    "name": "Yadav Ramziyavan Zinkai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10773",
    "name": "Ugale Sanjay Balawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12984",
    "name": "Chougale Subash Anand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9827",
    "name": "Nanavare Bajrang Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13283",
    "name": "Zore Ramchandra Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2325",
    "name": "Savla Mayur Nemchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13616",
    "name": "Ghewade Sandeep Tabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7048",
    "name": "Lambhe Ramdas Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13255",
    "name": "Ranware Sanjay Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17571",
    "name": "Kamtekar Shital Shamkant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14204",
    "name": "Aadhav Shantaram Rama"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8315",
    "name": "Nighore Rangnath Kushaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18192",
    "name": "Khan Mehmood Farid"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7681",
    "name": "Yadav Shankar Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20901",
    "name": "Gowda Shekhar Javare"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18108",
    "name": "Mane Chandrakant Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12836",
    "name": "Kazi Immamuddin I"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1608",
    "name": "Kadam Vilas Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22334",
    "name": "Jadhav Prashant Janu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15720",
    "name": "Kumbhar Suganda Adhik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6154",
    "name": "Salunkhe Bharat Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2124",
    "name": "Gaikawad Dnyanu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5045",
    "name": "Pujari Kamlakar Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17509",
    "name": "Dhok Sopan Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1883",
    "name": "Chavan Tanaji Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7186",
    "name": "Katkar Gopinath Aabaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5799",
    "name": "Sathe Baban Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21023",
    "name": "Lokare Anil Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6031",
    "name": "Yadav Dattatraya Shripatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3663",
    "name": "Bhagwat Dattatray Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19670",
    "name": "Chalke Dattaram Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13739",
    "name": "Dhumal Nivrutti Nagoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14533",
    "name": "Bhosale Namdeo Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9519",
    "name": "Yadav Dattatraya Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1677",
    "name": "Bhoite Vishwas Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9552",
    "name": "Jadhav Sambhaji Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19939",
    "name": "Dhadve Pramod Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15610",
    "name": "Dhumal Santosh Chandar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4688",
    "name": "Shinde Suresh Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12063",
    "name": "Karale Mohan Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6776",
    "name": "Pisal Ramchandra Dinakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12890",
    "name": "Avare Mohan Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20051",
    "name": "Bagkar Devendra Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3342",
    "name": "Pol Bandu Tukaram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1742",
    "name": "Gandhi Shruti Sunil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9549",
    "name": "Kadam Chetansing Vittal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "138",
    "name": "Shinde Chappanrao Yadavrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14707",
    "name": "Barge Bhanudas Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15798",
    "name": "Nikam Ramesh Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18230",
    "name": "Pal Samaru Pancham"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3337",
    "name": "Dere Veersen Krushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21288",
    "name": "Ghadigaonkar Dasharath Sahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19600",
    "name": "Pawar Hanmant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9740",
    "name": "Pawar Pradeep Vasantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2373",
    "name": "Makhije Laxmandas B"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11198",
    "name": "Thombre Vitthal Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15019",
    "name": "Awade Sushila Shrirang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3065",
    "name": "Khopade Jitendra Sudhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7810",
    "name": "Dhumal Suresh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "538",
    "name": "Bhosale Shamrao Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10383",
    "name": "Sonavane Yashwant Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5100",
    "name": "Kanse Yashwant Gopalrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11383",
    "name": "Khade Rajendra Damodar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14668",
    "name": "Chavan Hanmant Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4904",
    "name": "Pawar Balwant Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10124",
    "name": "Bobade Murlidhar Dnyanoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12439",
    "name": "Gundage Bandu Raghu 1054/1"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "173",
    "name": "Kadam Amar Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1320",
    "name": "Kadam Bhimrao Madhavrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7239",
    "name": "Nimbalkar Dattatray Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18480",
    "name": "Yadav Girjashankar Lalaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18891",
    "name": "Dhumal Rajendra Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7361",
    "name": "Bhosale Hanmant Mahadeo Tn-154-9"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5957",
    "name": "Gaikawad Rajaram Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14294",
    "name": "Shinde Hanmantrao Dinkarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "590",
    "name": "Shinde Vishnu Mugatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22950",
    "name": "Vora Mukesh Dhanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23631",
    "name": "Kalyani Santosh Narvekar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1208",
    "name": "Chavan Tulshidas Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11511",
    "name": "Shinde Sambhaji Pratap"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "837",
    "name": "Chavan Dattu Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "585",
    "name": "Kadam Dhyandeo Marutrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5210",
    "name": "Ranware Shankar Abasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16719",
    "name": "Dalvi Pratiksha Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2238",
    "name": "Kolekar Rajaram Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10680",
    "name": "Pawar Suresh Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12633",
    "name": "Pawar Jaywant Balaku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11933",
    "name": "Pisal Dilip Shankar 181/A/35"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13397",
    "name": "Jaiswal Bipat Kanayaa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8461",
    "name": "Bhosale Bhimrao Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7583",
    "name": "Yadav Raosaheb Suryaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10547",
    "name": "Kadam Kisan Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13811",
    "name": "Nikam Sagar Vishwas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4900",
    "name": "Pathan Gulab Mubarak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12983",
    "name": "Jadhav Kisan Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13547",
    "name": "Varpe Kunal Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9499",
    "name": "Gundage Mahadeo Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11070",
    "name": "Jadhv Dhondiram Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13046",
    "name": "Matre Ramchandra Abaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21467",
    "name": "Kachhela Pinal Navnit"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7143",
    "name": "Mohite Mohan Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16952",
    "name": "Mane Santosh Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14508",
    "name": "Jaiswal Jayaprasad Ramfer"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12328",
    "name": "Chavan Arjun Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7882",
    "name": "Chalke Pandurang Tatoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14829",
    "name": "Bhosale Uttamrao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6565",
    "name": "Gaikwad Shankar Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19247",
    "name": "Mane Vithhal Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17666",
    "name": "Lokhande Kiran Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10608",
    "name": "Bhoite Ashok Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16012",
    "name": "Visawadiya Ramesh Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8596",
    "name": "More Rajaram Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22233",
    "name": "Bhoite Umesh Tribakrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3996",
    "name": "Jadhav Suresh Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3522",
    "name": "Sapra Amar Sewasingh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14361",
    "name": "Chitragar Devidas Gundopant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18357",
    "name": "Ansari Anis Ahmed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17641",
    "name": "More Krishna Dharma"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18686",
    "name": "More Bharat Ananda"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17531",
    "name": "Yadav Ramjanam Ramnaval"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "343",
    "name": "Pisal Hanmant Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16147",
    "name": "Shaikh Ibrahim Mohd Hamid"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10081",
    "name": "Pawar Chandrakant Sawlaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10972",
    "name": "Nimbalkar Kashinath Yashwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14637",
    "name": "Mishra Usha Pankaj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12604",
    "name": "Jadhav Anand Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7571",
    "name": "Deshmukh Ganesh Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2383",
    "name": "Kadam Shivaji Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2425",
    "name": "Khot Rajaram Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16544",
    "name": "Khopade Suvarna Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "417",
    "name": "Pujari Pratap Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15317",
    "name": "Mandhare Santosh Janardhan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3041",
    "name": "Vaze Dhananjay Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16814",
    "name": "Chalke Ishwar Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5662",
    "name": "Shinde Arvind Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1255",
    "name": "Jagtap Mugatrao A"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2358",
    "name": "Ghotilkar Santosh Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1580",
    "name": "Chavan Namdev Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9467",
    "name": "Sonawane Hindurao Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15624",
    "name": "Jagdale Manoj Jagnnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5026",
    "name": "Matre Dattu Vishnu 383/14"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19134",
    "name": "Bhoite Shrikant Hanamant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4863",
    "name": "Pisal Madhukar Vishwas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7774",
    "name": "Sanas Raghunath Dnyandev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7458",
    "name": "Kanviya Manjuben Nanubhai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9636",
    "name": "Kadam Sambhajirao Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23432",
    "name": "Akbarali Hasimali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10581",
    "name": "Shinde Shamrao Nivrutti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9745",
    "name": "Gaikwad Eknath Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20484",
    "name": "Dhuri Sanman Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15751",
    "name": "Daphale Shahaji Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15788",
    "name": "Kadam Bharat Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16917",
    "name": "Shah Kaushik Mansukhlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8582",
    "name": "Kadam Vijay Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "695",
    "name": "Nimbalkar Abasaheb Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2645",
    "name": "Kalukhe Dada Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7909",
    "name": "Shinde Pravin Sadashiv"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22284",
    "name": "Hindalekar Sneha Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14009",
    "name": "Babare Reshma Sudhir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11159",
    "name": "Nalawade Rahul Shivajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2976",
    "name": "Bhoite Sarjerao Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10075",
    "name": "Kachare Hari Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6343",
    "name": "Shingare Digambar Shantaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20767",
    "name": "Dhumal Yuvaraj Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11749",
    "name": "Sakhare Kedar Sudhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "60",
    "name": "Bhosale Ganpatrao Bayajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2559",
    "name": "Taware Yeshwant Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6729",
    "name": "Jadhav Madukar Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18608",
    "name": "Kawde Tanaji Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11951",
    "name": "Nimbalkar Mahadeo Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6553",
    "name": "Shivther Kantilal Vithal 743/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9292",
    "name": "Patil Dhondiba Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12866",
    "name": "Dhabhade Yashwant Andanda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3946",
    "name": "Sakpal Narayan Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3362",
    "name": "More Shamrao Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10973",
    "name": "Jadhav Kondiba Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18964",
    "name": "Shikhare Mahesh Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5596",
    "name": "Chalke Yeshwant Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12085",
    "name": "Salunkhe Popat Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18668",
    "name": "Sawant Sunil Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17880",
    "name": "Agarwal  Vinod  Ambalal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10860",
    "name": "Wagh Mahesh Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3582",
    "name": "Jadhao Vijaysinh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9755",
    "name": "Yeole Arjun Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9113",
    "name": "Patil Dhnodiram Jagan 257/B/5"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "902",
    "name": "Phalake Ashok Ganpat"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1697",
    "name": "Jain Vivek Bhawarlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6171",
    "name": "Dhumal Bapu Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12989",
    "name": "Pandey Surendrakumar Prasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12934",
    "name": "Pawar Balu Yashwant  B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5116",
    "name": "Sapkal Maruti Sadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14180",
    "name": "Patil Balu Dnanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9467",
    "name": "More Adhik Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11648",
    "name": "Chavan Nitin Namdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13189",
    "name": "Dhumal Janardhan Bhimrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12863",
    "name": "Sonawane Arun Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6073",
    "name": "Jagtap Genaba Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9162",
    "name": "Chalake Athu Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16700",
    "name": "Jadhav Anil Bhim"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1448",
    "name": "Shinde Hanmant Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25167",
    "name": "Vaviya Dharmendra Narsi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20776",
    "name": "Trimbakrao Jagadevrao Bhoite"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14543",
    "name": "Shidruk Subhash Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8831",
    "name": "Shedage Nivrutti Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5205",
    "name": "Pawar Tukaram Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18073",
    "name": "Kadam Bharat Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12173",
    "name": "Chalke Serjerao Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3286",
    "name": "Nigade Vishwasrao Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1704",
    "name": "Nagale Sonu Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10805",
    "name": "Katkar Sudhakar Vishwasrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22985",
    "name": "Patil Sharad Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12960",
    "name": "Khairmode Shalini Parshuram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14144",
    "name": "Shinde Anil Yashawant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7534",
    "name": "Yewale Changdeo Vitthal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20285",
    "name": "Parab Pragati Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "631",
    "name": "Narvekar Ashok Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2376",
    "name": "Bhoite Vishwanath Sidram 392/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12042",
    "name": "S Natrajan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2935",
    "name": "Kadam Tukaram Ravaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18198",
    "name": "Patil Vijay Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21275",
    "name": "Gavhane Jyoti Vishwanathrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3997",
    "name": "Ghadge Ramchandra Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1916",
    "name": "Gaikawad Baliram Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13572",
    "name": "Shinde Sahdeo Hindurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2541",
    "name": "Mulik Hanmant S  478/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12083",
    "name": "Mandhare Madhukar Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9537",
    "name": "Shinde Bhanudas Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7241",
    "name": "Salate Sitaram Bhairu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11400",
    "name": "Maskar Balu Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12882",
    "name": "Yadav Uttam Tanaji 661/5"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13699",
    "name": "Nalawade Mugutrao Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7022",
    "name": "Shealr Sadashiv Nana"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17179",
    "name": "Shah Beena Rakesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11966",
    "name": "Harijan Jogiram Jaypal  Tn-15-4"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20870",
    "name": "Thorat Deepak Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15101",
    "name": "Inamdar Sameer Papamiya"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5652",
    "name": "Jadhav Madhukar Ishwara"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14537",
    "name": "Shinde Shantaram Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3302",
    "name": "Pawar Rangarao Ramchandraa"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12785",
    "name": "Kadam Ravindra Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15751",
    "name": "Bhosale Nileshkumar Vilas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5627",
    "name": "Shinde Ramchandra Waman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17351",
    "name": "Kadam Dattatray Audumber"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14155",
    "name": "Gawankar Govind Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5060",
    "name": "Kolekar Dhanaji Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9695",
    "name": "Radia Amisha A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1334",
    "name": "Chavan Dilip Narayan  Tn-692-27"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12268",
    "name": "Shelar Sundar Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "183",
    "name": "More Bhausaheb Hari"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14546",
    "name": "Kadam Ramchandra Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23235",
    "name": "Shinde Anandrao Krushnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9139",
    "name": "Patil Prakash Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9736",
    "name": "Sabale Ashok Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7078",
    "name": "Pisal Hanmant Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17918",
    "name": "Jadhav Sanjay Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23234",
    "name": "Shetty Ashwin Damodar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17876",
    "name": "Bhoite Mohan Madan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19756",
    "name": "Pandey Shambhunath Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7960",
    "name": "Gatte Saroj Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18050",
    "name": "Mulik Ganesh Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14372",
    "name": "Jaiswal Dhanraj Ramsevak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9624",
    "name": "Salunkhe Pratap Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9073",
    "name": "Gawade Dnyandev Biru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18086",
    "name": "Matekar Maruti Ananda Toli No-1048-16"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18586",
    "name": "Daki Naresh Rambhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15778",
    "name": "Shinde Lata Satish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6394",
    "name": "Chavan Changdev Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10937",
    "name": "Pawar Shivaji Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10325",
    "name": "Sabu Ramswarup Ramniwas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "982",
    "name": "Pisal Shankar Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "856",
    "name": "Salunkhe Pralhad Abaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12474",
    "name": "Gujar Balwant Sahdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4397",
    "name": "Lembhe Pandurang Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "686",
    "name": "Shinde Raghu Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8604",
    "name": "Dhamal Shivaji Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14722",
    "name": "Suryawanshi Bharat Udhav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15107",
    "name": "Suryawanshi Maruti Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10202",
    "name": "Nalwade Rajendra Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21857",
    "name": "Rahate Jayesh Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21863",
    "name": "Miss  Salvi Abhilasha Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13096",
    "name": "Ghorpade Balasaheb Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14129",
    "name": "Shinde Umesh Uttamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11655",
    "name": "Karpe Narayan Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8666",
    "name": "Pharande Shankar Bhikoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21112",
    "name": "Kotian Mohan Chikkai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12575",
    "name": "Mulgoankar Suresh Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2778",
    "name": "Bhandari Ganpat Motya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7774",
    "name": "Pawar Bajirao Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7288",
    "name": "Mohite Ankush Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16072",
    "name": "Jadhav Chandrashekhar Chintaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3567",
    "name": "Phadale Vanabhau Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2703",
    "name": "Ranware Pandit Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16882",
    "name": "Deshmukh Vikram Pandharinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12219",
    "name": "Sopan Baburao Lembhe"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12360",
    "name": "Malpote Damodar Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22436",
    "name": "Kasar Yaswant Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22437",
    "name": "Narule Bharat Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19311",
    "name": "Gaikwad Navnath Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6887",
    "name": "Galinde Satish Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23377",
    "name": "Patankar Pramod Shridhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9043",
    "name": "Parmar Babulal Sadaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18588",
    "name": "Bhosale Sanjay Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13503",
    "name": "Jambhale Vilas Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9652",
    "name": "Jadhav Mahadeo Govind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18523",
    "name": "Kakkad Bipin Kalyanji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9337",
    "name": "Salate Laxman Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1425",
    "name": "Taas Yashodabai Gangaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21850",
    "name": "Salvi Amit Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2283",
    "name": "Nimbalkar Bapurao Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16493",
    "name": "Karne Sandeep Sopan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9423",
    "name": "Bhoite Gajanan Babanrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20386",
    "name": "Pawaskar Mukund Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18400",
    "name": "Bhoite Shashikala Subhash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22514",
    "name": "Miss  Kadam Renuka Raviraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19234",
    "name": "Kadam Vikas C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18114",
    "name": "Jagtap Kalpana Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3989",
    "name": "Shirke Narayan Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10796",
    "name": "Mody Maniben Nagardas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12736",
    "name": "Dongare Jagannath Jaysing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7596",
    "name": "Sawant Hanmant Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12926",
    "name": "Mandhare Mohan Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4238",
    "name": "Shinde Babasaheb Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10901",
    "name": "Bhoite Ratan Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1706",
    "name": "Shinde Ramchandra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16230",
    "name": "Kanavia Dharmesh Nanubhai/Manjuben"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8196",
    "name": "Shinde Bharat Jaising"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18039",
    "name": "Salte Janabai Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16738",
    "name": "Suryavanshi Sukhadeo Rangarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15354",
    "name": "Shinde Vinod Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23048",
    "name": "Patil Dhondiba Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9766",
    "name": "Jagatap Ashok Sadashio"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18801",
    "name": "Shinde Sanjay Vasantrav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13033",
    "name": "Gujar Asgar Ali L"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8321",
    "name": "Chavan Arvind Vishnu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "774",
    "name": "Vhavale Anand Mahipati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17433",
    "name": "Maloo Kamlesh Surajmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10375",
    "name": "Bhoir Ashok Baluram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "911",
    "name": "Dhumal Pratap Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9894",
    "name": "Dhanawade Baban Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5533",
    "name": "Jadhav Balu Bhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14344",
    "name": "Sutar Ravindra Kondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10492",
    "name": "Bhilare Rohidas Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17655",
    "name": "Gamare Prabhakar Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8939",
    "name": "Ghor Shnakar Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10665",
    "name": "Hande Vasant Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10468",
    "name": "Parab Vanita Harichandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13168",
    "name": "Dhumal Jagdev Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23446",
    "name": "Kolage Rahul Vinod"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13111",
    "name": "Ghorpade Uddav Gulab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8227",
    "name": "Kadam Mahdeo Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10503",
    "name": "Shinde Narayan Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4351",
    "name": "Kadam Dhondiram Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6909",
    "name": "Jedhe Mohan Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17770",
    "name": "Shinde Dnyandev Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1082",
    "name": "Mandhare Sahebrao Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14724",
    "name": "Ranga Jagdish Laxminarayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5014",
    "name": "Kashilkar Subhash Anna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23880",
    "name": "Mandal Nani Gopal Satyanarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16763",
    "name": "Chikane Vijay Ragunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7023",
    "name": "Kolekar Nivrutti Sarjerao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14412",
    "name": "Pawar Tukaram Vithal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14709",
    "name": "Rananavare Harishchandra Hanumantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18218",
    "name": "Bhilare Amar Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15072",
    "name": "Pawar Arjun Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18704",
    "name": "Patel Hansa Kantilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17252",
    "name": "Karpe Ashok Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13914",
    "name": "Kanase Anand Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12580",
    "name": "Phalake Bapu Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12773",
    "name": "Kadlag Dhondibhau Kushaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15079",
    "name": "Sawant Vishnu Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20843",
    "name": "Jaguste Radhika Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3487",
    "name": "Kadam Subhash Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7438",
    "name": "Ghotkule Khandu Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10088",
    "name": "Dhumal Mohan Subhanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13844",
    "name": "Yadav Ram Bhavan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15869",
    "name": "Sawant Dhondiram Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9146",
    "name": "Phalake Shivaji Dattu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16884",
    "name": "Valunj Sangeeta Satish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1644",
    "name": "Shirke Dinkar Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21892",
    "name": "Miss  Babar Rani Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14695",
    "name": "Harijan Shyamlal Jagram  Tn-1147-2"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20385",
    "name": "Miss  Gupta Rashmi Baiju"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14906",
    "name": "Kolekar Dhondiba Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18269",
    "name": "Patne Deepak Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8562",
    "name": "More Shivaji Nanaso  734/14"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14567",
    "name": "Yadav Sanjay Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12426",
    "name": "Salunkhe Dadu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16298",
    "name": "Choudhari Babulal Pakaramji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11001",
    "name": "Chawan Satish Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11760",
    "name": "Thick Sadu Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10362",
    "name": "Kirve Vithal Dnyanoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14376",
    "name": "Jain Mohanlal Lalchand"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6608",
    "name": "Dhane Jotiram Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10367",
    "name": "Jadhav Hanumant Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6853",
    "name": "Lakhan Dhondiba Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9273",
    "name": "Yadav Shivaji Anna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11120",
    "name": "Mohite Rajaram Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17407",
    "name": "Dhumal Dinesh Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22997",
    "name": "Ghanawat Manda Baban"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22946",
    "name": "Nagda Viral Praful"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22947",
    "name": "Nagda Praful Lasmichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2112",
    "name": "Pophale Haribhau Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7152",
    "name": "Pathan Rajekhan Noorkhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17638",
    "name": "Khaire Sanjay Hiraji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15804",
    "name": "Deshamukh Ranganath Ramdas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "376",
    "name": "Khan Irshad Nausherwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15554",
    "name": "Karande Sunil Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9835",
    "name": "Ghodake Raghunath Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15806",
    "name": "Dhumal Ganesh Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5430",
    "name": "Bhor Balshiram Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19884",
    "name": "Veshvikar Dilip Dattatrey"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8972",
    "name": "Pawar Sunil Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12535",
    "name": "Kolekar Shankar Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17684",
    "name": "Ghadge Vikas Malhari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16530",
    "name": "Bawadekar Santosh Sadanand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15752",
    "name": "Nikam Vaishali Ganesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16796",
    "name": "Dhumal Bhanudas Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7761",
    "name": "More Vijay Hari     734/8"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20239",
    "name": "Bagve Ganesh Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9671",
    "name": "Newase Arjun Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7965",
    "name": "Kumthekar Babalal Karum"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7894",
    "name": "Patil Dadu Chandru"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15719",
    "name": "Shinde Ashok Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10314",
    "name": "Janugade Satish Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8644",
    "name": "Nalawade Dhansing Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14687",
    "name": "Patil Laxman Hariba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14790",
    "name": "Yadav Ramraksha Jagdish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14053",
    "name": "Shinde Ganesh Maruti 692/47"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8726",
    "name": "Mulani Gulab Mohamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6634",
    "name": "Salvi Anant Putlaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12768",
    "name": "Shilimkar Rajendra Vishwanath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17731",
    "name": "Shirke Kalidas Bapu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6677",
    "name": "More Balkrishana Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7201",
    "name": "Nalage Maruti Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10894",
    "name": "Raut Vishwas Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23966",
    "name": "Jaiswal Rekha Shivprakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4132",
    "name": "Pawar Arjun Anandrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8934",
    "name": "Vora Narendra Dharamshi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14210",
    "name": "Gaikwad Babanrao Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11516",
    "name": "Dongare Mahendra Ragunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19886",
    "name": "Jadhav Shridhar Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19985",
    "name": "Udeshi Jatin Ramdas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11206",
    "name": "Raut Sharda Viswas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22765",
    "name": "Tayade Anuruddha Madhukar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "83",
    "name": "Ingole Duryodhan Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9844",
    "name": "Deshpande Aanand Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12958",
    "name": "Bhilare Vijay Marutrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14899",
    "name": "Shinde Hambirrao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3701",
    "name": "Yadav Yeshwant Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10264",
    "name": "Chavan Ankush Jagdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7245",
    "name": "Kolekar Suresh Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4239",
    "name": "Bhosale Gajanan Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15859",
    "name": "Bhoite Vikrant Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11397",
    "name": "Sabale Dashrath Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7716",
    "name": "Shinde Ramesh Jaising"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5848",
    "name": "Nerurkar Anant Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12025",
    "name": "Dhumal Pradip Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10267",
    "name": "Gaikwad Tukaram Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4027",
    "name": "Gosavi Ramesh Dhakunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19305",
    "name": "Khatri Minbahadur Gagansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3700",
    "name": "Raskar Balu Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10851",
    "name": "Parte Nivrutti Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8003",
    "name": "Yadav Surasingrao Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8749",
    "name": "Lakhan Balu Sadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14019",
    "name": "Yadav Vaman Jaganath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22373",
    "name": "Shaikh Fakhruddin Nazuruddin Mirza"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11435",
    "name": "Dhumal Sambhaji Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20077",
    "name": "Nanda Ishmeet Singh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9885",
    "name": "Nikam Balaso Sarjerao 547/2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13964",
    "name": "Pawar Hariba Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7281",
    "name": "Jadhav Suresh Genu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3498",
    "name": "Gujar Ramchandra Shankarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21375",
    "name": "Sawant Abhishek Anand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18404",
    "name": "Desai Ranjana Shriram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5678",
    "name": "Poonekar Sandhya C"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14333",
    "name": "Shah Narendra Popatlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15616",
    "name": "Savadkar Ashok Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9192",
    "name": "Kadam Laxman Ravji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15964",
    "name": "Malkar Prashant Sadanand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4143",
    "name": "Jadhav Sadashiv Vishnu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "413",
    "name": "Tachtode Ramesh Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7748",
    "name": "Shinde Ramesh Rupchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8679",
    "name": "Nawadkar Shankar Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2496",
    "name": "Pujari Baban Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12915",
    "name": "Shinde Uday Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9994",
    "name": "Shelar Shantaram Sitaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "286",
    "name": "Salunkhe Pradeepkumar Sonba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7569",
    "name": "Pisal Rohidas Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18509",
    "name": "Patil Mangal Nivruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17476",
    "name": "Yadav Bechanram Deonarain"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10655",
    "name": "Gardi Shivaji T"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2174",
    "name": "Kadam Sharad Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12495",
    "name": "Shinde Shreedhan Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25054",
    "name": "Shah Pritesh Jagdish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7687",
    "name": "Whade Shamrao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15335",
    "name": "Shinde Hindurao Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12099",
    "name": "Anpat Shahaji Vinayak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10927",
    "name": "Nikam Namdeo Dada"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5576",
    "name": "Mehta Kevalchand Amrutraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10210",
    "name": "Jadhav Gajanan Vithoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17397",
    "name": "Kotwani Haresh Vishandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17783",
    "name": "Barge Rohidas Uttamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3639",
    "name": "Kadam Satish Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6215",
    "name": "Ravindra Laxman Mane"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17931",
    "name": "Pathan Sajeeda Hasanudding"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16711",
    "name": "Rajput Mahesh B"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18373",
    "name": "Gupta Sudhakar Jawaharlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11696",
    "name": "Jadhav Nanasaheb Appasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15888",
    "name": "Tambe Hemant Harichandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7175",
    "name": "Dagade Tukaram Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13574",
    "name": "Patil Sanjay Dagadu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4776",
    "name": "Pawar Shakuntala T"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19871",
    "name": "Patare Shilpa Surendre"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13173",
    "name": "Shah Vishal Narendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17157",
    "name": "Shinde Tarubai Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13269",
    "name": "Shinde Chandrakant Dhondu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19408",
    "name": "Sakunde Bhanudas Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18020",
    "name": "Ethape Mohan Bhagwat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9754",
    "name": "Bhilare Hanmant Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "295",
    "name": "Deepak Baban Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13248",
    "name": "Salunkhe Ashok Dnyanu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16815",
    "name": "Raikar Panna Abhijit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13531",
    "name": "Phathan Japharali M  678/B/4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14648",
    "name": "Bodake Ganesh Rajaram  Tn-1100-5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7050",
    "name": "Nikam Nivrutti Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13772",
    "name": "Singh Ramkuber Satyanarayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16770",
    "name": "Gupta Gulabchand Dudhanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22",
    "name": "Shinde Babasaheb Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7113",
    "name": "Ozarkar Mahadeo Ramu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2300",
    "name": "Naik Dattanath Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16885",
    "name": "Nawale Janabai Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15532",
    "name": "Korgaonkar Laxman Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23053",
    "name": "Pachupate Suvarna Deepak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8657",
    "name": "Jadhav Nana Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10642",
    "name": "Khilare Baburao Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6550",
    "name": "Kadam Hanmant Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17449",
    "name": "Jadhav Sunil Mahadev  Tn-1544-7"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13376",
    "name": "Mohite Sadhana Sanjog"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13831",
    "name": "Ghodake Malkari Malappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12381",
    "name": "Patil Sanpatrao Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17572",
    "name": "Dhonde Baburao Raghunath T-730/A/10"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19873",
    "name": "Patare Surendre Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18099",
    "name": "Mandhare Sitaram Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16272",
    "name": "Jadhav Lajwanti Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18639",
    "name": "Shinde Popatrao Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13235",
    "name": "Patil Prakash Bhauso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10760",
    "name": "Jain Vipul Bastimal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4393",
    "name": "More Sarjerao Genba 308"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2567",
    "name": "Patil Vilas Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4703",
    "name": "Chikane Tukaram Krishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11098",
    "name": "Kale Shivajirao Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14099",
    "name": "Dudhane Machhindra Babu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10106",
    "name": "Chavan Kalidas Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13435",
    "name": "Jagtap Gajanan Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7269",
    "name": "Shinde Dadasaheb Deoram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12735",
    "name": "Parmar Achalchand C"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16005",
    "name": "Sakunde Dilip Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2232",
    "name": "Bhoite Ashok Jaywantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25213",
    "name": "Shedekar Roshani Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10677",
    "name": "Shinde Maruti Bajrang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18831",
    "name": "Bamugade Shankar Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20922",
    "name": "Pawar Lahu Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10559",
    "name": "Choudhari Hanumanprasad Magaru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14010",
    "name": "Kolekar Rajaram Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12281",
    "name": "Bhosale Laxman Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16173",
    "name": "Naringrekar Dhanlxmi Vaman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21950",
    "name": "Bhapkar Hemlata Vilasrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9242",
    "name": "Jagtap Rajendra Bhausaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2731",
    "name": "Sawant Anandrao Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18446",
    "name": "Kadam Jeevan Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14162",
    "name": "Kharade Jalindar K 67/B/13"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9063",
    "name": "Nawadkar Pratap Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6275",
    "name": "Nikam Janardan Dhondiram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2300",
    "name": "Thakare Barku Chandar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5916",
    "name": "Jadhav Dinkar Vaman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9760",
    "name": "Gaikwad Jitendra Babasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10642",
    "name": "Gore Maruti Balaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19700",
    "name": "Mane Sudhir Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17361",
    "name": "Yewale Dhondiba Balasaheb"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21223",
    "name": "Sasane Surekha Satish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16403",
    "name": "Joshi Shankar N"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13258",
    "name": "Nevase Lalaso Appaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12484",
    "name": "Disale Hanmant Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18630",
    "name": "Sarafdar Nivruti Janu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10203",
    "name": "Barge Shyamrao Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16786",
    "name": "Chalke Rakesh Tatoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5462",
    "name": "Chavan Kisan Bhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17730",
    "name": "Mohite Bhagwan Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8825",
    "name": "Bhor Rajendra Dattatraya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2464",
    "name": "Kadam Madhukar Tayappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17955",
    "name": "Bhosale Bhanudas Mansing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22840",
    "name": "Shaikh Arfat Manzoor"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5040",
    "name": "Pawar Jagannath Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10294",
    "name": "Lawand Jaywant Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22767",
    "name": "Thorat Antara Abhay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15007",
    "name": "Salaskar Santosh Bhaskar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3110",
    "name": "Rayat Ramji Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2891",
    "name": "Katkar Ramdas Aabaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10641",
    "name": "Auti Manohar Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18494",
    "name": "Shinde Saili Sunil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5365",
    "name": "Mane Suresh Babasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16389",
    "name": "Pawar Kiran Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5638",
    "name": "Kalukhe Baliram Sarjerao 412/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10621",
    "name": "Bhinde Pandurang Ramu 891/5"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18306",
    "name": "Nimbre Pradeep Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14292",
    "name": "Chaudhari Shankar Ganpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17983",
    "name": "Mistry Devidas Vithaldas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10846",
    "name": "Gopali Rajanikant Devendrappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7348",
    "name": "Chawan Suresh Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11714",
    "name": "Yadav Chandrakant Vamanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11473",
    "name": "Pisal Prakash Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5079",
    "name": "Choure Dhondiram Biru 916/9"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16651",
    "name": "Sakunde Bhimrao Manik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11273",
    "name": "Jagtap Hanmant Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19982",
    "name": "Paleja Nikita Narottam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12747",
    "name": "Parte Ramchandra Sitaram 399/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2217",
    "name": "Raje Dagadu Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7380",
    "name": "Sivathare Dilip Vaman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12685",
    "name": "Chavan Vishvanath Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11180",
    "name": "Sachdev Kamal H"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14269",
    "name": "Walawalkar Lahu Janardhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6802",
    "name": "Jadhav Jalindar Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16107",
    "name": "Patel Bhikabhai G"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5611",
    "name": "Nalage Bapu Nana"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10808",
    "name": "Sanap Sharad Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16779",
    "name": "Jagtap Pradeep Ganpat Tn-477-27"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "525",
    "name": "Pisal Uttamrao Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13032",
    "name": "Ali Yunuskhan Mukadam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15813",
    "name": "Vinarkar Manjula Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11682",
    "name": "Kale Alka Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9948",
    "name": "Doiphode Dhondiba Sakharu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20972",
    "name": "Shaikh Hussain Rajmamhamad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4247",
    "name": "Salunkhe Mahadeo Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18265",
    "name": "Mishra Sanganlal Shardaprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11123",
    "name": "Kate Prakash Vitthalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13779",
    "name": "Bhosale Namrata Manoj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3997",
    "name": "Pokale Prafulla Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3682",
    "name": "Salunkhe Ankush Khashaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19671",
    "name": "Kale Vaishali Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15343",
    "name": "Patel Babubhai Somabhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14596",
    "name": "Rathod Jeshing Palji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14010",
    "name": "Godse Avinash Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9653",
    "name": "Dhumal Hindurao Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13685",
    "name": "Retharekar Babanrao Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8894",
    "name": "Suryawanshi Balasaheb Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12746",
    "name": "Chovan Harijan Jagaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17237",
    "name": "Said Ramdas Ranuji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23422",
    "name": "Desai Sunil Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21546",
    "name": "Siddque Mohamadsami Mohamad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14267",
    "name": "Walawalkar Ashwani Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6387",
    "name": "Salunkhe Popat Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9189",
    "name": "Bavdekar Sadashiv Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16043",
    "name": "Bhoite Pravin Mahadeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19254",
    "name": "Patel Basheer Abdul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8798",
    "name": "Gharal Kisan Joti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5395",
    "name": "Banka Govindram M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9792",
    "name": "Yadav Maniram Bihari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14035",
    "name": "Bhosale Chandrashekhar Gulabrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23661",
    "name": "Kharawala Farooq Suleman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17538",
    "name": "Mangeshikar Chhaya Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7196",
    "name": "Sawant Ramu Bhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18095",
    "name": "Jadhav Manesh Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17175",
    "name": "Sawant Tanaji M  B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18622",
    "name": "Kapadia Bipin Ratilal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23268",
    "name": "Dabholkar Sulochana Madan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14698",
    "name": "Ranware Tanaji Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16986",
    "name": "Gadage Mahendra Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14134",
    "name": "Dalvi Sitaram G"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15093",
    "name": "Bhoite Vishwas Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20356",
    "name": "Ghevade Vitthal Soma"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17286",
    "name": "Shidruk Kishor Sahebrao  Tn-482-A-12"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16075",
    "name": "Shivnagi Bhima Shankar Jyanappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16636",
    "name": "Lugade Pandurang Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21584",
    "name": "Bhoite Nitin Gulabsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18063",
    "name": "Sawant Laxman Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7085",
    "name": "Mohite Mahadev Piloba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8186",
    "name": "Kadam Bapurao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17248",
    "name": "Shegar Ravindra Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18996",
    "name": "Shinde Dinesh Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2024",
    "name": "Pawar Vishnu Kishan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19333",
    "name": "Sarang Narayan Gangaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12348",
    "name": "Dhumal Hanmant Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10538",
    "name": "Inamdar Riyaz Hidait"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15276",
    "name": "Thik Rajaram Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2161",
    "name": "Kadam Mahadeo Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6340",
    "name": "Sankpal Hindurao Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "48",
    "name": "Bhilare Uttam Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9709",
    "name": "Jagtap Chandrakant Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16353",
    "name": "Dangra Kailash Madanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18015",
    "name": "Gharal Sachin Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23281",
    "name": "Shetty Prakash Sunder"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17246",
    "name": "Munjal Dattatray Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6711",
    "name": "Jadhav Madhukar Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10037",
    "name": "Aavthar Anil Shankarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13760",
    "name": "Gaikwad Dhanaji Maruti 1022/9"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9263",
    "name": "Bobade Shivaji Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18064",
    "name": "Pawar Pandurang Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7104",
    "name": "Sangodkar Shivram Raghuvir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14892",
    "name": "Ahirekar Mahadeo Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11740",
    "name": "Bavdekar Sambhaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15352",
    "name": "Padelkar Shantaram Budhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7422",
    "name": "More Vikas Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8368",
    "name": "Salunkhe Dilip Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9582",
    "name": "Pawar Laxman Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19091",
    "name": "Sanas Ramchandra Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8056",
    "name": "Karpe Gajanan Malhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19392",
    "name": "Bachare Nitin Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6790",
    "name": "Sabale Shivaji Maruti  Tn-477-16"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6491",
    "name": "Miss  Bhoite Vijaya Bhikoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14771",
    "name": "Bhosale Vilas Mansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3259",
    "name": "Kate Jotiram Maruti   Tn 822-23"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "336",
    "name": "Ithape Baburao Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1943",
    "name": "Sawant Sampat Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9549",
    "name": "Vengurlekar Sandeep Fatuji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23375",
    "name": "Desai Ashok Shivajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15464",
    "name": "Nawadkar Sagar Kalidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14977",
    "name": "Pawar Rajendra Eknath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12950",
    "name": "Dhumal Sachin Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8768",
    "name": "Mohite Laxman Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14478",
    "name": "Borage Ishwar Nivrutia/9137"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16917",
    "name": "Chand Rakesh Bilbar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13483",
    "name": "Jaiswal Chetilal Gadur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15328",
    "name": "Chavan Subhash Hanamant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7938",
    "name": "Phadkar Mahadeo Dnyanu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19544",
    "name": "Miss  Jadhav Priya Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14427",
    "name": "Virkar Kailash Dada"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17445",
    "name": "Sabale Dilip Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6467",
    "name": "Phadtare Vijay Kashinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8821",
    "name": "More Ragunath Hariba 734/2"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2077",
    "name": "Naik Ashok Gajanan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12280",
    "name": "Lembhe Prakash Narsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10528",
    "name": "Pawar Popat Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15453",
    "name": "Naik Vasundhara Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16441",
    "name": "Shibe Nivrutti Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13559",
    "name": "Yadav Bachaprasad Ramsundar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16125",
    "name": "Raje Bharat Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17619",
    "name": "Bhoir Vikash Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17735",
    "name": "Dhotre Balkrishna Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13926",
    "name": "Sambhare Milan Gotu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7775",
    "name": "Dalvi Aatmaram Ganapt"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5025",
    "name": "Parekh Bharat P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15349",
    "name": "Talekar Chandrakant Shivaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5310",
    "name": "Kadam Pandurang Shnakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20807",
    "name": "Bharmal Mohan Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13201",
    "name": "Rajiwade Govind Kondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22844",
    "name": "Mony Mini Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9581",
    "name": "Gaikawad Bhimrao Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3026",
    "name": "Jain Bhavesh Popatlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23299",
    "name": "Joshi Bina Khyaliram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7276",
    "name": "Shirodkar Arun Anand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19760",
    "name": "Sawant Arvind Jaganath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15382",
    "name": "Khopade Sanjay Tulsiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12270",
    "name": "Bavadekar Ramesh Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20948",
    "name": "Shinde Sachin Mahadev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13812",
    "name": "Bhoite Balaso Nanaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17884",
    "name": "Ghare Nanasaheb Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16573",
    "name": "Lembhe Prakash N"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8832",
    "name": "Jadhav Virendra Venkatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4023",
    "name": "Patil Mahadeo Dagadu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4840",
    "name": "Shahane Bharat Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15896",
    "name": "Taware Meghnath Popat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15451",
    "name": "Chavan Udaykumar Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8453",
    "name": "Sapkal Maruti Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16997",
    "name": "Lembhe Rajendra N"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23221",
    "name": "Jadhav Nitin Bajrang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11946",
    "name": "Pendurkar Pandit Shridhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14266",
    "name": "Walawalkar Surekha Lahu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18441",
    "name": "Pujari Ratnakar Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13974",
    "name": "Mohite Vikaram Dhondiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14637",
    "name": "Kudale Arvind G"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11465",
    "name": "Jain Mahendra Kumar Dalichand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1911",
    "name": "Aggarwal Kapil Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18576",
    "name": "Vartak Vilas Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18577",
    "name": "Raut Akshay Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17363",
    "name": "Jain Rakesh Parasmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15452",
    "name": "Shitole Kailash Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6725",
    "name": "Pandey Vinayak Bholanath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "639",
    "name": "Shaikh Aktar Ahmed"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6189",
    "name": "Kolekar Bhagwan Krushna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18188",
    "name": "Chawan Gurcharansingh Babusing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16081",
    "name": "Sharma Tribhuvannath Kalpanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18200",
    "name": "Dawri Vijay S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9315",
    "name": "Thorat Sambhaji Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22631",
    "name": "Kanehan Karan D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21953",
    "name": "Shinde Vishnu Patilbuva"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23328",
    "name": "Gandhi Rajesh Suryakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13869",
    "name": "Shinde Mahadeo Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18100",
    "name": "Pokale Gitesh Anant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7688",
    "name": "Salunkhe Bapu Vyankat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14011",
    "name": "Shedage Shripati Bhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20708",
    "name": "Yadav Dipraj Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3905",
    "name": "Pokale Bhalchandra Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7273",
    "name": "Sambhare Milind Gotu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7985",
    "name": "More Chandrakant Bapurao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22324",
    "name": "Mandhare Ravindra Dyaneswar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "750",
    "name": "More Laxman Genu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23466",
    "name": "Dhanu Siddharth Vasant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12942",
    "name": "Nikam Yuvaraj A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21481",
    "name": "Bhambid Sharad Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23873",
    "name": "Kadam Deepak Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24372",
    "name": "Kumal Arjun Hark"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24499",
    "name": "Pawar Ramdas Dattatray"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2744",
    "name": "Kushma Kishna Shriniwas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1200",
    "name": "Mhaisdhune Nirmala Kishore"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1348",
    "name": "Londhe Vijay Mohan  A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14427",
    "name": "Nimbalkar Suresh Jagdeorao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22104",
    "name": "Chavan Prabhakar Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15569",
    "name": "More Balaso Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9529",
    "name": "Zanzane Sunita Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24644",
    "name": "Hasami Taj Mahammad Rustamaali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24453",
    "name": "Shaikh Mohd Farooq Ali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16411",
    "name": "Tiwari Dindayal Bhulai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24357",
    "name": "Ali Sakir Sabid"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20568",
    "name": "Das Anil Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22015",
    "name": "Ramesh Tukaram Tupsundare"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1532",
    "name": "Khade Gajanan Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23650",
    "name": "Palekar Rajani Ambadas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2303",
    "name": "Kamte Maruti Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14452",
    "name": "Bhambid Pramila Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14989",
    "name": "Londhe Pradeep Adinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20563",
    "name": "Katlkar Priyanka Nandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21214",
    "name": "Salunkhe Anil Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21251",
    "name": "Thakur Kailash Dagadu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1349",
    "name": "Londhe Vaishali Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16122",
    "name": "Pendharkar Prakash Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16270",
    "name": "Shinde Vrushali Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19988",
    "name": "Kambale Narayan Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25293",
    "name": "Dayal Dhaval Kamal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21210",
    "name": "Bhosale  Pandurang  Appaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24772",
    "name": "Kharwad Chanchal Mohansingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17252",
    "name": "Gomane Hanmant Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24229",
    "name": "Kolarikkal John George"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2006",
    "name": "Sawale Bhagwan Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24227",
    "name": "Nalawade Sudesh Gajanan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25656",
    "name": "Shaikh Hisamuddin Abdul Kader"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15549",
    "name": "Bhoite Vijay Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15550",
    "name": "Gaikwad Sachin Bhiku"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15541",
    "name": "Nalawade Ganesh Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15523",
    "name": "Vairat Sarita Vipin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22417",
    "name": "Vyas  Rakesh Deepak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19957",
    "name": "Shelar  Krushnrao  Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2389",
    "name": "Khare Tulsidas Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4307",
    "name": "Tambitkar Kamala Ganpat"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1658",
    "name": "Potdar Santosh Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21215",
    "name": "Loke Mohan Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24936",
    "name": "Shinde Manohar Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17014",
    "name": "Pawar Dilip Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11693",
    "name": "Chavan Prakash Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23216",
    "name": "Nawadkar Sandee Bhanudas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25663",
    "name": "Sayyed Rehmatulla Sharifulla"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9212",
    "name": "Salunkhe Anandrao Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15393",
    "name": "Shinde Prashant Chandrakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2546",
    "name": "Giri Triloknath Shriraja"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20310",
    "name": "Sabale Balu Narayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2611",
    "name": "Kalantre Ananda Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25555",
    "name": "Nilekar Sachin Gopichand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "933",
    "name": "Birajdar Dnyaneshwar Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25045",
    "name": "Jagtap Sonam Tanaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19919",
    "name": "Inder Abdul Razak Karim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22744",
    "name": "Pansare Sanjay Bapu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22498",
    "name": "Shirke Yogesh Sudhir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17515",
    "name": "Nikam Rajesh Yeswantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13593",
    "name": "Thorat Vinayak Baliram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20685",
    "name": "Gelot Devram Dharmaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1118",
    "name": "Haria Paresh Zaverchand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12964",
    "name": "Chavan Partharaj Krishanraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9946",
    "name": "Doiphode Kondiba Santu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20563",
    "name": "Dalvi Sangita Babaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25657",
    "name": "Palav Ramesh Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25609",
    "name": "Khan Iqbal Karam Hussain"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19346",
    "name": "Shah Shamsher Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22962",
    "name": "Chavan Kashinath Basherao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16593",
    "name": "Khan Eharar Ahamad Razak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14808",
    "name": "Shinde Ganpat Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10174",
    "name": "Gaikar Sonu Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6224",
    "name": "Chavan Datta Dagadu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "754",
    "name": "Solanki Narayansing Vijaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15716",
    "name": "Surekha  Suryakant Pore"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12681",
    "name": "Dhamal Jalindhar Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22636",
    "name": "Jadhav Ashok Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21372",
    "name": "Jagtap Ravindra Mahipati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22302",
    "name": "Shaikh Mehmood Kadar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3209",
    "name": "Waghmare Sampat Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24956",
    "name": "Nevate Anil Shakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10919",
    "name": "Nalge Suresh Namdeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1852",
    "name": "Mhatre Manohar Panurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11492",
    "name": "Bade Ganpat Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24181",
    "name": "Gupta Omprakash Johanlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22257",
    "name": "Tiwari Suryakant Hanumanprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13086",
    "name": "Inamdar Shabbir Abdul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19465",
    "name": "Nimbalkar Malan Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22887",
    "name": "Sherigar Sadashiv S"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15342",
    "name": "Chavan Santosh Wamanrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "817",
    "name": "Vora Sneha Harish"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19538",
    "name": "Kharvad Vardikuvar Mohansingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20054",
    "name": "Sule Subhash Vasantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17812",
    "name": "Maniyar Kismatali Vajidali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18027",
    "name": "Bista Padam Singh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17024",
    "name": "Surve Sunita Jitendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16113",
    "name": "Chikane Vithal Keshav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22330",
    "name": "Jadhav Suchita Shantaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2077",
    "name": "Gurjar Mulchand Banwarilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13809",
    "name": "Jadhav Shankar Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10484",
    "name": "Dayalal  Liladevi"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3237",
    "name": "Patil Naresh Pundlik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19332",
    "name": "Nimbalkar Umesh Balaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17494",
    "name": "Nikam Shankar Balasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13149",
    "name": "Durgawali Vitthal Devaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13086",
    "name": "Jaiswar Diwarilal Ramnihar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22681",
    "name": "Dige Yogesh Yeshwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9280",
    "name": "Pawar Bhausaheb Krishnarao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21049",
    "name": "Bhobaskar  Suhasini   Harishchandr"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12254",
    "name": "Ghadge Gopichand Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8322",
    "name": "Jadhav Ramchandra Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7539",
    "name": "Jagtap Kundlik Ganpatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25362",
    "name": "Naringrekar Saloni Santosh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12095",
    "name": "Chinchakar Ajit Ashok"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20022",
    "name": "Singh Satish Vinay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22219",
    "name": "Potdar Manisha Suryakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22022",
    "name": "Dahigawkar Sheetal Parag"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23769",
    "name": "Agarwal Mahesh Matadin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16499",
    "name": "Chavan Shivaji Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14763",
    "name": "Chavan Chitra Dattatrya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10940",
    "name": "Yadav Shivkumar Lavle"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14705",
    "name": "Sawant Pramod Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18038",
    "name": "More Pradeep Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15419",
    "name": "Chavan Prashant Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2445",
    "name": "Sabale Bhanudas Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1894",
    "name": "Sangeeta Jewellers"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1672",
    "name": "Om Shankar Tea House"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "446",
    "name": "Bhima Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1740",
    "name": "Brid Electrical Services"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "174",
    "name": "Ramdev Textiles (Ashok Jayantilal Gudhka Huf)"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "434",
    "name": "Vighnesh Typing & Computer Center"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "108",
    "name": "Siddhivinayak Foam Centre"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2767",
    "name": "Sah Ramsagar Uttim"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10384",
    "name": "Shah Rameshkumar Achalmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21041",
    "name": "Gole Mandar Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21456",
    "name": "Yadav Krupashankar Ramlakhan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "578",
    "name": "Yewale Swapnil Dattatraya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22546",
    "name": "Rajput Ranjan Thakurdas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11008",
    "name": "Shirke Baban Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8963",
    "name": "Shitap Gunaji Dema"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15699",
    "name": "Patil Anandrao Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2402",
    "name": "Sabale Laxman Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22604",
    "name": "Barretto High School"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13679",
    "name": "Baikar Tukaram Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11293",
    "name": "Solaskar Maruti Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18796",
    "name": "Upadhaya  Umeshchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22050",
    "name": "Gupta Malatidevi Lallji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6725",
    "name": "Solaskar Balasaheb Hanamantarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1688",
    "name": "Salate Sanjurao Dnyndeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15008",
    "name": "Bhosale Pushpa Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19687",
    "name": "Bhandarye Chandrshekhar Sanjeeva"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23796",
    "name": "Vankhede Shantabai Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19520",
    "name": "Phale Maruti Sonu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19724",
    "name": "Kamble Ramesh Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20807",
    "name": "Jilani Gulam Abdual"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23994",
    "name": "Mohd Zaheer Ahmed Basheer Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24168",
    "name": "Deniz Douglas John"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24563",
    "name": "Pawar Madhukar Santaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24622",
    "name": "Prabhu Krishnaji Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24974",
    "name": "Momin Noor Mohd Mehmood"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25209",
    "name": "Salgaonkar Anil Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25242",
    "name": "Gupta Baburam Rampher"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10715",
    "name": "Shaikh Amin Vajir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11280",
    "name": "Khalate Pramila Bhanudas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14121",
    "name": "Sabale Sanjay Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6180",
    "name": "Chalake Krushnat Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10519",
    "name": "Chavan Ganesh Jaywantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19067",
    "name": "Gaikwad Ashok Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18568",
    "name": "Pawar Uttam Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16264",
    "name": "Kolate Maruti Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14641",
    "name": "Pachpute Vithal Baburao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18567",
    "name": "Karale Sandeep Sambhaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22",
    "name": "Chavan Arjunrao Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6948",
    "name": "Ghorpade Mohan Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1922",
    "name": "Dutta Praveenkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24230",
    "name": "Joseph Daniel Rafael"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17338",
    "name": "Dhumal  Santosh  Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5725",
    "name": "Chavan Suman Arjunrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18842",
    "name": "Shedge Prakash Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18637",
    "name": "Kadam Dhanaji Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21870",
    "name": "Mohammad Hussain Mohmad Kasim"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "799",
    "name": "Vhade Bandu Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25267",
    "name": "Shaikh Mohammad Rafique"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21829",
    "name": "Acharya Parmeshwar Shridhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22267",
    "name": "Birwatkar Sunil Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22749",
    "name": "Dukka Eliyas Mohdismali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16881",
    "name": "Jadhav Vasant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22470",
    "name": "Ramesh Jiwabhai Khuman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16880",
    "name": "Kolekar Sanjay Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25722",
    "name": "Damaniya Surendra Harikishandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25723",
    "name": "Choudhari Modh Irshad Mohd Faruque"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19826",
    "name": "Shaikh Nazimuddim Bahuddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19978",
    "name": "Qureshi Mohd Rafiq Usman Gani"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22076",
    "name": "Ansari Mohd Quasim J"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22145",
    "name": "Lade Gautam Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22286",
    "name": "Kanan Ganesh Ganga"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9944",
    "name": "Shewale Dajisaheb Shankararao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13610",
    "name": "Dutta Asha Pravinkumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11285",
    "name": "Pisal Mangal Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10689",
    "name": "Nalawade Ramchandra Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21683",
    "name": "Madhukar Bhikaji Lanjekar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24004",
    "name": "Pawar Baburao Ramchandra 8303"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20423",
    "name": "Liman Neeta Machchindranath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18809",
    "name": "Satam Ankita Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11927",
    "name": "Mandhare Ganpat Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24166",
    "name": "Bhagat Rahul Dhansingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18166",
    "name": "Mandhare Sachin Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9851",
    "name": "Shelake Vitthal Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12476",
    "name": "Chavan Balu Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21866",
    "name": "Manchekar Kishor Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18556",
    "name": "Chalke Uttam Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13584",
    "name": "Mohite Dinkar Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18160",
    "name": "Salunkhe Chimaji Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18891",
    "name": "Disale Sakharam Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12967",
    "name": "Phalke Ashok Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18886",
    "name": "Khan Rasid Usmandin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9423",
    "name": "Bhoite Hiralal Jagdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25720",
    "name": "Singh Rameshkumar Ramsabadh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1160",
    "name": "Singh Pradeep Rakesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25680",
    "name": "Khan Abdul Bashir Abdul Aziz"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13827",
    "name": "Chavan Shrirang Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21823",
    "name": "Maru Usha Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15007",
    "name": "Andrade Alba John"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17593",
    "name": "Ghone Manoj Balkrishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14014",
    "name": "Chavan Lata Shrirang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20531",
    "name": "Pednekar Pratiksha Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19768",
    "name": "Ganesh Dayabhai Solanki"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8180",
    "name": "Dhamal Babanrao Bhikoba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "587",
    "name": "Shetty Sadanand Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18161",
    "name": "Kadam Ankush Kushaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9457",
    "name": "Khalate Bhanudas Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21996",
    "name": "Sawant Priyaka Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22860",
    "name": "Mandve Raghunath Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25173",
    "name": "Pujari Channaiya Anjaiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19972",
    "name": "Avalekar Ghandhi Kallappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19804",
    "name": "Sevak Shankarlal Pannalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24423",
    "name": "Shah Naseer Ahmed Miran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10626",
    "name": "Salunkhe Rajaram Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6273",
    "name": "Pisal Prakash Parabatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10557",
    "name": "Rakshe Ganpat Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11226",
    "name": "Shitole Rajendra Ganpatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16714",
    "name": "Mandhare Ravindra Govind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9424",
    "name": "Pawar Vijay Narsingrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17300",
    "name": "Bhapkar Pramod Raosaheb  Tn 178-12"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22574",
    "name": "Patil Sonu Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "881",
    "name": "Salunkhe Uttam Bhausaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24248",
    "name": "Kale Babasaheb Namdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25708",
    "name": "Shaikh Naseem Noorulla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25727",
    "name": "Shaikh Saeeda Bi Abbas Ali"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2013",
    "name": "Mahadik Kedar Sharad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24243",
    "name": "Pawar Santosh Kashinath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24244",
    "name": "Parab Prakash Vishnu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22602",
    "name": "Chavan Hema Purshottam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25693",
    "name": "Parab Prabhakar Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25697",
    "name": "Tiwari Shankathaprasad Shankathaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25706",
    "name": "Pal Parasnath Pabbar"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1098",
    "name": "Dongre Subhash Narhari"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2012",
    "name": "Gaikar Vijay Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19147",
    "name": "Singh Swarnsingh Kartar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25664",
    "name": "Inamdar Yamanappa Bhimappa"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10418",
    "name": "Ahirekar Dilip Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15556",
    "name": "Shedage Tanaji Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25650",
    "name": "Hosalkar Mehesh Datta"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15555",
    "name": "Kadam Hiralal Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11203",
    "name": "Thobare Ramchandra Kodiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10180",
    "name": "Sabale Vijaya Sudhir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8656",
    "name": "Kadam Dada Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22210",
    "name": "Gulam Mohmad Jamal Abbari"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2198",
    "name": "Prajapathi Ramjiyavan Ramavadh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1871",
    "name": "Sakpal Ajinkya Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10599",
    "name": "Dhumal Vilas Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11565",
    "name": "Shaikh Karim Rasul"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19400",
    "name": "Sawant Ramesh Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23983",
    "name": "Shah Laxmi Dhiraj"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16473",
    "name": "Randive Sunil Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25721",
    "name": "Maurya Mahendra Ramsurat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24706",
    "name": "Londhe Sachin Pandhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12373",
    "name": "Khan Barktulla Ashraf"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24351",
    "name": "Pawar Smita Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21954",
    "name": "Supanekar Ananda Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22240",
    "name": "Shaikh Samsuddin Jamal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25217",
    "name": "Pawar Sanjana Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25694",
    "name": "Dhokre Ravindra Shripat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25696",
    "name": "Qureshi Sirtajali Shaukatali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25703",
    "name": "Dhoke Parshuram Janrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11565",
    "name": "Shedge Navnath Baba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19319",
    "name": "Chavan Kailas Dattatrey"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10046",
    "name": "Sabale Suhas Ramdas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1568",
    "name": "Desai Suchita Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7176",
    "name": "Masurkar Shrikant Maharudra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6190",
    "name": "Gaikwad Chandrakant Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22284",
    "name": "Parmar Bhikuram Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24647",
    "name": "Shaikh Ismal Nazeer"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13685",
    "name": "Mistri Abdul A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5166",
    "name": "Kenjale Hanmant Dagdu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10966",
    "name": "Thombare Hirabai Vittal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9651",
    "name": "Shinde Ratnaprabha Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9620",
    "name": "Gade Madhukar Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18394",
    "name": "Mayekar Sayali Ajay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10039",
    "name": "Jadhav Bajirao Baburao"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "869",
    "name": "Anuse Usha Jairam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20695",
    "name": "Vichare Rajendra Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7811",
    "name": "Kambale Satish Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9641",
    "name": "Shinde Shashikant Wamanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24633",
    "name": "Khan Noorjaha Begam M Zafar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10765",
    "name": "Inamdar Dastagiri Gani"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14450",
    "name": "Chavan Pramod Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10502",
    "name": "Shinde Bharat Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3200",
    "name": "Babar Vishwas Gopal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16474",
    "name": "Yadav Ramsabad Santu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5158",
    "name": "Kadam Bhimrao Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18707",
    "name": "Gawade Ramakant Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9614",
    "name": "Dhumal Mahesh Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10503",
    "name": "Shinde Prithviraj Uttam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25003",
    "name": "Shaikh Shakil Ahmed"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11350",
    "name": "Pawar Asha Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11415",
    "name": "Dhumal Mandakini Muralidhar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12358",
    "name": "Phalke Vilas Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20585",
    "name": "Chavan Gunjan Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25682",
    "name": "Gupta Motilal Jagannath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1893",
    "name": "Vargade Rekha Goving"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12642",
    "name": "Bhauri Hakim Imran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20050",
    "name": "Nagpure Sanjay Mitthu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12641",
    "name": "Bhosale Dattatray Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15937",
    "name": "Shirke Ajit Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24111",
    "name": "Rajkumar Panaru Gupta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24066",
    "name": "Patil Vishnu Gopal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "572",
    "name": "Wagh Shivaji Mahipati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23997",
    "name": "Pawar Nanda Pandurang"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1170",
    "name": "Tundare Vasudev Venkat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14257",
    "name": "Jaiswal Shankar Hiralal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10878",
    "name": "Bhosale Pravin Shankar 553/52"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12031",
    "name": "Patil Vandana Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3093",
    "name": "Patil Balwantrao Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12982",
    "name": "Patade Pandurang Manaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12323",
    "name": "Nalawade Shivaji D      468/11"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15509",
    "name": "Pisal Dipali Navnath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8943",
    "name": "Sable Jaywant Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5200",
    "name": "Sawant Dattatray Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6946",
    "name": "Yadav Ashok Mahadeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3049",
    "name": "Magar Dashrath Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17221",
    "name": "Chuodhary  Santoshkumar  Rambharose"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20423",
    "name": "Sarafdar Sumal Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10240",
    "name": "Mandhare Mohan Krushna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15992",
    "name": "Kale Hirabai Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20021",
    "name": "Desai Arun Anat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21512",
    "name": "Jaiswar Amritlal Baluram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7319",
    "name": "Kadam Ankush Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12403",
    "name": "More Bhagwan Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9059",
    "name": "Khan Vajir Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23362",
    "name": "Varekar Deepak Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13195",
    "name": "Chavan Jaydeep Nandkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24448",
    "name": "Shingote Ramdas Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24250",
    "name": "Lakhani Vikram Laxmidas"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2014",
    "name": "Kene Vidhya Padman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25683",
    "name": "Kadam Nathuram Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15569",
    "name": "Shaikh Salima Aslam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23326",
    "name": "Sethi Jaspal Singh Charansingh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14349",
    "name": "Kapse Manisha Rajendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12769",
    "name": "Pisal Tulshidas Sampat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20598",
    "name": "Mohite Ajay Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23589",
    "name": "Kabade Vijaya Bapurao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3265",
    "name": "Ghorpade Mamta Anil"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "979",
    "name": "Pawar Vikas Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2848",
    "name": "Pisal Himmat Hanumant"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1563",
    "name": "Dhore Bharat Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21680",
    "name": "Dani Kalpana Ashok"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1619",
    "name": "Sakpal Madhukar Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23220",
    "name": "Malage Nagina Irappa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24913",
    "name": "Mirani Vijay Manilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12544",
    "name": "John Francis Angelo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18481",
    "name": "Choudhari Abdul Rahim"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13768",
    "name": "Parab Jaywant Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21857",
    "name": "Mandhare Prashant Suryakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19128",
    "name": "Soni Deepsing Ramsing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23167",
    "name": "Suthar Khemaram Hiraji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19136",
    "name": "Gole Kalyan Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12601",
    "name": "Shinde Yashwant Babasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21771",
    "name": "Nikam Balaso Gulabrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15443",
    "name": "Sawant Sarjerao Shankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2979",
    "name": "Mourya Abhishek Dayaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19467",
    "name": "Pathak Manoj Ramsingar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23454",
    "name": "Kadam Gouri Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12530",
    "name": "Sarafdar Pandurang Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1972",
    "name": "Salunkhe Rangrao Jaisingrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14540",
    "name": "Shinde Kalpana Dashrath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20106",
    "name": "Gupta Ravishankar Baburam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15336",
    "name": "Chorat Koushalya Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15508",
    "name": "Pendhari Nagesh Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9927",
    "name": "Ansari Saeed Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19269",
    "name": "Darekar Hanumant Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11647",
    "name": "Goriwale Sanjay Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14919",
    "name": "Gawade Mangesh Balkrishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2024",
    "name": "Patil Sunil Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14077",
    "name": "Taniwade Atmaram Shitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23575",
    "name": "Rawal Nainlal Manji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15474",
    "name": "Parab Digmber Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21235",
    "name": "Chaudhari Voraram Ladaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20414",
    "name": "Kausar  Mahealam Ansari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20400",
    "name": "Khedekar Varsha Pandurang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10836",
    "name": "Vichare Chandrashekhar Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16068",
    "name": "Ethape Udaykumar Bhagwat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9138",
    "name": "Jagtap Dattatray Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15739",
    "name": "Khan Mohd Mustkim Jan Mohammed Jama"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "963",
    "name": "A R Sareewala"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1072",
    "name": "New Swastik Cloth Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2141",
    "name": "Mohit Computer Institute"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2376",
    "name": "Vedas India"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2385",
    "name": "Laxmi Enterprises"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "18",
    "name": "Kailash Super Market"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "200",
    "name": "Meghvarsha Construction"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "201",
    "name": "Maruti Woodland Makers Pvt Ltd"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "202",
    "name": "Maruti Trading Corporation"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "347",
    "name": "Tejas Transport Service"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1981",
    "name": "Pawar Mahadeo Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2330",
    "name": "Chavan Dhondiram Ramrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6954",
    "name": "Ranka Lata Jeewatraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24516",
    "name": "Bohra Dansingh Lalitsingh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14618",
    "name": "Marathe Baburao Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13790",
    "name": "Kaskar Sunil Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17128",
    "name": "Mane Arjun Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15219",
    "name": "Jagtap Macchindra Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8066",
    "name": "Lembhe Shankar Jishigrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21364",
    "name": "Gawade Arpita Anil"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9712",
    "name": "Mulik Balu Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14752",
    "name": "Totre Anil Nandaram   13/A/22"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16886",
    "name": "Jain Sweta Bhabutmal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19429",
    "name": "Chavan Jaysica Janu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15511",
    "name": "Jagtap Shashikant Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10258",
    "name": "Sibe Tukaram Hariba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17863",
    "name": "Kambale Siddharth Babalya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16399",
    "name": "Gaikwad Vikas Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1642",
    "name": "Shirke Suresh Kashinath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "241",
    "name": "Gowari Sangita Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8325",
    "name": "Sabale Maruti Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9615",
    "name": "Dhumal Mangesh Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10382",
    "name": "Shah Sagarmal A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13157",
    "name": "Choudhari Udayraj Ghori"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17492",
    "name": "Mirani Jagadish Navinchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6963",
    "name": "Ranka  Dipika"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10923",
    "name": "Jadhav Chandrakant Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1336",
    "name": "Mishra Chandraprakash C"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16652",
    "name": "Kagane Sunil Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24395",
    "name": "Patil Pramila Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25344",
    "name": "Gawand Sanjay Shridhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9418",
    "name": "Chavan Ajitsing Suryasing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24106",
    "name": "Pawar Arvind Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21779",
    "name": "Kamble Devendra Vasant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21470",
    "name": "Rane Ankita Shamsundar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22231",
    "name": "Panday Sunilkumar Ramlakhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16931",
    "name": "Nalawade Santosh Parbati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23351",
    "name": "Salunkhe Sagar Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23802",
    "name": "Sawant Sandeep Vyankat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11136",
    "name": "Gurav Sunil Janardan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22160",
    "name": "Kadam Udhav Narayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22528",
    "name": "Jadhav Amol Ravindra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "818",
    "name": "Yadav Sampat Bhikoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20382",
    "name": "Dahisaria Vijaykumar Jadavji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12538",
    "name": "Dhumal Deepak Dattatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23093",
    "name": "Lingana Raghu Kumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1253",
    "name": "Shinde Shankar Maruti 614/4"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25733",
    "name": "Sharma Dinesh Ramaprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12293",
    "name": "Lole Ananda Abaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25736",
    "name": "Somani Sadruddin Ravjee"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24268",
    "name": "P Subramaniam Ponnusamy"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24269",
    "name": "Baviskar Rajesh Vithal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24270",
    "name": "Baviskar Surekha Rajesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24261",
    "name": "Kadam Nathuram Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24262",
    "name": "Rimal Jailal Nandalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25742",
    "name": "Chavhan Ramdas Ganapat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25753",
    "name": "Mishra Chanramani Balgovind"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24252",
    "name": "D`Souza Leslie Leo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15581",
    "name": "Shinde Vijaysing Anandrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3271",
    "name": "Chaurasiya Navinkumar Sumantmandal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2971",
    "name": "Gawade Vikas Nivruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12893",
    "name": "Lambor Sakharam Sidu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7061",
    "name": "Pawar Maruti Bhau"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13870",
    "name": "Gole Hanmant Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20546",
    "name": "Bhosale Vilas Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15773",
    "name": "Pawar Suchitra Sunil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24207",
    "name": "Surve Ravikant Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15177",
    "name": "Shinde Pavan Dhanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25754",
    "name": "Singh Ramnarayan Ramdaur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21036",
    "name": "Mujawar Tabasum Ramjan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15574",
    "name": "Tarade Dnyaneswar Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12800",
    "name": "Mandakini H Babar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9049",
    "name": "Chavan Rajaram Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21352",
    "name": "Erondole Shankar Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15966",
    "name": "Bist Purnbahadur Ballabahadur"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12337",
    "name": "Jadhav Kiran Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5066",
    "name": "Boinwad Shilpa Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14409",
    "name": "Bhasal Janardan Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8582",
    "name": "Patil Supriya Sushil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "3589",
    "name": "Bhoite Mahadeo Eknath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10817",
    "name": "Salunkhe Hanumant Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17831",
    "name": "Kewat Shamdev Ramsubag"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24253",
    "name": "Misquitta Archie Galen Valentine"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9207",
    "name": "Gawade Baburao Devaji 153/1"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1032",
    "name": "Bhosale Rohini Krantikumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14350",
    "name": "Nalawade Arun Mansingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "701",
    "name": "Pawar Tukaram Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15308",
    "name": "Sonawane Laxmi Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11477",
    "name": "Argekar Ajit Balkrishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2763",
    "name": "Naag Manik Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12272",
    "name": "Nikam Shankar Eknath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13684",
    "name": "Ghadigaonkar Rajashree Ramdas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23343",
    "name": "Pande Shivam Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8087",
    "name": "Pawar Ananda Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23754",
    "name": "Bandekar Deepak Babaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1380",
    "name": "Rajbhar Satiram Savaru"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9362",
    "name": "Jawale Ramesh Balwantrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23200",
    "name": "Vaghari Sangita Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17650",
    "name": "Chavan Pranita Pravin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1743",
    "name": "Shinde Jalindar P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24090",
    "name": "Banerjee Anamika Subrata"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23339",
    "name": "Chadha Baljeet Singh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1349",
    "name": "Varathe Sakharibai Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8745",
    "name": "Jain Vaishali Arvind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3821",
    "name": "Sabale Ananda Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11351",
    "name": "Khape Vijay Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18963",
    "name": "Bhandare Gangadhar Dattatray"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14865",
    "name": "Deshmane Vandana Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21790",
    "name": "Giri Billu Prabhunath"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2008",
    "name": "Bhosale Shankar Madhav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "2836",
    "name": "Jadhav Ashok Shrirang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17060",
    "name": "Sankpal Bharti Ashok"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1220",
    "name": "Prajapat Mohanram Chunaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25731",
    "name": "Tank Kanchanben Pravinbhai"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9058",
    "name": "Khichade Ramesh Baburao  Tn-417-11"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "648",
    "name": "Bajage Prabhudas Shripat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2436",
    "name": "Shaikh Mohd Shafiq Mohd Rafiq"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14867",
    "name": "Vichare Ruchi Rohan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3257",
    "name": "Sharma Manoj Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16772",
    "name": "Bhalekar Sapna Vijay"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2095",
    "name": "Chouhan Kuldip Sukhraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19910",
    "name": "Thakar Haresh Mahesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24205",
    "name": "Achrekar Suraj Chintaman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6517",
    "name": "Kirve Vijaya Hemant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13610",
    "name": "Awade Anita Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13058",
    "name": "Humane Dattaram Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23723",
    "name": "Ruke Suresh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20363",
    "name": "Gaikwad Swapnil Subhash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11401",
    "name": "Yadav Gamaprasad Rambahal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5787",
    "name": "Mokal Yogesh Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12613",
    "name": "Lade Arun Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20718",
    "name": "Keni Haresh Sadanand"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22515",
    "name": "Chafekar Anjali Vilas"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "990",
    "name": "Bhosale Tanubai Ananda"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3295",
    "name": "Shaikh Nuraslam Asulla"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24256",
    "name": "Miss  Chopra Sanjana Jawaharlal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2628",
    "name": "Sahu Dasarathi Kaviraj"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "580",
    "name": "Koli Sunil Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7056",
    "name": "Shinde Sampat Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12928",
    "name": "Phalke Rajendra Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19370",
    "name": "Pramod Babulal Lath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17639",
    "name": "Matekar Adhik Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17954",
    "name": "Kamble Sujit Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15335",
    "name": "Chorat Vithal Krishnadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13072",
    "name": "Pawar Sushila Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23151",
    "name": "Kashid Vaishali Pankaj"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1539",
    "name": "Damami Shiva Sitaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1488",
    "name": "Patel Vaibhav Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17488",
    "name": "Dalvi Sameer Prakash"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1933",
    "name": "Mehta Rakesh Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10817",
    "name": "Bandal Arjun Nivrutti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1474",
    "name": "Khutvad Alka Kailash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2021",
    "name": "Hule Atmaram Shripati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9210",
    "name": "Dalvi Rajendra Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15648",
    "name": "Vegurlekar  Dakshata Harishchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2020",
    "name": "Shidruk Natha Nilu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22546",
    "name": "Pawar Somnath Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24254",
    "name": "Chopra Jawaharlal Shivrajnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23231",
    "name": "Pujari Bhaskar Sadhu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15138",
    "name": "Kshirsagar Chnadrabhaga Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22986",
    "name": "Ghorpade Sujeet Kisan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "635",
    "name": "Bhise Ganesh Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13550",
    "name": "Sakunde Ramchandra Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14190",
    "name": "Gala Hetri Hiten"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2097",
    "name": "Choudhary Bhavarlal Ramkaran"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1466",
    "name": "Wagh Anna Narayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "730",
    "name": "Yadav Amarnath Shyamnarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24255",
    "name": "Chopra Bindiya Jawaharlal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14026",
    "name": "Kulkarni Deepak Shripad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9365",
    "name": "Bodhe Ganapat Shyamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16510",
    "name": "Ahamed  Nisar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18242",
    "name": "Gunjotikar Sachin S"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14180",
    "name": "Gala Mousam Suresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10256",
    "name": "Jagdale Kisan Dhondiram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "222",
    "name": "Mhatre Akash Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14179",
    "name": "Gala Kewal Suresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14186",
    "name": "Gala Bhavya Bipin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14162",
    "name": "Kshirsagar Sandeep Nanaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23520",
    "name": "Mahangade Gopal Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15531",
    "name": "Sheikh Kismat Alli Mazarali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15780",
    "name": "Bhatkar Prathamesh Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15077",
    "name": "Bhandari Hanuman Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15497",
    "name": "Bohra Rameshkumar L"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2062",
    "name": "Monde Pandurang Dhondiba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23915",
    "name": "Gadankush Prakash Mohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8520",
    "name": "Chavan Mohan Tukaram Tn-812-2"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1170",
    "name": "Abhishek Trading Co"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4385",
    "name": "Messers Home Builders"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4439",
    "name": "A  K  Enterprises"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4685",
    "name": "Reliable Marketing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1392",
    "name": "Mumbadevi Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2490",
    "name": "Priya Traders"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2720",
    "name": "V K Telecom"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "987",
    "name": "Am Tech Electrical Works"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1928",
    "name": "Akshay Immitation  Jewallery"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2264",
    "name": "Blue Ocean Swimming Club"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2286",
    "name": "Kuldeep Singh Transport"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2364",
    "name": "Global Inx"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "135",
    "name": "Efficient Data Processing Services"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "67",
    "name": "Bajrang Transport"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "446",
    "name": "Babutextiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "519",
    "name": "Alisha Construction"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "23",
    "name": "Jai Durga Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "24",
    "name": "Laxman Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "26",
    "name": "Ganesh Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "28",
    "name": "Baliram Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "29",
    "name": "Shri Ram Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "32",
    "name": "Savita Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "33",
    "name": "Indranil Labour Solutions"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "35",
    "name": "Mahesh Manpower Services"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "39",
    "name": "Nilkanth Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "41",
    "name": "Ramnath Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15239",
    "name": "Khopade Chandrakant Mugutrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14268",
    "name": "Walawalkar Ankukh Janardhan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22730",
    "name": "Salunkhe Sunil Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15525",
    "name": "Daodmanee Namdeo Dundappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20965",
    "name": "Zagade Jayaram Sonu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15559",
    "name": "Rathi Balmukund G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23524",
    "name": "Shanbhag Ramesh Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15588",
    "name": "Bole Amol Mukund"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23603",
    "name": "Kolambe Mangesh Sudam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24298",
    "name": "Dhangar Eleinga Shivraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24771",
    "name": "Chartuvedi Ashokakumar Lalataprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25170",
    "name": "Nadar Sheebarani Stephen"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16841",
    "name": "Jain Uttamchand Shesmalji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11519",
    "name": "Davda Vijay Kantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19226",
    "name": "Poojari Abhay Pratap"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14530",
    "name": "Mulik Ganesh Nandkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13258",
    "name": "Jain Rinku Uttamchand"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17517",
    "name": "Parab Samiksha Suhas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20629",
    "name": "Shelatkar Kavita Wishwambhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13238",
    "name": "Jain Manishkumar Uttamchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13239",
    "name": "Jain Dipeshkumar Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21070",
    "name": "Adelkar Parvati Babrauvan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14296",
    "name": "Manuskare Ramchandra T 1422/14"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22570",
    "name": "Chavan Manali Sahdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17166",
    "name": "Pawar Dilip Sahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18480",
    "name": "Shinde Hemlata Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14166",
    "name": "Jadhav Reshma Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12430",
    "name": "Jain Vastimal D"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21850",
    "name": "Patil Shivaji Sakharam"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2027",
    "name": "Nadar Ramnathan Arjunan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2028",
    "name": "Shirke Ravindra Rambhau"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24275",
    "name": "Shetty Mohan Babu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24276",
    "name": "Shetty Jagdish Padmanabh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24277",
    "name": "Naughane Suday Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24278",
    "name": "Kurne Santosh Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24279",
    "name": "Naughane Mohan Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24280",
    "name": "Navghane Vijayalaxmi Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24281",
    "name": "Upade Satyawan Vishwanath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25779",
    "name": "Sayyed Sharafat Mubarak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25785",
    "name": "Jadhav Sukesini Bhaguram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25786",
    "name": "Kuril Sunderlal Babulal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25790",
    "name": "Shah Mohmmed Yakub Ahmed"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24272",
    "name": "Padave Ashish Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25768",
    "name": "Devalia Deepak Mansukhbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25774",
    "name": "Varma Chhotelal Bacchu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25776",
    "name": "Dubey Vidhyadhar Chotelal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24263",
    "name": "Patharkar Manisha Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24264",
    "name": "Patharkar Vidhi Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15591",
    "name": "Babar Kishor Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15592",
    "name": "Rasal Sindhu Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15594",
    "name": "Dhumal Sudam Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15557",
    "name": "Kadam Raghunath Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20603",
    "name": "Khedekar Pravin Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12602",
    "name": "Dattatray Baburao Mane"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22540",
    "name": "Jadhav Nandkishor Shankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3023",
    "name": "Karande Chakrapani Sitarm"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25086",
    "name": "Bhojane Mahendra Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25406",
    "name": "Chavan Manoj Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13539",
    "name": "Sabale Vishwas Jijaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25777",
    "name": "Pal Udaybhan Ramdawar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19150",
    "name": "Mandave Hanmant Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17157",
    "name": "Kadam Sunil Sambhaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9453",
    "name": "More Vithal Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15554",
    "name": "Kadam Jitendra Dhanasing"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22591",
    "name": "Nirmal Uttam Dadaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15593",
    "name": "Kate Arati Balkrishna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6958",
    "name": "Sabale Dilip Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15132",
    "name": "Salunkhe Vijay Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14315",
    "name": "Jaiswal Girijesh Mithaiwala"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25614",
    "name": "Bohara Ganesh Rambahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22589",
    "name": "Mohd Ayaz  Shaikh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10204",
    "name": "Bhosale Sunil Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10208",
    "name": "Shinde Mangal Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16016",
    "name": "Pednekar Manshi Nandkumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2233",
    "name": "Sherkar Arjun Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "263",
    "name": "Shinde Vilas Baburao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3131",
    "name": "Jadhav Hanmant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15393",
    "name": "Patil Pandurang Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22857",
    "name": "Sachadev Tarala Jayantilal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "490",
    "name": "Taware Suresh Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21514",
    "name": "Mohammed Jumman Mohammed Hanif"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19209",
    "name": "Salunkhe Jayant Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15572",
    "name": "Nikam Shantaram Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25788",
    "name": "Laxmi Hardik Shah"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1105",
    "name": "Siddique Shaeen Khalik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12101",
    "name": "Jain Uttamchand S"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1403",
    "name": "Tripathi Avnish Lalmani"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1667",
    "name": "Mohite Rajiv Manohar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1598",
    "name": "Chorge Bhagwan Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11476",
    "name": "Lokhande Jayshri Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22380",
    "name": "Khan Gulzar Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23059",
    "name": "Garai Harjinder Singh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23470",
    "name": "Maingade Vilas Shripati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10922",
    "name": "Thick Maruti Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10363",
    "name": "Peje Dnyandev Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13271",
    "name": "Kadam Shaila Dattatray"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1136",
    "name": "Taware Jyotsna Sandeep"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14991",
    "name": "Kharat Sanjay Bhiku"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "228",
    "name": "Gaikwad Ganesh Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13150",
    "name": "Parikh Dhanesh Bipin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1502",
    "name": "Kumbhar Sachin Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25218",
    "name": "Tamsare Tulsabai Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12644",
    "name": "Bhalerao Nakul G"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22061",
    "name": "Bhosale Mohan Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12411",
    "name": "Wagh Jaywant Hanmant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3280",
    "name": "Patil Narmada Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8271",
    "name": "Bhoite Rajendra Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24121",
    "name": "Bhosale Rajendra Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12722",
    "name": "Saroji  Shyamsunder"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2313",
    "name": "Ahiwale Sikandar Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9661",
    "name": "Bhoite Shahaji Babanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12994",
    "name": "Sayeed Ahmed Tanreez"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18785",
    "name": "Bhuwad Narayan Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21901",
    "name": "Dhameja Disha Girish"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1431",
    "name": "Salunke Lalit Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19319",
    "name": "Jadhav Tukaram Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17235",
    "name": "Surve  Ravindra  Parsuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19814",
    "name": "Jaiswar Rakeshkumar Nankuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23940",
    "name": "Bhalekar Sanjay Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21591",
    "name": "Shinde Shankar Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22064",
    "name": "Singh Dinesh Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23114",
    "name": "Bhosale Sulbha Kishor"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15085",
    "name": "Hegishte Varsha Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25584",
    "name": "Dhanavade Gopinath Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25426",
    "name": "Ravnang Priyanka Ravindra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22869",
    "name": "Jain  Meena Anil"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11168",
    "name": "Manjrekar Suresh Tanu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3296",
    "name": "Gangal Nikita Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10977",
    "name": "Yadav Nitram Rufani"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3305",
    "name": "Majumdar Sanjay Sanyasi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8650",
    "name": "Kale Vijay/Madhukar Sadatule/Prakash Ran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22431",
    "name": "Modak Gajanan Kisan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1675",
    "name": "Bapat Dattatraya Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15058",
    "name": "Sable Satish Haribhau"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19568",
    "name": "Parab Meena Manohar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14173",
    "name": "Dige Hanmant Bhau"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3251",
    "name": "Patil Alka Kisan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "952",
    "name": "Maru Monil Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5413",
    "name": "Jaiswal Ramprasad Ramdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7428",
    "name": "Gavkhadkar Vithal Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2565",
    "name": "Mhatre Nanda Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23209",
    "name": "Sule Dhanaji Changdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14000",
    "name": "Vishwarupe Aditya Prakash"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13837",
    "name": "Jain Sangitakumari Manojkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10894",
    "name": "Bhansali Gautam Mohanlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11664",
    "name": "Sakunde Narmadabai Nivrutti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25177",
    "name": "Bhoite Pradip Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "67",
    "name": "Jayvijay General Stores"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1984",
    "name": "Aj`S House Keeping & Manpower Consultant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "97",
    "name": "Kunjal Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "7",
    "name": "Nikhil Transport & Clearing Agency"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "523",
    "name": "Devnarayan Packing"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "991",
    "name": "New Rajsthan General Stores"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13683",
    "name": "Bhosale Jigna Anil"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2458",
    "name": "Vanare Tanaji Dnyandev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15561",
    "name": "Sayyad Rafikahamad Khairuddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11573",
    "name": "Chikane Baliram Narayan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6448",
    "name": "Yadav Seetala Prasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22067",
    "name": "Khatun Salia Shaikh Ismil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14067",
    "name": "Naringrekar Harishchandra Vishwambhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12923",
    "name": "Pathan Ibrahim Indu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "312",
    "name": "Jadhav Ramchandra Shivaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2309",
    "name": "Gupta Rajesh Munilal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15394",
    "name": "Nalawade Kuldeep Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24240",
    "name": "Singh Gopal Bahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24244",
    "name": "Singh Shobhnsth Vijaybahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24483",
    "name": "Rajivale Anand Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24744",
    "name": "Shinde Shirish Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11359",
    "name": "Mane Dadasaheb Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13228",
    "name": "Ghorpade Sanjay Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20617",
    "name": "Badola Bhawana Hemant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21448",
    "name": "Ghadigaonkar Neelima Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18461",
    "name": "Raskar Rahul Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6783",
    "name": "Chawan Rajesh Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22718",
    "name": "Waghmare Motiram Bhojaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21749",
    "name": "Chavan Swapnali Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22612",
    "name": "Shelar Sandip Shivaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14297",
    "name": "Takale Anant Bhikaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23399",
    "name": "Salave Tarabai K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23400",
    "name": "Salave Sushama Kacharu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23401",
    "name": "Salave Bharati Kacharu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1354",
    "name": "Chaudhary  Janwa Mohanlal Bhutaramji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12135",
    "name": "Mane Sanjay Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9343",
    "name": "Chavan Sharad Bhikoba692/35"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12434",
    "name": "Bhosale Suryakant Shamrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16812",
    "name": "Dias  Gagarina"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22189",
    "name": "Lad Nayana Khandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21783",
    "name": "Kate Mithila Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22186",
    "name": "Gurav Chandrakant Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1791",
    "name": "Ranvare Eknath Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21552",
    "name": "Sutar Hemangi Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20387",
    "name": "Kadam Pravin Kisan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16056",
    "name": "Kadam Tatoram Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9737",
    "name": "Rana Kirankumar B"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20319",
    "name": "Mishra Sanjaykumar Devdatt"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16044",
    "name": "Nawadkar Balwant Dashrath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3367",
    "name": "Khan Shakir Bashir"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25822",
    "name": "Sawant Dilip Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25824",
    "name": "Makwana Kishor Pragji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25825",
    "name": "Verma Rampal Sarja"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1104",
    "name": "Bhandari Anant Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20610",
    "name": "More Kishor Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24288",
    "name": "Sherekar Dattatray Dinkar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24289",
    "name": "Nalawade Dattatray Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25796",
    "name": "Mansoori Mohd Jahangir Abdul Majid"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15605",
    "name": "Chikane Swati Vikram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18603",
    "name": "Kolekar Laxman Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25018",
    "name": "Irfan Mohammedd Yameen Shaikh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24067",
    "name": "Devale Bhavana Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15299",
    "name": "Jagtap Ganesh Anna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11503",
    "name": "Salunkhe Avinash Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12350",
    "name": "Lohar Mohanish Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25819",
    "name": "Qureshi Mohammed Rafiq Mohammad Haroon"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "4372",
    "name": "Jain Jayantilal Pratapchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19244",
    "name": "Desai Aniket Jayraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24061",
    "name": "Tambe Shrikant Dashrath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10924",
    "name": "Kumbhar Gorakh Akoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22719",
    "name": "Waghmare Vishranti Dattaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17106",
    "name": "Pawar Rajendra Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24029",
    "name": "Gupta Sushila Shyamsunder"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19281",
    "name": "Bane Rajendra Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15021",
    "name": "Pol Ajit Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18257",
    "name": "Kadam Nagesh Ramesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20235",
    "name": "Khamkar Trupti Dinanath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21601",
    "name": "Panchal Sneha Dinesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14357",
    "name": "Darekar Shivaji Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23981",
    "name": "Pawar Ajit Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24899",
    "name": "Gandhere Satyavan Keshav"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22353",
    "name": "Dalvi Manohar Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19541",
    "name": "Khade Santosh Bhikaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13041",
    "name": "Dethe Vrushali Nandkumar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "472",
    "name": "Kadam Shankar Chandru   A"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12998",
    "name": "Shinde Kalpana Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1915",
    "name": "Pednekar Suraykant Anant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22615",
    "name": "Mene Vinod Sonu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15548",
    "name": "Mandhare Ravindra Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13229",
    "name": "Dikshit Ravi Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13230",
    "name": "Vedpathak Dhananjay Ambadas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13231",
    "name": "Nandale Satish Sudam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13239",
    "name": "Dikshit Kiran Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12550",
    "name": "Phalke Sanjay Yashawant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12944",
    "name": "Gaikwad Bharat Shrirang 1043-B-14"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17842",
    "name": "Nawadkar Anilkumar Sampatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9327",
    "name": "Vedpathak Dipti Vishwanath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23006",
    "name": "Sarpota Gaurishankar Hira"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17202",
    "name": "Bhilare Anil Buva"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8629",
    "name": "Pawar Purushottam Popatrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11986",
    "name": "Shinde Shivaji Eknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20331",
    "name": "Zore Jayram Navlu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14697",
    "name": "Bhisale Sulochana Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14326",
    "name": "Sarafdar Bhau Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19769",
    "name": "Jaiswal Gautamprasad Ramprasad"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "480",
    "name": "Bhosale Atmaram Trimbak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17063",
    "name": "Baudhayjan Panchyat Samitee Br No 550"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19642",
    "name": "Kolekar Sanjay Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2082",
    "name": "Mishra Ajitkumar Abdhesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18509",
    "name": "Shinde Shankar Balu"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1157",
    "name": "Yadav Durgaprasad Jayram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3898",
    "name": "Dange Suresh Narayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3368",
    "name": "Bagwan Mohamad Aslam"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3370",
    "name": "Yaladi Kavita Venkatswami"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25827",
    "name": "Shetty Ganesh Bhoja"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2030",
    "name": "Pisal Sarjerao Jotiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25794",
    "name": "Devasi Bhikharam Ajabaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25801",
    "name": "Pittid Pushpa G"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3330",
    "name": "Londhe Yashoda Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19107",
    "name": "Shinde Dadaso Dinkar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2917",
    "name": "Lotkar Haridas Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11406",
    "name": "Gohil Harishchandra Bhagwan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2279",
    "name": "Bhoite Vilas Ganpatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24055",
    "name": "Qureshi Azmat Yaseen"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "327",
    "name": "Prasad Ashok Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25670",
    "name": "Patil Kurshna Arun"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1113",
    "name": "Patil Dilip Keshav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20198",
    "name": "Kambale Sushant Abhimanyu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24931",
    "name": "Sunar Janak Deb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23682",
    "name": "Keni Jyotsna Bharat"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1800",
    "name": "Bhosale Vishwas Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18455",
    "name": "Gadhave Masku Shyamrav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20066",
    "name": "Sawant Mukesh Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22096",
    "name": "Parab Rohidas Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24860",
    "name": "Raje Ramdas Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17069",
    "name": "Shinde Rajendra Dadasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19536",
    "name": "Kate Anil Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3251",
    "name": "Kadam Dhindiba Hari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8832",
    "name": "Pawar Jyoti Prabhakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25589",
    "name": "Khochede Deepak Anant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2948",
    "name": "Nikalje Nana Uddhav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20211",
    "name": "Edanvankar Ratandeep Ramkrushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18227",
    "name": "Mate Sanjay Vishnu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2512",
    "name": "Shetty Bharat Nagu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23683",
    "name": "Yadav Sarveshkumar Gangaprasad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12734",
    "name": "Tarade Dnyaneshwar Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20320",
    "name": "Gupta Santram Thakurbhuj"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2759",
    "name": "Savala Shantilal Nemchand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16329",
    "name": "Todkar Ajit Devappa"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2074",
    "name": "Pandavale Kantabai Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20174",
    "name": "Mahamulkar Laxman Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20604",
    "name": "Parekh Hansraj Pukhraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21730",
    "name": "Pareek Dinesh Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8969",
    "name": "Chalke Suresh Vithal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10755",
    "name": "Pednekar Suchita Shivram/"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5378",
    "name": "Pawar Mahadeo Martand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24188",
    "name": "Pawar Reshma Uttam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20603",
    "name": "Mehtha Dinesh Mithalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20789",
    "name": "Kalmaste Sushma Parshuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14098",
    "name": "Jagtap Dattatray Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2893",
    "name": "Morye Suresh Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20613",
    "name": "Parmar Paresh Jagajivan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22364",
    "name": "Gupta Vedmani Ramkishan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12780",
    "name": "Nikam Shantaram Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20322",
    "name": "Salunkhe Dhanshri Janardan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14593",
    "name": "Yadav Rajashree Dattatray"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22627",
    "name": "Ghosalkar Sarita Gajanan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10356",
    "name": "Phalke Sanjay Ankush"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22613",
    "name": "Jadhav Vaibhav Dattatrya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18286",
    "name": "Khopade Balu Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4494",
    "name": "Nalawade Bhiku Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25254",
    "name": "Awte Prasad Uday"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7890",
    "name": "Wagh Achut Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20178",
    "name": "Rathor Dinesh Tejpal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17971",
    "name": "Kadam Rakesh Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7857",
    "name": "Surve Hanmant Balaku"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12571",
    "name": "Virulkar Dilip Narhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7832",
    "name": "Vashist Sudhir Kumar Chandrashekhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20383",
    "name": "Upadhyay Shaktikumar Harishchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "72",
    "name": "Gujrat Milk Centre"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "90",
    "name": "Om Sai Enterprises"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2777",
    "name": "Eleven Impex"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4544",
    "name": "Kamats Holiday Resorts [Silvassa  Pvt Ltd"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4657",
    "name": "Amit Stationery & Xerox"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "120",
    "name": "Manish Parbat Patel Huf"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "139",
    "name": "Roshan Plumbing Works"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "269",
    "name": "Yugaant Deshi Bar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "270",
    "name": "Punit Textiles"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "319",
    "name": "Bhudev Tradesrs"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "412",
    "name": "Neeta Logistics"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "555",
    "name": "Surya Group"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11305",
    "name": "More Chandrbhaga Ramesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1856",
    "name": "Pathan Jabbar Musakhan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13324",
    "name": "Parmar Bhawarlal Motaramji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14201",
    "name": "Chouhan Ramadalan Bhagwandin"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15464",
    "name": "Gaikwad Prasad Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19683",
    "name": "Padave Sitaram Ratnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13623",
    "name": "Sonkar Motilal Sahati"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16366",
    "name": "Parab Darshan Rajaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1633",
    "name": "Jadhav Ashit Arvind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20368",
    "name": "Nage Siddharth Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18655",
    "name": "Kavhe Amol Aba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12310",
    "name": "Jain Deepak Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19820",
    "name": "Nigade Sujata Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7858",
    "name": "Kalpana Dhondiram Nalage"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18937",
    "name": "Abdul Mustak Abdul Mohamad Kureshi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22261",
    "name": "Yadav Hirawati Motilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23060",
    "name": "Nadar S Nityanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24331",
    "name": "Mandke Suresh Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24489",
    "name": "Singh Rajendra Prasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24652",
    "name": "Rai Kirankumar Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24862",
    "name": "Rathod Suresh Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24882",
    "name": "Thakur Keshav Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25182",
    "name": "Thakur Sunilkumar Dhaneshwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25816",
    "name": "Said Puja Mangesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25958",
    "name": "Shinde Meena Gautam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10033",
    "name": "Pawar Tanaji Arjun"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2205",
    "name": "Jaiswar Ramnayan Saltanram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2763",
    "name": "Rathod Vaman Mohan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1819",
    "name": "Sarode Harshal Lalit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15433",
    "name": "Pisal Navnath Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13044",
    "name": "Patange Santosh Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20662",
    "name": "Shidruk Jayram Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22160",
    "name": "Vengurlekar Amey Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3180",
    "name": "Lokhande Narayan Aanandarao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14117",
    "name": "Yadav Shrirang Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17964",
    "name": "Parab Arvind Madhukar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17789",
    "name": "Patel Dipika Nilesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23063",
    "name": "Dalvi Sadanand Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21651",
    "name": "Dhuri Geeta Sachin"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17682",
    "name": "Jadhav Vanita Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22489",
    "name": "Nigade Snehal Subhash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20596",
    "name": "Patil Shankar Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22801",
    "name": "Shukla Rameshchandra Aadhaprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19281",
    "name": "Ghanchi Hasan Mohd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20222",
    "name": "Varma Jogeshwar Bhagwandin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20670",
    "name": "Monde Sunil Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20671",
    "name": "Chalke Laxman Janu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2862",
    "name": "Shirke Vinayak Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17403",
    "name": "Kadam Shivaji Dhanshing  Tn 1540-3"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15705",
    "name": "Gujar Anil Damodar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17982",
    "name": "Chorge Baburao Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11045",
    "name": "More Banubai Gulabrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "551",
    "name": "Savant Shivaji Dhondiram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "788",
    "name": "Nikam Suraj Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20211",
    "name": "Yadav Ramachal Raghuvansh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2047",
    "name": "Jadhav Ananda Janardan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22106",
    "name": "Patel Haresh L"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23444",
    "name": "Patil Uttam Tukaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1775",
    "name": "Mali Sanjay Gangaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25983",
    "name": "Pitlekar Asha Chabbu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25959",
    "name": "Shaikh Abdul Hamid Mohd Shafi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25961",
    "name": "Zaveri Mohd Yusuf Mohd Ibrahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25962",
    "name": "Abbasi Naushad Wajid Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25964",
    "name": "Kelatkar Sitaram Yashwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25974",
    "name": "Jaiswar Sitadevi Ramnath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25975",
    "name": "Pandey Laxmishankar Rangile"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1119",
    "name": "Thorave Asha Shamsundar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15670",
    "name": "Salunkhe Sandeep Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20674",
    "name": "Doshi Dharmish Nitin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25925",
    "name": "Gupta Girijadevi Chotelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25928",
    "name": "Mirza Sanwar Ali Akbar Ali"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15662",
    "name": "Awale Gangadhar Sampat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15663",
    "name": "Magar Sunil Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15665",
    "name": "Godse Ramchandra Sitaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16639",
    "name": "Kadambanat Madhu Sudanan Nair"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4462",
    "name": "Jadhav Rajaram Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24199",
    "name": "Indulkar Vinaya Vijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24832",
    "name": "Singh Ramesh Chhattar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15513",
    "name": "Jadhav Achut Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9452",
    "name": "Kadam Gajanan Baliram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19978",
    "name": "Mishra Seetlaprasad Ramsevak"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19979",
    "name": "Mishra Omprakash Ramsevak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20815",
    "name": "Bhoite Atul Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2866",
    "name": "Kolekar Mahadev Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24518",
    "name": "Gaikwad Sandesh Mangesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25976",
    "name": "Qureshi Mohd Iqbal Ahmed Abdul Karim"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7013",
    "name": "Salunkhe Anandrao Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25952",
    "name": "Yadav Radheshyam Chandrikasingh"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1934",
    "name": "Magar Rushi Kashinath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13226",
    "name": "Bhoite Narshing Khanderao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8651",
    "name": "Awade Santosh Shreerang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22738",
    "name": "Pawar Tatyaso Raghunath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22157",
    "name": "Kolekar Bharat Madhukar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1025",
    "name": "Mane Siddhnath Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13922",
    "name": "Shelar Subhash Vasudeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16692",
    "name": "Gupta Kedarnath Dipu"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "667",
    "name": "Pisal Uddhav Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14275",
    "name": "Bhaldar Bismilla Tajuddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18826",
    "name": "Patil Sambhaji Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18202",
    "name": "Navale Manisha Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10098",
    "name": "Chavan Anusaya Namdev"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7149",
    "name": "Bhosale Dattatray Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7148",
    "name": "Bhosale Satish Sambhaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10379",
    "name": "Gawali Deepak Shrirang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24331",
    "name": "Visaria Kaushik Mahendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20675",
    "name": "Doshi Nita Nitin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20676",
    "name": "Shah Jay Bharat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20677",
    "name": "Suru Shamit Dinkar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22818",
    "name": "Bait Ankita Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14323",
    "name": "Phalke Madan Ramrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11126",
    "name": "Mohite Tatoba Balwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9238",
    "name": "Durgade Anant Sukhdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14992",
    "name": "Barge Shankar Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2696",
    "name": "Sabale Lahu Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11980",
    "name": "Ahiwale Surendra Parashuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23873",
    "name": "Sonar Sarswati Ransing"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1614",
    "name": "Pawar Sindhu Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15990",
    "name": "Raskar Amit Abaso"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23851",
    "name": "Bade Asha Ram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1861",
    "name": "Patel Marshal R"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12084",
    "name": "Kadam Ratna Shivaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "840",
    "name": "Shiralkar Kumar Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3331",
    "name": "Mehta Rajesh Balwantrai"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12924",
    "name": "Shende Popat Vasantrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1087",
    "name": "Kank Amol Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20086",
    "name": "Mishra Seshnaryan Chandrabhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25541",
    "name": "Katte Sushant Vijay"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24147",
    "name": "Patil Shankar Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25093",
    "name": "Bari Hemant Bhima"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25921",
    "name": "Jain Bhavik Tarun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19977",
    "name": "Mishra Rajeshkumar Kuldeep"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "644",
    "name": "Thombare Pandurang Vishnu Oli No-657/20"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1456",
    "name": "Avasthi Sunilkumar Girish"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22212",
    "name": "Pawar Mangala Govindrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10034",
    "name": "Jadhav Ganapat Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13522",
    "name": "Dhumal Santosh Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20010",
    "name": "Bhitle Vishnu Dhodiba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19894",
    "name": "Suvare Shrutika  Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19488",
    "name": "Shinde Manoj Sampat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20258",
    "name": "Vaz Gavin Hilari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22546",
    "name": "Vishal Sahyadri Co-Op Hsg Soc Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8939",
    "name": "Pradhan Gopal Ragunath"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1055",
    "name": "Sagare Dilip Mahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17815",
    "name": "Anpat Manojkumar Madhukar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17110",
    "name": "Jadhav Vilas Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18411",
    "name": "Korde Gajanan Ishwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18844",
    "name": "Zatakiya Shalin Kirit"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18991",
    "name": "Mahadik Adhik Sakharam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24127",
    "name": "Salunkhe Dattatray Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20001",
    "name": "Nimbalkar Charudutt Abasaheb"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22454",
    "name": "Solanki Kishoresingh S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19563",
    "name": "Shirke Nilesh Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "155",
    "name": "Yadav Shamrao B"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11944",
    "name": "Mhalim Dattaram Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2690",
    "name": "Baddey Rahul Baba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13942",
    "name": "Bhurke Mangesh Arun"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21094",
    "name": "Balip Shrikrishna Shrirang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18570",
    "name": "Kolar Raju Virani"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19847",
    "name": "Mishra Umashankar Premnarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20119",
    "name": "Bhande Rajiv Bhagwan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20118",
    "name": "Bhande Shankar Sadashiv"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22519",
    "name": "Zaveri  Riddhi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20336",
    "name": "Baraskar Shantram Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25638",
    "name": "Sable Abhijit Bhimashankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17570",
    "name": "Raut Maruti Shamrao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "275",
    "name": "Sayaji Khanderao Shinde"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4201",
    "name": "Chavan Manik Narsingh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3000",
    "name": "Tandale Mohan Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23637",
    "name": "Mundhe Satish Pandurang"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15179",
    "name": "Kale Vijay Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20085",
    "name": "Tiwari Rajprakash Lalbihari"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2496",
    "name": "Sharda Amba Tea House"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3203",
    "name": "Vaibhav Packing Works"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3259",
    "name": "Fabrics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3488",
    "name": "Marathe Sunanda Vinayak"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3739",
    "name": "Poddar  Rahul   Harisharan"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3816",
    "name": "Matekar Brothers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4436",
    "name": "Vaishanvi Arts"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4678",
    "name": "Pushapanjali Parivahan"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4772",
    "name": "Shree Salasar Logistics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4778",
    "name": "Guru Krupa Cargo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2064",
    "name": "Mahak Fabrics"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2522",
    "name": "Madhusudan  Textiles"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "970",
    "name": "Shinde Madan M"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1116",
    "name": "For Sai Engineering"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1127",
    "name": "Sanged Decorators"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1254",
    "name": "Om Sai Warehousing"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1535",
    "name": "Krishna Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1927",
    "name": "Jamv Company"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2220",
    "name": "Nisargraj Advertisements"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "228",
    "name": "Shital Pipes Private Limited"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "322",
    "name": "Sachin Construction"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "176",
    "name": "Neel Medical & General Stores"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9875",
    "name": "Maskar Tanaji Ananda"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "18",
    "name": "Vipul Cellular"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "21",
    "name": "Ashtavinayak Transport"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "83",
    "name": "Agana Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "133",
    "name": "Mahaveer Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "171",
    "name": "Shiromani Textiles"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "184",
    "name": "Sea Marine Service"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "223",
    "name": "Aadinath Goods Storage And  Transit"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "366",
    "name": "Bhimi Tempo Services"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "508",
    "name": "Atharv Hospital & I C U"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "521",
    "name": "Ambaji Textiles"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "132",
    "name": "Shree Sukhakarta Developers"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2732",
    "name": "Shinde Ashok Daga"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19657",
    "name": "Kadam Sachin Nathuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13031",
    "name": "Patil Ramu Gawade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25371",
    "name": "Varma Manoj Ramlakhan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "754",
    "name": "Chavan Ashok Arjun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18356",
    "name": "Burunge Bhagoji Khusava"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18485",
    "name": "Jadhav Nilesh Mansingh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14003",
    "name": "Daphale Hirabai Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18730",
    "name": "Jaiswal Shaymji Bipat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18473",
    "name": "Jagtap Pravin Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24281",
    "name": "Shaikh Minhaj Abdul Rahim"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24411",
    "name": "Sawant Kiran Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25208",
    "name": "Kureshi Mumataj Mo Said Mumataj Mo Said"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13183",
    "name": "Yadav Sanjay Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5414",
    "name": "Dhumal Narayan Dattatray"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23793",
    "name": "Kadam Rahul Somnath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13072",
    "name": "Shinde Shivaji Shyamraao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16742",
    "name": "Yewale Jyoti Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25946",
    "name": "Nadar Kamraj Parimal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2870",
    "name": "Dhumal Hindurao Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "640",
    "name": "Jay-Vijay Riveet Co"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1707",
    "name": "Mohammad Traders"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1881",
    "name": "Hari Om Light"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2320",
    "name": "Royal Transport"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "359",
    "name": "Allianz Polypack Industries"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "178",
    "name": "Shree Sai Furnishing"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "234",
    "name": "Kamal Electric & Hardware Store"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "536",
    "name": "Shree Transport"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "626",
    "name": "Salte Pankaj Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9090",
    "name": "Jadhav Pratap Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9920",
    "name": "Salunkhe Ananda Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13877",
    "name": "Sangale Arvind Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15167",
    "name": "Shelar Hanmant Balu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24191",
    "name": "Barve Praful Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24368",
    "name": "Bhilare Vishnu Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19906",
    "name": "Kadam Ravindra Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19823",
    "name": "Kamble Sachin Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7371",
    "name": "Tarade Kamal Prabhakra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7195",
    "name": "Khan Jahid Husain Mohd Jamil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19556",
    "name": "Patel Gulam Hussain Chandu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12627",
    "name": "Phalake Sampat Bhiku"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3213",
    "name": "Lovely Fabrics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4283",
    "name": "Shree Asthavinayk Roadlines"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4765",
    "name": "Ortec International Trading House"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1058",
    "name": "Shree   Sainath  Enterprise"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1874",
    "name": "Alhadid Scrap Traders"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "538",
    "name": "Vardhman Fashion Fabrics"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "879",
    "name": "Shendge Satyavan Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24255",
    "name": "Sayyed Liyakatali Majarali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24280",
    "name": "Sayyed Abdul Razak Haji Hakim Abdul Sattar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24338",
    "name": "Nirgun Mahesh Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24397",
    "name": "Ghatkar Shubhangi Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24510",
    "name": "Mishra Padamprakash Badriprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24896",
    "name": "Maurya Nandlal Lavadhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8400",
    "name": "Gaikwad Santosh Vasant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8308",
    "name": "Jadhav Bharat Parbati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24452",
    "name": "Tiwari Subhash Rajendra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20105",
    "name": "Bhoite Nagesh Shankarrao"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2126",
    "name": "Shiv Engineering Works"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2327",
    "name": "Avishkar Construction"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2358",
    "name": "Elite Human Resources"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2665",
    "name": "Madhu Processors"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2776",
    "name": "Shree Vardhman Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2790",
    "name": "S M Fabrics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3525",
    "name": "Harshadrai And Sons"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3564",
    "name": "Sharma Rameshkumar Tormal"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "156",
    "name": "Lpkc Land Development Corporation"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1792",
    "name": "Laxmi Transport Prop (Mrs  Ushatai A  Bo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "440",
    "name": "Vishal Transport"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "574",
    "name": "G K Warpers"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20887",
    "name": "Bhosale Sambhaji Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19091",
    "name": "Varekar Laxman Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13416",
    "name": "Dalvi Vijay Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18733",
    "name": "Wagh Shailendra Kalidas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3203",
    "name": "Sawant Shivaji Balku"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14341",
    "name": "More Sunil Pralhad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15140",
    "name": "Masurkar Rajedra Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25297",
    "name": "Singh Pralhad Lalabahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24442",
    "name": "Rane Sandip Satyavijay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25265",
    "name": "Khan Mhad Hafij Naseen"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7271",
    "name": "Bamankar Ashok Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11043",
    "name": "Pramar Chandrika P"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19571",
    "name": "Karande Uttam Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20809",
    "name": "Mohite Hirabai A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21365",
    "name": "Khetale Kedar Govend"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21366",
    "name": "Khan Pravina Anwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13123",
    "name": "Sanas Sanjay Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1826",
    "name": "Mankar Nana S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20802",
    "name": "Kochrekar  Tavini Rajesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4094",
    "name": "Sahyadri Nagar Pragati Mandal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "170",
    "name": "Pawar Sudamrao Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14807",
    "name": "Shirodkar Sunil Trivikram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18041",
    "name": ""
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "791",
    "name": "Kadam Ramchandra Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14757",
    "name": "Pawar Tukaram Dinkarrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10236",
    "name": "Benglorewala Nitesh R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20132",
    "name": "Bobade Hindurao Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20854",
    "name": ""
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19938",
    "name": "Ezaz Husain Zivi Abbas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19230",
    "name": "Baig Sayra Azgar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19749",
    "name": "Kazi Nasrina Munwar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11190",
    "name": "Salunkhe Dhansing Dnyandeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22036",
    "name": "Patel Inayat Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20804",
    "name": "Malpote Shobha Baloo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20649",
    "name": "Kadam Suresh Mohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Term Deposit",
    "accountNo": "2805",
    "name": "Das Pratapkumar Pradip"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20983",
    "name": "Shinde Dattatray Dayu"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "2706",
    "name": "Vegurlekar  Dakshata Harishchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16747",
    "name": "Jadhav Mangesh Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17442",
    "name": "Shelake Sanjay Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5613",
    "name": "Vora Gopalji Hansraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16899",
    "name": "Sawant Manohar Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18340",
    "name": "Salunkhe Sanjay Bhaguji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16966",
    "name": "Jain Gautam M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13774",
    "name": "Soni Bhanwarlal Nanchandji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19798",
    "name": "Saroz Babani Prabhudayal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10875",
    "name": "Kirtikumar  Gulraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16822",
    "name": "Gaikwad Uddhav Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16989",
    "name": "More Ravindra B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8946",
    "name": "Nair  Shyamlal"
  },
  {
    "branch": "Dombivali",
    "type": "Term Deposit",
    "accountNo": "60",
    "name": "Yadav Mahendra Rajdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18140",
    "name": "Shelar Tukaram Chandrakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7450",
    "name": "Dige Hanmant Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12430",
    "name": "Mandhare Shobha Mugutrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15327",
    "name": "Nakti Sudhir Dharma"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2924",
    "name": "Jaiswal Pancham Bhagwandas"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2580",
    "name": "Shree Gurudattclearing Agency"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "820",
    "name": "Lotlikar Suhas Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1083",
    "name": "Satguru Auto"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1569",
    "name": "Able Mould Works"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2315",
    "name": "V- Tech Engineering"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "323",
    "name": "Bhudev Construction"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "224",
    "name": "Zest Facility Services Pvt Ltd"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "398",
    "name": "New Bombay Q T S  Carrier"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "322",
    "name": "Disha Wire Products"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "2793",
    "name": "Kamath Pandurang Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15888",
    "name": "Shinde Vitthal Krishna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8919",
    "name": "Patel Jagjivandas K"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1134",
    "name": "Ghorpade Shamrao A (Treasure)"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5054",
    "name": "Dhury Suptendu Roychow"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5878",
    "name": "Patil Dinanath Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12578",
    "name": "Jain  Pavan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17893",
    "name": "Gujar Mahesh Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11545",
    "name": "Indeulkar Prakash Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Term Deposit",
    "accountNo": "18010",
    "name": "Jaiswal  Jabhsuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17962",
    "name": "Dere Virsen Krishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4554",
    "name": "Bhosale Yashwant Tukaram-878-2"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20776",
    "name": "Shinde Manjushree Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20777",
    "name": "Shinde Vijay Chintopant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22919",
    "name": "Pisal Balu Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24235",
    "name": "Mohd Amin Mustafa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24346",
    "name": "Pansare Dattaram Bhagoji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24407",
    "name": "Unde Vithal Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24422",
    "name": "Yadav Radheshyam Suryabali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24427",
    "name": "Patel Hiralal Kanji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24445",
    "name": "Yadav Ramgulab Saggal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24540",
    "name": "Bandekar Sitaram Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24573",
    "name": "Shaikh Afzal Jumman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24624",
    "name": "Phutane Ashok Krishnarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24673",
    "name": "Singh Sheshanaresh Kashinaresh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24732",
    "name": "Nevrekar Rajendra Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24764",
    "name": "Bhardiv Vijay Chandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24765",
    "name": "Shaikh Sheralam Ismail"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24786",
    "name": "Patel Ramanlal N"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24791",
    "name": "Sayyed Aslam Abdul Rehman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24827",
    "name": "Yadav Satyaprakash Karmaraj"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24879",
    "name": "Bojgar Abdul Rasul Dada Hayat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24971",
    "name": "Khadye Anil Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24973",
    "name": "Churi Pradip Bhaskar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25222",
    "name": "Karande Arun Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25331",
    "name": "Baloch Rabiya Mohammed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26218",
    "name": "Bhoite Ankur Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26219",
    "name": "Deshmukh Prashant Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26220",
    "name": "Surve Nilesh Sanjay"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26223",
    "name": "Deshmukh Sadashiv Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26225",
    "name": "Ramdurgkar Raghavendra Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26226",
    "name": "Khaire Anil Hari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26227",
    "name": "Nalawade Rohit Jeevan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26228",
    "name": "Sardesai Sandip Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26229",
    "name": "Bhoite Ajinkya Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26231",
    "name": "Prabhu Ameya Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26234",
    "name": "Dhmal Archana Ranjeet"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26240",
    "name": "Sonpal Kavita Vishal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26242",
    "name": "Desai Reshma Kiran"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26243",
    "name": "Sonpal Vishal Ghanshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26244",
    "name": "Dahije Kamal Shivram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "79",
    "name": "Kadam Dilip Vithal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "490",
    "name": "Phalke Sudam Sahebrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18336",
    "name": "Bhosale Shahaji Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20230",
    "name": "Bodake Reshma Balasaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3080",
    "name": "Fernandes Joseph"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15460",
    "name": "Santosh  Tukaram Jagtap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20808",
    "name": "Salim Ahmed Islamuddin"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17161",
    "name": "Shukla Anilkumar Rajbahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20616",
    "name": "Shedge Mangesh Sadashiv"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21067",
    "name": "Singh Santosh Kumar Rampratap"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22427",
    "name": "Subhan Mohd Parvez Abdul"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3815",
    "name": "Matekar Shankar Shivaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4769",
    "name": "Power Prons"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2769",
    "name": "Singh Shiv Ranjan"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "985",
    "name": "Katha Engineering"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1818",
    "name": "A R Mold Eng   Pro A S Rajendran"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "28",
    "name": "M S Logistics"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "387",
    "name": "Raj Packing Works"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15613",
    "name": "Kadam Prakash Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17061",
    "name": "Sanjay Ogale Manisha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24000",
    "name": "Dhumal Pooja Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24326",
    "name": "Singh Shyamnarayan Ramprasad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24469",
    "name": "Dhangar Mahadevi Shivraya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24588",
    "name": "Yadav  Akela Hemantkumar Radheshyam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24606",
    "name": "Pathan Dilavar Mohiddin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24770",
    "name": "Sharif Akbar Sharik Mohammad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24887",
    "name": "Sawant Rajendra Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25120",
    "name": "Khade Balasaheb Kaka"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26300",
    "name": "Ghadshi Ashok Sonu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26310",
    "name": "Varma Buddhilal Mathura"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26326",
    "name": "Shaikh Razia Sultana Makbul"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5517",
    "name": "Kadam Pradip Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13445",
    "name": "Jain Bharat Jivrajji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26311",
    "name": "Shaikh Ali Husain Khalil"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26312",
    "name": "Shaikh Khurshit Bano Anver Sadik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26325",
    "name": "Gawas Mahendra Manohar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2425",
    "name": "Wagh Hanmant Sitaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2304",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4667",
    "name": "Paras Express Cargo"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4672",
    "name": "Mahalaxmi Printers"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4715",
    "name": "A S Garments"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4802",
    "name": "Shiva Sales Agency"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1025",
    "name": "Kirit Enterprises"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1030",
    "name": "Axis Inc"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1380",
    "name": "Deep Hydraulics"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2249",
    "name": "Mast Footwear"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "165",
    "name": "Vishal Kirana & General Stores"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "167",
    "name": "Bharat Container Movers"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "370",
    "name": "Mayur Sizing"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "522",
    "name": "New Super Texspring"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "525",
    "name": "Ashapura Textiles Packing"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "115",
    "name": "Tanishka Laour Services"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "116",
    "name": "Jayant Enter Prises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "117",
    "name": "Sahil Enter Prises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "118",
    "name": "Sachin Enterprises"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "119",
    "name": "Jaguaai Enter Prises"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9891",
    "name": "Naik Navnit Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16351",
    "name": "Shukala Sanjay Ramakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24494",
    "name": "Jadhav Gangadhar Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24728",
    "name": "Maredia Nazarali Mohamedbhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24816",
    "name": "Jinandre Ghanshyam Amrutlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25520",
    "name": "Rao Saleena Deepak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25836",
    "name": "Shetti Lobha Vaidalingam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26316",
    "name": "Patel Rekha Dinesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26334",
    "name": "Randive Chandrakant Anna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26337",
    "name": "Ayare Ramchandra Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26343",
    "name": "Patole Dilip Jonsan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26346",
    "name": "Shaikh Mohd Iqbal Mohd Hanif"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26357",
    "name": "Ansari Khushid Alam Amir Hussain"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26363",
    "name": "Shaikha Javed Abbas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26373",
    "name": "Sondkar Suresh Dattaram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "70",
    "name": "Bhilare Rohidas Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17225",
    "name": "Sabale Maruti Dnyandev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24397",
    "name": "Tambe Shrikant Vasudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1720",
    "name": "Patil Rajendra Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17054",
    "name": "Salunke Shobha Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26356",
    "name": "Mirza Aslam Yakub Baig"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26368",
    "name": "Khan Mohammed Kadar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26369",
    "name": "Sawant Uday Manohar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26309",
    "name": "Yadav Rameshchandra Ramlal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "1875",
    "name": "N Jayantilal"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1149",
    "name": "Chintamani Enterprises"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1325",
    "name": "R  Y  Construction"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2195",
    "name": "New Society Dhanya Bhandar"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2371",
    "name": "Vaziralli Pvt Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2402",
    "name": "A K Associates"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2088",
    "name": "Pisal Shankar Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9924",
    "name": "Chavan Tanaji Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10186",
    "name": "Phalke Bharat Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11785",
    "name": "Shinde Ravindra Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12070",
    "name": "Rimal Gangaprasad Jayprasad"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15721",
    "name": "Padwal Vaishali Sanjay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12332",
    "name": "Sakunde Sadashiv Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9348",
    "name": "Pisal Satish Vinayak"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6389",
    "name": "Kadam Uttam Mahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3985",
    "name": "Jadhav Mahadeo Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14519",
    "name": "Londhe Surendra Bablaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1549",
    "name": "Wagh Ramrao Tatyaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12252",
    "name": "Mahadik Poonam Shashikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15451",
    "name": "Deshmane Sunita Prakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15861",
    "name": "Godase Mangesh Mansing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15866",
    "name": "Nalage Sumit Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15867",
    "name": "Malusare Rajaram Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15870",
    "name": "Yadav Rajaram Harishchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15903",
    "name": "More Vanita Kamlakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15753",
    "name": "Shingate Jijabai Sarjerao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3602",
    "name": "Chavan Balawantarao Yadaorao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7267",
    "name": "Shinde Dilip Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12369",
    "name": "Phalke Ramesh Uttam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10326",
    "name": "Jadhav Krushna Bajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15104",
    "name": "Karne Vijaykumar Dinkar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12751",
    "name": "Jadhav Snehal Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11955",
    "name": "Kadam Avinash Keshav"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15865",
    "name": "Nalawade Santosh Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15879",
    "name": "Phalke Vishal Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15881",
    "name": "Sawant Dattatray Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15898",
    "name": "Pisal Shivaji Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15821",
    "name": "Pawar Laxmikant Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15829",
    "name": "Pawar Ashok Maruti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10176",
    "name": "Pandit Ashok Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12540",
    "name": "Mulia Madhu Gurva"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13257",
    "name": "Sakunde Vasudeo Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2413",
    "name": "Wagh Ramchandra Sawala"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9326",
    "name": "Sakunde Vishwas Sakharam"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11790",
    "name": "Miss Shinde Yamunabai Changdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15956",
    "name": "Nikam Sarika Anil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13359",
    "name": "Mahadik Kundan Shyamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15921",
    "name": "Deshmukh Prasad Changdeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15922",
    "name": "Pisal Mahendra Tanaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15928",
    "name": "Awale Bajirao Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15827",
    "name": "Jadhav Neelam Shashank"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15828",
    "name": "Jadhav Vidya Abhijeet"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15836",
    "name": "Kadam Amita Hindurao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15847",
    "name": "Dhumal Sangeeta Manesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15850",
    "name": "Kadam Prakash Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15851",
    "name": "Kadam Kishor Bhimrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15882",
    "name": "Pawar Sayaji Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15899",
    "name": "Yele Kisan Balu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15909",
    "name": "Nikam Shubham Mahendra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15913",
    "name": "Nalage Prashant Shamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15914",
    "name": "Shaikh Riyajuddin Baxu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15915",
    "name": "Nalage Balaso Arjun"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15794",
    "name": "Gadhave Pravin Nivrutti"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15795",
    "name": "Shinde Dilip Dhondiram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15796",
    "name": "Shinde Rekha Dilip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15801",
    "name": "Babar Nitin Avinash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15802",
    "name": "Kondalkar Santosh Shankarrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15803",
    "name": "Pawar Vishwas Prabhakar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15804",
    "name": "Shirke Subhadra Parbati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15783",
    "name": "Waghmale Abhijit Arvind"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "496",
    "name": "Gaikwad Shivaji Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15720",
    "name": "Kadam Archana Nandkumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15686",
    "name": "Shinde Devyani Ajayrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15688",
    "name": "Nimbalkar Priyanka Amol"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15635",
    "name": "Palsande Sanket Kritikumar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2167",
    "name": "Bhosale Bhanudas Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "639",
    "name": "Nikam Chandrakant Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11449",
    "name": "Pawar Shankar Vithal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3358",
    "name": "Shingan Laxman Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13492",
    "name": "Shinde Mukund Madhukar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8118",
    "name": "Shinde Rajendra Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11318",
    "name": "Wagh Subhash Bhikoba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10705",
    "name": "Dhumal Rajaram Ramrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9368",
    "name": "Chavan Sanjay Buwasaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9347",
    "name": "Jagtap Sanjay Bhauso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10885",
    "name": "Katkar Baban Abaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14212",
    "name": "Renke Pradnya Sunil"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11224",
    "name": "Shingan Nilesh Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8105",
    "name": "Gaikwad Ashok Shivram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14287",
    "name": "Mulik Arvind Jaysing"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15003",
    "name": "Chavan Sonali Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6736",
    "name": "Gaikawad Ashok Shrirang"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14158",
    "name": "Nalawde Dilip Uttamrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8976",
    "name": "Wagh Keshar Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10122",
    "name": "Dandekar Bhaskar Yshawant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11582",
    "name": "Dhumal Vijaysinh Yashawantarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5654",
    "name": "More Gajarabai Kisan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15198",
    "name": "Nikam Seema Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12005",
    "name": "Shelar Vinayak Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10120",
    "name": "Babaso Lalasaheb Shingate"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15174",
    "name": "Mayane Madhuri Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10277",
    "name": "Chavan Ramesh Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12317",
    "name": "Phalke Malan Laxman"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9654",
    "name": "Shinde Savita Shivaji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12424",
    "name": "Ghadge Tukaram Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13908",
    "name": "Suvarna Yuvraj Jagadale"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10319",
    "name": "Dhumal Kisan Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9491",
    "name": "Sable Pradeep Sadashiv"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6114",
    "name": "Adagale Vasant Antu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13728",
    "name": "Inamdar Nadanabi Hamdullapattu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15723",
    "name": "Bhonsale Umesh Vyankatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15715",
    "name": "More Pradip Janardhan"
  },
  {
    "branch": "Satara",
    "type": "Term Deposit",
    "accountNo": "10747",
    "name": "Salunkhe Dnyandeo Ganpati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7923",
    "name": "Jadhav Pradeep Hanmant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5971",
    "name": "Phalke Deepak Vithalrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10948",
    "name": "Phalke Abaso Balaso"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13219",
    "name": "Phalke Sanket Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12929",
    "name": "Kadam Narayan Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14538",
    "name": "Navghane Maruti Sahadeo"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "1919",
    "name": "Tate Sudha Ganpat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13943",
    "name": "Nikam Sunanda Vijay"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15610",
    "name": "Jadhav Sadhana Ravindra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15432",
    "name": "Sonawane Sunanda Baban"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15677",
    "name": "Sawant Bhushan Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12901",
    "name": "Sakunde Hanmant Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3370",
    "name": "Kirve Sulabai Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8685",
    "name": "Kadam Amar Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9707",
    "name": "Phalke Suresh Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13080",
    "name": "Sapkal Ramchandra Baburao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8912",
    "name": "Sankpal Shankuntala Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9931",
    "name": "Kale Vimal Laxman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20359",
    "name": "Lade Ramchandra Jagannath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19917",
    "name": "Aiwale Sandhay Satish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "8435",
    "name": "Espiciosa Mathew Rodriguese"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22429",
    "name": "Kakade Manisha Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11381",
    "name": "Sureshkumar Chhogmalji Jain"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13071",
    "name": "Kadam Avinash Dharmaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2972",
    "name": "Ujwala Ekanath Parab"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17189",
    "name": "Chede Laxman Vitthal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22399",
    "name": "Hate Kaustubh Narendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18685",
    "name": "Deshmukh Swapnil Hanmant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14753",
    "name": "Pawar Kiran Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "307",
    "name": "Mandhare Maruti Krishna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22370",
    "name": "Kadar Suleman Abdul"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12187",
    "name": "Dapfhade Babaurao Dulubu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17795",
    "name": "Gurav Dhondiram Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19660",
    "name": "Nikam Dattatray Balaso"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22236",
    "name": "Bhosale Suresh Jagannath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4631",
    "name": "Rasal Vitthal Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6813",
    "name": "Kolekar Vasant Kondiba Tn-81A/4"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "2064",
    "name": "Dnyaneshwar Pralhad Pisal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5877",
    "name": "Kalugade Prakash Kashba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17757",
    "name": "Pawar Sakharam Tukaram Tn-1573-3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16400",
    "name": "Sheikh Sakirali Abdulazad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15003",
    "name": "Gawali Arati Ganesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22417",
    "name": "Mohammad Ashfaque Ansari"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20298",
    "name": "Shinde Ramchandra Madhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22266",
    "name": "Poojari Sudhakar Shriniwas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14275",
    "name": "Pawar Jaywant Raghunath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21886",
    "name": "Gupta Ashokkumar Chotelal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21242",
    "name": "Padwal Ramesh Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15247",
    "name": "Kadam Ashok Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11763",
    "name": "Tetame Dhanaji Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18299",
    "name": "Nalawade Vijay Uttamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19425",
    "name": "Raysingh Prabhakar Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15139",
    "name": "Sawant Vijay Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19247",
    "name": "Singh Jaysingh Videshi"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "68",
    "name": "Kshirsagar Dinkar Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17756",
    "name": "Pawar Navnath Daulat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8756",
    "name": "Lokare Shivmurati Vithal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "575",
    "name": "Barik Manojkumar Banshidhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12954",
    "name": "Bhosale Jaywant Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2669",
    "name": "Shinde Dinkar Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24558",
    "name": "Bhadricha Kalpana Jitendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26348",
    "name": "Kamble Navdeo Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26304",
    "name": "Mishra Harishchandra Kanhaiyalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26307",
    "name": "Shaikh Hasam Babumiya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26333",
    "name": "Kanse Shivaji Shantaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11866",
    "name": "Jadhav Vittal Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26221",
    "name": "Deshmukh Ramchandra Bajirao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26222",
    "name": "Deshmukh Swati Prashant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13960",
    "name": "Khade Hemalata Gangaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15446",
    "name": "Panvalkar Dinesh Tukaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22355",
    "name": "Torsekar Ashmi Mahesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5962",
    "name": "Shinde Ramesh Yeshwant 166/5"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7324",
    "name": "Rashik Tribhuvan Waghela"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26230",
    "name": "Kumthekar Paresh Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17314",
    "name": "Khindkar Satish Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14000",
    "name": "Jadhav Sunita Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13339",
    "name": "Kolekar Krishnath Hari1413/5"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3803",
    "name": "Salunkhe Mangal Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19773",
    "name": "Gaud Satyanarayan Kalu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20757",
    "name": "Pote Kishor Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10848",
    "name": "Maru Vikram Jayantilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24721",
    "name": "Yadav Kashiram Ramdhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24801",
    "name": "Salim Hidayatullah Shaikh Mohd"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20680",
    "name": "Ledha Prasad Rajbhar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21290",
    "name": "Sharma Surendrakumar Amrutlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22688",
    "name": "Atharali Abbasali Choudhary"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22917",
    "name": "Shivcharan Sudama Yadav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24678",
    "name": "Yadav Rajendra Prasad Bhagwandas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20509",
    "name": "Badshah Sayyad Salim Anwar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24468",
    "name": "Dhumal Shyam Dhondiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22900",
    "name": "Aagane Sunil Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24451",
    "name": "Maurya Phoolchand Ramkumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24458",
    "name": "Yadgiri Kamanpati Wanke"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6",
    "name": "Bagwe Savita Babaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18812",
    "name": "Pawar Atul Suryakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12210",
    "name": "Dhumal Rajendra Vittalrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15782",
    "name": "Bhatkar Dashrath Dattatraya"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15896",
    "name": "Redkar Prachi Dilip"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4491",
    "name": "Kadam Ashok Ramchandra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "291",
    "name": "Sable Seema Vishal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17535",
    "name": "Thakker Ajay L"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7359",
    "name": "Harijan Sidhu Sahadev"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20533",
    "name": "Dere Udaysingh Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3227",
    "name": "Selar Gulab Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13236",
    "name": "Vishwakarma Nirmala S"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23561",
    "name": "Salunkhe Shubhangi Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12552",
    "name": "Jadhav Sambhaji Baburao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18938",
    "name": "Gharat Shrikant Vinayak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20617",
    "name": "Suresh Ishwar Kamble"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17370",
    "name": "Tawade Arun Shivram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20045",
    "name": "Raje Dagadu Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12642",
    "name": "Raje Arvind Dagadu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "507",
    "name": "Varma Pappu Shivbhagwan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15244",
    "name": "Dhumal Shivaji Janardhan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14557",
    "name": "Amalani Ranjana Haresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19648",
    "name": "Mohale Vinod Vithal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10038",
    "name": "Ghorpade Bharat Bhausaheb"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22609",
    "name": "Abdul Rehman Mohd Ismail Haji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17337",
    "name": "Hule Vijaya Pandharinath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22273",
    "name": "Pednekar Suhas Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18141",
    "name": "Bhoite Sachin Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22446",
    "name": "Shaikh Siraj Abdul Rahim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22426",
    "name": "Thik Arjun Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13342",
    "name": "Bhosale Prabhak Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19563",
    "name": "Sachin Ravindra Pillai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22399",
    "name": "Hussain Khalil Khaja"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19948",
    "name": "Jagtap Jitendra Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10379",
    "name": "Dhumal Balasaheb Marutrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12709",
    "name": "Ghadage Radha Vishwas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17558",
    "name": "Hengiste Sandeep Shankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17949",
    "name": "Disale Neeta Shantaram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "177",
    "name": "Salunkhe Chandrakant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17886",
    "name": "Shedge Sanjay Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13064",
    "name": "Chavan Sambhaji Shivaji"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "376",
    "name": "Mhatre Kavita Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10266",
    "name": "Maruti Shripati Bhilare"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15218",
    "name": "Sutar Ramesh Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20524",
    "name": "Pandey Rajan Gulab"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13038",
    "name": "Jagtap Mahadeo Genba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11482",
    "name": "Shinde Suresh Vinayakrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18160",
    "name": "Kahane Prashant Dattaram & Landge Atish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23176",
    "name": "Salunkhe Appaji Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17704",
    "name": "Mohite Dilip Ramdas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17568",
    "name": "Mohite Pranita Krishnarao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12578",
    "name": "Patil Pandu Namdeo"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22561",
    "name": "Prashant Laxman Salunkhe"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21478",
    "name": "Phatak Nilesh Mohan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17996",
    "name": "Khot Vithal Anaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19943",
    "name": "Nakashe Manisha Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14161",
    "name": "Mestry Tukaram Govind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11185",
    "name": "Prasade Chandrakant Kashiram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19021",
    "name": "Vanel Hansa Girish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12581",
    "name": "Nikam Pravin Dnyaneshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14318",
    "name": "Patil Ananda Sakharam Tn"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19181",
    "name": "Soni Balu Laxminarayan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2765",
    "name": "Avaduth Mahila Bachat Gat Purna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13537",
    "name": "Kokate Mahadev Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20204",
    "name": "Chavan Pradeep Jaya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11786",
    "name": "Gawade Chaya Sadanand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3621",
    "name": "Bhoite Yamuna Ravindra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7298",
    "name": "Doke Anjana Kailash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "108",
    "name": "Chavan Ashok Bandoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18063",
    "name": "Chavan Atmaram Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11817",
    "name": "Sawant Raghunath Dnyandeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22407",
    "name": "Shah Jatin Hemanshu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11155",
    "name": "Sawant Prabhakar Ghansham"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7120",
    "name": "Shinde Chandrakant Yeshwant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22252",
    "name": "Parthe Shankar Chander"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22654",
    "name": "Jadhav Vidyadhar Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26345",
    "name": "Mane Suresh Tamanna"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26317",
    "name": "Bhosale Sanjay Waman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26318",
    "name": "Bhosale Vaibhav Pramod"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26319",
    "name": "Bhosale Priyanka Pramod"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15994",
    "name": "Kirve Dinesh Ramdas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24519",
    "name": "Parashar Asmita Pankuj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24520",
    "name": "Parashar Pankuj Jovinderlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24472",
    "name": "Nair Shashi Pukunnath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24473",
    "name": "Ahire Dnyanseshwar Jagannath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24489",
    "name": "Mahadik Uday Sharadchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24490",
    "name": "Mahadik Sheetal Uday"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26204",
    "name": "Kadiwal Sahid Ismile"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26206",
    "name": "Khot Prafull Chandrakant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26216",
    "name": "Yadav Doodhanath Ramnihor"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26262",
    "name": "Khan Ilyas Kudarat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3592",
    "name": "Desai Ganpat Shripati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24461",
    "name": "Shingan Prashant Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20766",
    "name": "Kadam Akshay Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20767",
    "name": "Kadam Amol Ashok"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24425",
    "name": "Miss Chavan Seema Anandrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24426",
    "name": "Vartak Vibha Pravin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24427",
    "name": "Sarfare Avinash Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24428",
    "name": "More Suresh Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24429",
    "name": "Tigdi Chetan Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24432",
    "name": "Bhaskar Surekha Sameer"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24433",
    "name": "Bhaskar Sameer Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24435",
    "name": "Khonde Anant Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24436",
    "name": "Naik Chandrakant Dagdu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24444",
    "name": "Bidwaik Pramod Tulshiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24445",
    "name": "Mali Ankush Motiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24447",
    "name": "Kamble Rajesh Atmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20740",
    "name": "Chavan Pramila Naresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20742",
    "name": "Dhamankar Rajaram Sitaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20753",
    "name": "Kadam Satish Parashram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20754",
    "name": "Tetame Jayshri Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20755",
    "name": "Kadam Vidya Sachin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26150",
    "name": "Ansari Mehandihasan Alihasan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26164",
    "name": "Shaikh Noormohammed Ibrahim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24409",
    "name": "Deshmukh Subhash Sahebrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24410",
    "name": "Deshmukh Lata Sahebrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26113",
    "name": "Patel Premkumar Natwarlal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26115",
    "name": "Bhalekar Anil Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15906",
    "name": "Kadam Vijay Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26071",
    "name": "Sayyed Imran Iqbal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26077",
    "name": "Gupta Hriday Narayan Baldev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26081",
    "name": "Jadhav Shakuntala Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26085",
    "name": "Sharma Omprakash Tribhuvannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26089",
    "name": "Jambhale Omkar Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26092",
    "name": "Gurav Rajaram Krishna"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1135",
    "name": "Dighe Anita Sandeep"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26064",
    "name": "Mali Santosh Dashrath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20724",
    "name": "Chouhan Nitadevi Ramdiraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24493",
    "name": "Mali Chandrakant Bhargav"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15966",
    "name": "Mahadik Hanmant Bapu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24316",
    "name": "Mehta Pramit Kamlesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24317",
    "name": "Mehta Meghana Viral"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24318",
    "name": "Gandhi Hemang Pankaj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24323",
    "name": "Geol Ashish Jagdish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24324",
    "name": "Shivalkar Sanjot M"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24325",
    "name": "Bhobe Namrata Nagesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24310",
    "name": "Gawade Hasmukh Chandrakant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3434",
    "name": "Gundu Padma Upallya"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3453",
    "name": "Deekonda Lalita Raju"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19390",
    "name": "Bobade Hemant Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23054",
    "name": "Mehta Viral Vikram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13154",
    "name": "Ramchandra Dagadu Salate"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21378",
    "name": "Tayde Sachin Pandit"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25862",
    "name": "Shah Jamil Ahmed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25844",
    "name": "Auti Shashikant Nanaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3376",
    "name": "Manda Vithabai Kumar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26042",
    "name": "Khan Khudrath Gafur"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18662",
    "name": "Patharkar Vijay Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1447",
    "name": "Mulik Gulabrao Mahadev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20894",
    "name": "Javare Budhaji Ramkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7624",
    "name": "Palase Namdeo Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4840",
    "name": "Gawade Tukaram Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13956",
    "name": "Shaikh Sahida Abdulrahiman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10568",
    "name": "Jayashri Vasudev Teli"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20057",
    "name": "Bohara Khem Bahadur"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15773",
    "name": "Bhosale Mahadeo Vishnu 679-12"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4492",
    "name": "Waghmare Tukaram Balu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "9613",
    "name": "Tavare Yeshwant Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9383",
    "name": "Mozar Dattatray Bandu 676/37"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20628",
    "name": "Pawar Vaishali Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14559",
    "name": "Dalvi Shankar Marutia/9321"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "839",
    "name": "Vhade Suresh Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18980",
    "name": "Ghadge Jayvant Madhusudan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16025",
    "name": "Adhtrao Sushma Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25373",
    "name": "Dhangar Purnima Siddappa"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2664",
    "name": "Disale Yashwant Daji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "816",
    "name": "Sasvat Babulal Madharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8223",
    "name": "Pande Ramnath Ramchabi"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14345",
    "name": "Tingare Pandit Bhanudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7311",
    "name": "Dhumal Dilip Keshavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "767",
    "name": "Yaswant Bhau Sinde"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14388",
    "name": "Kadam Laxman Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3851",
    "name": "Jagtap Lata Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18759",
    "name": "Gade Gopal Nathuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15348",
    "name": "Malaghe Rajaram Govind"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18337",
    "name": "Kadam Vaibhav Dagdu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12560",
    "name": "Jain Parasmal Bhabutmal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16324",
    "name": "More Vinayak Ishwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14404",
    "name": "Kadam Sitaram Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9377",
    "name": "Bhoite Fatesingh Shankarrao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14528",
    "name": "Mulam Parashuram Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20164",
    "name": "Singh Ram Ratan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15732",
    "name": "Mandhare Santosh Prakash Toli No -1471/4"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19770",
    "name": "Kavar Vilas Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17695",
    "name": "Kolekar Jalindhar Dyandev"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21489",
    "name": "Khamkar Shivani Shailesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20614",
    "name": "Prajapati Mehilal Ramkirpal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16762",
    "name": "Raut Vikrant Arun"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14773",
    "name": "Chalake Hanmant Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15622",
    "name": "Lembhe Ramesh Balwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4762",
    "name": "Dhumal Dattu Krushna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8367",
    "name": "Salunkhe Shankar P 211/A/3"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20048",
    "name": "Prashant Maruti Gunjal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20087",
    "name": "Lotale Vimal Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13053",
    "name": "Bagade Laxmi Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22366",
    "name": "Mohd Usman Sabbir Siddhiqui"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22850",
    "name": "Sushma Dattatray Ithape"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4629",
    "name": "Ahirekar Maruti Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9604",
    "name": "Chawan Shashikant Bandoba-692 38"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15675",
    "name": "Mane Sanjay Balku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21617",
    "name": "Manchekar Ruchita Rajesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12789",
    "name": "Patil Dhondiram Maruti"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16824",
    "name": "Naik Vidya Khanderao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7026",
    "name": "Matre Aatmaram Ganpat Tn"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13952",
    "name": "Pawar Sujata Prakash"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24025",
    "name": "Shaikh Ibrahim Abdulla"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23998",
    "name": "Dubey Bholanath Jagdamba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19814",
    "name": "Mutal Ashok Yaswant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12162",
    "name": "Yadav Rajaram Ramadhar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14358",
    "name": "Patil Bajirao Dynedeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15251",
    "name": "Sarafdar Dagadu Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13813",
    "name": "Bhagat Satish Tukaram 563/32"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17935",
    "name": "Patil Dagdu Kisan Tolino-1565/13"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12477",
    "name": "Sawant Shrirang Ramchandra 862/8"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16045",
    "name": "Shinde Ramchandra Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17337",
    "name": "Danawale Prakash Anandrao Tn-944-23"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13564",
    "name": "Shinde Tushar Yeshwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12175",
    "name": "Jagatap Sanjivan Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19439",
    "name": "Gunjal Prakash Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2689",
    "name": "Devkota Ravilal Devilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10240",
    "name": "Nikam Sanjay Vasantrao Tn-547-9"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "575",
    "name": "Kadav Mahadev Vithal 714-1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2779",
    "name": "Shinde Ramdas S"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17514",
    "name": "Nayadu Saroj Mithu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11304",
    "name": "Gaud Rajendraprasad Laxman"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1066",
    "name": "Vibhute Rajaram Tanaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12372",
    "name": "Bhoite Laxman Mansing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1167",
    "name": "Mahangare Dashrath Baburao"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12122",
    "name": "Panchal Balkrishna Gopal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23202",
    "name": "Bhausaheb Madhavrao Gangurde"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16640",
    "name": "Yadhav Sanjay Yeswant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14128",
    "name": "Shivale Ankush Pandharinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12100",
    "name": "Dhumal Dashrath Nivrutti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20422",
    "name": "Vaghmode Baburao Bhairu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14603",
    "name": "Shaikh Meharunnisa Ramzanali"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12555",
    "name": "Modak Prakash Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14935",
    "name": "Anthani Michel Nadar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23394",
    "name": "Sahebrao Daulatarao Vakale"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6631",
    "name": "Mandhare Dnyandeo Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7715",
    "name": "Mane Dilip Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21822",
    "name": "Misal Sahadev Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15334",
    "name": "Anil Sadashiv More"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20054",
    "name": "Bhandari Ravindra Parshuram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22974",
    "name": "Mane Kirti Milind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21907",
    "name": "Tiwari Nanhelal Ramdev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8425",
    "name": "Patil Hemlata Kesarinath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17505",
    "name": "Waghmode Bhiru Bhagoji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5728",
    "name": "Bhosale Balasaheb Haribhau Tn-232-5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12827",
    "name": "Yadav Ramesh Malairam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22527",
    "name": "Jadhav Vikas Shivaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8904",
    "name": "Sapkal Dattatrey Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20853",
    "name": "Rmugam Mugadevat"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "898",
    "name": "Shukla Rajeshkumar Umashankar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16488",
    "name": "Salunkhe Sandip Babanrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14483",
    "name": "Kashid Dhanwant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19505",
    "name": "Khadka Navalsingh Bhagatsingh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20171",
    "name": "Koli Salina Anthony"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8801",
    "name": "Saroj Baburam Ramcharan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8451",
    "name": "Mahakal Sheetal Jayant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17427",
    "name": "Gavde Kondiba Bhagoji Tn-1543-4"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13492",
    "name": "Rahemat Ali Mahamod I Pathan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15325",
    "name": "Bhor Kailash Karbhari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1884",
    "name": "Babar Vilas Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16765",
    "name": "Bhade Sunil Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12271",
    "name": "Pawar Maruti Bhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21072",
    "name": "Mushtar Mukhtar Mohammed"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21073",
    "name": "Vishwakarma Ashwin Mevalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21074",
    "name": "Patel Mhendrakumar Khimji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21075",
    "name": "Singh Vinaykumar Kulbhushan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21076",
    "name": "Tawade Ravindra Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21077",
    "name": "Tripathi Rajnarayan Shivnarayan"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1708",
    "name": "Pandey Amar Akhileshwar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4443",
    "name": "Malpote Damu Rambhau"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8720",
    "name": "Bhosale Dnyaneshwar Dharmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2743",
    "name": "Jadhav Lahu Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13261",
    "name": "Ashok Ramlal Garg"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13654",
    "name": "Saroj Pappu Pratap"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15401",
    "name": "More Ramesh Sitaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7434",
    "name": "Shinde Arjun Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20412",
    "name": "Waghela Kirit Shamji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19388",
    "name": "Kachare Shrirang Raghunath"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14384",
    "name": "Jadhav Ramesh Madhavrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10458",
    "name": "Nikam Hanmant Parbati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9369",
    "name": "Pawar Ananda Bapurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18998",
    "name": "Shukla Chandrakant Bindeshwariprasad"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "8",
    "name": "Harmalkar Ashok Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12591",
    "name": "Ithape Rohidas Manohar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4960",
    "name": "Mane Shivaji Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18531",
    "name": "Sabale Neeta Rajendra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11838",
    "name": "Jagtap Vinayak Bhimrao Tn 822-34"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2898",
    "name": "Patil Tukaram Bhau 351/1"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11594",
    "name": "Pawar Dhananjay Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15263",
    "name": "Chavan Raju Arjun"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16608",
    "name": "Chavan Surykant Narayan/Pallavi Suryakan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25355",
    "name": "Vage Asha Anand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23649",
    "name": "Jadhav Vaishali Suresh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1131",
    "name": "Jadhav Datta Sahebrav"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21416",
    "name": "Subhash Bellappa Muskee"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6886",
    "name": "Udale Madhukar Hindurao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25626",
    "name": "Shaikh Mohmad Miraj Ebrahim"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7904",
    "name": "Doshi Bharatkumar Prabhudas"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4255",
    "name": "Pisal Anandrao Gulabrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17211",
    "name": "Gawai Dilip Ankush"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6959",
    "name": "Ranka Kamini Kumari"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1674",
    "name": "Sawant Vijay Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18575",
    "name": "Halkeri Ravi Shivabasappa Kuveshkar Kala"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8268",
    "name": "Shinde Tukaram Anandrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12252",
    "name": "Gardi Umesh Sampat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19450",
    "name": "Lembhe Rahul Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18896",
    "name": "Parte Dattatray Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3579",
    "name": "Mane Sagar Prakash"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18232",
    "name": "Ray Vijayprakash Jagdish"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19517",
    "name": "Nimbare Anant Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15698",
    "name": "Rameshkumar Sijor Jaiswar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19998",
    "name": "Khedekar Vishnu Haribhau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22774",
    "name": "Ghadge Avinash Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17511",
    "name": "Sabale Mahesh Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18863",
    "name": "Sharma Omprakash Panalal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9347",
    "name": "Barma Tribhuvanprasad P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1787",
    "name": "Sawant Dattatray Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6468",
    "name": "Khair Shankar T"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16906",
    "name": "Kansara Jignesh Rameshchandra"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1043",
    "name": "Jadhav Narayan Ravji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20253",
    "name": "Garware Kailash Kisan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10309",
    "name": "Honspal Surjeet Kaur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15119",
    "name": "Suresh Sukkar Lade"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10395",
    "name": "Gurav Gunaji Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13396",
    "name": "Mugale Sidram Keshav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18305",
    "name": "Pawar Vitthal Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10502",
    "name": "Ali Rafique Husan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7505",
    "name": "Geeta Suhas Sinha"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23389",
    "name": "Manwatkar Shivshankar Husan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13922",
    "name": "Gorule Yeswant Ganpat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21596",
    "name": "Dubey Kailashnath Rajpati"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16704",
    "name": "Javlekar Gajanan Sunder"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "764",
    "name": "Rajaram Dnydev Karne"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16862",
    "name": "Kadam Vilas Balwant"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3625",
    "name": "Panda Gitanjali Ramesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8053",
    "name": "Dakave Ananda Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20793",
    "name": "Kadam Balu Devji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8004",
    "name": "Sawant Amol Dattatry"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13737",
    "name": "Choudhari Agyaram Lochai"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18445",
    "name": "Sadre Hrishikesh Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14360",
    "name": "Phale Sulochana Mahadeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1583",
    "name": "Dalvi Bhau Ramchandra"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22407",
    "name": "Shinde Hitesh Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26054",
    "name": "Wagh Amit Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26059",
    "name": "Kamble Amar Bharat"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26043",
    "name": "Sharif Mohammed Mehboob"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26045",
    "name": "Sawant Vilas Baliram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "910",
    "name": "Mayur Mahila Swayam Sahayyata Bachat Gat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22960",
    "name": "Shinde Rajendra Krishnrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22965",
    "name": "Shinde Harish Krishnrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16216",
    "name": "Kambale Kerba Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12371",
    "name": "Jadhav Ramdas Dasharath Toli-45/A/15"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15465",
    "name": "Pawar Vijay Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23775",
    "name": "Raichura Hemal Sharad"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20627",
    "name": "Vartak Shruti Rushant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15506",
    "name": "Gaikwad Vasant Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6919",
    "name": "Warlikar Shila Naresh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15804",
    "name": "Palse Damaji Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16851",
    "name": "Kadam Sayaji Bandu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14862",
    "name": "Baikar Dipak Mahadev/Mrs Baikar Dipika D"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2181",
    "name": "Paswan Kusum Bikaw"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "856",
    "name": "Dhane Machiandra Bandu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11766",
    "name": "Tarade Sanjay Khashaba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13476",
    "name": "Sawant Suhas Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "202",
    "name": "Sawant Shyam Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3390",
    "name": "Gound Vijaykumar Musafir"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15441",
    "name": "Pawar Sanjay Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19078",
    "name": "Atugade Kiran Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "1131",
    "name": "Salaskar Anjali Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15200",
    "name": "Shekha Mudal Golehabebi Fajalurehaman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20660",
    "name": "Zala Mulji Dadabhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23317",
    "name": "Patole Prashant Manik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24072",
    "name": "Mohite Vivek Jajannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1454",
    "name": "Ranware Padmavati Krishnarao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14408",
    "name": "Koli Mallesh Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13139",
    "name": "Atugade Shripati Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15579",
    "name": "Rajbahadur Fulchand Gupta"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17850",
    "name": "Kadam Vitthal Kundalik"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2105",
    "name": "Bhagat Jagannath Balu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20702",
    "name": "Sharma Hulasidevi Premashankar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2426",
    "name": "Mhatre Shailesh Shivram"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "471",
    "name": "Bangar Sunil Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14364",
    "name": "Jaiswal Somai Sultan Toli No 1029/5"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1823",
    "name": "Dodhia Hanish Pravin"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1133",
    "name": "Choudhari Surendra Mahendra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11639",
    "name": "Kadav Ashok Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21825",
    "name": "Surve Jagdish K Anu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13494",
    "name": "Sheikh Jakir Hussein"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8902",
    "name": "Maskar Shankar Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13196",
    "name": "Sonake Vithal Pandurang"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21195",
    "name": "Bhave Sushil Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13116",
    "name": "Sahyadri Nagar Bldg No -3"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14413",
    "name": "Dhanavade Nilesh Bhagavan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24027",
    "name": "Das Dhanlaxmi Krishna"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2729",
    "name": "Chalke Balkrishna Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "295",
    "name": "Shinde Sitabai Ramchandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12535",
    "name": "Shukla Umakant Tiloknath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17800",
    "name": "Ghorpade Nilesh Tanaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22201",
    "name": "Joshi Bhaghyashree Milind"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1774",
    "name": "Satve Sagar Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18779",
    "name": "Shelar Swapneel Hanmant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "12840",
    "name": "Palkar Dharmendra Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "13190",
    "name": "Tahasildar Gani Dastger"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19995",
    "name": "Pedhe Suyog Sudhir"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1062",
    "name": "Yadav Harichandra Kashaba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9380",
    "name": "Gurav Suresh Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20232",
    "name": "Salunkhe Vinanta Dipak"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1774",
    "name": "Bhandari Kisan Devjya"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23964",
    "name": "More Chandrakant Shivram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9443",
    "name": "Pawar Mangal Ramesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21452",
    "name": "Dilima Fredy Jarel"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4947",
    "name": "Kadam Sakharam Maruti"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1248",
    "name": "Teli Sanskruti Suraj"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "664",
    "name": "Yadav Ashok Bachau"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20646",
    "name": "Velgim Kempnna Balappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21056",
    "name": "More Raju Laxman"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20591",
    "name": "Jain Arthi Manav"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13611",
    "name": "Salunkhe Dilip Dhondiba"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1056",
    "name": "Prajapat Badriram Godhuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14488",
    "name": "Shirke Dada Bhanudas"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1438",
    "name": "Hivalkar Viki Raju"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17763",
    "name": "Pisal Alka Shivaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "402",
    "name": "Bhosale Rangrao Govindrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6733",
    "name": "Chavan Vijay Anandrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22388",
    "name": "Gupta Ranidevi Sureshchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19142",
    "name": "Ugale Bandu Rakhmaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17445",
    "name": "Palrecha Mohanlal Chhogamal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6148",
    "name": "Nalawade Hemlata Balasaheb"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19009",
    "name": "Jain Rakesh Khimchandji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12784",
    "name": "Narvekar Alka Ravindar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3204",
    "name": "Jagtap Ramdas Bhikaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13578",
    "name": "Pawar Uttam Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15667",
    "name": "Tarachand N Solanki"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18643",
    "name": "Tawade Appa Atmaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "23616",
    "name": "Kumbhar Sangeeta Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6956",
    "name": "Ranka Kalpeshkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15377",
    "name": "Chawan Shridhar Ramchandra"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13308",
    "name": "Jadhav Pratima Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "9469",
    "name": "Sadanand Manohar Bagawe"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20758",
    "name": "Mate Sonabai Yashwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15265",
    "name": "Vilas Maruti Patil"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21934",
    "name": "Kakade Sanjay Jaywant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17206",
    "name": "Patil Annapurna Vijay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15935",
    "name": "Jadhav Mansing Vithoba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12298",
    "name": "Jagtap Chandrakant Aabaji"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20177",
    "name": "Khilachi Mehboob Kaluroshan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15900",
    "name": "Salunkhe Bhushan Vilas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20085",
    "name": "Navghane Pradip Bhiku"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14472",
    "name": "Deshmukh Nilima Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22976",
    "name": "Shinde Seeta Mohan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2186",
    "name": "Amate Manohar Dhondu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2052",
    "name": "Mandhare Ravindra Sampat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16539",
    "name": "Parikh Manaharlal Ashalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21121",
    "name": "Kotkar Ranjita Baban"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "172",
    "name": "Ananda Parshuram Mane"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11571",
    "name": "Dangat Narayan Ganpat"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17259",
    "name": "Laxmi Dinkar Kadam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18742",
    "name": "Varpe Zelam Uttam"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18814",
    "name": "Ghadage Balkrishna Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12761",
    "name": "Chavan Anandrao Shrirangrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12860",
    "name": "Panditji Satish Narayan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19951",
    "name": "Bhosale Anil Vishwas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9077",
    "name": "More Bhaiyasaheb Motiram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13503",
    "name": "Chavan Shital Bharat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17709",
    "name": "Surywanshi Vikas Shamrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9512",
    "name": "Bhatte Suchita P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17611",
    "name": "Maloo Mangidevi Surajmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5408",
    "name": "Sawant Bhagwan Kundalik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18264",
    "name": "Ahire Sumanbai Mahadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7585",
    "name": "Kadam Balkrushna Madhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5052",
    "name": "Jadhav Appa Dnyanu"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "525",
    "name": "Ray Suryaprakash Keshbhan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13413",
    "name": "Mahadeshwar Vijay Kanoba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22083",
    "name": "Lapasia Nalini Rajesh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3995",
    "name": "Shivaram Bhiku Gole"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23391",
    "name": "Pawar Jitendra Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21171",
    "name": "Devrukhkar Shobha Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12960",
    "name": "Kolekar Shivaji Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7302",
    "name": "Shelar Aparna Sunil"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "896",
    "name": "Malde Vanshi Harish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2666",
    "name": "Kolekar Kashinath Ganpati"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21567",
    "name": "Ghorpade Milan Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20321",
    "name": "Dedhia Kevin Pravin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15496",
    "name": "Udare Mahadeo Sajan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20092",
    "name": "Patel Ramchandra Gherilal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9780",
    "name": "Gundge Vasant Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10736",
    "name": "Disale Adhikrao Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13637",
    "name": "Bhedate Shrirang Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "2888",
    "name": "Mane Uttam Antu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7498",
    "name": "Shivanekar Santosha Kamlakar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17953",
    "name": "Dabholkar Prabhakar Sonu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22367",
    "name": "Nivgune Sagar Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17596",
    "name": "K Somdevan Nagraj"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19060",
    "name": "Suryawanshi Bharat Ganpatrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14501",
    "name": "Banarjee Ashimkumar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13507",
    "name": "Pitale Anil Dattaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9950",
    "name": "Dhavade Sheetal Santosh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15019",
    "name": "Khatal Sashikant Baban"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14259",
    "name": "Jaiswal Kanhayalal Ramlout"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18249",
    "name": "Gound Suratkumar Ravindarkumar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3632",
    "name": "Malde Harshil Mahesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "4502",
    "name": "Suryawanshi Vasant Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13292",
    "name": "Patil Vanita Ladoba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17194",
    "name": "Wagh Tarabai Prabhakar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "6236",
    "name": "Velhal Kusum Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16618",
    "name": "Ashish Trust"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15767",
    "name": "Warse Rashmi Rajesh"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9321",
    "name": "Jain Kamlesh Hastimalji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11765",
    "name": "Shinde Vasudha Prabhakar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9191",
    "name": "Shinde Jaysingh Mahadeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25082",
    "name": "Gupta Sunita Ramprasad"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10837",
    "name": "Chandanwadi Sarvajanik Ganeshostav Manda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8528",
    "name": "Bharmal Uttam Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10658",
    "name": "Bohara Nirkaldevi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6437",
    "name": "Pawar Hanmant Bandu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22596",
    "name": "Kinjawadekar Sheela Shivram"
  },
  {
    "branch": "Dombivali",
    "type": "Savings",
    "accountNo": "1056",
    "name": "Mandhare Amit Ashok"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15336",
    "name": "Vishwkarma Pawan Sing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15016",
    "name": "More Avishkar Ajit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19085",
    "name": "Chavan Vilasrao Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12977",
    "name": "Babar Subhash Mansing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22304",
    "name": "Vadla Banappa Yallappa"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15587",
    "name": "Nawadkar Deepak Dharmaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1017",
    "name": "Vishwakarma Ashokkumar Shitalaprasad"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17570",
    "name": "Kagalwala Building Chawl Commitee"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20792",
    "name": "More Supriya Pralhad"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10087",
    "name": "Vishwakarma Kusum Ramavtar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2902",
    "name": "Chahare Nikhil Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6050",
    "name": "Bhosale Sunil Bajirao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16614",
    "name": "Palrecha Rajendra M"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14582",
    "name": "Naik Yogesh Pundalik"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17005",
    "name": "Atugade Bhauso Bhagwan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6631",
    "name": "Salvi Suverna Sambhaji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5485",
    "name": "More Ramchandra Bali"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18398",
    "name": "Gosavi Vaishali Ramesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1555",
    "name": "More Jagannath Rao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6174",
    "name": "Rao Bisuprasad Badalu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17935",
    "name": "Rajbhar Ganesh Ramdhari"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16125",
    "name": "Dubey Rajmohan Madanmohan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17065",
    "name": "Kadam Ramchandra Ravji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1423",
    "name": "Matre Rajaram Chandru"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1842",
    "name": "Karne Vishnu Sidu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10147",
    "name": "Sandeep Suryakant Sakpal"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "512",
    "name": "Shikare Sujata Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16894",
    "name": "Kalantre Sanjay Parasram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11385",
    "name": "Teli Amirhamja Sardar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18535",
    "name": "Padalkar Sandipan Dnyanu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15008",
    "name": "Patil Savita Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10594",
    "name": "Rajbhar Sushama Ramdevi"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10211",
    "name": "Dayya Jagdish Mohanlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16785",
    "name": "Shelar Gulab Maruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14825",
    "name": "Bunkar Shivpal Shrimanpher"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24100",
    "name": "Chaudhary Chandrakala Radheshyam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12754",
    "name": "Shilmkar Uttam Bajirao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "15815",
    "name": "Pawar Venubai Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13085",
    "name": "Kadam Hanmant Sadashiv"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16236",
    "name": "Shidruk Vikas Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3071",
    "name": "Marathe Dinkar Dadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6951",
    "name": "Ranka Kirtibala J"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14880",
    "name": "Shetty Rohidas Mudanna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17588",
    "name": "Galole Balu Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9216",
    "name": "Patil Hanmant D"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18902",
    "name": "Jagadale Mahadev Maruti"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16760",
    "name": "Bhatale Aswini Ankush"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12017",
    "name": "Sakhunde Vikas Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17422",
    "name": "Guptta Dinesh Kumar Bhagwandin"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20953",
    "name": "Kadam Bandu Ravji"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14819",
    "name": "Mahadik Dhondiram Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5897",
    "name": "Pawar Shivaji Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14064",
    "name": "Shingan Sambhaji Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17498",
    "name": "Kachare Vanita Hari"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "21899",
    "name": "Jagtap Chandrakant Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18363",
    "name": "Bhilare Ravindra Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8895",
    "name": "Salunkhe Ashok Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10967",
    "name": "Jadhav Neelima Vikrant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1020",
    "name": "Khanvilkar Ramesh Mahadev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4158",
    "name": "Goden Pirappa Bhutali"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "695",
    "name": "Saraswati Sadan Landlords"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2205",
    "name": "Soni Champalal Maganlalji"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3308",
    "name": "Surya Synthetics"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "4638",
    "name": "Sarvesh Builders India Pvt Ltd"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11884",
    "name": "Shinde Sadashiv Arjuna"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14769",
    "name": "Lad Mohan Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18710",
    "name": "Yadav Chinthram Dharmraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "506",
    "name": "Mandhare Suryakant Amritrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9938",
    "name": "Whade Ramchandra Tukaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7322",
    "name": "Bawle Suman Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2395",
    "name": "Shree Sati Silk Mill Pvt Ltd"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "251",
    "name": "Nalawade Acchutrao Rajaram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22280",
    "name": "Sakpal Nanda Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13208",
    "name": "Peje Namdev Santu 1050/11/A"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11670",
    "name": "Soni Laduram V"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "7729",
    "name": "Waze Chandrakant Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7894",
    "name": "Gore Narayan Laximan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9124",
    "name": "Tavare Nagoji Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3594",
    "name": "Shinde Ramchandra Madhavrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "8827",
    "name": "Sawant Namdeo Dasharath"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "937",
    "name": "Malani Rameshkumar Chmpalal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11777",
    "name": "Naik Urmi Uday"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3888",
    "name": "Bhosale Pallavi Vijay"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "558",
    "name": "Shah Damji Hadhubhai"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "623",
    "name": "Savla Vasant Velji"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "928",
    "name": "Salian Roadways"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "1042",
    "name": "Nirmiti Creation"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13306",
    "name": "Salunkhe Shivaji Vishnu"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1555",
    "name": "Krishna Art"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1793",
    "name": "Mahwana Bhavesh Jagdish"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15359",
    "name": "Gaikar Prakash Mahadev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11344",
    "name": "Kadam Aatmaram Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10649",
    "name": "Chouhan Ramvojar Hiralal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "6224",
    "name": "Dave Asha Jayesh"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14741",
    "name": "Shah Riddhi Ajay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14813",
    "name": "Lodh Bhagwandas Bechu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16962",
    "name": "Naik Smita Ganesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18112",
    "name": "Pansare Kamal Jaysing"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20695",
    "name": "Mehta Bharat Dalpatraj"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13692",
    "name": "Pawar Dattatray Sudamrao Tn-85-B-13"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20405",
    "name": "Murkar Bharti Baliram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10496",
    "name": "Jain Pravin Jethmal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5048",
    "name": "Jethmal Ranglalji Oswal(Jain)"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23233",
    "name": "Shetty Asha Damodar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7596",
    "name": "Maizee Moses Martin"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22632",
    "name": "Salian Kevalraj R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14232",
    "name": "Shaikh Khalil Ahemed"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "10584",
    "name": "Anapat Jaysing Krushnaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9872",
    "name": "Chavan Anita Arun"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11409",
    "name": "Jagtap Puspalata Rajaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2165",
    "name": "Mhatre Ramesh Kashinath"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12365",
    "name": "Shukla Premshankar Rajnarayan"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23232",
    "name": "Shetty Adarsh Damodar"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "364",
    "name": "Saini Manoharlal Giridharlal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "11916",
    "name": "Agari Gopalharichandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14351",
    "name": "Satam Sunil Suryakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "11814",
    "name": "Pawar Jagannath Namdeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19614",
    "name": "Kamdar Bharati Virendra"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "38",
    "name": "Gaikwad Nansaheb Kacharu"
  },
  {
    "branch": "Dombivali",
    "type": "Current",
    "accountNo": "40",
    "name": "Ugale Pandurang Devram"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16693",
    "name": "Guljar Mohamad"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "1191",
    "name": "Bakul Merchant"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2362",
    "name": "Shirgaonkar Studio"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "2494",
    "name": "Hinal Creations"
  },
  {
    "branch": "Chirabazar",
    "type": "Current",
    "accountNo": "3908",
    "name": "Shinde Santosh Hanumantrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "1960",
    "name": "Dhumal Hanmant Babanrao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "5051",
    "name": "Manjula J Khakriya"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "10969",
    "name": "Dhopat Manisha Madhukar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13545",
    "name": "Morzariya Chetankumar Jamnadas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "13785",
    "name": "Agarwal Girdharilal B"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "14310",
    "name": "Dhadve Bharat Shankar"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16330",
    "name": "Shedge Tanaji Tatyaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16526",
    "name": "Dere Anil Sarjerao"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16881",
    "name": "Kolekar Tatoba Maruti"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "16941",
    "name": "Kadam Prakash Balwant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "17818",
    "name": "Mehta Vasanti Jewanmal"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18538",
    "name": "Murkute Dipak Suryakant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18765",
    "name": "Sarapdar Ramesh Bandu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "18802",
    "name": "Yadav Balu (Santosh) Jijaba"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19177",
    "name": "Raja Vimal Girdhardas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "19369",
    "name": "Yadav Yaduvanshi Ranjit"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "20846",
    "name": "Sakpal Sunita Rajesh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22183",
    "name": "Miss Gada Amita Kiran"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "22538",
    "name": "Divekar Sanjeev Vasant"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23083",
    "name": "Bombale Maruti Vishnu"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "23267",
    "name": "Gamare Anju Suresh"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24582",
    "name": "Gowda Keertan Srinivas"
  },
  {
    "branch": "Chirabazar",
    "type": "Savings",
    "accountNo": "24608",
    "name": "Patel Lasaram Kasaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "84",
    "name": "Sangeeta Textiles"
  },
  {
    "branch": "Vithalwadi",
    "type": "Current",
    "accountNo": "2754",
    "name": "Sharma Umakant Brijmohan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "248",
    "name": "More Ankushrao Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "878",
    "name": "Bhoite Devidas D"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "969",
    "name": "Sankpal Wamanrao Rangrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1296",
    "name": "Bhapkar Pandharinath Genaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1549",
    "name": "Mane Shamrao Raghunath"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1664",
    "name": "Aaware Tatyaba Bapurao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "1949",
    "name": "Dhanawade Nathuram Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "2482",
    "name": "Chaudhari Nandlal Lalitram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "3795",
    "name": "Shelar Maruti Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4419",
    "name": "Kadam Kondiba Dhondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "4584",
    "name": "Bhapkar Vilas Hanmantrao 123/5"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "5932",
    "name": "Bhoite Kisan Dinkarrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6274",
    "name": "Kadam Baburao Nathu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6370",
    "name": "Mane Tanaji Ramchandra 217-6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6522",
    "name": "Jadhav Ramchandra Sakharam"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "6703",
    "name": "Kesare Laxman Yeshwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7021",
    "name": "Pawar Navnath Laxman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7464",
    "name": "Barge Arjun Bhiku"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "7895",
    "name": "Salte Laxman Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8203",
    "name": "Jagtap Shivaji Pandurang"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8313",
    "name": "Karne Savata Shivram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "8492",
    "name": "Bhosale Jaywant Dnyandeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9129",
    "name": "Pawar Anil Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9570",
    "name": "Dangra Radhadevi Badrinarayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9634",
    "name": "Varma Vinodkumar Bhagwatsing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "9711",
    "name": "Shinde Pandurang Bhau 425/6"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10012",
    "name": "Bobade Baliram Namdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10511",
    "name": "Salunkhe Tukaram Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10622",
    "name": "Mohite Sadashiv Parshuram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10758",
    "name": "Pansare Ramnath Nivruti"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10849",
    "name": "Gadhave Hindurao Kondiba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "10850",
    "name": "Pawar Vilas Tatyaba"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11007",
    "name": "Lenbhe Ankush Dhansing"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11036",
    "name": "Jain Mahavir Vimalchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11279",
    "name": "Yadav Satish Jotiram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11529",
    "name": "Jain Sangita M"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11569",
    "name": "Mach Damodar Laxmidas 554/8"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11816",
    "name": "Devkar Hanmant Rajaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "11870",
    "name": "Pawar Bandu Manu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12055",
    "name": "Gaikwad Ankush Parshram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12110",
    "name": "Jain Mukesh R"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12128",
    "name": "Thorat Mohan Ganpati"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12313",
    "name": "Shinde Ashok Mahadeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12402",
    "name": "Salte Sitaram Baburao A"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "12669",
    "name": "Jadhav Ganpati Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13110",
    "name": "Modhav Shantanu Gopichand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13320",
    "name": "Jagtap Mangala Prakash"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13357",
    "name": "Harijan Sukhlal Jagdeo"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13415",
    "name": "More Ananda Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13575",
    "name": "Gole Ganapat Tatyaso"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13795",
    "name": "Raut Narayn Waman"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13904",
    "name": "Korade Suryakant Ashok"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "13950",
    "name": "More Parasu Dagadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14338",
    "name": "More Ramchandra Parshram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14422",
    "name": "Patil Balu Sadu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14629",
    "name": "Pawar Ramchandra T 272/27"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14634",
    "name": "Shinde Ganesh Vasantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14639",
    "name": "Dhamal Rajendra Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14814",
    "name": "Saket Prabhuprasad Dukhiya"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "14833",
    "name": "Salate Dagadu Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15142",
    "name": "Kolpe Dnyanoba Vitthal"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15145",
    "name": "Bohra Ishwarlal P"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15250",
    "name": "Kadam Ananda Hari"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15262",
    "name": "Shende Ramchndra Nivruthi"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15279",
    "name": "Nalawade Manohar Dnyandev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15304",
    "name": "Patil Dattatray Laxman 211/A18"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15350",
    "name": "Joshi Ramchandra Ganpat"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15586",
    "name": "Mohite Balu Ananda"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "15879",
    "name": "Jain Ghisibai Fulchand"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16473",
    "name": "Kadam Rajaram Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16526",
    "name": "Shinde Narayan Shamrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16565",
    "name": "Berde Sampat Namdev"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "16982",
    "name": "Bhoite Sandeep Chandrakant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17118",
    "name": "Gavade Tukaram Babu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17162",
    "name": "Gavhane Ajit Kisan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17205",
    "name": "Pawar Vijay Narayan"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17331",
    "name": "Matkar Ajay Hanmantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17706",
    "name": "Kumbhar Dinkar Bapu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17766",
    "name": "Shinde Hanmant Yeswantrao"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17834",
    "name": "Patil Shankar Vishnu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17857",
    "name": "Bandal Laxman Yashwant"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "17905",
    "name": "Shewale Baburao Dinkar-Toli-131- 10"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18279",
    "name": "Miss Dalvi Archana Dinkar"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18353",
    "name": "Shelake Jaywant Ramchandra"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18364",
    "name": "Chavan Kailash Dattatray"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18414",
    "name": "Nivrutti Yashwant Peje"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "18499",
    "name": "Retharekar Sachin Atmaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19047",
    "name": "Shinde Hanmant Tukaram"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19400",
    "name": "Hule Sarika Sanjay"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19637",
    "name": "Kadam Shalan Dattu"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "19677",
    "name": "Jadhav Abhijeet Balkrishna"
  },
  {
    "branch": "Vithalwadi",
    "type": "Savings",
    "accountNo": "20819",
    "name": "Pawar Tukaram Kisan"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "216",
    "name": "Vijaya Prints"
  },
  {
    "branch": "Lalbaug",
    "type": "Current",
    "accountNo": "921",
    "name": "Shree Swami Samarth Stores"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "957",
    "name": "Ghadigaonkar Aparna Chandrakant"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "3979",
    "name": "Shirodkar Prabhakar Babu"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "5072",
    "name": "Sawant Rajendra Waman"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "6274",
    "name": "Chavan Jaywant Kamal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "7632",
    "name": "Mestry Pramodini Shankar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "8703",
    "name": "Jain Lilavati Bhawarlal"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12080",
    "name": "More Sandeep Bhikaji"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "12773",
    "name": "Pawar Ganesh Sawlaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13062",
    "name": "Vasaikar Arun Prabhudas"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "13808",
    "name": "Khopde Sambhaji Nagoba"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14301",
    "name": "Halwai Premlata Devendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14605",
    "name": "Nikam Vinesh Dattaram"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14610",
    "name": "Kadam Paresh Suresh"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "14799",
    "name": "Dhas Suman Dinkar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15139",
    "name": "Gole Lavaji Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15324",
    "name": "Sawant Dattatray Mahadeo"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "15798",
    "name": "Halwai Pradeep Devendrakumar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "16179",
    "name": "Pol Ramchandra Bhagawan"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "17274",
    "name": "Ghadigaonkar Anant Krishna"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "18203",
    "name": "Parab Pandurang Ramchandra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "19433",
    "name": "Pawar Sandeep Sakharam"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20422",
    "name": "Sutar Aruna Milind"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20467",
    "name": "Manjarekar Revati Rajendra"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "20841",
    "name": "Patel Chandu Subalak"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21394",
    "name": "Sawant Vitthal Ganpat"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21522",
    "name": "Pandy Kamishnar Kumar Rajdhar"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "21742",
    "name": "Aakar Pratisthan -Lalbaug Mumbai [Regi"
  },
  {
    "branch": "Lalbaug",
    "type": "Savings",
    "accountNo": "22375",
    "name": "Margaj Prashant Bapu"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "435",
    "name": "Sanghavi Premises Coop Soc Ltd"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "489",
    "name": "Daimond Plast Moulds"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "1776",
    "name": "Thorat Vishal Tukaram"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2256",
    "name": "Jagtap Rajaram Hanmant"
  },
  {
    "branch": "Kandivali",
    "type": "Current",
    "accountNo": "2344",
    "name": "Yadav Keval Basudev"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "182",
    "name": "Vilas Gangaram Bobade"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "219",
    "name": "Ramesh Hanmant Chavan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "835",
    "name": "Sindhu Ravindra Mandhare"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1344",
    "name": "Ketan Paduman Mehta"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "1811",
    "name": "Tawade Vijay Parsharam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "2555",
    "name": "Toraskar Dnyandeo Kondiba"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3099",
    "name": "Bhandari Vinayak Motiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "3613",
    "name": "Patil Bajirao Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "4533",
    "name": "Salunkhe Dyandeo Sarjerao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5351",
    "name": "Shaikh Akhtar Abbas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5682",
    "name": "Kadam Dilip Shriram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5801",
    "name": "Bansode Sambhaji Babu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "5915",
    "name": "Thorat Fulpavar Dagadu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "7815",
    "name": "Kasbe Namdev Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "9123",
    "name": "Shende Ashok Jagannath"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10005",
    "name": "Khambe Usha Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "10687",
    "name": "Maurya Mahendrakumar Motilal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11529",
    "name": "Sharma Nathu Bisuni"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11584",
    "name": "Kumbhar Chandrakant Shankar"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "11769",
    "name": "Chavan Vasant Baburao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12131",
    "name": "Surve Ramesh Appa"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "12524",
    "name": "Ithape Vijaya Popatrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14169",
    "name": "Gala Gunjan Vasant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14709",
    "name": "Jadhav Arun Anant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14834",
    "name": "Chavan Disha Dilip"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "14875",
    "name": "Kalabai Sadashiv Rakshe"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "15284",
    "name": "Pendhari Vithal Govind"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "16390",
    "name": "Lahane Dashrath Kisanrao"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17335",
    "name": "Abdul Hamid Md Sakur Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17414",
    "name": "Patil Jaiwant Sudam"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17425",
    "name": "Pendhari Vaishali Vitthal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "17814",
    "name": "Pal Mamta Sudarshan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18061",
    "name": "Sable Sheetal Sopan"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "18254",
    "name": "Mandhare Popat Jaysing"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19880",
    "name": "Patel Laxmi Kesuram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "19933",
    "name": "Pawar Mina Tanaji"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20008",
    "name": "Sakpal Anant Nana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20129",
    "name": "Patel Bharat Balubhai"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20442",
    "name": "Yadav Rajman Tarasu"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20643",
    "name": "Singh Jhankar L"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "20768",
    "name": "Sakharkar Vijay Kashiram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21092",
    "name": "Piedade Luies Saldana"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21279",
    "name": "Keni Kalpana Balwant"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21399",
    "name": "Koli Bajrang Dnyandeo"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "21418",
    "name": "Thasal Naresh Shantaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22313",
    "name": "Choudhary Anilkumar Sitaram"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22419",
    "name": "Gund Pandurang Kundalik"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22428",
    "name": "Jagtap Shakuntala Laxman"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22618",
    "name": "Khatri Chandrabai Dipabahadur"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "22700",
    "name": "Malkar Surekha Harichandra"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "24158",
    "name": "Panchal Hemand Jaichand"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25457",
    "name": "Jaunjal Sangram Jaunjal"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "25939",
    "name": "Sayed Ahmed Ali Mohd Ali"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26087",
    "name": "Khandizod Rahul Pandurang"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26088",
    "name": "Jalgaonkar Vaishnavi Vilas"
  },
  {
    "branch": "Kandivali",
    "type": "Savings",
    "accountNo": "26485",
    "name": "Jagtap Kamal Arvind"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "366",
    "name": "Handepatil Jayant Maruti"
  },
  {
    "branch": "Satara",
    "type": "Current",
    "accountNo": "370",
    "name": "Jaideep Foods Aqua Pvt Ltd"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "636",
    "name": "Thombre Sampat Waghji"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2301",
    "name": "Jadhav Vishwas Raghunath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2358",
    "name": "Rajmane Subhash Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "2724",
    "name": "Mane Satish Ganpatarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3416",
    "name": "Mane Namdevrao Rajaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3441",
    "name": "Dhayagude Anada Yashwant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "3998",
    "name": "Pisal Sadashiv Daulati"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4212",
    "name": "Bhatia Poonam Omprakash"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4311",
    "name": "Pisal Navnath Gulabrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "4828",
    "name": "Pawar Sampat Anna"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5274",
    "name": "Gujar Uday Damoder"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "5610",
    "name": "Dhumal Satish Narayan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6281",
    "name": "Shelke Madhukar Dadarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "6477",
    "name": "Salunkhe Ravindra Wamanrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7096",
    "name": "Bhoite Vishwasrao Bapusaheb"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7097",
    "name": "Bhoite Vijaydevi Vishwasrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7138",
    "name": "Rasal Laxman Sopan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "7376",
    "name": "Sayyad Karim Rustum"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8180",
    "name": "Dudhe Balaso Anandrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "8762",
    "name": "Kasar Bebi Chandrakant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9045",
    "name": "Sawant Sambhaji Nathuram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9142",
    "name": "Nikam Shivani Shashikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9143",
    "name": "Nikam Shashikant Vishnu"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9212",
    "name": "Sabale Pratap Ankush"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9535",
    "name": "Babar Sudhakar Haibatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "9653",
    "name": "Shinde Manisha Shashikant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10622",
    "name": "Sutar Sushila Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "10928",
    "name": "Shinde Kumar Krishnarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11171",
    "name": "Sawant Bhagwan Kundalik"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11173",
    "name": "Sawant Sandhya Bhagwan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11583",
    "name": "Dhumal Chandrasen Yashawantarao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "11714",
    "name": "Ingale Netaji Khashaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12034",
    "name": "Kadam Jyoti Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12042",
    "name": "Joshi Ramesh Surajram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12143",
    "name": "Pisal Shakuntala Gopal"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12205",
    "name": "Sapate Arunkumar Shankar"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12523",
    "name": "Kadam Shubhangi Mohan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "12992",
    "name": "Yewale Sanjay Dhondiba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13043",
    "name": "Shirke Ashok Popat"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13331",
    "name": "Yadav Suryaji Ravba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13566",
    "name": "Bansode Sahiraj Sahebrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13810",
    "name": "Jadhav Sangita Tukaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "13978",
    "name": "Mulani Ashpak Badashah"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14004",
    "name": "Jadhav Jagdish Janardan"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14198",
    "name": "Mane Kusum Ramesh"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14227",
    "name": "Salunkhe Umeshchandra Dattajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14557",
    "name": "Dhumal Madhukar Jagannath"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "14855",
    "name": "Mane Tejashree Hemant"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15093",
    "name": "Nigade Shashikant Shivajirao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15209",
    "name": "Pawar Shamrao Ganpatrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15228",
    "name": "Rasal Anil Vilas"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "15954",
    "name": "Hawalekar Kalappa Revansiddhi"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "16004",
    "name": "Nalawade Sushila Dayaram"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "16005",
    "name": "Gaikwad Arjun Awaba"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "16027",
    "name": "Jadhav Manoj Dharmraj"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "16028",
    "name": "Daunde Anita Sandip"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "16035",
    "name": "Mane Dipaksingh Ashokrao"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "16052",
    "name": "Shedge Sachin Ashok"
  },
  {
    "branch": "Satara",
    "type": "Savings",
    "accountNo": "16093",
    "name": "Yadav Bharat Suryaji"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "7",
    "name": "Navnath Raswanti Gruh"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "114",
    "name": "Mane Bhairavnath Mahadeo"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "229",
    "name": "Solanki Mohanlal Bhundaram"
  },
  {
    "branch": "Kamothe",
    "type": "Current",
    "accountNo": "235",
    "name": "Mukesh Kumar Satyawan"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "896",
    "name": "Shinde Shankar Namdeo"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1068",
    "name": "Tidke Shashikala Prakash"
  },
  {
    "branch": "Kamothe",
    "type": "Savings",
    "accountNo": "1137",
    "name": "Jadhav Sheeladevi Dhananjay"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "170",
    "name": "Chaugule Sunanda Shrishail"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "373",
    "name": "Gogri Ketan Revji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "461",
    "name": "Purohit Suresh Gulabchand"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "533",
    "name": "Mohite Sagar Bajirao"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "557",
    "name": "Jain Mahendrakumar Chiranjeevlal"
  },
  {
    "branch": "Bhiwandi",
    "type": "Current",
    "accountNo": "589",
    "name": "Khan Abdulrahman Mohammadmustafa"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "10",
    "name": "Shedge Sunil Govind"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "264",
    "name": "Chikate Shivaji Ananda"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "612",
    "name": "Ghadge Sukhadev Ramchandra"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "738",
    "name": "Nishad Ramfer Mitthuram"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1073",
    "name": "Navik Puja Shivbadan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1731",
    "name": "Shukla Nevalkishor Chandrabhan"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "1922",
    "name": "Paul Biswajit Saylen"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2047",
    "name": "Desai Kamal Dnyandeo"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2081",
    "name": "Jagtap Meghraj Shivaji"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "2533",
    "name": "Mishra Parmeshwar Ganesh"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3001",
    "name": "Bhosale Ujwala Pratap"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3134",
    "name": "Mohite Suvarna Ananda"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3607",
    "name": "Yadav Priyanka Dilip"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3645",
    "name": "Chaudhari Atmaram Nago"
  },
  {
    "branch": "Bhiwandi",
    "type": "Savings",
    "accountNo": "3703",
    "name": "Mhatre Premabai Vaman Mhatre Premabai Vaman Mhatre Premabai Vaman"
  }
];

export default UNCLAIMED_DATA;